/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		204: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({}[chunkId]||chunkId) + "." + {"0":"c6fba7c48cc92a11adeb3f7b25b4b0a9bd0befc7deda845f6baffa1c4280203c","1":"31cb1253b0e08e0636151700409e588725688d0da3550ae577a78f144c1a4f76","2":"35f43995daba98ce4429955f34e2f347a04f93ff6a3fe2dfbc97dd82c2af4e2c","3":"070fdf1e714b475e21e670fd0ede4b1f8baaaa68383e4169e424fe129c10e7d7","4":"40d859617d78d9bf8a669b032b8505527888f303b84556947ddf8eb2b84d61e9","5":"a85bdd8e3961aa38887be3652a6306d9d89b81b41343a2338ea2a83ca2c42711","6":"2aced5389c1193d5ed1d3f2cc50678a91d342b6571c2319104ea73f3664a05b9","7":"d445d47b405b059b7b5f0b53cc09ed93c627cc53dfc2cccd984d3c75a95551cf","8":"cad754ae71d3954dc4bb02c51446c24b5ed5958fb2975e4bd9051b431a7815fc","9":"b65c11ff9722bf0d132a9448f0b9c3d041a543fc33058087cd01cf4cf17ef7f9","10":"39634fb7993d4295f4db1d9aefeed4fd729486172b68b5735c13099e9be5238a","11":"8e82755252d6cda4e843096210110b4a14a26e741f74ad40f9e31daeb8a767b7","12":"91d30295e647ea0e2353eb30a67c46b6db91d74e366b525211c629b104d02ccc","13":"87c31e6b7d3041fa3434ec85689f85c5d1c9d00817f901a82c4946d98b9942f3","14":"3e6aa18942d0e5bc69fe22c8bcefc5d8146c6ddae963bec20fc560d3f18a5cfc","15":"eb5f8ee9f72bdc4195eff59d51af4af9ba85afd00c0159f73f368fbf2a57c492","16":"31c1ec17b5aa229a8d987acb9eb442ebb5c81d19a6000caf4843886bd9b94530","17":"2439826f8b9732e885bac4bb267d398fe111be6b6cf4976ebb0452b7a6a9e086","18":"961ad09e34ef184599a8dfddf8dffba62ca0f9de0debe78f86d848bb332ff57a","19":"35d9e5e101178a41665d5e9347be4c8f9c0da11507538104b405d4a2c137da93","20":"0bee0183fee813caff29c48ff62b0384d999ddcd906f90c7e7c533c0d0ffed7c","21":"794b679e362e6e5c09c82ec003ada4ce75755534785ce14d213238dea3a95fc0","22":"3787fccb367b5602b6be753f49c9f0aff257bd3f2955913e5e128c77eec247e2","23":"9346b2a5d498b564205018d1ff488b2d6b4c15eefc6d99f7c21fb9f4eed3dad8","24":"a9954bace64dc015b9d1d300a2b97879305ae3e234fd7074a439e92b1a2e8b86","25":"80752d1c469e5240a286bc78b9edb4c4f7b6d33e3f285ac6a54bd24a910554f8","26":"fb0792a9b8c8b21f64a5092004703bf7e239d6e81eb86b17cf8a9f19feba3d82","27":"ec6fa55b25ad1ce8b1c302b86300bf5f9c8495cb8f4be4206856e02ecb9b8cd6","28":"ca4813c76b4d0256a6f8dafaeb74e9332ce37ca79ca8a76077cffa643dfa0c16","29":"55a6eb219a656c8f8b5b5265483db66508d7f6d8d2421559c558c716b980522d","30":"740cf70771fffbae3255e839c7ba9669db9ea4a184c0e828340a2817b5b8f201","31":"2b7eea9b0cebdcc332f35e176ce4960c1dfb78997f9d7e0b821024673d6641e5","32":"47ab1fef399beab7e5077e2679543d40b37a96e40ceabd08ebe990010337b15b","33":"f1e7e00067d7dc7631747a138d389f84858d90f11d6644ce3f66e55d6c121d77","34":"98bea1b262522d4c019b6b06f48bbaaa1b69028aea040c9c662673731a6db617","35":"4e877da994596306650c155b77eb71cf4006b192e7685fa8c3957d6c2f255cf7","36":"5aa19cc7815199e23088e9523ee00106f5bb544989f3415f4ac4748a0780bf8a","37":"622c790fcbc062858d05533843a9e62606741017ceb2eeb4879f91aaf078eff5","38":"abbb9f7765aa64e39eaa799b87b8a3c7f7418464383d786a011a9ee13b022ad2","39":"a03608cd566274b85b313a502946f6e188e306eedbc7bacc851b36554841d8c3","40":"2a79dd30a5981a685656ba3d0aa3983eea9fce18e8b93d0b30c8dff346d40f5f","41":"c704d62b040b1244e4bdd68a5e2b8b00918824e67a600fa39ea02ded1c3170b6","42":"e28fee907ceaae8748a74ba3564796d6f78caec771dcf88b82fa6a27e6d1cd2e","43":"d87e1b83f29c90237f62dd908cf65d3874c3f5159d23568991502beff9ff346a","44":"a7ce6945a06d96287852141459f3f1af591375b685ccb97691dd171833b88b01","45":"64d589507a7ad6ab1114271108e80841105afe8731ad836038907aa773696282","46":"329d3977c8edd7d164a420df427df4e02ebf38180d21fd56978219c7bba5a0e1","47":"895e44e2bbc0bdaee127915afb08828f478ca29e8dc3f1e316cd838cf8b85ba4","48":"db3ce7429d14370eff34311bdff83554f887aa97774294ab88758d29f5df375a","49":"17966f8a26eafcb5f19b75d0c9676ede0f1c534bf33507bf8030b23a47d89a46","50":"41a4a4481f4355f9fb5818d62fd6273877a073847f523c7a3faa53f86396b204","51":"78133c86fdf60f2366f0626b47c8519b3d9a7ba687653b7b0456820cb43a2efd","52":"ce6e14d0c91bbc294529e9b7fdb33e38c5db58017f0c6655ba1be28c9a12b267","53":"745b57a3d516abac64c865527c93c375b43d554a97684471537e6982de4b339f","54":"2486879d926d6b4b61aea2740b90b5ac01bfbaf0d726844422fab29e0f188227","55":"7a9c5e3d7ecf5b46e74efbbd9b02645a72fbb240a66f8ad9a7c83e6ea739cc06","56":"551e9698d16b823e0a17f9071ecb8bdd3a66fcc643291101370ba387de6adea5","57":"f33e07c07a5924b77c59c6d5c2a1015164dae88e4cbdd6591dd1a02752938296","58":"452c7c9cf016e89e8b3abe11d2412a373d767567afa63ad535d78c0ee63019ab","59":"793a96665eb9b063ecd069e4ef3737010fed29a6c227f710894bc36f1a2b0fc3","60":"b5df8c6896c2d8fe9e2a4a378d46d8cbe7f9bd5b93409e40c75e505216381cee","61":"ddafc3ce419e9873cf8c3b11a6b0ef8400a22940814aa6ff6b6efa10e21d2e53","62":"0add1a30edf99447394439ad9312700259173d0d317f128aa045746f6960b1e8","63":"2aab66f2c34ebbbee674d6ede0759dbb5e311c9236fbd4be899ffd9ef582d0e1","64":"e8114bd74ab3cddc4740b66ca8e5dc3c728d3c4d3c96a82fff898ec61cdf330b","65":"b0f42add70208dfbfec303be24dda0bf1b5b5a7fbfc842c7df3a15f60acbbfb6","66":"dbefbbe973e6cbc9b5357871cf61caeefcca8062523c73c29c310ff8abce99e8","67":"d40c239e3596113ef6b56967956d448a1cdafcf3df4a12d41e94e81245d3d116","68":"777881b4abd20f0870b55e96e487f7302e272069721457bd60350a65c25556eb","69":"04239ac738ae16e68a54b4f7d9fb071ad4a03d27c73934f09ec922539968826e","70":"9b8e62d56f063fa4f615d75f032999a82a15c52347c070c8d23e1963f7399612","71":"bcb3681715bf81260a009323ff01dfc936bec8138e9916af49e5d574e1c90cd8","72":"be964c026eefc99be0fbbadb3a880f5e11cb2bb5e6b86952d9132defc467ad74","73":"52c2e69614d6197614330a20312fe7941c02c8df0d8774956bda76f56a19f752","74":"0e3e977c63c701ebb5b48e2dccb1bb0b2e324f8a03ad3082e395dd78ecb50279","75":"a7d2a77a58ad0aab172faba8423594b5359dc243c49db7c772675014a7a585e6","76":"6e5db3e9f5422fa4d114928205a57670496a81fdf178ad3886d734a45cd363c0","77":"2db8d0e788fda2845cec58546474bbc54777e5453fc243399a6ca77800ea28c1","78":"65ab8d73325b2dbecc5d31c7009dc022a29e093889e2a7afae384110eb73b322","79":"3ed4e7fb272eeb36aaf760c59c78f56128ce652aa67632755620ec3d38add097","80":"28dfb64e7fe47925786e40b3d70681237ef120b1ba2c28937f7acdee86e58bed","81":"a3aebf498ee5db23b5097090fd3e1120ffb596ed95fc87a6633fdd2b8b474a10","82":"2439f1c74216d627011bf24a22191a8545892f6c64b25ef6d6fc6b2289ad8c68","83":"03b3dbf82bf56236013cbba447cb3be9cfecad2844607d9f6411da99e0a22d74","84":"5bb4b3a61b0c0d625a5577e0dcbefe27bdcbf13414a03852a28173bd700c1e90","85":"f4ea1f939b5a78c9916398cfb1b378e5410c4cf948e1db225535b60b6dfc1a95","86":"d965a1ed654b950138e655da699d233c2788c37abe69899137aa65bc9a6918d0","87":"163173740b4931ea7b43c1916b33f577eaae8fd43346ec29715af5b59ccdc6e5","88":"04ef8b4a676a61c8b9943da215dd0d6322b35b32a1dcb57e69819ebfc1a73daf","89":"4efc02451e78cd3d849beafdf9191ff6eacba407554a54a8447ca902b124ef20","90":"ed6cffcf3b1312a0aea652c87c2061345eccf04af763a0fe738c411d1c31c20f","91":"d1cbe0577be771c6f2e35a15fb23477f0bf931185ddad93cd55c0a900dcacb6a","92":"1b90bb18f34f353bec1c589a892ac1ad65170af3e9f2df31b76d8a7bbd678fd8","93":"82550c265a6f720f0e113daa99a5f46ff45e18393eb2f0b7bc0d1f5656d127bf","94":"d013ade44331830dd7c6cf74c597ac8f570c9b504ba640c175a3b110dca7e539","95":"f080dab416df4cd37515bdf5f0a976957acb2325ebe50be21e35dec8587c3ed2","96":"fe62f0c19b81c9ab4781508f8791851ffdd78c8bc77f74faf6d9fa5d969022fc","97":"a497860b1671c96b1f5643264c43e71b9196665a07abacb73b414dd17eddaf70","98":"9803c2297bdccc49a4ced7e2d5a40fd722e31a1e665c2e78ed172620a735881d","99":"e0a1879f73d2889c3109c0b117c9af7d6f25a7a6b9221c98aca18ede4eeb17e5","100":"d4f0248abe817874d1afac2d40153b352fc17388562e4fa6abfbb5740b6ec4a7","101":"2d8165597c75a12ce2592537d3175392ca340913b78385f8080a3c27d306fff6","102":"0d1dc1e719f9f27a28e8ed852f1c7831a5f52006e7ca1ad94299c6a50954f579","103":"ae0322ab31da4e6ceed584beae4abe2675b026bc9baa85ef0fee7d5981ea0eef","104":"f3629ccc6b6e1c2cb9c35f6d0de90671a45fd7c1dddb92575c55dab9e5a48a15","105":"6222157ef0adfa4fc880e9210b94815e2e65ff9e5b2597a8e76bee3d8428e6f1","106":"7247447b43bacf6dca27b6114d509d1a9a4aa1d7576a49ddf48d09218ea62542","107":"a84752420350b9d1739b78e681446ca2146fd1079cb6a2c25fcb699ecf1f0f09","108":"e1e5ae2c95a39760ce59c73059f42cb8f6d43c5cecba9011a1ebaf06d29fd219","109":"3833ac9d40270125f5c8d7ee78e0fe0493442c5809580ed7d9a8df40f17d523c","110":"14c8ecb9dc1ba8a4872ab0dc59a8df07484f9c7b8b0c412cc9082fb252ceb141","111":"283a9af161eb45cdd258afd6a6744e9d890fab57a6adde171ebd98dd4566f1fd","112":"bef48509065224e1fd236b27ec6fe1c1b5ef8424e9a3d30cb8f72881960495fd","113":"09006ec0d4b383cff7bf2367cec86e105a165f5bc3c28f98335537d68413d31f","114":"39fcb70cb58b56481a150b50d9c39022c01c3b1a64e74d77e0a124cf06df6dce","115":"74986cbaa7094a5b63d6ad2720d543f7808b2a2cf6000eb3d329e07af8ae1626","116":"c12e7c8cf6be729d4881d49d20e36381699b41d0e5f4c80370e8ec635d96999f","117":"5e18aa9148b6056a110d1fc94dc87f3e5121c8adb7e39d795cf2e85ce04d4f73","118":"d60799512212cde4b4b4e3d4a667310c89809efd2192ae4c7bf8758fd44ee83b","119":"94c5d1cf942e2806cfdd1bca702f004adf2df7f2500ff62e23ebca554d6dc944","120":"06746240b5e7821b42a3446cc835cc34418b5f9c5eef70f1ad7b9523769c0064","121":"8a4baf012dca3d0f9d92d8bff756a7cc7b0f23c04a0db6cf20bd03e0e120d8ea","122":"fccd1ebd964aaa3a7e67c138089883613098262041535d7965712af2481dd367","123":"9350a5706481edbb2fa1b463cfec89e92dbcc24825da9d7568d7fb85eeb37b82","124":"326be495c7b0600898c366e3e859583b7d3b80c48a6176e98d159a86b70546a6","125":"7f80558f85826eb38033cd572226830afd688734303ac95915373ea032c9727b","126":"db4323f898b4b41c170796d713577eece56d4a68e76bd724d486ea37c2a0cadd","127":"df7b8069e08bf71fb1a5c25131a5bbcf61db50477943df2e7b8df472cba78e5b","128":"d0cca47757c6fd9dfa25df03bcdf7fc7e54927911fa804c377335ff751f29e4c","129":"c3a0791cfdc98604262c14dd52dc1dd8428739acd52a3f10704dc93afbd8de84","130":"000bad5abe01def1273c1751b482fd5fdef1737d4fb0db6a13c84281c77933fa","131":"3929c9f94a4f10a59a0c9ec8633f66fff4f581f1c71418a079fa1abb58edd584","132":"537cf70002296ce6539100869425e8f71aaa855fdb53af4eab420fce553a5a3e","133":"d3087cd2cd6b6d2f4335ef2b5e7f6fdb32f099927174fc5518b34ae8373984b1","134":"4b5a00aae5b9bf8aacaf3969222b57b801bfc6b642b06dad94a844fdfbef0f3a","135":"4e46b4bb1a5226b07be307163b212056deeb2b87a29dc567cb5363d76b5e906f","136":"45a7dacc8c151c435823ad693304116ca78d96040a0f02c6ab3b8c6378be409d","137":"ee756e41afa443d42e769684c0275f1ec860d3e01a6895f244352367a48ff892","138":"8c8701ae1e366db80a4e1d21b288c00ec2bbd8737e24dee285b99187d7817e10","139":"2279efc3fa2fb12ec373305467cc7b52d0135ea5ec7e8acb5ca9c9e92c9bd229","140":"8e93510a68f58f3ab604c8d0fcdb945890aa4b60dfa92fc8df4df76809678cdf","141":"c2f4ad6c1736beb2810b6885a2ed0d3002f32b89f05f84c7e9b01d24199a649d","142":"62534968169f53571c9a3f6f3df9381f6303c180226bd625a084c84883f5ecfd","143":"64f7700342505a7c93015e239547cf650978bc38b32146ac7841e23c73602ed5","144":"0623520692601f304872886ae1adcb74275979f139facc1af930054edec13b73","145":"32bad7a936ef7b22fb52c693e5ff7198a8dc9fd4426e501ae96dd89a4aeed406","146":"da30957620b88b96acedbf63ec0c8234834c7531dbda7ac3b22c303fe2544fbd","147":"89f0ba016f43a0286b5afd7d8f795866c1290aca7b53edcac07eac25a7e356a0","148":"61d75812f8c646245859a75ecbd3ec9c266d479541cc79953ff04c4ac3444da5","149":"746e521608e60b0e1219bdeaa2c91909fc7ffc125be27a0576586b8f4ffc32e5","150":"7a281ac50d4e157c491bd4e380320c6f38e0997d110ae6b2dcdad2adb1bd4f52","151":"2327ecaec3f069bf4f56c5df8daca4e19ca837bda03390c15316396e2ac1c3ea","152":"c602bfa1f766232db90a50b7fa6a4244563a0893a87f619d68d8f04c0fc33255","153":"f555554e4200b9d2da961a2d1d2c7940d2d8bd70b806488ad5c59bf0536b7908","154":"008ee073a415314d2b3b4cee8afb99aa3c77c085b63149800aa0a524109cdaf5","155":"e58f57b9c4d0536bc6ae3fc6639fc56f1053eaab1ac703967a9bd47fd469e691","156":"79044198b6a0ffaf7ac3dd84b2307608d1afae2bc93d986b32dac3e5e56d1b0e","157":"ef892a36742bd8cbd8f0e41bc8ad86e4a9ec7b38639f5dc895bd20764cca7ad0","158":"c41ea6074ff71ac50dcc952a93cc28b9676592d458b14b79a9d6d4fbbbc3287b","159":"3d14175e75ca8fd60e006fb5fc742995f982d9d42f63de2008027afeb413e159","160":"4bf8eb2d4da60a7bc2a44764d53cea5495700abe35375f1a12489c234dd967b0","161":"52141891efd84c476525a781c2bc00d69cf273ded8129255d3ccf90658b6701b","162":"7569f1b983290f02405812ccf07b5bb4fe3d3b1382816a1846b3b32492785482","163":"f6d108a41e72ccd7e8c25f1d89fc1effdd11146624ba5072eed7803a9bb16c8a","164":"ce1be8deb49222d429693cbb0c931cc487a11790fed8089b0e35c2647aea4220","165":"de437b74b7d41a797f5e188e937150765b419b0075714e1543e6b0d239ff39a2","166":"4c8225104832886896769d89b501ca8c706aa5223935063ec8d31bdc63976963","167":"3b0e51b8997d26e37ca373d0481c052e41c524ba95977950e74e1d859273a38a","168":"a9a37c3c4b75f30b5e705588a647c5508913ef6458063e8d8fc106dacf9f9c41","169":"79c9c90e9fd70d8bf36332c4c6da7532dd0a659f746ed0a47da11610fabc3cb2","170":"680f92624f4bbc77055c0d53b17274753753afd7288dc41a928fb0af20f93771","171":"bc11547305104d347f86908f2c326215e85d0ac35e7741aaef83001a9ade1a9b","172":"d2caafb06a0389b3629e69c4f9f2446c1619d8d70e0db1605debf326626aba21","173":"f193cd95271afd637484c4db2a2897e315be714228312ab4e5d0097844a0c40d","174":"f9ddee6e61a59cda435facbd9058637093f80a09abdf898a0285d0cdcab8fe34","175":"75e9feee82004cc18d5dc2d9b1fdd75b41a31bab497fd548157b06a37ddb5de3","176":"76b10a993bc0ec7241a590396fd1cb1df78c946a230ab606c6689e67182b6669","177":"6cfeac1156fb80d024570cf0672b134321a39b9dac763d91924ceae5320c6973","178":"3f4144c71ba4bf30802addc54f3d91b2110c07f0d3e6d99adb550948f366023f","179":"fb1dddcafac559b0cde4659373379d6bacff107b1cd66012b9a76463b69345d1","180":"eb43c0f20fbf0a73fed4036cd24f048b6092dc3d2a3f2e2da9ddf7c298d12db5","181":"a5c142587aa95dc0105685ad3810ea79be4a55c8c8cae81d127dd017378598e3","182":"47729850288a8c29c4c3e6cd455215e7d76592602298131bd033a90cf1eee088","183":"63e1a20f55e8bff8f7e992f35189770beb019116654e77a96cf83233e25ff699","184":"7492bde213bf28216ba414ab27d05630067b2c57f94d9f85d6a1d13e02a99243","185":"86f050667a06ef92d4010af2903b6b56bc41e54e4b22e2766f390f4b748ef8a7","186":"ba377a59748a4c38fee3dad99e73c9ea8067f3890052a93363de5f0ddd19db05","187":"9e698df79cb94897bb16a61e0b9c725840182f299140aa0aa84146e43cfd1613","188":"85597d54f923168b4e3c381b0d804d403f2edd03fc0e2427eb961dcae43695e7","189":"80fb90cebd98567036fe70159b505e3b9fe136da26e88241e1ca2b03bd3bdc88","190":"87d3b371fe99a9a549b3557687aad3669ac906707b075bbf0705b1d6dc6b1b13","191":"0b4b380b593fddb6370f826e48c7267886064e6e4cc2a70309a1e969ab6db77c","192":"17d5f47944b79e74641903a4959d033a855afd9bb0441f7cecc83b27bfec8e01","193":"43fc5c0bbe5b5bf49c18d2c1735ca75d3787633b663b7d376b2b723d6cbfbb90","194":"3065d1b447b3c0a8bbf3701564f2ecd457cf129d6d4b5c2ca42343b12564fe0f","195":"8817af2758a95e844399d95ba4b39bcc608252b8bdc62d0641dd4d1bce504d7b","196":"563df4144ede35b197533b655297dc6d0bd4bffa6660b56f93b4df3a82f368cd","197":"755ad5761fde840097c4fc737c892e06fca3cc003903f6d7097a9dafe99c58ea","198":"2d74068c2499c88caaf83ccf1015c618f4eea096eb53bd74897e58cc8ef265cf","199":"32f49725000d79f3fa8ebd642d60e5fb8867bdee9c210a1c5b19b00a509655dc","200":"9043e08f79054c0f0321a055e06785ea556709ba784abf14e1af70e136206e2e","201":"1f4c32772855a746228e86817ebae090678a80c63ee2a4fdb0ee44ccd1707258","202":"d0671c8a2b44d85ea7707d6ddfc3e32f9fc45eb780ec997e160f8df362d257af","203":"0748beaa913e6052295a9b43b754d3511c2039069b5bd54dd10d7027e073bdbc"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1016);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1315);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormattedDate; });
/* unused harmony export FormattedTime */
/* unused harmony export FormattedRelative */
/* unused harmony export FormattedNumber */
/* unused harmony export FormattedPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var locales = Array.isArray(data) ? data : [data];

    locales.forEach(function (localeData) {
        if (localeData && localeData.locale) {
            __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
            __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
        }
    });
}

function hasLocaleData(locale) {
    var localeParts = (locale || '').split('-');

    while (localeParts.length > 0) {
        if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
            return true;
        }

        localeParts.pop();
    }

    return false;
}

function hasIMFAndIRFLocaleData(locale) {
    var normalizedLocale = locale && locale.toLowerCase();

    return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
    locale: string,
    formats: object,
    messages: object,
    textComponent: any,

    defaultLocale: string,
    defaultFormats: object
};

var intlFormatPropTypes = {
    formatDate: funcReq,
    formatTime: funcReq,
    formatRelative: funcReq,
    formatNumber: funcReq,
    formatPlural: funcReq,
    formatMessage: funcReq,
    formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
    formatters: object,
    now: funcReq
}));

var messageDescriptorPropTypes = {
    id: string.isRequired,
    description: string,
    defaultMessage: string
};

var dateTimeFormatPropTypes = {
    localeMatcher: localeMatcher,
    formatMatcher: oneOf(['basic', 'best fit']),

    timeZone: string,
    hour12: bool,

    weekday: narrowShortLong,
    era: narrowShortLong,
    year: numeric2digit,
    month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
    day: numeric2digit,
    hour: numeric2digit,
    minute: numeric2digit,
    second: numeric2digit,
    timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
    localeMatcher: localeMatcher,

    style: oneOf(['decimal', 'currency', 'percent']),
    currency: string,
    currencyDisplay: oneOf(['symbol', 'code', 'name']),
    useGrouping: bool,

    minimumIntegerDigits: number,
    minimumFractionDigits: number,
    maximumFractionDigits: number,
    minimumSignificantDigits: number,
    maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
    style: oneOf(['best fit', 'numeric']),
    units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
    style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
    '&': '&amp;',
    '>': '&gt;',
    '<': '&lt;',
    '"': '&quot;',
    '\'': '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
    return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
        return ESCAPED_CHARS[match];
    });
}

function filterProps(props, whitelist) {
    var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return whitelist.reduce(function (filtered, name) {
        if (props.hasOwnProperty(name)) {
            filtered[name] = props[name];
        } else if (defaults$$1.hasOwnProperty(name)) {
            filtered[name] = defaults$$1[name];
        }

        return filtered;
    }, {});
}

function invariantIntlContext() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        intl = _ref.intl;

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
    if (objA === objB) {
        return true;
    }

    if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if (keysA.length !== keysB.length) {
        return false;
    }

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < keysA.length; i++) {
        if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
            return false;
        }
    }

    return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
    var props = _ref2.props,
        state = _ref2.state,
        _ref2$context = _ref2.context,
        context = _ref2$context === undefined ? {} : _ref2$context;
    var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _context$intl = context.intl,
        intl = _context$intl === undefined ? {} : _context$intl;
    var _nextContext$intl = nextContext.intl,
        nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


    return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
    return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$intlPropName = options.intlPropName,
        intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
        _options$withRef = options.withRef,
        withRef = _options$withRef === undefined ? false : _options$withRef;

    var InjectIntl = function (_Component) {
        inherits(InjectIntl, _Component);

        function InjectIntl(props, context) {
            classCallCheck(this, InjectIntl);

            var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

            invariantIntlContext(context);
            return _this;
        }

        createClass(InjectIntl, [{
            key: 'getWrappedInstance',
            value: function getWrappedInstance() {
                __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

                return this.refs.wrappedInstance;
            }
        }, {
            key: 'render',
            value: function render() {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
                    ref: withRef ? 'wrappedInstance' : null
                }));
            }
        }]);
        return InjectIntl;
    }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

    InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
    InjectIntl.contextTypes = {
        intl: intlShape
    };
    InjectIntl.WrappedComponent = WrappedComponent;


    return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
    // IntlMessageFormat#_resolveLocale() does not depend on `this`.
    return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
    // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
    return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlPluralFormat);

    var useOrdinal = options.style === 'ordinal';
    var pluralFn = findPluralFunction(resolveLocale(locales));

    this.format = function (value) {
        return pluralFn(value, useOrdinal);
    };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
    second: 60, // seconds to minute
    minute: 60, // minutes to hour
    hour: 24, // hours to day
    day: 30, // days to month
    month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
    var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
    thresholds.second = newThresholds.second;
    thresholds.minute = newThresholds.minute;
    thresholds.hour = newThresholds.hour;
    thresholds.day = newThresholds.day;
    thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
    var format = formats && formats[type] && formats[type][name];
    if (format) {
        return format;
    }

    if (false) {
        console.error('[React Intl] No ' + type + ' format named: ' + name);
    }
}

function formatDate(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var defaults$$1 = format && getNamedFormat(formats, 'date', format);
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting date.\n' + e);
        }
    }

    return String(date);
}

function formatTime(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var defaults$$1 = format && getNamedFormat(formats, 'time', format);
    var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

    if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
    }

    try {
        return state.getDateTimeFormat(locale, filteredOptions).format(date);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting time.\n' + e);
        }
    }

    return String(date);
}

function formatRelative(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var date = new Date(value);
    var now = new Date(options.now);
    var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
    var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

    // Capture the current threshold values, then temporarily override them with
    // specific values just for this render.
    var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
    updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

    try {
        return state.getRelativeFormat(locale, filteredOptions).format(date, {
            now: isFinite(now) ? now : state.now()
        });
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting relative time.\n' + e);
        }
    } finally {
        updateRelativeFormatThresholds(oldThresholds);
    }

    return String(date);
}

function formatNumber(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats;
    var format = options.format;


    var defaults$$1 = format && getNamedFormat(formats, 'number', format);
    var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

    try {
        return state.getNumberFormat(locale, filteredOptions).format(value);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting number.\n' + e);
        }
    }

    return String(value);
}

function formatPlural(config, state, value) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale;


    var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

    try {
        return state.getPluralFormat(locale, filteredOptions).format(value);
    } catch (e) {
        if (false) {
            console.error('[React Intl] Error formatting plural.\n' + e);
        }
    }

    return 'other';
}

function formatMessage(config, state) {
    var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var locale = config.locale,
        formats = config.formats,
        messages = config.messages,
        defaultLocale = config.defaultLocale,
        defaultFormats = config.defaultFormats;
    var id = messageDescriptor.id,
        defaultMessage = messageDescriptor.defaultMessage;

    // `id` is a required field of a Message Descriptor.

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

    var message = messages && messages[id];
    var hasValues = Object.keys(values).length > 0;

    // Avoid expensive message formatting for simple messages without values. In
    // development messages will always be formatted in case of missing values.
    if (!hasValues && "production" === 'production') {
        return message || defaultMessage || id;
    }

    var formattedMessage = void 0;

    if (message) {
        try {
            var formatter = state.getMessageFormat(message, locale, formats);

            formattedMessage = formatter.format(values);
        } catch (e) {
            if (false) {
                console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
            }
        }
    } else {
        if (false) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale, and a default message is in the source.
            if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {

                console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
            }
        }
    }

    if (!formattedMessage && defaultMessage) {
        try {
            var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

            formattedMessage = _formatter.format(values);
        } catch (e) {
            if (false) {
                console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
            }
        }
    }

    if (!formattedMessage) {
        if (false) {
            console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
        }
    }

    return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
    var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    // Process all the values before they are used when formatting the ICU
    // Message string. Since the formatted message might be injected via
    // `innerHTML`, all String-based values need to be HTML-escaped.
    var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
        var value = rawValues[name];
        escaped[name] = typeof value === 'string' ? escape(value) : value;
        return escaped;
    }, {});

    return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
    formats: {},
    messages: {},
    textComponent: 'span',

    defaultLocale: 'en',
    defaultFormats: {}
};

var IntlProvider = function (_Component) {
    inherits(IntlProvider, _Component);

    function IntlProvider(props) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        classCallCheck(this, IntlProvider);

        var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

        var intlContext = context.intl;

        // Used to stabilize time when performing an initial rendering so that
        // all relative times use the same reference "now" time.

        var initialNow = void 0;
        if (isFinite(props.initialNow)) {
            initialNow = Number(props.initialNow);
        } else {
            // When an `initialNow` isn't provided via `props`, look to see an
            // <IntlProvider> exists in the ancestry and call its `now()`
            // function to propagate its value for "now".
            initialNow = intlContext ? intlContext.now() : Date.now();
        }

        // Creating `Intl*` formatters is expensive. If there's a parent
        // `<IntlProvider>`, then its formatters will be used. Otherwise, this
        // memoize the `Intl*` constructors and cache them for the lifecycle of
        // this IntlProvider instance.

        var _ref = intlContext || {},
            _ref$formatters = _ref.formatters,
            formatters = _ref$formatters === undefined ? {
            getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
            getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
            getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
            getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
            getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
        } : _ref$formatters;

        _this.state = _extends({}, formatters, {

            // Wrapper to provide stable "now" time for initial render.
            now: function now() {
                return _this._didDisplay ? Date.now() : initialNow;
            }
        });
        return _this;
    }

    createClass(IntlProvider, [{
        key: 'getConfig',
        value: function getConfig() {
            var intlContext = this.context.intl;

            // Build a whitelisted config object from `props`, defaults, and
            // `context.intl`, if an <IntlProvider> exists in the ancestry.

            var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

            // Apply default props. This must be applied last after the props have
            // been resolved and inherited from any <IntlProvider> in the ancestry.
            // This matches how React resolves `defaultProps`.
            for (var propName in defaultProps) {
                if (config[propName] === undefined) {
                    config[propName] = defaultProps[propName];
                }
            }

            if (!hasLocaleData(config.locale)) {
                var _config = config,
                    locale = _config.locale,
                    defaultLocale = _config.defaultLocale,
                    defaultFormats = _config.defaultFormats;


                if (false) {
                    console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
                }

                // Since there's no registered locale data for `locale`, this will
                // fallback to the `defaultLocale` to make sure things can render.
                // The `messages` are overridden to the `defaultProps` empty object
                // to maintain referential equality across re-renders. It's assumed
                // each <FormattedMessage> contains a `defaultMessage` prop.
                config = _extends({}, config, {
                    locale: defaultLocale,
                    formats: defaultFormats,
                    messages: defaultProps.messages
                });
            }

            return config;
        }
    }, {
        key: 'getBoundFormatFns',
        value: function getBoundFormatFns(config, state) {
            return intlFormatPropNames.reduce(function (boundFormatFns, name) {
                boundFormatFns[name] = format[name].bind(null, config, state);
                return boundFormatFns;
            }, {});
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            var config = this.getConfig();

            // Bind intl factories and current config to the format functions.
            var boundFormatFns = this.getBoundFormatFns(config, this.state);

            var _state = this.state,
                now = _state.now,
                formatters = objectWithoutProperties(_state, ['now']);


            return {
                intl: _extends({}, config, boundFormatFns, {
                    formatters: formatters,
                    now: now
                })
            };
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._didDisplay = true;
        }
    }, {
        key: 'render',
        value: function render() {
            return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
        }
    }]);
    return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
    intl: intlShape
};
IntlProvider.childContextTypes = {
    intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
    children: PropTypes.element.isRequired,
    initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
    inherits(FormattedDate, _Component);

    function FormattedDate(props, context) {
        classCallCheck(this, FormattedDate);

        var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedDate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatDate = _context$intl.formatDate,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedDate = formatDate(value, this.props);

            if (typeof children === 'function') {
                return children(formattedDate);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedDate
            );
        }
    }]);
    return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
    intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
    inherits(FormattedTime, _Component);

    function FormattedTime(props, context) {
        classCallCheck(this, FormattedTime);

        var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedTime, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatTime = _context$intl.formatTime,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedTime = formatTime(value, this.props);

            if (typeof children === 'function') {
                return children(formattedTime);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedTime
            );
        }
    }]);
    return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
    intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
    var absDelta = Math.abs(delta);

    if (absDelta < MINUTE) {
        return 'second';
    }

    if (absDelta < HOUR) {
        return 'minute';
    }

    if (absDelta < DAY) {
        return 'hour';
    }

    // The maximum scheduled delay will be measured in days since the maximum
    // timer delay is less than the number of milliseconds in 25 days.
    return 'day';
}

function getUnitDelay(units) {
    switch (units) {
        case 'second':
            return SECOND;
        case 'minute':
            return MINUTE;
        case 'hour':
            return HOUR;
        case 'day':
            return DAY;
        default:
            return MAX_TIMER_DELAY;
    }
}

function isSameDate(a, b) {
    if (a === b) {
        return true;
    }

    var aTime = new Date(a).getTime();
    var bTime = new Date(b).getTime();

    return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
    inherits(FormattedRelative, _Component);

    function FormattedRelative(props, context) {
        classCallCheck(this, FormattedRelative);

        var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

        invariantIntlContext(context);

        var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

        // `now` is stored as state so that `render()` remains a function of
        // props + state, instead of accessing `Date.now()` inside `render()`.
        _this.state = { now: now };
        return _this;
    }

    createClass(FormattedRelative, [{
        key: 'scheduleNextUpdate',
        value: function scheduleNextUpdate(props, state) {
            var _this2 = this;

            // Cancel and pending update because we're scheduling a new update.
            clearTimeout(this._timer);

            var value = props.value,
                units = props.units,
                updateInterval = props.updateInterval;

            var time = new Date(value).getTime();

            // If the `updateInterval` is falsy, including `0` or we don't have a
            // valid date, then auto updates have been turned off, so we bail and
            // skip scheduling an update.
            if (!updateInterval || !isFinite(time)) {
                return;
            }

            var delta = time - state.now;
            var unitDelay = getUnitDelay(units || selectUnits(delta));
            var unitRemainder = Math.abs(delta % unitDelay);

            // We want the largest possible timer delay which will still display
            // accurate information while reducing unnecessary re-renders. The delay
            // should be until the next "interesting" moment, like a tick from
            // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
            var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

            this._timer = setTimeout(function () {
                _this2.setState({ now: _this2.context.intl.now() });
            }, delay);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.scheduleNextUpdate(this.props, this.state);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var nextValue = _ref.value;

            // When the `props.value` date changes, `state.now` needs to be updated,
            // and the next update can be rescheduled.
            if (!isSameDate(nextValue, this.props.value)) {
                this.setState({ now: this.context.intl.now() });
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            this.scheduleNextUpdate(nextProps, nextState);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this._timer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatRelative = _context$intl.formatRelative,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

            if (typeof children === 'function') {
                return children(formattedRelative);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedRelative
            );
        }
    }]);
    return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
    intl: intlShape
};
FormattedRelative.defaultProps = {
    updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    updateInterval: PropTypes.number,
    initialNow: PropTypes.any,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
    inherits(FormattedNumber, _Component);

    function FormattedNumber(props, context) {
        classCallCheck(this, FormattedNumber);

        var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedNumber, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatNumber = _context$intl.formatNumber,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                children = _props.children;


            var formattedNumber = formatNumber(value, this.props);

            if (typeof children === 'function') {
                return children(formattedNumber);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedNumber
            );
        }
    }]);
    return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
    intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
    value: PropTypes.any.isRequired,
    format: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
    inherits(FormattedPlural, _Component);

    function FormattedPlural(props, context) {
        classCallCheck(this, FormattedPlural);

        var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedPlural, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
                next[_key] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatPlural = _context$intl.formatPlural,
                Text = _context$intl.textComponent;
            var _props = this.props,
                value = _props.value,
                other = _props.other,
                children = _props.children;


            var pluralCategory = formatPlural(value, this.props);
            var formattedPlural = this.props[pluralCategory] || other;

            if (typeof children === 'function') {
                return children(formattedPlural);
            }

            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                Text,
                null,
                formattedPlural
            );
        }
    }]);
    return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
    intl: intlShape
};
FormattedPlural.defaultProps = {
    style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
    value: PropTypes.any.isRequired,

    other: PropTypes.node.isRequired,
    zero: PropTypes.node,
    one: PropTypes.node,
    two: PropTypes.node,
    few: PropTypes.node,
    many: PropTypes.node,

    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
    inherits(FormattedMessage, _Component);

    function FormattedMessage(props, context) {
        classCallCheck(this, FormattedMessage);

        var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var values = this.props.values;
            var nextValues = nextProps.values;


            if (!shallowEquals(nextValues, values)) {
                return true;
            }

            // Since `values` has already been checked, we know they're not
            // different, so the current `values` are carried over so the shallow
            // equals comparison on the other props isn't affected by the `values`.
            var nextPropsToCheck = _extends({}, nextProps, {
                values: values
            });

            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                next[_key - 1] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatMessage = _context$intl.formatMessage,
                Text = _context$intl.textComponent;
            var _props = this.props,
                id = _props.id,
                description = _props.description,
                defaultMessage = _props.defaultMessage,
                values = _props.values,
                _props$tagName = _props.tagName,
                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
                children = _props.children;


            var tokenDelimiter = void 0;
            var tokenizedValues = void 0;
            var elements = void 0;

            var hasValues = values && Object.keys(values).length > 0;
            if (hasValues) {
                // Creates a token with a random UID that should not be guessable or
                // conflict with other parts of the `message` string.
                var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

                var generateToken = function () {
                    var counter = 0;
                    return function () {
                        return 'ELEMENT-' + uid + '-' + (counter += 1);
                    };
                }();

                // Splitting with a delimiter to support IE8. When using a regex
                // with a capture group IE8 does not include the capture group in
                // the resulting array.
                tokenDelimiter = '@__' + uid + '__@';
                tokenizedValues = {};
                elements = {};

                // Iterates over the `props` to keep track of any React Element
                // values so they can be represented by the `token` as a placeholder
                // when the `message` is formatted. This allows the formatted
                // message to then be broken-up into parts with references to the
                // React Elements inserted back in.
                Object.keys(values).forEach(function (name) {
                    var value = values[name];

                    if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
                        var token = generateToken();
                        tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
                        elements[token] = value;
                    } else {
                        tokenizedValues[name] = value;
                    }
                });
            }

            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
            var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

            var nodes = void 0;

            var hasElements = elements && Object.keys(elements).length > 0;
            if (hasElements) {
                // Split the message into parts so the React Element values captured
                // above can be inserted back into the rendered message. This
                // approach allows messages to render with React Elements while
                // keeping React's virtual diffing working properly.
                nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
                    return !!part;
                }).map(function (part) {
                    return elements[part] || part;
                });
            } else {
                nodes = [formattedMessage];
            }

            if (typeof children === 'function') {
                return children.apply(undefined, toConsumableArray(nodes));
            }

            // Needs to use `createElement()` instead of JSX, otherwise React will
            // warn about a missing `key` prop with rich-text message formatting.
            return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
        }
    }]);
    return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
    intl: intlShape
};
FormattedMessage.defaultProps = {
    values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
    values: PropTypes.object,
    tagName: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
    inherits(FormattedHTMLMessage, _Component);

    function FormattedHTMLMessage(props, context) {
        classCallCheck(this, FormattedHTMLMessage);

        var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

        invariantIntlContext(context);
        return _this;
    }

    createClass(FormattedHTMLMessage, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var values = this.props.values;
            var nextValues = nextProps.values;


            if (!shallowEquals(nextValues, values)) {
                return true;
            }

            // Since `values` has already been checked, we know they're not
            // different, so the current `values` are carried over so the shallow
            // equals comparison on the other props isn't affected by the `values`.
            var nextPropsToCheck = _extends({}, nextProps, {
                values: values
            });

            for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                next[_key - 1] = arguments[_key];
            }

            return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
        }
    }, {
        key: 'render',
        value: function render() {
            var _context$intl = this.context.intl,
                formatHTMLMessage = _context$intl.formatHTMLMessage,
                Text = _context$intl.textComponent;
            var _props = this.props,
                id = _props.id,
                description = _props.description,
                defaultMessage = _props.defaultMessage,
                rawValues = _props.values,
                _props$tagName = _props.tagName,
                Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
                children = _props.children;


            var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
            var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

            if (typeof children === 'function') {
                return children(formattedHTMLMessage);
            }

            // Since the message presumably has HTML in it, we need to set
            // `innerHTML` in order for it to be rendered and not escaped by React.
            // To be safe, all string prop values were escaped when formatting the
            // message. It is assumed that the message is not UGC, and came from the
            // developer making it more like a template.
            //
            // Note: There's a perf impact of using this component since there's no
            // way for React to do its virtual DOM diffing.
            var html = { __html: formattedHTMLMessage };
            return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
        }
    }]);
    return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
    intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
    values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
    values: PropTypes.object,
    tagName: PropTypes.string,
    children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return injectGlobal; });
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeProvider; });
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);







/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

// 
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      return [].concat(ruleSet, flatten(chunk, executionContext));
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    return ruleSet.concat(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

// 
var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: true
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_2_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

// 

function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

// 
/**
 * When using streaming rendering, style blocks are emitted in chunks directly
 * next to the HTML they reference. In order to prevent errors during rehydration
 * (since React doesn't know about the style blocks we are interleaving) this
 * method relocates all styled-component blocks to the end of `<head>`.
 *
 * NOTE: this method MUST be called before ReactDOM.hydrate().
 */
function consolidateStreamedStyles() {
  var blocks = Array.from(document.querySelectorAll('style[data-styled-components]'));

  if (blocks.length) {
    var frag = document.createDocumentFragment();

    for (var i = 0, len = blocks.length; i < len; i += 1) {
      // $FlowFixMe
      frag.appendChild(blocks[i].parentNode.removeChild(blocks[i]));
    }

    // $FlowFixMe
    document.head.appendChild(frag);
  }
}

// 
var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
var charsLength = chars.length;

/* Some high number, usually 9-digit base-10. Map it to base-😎 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = chars[x % charsLength] + name;
  }

  return chars[x % charsLength] + name;
};

// 

var interleave = (function (strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
});

// 
var css = (function (strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  return flatten(interleave(strings, interpolations));
});

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractCompsFromCSS = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
/* eslint-disable no-underscore-dangle */
/*
 * Browser Style Sheet with Rehydration
 *
 * <style data-styled-components="x y z"
 *        data-styled-components-is-local="true">
 *   /· sc-component-id: a ·/
 *   .sc-a { ... }
 *   .x { ... }
 *   /· sc-component-id: b ·/
 *   .sc-b { ... }
 *   .y { ... }
 *   .z { ... }
 * </style>
 *
 * Note: replace · with * in the above snippet.
 * */
var DISABLE_SPEEDY = typeof false === 'boolean' && false || "production" === 'development';

var COMPONENTS_PER_TAG = 40;
var SPEEDY_COMPONENTS_PER_TAG = 1000; // insertRule allows more injections before a perf slowdown

// Source: https://github.com/threepointone/glamor/blob/master/src/sheet.js#L32-L43
var sheetForTag = function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  }

  for (var i = 0; i < document.styleSheets.length; i += 1) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }

  // NOTE: This should never happen
  throw new Error('');
};

// Safely (try/catch) injects rule at index and returns whether it was successful
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  if (cssRule === undefined || cssRule.length === 0) {
    return false;
  }

  var maxIndex = sheet.cssRules.length;
  var cappedIndex = index <= maxIndex ? index : maxIndex;

  try {
    sheet.insertRule(cssRule, cappedIndex);
  } catch (err) {
    // NOTE: An invalid rule here means it's not supported by the browser or obviously malformed
    return false;
  }

  return true;
};

// Counts up the number of rules inside the array until a specific component entry is found
// This is used to determine the necessary insertRule index
var sizeUpToComponentIndex = function sizeUpToComponentIndex(componentSizes, componentIndex) {
  var cssRulesSize = 0;
  for (var i = 0; i <= componentIndex; i += 1) {
    cssRulesSize += componentSizes[i];
  }

  return cssRulesSize;
};

var BaseBrowserTag = function () {
  function BaseBrowserTag() {
    classCallCheck(this, BaseBrowserTag);
  }

  BaseBrowserTag.prototype.toReactElement = function toReactElement() {
    throw new Error( false ? "BrowserTag doesn't implement toReactElement!" : '');
  };

  BaseBrowserTag.prototype.clone = function clone() {
    throw new Error( false ? 'BrowserTag cannot be cloned!' : '');
  };

  BaseBrowserTag.prototype.getComponentIds = function getComponentIds() {
    return Object.keys(this.components);
  };

  return BaseBrowserTag;
}();

var BrowserTag = void 0;
if (!DISABLE_SPEEDY) {
  BrowserTag = function (_BaseBrowserTag) {
    inherits(SpeedyBrowserTag, _BaseBrowserTag);

    // Store component ruleSizes in an array per component (in order)


    function SpeedyBrowserTag(el, isLocal, existingSource) {
      classCallCheck(this, SpeedyBrowserTag);

      var _this = possibleConstructorReturn(this, _BaseBrowserTag.call(this));

      var nonce = getNonce();
      if (nonce) {
        el.setAttribute('nonce', nonce);
      }

      var extractedComps = extractCompsFromCSS(existingSource);

      _this.el = el;
      _this.isLocal = isLocal;
      _this.ready = false;
      _this.componentSizes = [];
      _this.size = extractedComps.length;
      _this.components = extractedComps.reduce(function (acc, obj) {
        acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
        return acc;
      }, {});
      return _this;
    }

    /* Because we care about source order, before we can inject anything we need to
     * create a text node for each component and replace the existing CSS. */


    SpeedyBrowserTag.prototype.replaceElement = function replaceElement() {
      var _this2 = this;

      // Build up our replacement style tag
      var newEl = this.el.cloneNode(false);
      newEl.setAttribute(SC_ATTR, '');

      if (!this.el.parentNode) {
        throw new Error( false ? "Trying to replace an element that wasn't mounted!" : '');
      }

      this.el.parentNode.replaceChild(newEl, this.el);
      this.el = newEl;
      this.ready = true;

      // Retrieve the sheet for the new style tag
      var sheet = sheetForTag(newEl);

      Object.keys(this.components).forEach(function (componentId) {
        var comp = _this2.components[componentId];
        var cssFromDOM = comp.cssFromDOM;

        var rules = stringifyRules([cssFromDOM]);
        var rulesSize = rules.length;

        var injectedRules = 0;
        for (var j = 0; j < rulesSize; j += 1) {
          if (safeInsertRule(sheet, rules[j], sheet.cssRules.length)) {
            injectedRules += 1;
          }
        }

        comp.componentIndex = _this2.componentSizes.length;
        comp.css = rules.join(' ');
        _this2.componentSizes.push(injectedRules);
      });
    };

    SpeedyBrowserTag.prototype.isSealed = function isSealed() {
      return this.size >= SPEEDY_COMPONENTS_PER_TAG;
    };

    SpeedyBrowserTag.prototype.addComponent = function addComponent(componentId) {
      if (!this.ready) this.replaceElement();

      if (false) {
        throw new Error('Trying to add Component \'' + componentId + '\' twice!');
      }

      this.components[componentId] = {
        componentIndex: this.componentSizes.length,
        css: ''
      };

      this.componentSizes.push(0);
      this.size += 1;
    };

    SpeedyBrowserTag.prototype.inject = function inject(componentId, cssRules) {
      if (!this.ready) this.replaceElement();

      var comp = this.components[componentId];
      if (false) {
        throw new Error('Must add a new component before you can inject css into it');
      }

      var cssRulesSize = cssRules.length;
      var sheet = sheetForTag(this.el);
      var componentIndex = comp.componentIndex;

      // Determine start index for injection

      var insertIndex = sizeUpToComponentIndex(this.componentSizes, componentIndex);

      // Inject each rule shifting index forward for each one (in-order injection)
      var injectedRules = 0;
      for (var i = 0; i < cssRulesSize; i += 1) {
        var cssRule = cssRules[i];
        if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
          comp.css += ' ' + cssRule;
          injectedRules += 1;
        }
      }

      // Update number of rules for component
      this.componentSizes[componentIndex] += injectedRules;
    };

    SpeedyBrowserTag.prototype.toRawCSS = function toRawCSS() {
      return ''; // NOTE: Unsupported in production mode (SpeedyBrowserTag)
    };

    SpeedyBrowserTag.prototype.toHTML = function toHTML() {
      return ''; // NOTE: Unsupported in production mode (SpeedyBrowserTag)
    };

    return SpeedyBrowserTag;
  }(BaseBrowserTag);
} else {
  BrowserTag = function (_BaseBrowserTag2) {
    inherits(TextNodeBrowserTag, _BaseBrowserTag2);

    function TextNodeBrowserTag(el, isLocal) {
      var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      classCallCheck(this, TextNodeBrowserTag);

      var _this3 = possibleConstructorReturn(this, _BaseBrowserTag2.call(this));

      var nonce = getNonce();
      if (nonce !== null) {
        el.setAttribute('nonce', nonce);
      }

      var extractedComps = extractCompsFromCSS(existingSource);

      _this3.el = el;
      _this3.isLocal = isLocal;
      _this3.ready = false;
      _this3.size = extractedComps.length;
      _this3.components = extractedComps.reduce(function (acc, obj) {
        acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
        return acc;
      }, {});
      return _this3;
    }

    TextNodeBrowserTag.prototype.isSealed = function isSealed() {
      return this.size >= COMPONENTS_PER_TAG;
    };

    TextNodeBrowserTag.prototype.addComponent = function addComponent(componentId) {
      if (!this.ready) this.replaceElement();
      if (false) {
        throw new Error('Trying to add Component \'' + componentId + '\' twice!');
      }

      var comp = { componentId: componentId, textNode: document.createTextNode('') };
      this.el.appendChild(comp.textNode);
      this.size += 1;
      this.components[componentId] = comp;
    };

    TextNodeBrowserTag.prototype.inject = function inject(componentId, css, name) {
      if (!this.ready) this.replaceElement();
      var comp = this.components[componentId];

      if (false) {
        throw new Error('Must add a new component before you can inject css into it');
      }

      if (comp.textNode.data === '') {
        comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');
      }

      comp.textNode.appendData(css.join(' '));

      if (name !== undefined && name !== null) {
        var existingNames = this.el.getAttribute(SC_ATTR);
        this.el.setAttribute(SC_ATTR, existingNames ? existingNames + ' ' + name : name);
      }
    };

    TextNodeBrowserTag.prototype.toHTML = function toHTML() {
      return this.el.outerHTML;
    };

    TextNodeBrowserTag.prototype.toReactElement = function toReactElement() {
      throw new Error( false ? "BrowserTag doesn't implement toReactElement!" : '');
    };

    TextNodeBrowserTag.prototype.clone = function clone() {
      throw new Error( false ? 'BrowserTag cannot be cloned!' : '');
    };

    /* Because we care about source order, before we can inject anything we need to
     * create a text node for each component and replace the existing CSS. */


    TextNodeBrowserTag.prototype.replaceElement = function replaceElement() {
      var _this4 = this;

      this.ready = true;
      // We have nothing to inject. Use the current el.
      if (this.size === 0) return;

      // Build up our replacement style tag
      var newEl = this.el.cloneNode(false);
      newEl.appendChild(document.createTextNode('\n'));

      Object.keys(this.components).forEach(function (key) {
        var comp = _this4.components[key];

        // eslint-disable-next-line no-param-reassign
        comp.textNode = document.createTextNode(comp.cssFromDOM);
        newEl.appendChild(comp.textNode);
      });

      if (!this.el.parentNode) {
        throw new Error( false ? "Trying to replace an element that wasn't mounted!" : '');
      }

      // The ol' switcheroo
      this.el.parentNode.replaceChild(newEl, this.el);
      this.el = newEl;
    };

    return TextNodeBrowserTag;
  }(BaseBrowserTag);
}

/* Factory function to separate DOM operations from logical ones*/
var BrowserStyleSheet = {
  create: function create() {
    var tags = [];
    var names = {};

    /* Construct existing state from DOM */
    var nodes = document.querySelectorAll('[' + SC_ATTR + ']');
    var nodesLength = nodes.length;

    for (var i = 0; i < nodesLength; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];
      var attr = el.getAttribute(SC_ATTR);

      if (attr) {
        attr.trim().split(/\s+/).forEach(function (name) {
          names[name] = true;
        });
      }

      tags.push(new BrowserTag(el, el.getAttribute(LOCAL_ATTR) === 'true', el.innerHTML));
    }

    /* Factory for making more tags */
    var tagConstructor = function tagConstructor(isLocal) {
      var el = document.createElement('style');
      el.type = 'text/css';
      el.setAttribute(SC_ATTR, '');
      el.setAttribute(LOCAL_ATTR, isLocal ? 'true' : 'false');
      if (!document.head) {
        throw new Error( false ? 'Missing document <head>' : '');
      }
      document.head.appendChild(el);
      return new BrowserTag(el, isLocal);
    };

    return new StyleSheet(tagConstructor, tags, names);
  }
};

// 
var SC_ATTR = 'data-styled-components';
var LOCAL_ATTR = 'data-styled-components-is-local';
var CONTEXT_KEY = '__styled-components-stylesheet__';

/* eslint-disable flowtype/object-type-delimiter */
/* eslint-enable flowtype/object-type-delimiter */

var instance = null;
// eslint-disable-next-line no-use-before-define
var clones = [];

var IS_BROWSER = typeof document !== 'undefined';

var StyleSheet = function () {
  function StyleSheet(tagConstructor) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, StyleSheet);
    this.hashes = {};
    this.deferredInjections = {};
    this.stylesCacheable = IS_BROWSER;

    this.tagConstructor = tagConstructor;
    this.tags = tags;
    this.names = names;
    this.constructComponentTagMap();
  }

  // helper for `ComponentStyle` to know when it cache static styles.
  // staticly styled-component can not safely cache styles on the server
  // without all `ComponentStyle` instances saving a reference to the
  // the styleSheet instance they last rendered with,
  // or listening to creation / reset events. otherwise you might create
  // a component with one stylesheet and render it another api response
  // with another, losing styles on from your server-side render.


  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
    var _this = this;

    this.componentTags = {};

    this.tags.forEach(function (tag) {
      tag.getComponentIds().forEach(function (componentId) {
        _this.componentTags[componentId] = tag;
      });
    });
  };

  /* Best level of caching—get the name from the hash straight away. */


  StyleSheet.prototype.getName = function getName(hash) {
    return this.hashes[hash.toString()];
  };

  /* Second level of caching—if the name is already in the dom, don't
   * inject anything and record the hash for getName next time. */


  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
    if (!this.names[name]) return false;

    this.hashes[hash.toString()] = name;
    return true;
  };

  /* Third type of caching—don't inject components' componentId twice. */


  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
    return !!this.componentTags[componentId];
  };

  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.deferredInject(componentId, isLocal, css);
      });
    }

    this.getOrCreateTag(componentId, isLocal);
    this.deferredInjections[componentId] = css;
  };

  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.inject(componentId, isLocal, css);
      });
    }

    var tag = this.getOrCreateTag(componentId, isLocal);

    var deferredInjection = this.deferredInjections[componentId];
    if (deferredInjection) {
      tag.inject(componentId, deferredInjection);
      delete this.deferredInjections[componentId];
    }

    tag.inject(componentId, css, name);

    if (hash && name) {
      this.hashes[hash.toString()] = name;
    }
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    return this.tags.map(function (tag, i) {
      return tag.toReactElement('sc-' + i);
    });
  };

  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
    var existingTag = this.componentTags[componentId];
    if (existingTag) {
      return existingTag;
    }

    var lastTag = this.tags[this.tags.length - 1];
    var componentTag = !lastTag || lastTag.isSealed() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
    this.componentTags[componentId] = componentTag;
    componentTag.addComponent(componentId);
    return componentTag;
  };

  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
    var newTag = this.tagConstructor(isLocal);
    this.tags.push(newTag);
    return newTag;
  };

  StyleSheet.reset = function reset(isServer) {
    instance = StyleSheet.create(isServer);
  };

  /* We can make isServer totally implicit once Jest 20 drops and we
   * can change environment on a per-test basis. */


  StyleSheet.create = function create() {
    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !IS_BROWSER;

    return (isServer ? ServerStyleSheet : BrowserStyleSheet).create();
  };

  StyleSheet.clone = function clone(oldSheet) {
    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
      return tag.clone();
    }), _extends({}, oldSheet.names));

    newSheet.hashes = _extends({}, oldSheet.hashes);
    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
    clones.push(newSheet);

    return newSheet;
  };

  createClass(StyleSheet, null, [{
    key: 'instance',
    get: function get$$1() {
      return instance || (instance = StyleSheet.create());
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

// 
var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.props.sheet, _ref;
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);

 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]).isRequired
} : void 0;

// 
/* eslint-disable no-underscore-dangle */
var ServerTag = function () {
  function ServerTag(isLocal) {
    classCallCheck(this, ServerTag);

    this.emitted = false;
    this.isLocal = isLocal;
    this.isProduction = "production" === 'production';
    this.components = {};
    this.size = 0;
    this.names = [];
  }

  ServerTag.prototype.isSealed = function isSealed() {
    return this.emitted;
  };

  ServerTag.prototype.getComponentIds = function getComponentIds() {
    return Object.keys(this.components);
  };

  ServerTag.prototype.addComponent = function addComponent(componentId) {
    if (this.components[componentId]) {
      throw new Error( false ? 'Trying to add Component \'' + componentId + '\' twice!' : '');
    }
    this.components[componentId] = { componentId: componentId, css: '' };
    this.size += 1;
  };

  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
    var _this = this;

    return Object.keys(this.components).reduce(function (styles, k) {
      return styles + _this.components[k].css;
    }, '');
  };

  ServerTag.prototype.inject = function inject(componentId, css, name) {
    var comp = this.components[componentId];

    if (!comp) {
      throw new Error( false ? 'Must add a new component before you can inject css into it' : '');
    }

    if (comp.css === '') {
      comp.css = '/* sc-component-id: ' + componentId + ' */\n';
    }

    var cssRulesSize = css.length;
    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = css[i];
      comp.css += (cssRule + '\n').replace(/\n*$/, '\n');
    }

    if (name) this.names.push(name);
  };

  ServerTag.prototype.toHTML = function toHTML() {
    var attrs = ['type="text/css"', SC_ATTR + '="' + this.names.join(' ') + '"', LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];

    var nonce = getNonce();
    if (nonce) {
      attrs.push('nonce="' + nonce + '"');
    }

    this.emitted = true;
    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
  };

  ServerTag.prototype.toReactElement = function toReactElement(key) {
    var _attrs;

    var attrs = (_attrs = {}, _attrs[SC_ATTR] = this.names.join(' '), _attrs[LOCAL_ATTR] = this.isLocal.toString(), _attrs);

    var nonce = getNonce();
    if (nonce) {
      attrs.nonce = nonce;
    }

    this.emitted = true;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', _extends({
      key: key,
      type: 'text/css'
    }, attrs, {
      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
    }));
  };

  ServerTag.prototype.clone = function clone() {
    var _this2 = this;

    var copy = new ServerTag(this.isLocal);
    copy.names = [].concat(this.names);
    copy.size = this.size;
    copy.components = Object.keys(this.components).reduce(function (acc, key) {
      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
      return acc;
    }, {});

    return copy;
  };

  return ServerTag;
}();

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    this.instance = StyleSheet.clone(StyleSheet.instance);
    this.isStreaming = false;
  }

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new Error( false ? "Can't collect styles once you've called getStyleTags!" : '');
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    {
      throw new Error( false ? 'streaming only works in Node.js, please do not try to call this method in the browser' : '');
    }
  };

  ServerStyleSheet.create = function create() {
    return new StyleSheet(function (isLocal) {
      return new ServerTag(isLocal);
    });
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 **/
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|(?:attribute|glyph)Nam|playsInlin|(?:formE|e)ncTyp|(?:writing|input|edge)Mod|(?:xlinkTy|itemSco|keyTy|slo)p|(?:amplitu|mo)d|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ntrol|ord)s|o(?:lor(?:Interpolation)?|ntent)|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|o(?:ntextMenu|ls)|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|(?:rossOrigi|olSpa)n|apHeight|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|formActio|zoomAndPa|onFocusI|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:gradientT|patternT|t)ransform|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|a(?:utoCorrec|bou)|markerStar|onFocusOu|in(?:tercep|lis)|restar|forma|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|m(?:arkerMi|etho)|preloa|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:allowFullScre|hidd)en|strokeDasharray|systemLanguage|(?:strokeLineca|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|unicodeRange|(?:(?:allowReord|placehold|frameBord|paintOrd|post|ord)e|repeatDu|d(?:efe|u))r|mathematical|(?:vI|i)deographic|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|vAlphabetic|mediaGroup|spellCheck|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|(?:xmlnsXl|valueL)ink|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|(?:text|m(?:in|ax))Length|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|r(?:e(?:quired|sult|f))?|o(?:verflow|pen)|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|f(?:o(?:ntSize|rm)|il(?:ter|l))|autoPlay|unicode|p(?:attern|oints)|t(?:arget[XY]|o)|i(?:temRef|n2|s)|divisor|d(?:efault|ata|ir)?|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|(?:stri|la)ng|prefix|itemID|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|s)|t(?:arget|ype)|typeof|width|value|x(?:mlns)?|label|m(?:edia|a(?:sk|x)|in)|size|href|k(?:ey)?|end|low|x[12]|i[dn]|y[12]|g[12]|by|f[xy]|[yz])$/;

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

var _ThemeProvider$childC;
var _ThemeProvider$contex;

// 
/* globals React$Element */
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (false) {
        throw new Error(process.env.NODE_ENV !== 'production' ? '[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!' : '');
      }
      return mergedTheme;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(theme)) {
      throw new Error( false ? '[ThemeProvider] Please make your theme prop a plain object' : '');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

// 

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var identifiers = {};

  /* We depend on components having unique IDs */
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

    var componentId = void 0;

    /**
     * only fall back to hashing the component injection order if
     * a proper displayName isn't provided by the babel plugin
     */
    if (!_displayName) {
      var nr = (identifiers[displayName] || 0) + 1;
      identifiers[displayName] = nr;

      componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    } else {
      componentId = displayName + '-' + ComponentStyle.generateName(displayName);
    }

    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  var BaseStyledComponent = function (_Component) {
    inherits(BaseStyledComponent, _Component);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          attrs = _constructor.attrs,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.instance;

      // staticaly styled-components don't need to build an execution context object,
      // and shouldn't be increasing the number of class names
      if (componentStyle.isStatic && attrs === undefined) {
        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
      } else {
        var executionContext = this.buildExecutionContext(theme, props);
        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

        if (false) {
          warnTooManyClasses(className);
        }

        return className;
      }
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var componentStyle = this.constructor.componentStyle;

      var styledContext = this.context[CHANNEL_NEXT];

      // If this is a staticaly-styled component, we don't need to the theme
      // to generate or build styles.
      if (componentStyle.isStatic) {
        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
        this.setState({ generatedClassName: generatedClassName });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
      } else if (styledContext !== undefined) {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          // This will be called once immediately
          var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        // eslint-disable-next-line react/prop-types
        var theme = this.props.theme || {};
        var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: _generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // If this is a staticaly-styled component, we don't need to listen to
      // props changes to update styles
      var componentStyle = this.constructor.componentStyle;

      if (componentStyle.isStatic) {
        return;
      }

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, _this3.constructor.defaultProps);
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromContext();
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;


      var isTargetTag = isTag(target);

      var className = [
      // eslint-disable-next-line react/prop-types
      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')' : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _StyledComponent$cont);
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

// 
var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled copmonent
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      var value = attrs[key];
      if (typeof value === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHRMEnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHRMEnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;
      if (!StyleSheet.instance.hasInjectedComponent(this.componentId)) {
        var placeholder =  false ? '.' + componentId + ' {}' : '';
        StyleSheet.instance.deferredInject(componentId, true, [placeholder]);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          lastClassName = this.lastClassName;

      if (isStatic && lastClassName !== undefined) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var hash = doHash(this.componentId + flatCSS.join(''));

      var stylesCacheable = styleSheet.stylesCacheable;

      var existingName = styleSheet.getName(hash);

      if (existingName !== undefined) {
        if (stylesCacheable) {
          this.lastClassName = existingName;
        }
        return existingName;
      }

      var name = nameGenerator(hash);
      if (stylesCacheable) {
        this.lastClassName = existingName;
      }
      if (styleSheet.alreadyInjected(hash, name)) {
        return name;
      }

      var css = stringifyRules(flatCSS, '.' + name);
      // NOTE: this can only be set when we inject the class-name.
      // For some reason, presumably due to how css is stringifyRules behaves in
      // differently between client and server, styles break.
      styleSheet.inject(this.componentId, true, css, hash, name);
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return nameGenerator(doHash(str));
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 
var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(replaceWhitespace(JSON.stringify(rules)));

    var existingName = StyleSheet.instance.getName(hash);
    if (existingName) return existingName;

    var name = nameGenerator(hash);
    if (StyleSheet.instance.alreadyInjected(hash, name)) return name;

    var generatedCSS = stringifyRules(rules, name, '@keyframes');
    StyleSheet.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
    return name;
  };
});

// 
var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal(strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(JSON.stringify(rules));

    var componentId = 'sc-global-' + hash;
    if (StyleSheet.instance.hasInjectedComponent(componentId)) return;

    StyleSheet.instance.inject(componentId, false, stringifyRules(rules));
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (typeof tag !== 'string' && typeof tag !== 'function') {
      throw new Error( false ? 'Cannot create styled-component for component: ' + String(tag) : '');
    }

    /* This is callable directly as a template function */
    var templateFunction = function templateFunction(strings) {
      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }

      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 
/* globals ReactClass */

var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

// 

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Warning if you've imported this file on React Native */
if (false) {
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* Export everything */


/* harmony default export */ __webpack_exports__["c"] = (styled);
//# sourceMappingURL=styled-components.browser.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(420)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(22)
  , core      = __webpack_require__(109)
  , hide      = __webpack_require__(61)
  , redefine  = __webpack_require__(62)
  , ctx       = __webpack_require__(110)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target)redefine(target, key, out, type & $export.U);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1314)();
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAction__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handleAction__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleActions__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__combineActions__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createActions__ = __webpack_require__(1389);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createAction__["a"]; });
/* unused harmony reexport createActions */
/* unused harmony reexport handleAction */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__handleActions__["a"]; });
/* unused harmony reexport combineActions */








/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return Collection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Iterable", function() { return Iterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Seq", function() { return Seq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Map", function() { return Map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrderedMap", function() { return OrderedMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return List; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Stack", function() { return Stack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Set", function() { return Set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OrderedSet", function() { return OrderedSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Record", function() { return Record; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Range", function() { return Range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Repeat", function() { return Repeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "is", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromJS", function() { return fromJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hash", function() { return hash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isImmutable", function() { return isImmutable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCollection", function() { return isCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isKeyed", function() { return isKeyed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIndexed", function() { return isIndexed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAssociative", function() { return isAssociative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isOrdered", function() { return isOrdered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValueObject", function() { return isValueObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIn", function() { return getIn$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasIn", function() { return hasIn$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeDeep", function() { return mergeDeep$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeWith", function() { return mergeWith$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeDeepWith", function() { return mergeDeepWith$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeIn", function() { return removeIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setIn", function() { return setIn$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIn", function() { return updateIn; });
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// Used for setting prototype methods that IE8 chokes on.
var DELETE = 'delete';

// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;

// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};

// Boolean references, Rough equivalent of `bool &`.
var CHANGE_LENGTH = { value: false };
var DID_ALTER = { value: false };

function MakeRef(ref) {
  ref.value = false;
  return ref;
}

function SetRef(ref) {
  ref && (ref.value = true);
}

// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}

function ensureSize(iter) {
  if (iter.size === undefined) {
    iter.size = iter.__iterate(returnTrue);
  }
  return iter.size;
}

function wrapIndex(iter, index) {
  // This implements "is array index" which the ECMAString spec defines as:
  //
  //     A String property name P is an array index if and only if
  //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
  //     to 2^32−1.
  //
  // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
  if (typeof index !== 'number') {
    var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
    if ('' + uint32Index !== index || uint32Index === 4294967295) {
      return NaN;
    }
    index = uint32Index;
  }
  return index < 0 ? ensureSize(iter) + index : index;
}

function returnTrue() {
  return true;
}

function wholeSlice(begin, end, size) {
  return (
    ((begin === 0 && !isNeg(begin)) ||
      (size !== undefined && begin <= -size)) &&
    (end === undefined || (size !== undefined && end >= size))
  );
}

function resolveBegin(begin, size) {
  return resolveIndex(begin, size, 0);
}

function resolveEnd(end, size) {
  return resolveIndex(end, size, size);
}

function resolveIndex(index, size, defaultIndex) {
  // Sanitize indices using this shorthand for ToInt32(argument)
  // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
  return index === undefined
    ? defaultIndex
    : isNeg(index)
      ? size === Infinity ? size : Math.max(0, size + index) | 0
      : size === undefined || size === index
        ? index
        : Math.min(size, index) | 0;
}

function isNeg(value) {
  // Account for -0 which is negative, but not less than 0.
  return value < 0 || (value === 0 && 1 / value === -Infinity);
}

function isImmutable(maybeImmutable) {
  return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}

function isCollection(maybeCollection) {
  return !!(maybeCollection && maybeCollection[IS_ITERABLE_SENTINEL]);
}

function isKeyed(maybeKeyed) {
  return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
}

function isIndexed(maybeIndexed) {
  return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
}

function isAssociative(maybeAssociative) {
  return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}

function isOrdered(maybeOrdered) {
  return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
}

function isRecord(maybeRecord) {
  return !!(maybeRecord && maybeRecord[IS_RECORD_SENTINEL]);
}

function isValueObject(maybeValue) {
  return !!(
    maybeValue &&
    typeof maybeValue.equals === 'function' &&
    typeof maybeValue.hashCode === 'function'
  );
}

var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
var IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@';

var Collection = function Collection(value) {
  return isCollection(value) ? value : Seq(value);
};

var KeyedCollection = (function (Collection) {
  function KeyedCollection(value) {
    return isKeyed(value) ? value : KeyedSeq(value);
  }

  if ( Collection ) KeyedCollection.__proto__ = Collection;
  KeyedCollection.prototype = Object.create( Collection && Collection.prototype );
  KeyedCollection.prototype.constructor = KeyedCollection;

  return KeyedCollection;
}(Collection));

var IndexedCollection = (function (Collection) {
  function IndexedCollection(value) {
    return isIndexed(value) ? value : IndexedSeq(value);
  }

  if ( Collection ) IndexedCollection.__proto__ = Collection;
  IndexedCollection.prototype = Object.create( Collection && Collection.prototype );
  IndexedCollection.prototype.constructor = IndexedCollection;

  return IndexedCollection;
}(Collection));

var SetCollection = (function (Collection) {
  function SetCollection(value) {
    return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
  }

  if ( Collection ) SetCollection.__proto__ = Collection;
  SetCollection.prototype = Object.create( Collection && Collection.prototype );
  SetCollection.prototype.constructor = SetCollection;

  return SetCollection;
}(Collection));

Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;

var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;

var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';

var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;

var Iterator = function Iterator(next) {
  this.next = next;
};

Iterator.prototype.toString = function toString () {
  return '[Iterator]';
};

Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;

Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
  return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function() {
  return this;
};

function iteratorValue(type, k, v, iteratorResult) {
  var value = type === 0 ? k : type === 1 ? v : [k, v];
  iteratorResult
    ? (iteratorResult.value = value)
    : (iteratorResult = {
        value: value,
        done: false
      });
  return iteratorResult;
}

function iteratorDone() {
  return { value: undefined, done: true };
}

function hasIterator(maybeIterable) {
  return !!getIteratorFn(maybeIterable);
}

function isIterator(maybeIterator) {
  return maybeIterator && typeof maybeIterator.next === 'function';
}

function getIterator(iterable) {
  var iteratorFn = getIteratorFn(iterable);
  return iteratorFn && iteratorFn.call(iterable);
}

function getIteratorFn(iterable) {
  var iteratorFn =
    iterable &&
    ((REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

function isArrayLike(value) {
  return value && typeof value.length === 'number';
}

var Seq = (function (Collection$$1) {
  function Seq(value) {
    return value === null || value === undefined
      ? emptySequence()
      : isImmutable(value) ? value.toSeq() : seqFromValue(value);
  }

  if ( Collection$$1 ) Seq.__proto__ = Collection$$1;
  Seq.prototype = Object.create( Collection$$1 && Collection$$1.prototype );
  Seq.prototype.constructor = Seq;

  Seq.prototype.toSeq = function toSeq () {
    return this;
  };

  Seq.prototype.toString = function toString () {
    return this.__toString('Seq {', '}');
  };

  Seq.prototype.cacheResult = function cacheResult () {
    if (!this._cache && this.__iterateUncached) {
      this._cache = this.entrySeq().toArray();
      this.size = this._cache.length;
    }
    return this;
  };

  // abstract __iterateUncached(fn, reverse)

  Seq.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    var cache = this._cache;
    if (cache) {
      var size = cache.length;
      var i = 0;
      while (i !== size) {
        var entry = cache[reverse ? size - ++i : i++];
        if (fn(entry[1], entry[0], this$1) === false) {
          break;
        }
      }
      return i;
    }
    return this.__iterateUncached(fn, reverse);
  };

  // abstract __iteratorUncached(type, reverse)

  Seq.prototype.__iterator = function __iterator (type, reverse) {
    var cache = this._cache;
    if (cache) {
      var size = cache.length;
      var i = 0;
      return new Iterator(function () {
        if (i === size) {
          return iteratorDone();
        }
        var entry = cache[reverse ? size - ++i : i++];
        return iteratorValue(type, entry[0], entry[1]);
      });
    }
    return this.__iteratorUncached(type, reverse);
  };

  return Seq;
}(Collection));

var KeyedSeq = (function (Seq) {
  function KeyedSeq(value) {
    return value === null || value === undefined
      ? emptySequence().toKeyedSeq()
      : isCollection(value)
        ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq()
        : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
  }

  if ( Seq ) KeyedSeq.__proto__ = Seq;
  KeyedSeq.prototype = Object.create( Seq && Seq.prototype );
  KeyedSeq.prototype.constructor = KeyedSeq;

  KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq () {
    return this;
  };

  return KeyedSeq;
}(Seq));

var IndexedSeq = (function (Seq) {
  function IndexedSeq(value) {
    return value === null || value === undefined
      ? emptySequence()
      : isCollection(value)
        ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq()
        : isRecord(value)
          ? value.toSeq().entrySeq()
          : indexedSeqFromValue(value);
  }

  if ( Seq ) IndexedSeq.__proto__ = Seq;
  IndexedSeq.prototype = Object.create( Seq && Seq.prototype );
  IndexedSeq.prototype.constructor = IndexedSeq;

  IndexedSeq.of = function of (/*...values*/) {
    return IndexedSeq(arguments);
  };

  IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq () {
    return this;
  };

  IndexedSeq.prototype.toString = function toString () {
    return this.__toString('Seq [', ']');
  };

  return IndexedSeq;
}(Seq));

var SetSeq = (function (Seq) {
  function SetSeq(value) {
    return (isCollection(value) && !isAssociative(value)
      ? value
      : IndexedSeq(value)
    ).toSetSeq();
  }

  if ( Seq ) SetSeq.__proto__ = Seq;
  SetSeq.prototype = Object.create( Seq && Seq.prototype );
  SetSeq.prototype.constructor = SetSeq;

  SetSeq.of = function of (/*...values*/) {
    return SetSeq(arguments);
  };

  SetSeq.prototype.toSetSeq = function toSetSeq () {
    return this;
  };

  return SetSeq;
}(Seq));

Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;

var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

Seq.prototype[IS_SEQ_SENTINEL] = true;

// #pragma Root Sequences

var ArraySeq = (function (IndexedSeq) {
  function ArraySeq(array) {
    this._array = array;
    this.size = array.length;
  }

  if ( IndexedSeq ) ArraySeq.__proto__ = IndexedSeq;
  ArraySeq.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  ArraySeq.prototype.constructor = ArraySeq;

  ArraySeq.prototype.get = function get (index, notSetValue) {
    return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
  };

  ArraySeq.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    var array = this._array;
    var size = array.length;
    var i = 0;
    while (i !== size) {
      var ii = reverse ? size - ++i : i++;
      if (fn(array[ii], ii, this$1) === false) {
        break;
      }
    }
    return i;
  };

  ArraySeq.prototype.__iterator = function __iterator (type, reverse) {
    var array = this._array;
    var size = array.length;
    var i = 0;
    return new Iterator(function () {
      if (i === size) {
        return iteratorDone();
      }
      var ii = reverse ? size - ++i : i++;
      return iteratorValue(type, ii, array[ii]);
    });
  };

  return ArraySeq;
}(IndexedSeq));

var ObjectSeq = (function (KeyedSeq) {
  function ObjectSeq(object) {
    var keys = Object.keys(object);
    this._object = object;
    this._keys = keys;
    this.size = keys.length;
  }

  if ( KeyedSeq ) ObjectSeq.__proto__ = KeyedSeq;
  ObjectSeq.prototype = Object.create( KeyedSeq && KeyedSeq.prototype );
  ObjectSeq.prototype.constructor = ObjectSeq;

  ObjectSeq.prototype.get = function get (key, notSetValue) {
    if (notSetValue !== undefined && !this.has(key)) {
      return notSetValue;
    }
    return this._object[key];
  };

  ObjectSeq.prototype.has = function has (key) {
    return hasOwnProperty.call(this._object, key);
  };

  ObjectSeq.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    var object = this._object;
    var keys = this._keys;
    var size = keys.length;
    var i = 0;
    while (i !== size) {
      var key = keys[reverse ? size - ++i : i++];
      if (fn(object[key], key, this$1) === false) {
        break;
      }
    }
    return i;
  };

  ObjectSeq.prototype.__iterator = function __iterator (type, reverse) {
    var object = this._object;
    var keys = this._keys;
    var size = keys.length;
    var i = 0;
    return new Iterator(function () {
      if (i === size) {
        return iteratorDone();
      }
      var key = keys[reverse ? size - ++i : i++];
      return iteratorValue(type, key, object[key]);
    });
  };

  return ObjectSeq;
}(KeyedSeq));
ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;

var CollectionSeq = (function (IndexedSeq) {
  function CollectionSeq(collection) {
    this._collection = collection;
    this.size = collection.length || collection.size;
  }

  if ( IndexedSeq ) CollectionSeq.__proto__ = IndexedSeq;
  CollectionSeq.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  CollectionSeq.prototype.constructor = CollectionSeq;

  CollectionSeq.prototype.__iterateUncached = function __iterateUncached (fn, reverse) {
    var this$1 = this;

    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var collection = this._collection;
    var iterator = getIterator(collection);
    var iterations = 0;
    if (isIterator(iterator)) {
      var step;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this$1) === false) {
          break;
        }
      }
    }
    return iterations;
  };

  CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var collection = this._collection;
    var iterator = getIterator(collection);
    if (!isIterator(iterator)) {
      return new Iterator(iteratorDone);
    }
    var iterations = 0;
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, iterations++, step.value);
    });
  };

  return CollectionSeq;
}(IndexedSeq));

var IteratorSeq = (function (IndexedSeq) {
  function IteratorSeq(iterator) {
    this._iterator = iterator;
    this._iteratorCache = [];
  }

  if ( IndexedSeq ) IteratorSeq.__proto__ = IndexedSeq;
  IteratorSeq.prototype = Object.create( IndexedSeq && IndexedSeq.prototype );
  IteratorSeq.prototype.constructor = IteratorSeq;

  IteratorSeq.prototype.__iterateUncached = function __iterateUncached (fn, reverse) {
    var this$1 = this;

    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterator = this._iterator;
    var cache = this._iteratorCache;
    var iterations = 0;
    while (iterations < cache.length) {
      if (fn(cache[iterations], iterations++, this$1) === false) {
        return iterations;
      }
    }
    var step;
    while (!(step = iterator.next()).done) {
      var val = step.value;
      cache[iterations] = val;
      if (fn(val, iterations++, this$1) === false) {
        break;
      }
    }
    return iterations;
  };

  IteratorSeq.prototype.__iteratorUncached = function __iteratorUncached (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = this._iterator;
    var cache = this._iteratorCache;
    var iterations = 0;
    return new Iterator(function () {
      if (iterations >= cache.length) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        cache[iterations] = step.value;
      }
      return iteratorValue(type, iterations, cache[iterations++]);
    });
  };

  return IteratorSeq;
}(IndexedSeq));

// # pragma Helper functions

function isSeq(maybeSeq) {
  return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
}

var EMPTY_SEQ;

function emptySequence() {
  return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}

function keyedSeqFromValue(value) {
  var seq = Array.isArray(value)
    ? new ArraySeq(value)
    : isIterator(value)
      ? new IteratorSeq(value)
      : hasIterator(value) ? new CollectionSeq(value) : undefined;
  if (seq) {
    return seq.fromEntrySeq();
  }
  if (typeof value === 'object') {
    return new ObjectSeq(value);
  }
  throw new TypeError(
    'Expected Array or collection object of [k, v] entries, or keyed object: ' +
      value
  );
}

function indexedSeqFromValue(value) {
  var seq = maybeIndexedSeqFromValue(value);
  if (seq) {
    return seq;
  }
  throw new TypeError(
    'Expected Array or collection object of values: ' + value
  );
}

function seqFromValue(value) {
  var seq = maybeIndexedSeqFromValue(value);
  if (seq) {
    return seq;
  }
  if (typeof value === 'object') {
    return new ObjectSeq(value);
  }
  throw new TypeError(
    'Expected Array or collection object of values, or keyed object: ' + value
  );
}

function maybeIndexedSeqFromValue(value) {
  return isArrayLike(value)
    ? new ArraySeq(value)
    : isIterator(value)
      ? new IteratorSeq(value)
      : hasIterator(value) ? new CollectionSeq(value) : undefined;
}

/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */
function is(valueA, valueB) {
  if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
    return true;
  }
  if (!valueA || !valueB) {
    return false;
  }
  if (
    typeof valueA.valueOf === 'function' &&
    typeof valueB.valueOf === 'function'
  ) {
    valueA = valueA.valueOf();
    valueB = valueB.valueOf();
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
  }
  return !!(
    isValueObject(valueA) &&
    isValueObject(valueB) &&
    valueA.equals(valueB)
  );
}

var imul =
  typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2
    ? Math.imul
    : function imul(a, b) {
        a |= 0; // int
        b |= 0; // int
        var c = a & 0xffff;
        var d = b & 0xffff;
        // Shift by 0 fixes the sign on the high part.
        return (c * d + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0)) | 0; // int
      };

// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
  return ((i32 >>> 1) & 0x40000000) | (i32 & 0xbfffffff);
}

function hash(o) {
  if (o === false || o === null || o === undefined) {
    return 0;
  }
  if (typeof o.valueOf === 'function') {
    o = o.valueOf();
    if (o === false || o === null || o === undefined) {
      return 0;
    }
  }
  if (o === true) {
    return 1;
  }
  var type = typeof o;
  if (type === 'number') {
    if (o !== o || o === Infinity) {
      return 0;
    }
    var h = o | 0;
    if (h !== o) {
      h ^= o * 0xffffffff;
    }
    while (o > 0xffffffff) {
      o /= 0xffffffff;
      h ^= o;
    }
    return smi(h);
  }
  if (type === 'string') {
    return o.length > STRING_HASH_CACHE_MIN_STRLEN
      ? cachedHashString(o)
      : hashString(o);
  }
  if (typeof o.hashCode === 'function') {
    // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode());
  }
  if (type === 'object') {
    return hashJSObj(o);
  }
  if (typeof o.toString === 'function') {
    return hashString(o.toString());
  }
  throw new Error('Value type ' + type + ' cannot be hashed.');
}

function cachedHashString(string) {
  var hashed = stringHashCache[string];
  if (hashed === undefined) {
    hashed = hashString(string);
    if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
      STRING_HASH_CACHE_SIZE = 0;
      stringHashCache = {};
    }
    STRING_HASH_CACHE_SIZE++;
    stringHashCache[string] = hashed;
  }
  return hashed;
}

// http://jsperf.com/hashing-strings
function hashString(string) {
  // This is the hash from JVM
  // The hash code for a string is computed as
  // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
  // where s[i] is the ith character of the string and n is the length of
  // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
  // (exclusive) by dropping high bits.
  var hashed = 0;
  for (var ii = 0; ii < string.length; ii++) {
    hashed = (31 * hashed + string.charCodeAt(ii)) | 0;
  }
  return smi(hashed);
}

function hashJSObj(obj) {
  var hashed;
  if (usingWeakMap) {
    hashed = weakMap.get(obj);
    if (hashed !== undefined) {
      return hashed;
    }
  }

  hashed = obj[UID_HASH_KEY];
  if (hashed !== undefined) {
    return hashed;
  }

  if (!canDefineProperty) {
    hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
    if (hashed !== undefined) {
      return hashed;
    }

    hashed = getIENodeHash(obj);
    if (hashed !== undefined) {
      return hashed;
    }
  }

  hashed = ++objHashUID;
  if (objHashUID & 0x40000000) {
    objHashUID = 0;
  }

  if (usingWeakMap) {
    weakMap.set(obj, hashed);
  } else if (isExtensible !== undefined && isExtensible(obj) === false) {
    throw new Error('Non-extensible objects are not allowed as keys.');
  } else if (canDefineProperty) {
    Object.defineProperty(obj, UID_HASH_KEY, {
      enumerable: false,
      configurable: false,
      writable: false,
      value: hashed
    });
  } else if (
    obj.propertyIsEnumerable !== undefined &&
    obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable
  ) {
    // Since we can't define a non-enumerable property on the object
    // we'll hijack one of the less-used non-enumerable properties to
    // save our hash on it. Since this is a function it will not show up in
    // `JSON.stringify` which is what we want.
    obj.propertyIsEnumerable = function() {
      return this.constructor.prototype.propertyIsEnumerable.apply(
        this,
        arguments
      );
    };
    obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
  } else if (obj.nodeType !== undefined) {
    // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
  } else {
    throw new Error('Unable to set a non-enumerable property on object.');
  }

  return hashed;
}

// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;

// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = (function() {
  try {
    Object.defineProperty({}, '@', {});
    return true;
  } catch (e) {
    return false;
  }
})();

// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
  if (node && node.nodeType > 0) {
    switch (node.nodeType) {
      case 1: // Element
        return node.uniqueID;
      case 9: // Document
        return node.documentElement && node.documentElement.uniqueID;
    }
  }
}

// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) {
  weakMap = new WeakMap();
}

var objHashUID = 0;

var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') {
  UID_HASH_KEY = Symbol(UID_HASH_KEY);
}

var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};

var ToKeyedSequence = (function (KeyedSeq$$1) {
  function ToKeyedSequence(indexed, useKeys) {
    this._iter = indexed;
    this._useKeys = useKeys;
    this.size = indexed.size;
  }

  if ( KeyedSeq$$1 ) ToKeyedSequence.__proto__ = KeyedSeq$$1;
  ToKeyedSequence.prototype = Object.create( KeyedSeq$$1 && KeyedSeq$$1.prototype );
  ToKeyedSequence.prototype.constructor = ToKeyedSequence;

  ToKeyedSequence.prototype.get = function get (key, notSetValue) {
    return this._iter.get(key, notSetValue);
  };

  ToKeyedSequence.prototype.has = function has (key) {
    return this._iter.has(key);
  };

  ToKeyedSequence.prototype.valueSeq = function valueSeq () {
    return this._iter.valueSeq();
  };

  ToKeyedSequence.prototype.reverse = function reverse () {
    var this$1 = this;

    var reversedSequence = reverseFactory(this, true);
    if (!this._useKeys) {
      reversedSequence.valueSeq = function () { return this$1._iter.toSeq().reverse(); };
    }
    return reversedSequence;
  };

  ToKeyedSequence.prototype.map = function map (mapper, context) {
    var this$1 = this;

    var mappedSequence = mapFactory(this, mapper, context);
    if (!this._useKeys) {
      mappedSequence.valueSeq = function () { return this$1._iter.toSeq().map(mapper, context); };
    }
    return mappedSequence;
  };

  ToKeyedSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    return this._iter.__iterate(function (v, k) { return fn(v, k, this$1); }, reverse);
  };

  ToKeyedSequence.prototype.__iterator = function __iterator (type, reverse) {
    return this._iter.__iterator(type, reverse);
  };

  return ToKeyedSequence;
}(KeyedSeq));
ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;

var ToIndexedSequence = (function (IndexedSeq$$1) {
  function ToIndexedSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  if ( IndexedSeq$$1 ) ToIndexedSequence.__proto__ = IndexedSeq$$1;
  ToIndexedSequence.prototype = Object.create( IndexedSeq$$1 && IndexedSeq$$1.prototype );
  ToIndexedSequence.prototype.constructor = ToIndexedSequence;

  ToIndexedSequence.prototype.includes = function includes (value) {
    return this._iter.includes(value);
  };

  ToIndexedSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    var i = 0;
    reverse && ensureSize(this);
    return this._iter.__iterate(
      function (v) { return fn(v, reverse ? this$1.size - ++i : i++, this$1); },
      reverse
    );
  };

  ToIndexedSequence.prototype.__iterator = function __iterator (type, reverse) {
    var this$1 = this;

    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    var i = 0;
    reverse && ensureSize(this);
    return new Iterator(function () {
      var step = iterator.next();
      return step.done
        ? step
        : iteratorValue(
            type,
            reverse ? this$1.size - ++i : i++,
            step.value,
            step
          );
    });
  };

  return ToIndexedSequence;
}(IndexedSeq));

var ToSetSequence = (function (SetSeq$$1) {
  function ToSetSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  if ( SetSeq$$1 ) ToSetSequence.__proto__ = SetSeq$$1;
  ToSetSequence.prototype = Object.create( SetSeq$$1 && SetSeq$$1.prototype );
  ToSetSequence.prototype.constructor = ToSetSequence;

  ToSetSequence.prototype.has = function has (key) {
    return this._iter.includes(key);
  };

  ToSetSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    return this._iter.__iterate(function (v) { return fn(v, v, this$1); }, reverse);
  };

  ToSetSequence.prototype.__iterator = function __iterator (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      var step = iterator.next();
      return step.done
        ? step
        : iteratorValue(type, step.value, step.value, step);
    });
  };

  return ToSetSequence;
}(SetSeq));

var FromEntriesSequence = (function (KeyedSeq$$1) {
  function FromEntriesSequence(entries) {
    this._iter = entries;
    this.size = entries.size;
  }

  if ( KeyedSeq$$1 ) FromEntriesSequence.__proto__ = KeyedSeq$$1;
  FromEntriesSequence.prototype = Object.create( KeyedSeq$$1 && KeyedSeq$$1.prototype );
  FromEntriesSequence.prototype.constructor = FromEntriesSequence;

  FromEntriesSequence.prototype.entrySeq = function entrySeq () {
    return this._iter.toSeq();
  };

  FromEntriesSequence.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    return this._iter.__iterate(function (entry) {
      // Check if entry exists first so array access doesn't throw for holes
      // in the parent iteration.
      if (entry) {
        validateEntry(entry);
        var indexedCollection = isCollection(entry);
        return fn(
          indexedCollection ? entry.get(1) : entry[1],
          indexedCollection ? entry.get(0) : entry[0],
          this$1
        );
      }
    }, reverse);
  };

  FromEntriesSequence.prototype.__iterator = function __iterator (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      while (true) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedCollection = isCollection(entry);
          return iteratorValue(
            type,
            indexedCollection ? entry.get(0) : entry[0],
            indexedCollection ? entry.get(1) : entry[1],
            step
          );
        }
      }
    });
  };

  return FromEntriesSequence;
}(KeyedSeq));

ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;

function flipFactory(collection) {
  var flipSequence = makeSequence(collection);
  flipSequence._iter = collection;
  flipSequence.size = collection.size;
  flipSequence.flip = function () { return collection; };
  flipSequence.reverse = function() {
    var reversedSequence = collection.reverse.apply(this); // super.reverse()
    reversedSequence.flip = function () { return collection.reverse(); };
    return reversedSequence;
  };
  flipSequence.has = function (key) { return collection.includes(key); };
  flipSequence.includes = function (key) { return collection.has(key); };
  flipSequence.cacheResult = cacheResultThrough;
  flipSequence.__iterateUncached = function(fn, reverse) {
    var this$1 = this;

    return collection.__iterate(function (v, k) { return fn(k, v, this$1) !== false; }, reverse);
  };
  flipSequence.__iteratorUncached = function(type, reverse) {
    if (type === ITERATE_ENTRIES) {
      var iterator = collection.__iterator(type, reverse);
      return new Iterator(function () {
        var step = iterator.next();
        if (!step.done) {
          var k = step.value[0];
          step.value[0] = step.value[1];
          step.value[1] = k;
        }
        return step;
      });
    }
    return collection.__iterator(
      type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
      reverse
    );
  };
  return flipSequence;
}

function mapFactory(collection, mapper, context) {
  var mappedSequence = makeSequence(collection);
  mappedSequence.size = collection.size;
  mappedSequence.has = function (key) { return collection.has(key); };
  mappedSequence.get = function (key, notSetValue) {
    var v = collection.get(key, NOT_SET);
    return v === NOT_SET
      ? notSetValue
      : mapper.call(context, v, key, collection);
  };
  mappedSequence.__iterateUncached = function(fn, reverse) {
    var this$1 = this;

    return collection.__iterate(
      function (v, k, c) { return fn(mapper.call(context, v, k, c), k, this$1) !== false; },
      reverse
    );
  };
  mappedSequence.__iteratorUncached = function(type, reverse) {
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    return new Iterator(function () {
      var step = iterator.next();
      if (step.done) {
        return step;
      }
      var entry = step.value;
      var key = entry[0];
      return iteratorValue(
        type,
        key,
        mapper.call(context, entry[1], key, collection),
        step
      );
    });
  };
  return mappedSequence;
}

function reverseFactory(collection, useKeys) {
  var this$1 = this;

  var reversedSequence = makeSequence(collection);
  reversedSequence._iter = collection;
  reversedSequence.size = collection.size;
  reversedSequence.reverse = function () { return collection; };
  if (collection.flip) {
    reversedSequence.flip = function() {
      var flipSequence = flipFactory(collection);
      flipSequence.reverse = function () { return collection.flip(); };
      return flipSequence;
    };
  }
  reversedSequence.get = function (key, notSetValue) { return collection.get(useKeys ? key : -1 - key, notSetValue); };
  reversedSequence.has = function (key) { return collection.has(useKeys ? key : -1 - key); };
  reversedSequence.includes = function (value) { return collection.includes(value); };
  reversedSequence.cacheResult = cacheResultThrough;
  reversedSequence.__iterate = function(fn, reverse) {
    var this$1 = this;

    var i = 0;
    reverse && ensureSize(collection);
    return collection.__iterate(
      function (v, k) { return fn(v, useKeys ? k : reverse ? this$1.size - ++i : i++, this$1); },
      !reverse
    );
  };
  reversedSequence.__iterator = function (type, reverse) {
    var i = 0;
    reverse && ensureSize(collection);
    var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
    return new Iterator(function () {
      var step = iterator.next();
      if (step.done) {
        return step;
      }
      var entry = step.value;
      return iteratorValue(
        type,
        useKeys ? entry[0] : reverse ? this$1.size - ++i : i++,
        entry[1],
        step
      );
    });
  };
  return reversedSequence;
}

function filterFactory(collection, predicate, context, useKeys) {
  var filterSequence = makeSequence(collection);
  if (useKeys) {
    filterSequence.has = function (key) {
      var v = collection.get(key, NOT_SET);
      return v !== NOT_SET && !!predicate.call(context, v, key, collection);
    };
    filterSequence.get = function (key, notSetValue) {
      var v = collection.get(key, NOT_SET);
      return v !== NOT_SET && predicate.call(context, v, key, collection)
        ? v
        : notSetValue;
    };
  }
  filterSequence.__iterateUncached = function(fn, reverse) {
    var this$1 = this;

    var iterations = 0;
    collection.__iterate(function (v, k, c) {
      if (predicate.call(context, v, k, c)) {
        iterations++;
        return fn(v, useKeys ? k : iterations - 1, this$1);
      }
    }, reverse);
    return iterations;
  };
  filterSequence.__iteratorUncached = function(type, reverse) {
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    var iterations = 0;
    return new Iterator(function () {
      while (true) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        var value = entry[1];
        if (predicate.call(context, value, key, collection)) {
          return iteratorValue(type, useKeys ? key : iterations++, value, step);
        }
      }
    });
  };
  return filterSequence;
}

function countByFactory(collection, grouper, context) {
  var groups = Map().asMutable();
  collection.__iterate(function (v, k) {
    groups.update(grouper.call(context, v, k, collection), 0, function (a) { return a + 1; });
  });
  return groups.asImmutable();
}

function groupByFactory(collection, grouper, context) {
  var isKeyedIter = isKeyed(collection);
  var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
  collection.__iterate(function (v, k) {
    groups.update(
      grouper.call(context, v, k, collection),
      function (a) { return ((a = a || []), a.push(isKeyedIter ? [k, v] : v), a); }
    );
  });
  var coerce = collectionClass(collection);
  return groups.map(function (arr) { return reify(collection, coerce(arr)); });
}

function sliceFactory(collection, begin, end, useKeys) {
  var originalSize = collection.size;

  if (wholeSlice(begin, end, originalSize)) {
    return collection;
  }

  var resolvedBegin = resolveBegin(begin, originalSize);
  var resolvedEnd = resolveEnd(end, originalSize);

  // begin or end will be NaN if they were provided as negative numbers and
  // this collection's size is unknown. In that case, cache first so there is
  // a known size and these do not resolve to NaN.
  if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
    return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
  }

  // Note: resolvedEnd is undefined when the original sequence's length is
  // unknown and this slice did not supply an end and should contain all
  // elements after resolvedBegin.
  // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
  var resolvedSize = resolvedEnd - resolvedBegin;
  var sliceSize;
  if (resolvedSize === resolvedSize) {
    sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
  }

  var sliceSeq = makeSequence(collection);

  // If collection.size is undefined, the size of the realized sliceSeq is
  // unknown at this point unless the number of items to slice is 0
  sliceSeq.size =
    sliceSize === 0 ? sliceSize : (collection.size && sliceSize) || undefined;

  if (!useKeys && isSeq(collection) && sliceSize >= 0) {
    sliceSeq.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      return index >= 0 && index < sliceSize
        ? collection.get(index + resolvedBegin, notSetValue)
        : notSetValue;
    };
  }

  sliceSeq.__iterateUncached = function(fn, reverse) {
    var this$1 = this;

    if (sliceSize === 0) {
      return 0;
    }
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var skipped = 0;
    var isSkipping = true;
    var iterations = 0;
    collection.__iterate(function (v, k) {
      if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
        iterations++;
        return (
          fn(v, useKeys ? k : iterations - 1, this$1) !== false &&
          iterations !== sliceSize
        );
      }
    });
    return iterations;
  };

  sliceSeq.__iteratorUncached = function(type, reverse) {
    if (sliceSize !== 0 && reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    // Don't bother instantiating parent iterator if taking 0.
    if (sliceSize === 0) {
      return new Iterator(iteratorDone);
    }
    var iterator = collection.__iterator(type, reverse);
    var skipped = 0;
    var iterations = 0;
    return new Iterator(function () {
      while (skipped++ < resolvedBegin) {
        iterator.next();
      }
      if (++iterations > sliceSize) {
        return iteratorDone();
      }
      var step = iterator.next();
      if (useKeys || type === ITERATE_VALUES || step.done) {
        return step;
      }
      if (type === ITERATE_KEYS) {
        return iteratorValue(type, iterations - 1, undefined, step);
      }
      return iteratorValue(type, iterations - 1, step.value[1], step);
    });
  };

  return sliceSeq;
}

function takeWhileFactory(collection, predicate, context) {
  var takeSequence = makeSequence(collection);
  takeSequence.__iterateUncached = function(fn, reverse) {
    var this$1 = this;

    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterations = 0;
    collection.__iterate(
      function (v, k, c) { return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1); }
    );
    return iterations;
  };
  takeSequence.__iteratorUncached = function(type, reverse) {
    var this$1 = this;

    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    var iterating = true;
    return new Iterator(function () {
      if (!iterating) {
        return iteratorDone();
      }
      var step = iterator.next();
      if (step.done) {
        return step;
      }
      var entry = step.value;
      var k = entry[0];
      var v = entry[1];
      if (!predicate.call(context, v, k, this$1)) {
        iterating = false;
        return iteratorDone();
      }
      return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
    });
  };
  return takeSequence;
}

function skipWhileFactory(collection, predicate, context, useKeys) {
  var skipSequence = makeSequence(collection);
  skipSequence.__iterateUncached = function(fn, reverse) {
    var this$1 = this;

    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var isSkipping = true;
    var iterations = 0;
    collection.__iterate(function (v, k, c) {
      if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
        iterations++;
        return fn(v, useKeys ? k : iterations - 1, this$1);
      }
    });
    return iterations;
  };
  skipSequence.__iteratorUncached = function(type, reverse) {
    var this$1 = this;

    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
    var skipping = true;
    var iterations = 0;
    return new Iterator(function () {
      var step;
      var k;
      var v;
      do {
        step = iterator.next();
        if (step.done) {
          if (useKeys || type === ITERATE_VALUES) {
            return step;
          }
          if (type === ITERATE_KEYS) {
            return iteratorValue(type, iterations++, undefined, step);
          }
          return iteratorValue(type, iterations++, step.value[1], step);
        }
        var entry = step.value;
        k = entry[0];
        v = entry[1];
        skipping && (skipping = predicate.call(context, v, k, this$1));
      } while (skipping);
      return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
    });
  };
  return skipSequence;
}

function concatFactory(collection, values) {
  var isKeyedCollection = isKeyed(collection);
  var iters = [collection]
    .concat(values)
    .map(function (v) {
      if (!isCollection(v)) {
        v = isKeyedCollection
          ? keyedSeqFromValue(v)
          : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedCollection) {
        v = KeyedCollection(v);
      }
      return v;
    })
    .filter(function (v) { return v.size !== 0; });

  if (iters.length === 0) {
    return collection;
  }

  if (iters.length === 1) {
    var singleton = iters[0];
    if (
      singleton === collection ||
      (isKeyedCollection && isKeyed(singleton)) ||
      (isIndexed(collection) && isIndexed(singleton))
    ) {
      return singleton;
    }
  }

  var concatSeq = new ArraySeq(iters);
  if (isKeyedCollection) {
    concatSeq = concatSeq.toKeyedSeq();
  } else if (!isIndexed(collection)) {
    concatSeq = concatSeq.toSetSeq();
  }
  concatSeq = concatSeq.flatten(true);
  concatSeq.size = iters.reduce(function (sum, seq) {
    if (sum !== undefined) {
      var size = seq.size;
      if (size !== undefined) {
        return sum + size;
      }
    }
  }, 0);
  return concatSeq;
}

function flattenFactory(collection, depth, useKeys) {
  var flatSequence = makeSequence(collection);
  flatSequence.__iterateUncached = function(fn, reverse) {
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterations = 0;
    var stopped = false;
    function flatDeep(iter, currentDepth) {
      iter.__iterate(function (v, k) {
        if ((!depth || currentDepth < depth) && isCollection(v)) {
          flatDeep(v, currentDepth + 1);
        } else {
          iterations++;
          if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) {
            stopped = true;
          }
        }
        return !stopped;
      }, reverse);
    }
    flatDeep(collection, 0);
    return iterations;
  };
  flatSequence.__iteratorUncached = function(type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = collection.__iterator(type, reverse);
    var stack = [];
    var iterations = 0;
    return new Iterator(function () {
      while (iterator) {
        var step = iterator.next();
        if (step.done !== false) {
          iterator = stack.pop();
          continue;
        }
        var v = step.value;
        if (type === ITERATE_ENTRIES) {
          v = v[1];
        }
        if ((!depth || stack.length < depth) && isCollection(v)) {
          stack.push(iterator);
          iterator = v.__iterator(type, reverse);
        } else {
          return useKeys ? step : iteratorValue(type, iterations++, v, step);
        }
      }
      return iteratorDone();
    });
  };
  return flatSequence;
}

function flatMapFactory(collection, mapper, context) {
  var coerce = collectionClass(collection);
  return collection
    .toSeq()
    .map(function (v, k) { return coerce(mapper.call(context, v, k, collection)); })
    .flatten(true);
}

function interposeFactory(collection, separator) {
  var interposedSequence = makeSequence(collection);
  interposedSequence.size = collection.size && collection.size * 2 - 1;
  interposedSequence.__iterateUncached = function(fn, reverse) {
    var this$1 = this;

    var iterations = 0;
    collection.__iterate(
      function (v) { return (!iterations || fn(separator, iterations++, this$1) !== false) &&
        fn(v, iterations++, this$1) !== false; },
      reverse
    );
    return iterations;
  };
  interposedSequence.__iteratorUncached = function(type, reverse) {
    var iterator = collection.__iterator(ITERATE_VALUES, reverse);
    var iterations = 0;
    var step;
    return new Iterator(function () {
      if (!step || iterations % 2) {
        step = iterator.next();
        if (step.done) {
          return step;
        }
      }
      return iterations % 2
        ? iteratorValue(type, iterations++, separator)
        : iteratorValue(type, iterations++, step.value, step);
    });
  };
  return interposedSequence;
}

function sortFactory(collection, comparator, mapper) {
  if (!comparator) {
    comparator = defaultComparator;
  }
  var isKeyedCollection = isKeyed(collection);
  var index = 0;
  var entries = collection
    .toSeq()
    .map(function (v, k) { return [k, v, index++, mapper ? mapper(v, k, collection) : v]; })
    .valueSeq()
    .toArray();
  entries.sort(function (a, b) { return comparator(a[3], b[3]) || a[2] - b[2]; }).forEach(
    isKeyedCollection
      ? function (v, i) {
          entries[i].length = 2;
        }
      : function (v, i) {
          entries[i] = v[1];
        }
  );
  return isKeyedCollection
    ? KeyedSeq(entries)
    : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}

function maxFactory(collection, comparator, mapper) {
  if (!comparator) {
    comparator = defaultComparator;
  }
  if (mapper) {
    var entry = collection
      .toSeq()
      .map(function (v, k) { return [v, mapper(v, k, collection)]; })
      .reduce(function (a, b) { return (maxCompare(comparator, a[1], b[1]) ? b : a); });
    return entry && entry[0];
  }
  return collection.reduce(function (a, b) { return (maxCompare(comparator, a, b) ? b : a); });
}

function maxCompare(comparator, a, b) {
  var comp = comparator(b, a);
  // b is considered the new max if the comparator declares them equal, but
  // they are not equal and b is in fact a nullish value.
  return (
    (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) ||
    comp > 0
  );
}

function zipWithFactory(keyIter, zipper, iters, zipAll) {
  var zipSequence = makeSequence(keyIter);
  var sizes = new ArraySeq(iters).map(function (i) { return i.size; });
  zipSequence.size = zipAll ? sizes.max() : sizes.min();
  // Note: this a generic base implementation of __iterate in terms of
  // __iterator which may be more generically useful in the future.
  zipSequence.__iterate = function(fn, reverse) {
    var this$1 = this;

    /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */
    // indexed:
    var iterator = this.__iterator(ITERATE_VALUES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      if (fn(step.value, iterations++, this$1) === false) {
        break;
      }
    }
    return iterations;
  };
  zipSequence.__iteratorUncached = function(type, reverse) {
    var iterators = iters.map(
      function (i) { return ((i = Collection(i)), getIterator(reverse ? i.reverse() : i)); }
    );
    var iterations = 0;
    var isDone = false;
    return new Iterator(function () {
      var steps;
      if (!isDone) {
        steps = iterators.map(function (i) { return i.next(); });
        isDone = zipAll ? steps.every(function (s) { return s.done; }) : steps.some(function (s) { return s.done; });
      }
      if (isDone) {
        return iteratorDone();
      }
      return iteratorValue(
        type,
        iterations++,
        zipper.apply(null, steps.map(function (s) { return s.value; }))
      );
    });
  };
  return zipSequence;
}

// #pragma Helper Functions

function reify(iter, seq) {
  return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}

function validateEntry(entry) {
  if (entry !== Object(entry)) {
    throw new TypeError('Expected [K, V] tuple: ' + entry);
  }
}

function collectionClass(collection) {
  return isKeyed(collection)
    ? KeyedCollection
    : isIndexed(collection) ? IndexedCollection : SetCollection;
}

function makeSequence(collection) {
  return Object.create(
    (isKeyed(collection)
      ? KeyedSeq
      : isIndexed(collection) ? IndexedSeq : SetSeq
    ).prototype
  );
}

function cacheResultThrough() {
  if (this._iter.cacheResult) {
    this._iter.cacheResult();
    this.size = this._iter.size;
    return this;
  }
  return Seq.prototype.cacheResult.call(this);
}

function defaultComparator(a, b) {
  if (a === undefined && b === undefined) {
    return 0;
  }

  if (a === undefined) {
    return 1;
  }

  if (b === undefined) {
    return -1;
  }

  return a > b ? 1 : a < b ? -1 : 0;
}

// http://jsperf.com/copy-array-inline
function arrCopy(arr, offset) {
  offset = offset || 0;
  var len = Math.max(0, arr.length - offset);
  var newArr = new Array(len);
  for (var ii = 0; ii < len; ii++) {
    newArr[ii] = arr[ii + offset];
  }
  return newArr;
}

function invariant(condition, error) {
  if (!condition) { throw new Error(error); }
}

function assertNotInfinite(size) {
  invariant(
    size !== Infinity,
    'Cannot perform this action with an infinite size.'
  );
}

function coerceKeyPath(keyPath) {
  if (isArrayLike(keyPath) && typeof keyPath !== 'string') {
    return keyPath;
  }
  if (isOrdered(keyPath)) {
    return keyPath.toArray();
  }
  throw new TypeError(
    'Invalid keyPath: expected Ordered Collection or Array: ' + keyPath
  );
}

function isPlainObj(value) {
  return (
    value && (value.constructor === Object || value.constructor === undefined)
  );
}

/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */
function isDataStructure(value) {
  return isImmutable(value) || Array.isArray(value) || isPlainObj(value);
}

/**
 * Converts a value to a string, adding quotes if a string was provided.
 */
function quoteString(value) {
  try {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  } catch (_ignoreError) {
    return JSON.stringify(value);
  }
}

function has(collection, key) {
  return isImmutable(collection)
    ? collection.has(key)
    : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}

function get(collection, key, notSetValue) {
  return isImmutable(collection)
    ? collection.get(key, notSetValue)
    : !has(collection, key)
      ? notSetValue
      : typeof collection.get === 'function'
        ? collection.get(key)
        : collection[key];
}

function shallowCopy(from) {
  if (Array.isArray(from)) {
    return arrCopy(from);
  }
  var to = {};
  for (var key in from) {
    if (hasOwnProperty.call(from, key)) {
      to[key] = from[key];
    }
  }
  return to;
}

function remove(collection, key) {
  if (!isDataStructure(collection)) {
    throw new TypeError(
      'Cannot update non-data-structure value: ' + collection
    );
  }
  if (isImmutable(collection)) {
    if (!collection.remove) {
      throw new TypeError(
        'Cannot update immutable value without .remove() method: ' + collection
      );
    }
    return collection.remove(key);
  }
  if (!hasOwnProperty.call(collection, key)) {
    return collection;
  }
  var collectionCopy = shallowCopy(collection);
  if (Array.isArray(collectionCopy)) {
    collectionCopy.splice(key, 1);
  } else {
    delete collectionCopy[key];
  }
  return collectionCopy;
}

function set(collection, key, value) {
  if (!isDataStructure(collection)) {
    throw new TypeError(
      'Cannot update non-data-structure value: ' + collection
    );
  }
  if (isImmutable(collection)) {
    if (!collection.set) {
      throw new TypeError(
        'Cannot update immutable value without .set() method: ' + collection
      );
    }
    return collection.set(key, value);
  }
  if (hasOwnProperty.call(collection, key) && value === collection[key]) {
    return collection;
  }
  var collectionCopy = shallowCopy(collection);
  collectionCopy[key] = value;
  return collectionCopy;
}

function updateIn(collection, keyPath, notSetValue, updater) {
  if (!updater) {
    updater = notSetValue;
    notSetValue = undefined;
  }
  var updatedValue = updateInDeeply(
    isImmutable(collection),
    collection,
    coerceKeyPath(keyPath),
    0,
    notSetValue,
    updater
  );
  return updatedValue === NOT_SET ? notSetValue : updatedValue;
}

function updateInDeeply(
  inImmutable,
  existing,
  keyPath,
  i,
  notSetValue,
  updater
) {
  var wasNotSet = existing === NOT_SET;
  if (i === keyPath.length) {
    var existingValue = wasNotSet ? notSetValue : existing;
    var newValue = updater(existingValue);
    return newValue === existingValue ? existing : newValue;
  }
  if (!wasNotSet && !isDataStructure(existing)) {
    throw new TypeError(
      'Cannot update within non-data-structure value in path [' +
        keyPath.slice(0, i).map(quoteString) +
        ']: ' +
        existing
    );
  }
  var key = keyPath[i];
  var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
  var nextUpdated = updateInDeeply(
    nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting),
    nextExisting,
    keyPath,
    i + 1,
    notSetValue,
    updater
  );
  return nextUpdated === nextExisting
    ? existing
    : nextUpdated === NOT_SET
      ? remove(existing, key)
      : set(
          wasNotSet ? (inImmutable ? emptyMap() : {}) : existing,
          key,
          nextUpdated
        );
}

function setIn$1(collection, keyPath, value) {
  return updateIn(collection, keyPath, NOT_SET, function () { return value; });
}

function setIn$$1(keyPath, v) {
  return setIn$1(this, keyPath, v);
}

function removeIn(collection, keyPath) {
  return updateIn(collection, keyPath, function () { return NOT_SET; });
}

function deleteIn(keyPath) {
  return removeIn(this, keyPath);
}

function update$1(collection, key, notSetValue, updater) {
  return updateIn(collection, [key], notSetValue, updater);
}

function update$$1(key, notSetValue, updater) {
  return arguments.length === 1
    ? key(this)
    : update$1(this, key, notSetValue, updater);
}

function updateIn$1(keyPath, notSetValue, updater) {
  return updateIn(this, keyPath, notSetValue, updater);
}

function merge() {
  var iters = [], len = arguments.length;
  while ( len-- ) iters[ len ] = arguments[ len ];

  return mergeIntoKeyedWith(this, iters);
}

function mergeWith(merger) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return mergeIntoKeyedWith(this, iters, merger);
}

function mergeIntoKeyedWith(collection, collections, merger) {
  var iters = [];
  for (var ii = 0; ii < collections.length; ii++) {
    var collection$1 = KeyedCollection(collections[ii]);
    if (collection$1.size !== 0) {
      iters.push(collection$1);
    }
  }
  if (iters.length === 0) {
    return collection;
  }
  if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
    return collection.constructor(iters[0]);
  }
  return collection.withMutations(function (collection) {
    var mergeIntoCollection = merger
      ? function (value, key) {
          update$1(
            collection,
            key,
            NOT_SET,
            function (oldVal) { return (oldVal === NOT_SET ? value : merger(oldVal, value, key)); }
          );
        }
      : function (value, key) {
          collection.set(key, value);
        };
    for (var ii = 0; ii < iters.length; ii++) {
      iters[ii].forEach(mergeIntoCollection);
    }
  });
}

function merge$1(collection) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];

  return mergeWithSources(collection, sources);
}

function mergeWith$1(merger, collection) {
  var sources = [], len = arguments.length - 2;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 2 ];

  return mergeWithSources(collection, sources, merger);
}

function mergeDeep$1(collection) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];

  return mergeDeepWithSources(collection, sources);
}

function mergeDeepWith$1(merger, collection) {
  var sources = [], len = arguments.length - 2;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 2 ];

  return mergeDeepWithSources(collection, sources, merger);
}

function mergeDeepWithSources(collection, sources, merger) {
  return mergeWithSources(collection, sources, deepMergerWith(merger));
}

function mergeWithSources(collection, sources, merger) {
  if (!isDataStructure(collection)) {
    throw new TypeError(
      'Cannot merge into non-data-structure value: ' + collection
    );
  }
  if (isImmutable(collection)) {
    return collection.mergeWith
      ? collection.mergeWith.apply(collection, [ merger ].concat( sources ))
      : collection.concat.apply(collection, sources);
  }
  var isArray = Array.isArray(collection);
  var merged = collection;
  var Collection$$1 = isArray ? IndexedCollection : KeyedCollection;
  var mergeItem = isArray
    ? function (value) {
        // Copy on write
        if (merged === collection) {
          merged = shallowCopy(merged);
        }
        merged.push(value);
      }
    : function (value, key) {
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal =
          hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
          // Copy on write
          if (merged === collection) {
            merged = shallowCopy(merged);
          }
          merged[key] = nextVal;
        }
      };
  for (var i = 0; i < sources.length; i++) {
    Collection$$1(sources[i]).forEach(mergeItem);
  }
  return merged;
}

function deepMergerWith(merger) {
  function deepMerger(oldValue, newValue, key) {
    return isDataStructure(oldValue) && isDataStructure(newValue)
      ? mergeWithSources(oldValue, [newValue], deepMerger)
      : merger ? merger(oldValue, newValue, key) : newValue;
  }
  return deepMerger;
}

function mergeDeep() {
  var iters = [], len = arguments.length;
  while ( len-- ) iters[ len ] = arguments[ len ];

  return mergeDeepWithSources(this, iters);
}

function mergeDeepWith(merger) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return mergeDeepWithSources(this, iters, merger);
}

function mergeIn(keyPath) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return updateIn(this, keyPath, emptyMap(), function (m) { return mergeWithSources(m, iters); });
}

function mergeDeepIn(keyPath) {
  var iters = [], len = arguments.length - 1;
  while ( len-- > 0 ) iters[ len ] = arguments[ len + 1 ];

  return updateIn(this, keyPath, emptyMap(), function (m) { return mergeDeepWithSources(m, iters); }
  );
}

function withMutations(fn) {
  var mutable = this.asMutable();
  fn(mutable);
  return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}

function asMutable() {
  return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}

function asImmutable() {
  return this.__ensureOwner();
}

function wasAltered() {
  return this.__altered;
}

var Map = (function (KeyedCollection$$1) {
  function Map(value) {
    return value === null || value === undefined
      ? emptyMap()
      : isMap(value) && !isOrdered(value)
        ? value
        : emptyMap().withMutations(function (map) {
            var iter = KeyedCollection$$1(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v, k) { return map.set(k, v); });
          });
  }

  if ( KeyedCollection$$1 ) Map.__proto__ = KeyedCollection$$1;
  Map.prototype = Object.create( KeyedCollection$$1 && KeyedCollection$$1.prototype );
  Map.prototype.constructor = Map;

  Map.of = function of () {
    var keyValues = [], len = arguments.length;
    while ( len-- ) keyValues[ len ] = arguments[ len ];

    return emptyMap().withMutations(function (map) {
      for (var i = 0; i < keyValues.length; i += 2) {
        if (i + 1 >= keyValues.length) {
          throw new Error('Missing value for key: ' + keyValues[i]);
        }
        map.set(keyValues[i], keyValues[i + 1]);
      }
    });
  };

  Map.prototype.toString = function toString () {
    return this.__toString('Map {', '}');
  };

  // @pragma Access

  Map.prototype.get = function get (k, notSetValue) {
    return this._root
      ? this._root.get(0, undefined, k, notSetValue)
      : notSetValue;
  };

  // @pragma Modification

  Map.prototype.set = function set (k, v) {
    return updateMap(this, k, v);
  };

  Map.prototype.remove = function remove (k) {
    return updateMap(this, k, NOT_SET);
  };

  Map.prototype.deleteAll = function deleteAll (keys) {
    var collection = Collection(keys);

    if (collection.size === 0) {
      return this;
    }

    return this.withMutations(function (map) {
      collection.forEach(function (key) { return map.remove(key); });
    });
  };

  Map.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._root = null;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyMap();
  };

  // @pragma Composition

  Map.prototype.sort = function sort (comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator));
  };

  Map.prototype.sortBy = function sortBy (mapper, comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator, mapper));
  };

  // @pragma Mutability

  Map.prototype.__iterator = function __iterator (type, reverse) {
    return new MapIterator(this, type, reverse);
  };

  Map.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    var iterations = 0;
    this._root &&
      this._root.iterate(function (entry) {
        iterations++;
        return fn(entry[1], entry[0], this$1);
      }, reverse);
    return iterations;
  };

  Map.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      if (this.size === 0) {
        return emptyMap();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeMap(this.size, this._root, ownerID, this.__hash);
  };

  return Map;
}(KeyedCollection));

function isMap(maybeMap) {
  return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
}

Map.isMap = isMap;

var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SENTINEL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.concat = MapPrototype.merge;
MapPrototype.setIn = setIn$$1;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update$$1;
MapPrototype.updateIn = updateIn$1;
MapPrototype.merge = merge;
MapPrototype.mergeWith = mergeWith;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function(result, arr) {
  return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function(obj) {
  return obj.asImmutable();
};

// #pragma Trie Nodes

var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
  this.ownerID = ownerID;
  this.entries = entries;
};

ArrayMapNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  var entries = this.entries;
  for (var ii = 0, len = entries.length; ii < len; ii++) {
    if (is(key, entries[ii][0])) {
      return entries[ii][1];
    }
  }
  return notSetValue;
};

ArrayMapNode.prototype.update = function update$$1 (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  var removed = value === NOT_SET;

  var entries = this.entries;
  var idx = 0;
  var len = entries.length;
  for (; idx < len; idx++) {
    if (is(key, entries[idx][0])) {
      break;
    }
  }
  var exists = idx < len;

  if (exists ? entries[idx][1] === value : removed) {
    return this;
  }

  SetRef(didAlter);
  (removed || !exists) && SetRef(didChangeSize);

  if (removed && entries.length === 1) {
    return; // undefined
  }

  if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
    return createNodes(ownerID, entries, key, value);
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newEntries = isEditable ? entries : arrCopy(entries);

  if (exists) {
    if (removed) {
      idx === len - 1
        ? newEntries.pop()
        : (newEntries[idx] = newEntries.pop());
    } else {
      newEntries[idx] = [key, value];
    }
  } else {
    newEntries.push([key, value]);
  }

  if (isEditable) {
    this.entries = newEntries;
    return this;
  }

  return new ArrayMapNode(ownerID, newEntries);
};

var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
  this.ownerID = ownerID;
  this.bitmap = bitmap;
  this.nodes = nodes;
};

BitmapIndexedNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
  var bitmap = this.bitmap;
  return (bitmap & bit) === 0
    ? notSetValue
    : this.nodes[popCount(bitmap & (bit - 1))].get(
        shift + SHIFT,
        keyHash,
        key,
        notSetValue
      );
};

BitmapIndexedNode.prototype.update = function update$$1 (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
  var bit = 1 << keyHashFrag;
  var bitmap = this.bitmap;
  var exists = (bitmap & bit) !== 0;

  if (!exists && value === NOT_SET) {
    return this;
  }

  var idx = popCount(bitmap & (bit - 1));
  var nodes = this.nodes;
  var node = exists ? nodes[idx] : undefined;
  var newNode = updateNode(
    node,
    ownerID,
    shift + SHIFT,
    keyHash,
    key,
    value,
    didChangeSize,
    didAlter
  );

  if (newNode === node) {
    return this;
  }

  if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
    return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
  }

  if (
    exists &&
    !newNode &&
    nodes.length === 2 &&
    isLeafNode(nodes[idx ^ 1])
  ) {
    return nodes[idx ^ 1];
  }

  if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
    return newNode;
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newBitmap = exists ? (newNode ? bitmap : bitmap ^ bit) : bitmap | bit;
  var newNodes = exists
    ? newNode
      ? setAt(nodes, idx, newNode, isEditable)
      : spliceOut(nodes, idx, isEditable)
    : spliceIn(nodes, idx, newNode, isEditable);

  if (isEditable) {
    this.bitmap = newBitmap;
    this.nodes = newNodes;
    return this;
  }

  return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};

var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
  this.ownerID = ownerID;
  this.count = count;
  this.nodes = nodes;
};

HashArrayMapNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
  var node = this.nodes[idx];
  return node
    ? node.get(shift + SHIFT, keyHash, key, notSetValue)
    : notSetValue;
};

HashArrayMapNode.prototype.update = function update$$1 (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }
  var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
  var removed = value === NOT_SET;
  var nodes = this.nodes;
  var node = nodes[idx];

  if (removed && !node) {
    return this;
  }

  var newNode = updateNode(
    node,
    ownerID,
    shift + SHIFT,
    keyHash,
    key,
    value,
    didChangeSize,
    didAlter
  );
  if (newNode === node) {
    return this;
  }

  var newCount = this.count;
  if (!node) {
    newCount++;
  } else if (!newNode) {
    newCount--;
    if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
      return packNodes(ownerID, nodes, newCount, idx);
    }
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newNodes = setAt(nodes, idx, newNode, isEditable);

  if (isEditable) {
    this.count = newCount;
    this.nodes = newNodes;
    return this;
  }

  return new HashArrayMapNode(ownerID, newCount, newNodes);
};

var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
  this.ownerID = ownerID;
  this.keyHash = keyHash;
  this.entries = entries;
};

HashCollisionNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  var entries = this.entries;
  for (var ii = 0, len = entries.length; ii < len; ii++) {
    if (is(key, entries[ii][0])) {
      return entries[ii][1];
    }
  }
  return notSetValue;
};

HashCollisionNode.prototype.update = function update$$1 (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  if (keyHash === undefined) {
    keyHash = hash(key);
  }

  var removed = value === NOT_SET;

  if (keyHash !== this.keyHash) {
    if (removed) {
      return this;
    }
    SetRef(didAlter);
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
  }

  var entries = this.entries;
  var idx = 0;
  var len = entries.length;
  for (; idx < len; idx++) {
    if (is(key, entries[idx][0])) {
      break;
    }
  }
  var exists = idx < len;

  if (exists ? entries[idx][1] === value : removed) {
    return this;
  }

  SetRef(didAlter);
  (removed || !exists) && SetRef(didChangeSize);

  if (removed && len === 2) {
    return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
  }

  var isEditable = ownerID && ownerID === this.ownerID;
  var newEntries = isEditable ? entries : arrCopy(entries);

  if (exists) {
    if (removed) {
      idx === len - 1
        ? newEntries.pop()
        : (newEntries[idx] = newEntries.pop());
    } else {
      newEntries[idx] = [key, value];
    }
  } else {
    newEntries.push([key, value]);
  }

  if (isEditable) {
    this.entries = newEntries;
    return this;
  }

  return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};

var ValueNode = function ValueNode(ownerID, keyHash, entry) {
  this.ownerID = ownerID;
  this.keyHash = keyHash;
  this.entry = entry;
};

ValueNode.prototype.get = function get (shift, keyHash, key, notSetValue) {
  return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};

ValueNode.prototype.update = function update$$1 (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
  var removed = value === NOT_SET;
  var keyMatch = is(key, this.entry[0]);
  if (keyMatch ? value === this.entry[1] : removed) {
    return this;
  }

  SetRef(didAlter);

  if (removed) {
    SetRef(didChangeSize);
    return; // undefined
  }

  if (keyMatch) {
    if (ownerID && ownerID === this.ownerID) {
      this.entry[1] = value;
      return this;
    }
    return new ValueNode(ownerID, this.keyHash, [key, value]);
  }

  SetRef(didChangeSize);
  return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
};

// #pragma Iterators

ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(
  fn,
  reverse
) {
  var entries = this.entries;
  for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
    if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
      return false;
    }
  }
};

BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(
  fn,
  reverse
) {
  var nodes = this.nodes;
  for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
    var node = nodes[reverse ? maxIndex - ii : ii];
    if (node && node.iterate(fn, reverse) === false) {
      return false;
    }
  }
};

// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
  return fn(this.entry);
};

var MapIterator = (function (Iterator$$1) {
  function MapIterator(map, type, reverse) {
    this._type = type;
    this._reverse = reverse;
    this._stack = map._root && mapIteratorFrame(map._root);
  }

  if ( Iterator$$1 ) MapIterator.__proto__ = Iterator$$1;
  MapIterator.prototype = Object.create( Iterator$$1 && Iterator$$1.prototype );
  MapIterator.prototype.constructor = MapIterator;

  MapIterator.prototype.next = function next () {
    var this$1 = this;

    var type = this._type;
    var stack = this._stack;
    while (stack) {
      var node = stack.node;
      var index = stack.index++;
      var maxIndex = (void 0);
      if (node.entry) {
        if (index === 0) {
          return mapIteratorValue(type, node.entry);
        }
      } else if (node.entries) {
        maxIndex = node.entries.length - 1;
        if (index <= maxIndex) {
          return mapIteratorValue(
            type,
            node.entries[this$1._reverse ? maxIndex - index : index]
          );
        }
      } else {
        maxIndex = node.nodes.length - 1;
        if (index <= maxIndex) {
          var subNode = node.nodes[this$1._reverse ? maxIndex - index : index];
          if (subNode) {
            if (subNode.entry) {
              return mapIteratorValue(type, subNode.entry);
            }
            stack = this$1._stack = mapIteratorFrame(subNode, stack);
          }
          continue;
        }
      }
      stack = this$1._stack = this$1._stack.__prev;
    }
    return iteratorDone();
  };

  return MapIterator;
}(Iterator));

function mapIteratorValue(type, entry) {
  return iteratorValue(type, entry[0], entry[1]);
}

function mapIteratorFrame(node, prev) {
  return {
    node: node,
    index: 0,
    __prev: prev
  };
}

function makeMap(size, root, ownerID, hash$$1) {
  var map = Object.create(MapPrototype);
  map.size = size;
  map._root = root;
  map.__ownerID = ownerID;
  map.__hash = hash$$1;
  map.__altered = false;
  return map;
}

var EMPTY_MAP;
function emptyMap() {
  return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}

function updateMap(map, k, v) {
  var newRoot;
  var newSize;
  if (!map._root) {
    if (v === NOT_SET) {
      return map;
    }
    newSize = 1;
    newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
  } else {
    var didChangeSize = MakeRef(CHANGE_LENGTH);
    var didAlter = MakeRef(DID_ALTER);
    newRoot = updateNode(
      map._root,
      map.__ownerID,
      0,
      undefined,
      k,
      v,
      didChangeSize,
      didAlter
    );
    if (!didAlter.value) {
      return map;
    }
    newSize = map.size + (didChangeSize.value ? (v === NOT_SET ? -1 : 1) : 0);
  }
  if (map.__ownerID) {
    map.size = newSize;
    map._root = newRoot;
    map.__hash = undefined;
    map.__altered = true;
    return map;
  }
  return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}

function updateNode(
  node,
  ownerID,
  shift,
  keyHash,
  key,
  value,
  didChangeSize,
  didAlter
) {
  if (!node) {
    if (value === NOT_SET) {
      return node;
    }
    SetRef(didAlter);
    SetRef(didChangeSize);
    return new ValueNode(ownerID, keyHash, [key, value]);
  }
  return node.update(
    ownerID,
    shift,
    keyHash,
    key,
    value,
    didChangeSize,
    didAlter
  );
}

function isLeafNode(node) {
  return (
    node.constructor === ValueNode || node.constructor === HashCollisionNode
  );
}

function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
  if (node.keyHash === keyHash) {
    return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
  }

  var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
  var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

  var newNode;
  var nodes =
    idx1 === idx2
      ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)]
      : ((newNode = new ValueNode(ownerID, keyHash, entry)),
        idx1 < idx2 ? [node, newNode] : [newNode, node]);

  return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
}

function createNodes(ownerID, entries, key, value) {
  if (!ownerID) {
    ownerID = new OwnerID();
  }
  var node = new ValueNode(ownerID, hash(key), [key, value]);
  for (var ii = 0; ii < entries.length; ii++) {
    var entry = entries[ii];
    node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
  }
  return node;
}

function packNodes(ownerID, nodes, count, excluding) {
  var bitmap = 0;
  var packedII = 0;
  var packedNodes = new Array(count);
  for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
    var node = nodes[ii];
    if (node !== undefined && ii !== excluding) {
      bitmap |= bit;
      packedNodes[packedII++] = node;
    }
  }
  return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}

function expandNodes(ownerID, nodes, bitmap, including, node) {
  var count = 0;
  var expandedNodes = new Array(SIZE);
  for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
    expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
  }
  expandedNodes[including] = node;
  return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}

function popCount(x) {
  x -= (x >> 1) & 0x55555555;
  x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
  x = (x + (x >> 4)) & 0x0f0f0f0f;
  x += x >> 8;
  x += x >> 16;
  return x & 0x7f;
}

function setAt(array, idx, val, canEdit) {
  var newArray = canEdit ? array : arrCopy(array);
  newArray[idx] = val;
  return newArray;
}

function spliceIn(array, idx, val, canEdit) {
  var newLen = array.length + 1;
  if (canEdit && idx + 1 === newLen) {
    array[idx] = val;
    return array;
  }
  var newArray = new Array(newLen);
  var after = 0;
  for (var ii = 0; ii < newLen; ii++) {
    if (ii === idx) {
      newArray[ii] = val;
      after = -1;
    } else {
      newArray[ii] = array[ii + after];
    }
  }
  return newArray;
}

function spliceOut(array, idx, canEdit) {
  var newLen = array.length - 1;
  if (canEdit && idx === newLen) {
    array.pop();
    return array;
  }
  var newArray = new Array(newLen);
  var after = 0;
  for (var ii = 0; ii < newLen; ii++) {
    if (ii === idx) {
      after = 1;
    }
    newArray[ii] = array[ii + after];
  }
  return newArray;
}

var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

var List = (function (IndexedCollection$$1) {
  function List(value) {
    var empty = emptyList();
    if (value === null || value === undefined) {
      return empty;
    }
    if (isList(value)) {
      return value;
    }
    var iter = IndexedCollection$$1(value);
    var size = iter.size;
    if (size === 0) {
      return empty;
    }
    assertNotInfinite(size);
    if (size > 0 && size < SIZE) {
      return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
    }
    return empty.withMutations(function (list) {
      list.setSize(size);
      iter.forEach(function (v, i) { return list.set(i, v); });
    });
  }

  if ( IndexedCollection$$1 ) List.__proto__ = IndexedCollection$$1;
  List.prototype = Object.create( IndexedCollection$$1 && IndexedCollection$$1.prototype );
  List.prototype.constructor = List;

  List.of = function of (/*...values*/) {
    return this(arguments);
  };

  List.prototype.toString = function toString () {
    return this.__toString('List [', ']');
  };

  // @pragma Access

  List.prototype.get = function get (index, notSetValue) {
    index = wrapIndex(this, index);
    if (index >= 0 && index < this.size) {
      index += this._origin;
      var node = listNodeFor(this, index);
      return node && node.array[index & MASK];
    }
    return notSetValue;
  };

  // @pragma Modification

  List.prototype.set = function set (index, value) {
    return updateList(this, index, value);
  };

  List.prototype.remove = function remove (index) {
    return !this.has(index)
      ? this
      : index === 0
        ? this.shift()
        : index === this.size - 1 ? this.pop() : this.splice(index, 1);
  };

  List.prototype.insert = function insert (index, value) {
    return this.splice(index, 0, value);
  };

  List.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = this._origin = this._capacity = 0;
      this._level = SHIFT;
      this._root = this._tail = null;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyList();
  };

  List.prototype.push = function push (/*...values*/) {
    var values = arguments;
    var oldSize = this.size;
    return this.withMutations(function (list) {
      setListBounds(list, 0, oldSize + values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(oldSize + ii, values[ii]);
      }
    });
  };

  List.prototype.pop = function pop () {
    return setListBounds(this, 0, -1);
  };

  List.prototype.unshift = function unshift (/*...values*/) {
    var values = arguments;
    return this.withMutations(function (list) {
      setListBounds(list, -values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(ii, values[ii]);
      }
    });
  };

  List.prototype.shift = function shift () {
    return setListBounds(this, 1);
  };

  // @pragma Composition

  List.prototype.concat = function concat (/*...collections*/) {
    var arguments$1 = arguments;

    var seqs = [];
    for (var i = 0; i < arguments.length; i++) {
      var argument = arguments$1[i];
      var seq = IndexedCollection$$1(
        typeof argument !== 'string' && hasIterator(argument)
          ? argument
          : [argument]
      );
      if (seq.size !== 0) {
        seqs.push(seq);
      }
    }
    if (seqs.length === 0) {
      return this;
    }
    if (this.size === 0 && !this.__ownerID && seqs.length === 1) {
      return this.constructor(seqs[0]);
    }
    return this.withMutations(function (list) {
      seqs.forEach(function (seq) { return seq.forEach(function (value) { return list.push(value); }); });
    });
  };

  List.prototype.setSize = function setSize (size) {
    return setListBounds(this, 0, size);
  };

  // @pragma Iteration

  List.prototype.slice = function slice (begin, end) {
    var size = this.size;
    if (wholeSlice(begin, end, size)) {
      return this;
    }
    return setListBounds(
      this,
      resolveBegin(begin, size),
      resolveEnd(end, size)
    );
  };

  List.prototype.__iterator = function __iterator (type, reverse) {
    var index = reverse ? this.size : 0;
    var values = iterateList(this, reverse);
    return new Iterator(function () {
      var value = values();
      return value === DONE
        ? iteratorDone()
        : iteratorValue(type, reverse ? --index : index++, value);
    });
  };

  List.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    var index = reverse ? this.size : 0;
    var values = iterateList(this, reverse);
    var value;
    while ((value = values()) !== DONE) {
      if (fn(value, reverse ? --index : index++, this$1) === false) {
        break;
      }
    }
    return index;
  };

  List.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      if (this.size === 0) {
        return emptyList();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeList(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      ownerID,
      this.__hash
    );
  };

  return List;
}(IndexedCollection));

function isList(maybeList) {
  return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
}

List.isList = isList;

var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SENTINEL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn$$1;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update$$1;
ListPrototype.updateIn = updateIn$1;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function(result, arr) {
  return result.push(arr);
};
ListPrototype['@@transducer/result'] = function(obj) {
  return obj.asImmutable();
};

var VNode = function VNode(array, ownerID) {
  this.array = array;
  this.ownerID = ownerID;
};

// TODO: seems like these methods are very similar

VNode.prototype.removeBefore = function removeBefore (ownerID, level, index) {
  if (index === level ? 1 << level : 0 || this.array.length === 0) {
    return this;
  }
  var originIndex = (index >>> level) & MASK;
  if (originIndex >= this.array.length) {
    return new VNode([], ownerID);
  }
  var removingFirst = originIndex === 0;
  var newChild;
  if (level > 0) {
    var oldChild = this.array[originIndex];
    newChild =
      oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
    if (newChild === oldChild && removingFirst) {
      return this;
    }
  }
  if (removingFirst && !newChild) {
    return this;
  }
  var editable = editableVNode(this, ownerID);
  if (!removingFirst) {
    for (var ii = 0; ii < originIndex; ii++) {
      editable.array[ii] = undefined;
    }
  }
  if (newChild) {
    editable.array[originIndex] = newChild;
  }
  return editable;
};

VNode.prototype.removeAfter = function removeAfter (ownerID, level, index) {
  if (index === (level ? 1 << level : 0) || this.array.length === 0) {
    return this;
  }
  var sizeIndex = ((index - 1) >>> level) & MASK;
  if (sizeIndex >= this.array.length) {
    return this;
  }

  var newChild;
  if (level > 0) {
    var oldChild = this.array[sizeIndex];
    newChild =
      oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
    if (newChild === oldChild && sizeIndex === this.array.length - 1) {
      return this;
    }
  }

  var editable = editableVNode(this, ownerID);
  editable.array.splice(sizeIndex + 1);
  if (newChild) {
    editable.array[sizeIndex] = newChild;
  }
  return editable;
};

var DONE = {};

function iterateList(list, reverse) {
  var left = list._origin;
  var right = list._capacity;
  var tailPos = getTailOffset(right);
  var tail = list._tail;

  return iterateNodeOrLeaf(list._root, list._level, 0);

  function iterateNodeOrLeaf(node, level, offset) {
    return level === 0
      ? iterateLeaf(node, offset)
      : iterateNode(node, level, offset);
  }

  function iterateLeaf(node, offset) {
    var array = offset === tailPos ? tail && tail.array : node && node.array;
    var from = offset > left ? 0 : left - offset;
    var to = right - offset;
    if (to > SIZE) {
      to = SIZE;
    }
    return function () {
      if (from === to) {
        return DONE;
      }
      var idx = reverse ? --to : from++;
      return array && array[idx];
    };
  }

  function iterateNode(node, level, offset) {
    var values;
    var array = node && node.array;
    var from = offset > left ? 0 : (left - offset) >> level;
    var to = ((right - offset) >> level) + 1;
    if (to > SIZE) {
      to = SIZE;
    }
    return function () {
      while (true) {
        if (values) {
          var value = values();
          if (value !== DONE) {
            return value;
          }
          values = null;
        }
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        values = iterateNodeOrLeaf(
          array && array[idx],
          level - SHIFT,
          offset + (idx << level)
        );
      }
    };
  }
}

function makeList(origin, capacity, level, root, tail, ownerID, hash) {
  var list = Object.create(ListPrototype);
  list.size = capacity - origin;
  list._origin = origin;
  list._capacity = capacity;
  list._level = level;
  list._root = root;
  list._tail = tail;
  list.__ownerID = ownerID;
  list.__hash = hash;
  list.__altered = false;
  return list;
}

var EMPTY_LIST;
function emptyList() {
  return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}

function updateList(list, index, value) {
  index = wrapIndex(list, index);

  if (index !== index) {
    return list;
  }

  if (index >= list.size || index < 0) {
    return list.withMutations(function (list) {
      index < 0
        ? setListBounds(list, index).set(0, value)
        : setListBounds(list, 0, index + 1).set(index, value);
    });
  }

  index += list._origin;

  var newTail = list._tail;
  var newRoot = list._root;
  var didAlter = MakeRef(DID_ALTER);
  if (index >= getTailOffset(list._capacity)) {
    newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
  } else {
    newRoot = updateVNode(
      newRoot,
      list.__ownerID,
      list._level,
      index,
      value,
      didAlter
    );
  }

  if (!didAlter.value) {
    return list;
  }

  if (list.__ownerID) {
    list._root = newRoot;
    list._tail = newTail;
    list.__hash = undefined;
    list.__altered = true;
    return list;
  }
  return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}

function updateVNode(node, ownerID, level, index, value, didAlter) {
  var idx = (index >>> level) & MASK;
  var nodeHas = node && idx < node.array.length;
  if (!nodeHas && value === undefined) {
    return node;
  }

  var newNode;

  if (level > 0) {
    var lowerNode = node && node.array[idx];
    var newLowerNode = updateVNode(
      lowerNode,
      ownerID,
      level - SHIFT,
      index,
      value,
      didAlter
    );
    if (newLowerNode === lowerNode) {
      return node;
    }
    newNode = editableVNode(node, ownerID);
    newNode.array[idx] = newLowerNode;
    return newNode;
  }

  if (nodeHas && node.array[idx] === value) {
    return node;
  }

  SetRef(didAlter);

  newNode = editableVNode(node, ownerID);
  if (value === undefined && idx === newNode.array.length - 1) {
    newNode.array.pop();
  } else {
    newNode.array[idx] = value;
  }
  return newNode;
}

function editableVNode(node, ownerID) {
  if (ownerID && node && ownerID === node.ownerID) {
    return node;
  }
  return new VNode(node ? node.array.slice() : [], ownerID);
}

function listNodeFor(list, rawIndex) {
  if (rawIndex >= getTailOffset(list._capacity)) {
    return list._tail;
  }
  if (rawIndex < 1 << (list._level + SHIFT)) {
    var node = list._root;
    var level = list._level;
    while (node && level > 0) {
      node = node.array[(rawIndex >>> level) & MASK];
      level -= SHIFT;
    }
    return node;
  }
}

function setListBounds(list, begin, end) {
  // Sanitize begin & end using this shorthand for ToInt32(argument)
  // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
  if (begin !== undefined) {
    begin |= 0;
  }
  if (end !== undefined) {
    end |= 0;
  }
  var owner = list.__ownerID || new OwnerID();
  var oldOrigin = list._origin;
  var oldCapacity = list._capacity;
  var newOrigin = oldOrigin + begin;
  var newCapacity =
    end === undefined
      ? oldCapacity
      : end < 0 ? oldCapacity + end : oldOrigin + end;
  if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
    return list;
  }

  // If it's going to end after it starts, it's empty.
  if (newOrigin >= newCapacity) {
    return list.clear();
  }

  var newLevel = list._level;
  var newRoot = list._root;

  // New origin might need creating a higher root.
  var offsetShift = 0;
  while (newOrigin + offsetShift < 0) {
    newRoot = new VNode(
      newRoot && newRoot.array.length ? [undefined, newRoot] : [],
      owner
    );
    newLevel += SHIFT;
    offsetShift += 1 << newLevel;
  }
  if (offsetShift) {
    newOrigin += offsetShift;
    oldOrigin += offsetShift;
    newCapacity += offsetShift;
    oldCapacity += offsetShift;
  }

  var oldTailOffset = getTailOffset(oldCapacity);
  var newTailOffset = getTailOffset(newCapacity);

  // New size might need creating a higher root.
  while (newTailOffset >= 1 << (newLevel + SHIFT)) {
    newRoot = new VNode(
      newRoot && newRoot.array.length ? [newRoot] : [],
      owner
    );
    newLevel += SHIFT;
  }

  // Locate or create the new tail.
  var oldTail = list._tail;
  var newTail =
    newTailOffset < oldTailOffset
      ? listNodeFor(list, newCapacity - 1)
      : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

  // Merge Tail into tree.
  if (
    oldTail &&
    newTailOffset > oldTailOffset &&
    newOrigin < oldCapacity &&
    oldTail.array.length
  ) {
    newRoot = editableVNode(newRoot, owner);
    var node = newRoot;
    for (var level = newLevel; level > SHIFT; level -= SHIFT) {
      var idx = (oldTailOffset >>> level) & MASK;
      node = node.array[idx] = editableVNode(node.array[idx], owner);
    }
    node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
  }

  // If the size has been reduced, there's a chance the tail needs to be trimmed.
  if (newCapacity < oldCapacity) {
    newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
  }

  // If the new origin is within the tail, then we do not need a root.
  if (newOrigin >= newTailOffset) {
    newOrigin -= newTailOffset;
    newCapacity -= newTailOffset;
    newLevel = SHIFT;
    newRoot = null;
    newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
  } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
    offsetShift = 0;

    // Identify the new top root node of the subtree of the old root.
    while (newRoot) {
      var beginIndex = (newOrigin >>> newLevel) & MASK;
      if ((beginIndex !== newTailOffset >>> newLevel) & MASK) {
        break;
      }
      if (beginIndex) {
        offsetShift += (1 << newLevel) * beginIndex;
      }
      newLevel -= SHIFT;
      newRoot = newRoot.array[beginIndex];
    }

    // Trim the new sides of the new root.
    if (newRoot && newOrigin > oldOrigin) {
      newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
    }
    if (newRoot && newTailOffset < oldTailOffset) {
      newRoot = newRoot.removeAfter(
        owner,
        newLevel,
        newTailOffset - offsetShift
      );
    }
    if (offsetShift) {
      newOrigin -= offsetShift;
      newCapacity -= offsetShift;
    }
  }

  if (list.__ownerID) {
    list.size = newCapacity - newOrigin;
    list._origin = newOrigin;
    list._capacity = newCapacity;
    list._level = newLevel;
    list._root = newRoot;
    list._tail = newTail;
    list.__hash = undefined;
    list.__altered = true;
    return list;
  }
  return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}

function getTailOffset(size) {
  return size < SIZE ? 0 : ((size - 1) >>> SHIFT) << SHIFT;
}

var OrderedMap = (function (Map$$1) {
  function OrderedMap(value) {
    return value === null || value === undefined
      ? emptyOrderedMap()
      : isOrderedMap(value)
        ? value
        : emptyOrderedMap().withMutations(function (map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v, k) { return map.set(k, v); });
          });
  }

  if ( Map$$1 ) OrderedMap.__proto__ = Map$$1;
  OrderedMap.prototype = Object.create( Map$$1 && Map$$1.prototype );
  OrderedMap.prototype.constructor = OrderedMap;

  OrderedMap.of = function of (/*...values*/) {
    return this(arguments);
  };

  OrderedMap.prototype.toString = function toString () {
    return this.__toString('OrderedMap {', '}');
  };

  // @pragma Access

  OrderedMap.prototype.get = function get (k, notSetValue) {
    var index = this._map.get(k);
    return index !== undefined ? this._list.get(index)[1] : notSetValue;
  };

  // @pragma Modification

  OrderedMap.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._map.clear();
      this._list.clear();
      return this;
    }
    return emptyOrderedMap();
  };

  OrderedMap.prototype.set = function set (k, v) {
    return updateOrderedMap(this, k, v);
  };

  OrderedMap.prototype.remove = function remove (k) {
    return updateOrderedMap(this, k, NOT_SET);
  };

  OrderedMap.prototype.wasAltered = function wasAltered () {
    return this._map.wasAltered() || this._list.wasAltered();
  };

  OrderedMap.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    return this._list.__iterate(
      function (entry) { return entry && fn(entry[1], entry[0], this$1); },
      reverse
    );
  };

  OrderedMap.prototype.__iterator = function __iterator (type, reverse) {
    return this._list.fromEntrySeq().__iterator(type, reverse);
  };

  OrderedMap.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    var newList = this._list.__ensureOwner(ownerID);
    if (!ownerID) {
      if (this.size === 0) {
        return emptyOrderedMap();
      }
      this.__ownerID = ownerID;
      this._map = newMap;
      this._list = newList;
      return this;
    }
    return makeOrderedMap(newMap, newList, ownerID, this.__hash);
  };

  return OrderedMap;
}(Map));

function isOrderedMap(maybeOrderedMap) {
  return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}

OrderedMap.isOrderedMap = isOrderedMap;

OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;

function makeOrderedMap(map, list, ownerID, hash) {
  var omap = Object.create(OrderedMap.prototype);
  omap.size = map ? map.size : 0;
  omap._map = map;
  omap._list = list;
  omap.__ownerID = ownerID;
  omap.__hash = hash;
  return omap;
}

var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
  return (
    EMPTY_ORDERED_MAP ||
    (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()))
  );
}

function updateOrderedMap(omap, k, v) {
  var map = omap._map;
  var list = omap._list;
  var i = map.get(k);
  var has = i !== undefined;
  var newMap;
  var newList;
  if (v === NOT_SET) {
    // removed
    if (!has) {
      return omap;
    }
    if (list.size >= SIZE && list.size >= map.size * 2) {
      newList = list.filter(function (entry, idx) { return entry !== undefined && i !== idx; });
      newMap = newList
        .toKeyedSeq()
        .map(function (entry) { return entry[0]; })
        .flip()
        .toMap();
      if (omap.__ownerID) {
        newMap.__ownerID = newList.__ownerID = omap.__ownerID;
      }
    } else {
      newMap = map.remove(k);
      newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
    }
  } else if (has) {
    if (v === list.get(i)[1]) {
      return omap;
    }
    newMap = map;
    newList = list.set(i, [k, v]);
  } else {
    newMap = map.set(k, list.size);
    newList = list.set(list.size, [k, v]);
  }
  if (omap.__ownerID) {
    omap.size = newMap.size;
    omap._map = newMap;
    omap._list = newList;
    omap.__hash = undefined;
    return omap;
  }
  return makeOrderedMap(newMap, newList);
}

var Stack = (function (IndexedCollection$$1) {
  function Stack(value) {
    return value === null || value === undefined
      ? emptyStack()
      : isStack(value) ? value : emptyStack().pushAll(value);
  }

  if ( IndexedCollection$$1 ) Stack.__proto__ = IndexedCollection$$1;
  Stack.prototype = Object.create( IndexedCollection$$1 && IndexedCollection$$1.prototype );
  Stack.prototype.constructor = Stack;

  Stack.of = function of (/*...values*/) {
    return this(arguments);
  };

  Stack.prototype.toString = function toString () {
    return this.__toString('Stack [', ']');
  };

  // @pragma Access

  Stack.prototype.get = function get (index, notSetValue) {
    var head = this._head;
    index = wrapIndex(this, index);
    while (head && index--) {
      head = head.next;
    }
    return head ? head.value : notSetValue;
  };

  Stack.prototype.peek = function peek () {
    return this._head && this._head.value;
  };

  // @pragma Modification

  Stack.prototype.push = function push (/*...values*/) {
    var arguments$1 = arguments;

    if (arguments.length === 0) {
      return this;
    }
    var newSize = this.size + arguments.length;
    var head = this._head;
    for (var ii = arguments.length - 1; ii >= 0; ii--) {
      head = {
        value: arguments$1[ii],
        next: head
      };
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pushAll = function pushAll (iter) {
    iter = IndexedCollection$$1(iter);
    if (iter.size === 0) {
      return this;
    }
    if (this.size === 0 && isStack(iter)) {
      return iter;
    }
    assertNotInfinite(iter.size);
    var newSize = this.size;
    var head = this._head;
    iter.__iterate(function (value) {
      newSize++;
      head = {
        value: value,
        next: head
      };
    }, /* reverse */ true);
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pop = function pop () {
    return this.slice(1);
  };

  Stack.prototype.clear = function clear () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._head = undefined;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyStack();
  };

  Stack.prototype.slice = function slice (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    var resolvedBegin = resolveBegin(begin, this.size);
    var resolvedEnd = resolveEnd(end, this.size);
    if (resolvedEnd !== this.size) {
      // super.slice(begin, end);
      return IndexedCollection$$1.prototype.slice.call(this, begin, end);
    }
    var newSize = this.size - resolvedBegin;
    var head = this._head;
    while (resolvedBegin--) {
      head = head.next;
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  // @pragma Mutability

  Stack.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      if (this.size === 0) {
        return emptyStack();
      }
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeStack(this.size, this._head, ownerID, this.__hash);
  };

  // @pragma Iteration

  Stack.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    if (reverse) {
      return new ArraySeq(this.toArray()).__iterate(
        function (v, k) { return fn(v, k, this$1); },
        reverse
      );
    }
    var iterations = 0;
    var node = this._head;
    while (node) {
      if (fn(node.value, iterations++, this$1) === false) {
        break;
      }
      node = node.next;
    }
    return iterations;
  };

  Stack.prototype.__iterator = function __iterator (type, reverse) {
    if (reverse) {
      return new ArraySeq(this.toArray()).__iterator(type, reverse);
    }
    var iterations = 0;
    var node = this._head;
    return new Iterator(function () {
      if (node) {
        var value = node.value;
        node = node.next;
        return iteratorValue(type, iterations++, value);
      }
      return iteratorDone();
    });
  };

  return Stack;
}(IndexedCollection));

function isStack(maybeStack) {
  return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
}

Stack.isStack = isStack;

var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SENTINEL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function(result, arr) {
  return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function(obj) {
  return obj.asImmutable();
};

function makeStack(size, head, ownerID, hash) {
  var map = Object.create(StackPrototype);
  map.size = size;
  map._head = head;
  map.__ownerID = ownerID;
  map.__hash = hash;
  map.__altered = false;
  return map;
}

var EMPTY_STACK;
function emptyStack() {
  return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}

function deepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (
    !isCollection(b) ||
    (a.size !== undefined && b.size !== undefined && a.size !== b.size) ||
    (a.__hash !== undefined &&
      b.__hash !== undefined &&
      a.__hash !== b.__hash) ||
    isKeyed(a) !== isKeyed(b) ||
    isIndexed(a) !== isIndexed(b) ||
    isOrdered(a) !== isOrdered(b)
  ) {
    return false;
  }

  if (a.size === 0 && b.size === 0) {
    return true;
  }

  var notAssociative = !isAssociative(a);

  if (isOrdered(a)) {
    var entries = a.entries();
    return (
      b.every(function (v, k) {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done
    );
  }

  var flipped = false;

  if (a.size === undefined) {
    if (b.size === undefined) {
      if (typeof a.cacheResult === 'function') {
        a.cacheResult();
      }
    } else {
      flipped = true;
      var _ = a;
      a = b;
      b = _;
    }
  }

  var allEqual = true;
  var bSize = b.__iterate(function (v, k) {
    if (
      notAssociative
        ? !a.has(v)
        : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)
    ) {
      allEqual = false;
      return false;
    }
  });

  return allEqual && a.size === bSize;
}

/**
 * Contributes additional methods to a constructor
 */
function mixin(ctor, methods) {
  var keyCopier = function (key) {
    ctor.prototype[key] = methods[key];
  };
  Object.keys(methods).forEach(keyCopier);
  Object.getOwnPropertySymbols &&
    Object.getOwnPropertySymbols(methods).forEach(keyCopier);
  return ctor;
}

function toJS(value) {
  return isDataStructure(value)
    ? Seq(value)
        .map(toJS)
        .toJSON()
    : value;
}

var Set = (function (SetCollection$$1) {
  function Set(value) {
    return value === null || value === undefined
      ? emptySet()
      : isSet(value) && !isOrdered(value)
        ? value
        : emptySet().withMutations(function (set) {
            var iter = SetCollection$$1(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v) { return set.add(v); });
          });
  }

  if ( SetCollection$$1 ) Set.__proto__ = SetCollection$$1;
  Set.prototype = Object.create( SetCollection$$1 && SetCollection$$1.prototype );
  Set.prototype.constructor = Set;

  Set.of = function of (/*...values*/) {
    return this(arguments);
  };

  Set.fromKeys = function fromKeys (value) {
    return this(KeyedCollection(value).keySeq());
  };

  Set.intersect = function intersect (sets) {
    sets = Collection(sets).toArray();
    return sets.length
      ? SetPrototype.intersect.apply(Set(sets.pop()), sets)
      : emptySet();
  };

  Set.union = function union (sets) {
    sets = Collection(sets).toArray();
    return sets.length
      ? SetPrototype.union.apply(Set(sets.pop()), sets)
      : emptySet();
  };

  Set.prototype.toString = function toString () {
    return this.__toString('Set {', '}');
  };

  // @pragma Access

  Set.prototype.has = function has (value) {
    return this._map.has(value);
  };

  // @pragma Modification

  Set.prototype.add = function add (value) {
    return updateSet(this, this._map.set(value, value));
  };

  Set.prototype.remove = function remove (value) {
    return updateSet(this, this._map.remove(value));
  };

  Set.prototype.clear = function clear () {
    return updateSet(this, this._map.clear());
  };

  // @pragma Composition

  Set.prototype.union = function union () {
    var iters = [], len = arguments.length;
    while ( len-- ) iters[ len ] = arguments[ len ];

    iters = iters.filter(function (x) { return x.size !== 0; });
    if (iters.length === 0) {
      return this;
    }
    if (this.size === 0 && !this.__ownerID && iters.length === 1) {
      return this.constructor(iters[0]);
    }
    return this.withMutations(function (set) {
      for (var ii = 0; ii < iters.length; ii++) {
        SetCollection$$1(iters[ii]).forEach(function (value) { return set.add(value); });
      }
    });
  };

  Set.prototype.intersect = function intersect () {
    var iters = [], len = arguments.length;
    while ( len-- ) iters[ len ] = arguments[ len ];

    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) { return SetCollection$$1(iter); });
    var toRemove = [];
    this.forEach(function (value) {
      if (!iters.every(function (iter) { return iter.includes(value); })) {
        toRemove.push(value);
      }
    });
    return this.withMutations(function (set) {
      toRemove.forEach(function (value) {
        set.remove(value);
      });
    });
  };

  Set.prototype.subtract = function subtract () {
    var iters = [], len = arguments.length;
    while ( len-- ) iters[ len ] = arguments[ len ];

    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) { return SetCollection$$1(iter); });
    var toRemove = [];
    this.forEach(function (value) {
      if (iters.some(function (iter) { return iter.includes(value); })) {
        toRemove.push(value);
      }
    });
    return this.withMutations(function (set) {
      toRemove.forEach(function (value) {
        set.remove(value);
      });
    });
  };

  Set.prototype.sort = function sort (comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator));
  };

  Set.prototype.sortBy = function sortBy (mapper, comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator, mapper));
  };

  Set.prototype.wasAltered = function wasAltered () {
    return this._map.wasAltered();
  };

  Set.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    return this._map.__iterate(function (k) { return fn(k, k, this$1); }, reverse);
  };

  Set.prototype.__iterator = function __iterator (type, reverse) {
    return this._map.__iterator(type, reverse);
  };

  Set.prototype.__ensureOwner = function __ensureOwner (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    if (!ownerID) {
      if (this.size === 0) {
        return this.__empty();
      }
      this.__ownerID = ownerID;
      this._map = newMap;
      return this;
    }
    return this.__make(newMap, ownerID);
  };

  return Set;
}(SetCollection));

function isSet(maybeSet) {
  return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
}

Set.isSet = isSet;

var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SENTINEL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function(result, arr) {
  return result.add(arr);
};
SetPrototype['@@transducer/result'] = function(obj) {
  return obj.asImmutable();
};

SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;

function updateSet(set, newMap) {
  if (set.__ownerID) {
    set.size = newMap.size;
    set._map = newMap;
    return set;
  }
  return newMap === set._map
    ? set
    : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}

function makeSet(map, ownerID) {
  var set = Object.create(SetPrototype);
  set.size = map ? map.size : 0;
  set._map = map;
  set.__ownerID = ownerID;
  return set;
}

var EMPTY_SET;
function emptySet() {
  return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}

/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */
var Range = (function (IndexedSeq$$1) {
  function Range(start, end, step) {
    if (!(this instanceof Range)) {
      return new Range(start, end, step);
    }
    invariant(step !== 0, 'Cannot step a Range by 0');
    start = start || 0;
    if (end === undefined) {
      end = Infinity;
    }
    step = step === undefined ? 1 : Math.abs(step);
    if (end < start) {
      step = -step;
    }
    this._start = start;
    this._end = end;
    this._step = step;
    this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
    if (this.size === 0) {
      if (EMPTY_RANGE) {
        return EMPTY_RANGE;
      }
      EMPTY_RANGE = this;
    }
  }

  if ( IndexedSeq$$1 ) Range.__proto__ = IndexedSeq$$1;
  Range.prototype = Object.create( IndexedSeq$$1 && IndexedSeq$$1.prototype );
  Range.prototype.constructor = Range;

  Range.prototype.toString = function toString () {
    if (this.size === 0) {
      return 'Range []';
    }
    return (
      'Range [ ' +
      this._start +
      '...' +
      this._end +
      (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]'
    );
  };

  Range.prototype.get = function get (index, notSetValue) {
    return this.has(index)
      ? this._start + wrapIndex(this, index) * this._step
      : notSetValue;
  };

  Range.prototype.includes = function includes (searchValue) {
    var possibleIndex = (searchValue - this._start) / this._step;
    return (
      possibleIndex >= 0 &&
      possibleIndex < this.size &&
      possibleIndex === Math.floor(possibleIndex)
    );
  };

  Range.prototype.slice = function slice (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    begin = resolveBegin(begin, this.size);
    end = resolveEnd(end, this.size);
    if (end <= begin) {
      return new Range(0, 0);
    }
    return new Range(
      this.get(begin, this._end),
      this.get(end, this._end),
      this._step
    );
  };

  Range.prototype.indexOf = function indexOf (searchValue) {
    var offsetValue = searchValue - this._start;
    if (offsetValue % this._step === 0) {
      var index = offsetValue / this._step;
      if (index >= 0 && index < this.size) {
        return index;
      }
    }
    return -1;
  };

  Range.prototype.lastIndexOf = function lastIndexOf (searchValue) {
    return this.indexOf(searchValue);
  };

  Range.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    var size = this.size;
    var step = this._step;
    var value = reverse ? this._start + (size - 1) * step : this._start;
    var i = 0;
    while (i !== size) {
      if (fn(value, reverse ? size - ++i : i++, this$1) === false) {
        break;
      }
      value += reverse ? -step : step;
    }
    return i;
  };

  Range.prototype.__iterator = function __iterator (type, reverse) {
    var size = this.size;
    var step = this._step;
    var value = reverse ? this._start + (size - 1) * step : this._start;
    var i = 0;
    return new Iterator(function () {
      if (i === size) {
        return iteratorDone();
      }
      var v = value;
      value += reverse ? -step : step;
      return iteratorValue(type, reverse ? size - ++i : i++, v);
    });
  };

  Range.prototype.equals = function equals (other) {
    return other instanceof Range
      ? this._start === other._start &&
          this._end === other._end &&
          this._step === other._step
      : deepEqual(this, other);
  };

  return Range;
}(IndexedSeq));

var EMPTY_RANGE;

function getIn$1(collection, searchKeyPath, notSetValue) {
  var keyPath = coerceKeyPath(searchKeyPath);
  var i = 0;
  while (i !== keyPath.length) {
    collection = get(collection, keyPath[i++], NOT_SET);
    if (collection === NOT_SET) {
      return notSetValue;
    }
  }
  return collection;
}

function getIn$$1(searchKeyPath, notSetValue) {
  return getIn$1(this, searchKeyPath, notSetValue);
}

function hasIn$1(collection, keyPath) {
  return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}

function hasIn$$1(searchKeyPath) {
  return hasIn$1(this, searchKeyPath);
}

function toObject() {
  assertNotInfinite(this.size);
  var object = {};
  this.__iterate(function (v, k) {
    object[k] = v;
  });
  return object;
}

// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;

Collection.Iterator = Iterator;

mixin(Collection, {
  // ### Conversion to other types

  toArray: function toArray() {
    assertNotInfinite(this.size);
    var array = new Array(this.size || 0);
    var useTuples = isKeyed(this);
    var i = 0;
    this.__iterate(function (v, k) {
      // Keyed collections produce an array of tuples.
      array[i++] = useTuples ? [k, v] : v;
    });
    return array;
  },

  toIndexedSeq: function toIndexedSeq() {
    return new ToIndexedSequence(this);
  },

  toJS: function toJS$1() {
    return toJS(this);
  },

  toKeyedSeq: function toKeyedSeq() {
    return new ToKeyedSequence(this, true);
  },

  toMap: function toMap() {
    // Use Late Binding here to solve the circular dependency.
    return Map(this.toKeyedSeq());
  },

  toObject: toObject,

  toOrderedMap: function toOrderedMap() {
    // Use Late Binding here to solve the circular dependency.
    return OrderedMap(this.toKeyedSeq());
  },

  toOrderedSet: function toOrderedSet() {
    // Use Late Binding here to solve the circular dependency.
    return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
  },

  toSet: function toSet() {
    // Use Late Binding here to solve the circular dependency.
    return Set(isKeyed(this) ? this.valueSeq() : this);
  },

  toSetSeq: function toSetSeq() {
    return new ToSetSequence(this);
  },

  toSeq: function toSeq() {
    return isIndexed(this)
      ? this.toIndexedSeq()
      : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
  },

  toStack: function toStack() {
    // Use Late Binding here to solve the circular dependency.
    return Stack(isKeyed(this) ? this.valueSeq() : this);
  },

  toList: function toList() {
    // Use Late Binding here to solve the circular dependency.
    return List(isKeyed(this) ? this.valueSeq() : this);
  },

  // ### Common JavaScript methods and properties

  toString: function toString() {
    return '[Collection]';
  },

  __toString: function __toString(head, tail) {
    if (this.size === 0) {
      return head + tail;
    }
    return (
      head +
      ' ' +
      this.toSeq()
        .map(this.__toStringMapper)
        .join(', ') +
      ' ' +
      tail
    );
  },

  // ### ES6 Collection methods (ES6 Array and Map)

  concat: function concat() {
    var values = [], len = arguments.length;
    while ( len-- ) values[ len ] = arguments[ len ];

    return reify(this, concatFactory(this, values));
  },

  includes: function includes(searchValue) {
    return this.some(function (value) { return is(value, searchValue); });
  },

  entries: function entries() {
    return this.__iterator(ITERATE_ENTRIES);
  },

  every: function every(predicate, context) {
    assertNotInfinite(this.size);
    var returnValue = true;
    this.__iterate(function (v, k, c) {
      if (!predicate.call(context, v, k, c)) {
        returnValue = false;
        return false;
      }
    });
    return returnValue;
  },

  filter: function filter(predicate, context) {
    return reify(this, filterFactory(this, predicate, context, true));
  },

  find: function find(predicate, context, notSetValue) {
    var entry = this.findEntry(predicate, context);
    return entry ? entry[1] : notSetValue;
  },

  forEach: function forEach(sideEffect, context) {
    assertNotInfinite(this.size);
    return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
  },

  join: function join(separator) {
    assertNotInfinite(this.size);
    separator = separator !== undefined ? '' + separator : ',';
    var joined = '';
    var isFirst = true;
    this.__iterate(function (v) {
      isFirst ? (isFirst = false) : (joined += separator);
      joined += v !== null && v !== undefined ? v.toString() : '';
    });
    return joined;
  },

  keys: function keys() {
    return this.__iterator(ITERATE_KEYS);
  },

  map: function map(mapper, context) {
    return reify(this, mapFactory(this, mapper, context));
  },

  reduce: function reduce$1(reducer, initialReduction, context) {
    return reduce(
      this,
      reducer,
      initialReduction,
      context,
      arguments.length < 2,
      false
    );
  },

  reduceRight: function reduceRight(reducer, initialReduction, context) {
    return reduce(
      this,
      reducer,
      initialReduction,
      context,
      arguments.length < 2,
      true
    );
  },

  reverse: function reverse() {
    return reify(this, reverseFactory(this, true));
  },

  slice: function slice(begin, end) {
    return reify(this, sliceFactory(this, begin, end, true));
  },

  some: function some(predicate, context) {
    return !this.every(not(predicate), context);
  },

  sort: function sort(comparator) {
    return reify(this, sortFactory(this, comparator));
  },

  values: function values() {
    return this.__iterator(ITERATE_VALUES);
  },

  // ### More sequential methods

  butLast: function butLast() {
    return this.slice(0, -1);
  },

  isEmpty: function isEmpty() {
    return this.size !== undefined ? this.size === 0 : !this.some(function () { return true; });
  },

  count: function count(predicate, context) {
    return ensureSize(
      predicate ? this.toSeq().filter(predicate, context) : this
    );
  },

  countBy: function countBy(grouper, context) {
    return countByFactory(this, grouper, context);
  },

  equals: function equals(other) {
    return deepEqual(this, other);
  },

  entrySeq: function entrySeq() {
    var collection = this;
    if (collection._cache) {
      // We cache as an entries array, so we can just return the cache!
      return new ArraySeq(collection._cache);
    }
    var entriesSequence = collection
      .toSeq()
      .map(entryMapper)
      .toIndexedSeq();
    entriesSequence.fromEntrySeq = function () { return collection.toSeq(); };
    return entriesSequence;
  },

  filterNot: function filterNot(predicate, context) {
    return this.filter(not(predicate), context);
  },

  findEntry: function findEntry(predicate, context, notSetValue) {
    var found = notSetValue;
    this.__iterate(function (v, k, c) {
      if (predicate.call(context, v, k, c)) {
        found = [k, v];
        return false;
      }
    });
    return found;
  },

  findKey: function findKey(predicate, context) {
    var entry = this.findEntry(predicate, context);
    return entry && entry[0];
  },

  findLast: function findLast(predicate, context, notSetValue) {
    return this.toKeyedSeq()
      .reverse()
      .find(predicate, context, notSetValue);
  },

  findLastEntry: function findLastEntry(predicate, context, notSetValue) {
    return this.toKeyedSeq()
      .reverse()
      .findEntry(predicate, context, notSetValue);
  },

  findLastKey: function findLastKey(predicate, context) {
    return this.toKeyedSeq()
      .reverse()
      .findKey(predicate, context);
  },

  first: function first() {
    return this.find(returnTrue);
  },

  flatMap: function flatMap(mapper, context) {
    return reify(this, flatMapFactory(this, mapper, context));
  },

  flatten: function flatten(depth) {
    return reify(this, flattenFactory(this, depth, true));
  },

  fromEntrySeq: function fromEntrySeq() {
    return new FromEntriesSequence(this);
  },

  get: function get(searchKey, notSetValue) {
    return this.find(function (_, key) { return is(key, searchKey); }, undefined, notSetValue);
  },

  getIn: getIn$$1,

  groupBy: function groupBy(grouper, context) {
    return groupByFactory(this, grouper, context);
  },

  has: function has(searchKey) {
    return this.get(searchKey, NOT_SET) !== NOT_SET;
  },

  hasIn: hasIn$$1,

  isSubset: function isSubset(iter) {
    iter = typeof iter.includes === 'function' ? iter : Collection(iter);
    return this.every(function (value) { return iter.includes(value); });
  },

  isSuperset: function isSuperset(iter) {
    iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
    return iter.isSubset(this);
  },

  keyOf: function keyOf(searchValue) {
    return this.findKey(function (value) { return is(value, searchValue); });
  },

  keySeq: function keySeq() {
    return this.toSeq()
      .map(keyMapper)
      .toIndexedSeq();
  },

  last: function last() {
    return this.toSeq()
      .reverse()
      .first();
  },

  lastKeyOf: function lastKeyOf(searchValue) {
    return this.toKeyedSeq()
      .reverse()
      .keyOf(searchValue);
  },

  max: function max(comparator) {
    return maxFactory(this, comparator);
  },

  maxBy: function maxBy(mapper, comparator) {
    return maxFactory(this, comparator, mapper);
  },

  min: function min(comparator) {
    return maxFactory(
      this,
      comparator ? neg(comparator) : defaultNegComparator
    );
  },

  minBy: function minBy(mapper, comparator) {
    return maxFactory(
      this,
      comparator ? neg(comparator) : defaultNegComparator,
      mapper
    );
  },

  rest: function rest() {
    return this.slice(1);
  },

  skip: function skip(amount) {
    return amount === 0 ? this : this.slice(Math.max(0, amount));
  },

  skipLast: function skipLast(amount) {
    return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
  },

  skipWhile: function skipWhile(predicate, context) {
    return reify(this, skipWhileFactory(this, predicate, context, true));
  },

  skipUntil: function skipUntil(predicate, context) {
    return this.skipWhile(not(predicate), context);
  },

  sortBy: function sortBy(mapper, comparator) {
    return reify(this, sortFactory(this, comparator, mapper));
  },

  take: function take(amount) {
    return this.slice(0, Math.max(0, amount));
  },

  takeLast: function takeLast(amount) {
    return this.slice(-Math.max(0, amount));
  },

  takeWhile: function takeWhile(predicate, context) {
    return reify(this, takeWhileFactory(this, predicate, context));
  },

  takeUntil: function takeUntil(predicate, context) {
    return this.takeWhile(not(predicate), context);
  },

  update: function update(fn) {
    return fn(this);
  },

  valueSeq: function valueSeq() {
    return this.toIndexedSeq();
  },

  // ### Hashable Object

  hashCode: function hashCode() {
    return this.__hash || (this.__hash = hashCollection(this));
  }

  // ### Internal

  // abstract __iterate(fn, reverse)

  // abstract __iterator(type, reverse)
});

var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_ITERABLE_SENTINEL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
  return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;

mixin(KeyedCollection, {
  // ### More sequential methods

  flip: function flip() {
    return reify(this, flipFactory(this));
  },

  mapEntries: function mapEntries(mapper, context) {
    var this$1 = this;

    var iterations = 0;
    return reify(
      this,
      this.toSeq()
        .map(function (v, k) { return mapper.call(context, [k, v], iterations++, this$1); })
        .fromEntrySeq()
    );
  },

  mapKeys: function mapKeys(mapper, context) {
    var this$1 = this;

    return reify(
      this,
      this.toSeq()
        .flip()
        .map(function (k, v) { return mapper.call(context, k, v, this$1); })
        .flip()
    );
  }
});

var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SENTINEL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function (v, k) { return quoteString(k) + ': ' + quoteString(v); };

mixin(IndexedCollection, {
  // ### Conversion to other types

  toKeyedSeq: function toKeyedSeq() {
    return new ToKeyedSequence(this, false);
  },

  // ### ES6 Collection methods (ES6 Array and Map)

  filter: function filter(predicate, context) {
    return reify(this, filterFactory(this, predicate, context, false));
  },

  findIndex: function findIndex(predicate, context) {
    var entry = this.findEntry(predicate, context);
    return entry ? entry[0] : -1;
  },

  indexOf: function indexOf(searchValue) {
    var key = this.keyOf(searchValue);
    return key === undefined ? -1 : key;
  },

  lastIndexOf: function lastIndexOf(searchValue) {
    var key = this.lastKeyOf(searchValue);
    return key === undefined ? -1 : key;
  },

  reverse: function reverse() {
    return reify(this, reverseFactory(this, false));
  },

  slice: function slice(begin, end) {
    return reify(this, sliceFactory(this, begin, end, false));
  },

  splice: function splice(index, removeNum /*, ...values*/) {
    var numArgs = arguments.length;
    removeNum = Math.max(removeNum || 0, 0);
    if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
      return this;
    }
    // If index is negative, it should resolve relative to the size of the
    // collection. However size may be expensive to compute if not cached, so
    // only call count() if the number is in fact negative.
    index = resolveBegin(index, index < 0 ? this.count() : this.size);
    var spliced = this.slice(0, index);
    return reify(
      this,
      numArgs === 1
        ? spliced
        : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
    );
  },

  // ### More collection methods

  findLastIndex: function findLastIndex(predicate, context) {
    var entry = this.findLastEntry(predicate, context);
    return entry ? entry[0] : -1;
  },

  first: function first() {
    return this.get(0);
  },

  flatten: function flatten(depth) {
    return reify(this, flattenFactory(this, depth, false));
  },

  get: function get(index, notSetValue) {
    index = wrapIndex(this, index);
    return index < 0 ||
      (this.size === Infinity || (this.size !== undefined && index > this.size))
      ? notSetValue
      : this.find(function (_, key) { return key === index; }, undefined, notSetValue);
  },

  has: function has(index) {
    index = wrapIndex(this, index);
    return (
      index >= 0 &&
      (this.size !== undefined
        ? this.size === Infinity || index < this.size
        : this.indexOf(index) !== -1)
    );
  },

  interpose: function interpose(separator) {
    return reify(this, interposeFactory(this, separator));
  },

  interleave: function interleave(/*...collections*/) {
    var collections = [this].concat(arrCopy(arguments));
    var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
    var interleaved = zipped.flatten(true);
    if (zipped.size) {
      interleaved.size = zipped.size * collections.length;
    }
    return reify(this, interleaved);
  },

  keySeq: function keySeq() {
    return Range(0, this.size);
  },

  last: function last() {
    return this.get(-1);
  },

  skipWhile: function skipWhile(predicate, context) {
    return reify(this, skipWhileFactory(this, predicate, context, false));
  },

  zip: function zip(/*, ...collections */) {
    var collections = [this].concat(arrCopy(arguments));
    return reify(this, zipWithFactory(this, defaultZipper, collections));
  },

  zipAll: function zipAll(/*, ...collections */) {
    var collections = [this].concat(arrCopy(arguments));
    return reify(this, zipWithFactory(this, defaultZipper, collections, true));
  },

  zipWith: function zipWith(zipper /*, ...collections */) {
    var collections = arrCopy(arguments);
    collections[0] = this;
    return reify(this, zipWithFactory(this, zipper, collections));
  }
});

var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SENTINEL] = true;
IndexedCollectionPrototype[IS_ORDERED_SENTINEL] = true;

mixin(SetCollection, {
  // ### ES6 Collection methods (ES6 Array and Map)

  get: function get(value, notSetValue) {
    return this.has(value) ? value : notSetValue;
  },

  includes: function includes(value) {
    return this.has(value);
  },

  // ### More sequential methods

  keySeq: function keySeq() {
    return this.valueSeq();
  }
});

SetCollection.prototype.has = CollectionPrototype.includes;
SetCollection.prototype.contains = SetCollection.prototype.includes;

// Mixin subclasses

mixin(KeyedSeq, KeyedCollection.prototype);
mixin(IndexedSeq, IndexedCollection.prototype);
mixin(SetSeq, SetCollection.prototype);

// #pragma Helper functions

function reduce(collection, reducer, reduction, context, useFirst, reverse) {
  assertNotInfinite(collection.size);
  collection.__iterate(function (v, k, c) {
    if (useFirst) {
      useFirst = false;
      reduction = v;
    } else {
      reduction = reducer.call(context, reduction, v, k, c);
    }
  }, reverse);
  return reduction;
}

function keyMapper(v, k) {
  return k;
}

function entryMapper(v, k) {
  return [k, v];
}

function not(predicate) {
  return function() {
    return !predicate.apply(this, arguments);
  };
}

function neg(predicate) {
  return function() {
    return -predicate.apply(this, arguments);
  };
}

function defaultZipper() {
  return arrCopy(arguments);
}

function defaultNegComparator(a, b) {
  return a < b ? 1 : a > b ? -1 : 0;
}

function hashCollection(collection) {
  if (collection.size === Infinity) {
    return 0;
  }
  var ordered = isOrdered(collection);
  var keyed = isKeyed(collection);
  var h = ordered ? 1 : 0;
  var size = collection.__iterate(
    keyed
      ? ordered
        ? function (v, k) {
            h = (31 * h + hashMerge(hash(v), hash(k))) | 0;
          }
        : function (v, k) {
            h = (h + hashMerge(hash(v), hash(k))) | 0;
          }
      : ordered
        ? function (v) {
            h = (31 * h + hash(v)) | 0;
          }
        : function (v) {
            h = (h + hash(v)) | 0;
          }
  );
  return murmurHashOfSize(size, h);
}

function murmurHashOfSize(size, h) {
  h = imul(h, 0xcc9e2d51);
  h = imul((h << 15) | (h >>> -15), 0x1b873593);
  h = imul((h << 13) | (h >>> -13), 5);
  h = ((h + 0xe6546b64) | 0) ^ size;
  h = imul(h ^ (h >>> 16), 0x85ebca6b);
  h = imul(h ^ (h >>> 13), 0xc2b2ae35);
  h = smi(h ^ (h >>> 16));
  return h;
}

function hashMerge(a, b) {
  return (a ^ (b + 0x9e3779b9 + (a << 6) + (a >> 2))) | 0; // int
}

var OrderedSet = (function (Set$$1) {
  function OrderedSet(value) {
    return value === null || value === undefined
      ? emptyOrderedSet()
      : isOrderedSet(value)
        ? value
        : emptyOrderedSet().withMutations(function (set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function (v) { return set.add(v); });
          });
  }

  if ( Set$$1 ) OrderedSet.__proto__ = Set$$1;
  OrderedSet.prototype = Object.create( Set$$1 && Set$$1.prototype );
  OrderedSet.prototype.constructor = OrderedSet;

  OrderedSet.of = function of (/*...values*/) {
    return this(arguments);
  };

  OrderedSet.fromKeys = function fromKeys (value) {
    return this(KeyedCollection(value).keySeq());
  };

  OrderedSet.prototype.toString = function toString () {
    return this.__toString('OrderedSet {', '}');
  };

  return OrderedSet;
}(Set));

function isOrderedSet(maybeOrderedSet) {
  return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}

OrderedSet.isOrderedSet = isOrderedSet;

var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;

OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;

function makeOrderedSet(map, ownerID) {
  var set = Object.create(OrderedSetPrototype);
  set.size = map ? map.size : 0;
  set._map = map;
  set.__ownerID = ownerID;
  return set;
}

var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
  return (
    EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()))
  );
}

var Record = function Record(defaultValues, name) {
  var hasInitialized;

  var RecordType = function Record(values) {
    var this$1 = this;

    if (values instanceof RecordType) {
      return values;
    }
    if (!(this instanceof RecordType)) {
      return new RecordType(values);
    }
    if (!hasInitialized) {
      hasInitialized = true;
      var keys = Object.keys(defaultValues);
      var indices = (RecordTypePrototype._indices = {});
      RecordTypePrototype._name = name;
      RecordTypePrototype._keys = keys;
      RecordTypePrototype._defaultValues = defaultValues;
      for (var i = 0; i < keys.length; i++) {
        var propName = keys[i];
        indices[propName] = i;
        if (RecordTypePrototype[propName]) {
          /* eslint-disable no-console */
          typeof console === 'object' &&
            console.warn &&
            console.warn(
              'Cannot define ' +
                recordName(this$1) +
                ' with property "' +
                propName +
                '" since that property name is part of the Record API.'
            );
          /* eslint-enable no-console */
        } else {
          setProp(RecordTypePrototype, propName);
        }
      }
    }
    this.__ownerID = undefined;
    this._values = List().withMutations(function (l) {
      l.setSize(this$1._keys.length);
      KeyedCollection(values).forEach(function (v, k) {
        l.set(this$1._indices[k], v === this$1._defaultValues[k] ? undefined : v);
      });
    });
  };

  var RecordTypePrototype = (RecordType.prototype = Object.create(
    RecordPrototype
  ));
  RecordTypePrototype.constructor = RecordType;

  return RecordType;
};

Record.prototype.toString = function toString () {
    var this$1 = this;

  var str = recordName(this) + ' { ';
  var keys = this._keys;
  var k;
  for (var i = 0, l = keys.length; i !== l; i++) {
    k = keys[i];
    str += (i ? ', ' : '') + k + ': ' + quoteString(this$1.get(k));
  }
  return str + ' }';
};

Record.prototype.equals = function equals (other) {
  return (
    this === other ||
    (other &&
      this._keys === other._keys &&
      recordSeq(this).equals(recordSeq(other)))
  );
};

Record.prototype.hashCode = function hashCode () {
  return recordSeq(this).hashCode();
};

// @pragma Access

Record.prototype.has = function has (k) {
  return this._indices.hasOwnProperty(k);
};

Record.prototype.get = function get (k, notSetValue) {
  if (!this.has(k)) {
    return notSetValue;
  }
  var index = this._indices[k];
  var value = this._values.get(index);
  return value === undefined ? this._defaultValues[k] : value;
};

// @pragma Modification

Record.prototype.set = function set (k, v) {
  if (this.has(k)) {
    var newValues = this._values.set(
      this._indices[k],
      v === this._defaultValues[k] ? undefined : v
    );
    if (newValues !== this._values && !this.__ownerID) {
      return makeRecord(this, newValues);
    }
  }
  return this;
};

Record.prototype.remove = function remove (k) {
  return this.set(k);
};

Record.prototype.clear = function clear () {
  var newValues = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : makeRecord(this, newValues);
};

Record.prototype.wasAltered = function wasAltered () {
  return this._values.wasAltered();
};

Record.prototype.toSeq = function toSeq () {
  return recordSeq(this);
};

Record.prototype.toJS = function toJS$1 () {
  return toJS(this);
};

Record.prototype.entries = function entries () {
  return this.__iterator(ITERATE_ENTRIES);
};

Record.prototype.__iterator = function __iterator (type, reverse) {
  return recordSeq(this).__iterator(type, reverse);
};

Record.prototype.__iterate = function __iterate (fn, reverse) {
  return recordSeq(this).__iterate(fn, reverse);
};

Record.prototype.__ensureOwner = function __ensureOwner (ownerID) {
  if (ownerID === this.__ownerID) {
    return this;
  }
  var newValues = this._values.__ensureOwner(ownerID);
  if (!ownerID) {
    this.__ownerID = ownerID;
    this._values = newValues;
    return this;
  }
  return makeRecord(this, newValues, ownerID);
};

Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SENTINEL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn$$1;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge;
RecordPrototype.mergeWith = mergeWith;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn$$1;
RecordPrototype.update = update$$1;
RecordPrototype.updateIn = updateIn$1;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject =
  CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
  return this.toString();
};

function makeRecord(likeRecord, values, ownerID) {
  var record = Object.create(Object.getPrototypeOf(likeRecord));
  record._values = values;
  record.__ownerID = ownerID;
  return record;
}

function recordName(record) {
  return record._name || record.constructor.name || 'Record';
}

function recordSeq(record) {
  return keyedSeqFromValue(record._keys.map(function (k) { return [k, record.get(k)]; }));
}

function setProp(prototype, name) {
  try {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  } catch (error) {
    // Object.defineProperty failed. Probably IE8.
  }
}

/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */
var Repeat = (function (IndexedSeq$$1) {
  function Repeat(value, times) {
    if (!(this instanceof Repeat)) {
      return new Repeat(value, times);
    }
    this._value = value;
    this.size = times === undefined ? Infinity : Math.max(0, times);
    if (this.size === 0) {
      if (EMPTY_REPEAT) {
        return EMPTY_REPEAT;
      }
      EMPTY_REPEAT = this;
    }
  }

  if ( IndexedSeq$$1 ) Repeat.__proto__ = IndexedSeq$$1;
  Repeat.prototype = Object.create( IndexedSeq$$1 && IndexedSeq$$1.prototype );
  Repeat.prototype.constructor = Repeat;

  Repeat.prototype.toString = function toString () {
    if (this.size === 0) {
      return 'Repeat []';
    }
    return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
  };

  Repeat.prototype.get = function get (index, notSetValue) {
    return this.has(index) ? this._value : notSetValue;
  };

  Repeat.prototype.includes = function includes (searchValue) {
    return is(this._value, searchValue);
  };

  Repeat.prototype.slice = function slice (begin, end) {
    var size = this.size;
    return wholeSlice(begin, end, size)
      ? this
      : new Repeat(
          this._value,
          resolveEnd(end, size) - resolveBegin(begin, size)
        );
  };

  Repeat.prototype.reverse = function reverse () {
    return this;
  };

  Repeat.prototype.indexOf = function indexOf (searchValue) {
    if (is(this._value, searchValue)) {
      return 0;
    }
    return -1;
  };

  Repeat.prototype.lastIndexOf = function lastIndexOf (searchValue) {
    if (is(this._value, searchValue)) {
      return this.size;
    }
    return -1;
  };

  Repeat.prototype.__iterate = function __iterate (fn, reverse) {
    var this$1 = this;

    var size = this.size;
    var i = 0;
    while (i !== size) {
      if (fn(this$1._value, reverse ? size - ++i : i++, this$1) === false) {
        break;
      }
    }
    return i;
  };

  Repeat.prototype.__iterator = function __iterator (type, reverse) {
    var this$1 = this;

    var size = this.size;
    var i = 0;
    return new Iterator(
      function () { return i === size
          ? iteratorDone()
          : iteratorValue(type, reverse ? size - ++i : i++, this$1._value); }
    );
  };

  Repeat.prototype.equals = function equals (other) {
    return other instanceof Repeat
      ? is(this._value, other._value)
      : deepEqual(other);
  };

  return Repeat;
}(IndexedSeq));

var EMPTY_REPEAT;

function fromJS(value, converter) {
  return fromJSWith(
    [],
    converter || defaultConverter,
    value,
    '',
    converter && converter.length > 2 ? [] : undefined,
    { '': value }
  );
}

function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
  var toSeq = Array.isArray(value)
    ? IndexedSeq
    : isPlainObj(value) ? KeyedSeq : null;
  if (toSeq) {
    if (~stack.indexOf(value)) {
      throw new TypeError('Cannot convert circular structure to Immutable');
    }
    stack.push(value);
    keyPath && key !== '' && keyPath.push(key);
    var converted = converter.call(
      parentValue,
      key,
      toSeq(value).map(function (v, k) { return fromJSWith(stack, converter, v, k, keyPath, value); }
      ),
      keyPath && keyPath.slice()
    );
    stack.pop();
    keyPath && keyPath.pop();
    return converted;
  }
  return value;
}

function defaultConverter(k, v) {
  return isKeyed(v) ? v.toMap() : v.toList();
}

var version = "4.0.0-rc.9";

// Functional read/write API
var Immutable = {
  version: version,

  Collection: Collection,
  // Note: Iterable is deprecated
  Iterable: Collection,

  Seq: Seq,
  Map: Map,
  OrderedMap: OrderedMap,
  List: List,
  Stack: Stack,
  Set: Set,
  OrderedSet: OrderedSet,

  Record: Record,
  Range: Range,
  Repeat: Repeat,

  is: is,
  fromJS: fromJS,
  hash: hash,

  isImmutable: isImmutable,
  isCollection: isCollection,
  isKeyed: isKeyed,
  isIndexed: isIndexed,
  isAssociative: isAssociative,
  isOrdered: isOrdered,
  isValueObject: isValueObject,

  get: get,
  getIn: getIn$1,
  has: has,
  hasIn: hasIn$1,
  merge: merge$1,
  mergeDeep: mergeDeep$1,
  mergeWith: mergeWith$1,
  mergeDeepWith: mergeDeepWith$1,
  remove: remove,
  removeIn: removeIn,
  set: set,
  setIn: setIn$1,
  update: update$1,
  updateIn: updateIn
};

// Note: Iterable is deprecated
var Iterable = Collection;


/* harmony default export */ __webpack_exports__["default"] = (Immutable);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('noop', __webpack_require__(364), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(1454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(1024),
    util = __webpack_require__(1026);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1334);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GROUP", function() { return GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deviceTypes", function() { return deviceTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deviceImages", function() { return deviceImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batteryMap", function() { return batteryMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wifiMap", function() { return wifiMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "settingTypes", function() { return settingTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "signalMap", function() { return signalMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "categories", function() { return categories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapCategoryToRemoveFunction", function() { return mapCategoryToRemoveFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectionTypes", function() { return connectionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heatingTypes", function() { return heatingTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "thermostatDeviceTypes", function() { return thermostatDeviceTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "powerSourceTypes", function() { return powerSourceTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "devicesWithModelVariations", function() { return devicesWithModelVariations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "regions", function() { return regions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hublessDeviceTypes", function() { return hublessDeviceTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fanModes", function() { return fanModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "circulateDurations", function() { return circulateDurations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gu10Models", function() { return gu10Models; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "candlelightModels", function() { return candlelightModels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bulbTypes", function() { return bulbTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bulbModes", function() { return bulbModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugTypes", function() { return plugTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deviceCaps", function() { return deviceCaps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deviceModes", function() { return deviceModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deviceModels", function() { return deviceModels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deviceErrors", function() { return deviceErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deviceCapabilities", function() { return deviceCapabilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deviceControlModes", function() { return deviceControlModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deviceHumidityModes", function() { return deviceHumidityModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pmzStatusTypes", function() { return pmzStatusTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "manufacturers", function() { return manufacturers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capabilities", function() { return capabilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hubOperationModes", function() { return hubOperationModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removableDevicesByManufacturers", function() { return removableDevicesByManufacturers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hubModelTypes", function() { return hubModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiverModelTypes", function() { return receiverModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "thermostatModelTypes", function() { return thermostatModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "thermostatsWithReceivers", function() { return thermostatsWithReceivers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "motionSensorPrefixModelTypes", function() { return motionSensorPrefixModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contactSensorPrefixModelTypes", function() { return contactSensorPrefixModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plugModelTypes", function() { return plugModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "signalBoosterModelTypes", function() { return signalBoosterModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gu10DimmableModelTypes", function() { return gu10DimmableModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gu10TuneableModelTypes", function() { return gu10TuneableModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "candlelightDimmableModelTypes", function() { return candlelightDimmableModelTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "candlelightTuneableModelTypes", function() { return candlelightTuneableModelTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__icons_general_svg__ = __webpack_require__(20);
var GROUP='group';var deviceTypes={ACTIVE_PLUG:'activeplug',BOILER_MODULE:'boilermodule',BULB:'bulb',COLOR_TUNEABLE_LIGHT:'colourtuneablelight',COLOR_LIGHT:'colourlight',CONTACT_SENSOR:'contactsensor',HEATING:'heating',HIVE_BUTTON:'hivebutton',HIVE_CAMERA:'hivecamera',HOT_WATER:'hotwater',HUB:'hub',HUE_BRIDGE:'philipshuebridge',LEAK_SENSOR:'leakdetector',MOTION_SENSOR:'motionsensor',NA_THERMOSTAT:'nathermostat',PRODUCT_GROUP:'productgroup',SENSE:'sense',SIGNAL_BOOSTER:'signalbooster',SMART_PLUG:'smartplug',THERMOSTAT_UI:'thermostatui',TUNEABLE_LIGHT:'tuneablelight',WARM_WHITE_LIGHT:'warmwhitelight',THERMOSTAT:'thermostat'};var deviceImages=new Map([[deviceTypes.ACTIVE_PLUG,'default'],[deviceTypes.BOILER_MODULE,'receiver'],[deviceTypes.BULB,'white-light'],[deviceTypes.COLOR_TUNEABLE_LIGHT,'colour-light'],[deviceTypes.COLOR_LIGHT,'colour-light'],[deviceTypes.CONTACT_SENSOR,'contact-sensor'],[deviceTypes.HEATING,'default'],[deviceTypes.HOT_WATER,'default'],[deviceTypes.HUB,'hub'],[deviceTypes.LEAK_SENSOR,'leak'],[deviceTypes.MOTION_SENSOR,'motion-sensor'],[deviceTypes.NA_THERMOSTAT,'default'],[deviceTypes.SENSE,'sense'],[deviceTypes.SIGNAL_BOOSTER,'signal-booster'],[deviceTypes.SMART_PLUG,'default'],[deviceTypes.THERMOSTAT_UI,'default'],[deviceTypes.TUNEABLE_LIGHT,'tuneable-light'],[deviceTypes.WARM_WHITE_LIGHT,'white-light'],[deviceTypes.THERMOSTAT,'default'],[deviceTypes.HUE_BRIDGE,'hue-bridge'],[deviceTypes.HIVE_BUTTON,'button'],[deviceTypes.HIVE_CAMERA,'camera'],[GROUP,'group']]);var batteryMap=new Map([[0,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].BATTERY_EMPTY],[1,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].BATTERY_LOW],[2,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].BATTERY_LOW],[3,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].BATTERY_NORMAL],[4,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].BATTERY_NORMAL],[5,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].BATTERY_FULL]]);var wifiMap=new Map([[0,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].WIFI_0_BARS],[1,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].WIFI_1_BARS],[2,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].WIFI_2_BARS],[3,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].WIFI_3_BARS]]);var settingTypes={DELETE:'DELETE',DELETE_HUE:'DELETE_HUE',HOLIDAY_MODE:'HOLIDAY_MODE',INFORMATION:'INFORMATION',NOTIFICATIONS:'NOTIFICATIONS',PARTNER_INFO:'PARTNER_INFO',PRIVACY_SETTINGS:'PRIVACY_SETTINGS',REBOOT_HUB:'REBOOT_HUB',RENAME:'RENAME',EDIT_GROUP:'EDIT_GROUP',DELETE_GROUP:'DELETE_GROUP',OPTIMUM_START:'OPTIMUM_START',// Annoyingly have to name this to Optimum Start becuase of platform, but this should be referred to as Ready By in all future code
// Camera specific settings
CAMERA_VIDEO:'CAMERA_VIDEO',CAMERA_DETECTION:'CAMERA_DETECTION',CAMERA_DEVICE:'CAMERA_DEVICE',CHANGE_WIFI:'CHANGE_WIFI'};var signalMap=new Map([[0,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].LINK_BROKEN],[1,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].SIGNAL_1_BARS],[2,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].SIGNAL_2_BARS],[3,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].SIGNAL_3_BARS],[4,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].SIGNAL_4_BARS],[5,__WEBPACK_IMPORTED_MODULE_0__icons_general_svg__["a" /* default */].SIGNAL_4_BARS]]);var categories={HUE:'HUE',ZONE:'ZONE',DEVICE:'DEVICE'};// $FlowFixMe
var mapCategoryToRemoveFunction=function mapCategoryToRemoveFunction(category,deviceHandler,zoneHandler,hueHandler){var functionMap=new Map([[category===categories.ZONE,zoneHandler],[category===categories.DEVICE,deviceHandler],[category===categories.HUE,hueHandler]]);return functionMap.get(true);};var connectionTypes={WIFI:'wifi',WIRED:'wired'};var heatingTypes=[deviceTypes.THERMOSTAT_UI,deviceTypes.HEATING,deviceTypes.HOT_WATER,deviceTypes.NA_THERMOSTAT];var thermostatDeviceTypes=[deviceTypes.THERMOSTAT_UI,deviceTypes.NA_THERMOSTAT,deviceTypes.THERMOSTAT];var powerSourceTypes={MAINS:'mains',BATTERY:'battery'};var devicesWithModelVariations=[deviceTypes.BOILER_MODULE,deviceTypes.HUB,deviceTypes.THERMOSTAT,deviceTypes.THERMOSTAT_UI,deviceTypes.ACTIVE_PLUG];var regions={EU:'EU',IN:'IN',NA:'NA',UK:'UK'};var hublessDeviceTypes=[deviceTypes.LEAK_SENSOR,deviceTypes.HIVE_CAMERA];var fanModes={AUTO:'AUTO',CIRCULATE:'CIRCULATE',ALWAYS:'MANUAL'};var circulateDurations={FIFTEEN:'15',THIRTY:'30',FORTYFIVE:'45'};var gu10Models={FWBULB01UK:'FWBulb01UK',FWGU10BULBUK:'FWGU10BulbUK',FWGU10BULB01UK:'FWGU10Bulb01UK',TWGU10BULB01UK:'TWGU10Bulb01UK'};var candlelightModels={FWCLBulb01UK:'FWCLBulb01UK',TWCLBulb01UK:'TWCLBulb01UK'};var bulbTypes=[deviceTypes.COLOR_LIGHT,deviceTypes.COLOR_TUNEABLE_LIGHT,deviceTypes.TUNEABLE_LIGHT,deviceTypes.WARM_WHITE_LIGHT];var bulbModes={colour:'COLOUR',white:'WHITE'};var plugTypes=[deviceTypes.ACTIVE_PLUG,deviceTypes.SMART_PLUG];var deviceCaps={HIVE2_UPGRADE:'HIVE2_UPGRADE',SLT3B_REPLACEMENT:'SLT3B_REPLACEMENT'};var deviceModes={BOOST:'BOOST',MANUAL:'MANUAL',OFF:'OFF',ON:'ON',SCHEDULE:'SCHEDULE',HOLD:'HOLD',EMERGENCY_HEAT:'EMERGENCY_HEAT',MIMIC:'MIMIC'};var deviceModels={ALB1:'ALB1',CS1:'CS1',MS1:'MS1',NANO1:'NANO1',NANO2:'NANO2',SENSE:'SENSE',SLB1:'SLB1',SLB2:'SLB2',SLB3:'SLB3',SLP2:'SLP2',SLP2b:'SLP2b',SLP2c:'SLP2c',SLP2d:'SLP2d',SLR1:'SLR1',SLR2:'SLR2',SLT1:'SLT1',SLT2:'SLT2',SLT3:'SLT3',SLT3b:'SLT3b',// this device is a replacement for broken SLT3s
SLT4:'SLT4',SPG1:'SPG1'};var deviceErrors={FIRMWARE_UPDATE_REQUIRED:'FIRMWARE_UPDATE_REQUIRED',WRONG_PRODUCT_FOUND:'WRONG_PRODUCT_FOUND',MALFORMED_NODE_DESCRIPTOR:'MALFORMED_NODE_DESCRIPTOR'};var deviceCapabilities={FAN:'fan',DUAL:'dual',HUMIDITY:'humidity',HUMIDITY_READ:'humidity-read',HEAT:'heat',COOL:'cool',EMERGENCY_HEAT:'emergency-heat'};var deviceControlModes={HEAT:'HEAT',COOL:'COOL',AUTO:'AUTO',OFF:'OFF'};var deviceHumidityModes={UNKNOWN:'UNKNOWN',HUMIDIFIER:'HUMIDIFIER',DEHUMIDIFIER:'DEHUMIDIFIER'};var pmzStatusTypes={OK:'OK',PMZ_WRONG_PRODUCT:'PMZ_WRONG_PRODUCT',PMZ_FIRMWARE:'PMZ_FIRMWARE'};var manufacturers={PHILIPS:'Philips'};var capabilities={ACTIONS_2:'ACTIONS_2',BOOST:'BOOST',EMERGENCY_HEAT:'EMERGENCY_HEAT',HOLIDAY_MODE:'HOLIDAY_MODE',INSTALL_PHILIPS_HUE:'INSTALL_PHILIPS_HUE',LIGHT_COLOUR:'LIGHT_COLOUR',LIGHT_TUNEABLE:'LIGHT_TUNEABLE',LIGHT_WHITE:'LIGHT_WHITE',MIGRATE_NANO1:'MIGRATE_NANO1',MIMIC_MODE:'MIMIC_MODE',SCHEDULE:'SCHEDULE',PRODUCT_GROUP:'PRODUCT_GROUP',IDENTIFY_DEVICE:'IDENTIFY_DEVICE'};var hubOperationModes={FAILURE:'FAILURE',MIGRATING:'MIGRATING'};var removableDevicesByManufacturers=[manufacturers.PHILIPS];var hubModelTypes=[deviceModels.NANO1,deviceModels.NANO2,deviceModels.SENSE];var receiverModelTypes=[deviceModels.SLR1,deviceModels.SLR2];var thermostatModelTypes=[deviceModels.SLT1,deviceModels.SLT2,deviceModels.SLT3,deviceModels.SLT3b,deviceModels.SLT4];var thermostatsWithReceivers=[deviceModels.SLT2,deviceModels.SLT3,deviceModels.SLT3b];var motionSensorPrefixModelTypes=['PIR','MOT'];var contactSensorPrefixModelTypes=['WDS','DWS'];var plugModelTypes=[deviceModels.SLP2b,deviceModels.SLP2c,deviceModels.SLP2d,deviceModels.SLP2];var signalBoosterModelTypes=[deviceModels.SLB1,deviceModels.SLB2,deviceModels.SLB3];var gu10DimmableModelTypes=[gu10Models.FWBULB01UK,gu10Models.FWGU10BULBUK,gu10Models.FWGU10BULB01UK];var gu10TuneableModelTypes=[gu10Models.TWGU10BULB01UK];var candlelightDimmableModelTypes=[candlelightModels.FWCLBulb01UK];var candlelightTuneableModelTypes=[candlelightModels.TWCLBulb01UK];

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* unused harmony reexport spawn */
/* unused harmony reexport join */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["l"]; });
/* unused harmony reexport throttle */


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLoadingLocaleConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getConfigBound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFeatureFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getIconLocaleSuffix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLocales; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(68);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var getConfigState=function getConfigState(state){return state.config||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});};// $FlowFixMe
var getLoadingLocaleConfig=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getConfigState],function(config){return config.get('loadingCountryConfig');});var getMergedConfig=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getConfigState],function(config){return(// $FlowFixMe
config.get('mergedConfig',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({features:{}})));});var getConfig=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getMergedConfig,function(_,key){return key;}],function(config,key){if(!key){return config;}if(typeof key!=='string'){throw new Error('getConfig key parameter must be a string, received '+(typeof key==='undefined'?'undefined':_typeof(key)));}return config.getIn(key.split(':'));});var getConfigBound=Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["a" /* bindable */])(getConfig);var combineKey=function combineKey(_,key){return'features:'+key;};var getFeatureFlag=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["g" /* stateIdentity */],combineKey,getConfig);var getIconLocaleSuffix=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getMergedConfig],function(config){return config.get('iconLocaleSuffix');});// $FlowFixMe
var getLocales=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getConfigState,function(config){return config.get('locales');});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAllProducts; });
/* unused harmony export getProductsErrorStatus */
/* unused harmony export getProductsIsFetchingStatus */
/* unused harmony export getProductsLoadedStatus */
/* unused harmony export getProductId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getProductItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getProductItemsExcludingGroups; });
/* unused harmony export getGroups */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return doesProductExist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getProductsLoadedAt; });
/* unused harmony export allProductsByTypeSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return allProductsIncludingOfflineByTypeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return allProductsByTypeSelectorFactory; });
/* unused harmony export productByIdSelector */
/* unused harmony export productByIdSelectorFactory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getProductItemById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getIsGroupForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return makeGetProductItemById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getModeForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getNameForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getStateForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getTypeForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getPropsForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getPreviousConfigForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getProductCapabilities; });
/* unused harmony export productItemPropSelectorFactory */
/* unused harmony export firstHolidaymodeProduct */
/* unused harmony export firstProductTypeSelectorFactory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getProductsByZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getHubProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getHublessProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return hasParentHub; });
/* unused harmony export hasSLT1Thermostat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getProductsByTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return hasMultipleZones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getSameZoneScheduleByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getProductsByParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getIdFromParentByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getPowerConsumptionForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getOnSinceForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getProductError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getWhetherProductHasCapability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return doesAnyProductHaveCapability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getProductsWithParentCapability; });
/* unused harmony export productItemStatePropSelectorFactory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getHasWiringError; });
/* unused harmony export productModeSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["x"] = getProductIndexById;
/* unused harmony export getProductIndexByZoneId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getHasHeating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getIsProductHeatingOrHotWater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFirstHeatingProductId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getStatusForProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getProductTypesUserOwns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getIsHueProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getIsInGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFirstScheduledEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_some__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_pluck__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_pluck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_pluck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_uniq__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectors__ = __webpack_require__(68);
var getAllProducts=function getAllProducts(state){return state.products;};var getProductsErrorStatus=function getProductsErrorStatus(state){return state.products.hasError;};var getProductsIsFetchingStatus=function getProductsIsFetchingStatus(state){return state.products.isFetching;};var getProductsLoadedStatus=function getProductsLoadedStatus(state){return state.products.isLoaded;};var getProductId=function getProductId(product){return product.get('id');};var getProductItems=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getAllProducts,function(products){return products.productItems||Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])();});var getProductItemsExcludingGroups=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,function(productItems){return productItems.filterNot(function(p){return p.get('isGroup');});});var getGroups=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,function(productItems){return productItems.filter(function(p){return p.get('isGroup');});});var doesProductExist=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems,__WEBPACK_IMPORTED_MODULE_8__selectors__["c" /* getIdFromProps */]],function(productItems,id){return productItems.some(function(product){return product.get('id')===id;});});var getProductsLoadedAt=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getAllProducts,function(products){return products.loadedAt;});var allProductsByTypeSelector=function allProductsByTypeSelector(types,products){var normalisedTypes=Array.isArray(types)?types:[types];var items=products.filter(function(x){return normalisedTypes.includes(x.get('type'))&&x.getIn(['props','online']);});return items;};var allProductsIncludingOfflineByTypeSelector=function allProductsIncludingOfflineByTypeSelector(types,products){var normalisedTypes=Array.isArray(types)?types:[types];return products.filter(function(x){return normalisedTypes.includes(x.get('type'));});};var allProductsByTypeSelectorFactory=function allProductsByTypeSelectorFactory(typeNames){return Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems],function(productItems){return allProductsByTypeSelector(typeNames,productItems);});};var productByIdSelector=function productByIdSelector(id,products){return products.find(function(x){return x.get('id')===id;});};// Depricated in favor of getProductItemById
// Will replace all usages in another PR
var productByIdSelectorFactory=function productByIdSelectorFactory(id){return Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems],function(productItems){return productByIdSelector(id,productItems);});};var getProductItemById=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,__WEBPACK_IMPORTED_MODULE_8__selectors__["c" /* getIdFromProps */],function(productItems,id){return productItems.find(function(prod){return prod.get('id')===id;});});var getIsGroupForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(product){return product&&product.get('isGroup');});var makeGetProductItemById=function makeGetProductItemById(){return Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,__WEBPACK_IMPORTED_MODULE_8__selectors__["c" /* getIdFromProps */],function(productItems,id){return productItems.find(function(prod){return prod.get('id')===id;},null,Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])());});};var getModeForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(productItem){return productItem&&productItem.getIn(['state','mode']);});var getNameForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(productItem){return productItem&&productItem.getIn(['state','name']);});var getStateForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(productItem){return productItem&&productItem.get('state');});var getTypeForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(){var product=arguments.length>0&&arguments[0]!==undefined?arguments[0]:new __WEBPACK_IMPORTED_MODULE_4_immutable__["Map"]();return product.get('isGroup')?__WEBPACK_IMPORTED_MODULE_7__constants_devices__["deviceTypes"].PRODUCT_GROUP:product.get('type');});var getPropsForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(product){return product&&product.get('props',Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({}));});var getPreviousConfigForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(product){return product&&product.getIn(['props','previous']);});var getProductCapabilities=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(product){return product&&product.getIn(['props','capabilities'],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])([]));});var productItemPropSelectorFactory=function productItemPropSelectorFactory(id,prop){return Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([productByIdSelectorFactory(id)],function(product){return product&&product.getIn(['props',prop]);});};var firstHolidaymodeProduct=function firstHolidaymodeProduct(state){return state.products&&state.products.productItems&&state.products.productItems.size>0?state.products.productItems.find(function(prod){return prod.getIn(['props','holidayMode','enabled'])===true;})||Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({}):Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({});};var firstProductTypeSelectorFactory=function firstProductTypeSelectorFactory(type){return Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([allProductsByTypeSelectorFactory(type)],function(products){return products.first();});};var getZoneFromProps=function getZoneFromProps(_,props){return props&&props.zone||'';};var getTypeFromProps=function getTypeFromProps(_,props){return props&&props.type||'';};var getParentFromProps=function getParentFromProps(_,props){return props&&props.parent||'';};var getProductsByZone=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems,getZoneFromProps],function(products,zone){return products.filter(function(product){return product.getIn(['props','zone'])===zone;})||Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({});});var getHubProducts=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,function(products){return products.filter(function(p){return!__WEBPACK_IMPORTED_MODULE_7__constants_devices__["hublessDeviceTypes"].includes(p.get('type'));});});var getHublessProducts=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,function(products){return products.filter(function(p){return __WEBPACK_IMPORTED_MODULE_7__constants_devices__["hublessDeviceTypes"].includes(p.get('type'));});});var hasParentHub=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItemById,__WEBPACK_IMPORTED_MODULE_6__devices_selectors__["F" /* getHub */]],function(product,hub){return product&&hub&&product.get('parent')===hub.id;});var hasSLT1Thermostat=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,function(products){return products.some(function(p){return p.getIn(['props','model'])===__WEBPACK_IMPORTED_MODULE_7__constants_devices__["deviceModels"].SLT1;});});var getProductsByTypeList=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems,function(_,props){return props&&props.types||[];}],function(products,types){return products.filter(function(p){return types.includes(p.get('type'));});});var hasMultipleZones=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,function(products){return products.filter(function(product){return product.get('type')==='heating';}).size>1;});var getSameZoneProductByType=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductsByZone,getTypeFromProps],function(products,type){return(// $FlowFixMe
products.filter(function(z){return z.get('type')===type;}).getIn([0],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({})));});var getSameZoneScheduleByType=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getSameZoneProductByType,function(product){return product.getIn(['state','schedule']);});var getProductsByParent=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems,getParentFromProps],function(products,parent){return products.filter(function(p){return p.get('parent')===parent;})||Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])([]);});var getIdFromParentByType=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductsByParent,getTypeFromProps],function(products,type){return(// $FlowFixMe
products.filter(function(p){return p.get('type')===type;}).get(0,Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({})).get('id',undefined));});var getPowerConsumptionForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(product){return product&&product.getIn(['props','powerConsumption']);});var getOnSinceForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(product){return product&&product.getIn(['props','onSince']);});var getProductError=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(product){return product.getIn(['error']);});var getCapabilityFromProps=function getCapabilityFromProps(_,props){return props&&props.capability||'';};var getWhetherProductHasCapability=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItemById,getCapabilityFromProps],function(product,capability){return product.getIn(['props','capabilities'],[]).includes(capability);});var doesAnyProductHaveCapability=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems,getCapabilityFromProps],function(products,capability){return!!products.filter(function(p){return p.getIn(['props','capabilities'],[]).includes(capability);}).size;});var getProductsWithParentCapability=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems,__WEBPACK_IMPORTED_MODULE_8__selectors__["g" /* stateIdentity */],__WEBPACK_IMPORTED_MODULE_8__selectors__["b" /* getCapabilityNameFromProps */]],function(products,state,capabilityName){return products.filter(function(p){return Object(__WEBPACK_IMPORTED_MODULE_6__devices_selectors__["U" /* getParentHasCapability */])(state,{id:p.get('id'),capabilityName:capabilityName});});});// productItem functions
var productItemStatePropSelectorFactory=function productItemStatePropSelectorFactory(id,propName){return Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([productByIdSelectorFactory(id)],function(product){return product.getIn(['state',propName]);});};var getHasWiringError=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(product){return!!product.get('error');});var productModeSelectorFactory=function productModeSelectorFactory(id){return productItemStatePropSelectorFactory(id,'mode');};function getProductIndexById(products,id){return products.productItems.findIndex(function(x){return x.get('id')===id;});}function getProductIndexByZoneId(products,id){return products.productItems.findIndex(function(x){return x.getIn(['props','zone'])===id;});}var getHasHeating=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,function(products){return products.some(function(p){return[__WEBPACK_IMPORTED_MODULE_7__constants_devices__["deviceTypes"].HEATING,__WEBPACK_IMPORTED_MODULE_7__constants_devices__["deviceTypes"].NA_THERMOSTAT].includes(p.get('type'));});});var getIsProductHeatingOrHotWater=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems,getProductItemById],function(products,product){return!!product&&products.some(function(p){return[__WEBPACK_IMPORTED_MODULE_7__constants_devices__["deviceTypes"].HEATING,__WEBPACK_IMPORTED_MODULE_7__constants_devices__["deviceTypes"].HOT_WATER].includes(product.get('type'));});});var getFirstHeatingProductId=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItems,function(products){var prod=products.find(function(p){return[__WEBPACK_IMPORTED_MODULE_7__constants_devices__["deviceTypes"].HEATING,__WEBPACK_IMPORTED_MODULE_7__constants_devices__["deviceTypes"].NA_THERMOSTAT].includes(p.get('type'));});return prod&&prod.get('id');});var getStatusForProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(productItem){return productItem&&productItem.getIn(['state','status']);});var getProductTypesUserOwns=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getProductItems],function(products){return __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_uniq___default.a,__WEBPACK_IMPORTED_MODULE_1_lodash_fp_pluck___default()('type'))(products.toJS());});var getIsHueProduct=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(){var product=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])();return product.getIn(['props','manufacturer'])===__WEBPACK_IMPORTED_MODULE_7__constants_devices__["manufacturers"].PHILIPS;});var getIsInGroups=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(productItem){return productItem&&__WEBPACK_IMPORTED_MODULE_0_lodash_fp_some___default()(productItem.get('inGroups'));});var getFirstScheduledEvent=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getProductItemById,function(product){return product&&product.getIn(['state','schedule','monday',0]);});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(fnSuccess,fnErr){return function(state,action){return(action&&action.error?fnErr||function(s,a){return s;}:fnSuccess)(state,action);};});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__application_selectors__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toResult__ = __webpack_require__(452);
// @noflow
var statusEffectsMap={401:function _(){return[/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var isLoggedIn;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_2__application_selectors__["f" /* getIsLoggedIn */]);case 2:isLoggedIn=_context.sent;if(!isLoggedIn){_context.next=6;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__application_actions__["k" /* logOut */])());case 6:case'end':return _context.stop();}}},_callee,this);})];}};function handleApi(fn){return Object(__WEBPACK_IMPORTED_MODULE_4__toResult__["a" /* default */])(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function handleApiGenerator(){for(var _len=arguments.length,params=Array(_len),_key=0;_key<_len;_key++){params[_key]=arguments[_key];}var result,effects,body,message,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleApiGenerator$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */].apply(undefined,[fn].concat(params));case 2:result=_context3.sent;if(result){_context3.next=5;break;}return _context3.abrupt('return');case 5:effects=statusEffectsMap[result.status];if(!effects){_context3.next=9;break;}_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])(effects.apply(undefined,[result].concat(params)).map(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(effect){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return effect();case 2:case'end':return _context2.stop();}}},_callee2,this);})));case 9:body=void 0;_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(function(){return result.text();});case 12:body=_context3.sent;body=body.length?JSON.parse(body):{};if(!(result.status>=200&&result.status<=299)){_context3.next=18;break;}return _context3.abrupt('return',body);case 18:message=typeof result==='string'&&result;error=new Error(message);error.status=body&&(body.error||body.errors);error.code=result.status;throw error;case 23:case'end':return _context3.stop();}}},handleApiGenerator,this);}));}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(noop);// @noflow
// eslint-disable-next-line require-yield
function noop(_ref){var payload=_ref.payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function noop$(_context){while(1){switch(_context.prev=_context.next){case 0:if(false){window.console.warn('A saga recieved an unhandle error in its action payload. Did you mean to leave this unhandled? \n',payload);}case 1:case'end':return _context.stop();}}},_marked,this);}function handleSaga(fnSuccess){var fnError=arguments.length>1&&arguments[1]!==undefined?arguments[1]:noop;return(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:return _context2.delegateYield(action.error?fnError(action):fnSuccess(action),'t0',1);case 1:case'end':return _context2.stop();}}},_callee,this);}));}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file will replace the `general.js` once we get rid of the devices font icons
var generalIcons={ACTIONS:'ACTIONS',ADD_DEVICES:'ADD_DEVICES',ARROW_DOWN:'ARROW_DOWN',ARROW_LEFT:'ARROW_LEFT',ARROW_LEFT_SHAFT:'ARROW_LEFT_SHAFT',ARROW_RIGHT:'ARROW_RIGHT',ARROW_RIGHT_DOUBLE:'ARROW_RIGHT_DOUBLE',ARROW_UP:'ARROW_UP',BATTERY_EMPTY:'BATTERY_EMPTY',BATTERY_FULL:'BATTERY_FULL',BATTERY_LOW:'BATTERY_LOW',BATTERY_NORMAL:'BATTERY_NORMAL',BOOST:'BOOST',BORD_GAIS_LOGO:'BORD_GAIS_LOGO',CALL:'CALL',CIRCLE_FILLED:'CIRCLE_FILLED',CIRCLE_OUTLINE:'CIRCLE_OUTLINE',CLOSE:'CLOSE',CLOSE_HEAVY:'CLOSE_HEAVY',COLOR_PALETE:'COLOR_PALETE',COLOR_PICKER:'COLOR_PICKER',COMFORT:'COMFORT',CONNECTED:'CONNECTED',CONTROL_PAGE:'CONTROL_PAGE',COPY:'COPY',CREATE:'CREATE',CREATE_PLUS:'CREATE_PLUS',DASHBOARD:'DASHBOARD',DEMO:'DEMO',DIMMER:'DIMMER',DISCOVER:'DISCOVER',DOG_BARK:'DOG_BARK',DOWNLOAD:'DOWNLOAD',EDIT:'EDIT',EFFICIENCY:'EFFICIENCY',EXCLAMATION:'EXCLAMATION',FROST_PROTECTION:'FROST_PROTECTION',GLASS_BREAK:'GLASS_BREAK',GRAPHS:'GRAPHS',GROUP_CONTROL:'GROUP_CONTROL',HEATING_PAGE:'HEATING_PAGE',HELP:'HELP',HIVE_ICON:'HIVE_ICON',HOLIDAYS:'HOLIDAYS',HOME:'HOME',HOT_WATER:'HOT_WATER',INCORRECT_SOUND:'INCORRECT_SOUND',INFO:'INFO',INSTALL_DEVICE:'INSTALL_DEVICE',LINK:'LINK',LINK_BROKEN:'LINK_BROKEN',LIST_DEVICE_MENU:'LIST_DEVICE_MENU',LOCK_CLOSED:'LOCK_CLOSED',LOGOUT:'LOGOUT',MANAGE_DEVICE:'MANAGE_DEVICE',MENU:'MENU',MICROPHONE_OFF:'MICROPHONE_OFF',MICROPHONE_ON:'MICROPHONE_ON',MIMIC:'MIMIC',MINUS:'MINUS',MONITOR_SENSE:'MONITOR_SENSE',MONITORING_OFF:'MONITORING_OFF',MONITORING_ON:'MONITORING_ON',MOODS:'MOODS',MORE:'MORE',MORE_VERTICAL:'MORE_VERTICAL',MULTI_PROFILE:'MULTI_PROFILE',NOTIFICATIONS:'NOTIFICATIONS',NOTIFICATIONS_OFF:'NOTIFICATIONS_OFF',OVERFLOW:'OVERFLOW',PAUSE:'PAUSE',PAUSE_SIMPLE:'PAUSE_SIMPLE',PLAY:'PLAY',PLAY_SIMPLE:'PLAY_SIMPLE',PLUS:'PLUS',QUESTION:'QUESTION',REASSURANCE:'REASSURANCE',RECIPES:'RECIPES',RESET_RELOAD:'RESET_RELOAD',SCHEDULE:'SCHEDULE',SEARCH:'SEARCH',SETTINGS:'SETTINGS',SHOP:'SHOP',SIGNAL_1_BARS:'SIGNAL_1_BARS',SIGNAL_2_BARS:'SIGNAL_2_BARS',SIGNAL_3_BARS:'SIGNAL_3_BARS',SIGNAL_4_BARS:'SIGNAL_4_BARS',SMOKE_CO:'SMOKE_CO',SMOKE_CO2:'SMOKE_CO2',SOUND_CAM:'SOUND_CAM',SOUND_OFF:'SOUND_OFF',SOUND_ON:'SOUND_ON',STOP:'STOP',STOP_SIMPLE:'STOP_SIMPLE',TICK_ONE:'TICK_ONE',TICK_SIMPLE:'TICK_SIMPLE',TONE:'TONE',TRASH:'TRASH',USER_PROFILE:'USER_PROFILE',WELCOME_HOME:'WELCOME_HOME',WIFI:'WIFI',WIFI_0_BARS:'WIFI_0_BARS',WIFI_1_BARS:'WIFI_1_BARS',WIFI_2_BARS:'WIFI_2_BARS',WIFI_3_BARS:'WIFI_3_BARS',WIFI_OFF:'WIFI_OFF'};/* harmony default export */ __webpack_exports__["a"] = (generalIcons);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('flowRight', __webpack_require__(1514));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_components__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(1985);
var Svg=__WEBPACK_IMPORTED_MODULE_2__svg_components__["a" /* default */].Svg;var SVGIcon=function SVGIcon(_ref){var color=_ref.color,className=_ref.className,type=_ref.type,style=_ref.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{className:className,height:'100%',style:style,viewBox:'0 0 40 40',width:'100%'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__style__["a" /* IconStyle */],{color:color},Object(__WEBPACK_IMPORTED_MODULE_1__map__["a" /* default */])(type,{svgComponents:__WEBPACK_IMPORTED_MODULE_2__svg_components__["a" /* default */]})));};/* harmony default export */ __webpack_exports__["a"] = (SVGIcon);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1493);
moment.tz.load(__webpack_require__(1494));


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(511);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__alerts__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__application__ = __webpack_require__(856);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__application__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__days__ = __webpack_require__(437);
/* unused harmony reexport days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__devices__ = __webpack_require__(12);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__devices__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__errors__ = __webpack_require__(263);
/* unused harmony reexport errors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__feedback__ = __webpack_require__(1498);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__feedback__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__heating__ = __webpack_require__(981);
/* unused harmony reexport heating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__holidayMode__ = __webpack_require__(1499);
/* unused harmony reexport holidayMode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__menu__ = __webpack_require__(523);
/* unused harmony reexport menu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__periods__ = __webpack_require__(351);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9__periods__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__products__ = __webpack_require__(982);
/* unused harmony reexport products */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__products_sense__ = __webpack_require__(524);
/* unused harmony reexport productsSense */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__schedule__ = __webpack_require__(80);
/* unused harmony reexport schedule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__redux_request__ = __webpack_require__(1500);
/* unused harmony reexport reduxRequest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__routes__ = __webpack_require__(124);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_14__routes__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__strings__ = __webpack_require__(983);
/* unused harmony reexport strings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__text_control__ = __webpack_require__(1501);
/* unused harmony reexport textControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__time_units__ = __webpack_require__(315);
/* unused harmony reexport timeUnits */


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accordion_accordion_component__ = __webpack_require__(2048);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__accordion_accordion_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(518);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__actions__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alert__ = __webpack_require__(2189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boost__ = __webpack_require__(2191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__boost__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__boost_rings__ = __webpack_require__(2199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_4__boost_rings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bounce_effect__ = __webpack_require__(498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__bounce_effect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__calendar_calendar_component__ = __webpack_require__(2202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__calendar_calendar_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cookie_policy__ = __webpack_require__(741);
/* unused harmony reexport CookiePolicyAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__day_selector__ = __webpack_require__(864);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_8__day_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__checkbox_checkbox_component__ = __webpack_require__(2212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_9__checkbox_checkbox_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_menu__ = __webpack_require__(865);
/* unused harmony reexport ContextMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__delay_css__ = __webpack_require__(2215);
/* unused harmony reexport DelayCSS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__device_info_panel__ = __webpack_require__(2216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_12__device_info_panel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__device_list__ = __webpack_require__(2265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_13__device_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__device_offline__ = __webpack_require__(2276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_14__device_offline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dropdown__ = __webpack_require__(501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_15__dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__flipper___ = __webpack_require__(358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_16__flipper___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hub_clock__ = __webpack_require__(2289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_17__hub_clock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__icon_menu__ = __webpack_require__(1008);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_18__icon_menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__input__ = __webpack_require__(516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_19__input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__link__ = __webpack_require__(1009);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_20__link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__load_transition__ = __webpack_require__(2294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_21__load_transition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__logs_timeline__ = __webpack_require__(2298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_22__logs_timeline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modal__ = __webpack_require__(337);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_23__modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mode_selector_block__ = __webpack_require__(1010);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_24__mode_selector_block__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__mode_selector_slide__ = __webpack_require__(2330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_25__mode_selector_slide__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__mode_selector_switch__ = __webpack_require__(2335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_26__mode_selector_switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__new_website_popup__ = __webpack_require__(2337);
/* unused harmony reexport NewWebsiteAlert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__phone_number__ = __webpack_require__(2343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_28__phone_number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pin_input_pin_input_component__ = __webpack_require__(2345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_29__pin_input_pin_input_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pin_input_group_pin_input_group_component__ = __webpack_require__(2347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_30__pin_input_group_pin_input_group_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__prevent_back_gesture__ = __webpack_require__(2352);
/* unused harmony reexport PreventBackGesture */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__primary_btn_primary_btn_component__ = __webpack_require__(2353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_32__primary_btn_primary_btn_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__range_slider__ = __webpack_require__(2355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_33__range_slider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__recipes_recipes_list__ = __webpack_require__(832);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_34__recipes_recipes_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__recipes__ = __webpack_require__(175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_35__recipes__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_35__recipes__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_35__recipes__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_35__recipes__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__spinner_spinner_component__ = __webpack_require__(252);
/* unused harmony reexport Spinner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__schedule__ = __webpack_require__(2395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_37__schedule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__sequence_carousel__ = __webpack_require__(2492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_38__sequence_carousel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__side_modal_component__ = __webpack_require__(824);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_39__side_modal_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__sticky_sticky_component__ = __webpack_require__(2496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_40__sticky_sticky_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__tabs__ = __webpack_require__(535);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_41__tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__temperature_graph___ = __webpack_require__(2499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_42__temperature_graph___["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__temperature_spinner_full_color_range__ = __webpack_require__(2513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_43__temperature_spinner_full_color_range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__timespan__ = __webpack_require__(349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_44__timespan__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__time_spinner__ = __webpack_require__(2515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_45__time_spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__buttons__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_46__buttons__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_46__buttons__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_46__buttons__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_46__buttons__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_46__buttons__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_46__buttons__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_46__buttons__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__headings__ = __webpack_require__(2518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_47__headings__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_47__headings__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__indicators__ = __webpack_require__(2521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_48__indicators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_48__indicators__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_48__indicators__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__layouts__ = __webpack_require__(829);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_49__layouts__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_49__layouts__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__timer_timer_component__ = __webpack_require__(2527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_50__timer_timer_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__flipper_rgb_flipper__ = __webpack_require__(505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_51__flipper_rgb_flipper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__flipper_brightness_flipper__ = __webpack_require__(815);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_52__flipper_brightness_flipper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__temperature__ = __webpack_require__(255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_53__temperature__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__info_bar__ = __webpack_require__(2530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_54__info_bar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__unsaved_changes_modal__ = __webpack_require__(794);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_55__unsaved_changes_modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__humidity_control_modal__ = __webpack_require__(2533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_56__humidity_control_modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__errors__ = __webpack_require__(2537);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_57__errors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__wiring_error__ = __webpack_require__(2539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_58__wiring_error__["a"]; });


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function defaultEqualityCheck(a, b) {
  return a === b;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];

  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
      return equalityCheck(value, lastArgs[index]);
    })) {
      lastResult = func.apply(undefined, args);
    }
    lastArgs = args;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    memoizeOptions[_key2 - 1] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      funcs[_key3] = arguments[_key3];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      return resultFunc.apply(undefined, arguments);
    }].concat(memoizeOptions));

    var selector = function selector(state, props) {
      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      var params = dependencies.map(function (dependency) {
        return dependency.apply(undefined, [state, props].concat(args));
      });
      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
    };

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      values[_key5] = arguments[_key5];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dismissAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dismissAllAlerts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return requestAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
var dismissAlert=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISMISS_ALERT */]);var dismissAllAlerts=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISMISS_ALL_ALERTS */]);var nextAlertId=0;var requestAlert=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* REQUEST_ALERT */],function(text){var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* alerts */].types.INFO;var isPersistent=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var _ref=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{},intlValues=_ref.intlValues,expiryMs=_ref.expiryMs;var payload={id:nextAlertId++,isPersistent:isPersistent,text:text,type:type,intlValues:intlValues,expiryMs:expiryMs};return payload;});

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(295)('wks')
  , uid        = __webpack_require__(154)
  , Symbol     = __webpack_require__(22).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(25)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(16)
  , IE8_DOM_DEFINE = __webpack_require__(583)
  , toPrimitive    = __webpack_require__(93)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(34) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(58);
var isNil = __webpack_require__(98);
var fail = __webpack_require__(2021);
var stringify = __webpack_require__(750);

function assert(guard, message) {
  if (guard !== true) {
    if (isFunction(message)) { // handle lazy messages
      message = message();
    }
    else if (isNil(message)) { // use a default message
      message = 'Assert failed (turn on "Pause on exceptions" in your Source panel)';
    }
    assert.fail(message);
  }
}

assert.fail = fail;
assert.stringify = stringify;

module.exports = assert;

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDevices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getDeviceItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return getIsDevicesLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getDeviceById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return getDeviceType; });
/* unused harmony export getIsZone */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getDeviceCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return getHub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return getHueBridge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return getHueBridgeId; });
/* unused harmony export getBoilerModule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getBoilerModuleId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBoilerModuleVersion; });
/* unused harmony export getOfflineDevices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return getLeakSensors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCameras; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllVisibleDevices; });
/* unused harmony export getHubDevices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return getHublessDevices; });
/* unused harmony export getHubModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return getIsHubNano1; });
/* unused harmony export getIsHubNano2 */
/* unused harmony export getSenseDevice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return getIsHubSense; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return hasSLT1Thermostat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getDeviceRemovingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getDeviceErrorStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getDeviceSavingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getDeviceRestartingStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getDeviceRestartingErrorStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getDeviceModel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getDeviceIPAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getDeviceMacAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getDeviceConnectionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getDeviceFirmwareVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getDevicePowerSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDeviceBattery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getDeviceSignal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getDeviceLastSeen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getDeviceOnlineStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getDeviceZoneId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getDeviceStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getDeviceManufacturer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getDeviceSerialNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getDeviceName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getConnectedDevices; });
/* unused harmony export getDeviceResolution */
/* unused harmony export getDeviceNightVision */
/* unused harmony export getCameraAudio */
/* unused harmony export getDeviceInvertImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDeviceCapabilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return getIsHueBridge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return getIsHub; });
/* unused harmony export getPairedThermostatIdFromBoilerModuleId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return getPairedBoilerModuleIdFromThermostatId; });
/* unused harmony export createGetThermostatsForUpgrade */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getThermostatsForHive2Upgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return getIfAnyUpgradeableThermostats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getThermostatsForSLT3Upgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getSLT3sWithNoZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getShouldRequestDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getParentHasCapability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return getHubHasCapability; });
/* unused harmony export getDevicesWithParentCapability */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return getIsHueDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return getIsHueBulb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getDevicesByParentId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getParentPairedThermostatIdFromBoilerModuleId; });
/* unused harmony export getBulbItems */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return hasBulbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getWhetherDeviceHasCapability; });
/* unused harmony export getBulbItemsCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_some__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_reject__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_negate__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_negate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_negate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isEqual__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_isEmpty__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_folktale_maybe__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_folktale_maybe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_folktale_maybe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__selectors__ = __webpack_require__(68);
// Why not importing these from products/selectors?
// Because that creates a circular dependency whuch is baaaad.
// and means `getProductItemById` is imported as `undefined`
var getAllProducts=function getAllProducts(state){return state.products;};var getProductItems=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getAllProducts,function(products){return products.productItems;});var getProductItemById=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getProductItems,__WEBPACK_IMPORTED_MODULE_15__selectors__["c" /* getIdFromProps */],function(productItems,id){return productItems.find(function(prod){return prod.get('id')===id;});});// FIX-ME: for some $flow reason this needed... https://gist.github.com/sandfox/c71d86087ecfe8f6bd1a4d4bfcd257a4
// Pretty sure it's a flow or flow-typed bug...
var getId=function getId(item){return item&&item.id;};var getType=function getType(item){return item&&item.type;};var isHublessDevice=function isHublessDevice(device){return __WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes___default()(device.type,__WEBPACK_IMPORTED_MODULE_14__constants_devices__["hublessDeviceTypes"]);};var isDevice=function isDevice(device){return __WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes___default()(device.type,Object.values(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"]));};var getDevices=function getDevices(state){return state.devices;};var getDeviceItems=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDevices],function(devices){return devices.deviceItems||[];});var getIsDevicesLoaded=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDevices],function(_ref){var isLoaded=_ref.isLoaded;return isLoaded;});var getDeviceById=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems,__WEBPACK_IMPORTED_MODULE_15__selectors__["c" /* getIdFromProps */]],function(items,id){return __WEBPACK_IMPORTED_MODULE_8_lodash_fp_find___default()(['id',id],items);});var getDeviceType=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceById],__WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo___default()(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["GROUP"]),getType));var getIsZone=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceById],function(device){if(!device){return false;}var zone=Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])('zone')(device);var tui=Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])('tui')(device);return device.id===zone&&typeof tui!=='undefined'||typeof zone!=='undefined'&&device.id!==zone;});var getDeviceCategory=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getIsZone],function(isZone){return isZone?__WEBPACK_IMPORTED_MODULE_14__constants_devices__["categories"].ZONE:__WEBPACK_IMPORTED_MODULE_14__constants_devices__["categories"].DEVICE;});var createDeviceByTypeSelector=function createDeviceByTypeSelector(type){return Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems],__WEBPACK_IMPORTED_MODULE_8_lodash_fp_find___default()(['type',type]));};var createDevicesByTypeSelector=function createDevicesByTypeSelector(type){return Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems],__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(['type',type]));};var getHub=createDeviceByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].HUB);var getHueBridge=createDeviceByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].HUE_BRIDGE);var getHueBridgeId=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getHueBridge,getId);var getBoilerModule=createDeviceByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].BOILER_MODULE);var getBoilerModuleId=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getBoilerModule],getId);var getBoilerModuleVersion=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getBoilerModule],Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])('version'));var getOfflineDevices=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems],__WEBPACK_IMPORTED_MODULE_1_lodash_fp_reject___default()(Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])('online')));var getLeakSensors=createDevicesByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].LEAK_SENSOR);var getCameras=createDevicesByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].HIVE_CAMERA);var getAllVisibleDevices=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems],__WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(isDevice),__WEBPACK_IMPORTED_MODULE_1_lodash_fp_reject___default()(isHublessDevice)));var getHubDevices=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems],__WEBPACK_IMPORTED_MODULE_1_lodash_fp_reject___default()(isHublessDevice));var getHublessDevices=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems],__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(isHublessDevice));var getHubModel=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getHub],Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])('model'));var getIsHubNano1=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getHubModel],__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isEqual___default()(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceModels"].NANO1));var getIsHubNano2=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getHubModel],function(model){return __WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes___default()(model,[__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceModels"].NANO2,__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceModels"].SENSE]);});var getSenseDevice=createDeviceByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].SENSE);// SENSE IS BOTH HUB AND DEVICE (SENSORS) SO WE MAKE TWO CHECKS HERE
var getIsHubSense=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getHub,getSenseDevice],function(hub,senseDevice){return!!hub&&!!senseDevice;});var hasSLT1Thermostat=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems],__WEBPACK_IMPORTED_MODULE_0_lodash_fp_some___default()(['props.model',__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceModels"].SLT1]));// $FlowFixMe
var getDeviceRemovingStatus=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getDevices,function(devices){return devices.isRemoving;});var getDeviceErrorStatus=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getDevices,function(devices){return!!devices.hasError;});var getDeviceSavingStatus=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getDevices,function(devices){return devices.saving;});var getDeviceRestartingStatus=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getDevices,function(devices){return devices.isRestarting;});var getDeviceRestartingErrorStatus=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getDevices,function(devices){return devices.hasRestartingError;});var createDevicePropSelector=function createDevicePropSelector(name){return Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceById],Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])(name));};var getDeviceModel=createDevicePropSelector('model');var getDeviceIPAddress=createDevicePropSelector('ipAddress');var getDeviceMacAddress=createDevicePropSelector('macAddress');var getDeviceConnectionType=createDevicePropSelector('connection');var getDeviceFirmwareVersion=createDevicePropSelector('version');var getDevicePowerSource=createDevicePropSelector('power');var getDeviceBattery=createDevicePropSelector('battery');var getDeviceSignal=createDevicePropSelector('signal');var getDeviceLastSeen=createDevicePropSelector('uptime');var getDeviceOnlineStatus=createDevicePropSelector('online');var getDeviceZoneId=createDevicePropSelector('zone');var getDeviceStatus=createDevicePropSelector('status');var getDeviceManufacturer=createDevicePropSelector('manufacturer');var getDeviceSerialNumber=createDevicePropSelector('hardwareIdentifier');var createDeviceStateSelector=function createDeviceStateSelector(name){return Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceById],Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["f" /* getStateAttribute */])(name));};var getDeviceName=createDeviceStateSelector('name');var getConnectedDevices=createDeviceStateSelector('connectedDevices');var getDeviceResolution=createDeviceStateSelector('resolution');var getDeviceNightVision=createDeviceStateSelector('nightVision');var getCameraAudio=createDeviceStateSelector('cameraAudio');var getDeviceInvertImage=createDeviceStateSelector('invertImage');var getDeviceCapabilities=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(createDevicePropSelector('capabilities'),__WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo___default()([]));var createIsDeviceByTypeSelector=function createIsDeviceByTypeSelector(type){return Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceType],__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isEqual___default()(type));};var getIsHueBridge=createIsDeviceByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].HUE_BRIDGE);var getIsHub=createIsDeviceByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].HUB);var isThermostat=function isThermostat(_ref2){var type=_ref2.type;return __WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes___default()(type,__WEBPACK_IMPORTED_MODULE_14__constants_devices__["thermostatDeviceTypes"]);};var getPairedThermostatIdFromBoilerModuleId=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceZoneId,getDeviceItems],function(zone,deviceItems){return __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(getId,__WEBPACK_IMPORTED_MODULE_8_lodash_fp_find___default()(isThermostat),__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(['props.zone',zone]))(deviceItems);});var getPairedBoilerModuleIdFromThermostatId=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceName,getDeviceItems],function(thermoStatName,deviceItems){return thermoStatName.chain(function(name){return __WEBPACK_IMPORTED_MODULE_11_folktale_maybe___default.a.fromNullable(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(getId,__WEBPACK_IMPORTED_MODULE_8_lodash_fp_find___default()(['state.zoneName',name]))(deviceItems));});});var createGetThermostatsForUpgrade=function createGetThermostatsForUpgrade(deviceCapability){return Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([createDevicesByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].THERMOSTAT_UI)],__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes___default()(deviceCapability),__WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo___default()([]),Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])('capabilities'))));};var getThermostatsForHive2Upgrade=createGetThermostatsForUpgrade(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceCaps"].HIVE2_UPGRADE);var getIfAnyUpgradeableThermostats=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getThermostatsForHive2Upgrade,__WEBPACK_IMPORTED_MODULE_2_lodash_fp_negate___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_isEmpty___default.a));var getThermostatsForSLT3Upgrade=createGetThermostatsForUpgrade(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceCaps"].SLT3B_REPLACEMENT);var getSLT3sWithNoZone=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([createDevicesByTypeSelector(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["deviceTypes"].THERMOSTAT_UI)],__WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo___default()([]),__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(['props.model','SLT3']),__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(['props.zone',undefined])));var getShouldRequestDevices=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDevices],function(devices){return!devices.isFetching||devices.deviceItems.length;});var getParentDevice=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems,getProductItemById],function(devices){var product=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Object(__WEBPACK_IMPORTED_MODULE_13_immutable__["Map"])();return __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo___default()({}),__WEBPACK_IMPORTED_MODULE_8_lodash_fp_find___default()(['id',product.get('parent')]))(devices);});var getParentHasCapability=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(// $FlowFixMe
[function(state,_ref3){var id=_ref3.id;return getParentDevice(state,{id:id});},__WEBPACK_IMPORTED_MODULE_15__selectors__["b" /* getCapabilityNameFromProps */]],function(parent,capabilityName){return __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes___default()(capabilityName),__WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo___default()([]),Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])('capabilities'))(parent);});var getHubHasCapability=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getHub,function(state,name){return name;}],function(hub,name){return __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes___default()(name),__WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo___default()([]),Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])('capabilities'))(hub);});var getDevicesWithParentCapability=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(// $FlowFixMe
[function(state){return getDeviceItems(state);},__WEBPACK_IMPORTED_MODULE_15__selectors__["g" /* stateIdentity */],__WEBPACK_IMPORTED_MODULE_15__selectors__["b" /* getCapabilityNameFromProps */]],function(devices,state,capabilityName){return __WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(function(_ref4){var id=_ref4.id;return getParentHasCapability(state,{id:id,capabilityName:capabilityName});},devices);});var getIsHueDevice=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceManufacturer],__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isEqual___default()(__WEBPACK_IMPORTED_MODULE_14__constants_devices__["manufacturers"].PHILIPS));var getIsHueBulb=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getIsHueDevice,getIsHueBridge],function(isHueDevice,isHueBridge){return isHueDevice&&!isHueBridge;});var getDevicesByParentId=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceItems,__WEBPACK_IMPORTED_MODULE_15__selectors__["d" /* getParentFromProps */]],function(devices,parentId){return __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(['parent',parentId]),__WEBPACK_IMPORTED_MODULE_1_lodash_fp_reject___default()(['id',parentId]))(devices);});var getParentPairedThermostatIdFromBoilerModuleId=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getParentDevice,__WEBPACK_IMPORTED_MODULE_15__selectors__["g" /* stateIdentity */]],function(parentDevice,state){return getPairedThermostatIdFromBoilerModuleId(state,{id:parentDevice.id,controlType:''});});var getBulbItems=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getDeviceItems,__WEBPACK_IMPORTED_MODULE_9_lodash_fp_filter___default()(function(_ref5){var type=_ref5.type;return __WEBPACK_IMPORTED_MODULE_14__constants_devices__["bulbTypes"].includes(type);}));var hasBulbs=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getBulbItems,__WEBPACK_IMPORTED_MODULE_0_lodash_fp_some___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_identity___default.a));var getWhetherDeviceHasCapability=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])([getDeviceById,__WEBPACK_IMPORTED_MODULE_15__selectors__["b" /* getCapabilityNameFromProps */]],function(device,capabilityName){return __WEBPACK_IMPORTED_MODULE_7_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_includes___default()(capabilityName),__WEBPACK_IMPORTED_MODULE_10_lodash_fp_defaultTo___default()([]),Object(__WEBPACK_IMPORTED_MODULE_15__selectors__["e" /* getProp */])('capabilities'))(device);});var getBulbItemsCount=Object(__WEBPACK_IMPORTED_MODULE_12_reselect__["createSelector"])(getBulbItems,function(devices){return devices.length;});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = httpGet;
/* harmony export (immutable) */ __webpack_exports__["d"] = httpPut;
/* harmony export (immutable) */ __webpack_exports__["a"] = httpDelete;
/* harmony export (immutable) */ __webpack_exports__["c"] = httpPost;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drivers_cookie__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_config__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url__);
var GET='GET';var PUT='PUT';var DELETE='DELETE';var POST='POST';function httpGet(path){var useToken=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var handleSessionTimeout=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var forceEndpoint=arguments[3];return _fetch(path,GET,_getHeaders(useToken),null,handleSessionTimeout,useToken,forceEndpoint);}function httpPut(path){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var useToken=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var handleSessionTimeout=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var forceEndpoint=arguments[4];return _fetch(path,PUT,_getHeaders(useToken),data,handleSessionTimeout,useToken,forceEndpoint);}function httpDelete(path){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var useToken=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var handleSessionTimeout=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var forceEndpoint=arguments[4];return _fetch(path,DELETE,_getHeaders(useToken),data,handleSessionTimeout,useToken,forceEndpoint);}function httpPost(path){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var useToken=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var handleSessionTimeout=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var forceEndpoint=arguments[4];return _fetch(path,POST,_getHeaders(useToken),data,handleSessionTimeout,useToken,forceEndpoint);}////// HELPERS //////
/**
 * Wrapper around fetch object.
 *
 * Error handling works as follows:
 * 		- 500 errors are Beekeeper errors (e.g. missing param, incorrectly formatted param, etc.), and are returned
 * 		  as JSON objects. These will be handled in fetch.then(), which passes them off to _handleError(), which
 * 		  formats them and throws them to the .catch() function of _fetch()'s calling function.
 *
 * 		- 400 errors (e.g. 404 not found) are returned by fetch() in the response object, and so again are handled
 * 		  in fetch.then(), before being thrown by _handleError()
 *
 * 		- Network errors (DNS errors, network down, etc.) are automatically thrown by fetch(), and so must be handled
 * 		  by the .catch() function of _fetch()'s calling function.
 *
 * 		  NOTE: If _fetch's calling function (or *its* calling function) doesn't implement .catch()), the error will
 * 		  be suppressed, but an error message will appear in the console log.
 *
 * @param path
 * @param method
 * @param headers
 * @param bodyData
 * @returns {*|Promise.<TResult>}
 * @private
 */function _fetch(path,method){var headers=arguments.length>2&&arguments[2]!==undefined?arguments[2]:_getHeaders();var bodyData=arguments[3];var handleSessionTimeout=arguments[4];var useToken=arguments[5];var forceEndpoint=arguments[6];var fetchParams={method:method,headers:headers};if(bodyData){fetchParams.body=JSON.stringify(bodyData);}var endpoint=forceEndpoint||useToken&&__WEBPACK_IMPORTED_MODULE_0__drivers_cookie__["a" /* default */].get('endpoint')||Object(__WEBPACK_IMPORTED_MODULE_1__state_config__["b" /* getFromConfig */])('api');var _url$parse=__WEBPACK_IMPORTED_MODULE_2_url___default.a.parse(endpoint),host=_url$parse.host,_url$parse$pathname=_url$parse.pathname,version=_url$parse$pathname===undefined?'':_url$parse$pathname,port=_url$parse.port,protocol=_url$parse.protocol;var _url$parse2=__WEBPACK_IMPORTED_MODULE_2_url___default.a.parse(path),_url$parse2$pathname=_url$parse2.pathname,apiPath=_url$parse2$pathname===undefined?'':_url$parse2$pathname,search=_url$parse2.search;var apiUrl=__WEBPACK_IMPORTED_MODULE_2_url___default.a.format({host:host,protocol:protocol,port:port,search:search,pathname:version.replace(/\/$/,'')+'/'+apiPath.replace(/^\//,'')});return fetch(apiUrl,fetchParams);}function _getHeaders(){var useToken=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var headers={'Content-Type':'application/json'};var token=useToken?__WEBPACK_IMPORTED_MODULE_0__drivers_cookie__["a" /* default */].get('token'):null;if(token){headers.authorization=token;}return headers;}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return breakPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return media; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['@media (max-width: ',') {',';}'],['@media (max-width: ',') {',';}']),_templateObject2=_taggedTemplateLiteral(['@media (min-width: ',') {',';}'],['@media (min-width: ',') {',';}']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// @noflow
var breakPoints={mobile:'40em',// font-size: 14px
tablet:'40em',// font-size: 16px
desktop:'64em',// font-size: 18px
large:'90em',xlarge:'130em'};var media={mobile:function mobile(){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject,breakPoints.mobile,__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */].apply(undefined,arguments));},tablet:function tablet(){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,breakPoints.tablet,__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */].apply(undefined,arguments));},desktop:function desktop(){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,breakPoints.desktop,__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */].apply(undefined,arguments));},large:function large(){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,breakPoints.large,__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */].apply(undefined,arguments));},xlarge:function xlarge(){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2,breakPoints.xlarge,__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */].apply(undefined,arguments));}};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return appLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return attemptLogIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return logIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return logInComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return logInReset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return logOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResetState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return showHiveLiveModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hideHiveLiveModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return receiveGTMOffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return showWelcomeMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hideWelcomeMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return showLeakSensorModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hideLeakSensorModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return showHumidityControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hideHumidityControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return startLoginAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return stopLoginAnimation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
var appLoaded=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/APP_LOADED');var attemptLogIn=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/ATTEMPT_LOG_IN');var logIn=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/LOG_IN');var logInComplete=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/LOG_IN_COMPLETE');var logInReset=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/LOG_IN_RESET');var logOut=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/LOG_OUT');var ResetState=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/RESET_STATE');var showHiveLiveModal=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/SHOW_HIVE_LIVE_MODAL');var hideHiveLiveModal=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/HIDE_HIVE_LIVE_MODAL');var receiveGTMOffers=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/RECEIVE_GTM_OFFERS');var showWelcomeMessage=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/SHOW_WELCOME_MESSAGE');var hideWelcomeMessage=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/HIDE_WELCOME_MESSAGE');var showLeakSensorModal=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/SHOW_LEAK_SENSOR_MODAL');var hideLeakSensorModal=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/HIDE_LEAK_SENSOR_MODAL');var showHumidityControl=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/SHOW_HUMIDITY_CONTROL');var hideHumidityControl=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/HIDE_HUMIDITY_CONTROL');var startLoginAnimation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/START_LOGIN_ANIMATION');var stopLoginAnimation=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/application/STOP_LOGIN_ANIMATION');

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('identity', __webpack_require__(150), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDataId; });
/* unused harmony export getComponentById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getScheduleFromComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCleanSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getScheduleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDayScheduleEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getScheduleEventByDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentScheduleEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getNextScheduleEventInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getSelectedDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getSelectedEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getScheduleType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getScheduleMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCopyDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getIsSavingSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isShowingPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getIsScheduleValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getEventTypeFromEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_slice__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_reverse__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_reverse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_reverse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_reduce__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_flow__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_concat__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_days__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_schedule__ = __webpack_require__(80);
var MINUTES_IN_DAY=1440;var getSchedulesSection=function getSchedulesSection(state){return state.schedules2;};// $FlowFixMe
var getComponentId=function getComponentId(_,props){return props&&props.componentId||'';};var getDataId=function getDataId(_,props){return props.componentId.split('__')[1];};var getDayIndex=function getDayIndex(_,_ref){var dayIndex=_ref.dayIndex;return dayIndex;};var getSavedFlagFromProps=function getSavedFlagFromProps(_,props){return!!props.saved;};var getComponents=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getSchedulesSection],function(schedules){return schedules.get('components');});var getSchedulesData=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getSchedulesSection],function(schedules){return schedules.get('data');});var getComponentById=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getComponents,getComponentId],function(components,componentId){return components.get(componentId,Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["Map"])());});var getScheduleFromComponent=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([function(state,_ref2){var componentId=_ref2.componentId;return getComponentById(state,{componentId:componentId});}],function(component){return component.get('schedule');});// remove the guid property (e.g. when the schedule is sent to beekeeper to be saved)
var getCleanSchedule=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getScheduleFromComponent],function(schedule){return schedule.map(function(day){return day.map(function(event){return event.remove('guid');});});});/**
 * Get the schedule being modified by the component if it exists otherwise get the original schedule
 * (the `saved` property allow to force getting the original schedule)
 */var getScheduleData=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getScheduleFromComponent,getSchedulesData,getDataId,getSavedFlagFromProps],function(schedule,data,dataId,saved){return saved||!schedule?data.getIn([dataId,'schedule']):schedule;});var getLastEvent=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getScheduleData,getDayIndex],function(schedule,dayIndex){return __WEBPACK_IMPORTED_MODULE_5_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_concat___default()(__WEBPACK_IMPORTED_MODULE_11__constants_days__["a" /* listDays */]),__WEBPACK_IMPORTED_MODULE_0_lodash_fp_slice___default()(dayIndex)(dayIndex+7),__WEBPACK_IMPORTED_MODULE_1_lodash_fp_reverse___default.a,__WEBPACK_IMPORTED_MODULE_3_lodash_fp_map___default()(function(day){if(!schedule){return Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])({});}var daySchedule=schedule.get(day);if(!daySchedule){return Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])({});}var event=daySchedule.slice(-1).first();return event&&event.set('dayIndex',__WEBPACK_IMPORTED_MODULE_11__constants_days__["a" /* listDays */].indexOf(day)).set('eventIndex',daySchedule.size-1);}),__WEBPACK_IMPORTED_MODULE_6_lodash_fp_find___default()(function(event){return event!==undefined;}))(__WEBPACK_IMPORTED_MODULE_11__constants_days__["a" /* listDays */]);});/**
 * Get the events of a specific day (including the first event starting previously of the requested day)
 * @type {Immutable.List}
 */var getDayScheduleEvents=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getScheduleData,getLastEvent,getDayIndex],function(schedule,previousEvent,dayIndex){if(!schedule){return Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["List"])();}var mappedDayEvents=schedule.get(__WEBPACK_IMPORTED_MODULE_11__constants_days__["a" /* listDays */][dayIndex],Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["List"])()).map(function(event,i){return event.withMutations(function(event){return event.set('dayIndex',dayIndex).set('eventIndex',i);});});return Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["List"])([previousEvent]).concat(mappedDayEvents);});var getDateTime=function getDateTime(_,props){return props.dateTime;};var getScheduleEventByDateTime=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4_lodash_fp_identity___default.a,getDateTime,getComponentId],function(state,dt,componentId){var now=__WEBPACK_IMPORTED_MODULE_12_moment_timezone___default()(dt);var currentMinutes=now.diff(now.clone().startOf('day'),'minutes');var currentDayEvents=getDayScheduleEvents(state,{componentId:componentId,dayIndex:now.isoWeekday()-1});return(// $FlowFixMe
currentDayEvents.findLast(function(event,index){return index===0||event.get('start')<currentMinutes;})||Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["Map"])());});var getCurrentScheduleEvent=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4_lodash_fp_identity___default.a,__WEBPACK_IMPORTED_MODULE_9__hub_selectors__["e" /* getHubDate */],__WEBPACK_IMPORTED_MODULE_9__hub_selectors__["f" /* getHubMinsSinceMidnight */],getComponentId,getSavedFlagFromProps],function(state,now,currentMinutes,componentId,saved){var currentDayEvents=getDayScheduleEvents(state,{componentId:componentId,dayIndex:now.isoWeekday()-1,saved:saved});return(// $FlowFixMe
currentDayEvents.findLast(function(event,index){return index===0||event.get('start')<=currentMinutes;})||Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])({}));});var getNextScheduleEventInfo=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4_lodash_fp_identity___default.a,__WEBPACK_IMPORTED_MODULE_9__hub_selectors__["e" /* getHubDate */],__WEBPACK_IMPORTED_MODULE_9__hub_selectors__["f" /* getHubMinsSinceMidnight */],getComponentId,getScheduleData],function(state,now,currentMinutes,componentId,schedule){var currentDayIndex=now.isoWeekday()-1;var flattenSchedule=__WEBPACK_IMPORTED_MODULE_5_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_concat___default()(__WEBPACK_IMPORTED_MODULE_11__constants_days__["a" /* listDays */]),__WEBPACK_IMPORTED_MODULE_0_lodash_fp_slice___default()(currentDayIndex)(currentDayIndex+7),__WEBPACK_IMPORTED_MODULE_2_lodash_fp_reduce___default()(function(flattenList,day){if(!schedule){return flattenList;}var daySchedule=schedule.get(day);if(!daySchedule){return flattenList;}var dayScheduleMapped=daySchedule.map(function(event,index){return event.set('dayIndex',__WEBPACK_IMPORTED_MODULE_11__constants_days__["a" /* listDays */].indexOf(day)).set('eventIndex',index);});return flattenList.concat(__WEBPACK_IMPORTED_MODULE_11__constants_days__["a" /* listDays */][currentDayIndex]!==day?dayScheduleMapped:dayScheduleMapped.filter(function(event){return event.get('start')>currentMinutes;}));},Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])([])))(__WEBPACK_IMPORTED_MODULE_11__constants_days__["a" /* listDays */]);if(flattenSchedule.size===0){return Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])({});}var nextEvent=flattenSchedule.get(0);var followingEvent=flattenSchedule.get(1);var deltaDays=function deltaDays(dayIndex){return(dayIndex-currentDayIndex+7)%7;};var relativeStart=nextEvent.get('start')+deltaDays(nextEvent.get('dayIndex'))*MINUTES_IN_DAY;var relativeEnd=followingEvent.get('start')+deltaDays(followingEvent.get('dayIndex'))*MINUTES_IN_DAY;return Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])({value:nextEvent.get('value'),relativeStart:relativeStart,relativeEnd:relativeEnd});});var getSelectedDay=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getComponentById],function(component){return component.get('selectedDay',null);});var getSelectedEvent=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getComponentById],function(component){return component.get('selectedEvent',Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["Map"])());});var getScheduleType=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getSchedulesData,getDataId],function(data,dataId){return data.getIn([dataId,'scheduleType']);});var getScheduleMode=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getComponentById],function(component){return component.get('scheduleMode',__WEBPACK_IMPORTED_MODULE_13__constants_schedule__["b" /* scheduleModesEnum */].DEFAULT);});var getCopyDay=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getComponentById],function(component){return component.get('copyDay',null);});var getIsSavingSchedule=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getComponentById],function(component){return component.get('isSavingSchedule',false);});var isShowingPopup=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getComponentById],function(component){return component.get('showingPopup',false);});var getIsScheduleValid=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])([getSchedulesData,function(_,props){return props.id;}],function(data,id){var schedule=data.getIn([id,'schedule'],Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])([]));return schedule.size===0||schedule.size===7&&schedule.every(function(day){return day.size;});});var scheduleTypePriority=new Map([[__WEBPACK_IMPORTED_MODULE_13__constants_schedule__["c" /* scheduleType */].WARM_WHITE_LIGHT,0],[__WEBPACK_IMPORTED_MODULE_13__constants_schedule__["c" /* scheduleType */].TUNEABLE_LIGHT,1],[__WEBPACK_IMPORTED_MODULE_13__constants_schedule__["c" /* scheduleType */].COLOUR_TUNEABLE_LIGHT,2]]);var eventTypeFromEvent=function eventTypeFromEvent(scheduleType,event){var schedulePriority=scheduleTypePriority.get(scheduleType);if(!schedulePriority||!event){return scheduleType;}var value=event.get('value');var hue=value.get('hue');var saturation=value.get('saturation');var hsvValue=value.get('value');var temperature=value.get('colourTemperature');var eventTypeMap=new Map([[true,__WEBPACK_IMPORTED_MODULE_13__constants_schedule__["c" /* scheduleType */].WARM_WHITE_LIGHT],[!!temperature,__WEBPACK_IMPORTED_MODULE_13__constants_schedule__["c" /* scheduleType */].TUNEABLE_LIGHT],[!!(hue&&saturation&&hsvValue),__WEBPACK_IMPORTED_MODULE_13__constants_schedule__["c" /* scheduleType */].COLOUR_TUNEABLE_LIGHT]]);var possibleEventType=eventTypeMap.get(true);var possibleEventTypePriority=scheduleTypePriority.get(possibleEventType);if(!possibleEventTypePriority){return scheduleType;}return possibleEventTypePriority>=schedulePriority?possibleEventType:scheduleType;};var getEventFromProps=function getEventFromProps(_,_ref3){var event=_ref3.event;return event;};var getEventTypeFromEvent=Object(__WEBPACK_IMPORTED_MODULE_10_reselect__["createSelector"])(getScheduleType,getEventFromProps,eventTypeFromEvent);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(137)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(2121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(2125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(2126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(778);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(2129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(2130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(2131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(697);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(202);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(318);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(699);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["j"]; });
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(168);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(1550);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
 * modified to make it possible to validate Immutable.js data.
 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
 */


var Immutable = __webpack_require__(6);

var ANONYMOUS = "<<anonymous>>";

var ImmutablePropTypes = {
  listOf: createListOfTypeChecker,
  mapOf: createMapOfTypeChecker,
  orderedMapOf: createOrderedMapOfTypeChecker,
  setOf: createSetOfTypeChecker,
  orderedSetOf: createOrderedSetOfTypeChecker,
  stackOf: createStackOfTypeChecker,
  iterableOf: createIterableOfTypeChecker,
  recordOf: createRecordOfTypeChecker,
  shape: createShapeChecker,
  contains: createShapeChecker,
  mapContains: createMapContainsChecker,
  // Primitive Types
  list: createImmutableTypeChecker("List", Immutable.List.isList),
  map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
  orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
  set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
  orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
  stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
  seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
  record: createImmutableTypeChecker("Record", function (isRecord) {
    return isRecord instanceof Immutable.Record;
  }),
  iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
};

function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return "array";
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }
  if (propValue instanceof Immutable.Iterable) {
    return "Immutable." + propValue.toSource().split(" ")[0];
  }
  return propType;
}

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    propFullName = propFullName || propName;
    componentName = componentName || ANONYMOUS;
    if (props[propName] == null) {
      var locationName = location;
      if (isRequired) {
        return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
      }
    } else {
      return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var locationName = location;
      var propType = getPropType(propValue);
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }

    if (typeof typeChecker !== "function") {
      return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var propValues = propValue.toArray();
    for (var i = 0, len = propValues.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [propValues, i, componentName, location, "" + propFullName + "[" + i + "]"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createKeysTypeChecker(typeChecker) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (typeof typeChecker !== "function") {
      return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var keys = propValue.keySeq().toArray();
    for (var i = 0, len = keys.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [keys, i, componentName, location, "" + propFullName + " -> key(" + keys[i] + ")"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createListOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
}

function createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
  function validate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
  }

  return createChainableTypeChecker(validate);
}

function createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", Immutable.Map.isMap);
}

function createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", Immutable.OrderedMap.isOrderedMap);
}

function createSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
}

function createOrderedSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "OrderedSet", Immutable.OrderedSet.isOrderedSet);
}

function createStackOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Stack", Immutable.Stack.isStack);
}

function createIterableOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
}

function createRecordOfTypeChecker(recordKeys) {
  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!(propValue instanceof Immutable.Record)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
    }
    for (var key in recordKeys) {
      var checker = recordKeys[key];
      if (!checker) {
        continue;
      }
      var mutablePropValue = propValue.toObject();
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
function createShapeTypeChecker(shapeTypes) {
  var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
  var immutableClassTypeValidator = arguments[2] === undefined ? Immutable.Iterable.isIterable : arguments[2];

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }
    var mutablePropValue = propValue.toObject();
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createShapeChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes);
}

function createMapContainsChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes, "Map", Immutable.Map.isMap);
}

module.exports = ImmutablePropTypes;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(84);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return heightRatios; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MIN_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SIDE_MARGIN_WIDTH; });
/* unused harmony export SLIDER_HEIGHT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SLIDER_Y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OPACITY_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EASING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TRANSITION_DEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EVENT_SIDE_MARGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EVENT_HEIGHT_MARGIN_RATIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return dualColorGradiant; });
// Main section height ratios
var heightRatios={CONTROL_PANEL:0.09,TIME_AXIS:0.07,WEEK:0.84};var MIN_WIDTH=320;// the minimum width supported by the schedule
var SIDE_MARGIN_WIDTH=30;var SLIDER_HEIGHT=30;var SLIDER_Y=80;// distance between the selecetd event and the slider
var OPACITY_LEVEL=0.25;var DURATION='0.3s';var EASING='cubic-bezier(0.215, 0.61, 0.355, 1)';var TRANSITION_DEF='all '+DURATION+' '+EASING;// events
var EVENT_SIDE_MARGIN=2;var EVENT_HEIGHT_MARGIN_RATIO=0.15;// svg definitions
var dualColorGradiant='dualColorGradiant';

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getHub */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCurrentTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTimezone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHasHub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentTimeWithTimezone; });
/* unused harmony export getMomentWithHubTimezone */
/* unused harmony export getHubTimeToNearest5Minutes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHubDate; });
/* unused harmony export getHubTodayNumber */
/* unused harmony export getHubMidnight */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getHubMinsSinceMidnight; });
/* unused harmony export makeGetNextScheduleEventDisplay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPmzStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTodayAsString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getStartOfTodayMoment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getStartOfDayFromLastWeekMoment; });
/* unused harmony export getStartOfWeekFromLastMonthMoment */
/* unused harmony export getEndOfWeekMoment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getRecentMonthFullWeeksAsArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseActions2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_devices__ = __webpack_require__(12);
var getHub=function getHub(state){return state.hub||Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])({});};var getCurrentTime=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getHub],function(hub){return hub.get('currentTime');});var getTimezone=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getHub],function(hub){return hub.get('timezone');});var getHasHub=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getHub],function(hub){return hub.get('hasHub');});var getCurrentTimeWithTimezone=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(getHub,getCurrentTime,function(hub,currentTime){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(currentTime).tz(hub.get('timezone',__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DEFAULT_TIMEZONE */]));});var getMomentWithHubTimezone=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getHub],function(hub){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().tz(hub.get('timezone',__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DEFAULT_TIMEZONE */]));});var roundMinutesToNext5=function roundMinutesToNext5(date){return date.clone().minutes(Math.ceil((date.minutes()+1)/5)*5).seconds(0).milliseconds(0);};var getHubTimeToNearest5Minutes=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getMomentWithHubTimezone],roundMinutesToNext5);var getHubDate=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getCurrentTime,getTimezone],function(unixTime,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.unix(unixTime/1000).tz(timezone);});var getHubTodayNumber=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getHubDate],function(now){return now.day();});var getHubMidnight=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getHubDate],function(now){return now.clone().startOf('day');});var getHubMinsSinceMidnight=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getHubDate],function(now){return now.hours()*60+now.minutes();});var incrementDate=function incrementDate(day){var increment=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var unit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'day';return day.clone().add(increment,unit);};var displayTime=function displayTime(day){var increment=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;return incrementDate(day,increment,'m').format('LT');};var makeGetNextScheduleEventDisplay=function makeGetNextScheduleEventDisplay(event){return Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(getHubMidnight,function(midnight){var state=event.getIn(['value','status'],'OFF');var target=event.getIn(['value','target']);var start=event.get('start','0');var end=event.get('end','200');var nextHeatTarget=event.getIn(['value','heat']);var nextCoolTarget=event.getIn(['value','cool']);return{nextStatus:state,nextStartTime:displayTime(midnight,start),nextEndTime:displayTime(midnight,end),nextTarget:target,nextHeatCoolTargets:[nextCoolTarget,nextHeatTarget].filter(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a)};});};var getPmzStatus=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(getHub,function(hub){return hub.get('pmzStatus');});var getTodayAsString=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getCurrentTime,getTimezone],function(currentTime,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(currentTime,timezone).format('YYYY-MM-DD');});var getStartOfTodayMoment=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getCurrentTime,getTimezone],function(currentTime,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(currentTime,timezone).startOf('day');});var getStartOfDayFromLastWeekMoment=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getCurrentTime,getTimezone],function(currentTime,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(currentTime,timezone).subtract(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* NUMBER_OF_DAYS_DISPLAYED */]-1,'days').startOf('day');});var getStartOfWeekFromLastMonthMoment=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getCurrentTime,getTimezone],function(currentTime,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(currentTime,timezone).subtract(1,'month').startOf('week');});var getEndOfWeekMoment=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getCurrentTime,getTimezone],function(currentTime,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(currentTime,timezone).endOf('week');});var getRecentMonthFullWeeksAsArray=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getStartOfWeekFromLastMonthMoment,getEndOfWeekMoment],function(startPeriod,endPeriod){var period=[];var currentDay=endPeriod.clone();while(!currentDay.isBefore(startPeriod)){period.push(currentDay.format('YYYY-MM-DD'));currentDay.subtract(1,'days');}return period;});var getHubActions2Capability=function getHubActions2Capability(state){return Object(__WEBPACK_IMPORTED_MODULE_6__devices_selectors__["G" /* getHubHasCapability */])(state,__WEBPACK_IMPORTED_MODULE_7__constants_devices__["capabilities"].ACTIONS_2);};var canUseActions2=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__devices_selectors__["F" /* getHub */],__WEBPACK_IMPORTED_MODULE_5__products_selectors__["k" /* getHublessProducts */],getHubActions2Capability,function(hub,hublessProducts,hubHasActions2Capability){return!hub&&hublessProducts.size>0||hubHasActions2Capability;});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actions_api__ = __webpack_require__(1338);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_actions_api__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app_api__ = __webpack_require__(1397);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__app_app_api__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authentication_auth_auth_api__ = __webpack_require__(1398);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__authentication_auth_auth_api__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__authentication_change_password__ = __webpack_require__(1399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__authentication_change_password__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__devices_devices_api__ = __webpack_require__(644);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__devices_devices_api__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__authentication_password_reset_email__ = __webpack_require__(1400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__authentication_password_reset_email__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nodes_nodes_api__ = __webpack_require__(645);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__nodes_nodes_api__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__notifications_notifications_api__ = __webpack_require__(1401);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__notifications_notifications_api__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__products_products_api__ = __webpack_require__(105);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__products_products_api__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__authentication_reset_password__ = __webpack_require__(1402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__authentication_reset_password__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__history_history_api__ = __webpack_require__(646);
/* unused harmony reexport history */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__text_control_text_control_api__ = __webpack_require__(647);
/* unused harmony reexport textControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__user_user_api__ = __webpack_require__(1403);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__user_user_api__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__homes_homes_api__ = __webpack_require__(1404);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__homes_homes_api__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__service_outage_service_outage_api__ = __webpack_require__(1405);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__service_outage_service_outage_api__; });


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(543);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var isType = __webpack_require__(59);
var getFunctionName = __webpack_require__(245);

module.exports = function getTypeName(ctor) {
  if (isType(ctor)) {
    return ctor.displayName;
  }
  return getFunctionName(ctor);
};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1095),
    baseMatchesProperty = __webpack_require__(1103),
    identity = __webpack_require__(150),
    isArray = __webpack_require__(32),
    property = __webpack_require__(1107);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = function isFunction(x) {
  return typeof x === 'function';
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(58);
var isObject = __webpack_require__(115);

module.exports = function isType(x) {
  return isFunction(x) && isObject(x.meta);
};

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAlerts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAnalyticsSharingAllowed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLastActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSettingPin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSettingPinError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPostcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUserCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getUserPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getUserUsername; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getUserLocale; });
/* unused harmony export getUserEmail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
var getState=function getState(state){return state.user||Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({});};// $FlowFixMe
var getAlerts=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getState,function(state){return state.get('alerts');});var getAnalyticsSharingAllowed=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getState,function(user){return(// $FlowFixMe
user.getIn(['media','allowAnalyticsSharing']));});// $FlowFixMe
var getLastActivity=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getState,function(state){return state.get('lastActivity');});// $FlowFixMe
var getSettingPin=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getState,function(state){return state.get('settingPin');});// $FlowFixMe
var getSettingPinError=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getState,function(state){return state.get('settingPinError');});// $FlowFixMe
var getUser=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getState,function(state){return state.getIn(['userDetails'],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({}));});var getPostcode=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getUser,function(state){return state.get('postcode');});var getUserCountry=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getUser,function(state){return state.get('countryCode');});var getUserId=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getUser,function(state){return state.get('id');});var getUserPhone=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getUser,function(state){return state.get('mobile')||state.get('phone');});var getUserUsername=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getUser,function(state){return state.get('username');});var getUserLocale=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getUser,function(user){return user.get('locale');});var getUserEmail=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getUser,function(user){return user.get('email');});

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(35)
  , createDesc = __webpack_require__(135);
module.exports = __webpack_require__(34) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(22)
  , hide      = __webpack_require__(61)
  , has       = __webpack_require__(56)
  , SRC       = __webpack_require__(154)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(109).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  var isFunction = typeof val == 'function';
  if(isFunction)has(val, 'name') || hide(val, 'name', key);
  if(O[key] === val)return;
  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if(O === global){
    O[key] = val;
  } else {
    if(!safe){
      delete O[key];
      hide(O, key, val);
    } else {
      if(O[key])O[key] = val;
      else hide(O, key, val);
    }
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(232)
  , defined = __webpack_require__(84);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3)
  , fails   = __webpack_require__(25)
  , defined = __webpack_require__(84)
  , quot    = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function(string, tag, attribute, value) {
  var S  = String(defined(string))
    , p1 = '<' + tag;
  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function(NAME, exec){
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function(){
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isString = __webpack_require__(326);
var isFunction = __webpack_require__(58);
var forbidNewOperator = __webpack_require__(246);

module.exports = function irreducible(name, predicate) {

  if (false) {
    assert(isString(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to irreducible(name, predicate) (expected a string)'; });
    assert(isFunction(predicate), 'Invalid argument predicate ' + assert.stringify(predicate) + ' supplied to irreducible(name, predicate) (expected a function)');
  }

  function Irreducible(value, path) {

    if (false) {
      forbidNewOperator(this, Irreducible);
      path = path || [name];
      assert(predicate(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
    }

    return value;
  }

  Irreducible.meta = {
    kind: 'irreducible',
    name: name,
    predicate: predicate,
    identity: true
  };

  Irreducible.displayName = name;

  Irreducible.is = predicate;

  return Irreducible;
};


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIdFromProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getParentFromProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCapabilityNameFromProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stateIdentity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getStateAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_assign__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_folktale_maybe__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_folktale_maybe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_folktale_maybe__);
var getIdFromProps=function getIdFromProps(_,props){return props&&props.id||'';};var getParentFromProps=function getParentFromProps(_,props){return props&&props.parent||'';};var getCapabilityNameFromProps=function getCapabilityNameFromProps(_,props){return props&&props.capabilityName||'';};var stateIdentity=function stateIdentity(state){return state||{};};var getProp=function getProp(propName){return function(item){return item&&item.props&&item.props[propName];};};var getStateAttribute=function getStateAttribute(attributeName){return function(item){return __WEBPACK_IMPORTED_MODULE_4_folktale_maybe___default.a.fromNullable(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default()(['state',attributeName],item));};};var bindable=function bindable(fn){return function(boundProps){return function(state,props){var concat=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_isObject___default()(boundProps)?__WEBPACK_IMPORTED_MODULE_1_lodash_fp_assign___default.a:__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default.a;var nextProps=concat(boundProps,props);return fn(state,nextProps);};};};

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return modifyProductState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return undoProductChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return receiveProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return renameProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return renameProductZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeProductZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return productModeChangeUpdateProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return modeSelectorChange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var modifyProductState=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* MODIFY_PRODUCT_STATE */]);var undoProductChange=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* UNDO_PRODUCT_CHANGE */]);var getProducts=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* GET_PRODUCTS */]);var receiveProducts=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* RECEIVE_PRODUCTS */]);var renameProduct=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* RENAME_PRODUCT */]);var renameProductZone=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* RENAME_PRODUCT_ZONE */]);var removeProduct=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* REMOVE_PRODUCT */]);var removeProductZone=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* REMOVE_PRODUCT_ZONE */]);var productModeChangeUpdateProduct=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PRODUCT_MODE_CHANGE_UPDATE_PRODUCT */]);var modeSelectorChange=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* PRODUCT_MODE_CHANGE */],function(productId,mode,currentSchedule,type,defaultTargetTemperature){return{productId:productId,mode:mode,currentSchedule:currentSchedule,type:type,defaultTargetTemperature:defaultTargetTemperature};});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adjustHue */
/* unused harmony export animation */
/* unused harmony export backgroundImages */
/* unused harmony export backgrounds */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* unused harmony export borderStyle */
/* unused harmony export borderWidth */
/* unused harmony export buttons */
/* unused harmony export clearFix */
/* unused harmony export complement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curriedDarken; });
/* unused harmony export desaturate */
/* unused harmony export directionalProperty */
/* unused harmony export ellipsis */
/* unused harmony export em */
/* unused harmony export fontFace */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLuminance; });
/* unused harmony export grayscale */
/* unused harmony export invert */
/* unused harmony export hideText */
/* unused harmony export hideVisually */
/* unused harmony export hiDPI */
/* unused harmony export hsl */
/* unused harmony export hsla */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return curriedLighten; });
/* unused harmony export margin */
/* unused harmony export mix */
/* unused harmony export modularScale */
/* unused harmony export normalize */
/* unused harmony export opacify */
/* unused harmony export padding */
/* unused harmony export parseToHsl */
/* unused harmony export parseToRgb */
/* unused harmony export placeholder */
/* unused harmony export position */
/* unused harmony export radialGradient */
/* unused harmony export readableColor */
/* unused harmony export rem */
/* unused harmony export retinaImage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return rgb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return rgba; });
/* unused harmony export saturate */
/* unused harmony export selection */
/* unused harmony export setHue */
/* unused harmony export setLightness */
/* unused harmony export setSaturation */
/* unused harmony export shade */
/* unused harmony export size */
/* unused harmony export stripUnit */
/* unused harmony export textInputs */
/* unused harmony export timingFunctions */
/* unused harmony export tint */
/* unused harmony export toColorString */
/* unused harmony export transitions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return curriedTransparentize; });
/* unused harmony export triangle */
/* unused harmony export wordWrap */
//      

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

//      
var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');
  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return '' + acc + capitalizeString(val);
    });
  }
  var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
  return property === joinedProperty ? '' + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};
  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }
  return styles;
}

/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function directionalProperty(property) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === undefined ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === undefined ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === undefined ? secondValue : _values$3;

  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

//      

/**
 * Check if a string ends with something
 * @private
 */
var endsWith = function (string, suffix) {
  return string.substr(-suffix.length) === suffix;
};

//      

/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

//      

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */
var pxtoFactory = function pxtoFactory(to) {
  return function (pxval) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';

    var newPxval = pxval;
    var newBase = base;
    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
      }
      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
      }
      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    if (typeof newBase === 'string') {
      throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    return '' + newPxval / newBase + to;
  };
};

//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em = /*#__PURE__*/pxtoFactory('em');

//      

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};

/** */

/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables, see below.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */
function modularScale(steps) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';

  if (typeof steps !== 'number') {
    throw new Error('Please provide a number of steps to the modularScale helper.');
  }
  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
  }

  var realBase = typeof base === 'string' ? stripUnit(base) : base;
  var realRatio = typeof ratio === 'string' ? ratioNames[ratio] : ratio;

  if (typeof realBase === 'string') {
    throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
  }

  return realBase * Math.pow(realRatio, steps) + 'em';
}

//      

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem = /*#__PURE__*/pxtoFactory('rem');

//      

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */

function clearFix() {
  var _ref;

  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';

  var pseudoSelector = parent + '::after';
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

//      

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */

function ellipsis() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

//      

/** */

function generateFileReferences(fontFilePath, fileFormats) {
  var fileFontReferences = fileFormats.map(function (format) {
    return 'url("' + fontFilePath + '.' + format + '")';
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return 'local("' + font + '")';
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
  }
  return fontReferences.join(', ');
}

/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */

function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === undefined ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange;

  // Error Handling
  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
  if (!fontFilePath && !localFonts) {
    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
  }
  if (localFonts && !Array.isArray(localFonts)) {
    throw new Error('fontFace expects localFonts to be an array.');
  }
  if (!Array.isArray(fileFormats)) {
    throw new Error('fontFace expects fileFormats to be an array.');
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight
    }
  };

  // Removes undefined fields for cleaner css object.
  return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

//      

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */

function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

//      

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */

function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

//      

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */

function hiDPI() {
  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};



















var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



























var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var _opinionatedRules;
var _abbrTitle;
var _unopinionatedRules;

//      
var opinionatedRules = (_opinionatedRules = {
  html: {
    fontFamily: 'sans-serif'
  },

  body: {
    margin: '0'
  }

}, _opinionatedRules['a:active,\n  a:hover'] = {
  outlineWidth: '0'
}, _opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  fontFamily: 'sans-serif',
  fontSize: '100%',
  lineHeight: '1.15'
}, _opinionatedRules);

var unopinionatedRules = (_unopinionatedRules = {
  html: {
    lineHeight: '1.15',
    textSizeAdjust: '100%'
  }

}, _unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
  display: 'block'
}, _unopinionatedRules.h1 = {
  fontSize: '2em',
  margin: '0.67em 0'
}, _unopinionatedRules['figcaption,\n  figure,\n  main'] = {
  display: 'block'
}, _unopinionatedRules.figure = {
  margin: '1em 40px'
}, _unopinionatedRules.hr = {
  boxSizing: 'content-box',
  height: '0',
  overflow: 'visible'
}, _unopinionatedRules.pre = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.a = {
  'background-color': 'transparent',
  '-webkit-text-decoration-skip': 'objects'
}, _unopinionatedRules['abbr[title]'] = (_abbrTitle = {
  borderBottom: 'none',
  textDecoration: 'underline'
}, _abbrTitle['textDecoration'] = 'underline dotted', _abbrTitle), _unopinionatedRules['b,\n  strong'] = {
  fontWeight: 'inherit'
}, _unopinionatedRules['code,\n  kbd,\n  samp'] = {
  fontFamily: 'monospace, monospace',
  fontSize: '1em'
}, _unopinionatedRules.dfn = {
  fontStyle: 'italic'
}, _unopinionatedRules.mark = {
  backgroundColor: '#ff0',
  color: '#000'
}, _unopinionatedRules.small = {
  fontSize: '80%'
}, _unopinionatedRules['sub,\n  sup'] = {
  fontSize: '75%',
  lineHeight: '0',
  position: 'relative',
  verticalAlign: 'baseline'
}, _unopinionatedRules.sub = {
  bottom: '-0.25em'
}, _unopinionatedRules.sup = {
  top: '-0.5em'
}, _unopinionatedRules['audio,\n  video'] = {
  display: 'inline-block'
}, _unopinionatedRules['audio:not([controls])'] = {
  display: 'none',
  height: '0'
}, _unopinionatedRules.img = {
  borderStyle: 'none'
}, _unopinionatedRules['svg:not(:root)'] = {
  overflow: 'hidden'
}, _unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
  margin: '0'
}, _unopinionatedRules['button,\n  input'] = {
  overflow: 'visible'
}, _unopinionatedRules['button,\n  select'] = {
  textTransform: 'none'
}, _unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
  '-webkit-appearance': 'button'
}, _unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
  borderStyle: 'none',
  padding: '0'
}, _unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
  outline: '1px dotted ButtonText'
}, _unopinionatedRules.fieldset = {
  border: '1px solid #c0c0c0',
  margin: '0 2px',
  padding: '0.35em 0.625em 0.75em'
}, _unopinionatedRules.legend = {
  boxSizing: 'border-box',
  color: 'inherit',
  display: 'table',
  maxWidth: '100%',
  padding: '0',
  whiteSpace: 'normal'
}, _unopinionatedRules.progress = {
  display: 'inline-block',
  verticalAlign: 'baseline'
}, _unopinionatedRules.textarea = {
  overflow: 'auto'
}, _unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
  boxSizing: 'border-box',
  padding: '0'
}, _unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
  height: 'auto'
}, _unopinionatedRules['[type="search"]'] = {
  '-webkit-appearance': 'textfield',
  outlineOffset: '-2px'
}, _unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
  '-webkit-appearance': 'none'
}, _unopinionatedRules['::-webkit-file-upload-button'] = {
  '-webkit-appearance': 'button',
  font: 'inherit'
}, _unopinionatedRules['details,\n  menu'] = {
  display: 'block'
}, _unopinionatedRules.summary = {
  display: 'list-item'
}, _unopinionatedRules.canvas = {
  display: 'inline-block'
}, _unopinionatedRules.template = {
  display: 'none'
}, _unopinionatedRules['[hidden]'] = {
  display: 'none'
}, _unopinionatedRules);

function mergeRules(baseRules, additionalRules) {
  var mergedRules = _extends({}, baseRules);
  Object.keys(additionalRules).forEach(function (key) {
    if (mergedRules[key]) {
      mergedRules[key] = _extends({}, mergedRules[key], additionalRules[key]);
    } else {
      mergedRules[key] = _extends({}, additionalRules[key]);
    }
  });
  return mergedRules;
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize(excludeOpinionated) {
  if (excludeOpinionated) return unopinionatedRules;
  return mergeRules(unopinionatedRules, opinionatedRules);
}

//      

/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */

function placeholder(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';

  return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = _extends({}, styles), _ref[parent + ':-moz-placeholder'] = _extends({}, styles), _ref[parent + '::-moz-placeholder'] = _extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = _extends({}, styles), _ref;
}

var _templateObject = /*#__PURE__*/ taggedTemplateLiteralLoose(['radial-gradient(', '', '', '', ')'], ['radial-gradient(', '', '', '', ')']);

//      

/** */

function parseFallback(colorStops) {
  return colorStops[0].split(' ')[0];
}

function constructGradientValue(literals) {
  var template = '';
  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];
    // Adds leading coma if properties preceed color-stops
    if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
      template = template.slice(0, -1);
      template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // No trailing space if color-stops is the only param provided
    } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
      template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // Only adds substitution if it is defined
    } else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
      template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
  }
  return template.trim();
}

/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */

function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      extent = _ref.extent,
      fallback = _ref.fallback,
      position = _ref.position,
      shape = _ref.shape;

  if (!colorStops || colorStops.length < 2) {
    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
  }
  return {
    backgroundColor: fallback || parseFallback(colorStops),
    backgroundImage: constructGradientValue(_templateObject, position, shape, extent, colorStops.join(', '))
  };
}

//      

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize) {
  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';

  var _ref;

  var retinaFilename = arguments[3];
  var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';

  if (!filename) {
    throw new Error('Please supply a filename to retinaImage() as the first argument.');
  }
  // Replace the dot at the beginning of the passed extension if one exists
  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;

  return _ref = {
    backgroundImage: 'url(' + filename + '.' + ext + ')'
  }, _ref[hiDPI()] = {
    backgroundImage: 'url(' + rFilename + ')',
    backgroundSize: backgroundSize
  }, _ref;
}

//      

/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */

function selection(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return _ref = {}, _ref[parent + '::-moz-selection'] = _extends({}, styles), _ref[parent + '::selection'] = _extends({}, styles), _ref;
}

//      

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',

  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',

  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */

/** */

/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */

function timingFunctions(timingFunction) {
  return functionsMap[timingFunction];
}

//      

/** */

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  switch (pointingDirection) {
    case 'top':
      return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
    case 'left':
      return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
    case 'bottom':
      return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
    case 'right':
      return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';

    default:
      throw new Error("Passed invalid argument to triangle, please pass correct poitingDirection e.g. 'right'.");
  }
};

// needed for border-color
var reverseDirection = {
  left: 'Right',
  right: 'Left',
  top: 'Bottom',
  bottom: 'Top'
};

/**
 * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent',
 *  'borderLeftColor': 'red !important',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */

function triangle(_ref) {
  var _ref2;

  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;

  var unitlessHeight = parseFloat(height);
  var unitlessWidth = parseFloat(width);
  if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) {
    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
  }

  return _ref2 = {
    borderColor: backgroundColor,
    width: '0',
    height: '0',
    borderWidth: getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
    borderStyle: 'solid'
  }, _ref2['border' + reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}

//      

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */

function wordWrap() {
  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

//      


function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness) {
  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : convertToInt;

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  }

  // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));

  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

//      
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};

/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */
function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? '#' + namedColorMap[normalizedColorName] : color;
}

//      
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;

/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt('' + rgbMatched[1], 10),
      green: parseInt('' + rgbMatched[2], 10),
      blue: parseInt('' + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor);
  if (rgbaMatched) {
    return {
      red: parseInt('' + rgbaMatched[1], 10),
      green: parseInt('' + rgbaMatched[2], 10),
      blue: parseInt('' + rgbaMatched[3], 10),
      alpha: parseFloat('' + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt('' + hslMatched[1], 10);
    var saturation = parseInt('' + hslMatched[2], 10) / 100;
    var lightness = parseInt('' + hslMatched[3], 10) / 100;
    var rgbColorString = 'rgb(' + hslToRgb(hue, saturation, lightness) + ')';
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    return {
      red: parseInt('' + hslRgbMatched[1], 10),
      green: parseInt('' + hslRgbMatched[2], 10),
      blue: parseInt('' + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor);
  if (hslaMatched) {
    var _hue = parseInt('' + hslaMatched[1], 10);
    var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
    var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
    var _rgbColorString = 'rgb(' + hslToRgb(_hue, _saturation, _lightness) + ')';
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    return {
      red: parseInt('' + _hslRgbMatched[1], 10),
      green: parseInt('' + _hslRgbMatched[2], 10),
      blue: parseInt('' + _hslRgbMatched[3], 10),
      alpha: parseFloat('' + hslaMatched[4])
    };
  }
  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}

//      


function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;

  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return { hue: 0, saturation: 0, lightness: lightness, alpha: color.alpha };
    } else {
      return { hue: 0, saturation: 0, lightness: lightness };
    }
  }

  var hue = void 0;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;
  if (color.alpha !== undefined) {
    return { hue: hue, saturation: saturation, lightness: lightness, alpha: color.alpha };
  }
  return { hue: hue, saturation: saturation, lightness: lightness };
}

//      

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

//      

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};

//      
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue('#' + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue('#' + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
  } else if ((typeof firstValue === 'undefined' ? 'undefined' : _typeof(firstValue)) === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
  }

  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}

//      
function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue('#' + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}

//      

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : 'rgba(' + hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
  } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
  }

  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}

//      
var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';

/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if ((typeof color === 'undefined' ? 'undefined' : _typeof(color)) !== 'object') throw new Error(errMsg);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);

  throw new Error(errMsg);
}

//      

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js


// eslint-disable-next-line no-unused-vars


// eslint-disable-next-line no-unused-vars

// eslint-disable-next-line no-redeclare


function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

// eslint-disable-next-line no-redeclare
function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

//      

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */
function adjustHue(degree, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + degree) % 360
  }));
}

var curriedAdjustHue = /*#__PURE__*/curry(adjustHue);

//      

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function complement(color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

//      

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

//      

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */
function darken(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - amount)
  }));
}

var curriedDarken = /*#__PURE__*/curry(darken);

//      

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */
function desaturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - amount)
  }));
}

var curriedDesaturate = /*#__PURE__*/curry(desaturate);

//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */
function getLuminance(color) {
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

//      

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function grayscale(color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: 0
  }));
}

//      

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */
function invert(color) {
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(_extends({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

//      

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */
function lighten(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + amount)
  }));
}

var curriedLighten = /*#__PURE__*/curry(lighten);

//      

/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */
function mix() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
  var color = arguments[1];
  var otherColor = arguments[2];

  var parsedColor1 = parseToRgb(color);
  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  });

  // The formular is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  var alphaDelta = color1.alpha - color2.alpha;
  var x = weight * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;

  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
  };

  return rgba(mixedColor);
}

var curriedMix = /*#__PURE__*/curry(mix);

//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */
function opacify(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedOpacify = /*#__PURE__*/curry(opacify);

//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */

function readableColor(color) {
  return getLuminance(color) > 0.179 ? '#000' : '#fff';
}

var curriedReadableColor = /*#__PURE__*/curry(readableColor);

//      

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */
function saturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + amount)
  }));
}

var curriedSaturate = /*#__PURE__*/curry(saturate);

//      

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */
function setHue(hue, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    hue: hue
  }));
}

var curriedSetHue = /*#__PURE__*/curry(setHue);

//      

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */
function setLightness(lightness, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    lightness: lightness
  }));
}

var curriedSetLightness = /*#__PURE__*/curry(setLightness);

//      

/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */
function setSaturation(saturation, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: saturation
  }));
}

var curriedSetSaturation = /*#__PURE__*/curry(setSaturation);

//      

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(0, 0, 0)');
}

var curriedShade = /*#__PURE__*/curry(shade);

//      

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) {
    throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
  }
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  return curriedMix(percentage, color, 'rgb(255, 255, 255)');
}

var curriedTint = /*#__PURE__*/curry(tint);

//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */
function transparentize(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - amount * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedTransparentize = /*#__PURE__*/curry(transparentize);

//      

/** */

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);
  if (!multiMode && args.length > 8) {
    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
  }
  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
    }
    if (Array.isArray(arg) && arg.length > 8) {
      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');

  return {
    animation: code
  };
}

//      

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */

function backgroundImages() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

//      

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */

function borderColor() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderColor'].concat(values));
}

//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */

function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);
  if (!radius && radius !== 0) {
    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
  }
  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
  }

  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */

function borderStyle() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderStyle'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderWidth'].concat(values));
}

//      


function generateSelectors(template, state) {
  var stateSuffix = state ? ':' + state : '';
  return template(stateSuffix);
}

/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */
function statefulSelectors(states, template, stateMap) {
  if (!template) throw new Error('You must provide a template to this method.');
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];
  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new Error('You passed an unsupported selector state to this method.');
    }
    selectors.push(generateSelectors(template, states[i]));
  }
  selectors = selectors.join(',');
  return selectors;
}

//      
var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}

/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */

function buttons() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */

function margin() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['margin'].concat(values));
}

//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */

function padding() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['padding'].concat(values));
}

//      
var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];

/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(positionKeyword) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(positionKeyword) >= 0) {
    return _extends({
      position: positionKeyword
    }, directionalProperty.apply(undefined, [''].concat(values)));
  } else {
    var firstValue = positionKeyword; // in this case position is actually the first value
    return directionalProperty.apply(undefined, ['', firstValue].concat(values));
  }
}

//      

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */

function size(height) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;

  return {
    height: height,
    width: width
  };
}

//      
var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}

/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */

function textInputs() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

//      

/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */

function transitions() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    transition: properties.join(', ')
  };
}

//      
// Helpers
// Mixins
// Color
// Shorthands




/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(233)
  , createDesc     = __webpack_require__(135)
  , toIObject      = __webpack_require__(64)
  , toPrimitive    = __webpack_require__(93)
  , has            = __webpack_require__(56)
  , IE8_DOM_DEFINE = __webpack_require__(583)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(34) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(56)
  , toObject    = __webpack_require__(48)
  , IE_PROTO    = __webpack_require__(387)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAttributeDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return categories; });
/* unused harmony export sortFiltersByUserDevices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFilterDevicesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_TEMPLATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_weather_svg__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons_svg_icons_map__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_temperature__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__intl__ = __webpack_require__(453);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var actionTypes={MIXED:'mixed',QUICK_ACTION:'quick-action'};var getTemperatureList=function getTemperatureList(){var farenheit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default()(0.5,5,32.5).map(function(num){return{value:num,label:farenheit?Object(__WEBPACK_IMPORTED_MODULE_6__utils_temperature__["b" /* toFarenheit */])(num)+'\xB0F':num+'\xB0C'};});};var getHumidityList=function getHumidityList(){return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default()(5,5,100).map(function(num){return{value:num,label:num+'%'};});};var listBoostDurations=function listBoostDurations(){return[{value:1800,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].duration30Minutes},{value:3600,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].duration1Hour},{value:7200,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].duration2Hours},{value:10800,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].duration3Hours},{value:14400,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].duration4Hours},{value:18000,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].duration5Hours},{value:21600,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].duration6Hours}];};var listSunriseSunsetOffsets=function listSunriseSunsetOffsets(isSunset){return[{value:-3600,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset1HourBefore},{value:-3000,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset50MinutesBefore},{value:-2400,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset40MinutesBefore},{value:-1800,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset30MinutesBefore},{value:-1200,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset20MinutesBefore},{value:-600,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset10MinutesBefore},{value:0,label:isSunset?__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].atSunset:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].atSunrise},{value:600,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset10MinutesAfter},{value:1200,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset20MinutesAfter},{value:1800,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset30MinutesAfter},{value:2400,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset40MinutesAfter},{value:3000,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset50MinutesAfter},{value:3600,label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset1HourAfter}];};var listDarkOutsideOffset=function listDarkOutsideOffset(isSunset){var m=isSunset?{hourBefore:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset1HourBeforeSunset,minutesBefore:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offsetMinutesBeforeSunset,noOffset:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].sunset,minutesAfter:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offsetMinutesAfterSunset,hourAfter:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset1HourAfterSunset}:{hourBefore:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset1HourBeforeSunrise,minutesBefore:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offsetMinutesBeforeSunrise,noOffset:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].sunrise,minutesAfter:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offsetMinutesAfterSunrise,hourAfter:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].offset1HourAfterSunrise};return[{value:-3600,label:m.hourBefore}].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default()(600,-3000,0).map(function(num){return{value:num,label:Object.assign({},m.minutesBefore,{values:{numMinutes:Math.abs(num)/60}})};})),[{value:0,label:m.noOffset}],_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default()(600,600,3600).map(function(num){return{value:num,label:Object.assign({},m.minutesAfter,{values:{numMinutes:Math.abs(num)/60}})};})),[{value:3600,label:m.hourAfter}]);};var listBrightness=function listBrightness(){return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default()(10,10,110).reduce(function(acc,value){return[].concat(_toConsumableArray(acc),[{value:value,label:value+'%'}]);},[{value:-1,label:'Last used brightness'},{value:5,label:'5%'}]);};var getAttributeDefinition=function getAttributeDefinition(type,region){var map={'contact-sensor':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].chooseSensor,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].CONTACT_SENSOR],icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].DOOR_SENSOR,settings:{definitions:{'contact-sensor-event':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].whenSensor,defaultValue:'OPEN',id:'contact-sensor-event',propertyName:'event',values:[{value:'OPEN',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].constactSensorOpens},{value:'CLOSED',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].constactSensorCloses}]}},logic:[{settingId:'contact-sensor-event'}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].winDoorAttribute},heating:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heating,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].HEATING],icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].HEATING,settings:{definitions:{mode:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].setTo,defaultValue:'BOOST',id:'mode',propertyName:'mode',values:[{value:'SCHEDULE',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heatingSchedule},{value:'MANUAL',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heatingManual},{value:'OFF',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heatingOff},{value:'BOOST',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heatingBoost}]},setTargetTo:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].setTargetTo,defaultValue:16,id:'setTargetTo',propertyName:'target',values:getTemperatureList()},duration:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].forDuration,defaultValue:3600,id:'duration',propertyName:'duration',values:listBoostDurations()}},logic:[{settingId:'mode',ifValue:{MANUAL:[{settingId:'setTargetTo'}],BOOST:[{settingId:'setTargetTo'},{settingId:'duration'}]}}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heatingAttribute},'hive-camera':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].chooseView,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].HIVE_CAMERA],icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].CAMERA_OFF,settings:{definitions:{turnCamera:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].turnView,defaultValue:'ON',id:'turnCamera',propertyName:'status',values:[{value:'ON',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].cameraOn},{value:'OFF',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].cameraOff}]}},logic:[{settingId:'turnCamera'}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].cameraAttribute},'hive-camera-sensor':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].chooseView,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].HIVE_CAMERA],icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].CAMERA_OFF,text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].cameraAttribute},hotwater:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].hotwaterAttribute,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].HOT_WATER],icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].HOT_WATER,settings:{definitions:{mode:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].setTo,defaultValue:'BOOST',id:'mode',propertyName:'mode',values:[{value:'SCHEDULE',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heatingSchedule},{value:'MANUAL',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].hotWaterManual},{value:'OFF',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heatingOff},{value:'BOOST',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heatingBoost}]},duration:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].forDuration,defaultValue:3600,id:'duration',propertyName:'duration',values:listBoostDurations()}},logic:[{settingId:'mode',ifValue:{BOOST:[{settingId:'duration'}]}}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].hotwaterAttribute},humidity:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].chooseZone,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].NA_THERMOSTAT],icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].HUMIDITY,settings:{definitions:{'humidity-event':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].whenHumidity,defaultValue:'GT',id:'humidity-event',propertyName:'condition',values:[{value:'LT',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureBelow},{value:'GT',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureAbove}]},'humidity-below':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureBelow,defaultValue:30,id:'humidity-below',propertyName:'humidity',values:getHumidityList()},'humidity-above':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureAbove,defaultValue:60,id:'humidity-above',propertyName:'humidity',values:getHumidityList()}},logic:[{settingId:'humidity-event',ifValue:{GT:[{settingId:'humidity-above'}],LT:[{settingId:'humidity-below'}]}}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].humidityAttribute},light:{devices:__WEBPACK_IMPORTED_MODULE_4__devices__["bulbTypes"],hasDuration:true,icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].LIGHT,normaliseSettings:function normaliseSettings(_ref){var brightness=_ref.brightness,restSettings=_objectWithoutProperties(_ref,['brightness']);return brightness===-1?restSettings:Object.assign({brightness:brightness},restSettings);},settings:{definitions:{'light-status':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].turnLight,defaultValue:'ON',id:'light-status',propertyName:'status',values:[{value:'ON',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].lightOn},{value:'OFF',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].lightOff}]},'at-brightness':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].atBrightness,defaultValue:-1,id:'at-brightness',propertyName:'brightness',values:listBrightness()}},logic:[{settingId:'light-status',ifValue:{ON:[{settingId:'at-brightness'}]}}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].bulbAttribute},'light-dark':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].darkOutside,icon:__WEBPACK_IMPORTED_MODULE_3__icons_weather_svg__["a" /* default */].CLEAR_SKY,settings:{definitions:{period:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].choosePeriod,defaultValue:'DARK',hide:true,id:'period',propertyName:'period',values:[{value:'DARK',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].darkOutside},{value:'LIGHT',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].lightOutside}]},'sunset-offset':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].from,defaultValue:0,id:'sunset-offset',propertyName:'fromOffset',values:listDarkOutsideOffset(true)},'sunrise-offset':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].until,defaultValue:0,id:'sunrise-offset',propertyName:'untilOffset',values:listDarkOutsideOffset(false)}},logic:[{settingId:'period'},{settingId:'sunset-offset'},{settingId:'sunrise-offset'}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].darkAttribute},'motion-sensor':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].chooseSensor,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].MOTION_SENSOR],icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].MOTION_SENSOR,text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].motionAttribute},'na-temperature':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].chooseZone,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].NA_THERMOSTAT],icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3,settings:{definitions:{'temperature-event':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].whenTemperature,defaultValue:'GT',id:'temperature-event',propertyName:'condition',values:[{value:'LT',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureBelow},{value:'GT',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureAbove}]},'temperature-below':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureBelow,defaultValue:10,id:'temperature-below',propertyName:'temperature',values:getTemperatureList(true)},'temperature-above':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureAbove,defaultValue:25,id:'temperature-above',propertyName:'temperature',values:getTemperatureList(true)}},logic:[{settingId:'temperature-event',ifValue:{GT:[{settingId:'temperature-above'}],LT:[{settingId:'temperature-below'}]}}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].naThermostatAttribute},nathermostat:{icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].NA_THERMOSTAT],processSettings:function processSettings(settings){return Object.assign({},settings,settings.cool?{quick:'COOL'}:{},settings.heat?{quick:'HEAT'}:{});},settings:{definitions:{mode:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].setTo,defaultValue:'BOOST',hide:true,id:'mode',propertyName:'mode',values:[{value:'BOOST',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heatingBoost}]},quick:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].setTo,defaultValue:'HEAT',id:'quick',propertyName:'quick',values:[{value:'COOL',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].quickCool},{value:'HEAT',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].quickHeat}]},setHeatTargetTo:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].setTargetTo,defaultValue:22,id:'setHeatTargetTo',propertyName:'heat',values:getTemperatureList(true)},setCoolTargetTo:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].setTargetTo,defaultValue:24.5,id:'setCoolTargetTo',propertyName:'cool',values:getTemperatureList(true)},duration:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].forDuration,defaultValue:3600,id:'duration',propertyName:'duration',values:listBoostDurations()}},logic:[{settingId:'mode',ifValue:{BOOST:[{settingId:'quick',ifValue:{COOL:[{settingId:'setCoolTargetTo'},{settingId:'duration'}],HEAT:[{settingId:'setHeatTargetTo'},{settingId:'duration'}]}}]}}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].naThermostatAttribute},notification:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].notifyMe,componentType:'checkbox',icon:__WEBPACK_IMPORTED_MODULE_2__icons_general_svg__["a" /* default */].NOTIFICATIONS,settings:{definitions:{push:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].notifyPush,defaultValue:true,id:'push',propertyName:'push',values:[{value:true,label:'true'},{value:false,label:'false'}]},email:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].notifyEmail,defaultValue:false,id:'email',propertyName:'email',values:[{value:true,label:'true'},{value:false,label:'false'}]},text:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].notifyText,defaultValue:false,id:'text',propertyName:'sms',values:[{value:true,label:'true'},{value:false,label:'false'}]}},logic:[{settingId:'push'},{settingId:'email'}].concat(_toConsumableArray(region==='UK'?[{settingId:'text'}]:[]))},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].notifyMe},plug:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].choosePlug,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].ACTIVE_PLUG],hasDuration:true,icon:Object(__WEBPACK_IMPORTED_MODULE_5__icons_svg_icons_map__["b" /* productTypeToIcon */])({localeSuffix:region,type:__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].ACTIVE_PLUG}),settings:{definitions:{'plug-status':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].turnPlug,defaultValue:'ON',id:'plug-status',propertyName:'status',values:[{value:'ON',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].plugOn},{value:'OFF',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].plugOff}]}},logic:[{settingId:'plug-status'}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].plugAttribute},'quick-action':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].quickActionChosen,description:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].quickActionDescription,icon:__WEBPACK_IMPORTED_MODULE_2__icons_general_svg__["a" /* default */].DASHBOARD,text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].quickActionAttribute},schedule:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].betweenTheseTimes,componentType:'schedule',icon:__WEBPACK_IMPORTED_MODULE_2__icons_general_svg__["a" /* default */].SCHEDULE,settings:{definitions:{schedule:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].betweenTheseTimes,defaultValue:[],id:'schedule',propertyName:'schedule',values:[]}},logic:[{settingId:'schedule'}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].betweenTheseTimes},sense:{icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].SENSE,text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].senseAttribute},'sunrise-sunset':{icon:__WEBPACK_IMPORTED_MODULE_3__icons_weather_svg__["a" /* default */].SUNSET_SUNRISE,settings:{definitions:{'sunrise-sunset-event':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].whenSunriseSunset,defaultValue:'SUNRISE',id:'sunrise-sunset-event',propertyName:'event',values:[{value:'SUNRISE',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].sunrise},{value:'SUNSET',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].sunset}]},'sunrise-offset':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].sunrisePreference,defaultValue:0,id:'sunrise-offset',propertyName:'offset',values:listSunriseSunsetOffsets(false)},'sunset-offset':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].sunsetPreference,defaultValue:0,id:'sunset-offset',propertyName:'offset',values:listSunriseSunsetOffsets(true)}},logic:[{settingId:'sunrise-sunset-event',ifValue:{SUNRISE:[{settingId:'sunrise-offset'}],SUNSET:[{settingId:'sunset-offset'}]}}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].sunriseSunsetAttribute},temperature:{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heating,devices:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].HEATING],icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].GENERIC_TEMP,settings:{definitions:{'temperature-event':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].whenTemperature,defaultValue:'GT',id:'temperature-event',propertyName:'condition',values:[{value:'LT',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureBelow},{value:'GT',label:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureAbove}]},'temperature-below':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureBelow,defaultValue:10,id:'temperature-below',propertyName:'temperature',values:getTemperatureList()},'temperature-above':{chooseLabel:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureAbove,defaultValue:25,id:'temperature-above',propertyName:'temperature',values:getTemperatureList()}},logic:[{settingId:'temperature-event',ifValue:{GT:[{settingId:'temperature-above'}],LT:[{settingId:'temperature-below'}]}}]},text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].temperatureAttribute}};return Object.assign({},map[type],{type:type});};// *** Browse Icons ***
var categories=[{id:'comfort',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].comfort,icon:__WEBPACK_IMPORTED_MODULE_2__icons_general_svg__["a" /* default */].COMFORT,isUniversal:true,tagsAssociated:['comfort']},{id:'reassurance',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].reassurance,icon:__WEBPACK_IMPORTED_MODULE_2__icons_general_svg__["a" /* default */].REASSURANCE,isUniversal:true,tagsAssociated:['reassurance']},{id:'efficiency',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].efficiency,icon:__WEBPACK_IMPORTED_MODULE_2__icons_general_svg__["a" /* default */].EFFICIENCY,isUniversal:true,tagsAssociated:['efficiency']}];var sortFiltersByUserDevices=function sortFiltersByUserDevices(a,b){// both actions are related to devices user owns - no need to sort
if(a.canBeUsed&&b.canBeUsed){return 0;}// action B isn't related to a device the user owns; or action B is universal - A comes before B
if(a.canBeUsed){return-1;}// action A isn't related to a device the user owns; or action A is universal - B comes before A
if(b.canBeUsed){return 1;}// neither action is related to a device; A and B are universal
if(a.isUniversal&&b.isUniversal){return 0;}// neither action is related to a device; A is universal - A comes before B
if(a.isUniversal){return-1;}// neither action is related to a device; A is universal - A comes before B
if(b.isUniversal){return 1;}return 0;};var actionFiltersByProductType=function actionFiltersByProductType(productTypesUserOwns){return function(_ref2){var deviceTypes=_ref2.deviceTypes,deviceTypesRequired=_ref2.deviceTypesRequired,icon=_ref2.icon,id=_ref2.id,isUniversal=_ref2.isUniversal,tagsAssociated=_ref2.tagsAssociated,text=_ref2.text;return{id:id,text:text,icon:icon,isUniversal:isUniversal,canBeUsed:deviceTypes&&deviceTypes.some(function(device){return productTypesUserOwns.includes(device);}),hidden:deviceTypes&&deviceTypesRequired&&!deviceTypes.every(function(type){return productTypesUserOwns.includes(type);}),tagsAssociated:tagsAssociated};};};var getFilterDevicesList=function getFilterDevicesList(region,productTypesUserOwns){return[{id:'heating',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].heating,icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].HEATING,isUniversal:false,deviceTypes:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].BOILER_MODULE,__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].HEATING,__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].THERMOSTAT_UI,__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].THERMOSTAT],regions:['EU','UK'],tagsAssociated:['heating']},{id:'nathermostat',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].naThermostat,icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3,isUniversal:false,deviceTypes:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].NA_THERMOSTAT],regions:['NA'],tagsAssociated:['nathermostat']},{id:'hive-camera-sensor',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].cameraAttribute,icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].CAMERA_OFF,isUniversal:false,deviceTypes:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].HIVE_CAMERA],tagsAssociated:['hive-camera','hive-camera-sensor']},{id:'plug',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].plug,icon:Object(__WEBPACK_IMPORTED_MODULE_5__icons_svg_icons_map__["b" /* productTypeToIcon */])({localeSuffix:region,type:'activeplug'}),isUniversal:false,deviceTypes:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].ACTIVE_PLUG],tagsAssociated:['plug']},{id:'light',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].light,icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].LIGHT,isUniversal:false,deviceTypes:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].BULB,__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].COLOR_LIGHT,__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].TUNEABLE_LIGHT,__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].WARM_WHITE_LIGHT],tagsAssociated:['light']},{id:'motion-sensor',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].motion,icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].MOTION_SENSOR,isUniversal:false,deviceTypes:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].MOTION_SENSOR],tagsAssociated:['motion-sensor']},{id:'contact-sensor',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].contact,icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].DOOR_SENSOR,isUniversal:false,deviceTypes:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].CONTACT_SENSOR],tagsAssociated:['contact-sensor']},{id:'quick-action',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].quickAction,icon:__WEBPACK_IMPORTED_MODULE_2__icons_general_svg__["a" /* default */].DASHBOARD,isUniversal:true,tagsAssociated:['quick-action']},{id:'hotwater',text:__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].hotwaterAttribute,icon:__WEBPACK_IMPORTED_MODULE_1__icons_devices_svg__["a" /* default */].HOT_WATER,isUniversal:false,deviceTypes:[__WEBPACK_IMPORTED_MODULE_4__devices__["deviceTypes"].HOT_WATER],deviceTypesRequired:true,tagsAssociated:['hotwater']}].filter(function(item){return!item.regions||item.regions.includes(region);}).map(actionFiltersByProductType(productTypesUserOwns)).sort(sortFiltersByUserDevices);};var DEFAULT_TEMPLATE='DEFAULT';// used for actions that can't be linked to a template (e.g. old recipes)

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var isNil = __webpack_require__(98);
var isString = __webpack_require__(326);

module.exports = function isTypeName(name) {
  return isNil(name) || isString(name);
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deprecated_styles__ = __webpack_require__(2198);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var colors={butter:'rgb(255, 213, 54)',chalk:'rgb(244, 245, 246)',cranberry:'rgb(225, 41, 72)',emerald:'rgb(61, 232, 171)',evening:'rgb(92, 109, 124)',graphite:'rgb(204, 210, 214)',lime:'rgb(180, 214, 39)',merigold:'rgb(255, 185, 54)',midnight:'rgb(41, 61, 72)',orange:'rgb(255, 122, 0)',sapphire:'rgb(61, 97, 232)',slate:'rgb(51, 73, 91)',stone:'rgb(224, 228, 230)',violet:'rgb(137, 54, 255)',white:'rgb(255, 255, 255)'};var fontSizes={fs1:'14px',fs2:'16px',fs3:'18px',fs4:'20px',fs5:'24px',fs6:'36px',fs7:'48px',fs8:'60px',fs9:'72px'};var lineHeights={lh1:'18px',lh2:'20px',lh3:'22px',lh4:'24px',lh5:'28px',lh6:'40px',lh7:'52px',lh8:'64px',lh9:'76px'};var spacerSizes={ss0:'0px',ss1:'1px',ss2:'2px',ss3:'4px',ss4:'8px',ss5:'12px',ss6:'16px',ss7:'20px',ss8:'24px',ss9:'36px',ss10:'48px',ss11:'64px',ss12:'72px'};var newTheme={colors:colors,fontSizes:fontSizes,lineHeights:lineHeights,spacerSizes:spacerSizes};var theme=Object.assign({},__WEBPACK_IMPORTED_MODULE_0__deprecated_styles__["a" /* default */],newTheme);/**
 * Generate selectors for new theme
 * Usage e.g. color: ${selectors.butter};
 */// NOTE: If/when new props are added to newTheme, make sure to add the type here
/**
 * Flow has a problem inferring exact types when using spread (...)
 * So re-creating the spread functionality with this Generic type function
 */var assign=function assign(a){for(var _len=arguments.length,b=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){b[_key-1]=arguments[_key];}return Object.assign.apply(Object,[{},a].concat(_toConsumableArray(b)));};var selectors=Object.keys(newTheme).reduce(function(acc,key){return assign(acc,Object.keys(newTheme[key]).reduce(function(styles,styleKey){return assign(styles,_defineProperty({},styleKey,function(_ref// $FlowFixMe flow thinks we are trying to get non-existent props, e.g. colors.fs1
){var scTheme=_ref.theme;return scTheme[key][styleKey];}));},{}));},{});/* harmony default export */ __webpack_exports__["a"] = (theme);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('find', __webpack_require__(1496));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return scheduleType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scheduleModesEnum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return naThermostatScheduleEventKeys; });
var scheduleType={// product types
ACTIVE_PLUG:'ACTIVE_PLUG',COLOUR_TUNEABLE_LIGHT:'COLOUR_TUNEABLE_LIGHT',COLOUR_LIGHT:'COLOUR_LIGHT',HEATING:'HEATING',HOT_WATER:'HOT_WATER',NA_THERMOSTAT_COOL:'NA_THERMOSTAT_COOL',NA_THERMOSTAT_DUAL:'NA_THERMOSTAT_DUAL',NA_THERMOSTAT_HEAT:'NA_THERMOSTAT_HEAT',TUNEABLE_LIGHT:'TUNEABLE_LIGHT',WARM_WHITE_LIGHT:'WARM_WHITE_LIGHT',THERMOSTAT:'THERMOSTAT',NA_THERMOSTAT:'NA_THERMOSTAT',// others
RECIPE:'RECIPE'};var scheduleModesEnum={ADD_EVENT:'ADD_EVENT',COPY_DAY:'COPY_DAY',DEFAULT:'DEFAULT',// Changing events start & value
DELETE_EVENT:'DELETE_EVENT'};var naThermostatScheduleEventKeys={heat:'heat',cool:'cool'};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addScheduleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return attemptSaveSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cancelSaveSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return changeMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return deselectScheduleDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return completeSaveSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return copyDayEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deleteEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hidePopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return overrideSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return resetSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return setupActionFormSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return showPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return undoAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return updateEventStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return updateEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return updateDailyStartTimes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var addEvent=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ADD_EVENT */]);var addScheduleData=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ADD_SCHEDULE_DATA */]);var attemptSaveSchedule=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* ATTEMPT_SAVE_SCHEDULE */]);var cancelSaveSchedule=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CANCEL_SAVE_SCHEDULE */]);var changeMode=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CHANGE_MODE */]);var deselectScheduleDay=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DESELECT_SCHEDULE_DAY */]);var completeSaveSchedule=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* COMPLETE_SAVE_SCHEDULE */]);var copyDayEvents=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* COPY_DAY_EVENTS */]);var deleteEvent=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DELETE_EVENT */]);var hidePopup=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* HIDE_POPUP */]);var overrideSchedule=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* OVERRIDE_SCHEDULE */]);var resetSchedule=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["l" /* RESET_SCHEDULE */]);var selectDay=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* SELECT_DAY */]);var selectEvent=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SELECT_EVENT */]);var setupActionFormSchedule=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SETUP_ACTION_FORM_SCHEDULE */]);var showPopup=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SHOW_POPUP */]);var undoAll=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["q" /* UNDO_ALL */]);var updateEventStart=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["s" /* UPDATE_EVENT_START */]);var updateEventValue=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["t" /* UPDATE_EVENT_VALUE */]);var updateDailyStartTimes=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["r" /* UPDATE_DAILY_START_TIMES */]);

/***/ }),
/* 82 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(25);

module.exports = function(method, arg){
  return !!method && fails(function(){
    arg ? method.call(null, function(){}, 1) : method.call(null);
  });
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(2115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(2132);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(779);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(2134);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(2135);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(2136);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(2137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(2138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(2139);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(2140);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(2141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(2142);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(2143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BOOST_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BOOST_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DASHBOARD_ACTIONS_REMOVED_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FIRST_TIME_CUSTOMISATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HOLIDAY_MODE; });
/* unused harmony export LEAK_SENSOR_PRESENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MANUAL_TARGET_SETTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MANUAL_TARGET_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MODAL_DISMISSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SCHEDULE_STOP_TOOLTIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SEEN_OFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SENSE_ANALYTICS_SHARING_MODAL_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SENSE_SENSORS_FIRST_EVENT_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SENSE_SENSORS_FIRST_TIME_UNMUTE_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SENSE_SENSORS_HELP_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SENSE_SENSORS_NO_SMOKE_CO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return THANK_YOU_ACCEPTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return WIDGET_REMOVED_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return READY_BY_MODAL_DISMISSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return READY_BY_LEARNT_MORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return READY_BY_TOOLTIP_DISMISSED; });
var BOOST_DURATION='lastBoostDuration';var BOOST_TARGET='lastBoostTarget';var DASHBOARD_ACTIONS_REMOVED_MODAL='dashboard-actions-removed-modal';var FIRST_TIME_CUSTOMISATION_MODAL='first-time-customisation-modal';var HOLIDAY_MODE='temperature-warning-accepted';var LEAK_SENSOR_PRESENT='leak-sensor-present';var MANUAL_TARGET_SETTING='manualTargetTemperature';var MANUAL_TARGET_VALUE='manual-target-value';var MODAL_DISMISSED='modal-dismissed';var SCHEDULE_STOP_TOOLTIP='schedule-stop-tooltip';var SEEN_OFFER='seen-offer';var SENSE_ANALYTICS_SHARING_MODAL_VIEWED='sense-analytics-sharing-modal-viewed';var SENSE_SENSORS_FIRST_EVENT_VIEWED='sense-sensors-first-event-viewed';var SENSE_SENSORS_FIRST_TIME_UNMUTE_DONE='sense-sensors-first-time-unmute-done';var SENSE_SENSORS_HELP_REQUESTED='sense-sensors-help-requested';var SENSE_SENSORS_NO_SMOKE_CO='sense-sensors-does-not-have-smoke-co';var THANK_YOU_ACCEPTED='thank-you-popup-accepted';var WIDGET_REMOVED_MODAL='widget-removed-shown';var READY_BY_MODAL_DISMISSED='ready-by-modal-dismissed';var READY_BY_LEARNT_MORE='ready-by-learnt-more';var READY_BY_TOOLTIP_DISMISSED='ready-by-tooltip-dismissed';

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Convenience main entrypoint if you are running with destructuring support:
//
//   import {VelocityComponent, VelocityTransitionGroup} from 'velocity-react';
//
// You can also require just the component(s) you're using:
//
//   var VelocityComponent = require('velocity-react/velocity-component');
//
// Note that if you want to use UI Pack you will need to require 'velocity' and
// 'velocity.ui' at a top level in your app:
//
//   require('velocity');
//   require('velocity-animate/velocity.ui');

module.exports = {
  VelocityComponent: __webpack_require__(2050),
  VelocityTransitionGroup: __webpack_require__(2077),
  velocityHelpers: __webpack_require__(2102)
};

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getColour;
/* harmony export (immutable) */ __webpack_exports__["e"] = getColourRGB;
/* harmony export (immutable) */ __webpack_exports__["g"] = getRangeColours;
/* harmony export (immutable) */ __webpack_exports__["f"] = getRangeColourStrings;
/* harmony export (immutable) */ __webpack_exports__["b"] = convertRGBToHex;
/* harmony export (immutable) */ __webpack_exports__["c"] = convertTemperatureToRGB;
/* harmony export (immutable) */ __webpack_exports__["h"] = hsvToRgb;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hsvToRgbString; });
/* harmony export (immutable) */ __webpack_exports__["j"] = rgbToHsv;
/* harmony export (immutable) */ __webpack_exports__["k"] = rgbToRgbString;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return contrastRatioFromColours; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_spread__ = __webpack_require__(2407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_spread___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_spread__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_map__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished__ = __webpack_require__(70);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();// @noflow
var temperatureColours={5:{r:80,g:181,b:221},6:{r:78,g:178,b:206},7:{r:76,g:176,b:190},8:{r:73,g:173,b:175},9:{r:72,g:171,b:159},10:{r:70,g:168,b:142},11:{r:68,g:166,b:125},12:{r:66,g:164,b:108},13:{r:102,g:173,b:94},14:{r:135,g:190,b:64},15:{r:179,g:204,b:26},16:{r:214,g:213,b:28},17:{r:249,g:202,b:3},18:{r:246,g:181,b:3},19:{r:244,g:150,b:26},20:{r:236,g:110,b:5},21:{r:234,g:90,b:36},22:{r:228,g:87,b:43},23:{r:225,g:74,b:41},24:{r:224,g:65,b:39},25:{r:217,g:55,b:43},26:{r:214,g:49,b:41},27:{r:209,g:43,b:43},28:{r:205,g:40,b:47},29:{r:200,g:36,b:50},30:{r:195,g:35,b:52},31:{r:190,g:33,b:56},32:{r:185,g:32,b:59}};var hexTable={0:0,1:1,2:2,3:3,4:4,5:5,6:6,7:7,8:8,9:9,10:'A',11:'B',12:'C',13:'D',14:'E',15:'F'};var getHexParts=function getHexParts(part){var partY=part%16;var partX=(part-partY)/16;return[hexTable[partX],hexTable[partY]];};function getColour(temperature){temperature=temperature<5?5:temperature;temperature=temperature>32?32:temperature;var t=temperatureColours[Math.floor(temperature)];return'rgb('+t.r+', '+t.g+', '+t.b+')';}function getColourRGB(temperature){temperature=temperature<5?5:temperature;temperature=temperature>32?32:temperature;return temperatureColours[Math.floor(temperature)];}function getRangeColours(maxTemp,minTemp){var interval=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var rangeColors=[];for(var i=maxTemp;i>=minTemp;i-=interval){rangeColors.push(getColourRGB(parseInt(i,10)));}return rangeColors;}function getRangeColourStrings(maxTemp,minTemp){var interval=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;return getRangeColours(maxTemp,minTemp,interval).map(function(color){return'rgb('+color.r+', '+color.g+', '+color.b+')';});}function convertRGBToHex(rgbString){var numbers=rgbString.split(' ').join('').substr(4).slice(0,-1).split(',');var r=getHexParts(numbers[0]).join('');var g=getHexParts(numbers[1]).join('');var b=getHexParts(numbers[2]).join('');return'#'+r+g+b;}function convertTemperatureToRGB(kelvin){// !!!WARNING!!!
// This is not the acurate way to get the rgb from a temperature but just an approximation
// to get a colour which is close to the ones shown in the image used in the tuneable light picker
// (this image itself is not accurate). Only use for display purpose.
var green=246;var blue=Math.round(Math.sin(Math.PI/2*(kelvin-4500)/1500)*35+219);var red=Math.round(-Math.sin(Math.PI/2*(kelvin-4500)/1500)*25+230);return'rgb('+red+', '+green+', '+blue+')';}function hsvToRgb(hsv){var h=hsv.h/60;var s=hsv.s/100;var v=hsv.v/100;var hi=Math.floor(h)%6;var f=h-Math.floor(h);var p=255*v*(1-s);var q=255*v*(1-s*f);var t=255*v*(1-s*(1-f));var rgb=void 0;v*=255;switch(hi){case 0:rgb=[v,t,p];break;case 1:rgb=[q,v,p];break;case 2:rgb=[p,v,t];break;case 3:rgb=[p,q,v];break;case 4:rgb=[t,p,v];break;case 5:rgb=[v,p,q];break;default:rgb=[0,0,0];break;}var _rgb$map=rgb.map(Math.round),_rgb$map2=_slicedToArray(_rgb$map,3),red=_rgb$map2[0],green=_rgb$map2[1],blue=_rgb$map2[2];return{red:red,green:green,blue:blue};}var hsvToRgbString=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_3_polished__["d" /* rgb */],hsvToRgb);function rgbToHsv(rgb){var _rgb=_slicedToArray(rgb,3),r=_rgb[0],g=_rgb[1],b=_rgb[2];var min=Math.min(r,g,b);var max=Math.max(r,g,b);var delta=max-min;var h=void 0;var s=void 0;if(max===0){s=0;}else{s=delta/max*1000/10;}if(max===min){h=0;}else if(r===max){h=(g-b)/delta;}else if(g===max){h=2+(b-r)/delta;}else if(b===max){h=4+(r-g)/delta;}h=Math.min(h*60,360);if(h<0){h+=360;}var v=max/255*1000/10;var _map2=[h,s,v].map(Math.round);var _map3=_slicedToArray(_map2,3);h=_map3[0];s=_map3[1];v=_map3[2];return{h:h,s:s,v:v};}function rgbToRgbString(rgb){return rgb.length>=3?'rgb('+rgb[0]+', '+rgb[1]+', '+rgb[2]+')':'rgb(0, 0, 0)';}var contrastRatio=function contrastRatio(lum1,lum2){return(lum1+0.05)/(lum2+0.05);};var higherLuminance=function higherLuminance(lum1,lum2){return lum1>lum2?[lum1,lum2]:[lum2,lum1];};var luminance=function luminance(){for(var _len=arguments.length,colors=Array(_len),_key=0;_key<_len;_key++){colors[_key]=arguments[_key];}return __WEBPACK_IMPORTED_MODULE_1_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_3_polished__["b" /* getLuminance */],[].concat(colors));};var contrastRatioFromColours=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_spread___default()(contrastRatio),__WEBPACK_IMPORTED_MODULE_0_lodash_fp_spread___default()(higherLuminance),luminance);

/***/ }),
/* 91 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(275),
    isLength = __webpack_require__(370);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(31);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(3)
  , core    = __webpack_require__(109)
  , fails   = __webpack_require__(25);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx      = __webpack_require__(110)
  , IObject  = __webpack_require__(232)
  , toObject = __webpack_require__(48)
  , toLength = __webpack_require__(43)
  , asc      = __webpack_require__(1205);
module.exports = function(TYPE, $create){
  var IS_MAP        = TYPE == 1
    , IS_FILTER     = TYPE == 2
    , IS_SOME       = TYPE == 3
    , IS_EVERY      = TYPE == 4
    , IS_FIND_INDEX = TYPE == 6
    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
    , create        = $create || asc;
  return function($this, callbackfn, that){
    var O      = toObject($this)
      , self   = IObject(O)
      , f      = ctx(callbackfn, that, 3)
      , length = toLength(self.length)
      , index  = 0
      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
      , val, res;
    for(;length > index; index++)if(NO_HOLES || index in self){
      val = self[index];
      res = f(val, index, O);
      if(TYPE){
        if(IS_MAP)result[index] = res;            // map
        else if(res)switch(TYPE){
          case 3: return true;                    // some
          case 5: return val;                     // find
          case 6: return index;                   // findIndex
          case 2: result.push(val);               // filter
        } else if(IS_EVERY)return false;          // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(1392);
var util = __webpack_require__(1393);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(1394);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1926);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = function isNil(x) {
  return x === null || x === void 0;
};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('get', __webpack_require__(292));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadInstallOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadManageDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return receiveDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeDeviceError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return removedDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removedZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return renameDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return renameHubDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return renameZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return renamedDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return renamedZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return requestDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return restartHub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return restartedHub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var loadDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* LOAD_DEVICES */]);var loadInstallOptions=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* LOAD_INSTALL_OPTIONS */]);var loadManageDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* LOAD_MANAGE_DEVICES */]);var receiveDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* RECEIVE_DEVICES */]);var removeDevice=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* REMOVE_DEVICE */]);var removeDeviceError=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* REMOVE_DEVICE_ERROR */]);var removeZone=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* REMOVE_ZONE */]);var removedDevice=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* REMOVED_DEVICE */]);var removedZone=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* REMOVED_ZONE */]);var renameDevice=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["l" /* RENAME_DEVICE */]);var renameHubDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* RENAME_HUB_DEVICES */]);var renameZone=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* RENAME_ZONE */]);var renamedDevice=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* RENAMED_DEVICE */]);var renamedZone=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* RENAMED_ZONE */]);var requestDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["o" /* REQUEST_DEVICES */]);var restartHub=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["q" /* RESTART_HUB */]);var restartedHub=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["p" /* RESTARTED_HUB */]);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return toSeq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getIn; });
/* unused harmony export merge */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return includes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pick; });
/* unused harmony export getListAsChunks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
// @noflow
var toSeq=function toSeq(x){return x.toSeq();};var sortBy=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(predicate,collection){return collection.sortBy(predicate);});var map=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(predicate,collection){return collection.map(predicate);});var get=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(key,item){return item.get(key);});var getIn=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(key,item){return item.getIn(key);});var merge=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(dest,src){return dest.merge(src);});var filter=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(predicate,collection){return collection.filter(predicate);});var includes=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(collection,item){return collection.includes(item);});var find=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(predicate,collection){return collection.find(predicate);});var toJS=function toJS(collection){return collection.toJS();};var pick=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(props,map){return props.reduce(function(agg,prop){return agg.set(prop,map.get(prop));},Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({}));});/**
 * getListAsChunks : Takes an Immutable List and return it in a new list as chunks.
 * @param  { Immutable.List } An Immutable List that will be separated into chunks
 * @param  { int } The size of each chunk
 * @return { Immutable.List } An Immutable List with the original list broken into chunks
 * i.e.
 * const myList = fromJS([
 * 	{ name: 'foo' },
 * 	{ name: 'bar' },
 * 	{ name: 'fooBar' },
 * 	{ name: 'barFoo'},
 * ]);
 * const chunkedList = getListAsChunks(myList, 2);
 * //  List(
 * 		[ { name: 'foo' }, { name: 'bar' } ],
 * 		[ { name: 'fooBar' }, { name: 'barFoo'} ]
 * 	 );
 */function getListAsChunks(list,chunkSize){var iterations=Math.ceil(list.count()/chunkSize);return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,iterations).reduce(function(all,item,i){var start=i*chunkSize;var end=(i+1)*chunkSize;return all.push(list.slice(start,end));},Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]));}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTemplatesList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getNormalisedTemplates; });
/* unused harmony export getTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getIsLoadingActionsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getActionsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getOrderedActionsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getActionsListOfProductId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getActionForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentSavingState; });
/* unused harmony export triggerActionsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return initialiseFormFromAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return listDevicesForActionAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return initialiseFormFromTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return newActionEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getActionsBeingDeleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eventsByGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return quickActionStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isQuickAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isProductUsedInAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_values__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v1__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_immutable__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(182);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var getActionsState=function getActionsState(state){return state.actions||{};};var getTemplateIdFromProps=function getTemplateIdFromProps(_,_ref){var templateId=_ref.templateId;return templateId;};var getActionIdFromProps=function getActionIdFromProps(_){var props=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return props.actionId;};var getGroupFromProps=function getGroupFromProps(_,_ref2){var group=_ref2.group;return group;};var getTemplatesList=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getActionsState,function(actionsState){return actionsState.templates;});var getNormalisedTemplates=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getTemplatesList,__WEBPACK_IMPORTED_MODULE_10__user_selectors__["j" /* getUserLocale */],function(list,locale){return list.map(function(template){return Object(__WEBPACK_IMPORTED_MODULE_14__utils__["d" /* normaliseTemplate */])(template,locale);});});var getTemplate=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getTemplatesList,getTemplateIdFromProps,function(list,templateId){return list.find(function(t){return t.id===templateId;});});var getIsLoadingActionsList=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getActionsState,function(actionState){return actionState.loadingActions;});var getActionsList=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getActionsState,function(actionsState){return actionsState.actions;});var getOrderedActionsList=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getActionsList,function(actions){return actions.sort(function(a,b){if(a.enabled&&!b.enabled)return-1;if(!a.enabled&&b.enabled)return 1;if(a.created<b.created)return 1;if(a.created>b.created)return-1;return 0;});});var getActionsListOfProductId=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])([function(state){return getOrderedActionsList(state);},__WEBPACK_IMPORTED_MODULE_11__selectors__["c" /* getIdFromProps */]],function(actions,productId){return actions.filter(function(action){return action.events.some(function(event){return event.id===productId;});});});var getAction=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(function(state){return getActionsList(state);},getActionIdFromProps,function(list,actionId){return list.find(function(a){return a.id===actionId;});});var getActionForm=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getActionsState,function(actionsState){return actionsState.actionForm;});var currentSavingState=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getActionsState,function(actionsState){return actionsState.savingState;});var triggerActionsList=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getActionsState,function(actionsState){return actionsState.triggerActionsList;});var initialiseFormFromAction=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(// $FlowFixMe
getActionsState,getAction,getActionIdFromProps,function(actionsState,action,actionId){return action?Object(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* actionToForm */])(action):console.error('Unexpected Error: Action with id ('+actionId+') should exist in the list of actions');});var listDevicesForActionAttribute=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_12__products_selectors__["D" /* getProductsByTypeList */],__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_8__utils_immutable__["i" /* toJS */],Object(__WEBPACK_IMPORTED_MODULE_8__utils_immutable__["f" /* map */])(function(d){return{value:d.get('id'),label:d.getIn(['state','name'])};}),Object(__WEBPACK_IMPORTED_MODULE_8__utils_immutable__["h" /* sortBy */])(function(d){return d.get('isGroup');}),__WEBPACK_IMPORTED_MODULE_8__utils_immutable__["j" /* toSeq */]));var createActionEvent=function createActionEvent(templateEvent){return Object.assign({},templateEvent,{guid:__WEBPACK_IMPORTED_MODULE_5_uuid_v1___default()()},templateEvent.settings?{settings:Object.keys(templateEvent.settings).reduce(function(sets,key){// Flow complains about possible `event.settings` undefined
// but it is guaranteed to exist by condition above
// $FlowFixMe
return Object.assign({},sets,_defineProperty({},key,templateEvent.settings[key].value));},{})}:{});};var localeMetaFromTemplate=function localeMetaFromTemplate(template,locale){return template.meta[locale]||__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_find___default()(function(l){return l.default;}),__WEBPACK_IMPORTED_MODULE_0_lodash_fp_values___default.a)(template.meta)||{name:'',description:''};};var initialiseFormFromTemplate=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default.a,getActionsState,getTemplate,getTemplateIdFromProps,__WEBPACK_IMPORTED_MODULE_10__user_selectors__["j" /* getUserLocale */],__WEBPACK_IMPORTED_MODULE_9__config_selectors__["d" /* getIconLocaleSuffix */],function(state,actionsState,template,templateId,locale,region){if(!template){return console.error('Unexpected Error: Template with id ('+templateId+') should exist in the list of templates');}var defineActionEventsFromTemplateEvent=function defineActionEventsFromTemplateEvent(templateEvent){var definition=Object(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["d" /* getAttributeDefinition */])(templateEvent.type,region);if(!definition.devices){return[createActionEvent(templateEvent)];}// create the filter to either get all devices or just the first one depending `templateEvent.all`
var filter=templateEvent.all?__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default.a:function(arr){return arr.length?[arr[0]]:[];};var devices=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default()(filter,listDevicesForActionAttribute)(state,{types:definition.devices});return devices.map(function(device){return Object.assign({},createActionEvent(templateEvent),{id:device.value});});};var defineActionEvents=function defineActionEvents(acc,templateEvent){return templateEvent.required||templateEvent.default?Object.assign({},acc,_defineProperty({},templateEvent.group,[].concat(_toConsumableArray(acc[templateEvent.group]),_toConsumableArray(defineActionEventsFromTemplateEvent(templateEvent))))):acc;};var groups=template.events.reduce(defineActionEvents,{when:[],while:[],then:[]});return Object.assign({enabled:true,name:localeMetaFromTemplate(template,locale).name,status:'new',tags:template.meta.tags,template:{id:template.id,version:template.version}},groups);});var getEventFromProps=function getEventFromProps(_,props){return props.event;};var newActionEvent=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default.a,getEventFromProps,getActionForm,__WEBPACK_IMPORTED_MODULE_9__config_selectors__["d" /* getIconLocaleSuffix */],function(state,templateEvent,actionForm,region){var definition=Object(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["d" /* getAttributeDefinition */])(templateEvent.type,region);var devices=listDevicesForActionAttribute(state,{types:definition.devices||[]}).filter(// check the device is not already used in another event of the same type
function(device){return!(actionForm!=='none'&&__WEBPACK_IMPORTED_MODULE_1_lodash_fp_some___default()({type:templateEvent.type,id:device.value},actionForm[templateEvent.group]));});return Object.assign({},createActionEvent(templateEvent),devices.length?{id:devices[0].value}:{});});var getActionsBeingDeleted=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getActionsState,function(actionsState){return actionsState.actionsBeingDeleted;});var eventsByGroup=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getTemplate,getGroupFromProps,__WEBPACK_IMPORTED_MODULE_13__devices_selectors__["N" /* getIsHubNano1 */],function(template,group,isNano1){return template?template.events.reduce(function(acc,event){return event.group===group&&(!isNano1||!(event.incompatible||[]).includes('NANO1'))?[].concat(_toConsumableArray(acc),[event]):acc;},[]):[];});var quickActionStatus=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(triggerActionsList,getActionIdFromProps,function(triggerActionsList,actionId){var actionStatus=triggerActionsList.find(function(a){return a.id===actionId;});if(actionStatus){return actionStatus;}return{displayState:__WEBPACK_IMPORTED_MODULE_15__constants__["m" /* IDLE */]};});var isQuickAction=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getAction,function(){var action=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some___default()(['type',__WEBPACK_IMPORTED_MODULE_6__constants_actions__["b" /* actionTypes */].QUICK_ACTION],action.events);});// $FlowFixMe
var isProductUsedInAction=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(function(state){return getActionsList(state);},__WEBPACK_IMPORTED_MODULE_11__selectors__["c" /* getIdFromProps */],function(actionsList,productId){return __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some___default()(function(a){return __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some___default()(['id',productId],a.events);},actionsList);});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getProducts"] = getProducts;
/* harmony export (immutable) */ __webpack_exports__["patchProduct"] = patchProduct;
/* harmony export (immutable) */ __webpack_exports__["restartHub"] = restartHub;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
function getProducts(after){var getProductsURL=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'products',query:{after:after}});return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])(getProductsURL);}function patchProduct(patch,productType,id){var patchProductsURL=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'nodes/'+productType+'/'+id});return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])(patchProductsURL,patch);}function restartHub(id){var restartHubURL=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'nodes/hub/'+id});return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])(restartHubURL,{reboot:true});}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addActionAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return attemptCreateAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return attemptEditAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return attemptRemoveAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return attemptTriggerQuickAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cancelForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return editAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return endAttempt; });
/* unused harmony export endAttemptCreateAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return loadForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return makeEndAttemptCreateAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return receiveActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return receiveTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return removeActionAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return removeActionFromList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return removeActionFromDeleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return setActionAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return setActionForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return triggerQuickAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return resetQuickActionStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(182);
var addActionAttribute=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ADD_ACTION_ATTRIBUTE */]);var attemptCreateAction=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ATTEMPT_CREATE_ACTION */]);var attemptEditAction=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ATTEMPT_EDIT_ACTION */]);var attemptRemoveAction=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ATTEMPT_REMOVE_ACTION */]);var attemptTriggerQuickAction=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ATTEMPT_TRIGGER_QUICK_ACTION */]);var cancelForm=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* CANCEL_FORM */]);var editAction=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* EDIT_ACTION */]);var endAttempt=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* END_ATTEMPT */]);var endAttemptCreateAction=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* END_ATTEMPT_CREATE_ACTION */]);var getActions=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* GET_ACTIONS */]);var getTemplates=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* GET_TEMPLATES */]);var loadForm=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* LOAD_FORM */]);var makeEndAttemptCreateAction=function makeEndAttemptCreateAction(_ref){var newAction=_ref.newAction,created=_ref.created;return Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* END_ATTEMPT_CREATE_ACTION */],function(_ref2){var nodeId=_ref2.nodeId;return Object.assign({},newAction,{created:created,id:nodeId});});};var receiveActions=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* RECEIVE_ACTIONS */]);var receiveTemplates=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* RECEIVE_TEMPLATES */]);var removeActionAttribute=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* REMOVE_ACTION_ATTRIBUTE */]);var removeActionFromList=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* REMOVE_ACTION_FROM_LIST */]);var removeActionFromDeleteList=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* REMOVE_ACTION_FROM_DELETE_LIST */]);var setActionAttribute=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* SET_ACTION_ATTRIBUTE */]);var setActionForm=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_ACTION_FORM */]);var triggerQuickAction=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* TRIGGER_QUICK_ACTION */]);var resetQuickActionStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* RESET_QUICK_ACTION_STATUS */]);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(369);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(559),
    baseKeys = __webpack_require__(371),
    isArrayLike = __webpack_require__(92);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(63);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if(__webpack_require__(34)){
  var LIBRARY             = __webpack_require__(155)
    , global              = __webpack_require__(22)
    , fails               = __webpack_require__(25)
    , $export             = __webpack_require__(3)
    , $typed              = __webpack_require__(304)
    , $buffer             = __webpack_require__(410)
    , ctx                 = __webpack_require__(110)
    , anInstance          = __webpack_require__(161)
    , propertyDesc        = __webpack_require__(135)
    , hide                = __webpack_require__(61)
    , redefineAll         = __webpack_require__(162)
    , toInteger           = __webpack_require__(137)
    , toLength            = __webpack_require__(43)
    , toIndex             = __webpack_require__(157)
    , toPrimitive         = __webpack_require__(93)
    , has                 = __webpack_require__(56)
    , same                = __webpack_require__(589)
    , classof             = __webpack_require__(234)
    , isObject            = __webpack_require__(31)
    , toObject            = __webpack_require__(48)
    , isArrayIter         = __webpack_require__(402)
    , create              = __webpack_require__(158)
    , getPrototypeOf      = __webpack_require__(73)
    , gOPN                = __webpack_require__(159).f
    , getIterFn           = __webpack_require__(404)
    , uid                 = __webpack_require__(154)
    , wks                 = __webpack_require__(33)
    , createArrayMethod   = __webpack_require__(95)
    , createArrayIncludes = __webpack_require__(296)
    , speciesConstructor  = __webpack_require__(407)
    , ArrayIterators      = __webpack_require__(406)
    , Iterators           = __webpack_require__(193)
    , $iterDetect         = __webpack_require__(300)
    , setSpecies          = __webpack_require__(160)
    , arrayFill           = __webpack_require__(405)
    , arrayCopyWithin     = __webpack_require__(598)
    , $DP                 = __webpack_require__(35)
    , $GOPD               = __webpack_require__(72)
    , dP                  = $DP.f
    , gOPD                = $GOPD.f
    , RangeError          = global.RangeError
    , TypeError           = global.TypeError
    , Uint8Array          = global.Uint8Array
    , ARRAY_BUFFER        = 'ArrayBuffer'
    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
    , PROTOTYPE           = 'prototype'
    , ArrayProto          = Array[PROTOTYPE]
    , $ArrayBuffer        = $buffer.ArrayBuffer
    , $DataView           = $buffer.DataView
    , arrayForEach        = createArrayMethod(0)
    , arrayFilter         = createArrayMethod(2)
    , arraySome           = createArrayMethod(3)
    , arrayEvery          = createArrayMethod(4)
    , arrayFind           = createArrayMethod(5)
    , arrayFindIndex      = createArrayMethod(6)
    , arrayIncludes       = createArrayIncludes(true)
    , arrayIndexOf        = createArrayIncludes(false)
    , arrayValues         = ArrayIterators.values
    , arrayKeys           = ArrayIterators.keys
    , arrayEntries        = ArrayIterators.entries
    , arrayLastIndexOf    = ArrayProto.lastIndexOf
    , arrayReduce         = ArrayProto.reduce
    , arrayReduceRight    = ArrayProto.reduceRight
    , arrayJoin           = ArrayProto.join
    , arraySort           = ArrayProto.sort
    , arraySlice          = ArrayProto.slice
    , arrayToString       = ArrayProto.toString
    , arrayToLocaleString = ArrayProto.toLocaleString
    , ITERATOR            = wks('iterator')
    , TAG                 = wks('toStringTag')
    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
    , DEF_CONSTRUCTOR     = uid('def_constructor')
    , ALL_CONSTRUCTORS    = $typed.CONSTR
    , TYPED_ARRAY         = $typed.TYPED
    , VIEW                = $typed.VIEW
    , WRONG_LENGTH        = 'Wrong length!';

  var $map = createArrayMethod(1, function(O, length){
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function(){
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
    new Uint8Array(1).set({});
  });

  var strictToLength = function(it, SAME){
    if(it === undefined)throw TypeError(WRONG_LENGTH);
    var number = +it
      , length = toLength(it);
    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
    return length;
  };

  var toOffset = function(it, BYTES){
    var offset = toInteger(it);
    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function(it){
    if(isObject(it) && TYPED_ARRAY in it)return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function(C, length){
    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function(O, list){
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function(C, list){
    var index  = 0
      , length = list.length
      , result = allocate(C, length);
    while(length > index)result[index] = list[index++];
    return result;
  };

  var addGetter = function(it, key, internal){
    dP(it, key, {get: function(){ return this._d[internal]; }});
  };

  var $from = function from(source /*, mapfn, thisArg */){
    var O       = toObject(source)
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , iterFn  = getIterFn(O)
      , i, length, values, result, step, iterator;
    if(iterFn != undefined && !isArrayIter(iterFn)){
      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
        values.push(step.value);
      } O = values;
    }
    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/*...items*/){
    var index  = 0
      , length = arguments.length
      , result = allocate(this, length);
    while(length > index)result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString(){
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /*, end */){
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /*, thisArg */){
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /*, thisArg */){
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /*, thisArg */){
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /*, thisArg */){
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /*, thisArg */){
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /*, fromIndex */){
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /*, fromIndex */){
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator){ // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /*, thisArg */){
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse(){
      var that   = this
        , length = validate(that).length
        , middle = Math.floor(length / 2)
        , index  = 0
        , value;
      while(index < middle){
        value         = that[index];
        that[index++] = that[--length];
        that[length]  = value;
      } return that;
    },
    some: function some(callbackfn /*, thisArg */){
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn){
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end){
      var O      = validate(this)
        , length = O.length
        , $begin = toIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end){
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /*, offset */){
    validate(this);
    var offset = toOffset(arguments[1], 1)
      , length = this.length
      , src    = toObject(arrayLike)
      , len    = toLength(src.length)
      , index  = 0;
    if(len + offset > length)throw RangeError(WRONG_LENGTH);
    while(index < len)this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries(){
      return arrayEntries.call(validate(this));
    },
    keys: function keys(){
      return arrayKeys.call(validate(this));
    },
    values: function values(){
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function(target, key){
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key){
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc){
    if(isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ){
      target[key] = desc.value;
      return target;
    } else return dP(target, key, desc);
  };

  if(!ALL_CONSTRUCTORS){
    $GOPD.f = $getDesc;
    $DP.f   = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty:           $setDesc
  });

  if(fails(function(){ arrayToString.call({}); })){
    arrayToString = arrayToLocaleString = function toString(){
      return arrayJoin.call(this);
    }
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice:          $slice,
    set:            $set,
    constructor:    function(){ /* noop */ },
    toString:       arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function(){ return this[TYPED_ARRAY]; }
  });

  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
    CLAMPED = !!CLAMPED;
    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
      , ISNT_UINT8 = NAME != 'Uint8Array'
      , GETTER     = 'get' + KEY
      , SETTER     = 'set' + KEY
      , TypedArray = global[NAME]
      , Base       = TypedArray || {}
      , TAC        = TypedArray && getPrototypeOf(TypedArray)
      , FORCED     = !TypedArray || !$typed.ABV
      , O          = {}
      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function(that, index){
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function(that, index, value){
      var data = that._d;
      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function(that, index){
      dP(that, index, {
        get: function(){
          return getter(this, index);
        },
        set: function(value){
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if(FORCED){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME, '_d');
        var index  = 0
          , offset = 0
          , buffer, byteLength, length, klass;
        if(!isObject(data)){
          length     = strictToLength(data, true)
          byteLength = length * BYTES;
          buffer     = new $ArrayBuffer(byteLength);
        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if($length === undefined){
            if($len % BYTES)throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if(TYPED_ARRAY in data){
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while(index < length)addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if(!$iterDetect(function(iter){
      // V8 works with iterators, but fails in many other cases
      // https://code.google.com/p/v8/issues/detail?id=4552
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)){
      TypedArray = wrapper(function(that, data, $offset, $length){
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
      , $iterator         = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
      dP(TypedArrayPrototype, TAG, {
        get: function(){ return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES,
      from: $from,
      of: $of
    });

    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});

    $export($export.P + $export.F * fails(function(){
      new TypedArray(1).slice();
    }), NAME, {slice: $slice});

    $export($export.P + $export.F * (fails(function(){
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
    }) || !fails(function(){
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, {toLocaleString: $toLocaleString});

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function(){ /* empty */ };

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Map     = __webpack_require__(601)
  , $export = __webpack_require__(3)
  , shared  = __webpack_require__(295)('metadata')
  , store   = shared.store || (shared.store = new (__webpack_require__(604)));

var getOrCreateMetadataMap = function(target, targetKey, create){
  var targetMetadata = store.get(target);
  if(!targetMetadata){
    if(!create)return undefined;
    store.set(target, targetMetadata = new Map);
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if(!keyMetadata){
    if(!create)return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map);
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function(target, targetKey){
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
    , keys        = [];
  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
  return keys;
};
var toMetaKey = function(it){
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function(O){
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_cookie__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tiny_cookie__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var options={secure:global.location.protocol==='https:'};function loadCookies(){return(document&&document.cookie?decodeURIComponent(document.cookie):'').split(';').reduce(function(all,cookie){var _cookie$split=cookie.split('='),_cookie$split2=_slicedToArray(_cookie$split,2),_cookie$split2$=_cookie$split2[0],key=_cookie$split2$===undefined?'':_cookie$split2$,_cookie$split2$2=_cookie$split2[1],value=_cookie$split2$2===undefined?'':_cookie$split2$2;all[key.trim()]=value.trim();return all;},{});}/* harmony default export */ __webpack_exports__["a"] = (Object.assign({},__WEBPACK_IMPORTED_MODULE_0_tiny_cookie___default.a,{set:function set(key,value){return __WEBPACK_IMPORTED_MODULE_0_tiny_cookie___default.a.set(key,value,options);},load:loadCookies}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(470)('wks')
  , uid        = __webpack_require__(321)
  , Symbol     = __webpack_require__(140).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var isNil = __webpack_require__(98);
var isArray = __webpack_require__(116);

module.exports = function isObject(x) {
  return !isNil(x) && typeof x === 'object' && !isArray(x);
};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = function isArray(x) {
  return Array.isArray ? Array.isArray(x) : x instanceof Array;
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var Boolean = __webpack_require__(751);
var isType = __webpack_require__(59);
var getTypeName = __webpack_require__(53);

// return true if the type constructor behaves like the identity function
module.exports = function isIdentity(type) {
  if (isType(type)) {
    if (false) {
      assert(Boolean.is(type.meta.identity), function () { return 'Invalid meta identity ' + assert.stringify(type.meta.identity) + ' supplied to type ' + getTypeName(type); });
    }
    return type.meta.identity;
  }
  // for tcomb the other constructors, like ES6 classes, are identity-like
  return true;
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isType = __webpack_require__(59);
var getFunctionName = __webpack_require__(245);
var assert = __webpack_require__(36);
var stringify = __webpack_require__(750);

// creates an instance of a type, handling the optional new operator
module.exports = function create(type, value, path) {
  if (isType(type)) {
    return !type.meta.identity && typeof value === 'object' && value !== null ? new type(value, path): type(value, path);
  }

  if (false) {
    // here type should be a class constructor and value some instance, just check membership and return the value
    path = path || [getFunctionName(type)];
    assert(value instanceof type, function () { return 'Invalid value ' + stringify(value) + ' supplied to ' + path.join('/'); });
  }

  return value;
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var isType = __webpack_require__(59);

// returns true if x is an instance of type
module.exports = function is(x, type) {
  if (isType(type)) {
    return type.is(x);
  }
  return x instanceof type; // type should be a class constructor
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

module.exports = toObject;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(329),
    isLength = __webpack_require__(212),
    isObjectLike = __webpack_require__(211);

/** `Object#toString` result references. */
var arrayTag = '[object Array]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

module.exports = isArray;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createValidator;

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(308);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _markAsValueValidator = __webpack_require__(787);

var _markAsValueValidator2 = _interopRequireDefault(_markAsValueValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createValidator(curriedDefinition, defaultMessageCreator) {
  var messageCreatorIsString = typeof defaultMessageCreator === 'string';

  (0, _invariant2.default)(messageCreatorIsString || typeof defaultMessageCreator === 'function', 'Please provide a message string or message creator function');

  return function validator(config, value, allValues) {
    var configIsObject = (0, _isPlainObject2.default)(config);

    if (!messageCreatorIsString) {
      (0, _invariant2.default)(typeof config === 'string' || configIsObject, 'Please provide a string or configuration object with a `field` or ' + '`message` property');

      if (configIsObject) {
        (0, _invariant2.default)('field' in config || 'message' in config, 'Please provide a `field` or `message` property');
      }
    }

    var message = void 0;

    if (configIsObject && 'message' in config) {
      message = config.message;
    } else if (messageCreatorIsString) {
      message = defaultMessageCreator;
    } else if (configIsObject) {
      message = defaultMessageCreator(config.field);
    } else {
      message = defaultMessageCreator(config);
    }

    var valueValidator = curriedDefinition(message);

    if (arguments.length <= 1) {
      return (0, _markAsValueValidator2.default)(valueValidator);
    }

    return valueValidator(value, allValues);
  };
}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MenuIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MenuContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Menu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MenuItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    height: 1em;\n    width: 1em;\n'],['\n    height: 1em;\n    width: 1em;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    z-index: 500;\n    bottom: ',';\n    left: 0;\n    width: 100%;\n    font-size: ',';\n'],['\n    position: absolute;\n    z-index: 500;\n    bottom: ',';\n    left: 0;\n    width: 100%;\n    font-size: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    z-index: 500;\n    width: 100%;\n    margin: 0;\n'],['\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    z-index: 500;\n    width: 100%;\n    margin: 0;\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: ',';\n    cursor: ',';\n    flex-grow: 1;\n\n    a {\n        color: ',';\n    }\n\n    svg g {\n        fill: ',';\n    }\n'],['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: ',';\n    cursor: ',';\n    flex-grow: 1;\n\n    a {\n        color: ',';\n    }\n\n    svg g {\n        fill: ',';\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MenuIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject);var MenuContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.isSmall?'-1em':'-.75em';},function(props){return props.isSmall?'2em':'2.5em';});var Menu=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ul(_templateObject3);var MenuItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].li(_templateObject4,function(props){return props.enabled?'#000000':'#CCCCCC';},function(props){return props.enabled?'pointer':'auto';},function(props){return props.enabled?'#000000':'#CCCCCC';},function(props){return props.enabled?'#000000':'#CCCCCC';});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activePlugs", function() { return activePlugs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bulbs", function() { return bulbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "camera", function() { return camera; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePassword", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePin", function() { return changePin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectedCareInvite", function() { return connectedCareInvite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contactSensor", function() { return contactSensor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dashboard", function() { return dashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dev", function() { return dev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "devices", function() { return devices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forgottenPassword", function() { return forgottenPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heating", function() { return heating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "help", function() { return help; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "holidayMode", function() { return holidayMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hiveButton", function() { return hiveButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hotwater", function() { return hotwater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installDevices", function() { return installDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installDevicePlacement", function() { return installDevicePlacement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installDevicesInstructions", function() { return installDevicesInstructions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installDevicesFound", function() { return installDevicesFound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installDevicesTroubleshooting", function() { return installDevicesTroubleshooting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installDevicesTroubleshootingClean", function() { return installDevicesTroubleshootingClean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installHive2", function() { return installHive2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installHive2InsertBatteries", function() { return installHive2InsertBatteries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installHive2RemoveBatteries", function() { return installHive2RemoveBatteries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installHive2WrongProduct", function() { return installHive2WrongProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installHub", function() { return installHub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installPhilipsHue", function() { return installPhilipsHue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installPhilipsHueSearch", function() { return installPhilipsHueSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installMe", function() { return installMe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installSLT3SLT3BUpgrade", function() { return installSLT3SLT3BUpgrade; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installSLT3SLT3BAcquireStat", function() { return installSLT3SLT3BAcquireStat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installSLT3SLT3BUpgradeInsertBatteries", function() { return installSLT3SLT3BUpgradeInsertBatteries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installSLT3SLT3BUpgradeRemoveBatteries", function() { return installSLT3SLT3BUpgradeRemoveBatteries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installSLT3SLT3BUpgradeWrongProduct", function() { return installSLT3SLT3BUpgradeWrongProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installZones", function() { return installZones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installZonesFirmwareUpdate", function() { return installZonesFirmwareUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installZonesWrongProduct", function() { return installZonesWrongProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "leakSensor", function() { return leakSensor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "manageDevice", function() { return manageDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "manageHome", function() { return manageHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "motionSensor", function() { return motionSensor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "myAccount", function() { return myAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nathermostat", function() { return nathermostat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notifications", function() { return notifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "products", function() { return products; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readyByFindOutMore", function() { return readyByFindOutMore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readyBySetUp", function() { return readyBySetUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "recipes", function() { return recipes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPassword", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPasswordCognito", function() { return resetPasswordCognito; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPasswordBiq", function() { return resetPasswordBiq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rootPage", function() { return rootPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sense", function() { return sense; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shop", function() { return shop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sso", function() { return sso; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textControl", function() { return textControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "upgradeNano1Hub", function() { return upgradeNano1Hub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wiringError", function() { return wiringError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrongProduct", function() { return wrongProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mimic", function() { return mimic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "devicesGroups", function() { return devicesGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postinstallGroups", function() { return postinstallGroups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__devices__ = __webpack_require__(12);
var activePlugs='/products/'+__WEBPACK_IMPORTED_MODULE_0__devices__["deviceTypes"].ACTIVE_PLUG+'/:id';var bulbs='/products/'+__WEBPACK_IMPORTED_MODULE_0__devices__["deviceTypes"].BULB+'/:id';var camera='/camera-hold';var changePassword='/change-password';var changePin='/change-pin';var connectedCareInvite='/accept-hive-link-invite/:token';var contactSensor='/products/'+__WEBPACK_IMPORTED_MODULE_0__devices__["deviceTypes"].CONTACT_SENSOR+'/:id';var dashboard='/dashboard';var dev='/dev/:item?';var devices='/devices';var forgottenPassword='/forgotten-password';var heating='/products/'+__WEBPACK_IMPORTED_MODULE_0__devices__["deviceTypes"].HEATING+'/:id';var help='/help';var holidayMode='/holiday-mode';var hiveButton='/products/'+__WEBPACK_IMPORTED_MODULE_0__devices__["deviceTypes"].HIVE_BUTTON+'/:id';var hotwater='/products/'+__WEBPACK_IMPORTED_MODULE_0__devices__["deviceTypes"].HOT_WATER+'/:id';var install='/install';var installDevices='/install/devices';var installDevicePlacement='/install/devices/device-placement';var installDevicesInstructions='/install/devices/instructions';var installDevicesFound='/install/devices/found';var installDevicesTroubleshooting='/install/devices/troubleshooting/:from?';var installDevicesTroubleshootingClean='/install/devices/troubleshooting';var installHive2='/install/hive2';var installHive2InsertBatteries='/install/hive2/insert-batteries';var installHive2RemoveBatteries='/install/hive2/remove-batteries';var installHive2WrongProduct='/install/hive2/wrong-product';var installHub='/install/hub';var installPhilipsHue='/install/philips-hue/:id';var installPhilipsHueSearch='/install/philips-hue';var installMe='/installme';var installSLT3SLT3BUpgrade='/install/install-slt3-slt3b-upgrade';var installSLT3SLT3BAcquireStat='/install/install-slt3-slt3b-acquire-stat';var installSLT3SLT3BUpgradeInsertBatteries='/install/slt3-slt3b/insert-batteries';var installSLT3SLT3BUpgradeRemoveBatteries='/install/slt3-slt3b/remove-batteries';var installSLT3SLT3BUpgradeWrongProduct='/install/slt3-slt3b/wrong-product';var installZones='/install/zones';var installZonesFirmwareUpdate='/install/zones/firmware-update';var installZonesWrongProduct='/install/zones/wrong-product';var leakSensor='/products/'+__WEBPACK_IMPORTED_MODULE_0__devices__["deviceTypes"].LEAK_SENSOR+'/:id';var login='/login';var logout='/logout';var manageDevice='/devices/:id';var manageHome='/home/manage';var motionSensor='/products/'+__WEBPACK_IMPORTED_MODULE_0__devices__["deviceTypes"].MOTION_SENSOR+'/:id';var myAccount='/my-account';var nathermostat='/products/'+__WEBPACK_IMPORTED_MODULE_0__devices__["deviceTypes"].THERMOSTAT+'/:id';var notifications='/notifications';var products='/products/:productType/:id';var readyByFindOutMore='/ready-by';var readyBySetUp='/ready-by-set-up';var recipes='/actions';var resetPassword='/forgotten-password/:token';var resetPasswordCognito='/reset-password';var resetPasswordBiq='/reset-password-biq';var rootPage='/';var sense='/products/sense/:id';var shop='/shop';var sso='/sso';var textControl='/text-control';var upgradeNano1Hub='/install/install-nano1-upgrade';var wiringError='/wiring-error';var wrongProduct='/wrong-product';var mimic='/mimic-mode';var devicesGroups='/devices?tab=groups';var postinstallGroups='/postinstall/groups';

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('curry', __webpack_require__(382));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAppSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveAppSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setAppSettings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var getAppSettings=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* GET_APP_SETTINGS */]);var receiveAppSettings=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* RECEIVE_APP_SETTINGS */]);var setAppSettings=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_APP_SETTINGS */]);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAppSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAppSetting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
var getAllAppSettings=function getAllAppSettings(state){return state.appSettings;};var getSettingKeyFromProps=function getSettingKeyFromProps(_,key){return key;};var getAppSettings=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAllAppSettings,function(settings){return settings.get('settings');});var getAppSetting=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAppSettings,getSettingKeyFromProps,function(settings,key){return settings.get(key);});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVE_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PRODUCT_MODE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PRODUCT_MODE_CHANGE_UPDATE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MODIFY_PRODUCT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UNDO_PRODUCT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RENAME_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RENAME_PRODUCT_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REMOVE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REMOVE_PRODUCT_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MALFORMED_NODE_DESCRIPTOR; });
var GET_PRODUCTS='hive/products/GET_PRODUCTS';var RECEIVE_PRODUCTS='hive/products/RECEIVE_PRODUCTS';var PRODUCT_MODE_CHANGE='hive/product/mode_change';var PRODUCT_MODE_CHANGE_UPDATE_PRODUCT='hive/product/mode_change/UPDATE_PRODUCT';var MODIFY_PRODUCT_STATE='hive/product/modify-state';var UNDO_PRODUCT_CHANGE='hive/products/undo-product-change';var RENAME_PRODUCT='hive/products/RENAME';var RENAME_PRODUCT_ZONE='hive/products/RENAME_ZONE';var REMOVE_PRODUCT='hive/products/REMOVE';var REMOVE_PRODUCT_ZONE='hive/products/REMOVE_ZONE';var MALFORMED_NODE_DESCRIPTOR='MALFORMED_NODE_DESCRIPTOR';

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('debounce', __webpack_require__(842));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1966);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('range', __webpack_require__(660));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('map', __webpack_require__(1450));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return templateTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return notificationTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consumerPropertyTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return recipeStatus; });
var templateTypes={notifyMotion:'motion-sensor-notify',notifyOpenContact:'contact-sensor-opened-notify',notifyClosedContact:'contact-sensor-closed-notify',modifyPlugWhenMotion:'motion-sensor-activeplug-on-off',modifyPlugWhenOpenContact:'contact-sensor-opened-activeplug-on-off',modifyPlugWhenClosedContact:'contact-sensor-closed-activeplug-on-off',modifyLightWhenMotion:'motion-sensor-light-on-off',modifyLightWhenOpenContact:'contact-sensor-opened-light-on-off',modifyLightWhenClosedContact:'contact-sensor-closed-light-on-off',motionSensorHeatingMode:'motion-sensor-heating-mode',contactSensorOpenedHeatingMode:'contact-sensor-opened-heating-mode',contactSensorClosedHeatingMode:'contact-sensor-closed-heating-mode',hiveButtonPressedActivePlugOnOff:'hive-button-pressed-activeplug-on-off',hiveButtonDoublePressedActivePlugOnOff:'hive-button-double-pressed-activeplug-on-off',hiveButtonLongHoldPressedActivePlugOnOff:'hive-button-long-hold-pressed-activeplug-on-off',hiveButtonPressedLightOnOff:'hive-button-pressed-light-on-off',hiveButtonDoublePressedLightOnOff:'hive-button-double-pressed-light-on-off',hiveButtonLongHoldPressedLightOnOff:'hive-button-long-hold-pressed-light-on-off',hiveButtonPressedHeatingMode:'hive-button-pressed-heating-mode',hiveButtonDoublePressedHeatingMode:'hive-button-double-pressed-heating-mode',hiveButtonLongHoldPressedHeatingMode:'hive-button-long-hold-pressed-heating-mode'};var notificationTypes={email:'email',push:'push',sms:'sms'};var consumerPropertyTypes={duration:'duration',changeLightOnOff:'changeLightOnOff',changePlugOnOff:'changePlugOnOff',changeHeatingMode:'changeHeatingMode',changeHeatingTarget:'changeHeatingTarget',changeHeatingBoost:'changeHeatingBoost'};var recipeStatus={CONFIRMING:'CONFIRMING',CREATING:'CREATING',DEFINING:'DEFINING',DELETING:'DELETING',DISPLAYING:'DISPLAYING',EDITING:'EDITING',UPDATING:'UPDATING'};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(185),
    getRawTag = __webpack_require__(1029),
    objectToString = __webpack_require__(1030);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(154)('meta')
  , isObject = __webpack_require__(31)
  , has      = __webpack_require__(56)
  , setDesc  = __webpack_require__(35).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(25)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(626);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATE_TIME_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return POLL_API_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return POLL_API_STOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_TIMEZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_PRODUCTS_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NUMBER_OF_DAYS_DISPLAYED; });
var DATE_TIME_INTERVAL='hive/hub/DATE_TIME_INTERVAL';var POLL_API_START='hive/hub/POLL_API_START';var POLL_API_STOP='hive/hub/POLL_API_STOP';var DEFAULT_TIMEZONE='Europe/London';var INTERVAL=60000;var GET_PRODUCTS_INTERVAL=50000;var NUMBER_OF_DAYS_DISPLAYED=7;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2122)();
}


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(335);
var momentValidationWrapper = __webpack_require__(2211);

moment.createFromInputFallback = function(config) {
  config._d = new Date(config._i);
};

var ANONYMOUS = '<<anonymous>>';

var ReactPropTypeLocationNames = {
  prop : 'prop',
  context : 'context',
  childContext : 'child context',
};

function createInvalidRequiredErrorMessage(propName, componentName, value) {
  return new Error(
    'The prop `' + propName + '` is marked as required in `' + componentName + '`, but its value is `' + value + '`.'
  );
}

function createMomentChecker(type, typeValidator, validator, momentType) {

  function propValidator(
    isRequired, // Bound parameter to indicate with the propType is required
    predicate, // Bound parameter to allow user to add dynamic validation
    props,
    propName,
    componentName,
    location,
    propFullName
  ) {
    var propValue = props[ propName ];
    var propType = typeof propValue;

    var isPropValueUndefined = typeof propValue === 'undefined';
    var isPropValueNull = propValue === null;

    if (isRequired) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (isPropValueUndefined) {
        return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
      } else if (isPropValueNull) {
        return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
      }
    }

    if (isPropValueUndefined || isPropValueNull) {
      return null;
    }

    if (typeValidator && !typeValidator(propValue)) {
      return new Error(
        'Invalid input type: `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + type + '`.'
      );
    }

    if (! validator(propValue)) {
      return new Error(
        'Invalid ' + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
      );
    }

    if (predicate && ! predicate(propValue)) {
      var predicateName = predicate.name || ANONYMOUS;
      return new Error(
        'Invalid ' + location + ' `' + propName + '` of type `' + propType + '` ' +
        'supplied to `' + componentName + '`. Failed to succeed with predicate `' +
        predicateName + '`.'
      );
    }

    return null;

  }

  var requiredPropValidator = propValidator.bind(null, false, null);
  requiredPropValidator.isRequired = propValidator.bind(null, true, null);
  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
    if (typeof predicate !== 'function') {
      throw new Error('`predicate` must be a function');
    }
    var basePropValidator = propValidator.bind(null, false, predicate);
    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
    return basePropValidator;
  };

  return requiredPropValidator;

}

module.exports = {

  momentObj : createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(value);
    },
    'Moment'
  ),

  momentString : createMomentChecker(
    'string',
    function(str) {
      return typeof str === 'string';
    },
    function isValid(value) {
      return momentValidationWrapper.isValidMoment(moment(value));
    },
    'Moment'
  ),

  momentDurationObj : createMomentChecker(
    'object',
    function(obj) {
      return typeof obj === 'object';
    },
    function isValid(value) {
      return moment.isDuration(value);
    },
    'Duration'
  ),

};


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return navigate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetNavigate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var NAVIGATE='hive/navigate/NAVIGATE';var RESET_NAVIGATE='hive/navigate/RESET';var navigate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(NAVIGATE);var resetNavigate=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(RESET_NAVIGATE);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,NAVIGATE,Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;return state.set('path',payload).set('shouldRedirect',true);})),_defineProperty(_handleActions,RESET_NAVIGATE,Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return state.set('path','').set('shouldRedirect',false);})),_handleActions),Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({path:'',shouldRedirect:false})));

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeCurrentDashboardPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getDashboardCustomisation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return receiveDashboardCustomisation; });
/* unused harmony export showDashboardData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return displayAllProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return dashboardEditOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return saveDashboardEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return saveDashboardSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cancelDashboardEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return updateCellPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addNewDashboardPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dashboardAddOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dashboardAddOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dashboardAddProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return dashboardRemoveProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addNextProductPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return redirectToPostinstallGroups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var changeCurrentDashboardPage=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_CURRENT_DASHBOARD_PAGE */]);var getDashboardCustomisation=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["l" /* GET_DASHBOARD_CUSTOMISATION */]);var receiveDashboardCustomisation=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* RECEIVE_DASHBOARD_CUSTOMISATION */]);var showDashboardData=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["q" /* SHOW_DASHBOARD_DATA */]);var displayAllProducts=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* DISPLAY_ALL_PRODUCTS */]);var dashboardEditOn=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DASHBOARD_EDIT_ON */]);var saveDashboardEdit=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SAVE_DASHBOARD_EDIT */]);var saveDashboardSuccess=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SAVE_DASHBOARD_SUCCESS */]);var cancelDashboardEdit=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CANCEL_DASHBOARD_EDIT */]);var updateCellPosition=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["r" /* UPDATE_CELL_POSITION */]);var deleteCell=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DELETE_CELL */]);var addNewDashboardPage=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ADD_NEW_DASHBOARD_PAGE */]);var dashboardAddOn=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DASHBOARD_ADD_PRODUCT_ON */]);var dashboardAddOff=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DASHBOARD_ADD_PRODUCT_OFF */]);var dashboardAddProduct=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DASHBOARD_ADD_PRODUCT */],function(productId){var turnEditModeOn=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return{productId:productId,turnEditModeOn:turnEditModeOn};});var dashboardRemoveProducts=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DASHBOARD_REMOVE_PRODUCTS */]);var addNextProductPosition=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DASHBOARD_ADD_NEXT_PRODUCT_POSITION */]);var redirectToPostinstallGroups=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* REDIRECT_TO_POSTINSTALL_GROUPS */]);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_toLower__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_toLower___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_toLower__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_map__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_join__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_filter__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_filter__);
// @noflow
var buildKey=function buildKey(){for(var _len=arguments.length,params=Array(_len),_key=0;_key<_len;_key++){params[_key]=arguments[_key];}return __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_join___default()('-'),__WEBPACK_IMPORTED_MODULE_1_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_toLower___default.a),__WEBPACK_IMPORTED_MODULE_5_lodash_fp_filter___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_identity___default.a))([].concat(params));};

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(2359);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/**
 * Renders an icon from one of the icon fonts.
 *
 * `icon` - the character to render representing the font (see src/constants/general-icons.js)
 * `set` - which icon font to render from
 */var Icon=function Icon(_ref){var className=_ref.className,icon=_ref.icon,set=_ref.set,props=_objectWithoutProperties(_ref,['className','icon','set']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__style__["a" /* StyledIcon */],Object.assign({},props,{className:className,set:set}),icon);};/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_DEVICE", function() { return ADD_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_EMPTY", function() { return BATTERY_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_FULL", function() { return BATTERY_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_LOW", function() { return BATTERY_LOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_NORMAL", function() { return BATTERY_NORMAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOST", function() { return BOOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORD_GAIS", function() { return BORD_GAIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRITISH_GAS", function() { return BRITISH_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BULB_TUNER", function() { return BULB_TUNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALL", function() { return CALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIRCLE_FILLED", function() { return CIRCLE_FILLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIRCLE_OUTLINE", function() { return CIRCLE_OUTLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLOUR_PICKER", function() { return COLOUR_PICKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOSE", function() { return CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOSE_HEAVY", function() { return CLOSE_HEAVY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONNECTED", function() { return CONNECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTROLS", function() { return CONTROLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COPY", function() { return COPY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE", function() { return CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREATE_PLUS", function() { return CREATE_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DASHBOARD", function() { return DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEMO", function() { return DEMO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEVICE_MENU", function() { return DEVICE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIMMER", function() { return DIMMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWN", function() { return DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWNLOAD", function() { return DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDIT", function() { return EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXCLAMATION", function() { return EXCLAMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FROST", function() { return FROST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRAPHS", function() { return GRAPHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEATING", function() { return HEATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HELP", function() { return HELP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HIVE", function() { return HIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOLIDAY", function() { return HOLIDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOME", function() { return HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOT_WATER", function() { return HOT_WATER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INFO", function() { return INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INSTALL_DEVICE", function() { return INSTALL_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEFT", function() { return LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINKED", function() { return LINKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MANAGE_DEVICE", function() { return MANAGE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU", function() { return MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIC_OFF", function() { return MIC_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIC_ON", function() { return MIC_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MINUS", function() { return MINUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MORE", function() { return MORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOOD_HAPPY", function() { return MOOD_HAPPY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOOD_SUNSET", function() { return MOOD_SUNSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOOD_ZEN", function() { return MOOD_ZEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MORE_CIRCLE", function() { return MORE_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MULTI_PROFILE", function() { return MULTI_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOTIFICATIONS_OFF", function() { return NOTIFICATIONS_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOTIFICATIONS_ON", function() { return NOTIFICATIONS_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PET_MODE", function() { return PET_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUS", function() { return PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUS_CIRCLE", function() { return PLUS_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROFILE", function() { return PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUESTION", function() { return QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RECIPES", function() { return RECIPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RIGHT", function() { return RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCHEDULE", function() { return SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SETTINGS", function() { return SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH", function() { return SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOP", function() { return SHOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BAR_0", function() { return SIGNAL_BAR_0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BAR_1", function() { return SIGNAL_BAR_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BAR_2", function() { return SIGNAL_BAR_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BAR_3", function() { return SIGNAL_BAR_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BAR_4", function() { return SIGNAL_BAR_4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOUND_OFF", function() { return SOUND_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOUND_ON", function() { return SOUND_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TICK", function() { return TICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TICK_CIRCLE", function() { return TICK_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TONE", function() { return TONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRASH", function() { return TRASH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNLINKED", function() { return UNLINKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UP", function() { return UP; });
var ADD_DEVICE='d';var BATTERY_EMPTY='O';var BATTERY_FULL='R';var BATTERY_LOW='P';var BATTERY_NORMAL='Q';var BOOST='F';var BORD_GAIS='Z';var BRITISH_GAS='Y';var BULB_TUNER='"';var CALL='L';var CIRCLE_FILLED='5';var CIRCLE_OUTLINE='4';var COLOUR_PICKER='#';var CLOSE='E';var CLOSE_HEAVY='}';var CONNECTED='M';var CONTROLS='3';var COPY='H';var CREATE='^';var CREATE_PLUS='_';var DASHBOARD='a';var DEMO='j';var DEVICE_MENU='c';var DIMMER='!';var DOWN='B';var DOWNLOAD='s';var EDIT='I';var EXCLAMATION='x';var FROST='N';var GRAPHS='2';var HEATING='p';var HELP='l';var HIVE='X';var HOLIDAY='v';var HOME='u';var HOT_WATER='o';var INFO='w';var INSTALL_DEVICE='n';var LEFT='y';var LINKED='6';var LOGOUT='t';var MANAGE_DEVICE='h';var MENU='b';var MIC_OFF='=';var MIC_ON='+';var MINUS='g';var MORE='e';var MOOD_HAPPY='%';var MOOD_SUNSET='(';var MOOD_ZEN='$';var MORE_CIRCLE='&';var MULTI_PROFILE='0';var NOTIFICATIONS_OFF='r';var NOTIFICATIONS_ON='q';var PET_MODE=')';var PLUS='f';var PLUS_CIRCLE='d';var PROFILE='J';var QUESTION='9';//rules
var RECIPES='m';//rules
var RESET='K';var RIGHT='z';var SCHEDULE='1';var SETTINGS='i';var SEARCH='8';var SHOP='k';var SIGNAL_BAR_0='S';var SIGNAL_BAR_1='T';var SIGNAL_BAR_2='U';var SIGNAL_BAR_3='V';var SIGNAL_BAR_4='W';var SOUND_OFF=',';var SOUND_ON='<';var TICK='D';var TICK_CIRCLE='C';var TONE='"';var TRASH='G';var UNLINKED='7';var UP='A';

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledSpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BulbFlipperWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['font-size: 0.5em;'],['font-size: 0.5em;']),_templateObject2=_taggedTemplateLiteral(['\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: relative;\n'],['\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: relative;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledSpan=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject);var BulbFlipperWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);

/***/ }),
/* 150 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1028),
    getValue = __webpack_require__(1033);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(280),
    baseAssignValue = __webpack_require__(224);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(187);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(585)
  , enumBugKeys = __webpack_require__(388);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(137)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(16)
  , dPs         = __webpack_require__(586)
  , enumBugKeys = __webpack_require__(388)
  , IE_PROTO    = __webpack_require__(387)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(385)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(390).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(585)
  , hiddenKeys = __webpack_require__(388).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(22)
  , dP          = __webpack_require__(35)
  , DESCRIPTORS = __webpack_require__(34)
  , SPECIES     = __webpack_require__(33)('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(62);
module.exports = function(target, src, safe){
  for(var key in src)redefine(target, key, src[key], safe);
  return target;
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(225),
    isArrayLike = __webpack_require__(92),
    isIndex = __webpack_require__(223),
    isObject = __webpack_require__(54);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1351);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(166);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOAD_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_INSTALL_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_MANAGE_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVE_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REMOVED_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REMOVED_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REMOVE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REMOVE_DEVICE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REMOVE_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RENAMED_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RENAMED_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RENAME_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RENAME_HUB_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RENAME_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return REQUEST_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESTART_HUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RESTARTED_HUB; });
var PREFIX_DEVICES="hive/devices/";var PREFIX_ZONE="hive/zone/";var LOAD_DEVICES=PREFIX_DEVICES+"LOAD";var LOAD_INSTALL_OPTIONS=PREFIX_DEVICES+"LOAD_INSTALL_OPTIONS";var LOAD_MANAGE_DEVICES=PREFIX_DEVICES+"LOAD_MANAGE_DEVICES";var RECEIVE_DEVICES=PREFIX_DEVICES+"RECEIVE_DEVICES";var REMOVED_DEVICE=PREFIX_DEVICES+"removed";var REMOVED_ZONE=PREFIX_ZONE+"removed";var REMOVE_DEVICE=PREFIX_DEVICES+"remove";var REMOVE_DEVICE_ERROR=PREFIX_DEVICES+"remove_error";var REMOVE_ZONE=PREFIX_ZONE+"remove";var RENAMED_DEVICE=PREFIX_DEVICES+"renamed";var RENAMED_ZONE=PREFIX_ZONE+"renamed";var RENAME_DEVICE=PREFIX_DEVICES+"rename";var RENAME_HUB_DEVICES=PREFIX_DEVICES+"RENAME_HUB_DEVICES";var RENAME_ZONE=PREFIX_ZONE+"rename";var REQUEST_DEVICES=PREFIX_DEVICES+"REQUEST_DEVICES";var RESTART_HUB=PREFIX_DEVICES+"RESTART_HUB";var RESTARTED_HUB=PREFIX_DEVICES+"RESTARTED_HUB";

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["j"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["g"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* harmony export (immutable) */ __webpack_exports__["h"] = race;
/* harmony export (immutable) */ __webpack_exports__["d"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["f"] = fork;
/* unused harmony export spawn */
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["i"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* harmony export (immutable) */ __webpack_exports__["k"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["l"] = takeLatest;
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(699);



var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    args[_key8 - 2] = arguments[_key8];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
    args[_key9 - 2] = arguments[_key9];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attemptCreateRecipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return attemptDeleteRecipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return attemptUpdateRecipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cancelAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cancelTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return editRecipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return editSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getRecipes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return handleNotificationChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return handlePropertyChange; });
/* unused harmony export hideModal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return receiveRecipes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return requestConfirmDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return selectConsumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return selectProducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return selectTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return showTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return toggleScheduleState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return updateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return updateRecipe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var attemptCreateRecipe=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ATTEMPT_CREATE_RECIPE */]);var attemptDeleteRecipe=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ATTEMPT_DELETE_RECIPE */]);var attemptUpdateRecipe=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* ATTEMPT_UPDATE_RECIPE */]);var cancelAction=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CANCEL_ACTION */]);var cancelTemplate=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CANCEL_TEMPLATE */]);var editRecipe=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EDIT_RECIPE */]);var editSchedule=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* EDIT_SCHEDULE */]);var getRecipes=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* GET_RECIPES */]);var handleNotificationChange=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* HANDLE_NOTIFICATION_CHANGE */]);var handlePropertyChange=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* HANDLE_PROPERTY_CHANGE */]);var hideModal=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* HIDE_MODAL */]);var receiveRecipes=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["l" /* RECEIVE_RECIPES */]);var requestConfirmDelete=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* REQUEST_CONFIRM_DELETE */]);var selectConsumer=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SELECT_CONSUMER */]);var selectProducer=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SELECT_PRODUCER */]);var selectTemplate=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SELECT_TEMPLATE */]);var showTemplateList=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["q" /* SHOW_TEMPLATES_LIST */]);var toggleScheduleState=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["r" /* TOGGLE_SCHEDULE_STATE */]);var updateData=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["s" /* UPDATE_DATA */]);var updateRecipe=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["t" /* UPDATE_RECIPE */]);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(140)
  , core      = __webpack_require__(66)
  , ctx       = __webpack_require__(723)
  , hide      = __webpack_require__(203)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(728)
  , defined = __webpack_require__(464);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(329),
    isArrayLike = __webpack_require__(247),
    isObject = __webpack_require__(99),
    shimKeys = __webpack_require__(2056);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeKeys = getNative(Object, 'keys');

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
var keys = !nativeKeys ? shimKeys : function(object) {
  var Ctor = object == null ? undefined : object.constructor;
  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
      (typeof object != 'function' && isArrayLike(object))) {
    return shimKeys(object);
  }
  return isObject(object) ? nativeKeys(object) : [];
};

module.exports = keys;


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__ = __webpack_require__(133);
var _defineMessages;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])((_defineMessages={},_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["b" /* notificationTypes */].email,{id:'recipes.email',defaultMessage:'Email'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["b" /* notificationTypes */].push,{id:'recipes.mobile',defaultMessage:'Push (iOS & Android)'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["b" /* notificationTypes */].sms,{id:'recipes.text',defaultMessage:'Text'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].notifyMotion,{id:'recipes.notify-motion',defaultMessage:'Notify me when a motion sensor detects motion'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].notifyOpenContact,{id:'recipes.notify-open-contact',defaultMessage:'Notify me when a window or door sensor is opened'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].notifyClosedContact,{id:'recipes.notify-closed-contact',defaultMessage:'Notify me when a window or door sensor is closed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].modifyPlugWhenMotion,{id:'recipes.modify-plug-when-motion',defaultMessage:'Turn a plug ON or OFF when a motion sensor detects motion'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].modifyPlugWhenOpenContact,{id:'recipes.modify-plug-when-open-contact',defaultMessage:'Turn a plug ON or OFF when a window or door sensor is opened'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].modifyPlugWhenClosedContact,{id:'recipes.modify-plug-when-closed-contact',defaultMessage:'Turn a plug ON or OFF when a window or door sensor is closed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].modifyLightWhenMotion,{id:'recipes.modify-light-when-motion',defaultMessage:'Turn a light ON or OFF when a motion sensor detects motion'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].modifyLightWhenOpenContact,{id:'recipes.modify-light-when-open-contact',defaultMessage:'Turn a light ON or OFF when a door or window sensor is opened'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].modifyLightWhenClosedContact,{id:'recipes.modify-light-when-closed-contact',defaultMessage:'Turn a light ON or OFF when a door or window sensor is closed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].motionSensorHeatingMode,{id:'recipes.motion-sensor-heating-mode',defaultMessage:'Set heating when a motion sensor detects motion'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].contactSensorOpenedHeatingMode,{id:'recipes.contact-sensor-opened-heating-mode',defaultMessage:'Set heating when a window or door sensor is opened'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].contactSensorClosedHeatingMode,{id:'recipes.contact-sensor-closed-heating-mode',defaultMessage:'Set heating when a window or door sensor is closed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].hiveButtonPressedActivePlugOnOff,{id:'hive-button-pressed-activeplug-on-off',defaultMessage:'Turn a plug ON or OFF when a Hive Button is pressed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].hiveButtonDoublePressedActivePlugOnOff,{id:'hive-button-double-pressed-activeplug-on-off',defaultMessage:'Turn a plug ON or OFF when a Hive Button is double pressed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].hiveButtonLongHoldPressedActivePlugOnOff,{id:'hive-button-long-hold-pressed-activeplug-on-off',defaultMessage:'Turn a plug ON or OFF when a Hive Button is long-hold pressed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].hiveButtonPressedLightOnOff,{id:'hive-button-pressed-light-on-off',defaultMessage:'Turn a light ON or OFF when a Hive Button is pressed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].hiveButtonDoublePressedLightOnOff,{id:'hive-button-double-pressed-light-on-off',defaultMessage:'Turn a light ON or OFF when a Hive Button is double pressed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].hiveButtonLongHoldPressedLightOnOff,{id:'hive-button-long-hold-pressed-light-on-off',defaultMessage:'Turn a light ON or OFF when a Hive Button is long-hold pressed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].hiveButtonPressedHeatingMode,{id:'hive-button-pressed-heating-mode',defaultMessage:'Set heating when a Hive Button is pressed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].hiveButtonDoublePressedHeatingMode,{id:'hive-button-double-pressed-heating-mode',defaultMessage:'Set heating when a Hive Button is double pressed'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__core_constants_recipes__["d" /* templateTypes */].hiveButtonLongHoldPressedHeatingMode,{id:'hive-button-long-hold-pressed-heating-mode',defaultMessage:'Set heating when a Hive Button is long-hold pressed'}),_defineProperty(_defineMessages,'always',{id:'recipes.always',defaultMessage:'Always'}),_defineProperty(_defineMessages,'cancel',{id:'recipes.cancel',defaultMessage:'Cancel',description:'Button label to cancel an action'}),_defineProperty(_defineMessages,'confirm',{id:'recipes.confirm',defaultMessage:'Confirm',description:'Button label to confirm an action'}),_defineProperty(_defineMessages,'confirmDeleting',{id:'recipes.confirm-deleting',defaultMessage:'Confirm deleting action',description:'Message to show to confirm a recipe to be deleted'}),_defineProperty(_defineMessages,'deleting',{id:'recipes.deleting',defaultMessage:'Deleting...',description:'Message to show when a recipe is being deleted'}),_defineProperty(_defineMessages,'for',{id:'recipes.for',defaultMessage:'for {duration}',description:'to display a recipe duration (e.g. for 5 minutes)'}),_defineProperty(_defineMessages,'notifyMeBy',{id:'recipes.notify-me-by',defaultMessage:'Notify me by {list}'}),_defineProperty(_defineMessages,'scheduled',{id:'recipes.scheduled',defaultMessage:'Scheduled'}),_defineProperty(_defineMessages,'turnPlugOff',{id:'recipes.turn-plug-off',defaultMessage:'Turn {deviceName} off',description:'Turn a plug off'}),_defineProperty(_defineMessages,'turnPlugOn',{id:'recipes.turn-plug-on',defaultMessage:'Turn {deviceName} on',description:'Turn a plug on'}),_defineProperty(_defineMessages,'turnLightOff',{id:'recipes.turn-light-off',defaultMessage:'Turn {deviceName} off',description:'Turn a light bulb off'}),_defineProperty(_defineMessages,'turnLightOn',{id:'recipes.turn-light-on',defaultMessage:'Turn {deviceName} on',description:'Turn a light bulb on'}),_defineProperty(_defineMessages,'setHeatingToSchedule',{id:'recipes.set-heating-to-schedule',defaultMessage:'Set {deviceName} to Schedule',description:'Set a thermostat to schedule'}),_defineProperty(_defineMessages,'setHeatingToManual',{id:'recipes.set-heating-to-manual',defaultMessage:'Set {deviceName} to Manual at {degrees}°',description:'Boost a thermostat'}),_defineProperty(_defineMessages,'boostHeating',{id:'recipes.boost-heating',defaultMessage:'Boost {deviceName} to {degrees}° for {duration}',description:'Boost a thermostat'}),_defineProperty(_defineMessages,'turnHeatingOff',{id:'recipes.turn-heating-off',defaultMessage:'Set {deviceName} to Off',description:'Turn a thermostat off'}),_defineProperty(_defineMessages,'updating',{id:'recipes.updating',defaultMessage:'Updating...',description:'Message to show when enabling/disabling the recipe'}),_defineProperty(_defineMessages,'whenDetectsMotion',{id:'recipes.when-detects-motion',defaultMessage:'When {deviceName} detects motion'}),_defineProperty(_defineMessages,'whenContactIsClosed',{id:'recipes.when-contact-is-closed',defaultMessage:'When {deviceName} is closed'}),_defineProperty(_defineMessages,'whenContactIsOpened',{id:'recipes.when-contact-is-opened',defaultMessage:'When {deviceName} is opened'}),_defineProperty(_defineMessages,'whenButtonIsPressed',{id:'recipes.when-button-is-pressed',defaultMessage:'When {deviceName} is pressed'}),_defineProperty(_defineMessages,'whenButtonIsDoublePressed',{id:'recipes.when-button-is-double-pressed',defaultMessage:'When {deviceName} is double pressed'}),_defineProperty(_defineMessages,'whenButtonIsLongHoldPressed',{id:'recipes.when-button-is-long-hold-pressed',defaultMessage:'When {deviceName} is long-hold pressed'}),_defineProperty(_defineMessages,'addRecipe',{id:'recipes.add-recipe',defaultMessage:'Add a new action'}),_defineProperty(_defineMessages,'when',{id:'recipes.when',defaultMessage:'When'}),_defineProperty(_defineMessages,'then',{id:'recipes.then',defaultMessage:'Then'}),_defineMessages)));

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__device_selector__ = __webpack_require__(2369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__device_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frequency_selector__ = __webpack_require__(2371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__frequency_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generic_selector__ = __webpack_require__(2373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__generic_selector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__recipe_detail__ = __webpack_require__(2375);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__recipe_detail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__recipe_modal__ = __webpack_require__(811);
/* unused harmony reexport RecipeModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__recipe_schedule__ = __webpack_require__(2378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__recipe_schedule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__then_consumer__ = __webpack_require__(2381);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__then_consumer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__then_notify__ = __webpack_require__(2383);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__then_notify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__when__ = __webpack_require__(2385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__when__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__templates_list__ = __webpack_require__(2387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__templates_list__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__template__ = __webpack_require__(2390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_10__template__["a"]; });


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export getApplication */
/* unused harmony export getLocale */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getUserLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getUserRegion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getLoginComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getIsLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getShowHiveLiveModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getIsLoggingIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getIsLoggingOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getLoggingInError; });
/* unused harmony export getHiveOffers */
/* unused harmony export getHiveOffer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHiveOfferDefaultUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getActiveHiveOffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getWelcomeMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getShowWelcomeMessage; });
/* unused harmony export getShowLeakSensorModal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getShowHumidityControl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getShowLoginAnimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getActiveDiscoveryFeature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getShowDiscoveryModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getHoneycombEndpoint; });
/* unused harmony export getBeekeeperEndpoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_includes__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_map__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_curry__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_first__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_filter__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_fp_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_fp_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_settings_selectors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__products_bulbs_selectors__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cookies_selectors__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_app_settings__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants_app_settings__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_settings_constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants_routes__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__gtm__ = __webpack_require__(701);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var getApplication=function getApplication(state){return state.application||Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])({});};var getLocale=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('locale');});var uniq=function uniq(a){return Array.from(new Set(a));};var lowerCase=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default()(function(s){return s.trim().toLowerCase();});var includes=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_curry___default()(function(collection,value){return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_includes___default()(value,collection);});var _getBrowserLocale=function _getBrowserLocale(locales){var allLocales=lowerCase(locales.toJS());var transform=__WEBPACK_IMPORTED_MODULE_4_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_first___default.a,__WEBPACK_IMPORTED_MODULE_6_lodash_fp_filter___default()(includes(allLocales)),lowerCase,__WEBPACK_IMPORTED_MODULE_6_lodash_fp_filter___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default.a),uniq);var _global$navigator=global.navigator,userLanguage=_global$navigator.userLanguage,_global$navigator$lan=_global$navigator.languages,languages=_global$navigator$lan===undefined?[]:_global$navigator$lan,language=_global$navigator.language;return transform([userLanguage].concat(_toConsumableArray(languages),[language]));};var getBrowserLocale=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_9__config_selectors__["e" /* getLocales */],function(locales){return _getBrowserLocale(locales);});var getUserLocale=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getLocale,getBrowserLocale,function(locale,browserLocale){return locale||browserLocale;});var getUserRegion=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_13__cookies_selectors__["a" /* getAllCookies */],getUserLocale],function(cookie,locale){var _locale$split=locale.split('-'),_locale$split2=_slicedToArray(_locale$split,2),region=_locale$split2[1];return cookie.get('user-region','').toLowerCase()||region;});var getToken=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('token');});var getLoginComplete=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('loginComplete');});var getIsLoggedIn=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getToken,getLoginComplete,function(token,isLoginComplete){return!!(isLoginComplete&&Boolean(token));});var getShowHiveLiveModal=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('showHiveLiveModal');});var getIsLoggingIn=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('loggingIn');});var getIsLoggingOut=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('loggingOut');});var getLoggingInError=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('loggingInError');});var getHiveOffers=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('hive-offers');});var getHiveOffer=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.getIn(['hive-offers','items',0]);});var getHiveOfferDefaultUrl=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.getIn(['hive-offers','defaultURL']);});var getActiveHiveOffer=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getHiveOffer,getHiveOfferDefaultUrl,Object(__WEBPACK_IMPORTED_MODULE_9__config_selectors__["b" /* getConfigBound */])('features:shopMenuLink'),__WEBPACK_IMPORTED_MODULE_10__app_settings_selectors__["b" /* getAppSettings */],function(offer,defaultURL,shopMenuLinkEnabled,settings){if(shopMenuLinkEnabled&&Object(__WEBPACK_IMPORTED_MODULE_19__gtm__["b" /* isGTMActive */])(offer)){return offer.set('isOfferFirstTime',!settings.get(Object(__WEBPACK_IMPORTED_MODULE_15__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_16__constants_app_settings__["m" /* SEEN_OFFER */],offer.get('id')))).set('link',offer.get('url')||defaultURL);}});var getWelcomeMessage=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('welcomeMessage');});var getShowWelcomeMessage=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('showWelcomeMessage');});var getShowLeakSensorModal=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('showLeakSensorModal');});var getShowHumidityControl=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('showHumidityControl');});var getShowLoginAnimation=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(application){return application.get('playLoginAnimation');});var getActiveDiscoveryFeature=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(Object(__WEBPACK_IMPORTED_MODULE_9__config_selectors__["b" /* getConfigBound */])('discoverNewFeatures'),function(){var activeFeatures=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["Map"])();return activeFeatures.findKey(function(value){return value;})||'';});var mapFeatureToExtraConditions=function mapFeatureToExtraConditions(activeFeature,hubHasActions2Capability,hubHasGroupsCapability,bulbs,hueBridge,currentRoute,featureFlags){var featuresWithExtraConditions=[__WEBPACK_IMPORTED_MODULE_17__app_settings_constants__["b" /* DISCOVER_FEATURES */].ACTIONS2,__WEBPACK_IMPORTED_MODULE_17__app_settings_constants__["b" /* DISCOVER_FEATURES */].GROUPS,__WEBPACK_IMPORTED_MODULE_17__app_settings_constants__["b" /* DISCOVER_FEATURES */].HUE];var functionMap=new Map([[!featuresWithExtraConditions.includes(activeFeature),true],[activeFeature===__WEBPACK_IMPORTED_MODULE_17__app_settings_constants__["b" /* DISCOVER_FEATURES */].ACTIONS2,featureFlags.get('newActions')&&hubHasActions2Capability&&currentRoute===__WEBPACK_IMPORTED_MODULE_18__constants_routes__["dashboard"]],[activeFeature===__WEBPACK_IMPORTED_MODULE_17__app_settings_constants__["b" /* DISCOVER_FEATURES */].GROUPS,featureFlags.get('deviceGroups')&&bulbs&&bulbs.size>1&&hubHasGroupsCapability&&currentRoute===__WEBPACK_IMPORTED_MODULE_18__constants_routes__["dashboard"]],[activeFeature===__WEBPACK_IMPORTED_MODULE_17__app_settings_constants__["b" /* DISCOVER_FEATURES */].HUE,featureFlags.get('hueSchedule')&&featureFlags.get('hueMimic')&&featureFlags.get('installPhilipsHue')&&!hueBridge]]);return functionMap.get(true);};var getShowDiscoveryModal=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])([function(state){return getActiveDiscoveryFeature(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_11__products_bulbs_selectors__["d" /* getBulbs */])(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_12__devices_selectors__["I" /* getHueBridge */])(state);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_12__devices_selectors__["G" /* getHubHasCapability */])(state,__WEBPACK_IMPORTED_MODULE_14__constants_devices__["capabilities"].ACTIONS_2);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_12__devices_selectors__["G" /* getHubHasCapability */])(state,__WEBPACK_IMPORTED_MODULE_14__constants_devices__["capabilities"].PRODUCT_GROUP);},function(state){return Object(__WEBPACK_IMPORTED_MODULE_10__app_settings_selectors__["a" /* getAppSetting */])(state,__WEBPACK_IMPORTED_MODULE_17__app_settings_constants__["c" /* DISCOVER_NEW_FEATURES */]);},function(_,props){return props.currentRoute;},function(state){return Object(__WEBPACK_IMPORTED_MODULE_9__config_selectors__["a" /* getConfig */])(state,'features');}],function(activeFeature,bulbs,hueBridge,hubHasActions2Capability,hubHasGroupsCapability){var discoverNewFeatures=arguments.length>5&&arguments[5]!==undefined?arguments[5]:Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["Map"])();var currentRoute=arguments[6];var featureFlags=arguments[7];var extraConditionMet=mapFeatureToExtraConditions(activeFeature,hubHasActions2Capability,hubHasGroupsCapability,bulbs,hueBridge,currentRoute,featureFlags);return!!extraConditionMet&&!!activeFeature&&!discoverNewFeatures.get(activeFeature);});var getContact=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])([Object(__WEBPACK_IMPORTED_MODULE_9__config_selectors__["b" /* getConfigBound */])('help:supportEmail'),Object(__WEBPACK_IMPORTED_MODULE_9__config_selectors__["b" /* getConfigBound */])('help:deviceOfflineTelephoneNumber')],function(){var email=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var contact=arguments.length>1&&arguments[1]!==undefined?arguments[1]:email;return contact;});var getHoneycombEndpoint=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(app){return app.get('honeycombEndpoint');});var getBeekeeperEndpoint=Object(__WEBPACK_IMPORTED_MODULE_7_reselect__["createSelector"])(getApplication,function(app){return app.get('beekeeperEndpoint');});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file will replace the `device.js` once we get rid of the devices font icons
// The below constants naming convention closely follows the same names of the svg icons from design
// however for some devices, the names were incorrect and renamed, the original names as per the svg icons by design
// have been put in comments so we can easily match the svgs if there are any updates.
var devicesIcons={ACTIVE_BUTTON:'ACTIVE_BUTTON',APPLIANCE:'APPLIANCE',BOILER_MODULE_SLR1:'BOILER_MODULE_SLR1',//RECEIVER_SINGLE
BOILER_MODULE_SLR2:'BOILER_MODULE_SLR2',//RECEIVER_DUAL
BUTTON_OFF:'BUTTON_OFF',CAMERA_DEHARO:'CAMERA_DEHARO',CAMERA_OFF:'CAMERA_OFF',COLOUR_PICKER:'COLOUR_PICKER',COOLING:'COOLING',DOOR_SENSOR:'DOOR_SENSOR',DOUBLE_TAP:'DOUBLE_TAP',DUO_SOCKET_EU:'DUO_SOCKET_EU',DUO_SOCKET_IN:'DUO_SOCKET_IN',DUO_SOCKET_NA:'DUO_SOCKET_NA',DUO_SOCKET_UK:'DUO_SOCKET_UK',FAN_OFF:'FAN_OFF',FAN_ON:'FAN_ON',FLAME_NA:'FLAME_NA',GENERIC_TEMP:'GENERIC_TEMP',GROUP_CONTROL:'GROUP_CONTROL',HEATING:'HEATING',HIVE_BUTTON:'HIVE_BUTTON',HOT_WATER:'HOT_WATER',HOT_WATER_ON:'HOT_WATER_ON',HUB_NANO1:'HUB_NANO1',//HUB_NANO
HUB_NANO2:'HUB_NANO2',//NANO3
HUMIDITY:'HUMIDITY',LEAK_SENSOR:'LEAK_SENSOR',LIGHT:'LIGHT',LIGHT_DOUBLE:'LIGHT_DOUBLE',LINK_BROKEN:'LINK_BROKEN',LINKED:'LINKED',LONG_PRESS:'LONG_PRESS',MOTION_SENSOR:'MOTION_SENSOR',ONE_TAP:'ONE_TAP',PHILIPS_HUE_BRIDGE:'PHILIPS_HUE_BRIDGE',PLUG_EU:'PLUG_EU',PLUG_IN:'PLUG_IN',PLUG_NA:'PLUG_NA',PLUG_UK:'PLUG_UK',SENSE:'SENSE',SIGNAL_BOOST:'SIGNAL_BOOST',SIGNAL_BOOSTER_PLUG:'SIGNAL_BOOSTER_PLUG',SOCKET_EU:'SOCKET_EU',SOCKET_IN:'SOCKET_IN',SOCKET_NA:'SOCKET_NA',SOCKET_UK:'SOCKET_UK',SWITCH:'SWITCH',TANKS:'TANKS',THERMOSTAT_SLT1:'THERMOSTAT_SLT1',//STAT1
THERMOSTAT_SLT2:'THERMOSTAT_SLT2',//STAT2
THERMOSTAT_SLT3:'THERMOSTAT_SLT3',//STAT3
TOILETS:'TOILETS',WATER_FLOWING:'WATER_FLOWING',WATER_NOT_FLOWING:'WATER_NOT_FLOWING'};/* harmony default export */ __webpack_exports__["a"] = (devicesIcons);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(792);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__async__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_buttons_button_component__ = __webpack_require__(839);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__button_buttons_button_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_styles__ = __webpack_require__(333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__button_styles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__link_buttons_href_component__ = __webpack_require__(2252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__link_buttons_href_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__link_buttons_link_component__ = __webpack_require__(2253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__link_buttons_link_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__text_buttons_text_component__ = __webpack_require__(2254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__text_buttons_text_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toggle__ = __webpack_require__(515);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__toggle__["a"]; });


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getEntitlements */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConfig; });
/* unused harmony export getSubscriptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hasSMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHasEntitlement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSubscriptionsByName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_selectors__ = __webpack_require__(14);
var getEntitlements=function getEntitlements(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return state.entitlements||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});};var getConfig=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getEntitlements,function(entitlements){return entitlements.get('config');});var getSubscriptions=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getConfig,function(config){return config.get('subscriptions');});var hasSMS=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getConfig,function(config){return!!config.get('SMS');});var getKey=function getKey(_,key){return key;};var getHasEntitlement=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getConfig,getKey,function(config,key){return!!config.get(key);});var isLoading=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getEntitlements,function(entitlements){return!!entitlements.get('loading');});var getSubscriptionsByName=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getSubscriptions,function(_,props){return props&&props.names||[];},function(state){return Object(__WEBPACK_IMPORTED_MODULE_2__config_selectors__["a" /* getConfig */])(state,'subscriptions:types');},function(subscriptions,names,config){return(// $FlowFixMe
(subscriptions||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([])).filter(function(subscription){return names.includes(subscription.get('name'));}).filter(function(subscription){return!(subscription.get('status')==='SUSPENDED'&&!config.get(subscription.get('name')).get('suspendable'));}));});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_SETTINGS_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_APP_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_APP_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_APP_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISCOVER_FEATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISCOVER_NEW_FEATURES; });
var APP_SETTINGS_ATTRIBUTE='app-settings';var GET_APP_SETTINGS='hive/app-settings/GET_APP_SETTINGS';var RECEIVE_APP_SETTINGS='hive/app-settings/RECEIVE_APP_SETTINGS';var SET_APP_SETTINGS='hive/app-settings/SET_APP_SETTINGS';var DISCOVER_FEATURES={ACTIONS2:'actions2',GROUPS:'groups',HUE:'hue'};var DISCOVER_NEW_FEATURES='discover-new-features';

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getScheduleType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDataIdFromComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createComponentId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return actionFormDataId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionFormComponentId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_split__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_last__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_schedule__ = __webpack_require__(80);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var getScheduleType=function getScheduleType(){var _truthMap;var product=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var type=product.type,props=product.props,state=product.state;var truthMap=(_truthMap={},_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].ACTIVE_PLUG,__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].ACTIVE_PLUG),_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].COLOUR_TUNEABLE_LIGHT),_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].COLOR_LIGHT,__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].COLOUR_LIGHT),_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].HEATING,__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].HEATING),_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].HOT_WATER,__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].HOT_WATER),_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].NA_THERMOSTAT&&(state.controlMode===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceControlModes"].COOL||props.capabilities.includes(__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceCapabilities"].COOL)),__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].NA_THERMOSTAT_COOL),_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].NA_THERMOSTAT&&state.controlMode===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceControlModes"].AUTO,__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].NA_THERMOSTAT_DUAL),_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].NA_THERMOSTAT&&(state.controlMode===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceControlModes"].HEAT||props.capabilities.includes(__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceCapabilities"].HEAT)),__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].NA_THERMOSTAT_HEAT),_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].TUNEABLE_LIGHT,__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].TUNEABLE_LIGHT),_defineProperty(_truthMap,type===__WEBPACK_IMPORTED_MODULE_3__constants_devices__["deviceTypes"].WARM_WHITE_LIGHT,__WEBPACK_IMPORTED_MODULE_4__constants_schedule__["c" /* scheduleType */].WARM_WHITE_LIGHT),_truthMap);if(!truthMap[true]){console.error('Schedule type '+type+' not found');}return truthMap[true];};var separator='__';var getDataIdFromComponent=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default.a,__WEBPACK_IMPORTED_MODULE_0_lodash_fp_split___default()(separator));var createComponentId=function createComponentId(instanceId,dataId){return''+instanceId+separator+dataId;};var actionFormDataId='action-form';var actionFormComponentId=createComponentId('action',actionFormDataId);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ACTION_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ATTEMPT_CREATE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ATTEMPT_EDIT_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ATTEMPT_REMOVE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ATTEMPT_TRIGGER_QUICK_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CANCEL_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EDIT_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return END_ATTEMPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return END_ATTEMPT_CREATE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LOAD_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RECEIVE_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RECEIVE_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return REMOVE_ACTION_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REMOVE_ACTION_FROM_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return REMOVE_ACTION_FROM_DELETE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RESET_QUICK_ACTION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_ACTION_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_ACTION_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TRIGGER_QUICK_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return IDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TRIGGERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ERROR; });
var ADD_ACTION_ATTRIBUTE='hive/actions/ADD_ACTION_ATTRIBUTE';var ATTEMPT_CREATE_ACTION='hive/actions/ATTEMPT_CREATE_ACTION';var ATTEMPT_EDIT_ACTION='hive/actions/ATTEMPT_EDIT_ACTION';var ATTEMPT_REMOVE_ACTION='hive/actions/ATTEMPT_REMOVE_ACTION';var ATTEMPT_TRIGGER_QUICK_ACTION='hive/actions/ATTEMPT_TRIGGER_QUICK_ACTION';var CANCEL_FORM='hive/actions/CANCEL_FORM';var EDIT_ACTION='hive/actions/EDIT_ACTION';var END_ATTEMPT='hive/actions/END_ATTEMPT';var END_ATTEMPT_CREATE_ACTION='hive/actions/END_ATTEMPT_CREATE_ACTION';var GET_ACTIONS='hive/actions/GET_ACTIONS';var GET_TEMPLATES='hive/actions/GET_TEMPLATES';var LOAD_FORM='hive/actions/LOAD_FORM';var RECEIVE_ACTIONS='hive/actions/RECEIVE_ACTIONS';var RECEIVE_TEMPLATES='hive/actions/RECEIVE_TEMPLATES';var REMOVE_ACTION_ATTRIBUTE='hive/actions/REMOVE_ACTION_ATTRIBUTE';var REMOVE_ACTION_FROM_LIST='hive/actions/REMOVE_ACTION_FROM_LIST';var REMOVE_ACTION_FROM_DELETE_LIST='hive/actions/REMOVE_ACTION_FROM_DELETE_LIST';var RESET_QUICK_ACTION_STATUS='hive/actions/RESET_QUICK_ACTION_STATUS';var SET_ACTION_ATTRIBUTE='hive/actions/SET_ACTION_ATTRIBUTE';var SET_ACTION_FORM='hive/actions/SET_ACTION_FORM';var TRIGGER_QUICK_ACTION='hive/actions/TRIGGER_QUICK_ACTION';var IDLE='IDLE';var TRIGGERED='TRIGGERED';var SUCCESS='SUCCESS';var ERROR='ERROR';

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(150),
    overRest = __webpack_require__(580),
    setToString = __webpack_require__(366);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return producersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consumerProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getConsumerPropertiesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isConsumerActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateActionsValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return templates; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_recipes__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(1531);
var _consumerProperties,_templates;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var ACTIVE_PLUG=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].ACTIVE_PLUG,BULB=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].BULB,COLOR_TUNEABLE_LIGHT=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,COLOR_LIGHT=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_LIGHT,CONTACT_SENSOR=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].CONTACT_SENSOR,HEATING=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HEATING,MOTION_SENSOR=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].MOTION_SENSOR,TUNEABLE_LIGHT=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].TUNEABLE_LIGHT,WARM_WHITE_LIGHT=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].WARM_WHITE_LIGHT,HIVE_BUTTON=__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HIVE_BUTTON;var producersList=[CONTACT_SENSOR,MOTION_SENSOR,HIVE_BUTTON];var consumerProperties=(_consumerProperties={},_defineProperty(_consumerProperties,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].duration,{type:__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].duration,label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].for,optionsList:[{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].indefinitely,value:-1},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */]._30seconds,value:30},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */]._1minute,value:60},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */]._3minutes,value:180},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */]._5minutes,value:300},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */]._10minutes,value:600},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */]._15minutes,value:900}]}),_defineProperty(_consumerProperties,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeLightOnOff,{type:__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeLightOnOff,label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].lightLabel,field:'state',optionsList:[{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].lightOn,value:'ON'},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].lightOff,value:'OFF'}]}),_defineProperty(_consumerProperties,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changePlugOnOff,{type:__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changePlugOnOff,label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].plugLabel,field:'state',optionsList:[{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].plugOn,value:'ON'},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].plugOff,value:'OFF'}]}),_defineProperty(_consumerProperties,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode,{type:__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode,label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingModeLabel,field:'mode',optionsList:[{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingScheduleMode,value:'HEAT'},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingManualMode,value:'HEAT'},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingOffMode,value:'OFF'},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingBoostMode,value:'BOOST'}],defaultOptionIndex:0}),_defineProperty(_consumerProperties,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget,{type:__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget,label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingTargetLabel,field:'target',optionsList:function(){return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default()(0.5,5,32.5).map(function(v){return{label:v+'\xB0',value:v};});}(),defaultOptionIndex:22}),_defineProperty(_consumerProperties,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingBoost,{type:__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingBoost,label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingBoostLabel,field:'boost',optionsList:[{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingBoostDuration030,value:30},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingBoostDuration1,value:60},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingBoostDuration2,value:120},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingBoostDuration3,value:180},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingBoostDuration4,value:240},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingBoostDuration5,value:300},{label:__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].heatingBoostDuration6,value:360}],defaultOptionIndex:1}),_consumerProperties);var getConsumerPropertiesList=function getConsumerPropertiesList(deviceType,current,recipe){var _true$includes$true;var list=(_true$includes$true={},_defineProperty(_true$includes$true,true,function _true(){return[];}),_defineProperty(_true$includes$true,deviceType===ACTIVE_PLUG,function(){return[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changePlugOnOff,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].duration];}),_defineProperty(_true$includes$true,[BULB,COLOR_TUNEABLE_LIGHT,COLOR_LIGHT,TUNEABLE_LIGHT,WARM_WHITE_LIGHT].includes(deviceType),function(){return[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeLightOnOff,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].duration];}),_defineProperty(_true$includes$true,deviceType===HEATING,function(){if(recipe){var modeAction=recipe.getIn(['action','changes']).find(function(a){return a.get('field')===consumerProperties[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode].field;});if(modeAction.get('value')==='BOOST'){return[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingBoost];}else if(modeAction.get('value')==='HEAT'&&recipe.getIn(['action','changes']).find(function(a){return a.get('field')===consumerProperties[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget].field;})){return[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget];}}else{var mode=current&&current.find(function(p){return p.get('type')===__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode;});if(mode){if(mode.get('selectedIndex')===1){return[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget];}else if(mode.get('selectedIndex')===3){return[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingBoost];}}}return[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode];}),_true$includes$true)[true]();return list.map(function(p){var attr=consumerProperties[p];var selectedIndex=attr.defaultOptionIndex||0;if(recipe){if(attr.type===__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].duration){selectedIndex=attr.optionsList.findIndex(function(opt){return opt.value===recipe.getIn(['action','duration'],-1);});}else{var changeAction=recipe.getIn(['action','changes']).find(function(a){return a.get('field')===attr.field;});selectedIndex=attr.optionsList.findIndex(function(opt){return opt.value===changeAction.get('value');});// because both schedule and manual modes come with the same value (HEAT) we need to also look if the
// target also exist to know which mode it is
if(changeAction.get('value')==='HEAT'&&list.includes(__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget)){selectedIndex=1;}}}else if(current){var currentProperty=current.find(function(item){return item.get('type')===p;});if(currentProperty){selectedIndex=currentProperty.get('selectedIndex',selectedIndex);}}return Object.assign({},consumerProperties[p],{selectedIndex:selectedIndex});});};var isConsumerActive=function isConsumerActive(recipe,deviceType){var _true$includes$true2;var list=recipe.getIn(['data','action','changes']);return(_true$includes$true2={},_defineProperty(_true$includes$true2,true,function _true(){return false;}),_defineProperty(_true$includes$true2,[ACTIVE_PLUG,BULB,COLOR_TUNEABLE_LIGHT,COLOR_LIGHT,TUNEABLE_LIGHT,WARM_WHITE_LIGHT].includes(deviceType),function(){return list.getIn([0,'value'])==='ON';}),_defineProperty(_true$includes$true2,deviceType===HEATING,function(){return list.find(function(action){return action.get('field')==='mode';}).get('value')!=='OFF';}),_true$includes$true2)[true]();};var createAction=function createAction(field,value){return Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])({field:field,modifier:'SET_TO',value:value});};var updateActionsValue=function updateActionsValue(recipe){var list=recipe.get('consumerPropertiesList');var changesList=recipe.getIn(['data','action','changes']);recipe=list.reduce(function(recipe,prop){var type=prop.get('type');var value=consumerProperties[type].optionsList[prop.get('selectedIndex')].value;if(type===__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].duration){return value===-1?recipe.removeIn(['data','action','duration']):recipe.setIn(['data','action','duration'],value);}else if([__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeLightOnOff,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changePlugOnOff].includes(type)){changesList=changesList.setIn([0,'value'],value);}else if(type===__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode){// if the mode is not boost then delete the boost duration from the list of actions
if(prop.get('selectedIndex')!==3){var boostDurationIndex=changesList.findIndex(function(a){return a.get('field')===consumerProperties[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingBoost].field;});if(boostDurationIndex!==-1){changesList=changesList.remove(boostDurationIndex);}}// if the mode is either schedule or off then delete the target from the list of actions
if([0,2].includes(prop.get('selectedIndex'))){var targetIndex=changesList.findIndex(function(a){return a.get('field')===consumerProperties[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget].field;});if(targetIndex!==-1){changesList=changesList.remove(targetIndex);}}var actionIndex=changesList.findIndex(function(a){return a.get('field')===consumerProperties[__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode].field;});changesList=changesList.setIn([actionIndex,'value'],value);}else if([__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingBoost].includes(type)){var _actionIndex=changesList.findIndex(function(a){return a.get('field')===consumerProperties[type].field;});changesList=_actionIndex===-1?changesList.push(createAction(consumerProperties[type].field,value)):changesList.setIn([_actionIndex,'value'],value);}return recipe;},recipe);return recipe.setIn(['data','action','changes'],changesList);};var templates=(_templates={},_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].notifyMotion,{isNotification:true,producer:{active:true,type:MOTION_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].notifyOpenContact,{isNotification:true,producer:{active:true,type:CONTACT_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].notifyClosedContact,{isNotification:true,producer:{active:false,type:CONTACT_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].modifyPlugWhenMotion,{consumer:{propertiesList:getConsumerPropertiesList(ACTIVE_PLUG),types:[ACTIVE_PLUG]},producer:{active:true,type:MOTION_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].modifyPlugWhenOpenContact,{consumer:{propertiesList:getConsumerPropertiesList(ACTIVE_PLUG),types:[ACTIVE_PLUG]},producer:{active:true,type:CONTACT_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].modifyPlugWhenClosedContact,{consumer:{propertiesList:getConsumerPropertiesList(ACTIVE_PLUG),types:[ACTIVE_PLUG]},producer:{active:false,type:CONTACT_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].modifyLightWhenMotion,{consumer:{propertiesList:getConsumerPropertiesList(BULB),types:__WEBPACK_IMPORTED_MODULE_1__constants_devices__["bulbTypes"]},producer:{active:true,type:MOTION_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].modifyLightWhenOpenContact,{consumer:{propertiesList:getConsumerPropertiesList(BULB),types:__WEBPACK_IMPORTED_MODULE_1__constants_devices__["bulbTypes"]},producer:{active:true,type:CONTACT_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].modifyLightWhenClosedContact,{consumer:{propertiesList:getConsumerPropertiesList(BULB),types:__WEBPACK_IMPORTED_MODULE_1__constants_devices__["bulbTypes"]},producer:{active:false,type:CONTACT_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].motionSensorHeatingMode,{consumer:{propertiesList:getConsumerPropertiesList(HEATING),types:[HEATING]},producer:{active:true,type:MOTION_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].contactSensorOpenedHeatingMode,{consumer:{propertiesList:getConsumerPropertiesList(HEATING),types:[HEATING]},producer:{active:true,type:CONTACT_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].contactSensorClosedHeatingMode,{consumer:{propertiesList:getConsumerPropertiesList(HEATING),types:[HEATING]},producer:{active:false,type:CONTACT_SENSOR}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].hiveButtonPressedActivePlugOnOff,{consumer:{propertiesList:getConsumerPropertiesList(ACTIVE_PLUG),types:[ACTIVE_PLUG]},producer:{active:false,type:HIVE_BUTTON}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].hiveButtonDoublePressedActivePlugOnOff,{consumer:{propertiesList:getConsumerPropertiesList(ACTIVE_PLUG),types:[ACTIVE_PLUG]},producer:{active:false,type:HIVE_BUTTON}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].hiveButtonLongHoldPressedActivePlugOnOff,{consumer:{propertiesList:getConsumerPropertiesList(ACTIVE_PLUG),types:[ACTIVE_PLUG]},producer:{active:false,type:HIVE_BUTTON}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].hiveButtonPressedLightOnOff,{consumer:{propertiesList:getConsumerPropertiesList(BULB),types:__WEBPACK_IMPORTED_MODULE_1__constants_devices__["bulbTypes"]},producer:{active:false,type:HIVE_BUTTON}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].hiveButtonDoublePressedLightOnOff,{consumer:{propertiesList:getConsumerPropertiesList(BULB),types:__WEBPACK_IMPORTED_MODULE_1__constants_devices__["bulbTypes"]},producer:{active:false,type:HIVE_BUTTON}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].hiveButtonLongHoldPressedLightOnOff,{consumer:{propertiesList:getConsumerPropertiesList(BULB),types:__WEBPACK_IMPORTED_MODULE_1__constants_devices__["bulbTypes"]},producer:{active:false,type:HIVE_BUTTON}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].hiveButtonPressedHeatingMode,{consumer:{propertiesList:getConsumerPropertiesList(HEATING),types:[HEATING]},producer:{active:false,type:HIVE_BUTTON}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].hiveButtonDoublePressedHeatingMode,{consumer:{propertiesList:getConsumerPropertiesList(HEATING),types:[HEATING]},producer:{active:false,type:HIVE_BUTTON}}),_defineProperty(_templates,__WEBPACK_IMPORTED_MODULE_2__constants_recipes__["d" /* templateTypes */].hiveButtonLongHoldPressedHeatingMode,{consumer:{propertiesList:getConsumerPropertiesList(HEATING),types:[HEATING]},producer:{active:false,type:HIVE_BUTTON}}),_templates);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(52);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(134),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(32),
    isKey = __webpack_require__(384),
    stringToPath = __webpack_require__(575),
    toString = __webpack_require__(190);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(577);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(35).f
  , has = __webpack_require__(56)
  , TAG = __webpack_require__(33)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3)
  , defined = __webpack_require__(84)
  , fails   = __webpack_require__(25)
  , spaces  = __webpack_require__(392)
  , space   = '[' + spaces + ']'
  , non     = '\u200b\u0085'
  , ltrim   = RegExp('^' + space + space + '*')
  , rtrim   = RegExp(space + space + '*$');

var exporter = function(KEY, exec, ALIAS){
  var exp   = {};
  var FORCE = fails(function(){
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if(ALIAS)exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function(string, TYPE){
  string = String(defined(string));
  if(TYPE & 1)string = string.replace(ltrim, '');
  if(TYPE & 2)string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(33)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(61)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(110)
  , call        = __webpack_require__(596)
  , isArrayIter = __webpack_require__(402)
  , anObject    = __webpack_require__(16)
  , toLength    = __webpack_require__(43)
  , getIterFn   = __webpack_require__(404)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(620),
    createBaseEach = __webpack_require__(1342);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(416);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

// --[ Dependencies ]---------------------------------------------------
var warnDeprecation = __webpack_require__(238);
var extend = __webpack_require__(239);

// --[ Constants and Aliases ]------------------------------------------
var TYPE = Symbol.for('@@folktale:adt:type');
var TAG = Symbol.for('@@folktale:adt:tag');
var META = Symbol.for('@@meta:magical');

var keys = Object.keys;

// --[ Helpers ]--------------------------------------------------------

//
// Returns an array of own enumerable values in an object.
//
function values(object) {
  return keys(object).map(function (key) {
    return object[key];
  });
}

//
// Transforms own enumerable key/value pairs.
//
function mapObject(object, transform) {
  return keys(object).reduce(function (result, key) {
    result[key] = transform(key, object[key]);
    return result;
  }, {});
}

// --[ Variant implementation ]-----------------------------------------

//
// Defines the variants given a set of patterns and an ADT namespace.
//
function defineVariants(typeId, patterns, adt) {
  return mapObject(patterns, function (name, constructor) {
    var _constructor, _ref, _extend, _mutatorMap, _tag, _type, _constructor2, _extend2, _mutatorMap2;

    // ---[ Variant Internals ]-----------------------------------------
    function InternalConstructor() {}
    InternalConstructor.prototype = Object.create(adt);

    extend(InternalConstructor.prototype, (_extend = {}, _defineProperty(_extend, TAG, name), _constructor = 'constructor', _mutatorMap = {}, _mutatorMap[_constructor] = _mutatorMap[_constructor] || {}, _mutatorMap[_constructor].get = function () {
      return constructor;
    }, _ref = 'is' + name, _mutatorMap[_ref] = _mutatorMap[_ref] || {}, _mutatorMap[_ref].get = function () {
      warnDeprecation('.is' + name + ' is deprecated. Use ' + name + '.hasInstance(value)\ninstead to check if a value belongs to the ADT variant.');
      return true;
    }, _defineProperty(_extend, 'matchWith', function matchWith(pattern) {
      return pattern[name](this);
    }), _defineEnumerableProperties(_extend, _mutatorMap), _extend));

    function makeInstance() {
      var result = new InternalConstructor(); // eslint-disable-line prefer-const
      extend(result, constructor.apply(undefined, arguments) || {});
      return result;
    }

    extend(makeInstance, (_extend2 = {}, _defineProperty(_extend2, META, constructor[META]), _tag = 'tag', _mutatorMap2 = {}, _mutatorMap2[_tag] = _mutatorMap2[_tag] || {}, _mutatorMap2[_tag].get = function () {
      return name;
    }, _type = 'type', _mutatorMap2[_type] = _mutatorMap2[_type] || {}, _mutatorMap2[_type].get = function () {
      return typeId;
    }, _constructor2 = 'constructor', _mutatorMap2[_constructor2] = _mutatorMap2[_constructor2] || {}, _mutatorMap2[_constructor2].get = function () {
      return constructor;
    }, _defineProperty(_extend2, 'prototype', InternalConstructor.prototype), _defineProperty(_extend2, 'hasInstance', function hasInstance(value) {
      return Boolean(value) && adt.hasInstance(value) && value[TAG] === name;
    }), _defineEnumerableProperties(_extend2, _mutatorMap2), _extend2));

    return makeInstance;
  });
}

// --[ ADT Implementation ]--------------------------------------------

/*~
 * authors:
 *   - Quildreen Motta
 * 
 * stability: experimental
 * type: |
 *   (String, Object (Array String)) => Union
 */
var union = function union(typeId, patterns) {
  var _extend3;

  var UnionNamespace = Object.create(Union);
  var variants = defineVariants(typeId, patterns, UnionNamespace);

  extend(UnionNamespace, variants, (_extend3 = {}, _defineProperty(_extend3, TYPE, typeId), _defineProperty(_extend3, 'variants', values(variants)), _defineProperty(_extend3, 'hasInstance', function hasInstance(value) {
    return Boolean(value) && value[TYPE] === this[TYPE];
  }), _extend3));

  return UnionNamespace;
};

/*~ ~belongsTo : union */
var Union = {
  /*~
   * type: |
   *   Union . (...(Variant, Union) => Any) => Union
   */
  derive: function derive() {
    var _this = this;

    for (var _len = arguments.length, derivations = Array(_len), _key = 0; _key < _len; _key++) {
      derivations[_key] = arguments[_key];
    }

    derivations.forEach(function (derivation) {
      _this.variants.forEach(function (variant) {
        return derivation(variant, _this);
      });
    });
    return this;
  }
};

// --[ Exports ]--------------------------------------------------------
union.Union = Union;
union.typeSymbol = TYPE;
union.tagSymbol = TAG;

module.exports = union;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.makeFieldValue = makeFieldValue;
exports.isFieldValue = isFieldValue;
var flag = '_isFieldValue';
var isObject = function isObject(object) {
  return typeof object === 'object';
};

function makeFieldValue(object) {
  if (object && isObject(object)) {
    // This flag has to be enumerable, because otherwise it is not possible
    // to serialize object with this field.
    // The consequence is you lose information that particular field is
    // field or nested group of fields, so you're not able to fetch
    // field value from state when it has been affected in some way
    // by serializing/using immutable and so on.
    // @fixme marking field as leaf should be made in other way
    Object.defineProperty(object, flag, { value: true, enumerable: true });
  }
  return object;
}

function isFieldValue(object) {
  return !!(object && isObject(object) && object[flag]);
}

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('isEqual', __webpack_require__(1521));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('last', __webpack_require__(693), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(696);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(204)
  , createDesc = __webpack_require__(320);
module.exports = __webpack_require__(207) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(205)
  , IE8_DOM_DEFINE = __webpack_require__(724)
  , toPrimitive    = __webpack_require__(466)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(207) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(206);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(208)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(727)
  , enumBugKeys = __webpack_require__(471);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(77);

var ReactCurrentOwner = __webpack_require__(748);

var warning = __webpack_require__(325);
var canDefineProperty = __webpack_require__(747);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(749);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 211 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export colorNumber */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return colorProptype; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isDependentOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// @noflow
// check that a number is a valid colour number (between 0 and 255)
function colorNumber(props,propName,componentName){if(false){var value=props[propName];if(typeof value!=='number'){return new Error('Invalid prop \''+propName+'\' in \''+componentName+', expect to be a number!');}else if(value%1!==0||value<0||value>255){return new Error('Invalid prop '+propName+'\' in \''+componentName+', expect to be an integer between 0 and 255!');}}}// colour colour which should contain a red, green and blue colour
var colorProptype=__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({r:colorNumber,g:colorNumber,b:colorNumber});/**
 * A React prop validation that first checks if another prop meets some expectation
 * before checking itself.
 *
 * @example
 *
 * {
 *     foo: PropTypes.string,
 *     interactive: PropTypes.bool,
 *     onClick: isDependentOn(['interactive'], (onClick, interactive) => interactive, PropTypes.func.isRequired)
 *     onFoo: isDependentOn(['foo'], (onFoo, foo) => foo === 'bar', PropTypes.func.isRequired)
 * }
 *
 * @param  {String[]} 	 dependentOn   names of the props to check first
 * @param  {*|Function}  checkValues   function to call with the props
 * @param  {Function}    propType      own proptype to check if criteria met
 * @return {Function}
 */function isDependentOn(dependentOn,checkValues,propType){if(false){return function(props,propName){for(var _len=arguments.length,args=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){args[_key-2]=arguments[_key];}var dependents=Array.isArray(dependentOn)?dependentOn:[dependentOn];if(checkValues.apply(undefined,[props[propName]].concat(_toConsumableArray(dependents.map(function(d){return props[d];}))))){return propType.apply(undefined,[props,propName].concat(args));}};}}

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDefaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDualColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hasPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hasSaveButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__active_plugs__ = __webpack_require__(2396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_tuneable_light__ = __webpack_require__(2398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__color_light__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__heating__ = __webpack_require__(2424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hot_water__ = __webpack_require__(2426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__na_thermostat_cool__ = __webpack_require__(2428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__na_thermostat_dual__ = __webpack_require__(2435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__na_thermostat_heat__ = __webpack_require__(2437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__recipes__ = __webpack_require__(2439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tuneable_light__ = __webpack_require__(2441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__warm_white_light__ = __webpack_require__(2446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_themes_main__ = __webpack_require__(78);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var getTypeBehaviour=function getTypeBehaviour(type){var _true$true;return(_true$true={},_defineProperty(_true$true,true,{}),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].ACTIVE_PLUG,__WEBPACK_IMPORTED_MODULE_0__active_plugs__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].COLOUR_TUNEABLE_LIGHT,__WEBPACK_IMPORTED_MODULE_1__color_tuneable_light__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].COLOUR_LIGHT,__WEBPACK_IMPORTED_MODULE_2__color_light__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].HEATING,__WEBPACK_IMPORTED_MODULE_3__heating__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].HOT_WATER,__WEBPACK_IMPORTED_MODULE_4__hot_water__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].NA_THERMOSTAT_COOL,__WEBPACK_IMPORTED_MODULE_5__na_thermostat_cool__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].NA_THERMOSTAT_DUAL,__WEBPACK_IMPORTED_MODULE_6__na_thermostat_dual__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].NA_THERMOSTAT_HEAT,__WEBPACK_IMPORTED_MODULE_7__na_thermostat_heat__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].RECIPE,__WEBPACK_IMPORTED_MODULE_8__recipes__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].TUNEABLE_LIGHT,__WEBPACK_IMPORTED_MODULE_9__tuneable_light__),_defineProperty(_true$true,type===__WEBPACK_IMPORTED_MODULE_11__core_constants_schedule__["c" /* scheduleType */].WARM_WHITE_LIGHT,__WEBPACK_IMPORTED_MODULE_10__warm_white_light__),_true$true)[true];};var getDefaultEventValue=function getDefaultEventValue(args){var type=args.type;var _getTypeBehaviour=getTypeBehaviour(type),defaultEventValue=_getTypeBehaviour.defaultEventValue;return defaultEventValue;};var getValueColor=function getValueColor(args){var slotType=args.slotType;var defaultColor=__WEBPACK_IMPORTED_MODULE_12__core_themes_main__["a" /* default */].mediumGrey;var _getTypeBehaviour2=getTypeBehaviour(slotType),getValueColor=_getTypeBehaviour2.getValueColor;return getValueColor?getValueColor(args):defaultColor;};var getDualColors=function getDualColors(args){var type=args.type;var defaultDualColors=null;var _getTypeBehaviour3=getTypeBehaviour(type),getDualColors=_getTypeBehaviour3.getDualColors;return getDualColors?getDualColors(args):defaultDualColors;};var getValueLabel=function getValueLabel(args){var slotType=args.slotType;var defaultLabel='';var _getTypeBehaviour4=getTypeBehaviour(slotType),getValueLabel=_getTypeBehaviour4.getValueLabel;return getValueLabel?getValueLabel(args):defaultLabel;};var updateValue=function updateValue(type,event){var _getTypeBehaviour5=getTypeBehaviour(type),updateValue=_getTypeBehaviour5.updateValue;if(updateValue){return updateValue(event);}else{// eslint-disable-next-line no-console
console.warn('No \'updateValue\' function was defined for this schedule type! '+type);return event;}};var hasPicker=function hasPicker(args){var type=args.type;var defaultValue=false;var _getTypeBehaviour6=getTypeBehaviour(type),hasPicker=_getTypeBehaviour6.hasPicker;return hasPicker?hasPicker(args):defaultValue;};var getPicker=function getPicker(args){var type=args.type;var _getTypeBehaviour7=getTypeBehaviour(type),getPicker=_getTypeBehaviour7.getPicker;if(getPicker){return getPicker(args);}else{// eslint-disable-next-line no-console
console.warn('No \'getPicker\' function was defined for this schedule type! '+type);return null;}};var hasSaveButton=function hasSaveButton(args){var type=args.type;var defaultValue=true;var _getTypeBehaviour8=getTypeBehaviour(type),hasSaveButton=_getTypeBehaviour8.hasSaveButton;return hasSaveButton?hasSaveButton(args):defaultValue;};var getDefaultSchedule=function getDefaultSchedule(args){var type=args.type;var _getTypeBehaviour9=getTypeBehaviour(type),getDefaultSchedule=_getTypeBehaviour9.getDefaultSchedule;if(getDefaultSchedule){return getDefaultSchedule(args);}else{// eslint-disable-next-line no-console
console.warn('No \'getDefaultSchedule\' function was defined for this schedule type! '+type);return null;}};

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({undoAll:{id:'schedule.undo-all',defaultMessage:'Undo All',description:'Undo all changes made in the schedule'},save:{id:'schedule.save',defaultMessage:'Save',description:'Save changes made in the schedule'},close:{id:'schedule.close',defaultMessage:'Close',description:'Collapse the selected day'},// Messages
addEvent:{id:'schedule.add-event',defaultMessage:'To add a new time slot, choose the day you want to add it to'},addEventSelectedDay:{id:'schedule.add-event-selected-day',defaultMessage:'Now choose where you would like it to be added'},addEventMaxEvents:{id:'schedule.add-event-max-events',defaultMessage:'Sorry you cannot add more time slots on this day! The maximum allowed was reached'},copyDayEventsCopyFrom:{id:'schedule.copy-day-events-copy-from',defaultMessage:'Select the day you want to copy from'},copyDayEventsCopyTo:{id:'schedule.copy-day-events-copy-to',defaultMessage:'Now select the days you want to copy to'},deleteEvent:{id:'schedule.delete-event',defaultMessage:'To remove a time slot, choose the day you want to remove from'},deleteEventSelectedDay:{id:'schedule.delete-event-selected-day',defaultMessage:'Now select the time slot you want to remove'},deleteEventMinEvents:{id:'schedule.delete-event-min-events',defaultMessage:'Sorry you cannot remove the only time slot of the day'},// tooltip
tooltipMessage:{id:'schedule.tooltip-message',defaultMessage:"Click here to change this timeslot's value"},resetSchedule:{id:'schedule.reset-schedule',defaultMessage:'Reset Schedule'},savingSchedule:{id:'schedule.saving-schedule',defaultMessage:'Saving Schedule'},// Hue
hueWarningMessage:{id:'schedule-picker.hue-warning-message',defaultMessage:'Philips Hue Routines and Timers will remain active if not disabled.'}}));

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedDayHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getControlPanelHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTimeAxisHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getWeekHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPopupSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPopupButtonHeight; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_memoize__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(49);
// @noflow
var MIN_HEIGHT_RATIO=0.2;// When a day with no events is selected, it will use 20% of the height
var MAX_HEIGHT_RATIO=0.7;// When a day with 6 events is selected, it will use 70% of the height
var MAX_EVENTS_IN_DAY=6;var DAYS_IN_WEEK=7;var getSelectedDayHeight=function getSelectedDayHeight(height,numEventsInSelectedDay){// if a day is selected then define its height depending of the number of events it has
var expectedSelectedDayHeight=height*(MIN_HEIGHT_RATIO+(MAX_HEIGHT_RATIO-MIN_HEIGHT_RATIO)*numEventsInSelectedDay/MAX_EVENTS_IN_DAY);// now check how hight can be the 6 other days
var otherDayHeight=Math.floor((height-expectedSelectedDayHeight)/(DAYS_IN_WEEK-1));return{otherDayHeight:otherDayHeight,// Because we are flooring the value above, it may have some unused pixels so instead of
// just returning the expectedSelectedDayHeight we return the rest of the total height minus
// the 6 other days height
selectedDayHeight:height-otherDayHeight*(DAYS_IN_WEEK-1)};};var getControlPanelHeight=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_memoize___default()(function(componentHeight){return Math.floor(componentHeight*__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* heightRatios */].CONTROL_PANEL);});var getTimeAxisHeight=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_memoize___default()(function(componentHeight){return Math.floor(componentHeight*__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* heightRatios */].TIME_AXIS);});var getWeekHeight=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_memoize___default()(function(componentHeight){return componentHeight-getControlPanelHeight(componentHeight)-getTimeAxisHeight(componentHeight);});var getPopupSize=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_memoize___default()(function(componentHeight){return Math.floor(componentHeight*0.5);});var getPopupButtonHeight=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_memoize___default()(function(componentHeight){return Math.floor(getPopupSize(componentHeight)*0.2);});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return barColourModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return responsiveVars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return textAnchor; });
var barColourModes={YDOMAIN:'Y_DOMAIN',XINDEX:'X_INDEX',SINGLE:'SINGLE'};var responsiveVars={BAR_RADIUS_MEDIUM:5,BAR_RADIUS_SMALL:2,BAR_AMOUNT_LIMIT:10,GRAPH_WIDTH_MEDIUM:640,GRAPH_HEIGHT_COEF_MEDIUM:0.5,GRAPH_HEIGHT_COEF_SMALL:0.75,GRAPH_MAX_HEIGHT_COEF:250,GUTTER_SPACING_L:2,GUTTER_SPACING_S:1};var textAnchor={END:'end',MIDDLE:'middle',START:'start'};

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MIGRATION_STATUS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MIGRATION_STATUS_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return START_MIGRATION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return START_MIGRATION_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return START_MIGRATION_POLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return STOP_MIGRATION_POLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PROGRESS_INSTALL_STAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return STAGE_BAD_PLACEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STAGE_CLAIM_HUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STAGE_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return STAGE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return STAGE_GOOD_PLACEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STAGE_INSTRUCTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return STAGE_SLT1_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return STAGE_SPARE_ETHERNET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return STAGE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return STAGE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FINISHED; });
/* unused harmony export IN_PROGRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SOURCE_HUB_OFFLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DESTINATION_HUB_OFFLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DESTINATION_NOT_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MIGRATION_POLL_INTERVAL; });
var MIGRATION_STATUS_REQUEST='hive/install-nano1-upgrade/MIGRATION_STATUS_REQUEST';var MIGRATION_STATUS_RESPONSE='hive/install-nano1-upgrade/MIGRATION_STATUS_RESPONSE';var START_MIGRATION_REQUEST='hive/install-nano1-upgrade/START_MIGRATION_REQUEST';var START_MIGRATION_RESPONSE='hive/install-nano1-upgrade/START_MIGRATION_RESPONSE';var START_MIGRATION_POLL='hive/install-nano1-upgrade/START_MIGRATION_POLL';var STOP_MIGRATION_POLL='hive/install-nano1-upgrade/STOP_MIGRATION_POLL';var PROGRESS_INSTALL_STAGE='hive/install-nano1-upgrade/PROGRESS_INSTALL_STAGE';var STAGE_BAD_PLACEMENT='hive/install-nano1-upgrade/stage/BAD_PLACEMENT';var STAGE_CLAIM_HUB='hive/install-nano1-upgrade/stage/CLAIM_HUB';var STAGE_COMPLETE='hive/install-nano1-upgrade/stage/COMPLETE';var STAGE_ERROR='hive/install-nano1-upgrade/stage/ERROR';var STAGE_GOOD_PLACEMENT='hive/install-nano1-upgrade/stage/GOOD_PLACEMENT';var STAGE_INSTRUCTIONS='hive/install-nano1-upgrade/stage/INSTRUCTIONS';var STAGE_SLT1_ERROR='hive/install-nano1-upgrade/stage/SLT1_ERROR';var STAGE_SPARE_ETHERNET='hive/install-nano1-upgrade/stage/SPARE_ETHERNET';var STAGE_START='hive/install-nano1-upgrade/stage/START';var STAGE_STATUS='hive/install-nano1-upgrade/stage/STATUS';var FAILED='FAILED';var FINISHED='FINISHED';var IN_PROGRESS='IN_PROGRESS';var SOURCE_HUB_OFFLINE='SOURCE_HUB_OFFLINE';var DESTINATION_HUB_OFFLINE='DESTINATION_HUB_OFFLINE';var DESTINATION_NOT_FOUND='DESTINATION_NOT_FOUND';var MIGRATION_POLL_INTERVAL=30000;

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INITIATE_HOLIDAYMODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INITIALIZE_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EXIT_HOLIDAY_MODE_SCREEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATE_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_HOLIDAY_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TEMPERATURE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TIME_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DISABLE_HOLIDAY_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EDITING_HOLIDAY_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEVICES_OUT_OF_SYNC; });
var INITIATE_HOLIDAYMODE='hive/holiday-mode/initiate';var INITIALIZE_STATE='hive/holiday-mode/initialize';var EXIT_HOLIDAY_MODE_SCREEN='hive/holiday-mode/exit';var DATE_SELECTED='hive/holiday-mode/date_selected';var SET_HOLIDAY_MODE='hive/holiday-mode/set';var TEMPERATURE_CHANGE='hive/holiday-mode/temperature_change';var TIME_CHANGE='hive/holiday-mode/time_change';var DISABLE_HOLIDAY_MODE='hive/holiday-mode/disable';var EDITING_HOLIDAY_MODE='hive/holiday-mode/editing';var DEVICES_OUT_OF_SYNC='DEVICES_OUT_OF_SYNC';

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('some', __webpack_require__(1511));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(4);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(2285);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(2287);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(1007);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(807);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters or exits.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  exit?: string,
   *  exitActive?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ```js
 * import CSSTransition from 'react-transition-group/CSSTransition';
 *
 * const Fade = ({ children, ...props }) => (
 *  <CSSTransition
 *    {...props}
 *    timeout={500}
 *    classNames="fade"
 *  >
 *   {children}
 *  </CSSTransition>
 * );
 *
 * class FadeInAndOut extends React.Component {
 *   constructor(...args) {
 *     super(...args);
 *     this.state= { show: false }
 *
 *     setInterval(() => {
 *       this.setState({ show: !this.state.show })
 *     }, 5000)
 *   }
 *   render() {
 *     return (
 *       <Fade in={this.state.show}>
 *         <div>Hello world</div>
 *       </Fade>
 *     )
 *   }
 * }
 * ```
 *
 * And the coorresponding CSS for the `<Fade>` component:
 *
 * ```css
 * .fade-enter {
 *   opacity: 0.01;
 * }
 *
 * .fade-enter.fade-enter-active {
 *   opacity: 1;
 *   transition: opacity 500ms ease-in;
 * }
 *
 * .fade-exit {
 *   opacity: 1;
 * }
 *
 * .fade-exit.fade-exit-active {
 *   opacity: 0.01;
 *   transition: opacity 300ms ease-in;
 * }
 * ```
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      return { className: className, activeClassName: activeClassName };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(651);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 223 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(554);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1051),
    isObjectLike = __webpack_require__(91);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(52),
    stubFalse = __webpack_require__(1052);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188)(module)))

/***/ }),
/* 228 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(230),
    isFlattenable = __webpack_require__(1111);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(83);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 233 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(83)
  , TAG = __webpack_require__(33)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTEMPTS_BEFORE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ATTEMPT_LOAD_COUNTRY_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_COUNTRY_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ENVIRONMENT_CONFIG; });
var ATTEMPTS_BEFORE_FAIL=5;var ATTEMPT_LOAD_COUNTRY_CONFIG='hive/config/ATTEMPT_LOAD_COUNTRY_CONFIG';var LOAD_COUNTRY_CONFIG='hive/config/LOAD_COUNTRY_CONFIG';var CHANGE_ENV='hive/config/CHANGE_ENV';var ENVIRONMENT_CONFIG=global.ENV||{};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1378);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var BLAME_FUNCTION_INDEX = 3; // [current, parent, *error*, caller to blame, …]

function warnDeprecation(reason) {
  // eslint-disable-line max-statements
  if (Object({"NODE_ENV":"production","PUBLIC_URL":"","PLATFORM":"web"}).FOLKTALE_ASSERTIONS !== 'none') {
    var stack = new Error('').stack;
    var offender = void 0;
    if (stack) {
      var lines = stack.split('\n');
      offender = lines[BLAME_FUNCTION_INDEX];
    }

    if (offender) {
      console.warn(reason + '\n    Blame: ' + offender.trim());
    } else {
      console.warn(reason);
    }
  }
}

module.exports = warnDeprecation;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var keys = Object.keys;
var symbols = Object.getOwnPropertySymbols;
var defineProperty = Object.defineProperty;
var property = Object.getOwnPropertyDescriptor;

/*
 * Extends an objects with own enumerable key/value pairs from other sources.
 *
 * This is used to define objects for the ADTs througout this file, and there
 * are some important differences from Object.assign:
 *
 *   - This code is only concerned with own enumerable property *names*.
 *   - Additionally this code copies all own symbols (important for tags).
 *
 * When copying, this function copies **whole property descriptors**, which
 * means getters/setters are not executed during the copying. The only
 * exception is when the property name is `prototype`, which is not
 * configurable in functions by default.
 *
 * This code only special cases `prototype` because any other non-configurable
 * property is considered an error, and should crash the program so it can be
 * fixed.
 */
function extend(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  sources.forEach(function (source) {
    keys(source).forEach(function (key) {
      if (key === 'prototype') {
        target[key] = source[key];
      } else {
        defineProperty(target, key, property(source, key));
      }
    });
    symbols(source).forEach(function (symbol) {
      defineProperty(target, symbol, property(source, symbol));
    });
  });
  return target;
}

module.exports = extend;

/***/ }),
/* 240 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTEMPT_CREATE_RECIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ATTEMPT_DELETE_RECIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ATTEMPT_UPDATE_RECIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CANCEL_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CANCEL_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EDIT_RECIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EDIT_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_RECIPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HANDLE_NOTIFICATION_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HANDLE_PROPERTY_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return HIDE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RECEIVE_RECIPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return REQUEST_CONFIRM_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SELECT_CONSUMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SELECT_PRODUCER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SELECT_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SHOW_TEMPLATES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return TOGGLE_SCHEDULE_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPDATE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_RECIPE; });
var ATTEMPT_CREATE_RECIPE='hive/recipes/ATTEMPT_CREATE_RECIPE';var ATTEMPT_DELETE_RECIPE='hive/recipes/ATTEMPT_DELETE_RECIPE';var ATTEMPT_UPDATE_RECIPE='hive/recipes/ATTEMPT_UPDATE_RECIPE';var CANCEL_ACTION='hive/recipes/CANCEL_ACTION';var CANCEL_TEMPLATE='hive/recipes/CANCEL_TEMPLATE';var EDIT_RECIPE='hive/recipes/EDIT_RECIPE';var EDIT_SCHEDULE='hive/recipes/EDIT_SCHEDULE';var GET_RECIPES='hive/recipes/GET_RECIPES';var HANDLE_NOTIFICATION_CHANGE='hive/recipes/HANDLE_NOTIFICATION_CHANGE';var HANDLE_PROPERTY_CHANGE='hive/recipes/HANDLE_PROPERTY_CHANGE';var HIDE_MODAL='hive/recipes/HIDE_MODAL';var RECEIVE_RECIPES='hive/recipes/RECEIVE_RECIPES';var REQUEST_CONFIRM_DELETE='hive/recipes/REQUEST_CONFIRM_DELETE';var SELECT_CONSUMER='hive/recipes/SELECT_CONSUMER';var SELECT_PRODUCER='hive/recipes/SELECT_PRODUCER';var SELECT_TEMPLATE='hive/recipes/SELECT_TEMPLATE';var SHOW_TEMPLATES_LIST='hive/recipes/SHOW_TEMPLATES_LIST';var TOGGLE_SCHEDULE_STATE='hive/recipes/TOGGLE_SCHEDULE_STATE';var UPDATE_DATA='hive/recipes/UPDATE_DATA';var UPDATE_RECIPE='hive/recipes/UPDATE_RECIPE';

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = shouldPureComponentUpdate;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _shallowEqual = __webpack_require__(1850);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function shouldPureComponentUpdate(nextProps, nextState) {
  return !(0, _shallowEqual2['default'])(this.props, nextProps) || !(0, _shallowEqual2['default'])(this.state, nextState);
}

module.exports = exports['default'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = function getFunctionName(f) {
  return f.displayName || f.name || '<function' + f.length + '>';
};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var getTypeName = __webpack_require__(53);

module.exports = function forbidNewOperator(x, type) {
  assert(!(x instanceof type), function () { return 'Cannot use the new operator to instantiate the type ' + getTypeName(type); });
};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var getLength = __webpack_require__(765),
    isLength = __webpack_require__(212);

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

module.exports = isArrayLike;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(767);

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

module.exports = bindCallback;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2116)();
}


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({// Templates list
setUpNow:{id:'actions.set-up-now',defaultMessage:'Set up now'},// Template Description
continue:{id:'actions.continue',defaultMessage:'Continue'},thisActionUses:{id:'actions.this-action-uses',defaultMessage:'This actions uses',description:'Listing all attributes used by the actions (e.g. devices, dark)'},deviceRequired:{id:'actions.device-required',defaultMessage:'Required'},hiveLiveRequired:{id:'actions.hiveLiveRequired',defaultMessage:'Hive Live required'},hubRequiredTitle:{id:'actions.hub-required-title',defaultMessage:'Hive hub is required'},hubRequiredDescription:{id:'actions.hub-required-description',defaultMessage:'Actions is one of many new and upcoming smart features that needs our Hub to work.'},findOutMore:{id:'actions.find-out-more',defaultMessage:'Find out more'},upgradeHubTitle:{id:'actions.upgrade-hub-title',defaultMessage:"It's time to upgrade your Hub"},upgradeHubContent:{id:'actions.upgrade-hub-content',defaultMessage:'This is one of many new and upcoming smart features that needs the latest version of our Hub to work. Call us on 0333 202 9618 to get your upgrade.'},done:{id:'actions.done',defaultMessage:'Done'},// Filter sections
browseByCategory:{id:'actions.browse-by-category',defaultMessage:'Browse by category'},browseByDevice:{id:'actions.browse-by-device',defaultMessage:'Browse by device'},browseAllActions:{id:'actions.browse-all-actions',defaultMessage:'Browse all Actions'},buildYourOwn:{id:'actions.build-your-own',defaultMessage:'Build your own'},// Banner Filter
bannerTitle:{id:'actions.banner-title',defaultMessage:'Welcome Home'},bannerDescription:{id:'actions.banner-description',defaultMessage:'Browse the new and powerful actions introduced with Welcome Home subscription.'},bannerBrowse:{id:'actions.banner-browse',defaultMessage:'BROWSE'},//
cancelAttribute:{id:'actions.cancel-attribute',defaultMessage:'Cancel'}}));

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hamsterjs__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hamsterjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hamsterjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spinner_value_spinner_value_component__ = __webpack_require__(2197);
// @noflow
/*eslint react/no-did-mount-set-state:0*//**
 * The main logic of this component is around the 2 state variables displayFloatIndex
 * and targetFloatIndex. The range of the indexes is from 0 to props.rangeValues.lengt - 1.
 * Both indexes are float numbers for animation purpose. the displayFloatIndex state
 * represent the current position of the spinner and the targert one represent the desired
 * position (e.g.: key up)
 */var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// define global constant linked to the platform type
var isMac=window.navigator.platform==='MacIntel';var PIXEL_RATIO=window.devicePixelRatio||1;if(isMac){PIXEL_RATIO<<=1;}var updateDelay=750;/************************
  *   Helper functions   *
  ************************/var _getAbsoluteIndex=function _getAbsoluteIndex(index,length){return length?(index%length+length)%length:0;};var _getDisplayedValue=function _getDisplayedValue(rangeValues,index){if(typeof rangeValues[index]==='string'){return rangeValues[index];}else{return rangeValues[index]?rangeValues[index][0].text:'';}};/*****************
  *   Component   *
  *****************/var Spinner=function(_React$Component){_inherits(Spinner,_React$Component);function Spinner(props){_classCallCheck(this,Spinner);var _this=_possibleConstructorReturn(this,(Spinner.__proto__||Object.getPrototypeOf(Spinner)).call(this,props));_this.debouncedChange=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default()(updateDelay,function(_ref){var handleChangeIndex=_ref.handleChangeIndex,roundedTargetIndex=_ref.roundedTargetIndex,rangeValues=_ref.rangeValues;return handleChangeIndex&&handleChangeIndex(_getAbsoluteIndex(roundedTargetIndex,rangeValues.length));});_this.animate=function(){var _this$state=_this.state,animationId=_this$state.animationId,displayFloatIndex=_this$state.displayFloatIndex,targetFloatIndex=_this$state.targetFloatIndex;var delta=(targetFloatIndex-displayFloatIndex)/10;if(Math.abs(delta)>=0.001){_this.setState({animationId:window.requestAnimationFrame(_this.animate),displayFloatIndex:displayFloatIndex+delta});}else{window.cancelAnimationFrame(animationId);_this.setState({displayFloatIndex:targetFloatIndex});}};_this.snapValue=function(){var targetFloatIndex=_this.state.targetFloatIndex;if(targetFloatIndex%1){_this.setState({animationId:window.requestAnimationFrame(_this.animate),targetFloatIndex:Math.round(targetFloatIndex)});}};_this.up=function(){_this.setState(function(prevState,_ref2){var isLoop=_ref2.isLoop;if(isLoop||prevState.targetFloatIndex>0){return{animationId:window.requestAnimationFrame(_this.animate),pointerId:null,pointerMoving:false,targetFloatIndex:Math.round(prevState.targetFloatIndex-1)};}});};_this.down=function(){_this.setState(function(prevState,_ref3){var isLoop=_ref3.isLoop,rangeValues=_ref3.rangeValues;if(isLoop||prevState.targetFloatIndex<rangeValues.length-1){return{animationId:window.requestAnimationFrame(_this.animate),pointerId:null,pointerMoving:false,targetFloatIndex:Math.round(prevState.targetFloatIndex+1)};}});};_this.click=function(event){var height=_this.state.height;var bound=_this.canvas.getBoundingClientRect();var y=event.clientY-bound.top;if(y<=height||y>0){if(y<=height/2){_this.up();}else{_this.down();}}};_this.pointerDown=function(event,pointerId){_this.setState({delta:0,pointerDownY:event.screenY,pointerId:pointerId,pointerMoving:false});};_this.pointerMove=function(pointer){var _this$props=_this.props,isLoop=_this$props.isLoop,rangeValues=_this$props.rangeValues;var _this$state2=_this.state,displayFloatIndex=_this$state2.displayFloatIndex,pointerDownY=_this$state2.pointerDownY,pointerMoving=_this$state2.pointerMoving;var newPointerY=pointer.screenY;var delta=newPointerY-pointerDownY;var newDisplayFloatIndex=displayFloatIndex-delta*0.01;if(!isLoop){newDisplayFloatIndex=Math.max(newDisplayFloatIndex,-0.49);newDisplayFloatIndex=Math.min(newDisplayFloatIndex,rangeValues.length-1+0.49);}_this.setState({delta:delta,displayFloatIndex:newDisplayFloatIndex,pointerDownY:newPointerY,pointerMoving:pointerMoving||newPointerY!==pointerDownY});};_this.pointerUp=function(){var _this$props2=_this.props,isLoop=_this$props2.isLoop,rangeValues=_this$props2.rangeValues;var _this$state3=_this.state,delta=_this$state3.delta,displayFloatIndex=_this$state3.displayFloatIndex;var newTargetFloatIndex=Math.round(displayFloatIndex-delta*0.2);if(!isLoop){newTargetFloatIndex=Math.max(newTargetFloatIndex,0);newTargetFloatIndex=Math.min(newTargetFloatIndex,rangeValues.length-1);}_this.setState({animationId:window.requestAnimationFrame(_this.animate),pointerId:null,targetFloatIndex:newTargetFloatIndex});};_this.handleClick=function(event){var pointerMoving=_this.state.pointerMoving;if(_this.props.disabled){return;}if(pointerMoving){_this.setState({pointerMoving:false});}else{_this.click(event);}};_this.handleMouseWheel=function(event,delta,deltaX,deltaY){var _this$props3=_this.props,isLoop=_this$props3.isLoop,rangeValues=_this$props3.rangeValues;var _this$state4=_this.state,displayFloatIndex=_this$state4.displayFloatIndex,snapTimeOut=_this$state4.snapTimeOut,animationId=_this$state4.animationId;event.preventDefault();if(_this.props.disabled){return;}clearTimeout(snapTimeOut);if(isNaN(deltaY)){deltaY=0;}if(!isMac){deltaY*=20;}window.cancelAnimationFrame(animationId);var newDisplayFloatIndex=displayFloatIndex-Math.sign(deltaY)*Math.min(Math.abs(deltaY*0.1),2);if(!isLoop){newDisplayFloatIndex=Math.max(newDisplayFloatIndex,0);newDisplayFloatIndex=Math.min(newDisplayFloatIndex,rangeValues.length-1);}// if no event was called in the last 200ms then round the target index
var newTimeOut=setTimeout(function(){_this.snapValue();},200);_this.setState({animationId:window.requestAnimationFrame(_this.animate),targetFloatIndex:newDisplayFloatIndex,snapTimeOut:newTimeOut});};_this.handleTouchStart=function(event){var pointerId=_this.state.pointerId;if(_this.props.disabled){return;}if(pointerId===null){event.preventDefault();var touch=event.targetTouches[0];_this.pointerDown(touch,touch.identifier);}};_this.handleTouchMove=function(event){var pointerId=_this.state.pointerId;if(_this.props.disabled){return;}var touch=Object.keys(event.changedTouches).map(function(key){return event.changedTouches[key];}).find(function(touch){return touch.identifier===pointerId;});if(touch){event.preventDefault();_this.pointerMove(touch);}};_this.handleTouchEnd=function(event){var _this$state5=_this.state,pointerId=_this$state5.pointerId,pointerMoving=_this$state5.pointerMoving;if(_this.props.disabled){return;}var touch=Object.keys(event.changedTouches).map(function(key){return event.changedTouches[key];}).find(function(touch){return touch.identifier===pointerId;});if(touch){event.preventDefault();if(pointerMoving){_this.pointerUp();}else{_this.click(touch);}}};_this.handlePointerDown=function(event){event.preventDefault();var pointerId=_this.state.pointerId;if(_this.props.disabled){return;}if(event.pointerType!=='mouse'&&pointerId===null){_this.pointerDown(event,event.pointerId);}};_this.handlePointerMove=function(event){event.preventDefault();var pointerId=_this.state.pointerId;if(_this.props.disabled){return;}if(event.pointerType!=='mouse'&&pointerId===event.pointerId){_this.pointerMove(event);}};_this.handlePointerUp=function(event){event.preventDefault();var pointerId=_this.state.pointerId;if(_this.props.disabled){return;}if(event.pointerType!=='mouse'&&pointerId===event.pointerId){_this.pointerUp();}};_this.handleKeyDown=function(event){if(_this.props.disabled){return;}if(event.keyCode===38){_this.up();}else if(event.keyCode===40){_this.down();}};_this.handleResize=function(){var container=_this.container;if(container){_this.setState({height:container.offsetHeight,width:container.offsetWidth});}};_this.state={ctx:null,currentIndex:0,displayFloatIndex:props.currentIndex||0,pointerId:null,pointerMoving:false,targetFloatIndex:props.currentIndex||0};return _this;}_createClass(Spinner,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var ctx=this.canvas.getContext('2d');ctx.textBaseline='alphabetic';if(window.navigator.pointerEnabled||window.navigator.msPointerEnabled){this.canvas.addEventListener('pointerdown',this.handlePointerDown);window.addEventListener('pointermove',this.handlePointerMove);window.addEventListener('pointerup',this.handlePointerUp);}else if('ontouchstart'in window){this.canvas.addEventListener('touchstart',this.handleTouchStart);this.canvas.addEventListener('touchmove',this.handleTouchMove);window.addEventListener('touchend',this.handleTouchEnd);}__WEBPACK_IMPORTED_MODULE_1_hamsterjs___default()(this.canvas).wheel(this.handleMouseWheel);window.addEventListener('resize',this.handleResize);var container=this.container;if(container){var check=function check(){return container.offsetHeight>0&&container.offsetWidth>0?_this2.setState({ctx:ctx,height:container.offsetHeight,width:container.offsetWidth}):setTimeout(check,100);};check();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.canvas.removeEventListener('touchstart',this.handleTouchStart);this.canvas.removeEventListener('touchmove',this.handleTouchMove);window.removeEventListener('touchend',this.handleTouchEnd);this.canvas.removeEventListener('pointerdown',this.handlePointerDown);window.removeEventListener('pointermove',this.handlePointerMove);window.removeEventListener('pointerup',this.handlePointerUp);window.removeEventListener('resize',this.handleResize);}// if no update in the last 750ms then let the parent component know the current index has changed
},{key:'componentWillUpdate',value:function componentWillUpdate(nextProps,nextState){var _props=this.props,currentIndex=_props.currentIndex,handleChangeIndex=_props.handleChangeIndex,isLoop=_props.isLoop,rangeValues=_props.rangeValues;var targetFloatIndex=this.state.targetFloatIndex;if(currentIndex!==nextProps.currentIndex&&(!isLoop||(nextProps.currentIndex-targetFloatIndex)%rangeValues.length)){this.setState({animationId:window.requestAnimationFrame(this.animate),targetFloatIndex:nextProps.currentIndex});}else{var roundedTargetIndex=Math.round(nextState.targetFloatIndex);if(targetFloatIndex!==nextState.targetFloatIndex&&roundedTargetIndex!==nextProps.currentIndex&&handleChangeIndex){this.debouncedChange({handleChangeIndex:handleChangeIndex,roundedTargetIndex:roundedTargetIndex,rangeValues:rangeValues});}}}/**
	 * The aim of the animate function is to aproximate the display index
	 * to the target one by 10% of the diference in each frame until it
	 * gets so close then they become equal
	 *//**
	 * Round the target index (e.g. 2.23 -> 2, 3.834 -> 4)
	 *//************************
	 *   ACTION FUNCTIONS   *
	 ************************//*** POINTER ***//************************
	 *   EVENTS FUNCTIONS   *
	 ************************//*** Mouse wheel and trackpad scrolling ***//*** Touch events ***//*** Internet Explorer pointer ***//*** Key events ***/},{key:'render',value:function render(){var _this3=this;var _props2=this.props,bgColor=_props2.bgColor,color=_props2.color,font=_props2.font,isLoop=_props2.isLoop,rangeColors=_props2.rangeColors,rangeValues=_props2.rangeValues,style=_props2.style,disabled=_props2.disabled;var _state=this.state,ctx=_state.ctx,displayFloatIndex=_state.displayFloatIndex,height=_state.height,width=_state.width;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{'data-qa':'spinner',onKeyDown:this.handleKeyDown,ref:function ref(r){return _this3.container=r;},style:style,tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('canvas',{'aria-label':'Spinner',className:'spinner','data-qa':'spinner-value-'+_getDisplayedValue(rangeValues,displayFloatIndex),'data-qa-max':'spinner-value-'+_getDisplayedValue(rangeValues,0),'data-qa-min':'spinner-value-'+_getDisplayedValue(rangeValues,rangeValues.length-1),height:height*PIXEL_RATIO,onClick:this.handleClick,ref:function ref(r){return _this3.canvas=r;},style:Object.assign({},style),width:width*PIXEL_RATIO}),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__spinner_value_spinner_value_component__["a" /* default */],{bgColor:bgColor,color:color,ctx:ctx,disabled:disabled,displayFloatIndex:isLoop?_getAbsoluteIndex(displayFloatIndex,rangeValues.length):displayFloatIndex,font:font,height:height*PIXEL_RATIO,isLoop:isLoop,rangeColors:rangeColors,rangeValues:rangeValues,width:width*PIXEL_RATIO}));}}]);return Spinner;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);Spinner.propTypes={bgColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,color:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,currentIndex:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,font:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,handleChangeIndex:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,isLoop:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,rangeColors:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,rangeValues:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,style:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};Spinner.defaultProps={isLoop:false,rangeValues:[]};/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return marginMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return marginTablet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return marginDesktop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return borderRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return iconsContainerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return textContainerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return controlPanelHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return detailsPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return recipeItemAnimationDuration; });
/* unused harmony export bezier */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return iconContainerSize; });
var marginMobile=1;var marginTablet=marginMobile*1.5;var marginDesktop=marginMobile*2;var borderRadius=0.5;var iconsContainerHeight=5;var textContainerHeight=7;var controlPanelHeight=2.5;var detailsPadding=0.8;var recipeItemAnimationDuration=500;var bezier='cubic-bezier(0.23, 1, 0.32, 1)';var iconContainerSize=1.75;

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = interlaceItems;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_conditional_feature__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(123);
var truthyCondition=function truthyCondition(){return true;};function interlaceItems(originalList,insertions){return insertions.reduce(function(interlaced,next,key){var pos=parseInt(next.position,10);var element=next.element,_next$condition=next.condition,condition=_next$condition===undefined?truthyCondition:_next$condition,enabled=next.enabled;var nextItem=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__core_components_conditional_feature__["a" /* default */],{condition:condition,key:key+'-pickerItem'},function(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["d" /* MenuItem */],{enabled:enabled},element);});if(pos<0){interlaced.push(nextItem);}else{interlaced.splice(pos,0,nextItem);}return interlaced;},originalList);}

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(2434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__ = __webpack_require__(14);
var mapStateToProps=function mapStateToProps(state,_ref){var _ref$unit=_ref.unit,unit=_ref$unit===undefined?Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'temperatureUnit'):_ref$unit;return{unit:unit};};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]));

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRecipesSection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRecipesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTemplatesList; });
/* unused harmony export makeGetTemplate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return makeGetProducersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentRecipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return makeGetConsumersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIsFirstLoadingDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getModalVisiblePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hasRecipeProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHasActiveHeatingRecipes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_recipes__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
var getRecipesSection=function getRecipesSection(state){return state.recipes;};var getTemplateNameFromProps=function getTemplateNameFromProps(_,props){return props&&props.name||'';};var getProducerIdFromProps=function getProducerIdFromProps(_,_ref){var producerId=_ref.producerId;return producerId;};var getConsumerIdFromProps=function getConsumerIdFromProps(_,_ref2){var consumerId=_ref2.consumerId;return consumerId;};var getRecipesList=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a,getRecipesSection,getProducerIdFromProps,getConsumerIdFromProps],function(state,recipes,producerId,consumerId){return recipes.get('recipes').filter(function(r){return(!producerId||r.getIn(['data','producer'])===producerId)&&(!consumerId||r.getIn(['data','consumer'])===consumerId)&&__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["d" /* producersList */].includes(Object(__WEBPACK_IMPORTED_MODULE_2__products_selectors__["L" /* getTypeForProduct */])(state,{id:r.getIn(['data','producer'])}))&&(!r.getIn(['data','consumer'])||Object(__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["b" /* getConsumerPropertiesList */])(Object(__WEBPACK_IMPORTED_MODULE_2__products_selectors__["L" /* getTypeForProduct */])(state,{id:r.getIn(['data','consumer'])})).length>0);});});var getTemplatesList=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getRecipesSection,getProducerIdFromProps,getConsumerIdFromProps],function(recipes,producerId,consumerId){return recipes.get('templates').filter(function(t){return Object.keys(__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["e" /* templates */]).includes(t.get('name'))&&(!producerId||t.get('producers').map(function(p){return p.get('id');}).includes(producerId))&&(!consumerId||t.get('producers').map(function(p){return p.get('consumers');}).flatten().includes(consumerId));}).map(function(t){return t.get('name');});});var makeGetTemplate=function makeGetTemplate(){return Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getRecipesSection,getTemplateNameFromProps],function(recipes,name){return recipes.get('templates').find(function(t){return t.get('name')===name;});});};var makeGetProducersList=function makeGetProducersList(){return Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a,makeGetTemplate()],function(state,template){return template.get('producers').map(function(p){var id=p.get('id');return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({id:id,name:Object(__WEBPACK_IMPORTED_MODULE_2__products_selectors__["r" /* getNameForProduct */])(state,{id:id})});});});};var getCurrentRecipe=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(getRecipesSection,function(recipes){return recipes.get('currentRecipe');});var makeGetConsumersList=function makeGetConsumersList(){return Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a,makeGetTemplate(),getCurrentRecipe],function(state,template,currentRecipe){return currentRecipe.getIn(['data','producer'])===-1?Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])([]):template.get('producers').find(function(p){return p.get('id')===currentRecipe.getIn(['data','producer']);}).get('consumers').map(function(id){return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({id:id,name:Object(__WEBPACK_IMPORTED_MODULE_2__products_selectors__["r" /* getNameForProduct */])(state,{id:id})});});});};var getIsFirstLoadingDone=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(getRecipesSection,function(recipes){return recipes.get('isFirstLoadingDone');});var getModalVisiblePage=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(getRecipesSection,function(recipes){return recipes.get('modalVisiblePage');});var hasRecipeProducts=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__products_selectors__["z" /* getProductItems */],function(products){return products.some(function(p){return __WEBPACK_IMPORTED_MODULE_1__utils_recipes__["d" /* producersList */].includes(p.get('type'));});});var getHasActiveHeatingRecipes=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([getRecipesSection,__WEBPACK_IMPORTED_MODULE_2__products_selectors__["z" /* getProductItems */]],function(recipes,products){var listOfHeatingProducts=products.filter(function(p){return p.get('type')==='heating';}).map(function(p){return p.get('id');});return recipes.get('recipes').some(function(r){return r.getIn(['data','enabled'])&&listOfHeatingProducts.includes(r.getIn(['data','consumer']));});});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_CHILDREN_TO_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BRIDGE_NODE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BRIDGE_STATUS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAIR_WITH_BRIDGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return POLL_HUE_BRIDGE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SEARCH_FOR_BRIDGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AGAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return hueBridgeStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return transientStatuses; });
var ADD_CHILDREN_TO_DASHBOARD='ADD_CHILDREN_TO_DASHBOARD';var BRIDGE_NODE_CREATED='BRIDGE_NODE_CREATED';var BRIDGE_STATUS_UPDATE='BRIDGE_STATUS_UPDATE';var PAIR_WITH_BRIDGE='PAIR_WITH_BRIDGE';var POLL_HUE_BRIDGE_STATUS='POLL_HUE_BRIDGE_STATUS';var SEARCH_FOR_BRIDGE='SEARCH_FOR_BRIDGE';var AGAIN='_AGAIN';var hueBridgeStatuses={AUTHENTICATED:'AUTHENTICATED',AUTHENTICATION_REQUIRED:'AUTHENTICATION_REQUIRED',NOT_AUTHENTICATED:'NOT_AUTHENTICATED',NOT_AUTHENTICATED_AGAIN:'NOT_AUTHENTICATED_AGAIN',NOT_FOUND:'NOT_FOUND',RETRY:'RETRY',SEARCHING:'SEARCHING'};var transientStatuses=[hueBridgeStatuses.RETRY,hueBridgeStatuses.SEARCHING,hueBridgeStatuses.AUTHENTICATION_REQUIRED];

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return undoable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filterOutDeviceGroups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors__ = __webpack_require__(15);
var undoable=function undoable(reducer){return function(state,action){var index=Object(__WEBPACK_IMPORTED_MODULE_0__selectors__["x" /* getProductIndexById */])(state,action.payload.productId);return Object.assign({},reducer(state,action),{previous:state.previous.set(action.type,[index,state.productItems.get(index)])});};};var filterOutDeviceGroups=function filterOutDeviceGroups(products){return products.filter(function(p){return!p.isGroup;});};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('findIndex', __webpack_require__(429));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCurrentDashboardPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getIsDashboardFetching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getIsCustomisationLoaded; });
/* unused harmony export getDashboardCustomisation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getLastSwappedProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getIsShowingAllProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getDashboardGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getIsDashboardEditModeOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getIdsToBeDeleted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getLastPageItemCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getLastPageLastItemId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAvailableProductsForCustomisation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getHasAvailableProductsForCustomisation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getIsDashboardAddModeOn; });
/* unused harmony export getNextAvailableProductSlot */
/* unused harmony export getCurrentDashboardProductsLength */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCanDeleteProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getHasUnsavedChanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getLastProductAdded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDashboardItemPositionById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getShouldRedirectToPostinstallGroups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboardItemPositionById__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__nextAvailableProductSlot__ = __webpack_require__(662);
var minProductLength=1;var getDashboard=function getDashboard(state){return state.dashboard;};var getCurrentDashboardPage=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return dashboard.get('currentPage');});var getIsDashboardFetching=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return!!dashboard.get('isFetching');});var getIsCustomisationLoaded=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return!!dashboard.get('isLoaded');});var getDashboardCustomisation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return dashboard.get('customisation');});var getLastSwappedProduct=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return dashboard.get('lastProductSwapped');});var getIsShowingAllProducts=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return dashboard.get('displayAllProducts',false);});var getDashboardGroups=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboardCustomisation],function(customisation){return customisation.get('pages',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]));});var getIsDashboardEditModeOn=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return dashboard.get('isEditModeOn');});var getIdsToBeDeleted=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return dashboard.get('idsToBeDeleted');});var getLastPageItemCount=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboardGroups],function(){var pages=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]);return(// $FlowFixMe
pages.getIn([-1,'items'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([])).count());});var getLastPageLastItemId=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboardGroups],function(){var pages=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]);return(// $FlowFixMe
pages.getIn([-1,'items',-1,'id']));});var getAvailableProductsForCustomisation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboardGroups,__WEBPACK_IMPORTED_MODULE_4__products_selectors__["z" /* getProductItems */]],function(customisationGroups,products){if(!customisationGroups){return;}var usedIds=customisationGroups.flatMap(function(page){return page.get('items');}).map(function(item){return item.get('id');});return products.map(function(p){return p.get('id');}).filter(function(p){return!usedIds.some(function(u){return u===p;});});});var getHasAvailableProductsForCustomisation=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAvailableProductsForCustomisation],function(products){return products?products.count()>0:false;});var getIsDashboardAddModeOn=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return dashboard.get('isAddModeOn');});var getNextAvailableProductSlot=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboardGroups],__WEBPACK_IMPORTED_MODULE_5__nextAvailableProductSlot__["a" /* default */]);var getCurrentDashboardProductsLength=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboardGroups],function(pages){return pages.flatMap(function(page){return page.get('items');}).count();});var getCanDeleteProduct=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getCurrentDashboardProductsLength],function(productsLength){return productsLength>minProductLength;});var getHasUnsavedChanges=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return dashboard.get('hasUnsavedChanges');});var getLastProductAdded=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getDashboard],function(dashboard){return dashboard.get('lastProductAdded');});// $FlowFixMe
var getDashboardItemPositionById=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getDashboardGroups,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */],__WEBPACK_IMPORTED_MODULE_1__dashboardItemPositionById__["a" /* default */]);var getShouldRedirectToPostinstallGroups=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getDashboard,function(dashboard){return dashboard.get('shouldRedirectToPostinstallGroups');});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------


var Maybe = __webpack_require__(309);

var _require = __webpack_require__(198),
    typeSymbol = _require.typeSymbol;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 *   - Quildreen Motta
 * 
 * name: module folktale/maybe
 */


module.exports = (_module$exports = {
  Just: Maybe.Just,
  Nothing: Maybe.Nothing,
  hasInstance: Maybe.hasInstance,
  of: Maybe.of,
  empty: Maybe.empty,
  fromJSON: Maybe.fromJSON
}, _defineProperty(_module$exports, typeSymbol, Maybe[typeSymbol]), _defineProperty(_module$exports, 'fantasy-land/of', Maybe['fantasy-land/of']), _defineProperty(_module$exports, 'fromNullable', function fromNullable(aNullable) {
  return __webpack_require__(1437)(aNullable);
}), _defineProperty(_module$exports, 'fromResult', function fromResult(aResult) {
  return __webpack_require__(659)(aResult);
}), _defineProperty(_module$exports, 'fromValidation', function fromValidation(aValidation) {
  return __webpack_require__(658)(aValidation);
}), _module$exports);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTranslationsLoading; });
/* unused harmony export getTranslationsError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTranslations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
var getTranslationsState=function getTranslationsState(state){return state.translations||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});};var getTranslationsLoading=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getTranslationsState],function(translations){return translations.get('loading');});var getTranslationsError=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getTranslationsState],function(translations){return translations.get('error');});var getTranslations=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getTranslationsState],function(translations){return translations.get('translations');});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetPassword; });
/* unused harmony export REQUIRED */
/* unused harmony export MAX_LENGTH */
/* unused harmony export ALPHA_ONLY */
/* unused harmony export INVALID_MOBILE_NUMBER */
/* unused harmony export NOT_UNIQUE */
/* unused harmony export VALIDATION_MESSAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generalErrorMessages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/*eslint max-len:0*//* eslint-disable max-len */// ChangePassword Error messages.
var resetPassword=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({DEFAULT_ERROR_MSG:{id:'auth.reset-password.default',defaultMessage:'Oops! An unexpected error has occurred. Please refresh to continue or try again later.'},REQUIRED:{id:'auth.reset-password.required',defaultMessage:'Required'},OLD_PASSWORD_INVALID_MSG:{id:'auth.reset-password.wrong-old-password',defaultMessage:'Oops! That does not look like your old password. Please try again.'},MISMATCH:{id:'auth.reset-password.passwords-do-not-match',defaultMessage:'Oops! Your new passwords do not match. Please check and try again.'},MALFORMED:{id:'auth.reset-password.password-validation',defaultMessage:'Oops! Your password must be 8 characters or more with at least one number.'},NOT_NEW:{id:'auth.reset-password.new-same-as-old',defaultMessage:'Your new password must not be the same as your old password.'},TOO_MANY_REQUESTS:{id:'auth.reset-password.too-many-requests',defaultMessage:'There have been too many attempts to reset this password. Please wait a few minutes and try again.'},CODE_INVALID:{id:'auth.code.invalid',defaultMessage:'The verification code must be exactly 6 digits'},NOT_AUTHORIZED:{id:'auth.code.not-authorized',defaultMessage:'The verification code you sent has expired.'}});/* eslint-enable max-len */// Validation Errors
var REQUIRED='Required';var MAX_LENGTH='MaxLength';var ALPHA_ONLY='AlphaOnly';var INVALID_MOBILE_NUMBER='InvalidMobileNumber';var NOT_UNIQUE='NotUnique';var VALIDATION_MESSAGE={Required:'Oops! This field is required.',AlphaOnly:'Oops! Use only letters when entering a contact name...',InvalidMobileNumber:'Please enter a valid (UK) 11 digit mobile number.',NotUnique:'Mobile number already used.'};var generalErrorMessages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({tryAgain:{id:'general.try-again',defaultMessage:'Oops, An unexpected error occurred. Please try again or refresh the page'}});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('flow', __webpack_require__(1451));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1554);


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(2288);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disabled appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disabled enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disabled exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ```jsx
 * import TransitionGroup from 'react-transition-group/TransitionGroup';
 *
 * class TodoList extends React.Component {
 *   constructor(props) {
 *     super(props)
 *     this.state = {items: ['hello', 'world', 'click', 'me']}
 *   }
 *   handleAdd() {
 *     const newItems = this.state.items.concat([
 *       prompt('Enter some text')
 *     ]);
 *     this.setState({ items: newItems });
 *   }
 *   handleRemove(i) {
 *     let newItems = this.state.items.slice();
 *     newItems.splice(i, 1);
 *     this.setState({items: newItems});
 *   }
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={() => this.handleAdd()}>Add Item</button>
 *         <TransitionGroup>
 *           {this.state.items.map((item, i) => (
 *             <FadeTransition key={item}>
 *               <div>
 *                 {item}{' '}
 *                 <button onClick={() => this.handleRemove(i)}>
 *                   remove
 *                 </button>
 *               </div>
 *             </FadeTransition>
 *           ))}
 *         </TransitionGroup>
 *       </div>
 *     );
 *   }
 * }
 * ```
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleExited = function (key, node, originalHandler) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (key in currentChildMapping) return;

      if (originalHandler) originalHandler(node);

      _this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[key];
        return { children: children };
      });
    };

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        var onExited = function onExited(node) {
          _this.handleExited(child.key, node, child.props.onExited);
        };

        return (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var onExited = function onExited(node) {
        _this2.handleExited(child.key, node, child.props.onExited);
      };

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: onExited,
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = this.state.children;


    delete props.appear;
    delete props.enter;
    delete props.exit;

    return _react2.default.createElement(
      Component,
      props,
      values(children).map(childFactory)
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('filter', __webpack_require__(1527));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54),
    isSymbol = __webpack_require__(187);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFromConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_reduce__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_merge__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_default__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var mergeConfig=function mergeConfig(defaultConfig,env){var countryConfig=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_reduce___default()(function(all,current){return __WEBPACK_IMPORTED_MODULE_1_lodash_fp_merge___default()(all,current);},{},[defaultConfig,countryConfig,env]);};var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* ATTEMPT_LOAD_COUNTRY_CONFIG */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return(// $FlowFixMe
state.withMutations(function(map){return map.set('loadingCountryConfig',true).set('error',false);}));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* LOAD_COUNTRY_CONFIG */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref){var countryConfig=_ref.payload;// $FlowFixMe
var newState=state.withMutations(function(map){return map.mergeIn(['mergedConfig'],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(mergeConfig(__WEBPACK_IMPORTED_MODULE_3__config_default__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ENVIRONMENT_CONFIG */],countryConfig))).set('loadingCountryConfig',false);});mergedConfig=newState.get('mergedConfig');return newState;},// $FlowFixMe
function(state){return state.set('error',true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* CHANGE_ENV */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref2){var payload=_ref2.payload;mergedConfig=calculateConfig(payload);// $FlowFixMe
return state.set('mergedConfig',mergedConfig);})),_actionHandlers);var calculateConfig=function calculateConfig(env){return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(mergeConfig(__WEBPACK_IMPORTED_MODULE_3__config_default__["a" /* default */],env));};// This is an escape hatch to help parts of the app that are unable to use config from the application
// state because of where they run (mainly during startup).
// PLEASE TRY NOT TO USE THIS (VIA `getFromConfig`)
var mergedConfig=calculateConfig(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ENVIRONMENT_CONFIG */]);// $FlowFixMe
var getFromConfig=function getFromConfig(key){return mergedConfig.getIn(key.split(':'));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({mergedConfig:mergedConfig,locales:["en-gb","en-ca","en-ie","en-us","es-us","fr-ca","fr-fr","it-it"]||[]})));

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACQUIRE_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOSE_PLACEMENT_ADVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FINISH_INSTALL_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FINISHED_INSTALL_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_INSTALL_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return START_ACQUIRE_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return STOP_ACQUIRE_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UNLOAD_INSTALL_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PLACEMENT_ADVICE_TYPES; });
var ACQUIRE_DEVICES='hive/devices/ACQUIRE_DEVICES';var CLOSE_PLACEMENT_ADVICE='hive/devices/CLOSE_PLACEMENT_ADVICE';var FINISH_INSTALL_DEVICES='hive/devices/FINISH_INSTALL_DEVICES';var FINISHED_INSTALL_DEVICES='hive/devices/FINISHED_INSTALL_DEVICES';var LOAD_INSTALL_DEVICES='hive/devices/LOAD_INSTALL_DEVICES';var START_ACQUIRE_DEVICES='hive/devices/START_ACQUIRE_DEVICES';var STOP_ACQUIRE_DEVICES='hive/devices/STOP_ACQUIRE_DEVICES';var UNLOAD_INSTALL_DEVICES='hive/devices/UNLOAD_INSTALL_DEVICES';var PLACEMENT_ADVICE_TYPES={NOT_SHOWN:'PLACEMENT_ADVICE_NOT_SHOWN',SHOW:'PLACEMENT_ADVICE_SHOW',SHOWN:'PLACEMENT_ADVICE_SHOWN'};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toFarenheit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toCelsius; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flow__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flow__);
// @noflow
var toFarenheit=function toFarenheit(celsius){return Math.round(celsius*1.8+32);};var farnenheitToCelsius=function farnenheitToCelsius(farenheit){return(farenheit-32)/1.8;};var roundToHalfDegree=function roundToHalfDegree(temperature){return(Math.round(temperature*2)/2).toFixed(1);};var convertToNumber=Number;var toCelsius=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flow___default()(farnenheitToCelsius,roundToHalfDegree,convertToNumber);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return easing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bounceEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return finishBounceEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return expandIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expandFadeOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return implode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return rotate360; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return shrinkExpand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return slideDownAndGrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return slideUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return vanish; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n\t0% { transform: scale(1); }\n\t35% { transform: scale(1.05); }\n\t100% { transform: scale(1); }\n'],['\n\t0% { transform: scale(1); }\n\t35% { transform: scale(1.05); }\n\t100% { transform: scale(1); }\n']),_templateObject2=_taggedTemplateLiteral(['\n\t30% { transform: scale(1.15); }\n\t100% { transform: scale(1); }\n'],['\n\t30% { transform: scale(1.15); }\n\t100% { transform: scale(1); }\n']),_templateObject3=_taggedTemplateLiteral(['\n\t0% { transform: scale(0); }\n\t100% { transform: scale(1); }\n'],['\n\t0% { transform: scale(0); }\n\t100% { transform: scale(1); }\n']),_templateObject4=_taggedTemplateLiteral(['\n\t0% {\n\t\ttransform: scale(.8);\n\t\topacity: 0;\n\t}\n\t50% { opacity: 1; }\n\t100% {\n      \ttransform: scale(1.1);\n      \topacity: 0;\n\t}\n'],['\n\t0% {\n\t\ttransform: scale(.8);\n\t\topacity: 0;\n\t}\n\t50% { opacity: 1; }\n\t100% {\n      \ttransform: scale(1.1);\n      \topacity: 0;\n\t}\n']),_templateObject5=_taggedTemplateLiteral(['\n\t0% { transform: scaleX(1); }\n\t50% { transform: scaleX(0); }\n\t100% { transform: scaleX(1); }\n'],['\n\t0% { transform: scaleX(1); }\n\t50% { transform: scaleX(0); }\n\t100% { transform: scaleX(1); }\n']),_templateObject6=_taggedTemplateLiteral(['\n\t0% { transform: rotate(0deg); }\n\t100% { transform: rotate(360deg); }\n'],['\n\t0% { transform: rotate(0deg); }\n\t100% { transform: rotate(360deg); }\n']),_templateObject7=_taggedTemplateLiteral(['\n\t0% { transform: scale(1); }\n\t25% { transform: scale(0.85); }\n\t75% { transform: scale(0.85); }\n\t100% { transform: scale(1); }\n'],['\n\t0% { transform: scale(1); }\n\t25% { transform: scale(0.85); }\n\t75% { transform: scale(0.85); }\n\t100% { transform: scale(1); }\n']),_templateObject8=_taggedTemplateLiteral(['\n\t0% { transform: translateY(-3em) scale(0.75); }\n\t25% { transform: translateY(-3em) scale(0.75); }\n\t75% { transform: translateY(0) scale(0.75); }\n\t100% { transform: scale(1); }\n'],['\n\t0% { transform: translateY(-3em) scale(0.75); }\n\t25% { transform: translateY(-3em) scale(0.75); }\n\t75% { transform: translateY(0) scale(0.75); }\n\t100% { transform: scale(1); }\n']),_templateObject9=_taggedTemplateLiteral(['\n\t0% { transform: translateY(0); }\n\t50% { transform: translateY(0); }\n\t100% { transform: translateY(-3em); }\n'],['\n\t0% { transform: translateY(0); }\n\t50% { transform: translateY(0); }\n\t100% { transform: translateY(-3em); }\n']),_templateObject10=_taggedTemplateLiteral(['\n\t0%, 49% { opacity: 1; }\n\t50%, 100% { opacity: 0; }\n'],['\n\t0%, 49% { opacity: 1; }\n\t50%, 100% { opacity: 0; }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var easing={bounce:'cubic-bezier(.87,-.41,.19,1.44)'};var bounceEffect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject);var finishBounceEffect=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject2);var expandIn=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject3);var expandFadeOut=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject4);var implode=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject5);var rotate360=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject6);var shrinkExpand=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject7);var slideDownAndGrow=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject8);var slideUp=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject9);var vanish=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject10);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DOMResize=function(_React$Component){_inherits(DOMResize,_React$Component);function DOMResize(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DOMResize);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DOMResize.__proto__||Object.getPrototypeOf(DOMResize)).call.apply(_ref,[this].concat(args))),_this),_this.state={height:0,width:0},_this.handleResize=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default()(_this.props.debounce,function(){if(!_this.resizeParent){return;}var node=Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(_this.resizeParent);if(node&&node instanceof HTMLElement){var rect=node.getBoundingClientRect();var _onResize=_this.props.onResize;var sizes={height:rect.height,width:rect.width};_onResize&&_onResize(sizes);_this.setState(sizes);}}),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DOMResize,[{key:'componentDidMount',value:function componentDidMount(){this.handleResize();window.addEventListener('resize',this.handleResize);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.handleResize.cancel();window.removeEventListener('resize',this.handleResize);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,className=_props.className;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Container */],{className:className,ref:function ref(c){return _this2.resizeParent=c;}},children(Object.assign({},this.state)));}}]);return DOMResize;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);DOMResize.defaultProps={debounce:500};/* harmony default export */ __webpack_exports__["a"] = (DOMResize);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(134),
    isObject = __webpack_require__(54);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(277),
    isObject = __webpack_require__(54);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(555);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(224),
    eq = __webpack_require__(225);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1053),
    baseUnary = __webpack_require__(228),
    nodeUtil = __webpack_require__(560);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(283),
    stackClear = __webpack_require__(1061),
    stackDelete = __webpack_require__(1062),
    stackGet = __webpack_require__(1063),
    stackHas = __webpack_require__(1064),
    stackSet = __webpack_require__(1065);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1056),
    listCacheDelete = __webpack_require__(1057),
    listCacheGet = __webpack_require__(1058),
    listCacheHas = __webpack_require__(1059),
    listCacheSet = __webpack_require__(1060);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(225);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1074);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(559),
    baseKeysIn = __webpack_require__(1079),
    isArrayLike = __webpack_require__(92);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1083),
    Map = __webpack_require__(373),
    Promise = __webpack_require__(1084),
    Set = __webpack_require__(567),
    WeakMap = __webpack_require__(542),
    baseGetTag = __webpack_require__(134),
    toSource = __webpack_require__(544);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 289 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(374),
    setCacheAdd = __webpack_require__(1098),
    setCacheHas = __webpack_require__(1099);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 291 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(293);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(189),
    toKey = __webpack_require__(153);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(579),
    overRest = __webpack_require__(580),
    setToString = __webpack_require__(366);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(64)
  , toLength  = __webpack_require__(43)
  , toIndex   = __webpack_require__(157);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 297 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(31)
  , cof      = __webpack_require__(83)
  , MATCH    = __webpack_require__(33)('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(33)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(16);
module.exports = function(){
  var that   = anObject(this)
    , result = '';
  if(that.global)     result += 'g';
  if(that.ignoreCase) result += 'i';
  if(that.multiline)  result += 'm';
  if(that.unicode)    result += 'u';
  if(that.sticky)     result += 'y';
  return result;
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide     = __webpack_require__(61)
  , redefine = __webpack_require__(62)
  , fails    = __webpack_require__(25)
  , defined  = __webpack_require__(84)
  , wks      = __webpack_require__(33);

module.exports = function(KEY, length, exec){
  var SYMBOL   = wks(KEY)
    , fns      = exec(defined, SYMBOL, ''[KEY])
    , strfn    = fns[0]
    , rxfn     = fns[1];
  if(fails(function(){
    var O = {};
    O[SYMBOL] = function(){ return 7; };
    return ''[KEY](O) != 7;
  })){
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function(string, arg){ return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function(string){ return rxfn.call(string, this); }
    );
  }
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global            = __webpack_require__(22)
  , $export           = __webpack_require__(3)
  , redefine          = __webpack_require__(62)
  , redefineAll       = __webpack_require__(162)
  , meta              = __webpack_require__(136)
  , forOf             = __webpack_require__(195)
  , anInstance        = __webpack_require__(161)
  , isObject          = __webpack_require__(31)
  , fails             = __webpack_require__(25)
  , $iterDetect       = __webpack_require__(300)
  , setToStringTag    = __webpack_require__(191)
  , inheritIfRequired = __webpack_require__(393);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO = !IS_WEAK && fails(function(){
        // V8 ~ Chromium 42- fails only with 5+ elements
        var $instance = new C()
          , index     = 5;
        while(index--)$instance[ADDER](index, index);
        return !$instance.has(-0);
      });
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base, target, C);
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(22)
  , hide   = __webpack_require__(61)
  , uid    = __webpack_require__(154)
  , TYPED  = uid('typed_array')
  , VIEW   = uid('view')
  , ABV    = !!(global.ArrayBuffer && global.DataView)
  , CONSTR = ABV
  , i = 0, l = 9, Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while(i < l){
  if(Typed = global[TypedArrayConstructors[i++]]){
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV:    ABV,
  CONSTR: CONSTR,
  TYPED:  TYPED,
  VIEW:   VIEW
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(155)|| !__webpack_require__(25)(function(){
  var K = Math.random();
  // In FF throws only define methods
  __defineSetter__.call(null, K, function(){ /* empty */});
  delete __webpack_require__(22)[K];
});

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Enforces a single instance of the Raven client, and the
 * main entry point for Raven. If you are a consumer of the
 * Raven library, you SHOULD load this file (vs raven.js).
 **/

var RavenConstructor = __webpack_require__(1320);

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _Raven = _window.Raven;

var Raven = new RavenConstructor();

/*
 * Allow multiple versions of Raven to be installed.
 * Strip Raven from the global context and returns the instance.
 *
 * @return {Raven}
 */
Raven.noConflict = function() {
  _window.Raven = _Raven;
  return Raven;
};

Raven.afterLoad();

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(92),
    isObjectLike = __webpack_require__(91);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(134),
    getPrototype = __webpack_require__(377),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var assertType = __webpack_require__(310);
var assertFunction = __webpack_require__(425);

var _require = __webpack_require__(426),
    union = _require.union,
    derivations = _require.derivations;

var provideAliases = __webpack_require__(311);
var warnDeprecation = __webpack_require__(238);
var adtMethods = __webpack_require__(427);
var extend = __webpack_require__(239);

var equality = derivations.equality,
    debugRepresentation = derivations.debugRepresentation,
    serialization = derivations.serialization;

/*~ stability: stable */

var Maybe = union('folktale:Maybe', {
  /*~
   * type: |
   *   forall a: () => Maybe a
   */
  Nothing: function Nothing() {},


  /*~
   * type: |
   *   forall a: (a) => Maybe a
   */
  Just: function Just(value) {
    return { value: value };
  }
}).derive(equality, debugRepresentation, serialization);

var Nothing = Maybe.Nothing,
    _Just = Maybe.Just;

var assertMaybe = assertType(Maybe);

extend(_Just.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a: get (Maybe a) => a
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Maybe.Just');
  }
});

/*~~belongsTo: Maybe */
adtMethods(Maybe, {
  /*~
   * stability: stable
   * type: |
   *   forall a, b: (Maybe a).((a) => b) => Maybe b
   */
  map: {
    /*~*/
    Nothing: function map(transformation) {
      assertFunction('Maybe.Nothing#map', transformation);
      return this;
    },

    /*~*/
    Just: function map(transformation) {
      assertFunction('Maybe.Just#map', transformation);
      return _Just(transformation(this.value));
    }
  },

  /*~
   * stability: stable
   * type: |
   *   forall a, b: (Maybe (a) => b).(Maybe a) => Maybe b
   */
  apply: {
    /*~*/
    Nothing: function apply(aMaybe) {
      assertMaybe('Maybe.Nothing#apply', aMaybe);
      return this;
    },

    /*~*/
    Just: function apply(aMaybe) {
      assertMaybe('Maybe.Just#apply', aMaybe);
      return aMaybe.map(this.value);
    }
  },

  /*~
   * stability: stable
   * type: |
   *   forall a, b: (Maybe a).((a) => Maybe b) => Maybe b
   */
  chain: {
    /*~*/
    Nothing: function chain(transformation) {
      assertFunction('Maybe.Nothing#chain', transformation);
      return this;
    },

    /*~*/
    Just: function chain(transformation) {
      assertFunction('Maybe.Just#chain', transformation);
      return transformation(this.value);
    }
  },

  /*~
   * type: |
   *   forall a: (Maybe a).() => a :: (throws TypeError)
   */
  unsafeGet: {
    /*~*/
    Nothing: function unsafeGet() {
      throw new TypeError('Can\'t extract the value of a Nothing.\n\n    Since Nothing holds no values, it\'s not possible to extract one from them.\n    You might consider switching from Maybe#get to Maybe#getOrElse, or some other method\n    that is not partial.\n      ');
    },

    /*~*/
    Just: function unsafeGet() {
      return this.value;
    }
  },

  /*~
   * type: |
   *   forall a: (Maybe a).(a) => a
   */
  getOrElse: {
    /*~*/
    Nothing: function getOrElse(_default) {
      return _default;
    },

    /*~*/
    Just: function getOrElse(_default) {
      return this.value;
    }
  },

  /*~
   * type: |
   *   forall a: (Maybe a).((a) => Maybe a) => Maybe a
   */
  orElse: {
    /*~*/
    Nothing: function orElse(handler) {
      assertFunction('Maybe.Nothing#orElse', handler);
      return handler(this.value);
    },

    /*~*/
    Just: function orElse(handler) {
      assertFunction('Maybe.Nothing#orElse', handler);
      return this;
    }
  },

  /*~
   * authors:
   *   - "@diasbruno"
   * type: |
   *   forall a: (Maybe a).(Maybe a) => Maybe a
   *   where a is Semigroup
   */
  concat: {
    /*~*/
    Nothing: function concat(aMaybe) {
      assertMaybe('Maybe.Nothing#concat', aMaybe);
      return aMaybe;
    },

    /*~*/
    Just: function concat(aMaybe) {
      var _this = this;

      assertMaybe('Maybe.Just#concat', aMaybe);
      return aMaybe.matchWith({
        Nothing: function Nothing() {
          return _Just(_this.value);
        },
        Just: function Just(a) {
          return _Just(_this.value.concat(a.value));
        }
      });
    }
  },

  /*~
   * deprecated:
   *   since: 2.0.0
   *   replacedBy: .matchWith(pattern)
   * 
   * type: |
   *   forall a, b:
   *     (Maybe a).({
   *       Nothing: () => b,
   *       Just: (a) => b
   *     }) => b
   */
  cata: {
    /*~*/
    Nothing: function cata(pattern) {
      warnDeprecation('`.cata(pattern)` is deprecated. Use `.matchWith(pattern)` instead.');
      return pattern.Nothing();
    },

    /*~*/
    Just: function cata(pattern) {
      warnDeprecation('`.cata(pattern)` is deprecated. Use `.matchWith(pattern)` instead.');
      return pattern.Just(this.value);
    }
  },

  /*~
   * type: |
   *   forall a, b: (Maybe a).(() => b, (a) => b) => b
   */
  fold: {
    /*~*/
    Nothing: function Nothing(transformNothing, transformJust) {
      assertFunction('Maybe.Nothing#fold', transformNothing);
      assertFunction('Maybe.Nothing#fold', transformJust);
      return transformNothing();
    },

    /*~*/
    Just: function Just(transformNothing, transformJust) {
      assertFunction('Maybe.Just#fold', transformNothing);
      assertFunction('Maybe.Just#fold', transformJust);
      return transformJust(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a: (Maybe a).((a) => Boolean) => Maybe a
   */
  filter: {
    /*~*/
    Nothing: function filter(predicate) {
      assertFunction('Maybe.Nothing#filter', predicate);
      return this;
    },

    /*~*/
    Just: function filter(predicate) {
      assertFunction('Maybe.Just#filter', predicate);
      return predicate(this.value) ? this : Nothing();
    }
  }
});

Object.assign(Maybe, {
  /*~
   * stability: stable
   * type: |
   *   forall a: (a) => Maybe a
   */
  of: function of(value) {
    return _Just(value);
  },


  /*~
   * authors:
   *   - "@diasbruno"
   * type: |
   *   forall a: () => Maybe a
   */
  empty: function empty() {
    return Nothing();
  },


  /*~
   * deprecated:
   *   since: 2.0.0
   *   replacedBy: .unsafeGet()
   * type: |
   *   forall a: (Maybe a).() => a :: (throws TypeError)
   */
  'get': function get() {
    warnDeprecation('`.get()` is deprecated, and has been renamed to `.unsafeGet()`.');
    return this.unsafeGet();
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Maybe a).(b) => Result b a
   */
  toResult: function toResult(fallbackValue) {
    return __webpack_require__(1433)(this, fallbackValue);
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Maybe a).(b) => Result b a
   */
  toValidation: function toValidation(fallbackValue) {
    return __webpack_require__(1436)(this, fallbackValue);
  }
});

provideAliases(_Just.prototype);
provideAliases(Nothing.prototype);
provideAliases(Maybe);

module.exports = Maybe;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(198),
    typeSymbol = _require.typeSymbol;

module.exports = function (type) {
  return function (method, value) {
    var typeName = type[typeSymbol];
    if (Object({"NODE_ENV":"production","PUBLIC_URL":"","PLATFORM":"web"}).FOLKTALE_ASSERTIONS !== 'none' && !type.isPrototypeOf(value)) {
      console.warn(typeName + '.' + method + ' expects a value of the same type, but was given ' + value + '.');

      if (Object({"NODE_ENV":"production","PUBLIC_URL":"","PLATFORM":"web"}).FOLKTALE_ASSERTIONS !== 'minimal') {
        console.warn('\nThis could mean that you\'ve provided the wrong value to the method, in\nwhich case this is a bug in your program, and you should try to track\ndown why the wrong value is getting here.\n\nBut this could also mean that you have more than one ' + typeName + ' library\ninstantiated in your program. This is not **necessarily** a bug, it\ncould happen for several reasons:\n\n 1) You\'re loading the library in Node, and Node\'s cache didn\'t give\n    you back the same instance you had previously requested.\n\n 2) You have more than one Code Realm in your program, and objects\n    created from the same library, in different realms, are interacting.\n\n 3) You have a version conflict of folktale libraries, and objects\n    created from different versions of the library are interacting.\n\nIf your situation fits the cases (1) or (2), you are okay, as long as\nthe objects originate from the same version of the library. Folktale\ndoes not rely on reference checking, only structural checking. However\nyou\'ll want to watch out if you\'re modifying the ' + typeName + '\'s prototype,\nbecause you\'ll have more than one of them, and you\'ll want to make\nsure you do the same change in all of them \u2014 ideally you shouldn\'t\nbe modifying the object, though.\n\nIf your situation fits the case (3), you are *probably* okay if the\nversion difference isn\'t a major one. However, at this point the\nbehaviour of your program using ' + typeName + ' is undefined, and you should\ntry looking into why the version conflict is happening.\n\nParametric modules can help ensuring your program only has a single\ninstance of the folktale library. Check out the Folktale Architecture\ndocumentation for more information.\n      ');
      }
    }
  };
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------


var aliases = {
  equals: {
    /*~
     * module: null
     * type: |
     *   ('S 'a).('S 'a) => Boolean
     *   where 'S is Setoid
     */
    'fantasy-land/equals': function fantasyLandEquals(that) {
      return this.equals(that);
    }
  },

  concat: {
    /*~
     * module: null
     * type: |
     *   ('S 'a).('S 'a) => 'S 'a
     *   where 'S is Semigroup
     */
    'fantasy-land/concat': function fantasyLandConcat(that) {
      return this.concat(that);
    }
  },

  empty: {
    /*~
     * module: null
     * type: |
     *   ('M).() => 'M a
     *   where 'M is Monoid
     */
    'fantasy-land/empty': function fantasyLandEmpty() {
      return this.empty();
    }
  },

  map: {
    /*~
     * module: null
     * type: |
     *   ('F 'a).(('a) => 'b) => 'F 'b
     *   where 'F is Functor
     */
    'fantasy-land/map': function fantasyLandMap(transformation) {
      return this.map(transformation);
    }
  },

  apply: {
    /*~
     * module: null
     * type: |
     *   ('F ('a) => b).('F 'a) => 'F 'b
     *   where 'F is Apply
     */
    ap: function ap(that) {
      return this.apply(that);
    },


    /*~
     * module: null
     * type: |
     *   ('F 'a).('F ('a) => 'b) => 'F 'b
     *   where 'F is Apply
     */
    'fantasy-land/ap': function fantasyLandAp(that) {
      return that.apply(this);
    }
  },

  of: {
    /*~
     * module: null
     * type: |
     *   forall F, a:
     *     (F).(a) => F a
     *   where F is Applicative 
     */
    'fantasy-land/of': function fantasyLandOf(value) {
      return this.of(value);
    }
  },

  reduce: {
    /*~
     * module: null
     * type: |
     *   forall F, a, b:
     *     (F a).((b, a) => b, b) => b
     *   where F is Foldable  
     */
    'fantasy-land/reduce': function fantasyLandReduce(combinator, initial) {
      return this.reduce(combinator, initial);
    }
  },

  traverse: {
    /*~
     * module: null
     * type: |
     *   forall F, T, a, b:
     *     (T a).((a) => F b, (c) => F c) => F (T b)
     *   where F is Apply, T is Traversable
     */
    'fantasy-land/traverse': function fantasyLandTraverse(transformation, lift) {
      return this.traverse(transformation, lift);
    }
  },

  chain: {
    /*~
     * module: null
     * type: |
     *   forall M, a, b:
     *     (M a).((a) => M b) => M b
     *   where M is Chain
     */
    'fantasy-land/chain': function fantasyLandChain(transformation) {
      return this.chain(transformation);
    }
  },

  chainRecursively: {
    /*~
     * module: null
     * type: |
     *   forall M, a, b, c:
     *     (M).(
     *       Step:    ((a) => c, (b) => c, a) => M c,
     *       Initial: a
     *     ) => M b
     *   where M is ChainRec 
     */
    chainRec: function chainRec(step, initial) {
      return this.chainRecursively(step, initial);
    },


    /*~
     * module: null
     * type: |
     *   forall M, a, b, c:
     *     (M).(
     *       Step:    ((a) => c, (b) => c, a) => M c,
     *       Initial: a
     *     ) => M b
     *   where M is ChainRec 
     */
    'fantasy-land/chainRec': function fantasyLandChainRec(step, initial) {
      return this.chainRecursively(step, initial);
    }
  },

  extend: {
    /*~
     * module: null
     * type: |
     *   forall W, a, b:
     *     (W a).((W a) => b) => W b
     *   where W is Extend
     */
    'fantasy-land/extend': function fantasyLandExtend(transformation) {
      return this.extend(transformation);
    }
  },

  extract: {
    /*~
     * module: null
     * type: |
     *   forall W, a, b:
     *     (W a).() => a
     *   where W is Comonad
     */
    'fantasy-land/extract': function fantasyLandExtract() {
      return this.extract();
    }
  },

  bimap: {
    /*~
     * module: null
     * type: |
     *   forall F, a, b, c, d:
     *     (F a b).((a) => c, (b) => d) => F c d
     *   where F is Bifunctor
     */
    'fantasy-land/bimap': function fantasyLandBimap(f, g) {
      return this.bimap(f, g);
    }
  },

  promap: {
    /*~
     * module: null
     * type: |
     *   forall P, a, b, c, d:
     *     (P a b).((c) => a, (b) => d) => P c d
     */
    'fantasy-land/promap': function fantasyLandPromap(f, g) {
      return this.promap(f, g);
    }
  }
};

var provideAliases = function provideAliases(structure) {
  Object.keys(aliases).forEach(function (method) {
    if (typeof structure[method] === 'function') {
      Object.keys(aliases[method]).forEach(function (alias) {
        structure[alias] = aliases[method][alias];
      });
    }
  });
};

module.exports = provideAliases;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isValid;
function isValid(error) {
  if (Array.isArray(error)) {
    return error.reduce(function (valid, errorValue) {
      return valid && isValid(errorValue);
    }, true);
  }
  if (error && typeof error === 'object') {
    return Object.keys(error).reduce(function (valid, key) {
      return valid && isValid(error[key]);
    }, true);
  }
  return !error;
}

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_GROUP_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_GROUP_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_NEW_GROUP_COMPLETE; });
var SAVE_GROUP='hive/groups/SAVE_GROUP';var SAVE_GROUP_PENDING='hive/groups/SAVE_GROUP_PENDING';var SAVE_GROUP_COMPLETE='hive/groups/SAVE_GROUP_COMPLETE';var SAVE_NEW_GROUP_COMPLETE='hive/groups/SAVE_NEW_GROUP_COMPLETE';

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SECONDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MINUTES; });
/* unused harmony export HOURS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DAYS; });
/* unused harmony export WEEKS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MONTHS; });
/* unused harmony export YEARS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
var SECONDS='SECONDS';var MINUTES='MINUTES';var HOURS='HOURS';var DAYS='DAYS';var WEEKS='WEEKS';var MONTHS='MONTHS';var YEARS='YEARS';var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({a:{id:'time-unit.a',defaultMessage:'a'},an:{id:'time-unit.an',defaultMessage:'an'},hour:{id:'time-unit.hour',defaultMessage:'hour'},hours:{id:'time-unit.hours',defaultMessage:'hours'},minute:{id:'time-unit.minute',defaultMessage:'minute'},minutes:{id:'time-unit.minutes',defaultMessage:'minutes'},now:{id:'time-unit.now',defaultMessage:'now'},tomorrow:{id:'time-unit.tomorrow',defaultMessage:'tomorrow'}});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVED_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_NOTIFICATIONS_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVED_NOTIFICATIONS; });
var CHANGE_ZONE='hive/notificationsUi/CHANGE_ZONE';var LOAD_NOTIFICATIONS='hive/notifications/LOAD';var RECEIVED_NOTIFICATIONS='hive/notifications/RECEIVED';var SAVE_NOTIFICATIONS='hive/notifications/SAVE';var SAVE_NOTIFICATIONS_ERROR='hive/notifications/SAVE_ERROR';var SAVED_NOTIFICATIONS='hive/notifications/SAVED';

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_WEATHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVED_WEATHER; });
var GET_WEATHER='hive/weather/GET';var RECEIVED_WEATHER='hive/weather/RECEIVED';

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(74);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
// @noflow
var getEvents=function getEvents(eventType,id,from,to){var productUrl=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'products/'+eventType+'/'+id+'/events',query:{from:from,to:to}});return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])(productUrl);};

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 321 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1930), __esModule: true };

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(100);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 326 */
/***/ (function(module, exports) {

module.exports = function isString(x) {
  return typeof x === 'string';
};

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports = function isBoolean(x) {
  return x === true || x === false;
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);
var isFunction = __webpack_require__(58);

module.exports = irreducible('Function', isFunction);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isNative = __webpack_require__(2054);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = internalMatchesPattern;

var _createValidator = __webpack_require__(122);

var _createValidator2 = _interopRequireDefault(_createValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function internalMatchesPattern(regex, messageCreator) {
  return (0, _createValidator2.default)(function (message) {
    return function (value) {
      if (value && !regex.test(value)) {
        return message;
      }
    };
  }, messageCreator);
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DeviceInfoPanelList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DeviceInfoPanelListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeviceInfoPanelHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DeviceInfoPanelValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DeviceInfoPanelValueInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_style__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    height: auto;\n    margin-bottom: 30px;\n\n    ',';\n'],['\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    height: auto;\n    margin-bottom: 30px;\n\n    ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n\t\tflex-wrap: nowrap;\n\t'],['\n\t\tflex-wrap: nowrap;\n\t']),_templateObject3=_taggedTemplateLiteral(['\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    padding-right: 2em;\n    margin-bottom: 15px;\n    width: 50%;\n\n    &:last-child {\n        padding-right: 0;\n    }\n\n    ',';\n'],['\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    padding-right: 2em;\n    margin-bottom: 15px;\n    width: 50%;\n\n    &:last-child {\n        padding-right: 0;\n    }\n\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n\t\tmargin-bottom: 0;\n\t\twidth: auto;\n\t'],['\n\t\tmargin-bottom: 0;\n\t\twidth: auto;\n\t']),_templateObject5=_taggedTemplateLiteral(['\n    margin: 0 0 5px 0;\n    height: 50%;\n    font-weight: normal;\n'],['\n    margin: 0 0 5px 0;\n    height: 50%;\n    font-weight: normal;\n']),_templateObject6=_taggedTemplateLiteral(['\n    height: 50%;\n    font-weight: bold;\n'],['\n    height: 50%;\n    font-weight: bold;\n']),_templateObject7=_taggedTemplateLiteral(['\n    padding: 3px;\n    border: 1px solid ',';\n\n    &:focus {\n        border-color: ',';\n        outline: none;\n    }\n'],['\n    padding: 3px;\n    border: 1px solid ',';\n\n    &:focus {\n        border-color: ',';\n        outline: none;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DeviceInfoPanelList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ul(_templateObject,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject2));var DeviceInfoPanelListItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].li(_templateObject3,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject4));var DeviceInfoPanelHeading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].h4(_templateObject5);var DeviceInfoPanelValue=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject6);var DeviceInfoPanelValueInput=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].input(_templateObject7,function(props){return props.theme.mediumGrey;},function(props){return props.theme.grey;});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({aboutToDelete:{id:'info-panel.about-to-delete',defaultMessage:'You are about to delete {device}.'},battery:{id:'info-panel.mains-battery',defaultMessage:'Battery'},cancel:{id:'info-panel.cancel',defaultMessage:'Cancel'},cancelOrConfirm:{id:'info-panel.cancel-or-confirm',defaultMessage:'Please cancel to return to the device screen or confirm you wish to delete'},cancelOrConfirmZone:{id:'info-panel.cancel-or-confirm-zone',// eslint-disable-next-line max-len
defaultMessage:'Please cancel to return to the device screen or confirm you wish to delete the thermostat and receiver for this zone.'},connectedDevices:{id:'info-panel.connected-devices',defaultMessage:'Devices'},connectedDevicesNumber:{id:'info-panel.connected-devices-number',defaultMessage:'{connectedDevices, plural,\n    \t\t\tone {Light}\n    \t\t\tother {Lights}\n    \t\t}'},firmwareVersion:{id:'info-panel.firmware-version',defaultMessage:'Firmware version'},hubUptime:{id:'info-panel.hub-up-time',defaultMessage:'Hub uptime'},internetConnection:{id:'info-panel.internet-connection',defaultMessage:'Internet connection'},invalidCharacters:{id:'info-panel.invalid-chars',defaultMessage:'Please enter a valid device name - use only letters and numbers'},ipAddress:{id:'info-panel.ip-address',defaultMessage:'IP Address'},link:{id:'info-panel.link',defaultMessage:'Link'},macAddress:{id:'info-panel.mac-address',defaultMessage:'MAC Address'},mains:{id:'info-panel.mains',defaultMessage:'AC'},manufacturer:{id:'info-panel.manufacturer',defaultMessage:'Manufacturer'},modalRemoveDevice:{id:'modal-remove-device',defaultMessage:'Remove device'},nickname:{id:'info-panel.edit-device-name',defaultMessage:'Edit device name'},passwordLength:{id:'info-panel.nickname-length',defaultMessage:'Nickname must be less than 20 characters'},philips:{id:'info-panel.philips',defaultMessage:'Philips lighting'},powerSource:{id:'info-panel.power-source',defaultMessage:'Power source'},removeDevice:{id:'info-panel.remove-device',defaultMessage:'Remove'},removeDeviceTitle:{id:'info-panel.remove-device-title',defaultMessage:'Remove device'},removePartner:{id:'info-panel.remove-partner',defaultMessage:'Remove partner'},removeZoneTitle:{id:'info-panel.remove-zone-title',defaultMessage:'Remove zone'},required:{id:'info-panel.validation-required',defaultMessage:'Please enter a nickname'},restartHub:{id:'info-panel.restart-hub',defaultMessage:'Restart Hub'},restarting:{id:'info-panel.restarting',defaultMessage:'Restarting'},save:{id:'info-panel.save',defaultMessage:'Save'},serialNumber:{id:'info-panel.serial-number',defaultMessage:'Serial Number'},support:{id:'info-panel.support',defaultMessage:'Customer support'},wired:{id:'info-panel.mains-wired',defaultMessage:'Ethernet'},zoneNickname:{id:'info-panel.edit-zone-name',defaultMessage:'Edit zone name'}}));

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RHSButtonContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_style__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(['\n    background-color: ',';\n    border-radius: 2.5rem;\n    border: 2px solid ',';\n    cursor: ',';\n    color: ',';\n    font-size: 1rem;\n    outline: none;\n    padding: 0.75rem 3rem;\n    position: relative;\n    transition: background-color 0.3s, border-color 0.3s, color 0.3s;\n\n    &:focus,\n    &:hover {\n        ',';\n    }\n'],['\n    background-color: ',';\n    border-radius: 2.5rem;\n    border: 2px solid ',';\n    cursor: ',';\n    color: ',';\n    font-size: 1rem;\n    outline: none;\n    padding: 0.75rem 3rem;\n    position: relative;\n    transition: background-color 0.3s, border-color 0.3s, color 0.3s;\n\n    &:focus,\n    &:hover {\n        ',';\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    margin: 0 0 2em;\n    min-width: 20em;\n    text-align: center;\n    ',';\n'],['\n    margin: 0 0 2em;\n    min-width: 20em;\n    text-align: center;\n    ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n      float: right;\n      margin: 0 0 0 2em;\n      min-width: 0;\n    '],['\n      float: right;\n      margin: 0 0 0 2em;\n      min-width: 0;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].button(_templateObject,function(_ref){var alternate=_ref.alternate,disabled=_ref.disabled,theme=_ref.theme;return disabled?theme.mediumGrey:alternate?theme.white:theme.mainBrandColor;},function(_ref2){var disabled=_ref2.disabled,theme=_ref2.theme;return disabled?theme.mediumGrey:theme.mainBrandColor;},function(_ref3){var disabled=_ref3.disabled,theme=_ref3.theme;return disabled?'default':'pointer';},function(_ref4){var alternate=_ref4.alternate,disabled=_ref4.disabled,theme=_ref4.theme;return!alternate||disabled?theme.white:theme.grey;},function(_ref5){var disabled=_ref5.disabled,theme=_ref5.theme;return!disabled?'background-color: '+theme.primaryBtnColors.hover+'; color: '+theme.white+';':null;});var RHSButtonContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject3));

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({pickerColor:{id:'picker.pickerColor',defaultMessage:'colour'},pickerTuneable:{id:'picker.tuneable',defaultMessage:'tone'},pickerDimmer:{id:'picker.dimmer',defaultMessage:'dimmer'},pickerWhite:{id:'picker.white',defaultMessage:'white'}}));

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188)(module)))

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return openSettingsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return closeSettingsModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
var NONE='NONE';var PRIMARY='PRIMARY';var SECONDARY='SECONDARY';var openSettingsModal=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('OPEN_SETTINGS_MODAL');var closeSettingsModal=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('CLOSE_SETTINGS_MODAL');

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl__ = __webpack_require__(2262);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var buttonLinkText=_ref.buttonLinkText,children=_ref.children,closeText=_ref.closeText,_ref$contentLabel=_ref.contentLabel,contentLabel=_ref$contentLabel===undefined?'':_ref$contentLabel,_ref$disableSaveButto=_ref.disableSaveButton,disableSaveButton=_ref$disableSaveButto===undefined?false:_ref$disableSaveButto,_ref$isBig=_ref.isBig,isBig=_ref$isBig===undefined?false:_ref$isBig,isOpen=_ref.isOpen,linkText=_ref.linkText,linkTo=_ref.linkTo,linkUrl=_ref.linkUrl,noButtons=_ref.noButtons,noPadding=_ref.noPadding,onLinkClicked=_ref.onLinkClicked,onRequestClose=_ref.onRequestClose,onSave=_ref.onSave,saveText=_ref.saveText,props=_objectWithoutProperties(_ref,['buttonLinkText','children','closeText','contentLabel','disableSaveButton','isBig','isOpen','linkText','linkTo','linkUrl','noButtons','noPadding','onLinkClicked','onRequestClose','onSave','saveText']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["f" /* StyledModal */],Object.assign({},props,{contentLabel:contentLabel,isBig:isBig,isOpen:isOpen,onRequestClose:onRequestClose,style:{overlay:__WEBPACK_IMPORTED_MODULE_1__style__["g" /* overlayStyle */]}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["b" /* Content */],{'data-qa':'modal',hasButtons:onRequestClose||onSave||linkUrl,isBig:isBig,noPadding:noPadding},children),(onRequestClose||onSave||linkUrl)&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["a" /* Buttons */],null,onRequestClose&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["c" /* ModalButton */],{alternate:true,'data-qa':'modal-cancel',onClick:onRequestClose},typeof closeText==='string'?closeText:closeText?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],closeText):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].cancel)),onSave&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["c" /* ModalButton */],{'data-qa':'modal-save',disabled:disableSaveButton,onClick:onSave},typeof saveText==='string'?saveText:saveText?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],saveText):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].save)),linkUrl&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["d" /* ModalHrefButton */],{'data-qa':'modal-link',href:linkUrl,target:'_blank'},typeof linkText==='string'?linkText:linkText?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],linkText):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].learnMore)),linkTo&&onLinkClicked&&buttonLinkText&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["e" /* ModalLinkButton */],{onClick:onLinkClicked,to:linkTo},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],buttonLinkText))));});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toEntitlements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_entitlements_selectors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_immutable__ = __webpack_require__(103);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// These paths are relative because they cause problems with Jest mocking when aliased
var pick=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(keys,obj){return keys.reduce(function(agg,key){return Object.assign({},agg,_defineProperty({},key,obj[key]||null));},{});});var toEntitlements=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default()(pick(['MimicMode']),__WEBPACK_IMPORTED_MODULE_6__utils_immutable__["i" /* toJS */]);var mapStateToProps=function mapStateToProps(state,ownProps){var config=Object(__WEBPACK_IMPORTED_MODULE_4__state_config_selectors__["a" /* getConfig */])(state);var entitlementFlags=toEntitlements(Object(__WEBPACK_IMPORTED_MODULE_5__state_entitlements_selectors__["a" /* getConfig */])(state));var isValidChildren=typeof ownProps.children==='function';if(false){if(!isValidChildren){// eslint-disable-next-line
console.warn('You must pass `children` as a function to <ConditionalFeature />. '+'Such that <ConditionalFeature>{() => <div>Hello World</div>}</ConditionalFeature>');}}// $FlowFixMe
var featureFlags=config.toJS().features;return{featureFlags:featureFlags,entitlementFlags:entitlementFlags,isValidChildren:isValidChildren};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getFanMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getFanCirculatePeriod; });
/* unused harmony export getDualMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getThermostatCapabilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getThermostatControlMode; });
/* unused harmony export getThermostatMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getThermostatStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getControlTypeSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getThermostatHeatTemperature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getThermostatCoolTemperature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getHumidity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getCurrentTemperature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCurrentHumidity; });
/* unused harmony export getNaThermostats */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getOnlineNaThermostats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getIsAnyMissingHumidifierType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getKnownHumidifierType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getIsUpdating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getUpdateType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllThermostatCapabilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllThermostatCoolTemps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAllThermostatHeatTemps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getThermostatHumidity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAllThermostatUpdating; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_immutable__ = __webpack_require__(103);
var getFanMode=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['state','fanMode']);});var getFanCirculatePeriod=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['state','fanCirculate']);});var getDualMode=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product&&product.getIn(['state','dual','mode']);});var getThermostatCapabilities=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['props','capabilities'],Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])());});var getThermostatControlMode=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){var controlMode=product.getIn(['state','controlMode']);return controlMode?controlMode:product.getIn(['props','capabilities'],[]).includes('heat')?__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceControlModes"].HEAT:__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceControlModes"].COOL;});var getThermostatMode=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['state','mode']);});var getThermostatStatus=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['state','status'],false);});var getControlTypeName=function getControlTypeName(_,_ref){var controlType=_ref.controlType;return controlType;};var getControlTypeSchedule=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(getControlTypeName,__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(controlType,product){return product.getIn(['state',controlType.toLowerCase()+'Schedule']);});var getThermostatHeatTemperature=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['state','heat']);});var getThermostatCoolTemperature=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['state','cool']);});var getHumidity=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['state','humidity']);});var getCurrentTemperature=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['props','temperature']);});var getCurrentHumidity=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.getIn(['props','humidity']);});var getNaThermostats=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["z" /* getProductItems */],function(items){return items.filter(function(p){return p.get('type')===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].NA_THERMOSTAT;});});var getOnlineNaThermostats=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(getNaThermostats,function(stats){return stats.filter(function(s){return s.getIn(['props','online'])&&!s.get('error');});});var getIsAnyMissingHumidifierType=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(getOnlineNaThermostats,function(nathermos){return nathermos.some(function(p){return p.getIn(['state','humidifierType'])===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceHumidityModes"].UNKNOWN;});});var getKnownHumidifierType=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(getNaThermostats,function(nathermos){var prod=nathermos.filter(function(p){var type=p.getIn(['state','humidifierType']);return type&&type!==__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceHumidityModes"].UNKNOWN;}).first();return prod&&prod.getIn(['state','humidifierType']);});var getIsUpdating=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.get('isUpdating',false);});var getUpdateType=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* getProductItemById */],function(product){return product.get('updateType');});var getAllThermostatCapabilities=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["z" /* getProductItems */],function(products){return products.toSeq().filter(function(p){return p.get('type')===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].NA_THERMOSTAT;}).flatMap(function(p){return p.getIn(['props','capabilities'],Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])([]));}).toSet();});var getAllThermostatCoolTemps=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["z" /* getProductItems */],Object(__WEBPACK_IMPORTED_MODULE_4__utils_immutable__["b" /* find */])(function(p){return p.get('type')===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].NA_THERMOSTAT&&p.getIn(['state','cool']);}));var getAllThermostatHeatTemps=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["z" /* getProductItems */],Object(__WEBPACK_IMPORTED_MODULE_4__utils_immutable__["b" /* find */])(function(p){return p.get('type')===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].NA_THERMOSTAT&&p.getIn(['state','heat']);}));var getThermostatHumidity=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["z" /* getProductItems */],function(items){return Object(__WEBPACK_IMPORTED_MODULE_4__utils_immutable__["b" /* find */])(function(p){return p.get('type')===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].NA_THERMOSTAT&&p.getIn(['state','humidity']);},items).getIn(['state','humidity']);});var getAllThermostatUpdating=Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_1__selectors__["z" /* getProductItems */],Object(__WEBPACK_IMPORTED_MODULE_4__utils_immutable__["b" /* find */])(function(p){return p.get('type')===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].NA_THERMOSTAT&&p.getIn(['isUpdating',false]);}));

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getGroupItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGroupById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getGroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGroupConsumers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getGroupProductsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getIsSaving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getGroupHasHueDevices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_curry__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_get__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_immutable__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_folktale_maybe__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_folktale_maybe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_folktale_maybe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__devices_selectors__ = __webpack_require__(37);
var map=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_curry___default()(function(iteratee,functor){return functor.map(iteratee);});var getName=Object(__WEBPACK_IMPORTED_MODULE_8__utils_immutable__["d" /* getIn */])(['state','name']);var getConsumers=Object(__WEBPACK_IMPORTED_MODULE_8__utils_immutable__["d" /* getIn */])(['props','consumers']);var getIsGroup=Object(__WEBPACK_IMPORTED_MODULE_8__utils_immutable__["c" /* get */])('isGroup');var getId=Object(__WEBPACK_IMPORTED_MODULE_8__utils_immutable__["c" /* get */])('id');var getSaving=Object(__WEBPACK_IMPORTED_MODULE_8__utils_immutable__["c" /* get */])('saving');var pluckSize=__WEBPACK_IMPORTED_MODULE_4_lodash_fp_get___default()('size');var pluckGroups=__WEBPACK_IMPORTED_MODULE_4_lodash_fp_get___default()('groups');var ascending=function ascending(a,b){return a.localeCompare(b);};var byName=function byName(comparator){return function(a,b){return comparator(getName(a),getName(b));};};var getGroups=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_9_folktale_maybe___default.a.fromNullable,pluckGroups);var getGroupItems=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_7__products_selectors__["z" /* getProductItems */],function(prods){return __WEBPACK_IMPORTED_MODULE_9_folktale_maybe___default.a.fromNullable(prods).map(function(prods){return prods.filter(getIsGroup).sort(byName(ascending));});});var getGroupById=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__selectors__["c" /* getIdFromProps */],getGroupItems,function(id,groups){return groups.chain(function(groups){return __WEBPACK_IMPORTED_MODULE_9_folktale_maybe___default.a.fromNullable(groups.find(function(g){return getId(g)===id;}));});});var getGroupName=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getGroupById,map(getName));var getGroupConsumers=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getGroupById,map(getConsumers));var getGroupProductsCount=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getGroupConsumers,map(pluckSize));var getIsSaving=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])(getGroups,function(groups){return groups.map(getSaving).getOrElse(false);});var getGroupHasHueDevices=Object(__WEBPACK_IMPORTED_MODULE_5_reselect__["createSelector"])([getGroupConsumers,__WEBPACK_IMPORTED_MODULE_6__selectors__["g" /* stateIdentity */]],function(devices,state){return map(function(devices){return __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a,devices.map(function(id){return Object(__WEBPACK_IMPORTED_MODULE_10__devices_selectors__["R" /* getIsHueDevice */])(state,{id:id});}).toJS());},devices).getOrElse(false);});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return findDeviceTypeMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intl__ = __webpack_require__(513);
var findDeviceTypeMessage=function findDeviceTypeMessage(type){var manufacturer=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var model=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';return __WEBPACK_IMPORTED_MODULE_0__intl__["e" /* deviceTypeMessages */][type+'-'+manufacturer]||__WEBPACK_IMPORTED_MODULE_0__intl__["c" /* deviceModelTypeMessages */][model]||__WEBPACK_IMPORTED_MODULE_0__intl__["e" /* deviceTypeMessages */][type+'-'+model]||__WEBPACK_IMPORTED_MODULE_0__intl__["e" /* deviceTypeMessages */][type];};

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBgColorKey; });
var _colorMapKey;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var saveStates={DEFAULT:'DEFAULT',SAVING:'SAVING',SAVED:'SAVED',SAVED_END:'SAVED_END',SAVE_ERROR:'SAVE_ERROR',SAVE_ERROR_END:'SAVE_ERROR_END'};// the value represent a key of the primaryBtnColors from the theme file ( when the theme and styled components
// will be fully typed then we can define proper enumeration for the primary button colours)
var colorMapKey=(_colorMapKey={},_defineProperty(_colorMapKey,saveStates.DEFAULT,'default'),_defineProperty(_colorMapKey,saveStates.SAVING,'busy'),_defineProperty(_colorMapKey,saveStates.SAVED,'default'),_defineProperty(_colorMapKey,saveStates.SAVED_END,'default'),_defineProperty(_colorMapKey,saveStates.SAVE_ERROR,'error'),_defineProperty(_colorMapKey,saveStates.SAVE_ERROR_END,'error'),_colorMapKey);var getBgColorKey=function getBgColorKey(saveState){return colorMapKey[saveState];};

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FORGOTTEN_PASSWORD_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FORGOTTEN_PASSWORD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESET_PASSWORD_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESETTING_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESET_PASSWORD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PASSWORD_RESET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_RESET_PASSWORD_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return forgottenPasswordStates; });
var FORGOTTEN_PASSWORD_READY='FORGOTTEN_PASSWORD_READY';var FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST='FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST';var FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT='FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT';var FORGOTTEN_PASSWORD_ERROR='FORGOTTEN_PASSWORD_ERROR';var RESET_PASSWORD_READY='RESET_PASSWORD_READY';var RESETTING_PASSWORD='RESETTING_PASSWORD';var RESET_PASSWORD_SUCCESS='RESET_PASSWORD_SUCCESS';var RESET_PASSWORD_ERROR='RESET_PASSWORD_ERROR';var RESET_PASSWORD='RESET_PASSWORD';var PASSWORD_RESET_REQUEST='PASSWORD_RESET_REQUEST';var CLEAR_RESET_PASSWORD_ERROR='CLEAR_RESET_PASSWORD_ERROR';var forgottenPasswordStates=[FORGOTTEN_PASSWORD_READY,FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST,FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT,FORGOTTEN_PASSWORD_ERROR];

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDirtyFields */
/* unused harmony export getItemsWithProp */
/* harmony export (immutable) */ __webpack_exports__["a"] = getDOMOnlyProps;
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
function getDirtyFields(arr){return getItemsWithProp(arr,'dirty');}function getItemsWithProp(arr,prop){return arr.filter(function(item){var values=Object.values(item);return values.some(function(key){return key[prop];});});}/* eslint-disable no-unused-vars */// React 15.3 gives a warning about unknown props being passed to a component.
// Since Redux Form V5 just gives us a big object of props we need to extract
// just the ones for an <input />.
function getDOMOnlyProps(_ref){var active=_ref.active,autofill=_ref.autofill,autofilled=_ref.autofilled,dirty=_ref.dirty,error=_ref.error,initialValue=_ref.initialValue,invalid=_ref.invalid,onUpdate=_ref.onUpdate,pristine=_ref.pristine,touched=_ref.touched,valid=_ref.valid,visited=_ref.visited,domProps=_objectWithoutProperties(_ref,['active','autofill','autofilled','dirty','error','initialValue','invalid','onUpdate','pristine','touched','valid','visited']);return domProps;}/* eslint-enable no-unused-vars */

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cooling__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dual_spinner__ = __webpack_require__(2432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__heating__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
var componentMap={AUTO:{component:__WEBPACK_IMPORTED_MODULE_1__dual_spinner__["a" /* default */],mode:['heat','cool']},HEAT:{component:__WEBPACK_IMPORTED_MODULE_2__heating__["a" /* default */],mode:'heat'},COOL:{component:__WEBPACK_IMPORTED_MODULE_0__cooling__["a" /* default */],mode:'cool'},default:{component:__WEBPACK_IMPORTED_MODULE_2__heating__["a" /* default */],mode:'heat'}};var Component=function Component(_ref){var controlMode=_ref.controlMode,className=_ref.className,props=_objectWithoutProperties(_ref,['controlMode','className']);var _ref2=componentMap[controlMode]||componentMap.default,Comp=_ref2.component,mode=_ref2.mode;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:className},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Comp,Object.assign({mode:mode},props)));};Component.propTypes={className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,controlMode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (Component);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_ALL_PRODUCT_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_PRODUCT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_HUMIDIFIER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGED_PRODUCT_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CACHE_PRODUCT_TEMPERATURE; });
var CHANGE_ALL_PRODUCT_STATES='hive/thermostat/CHANGE_ALL_PRODUCT_STATES';var CHANGE_PRODUCT_STATE='hive/thermostat/CHANGE_PRODUCT_STATE';var SET_HUMIDIFIER_TYPE='hive/thermostat/SET_HUMIDIFIER_TYPE';var CHANGED_PRODUCT_STATE='hive/thermostat/CHANGED_PRODUCT_STATE';var CACHE_PRODUCT_TEMPERATURE='hive/thermostat/CACHE_PRODUCT_TEMPERATURE';

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_TARGET_TEMPERATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_TARGET_TEMPERATURE_UPDATE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_TARGET_TEMPERATURE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET_TEMPERATURE_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_TEMPERATURE_HISTORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELECT_PERIOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SELECTED_PERIOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOGGLE_READY_BY; });
var SET_TARGET_TEMPERATURE='hive/heating/target/set';var SET_TARGET_TEMPERATURE_UPDATE_PRODUCT='hive/heating/target/set/UPDATE_PRODUCT';var SET_TARGET_TEMPERATURE_SUCCESS='hive/heating/target/set/SUCCESS';var GET_TEMPERATURE_HISTORY='hive/heating/history/get';var GET_TEMPERATURE_HISTORY_SUCCESS='hive/heating/history/get/success';var SELECT_PERIOD='hive/heating/history/select/period';var SELECTED_PERIOD='SELECTED_PERIOD';var TOGGLE_READY_BY='hive/heating/ready-by';

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TAB_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TAB_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TAB_DISCOVER; });
var TAB_KEY='tab';var TAB_ACTIONS='actions';var TAB_DISCOVER='discover';

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__intl__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
// @noflow
var TimeSpan=function TimeSpan(_ref){var value=_ref.value;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{'data-qa':'timespan'},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_1__intl__["a" /* default */].timespan,{values:{years:value.years(),months:value.months(),days:value.days(),hours:value.hours(),minutes:value.minutes(),seconds:value.seconds()}})));};TimeSpan.propTypes={value:__WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__["momentDurationObj"]};/* harmony default export */ __webpack_exports__["a"] = (TimeSpan);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_SELECTED_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_ZOOM_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_EVENTS_CURRENT_DAY; });
/* unused harmony export GET_EVENTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOAD_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAGE_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECEIVE_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UNLOAD_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONTACT_SENSOR_EVENT_TYPES_OPEN; });
/* unused harmony export CONTACT_SENSOR_EVENT_TYPES_CLOSED */
var CHANGE_SELECTED_DAY='hive/contact-sensor/CHANGE_SELECTED_DAY';var CHANGE_ZOOM_LEVEL='hive/contact-sensor/CHANGE_ZOOM_LEVEL';var CHANGE_EVENTS_CURRENT_DAY='hive/contact-sensor/CHANGE_EVENTS_CURRENT_DAY';var GET_EVENTS='hive/contact-sensor/GET_EVENTS';var LOAD_PAGE='hive/contact-sensor/LOAD_PAGE';var PAGE_READY='hive/contact-sensor/PAGE_READY';var RECEIVE_EVENTS='hive/contact-sensor/RECEIVE_EVENTS';var UNLOAD_PAGE='hive/contact-sensor/UNLOAD_PAGE';var CONTACT_SENSOR_EVENT_TYPES_OPEN='Opened';var CONTACT_SENSOR_EVENT_TYPES_CLOSED='Closed';

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TODAY", function() { return TODAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YESTERDAY", function() { return YESTERDAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THIS_WEEK", function() { return THIS_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_WEEK", function() { return LAST_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THIS_MONTH", function() { return THIS_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_MONTH", function() { return LAST_MONTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THIS_YEAR", function() { return THIS_YEAR; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time_units__ = __webpack_require__(315);
var TODAY={constant:'TODAY',intlKey:'today',timeUnit:__WEBPACK_IMPORTED_MODULE_0__time_units__["b" /* MINUTES */],rate:30,resolution:'day'};var YESTERDAY={constant:'YESTERDAY',intlKey:'yesterday',timeUnit:__WEBPACK_IMPORTED_MODULE_0__time_units__["b" /* MINUTES */],rate:30,resolution:'day'};var THIS_WEEK={constant:'THIS_WEEK',intlKey:'thisWeek',timeUnit:__WEBPACK_IMPORTED_MODULE_0__time_units__["a" /* DAYS */],rate:1,resolution:'week'};var LAST_WEEK={constant:'LAST_WEEK',intlKey:'lastWeek',timeUnit:__WEBPACK_IMPORTED_MODULE_0__time_units__["a" /* DAYS */],rate:1,resolution:'week'};var THIS_MONTH={constant:'THIS_MONTH',intlKey:'thisMonth',timeUnit:__WEBPACK_IMPORTED_MODULE_0__time_units__["a" /* DAYS */],rate:1,resolution:'month'};var LAST_MONTH={constant:'LAST_MONTH',intlKey:'lastMonth',timeUnit:__WEBPACK_IMPORTED_MODULE_0__time_units__["a" /* DAYS */],rate:1,resolution:'month'};var THIS_YEAR={constant:'THIS_YEAR',intlKey:'thisYear',timeUnit:__WEBPACK_IMPORTED_MODULE_0__time_units__["c" /* MONTHS */],rate:1,resolution:'year'};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pollNodeExists; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(702);
var pollNodeExists=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* POLL_NODE_EXISTS */]);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// This file will replace the `general.js` once we get rid of the devices font icons
var weatherIcons={BLACK_LOW_CLOUD:'BLACK_LOW_CLOUD',CLEAR_SKY:'CLEAR_SKY',CLOUDY_WITH_HEAVY_RAIN:'CLOUDY_WITH_HEAVY_RAIN',CLOUDY_WITH_HEAVY_RAIN_NIGHT:'CLOUDY_WITH_HEAVY_RAIN_NIGHT',CLOUDY_WITH_HEAVY_SNOW:'CLOUDY_WITH_HEAVY_SNOW',CLOUDY_WITH_LIGHT_RAIN:'CLOUDY_WITH_LIGHT_RAIN',CLOUDY_WITH_LIGHT_RAIN_NIGHT:'CLOUDY_WITH_LIGHT_RAIN_NIGHT',CLOUDY_WITH_SLEET:'CLOUDY_WITH_SLEET',FOG_MIST:'FOG_MIST',HEAVY_RAIN_SHOWERS:'HEAVY_RAIN_SHOWERS',HEAVY_SNOW_SHOWERS:'HEAVY_SNOW_SHOWERS',HEAVY_SNOW_SHOWERS_NIGHT:'HEAVY_SNOW_SHOWERS_NIGHT',LIGHT_RAIN_SHOWERS:'LIGHT_RAIN_SHOWERS',LIGHT_SNOW:'LIGHT_SNOW',LIGHT_SNOW_NIGHT:'LIGHT_SNOW_NIGHT',LIGHT_SNOW_SHOWERS:'LIGHT_SNOW_SHOWERS',SLEET_SHOWERS:'SLEET_SHOWERS',SLEET_SHOWERS_NIGHT:'SLEET_SHOWERS_NIGHT',SUNNY:'SUNNY',SUNNY_INTERVALS:'SUNNY_INTERVALS',SUNSET_SUNRISE:'SUNSET_SUNRISE',THUNDER_SHOWERS:'THUNDER_SHOWERS',THUNDER_SHOWERS_NIGHT:'THUNDER_SHOWERS_NIGHT',THUNDERSTORMS:'THUNDERSTORMS',WHITE_CLOUD:'WHITE_CLOUD',WHITE_CLOUD_NIGHT:'WHITE_CLOUD_NIGHT'};/* harmony default export */ __webpack_exports__["a"] = (weatherIcons);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cacheProductTemperature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeAllProductStates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeProductState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changedProductState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setHumidifierType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var cacheProductTemperature=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CACHE_PRODUCT_TEMPERATURE */]);var changeAllProductStates=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_ALL_PRODUCT_STATES */]);var changeProductState=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CHANGE_PRODUCT_STATE */]);var changedProductState=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CHANGED_PRODUCT_STATE */]);var setHumidifierType=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_HUMIDIFIER_TYPE */]);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LoadingIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__waiting__ = __webpack_require__(783);
function LoadingIndicator(_ref){var children=_ref.children,isLoading=_ref.isLoading;if(isLoading){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* LoadingIndicatorContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* LoadingIndicatorContent */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__waiting__["a" /* default */],{show:true})));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,children);}

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_CURRENT_DASHBOARD_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_DASHBOARD_CUSTOMISATION; });
/* unused harmony export LOAD_DASHBOARD_PAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RECEIVE_DASHBOARD_CUSTOMISATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SHOW_DASHBOARD_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DISPLAY_ALL_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DASHBOARD_EDIT_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CANCEL_DASHBOARD_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SAVE_DASHBOARD_EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SAVE_DASHBOARD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPDATE_CELL_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETE_CELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_NEW_DASHBOARD_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DASHBOARD_ADD_PRODUCT_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DASHBOARD_ADD_PRODUCT_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DASHBOARD_ADD_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DASHBOARD_REMOVE_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DASHBOARD_ADD_NEXT_PRODUCT_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return REDIRECT_TO_POSTINSTALL_GROUPS; });
var CHANGE_CURRENT_DASHBOARD_PAGE='hive/dashboard/CHANGE_CURRENT_DASHBOARD_PAGE';var GET_DASHBOARD_CUSTOMISATION='hive/dashboard/GET_DASHBOARD_CUSTOMISATION';var LOAD_DASHBOARD_PAGE='hive/dashboard/LOAD_DASHBOARD_PAGE';var RECEIVE_DASHBOARD_CUSTOMISATION='hive/dashboard/RECEIVE_DASHBOARD_CUSTOMISATION';var SHOW_DASHBOARD_DATA='hive/dashboard/SHOW_DASHBOARD_DATA';var DISPLAY_ALL_PRODUCTS='hive/dashboard/DISPLAY_ALL_PRODUCTS';var DASHBOARD_EDIT_ON='hive/dashboard/DASHBOARD_EDIT_ON';var CANCEL_DASHBOARD_EDIT='hive/dashboard/CANCEL_DASHBOARD_EDIT';var SAVE_DASHBOARD_EDIT='hive/dashboard/SAVE_DASHBOARD_EDIT';var SAVE_DASHBOARD_SUCCESS='hive/dashboard/SAVE_DASHBOARD_SUCCESS';var UPDATE_CELL_POSITION='hive/dashboard/UPDATE_CELL_POSITION';var DELETE_CELL='hive/dashboard/DELETE_CELL';var ADD_NEW_DASHBOARD_PAGE='hive/dashboard/ADD_NEW_DASHBOARD_PAGE';var DASHBOARD_ADD_PRODUCT_ON='hive/dashboard/DASHBOARD_ADD_PRODUCT_ON';var DASHBOARD_ADD_PRODUCT_OFF='hive/dashboard/DASHBOARD_ADD_PRODUCT_OFF';var DASHBOARD_ADD_PRODUCT='hive/dashboard/DASHBOARD_ADD_PRODUCT';var DASHBOARD_REMOVE_PRODUCTS='hive/dashboard/DASHBOARD_REMOVE_PRODUCTS';var DASHBOARD_ADD_NEXT_PRODUCT_POSITION='hive/dashboard/DASHBOARD_ADD_NEXT_PRODUCT_POSITION';var REDIRECT_TO_POSTINSTALL_GROUPS='hive/dashboard/REDIRECT_TO_POSTINSTALL_GROUPS';

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveHomes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHomes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renameHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return renamedHome; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
var RECEIVE_HOMES='hive/homes/RECEIVE_HOMES';var RENAMED_HOME='hive/homes/RENAMED_HOME';var GET_HOMES='hive/homes/GET_HOMES';var RENAME_HOME='hive/homes/RENAME_HOME';var receiveHomes=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(RECEIVE_HOMES);var getHomes=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(GET_HOMES);var renameHome=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(RENAME_HOME);var renamedHome=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(RENAMED_HOME);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Flipper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(502);
/**
 * Allows the user to see a "flip" transition between two different bits of content.
 *
 * Requires that the supplied children have a `key`.
 */function Flipper(_ref){var children=_ref.children,childKey=_ref.childKey,_ref$isSwitchable=_ref.isSwitchable,isSwitchable=_ref$isSwitchable===undefined?true:_ref$isSwitchable;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* StyledTransitionGroup */],{isSwitchable:isSwitchable},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* StyledCSSTransition */],{classNames:'flipper__flip',key:childKey,timeout:__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* TRANSITION_DURATION_TOTAL */]},children));}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(2366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_devices__ = __webpack_require__(827);
var mapStateToProps=function mapStateToProps(state,_ref){var active=_ref.active,model=_ref.model,type=_ref.type;return{icon:Object(__WEBPACK_IMPORTED_MODULE_3__utils_devices__["c" /* iconForDevice */])({active:active,localeSuffix:Object(__WEBPACK_IMPORTED_MODULE_2__state_config_selectors__["d" /* getIconLocaleSuffix */])(state),model:model,type:type})};};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */]));

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(540),
    createBind = __webpack_require__(1034),
    createCurry = __webpack_require__(1035),
    createHybrid = __webpack_require__(545),
    createPartial = __webpack_require__(1048),
    getData = __webpack_require__(363),
    mergeData = __webpack_require__(1049),
    setData = __webpack_require__(551),
    setWrapToString = __webpack_require__(553),
    toInteger = __webpack_require__(107);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(277),
    baseLodash = __webpack_require__(362);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(541),
    noop = __webpack_require__(364);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(277),
    baseLodash = __webpack_require__(362);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1042),
    shortOut = __webpack_require__(552);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 367 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(268);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(229),
    nativeKeys = __webpack_require__(1054);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(282),
    arrayEach = __webpack_require__(367),
    assignValue = __webpack_require__(280),
    baseAssign = __webpack_require__(558),
    baseAssignIn = __webpack_require__(1078),
    cloneBuffer = __webpack_require__(562),
    copyArray = __webpack_require__(186),
    copySymbols = __webpack_require__(1081),
    copySymbolsIn = __webpack_require__(1082),
    getAllKeys = __webpack_require__(565),
    getAllKeysIn = __webpack_require__(378),
    getTag = __webpack_require__(288),
    initCloneArray = __webpack_require__(1085),
    initCloneByTag = __webpack_require__(1086),
    initCloneObject = __webpack_require__(570),
    isArray = __webpack_require__(32),
    isBuffer = __webpack_require__(227),
    isObject = __webpack_require__(54),
    keys = __webpack_require__(108);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1066),
    mapCacheDelete = __webpack_require__(1073),
    mapCacheGet = __webpack_require__(1075),
    mapCacheHas = __webpack_require__(1076),
    mapCacheSet = __webpack_require__(1077);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(376),
    stubArray = __webpack_require__(563);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(561);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(566),
    getSymbolsIn = __webpack_require__(564),
    keysIn = __webpack_require__(287);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(568);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 380 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(360);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1097),
    isObjectLike = __webpack_require__(91);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(32),
    isSymbol = __webpack_require__(187);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31)
  , document = __webpack_require__(22).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(22)
  , core           = __webpack_require__(109)
  , LIBRARY        = __webpack_require__(155)
  , wksExt         = __webpack_require__(584)
  , defineProperty = __webpack_require__(35).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(295)('keys')
  , uid    = __webpack_require__(154);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 388 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(83);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22).document && document.documentElement;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(31)
  , anObject = __webpack_require__(16);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(110)(Function.call, __webpack_require__(72).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var isObject       = __webpack_require__(31)
  , setPrototypeOf = __webpack_require__(391).set;
module.exports = function(that, target, C){
  var P, S = target.constructor;
  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
    setPrototypeOf(that, P);
  } return that;
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(137)
  , defined   = __webpack_require__(84);

module.exports = function repeat(count){
  var str = String(defined(this))
    , res = ''
    , n   = toInteger(count);
  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
  return res;
};

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x){
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 396 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x){
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(137)
  , defined   = __webpack_require__(84);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(155)
  , $export        = __webpack_require__(3)
  , redefine       = __webpack_require__(62)
  , hide           = __webpack_require__(61)
  , has            = __webpack_require__(56)
  , Iterators      = __webpack_require__(193)
  , $iterCreate    = __webpack_require__(399)
  , setToStringTag = __webpack_require__(191)
  , getPrototypeOf = __webpack_require__(73)
  , ITERATOR       = __webpack_require__(33)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(158)
  , descriptor     = __webpack_require__(135)
  , setToStringTag = __webpack_require__(191)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(61)(IteratorPrototype, __webpack_require__(33)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(299)
  , defined  = __webpack_require__(84);

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(33)('match');
module.exports = function(KEY){
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch(e){
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch(f){ /* empty */ }
  } return true;
};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(193)
  , ITERATOR   = __webpack_require__(33)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(35)
  , createDesc      = __webpack_require__(135);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(234)
  , ITERATOR  = __webpack_require__(33)('iterator')
  , Iterators = __webpack_require__(193);
module.exports = __webpack_require__(109).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(48)
  , toIndex  = __webpack_require__(157)
  , toLength = __webpack_require__(43);
module.exports = function fill(value /*, start = 0, end = @length */){
  var O      = toObject(this)
    , length = toLength(O.length)
    , aLen   = arguments.length
    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
    , end    = aLen > 2 ? arguments[2] : undefined
    , endPos = end === undefined ? length : toIndex(end, length);
  while(endPos > index)O[index++] = value;
  return O;
};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(194)
  , step             = __webpack_require__(599)
  , Iterators        = __webpack_require__(193)
  , toIObject        = __webpack_require__(64);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(398)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(16)
  , aFunction = __webpack_require__(63)
  , SPECIES   = __webpack_require__(33)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(110)
  , invoke             = __webpack_require__(298)
  , html               = __webpack_require__(390)
  , cel                = __webpack_require__(385)
  , global             = __webpack_require__(22)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(83)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(22)
  , macrotask = __webpack_require__(408).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(83)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(22)
  , DESCRIPTORS    = __webpack_require__(34)
  , LIBRARY        = __webpack_require__(155)
  , $typed         = __webpack_require__(304)
  , hide           = __webpack_require__(61)
  , redefineAll    = __webpack_require__(162)
  , fails          = __webpack_require__(25)
  , anInstance     = __webpack_require__(161)
  , toInteger      = __webpack_require__(137)
  , toLength       = __webpack_require__(43)
  , gOPN           = __webpack_require__(159).f
  , dP             = __webpack_require__(35).f
  , arrayFill      = __webpack_require__(405)
  , setToStringTag = __webpack_require__(191)
  , ARRAY_BUFFER   = 'ArrayBuffer'
  , DATA_VIEW      = 'DataView'
  , PROTOTYPE      = 'prototype'
  , WRONG_LENGTH   = 'Wrong length!'
  , WRONG_INDEX    = 'Wrong index!'
  , $ArrayBuffer   = global[ARRAY_BUFFER]
  , $DataView      = global[DATA_VIEW]
  , Math           = global.Math
  , RangeError     = global.RangeError
  , Infinity       = global.Infinity
  , BaseBuffer     = $ArrayBuffer
  , abs            = Math.abs
  , pow            = Math.pow
  , floor          = Math.floor
  , log            = Math.log
  , LN2            = Math.LN2
  , BUFFER         = 'buffer'
  , BYTE_LENGTH    = 'byteLength'
  , BYTE_OFFSET    = 'byteOffset'
  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
var packIEEE754 = function(value, mLen, nBytes){
  var buffer = Array(nBytes)
    , eLen   = nBytes * 8 - mLen - 1
    , eMax   = (1 << eLen) - 1
    , eBias  = eMax >> 1
    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
    , i      = 0
    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
    , e, m, c;
  value = abs(value)
  if(value != value || value === Infinity){
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if(value * (c = pow(2, -e)) < 1){
      e--;
      c *= 2;
    }
    if(e + eBias >= 1){
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if(value * c >= 2){
      e++;
      c /= 2;
    }
    if(e + eBias >= eMax){
      m = 0;
      e = eMax;
    } else if(e + eBias >= 1){
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
};
var unpackIEEE754 = function(buffer, mLen, nBytes){
  var eLen  = nBytes * 8 - mLen - 1
    , eMax  = (1 << eLen) - 1
    , eBias = eMax >> 1
    , nBits = eLen - 7
    , i     = nBytes - 1
    , s     = buffer[i--]
    , e     = s & 127
    , m;
  s >>= 7;
  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if(e === 0){
    e = 1 - eBias;
  } else if(e === eMax){
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
};

var unpackI32 = function(bytes){
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
};
var packI8 = function(it){
  return [it & 0xff];
};
var packI16 = function(it){
  return [it & 0xff, it >> 8 & 0xff];
};
var packI32 = function(it){
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
};
var packF64 = function(it){
  return packIEEE754(it, 52, 8);
};
var packF32 = function(it){
  return packIEEE754(it, 23, 4);
};

var addGetter = function(C, key, internal){
  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
};

var get = function(view, bytes, index, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
};
var set = function(view, bytes, index, conversion, value, isLittleEndian){
  var numIndex = +index
    , intIndex = toInteger(numIndex);
  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b
    , start = intIndex + view[$OFFSET]
    , pack  = conversion(+value);
  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
};

var validateArrayBufferArguments = function(that, length){
  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
  var numberLength = +length
    , byteLength   = toLength(numberLength);
  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
  return byteLength;
};

if(!$typed.ABV){
  $ArrayBuffer = function ArrayBuffer(length){
    var byteLength = validateArrayBufferArguments(this, length);
    this._b       = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength){
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH]
      , offset       = toInteger(byteOffset);
    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if(DESCRIPTORS){
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset){
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset){
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /*, littleEndian */){
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /*, littleEndian */){
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value){
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if(!fails(function(){
    new $ArrayBuffer;     // eslint-disable-line no-new
  }) || !fails(function(){
    new $ArrayBuffer(.5); // eslint-disable-line no-new
  })){
    $ArrayBuffer = function ArrayBuffer(length){
      return new BaseBuffer(validateArrayBufferArguments(this, length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
    };
    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2))
    , $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value){
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialize */
/* unused harmony export ga */
/* unused harmony export set */
/* unused harmony export send */
/* unused harmony export pageview */
/* unused harmony export modalview */
/* unused harmony export timing */
/* unused harmony export event */
/* unused harmony export exception */
/* unused harmony export plugin */
/* unused harmony export outboundLink */
/* unused harmony export OutboundLink */
/* unused harmony export testModeAPI */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_format__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_trim__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_loadGA__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_console_warn__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_console_log__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__ = __webpack_require__(1332);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */].ga.apply(__WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */], arguments);
  if (typeof window === 'undefined') return false;
  if (!window.ga) return Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_format__["a" /* default */])(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (typeof window === 'undefined') {
      return false;
    }

    if (!options || options.standardImplementation !== true) Object(__WEBPACK_IMPORTED_MODULE_3__utils_loadGA__["a" /* default */])(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'arguments\');');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'set\', fieldsObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', fieldObject);');
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path is required in .pageview()');
    return;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawPath);

  if (path === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_removeLeadingSlash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawModalName));

  if (modalName === '') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])('called ga(\'send\', \'pageview\', path);');
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   */
  require: function require(rawName, options) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` is required in .require()');
        return;
      }

      var name = Object(__WEBPACK_IMPORTED_MODULE_2__utils_trim__["a" /* default */])(rawName);

      if (name === '') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('`name` cannot be an empty string in .require()');
        return;
      } // Optional Fields


      if (options) {
        if (_typeof(options) !== 'object') {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Empty `options` given to .require()');
        }

        ga('require', name, options);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga('require', name);

        if (_debug) {
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            Object(__WEBPACK_IMPORTED_MODULE_5__utils_console_log__["a" /* default */])("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_console_warn__["a" /* default */])('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
__WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__["a" /* default */].origTrackLink = __WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__["a" /* default */].trackLink;
__WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__["a" /* default */].trackLink = outboundLink;
var OutboundLink = __WEBPACK_IMPORTED_MODULE_7__components_OutboundLink__["a" /* default */];
var testModeAPI = __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  OutboundLink: OutboundLink,
  testModeAPI: __WEBPACK_IMPORTED_MODULE_6__utils_testModeAPI__["a" /* default */]
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warn;
function warn(s) {
  console.warn('[react-ga]', s);
}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('reduce', __webpack_require__(1340));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(138);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(630);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(166);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isString);


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(636);




/* Node.js helper references. */
var nodeIsMap = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsMap) : __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isMap);


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isMap__ = __webpack_require__(421);


function ownKeys(object) {

  if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isMap__["a" /* default */])(object)) {
    return Array.from(object.keys());
  }

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISMISS_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REQUEST_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISMISS_ALL_ALERTS; });
var DISMISS_ALERT='hive/alerts/DISMISS_ALERT';var REQUEST_ALERT='hive/alerts/REQUEST_ALERT';var DISMISS_ALL_ALERTS='hive/alerts/DISMISS_ALL_ALERTS';

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUDIO_DATA_RECEIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_AUDIO_DATA; });
var PREFIX='hive/ui/sensor-logs/audio-player/';var AUDIO_DATA_RECEIVED=PREFIX+'AUDIO_DATA_RECEIVED';var CLEAR_DATA=PREFIX+'CLEAR_DATA';var GET_AUDIO_DATA=PREFIX+'GET_AUDIO_DATA';

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

module.exports = function (method, transformation) {
  if (typeof transformation !== 'function') {
    throw new TypeError(method + ' expects a function, but was given ' + transformation + '.');
  }
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: experimental
 * name: module folktale/adt/union
 */
module.exports = {
  union: __webpack_require__(198),
  derivations: __webpack_require__(1423)
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var copyDocs = __webpack_require__(655);

var defineAdtMethod = function defineAdtMethod(adt, definitions) {
  Object.keys(definitions).forEach(function (name) {
    var methods = definitions[name];
    adt.variants.forEach(function (variant) {
      var method = methods[variant.tag];
      if (!method) {
        throw new TypeError('Method ' + name + ' not defined for ' + variant.tag);
      }
      copyDocs(methods, method);
      variant.prototype[name] = method;
    });
  });
};

module.exports = defineAdtMethod;

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_COOKIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COOKIES_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_COOKIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COOKIE_SET; });
var LOAD_COOKIES='hive/cookies/LOAD_COOKIES';var COOKIES_LOADED='hive/cookies/COOKIES_LOADED';var SET_COOKIE='hive/cookies/SET_COOKIE';var COOKIE_SET='hive/cookies/COOKIE_SET';

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(556),
    baseIteratee = __webpack_require__(55),
    toInteger = __webpack_require__(107);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_CAMERA_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CAMERA_SETTINGS_UPDATED; });
var PREFIX_CAMERA="hive/camera/";var UPDATE_CAMERA_SETTINGS=PREFIX_CAMERA+"UPDATE_CAMERA_SETTINGS";var CAMERA_SETTINGS_UPDATED=PREFIX_CAMERA+"CAMERA_SETTINGS_UPDATED";

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTITELEMENTS_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_ENTITLEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVE_ENTITLEMENTS; });
var ENTITELEMENTS_ATTRIBUTE='entitlements';var GET_ENTITLEMENTS='hive/entitlements/GET_ENTITLEMENTS';var RECEIVE_ENTITLEMENTS='hive/entitlements/RECEIVE_ENTITLEMENTS';

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.initialState = exports.globalErrorKey = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _initialState, _behaviors;

var _actionTypes = __webpack_require__(434);

var _mapValues = __webpack_require__(435);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _read = __webpack_require__(671);

var _read2 = _interopRequireDefault(_read);

var _write = __webpack_require__(672);

var _write2 = _interopRequireDefault(_write);

var _getValuesFromState = __webpack_require__(673);

var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);

var _initializeState = __webpack_require__(674);

var _initializeState2 = _interopRequireDefault(_initializeState);

var _resetState = __webpack_require__(1462);

var _resetState2 = _interopRequireDefault(_resetState);

var _setErrors = __webpack_require__(1463);

var _setErrors2 = _interopRequireDefault(_setErrors);

var _fieldValue = __webpack_require__(199);

var _normalizeFields = __webpack_require__(1464);

var _normalizeFields2 = _interopRequireDefault(_normalizeFields);

var _createInitialState = __webpack_require__(675);

var _createInitialState2 = _interopRequireDefault(_createInitialState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var globalErrorKey = exports.globalErrorKey = '_error';

var initialState = exports.initialState = (_initialState = {
  _active: undefined,
  _asyncValidating: false
}, _initialState[globalErrorKey] = undefined, _initialState._initialized = false, _initialState._submitting = false, _initialState._submitFailed = false, _initialState);

var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
  var path = _ref.path,
      index = _ref.index,
      value = _ref.value,
      fields = _ref.fields;

  var array = (0, _read2.default)(path, state);
  var stateCopy = _extends({}, state);
  var arrayCopy = array ? [].concat(array) : [];
  var newValue = value !== null && typeof value === 'object' ? (0, _initializeState2.default)(value, fields || Object.keys(value)) : (0, _fieldValue.makeFieldValue)({ value: value });
  if (index === undefined) {
    arrayCopy.push(newValue);
  } else {
    arrayCopy.splice(index, 0, newValue);
  }
  return (0, _write2.default)(path, arrayCopy, stateCopy);
}, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref2) {
  var field = _ref2.field,
      value = _ref2.value;

  return (0, _write2.default)(field, function (previous) {
    var _previous$value$autof = _extends({}, previous, { value: value, autofilled: true }),
        asyncError = _previous$value$autof.asyncError,
        submitError = _previous$value$autof.submitError,
        result = _objectWithoutProperties(_previous$value$autof, ['asyncError', 'submitError']);

    return (0, _fieldValue.makeFieldValue)(result);
  }, state);
}, _behaviors[_actionTypes.BLUR] = function (state, _ref3) {
  var field = _ref3.field,
      value = _ref3.value,
      touch = _ref3.touch;

  var _active = state._active,
      stateCopy = _objectWithoutProperties(state, ['_active']);

  if (_active && _active !== field) {
    // remove _active from state
    stateCopy._active = _active;
  }
  return (0, _write2.default)(field, function (previous) {
    var result = _extends({}, previous);
    if (value !== undefined) {
      result.value = value;
    }
    if (touch) {
      result.touched = true;
    }
    return (0, _fieldValue.makeFieldValue)(result);
  }, stateCopy);
}, _behaviors[_actionTypes.CHANGE] = function (state, _ref4) {
  var field = _ref4.field,
      value = _ref4.value,
      touch = _ref4.touch;

  return (0, _write2.default)(field, function (previous) {
    var _previous$value = _extends({}, previous, { value: value }),
        asyncError = _previous$value.asyncError,
        submitError = _previous$value.submitError,
        autofilled = _previous$value.autofilled,
        result = _objectWithoutProperties(_previous$value, ['asyncError', 'submitError', 'autofilled']);

    if (touch) {
      result.touched = true;
    }
    return (0, _fieldValue.makeFieldValue)(result);
  }, state);
}, _behaviors[_actionTypes.DESTROY] = function () {
  return undefined;
}, _behaviors[_actionTypes.FOCUS] = function (state, _ref5) {
  var field = _ref5.field;

  var stateCopy = (0, _write2.default)(field, function (previous) {
    return (0, _fieldValue.makeFieldValue)(_extends({}, previous, { visited: true }));
  }, state);
  stateCopy._active = field;
  return stateCopy;
}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref6) {
  var data = _ref6.data,
      fields = _ref6.fields,
      overwriteValues = _ref6.overwriteValues;

  return (0, _createInitialState2.default)(data, fields, state, overwriteValues);
}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref7) {
  var path = _ref7.path,
      index = _ref7.index;

  var array = (0, _read2.default)(path, state);
  var stateCopy = _extends({}, state);
  var arrayCopy = array ? [].concat(array) : [];
  if (index === undefined) {
    arrayCopy.pop();
  } else if (isNaN(index)) {
    delete arrayCopy[index];
  } else {
    arrayCopy.splice(index, 1);
  }
  return (0, _write2.default)(path, arrayCopy, stateCopy);
}, _behaviors[_actionTypes.RESET] = function (state) {
  var _extends2;

  return _extends({}, (0, _resetState2.default)(state), (_extends2 = {
    _active: undefined,
    _asyncValidating: false
  }, _extends2[globalErrorKey] = undefined, _extends2._initialized = state._initialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref8) {
  var field = _ref8.field;

  return _extends({}, state, {
    _asyncValidating: field || true
  });
}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
  return _extends({}, state, {
    _submitting: true
  });
}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref9) {
  var _extends3;

  var errors = _ref9.errors;

  return _extends({}, (0, _setErrors2.default)(state, errors, 'asyncError'), (_extends3 = {
    _asyncValidating: false
  }, _extends3[globalErrorKey] = errors && errors[globalErrorKey], _extends3));
}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref10) {
  var _extends4;

  var errors = _ref10.errors;

  return _extends({}, (0, _setErrors2.default)(state, errors, 'submitError'), (_extends4 = {}, _extends4[globalErrorKey] = errors && errors[globalErrorKey], _extends4._submitting = false, _extends4._submitFailed = !!(errors && Object.keys(errors).length), _extends4));
}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
  return _extends({}, state, {
    _submitFailed: true
  });
}, _behaviors[_actionTypes.SWAP_ARRAY_VALUES] = function (state, _ref11) {
  var path = _ref11.path,
      indexA = _ref11.indexA,
      indexB = _ref11.indexB;

  var array = (0, _read2.default)(path, state);
  var arrayLength = array.length;
  if (indexA === indexB || isNaN(indexA) || isNaN(indexB) || indexA >= arrayLength || indexB >= arrayLength) {
    return state; // do nothing
  }
  var stateCopy = _extends({}, state);
  var arrayCopy = [].concat(array);
  arrayCopy[indexA] = array[indexB];
  arrayCopy[indexB] = array[indexA];
  return (0, _write2.default)(path, arrayCopy, stateCopy);
}, _behaviors[_actionTypes.TOUCH] = function (state, _ref12) {
  var fields = _ref12.fields;

  return _extends({}, state, fields.reduce(function (accumulator, field) {
    return (0, _write2.default)(field, function (value) {
      return (0, _fieldValue.makeFieldValue)(_extends({}, value, { touched: true }));
    }, accumulator);
  }, state));
}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref13) {
  var fields = _ref13.fields;

  return _extends({}, state, fields.reduce(function (accumulator, field) {
    return (0, _write2.default)(field, function (value) {
      if (value) {
        var touched = value.touched,
            rest = _objectWithoutProperties(value, ['touched']);

        return (0, _fieldValue.makeFieldValue)(rest);
      }
      return (0, _fieldValue.makeFieldValue)(value);
    }, accumulator);
  }, state));
}, _behaviors);

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var behavior = behaviors[action.type];
  return behavior ? behavior(state, action) : state;
};

function formReducer() {
  var _extends10;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var form = action.form,
      key = action.key,
      rest = _objectWithoutProperties(action, ['form', 'key']); // eslint-disable-line no-redeclare


  if (!form) {
    return state;
  }
  if (key) {
    var _extends7, _extends8;

    if (action.type === _actionTypes.DESTROY) {
      var _extends6;

      return _extends({}, state, (_extends6 = {}, _extends6[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
        var _extends5;

        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[stateKey] = state[form][stateKey], _extends5));
      }, {}), _extends6));
    }
    return _extends({}, state, (_extends8 = {}, _extends8[form] = _extends({}, state[form], (_extends7 = {}, _extends7[key] = reducer((state[form] || {})[key], rest), _extends7)), _extends8));
  }
  if (action.type === _actionTypes.DESTROY) {
    return Object.keys(state).reduce(function (accumulator, formName) {
      var _extends9;

      return formName === form ? accumulator : _extends({}, accumulator, (_extends9 = {}, _extends9[formName] = state[formName], _extends9));
    }, {});
  }
  return _extends({}, state, (_extends10 = {}, _extends10[form] = reducer(state[form], rest), _extends10));
}

/**
 * Adds additional functionality to the reducer
 */
function decorate(target) {
  target.plugin = function plugin(reducers) {
    var _this = this;

    // use 'function' keyword to enable 'this'
    return decorate(function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var result = _this(state, action);
      return _extends({}, result, (0, _mapValues2.default)(reducers, function (pluginReducer, key) {
        return pluginReducer(result[key] || initialState, action);
      }));
    });
  };

  target.normalize = function normalize(normalizers) {
    var _this2 = this;

    // use 'function' keyword to enable 'this'
    return decorate(function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var result = _this2(state, action);
      return _extends({}, result, (0, _mapValues2.default)(normalizers, function (formNormalizers, form) {
        var runNormalize = function runNormalize(previous, currentResult) {
          var previousValues = (0, _getValuesFromState2.default)(_extends({}, initialState, previous));
          var formResult = _extends({}, initialState, currentResult);
          var values = (0, _getValuesFromState2.default)(formResult);
          return (0, _normalizeFields2.default)(formNormalizers, formResult, previous, values, previousValues);
        };
        if (action.key) {
          var _extends11;

          return _extends({}, result[form], (_extends11 = {}, _extends11[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends11));
        }
        return runNormalize(state[form], result[form]);
      }));
    });
  };

  return target;
}

exports.default = decorate(formReducer);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var ADD_ARRAY_VALUE = exports.ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
var AUTOFILL = exports.AUTOFILL = 'redux-form/AUTOFILL';
var BLUR = exports.BLUR = 'redux-form/BLUR';
var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
var REMOVE_ARRAY_VALUE = exports.REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
var RESET = exports.RESET = 'redux-form/RESET';
var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
var SUBMIT_FAILED = exports.SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
var SWAP_ARRAY_VALUES = exports.SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = mapValues;
/**
 * Maps all the values in the given object through the given function and saves them, by key, to a result object
 */
function mapValues(obj, fn) {
  return obj ? Object.keys(obj).reduce(function (accumulator, key) {
    var _extends2;

    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = fn(obj[key], key), _extends2));
  }, {}) : obj;
}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SUN */
/* unused harmony export MON */
/* unused harmony export TUE */
/* unused harmony export WED */
/* unused harmony export THU */
/* unused harmony export FRI */
/* unused harmony export SAT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listDays; });
var SUN='SUN';var MON='MON';var TUE='TUE';var WED='WED';var THU='THU';var FRI='FRI';var SAT='SAT';var listDays=['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LEAK_SENSOR_SET_CURRENT_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEAK_SENSOR_LOAD_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LEAK_SENSOR_PAGE_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LEAK_SENSOR_RECEIVE_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LEAK_SENSOR_UNLOAD_PAGE; });
var LEAK_SENSOR_SET_CURRENT_DAY='hive/leak-sensor/LEAK_SENSOR_SET_CURRENT_DAY';var LEAK_SENSOR_LOAD_PAGE='hive/leak-sensor/LEAK_SENSOR_LOAD_PAGE';var LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS='hive/leak-sensor/LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS';var LEAK_SENSOR_PAGE_READY='hive/leak-sensor/LEAK_SENSOR_PAGE_READY';var LEAK_SENSOR_RECEIVE_EVENTS='hive/leak-sensor/LEAK_SENSOR_RECEIVE_EVENTS';var LEAK_SENSOR_UNLOAD_PAGE='hive/leak-sensor/LEAK_SENSOR_UNLOAD_PAGE';

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_MOTION_SENSOR_SELECTED_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_MOTION_SENSOR_ZOOM_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_EVENTS_CURRENT_DAY; });
/* unused harmony export GET_MOTION_SENSOR_EVENTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_MOTION_SENSOR_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MOTION_SENSOR_PAGE_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVE_MOTION_SENSOR_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UNLOAD_MOTION_SENSOR_PAGE; });
var CHANGE_MOTION_SENSOR_SELECTED_DAY='hive/motion-sensor/CHANGE_MOTION_SENSOR_SELECTED_DAY';var CHANGE_MOTION_SENSOR_ZOOM_LEVEL='hive/motion-sensor/CHANGE_MOTION_SENSOR_ZOOM_LEVEL';var CHANGE_EVENTS_CURRENT_DAY='hive/motion-sensor/CHANGE_EVENTS_CURRENT_DAY';var GET_MOTION_SENSOR_EVENTS='hive/motion-sensor/GET_MOTION_SENSOR_EVENTS';var LOAD_MOTION_SENSOR_PAGE='hive/motion-sensor/LOAD_MOTION_SENSOR_PAGE';var MOTION_SENSOR_PAGE_READY='hive/motion-sensor/MOTION_SENSOR_PAGE_READY';var RECEIVE_MOTION_SENSOR_EVENTS='hive/motion-sensor/RECEIVE_MOTION_SENSOR_EVENTS';var UNLOAD_MOTION_SENSOR_PAGE='hive/motion-sensor/UNLOAD_MOTION_SENSOR_PAGE';

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PLATFORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_POWER_CONSUMPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_POWER_CONSUMPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SHOW_ESTIMATED_COST_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIDE_ESTIMATED_COST_MODAL; });
var PLATFORM='hivehome';var CONFIG='power-consumption';var GET_POWER_CONSUMPTION='hive/power-consumption/get';var RECEIVE_POWER_CONSUMPTION='hive/power-consumption/receive';var SHOW_ESTIMATED_COST_MODAL='hive/power-consumption/SHOW_ESTIMATED_COST_MODAL';var HIDE_ESTIMATED_COST_MODAL='hive/power-consumption/HIDE_ESTIMATED_COST_MODAL';

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BULB_SAVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_BRIGHTNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_COLOR_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COLOR_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOGGLE_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_LIGHTBULB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TALK_TO_LIGHT; });
var BULB_SAVED='hive/lightbulbs/saved';var CHANGE_BRIGHTNESS='hive/lightbulbs/brightness';var CHANGE_COLOR_MODE='hive/color-picker/change-color-mode';var COLOR_CHANGED='hive/color-picker/color-changed';var TOGGLE_DONE='hive/lightbulbs/toggle-done';var TOGGLE_LIGHTBULB='hive/lightbulbs/toggle';var TALK_TO_LIGHT='hive/lightbulbs/talk';

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(290),
    arrayIncludes = __webpack_require__(279),
    arrayIncludesWith = __webpack_require__(443),
    cacheHas = __webpack_require__(291),
    createSet = __webpack_require__(1517),
    setToArray = __webpack_require__(289);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_SENSE_LOGS_SELECTED_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_SENSE_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_SENSE_EVENT_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FLAG_SENSE_MEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FLAG_SENSE_MEDIA_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_SENSE_DAY_EVENT_LOGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECEIVE_SENSE_DAY_EVENT_LOGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RECEIVED_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_DEFAULT_MUTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_DEFAULT_MUTING_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return STOP_SENSE_DAY_EVENT_LOGS_POLLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TOGGLE_MONITORING_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TOGGLE_MONITORING_ALL_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TOGGLE_MONITORING_SENSOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TOGGLE_MONITORING_SENSOR_DONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return defaultMuting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_products_sense__ = __webpack_require__(524);
var _sensors;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var PREFIX='hive/sense/';var CHANGE_SENSE_LOGS_SELECTED_DAY=PREFIX+'CHANGE_SENSE_LOGS_SELECTED_DAY';var DELETE_SENSE_EVENT=PREFIX+'DELETE_SENSE_EVENT';var DELETE_SENSE_EVENT_COMPLETE=PREFIX+'DELETE_SENSE_EVENT_COMPLETE';var FLAG_SENSE_MEDIA=PREFIX+'FLAG_SENSE_MEDIA';var FLAG_SENSE_MEDIA_COMPLETE=PREFIX+'FLAG_SENSE_MEDIA_COMPLETE';var GET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS=PREFIX+'hub-offline-notifications-status/get';var GET_SENSE_DAY_EVENT_LOGS=PREFIX+'GET_SENSE_DAY_EVENT_LOGS';var RECEIVE_SENSE_DAY_EVENT_LOGS=PREFIX+'RECEIVE_SENSE_DAY_EVENT_LOGS';var RECEIVED_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS=PREFIX+'hub-offline-notifications-status/received';var SET_DEFAULT_MUTING=PREFIX+'monitoring/set-default-muting';var SET_DEFAULT_MUTING_DONE=PREFIX+'monitoring/set-default-muting/done';var SET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS=PREFIX+'hub-offline-notifications-status/set';var STOP_SENSE_DAY_EVENT_LOGS_POLLING=PREFIX+'day-event-logs/polling/stop';var TOGGLE_MONITORING_ALL=PREFIX+'monitoring/toggle/all';var TOGGLE_MONITORING_ALL_DONE=PREFIX+'monitoring/toggle/all/done';var TOGGLE_MONITORING_SENSOR=PREFIX+'monitoring/toggle/sensor';var TOGGLE_MONITORING_SENSOR_DONE=PREFIX+'monitoring/toggle/sensor/done';var defaultMuting={mute:false,sensors:(_sensors={},_defineProperty(_sensors,__WEBPACK_IMPORTED_MODULE_0__constants_products_sense__["a" /* DOG_BARK */],true),_defineProperty(_sensors,__WEBPACK_IMPORTED_MODULE_0__constants_products_sense__["b" /* GLASS_BREAK */],true),_defineProperty(_sensors,__WEBPACK_IMPORTED_MODULE_0__constants_products_sense__["c" /* SMOKE_CO */],true),_sensors)};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('rangeStep', __webpack_require__(660));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_SCHEDULE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ATTEMPT_SAVE_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CANCEL_SAVE_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMPLETE_SAVE_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COPY_DAY_EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DESELECT_SCHEDULE_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HIDE_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return OVERRIDE_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RESET_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SELECT_DAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SELECT_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SETUP_ACTION_FORM_SCHEDULE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SHOW_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UNDO_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPDATE_EVENT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_EVENT_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPDATE_DAILY_START_TIMES; });
var ADD_EVENT='hive/schedules2/ADD_EVENT';var ADD_SCHEDULE_DATA='hive/schedules2/ADD_SCHEDULE_DATA';var ATTEMPT_SAVE_SCHEDULE='hive/schedules2/ATTEMPT_SAVE_SCHEDULE';var CANCEL_SAVE_SCHEDULE='hive/schedules2/CANCEL_SAVE_SCHEDULE';var CHANGE_MODE='hive/schedules2/CHANGE_MODE';var COMPLETE_SAVE_SCHEDULE='hive/schedules2/COMPLETE_SAVE_SCHEDULE';var COPY_DAY_EVENTS='hive/schedules2/COPY_DAY_EVENTS';var DELETE_EVENT='hive/schedules2/DELETE_EVENT';var DESELECT_SCHEDULE_DAY='hive/schedules2/DESELECT_SCHEDULE_DAY';var HIDE_POPUP='hive/schedules2/HIDE_POPUP';var OVERRIDE_SCHEDULE='hive/schedules2/OVERRIDE_SCHEDULE';var RESET_SCHEDULE='hive/schedules2/RESET_SCHEDULE';var SELECT_DAY='hive/schedules2/SELECT_DAY';var SELECT_EVENT='hive/schedules2/SELECT_EVENT';var SETUP_ACTION_FORM_SCHEDULE='hive/schedules2/SETUP_ACTION_FORM_SCHEDULE';var SHOW_POPUP='hive/schedules2/SHOW_POPUP';var UNDO_ALL='hive/schedules2/UNDO_ALL';var UPDATE_EVENT_START='hive/schedules2/UPDATE_EVENT_START';var UPDATE_EVENT_VALUE='hive/schedules2/UPDATE_EVENT_VALUE';var UPDATE_DAILY_START_TIMES='hive/schedules2/UPDATE_DAILY_START_TIMES';

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVED_SERVER_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FORM_INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_CONTACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVED_CONTACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_CONTACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVED_CONTACTS; });
var RECEIVED_SERVER_ERRORS='RECEIVED_SERVER_ERRORS';var FORM_INITIALIZE='redux-form/INITIALIZE';var GET_CONTACTS='hive/text-control/GET_CONTACTS';var RECEIVED_CONTACTS='hive/text-control/RECEIVED_CONTACTS';var SAVE_CONTACTS='hive/text-control/SAVE_CONTACTS';var SAVED_CONTACTS='hive/text-control/SAVED_CONTACTS';

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NUMBER_OF_ATTEMPTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTEMPT_LOAD_TRANSLATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_TRANSLATIONS; });
var NUMBER_OF_ATTEMPTS=5;var DEFAULT_LOCALE='en-GB';var ATTEMPT_LOAD_TRANSLATIONS='hive/translations/ATTEMPT_LOAD_TRANSLATIONS';var LOAD_TRANSLATIONS='hive/translations/LOAD_TRANSLATIONS';

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANALYTICS_SHARING_TOGGLED; });
/* unused harmony export DEFAULT_LOCALE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PIN_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_PIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SETTING_PIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_PIN_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TOGGLE_ANALYTICS_SHARING_ALLOWED; });
var PREFIX='hive/user/';var ANALYTICS_SHARING_TOGGLED=PREFIX+'ANALYTICS_SHARING_TOGGLED';var DEFAULT_LOCALE='en-GB';var PIN_SET='PIN_SET';var SET_PIN='SET_PIN';var SETTING_PIN='SETTING_PIN';var RESET_PIN_ERROR='RESET_PIN_ERROR';var TOGGLE_ANALYTICS_SHARING_ALLOWED=PREFIX+'TOGGLE_ANALYTICS_SHARING_ALLOWED';

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_SERVICE_OUTAGE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVE_SERVICE_OUTAGE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_ALERT_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDE_ALERT_NOTIFICATION; });
var CHECK_SERVICE_OUTAGE_STATUS='hive/service_outage/CHECK_SERVICE_OUTAGE_STATUS';var RECEIVE_SERVICE_OUTAGE_STATUS='hive/service_outage/RECEIVE_SERVICE_OUTAGE_STATUS';var SHOW_ALERT_NOTIFICATION='hive/service_outage/SHOW_SERVICE_OUTAGE';var HIDE_ALERT_NOTIFICATION='hive/service_outage/HIDE_SERVICE_OUTAGE';

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(74);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
// @noflow
var toLeft=function toLeft(left){return[left,null];};var toRight=function toRight(right){return[null,right];};function toResult(fn){var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(wrapFunctionWithToResult);function wrapFunctionWithToResult(){var out,_args=arguments;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function wrapFunctionWithToResult$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return fn.apply(undefined,_args);case 3:out=_context.sent;if(!(out&&out.then)){_context.next=6;break;}return _context.abrupt("return",out.then(toLeft,toRight));case 6:return _context.abrupt("return",toLeft(out));case 9:_context.prev=9;_context.t0=_context["catch"](0);return _context.abrupt("return",toRight(_context.t0));case 12:case"end":return _context.stop();}}},_marked,this,[[0,9]]);}return wrapFunctionWithToResult;}

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({// Category
comfort:{id:'actions.comfort',defaultMessage:'Comfort'},reassurance:{id:'actions.reassurance',defaultMessage:'Reassurance'},efficiency:{id:'actions.efficiency',defaultMessage:'Efficiency'},// Devices
heating:{id:'actions.heating',defaultMessage:'Heating'},light:{id:'actions.light',defaultMessage:'Bulb'},plug:{id:'actions.plug',defaultMessage:'Plug'},motion:{id:'actions.motion',defaultMessage:'Motion'},naThermostat:{id:'actions.na-thermostat',defaultMessage:'Thermostat'},contact:{id:'actions.contact',defaultMessage:'Win/Door'},button:{id:'actions.button',defaultMessage:'Hive Button'},quickAction:{id:'actions.quick-action',defaultMessage:'Quick Action'},quickActionChosen:{id:'actions.quick-action-chosen',defaultMessage:'Quick Action tapped'},quickActionDescription:{id:'actions.quick-action-description',defaultMessage:'Trigger this action from your dashboard'},// attributes
heatingAttribute:{id:'actions.heating-attribute',defaultMessage:'Heating'},hotwaterAttribute:{id:'actions.hotwater-attribute',defaultMessage:'Hot Water'},bulbAttribute:{id:'actions.bulb-attribute',defaultMessage:'Active Light'},plugAttribute:{id:'actions.plug-attribute',defaultMessage:'Active Plug'},motionAttribute:{id:'actions.motion-attribute',defaultMessage:'Motion Sensor'},winDoorAttribute:{id:'actions.win-door-attribute',defaultMessage:'Window/Door Sensor'},notificationsAttribute:{id:'actions.notifications-attribute',defaultMessage:'Notifications'},notifyMe:{id:'actions.notify-me',defaultMessage:'Notify me'},notifyPush:{id:'actions.notify-push',defaultMessage:'Push'},notifyEmail:{id:'actions.notify-email',defaultMessage:'Email'},notifyText:{id:'actions.notify-text',defaultMessage:'Text'},scheduleAttribute:{id:'actions.schedule-attribute',defaultMessage:'Schedule'},betweenTheseTimes:{id:'actions.between-these-times',defaultMessage:'Between these times'},darkAttribute:{id:'actions.dark-attribute',defaultMessage:'Dark Outside'},humidityAttribute:{id:'actions.humidity-attribute',defaultMessage:'Humidity'},naThermostatAttribute:{id:'actions.na-thermostat-attribute',defaultMessage:'Thermostat'},quickActionAttribute:{id:'actions.quick-action-attribute',defaultMessage:'Quick Action'},senseAttribute:{id:'actions.sense-attribute',defaultMessage:'Sense'},sunriseSunsetAttribute:{id:'actions.sunrise-sunset-attribute',defaultMessage:'Sunrise Sunset'},temperatureAttribute:{id:'actions.temperature-attribute',defaultMessage:'Temperature'},cameraAttribute:{id:'actions.camera-attribute',defaultMessage:'View'},// select labels
forDuration:{id:'actions.for-duration',defaultMessage:'For duration'},chooseSensor:{id:'actions.choose-sensor',defaultMessage:'Choose Sensor'},whenSensor:{id:'actions.when-sensor',defaultMessage:'When the sensor'},chooseZone:{id:'actions.choose-zone',defaultMessage:'Choose Zone'},whenTemperature:{id:'actions.when-temperature',defaultMessage:'When temperature'},whenHumidity:{id:'actions.when-humidity',defaultMessage:'When humidity'},whenSunriseSunset:{id:'actions.when-sunrise-sunset',defaultMessage:'When'},sunrisePreference:{id:'actions.sunrise-preference',defaultMessage:'Sunrise preference'},sunsetPreference:{id:'actions.sunset-preference',defaultMessage:'Sunset preference'},choosePlug:{id:'actions.choose-plug',defaultMessage:'Choose plug'},setTo:{id:'actions.set-to',defaultMessage:'Set to'},setTargetTo:{id:'actions.set-target-to',defaultMessage:'Set target to'},quickCool:{id:'actions.quick-cool',defaultMessage:'Quick Cool'},quickHeat:{id:'actions.quick-heat',defaultMessage:'Quick Heat'},chooseView:{id:'actions.choose-view',defaultMessage:'Choose View'},turnView:{id:'actions.turn-view',defaultMessage:'Turn View monitoring'},cameraOn:{id:'actions.camera-on',defaultMessage:'On'},cameraOff:{id:'actions.camera-off',defaultMessage:'Off'},// select values label
durationStayOn:{id:'actions.duration-stay-on',defaultMessage:'Stay on'},durationStayOff:{id:'actions.duration-stay-off',defaultMessage:'Stay off'},duration30Seconds:{id:'actions.duration-30-seconds',defaultMessage:'30 seconds'},duration1Minute:{id:'actions.duration-1-minute',defaultMessage:'1 minute'},duration3Minutes:{id:'actions.duration-3-minutes',defaultMessage:'3 minutes'},duration5Minutes:{id:'actions.duration-5-minutes',defaultMessage:'5 minutes'},duration10Minutes:{id:'actions.duration-10-minutes',defaultMessage:'10 minutes'},duration15Minutes:{id:'actions.duration-15-minutes',defaultMessage:'15 minutes'},duration30Minutes:{id:'actions.duration-30-minutes',defaultMessage:'30 minutes'},duration1Hour:{id:'actions.duration-1-hour',defaultMessage:'1 hour'},duration2Hours:{id:'actions.duration-2-hours',defaultMessage:'2 hours'},duration3Hours:{id:'actions.duration-3-hours',defaultMessage:'3 hours'},duration4Hours:{id:'actions.duration-4-hours',defaultMessage:'4 hours'},duration5Hours:{id:'actions.duration-5-hours',defaultMessage:'5 hours'},duration6Hours:{id:'actions.duration-6-hours',defaultMessage:'6 hours'},constactSensorOpens:{id:'actions.constact-sensor-opens',defaultMessage:'Opens'},constactSensorCloses:{id:'actions.constact-sensor-closes',defaultMessage:'Closes'},temperatureBelow:{id:'actions.temperature-below',defaultMessage:'Falls below'},temperatureAbove:{id:'actions.temperature-above',defaultMessage:'Rises above'},sunrise:{id:'actions.sunrise',defaultMessage:'Sunrise'},sunset:{id:'actions.sunset',defaultMessage:'Sunset'},atSunrise:{id:'actions.at-sunrise',defaultMessage:'At sunrise'},atSunset:{id:'actions.at-sunset',defaultMessage:'At sunset'},offset1HourBefore:{id:'actions.offset-1-hour-before',defaultMessage:'1 hour before'},offset50MinutesBefore:{id:'actions.offset-50-minutes-before',defaultMessage:'50 minutes before'},offset40MinutesBefore:{id:'actions.offset-40-minutes-before',defaultMessage:'40 minutes before'},offset30MinutesBefore:{id:'actions.offset-30-minutes-before',defaultMessage:'30 minutes before'},offset20MinutesBefore:{id:'actions.offset-20-minutes-before',defaultMessage:'20 minutes before'},offset10MinutesBefore:{id:'actions.offset-10-minutes-before',defaultMessage:'10 minutes before'},offset10MinutesAfter:{id:'actions.offset-10-minutes-after',defaultMessage:'10 minutes after'},offset20MinutesAfter:{id:'actions.offset-20-minutes-after',defaultMessage:'20 minutes after'},offset30MinutesAfter:{id:'actions.offset-30-minutes-after',defaultMessage:'30 minutes after'},offset40MinutesAfter:{id:'actions.offset-40-minutes-after',defaultMessage:'40 minutes after'},offset50MinutesAfter:{id:'actions.offset-50-minutes-after',defaultMessage:'50 minutes after'},offset1HourAfter:{id:'actions.offset-1-hour-after',defaultMessage:'1 hour after'},choosePeriod:{id:'actions.choose-period',defaultMessage:'Choose period'},darkOutside:{id:'actions.dark-outside',defaultMessage:'Dark Outside'},lightOutside:{id:'actions.light-outside',defaultMessage:'Light Outside'},from:{id:'actions.from',defaultMessage:'From'},until:{id:'actions.until',defaultMessage:'Until'},offset1HourBeforeSunset:{id:'actions.offset-1-hour-before-sunset',defaultMessage:'1 hour before sunset'},offset1HourAfterSunset:{id:'actions.offset-1-hourAfterSunset',defaultMessage:'1 hour after sunset'},offsetMinutesBeforeSunset:{id:'actions.offset-minutes-before-sunset',defaultMessage:'{numMinutes} {numMinutes, plural, one {minute} other {minutes}} before sunset'},offsetMinutesAfterSunset:{id:'actions.offset-minutes-after-sunset',defaultMessage:'{numMinutes} {numMinutes, plural, one {minute} other {minutes}} after sunset'},offset1HourBeforeSunrise:{id:'actions.offset-1-hour-before-sunrise',defaultMessage:'1 hour before sunrise'},offset1HourAfterSunrise:{id:'actions.offset-1-hour-after-sunrise',defaultMessage:'1 hour after sunrise'},offsetMinutesBeforeSunrise:{id:'actions.offset-minutes-before-sunrise',defaultMessage:'{numMinutes} {numMinutes, plural, one {minute} other {minutes}} before sunrise'},offsetMinutesAfterSunrise:{id:'actions.offset-minutes-after-sunrise',defaultMessage:'{numMinutes} {numMinutes, plural, one {minute} other {minutes}} after sunrise'},turnPlug:{id:'actions.turn-plug',defaultMessage:'Turn plug'},plugOn:{id:'actions.plug-on',defaultMessage:'On'},plugOff:{id:'actions.plug-off',defaultMessage:'Off'},turnLight:{id:'actions.turn-light',defaultMessage:'Turn light'},lightOn:{id:'actions.light-on',defaultMessage:'On'},lightOff:{id:'actions.light-off',defaultMessage:'Off'},atBrightness:{id:'actions.at-brightness',defaultMessage:'At brightness'},lastUsedBrightness:{id:'actions.last-used-brightness',defaultMessage:'Last used brightness'},heatingSchedule:{id:'actions.heating-schedule',defaultMessage:'Schedule'},heatingManual:{id:'actions.heating-manual',defaultMessage:'Manual'},heatingOff:{id:'actions.heating-off',defaultMessage:'Off'},heatingBoost:{id:'actions.heating-boost',defaultMessage:'Boost'},hotWaterManual:{id:'actions.hot-water-manual',defaultMessage:'On'}}));

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateTimeInterval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pollApiStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pollApiStart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(139);
var dateTimeInterval=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DATE_TIME_INTERVAL */]);var pollApiStop=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* POLL_API_STOP */]);var pollApiStart=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* POLL_API_START */]);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getWeather; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receivedWeather; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var getWeather=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* GET_WEATHER */]);var receivedWeather=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* RECEIVED_WEATHER */]);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(23);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setupHeaders; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getSenseMedia;
/* harmony export (immutable) */ __webpack_exports__["b"] = flagSenseMedia;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteSenseMedia;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_application_selectors__ = __webpack_require__(176);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getSenseMedia),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(flagSenseMedia),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteSenseMedia);var setupHeaders=function setupHeaders(token){var headers={'Content-Type':'application/json','X-AlertMe-Client':'Honeycomb Webapp',Accept:'application/vnd.alertme.zoo-6.5+json'};if(token.length>64){headers['Authorization']='Bearer '+token;}else{headers['X-Omnia-Access-Token']=token;}return headers;};function getSenseMedia(id){var endpoint,token,headers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSenseMedia$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_application_selectors__["e" /* getHoneycombEndpoint */]);case 2:endpoint=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_application_selectors__["p" /* getToken */]);case 5:token=_context.sent;headers=setupHeaders(token);_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetch,endpoint+'/omnia/media/'+id,{headers:headers});case 9:return _context.abrupt('return',_context.sent);case 10:case'end':return _context.stop();}}},_marked,this);}function flagSenseMedia(id,flag){var endpoint,token,headers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function flagSenseMedia$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_application_selectors__["e" /* getHoneycombEndpoint */]);case 2:endpoint=_context2.sent;_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_application_selectors__["p" /* getToken */]);case 5:token=_context2.sent;headers=setupHeaders(token);_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetch,endpoint+'/omnia/media/'+id,{method:'PUT',headers:headers,body:JSON.stringify({media:[{flagged:true}]})});case 9:return _context2.abrupt('return',_context2.sent);case 10:case'end':return _context2.stop();}}},_marked2,this);}function deleteSenseMedia(id){var endpoint,token,headers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteSenseMedia$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_application_selectors__["e" /* getHoneycombEndpoint */]);case 2:endpoint=_context3.sent;_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_2__state_application_selectors__["p" /* getToken */]);case 5:token=_context3.sent;headers=setupHeaders(token);_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(fetch,endpoint+'/omnia/media/'+id,{method:'DELETE',headers:headers});case 9:return _context3.abrupt('return',_context3.sent);case 10:case'end':return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reduxDevtoolsInstrument = __webpack_require__(714);

Object.defineProperty(exports, 'instrument', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reduxDevtoolsInstrument).default;
  }
});
Object.defineProperty(exports, 'ActionCreators', {
  enumerable: true,
  get: function get() {
    return _reduxDevtoolsInstrument.ActionCreators;
  }
});
Object.defineProperty(exports, 'ActionTypes', {
  enumerable: true,
  get: function get() {
    return _reduxDevtoolsInstrument.ActionTypes;
  }
});

var _persistState = __webpack_require__(1836);

Object.defineProperty(exports, 'persistState', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_persistState).default;
  }
});

var _createDevTools = __webpack_require__(1838);

Object.defineProperty(exports, 'createDevTools', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createDevTools).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(461);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(721);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1909);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(1897)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(722)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(206);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(205)
  , dPs         = __webpack_require__(1900)
  , enumBugKeys = __webpack_require__(471)
  , IE_PROTO    = __webpack_require__(469)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(725)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1904).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 468 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(470)('keys')
  , uid    = __webpack_require__(321);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(140)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(204).f
  , has = __webpack_require__(171)
  , TAG = __webpack_require__(114)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(464);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1906);
var global        = __webpack_require__(140)
  , hide          = __webpack_require__(203)
  , Iterators     = __webpack_require__(244)
  , TO_STRING_TAG = __webpack_require__(114)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(114);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(140)
  , core           = __webpack_require__(66)
  , LIBRARY        = __webpack_require__(465)
  , wksExt         = __webpack_require__(475)
  , defineProperty = __webpack_require__(204).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 477 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1919);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1923);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(461);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _keys = __webpack_require__(323);

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = __webpack_require__(459);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(460);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(478);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONArrow = __webpack_require__(735);

var _JSONArrow2 = _interopRequireDefault(_JSONArrow);

var _getCollectionEntries = __webpack_require__(1936);

var _getCollectionEntries2 = _interopRequireDefault(_getCollectionEntries);

var _JSONNode = __webpack_require__(733);

var _JSONNode2 = _interopRequireDefault(_JSONNode);

var _ItemRange = __webpack_require__(1940);

var _ItemRange2 = _interopRequireDefault(_ItemRange);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Renders nested values (eg. objects, arrays, lists, etc.)
 */

function renderChildNodes(props, from, to) {
  var nodeType = props.nodeType,
      data = props.data,
      collectionLimit = props.collectionLimit,
      circularCache = props.circularCache,
      keyPath = props.keyPath,
      postprocessValue = props.postprocessValue,
      sortObjectKeys = props.sortObjectKeys;

  var childNodes = [];

  (0, _getCollectionEntries2['default'])(nodeType, data, sortObjectKeys, collectionLimit, from, to).forEach(function (entry) {
    if (entry.to) {
      childNodes.push(_react2['default'].createElement(_ItemRange2['default'], (0, _extends3['default'])({}, props, {
        key: 'ItemRange--' + entry.from + '-' + entry.to,
        from: entry.from,
        to: entry.to,
        renderChildNodes: renderChildNodes
      })));
    } else {
      var key = entry.key,
          value = entry.value;

      var isCircular = circularCache.indexOf(value) !== -1;

      var node = _react2['default'].createElement(_JSONNode2['default'], (0, _extends3['default'])({}, props, { postprocessValue: postprocessValue, collectionLimit: collectionLimit }, {
        key: 'Node--' + key,
        keyPath: [key].concat(keyPath),
        value: postprocessValue(value),
        circularCache: [].concat(circularCache, [value]),
        isCircular: isCircular,
        hideRoot: false
      }));

      if (node !== false) {
        childNodes.push(node);
      }
    }
  });

  return childNodes;
}

function getStateFromProps(props) {
  // calculate individual node expansion if necessary
  var expanded = props.shouldExpandNode && !props.isCircular ? props.shouldExpandNode(props.keyPath, props.data, props.level) : false;
  return {
    expanded: expanded
  };
}

var JSONNestedNode = function (_React$Component) {
  (0, _inherits3['default'])(JSONNestedNode, _React$Component);

  function JSONNestedNode(props) {
    (0, _classCallCheck3['default'])(this, JSONNestedNode);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.handleClick = function () {
      if (_this.props.expandable) {
        _this.setState({ expanded: !_this.state.expanded });
      }
    };

    _this.state = getStateFromProps(props);
    return _this;
  }

  JSONNestedNode.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextState = getStateFromProps(nextProps);
    if (getStateFromProps(this.props).expanded !== nextState.expanded) {
      this.setState(nextState);
    }
  };

  JSONNestedNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var _this2 = this;

    return !!(0, _keys2['default'])(nextProps).find(function (key) {
      return key !== 'circularCache' && (key === 'keyPath' ? nextProps[key].join('/') !== _this2.props[key].join('/') : nextProps[key] !== _this2.props[key]);
    }) || nextState.expanded !== this.state.expanded;
  };

  JSONNestedNode.prototype.render = function render() {
    var _props = this.props,
        getItemString = _props.getItemString,
        nodeTypeIndicator = _props.nodeTypeIndicator,
        nodeType = _props.nodeType,
        data = _props.data,
        hideRoot = _props.hideRoot,
        createItemString = _props.createItemString,
        styling = _props.styling,
        collectionLimit = _props.collectionLimit,
        keyPath = _props.keyPath,
        labelRenderer = _props.labelRenderer,
        expandable = _props.expandable;
    var expanded = this.state.expanded;

    var renderedChildren = expanded || hideRoot && this.props.level === 0 ? renderChildNodes((0, _extends3['default'])({}, this.props, { level: this.props.level + 1 })) : null;

    var itemType = _react2['default'].createElement(
      'span',
      styling('nestedNodeItemType', expanded),
      nodeTypeIndicator
    );
    var renderedItemString = getItemString(nodeType, data, itemType, createItemString(data, collectionLimit));
    var stylingArgs = [keyPath, nodeType, expanded, expandable];

    return hideRoot ? _react2['default'].createElement(
      'li',
      styling.apply(undefined, ['rootNode'].concat(stylingArgs)),
      _react2['default'].createElement(
        'ul',
        styling.apply(undefined, ['rootNodeChildren'].concat(stylingArgs)),
        renderedChildren
      )
    ) : _react2['default'].createElement(
      'li',
      styling.apply(undefined, ['nestedNode'].concat(stylingArgs)),
      expandable && _react2['default'].createElement(_JSONArrow2['default'], {
        styling: styling,
        nodeType: nodeType,
        expanded: expanded,
        onClick: this.handleClick
      }),
      _react2['default'].createElement(
        'label',
        (0, _extends3['default'])({}, styling.apply(undefined, [['label', 'nestedNodeLabel']].concat(stylingArgs)), {
          onClick: this.handleClick
        }),
        labelRenderer.apply(undefined, stylingArgs)
      ),
      _react2['default'].createElement(
        'span',
        (0, _extends3['default'])({}, styling.apply(undefined, ['nestedNodeItemString'].concat(stylingArgs)), {
          onClick: this.handleClick
        }),
        renderedItemString
      ),
      _react2['default'].createElement(
        'ul',
        styling.apply(undefined, ['nestedNodeChildren'].concat(stylingArgs)),
        renderedChildren
      )
    );
  };

  return JSONNestedNode;
}(_react2['default'].Component);

JSONNestedNode.propTypes = {
  getItemString: _propTypes2['default'].func.isRequired,
  nodeTypeIndicator: _propTypes2['default'].any,
  nodeType: _propTypes2['default'].string.isRequired,
  data: _propTypes2['default'].any,
  hideRoot: _propTypes2['default'].bool.isRequired,
  createItemString: _propTypes2['default'].func.isRequired,
  styling: _propTypes2['default'].func.isRequired,
  collectionLimit: _propTypes2['default'].number,
  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
  labelRenderer: _propTypes2['default'].func.isRequired,
  shouldExpandNode: _propTypes2['default'].func,
  level: _propTypes2['default'].number.isRequired,
  sortObjectKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].bool]),
  isCircular: _propTypes2['default'].bool,
  expandable: _propTypes2['default'].bool
};
JSONNestedNode.defaultProps = {
  data: [],
  circularCache: [],
  level: 0,
  expandable: true
};
exports['default'] = JSONNestedNode;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1937), __esModule: true };

/***/ }),
/* 481 */
/***/ (function(module, exports) {

function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

module.exports = clamp;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);

module.exports = irreducible('Any', function () { return true; });


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var isFunction = __webpack_require__(58);
var forbidNewOperator = __webpack_require__(246);
var isIdentity = __webpack_require__(117);
var create = __webpack_require__(118);
var is = __webpack_require__(119);
var getTypeName = __webpack_require__(53);
var getFunctionName = __webpack_require__(245);

function getDefaultName(type, predicate) {
  return '{' + getTypeName(type) + ' | ' + getFunctionName(predicate) + '}';
}

function refinement(type, predicate, name) {

  if (false) {
    assert(isFunction(type), function () { return 'Invalid argument type ' + assert.stringify(type) + ' supplied to refinement(type, predicate, [name]) combinator (expected a type)'; });
    assert(isFunction(predicate), function () { return 'Invalid argument predicate supplied to refinement(type, predicate, [name]) combinator (expected a function)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to refinement(type, predicate, [name]) combinator (expected a string)'; });
  }

  var displayName = name || getDefaultName(type, predicate);
  var identity = isIdentity(type);

  function Refinement(value, path) {

    if (false) {
      if (identity) {
        forbidNewOperator(this, Refinement);
      }
      path = path || [displayName];
    }

    var x = create(type, value, path);

    if (false) {
      assert(predicate(x), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
    }

    return x;
  }

  Refinement.meta = {
    kind: 'subtype',
    type: type,
    predicate: predicate,
    name: name,
    identity: identity
  };

  Refinement.displayName = displayName;

  Refinement.is = function (x) {
    return is(x, type) && predicate(x);
  };

  Refinement.update = function (instance, patch) {
    return Refinement(assert.update(instance, patch));
  };

  return Refinement;
}

refinement.getDefaultName = getDefaultName;
module.exports = refinement;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);
var isString = __webpack_require__(326);

module.exports = irreducible('String', isString);


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var isFunction = __webpack_require__(58);
var getTypeName = __webpack_require__(53);
var isIdentity = __webpack_require__(117);
var isObject = __webpack_require__(115);
var create = __webpack_require__(118);
var is = __webpack_require__(119);

function getDefaultName(domain, codomain) {
  return '{[key: ' + getTypeName(domain) + ']: ' + getTypeName(codomain) + '}';
}

function dict(domain, codomain, name) {

  if (false) {
    assert(isFunction(domain), function () { return 'Invalid argument domain ' + assert.stringify(domain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
    assert(isFunction(codomain), function () { return 'Invalid argument codomain ' + assert.stringify(codomain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to dict(domain, codomain, [name]) combinator (expected a string)'; });
  }

  var displayName = name || getDefaultName(domain, codomain);
  var domainNameCache = getTypeName(domain);
  var codomainNameCache = getTypeName(codomain);
  var identity = isIdentity(domain) && isIdentity(codomain);

  function Dict(value, path) {

    if (true) {
      if (identity) {
        return value; // just trust the input if elements must not be hydrated
      }
    }

    if (false) {
      path = path || [displayName];
      assert(isObject(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
    }

    var idempotent = true; // will remain true if I can reutilise the input
    var ret = {}; // make a temporary copy, will be discarded if idempotent remains true
    for (var k in value) {
      if (value.hasOwnProperty(k)) {
        k = create(domain, k, (  false ? path.concat(domainNameCache) : null ));
        var actual = value[k];
        var instance = create(codomain, actual, (  false ? path.concat(k + ': ' + codomainNameCache) : null ));
        idempotent = idempotent && ( actual === instance );
        ret[k] = instance;
      }
    }

    if (idempotent) { // implements idempotency
      ret = value;
    }

    if (false) {
      Object.freeze(ret);
    }

    return ret;
  }

  Dict.meta = {
    kind: 'dict',
    domain: domain,
    codomain: codomain,
    name: name,
    identity: identity
  };

  Dict.displayName = displayName;

  Dict.is = function (x) {
    if (!isObject(x)) {
      return false;
    }
    for (var k in x) {
      if (x.hasOwnProperty(k)) {
        if (!is(k, domain) || !is(x[k], codomain)) {
          return false;
        }
      }
    }
    return true;
  };

  Dict.update = function (instance, patch) {
    return Dict(assert.update(instance, patch));
  };

  return Dict;
}

dict.getDefaultName = getDefaultName;
module.exports = dict;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var isNil = __webpack_require__(98);
var assert = __webpack_require__(36);

// safe mixin, cannot override props unless specified
module.exports = function mixin(target, source, overwrite) {
  if (isNil(source)) { return target; }
  for (var k in source) {
    if (source.hasOwnProperty(k)) {
      if (overwrite !== true) {
        if (false) {
          assert(!target.hasOwnProperty(k) || target[k] === source[k], function () { return 'Invalid call to mixin(target, source, [overwrite]): cannot overwrite property "' + k + '" of target object'; });
        }
      }
      target[k] = source[k];
    }
  }
  return target;
};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(2051),
    baseEach = __webpack_require__(763),
    createForEach = __webpack_require__(2058);

/**
 * Iterates over elements of `collection` invoking `iteratee` for each element.
 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
 * (value, index|key, collection). Iteratee functions may exit iteration early
 * by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length" property
 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
 * may be used for object iteration.
 *
 * @static
 * @memberOf _
 * @alias each
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array|Object|string} Returns `collection`.
 * @example
 *
 * _([1, 2]).forEach(function(n) {
 *   console.log(n);
 * }).value();
 * // => logs each value from left to right and returns the array
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
 *   console.log(n, key);
 * });
 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
 */
var forEach = createForEach(arrayEach, baseEach);

module.exports = forEach;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(247),
    isObjectLike = __webpack_require__(211);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Native method references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is classified as an `arguments` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  return isObjectLike(value) && isArrayLike(value) &&
    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
}

module.exports = isArguments;


/***/ }),
/* 489 */
/***/ (function(module, exports) {

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var isArguments = __webpack_require__(488),
    isArray = __webpack_require__(121),
    isIndex = __webpack_require__(489),
    isLength = __webpack_require__(212),
    isObject = __webpack_require__(99);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keysIn;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2059),
    isObject = __webpack_require__(99),
    isObjectLike = __webpack_require__(211);

/**
 * The base implementation of `_.isEqual` without support for `this` binding
 * `customizer` functions.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
}

module.exports = baseIsEqual;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Shim to avoid requiring Velocity in Node environments, since it
// requires window. Note that this just no-ops the components so
// that they'll render, rather than doing something clever like
// statically rendering the end state of any provided animations.
//
// TODO(finneganh): Circle back on jsdom to see if we can run full
// Velocity with it in place. This come up in:
// https://github.com/twitter-fabric/velocity-react/issues/119
// but there may have been different loading issues in that case,
// not a global incompatibility with jsdom.
if (typeof window === 'undefined' || typeof navigator === 'undefined' || navigator.userAgent.indexOf("Node.js") !== -1 || navigator.userAgent.indexOf("jsdom") !== -1) {

  var Velocity = function Velocity() {};
  Velocity.Utilities = {};
  Velocity.Utilities.removeData = function () {};
  Velocity.velocityReactServerShim = true;
  module.exports = Velocity;
} else {
  // this is how velocity-ui finds the Velocity instance, so lets make sure we find the right instance
  var g = window.jQuery || window.Zepto || window;

  // require Velocity if it doesn't already exist
  module.exports = g.Velocity ? g.Velocity : __webpack_require__(618);
}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(2119);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(2120);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(250);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(141);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(2127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict;

  var _compilePath = compilePath(path, { end: exact, strict: strict }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__ = __webpack_require__(20);
var minValueToShowNumber=2;/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var when=_ref.when,_while=_ref._while,then=_ref.then,_ref$disabled=_ref.disabled,disabled=_ref$disabled===undefined?false:_ref$disabled;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Main */],{number:1+(_while?1:0)+(then?1:0)},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Line */],{disabled:disabled}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* IconContainer */],{disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Icon */],{type:when})),_while&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* IconContainer */],{disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Icon */],{type:_while})),then&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* IconContainer */],{disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Icon */],{type:then.type===__WEBPACK_IMPORTED_MODULE_2__core_constants_actions__["b" /* actionTypes */].MIXED?__WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__["a" /* default */].MORE_VERTICAL:then.type}),then.count&&then.count>=minValueToShowNumber&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* NumberContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* Number */],null,then.count))));});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var BounceEffect=function(_Component){_inherits(BounceEffect,_Component);function BounceEffect(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BounceEffect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BounceEffect.__proto__||Object.getPrototypeOf(BounceEffect)).call.apply(_ref,[this].concat(args))),_this),_this.state={finishBounce:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BounceEffect,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setState({finishBounce:this.props.isWaiting&&!nextProps.isWaiting});}},{key:'render',value:function render(){var _props=this.props,children=_props.children,isWaiting=_props.isWaiting,usePadding=_props.usePadding;var finishBounce=this.state.finishBounce;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Bounce */],{bounce:isWaiting,finishBounce:finishBounce,usePadding:usePadding},children);}}]);return BounceEffect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);BounceEffect.defaultProps={isWaiting:false};BounceEffect.propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,isWaiting:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (BounceEffect);

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var difference = __webpack_require__(2208);
var trunc = __webpack_require__(2209);

var constants = {
  MS_IN_DAY: 1000 * 60 * 60 * 24,
  MS_IN_HOUR: 1000 * 60 * 60,
  MS_IN_MINUTE: 1000 * 60,
  MS_IN_SECOND: 1000,
  WEEKEND_DAYS: [6, 0],
  WORK_DAYS: [1, 2, 3, 4, 5],
  ALL_DAYS: [0, 1, 2, 3, 4, 5, 6],
}

var instadate = {

  utc: utc,

  noon: function (d) {
    var date;
    if (d) {
      date = new Date(d);
    } else {
      date = new Date();
    }
    date.setHours(12, 0, 0, 0);
    return date;
  },

  /* Difference between dates */

  differenceInDates: function (d1, d2) {
    return trunc((utcDate(d2) - utcDate(d1)) / constants.MS_IN_DAY);
  },

  differenceInDays: function (d1, d2) {
    return trunc((utc(d2) - utc(d1)) / constants.MS_IN_DAY);
  },

  differenceInHours: function (d1, d2) {
    return trunc((utc(d2) - utc(d1)) / constants.MS_IN_HOUR);
  },

  differenceInMinutes: function (d1, d2) {
    return trunc((utc(d2) - utc(d1)) / constants.MS_IN_MINUTE);
  },

  differenceInSeconds: function (d1, d2) {
    return trunc((utc(d2) - utc(d1)) / constants.MS_IN_SECOND);
  },

  differenceInWeekendDays: function (d1, d2) {
    var period = instadate.differenceInDays(d1, d2);
    return instadate.weekendDaysInPeriod(d1.getDay(), period)
  },

  differenceInWorkDays: function (d1, d2) {
    var period = instadate.differenceInDays(d1, d2);
    return instadate.workDaysInPeriod(d1.getDay(), period)
  },

  /* Adding time to dates */

  addYears: function (d, years) {
    var date = new Date(d);
    date.setFullYear(date.getFullYear() + years);
    return date;
  },

  addMonths: function (d, months) {
    var date = new Date(d);
    date.setMonth(date.getMonth() + months);
    return date;
  },

  addDays: function (d, days) {
    return instadate.addMilliseconds(d, days * constants.MS_IN_DAY);
  },

  addHours: function(d, hours) {
    return instadate.addMilliseconds(d, hours * constants.MS_IN_HOUR);
  },

  addMinutes: function(d, minutes) {
    return instadate.addMilliseconds(d, minutes * constants.MS_IN_MINUTE);
  },

  addSeconds: function (d, seconds) {
    return instadate.addMilliseconds(d, seconds * constants.MS_IN_SECOND);
  },

  addMilliseconds: function (d, ms) {
    return new Date(d.getTime() + ms);
  },

  /* Comparison */

  isSameYear: function (a, b) {
    return a && b && a.getFullYear() === b.getFullYear();
  },

  isSameMonth: function (a, b) {
    return instadate.isSameYear(a, b) && a.getMonth() === b.getMonth();
  },

  isSameDay: function (a, b) {
    return instadate.isSameMonth(a, b) && a.getDate() === b.getDate();
  },

  equal: function (d1, d2) {
    return d1 && d2 && !(d1 - d2);
  },

  min: function (d1, d2) {
    return d1 < d2 ? d1 : d2;
  },

  max: function (d1, d2) {
    return d1 > d2 ? d1 : d2;
  },

  /* Other */

  dates: function(start, end) {
    if (start > end) {
      var temp = end;
      end = start;
      start = temp;
    }
    var result = []
      , diff = instadate.differenceInDates(start, end);
    for (var i = 0; i <= diff; i++) {
      result.push(instadate.addDays(start, i));
    }
    return result;
  },

  dateString: function (date) {
    return date.toString().slice(0, 15);
  },

  isoDateString: function (date) {
    return date.toISOString().slice(0, 10);
  },

  firstDateInMonth: function (d) {
    var date = new Date(d);
    date.setDate(1);
    return date;
  },

  lastDateInMonth: function (d) {
    var date = new Date(d.getFullYear(), d.getMonth() + 1, 0);
    date.setHours(d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
    return date;
  },

  isWeekendDay: function (day) {
    return constants.WEEKEND_DAYS.indexOf(day) !== -1;
  },

  isWorkDay: function (day) {
    return !instadate.isWeekendDay(day);
  },

  isWeekendDate: function (date) {
    return instadate.isWeekendDay(date.getDay());
  },

  isWorkDate: function (date) {
    return !instadate.isWeekendDate(date);
  },

  setWeekendDays: function (days) {
    if (!(days instanceof Array)) {
      throw new Error('Weekend days needs to be an array');
    }
    constants.WEEKEND_DAYS = days;
    constants.WORK_DAYS = difference([0, 1, 2, 3, 4, 5, 6], days);
  },

  daysInPeriod: function(firstDay, length, days) {
    if (firstDay instanceof Date) {
      firstDay = firstDay.getDay();
    }
    if (!days) {
      days = constants.ALL_DAYS;
    }
    var total = 0
      , direction = length >= 0 ? 1 : -1;

    function check(i) {
      var absShift = Math.abs(firstDay + i);
      var extra = Math.ceil(absShift / 7) * 7;
      var day = (extra + firstDay + i) % 7;
      if (days.indexOf(day) !== -1) {
        total++;
      }
    }

    if (length >= 0) {
      for (var i = 0; i < length; i++) {
        check(i);
      }
    } else {
      for (var i = 0; i > length; i--) {
        check(i);
      }
    }
    return total;
  },

  weekendDaysInPeriod: function (firstDay, length) {
    return instadate.daysInPeriod(firstDay, length, constants.WEEKEND_DAYS);
  },

  workDaysInPeriod: function (firstDay, length) {
    return instadate.daysInPeriod(firstDay, length, constants.WORK_DAYS);
  },

  /* isAfter & isBefore */
  isAfter: function (a, b) {
    return a.getTime() > b.getTime()
  },

  isBefore: function (a, b) {
    return a.getTime() < b.getTime()
  },

  isYearAfter: function (a, b) {
    return a.getFullYear() > b.getFullYear();
  },

  isMonthAfter: function (a, b) {
    return instadate.isYearAfter(a, b) ||
      a.getMonth() > b.getMonth() && instadate.isSameYear(a, b);
  },

  isDayAfter: function (a, b) {
    return instadate.isMonthAfter(a, b) ||
      a.getDate() > b.getDate() && instadate.isSameMonth(a, b);
  },

  isYearBefore: function (a, b) {
    return instadate.isYearAfter(b, a);
  },

  isMonthBefore: function (a, b) {
    return instadate.isMonthAfter(b, a);
  },

  isDayBefore: function (a, b) {
    return instadate.isDayAfter(b, a);
  },

  /* isBetween */

  isYearBetween: function (d, start, end) {
    return isBetween(d, start, end, instadate.isYearBefore, instadate.isYearAfter);
  },

  isMonthBetween: function (d, start, end) {
    return isBetween(d, start, end, instadate.isMonthBefore, instadate.isMonthAfter);
  },

  isDayBetween: function (d, start, end) {
    return isBetween(d, start, end, instadate.isDayBefore, instadate.isDayAfter);
  },

  isoWeekDay: function (d) {
    return d.getDay() || 7;
  },

};

function utc(d) {
  return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(),
    d.getMinutes(), d.getSeconds(), d.getMilliseconds());
}

function utcDate(d) {
  return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
}

function isBetween(d, start, end, beforeFn, afterFn) {
  if (start > end) {
    var temp = end;
    end = start;
    start = temp;
  }
  return beforeFn(start, d) && afterFn(end, d);
};

module.exports = instadate;


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeviceIconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StyledSVGIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ItemContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InputStyled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StatusContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IdentifyButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buttons__ = __webpack_require__(178);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    border-bottom: ',';\n    display: flex;\n    padding: 1rem 0;\n'],['\n    align-items: center;\n    border-bottom: ',';\n    display: flex;\n    padding: 1rem 0;\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    min-height: 4.25rem;\n    min-width: 4.25rem;\n    position: relative;\n'],['\n    align-items: center;\n    background-color: ',';\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    min-height: 4.25rem;\n    min-width: 4.25rem;\n    position: relative;\n']),_templateObject3=_taggedTemplateLiteral(['\n    height: 3em;\n    width: 3em;\n    > g {\n        fill: ',';\n    }\n'],['\n    height: 3em;\n    width: 3em;\n    > g {\n        fill: ',';\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    align-content: flex-start;\n    margin-left: 1rem;\n    width: 100%;\n'],['\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    align-content: flex-start;\n    margin-left: 1rem;\n    width: 100%;\n']),_templateObject5=_taggedTemplateLiteral(['\n    border: ',';\n    color: ',';\n    font-size: 1.2rem;\n    font-weight: 500;\n'],['\n    border: ',';\n    color: ',';\n    font-size: 1.2rem;\n    font-weight: 500;\n']),_templateObject6=_taggedTemplateLiteral(['\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    align-items: center;\n'],['\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    align-items: center;\n']),_templateObject7=_taggedTemplateLiteral(['\n    color: ',';\n    font-size: 1rem;\n'],['\n    color: ',';\n    font-size: 1rem;\n']),_templateObject8=_taggedTemplateLiteral(['\n    margin-left: 1em;\n    height: 1.8em;\n    padding: 0 1.8em;\n'],['\n    margin-left: 1em;\n    height: 1.8em;\n    padding: 0 1.8em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return'1px solid '+theme.lightGrey;});var DeviceIconWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2,function(_ref2){var theme=_ref2.theme;return theme.mainBrandColor;});var StyledSVGIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */])(_templateObject3,function(_ref3){var theme=_ref3.theme;return theme.white;});var ItemContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4);var InputStyled=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0__input__["a" /* default */])(_templateObject5,function(_ref4){var theme=_ref4.theme;return'1px solid '+theme.mediumGrey+' !important';},function(_ref5){var theme=_ref5.theme;return theme.grey;});var StatusContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject6);var Status=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject7,function(_ref6){var theme=_ref6.theme;return theme.linkColor;});var IdentifyButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3__buttons__["b" /* Button */])(_templateObject8);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(2284);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// $FlowFixMe
var Dropdown=function(_React$Component){_inherits(Dropdown,_React$Component);function Dropdown(props){_classCallCheck(this,Dropdown);var _this=_possibleConstructorReturn(this,(Dropdown.__proto__||Object.getPrototypeOf(Dropdown)).call(this,props));_this.state={selectedValue:-1};_this.handleSelect=function(_ref){var target=_ref.target;var handleChange=_this.props.handleChange;var index=parseInt(target.value,10);handleChange(index);_this.setState({selectedValue:index});};var currentValue=props.currentValue;_this.state={selectedValue:currentValue};return _this;}_createClass(Dropdown,[{key:'render',value:function render(){var _props=this.props,formatMessage=_props.intl.formatMessage,options=_props.options,color=_props.color;var selectedValue=this.state.selectedValue;var opts=selectedValue===-1?[formatMessage(__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].pleaseSelect)].concat(_toConsumableArray(options)):options;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Base */],{color:color},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Select */],{onChange:this.handleSelect,value:selectedValue},opts.map(function(caption,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('option',{key:''+index,value:selectedValue===-1?index-1:index},//$FlowFixMe https://github.com/ConnectedHomes/hivehome-webapp-v3/issues/2995
typeof caption==='string'?caption:formatMessage(caption,caption.values));})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* IconContainer */],{color:color},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Icon */],{type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].ARROW_DOWN})));}}]);return Dropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["g" /* injectIntl */])(Dropdown));

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TRANSITION_DURATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TRANSITION_DURATION_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StyledTransitionGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledCSSTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BrightnessFlipperWrapper; });
/* unused harmony export FlipperIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FlipperMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrightnessFlipperContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BrightnessFlipperIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Picker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group_TransitionGroup__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group_TransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_transition_group_TransitionGroup__);
var _templateObject=_taggedTemplateLiteral(['\n    color: ',';\n    font-size: ',';\n    align-items: center;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    justify-content: center;\n    box-shadow: rgb(221, 221, 221) 1px 0px 8px 0px;\n    outline: none;\n'],['\n    color: ',';\n    font-size: ',';\n    align-items: center;\n    border-radius: 50%;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    justify-content: center;\n    box-shadow: rgb(221, 221, 221) 1px 0px 8px 0px;\n    outline: none;\n']),_templateObject2=_taggedTemplateLiteral(['\n    cursor: ',';\n    display: block;\n    height: 100%;\n    position: relative;\n    user-select: none;\n    width: 100%;\n'],['\n    cursor: ',';\n    display: block;\n    height: 100%;\n    position: relative;\n    user-select: none;\n    width: 100%;\n']),_templateObject3=_taggedTemplateLiteral(['\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    border-radius: 50%;\n\n    &.flipper__flip-enter {\n        opacity: 0.01;\n        transform: rotateY(-90deg) scale(0.6, 0.6);\n    }\n\n    &.flipper__flip-enter.flipper__flip-enter-active {\n        opacity: 1;\n        transform: rotateY(0) scale(1, 1);\n        transition: opacity ','ms ','ms,\n            transform ','ms ','ms;\n    }\n\n    &.flipper__flip-exit {\n        left: 0;\n        opacity: 1;\n        position: absolute;\n        top: 0;\n    }\n\n    &.flipper__flip-exit.flipper__flip-exit-active {\n        opacity: 0;\n        transition: opacity ','ms, transform ','ms;\n        transform: rotateY(90deg) scale(0.6, 0.6);\n    }\n'],['\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    border-radius: 50%;\n\n    &.flipper__flip-enter {\n        opacity: 0.01;\n        transform: rotateY(-90deg) scale(0.6, 0.6);\n    }\n\n    &.flipper__flip-enter.flipper__flip-enter-active {\n        opacity: 1;\n        transform: rotateY(0) scale(1, 1);\n        transition: opacity ','ms ','ms,\n            transform ','ms ','ms;\n    }\n\n    &.flipper__flip-exit {\n        left: 0;\n        opacity: 1;\n        position: absolute;\n        top: 0;\n    }\n\n    &.flipper__flip-exit.flipper__flip-exit-active {\n        opacity: 0;\n        transition: opacity ','ms, transform ','ms;\n        transform: rotateY(90deg) scale(0.6, 0.6);\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: relative;\n\n    & > svg {\n        position: relative;\n        transform: rotate(-45deg);\n        width: 100%;\n        height: 100%;\n        pointer-events: none;\n        z-index: 0;\n    }\n\n    & circle {\n        position: relative;\n        cursor: pointer;\n    }\n\n    & circle.hit-area {\n        position: relative;\n    }\n'],['\n    display: block;\n    width: 100%;\n    height: 100%;\n    position: relative;\n\n    & > svg {\n        position: relative;\n        transform: rotate(-45deg);\n        width: 100%;\n        height: 100%;\n        pointer-events: none;\n        z-index: 0;\n    }\n\n    & circle {\n        position: relative;\n        cursor: pointer;\n    }\n\n    & circle.hit-area {\n        position: relative;\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    height: 3em;\n    text-shadow: 1px 0px 8px rgb(221, 221, 221);\n    width: 3em;\n'],['\n    height: 3em;\n    text-shadow: 1px 0px 8px rgb(221, 221, 221);\n    width: 3em;\n']),_templateObject6=_taggedTemplateLiteral(['\n    font-size: 0.7em;\n    text-shadow: 1px 0px 8px rgb(221, 221, 221);\n'],['\n    font-size: 0.7em;\n    text-shadow: 1px 0px 8px rgb(221, 221, 221);\n']),_templateObject7=_taggedTemplateLiteral(['\n    position: absolute;\n    height: 69%;\n    width: 69%;\n    left: 15.5%;\n    top: 15.5%;\n    z-index: 1;\n    border-radius: 50%;\n'],['\n    position: absolute;\n    height: 69%;\n    width: 69%;\n    left: 15.5%;\n    top: 15.5%;\n    z-index: 1;\n    border-radius: 50%;\n']),_templateObject8=_taggedTemplateLiteral(['\n    > g {\n        fill: ',';\n    }\n'],['\n    > g {\n        fill: ',';\n    }\n']),_templateObject9=_taggedTemplateLiteral(['\n    height: 100%;\n    pointer-events: ',';\n'],['\n    height: 100%;\n    pointer-events: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TRANSITION_DURATION=200;var TRANSITION_DURATION_TOTAL=TRANSITION_DURATION*2;/* harmony default export */ __webpack_exports__["i"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.attrs({style:function style(_ref){var isOn=_ref.isOn,isCustomRange=_ref.isCustomRange,rgb=_ref.rgb;return{background:isOn&&!isCustomRange&&rgb?'rgb('+rgb+')':'#FFFFFF'};}})(_templateObject,function(_ref2){var isActive=_ref2.isActive,isVariableColour=_ref2.isVariableColour,theme=_ref2.theme;return isActive?isVariableColour?theme.white:theme.black:theme.mediumGrey;},function(props){return props.isSmall?'1.1em':'1.8em';}));var StyledTransitionGroup=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_transition_group_TransitionGroup___default.a)(_templateObject2,function(_ref3){var isSwitchable=_ref3.isSwitchable;return isSwitchable?'pointer':'default';});var StyledCSSTransition=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition___default.a)(_templateObject3,TRANSITION_DURATION,TRANSITION_DURATION,TRANSITION_DURATION,TRANSITION_DURATION,TRANSITION_DURATION,TRANSITION_DURATION);var BrightnessFlipperWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4);var FlipperIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */])(_templateObject5);var FlipperMessage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject6);var BrightnessFlipperContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject7);var BrightnessFlipperIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(FlipperIcon)(_templateObject8,function(_ref4){var isActive=_ref4.isActive,isVariableColour=_ref4.isVariableColour,theme=_ref4.theme;return isActive?isVariableColour?theme.white:theme.mainBrandColor:theme.offlineGrey;});var Picker=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject9,function(props){return props.isOn?'auto':'none';});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return responsiveVars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return increaseZoomMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decreaseZoomMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mergeThresholdMap; });
var _increaseZoomMap,_decreaseZoomMap,_mergeThresholdMap;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// Responsive sizes based off the media queries in variables.css
var baseFontSize=14;var tabletFontSize=16;var viewMobile=baseFontSize*40;//560
var viewTablet=tabletFontSize*40;// 640
var viewDesktop=tabletFontSize*64;// 1024
var viewLarge=tabletFontSize*90;// 1440
var responsiveVars={MIN_TICKS_ON_SCREEN:4,TICKS_PER_DAY:24,MAX_TICKS_MOBILE:4,MAX_TICKS_TABLET:6,MAX_TICKS_DESKTOP:6,MAX_TICKS_LARGE:8,MAX_TICKS_XLARGE:12,VIEW_MOBILE:viewMobile,VIEW_TABLET:viewTablet,VIEW_DESKTOP:viewDesktop,VIEW_LARGE:viewLarge,MERGE_THRESHOLD_HOUR:3,MERGE_THRESHOLD_15MINS:2,MERGE_THRESHOLD_10MINS:5,MERGE_THRESHOLD_5MINS:8,MERGE_THRESHOLD_MINS:0,ZOOM_HOUR:1,ZOOM_30MINS:2,ZOOM_15MINS:4,ZOOM_10MINS:6,ZOOM_5MINS:12,ZOOM_2MINS:30,ZOOM_MINS:60};var MERGE_THRESHOLD_HOUR=responsiveVars.MERGE_THRESHOLD_HOUR,MERGE_THRESHOLD_15MINS=responsiveVars.MERGE_THRESHOLD_15MINS,MERGE_THRESHOLD_10MINS=responsiveVars.MERGE_THRESHOLD_10MINS,MERGE_THRESHOLD_5MINS=responsiveVars.MERGE_THRESHOLD_5MINS,MERGE_THRESHOLD_MINS=responsiveVars.MERGE_THRESHOLD_MINS,ZOOM_HOUR=responsiveVars.ZOOM_HOUR,ZOOM_30MINS=responsiveVars.ZOOM_30MINS,ZOOM_15MINS=responsiveVars.ZOOM_15MINS,ZOOM_10MINS=responsiveVars.ZOOM_10MINS,ZOOM_5MINS=responsiveVars.ZOOM_5MINS,ZOOM_2MINS=responsiveVars.ZOOM_2MINS,ZOOM_MINS=responsiveVars.ZOOM_MINS;var increaseZoomMap=(_increaseZoomMap={},_defineProperty(_increaseZoomMap,ZOOM_HOUR,ZOOM_30MINS),_defineProperty(_increaseZoomMap,ZOOM_30MINS,ZOOM_15MINS),_defineProperty(_increaseZoomMap,ZOOM_15MINS,ZOOM_10MINS),_defineProperty(_increaseZoomMap,ZOOM_10MINS,ZOOM_5MINS),_defineProperty(_increaseZoomMap,ZOOM_5MINS,ZOOM_2MINS),_defineProperty(_increaseZoomMap,ZOOM_2MINS,ZOOM_MINS),_increaseZoomMap);var decreaseZoomMap=(_decreaseZoomMap={},_defineProperty(_decreaseZoomMap,ZOOM_MINS,ZOOM_2MINS),_defineProperty(_decreaseZoomMap,ZOOM_2MINS,ZOOM_5MINS),_defineProperty(_decreaseZoomMap,ZOOM_5MINS,ZOOM_10MINS),_defineProperty(_decreaseZoomMap,ZOOM_10MINS,ZOOM_15MINS),_defineProperty(_decreaseZoomMap,ZOOM_15MINS,ZOOM_30MINS),_defineProperty(_decreaseZoomMap,ZOOM_30MINS,ZOOM_HOUR),_decreaseZoomMap);var mergeThresholdMap=(_mergeThresholdMap={},_defineProperty(_mergeThresholdMap,ZOOM_HOUR,MERGE_THRESHOLD_HOUR),_defineProperty(_mergeThresholdMap,ZOOM_30MINS,MERGE_THRESHOLD_HOUR),_defineProperty(_mergeThresholdMap,ZOOM_15MINS,MERGE_THRESHOLD_15MINS),_defineProperty(_mergeThresholdMap,ZOOM_10MINS,MERGE_THRESHOLD_10MINS),_defineProperty(_mergeThresholdMap,ZOOM_5MINS,MERGE_THRESHOLD_5MINS),_defineProperty(_mergeThresholdMap,ZOOM_2MINS,MERGE_THRESHOLD_MINS),_defineProperty(_mergeThresholdMap,ZOOM_MINS,MERGE_THRESHOLD_MINS),_mergeThresholdMap);

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export B */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getWhenText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getThenNotificationText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getThenConsumerText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_recipes__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__timespan__ = __webpack_require__(349);
var _templateObject=_taggedTemplateLiteral(['font-weight: bold;'],['font-weight: bold;']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// @noflow
var B=__WEBPACK_IMPORTED_MODULE_8_styled_components__["c" /* default */].span(_templateObject);var getWhenText=function getWhenText(formatMessage,producer){var _true$true;var message=(_true$true={},_defineProperty(_true$true,true,''),_defineProperty(_true$true,producer.type===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].MOTION_SENSOR,__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].whenDetectsMotion),_defineProperty(_true$true,producer.type===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].CONTACT_SENSOR&&producer.trigger==='OPEN',__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].whenContactIsOpened),_defineProperty(_true$true,producer.type===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].CONTACT_SENSOR&&producer.trigger==='CLOSED',__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].whenContactIsClosed),_defineProperty(_true$true,producer.type===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].HIVE_BUTTON&&producer.trigger==='BUTTON_PRESSED',__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].whenButtonIsPressed),_defineProperty(_true$true,producer.type===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].HIVE_BUTTON&&producer.trigger==='BUTTON_DOUBLE_PRESSED',__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].whenButtonIsDoublePressed),_defineProperty(_true$true,producer.type===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].HIVE_BUTTON&&producer.trigger==='BUTTON_LONG_HOLD_PRESSED',__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].whenButtonIsLongHoldPressed),_true$true)[true];return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},message,{values:{deviceName:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,producer.name)}}));};var getThenNotificationText=function getThenNotificationText(formatMessage,notificationOptions){var email=__WEBPACK_IMPORTED_MODULE_3__core_constants_recipes__["b" /* notificationTypes */].email,push=__WEBPACK_IMPORTED_MODULE_3__core_constants_recipes__["b" /* notificationTypes */].push,sms=__WEBPACK_IMPORTED_MODULE_3__core_constants_recipes__["b" /* notificationTypes */].sms;var list=[notificationOptions.get(email,false)&&formatMessage(__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */][email]),notificationOptions.get(push,false)&&formatMessage(__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */][push]),notificationOptions.get(sms,false)&&formatMessage(__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */][sms])].filter(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a);var text=list.length>0?list.join(', ').replace(/,([^,]*)$/,' &$1'):'...';return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].notifyMeBy,{values:{list:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,text)}}));};var getThenConsumerText=function getThenConsumerText(formatMessage,consumer){var _true$true2;var actionText=(_true$true2={},_defineProperty(_true$true2,true,function _true(){return'';}),_defineProperty(_true$true2,consumer.type===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].ACTIVE_PLUG&&consumer.state.getIn([0,'value'])==='ON',function(){return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].turnPlugOn,{values:{deviceName:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,consumer.name)}}));}),_defineProperty(_true$true2,consumer.type===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].ACTIVE_PLUG&&consumer.state.getIn([0,'value'])==='OFF',function(){return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].turnPlugOff,{values:{deviceName:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,consumer.name)}}));}),_defineProperty(_true$true2,__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbTypes"].includes(consumer.type)&&consumer.state.getIn([0,'value'])==='ON',function(){return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].turnLightOn,{values:{deviceName:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,consumer.name)}}));}),_defineProperty(_true$true2,__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbTypes"].includes(consumer.type)&&consumer.state.getIn([0,'value'])==='OFF',function(){return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].turnLightOff,{values:{deviceName:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,consumer.name)}}));}),_defineProperty(_true$true2,consumer.type===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].HEATING,function(){var mode=consumer.state.find(function(action){return action.get('field')===__WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__["a" /* consumerProperties */][__WEBPACK_IMPORTED_MODULE_3__core_constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingMode].field;});if(mode.get('value')==='OFF'){return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].turnHeatingOff,{values:{deviceName:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,consumer.name)}}));}var target=consumer.state.find(function(action){return action.get('field')===__WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__["a" /* consumerProperties */][__WEBPACK_IMPORTED_MODULE_3__core_constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingTarget].field;});if(mode.get('value')==='HEAT'){if(!!target){return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].setHeatingToManual,{values:{deviceName:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,consumer.name),degrees:target.get('value')}}));}else{return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].setHeatingToSchedule,{values:{deviceName:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,consumer.name)}}));}}if(mode.get('value')==='BOOST'){var boost=consumer.state.find(function(action){return action.get('field')===__WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__["a" /* consumerProperties */][__WEBPACK_IMPORTED_MODULE_3__core_constants_recipes__["a" /* consumerPropertyTypes */].changeHeatingBoost].field;});return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].boostHeating,{values:{deviceName:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](B,null,consumer.name),degrees:target.get('value'),duration:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__timespan__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_6_moment_timezone___default.a.duration(boost.get('value'),'minutes')})}}));}return'Heating consumer';}),_true$true2)[true]();var duration=void 0;if(consumer.duration){duration=__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].for,{values:{duration:__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__timespan__["a" /* default */],{value:__WEBPACK_IMPORTED_MODULE_6_moment_timezone___default.a.duration(consumer.duration,'seconds')})}}));}return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]('span',null,actionText,' ',duration);};

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(2399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(87);
var mapStateToProps=function mapStateToProps(state,_ref){var match=_ref.match;var id=match.params.id;return{isGroup:Object(__WEBPACK_IMPORTED_MODULE_2__core_state_products_selectors__["m" /* getIsGroupForProduct */])(state,{id:id})};};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */])));

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets_flipper_brightness_flipper__ = __webpack_require__(815);
var StandardBrightnessPicker=function StandardBrightnessPicker(_ref){var isOn=_ref.isOn,isSaving=_ref.isSaving,isToggling=_ref.isToggling,toggleLightbulb=_ref.toggleLightbulb,value=_ref.value,valueChanged=_ref.valueChanged,rgb=_ref.rgb,isSmall=_ref.isSmall,isVariableColour=_ref.isVariableColour;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__widgets_flipper_brightness_flipper__["a" /* default */],{isOn:isOn,isSaving:isSaving,isSmall:isSmall,isToggling:isToggling,isVariableColour:isVariableColour,items:[{display:'Most Dim',value:5,id:1},{display:'Less Dim',value:10,id:2},{display:'Less Dim',value:20,id:3},{display:'Less Dim',value:30,id:4},{display:'Less Dim',value:40,id:5},{display:'Medium',value:50,id:6},{display:'Less Bright',value:60,id:7},{display:'Less Bright',value:70,id:8},{display:'Less Bright',value:80,id:9},{display:'Less Bright',value:90,id:10},{display:'Most Bright',value:100,id:11}],rgb:rgb,toggleLightbulb:toggleLightbulb,value:value,valueChanged:valueChanged});};/* harmony default export */ __webpack_exports__["a"] = (StandardBrightnessPicker);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var errorMessage='\uD83D\uDC7E Missing render prop when using ~/mappings/container \uD83D\uDC7E\n\nYou\'re probably using `mergeProps` in a `connect` function without passing on `ownProps`.\nPlease make sure that `render` is passed from `ownProps` during `mergeProps` for example:\n\nfunction mergeProps(stateProps, dispatchProps, ownProps) {\n    return {\n        ...ownProps // or\n        render: ownProps.render\n    }\n}\n';var _class=function(_React$Component){_inherits(_class,_React$Component);function _class(){_classCallCheck(this,_class);return _possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).apply(this,arguments));}_createClass(_class,[{key:'validRender',value:function validRender(render){return render&&typeof render==='function';}},{key:'checkProps',value:function checkProps(render){if(!this.validRender(render)){throw new Error(errorMessage);}}},{key:'componentDidMount',value:function componentDidMount(){this.checkProps(this.props.render);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.checkProps(nextProps.render);}},{key:'render',value:function render(){var _props=this.props,render=_props.render,rest=_objectWithoutProperties(_props,['render']);return this.validRender(render)?render(rest):null;}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.untouchWithKey = exports.untouch = exports.touchWithKey = exports.touch = exports.swapArrayValues = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.propTypes = exports.initializeWithKey = exports.initialize = exports.getValues = exports.removeArrayValue = exports.reduxForm = exports.reducer = exports.focus = exports.destroy = exports.changeWithKey = exports.change = exports.blur = exports.autofillWithKey = exports.autofill = exports.addArrayValue = exports.actionTypes = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(8);

var _createAll2 = __webpack_require__(1461);

var _createAll3 = _interopRequireDefault(_createAll2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

var _createAll = (0, _createAll3.default)(isNative, _react2.default, _reactRedux.connect);

var actionTypes = _createAll.actionTypes,
    addArrayValue = _createAll.addArrayValue,
    autofill = _createAll.autofill,
    autofillWithKey = _createAll.autofillWithKey,
    blur = _createAll.blur,
    change = _createAll.change,
    changeWithKey = _createAll.changeWithKey,
    destroy = _createAll.destroy,
    focus = _createAll.focus,
    reducer = _createAll.reducer,
    reduxForm = _createAll.reduxForm,
    removeArrayValue = _createAll.removeArrayValue,
    getValues = _createAll.getValues,
    initialize = _createAll.initialize,
    initializeWithKey = _createAll.initializeWithKey,
    propTypes = _createAll.propTypes,
    reset = _createAll.reset,
    startAsyncValidation = _createAll.startAsyncValidation,
    startSubmit = _createAll.startSubmit,
    stopAsyncValidation = _createAll.stopAsyncValidation,
    stopSubmit = _createAll.stopSubmit,
    swapArrayValues = _createAll.swapArrayValues,
    touch = _createAll.touch,
    touchWithKey = _createAll.touchWithKey,
    untouch = _createAll.untouch,
    untouchWithKey = _createAll.untouchWithKey;
exports.actionTypes = actionTypes;
exports.addArrayValue = addArrayValue;
exports.autofill = autofill;
exports.autofillWithKey = autofillWithKey;
exports.blur = blur;
exports.change = change;
exports.changeWithKey = changeWithKey;
exports.destroy = destroy;
exports.focus = focus;
exports.reducer = reducer;
exports.reduxForm = reduxForm;
exports.removeArrayValue = removeArrayValue;
exports.getValues = getValues;
exports.initialize = initialize;
exports.initializeWithKey = initializeWithKey;
exports.propTypes = propTypes;
exports.reset = reset;
exports.startAsyncValidation = startAsyncValidation;
exports.startSubmit = startSubmit;
exports.stopAsyncValidation = stopAsyncValidation;
exports.stopSubmit = stopSubmit;
exports.swapArrayValues = swapArrayValues;
exports.touch = touch;
exports.touchWithKey = touchWithKey;
exports.untouch = untouch;
exports.untouchWithKey = untouchWithKey;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(1469);
var isArguments = __webpack_require__(1470);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return migrationStatusRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return migrationStatusResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return startMigrationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return startMigrationResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return startMigrationPoll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stopMigrationPoll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return progressInstallStage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var migrationStatusRequest=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* MIGRATION_STATUS_REQUEST */]);var migrationStatusResponse=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* MIGRATION_STATUS_RESPONSE */]);var startMigrationRequest=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["u" /* START_MIGRATION_REQUEST */]);var startMigrationResponse=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["v" /* START_MIGRATION_RESPONSE */]);var startMigrationPoll=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["t" /* START_MIGRATION_POLL */]);var stopMigrationPoll=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["w" /* STOP_MIGRATION_POLL */]);var progressInstallStage=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* PROGRESS_INSTALL_STAGE */]);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "types", function() { return types; });
var types={INFO:'INFO',SUCCESS:'SUCCESS',WARNING:'WARNING',ERROR:'ERROR'};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectWithLifecycle = exports.applyLifecycle = exports.LifecycleComponent = undefined;

var _component = __webpack_require__(739);

var _component2 = _interopRequireDefault(_component);

var _applyLifecycle = __webpack_require__(740);

var _applyLifecycle2 = _interopRequireDefault(_applyLifecycle);

var _lifecycleConnect = __webpack_require__(1975);

var _lifecycleConnect2 = _interopRequireDefault(_lifecycleConnect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.LifecycleComponent = _component2.default;
exports.applyLifecycle = _applyLifecycle2.default;
exports.connectWithLifecycle = _lifecycleConnect2.default;
exports.default = _component2.default;

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deviceModeMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fanModeMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return circulateDurationMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deviceOnlineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return deviceTypeMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deviceModelTypeMessages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_devices__ = __webpack_require__(12);
var _defineMessages,_defineMessages2,_defineMessages3,_defineMessages4,_defineMessages5;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var deviceModeMessages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])((_defineMessages={},_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModes"].BOOST,{id:'device.modes.boost',defaultMessage:'Heating'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModes"].MANUAL,{id:'device.modes.manual',defaultMessage:'Manual'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModes"].OFF,{id:'device.modes.off',defaultMessage:'Off'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModes"].ON,{id:'device.modes.on',defaultMessage:'On'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModes"].SCHEDULE,{id:'device.modes.schedule',defaultMessage:'Schedule'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModes"].HOLD,{id:'device.modes.hold',defaultMessage:'Hold'}),_defineProperty(_defineMessages,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModes"].MIMIC,{id:'device.modes.mimic',defaultMessage:'Mimic'}),_defineMessages));var fanModeMessages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])((_defineMessages2={},_defineProperty(_defineMessages2,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["fanModes"].AUTO,{id:'device.fanmodes.auto',defaultMessage:'Auto'}),_defineProperty(_defineMessages2,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["fanModes"].CIRCULATE,{id:'device.fanmodes.circulate',defaultMessage:'Circulate'}),_defineProperty(_defineMessages2,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["fanModes"].ALWAYS,{id:'device.fanmodes.always',defaultMessage:'Always on'}),_defineMessages2));var circulateDurationMessages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])((_defineMessages3={},_defineProperty(_defineMessages3,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["circulateDurations"].FIFTEEN,{id:'device.circulate-durations.fifteen',defaultMessage:'15Mins'}),_defineProperty(_defineMessages3,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["circulateDurations"].THIRTY,{id:'device.circulate-durations.thirty',defaultMessage:'30Mins'}),_defineProperty(_defineMessages3,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["circulateDurations"].FORTYFIVE,{id:'device.circulate-durations.fortyfive',defaultMessage:'45Mins'}),_defineProperty(_defineMessages3,'description',{id:'device.circulate-durations.description',defaultMessage:'every hour'}),_defineMessages3));var deviceOnlineMessages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({connected:{id:'device.online.connected',defaultMessage:'Connected'},off:{id:'devices.off',defaultMessage:'off'},offline:{id:'device.online.offline',defaultMessage:'Offline'},on:{id:'devices.on',defaultMessage:'on'},identify:{id:'devices.identify',defaultMessage:'Flash Light'}});var deviceTypeMessages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])((_defineMessages4={},_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].ACTIVE_PLUG,{id:'device.types.activeplug',defaultMessage:'{amount, plural,\n\t\t\tone {Active Plug}\n\t\t\tother {Active Plugs}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].BOILER_MODULE,{id:'device.types.boilermodule',defaultMessage:'{amount, plural,\n\t\t\tone {Receiver}\n\t\t\tother {Receivers}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].BULB,{id:'device.types.colourtuneablelight',defaultMessage:'{amount, plural,\n\t\t\tone {Colour Light}\n\t\t\tother {Colour Lights}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,{id:'device.types.colourtuneablelight',defaultMessage:'{amount, plural,\n\t\t\tone {Colour Light}\n\t\t\tother {Colour Lights}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_LIGHT,{id:'device.types.colourlight',defaultMessage:'{amount, plural,\n\t\t\tone {Colour Light}\n\t\t\tother {Colour Lights}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].CONTACT_SENSOR,{id:'device.types.contactsensor',defaultMessage:'{amount, plural,\n\t\t\tone {Window or Door Sensor}\n\t\t\tother {Window or Door Sensors}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HEATING,{id:'device.types.heating',defaultMessage:'{amount, plural,\n\t\t\tone {Heating Module}\n\t\t\tother {Heating Modules}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HOT_WATER,{id:'device.types.hotwater',defaultMessage:'{amount, plural,\n\t\t\tone {Hot Water Module}\n\t\t\tother {Hot Water Modules}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HIVE_BUTTON,{id:'device.types.hivebutton',defaultMessage:'{amount, plural,\n\t\t\tone {Hive Button}\n\t\t\tother {Hive Buttons}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HIVE_CAMERA,{id:'device.types.hivecamera',defaultMessage:'{amount, plural,\n\t\t\tone {Camera}\n\t\t\tother {Cameras}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HUB,{id:'device.types.hub',defaultMessage:'{amount, plural,\n\t\t\tone {Hub}\n\t\t\tother {Hubs}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HUB+'-'+__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].SENSE,{id:'device.types.hub.sense',defaultMessage:'{amount, plural,\n\t\t\tone {Hive Hub 360}\n\t\t\tother {Hive Hub 360}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HUE_BRIDGE,{id:'device.types.philipshuebridge',defaultMessage:'{amount, plural,\n\t\t\tone {Philips Hue Bridge}\n\t\t\tother {Philips Hue Bridges}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].LEAK_SENSOR,{id:'device.types.leaksensor',defaultMessage:'{amount, plural,\n        one {Leak Sensor}\n        other {Leak Sensors}\n\n      }'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].MOTION_SENSOR,{id:'device.types.motionsensor',defaultMessage:'{amount, plural,\n\t\t\tone {Motion Sensor}\n\t\t\tother {Motion Sensors}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].NA_THERMOSTAT,{id:'device.types.nathermostat',defaultMessage:'{amount, plural,\n\t\t\tone {Thermostat}\n\t\t\tother {Thermostat}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].SENSE,{id:'device.types.sense',defaultMessage:'{amount, plural,\n\t\t\tone {Hive Hub 360}\n\t\t\tother {Hive Hub 360}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].SIGNAL_BOOSTER,{id:'device.types.signalbooster',defaultMessage:'{amount, plural,\n\t\t\tone {Signal Booster}\n\t\t\tother {Signal Boosters}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].SMART_PLUG,{id:'device.types.smartplug',defaultMessage:'{amount, plural,\n\t\t\tone {Smart Plug}\n\t\t\tother {Smart Plugs}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].THERMOSTAT_UI,{id:'device.types.thermostatui',defaultMessage:'{amount, plural,\n\t\t\tone {Thermostat}\n\t\t\tother {Thermostats}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].THERMOSTAT,{id:'device.types.thermostatui',defaultMessage:'{amount, plural,\n\t\t\tone {Thermostat}\n\t\t\tother {Thermostats}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].TUNEABLE_LIGHT,{id:'device.types.tuneablelight',defaultMessage:'{amount, plural,\n\t\t\tone {Tuneable Light}\n\t\t\tother {Tuneable Lights}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].WARM_WHITE_LIGHT,{id:'device.types.warmwhitelight',defaultMessage:'{amount, plural,\n\t\t\tone {Warm White Light}\n\t\t\tother {Warm White Lights}\n\t\t}'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT+'-'+__WEBPACK_IMPORTED_MODULE_1__constants_devices__["manufacturers"].PHILIPS,{id:'device.types.huelight',defaultMessage:'{amount, plural,\n          one {Hue Light}\n          other {Hue Lights}\n        }'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_LIGHT+'-'+__WEBPACK_IMPORTED_MODULE_1__constants_devices__["manufacturers"].PHILIPS,{id:'device.types.huelight',defaultMessage:'{amount, plural,\n          one {Hue Light}\n          other {Hue Lights}\n        }'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].TUNEABLE_LIGHT+'-'+__WEBPACK_IMPORTED_MODULE_1__constants_devices__["manufacturers"].PHILIPS,{id:'device.types.huelight',defaultMessage:'{amount, plural,\n          one {Hue Light}\n          other {Hue Lights}\n        }'}),_defineProperty(_defineMessages4,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].WARM_WHITE_LIGHT+'-'+__WEBPACK_IMPORTED_MODULE_1__constants_devices__["manufacturers"].PHILIPS,{id:'device.types.huelight',defaultMessage:'{amount, plural,\n          one {Hue Light}\n          other {Hue Lights}\n        }'}),_defineMessages4));var deviceModelTypeMessages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])((_defineMessages5={},_defineProperty(_defineMessages5,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["gu10Models"].FWBULB01UK,{id:'device.types.gu10.white',defaultMessage:'{amount, plural,\n            one {Warm White Spotlight}\n            other {Warm White Spotlights}\n        }'}),_defineProperty(_defineMessages5,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["gu10Models"].FWGU10BULBUK,{id:'device.types.gu10.white',defaultMessage:'{amount, plural,\n            one {Warm White Spotlight}\n            other {Warm White Spotlights}\n        }'}),_defineProperty(_defineMessages5,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["gu10Models"].FWGU10BULB01UK,{id:'device.types.gu10.white',defaultMessage:'{amount, plural,\n            one {Warm White Spotlight}\n            other {Warm White Spotlights}\n        }'}),_defineProperty(_defineMessages5,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["gu10Models"].TWGU10BULB01UK,{id:'device.types.gu10.tuneable',defaultMessage:'{amount, plural,\n            one {Tuneable Spotlight}\n            other {Tuneable Spotlights}\n        }'}),_defineProperty(_defineMessages5,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["candlelightModels"].FWCLBulb01UK,{id:'device.types.candlelight.white',defaultMessage:'{amount, plural,\n            one {Warm White Candlelight}\n            other {Warm White Candlelights}\n        }'}),_defineProperty(_defineMessages5,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["candlelightModels"].TWCLBulb01UK,{id:'device.types.candlelight.tuneable',defaultMessage:'{amount, plural,\n            one {Tuneable Candlelight}\n            other {Tuneable Candlelights}\n        }'}),_defineMessages5));

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productTypeToIcon; });
/* unused harmony export map */
/* harmony export (immutable) */ __webpack_exports__["a"] = getIconComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__devices__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__weather__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__ = __webpack_require__(353);
var _deviceIconMap,_deviceTypes$ACTIVE_P,_deviceTypes$SMART_PL,_regionIconMap,_deviceTypes$BOILER_M,_deviceTypes$HUB,_deviceTypes$THERMOST,_deviceTypes$THERMOST2,_deviceTypes$ACTIVE_P2,_modelIconMap,_map;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var deviceIconMap=(_deviceIconMap={},_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LIGHT),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].COLOR_LIGHT,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LIGHT),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].CONTACT_SENSOR,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].DOOR_SENSOR),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].HEATING,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HEATING),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].HIVE_BUTTON,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HIVE_BUTTON),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].HIVE_CAMERA,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].CAMERA_DEHARO),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].HOT_WATER,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HOT_WATER),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].LEAK_SENSOR,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LEAK_SENSOR),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].MOTION_SENSOR,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].MOTION_SENSOR),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].NA_THERMOSTAT,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].FLAME_NA),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].SIGNAL_BOOSTER,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SIGNAL_BOOST),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].SENSE,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SENSE),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].TUNEABLE_LIGHT,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LIGHT),_defineProperty(_deviceIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].WARM_WHITE_LIGHT,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LIGHT),_deviceIconMap);var regionIconMap=(_regionIconMap={},_defineProperty(_regionIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].ACTIVE_PLUG,(_deviceTypes$ACTIVE_P={},_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["regions"].EU,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_EU),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["regions"].IN,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_IN),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["regions"].NA,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_NA),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["regions"].UK,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_UK),_deviceTypes$ACTIVE_P)),_defineProperty(_regionIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].SMART_PLUG,(_deviceTypes$SMART_PL={},_defineProperty(_deviceTypes$SMART_PL,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["regions"].EU,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_EU),_defineProperty(_deviceTypes$SMART_PL,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["regions"].IN,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_IN),_defineProperty(_deviceTypes$SMART_PL,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["regions"].NA,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_NA),_defineProperty(_deviceTypes$SMART_PL,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["regions"].UK,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_UK),_deviceTypes$SMART_PL)),_regionIconMap);var productGroupMap=_defineProperty({},__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].PRODUCT_GROUP,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].GROUP_CONTROL);var modelIconMap=(_modelIconMap={},_defineProperty(_modelIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].BOILER_MODULE,(_deviceTypes$BOILER_M={},_defineProperty(_deviceTypes$BOILER_M,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLR1,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].BOILER_MODULE_SLR1),_defineProperty(_deviceTypes$BOILER_M,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLR2,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].BOILER_MODULE_SLR2),_deviceTypes$BOILER_M)),_defineProperty(_modelIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].HUB,(_deviceTypes$HUB={},_defineProperty(_deviceTypes$HUB,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].NANO1,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HUB_NANO1),_defineProperty(_deviceTypes$HUB,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].NANO2,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HUB_NANO2),_defineProperty(_deviceTypes$HUB,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SENSE,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SENSE),_deviceTypes$HUB)),_defineProperty(_modelIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].THERMOSTAT,(_deviceTypes$THERMOST={},_defineProperty(_deviceTypes$THERMOST,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLT1,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT1),_defineProperty(_deviceTypes$THERMOST,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLT2,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT2),_defineProperty(_deviceTypes$THERMOST,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLT3,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3),_defineProperty(_deviceTypes$THERMOST,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLT3b,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3),_deviceTypes$THERMOST)),_defineProperty(_modelIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].THERMOSTAT_UI,(_deviceTypes$THERMOST2={},_defineProperty(_deviceTypes$THERMOST2,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLT1,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT1),_defineProperty(_deviceTypes$THERMOST2,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLT2,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT2),_defineProperty(_deviceTypes$THERMOST2,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLT3,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3),_defineProperty(_deviceTypes$THERMOST2,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLT3b,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3),_deviceTypes$THERMOST2)),_defineProperty(_modelIconMap,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].ACTIVE_PLUG,(_deviceTypes$ACTIVE_P2={},_defineProperty(_deviceTypes$ACTIVE_P2,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLP2d,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_EU),_defineProperty(_deviceTypes$ACTIVE_P2,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLP2c,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_NA),_defineProperty(_deviceTypes$ACTIVE_P2,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLP2b,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_UK),_defineProperty(_deviceTypes$ACTIVE_P2,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModels"].SLP2,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_UK),_deviceTypes$ACTIVE_P2)),_modelIconMap);var productTypeToIcon=function productTypeToIcon(_ref){var _ref$localeSuffix=_ref.localeSuffix,localeSuffix=_ref$localeSuffix===undefined?__WEBPACK_IMPORTED_MODULE_5__constants_devices__["regions"].UK:_ref$localeSuffix,_ref$model=_ref.model,model=_ref$model===undefined?'':_ref$model,type=_ref.type;if(type in deviceIconMap){return deviceIconMap[type];}if(type in productGroupMap){return productGroupMap[type];}var iconFromModel=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default()([type,model])(modelIconMap);if(iconFromModel){return iconFromModel;}var iconFromRegion=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default()([type,localeSuffix])(regionIconMap);if(iconFromRegion){return iconFromRegion;}return __WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LINKED;};var map=(_map={},_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].ACTIVE_BUTTON,__WEBPACK_IMPORTED_MODULE_1__devices__["a" /* ActionButton */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].APPLIANCE,__WEBPACK_IMPORTED_MODULE_1__devices__["b" /* Appliance */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].BOILER_MODULE_SLR1,__WEBPACK_IMPORTED_MODULE_1__devices__["c" /* BoilerModuleSLR1 */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].BOILER_MODULE_SLR2,__WEBPACK_IMPORTED_MODULE_1__devices__["d" /* BoilerModuleSLR2 */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].BUTTON_OFF,__WEBPACK_IMPORTED_MODULE_1__devices__["e" /* ButtonOff */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].CAMERA_DEHARO,__WEBPACK_IMPORTED_MODULE_1__devices__["f" /* CameraDeharo */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].CAMERA_OFF,__WEBPACK_IMPORTED_MODULE_1__devices__["g" /* CameraOff */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].COLOUR_PICKER,__WEBPACK_IMPORTED_MODULE_1__devices__["h" /* ColourPicker */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].COOLING,__WEBPACK_IMPORTED_MODULE_1__devices__["i" /* Cooling */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].DOOR_SENSOR,__WEBPACK_IMPORTED_MODULE_1__devices__["j" /* DoorSensorClosed */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].DOUBLE_TAP,__WEBPACK_IMPORTED_MODULE_1__devices__["k" /* DoubleTap */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].DUO_SOCKET_EU,__WEBPACK_IMPORTED_MODULE_1__devices__["l" /* DuoSocketEU */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].DUO_SOCKET_IN,__WEBPACK_IMPORTED_MODULE_1__devices__["m" /* DuoSocketIN */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].DUO_SOCKET_NA,__WEBPACK_IMPORTED_MODULE_1__devices__["n" /* DuoSocketNA */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].DUO_SOCKET_UK,__WEBPACK_IMPORTED_MODULE_1__devices__["o" /* DuoSocketUK */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].FAN_OFF,__WEBPACK_IMPORTED_MODULE_1__devices__["p" /* FanOff */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].FAN_ON,__WEBPACK_IMPORTED_MODULE_1__devices__["q" /* FanOn */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].FLAME_NA,__WEBPACK_IMPORTED_MODULE_1__devices__["r" /* FlameNA */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].GENERIC_TEMP,__WEBPACK_IMPORTED_MODULE_1__devices__["s" /* GenericTemp */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HEATING,__WEBPACK_IMPORTED_MODULE_1__devices__["t" /* Heating */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HIVE_BUTTON,__WEBPACK_IMPORTED_MODULE_1__devices__["u" /* HiveButton */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HOT_WATER,__WEBPACK_IMPORTED_MODULE_1__devices__["v" /* HotWater */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HOT_WATER_ON,__WEBPACK_IMPORTED_MODULE_1__devices__["w" /* HotWaterOn */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HUB_NANO1,__WEBPACK_IMPORTED_MODULE_1__devices__["x" /* HubNano1 */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HUB_NANO2,__WEBPACK_IMPORTED_MODULE_1__devices__["y" /* HubNano2 */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].HUMIDITY,__WEBPACK_IMPORTED_MODULE_1__devices__["z" /* Humidity */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LEAK_SENSOR,__WEBPACK_IMPORTED_MODULE_1__devices__["A" /* LeakSensor */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LIGHT,__WEBPACK_IMPORTED_MODULE_1__devices__["B" /* Light */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LIGHT_DOUBLE,__WEBPACK_IMPORTED_MODULE_1__devices__["C" /* LightDouble */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LINK_BROKEN,__WEBPACK_IMPORTED_MODULE_1__devices__["D" /* LinkBroken */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LINKED,__WEBPACK_IMPORTED_MODULE_1__devices__["E" /* Linked */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].LONG_PRESS,__WEBPACK_IMPORTED_MODULE_1__devices__["F" /* LongPress */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].MOTION_SENSOR,__WEBPACK_IMPORTED_MODULE_1__devices__["G" /* MotionSensor */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].ONE_TAP,__WEBPACK_IMPORTED_MODULE_1__devices__["H" /* OneTap */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PHILIPS_HUE_BRIDGE,__WEBPACK_IMPORTED_MODULE_1__devices__["I" /* PhilipsHueBridge */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_EU,__WEBPACK_IMPORTED_MODULE_1__devices__["J" /* PlugEU */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_IN,__WEBPACK_IMPORTED_MODULE_1__devices__["K" /* PlugIN */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_NA,__WEBPACK_IMPORTED_MODULE_1__devices__["L" /* PlugNA */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].PLUG_UK,__WEBPACK_IMPORTED_MODULE_1__devices__["M" /* PlugUK */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SENSE,__WEBPACK_IMPORTED_MODULE_1__devices__["N" /* Sense */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SIGNAL_BOOST,__WEBPACK_IMPORTED_MODULE_1__devices__["O" /* SignalBoost */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SIGNAL_BOOSTER_PLUG,__WEBPACK_IMPORTED_MODULE_1__devices__["P" /* SignalBoosterPlug */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SOCKET_EU,__WEBPACK_IMPORTED_MODULE_1__devices__["Q" /* SocketEU */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SOCKET_IN,__WEBPACK_IMPORTED_MODULE_1__devices__["R" /* SocketIN */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SOCKET_NA,__WEBPACK_IMPORTED_MODULE_1__devices__["S" /* SocketNA */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SOCKET_UK,__WEBPACK_IMPORTED_MODULE_1__devices__["T" /* SocketUK */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].SWITCH,__WEBPACK_IMPORTED_MODULE_1__devices__["U" /* Switch */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].TANKS,__WEBPACK_IMPORTED_MODULE_1__devices__["V" /* Tanks */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT1,__WEBPACK_IMPORTED_MODULE_1__devices__["W" /* ThermostatSLT1 */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT2,__WEBPACK_IMPORTED_MODULE_1__devices__["X" /* ThermostatSLT2 */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3,__WEBPACK_IMPORTED_MODULE_1__devices__["Y" /* ThermostatSLT3 */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].TOILETS,__WEBPACK_IMPORTED_MODULE_1__devices__["Z" /* Toilets */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].WATER_FLOWING,__WEBPACK_IMPORTED_MODULE_1__devices__["_0" /* WaterFlowing */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_6__constants_icons_devices_svg__["a" /* default */].WATER_NOT_FLOWING,__WEBPACK_IMPORTED_MODULE_1__devices__["_1" /* WaterNotFlowing */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].ACTIONS,__WEBPACK_IMPORTED_MODULE_2__general__["a" /* Actions */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].ADD_DEVICES,__WEBPACK_IMPORTED_MODULE_2__general__["b" /* AddDevices */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].ARROW_DOWN,__WEBPACK_IMPORTED_MODULE_2__general__["c" /* ArrowDown */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].ARROW_LEFT,__WEBPACK_IMPORTED_MODULE_2__general__["d" /* ArrowLeft */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].ARROW_LEFT_SHAFT,__WEBPACK_IMPORTED_MODULE_2__general__["e" /* ArrowLeftShaft */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].ARROW_RIGHT,__WEBPACK_IMPORTED_MODULE_2__general__["f" /* ArrowRight */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].ARROW_RIGHT_DOUBLE,__WEBPACK_IMPORTED_MODULE_2__general__["g" /* ArrowRightDouble */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].ARROW_UP,__WEBPACK_IMPORTED_MODULE_2__general__["h" /* ArrowUp */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].BATTERY_EMPTY,__WEBPACK_IMPORTED_MODULE_2__general__["i" /* BatteryEmpty */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].BATTERY_FULL,__WEBPACK_IMPORTED_MODULE_2__general__["j" /* BatteryFull */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].BATTERY_LOW,__WEBPACK_IMPORTED_MODULE_2__general__["k" /* BatteryLow */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].BATTERY_NORMAL,__WEBPACK_IMPORTED_MODULE_2__general__["l" /* BatteryNormal */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].BOOST,__WEBPACK_IMPORTED_MODULE_2__general__["m" /* Boost */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].BORD_GAIS_LOGO,__WEBPACK_IMPORTED_MODULE_2__general__["n" /* BordGaisLogo */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].CALL,__WEBPACK_IMPORTED_MODULE_2__general__["o" /* Call */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].CIRCLE_FILLED,__WEBPACK_IMPORTED_MODULE_2__general__["p" /* CircleFilled */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].CIRCLE_OUTLINE,__WEBPACK_IMPORTED_MODULE_2__general__["q" /* CircleOutline */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].CLOSE,__WEBPACK_IMPORTED_MODULE_2__general__["r" /* Close */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].CLOSE_HEAVY,__WEBPACK_IMPORTED_MODULE_2__general__["s" /* CloseHeavy */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].COLOR_PALETE,__WEBPACK_IMPORTED_MODULE_2__general__["t" /* ColorPalete */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].COLOR_PICKER,__WEBPACK_IMPORTED_MODULE_2__general__["u" /* ColorPicker */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].COMFORT,__WEBPACK_IMPORTED_MODULE_2__general__["v" /* Comfort */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].CONNECTED,__WEBPACK_IMPORTED_MODULE_2__general__["w" /* Connected */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].CONTROL_PAGE,__WEBPACK_IMPORTED_MODULE_2__general__["x" /* ControlPage */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].COPY,__WEBPACK_IMPORTED_MODULE_2__general__["y" /* Copy */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].CREATE,__WEBPACK_IMPORTED_MODULE_2__general__["z" /* Create */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].CREATE_PLUS,__WEBPACK_IMPORTED_MODULE_2__general__["A" /* CreatePlus */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].DASHBOARD,__WEBPACK_IMPORTED_MODULE_2__general__["B" /* Dashboard */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].DEMO,__WEBPACK_IMPORTED_MODULE_2__general__["C" /* Demo */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].DIMMER,__WEBPACK_IMPORTED_MODULE_2__general__["D" /* Dimmer */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].DISCOVER,__WEBPACK_IMPORTED_MODULE_2__general__["E" /* Discover */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].DOG_BARK,__WEBPACK_IMPORTED_MODULE_2__general__["F" /* DogBark */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].DOWNLOAD,__WEBPACK_IMPORTED_MODULE_2__general__["G" /* Download */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].EDIT,__WEBPACK_IMPORTED_MODULE_2__general__["H" /* Edit */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].EFFICIENCY,__WEBPACK_IMPORTED_MODULE_2__general__["I" /* Efficiency */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].EXCLAMATION,__WEBPACK_IMPORTED_MODULE_2__general__["J" /* Exclamation */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].FROST_PROTECTION,__WEBPACK_IMPORTED_MODULE_2__general__["K" /* FrostProtection */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].GLASS_BREAK,__WEBPACK_IMPORTED_MODULE_2__general__["L" /* GlassBreak */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].GROUP_CONTROL,__WEBPACK_IMPORTED_MODULE_2__general__["N" /* GroupControl */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].GRAPHS,__WEBPACK_IMPORTED_MODULE_2__general__["M" /* Graphs */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].HEATING_PAGE,__WEBPACK_IMPORTED_MODULE_2__general__["O" /* HeatingPage */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].HELP,__WEBPACK_IMPORTED_MODULE_2__general__["P" /* Help */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].HIVE_ICON,__WEBPACK_IMPORTED_MODULE_2__general__["Q" /* HiveIcon */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].HOLIDAYS,__WEBPACK_IMPORTED_MODULE_2__general__["R" /* Holidays */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].HOME,__WEBPACK_IMPORTED_MODULE_2__general__["S" /* Home */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].HOT_WATER,__WEBPACK_IMPORTED_MODULE_2__general__["T" /* HotWater */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].INCORRECT_SOUND,__WEBPACK_IMPORTED_MODULE_2__general__["U" /* IncorrectSound */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].INFO,__WEBPACK_IMPORTED_MODULE_2__general__["V" /* Info */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].INSTALL_DEVICE,__WEBPACK_IMPORTED_MODULE_2__general__["W" /* InstallDevice */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].LINK,__WEBPACK_IMPORTED_MODULE_2__general__["X" /* Link */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].LINK_BROKEN,__WEBPACK_IMPORTED_MODULE_2__general__["Y" /* LinkBroken */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].LIST_DEVICE_MENU,__WEBPACK_IMPORTED_MODULE_2__general__["Z" /* ListDeviceMenu */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].LOCK_CLOSED,__WEBPACK_IMPORTED_MODULE_2__general__["_0" /* LockClosed */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].LOGOUT,__WEBPACK_IMPORTED_MODULE_2__general__["_1" /* Logout */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MANAGE_DEVICE,__WEBPACK_IMPORTED_MODULE_2__general__["_2" /* ManageDevice */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MENU,__WEBPACK_IMPORTED_MODULE_2__general__["_3" /* Menu */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MICROPHONE_OFF,__WEBPACK_IMPORTED_MODULE_2__general__["_4" /* MicrophoneOff */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MICROPHONE_ON,__WEBPACK_IMPORTED_MODULE_2__general__["_5" /* MicrophoneOn */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MIMIC,__WEBPACK_IMPORTED_MODULE_2__general__["_6" /* Mimic */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MINUS,__WEBPACK_IMPORTED_MODULE_2__general__["_7" /* Minus */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MONITOR_SENSE,__WEBPACK_IMPORTED_MODULE_2__general__["_8" /* MonitorSense */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MONITORING_OFF,__WEBPACK_IMPORTED_MODULE_2__general__["_9" /* MonitoringOff */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MONITORING_ON,__WEBPACK_IMPORTED_MODULE_2__general__["_10" /* MonitoringOn */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MOODS,__WEBPACK_IMPORTED_MODULE_2__general__["_11" /* Moods */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MORE,__WEBPACK_IMPORTED_MODULE_2__general__["_12" /* More */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MORE_VERTICAL,__WEBPACK_IMPORTED_MODULE_2__general__["_13" /* MoreVertical */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].MULTI_PROFILE,__WEBPACK_IMPORTED_MODULE_2__general__["_14" /* MultiProfile */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].NOTIFICATIONS,__WEBPACK_IMPORTED_MODULE_2__general__["_15" /* Notifications */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].NOTIFICATIONS_OFF,__WEBPACK_IMPORTED_MODULE_2__general__["_16" /* NotificationsOff */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].OVERFLOW,__WEBPACK_IMPORTED_MODULE_2__general__["_17" /* Overflow */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].PAUSE,__WEBPACK_IMPORTED_MODULE_2__general__["_18" /* Pause */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].PAUSE_SIMPLE,__WEBPACK_IMPORTED_MODULE_2__general__["_19" /* PauseSimple */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].PLAY,__WEBPACK_IMPORTED_MODULE_2__general__["_20" /* Play */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].PLAY_SIMPLE,__WEBPACK_IMPORTED_MODULE_2__general__["_21" /* PlaySimple */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].PLUS,__WEBPACK_IMPORTED_MODULE_2__general__["_22" /* Plus */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].QUESTION,__WEBPACK_IMPORTED_MODULE_2__general__["_23" /* Question */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].REASSURANCE,__WEBPACK_IMPORTED_MODULE_2__general__["_24" /* Reassurance */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].RECIPES,__WEBPACK_IMPORTED_MODULE_2__general__["_25" /* Recipes */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].RESET_RELOAD,__WEBPACK_IMPORTED_MODULE_2__general__["_26" /* ResetReload */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SCHEDULE,__WEBPACK_IMPORTED_MODULE_2__general__["_27" /* Schedule */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SEARCH,__WEBPACK_IMPORTED_MODULE_2__general__["_28" /* Search */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SETTINGS,__WEBPACK_IMPORTED_MODULE_2__general__["_29" /* Settings */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SHOP,__WEBPACK_IMPORTED_MODULE_2__general__["_30" /* Shop */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SIGNAL_1_BARS,__WEBPACK_IMPORTED_MODULE_2__general__["_31" /* Signal1Bars */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SIGNAL_2_BARS,__WEBPACK_IMPORTED_MODULE_2__general__["_32" /* Signal2Bars */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SIGNAL_3_BARS,__WEBPACK_IMPORTED_MODULE_2__general__["_33" /* Signal3Bars */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SIGNAL_4_BARS,__WEBPACK_IMPORTED_MODULE_2__general__["_34" /* Signal4Bars */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SMOKE_CO,__WEBPACK_IMPORTED_MODULE_2__general__["_35" /* SmokeCo */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SMOKE_CO2,__WEBPACK_IMPORTED_MODULE_2__general__["_36" /* SmokeCo2 */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SOUND_CAM,__WEBPACK_IMPORTED_MODULE_2__general__["_37" /* SoundCam */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SOUND_OFF,__WEBPACK_IMPORTED_MODULE_2__general__["_38" /* SoundOff */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].SOUND_ON,__WEBPACK_IMPORTED_MODULE_2__general__["_39" /* SoundOn */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].STOP,__WEBPACK_IMPORTED_MODULE_2__general__["_40" /* Stop */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].STOP_SIMPLE,__WEBPACK_IMPORTED_MODULE_2__general__["_41" /* StopSimple */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].TICK_ONE,__WEBPACK_IMPORTED_MODULE_2__general__["_42" /* TickOne */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].TICK_SIMPLE,__WEBPACK_IMPORTED_MODULE_2__general__["_43" /* TickSimple */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].TONE,__WEBPACK_IMPORTED_MODULE_2__general__["_44" /* Tone */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].TRASH,__WEBPACK_IMPORTED_MODULE_2__general__["_45" /* Trash */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].USER_PROFILE,__WEBPACK_IMPORTED_MODULE_2__general__["_46" /* UserProfile */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].WELCOME_HOME,__WEBPACK_IMPORTED_MODULE_2__general__["_47" /* WelcomeHome */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].WIFI,__WEBPACK_IMPORTED_MODULE_2__general__["_48" /* Wifi */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].WIFI_0_BARS,__WEBPACK_IMPORTED_MODULE_2__general__["_49" /* Wifi0Bars */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].WIFI_1_BARS,__WEBPACK_IMPORTED_MODULE_2__general__["_50" /* Wifi1Bars */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].WIFI_2_BARS,__WEBPACK_IMPORTED_MODULE_2__general__["_51" /* Wifi2Bars */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].WIFI_3_BARS,__WEBPACK_IMPORTED_MODULE_2__general__["_52" /* Wifi3Bars */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_7__constants_icons_general_svg__["a" /* default */].WIFI_OFF,__WEBPACK_IMPORTED_MODULE_2__general__["_53" /* WifiOff */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].BLACK_LOW_CLOUD,__WEBPACK_IMPORTED_MODULE_4__weather__["a" /* BlackLowCloud */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].CLEAR_SKY,__WEBPACK_IMPORTED_MODULE_4__weather__["b" /* ClearSky */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_HEAVY_RAIN,__WEBPACK_IMPORTED_MODULE_4__weather__["c" /* CloudyWithHeavyRain */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_HEAVY_RAIN_NIGHT,__WEBPACK_IMPORTED_MODULE_4__weather__["d" /* CloudyWithHeavyRainNight */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_HEAVY_SNOW,__WEBPACK_IMPORTED_MODULE_4__weather__["e" /* CloudyWithHeavySnow */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_LIGHT_RAIN,__WEBPACK_IMPORTED_MODULE_4__weather__["f" /* CloudyWithLightRain */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_LIGHT_RAIN_NIGHT,__WEBPACK_IMPORTED_MODULE_4__weather__["g" /* CloudyWithLightRainNight */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_SLEET,__WEBPACK_IMPORTED_MODULE_4__weather__["h" /* CloudyWithSleet */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].FOG_MIST,__WEBPACK_IMPORTED_MODULE_4__weather__["i" /* FogMist */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].HEAVY_RAIN_SHOWERS,__WEBPACK_IMPORTED_MODULE_4__weather__["j" /* HeavyRainShowers */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].HEAVY_SNOW_SHOWERS,__WEBPACK_IMPORTED_MODULE_4__weather__["k" /* HeavySnowShowers */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].HEAVY_SNOW_SHOWERS_NIGHT,__WEBPACK_IMPORTED_MODULE_4__weather__["l" /* HeavySnowShowersNight */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].LIGHT_RAIN_SHOWERS,__WEBPACK_IMPORTED_MODULE_4__weather__["m" /* LightRainShowers */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].LIGHT_SNOW,__WEBPACK_IMPORTED_MODULE_4__weather__["n" /* LightSnow */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].LIGHT_SNOW_NIGHT,__WEBPACK_IMPORTED_MODULE_4__weather__["o" /* LightSnowNight */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].LIGHT_SNOW_SHOWERS,__WEBPACK_IMPORTED_MODULE_4__weather__["p" /* LightSnowShowers */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].SLEET_SHOWERS,__WEBPACK_IMPORTED_MODULE_4__weather__["q" /* SleetShowers */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].SLEET_SHOWERS_NIGHT,__WEBPACK_IMPORTED_MODULE_4__weather__["r" /* SleetShowersNight */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].SUNNY,__WEBPACK_IMPORTED_MODULE_4__weather__["s" /* Sunny */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].SUNNY_INTERVALS,__WEBPACK_IMPORTED_MODULE_4__weather__["t" /* SunnyIntervals */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].SUNSET_SUNRISE,__WEBPACK_IMPORTED_MODULE_4__weather__["u" /* SunsetSunrise */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].THUNDER_SHOWERS,__WEBPACK_IMPORTED_MODULE_4__weather__["v" /* ThunderShowers */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].THUNDER_SHOWERS_NIGHT,__WEBPACK_IMPORTED_MODULE_4__weather__["w" /* ThunderShowersNight */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].THUNDERSTORMS,__WEBPACK_IMPORTED_MODULE_4__weather__["x" /* Thunderstorms */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].WHITE_CLOUD,__WEBPACK_IMPORTED_MODULE_4__weather__["y" /* WhiteCloud */]),_defineProperty(_map,__WEBPACK_IMPORTED_MODULE_8__constants_icons_weather_svg__["a" /* default */].WHITE_CLOUD_NIGHT,__WEBPACK_IMPORTED_MODULE_4__weather__["z" /* WhiteCloudNight */]),_map);function getIconComponent(type){var props=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return map[type]?__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](map[type],props):null;}

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_js__ = __webpack_require__(2256);
var ToggleButton=function ToggleButton(_ref){var isOn=_ref.isOn,name=_ref.name,onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('label',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles_js__["a" /* Checkbox */],{checked:isOn,name:name,onChange:onChange,type:'checkbox'}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles_js__["b" /* Switch */],{isOn:isOn})));};/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Input */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2273);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Input(_ref){var id=_ref.id,formatMessage=_ref.intl.formatMessage,error=_ref.error,label=_ref.label,placeholder=_ref.placeholder,showLabel=_ref.showLabel,serverError=_ref.serverError,touched=_ref.touched,inputRef=_ref.inputRef,props=_objectWithoutProperties(_ref,['id','intl','error','label','placeholder','showLabel','serverError','touched','inputRef']);/* eslint-disable camelcase */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* InputContainer */],null,label&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* LabelField */],{htmlFor:id},(typeof label==='undefined'?'undefined':_typeof(label))==='object'?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],label):label),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* InputField */],Object.assign({},props,{error:error,id:id,innerRef:inputRef// $FlowFixMe
,placeholder:(typeof placeholder==='undefined'?'undefined':_typeof(placeholder))==='object'?formatMessage(placeholder):placeholder,serverError:serverError,touched:touched})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* InputValidation */],{error:error,role:'alert',serverError:serverError,touched:touched},error&&touched&&((typeof error==='undefined'?'undefined':_typeof(error))==='object'?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],error):error),serverError&&!touched&&((typeof serverError==='undefined'?'undefined':_typeof(serverError))==='object'?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],serverError):serverError)));}/* eslint-enable camelcase *//* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["g" /* injectIntl */])(Input));

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bulbSaved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return changeColorMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleLightbulb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return talkToLight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeBrightness; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createCurriedAction__ = __webpack_require__(1772);
var bulbSaved=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BULB_SAVED */]);var changeColorMode=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_COLOR_MODE */]);var changeColor=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COLOR_CHANGED */]);var toggleLightbulb=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* TOGGLE_LIGHTBULB */]);var toggleDone=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* TOGGLE_DONE */]);var talkToLight=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* TALK_TO_LIGHT */]);var changeBrightness=Object(__WEBPACK_IMPORTED_MODULE_2__createCurriedAction__["a" /* createCurriedAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CHANGE_BRIGHTNESS */],function(productId,isOn,brightness){return{productId:productId,isOn:isOn,brightness:brightness};});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_attribute_component__ = __webpack_require__(762);
/* unused harmony reexport ActionAttribute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry__ = __webpack_require__(2113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__entry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_component__ = __webpack_require__(2175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__filter_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_summary_component__ = __webpack_require__(497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__icons_summary_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_description__ = __webpack_require__(2182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__template_description__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_component__ = __webpack_require__(2187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__template_component__["a"]; });


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('every', __webpack_require__(2348));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBulbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return availableBulbsForGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bulbsInOtherGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getIsToggling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getIsSaving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getHSVForBulb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getTemperatureForBulb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCanChangeToWhite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getNameForBulb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getColorModeForBulb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBrightnessForBulb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getIsSchedulable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__groups_selectors__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_immutable__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_folktale_maybe__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_folktale_maybe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_folktale_maybe__);
var getWhetherProductHasCapability=Object(__WEBPACK_IMPORTED_MODULE_7__selectors__["a" /* bindable */])(__WEBPACK_IMPORTED_MODULE_2__selectors__["M" /* getWhetherProductHasCapability */]);var defaultSaturation=99;var getBulbs=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["A" /* getProductItemsExcludingGroups */],function(products){return Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["b" /* allProductsIncludingOfflineByTypeSelector */])(__WEBPACK_IMPORTED_MODULE_5__constants_devices__["bulbTypes"],products);});var getConsumers=Object(__WEBPACK_IMPORTED_MODULE_6__utils_immutable__["d" /* getIn */])(['props','consumers']);var bulbsAssignedToOtherGroups=function bulbsAssignedToOtherGroups(allGroups,currentGroup){return allGroups.chain(function(groups){return currentGroup.map(function(currentGroup){return groups.filter(function(group){return group.get('id')!==currentGroup.get('id');}).map(function(group){return getConsumers(group)||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});}).flatten();}).orElse(function(){return __WEBPACK_IMPORTED_MODULE_8_folktale_maybe___default.a.of(groups.map(getConsumers).flatten());});});};var availableBulbsForGroup=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4__groups_selectors__["a" /* getGroupById */],__WEBPACK_IMPORTED_MODULE_4__groups_selectors__["b" /* getGroupConsumers */],__WEBPACK_IMPORTED_MODULE_4__groups_selectors__["d" /* getGroupItems */],getBulbs],function(currentGroup,currentGroupProducts,allGroups,bulbs){var productsAssignedToOtherGroups=bulbsAssignedToOtherGroups(allGroups,currentGroup);return bulbs.filter(function(bulb){return!productsAssignedToOtherGroups.getOrElse([]).includes(bulb.get('id'));}).map(function(b){var shouldSet=currentGroupProducts.map(function(consumers){return consumers.includes(b.get('id'));});return b.set('include',shouldSet.getOrElse(false));});});var bulbsInOtherGroups=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4__groups_selectors__["a" /* getGroupById */],__WEBPACK_IMPORTED_MODULE_4__groups_selectors__["d" /* getGroupItems */],getBulbs],function(currentGroup,allGroups,bulbs){var productsAssignedToOtherGroups=bulbsAssignedToOtherGroups(allGroups,currentGroup).getOrElse([]);return bulbs.filter(function(bulb){return productsAssignedToOtherGroups.includes(bulb.get('id'));}).map(function(b){return b.set('include',false);});});var getIsToggling=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["y" /* getProductItemById */],function(productItem){return!!(productItem&&productItem.get('isToggling',false));});var getIsSaving=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["y" /* getProductItemById */],function(productItem){return!!(productItem&&productItem.get('isSaving',false));});var getHSVForBulb=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["J" /* getStateForProduct */],function(state){var h=state.get('hue');var s=state.get('saturation');var v=state.get('value');return[h,s<=0?defaultSaturation:s,v];});var getTemperatureForBulb=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["J" /* getStateForProduct */],function(state){return state&&state.get('colourTemperature');});var getCanChangeToWhite=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([Object(__WEBPACK_IMPORTED_MODULE_3__config_selectors__["b" /* getConfigBound */])('features:installPhilipsHue'),getWhetherProductHasCapability({capability:__WEBPACK_IMPORTED_MODULE_5__constants_devices__["capabilities"].LIGHT_WHITE}),__WEBPACK_IMPORTED_MODULE_2__selectors__["L" /* getTypeForProduct */]],function(isReadyForHueLights,canChangeToWhite,bulbType){return isReadyForHueLights?canChangeToWhite:__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceTypes"].COLOR_LIGHT===bulbType;});var getNameForBulb=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["J" /* getStateForProduct */],function(state){return state&&state.get('name');});var getColorModeForBulb=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["J" /* getStateForProduct */],function(state){return state&&state.get('colourMode');});var getBrightnessForBulb=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2__selectors__["y" /* getProductItemById */],getColorModeForBulb,function(productItem,mode){return productItem&&mode==='COLOUR'?productItem.getIn(['state','value'],0):productItem.getIn(['state','brightness'],0);});var getIsSchedulable=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getWhetherProductHasCapability({capability:__WEBPACK_IMPORTED_MODULE_5__constants_devices__["capabilities"].SCHEDULE}),__WEBPACK_IMPORTED_MODULE_2__selectors__["m" /* getIsGroupForProduct */],__WEBPACK_IMPORTED_MODULE_2__selectors__["n" /* getIsHueProduct */],Object(__WEBPACK_IMPORTED_MODULE_3__config_selectors__["b" /* getConfigBound */])('features:installPhilipsHue'),Object(__WEBPACK_IMPORTED_MODULE_3__config_selectors__["b" /* getConfigBound */])('features:devicegroupSchedule'),Object(__WEBPACK_IMPORTED_MODULE_3__config_selectors__["b" /* getConfigBound */])('features:hueSchedule')],function(isCapable,isGroup,isHueProduct,bulbCapabilitesExist,groupScheduleEnabled,hueScheduleEnabled){if(isGroup){return!!groupScheduleEnabled;}if(isHueProduct){return!!hueScheduleEnabled;}return bulbCapabilitesExist?isCapable:true;});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deviceTypeToIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sensorLogTypeToIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__ = __webpack_require__(20);
var _deviceTypes$BOILER_M,_deviceTypes$HUB,_deviceTypes$THERMOST,_deviceTypes$THERMOST2,_deviceTypes$ACTIVE_P,_typeAndModelIconMap,_plugsAndRegionIconMa;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
// productTypeToIcon() has been moved to ../core/icons/svg-icons/map
// Left here for reference.
// Please remove/delete file when the other two functions (deviceTypeToIcon/sensorLogTypeToIcon) have been moved (if necessary)
export const productTypeToIcon = ({
    type,
    localeSuffix = 'UK',
    model
}: {
    type: DeviceType,
    localeSuffix?: Region,
    model?: DeviceModel
}): DevicesIcon => {
    // $FlowFixMe
    const iconMap: { [DeviceType]: DevicesIcon } = {
        [deviceTypes.COLOR_TUNEABLE_LIGHT]: devicesIcons.LIGHT,
        [deviceTypes.COLOR_LIGHT]: devicesIcons.LIGHT,
        [deviceTypes.CONTACT_SENSOR]: devicesIcons.DOOR_SENSOR,
        [deviceTypes.HEATING]: devicesIcons.HEATING,
        [deviceTypes.HIVE_BUTTON]: devicesIcons.HIVE_BUTTON,
        [deviceTypes.HIVE_CAMERA]: devicesIcons.CAMERA_DEHARO,
        [deviceTypes.HOT_WATER]: devicesIcons.HOT_WATER,
        [deviceTypes.LEAK_SENSOR]: devicesIcons.LEAK_SENSOR,
        [deviceTypes.MOTION_SENSOR]: devicesIcons.MOTION_SENSOR,
        [deviceTypes.NA_THERMOSTAT]: devicesIcons.FLAME_NA,
        [deviceTypes.PRODUCT_GROUP]: generalIcons.GROUP_CONTROL,
        [deviceTypes.SIGNAL_BOOSTER]: devicesIcons.SIGNAL_BOOST,
        [deviceTypes.SENSE]: devicesIcons.SENSE,
        [deviceTypes.TUNEABLE_LIGHT]: devicesIcons.LIGHT,
        [deviceTypes.WARM_WHITE_LIGHT]: devicesIcons.LIGHT
    };

    const regionSpecificIconMap: { [DeviceType]: { [Region]: DevicesIcon } } = {
        [deviceTypes.ACTIVE_PLUG]: {
            [regions.EU]: devicesIcons.PLUG_EU,
            [regions.IN]: devicesIcons.PLUG_IN,
            [regions.NA]: devicesIcons.PLUG_NA,
            [regions.UK]: devicesIcons.PLUG_UK
        },
        [deviceTypes.SMART_PLUG]: {
            [regions.EU]: devicesIcons.PLUG_EU,
            [regions.IN]: devicesIcons.PLUG_IN,
            [regions.NA]: devicesIcons.PLUG_NA,
            [regions.UK]: devicesIcons.PLUG_UK
        }
    };

    return (
        iconMap[type] ||
        // $FlowFixMe
        (typeAndModelIconMap[type] && typeAndModelIconMap[type][model]) ||
        (regionSpecificIconMap[type] && regionSpecificIconMap[type][localeSuffix]) ||
        devicesIcons.LINKED
    );
};*/var typeAndModelIconMap=(_typeAndModelIconMap={},_defineProperty(_typeAndModelIconMap,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].BOILER_MODULE,(_deviceTypes$BOILER_M={},_defineProperty(_deviceTypes$BOILER_M,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLR1,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].BOILER_MODULE_SLR1),_defineProperty(_deviceTypes$BOILER_M,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLR2,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].BOILER_MODULE_SLR2),_deviceTypes$BOILER_M)),_defineProperty(_typeAndModelIconMap,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].HUB,(_deviceTypes$HUB={},_defineProperty(_deviceTypes$HUB,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].NANO1,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].HUB_NANO1),_defineProperty(_deviceTypes$HUB,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].NANO2,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].HUB_NANO2),_defineProperty(_deviceTypes$HUB,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SENSE,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].SENSE),_deviceTypes$HUB)),_defineProperty(_typeAndModelIconMap,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].THERMOSTAT,(_deviceTypes$THERMOST={},_defineProperty(_deviceTypes$THERMOST,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLT1,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT1),_defineProperty(_deviceTypes$THERMOST,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLT2,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT2),_defineProperty(_deviceTypes$THERMOST,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLT3,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3),_defineProperty(_deviceTypes$THERMOST,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLT3b,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3),_deviceTypes$THERMOST)),_defineProperty(_typeAndModelIconMap,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].THERMOSTAT_UI,(_deviceTypes$THERMOST2={},_defineProperty(_deviceTypes$THERMOST2,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLT1,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT1),_defineProperty(_deviceTypes$THERMOST2,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLT2,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT2),_defineProperty(_deviceTypes$THERMOST2,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLT3,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3),_defineProperty(_deviceTypes$THERMOST2,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLT3b,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3),_deviceTypes$THERMOST2)),_defineProperty(_typeAndModelIconMap,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].ACTIVE_PLUG,(_deviceTypes$ACTIVE_P={},_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLP2d,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].PLUG_EU),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLP2c,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].PLUG_NA),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLP2b,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].PLUG_UK),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceModels"].SLP2,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].PLUG_UK),_deviceTypes$ACTIVE_P)),_typeAndModelIconMap);var plugsAndRegionIconMap=(_plugsAndRegionIconMa={},_defineProperty(_plugsAndRegionIconMa,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["regions"].EU,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].PLUG_EU),_defineProperty(_plugsAndRegionIconMa,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["regions"].IN,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].PLUG_IN),_defineProperty(_plugsAndRegionIconMa,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["regions"].NA,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].PLUG_NA),_defineProperty(_plugsAndRegionIconMa,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["regions"].UK,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].PLUG_UK),_plugsAndRegionIconMa);var deviceTypeToIcon=function deviceTypeToIcon(_ref){var model=_ref.model,type=_ref.type,_ref$localeSuffix=_ref.localeSuffix,localeSuffix=_ref$localeSuffix===undefined?__WEBPACK_IMPORTED_MODULE_0__constants_devices__["regions"].UK:_ref$localeSuffix;var defaultIcon=__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].LINKED;if(__WEBPACK_IMPORTED_MODULE_0__constants_devices__["devicesWithModelVariations"].includes(type)&&model){return typeAndModelIconMap[type]&&typeAndModelIconMap[type][model]||__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].LINKED;}if(type===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].NA_THERMOSTAT){return __WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].THERMOSTAT_SLT3;}if(__WEBPACK_IMPORTED_MODULE_0__constants_devices__["bulbTypes"].includes(type)){return __WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].LIGHT;}if(__WEBPACK_IMPORTED_MODULE_0__constants_devices__["plugTypes"].includes(type)){return plugsAndRegionIconMap[localeSuffix]||defaultIcon;}if(type===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].CONTACT_SENSOR){return __WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].DOOR_SENSOR;}if(type===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].MOTION_SENSOR){return __WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].MOTION_SENSOR;}if(type===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].SIGNAL_BOOSTER){return __WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].SIGNAL_BOOST;}if(type===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].LEAK_SENSOR){return __WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].LEAK_SENSOR;}if(type===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].HUE_BRIDGE){return __WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].PHILIPS_HUE_BRIDGE;}if(type===__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].HIVE_CAMERA){return __WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].CAMERA_DEHARO;}return defaultIcon;};var sensorLogTypeToIcon=function sensorLogTypeToIcon(type,sensor){var senseLogIconMap=new Map([[true,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].LINKED],[sensor===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["a" /* senseSensorTypes */].SMOKE_CO,__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].SMOKE_CO],[sensor===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["a" /* senseSensorTypes */].GLASS_BREAK,__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].GLASS_BREAK],[sensor===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["a" /* senseSensorTypes */].DOG_BARK,__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].DOG_BARK]]);var eventLogIconMap=new Map([[true,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].LINKED],[type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].SOUND,senseLogIconMap.get(true)],[type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].UNMUTE,__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].MONITORING_ON],[type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].MUTE,__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].MONITORING_OFF],[type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].CLOSED||type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].OPENED,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].DOOR_SENSOR],[type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].MOTION,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].MOTION_SENSOR],[type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].FLOW_DETECTED||type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].LEAK_DETECTED||type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].LEAK_FIXED||type===__WEBPACK_IMPORTED_MODULE_1__constants_sensor_logs__["b" /* sensorLogTypes */].USER_INTENDED_USAGE,__WEBPACK_IMPORTED_MODULE_2__constants_icons_devices_svg__["a" /* default */].WATER_FLOWING]]);return eventLogIconMap.get(true);};

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INSTALL_HUB_STAGES_GOOD_PLACEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INSTALL_HUB_STAGES_BAD_PLACEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INSTALL_HUB_STAGES_INSTALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INSTALL_HUB_STAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ATTEMPT_CLAIM_HUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PROGRESS_INSTALL_STAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLAIM_HUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_CLAIM_HUB_ERROR; });
var INSTALL_HUB_STAGES_GOOD_PLACEMENT='hive/installHub/INSTALL_HUB_STAGES_GOOD_PLACEMENT';var INSTALL_HUB_STAGES_BAD_PLACEMENT='hive/installHub/INSTALL_HUB_STAGES_BAD_PLACEMENT';var INSTALL_HUB_STAGES_INSTALL='hive/installHub/INSTALL_HUB_STAGES_INSTALL';var INSTALL_HUB_STAGES=[INSTALL_HUB_STAGES_GOOD_PLACEMENT,INSTALL_HUB_STAGES_BAD_PLACEMENT,INSTALL_HUB_STAGES_INSTALL];// Constants
var ATTEMPT_CLAIM_HUB='hive/installHub/ATTEMPT_CLAIM_HUB';var PROGRESS_INSTALL_STAGE='hive/installHub/PROGRESS_INSTALL_STAGE';var CLAIM_HUB='hive/installHub/CLAIM_HUB';var RESET_CLAIM_HUB_ERROR='hive/installHub/RESET_CLAIM_HUB_ERROR';

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menuTemplates; });
var menuTemplates={SHOP:'SHOP'};

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOG_BARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GLASS_BREAK; });
/* unused harmony export SENSE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SMOKE_CO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VALID_SENSOR_TYPES; });
var DOG_BARK='DOG_BARK';var GLASS_BREAK='GLASS_BREAK';var SENSE='SENSE';var SMOKE_CO='SMOKE_CO';var VALID_SENSOR_TYPES=[DOG_BARK,GLASS_BREAK,SMOKE_CO];

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cookiesLoaded; });
/* unused harmony export setCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cookieSet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var loadCookies=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* LOAD_COOKIES */]);var cookiesLoaded=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* COOKIES_LOADED */]);var setCookie=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_COOKIE */]);var cookieSet=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* COOKIE_SET */]);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_BOOST_HEATING_HOTWATER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_HOT_WATER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_HOT_WATER_STATUS_SUCCESSFUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_HOT_WATER_STATUS_UPDATE_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STOP_BOOST_HEATING_HOTWATER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TIMEOUT_BOOST_HEATING_HOTWATER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_HOT_WATER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOGGLE_HOT_WATER_DONE; });
var SET_BOOST_HEATING_HOTWATER='hive/heating-hotwater/boost/set';var SET_HOT_WATER_STATUS='hive/heating-hotwater/status/set';var SET_HOT_WATER_STATUS_SUCCESSFUL='hive/heating-hotwater/status/set-success';var SET_HOT_WATER_STATUS_UPDATE_PRODUCT='hive/heating-hotwater/status/set-update-product';var STOP_BOOST_HEATING_HOTWATER='hive/heating-hotwater/boost/stop';var TIMEOUT_BOOST_HEATING_HOTWATER='hive/heating-hotwater/boost/timeout';var TOGGLE_HOT_WATER='hive/heating-hotwater/toggle';var TOGGLE_HOT_WATER_DONE='hive/heating-hotwater/toggle-done';

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setBoostHeatingHotwater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setHotWaterStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setHotWaterStatusSuccessful; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setHotWaterStatusUpdateProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stopBoostHeatingHotwater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return timeoutBoostHeatingHotwater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleHotWater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return toggleHotWaterDone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var setBoostHeatingHotwater=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SET_BOOST_HEATING_HOTWATER */]);var setHotWaterStatus=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SET_HOT_WATER_STATUS */]);var setHotWaterStatusSuccessful=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SET_HOT_WATER_STATUS_SUCCESSFUL */]);var setHotWaterStatusUpdateProduct=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SET_HOT_WATER_STATUS_UPDATE_PRODUCT */]);var stopBoostHeatingHotwater=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* STOP_BOOST_HEATING_HOTWATER */]);var timeoutBoostHeatingHotwater=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* TIMEOUT_BOOST_HEATING_HOTWATER */]);var toggleHotWater=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* TOGGLE_HOT_WATER */]);var toggleHotWaterDone=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* TOGGLE_HOT_WATER_DONE */]);

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getStartEndTimeFromPeriod;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return daysBetween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customDuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__numbers__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(1794);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
function getStartEndTimeFromPeriod(period){var _periodFnLookup;var now=arguments.length>1&&arguments[1]!==undefined?arguments[1]:__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()();var periodFnLookup=(_periodFnLookup={},_defineProperty(_periodFnLookup,__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* periods */].TODAY.constant,function(){return getDayStartEndTimes(now);}),_defineProperty(_periodFnLookup,__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* periods */].YESTERDAY.constant,function(){return getDayStartEndTimes(now,-1);}),_defineProperty(_periodFnLookup,__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* periods */].THIS_WEEK.constant,function(){return getWeekStartEndTimes(now);}),_defineProperty(_periodFnLookup,__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* periods */].LAST_WEEK.constant,function(){return getWeekStartEndTimes(now,-1);}),_defineProperty(_periodFnLookup,__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* periods */].THIS_MONTH.constant,function(){return getMonthStartEndTimes(now);}),_defineProperty(_periodFnLookup,__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* periods */].LAST_MONTH.constant,function(){return getMonthStartEndTimes(now,-1);}),_defineProperty(_periodFnLookup,__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* periods */].THIS_YEAR.constant,function(){return getYearStartEndTimes(now);}),_periodFnLookup);return periodFnLookup[period.constant]();}function getDayStartEndTimes(now){var dayOffset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var startOfDay=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(now).startOf('day').add(dayOffset,'d').startOf('day');var endOfDay=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(startOfDay).endOf('day');return{start:startOfDay,end:endOfDay};}function getWeekStartEndTimes(now){var weekOffset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var startOfWeek=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(now).add(weekOffset,'w').startOf('week').add(-1,'d');var endOfWeek=weekOffset===0?__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(now):__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(startOfWeek).add(1,'d').endOf('week').add(-1,'d');return{start:startOfWeek,end:endOfWeek};}function getMonthStartEndTimes(now){var monthOffset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var startOfMonth=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(now).add(monthOffset,'M').startOf('month');var endOfMonth=monthOffset===0?__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(now):__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(startOfMonth).endOf('month');return{start:startOfMonth,end:endOfMonth};}function getYearStartEndTimes(now){var yearOffset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var startOfYear=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(now).add(yearOffset,'y').startOf('year');var endOfYear=yearOffset===0?__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(now):__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(startOfYear).endOf('year');return{start:startOfYear,end:endOfYear};}var daysBetween=function daysBetween(start,end){var startOfFinish=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(end).startOf('day');var current=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(start).startOf('day');var days=[];while(current.isSameOrBefore(startOfFinish)){days.push(current);current=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(current).add(1,'day');}return days;};var customDuration=function customDuration(start,end){var duration=__WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.duration(end-start);var message=void 0;if(duration.asSeconds()<1)message=__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].durationMiliseconds;else if(duration.asHours()>=1)message=__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].durationHours;else message=__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].durationMinutes;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({},message,{values:{hours:Math.floor(duration.asHours()),minutes:Object(__WEBPACK_IMPORTED_MODULE_4__numbers__["a" /* padNumber */])(Math.floor(duration.asMinutes())),seconds:Object(__WEBPACK_IMPORTED_MODULE_4__numbers__["a" /* padNumber */])(duration.seconds())}}));};

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return features; });
var features={textNotifications:'textNotifications'};

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2162);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function StandardLayout(_ref){var children=_ref.children,className=_ref.className,props=_objectWithoutProperties(_ref,['children','className']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StandardLayoutContainer */],{className:className,'data-qa':props['data-qa']},children);}/* harmony default export */ __webpack_exports__["a"] = (StandardLayout);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/* unused harmony export Icon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MainIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Popup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ShadowMask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Item; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ItemIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ItemCaption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ItemCaptionContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    from { transform: scale3d(1, 0, 1) }\n    to { transform: scale3d(1, 1, 1) }\n'],['\n    from { transform: scale3d(1, 0, 1) }\n    to { transform: scale3d(1, 1, 1) }\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: ','em;\n    outline: none;\n    position: relative;\n    width: ','em;\n    transition: background-color 0.2s ease-out;\n\n    &:focus {\n        background-color: ',';\n    }\n'],['\n    height: ','em;\n    outline: none;\n    position: relative;\n    width: ','em;\n    transition: background-color 0.2s ease-out;\n\n    &:focus {\n        background-color: ',';\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    height: ','em;\n    padding: ','em;\n    width: ','em;\n'],['\n    height: ','em;\n    padding: ','em;\n    width: ','em;\n']),_templateObject4=_taggedTemplateLiteral(['\n    border-radius: ','em ','em 0 0;\n    box-shadow: ',';\n    cursor: pointer;\n\n    & > g {\n        fill: ',';\n    }\n'],['\n    border-radius: ','em ','em 0 0;\n    box-shadow: ',';\n    cursor: pointer;\n\n    & > g {\n        fill: ',';\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    animation: ',' 0.1s ease-out forwards;\n    background-color: ',';\n    border-radius: ',';\n    box-shadow: 0 0 0.5em 1px ',';\n    overflow: hidden;\n    position: absolute;\n    right: ',';\n    top: ','em;\n    width: ','em;\n    z-index: 1;\n'],['\n    animation: ',' 0.1s ease-out forwards;\n    background-color: ',';\n    border-radius: ',';\n    box-shadow: 0 0 0.5em 1px ',';\n    overflow: hidden;\n    position: absolute;\n    right: ',';\n    top: ','em;\n    width: ','em;\n    z-index: 1;\n']),_templateObject6=_taggedTemplateLiteral(['\n    background-color: ',';\n    height: ','em;\n    position: absolute;\n    top: ','em;\n    width: ','em;\n    z-index: 2;\n'],['\n    background-color: ',';\n    height: ','em;\n    position: absolute;\n    top: ','em;\n    width: ','em;\n    z-index: 2;\n']),_templateObject7=_taggedTemplateLiteral(['\n    cursor: pointer;\n    display: flex;\n    height: ','em;\n    margin: 0.2em 0;\n\n    &:hover > div {\n        text-decoration: underline;\n    }\n'],['\n    cursor: pointer;\n    display: flex;\n    height: ','em;\n    margin: 0.2em 0;\n\n    &:hover > div {\n        text-decoration: underline;\n    }\n']),_templateObject8=_taggedTemplateLiteral(['\n    flex: 0 0 ','em;\n\n    & > g {\n        fill: ',';\n    }\n'],['\n    flex: 0 0 ','em;\n\n    & > g {\n        fill: ',';\n    }\n']),_templateObject9=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 1 0 auto;\n    justify-content: flex-start;\n    padding-left: 0.5em;\n'],['\n    align-items: center;\n    display: flex;\n    flex: 1 0 auto;\n    justify-content: flex-start;\n    padding-left: 0.5em;\n']),_templateObject10=_taggedTemplateLiteral(['\n    text-decoration: ',';\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    width: ','em;\n'],['\n    text-decoration: ',';\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    width: ','em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var POPUP_WIDTH=12;var RADIUS=0.25;var SIZE=2.2;var reveal=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject);var Base=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,SIZE,SIZE,function(p){return p.selected?'inherit':p.theme.lightGrey;});var Icon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject3,SIZE,SIZE*0.2,SIZE);var MainIcon=Icon.extend(_templateObject4,RADIUS,RADIUS,function(p){return p.selected?'0 0 0.5em 1px '+p.theme.secondaryHeavy:'none';},function(p){return p.theme.secondaryHeavy;});var Popup=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,reveal,function(p){return p.theme.white;},function(p){return p.left?RADIUS+'em 0 '+RADIUS+'em '+RADIUS+'em':'0 '+RADIUS+'em '+RADIUS+'em '+RADIUS+'em';},function(p){return p.theme.secondaryHeavy;},function(p){return p.left?'0':'inherit';},SIZE,POPUP_WIDTH);var ShadowMask=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject6,function(p){return p.theme.white;},SIZE*0.2,SIZE*0.8,SIZE);var Item=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject7,SIZE);var ItemIcon=Icon.extend(_templateObject8,SIZE,function(p){return p.theme.fontColor;});var ItemCaption=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject9);var ItemCaptionContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject10,function(p){return p.selected?'underline':'inherit';},POPUP_WIDTH-SIZE-0.5);

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changePicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPickerNameForProduct; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__(68);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// ACTIONS
var CHANGE_PICKER='hive/bulbs/CHANGE_PICKER';var changePicker=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(CHANGE_PICKER);// SELECTORS
var getBulbUi=function getBulbUi(state){return state.bulbsUi;};var getPickerNameForProduct=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getBulbUi,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */],function(bulbUi,id){return bulbUi.get(id);});// REDUCERS
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])(_defineProperty({},CHANGE_PICKER,function(state,_ref){var _ref$payload=_ref.payload,productId=_ref$payload.productId,pickerType=_ref$payload.pickerType;// $FlowFixMe
return state.set(productId,pickerType);}),Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({})));

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return attemptValidateToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validateToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return attemptAcceptInvite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acceptInvite; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
var attemptValidateToken=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/connected-care-invite/ATTEMPT_VALIDATE_TOKEN');var validateToken=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/connected-care-invite/VALIDATE_TOKEN');var attemptAcceptInvite=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/connected-care-invite/ATTEMPT_ACCEPT_INVITE');var acceptInvite=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])('hive/connected-care-invite/ACCEPT_INVITE');

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GROUP_SIZE; });
var GROUP_SIZE=7;

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__ = __webpack_require__(780);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var IdentityTabRenderer=function IdentityTabRenderer(_ref){var maybeIcon=_ref.maybeIcon,label=_ref.label,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',{onClick:onClick},maybeIcon,label);};var getLength=function getLength(children){return Array.isArray(children)?children.length:children?1:0;};var Tab=function Tab(_ref2){var children=_ref2.children,icon=_ref2.icon,onClick=_ref2.onClick,selected=_ref2.selected,_ref2$RenderTab=_ref2.RenderTab,RenderTab=_ref2$RenderTab===undefined?IdentityTabRenderer:_ref2$RenderTab,rest=_objectWithoutProperties(_ref2,['children','icon','onClick','selected','RenderTab']);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Item */],{selected:selected},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RenderTab,Object.assign({label:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Label */],null,children),maybeIcon:icon&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* TabIcon */],{selected:selected,type:icon}),onClick:onClick},rest)));};var Tabs=function(_React$Component){_inherits(Tabs,_React$Component);function Tabs(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,Tabs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=Tabs.__proto__||Object.getPrototypeOf(Tabs)).call.apply(_ref3,[this].concat(args))),_this),_this.keyDown=function(e){var _switchCase;var switchCase=(_switchCase={},_defineProperty(_switchCase,__WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__["a" /* default */].ARROW_LEFT,function(){e.preventDefault();var _this$props=_this.props,_this$props$onTabChan=_this$props.onTabChange,onTabChange=_this$props$onTabChan===undefined?__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default.a:_this$props$onTabChan,selectedTabIndex=_this$props.selectedTabIndex;if(selectedTabIndex>0){onTabChange(selectedTabIndex-1);}}),_defineProperty(_switchCase,__WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__["a" /* default */].ARROW_RIGHT,function(){e.preventDefault();var _this$props2=_this.props,children=_this$props2.children,_this$props2$onTabCha=_this$props2.onTabChange,onTabChange=_this$props2$onTabCha===undefined?__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default.a:_this$props2$onTabCha,selectedTabIndex=_this$props2.selectedTabIndex;if(selectedTabIndex<getLength(children)-1){onTabChange(selectedTabIndex+1);}}),_switchCase);if(typeof switchCase[e.keyCode]==='function'){switchCase[e.keyCode]();}else if(e.keyCode>=__WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__["a" /* default */].KEY_1&&e.keyCode<=__WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__["a" /* default */].KEY_9){var _this$props3=_this.props,_children=_this$props3.children,_this$props3$onTabCha=_this$props3.onTabChange,_onTabChange=_this$props3$onTabCha===undefined?__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default.a:_this$props3$onTabCha,_selectedTabIndex=_this$props3.selectedTabIndex;var digit=e.keyCode-48;// cast the key number into the range [1-9]
if(digit!==_selectedTabIndex+1&&digit<=getLength(_children)){_onTabChange(digit-1);}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tabs,[{key:'render',value:function render(){var _props=this.props,children=_props.children,maxWidth=_props.maxWidth,_props$onTabChange=_props.onTabChange,onTabChange=_props$onTabChange===undefined?__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default.a:_props$onTabChange,selectedTabIndex=_props.selectedTabIndex,renderTab=_props.renderTab;var childrenWithProps=__WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children,function(child,index){return(// $FlowFixMe
__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child,{onClick:selectedTabIndex===index?null:function(){return onTabChange(index);},selected:selectedTabIndex===index,RenderTab:renderTab}));});return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Base */],{onKeyDown:this.keyDown,tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* TabContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* List */],{maxWidth:maxWidth},childrenWithProps)));}}]);return Tabs;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);Tabs.Item=Tab;Tabs.defaultProps={selectedTabIndex:0};/* harmony default export */ __webpack_exports__["a"] = (Tabs);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
/**
 * Takes a React Component and an interval for how often that Component should be updated.
 * Every interval the component will be rendered and have the current time passed when rendered.
 *
 * @param  {Component} WrappedComponent the Component to wrap
 * @param  {Number} interval         	the number of milliseconds per update
 * @return {[type]}                  [description]
 *//* harmony default export */ __webpack_exports__["a"] = (function(WrappedComponent,interval){var IntervalUpdate=function(_Component){_inherits(IntervalUpdate,_Component);function IntervalUpdate(){_classCallCheck(this,IntervalUpdate);return _possibleConstructorReturn(this,(IntervalUpdate.__proto__||Object.getPrototypeOf(IntervalUpdate)).apply(this,arguments));}_createClass(IntervalUpdate,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this._interval=setInterval(function(){_this2.forceUpdate();},interval);}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this._interval){clearInterval(this._interval);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent,this.props);}}]);return IntervalUpdate;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// This is here because if it's a class property then shallow rendering won't see it
var displayName='intervalUpdate('+(WrappedComponent.displayName||WrappedComponent.name||'Component')+')';IntervalUpdate.displayName=displayName;return IntervalUpdate;});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRANSITION_ENTER_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSITION_ENTER_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRANSITION_EXIT_DURATION; });
var TRANSITION_ENTER_DELAY=200;var TRANSITION_ENTER_DURATION=600;var TRANSITION_EXIT_DURATION=400;

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_isEqual__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_tone_picker_white_png__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_tone_picker_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_tone_picker_white_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_tone_picker_colour_png__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_tone_picker_colour_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_tone_picker_colour_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__widgets_flipper_rgb_flipper__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__menu__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__standard_brightness_picker__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dimmer_menu__ = __webpack_require__(2417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__picker_menu__ = __webpack_require__(2418);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var offWhiteSample1=[255,223,203];var offWhiteSample2=[255,224,204];var isOffWhiteColour=function isOffWhiteColour(canChangeToWhite,rgb){return canChangeToWhite&&(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_isEqual___default()(rgb,offWhiteSample1)||__WEBPACK_IMPORTED_MODULE_1_lodash_fp_isEqual___default()(rgb,offWhiteSample2));};var ColorTuneable=function(_Component){_inherits(ColorTuneable,_Component);function ColorTuneable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ColorTuneable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ColorTuneable.__proto__||Object.getPrototypeOf(ColorTuneable)).call.apply(_ref,[this].concat(args))),_this),_this.state={showBrightnessPicker:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ColorTuneable,[{key:'switchComponent',value:function switchComponent(showBrightnessPicker){this.setState({showBrightnessPicker:showBrightnessPicker});}},{key:'switchPicker',value:function switchPicker(){var showBrightnessPicker=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;this.setState({showBrightnessPicker:showBrightnessPicker});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,activePicker=_props.activePicker,additionalMenuItems=_props.additionalMenuItems,bulbBrightness=_props.bulbBrightness,bulbColorMode=_props.bulbColorMode,bulbType=_props.bulbType,changeColor=_props.changeColor,changeColorMode=_props.changeColorMode,changePicker=_props.changePicker,debug=_props.debug,defaultsForBulbs=_props.defaultsForBulbs,delayRendering=_props.delayRendering,_props$handleRadiusPe=_props.handleRadiusPercent,handleRadiusPercent=_props$handleRadiusPe===undefined?5:_props$handleRadiusPe,isOn=_props.isOn,isSaving=_props.isSaving,isSmall=_props.isSmall,isToggling=_props.isToggling,isTuneable=_props.isTuneable,canChangeToWhite=_props.canChangeToWhite,logger=_props.logger,_props$pickerDepthPer=_props.pickerDepthPercent,pickerDepthPercent=_props$pickerDepthPer===undefined?5:_props$pickerDepthPer,productId=_props.productId,rangeValue=_props.rangeValue,rgb=_props.rgb,toggleLightbulb=_props.toggleLightbulb,valueChanged=_props.valueChanged;var showBrightnessPicker=this.state.showBrightnessPicker;var tuneablePickerActive=isTuneable&&bulbColorMode===__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["bulbModes"].white;var isWhite=canChangeToWhite&&isOffWhiteColour(canChangeToWhite,rgb);var rgbValue=isWhite?new Uint8ClampedArray([255,246,185]):rgb;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* BulbFlipperWrapper */],null,showBrightnessPicker||activePicker==='brightness'||isWhite?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__standard_brightness_picker__["a" /* default */],{isOn:isOn,isSaving:isSaving,isSmall:isSmall,isToggling:isToggling,isVariableColour:!tuneablePickerActive,rgb:rgbValue,toggleLightbulb:toggleLightbulb,value:bulbBrightness,valueChanged:valueChanged}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__widgets_flipper_rgb_flipper__["a" /* default */],{bulbBrightness:bulbBrightness,bulbType:bulbType,changeColor:changeColor,colourStartRadians:3.52,colourStopRadians:5.9,debug:debug,defaultsForBulbs:defaultsForBulbs,delayRendering:delayRendering,handleRadiusPercent:handleRadiusPercent,image:tuneablePickerActive?__WEBPACK_IMPORTED_MODULE_3__assets_images_tone_picker_white_png___default.a:__WEBPACK_IMPORTED_MODULE_4__assets_images_tone_picker_colour_png___default.a,isCustomRange:tuneablePickerActive,isOn:isOn,isSaving:isSaving,isSmall:isSmall,isToggling:isToggling,logger:logger,pickerDepthPercent:pickerDepthPercent,productId:productId,rangeValue:rangeValue,rgb:rgbValue,toggleLightbulb:toggleLightbulb}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__menu__["b" /* MenuContainer */],{isSmall:isSmall},showBrightnessPicker||activePicker==='brightness'||isWhite?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__dimmer_menu__["a" /* default */],{additionalItems:additionalMenuItems,isOn:isOn,onClick:function onClick(){if(changePicker){changePicker({productId:productId,pickerType:tuneablePickerActive?'white':'colour'});}else{var showBrightness=isWhite&&changeColor?false:!showBrightnessPicker;_this2.switchComponent(showBrightness);}if(isWhite&&changeColor){changeColor({hsv:{h:0,s:100},mode:__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["bulbModes"].colour,productId:productId});}},temperaturePickerActive:tuneablePickerActive}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__picker_menu__["a" /* default */],{additionalItems:additionalMenuItems,canChangeToWhite:canChangeToWhite,isOn:isOn,isTuneable:isTuneable,switchPicker:function switchPicker(){_this2.switchPicker();changeColorMode({mode:tuneablePickerActive?__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["bulbModes"].colour:__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["bulbModes"].white,productId:productId});},temperaturePickerActive:tuneablePickerActive,toggleDimmer:function toggleDimmer(){if(changePicker){changePicker({pickerType:'brightness',productId:productId});}else{_this2.switchComponent(!showBrightnessPicker);}},toggleWhite:function toggleWhite(){if(changeColor){changeColor({hsv:{h:defaultsForBulbs.get('offWhiteHue'),s:defaultsForBulbs.get('offWhiteSaturation')},mode:__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["bulbModes"].white,pickerType:'brightness',productId:productId});}}})));}}]);return ColorTuneable;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ColorTuneable);

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(1019);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(150),
    metaMap = __webpack_require__(541);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(542);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 544 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(546),
    composeArgsRight = __webpack_require__(547),
    countHolders = __webpack_require__(1036),
    createCtor = __webpack_require__(276),
    createRecurry = __webpack_require__(548),
    getHolder = __webpack_require__(557),
    reorder = __webpack_require__(1047),
    replaceHolders = __webpack_require__(368),
    root = __webpack_require__(52);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 546 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(549),
    setData = __webpack_require__(551),
    setWrapToString = __webpack_require__(553);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(361),
    getData = __webpack_require__(363),
    getFuncName = __webpack_require__(550),
    lodash = __webpack_require__(1038);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(1037);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(540),
    shortOut = __webpack_require__(552);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 552 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(1040),
    insertWrapDetails = __webpack_require__(1041),
    setToString = __webpack_require__(366),
    updateWrapDetails = __webpack_require__(1044);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(556),
    baseIsNaN = __webpack_require__(1045),
    strictIndexOf = __webpack_require__(1046);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 557 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(152),
    keys = __webpack_require__(108);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1050),
    isArguments = __webpack_require__(226),
    isArray = __webpack_require__(32),
    isBuffer = __webpack_require__(227),
    isIndex = __webpack_require__(223),
    isTypedArray = __webpack_require__(281);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(543);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188)(module)))

/***/ }),
/* 561 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(52);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188)(module)))

/***/ }),
/* 563 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(230),
    getPrototype = __webpack_require__(377),
    getSymbols = __webpack_require__(375),
    stubArray = __webpack_require__(563);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(566),
    getSymbols = __webpack_require__(375),
    keys = __webpack_require__(108);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(230),
    isArray = __webpack_require__(32);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(52);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(379);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(277),
    getPrototype = __webpack_require__(377),
    isPrototype = __webpack_require__(229);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(290),
    arraySome = __webpack_require__(572),
    cacheHas = __webpack_require__(291);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 572 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 574 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1104);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(374);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(185),
    arrayMap = __webpack_require__(82),
    isArray = __webpack_require__(32),
    isSymbol = __webpack_require__(187);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1105),
    hasPath = __webpack_require__(1106);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(231);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(278);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(293),
    baseSet = __webpack_require__(582),
    castPath = __webpack_require__(189);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(280),
    castPath = __webpack_require__(189),
    isIndex = __webpack_require__(223),
    isObject = __webpack_require__(54),
    toKey = __webpack_require__(153);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(34) && !__webpack_require__(25)(function(){
  return Object.defineProperty(__webpack_require__(385)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(33);

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(56)
  , toIObject    = __webpack_require__(64)
  , arrayIndexOf = __webpack_require__(296)(false)
  , IE_PROTO     = __webpack_require__(387)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(35)
  , anObject = __webpack_require__(16)
  , getKeys  = __webpack_require__(156);

module.exports = __webpack_require__(34) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(64)
  , gOPN      = __webpack_require__(159).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(156)
  , gOPS     = __webpack_require__(297)
  , pIE      = __webpack_require__(233)
  , toObject = __webpack_require__(48)
  , IObject  = __webpack_require__(232)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(25)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction  = __webpack_require__(63)
  , isObject   = __webpack_require__(31)
  , invoke     = __webpack_require__(298)
  , arraySlice = [].slice
  , factories  = {};

var construct = function(F, len, args){
  if(!(len in factories)){
    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /*, args... */){
  var fn       = aFunction(this)
    , partArgs = arraySlice.call(arguments, 1);
  var bound = function(/* args... */){
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if(isObject(fn.prototype))bound.prototype = fn.prototype;
  return bound;
};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(22).parseInt
  , $trim     = __webpack_require__(192).trim
  , ws        = __webpack_require__(392)
  , hex       = /^[\-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(22).parseFloat
  , $trim       = __webpack_require__(192).trim;

module.exports = 1 / $parseFloat(__webpack_require__(392) + '-0') !== -Infinity ? function parseFloat(str){
  var string = $trim(String(str), 3)
    , result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(83);
module.exports = function(it, msg){
  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
  return +it;
};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(31)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x){
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(16);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(63)
  , toObject  = __webpack_require__(48)
  , IObject   = __webpack_require__(232)
  , toLength  = __webpack_require__(43);

module.exports = function(that, callbackfn, aLen, memo, isRight){
  aFunction(callbackfn);
  var O      = toObject(that)
    , self   = IObject(O)
    , length = toLength(O.length)
    , index  = isRight ? length - 1 : 0
    , i      = isRight ? -1 : 1;
  if(aLen < 2)for(;;){
    if(index in self){
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if(isRight ? index < 0 : length <= index){
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(48)
  , toIndex  = __webpack_require__(157)
  , toLength = __webpack_require__(43);

module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
  var O     = toObject(this)
    , len   = toLength(O.length)
    , to    = toIndex(target, len)
    , from  = toIndex(start, len)
    , end   = arguments.length > 2 ? arguments[2] : undefined
    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
    , inc   = 1;
  if(from < to && to < from + count){
    inc  = -1;
    from += count - 1;
    to   += count - 1;
  }
  while(count-- > 0){
    if(from in O)O[to] = O[from];
    else delete O[to];
    to   += inc;
    from += inc;
  } return O;
};

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if(__webpack_require__(34) && /./g.flags != 'g')__webpack_require__(35).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(301)
});

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(602);

// 23.1 Map Objects
module.exports = __webpack_require__(303)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP          = __webpack_require__(35).f
  , create      = __webpack_require__(158)
  , redefineAll = __webpack_require__(162)
  , ctx         = __webpack_require__(110)
  , anInstance  = __webpack_require__(161)
  , defined     = __webpack_require__(84)
  , forOf       = __webpack_require__(195)
  , $iterDefine = __webpack_require__(398)
  , step        = __webpack_require__(599)
  , setSpecies  = __webpack_require__(160)
  , DESCRIPTORS = __webpack_require__(34)
  , fastKey     = __webpack_require__(136).fastKey
  , SIZE        = DESCRIPTORS ? '_s' : 'size';

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        anInstance(this, C, 'forEach');
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)dP(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(602);

// 23.2 Set Objects
module.exports = __webpack_require__(303)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each         = __webpack_require__(95)(0)
  , redefine     = __webpack_require__(62)
  , meta         = __webpack_require__(136)
  , assign       = __webpack_require__(588)
  , weak         = __webpack_require__(605)
  , isObject     = __webpack_require__(31)
  , getWeak      = meta.getWeak
  , isExtensible = Object.isExtensible
  , uncaughtFrozenStore = weak.ufstore
  , tmp          = {}
  , InternalMap;

var wrapper = function(get){
  return function WeakMap(){
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key){
    if(isObject(key)){
      var data = getWeak(key);
      if(data === true)return uncaughtFrozenStore(this).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value){
    return weak.def(this, key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(303)('WeakMap', wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
  InternalMap = weak.getConstructor(wrapper);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function(key){
    var proto  = $WeakMap.prototype
      , method = proto[key];
    redefine(proto, key, function(a, b){
      // store frozen objects on internal weakmap shim
      if(isObject(a) && !isExtensible(a)){
        if(!this._f)this._f = new InternalMap;
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll       = __webpack_require__(162)
  , getWeak           = __webpack_require__(136).getWeak
  , anObject          = __webpack_require__(16)
  , isObject          = __webpack_require__(31)
  , anInstance        = __webpack_require__(161)
  , forOf             = __webpack_require__(195)
  , createArrayMethod = __webpack_require__(95)
  , $has              = __webpack_require__(56)
  , arrayFind         = createArrayMethod(5)
  , arrayFindIndex    = createArrayMethod(6)
  , id                = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function(that){
  return that._l || (that._l = new UncaughtFrozenStore);
};
var UncaughtFrozenStore = function(){
  this.a = [];
};
var findUncaughtFrozen = function(store, key){
  return arrayFind(store.a, function(it){
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key){
    var entry = findUncaughtFrozen(this, key);
    if(entry)return entry[1];
  },
  has: function(key){
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value){
    var entry = findUncaughtFrozen(this, key);
    if(entry)entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function(key){
    var index = arrayFindIndex(this.a, function(it){
      return it[0] === key;
    });
    if(~index)this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      anInstance(that, C, NAME, '_i');
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key){
        if(!isObject(key))return false;
        var data = getWeak(key);
        if(data === true)return uncaughtFrozenStore(this).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var data = getWeak(anObject(key), true);
    if(data === true)uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN     = __webpack_require__(159)
  , gOPS     = __webpack_require__(297)
  , anObject = __webpack_require__(16)
  , Reflect  = __webpack_require__(22).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
  var keys       = gOPN.f(anObject(it))
    , getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(43)
  , repeat   = __webpack_require__(394)
  , defined  = __webpack_require__(84);

module.exports = function(that, maxLength, fillString, left){
  var S            = String(defined(that))
    , stringLength = S.length
    , fillStr      = fillString === undefined ? ' ' : String(fillString)
    , intMaxLength = toLength(maxLength);
  if(intMaxLength <= stringLength || fillStr == '')return S;
  var fillLen = intMaxLength - stringLength
    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(156)
  , toIObject = __webpack_require__(64)
  , isEnum    = __webpack_require__(233).f;
module.exports = function(isEntries){
  return function(it){
    var O      = toIObject(it)
      , keys   = getKeys(O)
      , length = keys.length
      , i      = 0
      , result = []
      , key;
    while(length > i)if(isEnum.call(O, key = keys[i++])){
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(234)
  , from    = __webpack_require__(610);
module.exports = function(NAME){
  return function toJSON(){
    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(195);

module.exports = function(iter, ITERATOR){
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(1299)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1306);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";var e=[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}];return e});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function isObject(what) {
  return typeof what === 'object' && what !== null;
}

// Yanked from https://git.io/vS8DV re-used under CC0
// with some tiny modifications
function isError(value) {
  switch ({}.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

function isErrorEvent(value) {
  return supportsErrorEvent() && {}.toString.call(value) === '[object ErrorEvent]';
}

function isUndefined(what) {
  return what === void 0;
}

function isFunction(what) {
  return typeof what === 'function';
}

function isString(what) {
  return Object.prototype.toString.call(what) === '[object String]';
}

function isArray(what) {
  return Object.prototype.toString.call(what) === '[object Array]';
}

function isEmptyObject(what) {
  for (var _ in what) {
    if (what.hasOwnProperty(_)) {
      return false;
    }
  }
  return true;
}

function supportsErrorEvent() {
  try {
    new ErrorEvent(''); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function supportsFetch() {
  if (!('fetch' in _window)) return false;

  try {
    new Headers(); // eslint-disable-line no-new
    new Request(''); // eslint-disable-line no-new
    new Response(); // eslint-disable-line no-new
    return true;
  } catch (e) {
    return false;
  }
}

function wrappedCallback(callback) {
  function dataCallback(data, original) {
    var normalizedData = callback(data) || data;
    if (original) {
      return original(normalizedData) || normalizedData;
    }
    return normalizedData;
  }

  return dataCallback;
}

function each(obj, callback) {
  var i, j;

  if (isUndefined(obj.length)) {
    for (i in obj) {
      if (hasKey(obj, i)) {
        callback.call(null, i, obj[i]);
      }
    }
  } else {
    j = obj.length;
    if (j) {
      for (i = 0; i < j; i++) {
        callback.call(null, i, obj[i]);
      }
    }
  }
}

function objectMerge(obj1, obj2) {
  if (!obj2) {
    return obj1;
  }
  each(obj2, function(key, value) {
    obj1[key] = value;
  });
  return obj1;
}

/**
 * This function is only used for react-native.
 * react-native freezes object that have already been sent over the
 * js bridge. We need this function in order to check if the object is frozen.
 * So it's ok that objectFrozen returns false if Object.isFrozen is not
 * supported because it's not relevant for other "platforms". See related issue:
 * https://github.com/getsentry/react-native-sentry/issues/57
 */
function objectFrozen(obj) {
  if (!Object.isFrozen) {
    return false;
  }
  return Object.isFrozen(obj);
}

function truncate(str, max) {
  return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
}

/**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function hasKey(object, key) {
  return Object.prototype.hasOwnProperty.call(object, key);
}

function joinRegExp(patterns) {
  // Combine an array of regular expressions and strings into one large regexp
  // Be mad.
  var sources = [],
    i = 0,
    len = patterns.length,
    pattern;

  for (; i < len; i++) {
    pattern = patterns[i];
    if (isString(pattern)) {
      // If it's a string, we need to escape it
      // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
      sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
    } else if (pattern && pattern.source) {
      // If it's a regexp already, we want to extract the source
      sources.push(pattern.source);
    }
    // Intentionally skip other cases
  }
  return new RegExp(sources.join('|'), 'i');
}

function urlencode(o) {
  var pairs = [];
  each(o, function(key, value) {
    pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
  });
  return pairs.join('&');
}

// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
// intentionally using regex and not <a/> href parsing trick because React Native and other
// environments where DOM might not be available
function parseUrl(url) {
  var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!match) return {};

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    protocol: match[2],
    host: match[4],
    path: match[5],
    relative: match[5] + query + fragment // everything minus origin
  };
}
function uuid4() {
  var crypto = _window.crypto || _window.msCrypto;

  if (!isUndefined(crypto) && crypto.getRandomValues) {
    // Use window.crypto API if available
    // eslint-disable-next-line no-undef
    var arr = new Uint16Array(8);
    crypto.getRandomValues(arr);

    // set 4 in byte 7
    arr[3] = (arr[3] & 0xfff) | 0x4000;
    // set 2 most significant bits of byte 9 to '10'
    arr[4] = (arr[4] & 0x3fff) | 0x8000;

    var pad = function(num) {
      var v = num.toString(16);
      while (v.length < 4) {
        v = '0' + v;
      }
      return v;
    };

    return (
      pad(arr[0]) +
      pad(arr[1]) +
      pad(arr[2]) +
      pad(arr[3]) +
      pad(arr[4]) +
      pad(arr[5]) +
      pad(arr[6]) +
      pad(arr[7])
    );
  } else {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @param elem
 * @returns {string}
 */
function htmlTreeAsString(elem) {
  /* eslint no-extra-parens:0*/
  var MAX_TRAVERSE_HEIGHT = 5,
    MAX_OUTPUT_LEN = 80,
    out = [],
    height = 0,
    len = 0,
    separator = ' > ',
    sepLength = separator.length,
    nextStr;

  while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
    nextStr = htmlElementAsString(elem);
    // bail out if
    // - nextStr is the 'html' element
    // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
    //   (ignore this limit if we are on the first iteration)
    if (
      nextStr === 'html' ||
      (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)
    ) {
      break;
    }

    out.push(nextStr);

    len += nextStr.length;
    elem = elem.parentNode;
  }

  return out.reverse().join(separator);
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @param HTMLElement
 * @returns {string}
 */
function htmlElementAsString(elem) {
  var out = [],
    className,
    classes,
    key,
    attr,
    i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());
  if (elem.id) {
    out.push('#' + elem.id);
  }

  className = elem.className;
  if (className && isString(className)) {
    classes = className.split(/\s+/);
    for (i = 0; i < classes.length; i++) {
      out.push('.' + classes[i]);
    }
  }
  var attrWhitelist = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < attrWhitelist.length; i++) {
    key = attrWhitelist[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push('[' + key + '="' + attr + '"]');
    }
  }
  return out.join('');
}

/**
 * Returns true if either a OR b is truthy, but not both
 */
function isOnlyOneTruthy(a, b) {
  return !!(!!a ^ !!b);
}

/**
 * Returns true if both parameters are undefined
 */
function isBothUndefined(a, b) {
  return isUndefined(a) && isUndefined(b);
}

/**
 * Returns true if the two input exception interfaces have the same content
 */
function isSameException(ex1, ex2) {
  if (isOnlyOneTruthy(ex1, ex2)) return false;

  ex1 = ex1.values[0];
  ex2 = ex2.values[0];

  if (ex1.type !== ex2.type || ex1.value !== ex2.value) return false;

  // in case both stacktraces are undefined, we can't decide so default to false
  if (isBothUndefined(ex1.stacktrace, ex2.stacktrace)) return false;

  return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
}

/**
 * Returns true if the two input stack trace interfaces have the same content
 */
function isSameStacktrace(stack1, stack2) {
  if (isOnlyOneTruthy(stack1, stack2)) return false;

  var frames1 = stack1.frames;
  var frames2 = stack2.frames;

  // Exit early if frame count differs
  if (frames1.length !== frames2.length) return false;

  // Iterate through every frame; bail out if anything differs
  var a, b;
  for (var i = 0; i < frames1.length; i++) {
    a = frames1[i];
    b = frames2[i];
    if (
      a.filename !== b.filename ||
      a.lineno !== b.lineno ||
      a.colno !== b.colno ||
      a['function'] !== b['function']
    )
      return false;
  }
  return true;
}

/**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */
function fill(obj, name, replacement, track) {
  var orig = obj[name];
  obj[name] = replacement(orig);
  obj[name].__raven__ = true;
  obj[name].__orig__ = orig;
  if (track) {
    track.push([obj, name, orig]);
  }
}

module.exports = {
  isObject: isObject,
  isError: isError,
  isErrorEvent: isErrorEvent,
  isUndefined: isUndefined,
  isFunction: isFunction,
  isString: isString,
  isArray: isArray,
  isEmptyObject: isEmptyObject,
  supportsErrorEvent: supportsErrorEvent,
  supportsFetch: supportsFetch,
  wrappedCallback: wrappedCallback,
  each: each,
  objectMerge: objectMerge,
  truncate: truncate,
  objectFrozen: objectFrozen,
  hasKey: hasKey,
  joinRegExp: joinRegExp,
  urlencode: urlencode,
  uuid4: uuid4,
  htmlTreeAsString: htmlTreeAsString,
  htmlElementAsString: htmlElementAsString,
  isSameException: isSameException,
  isSameStacktrace: isSameStacktrace,
  parseUrl: parseUrl,
  fill: fill
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trim;
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": [
		866,
		124
	],
	"./af.js": [
		866,
		124
	],
	"./ar": [
		873,
		117
	],
	"./ar-dz": [
		867,
		123
	],
	"./ar-dz.js": [
		867,
		123
	],
	"./ar-kw": [
		868,
		122
	],
	"./ar-kw.js": [
		868,
		122
	],
	"./ar-ly": [
		869,
		121
	],
	"./ar-ly.js": [
		869,
		121
	],
	"./ar-ma": [
		870,
		120
	],
	"./ar-ma.js": [
		870,
		120
	],
	"./ar-sa": [
		871,
		119
	],
	"./ar-sa.js": [
		871,
		119
	],
	"./ar-tn": [
		872,
		118
	],
	"./ar-tn.js": [
		872,
		118
	],
	"./ar.js": [
		873,
		117
	],
	"./az": [
		874,
		116
	],
	"./az.js": [
		874,
		116
	],
	"./be": [
		875,
		115
	],
	"./be.js": [
		875,
		115
	],
	"./bg": [
		876,
		114
	],
	"./bg.js": [
		876,
		114
	],
	"./bn": [
		877,
		113
	],
	"./bn.js": [
		877,
		113
	],
	"./bo": [
		878,
		112
	],
	"./bo.js": [
		878,
		112
	],
	"./br": [
		879,
		111
	],
	"./br.js": [
		879,
		111
	],
	"./bs": [
		880,
		110
	],
	"./bs.js": [
		880,
		110
	],
	"./ca": [
		881,
		109
	],
	"./ca.js": [
		881,
		109
	],
	"./cs": [
		882,
		108
	],
	"./cs.js": [
		882,
		108
	],
	"./cv": [
		883,
		107
	],
	"./cv.js": [
		883,
		107
	],
	"./cy": [
		884,
		106
	],
	"./cy.js": [
		884,
		106
	],
	"./da": [
		885,
		105
	],
	"./da.js": [
		885,
		105
	],
	"./de": [
		888,
		102
	],
	"./de-at": [
		886,
		104
	],
	"./de-at.js": [
		886,
		104
	],
	"./de-ch": [
		887,
		103
	],
	"./de-ch.js": [
		887,
		103
	],
	"./de.js": [
		888,
		102
	],
	"./dv": [
		889,
		101
	],
	"./dv.js": [
		889,
		101
	],
	"./el": [
		890,
		100
	],
	"./el.js": [
		890,
		100
	],
	"./en-au": [
		891,
		99
	],
	"./en-au.js": [
		891,
		99
	],
	"./en-ca": [
		892,
		98
	],
	"./en-ca.js": [
		892,
		98
	],
	"./en-gb": [
		893,
		97
	],
	"./en-gb.js": [
		893,
		97
	],
	"./en-ie": [
		894,
		96
	],
	"./en-ie.js": [
		894,
		96
	],
	"./en-nz": [
		895,
		95
	],
	"./en-nz.js": [
		895,
		95
	],
	"./eo": [
		896,
		94
	],
	"./eo.js": [
		896,
		94
	],
	"./es": [
		898,
		92
	],
	"./es-do": [
		897,
		93
	],
	"./es-do.js": [
		897,
		93
	],
	"./es.js": [
		898,
		92
	],
	"./et": [
		899,
		91
	],
	"./et.js": [
		899,
		91
	],
	"./eu": [
		900,
		90
	],
	"./eu.js": [
		900,
		90
	],
	"./fa": [
		901,
		89
	],
	"./fa.js": [
		901,
		89
	],
	"./fi": [
		902,
		88
	],
	"./fi.js": [
		902,
		88
	],
	"./fo": [
		903,
		87
	],
	"./fo.js": [
		903,
		87
	],
	"./fr": [
		906,
		84
	],
	"./fr-ca": [
		904,
		86
	],
	"./fr-ca.js": [
		904,
		86
	],
	"./fr-ch": [
		905,
		85
	],
	"./fr-ch.js": [
		905,
		85
	],
	"./fr.js": [
		906,
		84
	],
	"./fy": [
		907,
		83
	],
	"./fy.js": [
		907,
		83
	],
	"./gd": [
		908,
		82
	],
	"./gd.js": [
		908,
		82
	],
	"./gl": [
		909,
		81
	],
	"./gl.js": [
		909,
		81
	],
	"./gom-latn": [
		910,
		80
	],
	"./gom-latn.js": [
		910,
		80
	],
	"./he": [
		911,
		79
	],
	"./he.js": [
		911,
		79
	],
	"./hi": [
		912,
		78
	],
	"./hi.js": [
		912,
		78
	],
	"./hr": [
		913,
		77
	],
	"./hr.js": [
		913,
		77
	],
	"./hu": [
		914,
		76
	],
	"./hu.js": [
		914,
		76
	],
	"./hy-am": [
		915,
		75
	],
	"./hy-am.js": [
		915,
		75
	],
	"./id": [
		916,
		74
	],
	"./id.js": [
		916,
		74
	],
	"./is": [
		917,
		73
	],
	"./is.js": [
		917,
		73
	],
	"./it": [
		918,
		72
	],
	"./it.js": [
		918,
		72
	],
	"./ja": [
		919,
		71
	],
	"./ja.js": [
		919,
		71
	],
	"./jv": [
		920,
		70
	],
	"./jv.js": [
		920,
		70
	],
	"./ka": [
		921,
		69
	],
	"./ka.js": [
		921,
		69
	],
	"./kk": [
		922,
		68
	],
	"./kk.js": [
		922,
		68
	],
	"./km": [
		923,
		67
	],
	"./km.js": [
		923,
		67
	],
	"./kn": [
		924,
		66
	],
	"./kn.js": [
		924,
		66
	],
	"./ko": [
		925,
		65
	],
	"./ko.js": [
		925,
		65
	],
	"./ky": [
		926,
		64
	],
	"./ky.js": [
		926,
		64
	],
	"./lb": [
		927,
		63
	],
	"./lb.js": [
		927,
		63
	],
	"./lo": [
		928,
		62
	],
	"./lo.js": [
		928,
		62
	],
	"./lt": [
		929,
		61
	],
	"./lt.js": [
		929,
		61
	],
	"./lv": [
		930,
		60
	],
	"./lv.js": [
		930,
		60
	],
	"./me": [
		931,
		59
	],
	"./me.js": [
		931,
		59
	],
	"./mi": [
		932,
		58
	],
	"./mi.js": [
		932,
		58
	],
	"./mk": [
		933,
		57
	],
	"./mk.js": [
		933,
		57
	],
	"./ml": [
		934,
		56
	],
	"./ml.js": [
		934,
		56
	],
	"./mr": [
		935,
		55
	],
	"./mr.js": [
		935,
		55
	],
	"./ms": [
		937,
		53
	],
	"./ms-my": [
		936,
		54
	],
	"./ms-my.js": [
		936,
		54
	],
	"./ms.js": [
		937,
		53
	],
	"./my": [
		938,
		52
	],
	"./my.js": [
		938,
		52
	],
	"./nb": [
		939,
		51
	],
	"./nb.js": [
		939,
		51
	],
	"./ne": [
		940,
		50
	],
	"./ne.js": [
		940,
		50
	],
	"./nl": [
		942,
		48
	],
	"./nl-be": [
		941,
		49
	],
	"./nl-be.js": [
		941,
		49
	],
	"./nl.js": [
		942,
		48
	],
	"./nn": [
		943,
		47
	],
	"./nn.js": [
		943,
		47
	],
	"./pa-in": [
		944,
		46
	],
	"./pa-in.js": [
		944,
		46
	],
	"./pl": [
		945,
		45
	],
	"./pl.js": [
		945,
		45
	],
	"./pt": [
		947,
		43
	],
	"./pt-br": [
		946,
		44
	],
	"./pt-br.js": [
		946,
		44
	],
	"./pt.js": [
		947,
		43
	],
	"./ro": [
		948,
		42
	],
	"./ro.js": [
		948,
		42
	],
	"./ru": [
		949,
		41
	],
	"./ru.js": [
		949,
		41
	],
	"./sd": [
		950,
		40
	],
	"./sd.js": [
		950,
		40
	],
	"./se": [
		951,
		39
	],
	"./se.js": [
		951,
		39
	],
	"./si": [
		952,
		38
	],
	"./si.js": [
		952,
		38
	],
	"./sk": [
		953,
		37
	],
	"./sk.js": [
		953,
		37
	],
	"./sl": [
		954,
		36
	],
	"./sl.js": [
		954,
		36
	],
	"./sq": [
		955,
		35
	],
	"./sq.js": [
		955,
		35
	],
	"./sr": [
		957,
		33
	],
	"./sr-cyrl": [
		956,
		34
	],
	"./sr-cyrl.js": [
		956,
		34
	],
	"./sr.js": [
		957,
		33
	],
	"./ss": [
		958,
		32
	],
	"./ss.js": [
		958,
		32
	],
	"./sv": [
		959,
		31
	],
	"./sv.js": [
		959,
		31
	],
	"./sw": [
		960,
		30
	],
	"./sw.js": [
		960,
		30
	],
	"./ta": [
		961,
		29
	],
	"./ta.js": [
		961,
		29
	],
	"./te": [
		962,
		28
	],
	"./te.js": [
		962,
		28
	],
	"./tet": [
		963,
		27
	],
	"./tet.js": [
		963,
		27
	],
	"./th": [
		964,
		26
	],
	"./th.js": [
		964,
		26
	],
	"./tl-ph": [
		965,
		25
	],
	"./tl-ph.js": [
		965,
		25
	],
	"./tlh": [
		966,
		24
	],
	"./tlh.js": [
		966,
		24
	],
	"./tr": [
		967,
		23
	],
	"./tr.js": [
		967,
		23
	],
	"./tzl": [
		968,
		22
	],
	"./tzl.js": [
		968,
		22
	],
	"./tzm": [
		970,
		20
	],
	"./tzm-latn": [
		969,
		21
	],
	"./tzm-latn.js": [
		969,
		21
	],
	"./tzm.js": [
		970,
		20
	],
	"./uk": [
		971,
		19
	],
	"./uk.js": [
		971,
		19
	],
	"./ur": [
		972,
		18
	],
	"./ur.js": [
		972,
		18
	],
	"./uz": [
		974,
		16
	],
	"./uz-latn": [
		973,
		17
	],
	"./uz-latn.js": [
		973,
		17
	],
	"./uz.js": [
		974,
		16
	],
	"./vi": [
		975,
		15
	],
	"./vi.js": [
		975,
		15
	],
	"./x-pseudo": [
		976,
		14
	],
	"./x-pseudo.js": [
		976,
		14
	],
	"./yo": [
		977,
		13
	],
	"./yo.js": [
		977,
		13
	],
	"./zh-cn": [
		978,
		12
	],
	"./zh-cn.js": [
		978,
		12
	],
	"./zh-hk": [
		979,
		11
	],
	"./zh-hk.js": [
		979,
		11
	],
	"./zh-tw": [
		980,
		10
	],
	"./zh-tw.js": [
		980,
		10
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 617;
module.exports = webpackAsyncContext;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! VelocityJS.org (1.5.0). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */

/*************************
 Velocity jQuery Shim
 *************************/

/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */

/* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
/* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
/* Browser support: Using this shim instead of jQuery proper removes support for IE8. */

(function(window) {
	"use strict";
	/***************
	 Setup
	 ***************/

	/* If jQuery is already loaded, there's no point in loading this shim. */
	if (window.jQuery) {
		return;
	}

	/* jQuery base. */
	var $ = function(selector, context) {
		return new $.fn.init(selector, context);
	};

	/********************
	 Private Methods
	 ********************/

	/* jQuery */
	$.isWindow = function(obj) {
		/* jshint eqeqeq: false */
		return obj && obj === obj.window;
	};

	/* jQuery */
	$.type = function(obj) {
		if (!obj) {
			return obj + "";
		}

		return typeof obj === "object" || typeof obj === "function" ?
				class2type[toString.call(obj)] || "object" :
				typeof obj;
	};

	/* jQuery */
	$.isArray = Array.isArray || function(obj) {
		return $.type(obj) === "array";
	};

	/* jQuery */
	function isArraylike(obj) {
		var length = obj.length,
				type = $.type(obj);

		if (type === "function" || $.isWindow(obj)) {
			return false;
		}

		if (obj.nodeType === 1 && length) {
			return true;
		}

		return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
	}

	/***************
	 $ Methods
	 ***************/

	/* jQuery: Support removed for IE<9. */
	$.isPlainObject = function(obj) {
		var key;

		if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
			return false;
		}

		try {
			if (obj.constructor &&
					!hasOwn.call(obj, "constructor") &&
					!hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
				return false;
			}
		} catch (e) {
			return false;
		}

		for (key in obj) {
		}

		return key === undefined || hasOwn.call(obj, key);
	};

	/* jQuery */
	$.each = function(obj, callback, args) {
		var value,
				i = 0,
				length = obj.length,
				isArray = isArraylike(obj);

		if (args) {
			if (isArray) {
				for (; i < length; i++) {
					value = callback.apply(obj[i], args);

					if (value === false) {
						break;
					}
				}
			} else {
				for (i in obj) {
					if (!obj.hasOwnProperty(i)) {
						continue;
					}
					value = callback.apply(obj[i], args);

					if (value === false) {
						break;
					}
				}
			}

		} else {
			if (isArray) {
				for (; i < length; i++) {
					value = callback.call(obj[i], i, obj[i]);

					if (value === false) {
						break;
					}
				}
			} else {
				for (i in obj) {
					if (!obj.hasOwnProperty(i)) {
						continue;
					}
					value = callback.call(obj[i], i, obj[i]);

					if (value === false) {
						break;
					}
				}
			}
		}

		return obj;
	};

	/* Custom */
	$.data = function(node, key, value) {
		/* $.getData() */
		if (value === undefined) {
			var getId = node[$.expando],
					store = getId && cache[getId];

			if (key === undefined) {
				return store;
			} else if (store) {
				if (key in store) {
					return store[key];
				}
			}
			/* $.setData() */
		} else if (key !== undefined) {
			var setId = node[$.expando] || (node[$.expando] = ++$.uuid);

			cache[setId] = cache[setId] || {};
			cache[setId][key] = value;

			return value;
		}
	};

	/* Custom */
	$.removeData = function(node, keys) {
		var id = node[$.expando],
				store = id && cache[id];

		if (store) {
			// Cleanup the entire store if no keys are provided.
			if (!keys) {
				delete cache[id];
			} else {
				$.each(keys, function(_, key) {
					delete store[key];
				});
			}
		}
	};

	/* jQuery */
	$.extend = function() {
		var src, copyIsArray, copy, name, options, clone,
				target = arguments[0] || {},
				i = 1,
				length = arguments.length,
				deep = false;

		if (typeof target === "boolean") {
			deep = target;

			target = arguments[i] || {};
			i++;
		}

		if (typeof target !== "object" && $.type(target) !== "function") {
			target = {};
		}

		if (i === length) {
			target = this;
			i--;
		}

		for (; i < length; i++) {
			if ((options = arguments[i])) {
				for (name in options) {
					if (!options.hasOwnProperty(name)) {
						continue;
					}
					src = target[name];
					copy = options[name];

					if (target === copy) {
						continue;
					}

					if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && $.isArray(src) ? src : [];

						} else {
							clone = src && $.isPlainObject(src) ? src : {};
						}

						target[name] = $.extend(deep, clone, copy);

					} else if (copy !== undefined) {
						target[name] = copy;
					}
				}
			}
		}

		return target;
	};

	/* jQuery 1.4.3 */
	$.queue = function(elem, type, data) {
		function $makeArray(arr, results) {
			var ret = results || [];

			if (arr) {
				if (isArraylike(Object(arr))) {
					/* $.merge */
					(function(first, second) {
						var len = +second.length,
								j = 0,
								i = first.length;

						while (j < len) {
							first[i++] = second[j++];
						}

						if (len !== len) {
							while (second[j] !== undefined) {
								first[i++] = second[j++];
							}
						}

						first.length = i;

						return first;
					})(ret, typeof arr === "string" ? [arr] : arr);
				} else {
					[].push.call(ret, arr);
				}
			}

			return ret;
		}

		if (!elem) {
			return;
		}

		type = (type || "fx") + "queue";

		var q = $.data(elem, type);

		if (!data) {
			return q || [];
		}

		if (!q || $.isArray(data)) {
			q = $.data(elem, type, $makeArray(data));
		} else {
			q.push(data);
		}

		return q;
	};

	/* jQuery 1.4.3 */
	$.dequeue = function(elems, type) {
		/* Custom: Embed element iteration. */
		$.each(elems.nodeType ? [elems] : elems, function(i, elem) {
			type = type || "fx";

			var queue = $.queue(elem, type),
					fn = queue.shift();

			if (fn === "inprogress") {
				fn = queue.shift();
			}

			if (fn) {
				if (type === "fx") {
					queue.unshift("inprogress");
				}

				fn.call(elem, function() {
					$.dequeue(elem, type);
				});
			}
		});
	};

	/******************
	 $.fn Methods
	 ******************/

	/* jQuery */
	$.fn = $.prototype = {
		init: function(selector) {
			/* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
			if (selector.nodeType) {
				this[0] = selector;

				return this;
			} else {
				throw new Error("Not a DOM node.");
			}
		},
		offset: function() {
			/* jQuery altered code: Dropped disconnected DOM node checking. */
			var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {top: 0, left: 0};

			return {
				top: box.top + (window.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
				left: box.left + (window.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
			};
		},
		position: function() {
			/* jQuery */
			function offsetParentFn(elem) {
				var offsetParent = elem.offsetParent;

				while (offsetParent && offsetParent.nodeName.toLowerCase() !== "html" && offsetParent.style && offsetParent.style.position === "static") {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || document;
			}

			/* Zepto */
			var elem = this[0],
					offsetParent = offsetParentFn(elem),
					offset = this.offset(),
					parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? {top: 0, left: 0} : $(offsetParent).offset();

			offset.top -= parseFloat(elem.style.marginTop) || 0;
			offset.left -= parseFloat(elem.style.marginLeft) || 0;

			if (offsetParent.style) {
				parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0;
				parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0;
			}

			return {
				top: offset.top - parentOffset.top,
				left: offset.left - parentOffset.left
			};
		}
	};

	/**********************
	 Private Variables
	 **********************/

	/* For $.data() */
	var cache = {};
	$.expando = "velocity" + (new Date().getTime());
	$.uuid = 0;

	/* For $.queue() */
	var class2type = {},
			hasOwn = class2type.hasOwnProperty,
			toString = class2type.toString;

	var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
	for (var i = 0; i < types.length; i++) {
		class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
	}

	/* Makes $(node) possible, without having to call init. */
	$.fn.init.prototype = $.fn;

	/* Globalize Velocity onto the window, and assign its Utilities property. */
	window.Velocity = {Utilities: $};
})(window);

/******************
 Velocity.js
 ******************/

(function(factory) {
	"use strict";
	/* CommonJS module. */
	if (typeof module === "object" && typeof module.exports === "object") {
		module.exports = factory();
		/* AMD module. */
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		/* Browser globals. */
	} else {
		factory();
	}
}(function() {
	"use strict";
	return function(global, window, document, undefined) {

		/***************
		 Summary
		 ***************/

		/*
		 - CSS: CSS stack that works independently from the rest of Velocity.
		 - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
		 - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
		 - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
		 Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
		 - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
		 - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
		 - completeCall(): Handles the cleanup process for each Velocity call.
		 */

		/*********************
		 Helper Functions
		 *********************/

		/* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
		var IE = (function() {
			if (document.documentMode) {
				return document.documentMode;
			} else {
				for (var i = 7; i > 4; i--) {
					var div = document.createElement("div");

					div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";

					if (div.getElementsByTagName("span").length) {
						div = null;

						return i;
					}
				}
			}

			return undefined;
		})();

		/* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
		var rAFShim = (function() {
			var timeLast = 0;

			return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
				var timeCurrent = (new Date()).getTime(),
						timeDelta;

				/* Dynamically set delay on a per-tick basis to match 60fps. */
				/* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
				timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
				timeLast = timeCurrent + timeDelta;

				return setTimeout(function() {
					callback(timeCurrent + timeDelta);
				}, timeDelta);
			};
		})();

		var performance = (function() {
			var perf = window.performance || {};

			if (typeof perf.now !== "function") {
				var nowOffset = perf.timing && perf.timing.navigationStart ? perf.timing.navigationStart : (new Date()).getTime();

				perf.now = function() {
					return (new Date()).getTime() - nowOffset;
				};
			}
			return perf;
		})();

		/* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
		function compactSparseArray(array) {
			var index = -1,
					length = array ? array.length : 0,
					result = [];

			while (++index < length) {
				var value = array[index];

				if (value) {
					result.push(value);
				}
			}

			return result;
		}

		/**
		 * Shim for "fixing" IE's lack of support (IE < 9) for applying slice
		 * on host objects like NamedNodeMap, NodeList, and HTMLCollection
		 * (technically, since host objects have been implementation-dependent,
		 * at least before ES2015, IE hasn't needed to work this way).
		 * Also works on strings, fixes IE < 9 to allow an explicit undefined
		 * for the 2nd argument (as in Firefox), and prevents errors when
		 * called on other DOM objects.
		 */
		var _slice = (function() {
			var slice = Array.prototype.slice;

			try {
				// Can't be used with DOM elements in IE < 9
				slice.call(document.documentElement);
				return slice;
			} catch (e) { // Fails in IE < 9

				// This will work for genuine arrays, array-like objects, 
				// NamedNodeMap (attributes, entities, notations),
				// NodeList (e.g., getElementsByTagName), HTMLCollection (e.g., childNodes),
				// and will not fail on other DOM objects (as do DOM elements in IE < 9)
				return function(begin, end) {
					var len = this.length;

					if (typeof begin !== "number") {
						begin = 0;
					}
					// IE < 9 gets unhappy with an undefined end argument
					if (typeof end !== "number") {
						end = len;
					}
					// For native Array objects, we use the native slice function
					if (this.slice) {
						return slice.call(this, begin, end);
					}
					// For array like object we handle it ourselves.
					var i,
							cloned = [],
							// Handle negative value for "begin"
							start = (begin >= 0) ? begin : Math.max(0, len + begin),
							// Handle negative value for "end"
							upTo = end < 0 ? len + end : Math.min(end, len),
							// Actual expected size of the slice
							size = upTo - start;

					if (size > 0) {
						cloned = new Array(size);
						if (this.charAt) {
							for (i = 0; i < size; i++) {
								cloned[i] = this.charAt(start + i);
							}
						} else {
							for (i = 0; i < size; i++) {
								cloned[i] = this[start + i];
							}
						}
					}
					return cloned;
				};
			}
		})();

		/* .indexOf doesn't exist in IE<9 */
		var _inArray = (function() {
			if (Array.prototype.includes) {
				return function(arr, val) {
					return arr.includes(val);
				};
			}
			if (Array.prototype.indexOf) {
				return function(arr, val) {
					return arr.indexOf(val) >= 0;
				};
			}
			return function(arr, val) {
				for (var i = 0; i < arr.length; i++) {
					if (arr[i] === val) {
						return true;
					}
				}
				return false;
			};
		});

		function sanitizeElements(elements) {
			/* Unwrap jQuery/Zepto objects. */
			if (Type.isWrapped(elements)) {
				elements = _slice.call(elements);
				/* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
			} else if (Type.isNode(elements)) {
				elements = [elements];
			}

			return elements;
		}

		var Type = {
			isNumber: function(variable) {
				return (typeof variable === "number");
			},
			isString: function(variable) {
				return (typeof variable === "string");
			},
			isArray: Array.isArray || function(variable) {
				return Object.prototype.toString.call(variable) === "[object Array]";
			},
			isFunction: function(variable) {
				return Object.prototype.toString.call(variable) === "[object Function]";
			},
			isNode: function(variable) {
				return variable && variable.nodeType;
			},
			/* Determine if variable is an array-like wrapped jQuery, Zepto or similar element, or even a NodeList etc. */
			/* NOTE: HTMLFormElements also have a length. */
			isWrapped: function(variable) {
				return variable
						&& variable !== window
						&& Type.isNumber(variable.length)
						&& !Type.isString(variable)
						&& !Type.isFunction(variable)
						&& !Type.isNode(variable)
						&& (variable.length === 0 || Type.isNode(variable[0]));
			},
			isSVG: function(variable) {
				return window.SVGElement && (variable instanceof window.SVGElement);
			},
			isEmptyObject: function(variable) {
				for (var name in variable) {
					if (variable.hasOwnProperty(name)) {
						return false;
					}
				}

				return true;
			}
		};

		/*****************
		 Dependencies
		 *****************/

		var $,
				isJQuery = false;

		if (global.fn && global.fn.jquery) {
			$ = global;
			isJQuery = true;
		} else {
			$ = window.Velocity.Utilities;
		}

		if (IE <= 8 && !isJQuery) {
			throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
		} else if (IE <= 7) {
			/* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
			jQuery.fn.velocity = jQuery.fn.animate;

			/* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
			return;
		}

		/*****************
		 Constants
		 *****************/

		var DURATION_DEFAULT = 400,
				EASING_DEFAULT = "swing";

		/*************
		 State
		 *************/

		var Velocity = {
			/* Container for page-wide Velocity state data. */
			State: {
				/* Detect mobile devices to determine if mobileHA should be turned on. */
				isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
				/* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
				isAndroid: /Android/i.test(navigator.userAgent),
				isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
				isChrome: window.chrome,
				isFirefox: /Firefox/i.test(navigator.userAgent),
				/* Create a cached element for re-use when checking for CSS property prefixes. */
				prefixElement: document.createElement("div"),
				/* Cache every prefix match to avoid repeating lookups. */
				prefixMatches: {},
				/* Cache the anchor used for animating window scrolling. */
				scrollAnchor: null,
				/* Cache the browser-specific property names associated with the scroll anchor. */
				scrollPropertyLeft: null,
				scrollPropertyTop: null,
				/* Keep track of whether our RAF tick is running. */
				isTicking: false,
				/* Container for every in-progress call to Velocity. */
				calls: [],
				delayedElements: {
					count: 0
				}
			},
			/* Velocity's custom CSS stack. Made global for unit testing. */
			CSS: {/* Defined below. */},
			/* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
			Utilities: $,
			/* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
			Redirects: {/* Manually registered by the user. */},
			Easings: {/* Defined below. */},
			/* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
			Promise: window.Promise,
			/* Velocity option defaults, which can be overriden by the user. */
			defaults: {
				queue: "",
				duration: DURATION_DEFAULT,
				easing: EASING_DEFAULT,
				begin: undefined,
				complete: undefined,
				progress: undefined,
				display: undefined,
				visibility: undefined,
				loop: false,
				delay: false,
				mobileHA: true,
				/* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
				_cacheValues: true,
				/* Advanced: Set to false if the promise should always resolve on empty element lists. */
				promiseRejectEmpty: true
			},
			/* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
			init: function(element) {
				$.data(element, "velocity", {
					/* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
					isSVG: Type.isSVG(element),
					/* Keep track of whether the element is currently being animated by Velocity.
					 This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
					isAnimating: false,
					/* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
					computedStyle: null,
					/* Tween data is cached for each animation on the element so that data can be passed across calls --
					 in particular, end values are used as subsequent start values in consecutive Velocity calls. */
					tweensContainer: null,
					/* The full root property values of each CSS hook being animated on this element are cached so that:
					 1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
					 2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
					rootPropertyValueCache: {},
					/* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
					transformCache: {}
				});
			},
			/* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
			hook: null, /* Defined below. */
			/* Velocity-wide animation time remapping for testing purposes. */
			mock: false,
			version: {major: 1, minor: 5, patch: 0},
			/* Set to 1 or 2 (most verbose) to output debug info to console. */
			debug: false,
			/* Use rAF high resolution timestamp when available */
			timestamp: true,
			/* Pause all animations */
			pauseAll: function(queueName) {
				var currentTime = (new Date()).getTime();

				$.each(Velocity.State.calls, function(i, activeCall) {

					if (activeCall) {

						/* If we have a queueName and this call is not on that queue, skip */
						if (queueName !== undefined && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
							return true;
						}

						/* Set call to paused */
						activeCall[5] = {
							resume: false
						};
					}
				});

				/* Pause timers on any currently delayed calls */
				$.each(Velocity.State.delayedElements, function(k, element) {
					if (!element) {
						return;
					}
					pauseDelayOnElement(element, currentTime);
				});
			},
			/* Resume all animations */
			resumeAll: function(queueName) {
				var currentTime = (new Date()).getTime();

				$.each(Velocity.State.calls, function(i, activeCall) {

					if (activeCall) {

						/* If we have a queueName and this call is not on that queue, skip */
						if (queueName !== undefined && ((activeCall[2].queue !== queueName) || (activeCall[2].queue === false))) {
							return true;
						}

						/* Set call to resumed if it was paused */
						if (activeCall[5]) {
							activeCall[5].resume = true;
						}
					}
				});
				/* Resume timers on any currently delayed calls */
				$.each(Velocity.State.delayedElements, function(k, element) {
					if (!element) {
						return;
					}
					resumeDelayOnElement(element, currentTime);
				});
			}
		};

		/* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
		if (window.pageYOffset !== undefined) {
			Velocity.State.scrollAnchor = window;
			Velocity.State.scrollPropertyLeft = "pageXOffset";
			Velocity.State.scrollPropertyTop = "pageYOffset";
		} else {
			Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
			Velocity.State.scrollPropertyLeft = "scrollLeft";
			Velocity.State.scrollPropertyTop = "scrollTop";
		}

		/* Shorthand alias for jQuery's $.data() utility. */
		function Data(element) {
			/* Hardcode a reference to the plugin name. */
			var response = $.data(element, "velocity");

			/* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
			return response === null ? undefined : response;
		}

		/**************
		 Delay Timer
		 **************/

		function pauseDelayOnElement(element, currentTime) {
			/* Check for any delay timers, and pause the set timeouts (while preserving time data)
			 to be resumed when the "resume" command is issued */
			var data = Data(element);
			if (data && data.delayTimer && !data.delayPaused) {
				data.delayRemaining = data.delay - currentTime + data.delayBegin;
				data.delayPaused = true;
				clearTimeout(data.delayTimer.setTimeout);
			}
		}

		function resumeDelayOnElement(element, currentTime) {
			/* Check for any paused timers and resume */
			var data = Data(element);
			if (data && data.delayTimer && data.delayPaused) {
				/* If the element was mid-delay, re initiate the timeout with the remaining delay */
				data.delayPaused = false;
				data.delayTimer.setTimeout = setTimeout(data.delayTimer.next, data.delayRemaining);
			}
		}



		/**************
		 Easing
		 **************/

		/* Step easing generator. */
		function generateStep(steps) {
			return function(p) {
				return Math.round(p * steps) * (1 / steps);
			};
		}

		/* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
		function generateBezier(mX1, mY1, mX2, mY2) {
			var NEWTON_ITERATIONS = 4,
					NEWTON_MIN_SLOPE = 0.001,
					SUBDIVISION_PRECISION = 0.0000001,
					SUBDIVISION_MAX_ITERATIONS = 10,
					kSplineTableSize = 11,
					kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
					float32ArraySupported = "Float32Array" in window;

			/* Must contain four arguments. */
			if (arguments.length !== 4) {
				return false;
			}

			/* Arguments must be numbers. */
			for (var i = 0; i < 4; ++i) {
				if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
					return false;
				}
			}

			/* X values must be in the [0, 1] range. */
			mX1 = Math.min(mX1, 1);
			mX2 = Math.min(mX2, 1);
			mX1 = Math.max(mX1, 0);
			mX2 = Math.max(mX2, 0);

			var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

			function A(aA1, aA2) {
				return 1.0 - 3.0 * aA2 + 3.0 * aA1;
			}
			function B(aA1, aA2) {
				return 3.0 * aA2 - 6.0 * aA1;
			}
			function C(aA1) {
				return 3.0 * aA1;
			}

			function calcBezier(aT, aA1, aA2) {
				return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
			}

			function getSlope(aT, aA1, aA2) {
				return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
			}

			function newtonRaphsonIterate(aX, aGuessT) {
				for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
					var currentSlope = getSlope(aGuessT, mX1, mX2);

					if (currentSlope === 0.0) {
						return aGuessT;
					}

					var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
					aGuessT -= currentX / currentSlope;
				}

				return aGuessT;
			}

			function calcSampleValues() {
				for (var i = 0; i < kSplineTableSize; ++i) {
					mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
				}
			}

			function binarySubdivide(aX, aA, aB) {
				var currentX, currentT, i = 0;

				do {
					currentT = aA + (aB - aA) / 2.0;
					currentX = calcBezier(currentT, mX1, mX2) - aX;
					if (currentX > 0.0) {
						aB = currentT;
					} else {
						aA = currentT;
					}
				} while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

				return currentT;
			}

			function getTForX(aX) {
				var intervalStart = 0.0,
						currentSample = 1,
						lastSample = kSplineTableSize - 1;

				for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
					intervalStart += kSampleStepSize;
				}

				--currentSample;

				var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]),
						guessForT = intervalStart + dist * kSampleStepSize,
						initialSlope = getSlope(guessForT, mX1, mX2);

				if (initialSlope >= NEWTON_MIN_SLOPE) {
					return newtonRaphsonIterate(aX, guessForT);
				} else if (initialSlope === 0.0) {
					return guessForT;
				} else {
					return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
				}
			}

			var _precomputed = false;

			function precompute() {
				_precomputed = true;
				if (mX1 !== mY1 || mX2 !== mY2) {
					calcSampleValues();
				}
			}

			var f = function(aX) {
				if (!_precomputed) {
					precompute();
				}
				if (mX1 === mY1 && mX2 === mY2) {
					return aX;
				}
				if (aX === 0) {
					return 0;
				}
				if (aX === 1) {
					return 1;
				}

				return calcBezier(getTForX(aX), mY1, mY2);
			};

			f.getControlPoints = function() {
				return [{x: mX1, y: mY1}, {x: mX2, y: mY2}];
			};

			var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
			f.toString = function() {
				return str;
			};

			return f;
		}

		/* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
		/* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
		 then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
		var generateSpringRK4 = (function() {
			function springAccelerationForState(state) {
				return (-state.tension * state.x) - (state.friction * state.v);
			}

			function springEvaluateStateWithDerivative(initialState, dt, derivative) {
				var state = {
					x: initialState.x + derivative.dx * dt,
					v: initialState.v + derivative.dv * dt,
					tension: initialState.tension,
					friction: initialState.friction
				};

				return {dx: state.v, dv: springAccelerationForState(state)};
			}

			function springIntegrateState(state, dt) {
				var a = {
					dx: state.v,
					dv: springAccelerationForState(state)
				},
						b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
						c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
						d = springEvaluateStateWithDerivative(state, dt, c),
						dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
						dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);

				state.x = state.x + dxdt * dt;
				state.v = state.v + dvdt * dt;

				return state;
			}

			return function springRK4Factory(tension, friction, duration) {

				var initState = {
					x: -1,
					v: 0,
					tension: null,
					friction: null
				},
						path = [0],
						time_lapsed = 0,
						tolerance = 1 / 10000,
						DT = 16 / 1000,
						have_duration, dt, last_state;

				tension = parseFloat(tension) || 500;
				friction = parseFloat(friction) || 20;
				duration = duration || null;

				initState.tension = tension;
				initState.friction = friction;

				have_duration = duration !== null;

				/* Calculate the actual time it takes for this animation to complete with the provided conditions. */
				if (have_duration) {
					/* Run the simulation without a duration. */
					time_lapsed = springRK4Factory(tension, friction);
					/* Compute the adjusted time delta. */
					dt = time_lapsed / duration * DT;
				} else {
					dt = DT;
				}

				while (true) {
					/* Next/step function .*/
					last_state = springIntegrateState(last_state || initState, dt);
					/* Store the position. */
					path.push(1 + last_state.x);
					time_lapsed += 16;
					/* If the change threshold is reached, break. */
					if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
						break;
					}
				}

				/* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
				 computed path and returns a snapshot of the position according to a given percentComplete. */
				return !have_duration ? time_lapsed : function(percentComplete) {
					return path[ (percentComplete * (path.length - 1)) | 0 ];
				};
			};
		}());

		/* jQuery easings. */
		Velocity.Easings = {
			linear: function(p) {
				return p;
			},
			swing: function(p) {
				return 0.5 - Math.cos(p * Math.PI) / 2;
			},
			/* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
			spring: function(p) {
				return 1 - (Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6));
			}
		};

		/* CSS3 and Robert Penner easings. */
		$.each(
				[
					["ease", [0.25, 0.1, 0.25, 1.0]],
					["ease-in", [0.42, 0.0, 1.00, 1.0]],
					["ease-out", [0.00, 0.0, 0.58, 1.0]],
					["ease-in-out", [0.42, 0.0, 0.58, 1.0]],
					["easeInSine", [0.47, 0, 0.745, 0.715]],
					["easeOutSine", [0.39, 0.575, 0.565, 1]],
					["easeInOutSine", [0.445, 0.05, 0.55, 0.95]],
					["easeInQuad", [0.55, 0.085, 0.68, 0.53]],
					["easeOutQuad", [0.25, 0.46, 0.45, 0.94]],
					["easeInOutQuad", [0.455, 0.03, 0.515, 0.955]],
					["easeInCubic", [0.55, 0.055, 0.675, 0.19]],
					["easeOutCubic", [0.215, 0.61, 0.355, 1]],
					["easeInOutCubic", [0.645, 0.045, 0.355, 1]],
					["easeInQuart", [0.895, 0.03, 0.685, 0.22]],
					["easeOutQuart", [0.165, 0.84, 0.44, 1]],
					["easeInOutQuart", [0.77, 0, 0.175, 1]],
					["easeInQuint", [0.755, 0.05, 0.855, 0.06]],
					["easeOutQuint", [0.23, 1, 0.32, 1]],
					["easeInOutQuint", [0.86, 0, 0.07, 1]],
					["easeInExpo", [0.95, 0.05, 0.795, 0.035]],
					["easeOutExpo", [0.19, 1, 0.22, 1]],
					["easeInOutExpo", [1, 0, 0, 1]],
					["easeInCirc", [0.6, 0.04, 0.98, 0.335]],
					["easeOutCirc", [0.075, 0.82, 0.165, 1]],
					["easeInOutCirc", [0.785, 0.135, 0.15, 0.86]]
				], function(i, easingArray) {
			Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
		});

		/* Determine the appropriate easing type given an easing input. */
		function getEasing(value, duration) {
			var easing = value;

			/* The easing option can either be a string that references a pre-registered easing,
			 or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
			if (Type.isString(value)) {
				/* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
				if (!Velocity.Easings[value]) {
					easing = false;
				}
			} else if (Type.isArray(value) && value.length === 1) {
				easing = generateStep.apply(null, value);
			} else if (Type.isArray(value) && value.length === 2) {
				/* springRK4 must be passed the animation's duration. */
				/* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
				 function generated with default tension and friction values. */
				easing = generateSpringRK4.apply(null, value.concat([duration]));
			} else if (Type.isArray(value) && value.length === 4) {
				/* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
				easing = generateBezier.apply(null, value);
			} else {
				easing = false;
			}

			/* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
			 if the Velocity-wide default has been incorrectly modified. */
			if (easing === false) {
				if (Velocity.Easings[Velocity.defaults.easing]) {
					easing = Velocity.defaults.easing;
				} else {
					easing = EASING_DEFAULT;
				}
			}

			return easing;
		}

		/*****************
		 CSS Stack
		 *****************/

		/* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
		 It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
		/* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
		var CSS = Velocity.CSS = {
			/*************
			 RegEx
			 *************/

			RegEx: {
				isHex: /^#([A-f\d]{3}){1,2}$/i,
				/* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
				valueUnwrap: /^[A-z]+\((.*)\)$/i,
				wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
				/* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
				valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
			},
			/************
			 Lists
			 ************/

			Lists: {
				colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
				transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
				transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
				units: [
					"%", // relative
					"em", "ex", "ch", "rem", // font relative
					"vw", "vh", "vmin", "vmax", // viewport relative
					"cm", "mm", "Q", "in", "pc", "pt", "px", // absolute lengths
					"deg", "grad", "rad", "turn", // angles
					"s", "ms" // time
				],
				colorNames: {
					"aliceblue": "240,248,255",
					"antiquewhite": "250,235,215",
					"aquamarine": "127,255,212",
					"aqua": "0,255,255",
					"azure": "240,255,255",
					"beige": "245,245,220",
					"bisque": "255,228,196",
					"black": "0,0,0",
					"blanchedalmond": "255,235,205",
					"blueviolet": "138,43,226",
					"blue": "0,0,255",
					"brown": "165,42,42",
					"burlywood": "222,184,135",
					"cadetblue": "95,158,160",
					"chartreuse": "127,255,0",
					"chocolate": "210,105,30",
					"coral": "255,127,80",
					"cornflowerblue": "100,149,237",
					"cornsilk": "255,248,220",
					"crimson": "220,20,60",
					"cyan": "0,255,255",
					"darkblue": "0,0,139",
					"darkcyan": "0,139,139",
					"darkgoldenrod": "184,134,11",
					"darkgray": "169,169,169",
					"darkgrey": "169,169,169",
					"darkgreen": "0,100,0",
					"darkkhaki": "189,183,107",
					"darkmagenta": "139,0,139",
					"darkolivegreen": "85,107,47",
					"darkorange": "255,140,0",
					"darkorchid": "153,50,204",
					"darkred": "139,0,0",
					"darksalmon": "233,150,122",
					"darkseagreen": "143,188,143",
					"darkslateblue": "72,61,139",
					"darkslategray": "47,79,79",
					"darkturquoise": "0,206,209",
					"darkviolet": "148,0,211",
					"deeppink": "255,20,147",
					"deepskyblue": "0,191,255",
					"dimgray": "105,105,105",
					"dimgrey": "105,105,105",
					"dodgerblue": "30,144,255",
					"firebrick": "178,34,34",
					"floralwhite": "255,250,240",
					"forestgreen": "34,139,34",
					"fuchsia": "255,0,255",
					"gainsboro": "220,220,220",
					"ghostwhite": "248,248,255",
					"gold": "255,215,0",
					"goldenrod": "218,165,32",
					"gray": "128,128,128",
					"grey": "128,128,128",
					"greenyellow": "173,255,47",
					"green": "0,128,0",
					"honeydew": "240,255,240",
					"hotpink": "255,105,180",
					"indianred": "205,92,92",
					"indigo": "75,0,130",
					"ivory": "255,255,240",
					"khaki": "240,230,140",
					"lavenderblush": "255,240,245",
					"lavender": "230,230,250",
					"lawngreen": "124,252,0",
					"lemonchiffon": "255,250,205",
					"lightblue": "173,216,230",
					"lightcoral": "240,128,128",
					"lightcyan": "224,255,255",
					"lightgoldenrodyellow": "250,250,210",
					"lightgray": "211,211,211",
					"lightgrey": "211,211,211",
					"lightgreen": "144,238,144",
					"lightpink": "255,182,193",
					"lightsalmon": "255,160,122",
					"lightseagreen": "32,178,170",
					"lightskyblue": "135,206,250",
					"lightslategray": "119,136,153",
					"lightsteelblue": "176,196,222",
					"lightyellow": "255,255,224",
					"limegreen": "50,205,50",
					"lime": "0,255,0",
					"linen": "250,240,230",
					"magenta": "255,0,255",
					"maroon": "128,0,0",
					"mediumaquamarine": "102,205,170",
					"mediumblue": "0,0,205",
					"mediumorchid": "186,85,211",
					"mediumpurple": "147,112,219",
					"mediumseagreen": "60,179,113",
					"mediumslateblue": "123,104,238",
					"mediumspringgreen": "0,250,154",
					"mediumturquoise": "72,209,204",
					"mediumvioletred": "199,21,133",
					"midnightblue": "25,25,112",
					"mintcream": "245,255,250",
					"mistyrose": "255,228,225",
					"moccasin": "255,228,181",
					"navajowhite": "255,222,173",
					"navy": "0,0,128",
					"oldlace": "253,245,230",
					"olivedrab": "107,142,35",
					"olive": "128,128,0",
					"orangered": "255,69,0",
					"orange": "255,165,0",
					"orchid": "218,112,214",
					"palegoldenrod": "238,232,170",
					"palegreen": "152,251,152",
					"paleturquoise": "175,238,238",
					"palevioletred": "219,112,147",
					"papayawhip": "255,239,213",
					"peachpuff": "255,218,185",
					"peru": "205,133,63",
					"pink": "255,192,203",
					"plum": "221,160,221",
					"powderblue": "176,224,230",
					"purple": "128,0,128",
					"red": "255,0,0",
					"rosybrown": "188,143,143",
					"royalblue": "65,105,225",
					"saddlebrown": "139,69,19",
					"salmon": "250,128,114",
					"sandybrown": "244,164,96",
					"seagreen": "46,139,87",
					"seashell": "255,245,238",
					"sienna": "160,82,45",
					"silver": "192,192,192",
					"skyblue": "135,206,235",
					"slateblue": "106,90,205",
					"slategray": "112,128,144",
					"snow": "255,250,250",
					"springgreen": "0,255,127",
					"steelblue": "70,130,180",
					"tan": "210,180,140",
					"teal": "0,128,128",
					"thistle": "216,191,216",
					"tomato": "255,99,71",
					"turquoise": "64,224,208",
					"violet": "238,130,238",
					"wheat": "245,222,179",
					"whitesmoke": "245,245,245",
					"white": "255,255,255",
					"yellowgreen": "154,205,50",
					"yellow": "255,255,0"
				}
			},
			/************
			 Hooks
			 ************/

			/* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
			 (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
			/* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
			 tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
			Hooks: {
				/********************
				 Registration
				 ********************/

				/* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
				/* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
				templates: {
					"textShadow": ["Color X Y Blur", "black 0px 0px 0px"],
					"boxShadow": ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
					"clip": ["Top Right Bottom Left", "0px 0px 0px 0px"],
					"backgroundPosition": ["X Y", "0% 0%"],
					"transformOrigin": ["X Y Z", "50% 50% 0px"],
					"perspectiveOrigin": ["X Y", "50% 50%"]
				},
				/* A "registered" hook is one that has been converted from its template form into a live,
				 tweenable property. It contains data to associate it with its root property. */
				registered: {
					/* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
					 which consists of the subproperty's name, the associated root property's name,
					 and the subproperty's position in the root's value. */
				},
				/* Convert the templates into individual hooks then append them to the registered object above. */
				register: function() {
					/* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
					 currently set to "transparent" default to their respective template below when color-animated,
					 and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
					 which is almost always set closer to black than white. */
					for (var i = 0; i < CSS.Lists.colors.length; i++) {
						var rgbComponents = (CSS.Lists.colors[i] === "color") ? "0 0 0 1" : "255 255 255 1";
						CSS.Hooks.templates[CSS.Lists.colors[i]] = ["Red Green Blue Alpha", rgbComponents];
					}

					var rootProperty,
							hookTemplate,
							hookNames;

					/* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
					 Thus, we re-arrange the templates accordingly. */
					if (IE) {
						for (rootProperty in CSS.Hooks.templates) {
							if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
								continue;
							}
							hookTemplate = CSS.Hooks.templates[rootProperty];
							hookNames = hookTemplate[0].split(" ");

							var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);

							if (hookNames[0] === "Color") {
								/* Reposition both the hook's name and its default value to the end of their respective strings. */
								hookNames.push(hookNames.shift());
								defaultValues.push(defaultValues.shift());

								/* Replace the existing template for the hook's root property. */
								CSS.Hooks.templates[rootProperty] = [hookNames.join(" "), defaultValues.join(" ")];
							}
						}
					}

					/* Hook registration. */
					for (rootProperty in CSS.Hooks.templates) {
						if (!CSS.Hooks.templates.hasOwnProperty(rootProperty)) {
							continue;
						}
						hookTemplate = CSS.Hooks.templates[rootProperty];
						hookNames = hookTemplate[0].split(" ");

						for (var j in hookNames) {
							if (!hookNames.hasOwnProperty(j)) {
								continue;
							}
							var fullHookName = rootProperty + hookNames[j],
									hookPosition = j;

							/* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
							 and the hook's position in its template's default value string. */
							CSS.Hooks.registered[fullHookName] = [rootProperty, hookPosition];
						}
					}
				},
				/*****************************
				 Injection and Extraction
				 *****************************/

				/* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
				/* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
				getRoot: function(property) {
					var hookData = CSS.Hooks.registered[property];

					if (hookData) {
						return hookData[0];
					} else {
						/* If there was no hook match, return the property name untouched. */
						return property;
					}
				},
				getUnit: function(str, start) {
					var unit = (str.substr(start || 0, 5).match(/^[a-z%]+/) || [])[0] || "";

					if (unit && _inArray(CSS.Lists.units, unit)) {
						return unit;
					}
					return "";
				},
				fixColors: function(str) {
					return str.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function($0, $1, $2) {
						if (CSS.Lists.colorNames.hasOwnProperty($2)) {
							return ($1 ? $1 : "rgba(") + CSS.Lists.colorNames[$2] + ($1 ? "" : ",1)");
						}
						return $1 + $2;
					});
				},
				/* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
				 the targeted hook can be injected or extracted at its standard position. */
				cleanRootPropertyValue: function(rootProperty, rootPropertyValue) {
					/* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
					if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
						rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
					}

					/* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
					 default to the root's default value as defined in CSS.Hooks.templates. */
					/* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
					 zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
					if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
						rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
					}

					return rootPropertyValue;
				},
				/* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
				extractValue: function(fullHookName, rootPropertyValue) {
					var hookData = CSS.Hooks.registered[fullHookName];

					if (hookData) {
						var hookRoot = hookData[0],
								hookPosition = hookData[1];

						rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

						/* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
						return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
					} else {
						/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
						return rootPropertyValue;
					}
				},
				/* Inject the hook's value into its root property's value. This is used to piece back together the root property
				 once Velocity has updated one of its individually hooked values through tweening. */
				injectValue: function(fullHookName, hookValue, rootPropertyValue) {
					var hookData = CSS.Hooks.registered[fullHookName];

					if (hookData) {
						var hookRoot = hookData[0],
								hookPosition = hookData[1],
								rootPropertyValueParts,
								rootPropertyValueUpdated;

						rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);

						/* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
						 then reconstruct the rootPropertyValue string. */
						rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
						rootPropertyValueParts[hookPosition] = hookValue;
						rootPropertyValueUpdated = rootPropertyValueParts.join(" ");

						return rootPropertyValueUpdated;
					} else {
						/* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
						return rootPropertyValue;
					}
				}
			},
			/*******************
			 Normalizations
			 *******************/

			/* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
			 and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
			Normalizations: {
				/* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
				 the targeted element (which may need to be queried), and the targeted property value. */
				registered: {
					clip: function(type, element, propertyValue) {
						switch (type) {
							case "name":
								return "clip";
								/* Clip needs to be unwrapped and stripped of its commas during extraction. */
							case "extract":
								var extracted;

								/* If Velocity also extracted this value, skip extraction. */
								if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
									extracted = propertyValue;
								} else {
									/* Remove the "rect()" wrapper. */
									extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);

									/* Strip off commas. */
									extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
								}

								return extracted;
								/* Clip needs to be re-wrapped during injection. */
							case "inject":
								return "rect(" + propertyValue + ")";
						}
					},
					blur: function(type, element, propertyValue) {
						switch (type) {
							case "name":
								return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
							case "extract":
								var extracted = parseFloat(propertyValue);

								/* If extracted is NaN, meaning the value isn't already extracted. */
								if (!(extracted || extracted === 0)) {
									var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);

									/* If the filter string had a blur component, return just the blur value and unit type. */
									if (blurComponent) {
										extracted = blurComponent[1];
										/* If the component doesn't exist, default blur to 0. */
									} else {
										extracted = 0;
									}
								}

								return extracted;
								/* Blur needs to be re-wrapped during injection. */
							case "inject":
								/* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
								if (!parseFloat(propertyValue)) {
									return "none";
								} else {
									return "blur(" + propertyValue + ")";
								}
						}
					},
					/* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
					opacity: function(type, element, propertyValue) {
						if (IE <= 8) {
							switch (type) {
								case "name":
									return "filter";
								case "extract":
									/* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
									 Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
									var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);

									if (extracted) {
										/* Convert to decimal value. */
										propertyValue = extracted[1] / 100;
									} else {
										/* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
										propertyValue = 1;
									}

									return propertyValue;
								case "inject":
									/* Opacified elements are required to have their zoom property set to a non-zero value. */
									element.style.zoom = 1;

									/* Setting the filter property on elements with certain font property combinations can result in a
									 highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
									 value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
									if (parseFloat(propertyValue) >= 1) {
										return "";
									} else {
										/* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
										return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
									}
							}
							/* With all other browsers, normalization is not required; return the same values that were passed in. */
						} else {
							switch (type) {
								case "name":
									return "opacity";
								case "extract":
									return propertyValue;
								case "inject":
									return propertyValue;
							}
						}
					}
				},
				/*****************************
				 Batched Registrations
				 *****************************/

				/* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
				register: function() {

					/*****************
					 Transforms
					 *****************/

					/* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
					 so that they can be referenced in a properties map by their individual names. */
					/* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
					 setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
					 Transform setting is batched in this way to improve performance: the transform style only needs to be updated
					 once when multiple transform subproperties are being animated simultaneously. */
					/* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
					 transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
					 from being normalized for these browsers so that tweening skips these properties altogether
					 (since it will ignore them as being unsupported by the browser.) */
					if ((!IE || IE > 9) && !Velocity.State.isGingerbread) {
						/* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
						 share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
						CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
					}

					for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
						/* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
						 paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
						(function() {
							var transformName = CSS.Lists.transformsBase[i];

							CSS.Normalizations.registered[transformName] = function(type, element, propertyValue) {
								switch (type) {
									/* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
									case "name":
										return "transform";
										/* Transform values are cached onto a per-element transformCache object. */
									case "extract":
										/* If this transform has yet to be assigned a value, return its null value. */
										if (Data(element) === undefined || Data(element).transformCache[transformName] === undefined) {
											/* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
											return /^scale/i.test(transformName) ? 1 : 0;
											/* When transform values are set, they are wrapped in parentheses as per the CSS spec.
											 Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
										}
										return Data(element).transformCache[transformName].replace(/[()]/g, "");
									case "inject":
										var invalid = false;

										/* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
										 Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
										/* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
										switch (transformName.substr(0, transformName.length - 1)) {
											/* Whitelist unit types for each transform. */
											case "translate":
												invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
												break;
												/* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
											case "scal":
											case "scale":
												/* Chrome on Android has a bug in which scaled elements blur if their initial scale
												 value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
												 and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
												if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined && propertyValue < 1) {
													propertyValue = 1;
												}

												invalid = !/(\d)$/i.test(propertyValue);
												break;
											case "skew":
												invalid = !/(deg|\d)$/i.test(propertyValue);
												break;
											case "rotate":
												invalid = !/(deg|\d)$/i.test(propertyValue);
												break;
										}

										if (!invalid) {
											/* As per the CSS spec, wrap the value in parentheses. */
											Data(element).transformCache[transformName] = "(" + propertyValue + ")";
										}

										/* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
										return Data(element).transformCache[transformName];
								}
							};
						})();
					}

					/*************
					 Colors
					 *************/

					/* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
					 Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
					for (var j = 0; j < CSS.Lists.colors.length; j++) {
						/* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
						 (Otherwise, all functions would take the final for loop's colorName.) */
						(function() {
							var colorName = CSS.Lists.colors[j];

							/* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
							CSS.Normalizations.registered[colorName] = function(type, element, propertyValue) {
								switch (type) {
									case "name":
										return colorName;
										/* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
									case "extract":
										var extracted;

										/* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
										if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
											extracted = propertyValue;
										} else {
											var converted,
													colorNames = {
														black: "rgb(0, 0, 0)",
														blue: "rgb(0, 0, 255)",
														gray: "rgb(128, 128, 128)",
														green: "rgb(0, 128, 0)",
														red: "rgb(255, 0, 0)",
														white: "rgb(255, 255, 255)"
													};

											/* Convert color names to rgb. */
											if (/^[A-z]+$/i.test(propertyValue)) {
												if (colorNames[propertyValue] !== undefined) {
													converted = colorNames[propertyValue];
												} else {
													/* If an unmatched color name is provided, default to black. */
													converted = colorNames.black;
												}
												/* Convert hex values to rgb. */
											} else if (CSS.RegEx.isHex.test(propertyValue)) {
												converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
												/* If the provided color doesn't match any of the accepted color formats, default to black. */
											} else if (!(/^rgba?\(/i.test(propertyValue))) {
												converted = colorNames.black;
											}

											/* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
											 repeated spaces (in case the value included spaces to begin with). */
											extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
										}

										/* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
										if ((!IE || IE > 8) && extracted.split(" ").length === 3) {
											extracted += " 1";
										}

										return extracted;
									case "inject":
										/* If we have a pattern then it might already have the right values */
										if (/^rgb/.test(propertyValue)) {
											return propertyValue;
										}

										/* If this is IE<=8 and an alpha component exists, strip it off. */
										if (IE <= 8) {
											if (propertyValue.split(" ").length === 4) {
												propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
											}
											/* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
										} else if (propertyValue.split(" ").length === 3) {
											propertyValue += " 1";
										}

										/* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
										 on all values but the fourth (R, G, and B only accept whole numbers). */
										return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
								}
							};
						})();
					}

					/**************
					 Dimensions
					 **************/
					function augmentDimension(name, element, wantInner) {
						var isBorderBox = CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() === "border-box";

						if (isBorderBox === (wantInner || false)) {
							/* in box-sizing mode, the CSS width / height accessors already give the outerWidth / outerHeight. */
							var i,
									value,
									augment = 0,
									sides = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"],
									fields = ["padding" + sides[0], "padding" + sides[1], "border" + sides[0] + "Width", "border" + sides[1] + "Width"];

							for (i = 0; i < fields.length; i++) {
								value = parseFloat(CSS.getPropertyValue(element, fields[i]));
								if (!isNaN(value)) {
									augment += value;
								}
							}
							return wantInner ? -augment : augment;
						}
						return 0;
					}
					function getDimension(name, wantInner) {
						return function(type, element, propertyValue) {
							switch (type) {
								case "name":
									return name;
								case "extract":
									return parseFloat(propertyValue) + augmentDimension(name, element, wantInner);
								case "inject":
									return (parseFloat(propertyValue) - augmentDimension(name, element, wantInner)) + "px";
							}
						};
					}
					CSS.Normalizations.registered.innerWidth = getDimension("width", true);
					CSS.Normalizations.registered.innerHeight = getDimension("height", true);
					CSS.Normalizations.registered.outerWidth = getDimension("width");
					CSS.Normalizations.registered.outerHeight = getDimension("height");
				}
			},
			/************************
			 CSS Property Names
			 ************************/

			Names: {
				/* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
				 Camelcasing is used to normalize property names between and across calls. */
				camelCase: function(property) {
					return property.replace(/-(\w)/g, function(match, subMatch) {
						return subMatch.toUpperCase();
					});
				},
				/* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
				SVGAttribute: function(property) {
					var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";

					/* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
					if (IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) {
						SVGAttributes += "|transform";
					}

					return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
				},
				/* Determine whether a property should be set with a vendor prefix. */
				/* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
				 If the property is not at all supported by the browser, return a false flag. */
				prefixCheck: function(property) {
					/* If this property has already been checked, return the cached value. */
					if (Velocity.State.prefixMatches[property]) {
						return [Velocity.State.prefixMatches[property], true];
					} else {
						var vendors = ["", "Webkit", "Moz", "ms", "O"];

						for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
							var propertyPrefixed;

							if (i === 0) {
								propertyPrefixed = property;
							} else {
								/* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
								propertyPrefixed = vendors[i] + property.replace(/^\w/, function(match) {
									return match.toUpperCase();
								});
							}

							/* Check if the browser supports this property as prefixed. */
							if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
								/* Cache the match. */
								Velocity.State.prefixMatches[property] = propertyPrefixed;

								return [propertyPrefixed, true];
							}
						}

						/* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
						return [property, false];
					}
				}
			},
			/************************
			 CSS Property Values
			 ************************/

			Values: {
				/* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
				hexToRgb: function(hex) {
					var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
							longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
							rgbParts;

					hex = hex.replace(shortformRegex, function(m, r, g, b) {
						return r + r + g + g + b + b;
					});

					rgbParts = longformRegex.exec(hex);

					return rgbParts ? [parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16)] : [0, 0, 0];
				},
				isCSSNullValue: function(value) {
					/* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
					 Thus, we check for both falsiness and these special strings. */
					/* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
					 templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
					/* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
					return (!value || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value));
				},
				/* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
				getUnitType: function(property) {
					if (/^(rotate|skew)/i.test(property)) {
						return "deg";
					} else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
						/* The above properties are unitless. */
						return "";
					} else {
						/* Default to px for all other properties. */
						return "px";
					}
				},
				/* HTML elements default to an associated display type when they're not set to display:none. */
				/* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
				getDisplayType: function(element) {
					var tagName = element && element.tagName.toString().toLowerCase();

					if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
						return "inline";
					} else if (/^(li)$/i.test(tagName)) {
						return "list-item";
					} else if (/^(tr)$/i.test(tagName)) {
						return "table-row";
					} else if (/^(table)$/i.test(tagName)) {
						return "table";
					} else if (/^(tbody)$/i.test(tagName)) {
						return "table-row-group";
						/* Default to "block" when no match is found. */
					} else {
						return "block";
					}
				},
				/* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
				addClass: function(element, className) {
					if (element) {
						if (element.classList) {
							element.classList.add(className);
						} else if (Type.isString(element.className)) {
							// Element.className is around 15% faster then set/getAttribute
							element.className += (element.className.length ? " " : "") + className;
						} else {
							// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
							var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";

							element.setAttribute("class", currentClass + (currentClass ? " " : "") + className);
						}
					}
				},
				removeClass: function(element, className) {
					if (element) {
						if (element.classList) {
							element.classList.remove(className);
						} else if (Type.isString(element.className)) {
							// Element.className is around 15% faster then set/getAttribute
							// TODO: Need some jsperf tests on performance - can we get rid of the regex and maybe use split / array manipulation?
							element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
						} else {
							// Work around for IE strict mode animating SVG - and anything else that doesn't behave correctly - the same way jQuery does it
							var currentClass = element.getAttribute(IE <= 7 ? "className" : "class") || "";

							element.setAttribute("class", currentClass.replace(new RegExp("(^|\s)" + className.split(" ").join("|") + "(\s|$)", "gi"), " "));
						}
					}
				}
			},
			/****************************
			 Style Getting & Setting
			 ****************************/

			/* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
			getPropertyValue: function(element, property, rootPropertyValue, forceStyleLookup) {
				/* Get an element's computed property value. */
				/* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
				 style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
				 *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
				function computePropertyValue(element, property) {
					/* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
					 element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
					 offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
					 We subtract border and padding to get the sum of interior + scrollbar. */
					var computedValue = 0;

					/* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
					 of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
					 codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
					 Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
					if (IE <= 8) {
						computedValue = $.css(element, property); /* GET */
						/* All other browsers support getComputedStyle. The returned live object reference is cached onto its
						 associated element so that it does not need to be refetched upon every GET. */
					} else {
						/* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
						 toggle display to the element type's default value. */
						var toggleDisplay = false;

						if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
							toggleDisplay = true;
							CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
						}

						var revertDisplay = function() {
							if (toggleDisplay) {
								CSS.setPropertyValue(element, "display", "none");
							}
						};

						if (!forceStyleLookup) {
							if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
								var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
								revertDisplay();

								return contentBoxHeight;
							} else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
								var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
								revertDisplay();

								return contentBoxWidth;
							}
						}

						var computedStyle;

						/* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
						 of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
						if (Data(element) === undefined) {
							computedStyle = window.getComputedStyle(element, null); /* GET */
							/* If the computedStyle object has yet to be cached, do so now. */
						} else if (!Data(element).computedStyle) {
							computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
							/* If computedStyle is cached, use it. */
						} else {
							computedStyle = Data(element).computedStyle;
						}

						/* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
						 Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
						 So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
						if (property === "borderColor") {
							property = "borderTopColor";
						}

						/* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
						 instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
						if (IE === 9 && property === "filter") {
							computedValue = computedStyle.getPropertyValue(property); /* GET */
						} else {
							computedValue = computedStyle[property];
						}

						/* Fall back to the property's style value (if defined) when computedValue returns nothing,
						 which can happen when the element hasn't been painted. */
						if (computedValue === "" || computedValue === null) {
							computedValue = element.style[property];
						}

						revertDisplay();
					}

					/* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
					 defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
					 effect as being set to 0, so no conversion is necessary.) */
					/* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
					 property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
					 to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
					if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
						var position = computePropertyValue(element, "position"); /* GET */

						/* For absolute positioning, jQuery's $.position() only returns values for top and left;
						 right and bottom will have their "auto" value reverted to 0. */
						/* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
						 Not a big deal since we're currently in a GET batch anyway. */
						if (position === "fixed" || (position === "absolute" && /top|left/i.test(property))) {
							/* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
							computedValue = $(element).position()[property] + "px"; /* GET */
						}
					}

					return computedValue;
				}

				var propertyValue;

				/* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
				 extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
				if (CSS.Hooks.registered[property]) {
					var hook = property,
							hookRoot = CSS.Hooks.getRoot(hook);

					/* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
					 query the DOM for the root property's value. */
					if (rootPropertyValue === undefined) {
						/* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
						rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
					}

					/* If this root has a normalization registered, peform the associated normalization extraction. */
					if (CSS.Normalizations.registered[hookRoot]) {
						rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
					}

					/* Extract the hook's value. */
					propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);

					/* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
					 normalize the property's name and value, and handle the special case of transforms. */
					/* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
					 numerical and therefore do not require normalization extraction. */
				} else if (CSS.Normalizations.registered[property]) {
					var normalizedPropertyName,
							normalizedPropertyValue;

					normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);

					/* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
					 At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
					 This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
					 thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
					if (normalizedPropertyName !== "transform") {
						normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */

						/* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
						if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
							normalizedPropertyValue = CSS.Hooks.templates[property][1];
						}
					}

					propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
				}

				/* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
				if (!/^[\d-]/.test(propertyValue)) {
					/* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
					 their HTML attribute values instead of their CSS style values. */
					var data = Data(element);

					if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
						/* Since the height/width attribute values must be set manually, they don't reflect computed values.
						 Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
						if (/^(height|width)$/i.test(property)) {
							/* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
							try {
								propertyValue = element.getBBox()[property];
							} catch (error) {
								propertyValue = 0;
							}
							/* Otherwise, access the attribute value directly. */
						} else {
							propertyValue = element.getAttribute(property);
						}
					} else {
						propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
					}
				}

				/* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
				 convert CSS null-values to an integer of value 0. */
				if (CSS.Values.isCSSNullValue(propertyValue)) {
					propertyValue = 0;
				}

				if (Velocity.debug >= 2) {
					console.log("Get " + property + ": " + propertyValue);
				}

				return propertyValue;
			},
			/* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
			setPropertyValue: function(element, property, propertyValue, rootPropertyValue, scrollData) {
				var propertyName = property;

				/* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
				if (property === "scroll") {
					/* If a container option is present, scroll the container instead of the browser window. */
					if (scrollData.container) {
						scrollData.container["scroll" + scrollData.direction] = propertyValue;
						/* Otherwise, Velocity defaults to scrolling the browser window. */
					} else {
						if (scrollData.direction === "Left") {
							window.scrollTo(propertyValue, scrollData.alternateValue);
						} else {
							window.scrollTo(scrollData.alternateValue, propertyValue);
						}
					}
				} else {
					/* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
					 Thus, for now, we merely cache transforms being SET. */
					if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
						/* Perform a normalization injection. */
						/* Note: The normalization logic handles the transformCache updating. */
						CSS.Normalizations.registered[property]("inject", element, propertyValue);

						propertyName = "transform";
						propertyValue = Data(element).transformCache[property];
					} else {
						/* Inject hooks. */
						if (CSS.Hooks.registered[property]) {
							var hookName = property,
									hookRoot = CSS.Hooks.getRoot(property);

							/* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
							rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */

							propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
							property = hookRoot;
						}

						/* Normalize names and values. */
						if (CSS.Normalizations.registered[property]) {
							propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
							property = CSS.Normalizations.registered[property]("name", element);
						}

						/* Assign the appropriate vendor prefix before performing an official style update. */
						propertyName = CSS.Names.prefixCheck(property)[0];

						/* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
						 Try/catch is avoided for other browsers since it incurs a performance overhead. */
						if (IE <= 8) {
							try {
								element.style[propertyName] = propertyValue;
							} catch (error) {
								if (Velocity.debug) {
									console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]");
								}
							}
							/* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
							/* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
						} else {
							var data = Data(element);

							if (data && data.isSVG && CSS.Names.SVGAttribute(property)) {
								/* Note: For SVG attributes, vendor-prefixed property names are never used. */
								/* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
								element.setAttribute(property, propertyValue);
							} else {
								element.style[propertyName] = propertyValue;
							}
						}

						if (Velocity.debug >= 2) {
							console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
						}
					}
				}

				/* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
				return [propertyName, propertyValue];
			},
			/* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
			/* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
			flushTransformCache: function(element) {
				var transformString = "",
						data = Data(element);

				/* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
				 (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
				if ((IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) && data && data.isSVG) {
					/* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
					 Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
					var getTransformFloat = function(transformProperty) {
						return parseFloat(CSS.getPropertyValue(element, transformProperty));
					};

					/* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
					 we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
					var SVGTransforms = {
						translate: [getTransformFloat("translateX"), getTransformFloat("translateY")],
						skewX: [getTransformFloat("skewX")], skewY: [getTransformFloat("skewY")],
						/* If the scale property is set (non-1), use that value for the scaleX and scaleY values
						 (this behavior mimics the result of animating all these properties at once on HTML elements). */
						scale: getTransformFloat("scale") !== 1 ? [getTransformFloat("scale"), getTransformFloat("scale")] : [getTransformFloat("scaleX"), getTransformFloat("scaleY")],
						/* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
						 defining the rotation's origin point. We ignore the origin values (default them to 0). */
						rotate: [getTransformFloat("rotateZ"), 0, 0]
					};

					/* Iterate through the transform properties in the user-defined property map order.
					 (This mimics the behavior of non-SVG transform animation.) */
					$.each(Data(element).transformCache, function(transformName) {
						/* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
						 properties so that they match up with SVG's accepted transform properties. */
						if (/^translate/i.test(transformName)) {
							transformName = "translate";
						} else if (/^scale/i.test(transformName)) {
							transformName = "scale";
						} else if (/^rotate/i.test(transformName)) {
							transformName = "rotate";
						}

						/* Check that we haven't yet deleted the property from the SVGTransforms container. */
						if (SVGTransforms[transformName]) {
							/* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
							transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";

							/* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
							 re-insert the same master property if we encounter another one of its axis-specific properties. */
							delete SVGTransforms[transformName];
						}
					});
				} else {
					var transformValue,
							perspective;

					/* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
					$.each(Data(element).transformCache, function(transformName) {
						transformValue = Data(element).transformCache[transformName];

						/* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
						if (transformName === "transformPerspective") {
							perspective = transformValue;
							return true;
						}

						/* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
						if (IE === 9 && transformName === "rotateZ") {
							transformName = "rotate";
						}

						transformString += transformName + transformValue + " ";
					});

					/* If present, set the perspective subproperty first. */
					if (perspective) {
						transformString = "perspective" + perspective + " " + transformString;
					}
				}

				CSS.setPropertyValue(element, "transform", transformString);
			}
		};

		/* Register hooks and normalizations. */
		CSS.Hooks.register();
		CSS.Normalizations.register();

		/* Allow hook setting in the same fashion as jQuery's $.css(). */
		Velocity.hook = function(elements, arg2, arg3) {
			var value;

			elements = sanitizeElements(elements);

			$.each(elements, function(i, element) {
				/* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
				if (Data(element) === undefined) {
					Velocity.init(element);
				}

				/* Get property value. If an element set was passed in, only return the value for the first element. */
				if (arg3 === undefined) {
					if (value === undefined) {
						value = CSS.getPropertyValue(element, arg2);
					}
					/* Set property value. */
				} else {
					/* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
					var adjustedSet = CSS.setPropertyValue(element, arg2, arg3);

					/* Transform properties don't automatically set. They have to be flushed to the DOM. */
					if (adjustedSet[0] === "transform") {
						Velocity.CSS.flushTransformCache(element);
					}

					value = adjustedSet;
				}
			});

			return value;
		};

		/*****************
		 Animation
		 *****************/

		var animate = function() {
			var opts;

			/******************
			 Call Chain
			 ******************/

			/* Logic for determining what to return to the call stack when exiting out of Velocity. */
			function getChain() {
				/* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
				 default to null instead of returning the targeted elements so that utility function's return value is standardized. */
				if (isUtility) {
					return promiseData.promise || null;
					/* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
				} else {
					return elementsWrapped;
				}
			}

			/*************************
			 Arguments Assignment
			 *************************/

			/* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
			 objects are defined on a container object that's passed in as Velocity's sole argument. */
			/* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
			var syntacticSugar = (arguments[0] && (arguments[0].p || (($.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || Type.isString(arguments[0].properties)))),
					/* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
					isUtility,
					/* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
					 passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
					elementsWrapped,
					argumentIndex;

			var elements,
					propertiesMap,
					options;

			/* Detect jQuery/Zepto elements being animated via the $.fn method. */
			if (Type.isWrapped(this)) {
				isUtility = false;

				argumentIndex = 0;
				elements = this;
				elementsWrapped = this;
				/* Otherwise, raw elements are being animated via the utility function. */
			} else {
				isUtility = true;

				argumentIndex = 1;
				elements = syntacticSugar ? (arguments[0].elements || arguments[0].e) : arguments[0];
			}

			/***************
			 Promises
			 ***************/

			var promiseData = {
				promise: null,
				resolver: null,
				rejecter: null
			};

			/* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
			 promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
			 method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
			 call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
			/* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
			 triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
			 grouped together for the purposes of resolving and rejecting a promise. */
			if (isUtility && Velocity.Promise) {
				promiseData.promise = new Velocity.Promise(function(resolve, reject) {
					promiseData.resolver = resolve;
					promiseData.rejecter = reject;
				});
			}

			if (syntacticSugar) {
				propertiesMap = arguments[0].properties || arguments[0].p;
				options = arguments[0].options || arguments[0].o;
			} else {
				propertiesMap = arguments[argumentIndex];
				options = arguments[argumentIndex + 1];
			}

			elements = sanitizeElements(elements);

			if (!elements) {
				if (promiseData.promise) {
					if (!propertiesMap || !options || options.promiseRejectEmpty !== false) {
						promiseData.rejecter();
					} else {
						promiseData.resolver();
					}
				}
				return;
			}

			/* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
			 single raw DOM element is passed in (which doesn't contain a length property). */
			var elementsLength = elements.length,
					elementsIndex = 0;

			/***************************
			 Argument Overloading
			 ***************************/

			/* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
			 Overloading is detected by checking for the absence of an object being passed into options. */
			/* Note: The stop/finish/pause/resume actions do not accept animation options, and are therefore excluded from this check. */
			if (!/^(stop|finish|finishAll|pause|resume)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
				/* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
				var startingArgumentPosition = argumentIndex + 1;

				options = {};

				/* Iterate through all options arguments */
				for (var i = startingArgumentPosition; i < arguments.length; i++) {
					/* Treat a number as a duration. Parse it out. */
					/* Note: The following RegEx will return true if passed an array with a number as its first item.
					 Thus, arrays are skipped from this check. */
					if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
						options.duration = arguments[i];
						/* Treat strings and arrays as easings. */
					} else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
						options.easing = arguments[i];
						/* Treat a function as a complete callback. */
					} else if (Type.isFunction(arguments[i])) {
						options.complete = arguments[i];
					}
				}
			}

			/*********************
			 Action Detection
			 *********************/

			/* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
			 or they can be started, stopped, paused, resumed, or reversed . If a literal or referenced properties map is passed in as Velocity's
			 first argument, the associated action is "start". Alternatively, "scroll", "reverse", "pause", "resume" or "stop" can be passed in 
			 instead of a properties map. */
			var action;

			switch (propertiesMap) {
				case "scroll":
					action = "scroll";
					break;

				case "reverse":
					action = "reverse";
					break;

				case "pause":

					/*******************
					 Action: Pause
					 *******************/

					var currentTime = (new Date()).getTime();

					/* Handle delay timers */
					$.each(elements, function(i, element) {
						pauseDelayOnElement(element, currentTime);
					});

					/* Pause and Resume are call-wide (not on a per element basis). Thus, calling pause or resume on a 
					 single element will cause any calls that containt tweens for that element to be paused/resumed
					 as well. */

					/* Iterate through all calls and pause any that contain any of our elements */
					$.each(Velocity.State.calls, function(i, activeCall) {

						var found = false;
						/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
						if (activeCall) {
							/* Iterate through the active call's targeted elements. */
							$.each(activeCall[1], function(k, activeElement) {
								var queueName = (options === undefined) ? "" : options;

								if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
									return true;
								}

								/* Iterate through the calls targeted by the stop command. */
								$.each(elements, function(l, element) {
									/* Check that this call was applied to the target element. */
									if (element === activeElement) {

										/* Set call to paused */
										activeCall[5] = {
											resume: false
										};

										/* Once we match an element, we can bounce out to the next call entirely */
										found = true;
										return false;
									}
								});

								/* Proceed to check next call if we have already matched */
								if (found) {
									return false;
								}
							});
						}

					});

					/* Since pause creates no new tweens, exit out of Velocity. */
					return getChain();

				case "resume":

					/*******************
					 Action: Resume
					 *******************/

					/* Handle delay timers */
					$.each(elements, function(i, element) {
						resumeDelayOnElement(element, currentTime);
					});

					/* Pause and Resume are call-wide (not on a per elemnt basis). Thus, calling pause or resume on a 
					 single element will cause any calls that containt tweens for that element to be paused/resumed
					 as well. */

					/* Iterate through all calls and pause any that contain any of our elements */
					$.each(Velocity.State.calls, function(i, activeCall) {
						var found = false;
						/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
						if (activeCall) {
							/* Iterate through the active call's targeted elements. */
							$.each(activeCall[1], function(k, activeElement) {
								var queueName = (options === undefined) ? "" : options;

								if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
									return true;
								}

								/* Skip any calls that have never been paused */
								if (!activeCall[5]) {
									return true;
								}

								/* Iterate through the calls targeted by the stop command. */
								$.each(elements, function(l, element) {
									/* Check that this call was applied to the target element. */
									if (element === activeElement) {

										/* Flag a pause object to be resumed, which will occur during the next tick. In
										 addition, the pause object will at that time be deleted */
										activeCall[5].resume = true;

										/* Once we match an element, we can bounce out to the next call entirely */
										found = true;
										return false;
									}
								});

								/* Proceed to check next call if we have already matched */
								if (found) {
									return false;
								}
							});
						}

					});

					/* Since resume creates no new tweens, exit out of Velocity. */
					return getChain();

				case "finish":
				case "finishAll":
				case "stop":
					/*******************
					 Action: Stop
					 *******************/

					/* Clear the currently-active delay on each targeted element. */
					$.each(elements, function(i, element) {
						if (Data(element) && Data(element).delayTimer) {
							/* Stop the timer from triggering its cached next() function. */
							clearTimeout(Data(element).delayTimer.setTimeout);

							/* Manually call the next() function so that the subsequent queue items can progress. */
							if (Data(element).delayTimer.next) {
								Data(element).delayTimer.next();
							}

							delete Data(element).delayTimer;
						}

						/* If we want to finish everything in the queue, we have to iterate through it
						 and call each function. This will make them active calls below, which will
						 cause them to be applied via the duration setting. */
						if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
							/* Iterate through the items in the element's queue. */
							$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
								/* The queue array can contain an "inprogress" string, which we skip. */
								if (Type.isFunction(item)) {
									item();
								}
							});

							/* Clearing the $.queue() array is achieved by resetting it to []. */
							$.queue(element, Type.isString(options) ? options : "", []);
						}
					});

					var callsToStop = [];

					/* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
					 been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
					 is stopped, the next item in its animation queue is immediately triggered. */
					/* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
					 or a custom queue string can be passed in. */
					/* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
					 regardless of the element's current queue state. */

					/* Iterate through every active call. */
					$.each(Velocity.State.calls, function(i, activeCall) {
						/* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
						if (activeCall) {
							/* Iterate through the active call's targeted elements. */
							$.each(activeCall[1], function(k, activeElement) {
								/* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
								 clear calls associated with the relevant queue. */
								/* Call stopping logic works as follows:
								 - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
								 - options === undefined --> stop current queue:"" call and all queue:false calls.
								 - options === false --> stop only queue:false calls.
								 - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
								var queueName = (options === undefined) ? "" : options;

								if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
									return true;
								}

								/* Iterate through the calls targeted by the stop command. */
								$.each(elements, function(l, element) {
									/* Check that this call was applied to the target element. */
									if (element === activeElement) {
										/* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
										 due to the queue-clearing above. */
										if (options === true || Type.isString(options)) {
											/* Iterate through the items in the element's queue. */
											$.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
												/* The queue array can contain an "inprogress" string, which we skip. */
												if (Type.isFunction(item)) {
													/* Pass the item's callback a flag indicating that we want to abort from the queue call.
													 (Specifically, the queue will resolve the call's associated promise then abort.)  */
													item(null, true);
												}
											});

											/* Clearing the $.queue() array is achieved by resetting it to []. */
											$.queue(element, Type.isString(options) ? options : "", []);
										}

										if (propertiesMap === "stop") {
											/* Since "reverse" uses cached start values (the previous call's endValues), these values must be
											 changed to reflect the final value that the elements were actually tweened to. */
											/* Note: If only queue:false animations are currently running on an element, it won't have a tweensContainer
											 object. Also, queue:false animations can't be reversed. */
											var data = Data(element);
											if (data && data.tweensContainer && queueName !== false) {
												$.each(data.tweensContainer, function(m, activeTween) {
													activeTween.endValue = activeTween.currentValue;
												});
											}

											callsToStop.push(i);
										} else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
											/* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
											 they finish upon the next rAf tick then proceed with normal call completion logic. */
											activeCall[2].duration = 1;
										}
									}
								});
							});
						}
					});

					/* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
					 that the complete callback and display:none setting should be skipped since we're completing prematurely. */
					if (propertiesMap === "stop") {
						$.each(callsToStop, function(i, j) {
							completeCall(j, true);
						});

						if (promiseData.promise) {
							/* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
							promiseData.resolver(elements);
						}
					}

					/* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
					return getChain();

				default:
					/* Treat a non-empty plain object as a literal properties map. */
					if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
						action = "start";

						/****************
						 Redirects
						 ****************/

						/* Check if a string matches a registered redirect (see Redirects above). */
					} else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
						opts = $.extend({}, options);

						var durationOriginal = opts.duration,
								delayOriginal = opts.delay || 0;

						/* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
						if (opts.backwards === true) {
							elements = $.extend(true, [], elements).reverse();
						}

						/* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
						$.each(elements, function(elementIndex, element) {
							/* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
							if (parseFloat(opts.stagger)) {
								opts.delay = delayOriginal + (parseFloat(opts.stagger) * elementIndex);
							} else if (Type.isFunction(opts.stagger)) {
								opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
							}

							/* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
							 the duration of each element's animation, using floors to prevent producing very short durations. */
							if (opts.drag) {
								/* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
								opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);

								/* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
								 B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
								 The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
								opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex / elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
							}

							/* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
							 reduce the opts checking logic required inside the redirect. */
							Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined);
						});

						/* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
						 (The performance overhead up to this point is virtually non-existant.) */
						/* Note: The jQuery call chain is kept intact by returning the complete element set. */
						return getChain();
					} else {
						var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";

						if (promiseData.promise) {
							promiseData.rejecter(new Error(abortError));
						} else if (window.console) {
							console.log(abortError);
						}

						return getChain();
					}
			}

			/**************************
			 Call-Wide Variables
			 **************************/

			/* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
			 being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
			 avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
			 conversion metrics across Velocity animations that are not immediately consecutively chained. */
			var callUnitConversionData = {
				lastParent: null,
				lastPosition: null,
				lastFontSize: null,
				lastPercentToPxWidth: null,
				lastPercentToPxHeight: null,
				lastEmToPx: null,
				remToPx: null,
				vwToPx: null,
				vhToPx: null
			};

			/* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
			 Velocity.State.calls array that is processed during animation ticking. */
			var call = [];

			/************************
			 Element Processing
			 ************************/

			/* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
			 1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
			 2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
			 3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
			 `elementArrayIndex` allows passing index of the element in the original array to value functions.
			 If `elementsIndex` were used instead the index would be determined by the elements' per-element queue.
			 */
			function processElement(element, elementArrayIndex) {

				/*************************
				 Part I: Pre-Queueing
				 *************************/

				/***************************
				 Element-Wide Variables
				 ***************************/

				var /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
						opts = $.extend({}, Velocity.defaults, options),
						/* A container for the processed data associated with each property in the propertyMap.
						 (Each property in the map produces its own "tween".) */
						tweensContainer = {},
						elementUnitConversionData;

				/******************
				 Element Init
				 ******************/

				if (Data(element) === undefined) {
					Velocity.init(element);
				}

				/******************
				 Option: Delay
				 ******************/

				/* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
				/* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
				 (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
				if (parseFloat(opts.delay) && opts.queue !== false) {
					$.queue(element, opts.queue, function(next) {
						/* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
						Velocity.velocityQueueEntryFlag = true;

						/* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
						 The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command, and
						 delayBegin/delayTime is used to ensure we can "pause" and "resume" a tween that is still mid-delay. */

						/* Temporarily store delayed elements to facilite access for global pause/resume */
						var callIndex = Velocity.State.delayedElements.count++;
						Velocity.State.delayedElements[callIndex] = element;

						var delayComplete = (function(index) {
							return function() {
								/* Clear the temporary element */
								Velocity.State.delayedElements[index] = false;

								/* Finally, issue the call */
								next();
							};
						})(callIndex);


						Data(element).delayBegin = (new Date()).getTime();
						Data(element).delay = parseFloat(opts.delay);
						Data(element).delayTimer = {
							setTimeout: setTimeout(next, parseFloat(opts.delay)),
							next: delayComplete
						};
					});
				}

				/*********************
				 Option: Duration
				 *********************/

				/* Support for jQuery's named durations. */
				switch (opts.duration.toString().toLowerCase()) {
					case "fast":
						opts.duration = 200;
						break;

					case "normal":
						opts.duration = DURATION_DEFAULT;
						break;

					case "slow":
						opts.duration = 600;
						break;

					default:
						/* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
						opts.duration = parseFloat(opts.duration) || 1;
				}

				/************************
				 Global Option: Mock
				 ************************/

				if (Velocity.mock !== false) {
					/* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
					 Alternatively, a multiplier can be passed in to time remap all delays and durations. */
					if (Velocity.mock === true) {
						opts.duration = opts.delay = 1;
					} else {
						opts.duration *= parseFloat(Velocity.mock) || 1;
						opts.delay *= parseFloat(Velocity.mock) || 1;
					}
				}

				/*******************
				 Option: Easing
				 *******************/

				opts.easing = getEasing(opts.easing, opts.duration);

				/**********************
				 Option: Callbacks
				 **********************/

				/* Callbacks must functions. Otherwise, default to null. */
				if (opts.begin && !Type.isFunction(opts.begin)) {
					opts.begin = null;
				}

				if (opts.progress && !Type.isFunction(opts.progress)) {
					opts.progress = null;
				}

				if (opts.complete && !Type.isFunction(opts.complete)) {
					opts.complete = null;
				}

				/*********************************
				 Option: Display & Visibility
				 *********************************/

				/* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
				/* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
				if (opts.display !== undefined && opts.display !== null) {
					opts.display = opts.display.toString().toLowerCase();

					/* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
					if (opts.display === "auto") {
						opts.display = Velocity.CSS.Values.getDisplayType(element);
					}
				}

				if (opts.visibility !== undefined && opts.visibility !== null) {
					opts.visibility = opts.visibility.toString().toLowerCase();
				}

				/**********************
				 Option: mobileHA
				 **********************/

				/* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
				 on animating elements. HA is removed from the element at the completion of its animation. */
				/* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
				/* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
				opts.mobileHA = (opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread);

				/***********************
				 Part II: Queueing
				 ***********************/

				/* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
				 In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
				/* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
				 the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
				function buildQueue(next) {
					var data, lastTweensContainer;

					/*******************
					 Option: Begin
					 *******************/

					/* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
					if (opts.begin && elementsIndex === 0) {
						/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
						try {
							opts.begin.call(elements, elements);
						} catch (error) {
							setTimeout(function() {
								throw error;
							}, 1);
						}
					}

					/*****************************************
					 Tween Data Construction (for Scroll)
					 *****************************************/

					/* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
					if (action === "scroll") {
						/* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
						var scrollDirection = (/^x$/i.test(opts.axis) ? "Left" : "Top"),
								scrollOffset = parseFloat(opts.offset) || 0,
								scrollPositionCurrent,
								scrollPositionCurrentAlternate,
								scrollPositionEnd;

						/* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
						 as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
						if (opts.container) {
							/* Ensure that either a jQuery object or a raw DOM element was passed in. */
							if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
								/* Extract the raw DOM element from the jQuery wrapper. */
								opts.container = opts.container[0] || opts.container;
								/* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
								 (due to the user's natural interaction with the page). */
								scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */

								/* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
								 -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
								 the scroll container's current scroll position. */
								scrollPositionEnd = (scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()]) + scrollOffset; /* GET */
								/* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
							} else {
								opts.container = null;
							}
						} else {
							/* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
							 the appropriate cached property names (which differ based on browser type). */
							scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
							/* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
							scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */

							/* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
							 and therefore end values do not need to be compounded onto current values. */
							scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
						}

						/* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
						tweensContainer = {
							scroll: {
								rootPropertyValue: false,
								startValue: scrollPositionCurrent,
								currentValue: scrollPositionCurrent,
								endValue: scrollPositionEnd,
								unitType: "",
								easing: opts.easing,
								scrollData: {
									container: opts.container,
									direction: scrollDirection,
									alternateValue: scrollPositionCurrentAlternate
								}
							},
							element: element
						};

						if (Velocity.debug) {
							console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);
						}

						/******************************************
						 Tween Data Construction (for Reverse)
						 ******************************************/

						/* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
						 that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
						 the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
						/* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
						/* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
						 there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
						 as reverting to the element's values as they were prior to the previous *Velocity* call. */
					} else if (action === "reverse") {
						data = Data(element);

						/* Abort if there is no prior animation data to reverse to. */
						if (!data) {
							return;
						}

						if (!data.tweensContainer) {
							/* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
							$.dequeue(element, opts.queue);

							return;
						} else {
							/*********************
							 Options Parsing
							 *********************/

							/* If the element was hidden via the display option in the previous call,
							 revert display to "auto" prior to reversal so that the element is visible again. */
							if (data.opts.display === "none") {
								data.opts.display = "auto";
							}

							if (data.opts.visibility === "hidden") {
								data.opts.visibility = "visible";
							}

							/* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
							 Further, remove the previous call's callback options; typically, users do not want these to be refired. */
							data.opts.loop = false;
							data.opts.begin = null;
							data.opts.complete = null;

							/* Since we're extending an opts object that has already been extended with the defaults options object,
							 we remove non-explicitly-defined properties that are auto-assigned values. */
							if (!options.easing) {
								delete opts.easing;
							}

							if (!options.duration) {
								delete opts.duration;
							}

							/* The opts object used for reversal is an extension of the options object optionally passed into this
							 reverse call plus the options used in the previous Velocity call. */
							opts = $.extend({}, data.opts, opts);

							/*************************************
							 Tweens Container Reconstruction
							 *************************************/

							/* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
							lastTweensContainer = $.extend(true, {}, data ? data.tweensContainer : null);

							/* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
							for (var lastTween in lastTweensContainer) {
								/* In addition to tween data, tweensContainers contain an element property that we ignore here. */
								if (lastTweensContainer.hasOwnProperty(lastTween) && lastTween !== "element") {
									var lastStartValue = lastTweensContainer[lastTween].startValue;

									lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
									lastTweensContainer[lastTween].endValue = lastStartValue;

									/* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
									 Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
									 The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
									if (!Type.isEmptyObject(options)) {
										lastTweensContainer[lastTween].easing = opts.easing;
									}

									if (Velocity.debug) {
										console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
									}
								}
							}

							tweensContainer = lastTweensContainer;
						}

						/*****************************************
						 Tween Data Construction (for Start)
						 *****************************************/

					} else if (action === "start") {

						/*************************
						 Value Transferring
						 *************************/

						/* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
						 while the element was in the process of being animated by Velocity, then this current call is safe to use
						 the end values from the prior call as its start values. Velocity attempts to perform this value transfer
						 process whenever possible in order to avoid requerying the DOM. */
						/* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
						 then the DOM is queried for the element's current values as a last resort. */
						/* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */

						data = Data(element);

						/* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
						 to transfer over end values to use as start values. If it's set to true and there is a previous
						 Velocity call to pull values from, do so. */
						if (data && data.tweensContainer && data.isAnimating === true) {
							lastTweensContainer = data.tweensContainer;
						}

						/***************************
						 Tween Data Calculation
						 ***************************/

						/* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
						/* Property map values can either take the form of 1) a single value representing the end value,
						 or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
						 The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
						 the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
						var parsePropertyValue = function(valueData, skipResolvingEasing) {
							var endValue, easing, startValue;

							/* If we have a function as the main argument then resolve it first, in case it returns an array that needs to be split */
							if (Type.isFunction(valueData)) {
								valueData = valueData.call(element, elementArrayIndex, elementsLength);
							}

							/* Handle the array format, which can be structured as one of three potential overloads:
							 A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
							if (Type.isArray(valueData)) {
								/* endValue is always the first item in the array. Don't bother validating endValue's value now
								 since the ensuing property cycling logic does that. */
								endValue = valueData[0];

								/* Two-item array format: If the second item is a number, function, or hex string, treat it as a
								 start value since easings can only be non-hex strings or arrays. */
								if ((!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1])) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
									startValue = valueData[1];
									/* Two or three-item array: If the second item is a non-hex string easing name or an array, treat it as an easing. */
								} else if ((Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1]) && Velocity.Easings[valueData[1]]) || Type.isArray(valueData[1])) {
									easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);

									/* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
									startValue = valueData[2];
								} else {
									startValue = valueData[1] || valueData[2];
								}
								/* Handle the single-value format. */
							} else {
								endValue = valueData;
							}

							/* Default to the call's easing if a per-property easing type was not defined. */
							if (!skipResolvingEasing) {
								easing = easing || opts.easing;
							}

							/* If functions were passed in as values, pass the function the current element as its context,
							 plus the element's index and the element set's size as arguments. Then, assign the returned value. */
							if (Type.isFunction(endValue)) {
								endValue = endValue.call(element, elementArrayIndex, elementsLength);
							}

							if (Type.isFunction(startValue)) {
								startValue = startValue.call(element, elementArrayIndex, elementsLength);
							}

							/* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
							return [endValue || 0, easing, startValue];
						};

						var fixPropertyValue = function(property, valueData) {
							/* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
							var rootProperty = CSS.Hooks.getRoot(property),
									rootPropertyValue = false,
									/* Parse out endValue, easing, and startValue from the property's data. */
									endValue = valueData[0],
									easing = valueData[1],
									startValue = valueData[2],
									pattern;

							/**************************
							 Start Value Sourcing
							 **************************/

							/* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
							 inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
							 Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
							/* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
							 there is no way to check for their explicit browser support, and so we skip skip this check for them. */
							if ((!data || !data.isSVG) && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined) {
								if (Velocity.debug) {
									console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");
								}
								return;
							}

							/* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
							 animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
							 a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
							if (((opts.display !== undefined && opts.display !== null && opts.display !== "none") || (opts.visibility !== undefined && opts.visibility !== "hidden")) && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
								startValue = 0;
							}

							/* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
							 for all of the current call's properties that were *also* animated in the previous call. */
							/* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
							if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
								if (startValue === undefined) {
									startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
								}

								/* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
								 instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
								 attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
								rootPropertyValue = data.rootPropertyValueCache[rootProperty];
								/* If values were not transferred from a previous Velocity call, query the DOM as needed. */
							} else {
								/* Handle hooked properties. */
								if (CSS.Hooks.registered[property]) {
									if (startValue === undefined) {
										rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
										/* Note: The following getPropertyValue() call does not actually trigger a DOM query;
										 getPropertyValue() will extract the hook from rootPropertyValue. */
										startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
										/* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
										 just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
										 root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
										 to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
									} else {
										/* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
										rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
									}
									/* Handle non-hooked properties that haven't already been defined via forcefeeding. */
								} else if (startValue === undefined) {
									startValue = CSS.getPropertyValue(element, property); /* GET */
								}
							}

							/**************************
							 Value Data Extraction
							 **************************/

							var separatedValue,
									endValueUnitType,
									startValueUnitType,
									operator = false;

							/* Separates a property value into its numeric value and its unit type. */
							var separateValue = function(property, value) {
								var unitType,
										numericValue;

								numericValue = (value || "0")
										.toString()
										.toLowerCase()
										/* Match the unit type at the end of the value. */
										.replace(/[%A-z]+$/, function(match) {
											/* Grab the unit type. */
											unitType = match;

											/* Strip the unit type off of value. */
											return "";
										});

								/* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
								if (!unitType) {
									unitType = CSS.Values.getUnitType(property);
								}

								return [numericValue, unitType];
							};

							if (startValue !== endValue && Type.isString(startValue) && Type.isString(endValue)) {
								pattern = "";
								var iStart = 0, // index in startValue
										iEnd = 0, // index in endValue
										aStart = [], // array of startValue numbers
										aEnd = [], // array of endValue numbers
										inCalc = 0, // Keep track of being inside a "calc()" so we don't duplicate it
										inRGB = 0, // Keep track of being inside an RGB as we can't use fractional values
										inRGBA = 0; // Keep track of being inside an RGBA as we must pass fractional for the alpha channel

								startValue = CSS.Hooks.fixColors(startValue);
								endValue = CSS.Hooks.fixColors(endValue);
								while (iStart < startValue.length && iEnd < endValue.length) {
									var cStart = startValue[iStart],
											cEnd = endValue[iEnd];

									if (/[\d\.-]/.test(cStart) && /[\d\.-]/.test(cEnd)) {
										var tStart = cStart, // temporary character buffer
												tEnd = cEnd, // temporary character buffer
												dotStart = ".", // Make sure we can only ever match a single dot in a decimal
												dotEnd = "."; // Make sure we can only ever match a single dot in a decimal

										while (++iStart < startValue.length) {
											cStart = startValue[iStart];
											if (cStart === dotStart) {
												dotStart = ".."; // Can never match two characters
											} else if (!/\d/.test(cStart)) {
												break;
											}
											tStart += cStart;
										}
										while (++iEnd < endValue.length) {
											cEnd = endValue[iEnd];
											if (cEnd === dotEnd) {
												dotEnd = ".."; // Can never match two characters
											} else if (!/\d/.test(cEnd)) {
												break;
											}
											tEnd += cEnd;
										}
										var uStart = CSS.Hooks.getUnit(startValue, iStart), // temporary unit type
												uEnd = CSS.Hooks.getUnit(endValue, iEnd); // temporary unit type

										iStart += uStart.length;
										iEnd += uEnd.length;
										if (uStart === uEnd) {
											// Same units
											if (tStart === tEnd) {
												// Same numbers, so just copy over
												pattern += tStart + uStart;
											} else {
												// Different numbers, so store them
												pattern += "{" + aStart.length + (inRGB ? "!" : "") + "}" + uStart;
												aStart.push(parseFloat(tStart));
												aEnd.push(parseFloat(tEnd));
											}
										} else {
											// Different units, so put into a "calc(from + to)" and animate each side to/from zero
											var nStart = parseFloat(tStart),
													nEnd = parseFloat(tEnd);

											pattern += (inCalc < 5 ? "calc" : "") + "("
													+ (nStart ? "{" + aStart.length + (inRGB ? "!" : "") + "}" : "0") + uStart
													+ " + "
													+ (nEnd ? "{" + (aStart.length + (nStart ? 1 : 0)) + (inRGB ? "!" : "") + "}" : "0") + uEnd
													+ ")";
											if (nStart) {
												aStart.push(nStart);
												aEnd.push(0);
											}
											if (nEnd) {
												aStart.push(0);
												aEnd.push(nEnd);
											}
										}
									} else if (cStart === cEnd) {
										pattern += cStart;
										iStart++;
										iEnd++;
										// Keep track of being inside a calc()
										if (inCalc === 0 && cStart === "c"
												|| inCalc === 1 && cStart === "a"
												|| inCalc === 2 && cStart === "l"
												|| inCalc === 3 && cStart === "c"
												|| inCalc >= 4 && cStart === "("
												) {
											inCalc++;
										} else if ((inCalc && inCalc < 5)
												|| inCalc >= 4 && cStart === ")" && --inCalc < 5) {
											inCalc = 0;
										}
										// Keep track of being inside an rgb() / rgba()
										if (inRGB === 0 && cStart === "r"
												|| inRGB === 1 && cStart === "g"
												|| inRGB === 2 && cStart === "b"
												|| inRGB === 3 && cStart === "a"
												|| inRGB >= 3 && cStart === "("
												) {
											if (inRGB === 3 && cStart === "a") {
												inRGBA = 1;
											}
											inRGB++;
										} else if (inRGBA && cStart === ",") {
											if (++inRGBA > 3) {
												inRGB = inRGBA = 0;
											}
										} else if ((inRGBA && inRGB < (inRGBA ? 5 : 4))
												|| inRGB >= (inRGBA ? 4 : 3) && cStart === ")" && --inRGB < (inRGBA ? 5 : 4)) {
											inRGB = inRGBA = 0;
										}
									} else {
										inCalc = 0;
										// TODO: changing units, fixing colours
										break;
									}
								}
								if (iStart !== startValue.length || iEnd !== endValue.length) {
									if (Velocity.debug) {
										console.error("Trying to pattern match mis-matched strings [\"" + endValue + "\", \"" + startValue + "\"]");
									}
									pattern = undefined;
								}
								if (pattern) {
									if (aStart.length) {
										if (Velocity.debug) {
											console.log("Pattern found \"" + pattern + "\" -> ", aStart, aEnd, "[" + startValue + "," + endValue + "]");
										}
										startValue = aStart;
										endValue = aEnd;
										endValueUnitType = startValueUnitType = "";
									} else {
										pattern = undefined;
									}
								}
							}

							if (!pattern) {
								/* Separate startValue. */
								separatedValue = separateValue(property, startValue);
								startValue = separatedValue[0];
								startValueUnitType = separatedValue[1];

								/* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
								separatedValue = separateValue(property, endValue);
								endValue = separatedValue[0].replace(/^([+-\/*])=/, function(match, subMatch) {
									operator = subMatch;

									/* Strip the operator off of the value. */
									return "";
								});
								endValueUnitType = separatedValue[1];

								/* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
								startValue = parseFloat(startValue) || 0;
								endValue = parseFloat(endValue) || 0;

								/***************************************
								 Property-Specific Value Conversion
								 ***************************************/

								/* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
								if (endValueUnitType === "%") {
									/* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
									 which is identical to the em unit's behavior, so we piggyback off of that. */
									if (/^(fontSize|lineHeight)$/.test(property)) {
										/* Convert % into an em decimal value. */
										endValue = endValue / 100;
										endValueUnitType = "em";
										/* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
									} else if (/^scale/.test(property)) {
										endValue = endValue / 100;
										endValueUnitType = "";
										/* For RGB components, take the defined percentage of 255 and strip off the unit type. */
									} else if (/(Red|Green|Blue)$/i.test(property)) {
										endValue = (endValue / 100) * 255;
										endValueUnitType = "";
									}
								}
							}

							/***************************
							 Unit Ratio Calculation
							 ***************************/

							/* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
							 %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
							 for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
							 from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
							 1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
							 2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
							/* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
							 setting values with the target unit type then comparing the returned pixel value. */
							/* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
							 of batching the SETs and GETs together upfront outweights the potential overhead
							 of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
							/* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
							var calculateUnitRatios = function() {

								/************************
								 Same Ratio Checks
								 ************************/

								/* The properties below are used to determine whether the element differs sufficiently from this call's
								 previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
								 of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
								 this is done to minimize DOM querying. */
								var sameRatioIndicators = {
									myParent: element.parentNode || document.body, /* GET */
									position: CSS.getPropertyValue(element, "position"), /* GET */
									fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
								},
										/* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
										samePercentRatio = ((sameRatioIndicators.position === callUnitConversionData.lastPosition) && (sameRatioIndicators.myParent === callUnitConversionData.lastParent)),
										/* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
										sameEmRatio = (sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize);

								/* Store these ratio indicators call-wide for the next element to compare against. */
								callUnitConversionData.lastParent = sameRatioIndicators.myParent;
								callUnitConversionData.lastPosition = sameRatioIndicators.position;
								callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;

								/***************************
								 Element-Specific Units
								 ***************************/

								/* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
								 of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
								var measurement = 100,
										unitRatios = {};

								if (!sameEmRatio || !samePercentRatio) {
									var dummy = data && data.isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");

									Velocity.init(dummy);
									sameRatioIndicators.myParent.appendChild(dummy);

									/* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
									 Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
									/* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
									$.each(["overflow", "overflowX", "overflowY"], function(i, property) {
										Velocity.CSS.setPropertyValue(dummy, property, "hidden");
									});
									Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
									Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
									Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");

									/* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
									$.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(i, property) {
										Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
									});
									/* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
									Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");

									/* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
									unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
									unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
									unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */

									sameRatioIndicators.myParent.removeChild(dummy);
								} else {
									unitRatios.emToPx = callUnitConversionData.lastEmToPx;
									unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
									unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
								}

								/***************************
								 Element-Agnostic Units
								 ***************************/

								/* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
								 once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
								 that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
								 so we calculate it now. */
								if (callUnitConversionData.remToPx === null) {
									/* Default to browsers' default fontSize of 16px in the case of 0. */
									callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
								}

								/* Similarly, viewport units are %-relative to the window's inner dimensions. */
								if (callUnitConversionData.vwToPx === null) {
									callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
									callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
								}

								unitRatios.remToPx = callUnitConversionData.remToPx;
								unitRatios.vwToPx = callUnitConversionData.vwToPx;
								unitRatios.vhToPx = callUnitConversionData.vhToPx;

								if (Velocity.debug >= 1) {
									console.log("Unit ratios: " + JSON.stringify(unitRatios), element);
								}
								return unitRatios;
							};

							/********************
							 Unit Conversion
							 ********************/

							/* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
							if (/[\/*]/.test(operator)) {
								endValueUnitType = startValueUnitType;
								/* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
								 is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
								 on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
								 would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
								/* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
							} else if ((startValueUnitType !== endValueUnitType) && startValue !== 0) {
								/* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
								/* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
								 match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
								 which remains past the point of the animation's completion. */
								if (endValue === 0) {
									endValueUnitType = startValueUnitType;
								} else {
									/* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
									 If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
									elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();

									/* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
									/* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
									var axis = (/margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x") ? "x" : "y";

									/* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
									 1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
									switch (startValueUnitType) {
										case "%":
											/* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
											 Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
											 to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
											startValue *= (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
											break;

										case "px":
											/* px acts as our midpoint in the unit conversion process; do nothing. */
											break;

										default:
											startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
									}

									/* Invert the px ratios to convert into to the target unit. */
									switch (endValueUnitType) {
										case "%":
											startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
											break;

										case "px":
											/* startValue is already in px, do nothing; we're done. */
											break;

										default:
											startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
									}
								}
							}

							/*********************
							 Relative Values
							 *********************/

							/* Operator logic must be performed last since it requires unit-normalized start and end values. */
							/* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
							 to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
							 50 points is added on top of the current % value. */
							switch (operator) {
								case "+":
									endValue = startValue + endValue;
									break;

								case "-":
									endValue = startValue - endValue;
									break;

								case "*":
									endValue = startValue * endValue;
									break;

								case "/":
									endValue = startValue / endValue;
									break;
							}

							/**************************
							 tweensContainer Push
							 **************************/

							/* Construct the per-property tween object, and push it to the element's tweensContainer. */
							tweensContainer[property] = {
								rootPropertyValue: rootPropertyValue,
								startValue: startValue,
								currentValue: startValue,
								endValue: endValue,
								unitType: endValueUnitType,
								easing: easing
							};
							if (pattern) {
								tweensContainer[property].pattern = pattern;
							}

							if (Velocity.debug) {
								console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
							}
						};

						/* Create a tween out of each property, and append its associated data to tweensContainer. */
						for (var property in propertiesMap) {

							if (!propertiesMap.hasOwnProperty(property)) {
								continue;
							}
							/* The original property name's format must be used for the parsePropertyValue() lookup,
							 but we then use its camelCase styling to normalize it for manipulation. */
							var propertyName = CSS.Names.camelCase(property),
									valueData = parsePropertyValue(propertiesMap[property]);

							/* Find shorthand color properties that have been passed a hex string. */
							/* Would be quicker to use CSS.Lists.colors.includes() if possible */
							if (_inArray(CSS.Lists.colors, propertyName)) {
								/* Parse the value data for each shorthand. */
								var endValue = valueData[0],
										easing = valueData[1],
										startValue = valueData[2];

								if (CSS.RegEx.isHex.test(endValue)) {
									/* Convert the hex strings into their RGB component arrays. */
									var colorComponents = ["Red", "Green", "Blue"],
											endValueRGB = CSS.Values.hexToRgb(endValue),
											startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined;

									/* Inject the RGB component tweens into propertiesMap. */
									for (var i = 0; i < colorComponents.length; i++) {
										var dataArray = [endValueRGB[i]];

										if (easing) {
											dataArray.push(easing);
										}

										if (startValueRGB !== undefined) {
											dataArray.push(startValueRGB[i]);
										}

										fixPropertyValue(propertyName + colorComponents[i], dataArray);
									}
									/* If we have replaced a shortcut color value then don't update the standard property name */
									continue;
								}
							}
							fixPropertyValue(propertyName, valueData);
						}

						/* Along with its property data, store a reference to the element itself onto tweensContainer. */
						tweensContainer.element = element;
					}

					/*****************
					 Call Push
					 *****************/

					/* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
					 being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
					if (tweensContainer.element) {
						/* Apply the "velocity-animating" indicator class. */
						CSS.Values.addClass(element, "velocity-animating");

						/* The call array houses the tweensContainers for each element being animated in the current call. */
						call.push(tweensContainer);

						data = Data(element);

						if (data) {
							/* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
							if (opts.queue === "") {

								data.tweensContainer = tweensContainer;
								data.opts = opts;
							}

							/* Switch on the element's animating flag. */
							data.isAnimating = true;
						}

						/* Once the final element in this call's element set has been processed, push the call array onto
						 Velocity.State.calls for the animation tick to immediately begin processing. */
						if (elementsIndex === elementsLength - 1) {
							/* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
							 Anything on this call container is subjected to tick() processing. */
							Velocity.State.calls.push([call, elements, opts, null, promiseData.resolver, null, 0]);

							/* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
							if (Velocity.State.isTicking === false) {
								Velocity.State.isTicking = true;

								/* Start the tick loop. */
								tick();
							}
						} else {
							elementsIndex++;
						}
					}
				}

				/* When the queue option is set to false, the call skips the element's queue and fires immediately. */
				if (opts.queue === false) {
					/* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
					 we manually inject the delay property here with an explicit setTimeout. */
					if (opts.delay) {

						/* Temporarily store delayed elements to facilitate access for global pause/resume */
						var callIndex = Velocity.State.delayedElements.count++;
						Velocity.State.delayedElements[callIndex] = element;

						var delayComplete = (function(index) {
							return function() {
								/* Clear the temporary element */
								Velocity.State.delayedElements[index] = false;

								/* Finally, issue the call */
								buildQueue();
							};
						})(callIndex);

						Data(element).delayBegin = (new Date()).getTime();
						Data(element).delay = parseFloat(opts.delay);
						Data(element).delayTimer = {
							setTimeout: setTimeout(buildQueue, parseFloat(opts.delay)),
							next: delayComplete
						};
					} else {
						buildQueue();
					}
					/* Otherwise, the call undergoes element queueing as normal. */
					/* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
				} else {
					$.queue(element, opts.queue, function(next, clearQueue) {
						/* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
						 so it's fine if this is repeatedly triggered for each element in the associated call.) */
						if (clearQueue === true) {
							if (promiseData.promise) {
								promiseData.resolver(elements);
							}

							/* Do not continue with animation queueing. */
							return true;
						}

						/* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
						 See completeCall() for further details. */
						Velocity.velocityQueueEntryFlag = true;

						buildQueue(next);
					});
				}

				/*********************
				 Auto-Dequeuing
				 *********************/

				/* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
				 must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
				 for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
				 queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
				 first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
				/* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
				 each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
				/* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
				 Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
				if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
					$.dequeue(element);
				}
			}

			/**************************
			 Element Set Iteration
			 **************************/

			/* If the "nodeType" property exists on the elements variable, we're animating a single element.
			 Place it in an array so that $.each() can iterate over it. */
			$.each(elements, function(i, element) {
				/* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
				if (Type.isNode(element)) {
					processElement(element, i);
				}
			});

			/******************
			 Option: Loop
			 ******************/

			/* The loop option accepts an integer indicating how many times the element should loop between the values in the
			 current call's properties map and the element's property values prior to this call. */
			/* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
			 to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
			 which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
			opts = $.extend({}, Velocity.defaults, options);
			opts.loop = parseInt(opts.loop, 10);
			var reverseCallsCount = (opts.loop * 2) - 1;

			if (opts.loop) {
				/* Double the loop count to convert it into its appropriate number of "reverse" calls.
				 Subtract 1 from the resulting value since the current call is included in the total alternation count. */
				for (var x = 0; x < reverseCallsCount; x++) {
					/* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
					 isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
					 call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
					var reverseOptions = {
						delay: opts.delay,
						progress: opts.progress
					};

					/* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
					 so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
					if (x === reverseCallsCount - 1) {
						reverseOptions.display = opts.display;
						reverseOptions.visibility = opts.visibility;
						reverseOptions.complete = opts.complete;
					}

					animate(elements, "reverse", reverseOptions);
				}
			}

			/***************
			 Chaining
			 ***************/

			/* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
			return getChain();
		};

		/* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
		Velocity = $.extend(animate, Velocity);
		/* For legacy support, also expose the literal animate method. */
		Velocity.animate = animate;

		/**************
		 Timing
		 **************/

		/* Ticker function. */
		var ticker = window.requestAnimationFrame || rAFShim;

		/* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
		 To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
		 devices to avoid wasting battery power on inactive tabs. */
		/* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
		if (!Velocity.State.isMobile && document.hidden !== undefined) {
			var updateTicker = function() {
				/* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
				if (document.hidden) {
					ticker = function(callback) {
						/* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
						return setTimeout(function() {
							callback(true);
						}, 16);
					};

					/* The rAF loop has been paused by the browser, so we manually restart the tick. */
					tick();
				} else {
					ticker = window.requestAnimationFrame || rAFShim;
				}
			};

			/* Page could be sitting in the background at this time (i.e. opened as new tab) so making sure we use correct ticker from the start */
			updateTicker();

			/* And then run check again every time visibility changes */
			document.addEventListener("visibilitychange", updateTicker);
		}

		/************
		 Tick
		 ************/

		/* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
		function tick(timestamp) {
			/* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
			 We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
			 the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
			 calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
			 the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
			 by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
			if (timestamp) {
				/* We normally use RAF's high resolution timestamp but as it can be significantly offset when the browser is
				 under high stress we give the option for choppiness over allowing the browser to drop huge chunks of frames.
				 We use performance.now() and shim it if it doesn't exist for when the tab is hidden. */
				var timeCurrent = Velocity.timestamp && timestamp !== true ? timestamp : performance.now();

				/********************
				 Call Iteration
				 ********************/

				var callsLength = Velocity.State.calls.length;

				/* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
				 when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
				 has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
				if (callsLength > 10000) {
					Velocity.State.calls = compactSparseArray(Velocity.State.calls);
					callsLength = Velocity.State.calls.length;
				}

				/* Iterate through each active call. */
				for (var i = 0; i < callsLength; i++) {
					/* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
					if (!Velocity.State.calls[i]) {
						continue;
					}

					/************************
					 Call-Wide Variables
					 ************************/

					var callContainer = Velocity.State.calls[i],
							call = callContainer[0],
							opts = callContainer[2],
							timeStart = callContainer[3],
							firstTick = !!timeStart,
							tweenDummyValue = null,
							pauseObject = callContainer[5],
							millisecondsEllapsed = callContainer[6];



					/* If timeStart is undefined, then this is the first time that this call has been processed by tick().
					 We assign timeStart now so that its value is as close to the real animation start time as possible.
					 (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
					 between that time and now would cause the first few frames of the tween to be skipped since
					 percentComplete is calculated relative to timeStart.) */
					/* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
					 first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
					 same style value as the element's current value. */
					if (!timeStart) {
						timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
					}

					/* If a pause object is present, skip processing unless it has been set to resume */
					if (pauseObject) {
						if (pauseObject.resume === true) {
							/* Update the time start to accomodate the paused completion amount */
							timeStart = callContainer[3] = Math.round(timeCurrent - millisecondsEllapsed - 16);

							/* Remove pause object after processing */
							callContainer[5] = null;
						} else {
							continue;
						}
					}

					millisecondsEllapsed = callContainer[6] = timeCurrent - timeStart;

					/* The tween's completion percentage is relative to the tween's start time, not the tween's start value
					 (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
					 Accordingly, we ensure that percentComplete does not exceed 1. */
					var percentComplete = Math.min((millisecondsEllapsed) / opts.duration, 1);

					/**********************
					 Element Iteration
					 **********************/

					/* For every call, iterate through each of the elements in its set. */
					for (var j = 0, callLength = call.length; j < callLength; j++) {
						var tweensContainer = call[j],
								element = tweensContainer.element;

						/* Check to see if this element has been deleted midway through the animation by checking for the
						 continued existence of its data cache. If it's gone, or the element is currently paused, skip animating this element. */
						if (!Data(element)) {
							continue;
						}

						var transformPropertyExists = false;

						/**********************************
						 Display & Visibility Toggling
						 **********************************/

						/* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
						 (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
						if (opts.display !== undefined && opts.display !== null && opts.display !== "none") {
							if (opts.display === "flex") {
								var flexValues = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];

								$.each(flexValues, function(i, flexValue) {
									CSS.setPropertyValue(element, "display", flexValue);
								});
							}

							CSS.setPropertyValue(element, "display", opts.display);
						}

						/* Same goes with the visibility option, but its "none" equivalent is "hidden". */
						if (opts.visibility !== undefined && opts.visibility !== "hidden") {
							CSS.setPropertyValue(element, "visibility", opts.visibility);
						}

						/************************
						 Property Iteration
						 ************************/

						/* For every element, iterate through each property. */
						for (var property in tweensContainer) {
							/* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
							if (tweensContainer.hasOwnProperty(property) && property !== "element") {
								var tween = tweensContainer[property],
										currentValue,
										/* Easing can either be a pre-genereated function or a string that references a pre-registered easing
										 on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
										easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;

								/******************************
								 Current Value Calculation
								 ******************************/

								if (Type.isString(tween.pattern)) {
									var patternReplace = percentComplete === 1 ?
											function($0, index, round) {
												var result = tween.endValue[index];

												return round ? Math.round(result) : result;
											} :
											function($0, index, round) {
												var startValue = tween.startValue[index],
														tweenDelta = tween.endValue[index] - startValue,
														result = startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));

												return round ? Math.round(result) : result;
											};

									currentValue = tween.pattern.replace(/{(\d+)(!)?}/g, patternReplace);
								} else if (percentComplete === 1) {
									/* If this is the last tick pass (if we've reached 100% completion for this tween),
									 ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
									currentValue = tween.endValue;
								} else {
									/* Otherwise, calculate currentValue based on the current delta from startValue. */
									var tweenDelta = tween.endValue - tween.startValue;

									currentValue = tween.startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
									/* If no value change is occurring, don't proceed with DOM updating. */
								}
								if (!firstTick && (currentValue === tween.currentValue)) {
									continue;
								}

								tween.currentValue = currentValue;

								/* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
								 it can be passed into the progress callback. */
								if (property === "tween") {
									tweenDummyValue = currentValue;
								} else {
									/******************
									 Hooks: Part I
									 ******************/
									var hookRoot;

									/* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
									 for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
									 rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
									 updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
									 subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
									if (CSS.Hooks.registered[property]) {
										hookRoot = CSS.Hooks.getRoot(property);

										var rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];

										if (rootPropertyValueCache) {
											tween.rootPropertyValue = rootPropertyValueCache;
										}
									}

									/*****************
									 DOM Update
									 *****************/

									/* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
									/* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
									var adjustedSetData = CSS.setPropertyValue(element, /* SET */
											property,
											tween.currentValue + (IE < 9 && parseFloat(currentValue) === 0 ? "" : tween.unitType),
											tween.rootPropertyValue,
											tween.scrollData);

									/*******************
									 Hooks: Part II
									 *******************/

									/* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
									if (CSS.Hooks.registered[property]) {
										/* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
										if (CSS.Normalizations.registered[hookRoot]) {
											Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
										} else {
											Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
										}
									}

									/***************
									 Transforms
									 ***************/

									/* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
									if (adjustedSetData[0] === "transform") {
										transformPropertyExists = true;
									}

								}
							}
						}

						/****************
						 mobileHA
						 ****************/

						/* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
						 It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
						if (opts.mobileHA) {
							/* Don't set the null transform hack if we've already done so. */
							if (Data(element).transformCache.translate3d === undefined) {
								/* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
								Data(element).transformCache.translate3d = "(0px, 0px, 0px)";

								transformPropertyExists = true;
							}
						}

						if (transformPropertyExists) {
							CSS.flushTransformCache(element);
						}
					}

					/* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
					 Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
					if (opts.display !== undefined && opts.display !== "none") {
						Velocity.State.calls[i][2].display = false;
					}
					if (opts.visibility !== undefined && opts.visibility !== "hidden") {
						Velocity.State.calls[i][2].visibility = false;
					}

					/* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
					if (opts.progress) {
						opts.progress.call(callContainer[1],
								callContainer[1],
								percentComplete,
								Math.max(0, (timeStart + opts.duration) - timeCurrent),
								timeStart,
								tweenDummyValue);
					}

					/* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
					if (percentComplete === 1) {
						completeCall(i);
					}
				}
			}

			/* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
			if (Velocity.State.isTicking) {
				ticker(tick);
			}
		}

		/**********************
		 Call Completion
		 **********************/

		/* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
		function completeCall(callIndex, isStopped) {
			/* Ensure the call exists. */
			if (!Velocity.State.calls[callIndex]) {
				return false;
			}

			/* Pull the metadata from the call. */
			var call = Velocity.State.calls[callIndex][0],
					elements = Velocity.State.calls[callIndex][1],
					opts = Velocity.State.calls[callIndex][2],
					resolver = Velocity.State.calls[callIndex][4];

			var remainingCallsExist = false;

			/*************************
			 Element Finalization
			 *************************/

			for (var i = 0, callLength = call.length; i < callLength; i++) {
				var element = call[i].element;

				/* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
				/* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
				/* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
				if (!isStopped && !opts.loop) {
					if (opts.display === "none") {
						CSS.setPropertyValue(element, "display", opts.display);
					}

					if (opts.visibility === "hidden") {
						CSS.setPropertyValue(element, "visibility", opts.visibility);
					}
				}

				/* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
				 a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
				 an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
				 we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
				 is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
				var data = Data(element);

				if (opts.loop !== true && ($.queue(element)[1] === undefined || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
					/* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
					if (data) {
						data.isAnimating = false;
						/* Clear the element's rootPropertyValueCache, which will become stale. */
						data.rootPropertyValueCache = {};

						var transformHAPropertyExists = false;
						/* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
						$.each(CSS.Lists.transforms3D, function(i, transformName) {
							var defaultValue = /^scale/.test(transformName) ? 1 : 0,
									currentValue = data.transformCache[transformName];

							if (data.transformCache[transformName] !== undefined && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
								transformHAPropertyExists = true;

								delete data.transformCache[transformName];
							}
						});

						/* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
						if (opts.mobileHA) {
							transformHAPropertyExists = true;
							delete data.transformCache.translate3d;
						}

						/* Flush the subproperty removals to the DOM. */
						if (transformHAPropertyExists) {
							CSS.flushTransformCache(element);
						}

						/* Remove the "velocity-animating" indicator class. */
						CSS.Values.removeClass(element, "velocity-animating");
					}
				}

				/*********************
				 Option: Complete
				 *********************/

				/* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
				/* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
				if (!isStopped && opts.complete && !opts.loop && (i === callLength - 1)) {
					/* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
					try {
						opts.complete.call(elements, elements);
					} catch (error) {
						setTimeout(function() {
							throw error;
						}, 1);
					}
				}

				/**********************
				 Promise Resolving
				 **********************/

				/* Note: Infinite loops don't return promises. */
				if (resolver && opts.loop !== true) {
					resolver(elements);
				}

				/****************************
				 Option: Loop (Infinite)
				 ****************************/

				if (data && opts.loop === true && !isStopped) {
					/* If a rotateX/Y/Z property is being animated by 360 deg with loop:true, swap tween start/end values to enable
					 continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
					$.each(data.tweensContainer, function(propertyName, tweenContainer) {
						if (/^rotate/.test(propertyName) && ((parseFloat(tweenContainer.startValue) - parseFloat(tweenContainer.endValue)) % 360 === 0)) {
							var oldStartValue = tweenContainer.startValue;

							tweenContainer.startValue = tweenContainer.endValue;
							tweenContainer.endValue = oldStartValue;
						}

						if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
							tweenContainer.endValue = 0;
							tweenContainer.startValue = 100;
						}
					});

					Velocity(element, "reverse", {loop: true, delay: opts.delay});
				}

				/***************
				 Dequeueing
				 ***************/

				/* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
				 which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
				 $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
				if (opts.queue !== false) {
					$.dequeue(element, opts.queue);
				}
			}

			/************************
			 Calls Array Cleanup
			 ************************/

			/* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
			 (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
			Velocity.State.calls[callIndex] = false;

			/* Iterate through the calls array to determine if this was the final in-progress animation.
			 If so, set a flag to end ticking and clear the calls array. */
			for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
				if (Velocity.State.calls[j] !== false) {
					remainingCallsExist = true;

					break;
				}
			}

			if (remainingCallsExist === false) {
				/* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
				Velocity.State.isTicking = false;

				/* Clear the calls array so that its length is reset. */
				delete Velocity.State.calls;
				Velocity.State.calls = [];
			}
		}

		/******************
		 Frameworks
		 ******************/

		/* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
		 If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
		 also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
		 accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
		 (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
		global.Velocity = Velocity;

		if (global !== window) {
			/* Assign the element function to Velocity's core animate() method. */
			global.fn.velocity = animate;
			/* Assign the object function's defaults to Velocity's global defaults object. */
			global.fn.velocity.defaults = Velocity.defaults;
		}

		/***********************
		 Packaged Redirects
		 ***********************/

		/* slideUp, slideDown */
		$.each(["Down", "Up"], function(i, direction) {
			Velocity.Redirects["slide" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
				var opts = $.extend({}, options),
						begin = opts.begin,
						complete = opts.complete,
						inlineValues = {},
						computedValues = {height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: ""};

				if (opts.display === undefined) {
					/* Show the element before slideDown begins and hide the element after slideUp completes. */
					/* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
					opts.display = (direction === "Down" ? (Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block") : "none");
				}

				opts.begin = function() {
					/* If the user passed in a begin callback, fire it now. */
					if (elementsIndex === 0 && begin) {
						begin.call(elements, elements);
					}

					/* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
					for (var property in computedValues) {
						if (!computedValues.hasOwnProperty(property)) {
							continue;
						}
						inlineValues[property] = element.style[property];

						/* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
						 use forcefeeding to start from computed values and animate down to 0. */
						var propertyValue = CSS.getPropertyValue(element, property);
						computedValues[property] = (direction === "Down") ? [propertyValue, 0] : [0, propertyValue];
					}

					/* Force vertical overflow content to clip so that sliding works as expected. */
					inlineValues.overflow = element.style.overflow;
					element.style.overflow = "hidden";
				};

				opts.complete = function() {
					/* Reset element to its pre-slide inline values once its slide animation is complete. */
					for (var property in inlineValues) {
						if (inlineValues.hasOwnProperty(property)) {
							element.style[property] = inlineValues[property];
						}
					}

					/* If the user passed in a complete callback, fire it now. */
					if (elementsIndex === elementsSize - 1) {
						if (complete) {
							complete.call(elements, elements);
						}
						if (promiseData) {
							promiseData.resolver(elements);
						}
					}
				};

				Velocity(element, computedValues, opts);
			};
		});

		/* fadeIn, fadeOut */
		$.each(["In", "Out"], function(i, direction) {
			Velocity.Redirects["fade" + direction] = function(element, options, elementsIndex, elementsSize, elements, promiseData) {
				var opts = $.extend({}, options),
						complete = opts.complete,
						propertiesMap = {opacity: (direction === "In") ? 1 : 0};

				/* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
				 callbacks by firing them only when the final element has been reached. */
				if (elementsIndex !== 0) {
					opts.begin = null;
				}
				if (elementsIndex !== elementsSize - 1) {
					opts.complete = null;
				} else {
					opts.complete = function() {
						if (complete) {
							complete.call(elements, elements);
						}
						if (promiseData) {
							promiseData.resolver(elements);
						}
					};
				}

				/* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
				/* Note: We allow users to pass in "null" to skip display setting altogether. */
				if (opts.display === undefined) {
					opts.display = (direction === "In" ? "auto" : "none");
				}

				Velocity(this, propertiesMap, opts);
			};
		});

		return Velocity;
	}((window.jQuery || window.Zepto || window), window, (window ? window.document : undefined));
}));

/******************
 Known Issues
 ******************/

/* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
 Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
 will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

/**********************
 Velocity UI Pack
 **********************/

/* VelocityJS.org UI Pack (5.2.0). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License. Portions copyright Daniel Eden, Christian Pucci. */

(function(factory) {
	"use strict";
	/* CommonJS module. */
	if (true) {
		module.exports = factory();
		/* AMD module. */
	} else if (typeof define === "function" && define.amd) {
		define(["velocity"], factory);
		/* Browser globals. */
	} else {
		factory();
	}
}(function() {
	"use strict";
	return function(global, window, document, undefined) {

		/*************
		 Checks
		 *************/
		var Velocity = global.Velocity;

		if (!Velocity || !Velocity.Utilities) {
			if (window.console) {
				console.log("Velocity UI Pack: Velocity must be loaded first. Aborting.");
			}
			return;
		}
		var $ = Velocity.Utilities;

		var velocityVersion = Velocity.version,
				requiredVersion = {major: 1, minor: 1, patch: 0};

		function greaterSemver(primary, secondary) {
			var versionInts = [];

			if (!primary || !secondary) {
				return false;
			}

			$.each([primary, secondary], function(i, versionObject) {
				var versionIntsComponents = [];

				$.each(versionObject, function(component, value) {
					while (value.toString().length < 5) {
						value = "0" + value;
					}
					versionIntsComponents.push(value);
				});

				versionInts.push(versionIntsComponents.join(""));
			});

			return (parseFloat(versionInts[0]) > parseFloat(versionInts[1]));
		}

		if (greaterSemver(requiredVersion, velocityVersion)) {
			var abortError = "Velocity UI Pack: You need to update Velocity (velocity.js) to a newer version. Visit http://github.com/julianshapiro/velocity.";
			alert(abortError);
			throw new Error(abortError);
		}

		/************************
		 Effect Registration
		 ************************/

		/* Note: RegisterUI is a legacy name. */
		Velocity.RegisterEffect = Velocity.RegisterUI = function(effectName, properties) {
			/* Animate the expansion/contraction of the elements' parent's height for In/Out effects. */
			function animateParentHeight(elements, direction, totalDuration, stagger) {
				var totalHeightDelta = 0,
						parentNode;

				/* Sum the total height (including padding and margin) of all targeted elements. */
				$.each(elements.nodeType ? [elements] : elements, function(i, element) {
					if (stagger) {
						/* Increase the totalDuration by the successive delay amounts produced by the stagger option. */
						totalDuration += i * stagger;
					}

					parentNode = element.parentNode;

					var propertiesToSum = ["height", "paddingTop", "paddingBottom", "marginTop", "marginBottom"];

					/* If box-sizing is border-box, the height already includes padding and margin */
					if (Velocity.CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() === "border-box") {
						propertiesToSum = ["height"];
					}

					$.each(propertiesToSum, function(i, property) {
						totalHeightDelta += parseFloat(Velocity.CSS.getPropertyValue(element, property));
					});
				});

				/* Animate the parent element's height adjustment (with a varying duration multiplier for aesthetic benefits). */
				Velocity.animate(
						parentNode,
						{height: (direction === "In" ? "+" : "-") + "=" + totalHeightDelta},
						{queue: false, easing: "ease-in-out", duration: totalDuration * (direction === "In" ? 0.6 : 1)}
				);
			}

			/* Register a custom redirect for each effect. */
			Velocity.Redirects[effectName] = function(element, redirectOptions, elementsIndex, elementsSize, elements, promiseData, loop) {
				var finalElement = (elementsIndex === elementsSize - 1),
						totalDuration = 0;

				loop = loop || properties.loop;
				if (typeof properties.defaultDuration === "function") {
					properties.defaultDuration = properties.defaultDuration.call(elements, elements);
				} else {
					properties.defaultDuration = parseFloat(properties.defaultDuration);
				}

				/* Get the total duration used, so we can share it out with everything that doesn't have a duration */
				for (var callIndex = 0; callIndex < properties.calls.length; callIndex++) {
					durationPercentage = properties.calls[callIndex][1];
					if (typeof durationPercentage === "number") {
						totalDuration += durationPercentage;
					}
				}
				var shareDuration = totalDuration >= 1 ? 0 : properties.calls.length ? (1 - totalDuration) / properties.calls.length : 1;

				/* Iterate through each effect's call array. */
				for (callIndex = 0; callIndex < properties.calls.length; callIndex++) {
					var call = properties.calls[callIndex],
							propertyMap = call[0],
							redirectDuration = 1000,
							durationPercentage = call[1],
							callOptions = call[2] || {},
							opts = {};

					if (redirectOptions.duration !== undefined) {
						redirectDuration = redirectOptions.duration;
					} else if (properties.defaultDuration !== undefined) {
						redirectDuration = properties.defaultDuration;
					}

					/* Assign the whitelisted per-call options. */
					opts.duration = redirectDuration * (typeof durationPercentage === "number" ? durationPercentage : shareDuration);
					opts.queue = redirectOptions.queue || "";
					opts.easing = callOptions.easing || "ease";
					opts.delay = parseFloat(callOptions.delay) || 0;
					opts.loop = !properties.loop && callOptions.loop;
					opts._cacheValues = callOptions._cacheValues || true;

					/* Special processing for the first effect call. */
					if (callIndex === 0) {
						/* If a delay was passed into the redirect, combine it with the first call's delay. */
						opts.delay += (parseFloat(redirectOptions.delay) || 0);

						if (elementsIndex === 0) {
							opts.begin = function() {
								/* Only trigger a begin callback on the first effect call with the first element in the set. */
								if (redirectOptions.begin) {
									redirectOptions.begin.call(elements, elements);
								}

								var direction = effectName.match(/(In|Out)$/);

								/* Make "in" transitioning elements invisible immediately so that there's no FOUC between now
								 and the first RAF tick. */
								if ((direction && direction[0] === "In") && propertyMap.opacity !== undefined) {
									$.each(elements.nodeType ? [elements] : elements, function(i, element) {
										Velocity.CSS.setPropertyValue(element, "opacity", 0);
									});
								}

								/* Only trigger animateParentHeight() if we're using an In/Out transition. */
								if (redirectOptions.animateParentHeight && direction) {
									animateParentHeight(elements, direction[0], redirectDuration + opts.delay, redirectOptions.stagger);
								}
							};
						}

						/* If the user isn't overriding the display option, default to "auto" for "In"-suffixed transitions. */
						if (redirectOptions.display !== null) {
							if (redirectOptions.display !== undefined && redirectOptions.display !== "none") {
								opts.display = redirectOptions.display;
							} else if (/In$/.test(effectName)) {
								/* Inline elements cannot be subjected to transforms, so we switch them to inline-block. */
								var defaultDisplay = Velocity.CSS.Values.getDisplayType(element);
								opts.display = (defaultDisplay === "inline") ? "inline-block" : defaultDisplay;
							}
						}

						if (redirectOptions.visibility && redirectOptions.visibility !== "hidden") {
							opts.visibility = redirectOptions.visibility;
						}
					}

					/* Special processing for the last effect call. */
					if (callIndex === properties.calls.length - 1) {
						/* Append promise resolving onto the user's redirect callback. */
						var injectFinalCallbacks = function() {
							if ((redirectOptions.display === undefined || redirectOptions.display === "none") && /Out$/.test(effectName)) {
								$.each(elements.nodeType ? [elements] : elements, function(i, element) {
									Velocity.CSS.setPropertyValue(element, "display", "none");
								});
							}
							if (redirectOptions.complete) {
								redirectOptions.complete.call(elements, elements);
							}
							if (promiseData) {
								promiseData.resolver(elements || element);
							}
						};

						opts.complete = function() {
							if (loop) {
								Velocity.Redirects[effectName](element, redirectOptions, elementsIndex, elementsSize, elements, promiseData, loop === true ? true : Math.max(0, loop - 1));
							}
							if (properties.reset) {
								for (var resetProperty in properties.reset) {
									if (!properties.reset.hasOwnProperty(resetProperty)) {
										continue;
									}
									var resetValue = properties.reset[resetProperty];

									/* Format each non-array value in the reset property map to [ value, value ] so that changes apply
									 immediately and DOM querying is avoided (via forcefeeding). */
									/* Note: Don't forcefeed hooks, otherwise their hook roots will be defaulted to their null values. */
									if (Velocity.CSS.Hooks.registered[resetProperty] === undefined && (typeof resetValue === "string" || typeof resetValue === "number")) {
										properties.reset[resetProperty] = [properties.reset[resetProperty], properties.reset[resetProperty]];
									}
								}

								/* So that the reset values are applied instantly upon the next rAF tick, use a zero duration and parallel queueing. */
								var resetOptions = {duration: 0, queue: false};

								/* Since the reset option uses up the complete callback, we trigger the user's complete callback at the end of ours. */
								if (finalElement) {
									resetOptions.complete = injectFinalCallbacks;
								}

								Velocity.animate(element, properties.reset, resetOptions);
								/* Only trigger the user's complete callback on the last effect call with the last element in the set. */
							} else if (finalElement) {
								injectFinalCallbacks();
							}
						};

						if (redirectOptions.visibility === "hidden") {
							opts.visibility = redirectOptions.visibility;
						}
					}

					Velocity.animate(element, propertyMap, opts);
				}
			};

			/* Return the Velocity object so that RegisterUI calls can be chained. */
			return Velocity;
		};

		/*********************
		 Packaged Effects
		 *********************/

		/* Externalize the packagedEffects data so that they can optionally be modified and re-registered. */
		/* Support: <=IE8: Callouts will have no effect, and transitions will simply fade in/out. IE9/Android 2.3: Most effects are fully supported, the rest fade in/out. All other browsers: full support. */
		Velocity.RegisterEffect.packagedEffects =
				{
					/* Animate.css */
					"callout.bounce": {
						defaultDuration: 550,
						calls: [
							[{translateY: -30}, 0.25],
							[{translateY: 0}, 0.125],
							[{translateY: -15}, 0.125],
							[{translateY: 0}, 0.25]
						]
					},
					/* Animate.css */
					"callout.shake": {
						defaultDuration: 800,
						calls: [
							[{translateX: -11}],
							[{translateX: 11}],
							[{translateX: -11}],
							[{translateX: 11}],
							[{translateX: -11}],
							[{translateX: 11}],
							[{translateX: -11}],
							[{translateX: 0}]
						]
					},
					/* Animate.css */
					"callout.flash": {
						defaultDuration: 1100,
						calls: [
							[{opacity: [0, "easeInOutQuad", 1]}],
							[{opacity: [1, "easeInOutQuad"]}],
							[{opacity: [0, "easeInOutQuad"]}],
							[{opacity: [1, "easeInOutQuad"]}]
						]
					},
					/* Animate.css */
					"callout.pulse": {
						defaultDuration: 825,
						calls: [
							[{scaleX: 1.1, scaleY: 1.1}, 0.50, {easing: "easeInExpo"}],
							[{scaleX: 1, scaleY: 1}, 0.50]
						]
					},
					/* Animate.css */
					"callout.swing": {
						defaultDuration: 950,
						calls: [
							[{rotateZ: 15}],
							[{rotateZ: -10}],
							[{rotateZ: 5}],
							[{rotateZ: -5}],
							[{rotateZ: 0}]
						]
					},
					/* Animate.css */
					"callout.tada": {
						defaultDuration: 1000,
						calls: [
							[{scaleX: 0.9, scaleY: 0.9, rotateZ: -3}, 0.10],
							[{scaleX: 1.1, scaleY: 1.1, rotateZ: 3}, 0.10],
							[{scaleX: 1.1, scaleY: 1.1, rotateZ: -3}, 0.10],
							["reverse", 0.125],
							["reverse", 0.125],
							["reverse", 0.125],
							["reverse", 0.125],
							["reverse", 0.125],
							[{scaleX: 1, scaleY: 1, rotateZ: 0}, 0.20]
						]
					},
					"transition.fadeIn": {
						defaultDuration: 500,
						calls: [
							[{opacity: [1, 0]}]
						]
					},
					"transition.fadeOut": {
						defaultDuration: 500,
						calls: [
							[{opacity: [0, 1]}]
						]
					},
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.flipXIn": {
						defaultDuration: 700,
						calls: [
							[{opacity: [1, 0], transformPerspective: [800, 800], rotateY: [0, -55]}]
						],
						reset: {transformPerspective: 0}
					},
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.flipXOut": {
						defaultDuration: 700,
						calls: [
							[{opacity: [0, 1], transformPerspective: [800, 800], rotateY: 55}]
						],
						reset: {transformPerspective: 0, rotateY: 0}
					},
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.flipYIn": {
						defaultDuration: 800,
						calls: [
							[{opacity: [1, 0], transformPerspective: [800, 800], rotateX: [0, -45]}]
						],
						reset: {transformPerspective: 0}
					},
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.flipYOut": {
						defaultDuration: 800,
						calls: [
							[{opacity: [0, 1], transformPerspective: [800, 800], rotateX: 25}]
						],
						reset: {transformPerspective: 0, rotateX: 0}
					},
					/* Animate.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.flipBounceXIn": {
						defaultDuration: 900,
						calls: [
							[{opacity: [0.725, 0], transformPerspective: [400, 400], rotateY: [-10, 90]}, 0.50],
							[{opacity: 0.80, rotateY: 10}, 0.25],
							[{opacity: 1, rotateY: 0}, 0.25]
						],
						reset: {transformPerspective: 0}
					},
					/* Animate.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.flipBounceXOut": {
						defaultDuration: 800,
						calls: [
							[{opacity: [0.9, 1], transformPerspective: [400, 400], rotateY: -10}],
							[{opacity: 0, rotateY: 90}]
						],
						reset: {transformPerspective: 0, rotateY: 0}
					},
					/* Animate.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.flipBounceYIn": {
						defaultDuration: 850,
						calls: [
							[{opacity: [0.725, 0], transformPerspective: [400, 400], rotateX: [-10, 90]}, 0.50],
							[{opacity: 0.80, rotateX: 10}, 0.25],
							[{opacity: 1, rotateX: 0}, 0.25]
						],
						reset: {transformPerspective: 0}
					},
					/* Animate.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.flipBounceYOut": {
						defaultDuration: 800,
						calls: [
							[{opacity: [0.9, 1], transformPerspective: [400, 400], rotateX: -15}],
							[{opacity: 0, rotateX: 90}]
						],
						reset: {transformPerspective: 0, rotateX: 0}
					},
					/* Magic.css */
					"transition.swoopIn": {
						defaultDuration: 850,
						calls: [
							[{opacity: [1, 0], transformOriginX: ["100%", "50%"], transformOriginY: ["100%", "100%"], scaleX: [1, 0], scaleY: [1, 0], translateX: [0, -700], translateZ: 0}]
						],
						reset: {transformOriginX: "50%", transformOriginY: "50%"}
					},
					/* Magic.css */
					"transition.swoopOut": {
						defaultDuration: 850,
						calls: [
							[{opacity: [0, 1], transformOriginX: ["50%", "100%"], transformOriginY: ["100%", "100%"], scaleX: 0, scaleY: 0, translateX: -700, translateZ: 0}]
						],
						reset: {transformOriginX: "50%", transformOriginY: "50%", scaleX: 1, scaleY: 1, translateX: 0}
					},
					/* Magic.css */
					/* Support: Loses rotation in IE9/Android 2.3. (Fades and scales only.) */
					"transition.whirlIn": {
						defaultDuration: 850,
						calls: [
							[{opacity: [1, 0], transformOriginX: ["50%", "50%"], transformOriginY: ["50%", "50%"], scaleX: [1, 0], scaleY: [1, 0], rotateY: [0, 160]}, 1, {easing: "easeInOutSine"}]
						]
					},
					/* Magic.css */
					/* Support: Loses rotation in IE9/Android 2.3. (Fades and scales only.) */
					"transition.whirlOut": {
						defaultDuration: 750,
						calls: [
							[{opacity: [0, "easeInOutQuint", 1], transformOriginX: ["50%", "50%"], transformOriginY: ["50%", "50%"], scaleX: 0, scaleY: 0, rotateY: 160}, 1, {easing: "swing"}]
						],
						reset: {scaleX: 1, scaleY: 1, rotateY: 0}
					},
					"transition.shrinkIn": {
						defaultDuration: 750,
						calls: [
							[{opacity: [1, 0], transformOriginX: ["50%", "50%"], transformOriginY: ["50%", "50%"], scaleX: [1, 1.5], scaleY: [1, 1.5], translateZ: 0}]
						]
					},
					"transition.shrinkOut": {
						defaultDuration: 600,
						calls: [
							[{opacity: [0, 1], transformOriginX: ["50%", "50%"], transformOriginY: ["50%", "50%"], scaleX: 1.3, scaleY: 1.3, translateZ: 0}]
						],
						reset: {scaleX: 1, scaleY: 1}
					},
					"transition.expandIn": {
						defaultDuration: 700,
						calls: [
							[{opacity: [1, 0], transformOriginX: ["50%", "50%"], transformOriginY: ["50%", "50%"], scaleX: [1, 0.625], scaleY: [1, 0.625], translateZ: 0}]
						]
					},
					"transition.expandOut": {
						defaultDuration: 700,
						calls: [
							[{opacity: [0, 1], transformOriginX: ["50%", "50%"], transformOriginY: ["50%", "50%"], scaleX: 0.5, scaleY: 0.5, translateZ: 0}]
						],
						reset: {scaleX: 1, scaleY: 1}
					},
					/* Animate.css */
					"transition.bounceIn": {
						defaultDuration: 800,
						calls: [
							[{opacity: [1, 0], scaleX: [1.05, 0.3], scaleY: [1.05, 0.3]}, 0.35],
							[{scaleX: 0.9, scaleY: 0.9, translateZ: 0}, 0.20],
							[{scaleX: 1, scaleY: 1}, 0.45]
						]
					},
					/* Animate.css */
					"transition.bounceOut": {
						defaultDuration: 800,
						calls: [
							[{scaleX: 0.95, scaleY: 0.95}, 0.35],
							[{scaleX: 1.1, scaleY: 1.1, translateZ: 0}, 0.35],
							[{opacity: [0, 1], scaleX: 0.3, scaleY: 0.3}, 0.30]
						],
						reset: {scaleX: 1, scaleY: 1}
					},
					/* Animate.css */
					"transition.bounceUpIn": {
						defaultDuration: 800,
						calls: [
							[{opacity: [1, 0], translateY: [-30, 1000]}, 0.60, {easing: "easeOutCirc"}],
							[{translateY: 10}, 0.20],
							[{translateY: 0}, 0.20]
						]
					},
					/* Animate.css */
					"transition.bounceUpOut": {
						defaultDuration: 1000,
						calls: [
							[{translateY: 20}, 0.20],
							[{opacity: [0, "easeInCirc", 1], translateY: -1000}, 0.80]
						],
						reset: {translateY: 0}
					},
					/* Animate.css */
					"transition.bounceDownIn": {
						defaultDuration: 800,
						calls: [
							[{opacity: [1, 0], translateY: [30, -1000]}, 0.60, {easing: "easeOutCirc"}],
							[{translateY: -10}, 0.20],
							[{translateY: 0}, 0.20]
						]
					},
					/* Animate.css */
					"transition.bounceDownOut": {
						defaultDuration: 1000,
						calls: [
							[{translateY: -20}, 0.20],
							[{opacity: [0, "easeInCirc", 1], translateY: 1000}, 0.80]
						],
						reset: {translateY: 0}
					},
					/* Animate.css */
					"transition.bounceLeftIn": {
						defaultDuration: 750,
						calls: [
							[{opacity: [1, 0], translateX: [30, -1250]}, 0.60, {easing: "easeOutCirc"}],
							[{translateX: -10}, 0.20],
							[{translateX: 0}, 0.20]
						]
					},
					/* Animate.css */
					"transition.bounceLeftOut": {
						defaultDuration: 750,
						calls: [
							[{translateX: 30}, 0.20],
							[{opacity: [0, "easeInCirc", 1], translateX: -1250}, 0.80]
						],
						reset: {translateX: 0}
					},
					/* Animate.css */
					"transition.bounceRightIn": {
						defaultDuration: 750,
						calls: [
							[{opacity: [1, 0], translateX: [-30, 1250]}, 0.60, {easing: "easeOutCirc"}],
							[{translateX: 10}, 0.20],
							[{translateX: 0}, 0.20]
						]
					},
					/* Animate.css */
					"transition.bounceRightOut": {
						defaultDuration: 750,
						calls: [
							[{translateX: -30}, 0.20],
							[{opacity: [0, "easeInCirc", 1], translateX: 1250}, 0.80]
						],
						reset: {translateX: 0}
					},
					"transition.slideUpIn": {
						defaultDuration: 900,
						calls: [
							[{opacity: [1, 0], translateY: [0, 20], translateZ: 0}]
						]
					},
					"transition.slideUpOut": {
						defaultDuration: 900,
						calls: [
							[{opacity: [0, 1], translateY: -20, translateZ: 0}]
						],
						reset: {translateY: 0}
					},
					"transition.slideDownIn": {
						defaultDuration: 900,
						calls: [
							[{opacity: [1, 0], translateY: [0, -20], translateZ: 0}]
						]
					},
					"transition.slideDownOut": {
						defaultDuration: 900,
						calls: [
							[{opacity: [0, 1], translateY: 20, translateZ: 0}]
						],
						reset: {translateY: 0}
					},
					"transition.slideLeftIn": {
						defaultDuration: 1000,
						calls: [
							[{opacity: [1, 0], translateX: [0, -20], translateZ: 0}]
						]
					},
					"transition.slideLeftOut": {
						defaultDuration: 1050,
						calls: [
							[{opacity: [0, 1], translateX: -20, translateZ: 0}]
						],
						reset: {translateX: 0}
					},
					"transition.slideRightIn": {
						defaultDuration: 1000,
						calls: [
							[{opacity: [1, 0], translateX: [0, 20], translateZ: 0}]
						]
					},
					"transition.slideRightOut": {
						defaultDuration: 1050,
						calls: [
							[{opacity: [0, 1], translateX: 20, translateZ: 0}]
						],
						reset: {translateX: 0}
					},
					"transition.slideUpBigIn": {
						defaultDuration: 850,
						calls: [
							[{opacity: [1, 0], translateY: [0, 75], translateZ: 0}]
						]
					},
					"transition.slideUpBigOut": {
						defaultDuration: 800,
						calls: [
							[{opacity: [0, 1], translateY: -75, translateZ: 0}]
						],
						reset: {translateY: 0}
					},
					"transition.slideDownBigIn": {
						defaultDuration: 850,
						calls: [
							[{opacity: [1, 0], translateY: [0, -75], translateZ: 0}]
						]
					},
					"transition.slideDownBigOut": {
						defaultDuration: 800,
						calls: [
							[{opacity: [0, 1], translateY: 75, translateZ: 0}]
						],
						reset: {translateY: 0}
					},
					"transition.slideLeftBigIn": {
						defaultDuration: 800,
						calls: [
							[{opacity: [1, 0], translateX: [0, -75], translateZ: 0}]
						]
					},
					"transition.slideLeftBigOut": {
						defaultDuration: 750,
						calls: [
							[{opacity: [0, 1], translateX: -75, translateZ: 0}]
						],
						reset: {translateX: 0}
					},
					"transition.slideRightBigIn": {
						defaultDuration: 800,
						calls: [
							[{opacity: [1, 0], translateX: [0, 75], translateZ: 0}]
						]
					},
					"transition.slideRightBigOut": {
						defaultDuration: 750,
						calls: [
							[{opacity: [0, 1], translateX: 75, translateZ: 0}]
						],
						reset: {translateX: 0}
					},
					/* Magic.css */
					"transition.perspectiveUpIn": {
						defaultDuration: 800,
						calls: [
							[{opacity: [1, 0], transformPerspective: [800, 800], transformOriginX: [0, 0], transformOriginY: ["100%", "100%"], rotateX: [0, -180]}]
						],
						reset: {transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%"}
					},
					/* Magic.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.perspectiveUpOut": {
						defaultDuration: 850,
						calls: [
							[{opacity: [0, 1], transformPerspective: [800, 800], transformOriginX: [0, 0], transformOriginY: ["100%", "100%"], rotateX: -180}]
						],
						reset: {transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%", rotateX: 0}
					},
					/* Magic.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.perspectiveDownIn": {
						defaultDuration: 800,
						calls: [
							[{opacity: [1, 0], transformPerspective: [800, 800], transformOriginX: [0, 0], transformOriginY: [0, 0], rotateX: [0, 180]}]
						],
						reset: {transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%"}
					},
					/* Magic.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.perspectiveDownOut": {
						defaultDuration: 850,
						calls: [
							[{opacity: [0, 1], transformPerspective: [800, 800], transformOriginX: [0, 0], transformOriginY: [0, 0], rotateX: 180}]
						],
						reset: {transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%", rotateX: 0}
					},
					/* Magic.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.perspectiveLeftIn": {
						defaultDuration: 950,
						calls: [
							[{opacity: [1, 0], transformPerspective: [2000, 2000], transformOriginX: [0, 0], transformOriginY: [0, 0], rotateY: [0, -180]}]
						],
						reset: {transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%"}
					},
					/* Magic.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.perspectiveLeftOut": {
						defaultDuration: 950,
						calls: [
							[{opacity: [0, 1], transformPerspective: [2000, 2000], transformOriginX: [0, 0], transformOriginY: [0, 0], rotateY: -180}]
						],
						reset: {transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%", rotateY: 0}
					},
					/* Magic.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.perspectiveRightIn": {
						defaultDuration: 950,
						calls: [
							[{opacity: [1, 0], transformPerspective: [2000, 2000], transformOriginX: ["100%", "100%"], transformOriginY: [0, 0], rotateY: [0, 180]}]
						],
						reset: {transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%"}
					},
					/* Magic.css */
					/* Support: Loses rotation in IE9/Android 2.3 (fades only). */
					"transition.perspectiveRightOut": {
						defaultDuration: 950,
						calls: [
							[{opacity: [0, 1], transformPerspective: [2000, 2000], transformOriginX: ["100%", "100%"], transformOriginY: [0, 0], rotateY: 180}]
						],
						reset: {transformPerspective: 0, transformOriginX: "50%", transformOriginY: "50%", rotateY: 0}
					}
				};

		/* Register the packaged effects. */
		for (var effectName in Velocity.RegisterEffect.packagedEffects) {
			if (Velocity.RegisterEffect.packagedEffects.hasOwnProperty(effectName)) {
				Velocity.RegisterEffect(effectName, Velocity.RegisterEffect.packagedEffects[effectName]);
			}
		}

		/*********************
		 Sequence Running
		 **********************/

		/* Note: Sequence calls must use Velocity's single-object arguments syntax. */
		Velocity.RunSequence = function(originalSequence) {
			var sequence = $.extend(true, [], originalSequence);

			if (sequence.length > 1) {
				$.each(sequence.reverse(), function(i, currentCall) {
					var nextCall = sequence[i + 1];

					if (nextCall) {
						/* Parallel sequence calls (indicated via sequenceQueue:false) are triggered
						 in the previous call's begin callback. Otherwise, chained calls are normally triggered
						 in the previous call's complete callback. */
						var currentCallOptions = currentCall.o || currentCall.options,
								nextCallOptions = nextCall.o || nextCall.options;

						var timing = (currentCallOptions && currentCallOptions.sequenceQueue === false) ? "begin" : "complete",
								callbackOriginal = nextCallOptions && nextCallOptions[timing],
								options = {};

						options[timing] = function() {
							var nextCallElements = nextCall.e || nextCall.elements;
							var elements = nextCallElements.nodeType ? [nextCallElements] : nextCallElements;

							if (callbackOriginal) {
								callbackOriginal.call(elements, elements);
							}
							Velocity(currentCall);
						};

						if (nextCall.o) {
							nextCall.o = $.extend({}, nextCallOptions, options);
						} else {
							nextCall.options = $.extend({}, nextCallOptions, options);
						}
					}
				});

				sequence.reverse();
			}

			Velocity(sequence[0]);
		};
	}((window.jQuery || window.Zepto || window), window, (window ? window.document : undefined));
}));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(621),
    keys = __webpack_require__(108);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1341);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('merge', __webpack_require__(1344));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(224),
    eq = __webpack_require__(225);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(183),
    isIterateeCall = __webpack_require__(163);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);





function createAction(type) {
  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */];
  var metaCreator = arguments[2];

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(payloadCreator) || Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__["a" /* default */])(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__["a" /* default */])(payloadCreator) || payloadCreator === __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] : function (head) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
  };

  var hasMeta = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(metaCreator);
  var typeString = type.toString();

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(undefined, arguments);
    var action = { type: type };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (hasMeta) {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return typeString;
  };

  return actionCreator;
}

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__combineActions__ = __webpack_require__(639);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function handleAction(type) {
  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__["a" /* default */];
  var defaultState = arguments[2];

  var types = type.toString().split(__WEBPACK_IMPORTED_MODULE_7__combineActions__["a" /* ACTION_TYPE_DELIMITER */]);
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(!Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__["a" /* default */])(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__["a" /* default */])(reducer) || Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__["a" /* default */])(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(aReducer) ? __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__["a" /* default */] : aReducer;
  }),
      _ref2 = _slicedToArray(_ref, 2),
      nextReducer = _ref2[0],
      throwReducer = _ref2[1];

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    var actionType = action.type;

    if (!actionType || !Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__["a" /* default */])(types, actionType.toString())) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNil);


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(1369);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(420)(module)))

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(636);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(626);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(420)(module)))

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(1372);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPE_DELIMITER; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isString__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_toString__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isSymbol__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);







var ACTION_TYPE_DELIMITER = '||';

function isValidActionType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isString__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(type) || Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isSymbol__["a" /* default */])(type);
}

function isValidActionTypes(types) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(types)) {
    return false;
  }
  return types.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(__WEBPACK_IMPORTED_MODULE_3_lodash_es_toString__["a" /* default */]).join(ACTION_TYPE_DELIMITER);
  return { toString: function toString() {
      return combinedActionType;
    } };
}

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(641);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flattenActionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return flattenReducerMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unflattenActionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ownKeys__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isMap__ = __webpack_require__(421);






var defaultNamespace = '/';

function get(key, x) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isMap__["a" /* default */])(x) ? x.get(key) : x[key];
}

var flattenWhenNode = function flattenWhenNode(predicate) {
  return function flatten(map) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$namespace = _ref.namespace,
        namespace = _ref$namespace === undefined ? defaultNamespace : _ref$namespace,
        prefix = _ref.prefix;

    var partialFlatMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var partialFlatActionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    function connectNamespace(type) {
      return partialFlatActionType ? '' + partialFlatActionType + namespace + type : type;
    }

    function connectPrefix(type) {
      if (partialFlatActionType || !prefix) {
        return type;
      }

      return '' + prefix + namespace + type;
    }

    Object(__WEBPACK_IMPORTED_MODULE_1__ownKeys__["a" /* default */])(map).forEach(function (type) {
      var nextNamespace = connectPrefix(connectNamespace(type));
      var mapValue = get(type, map);

      if (!predicate(mapValue)) {
        partialFlatMap[nextNamespace] = mapValue;
      } else {
        flatten(mapValue, { namespace: namespace, prefix: prefix }, partialFlatMap, nextNamespace);
      }
    });

    return partialFlatMap;
  };
};

var flattenActionMap = flattenWhenNode(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */]);
var flattenReducerMap = flattenWhenNode(function (node) {
  return (Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */])(node) || Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isMap__["a" /* default */])(node)) && !Object(__WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__["a" /* default */])(node);
});

function unflattenActionCreators(flatActionCreators) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$namespace = _ref2.namespace,
      namespace = _ref2$namespace === undefined ? defaultNamespace : _ref2$namespace,
      prefix = _ref2.prefix;

  function unflatten(flatActionType) {
    var partialNestedActionCreators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var partialFlatActionTypePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var nextNamespace = Object(__WEBPACK_IMPORTED_MODULE_0__camelCase__["a" /* default */])(partialFlatActionTypePath.shift());
    if (partialFlatActionTypePath.length) {
      if (!partialNestedActionCreators[nextNamespace]) {
        partialNestedActionCreators[nextNamespace] = {};
      }
      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
    } else {
      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
    }
  }

  var nestedActionCreators = {};
  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
    var unprefixedType = prefix ? type.replace('' + prefix + namespace, '') : type;
    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
  });

  return nestedActionCreators;
}



/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
// eslint-disable-next-line max-len
var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
var namespacer = '/';

function camelCase(string) {
  return string.match(wordPattern).reduce(function (camelCased, word, index) {
    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
  }, '');
}

/* harmony default export */ __webpack_exports__["a"] = (function (type) {
  return type.split(namespacer).map(camelCase).join(namespacer);
});

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDevices", function() { return getDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDevice", function() { return getDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteDevice", function() { return deleteDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteZone", function() { return deleteZone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
var getDevices=function getDevices(after){return after?Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])('devices?after='+after.getTime()):Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])('devices');};var getDevice=function getDevice(deviceId){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])('devices/'+deviceId);};var deleteDevice=function deleteDevice(deviceId){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["a" /* httpDelete */])('devices/'+deviceId);};var deleteZone=function deleteZone(deviceId){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["a" /* httpDelete */])('zone/'+deviceId);};

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["patchNode"] = patchNode;
/* harmony export (immutable) */ __webpack_exports__["getNodeCreationStatus"] = getNodeCreationStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
function patchNode(patch,deviceType,id){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('nodes/'+deviceType+'/'+id,patch);}function getNodeCreationStatus(id){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])('node-creation/poll/'+id);}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHeatingHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
function getHeatingHistory(id,start,end,timeUnit,rate){var heatingHistoryUrl=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'/history/heating/'+id,query:{start:start.valueOf(),end:end.valueOf(),timeUnit:timeUnit,rate:rate,operation:'AVG'}});return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])(heatingHistoryUrl);}

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addTextControlContactsApi;
/* harmony export (immutable) */ __webpack_exports__["c"] = getTextControlContactsApi;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteTextControlContactsApi;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateTextControlContactsApi;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
function addTextControlContactsApi(){for(var _len=arguments.length,contacts=Array(_len),_key=0;_key<_len;_key++){contacts[_key]=arguments[_key];}return __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */]('contacts',{contacts:contacts},true);}function getTextControlContactsApi(){return __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */]('contacts',true);}function deleteTextControlContactsApi(){for(var _len2=arguments.length,contactIds=Array(_len2),_key2=0;_key2<_len2;_key2++){contactIds[_key2]=arguments[_key2];}return __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["a" /* httpDelete */]('contacts',{contacts:contactIds},true);}function updateTextControlContactsApi(){for(var _len3=arguments.length,contacts=Array(_len3),_key3=0;_key3<_len3;_key3++){contacts[_key3]=arguments[_key3];}return __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["d" /* httpPut */]('contacts',{contacts:contacts},true);}

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = configureStore;
/* harmony export (immutable) */ __webpack_exports__["b"] = injectAsyncReducers;
/* harmony export (immutable) */ __webpack_exports__["c"] = injectAsyncSagas;
/* harmony export (immutable) */ __webpack_exports__["d"] = injectAsyncTrackers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middleware_tracking__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sagas_registration__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_thunk__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__middleware_timestamp__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__trackers_registration__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raven_js__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// @noflow
global.myData={};var logSagaErrors=function logSagaErrors(e){return global.console.log(e);};var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["a" /* default */])({onError: false?logSagaErrors:__WEBPACK_IMPORTED_MODULE_10_raven_js___default.a.captureException.bind(__WEBPACK_IMPORTED_MODULE_10_raven_js___default.a)});function configureStore(initialState){var DevTools=void 0;var allowDevTools=Object({"NODE_ENV":"production","PUBLIC_URL":"","PLATFORM":"web"}).REACT_APP_DEVTOOLS;var isProduction="production"!=='production';if(allowDevTools){DevTools=__webpack_require__(713).default;}var trackerMiddleware=Object(__WEBPACK_IMPORTED_MODULE_5__middleware_tracking__["a" /* default */])(global._satellite,global.myData);var middlewares=[__WEBPACK_IMPORTED_MODULE_7_redux_thunk___default.a,sagaMiddleware,trackerMiddleware,__WEBPACK_IMPORTED_MODULE_8__middleware_timestamp__["a" /* default */],isProduction&&Object(__WEBPACK_IMPORTED_MODULE_2_redux_logger__["createLogger"])({collapsed:true})].filter(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a);var enhancers=[__WEBPACK_IMPORTED_MODULE_1_redux__["applyMiddleware"].apply(undefined,_toConsumableArray(middlewares)),allowDevTools&&DevTools.instrument()].filter(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a);var enhancer=__WEBPACK_IMPORTED_MODULE_1_redux__["compose"].apply(undefined,_toConsumableArray(enhancers));var store=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["createStore"])(Object(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */])(),initialState,enhancer);// This will hold any reducers that are loaded at runtime in modules
store.asyncReducers={};if(false){// Enable Webpack Hot Module Replacement for reducers
module.hot.accept('./',function(){var nextCreateReducer=require('./').default;// If any core reducers change then reapply them with the
// async ones loaded so far applied too.
store.replaceReducer(nextCreateReducer(store.asyncReducers));});}__WEBPACK_IMPORTED_MODULE_5__middleware_tracking__["a" /* default */].registerTrackers(__WEBPACK_IMPORTED_MODULE_9__trackers_registration__["a" /* default */]);sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_6__sagas_registration__["a" /* default */]);return store;}// This is called when a module has been asynchronously loaded and wants
// to add some new reducers
function injectAsyncReducers(store,asyncReducers){store.asyncReducers=Object.assign({},store.asyncReducers,asyncReducers);store.replaceReducer(Object(__WEBPACK_IMPORTED_MODULE_3____["a" /* default */])(store.asyncReducers));}function injectAsyncSagas(sagas){sagas.forEach(sagaMiddleware.run);}function injectAsyncTrackers(trackers){__WEBPACK_IMPORTED_MODULE_5__middleware_tracking__["a" /* default */].registerTrackers(trackers);}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1406);


/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('getOr', __webpack_require__(292));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

module.exports = {
  equals: 'fantasy-land/equals',
  concat: 'fantasy-land/concat',
  empty: 'fantasy-land/empty',
  map: 'fantasy-land/map',
  ap: 'fantasy-land/ap',
  of: 'fantasy-land/of',
  reduce: 'fantasy-land/reduce',
  traverse: 'fantasy-land/traverse',
  chain: 'fantasy-land/chain',
  chainRec: 'fantasy-land/chainRec',
  extend: 'fantasy-land/extend',
  extract: 'fantasy-land/extract',
  bimap: 'fantasy-land/bimap',
  promap: 'fantasy-land/promap'
};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var mm = Symbol.for('@@meta:magical');

var copyDocumentation = function copyDocumentation(source, target) {
  var extensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (Object({"NODE_ENV":"production","PUBLIC_URL":"","PLATFORM":"web"}).FOLKTALE_DOCS !== 'false') {
    target[mm] = Object.assign({}, source[mm] || {}, extensions);
  }
};

module.exports = copyDocumentation;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var assertType = __webpack_require__(310);
var assertFunction = __webpack_require__(425);

var _require = __webpack_require__(426),
    union = _require.union,
    derivations = _require.derivations;

var provideAliases = __webpack_require__(311);
var adtMethods = __webpack_require__(427);
var extend = __webpack_require__(239);
var warnDeprecation = __webpack_require__(238);

var equality = derivations.equality,
    debugRepresentation = derivations.debugRepresentation,
    serialization = derivations.serialization;

/*~ stability: experimental */

var Result = union('folktale:Result', {
  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (a) => Result a b
   */
  Error: function Error(value) {
    return { value: value };
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (b) => Result a b
   */
  Ok: function Ok(value) {
    return { value: value };
  }
}).derive(equality, debugRepresentation, serialization);

var Error = Result.Error,
    Ok = Result.Ok;


var assertResult = assertType(Result);

extend(Error.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a, b: get (Result a b) => a
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Result.Error');
  }
});

extend(Ok.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a, b: get (Result a b) => b
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Result.Ok');
  }
});

/*~
 * ~belongsTo: Result
 */
adtMethods(Result, {
  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((b) => c) => Result a c
   */
  map: {
    /*~*/
    Error: function map(f) {
      assertFunction('Result.Error#map', f);
      return this;
    },

    /*~*/
    Ok: function map(f) {
      assertFunction('Result.Ok#map', f);
      return Ok(f(this.value));
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a ((b) => c)).(Result a b) => Result a c
   */
  apply: {
    /*~*/
    Error: function apply(anResult) {
      assertResult('Result.Error#apply', anResult);
      return this;
    },

    /*~*/
    Ok: function apply(anResult) {
      assertResult('Result.Ok#apply', anResult);
      return anResult.map(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((b) => Result a c) => Result a c
   */
  chain: {
    /*~*/
    Error: function chain(f) {
      assertFunction('Result.Error#chain', f);
      return this;
    },

    /*~*/
    Ok: function chain(f) {
      assertFunction('Result.Ok#chain', f);
      return f(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => b :: throws TypeError
   */
  unsafeGet: {
    /*~*/
    Error: function unsafeGet() {
      throw new TypeError('Can\'t extract the value of an Error.\n\nError does not contain a normal value - it contains an error.\nYou might consider switching from Result#unsafeGet to Result#getOrElse,\nor some other method that is not partial.\n      ');
    },

    /*~*/
    Ok: function unsafeGet() {
      return this.value;
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).(b) => b
   */
  getOrElse: {
    /*~*/
    Error: function getOrElse(_default) {
      return _default;
    },

    /*~*/
    Ok: function getOrElse(_default) {
      return this.value;
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((a) => Result c b) => Result c b
   */
  orElse: {
    /*~*/
    Error: function orElse(handler) {
      assertFunction('Result.Error#orElse', handler);
      return handler(this.value);
    },

    /*~*/
    Ok: function orElse(handler) {
      assertFunction('Result.Ok#orElse', handler);
      return this;
    }
  },

  /*~
   * stability: stable
   * type: |
   *   forall a, b: (Result a b).(Result a b) => Result a b
   *   where b is Semigroup
   */
  concat: {
    /*~*/
    Error: function concat(aResult) {
      assertResult('Result.Error#concat', aResult);
      return this;
    },

    /*~*/
    Ok: function concat(aResult) {
      var _this = this;

      assertResult('Result.Ok#concat', aResult);
      return aResult.map(function (xs) {
        return _this.value.concat(xs);
      });
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((a) => c, (b) => c) => c
   */
  fold: {
    /*~*/
    Error: function fold(f, g) {
      assertFunction('Result.Error#fold', f);
      assertFunction('Result.Error#fold', g);
      return f(this.value);
    },

    /*~*/
    Ok: function fold(f, g) {
      assertFunction('Result.Ok#fold', f);
      assertFunction('Result.Ok#fold', g);
      return g(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => Result b a
   */
  swap: {
    /*~*/
    Error: function swap() {
      return Ok(this.value);
    },

    /*~*/
    Ok: function swap() {
      return Error(this.value);
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   (Result a b).((a) => c, (b) => d) => Result c d
   */
  bimap: {
    /*~*/
    Error: function bimap(f, g) {
      assertFunction('Result.Error#bimap', f);
      assertFunction('Result.Error#bimap', g);
      return Error(f(this.value));
    },

    /*~*/
    Ok: function bimap(f, g) {
      assertFunction('Result.Ok#bimap', f);
      assertFunction('Result.Ok#bimap', g);
      return Ok(g(this.value));
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a, b, c:
   *     (Result a b).((a) => c) => Result c b
   */
  mapError: {
    /*~*/
    Error: function mapError(f) {
      assertFunction('Result.Error#mapError', f);
      return Error(f(this.value));
    },

    /*~*/
    Ok: function mapError(f) {
      assertFunction('Result.Ok#mapError', f);
      return this;
    }
  },

  /*~
   * stability: experimental
   * type: |
   *   forall a: (Maybe a).((a) => Boolean) => Maybe a
   */
  filter: {
    /*~*/
    Error: function filter(predicate) {
      assertFunction('Result.Error#filter', predicate);
      return this;
    },

    /*~*/
    Ok: function filter(predicate) {
      assertFunction('Result.Ok#filter', predicate);
      return predicate(this.value) ? this : Error();
    }
  }
});

Object.assign(Result, {
  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (b) => Result a b
   */
  of: function of(value) {
    return Ok(value);
  },


  /*~
   * deprecated:
   *   since: 2.0.0
   *   replacedBy: .unsafeGet()
   * type: |
   *   forall a, b: (Result a b).() => b :: (throws TypeError)
   */
  'get': function get() {
    warnDeprecation('`.get()` is deprecated, and has been renamed to `.unsafeGet()`.');
    return this.unsafeGet();
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => a or b
   */
  merge: function merge() {
    return this.value;
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => Validation a b
   */
  toValidation: function toValidation() {
    return __webpack_require__(1434)(this);
  },


  /*~
   * stability: experimental
   * type: |
   *   forall a, b: (Result a b).() => Maybe b
   */
  toMaybe: function toMaybe() {
    return __webpack_require__(659)(this);
  }
});

provideAliases(Error.prototype);
provideAliases(Ok.prototype);
provideAliases(Result);

module.exports = Result;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var assertType = __webpack_require__(310);
var assertFunction = __webpack_require__(425);

var _require = __webpack_require__(426),
    union = _require.union,
    derivations = _require.derivations;

var provideAliases = __webpack_require__(311);
var adtMethods = __webpack_require__(427);
var extend = __webpack_require__(239);
var warnDeprecation = __webpack_require__(238);

var equality = derivations.equality,
    debugRepresentation = derivations.debugRepresentation,
    serialization = derivations.serialization;

/*~ stability: experimental */

var Validation = union('folktale:Validation', {
  /*~
   * type: |
   *   forall a, b: (a) => Validation a b
   */
  Failure: function Failure(value) {
    return { value: value };
  },


  /*~
   * type: |
   *   forall a, b: (b) => Validation a b
   */
  Success: function Success(value) {
    return { value: value };
  }
}).derive(equality, debugRepresentation, serialization);

var Success = Validation.Success,
    Failure = Validation.Failure;

var assertValidation = assertType(Validation);

extend(Failure.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a, b: get (Validation a b) => a
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Validation.Failure');
  }
});

extend(Success.prototype, {
  /*~
   * isRequired: true
   * type: |
   *   forall a, b: get (Validation a b) => b
   */
  get value() {
    throw new TypeError('`value` can’t be accessed in an abstract instance of Validation.Success');
  }
});

/*~~belongsTo: Validation */
adtMethods(Validation, {
  /*~
   * type: |
   *   forall a, b, c: (Validation a b).((b) => c) => Validation a c
   */
  map: {
    /*~*/
    Failure: function map(transformation) {
      assertFunction('Validation.Failure#map', transformation);
      return this;
    },

    /*~*/
    Success: function map(transformation) {
      assertFunction('Validation.Success#map', transformation);
      return Success(transformation(this.value));
    }
  },

  /*~
   * type: |
   *   forall a, b, c: (Validation (b) => c).(Validation a b) => Validation a c
   */
  apply: {
    /*~*/
    Failure: function apply(aValidation) {
      assertValidation('Failure#apply', aValidation);
      return Failure.hasInstance(aValidation) ? Failure(this.value.concat(aValidation.value)) : /* otherwise */this;
    },

    /*~*/
    Success: function apply(aValidation) {
      assertValidation('Success#apply', aValidation);
      return Failure.hasInstance(aValidation) ? aValidation : /* otherwise */aValidation.map(this.value);
    }
  },

  /*~
   * type: |
   *   forall a, b: (Validation a b).() => b :: throws TypeError
   */
  unsafeGet: {
    /*~*/
    Failure: function unsafeGet() {
      throw new TypeError('Can\'t extract the value of a Failure.\n\n    Failure does not contain a normal value - it contains an error.\n    You might consider switching from Validation#get to Validation#getOrElse, or some other method\n    that is not partial.\n      ');
    },

    /*~*/
    Success: function unsafeGet() {
      return this.value;
    }
  },

  /*~
   * type: |
   *   forall a, b: (Validation a b).(b) => b
   */
  getOrElse: {
    /*~*/
    Failure: function getOrElse(_default) {
      return _default;
    },

    /*~*/
    Success: function getOrElse(_default) {
      return this.value;
    }
  },

  /*~
   * type: |
   *   forall a, b, c:
   *     (Validation a b).((a) => Validation c b) => Validation c b
   */
  orElse: {
    /*~*/
    Failure: function orElse(handler) {
      assertFunction('Validation.Failure#orElse', handler);
      return handler(this.value);
    },

    /*~*/
    Success: function orElse(handler) {
      assertFunction('Validation.Success#orElse', handler);
      return this;
    }
  },

  /*~
   * type: |
   *   forall a, b:
   *     (Validation a b).(Validation a b) => Validation a b
   *   where a is Semigroup
   */
  concat: {
    /*~*/
    Failure: function concat(aValidation) {
      assertValidation('Validation.Failure#concat', aValidation);
      if (Failure.hasInstance(aValidation)) {
        return Failure(this.value.concat(aValidation.value));
      } else {
        return this;
      }
    },

    /*~*/
    Success: function concat(aValidation) {
      assertValidation('Validation.Success#concat', aValidation);
      return aValidation;
    }
  },

  /*~
   * type: |
   *   forall a, b, c:
   *     (Validation a b).((a) => c, (b) => c) => c
   */
  fold: {
    /*~*/
    Failure: function fold(failureTransformation, successTransformation) {
      assertFunction('Validation.Failure#fold', failureTransformation);
      assertFunction('Validation.Failure#fold', successTransformation);
      return failureTransformation(this.value);
    },

    /*~*/
    Success: function fold(failureTransformation, successTransformation) {
      assertFunction('Validation.Success#fold', failureTransformation);
      assertFunction('Validation.Success#fold', successTransformation);
      return successTransformation(this.value);
    }
  },

  /*~
   * type: |
   *   forall a, b: (Validation a b).() => Validation b a
   */
  swap: {
    /*~*/
    Failure: function swap() {
      return Success(this.value);
    },

    /*~*/
    Success: function swap() {
      return Failure(this.value);
    }
  },

  /*~
   * type: |
   *   forall a, b, c, d:
   *     (Validation a b).((a) => c, (b) => d) => Validation c d
   */
  bimap: {
    /*~*/
    Failure: function bimap(failureTransformation, successTransformation) {
      assertFunction('Validation.Failure#fold', failureTransformation);
      assertFunction('Validation.Failure#fold', successTransformation);
      return Failure(failureTransformation(this.value));
    },

    /*~*/
    Success: function bimap(failureTransformation, successTransformation) {
      assertFunction('Validation.Success#fold', failureTransformation);
      assertFunction('Validation.Success#fold', successTransformation);
      return Success(successTransformation(this.value));
    }
  },

  /*~
   * type: |
   *   forall a, b, c:
   *     (Validation a b).((a) => c) Validation c b
   */
  mapFailure: {
    /*~*/
    Failure: function mapFailure(transformation) {
      assertFunction('Validation.Failure#mapFailure', transformation);
      return Failure(transformation(this.value));
    },

    /*~*/
    Success: function mapFailure(transformation) {
      assertFunction('Validation.Failure#mapFailure', transformation);
      return this;
    }
  }
});

Object.assign(Validation, {
  /*~
   * type: |
   *   forall a, b: (b) => Validation a b
   */
  of: function of(value) {
    return Success(value);
  },


  /*~
   * type: |
   *   forall a, b: (Validation a b).() => b :: throws TypeError
   */
  'get': function get() {
    warnDeprecation('`.get()` is deprecated, and has been renamed to `.unsafeGet()`.');
    return this.unsafeGet();
  },


  /*~
   * type: |
   *   forall a, b: (Validation a b).() => a or b
   */
  merge: function merge() {
    return this.value;
  },


  /*~
   * type: |
   *   forall a, b: (Validation a b).() => Result a b
   */
  toResult: function toResult() {
    return __webpack_require__(1435)(this);
  },


  /*~
   * type: |
   *   forall a, b: (Validation a b).() => Maybe b
   */
  toMaybe: function toMaybe() {
    return __webpack_require__(658)(this);
  }
});

provideAliases(Success.prototype);
provideAliases(Failure.prototype);
provideAliases(Validation);

module.exports = Validation;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(309),
    Just = _require.Just,
    Nothing = _require.Nothing;

/*~
 * stability: stable
 * authors: 
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *     (Validation a b) => Maybe b
 */


var validationToMaybe = function validationToMaybe(aValidation) {
  return aValidation.matchWith({
    Failure: function Failure() {
      return Nothing();
    },
    Success: function Success(_ref) {
      var value = _ref.value;
      return Just(value);
    }
  });
};

module.exports = validationToMaybe;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(309),
    Just = _require.Just,
    Nothing = _require.Nothing;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 *
 * type: |
 *   forall a, b:
 *     (Result a b) => Maybe b
 */


var resultToMaybe = function resultToMaybe(aResult) {
  return aResult.matchWith({
    Error: function Error(_ref) {
      var _ = _ref.value;
      return Nothing();
    },
    Ok: function Ok(_ref2) {
      var value = _ref2.value;
      return Just(value);
    }
  });
};

module.exports = resultToMaybe;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1443);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(groups,id){for(var i=0;i<groups.size;i++){// $FlowFixMe
var device=groups.get(i).get('items').find(function(device){return device.get('id')===id;});if(device){return i+':'+device.get('position');}}});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_dashboard__ = __webpack_require__(534);
/* harmony default export */ __webpack_exports__["a"] = (function(pages){if(!pages){return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();}// $FlowFixMe
var nextAvailablePage=(pages.find(function(p){return p.get('items').count()<__WEBPACK_IMPORTED_MODULE_2__constants_dashboard__["a" /* GROUP_SIZE */];})||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({position:-1})).get('position');// $FlowFixMe
var usedPositions=pages.getIn([nextAvailablePage,'items'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({})).map(function(item){return item.get('position');}).sort();var nextAvailablePos=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,__WEBPACK_IMPORTED_MODULE_2__constants_dashboard__["a" /* GROUP_SIZE */]).filter(function(pos){return!usedPositions.some(function(usedPos){return usedPos===pos;});})[0];var nextPos=nextAvailablePos||nextAvailablePos===0?nextAvailablePos:-1;return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({page:nextAvailablePage,position:nextPos});});

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('takeRight', __webpack_require__(1448));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('take', __webpack_require__(1449));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(196),
    isArrayLike = __webpack_require__(92);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(365),
    flatRest = __webpack_require__(294),
    getData = __webpack_require__(363),
    getFuncName = __webpack_require__(550),
    isArray = __webpack_require__(32),
    isLaziable = __webpack_require__(549);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(667);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidMount` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          if (this.subscription) this.subscription.tryUnsubscribe();
          this.initSubscription();
          if (shouldHandleStateChanges) this.subscription.trySubscribe();
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(670);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(432);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Reads any potentially deep value from an object using dot and array syntax
 */
var read = function read(path, object) {
  if (!path || !object) {
    return object;
  }
  var dotIndex = path.indexOf('.');
  if (dotIndex === 0) {
    return read(path.substring(1), object);
  }
  var openIndex = path.indexOf('[');
  var closeIndex = path.indexOf(']');
  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
    // iterate down object tree
    return read(path.substring(dotIndex + 1), object[path.substring(0, dotIndex)]);
  }
  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    if (closeIndex < 0) {
      throw new Error('found [ but no ]');
    }
    var key = path.substring(0, openIndex);
    var index = path.substring(openIndex + 1, closeIndex);
    if (!index.length) {
      return object[key];
    }
    if (openIndex === 0) {
      return read(path.substring(closeIndex + 1), object[index]);
    }
    if (!object[key]) {
      return undefined;
    }
    return read(path.substring(closeIndex + 1), object[key][index]);
  }
  return object[path];
};

exports.default = read;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Writes any potentially deep value from an object using dot and array syntax,
 * and returns a new copy of the object.
 */
var write = function write(path, value, object) {
  var _extends7;

  var dotIndex = path.indexOf('.');
  if (dotIndex === 0) {
    return write(path.substring(1), value, object);
  }
  var openIndex = path.indexOf('[');
  var closeIndex = path.indexOf(']');
  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
    var _extends2;

    // is dot notation
    var key = path.substring(0, dotIndex);
    return _extends({}, object, (_extends2 = {}, _extends2[key] = write(path.substring(dotIndex + 1), value, object[key] || {}), _extends2));
  }
  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    var _extends6;

    // is array notation
    if (closeIndex < 0) {
      throw new Error('found [ but no ]');
    }
    var _key = path.substring(0, openIndex);
    var index = path.substring(openIndex + 1, closeIndex);
    var array = object[_key] || [];
    var rest = path.substring(closeIndex + 1);
    if (index) {
      var _extends4;

      // indexed array
      if (rest.length) {
        var _extends3;

        // need to keep recursing
        var dest = array[index] || {};
        var arrayCopy = [].concat(array);
        arrayCopy[index] = write(rest, value, dest);
        return _extends({}, object || {}, (_extends3 = {}, _extends3[_key] = arrayCopy, _extends3));
      }
      var copy = [].concat(array);
      copy[index] = typeof value === 'function' ? value(copy[index]) : value;
      return _extends({}, object || {}, (_extends4 = {}, _extends4[_key] = copy, _extends4));
    }
    // indexless array
    if (rest.length) {
      var _extends5;

      // need to keep recursing
      if ((!array || !array.length) && typeof value === 'function') {
        return object; // don't even set a value under [key]
      }
      var _arrayCopy = array.map(function (dest) {
        return write(rest, value, dest);
      });
      return _extends({}, object || {}, (_extends5 = {}, _extends5[_key] = _arrayCopy, _extends5));
    }
    var result = void 0;
    if (Array.isArray(value)) {
      result = value;
    } else if (object[_key]) {
      result = array.map(function (dest) {
        return typeof value === 'function' ? value(dest) : value;
      });
    } else if (typeof value === 'function') {
      return object; // don't even set a value under [key]
    } else {
      result = value;
    }
    return _extends({}, object || {}, (_extends6 = {}, _extends6[_key] = result, _extends6));
  }
  return _extends({}, object, (_extends7 = {}, _extends7[path] = typeof value === 'function' ? value(object[path]) : value, _extends7));
};

exports.default = write;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _fieldValue = __webpack_require__(199);

/**
 * A different version of getValues() that does not need the fields array
 */
var getValuesFromState = function getValuesFromState(state) {
  if (!state) {
    return state;
  }
  var keys = Object.keys(state);
  if (!keys.length) {
    return undefined;
  }
  return keys.reduce(function (accumulator, key) {
    var field = state[key];
    if (field) {
      if ((0, _fieldValue.isFieldValue)(field)) {
        if (field.value !== undefined) {
          accumulator[key] = field.value;
        }
      } else if (Array.isArray(field)) {
        accumulator[key] = field.map(function (arrayField) {
          return (0, _fieldValue.isFieldValue)(arrayField) ? arrayField.value : getValuesFromState(arrayField);
        });
      } else if (typeof field === 'object') {
        var result = getValuesFromState(field);

        if (result && Object.keys(result).length > 0) {
          accumulator[key] = result;
        }
      }
    }
    return accumulator;
  }, {});
};

exports.default = getValuesFromState;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fieldValue = __webpack_require__(199);

var makeEntry = function makeEntry(value, previousValue, overwriteValues) {
  if (value === undefined && previousValue === undefined) return (0, _fieldValue.makeFieldValue)({});
  return (0, _fieldValue.makeFieldValue)({
    initial: value,
    value: overwriteValues ? value : previousValue
  });
};

/**
 * Sets the initial values into the state and returns a new copy of the state
 */
var initializeState = function initializeState(values, fields) {
  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!fields) {
    throw new Error('fields must be passed when initializing state');
  }
  if (!values || !fields.length) {
    return state;
  }
  var initializeField = function initializeField(path, src, dest) {
    var dotIndex = path.indexOf('.');
    if (dotIndex === 0) {
      return initializeField(path.substring(1), src, dest);
    }
    var openIndex = path.indexOf('[');
    var closeIndex = path.indexOf(']');
    var result = _extends({}, dest) || {};
    if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
      // is dot notation
      var key = path.substring(0, dotIndex);
      result[key] = src[key] && initializeField(path.substring(dotIndex + 1), src[key], result[key] || {});
    } else if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
      // is array notation
      if (closeIndex < 0) {
        throw new Error('found \'[\' but no \']\': \'' + path + '\'');
      }
      var _key = path.substring(0, openIndex);
      var srcArray = src[_key];
      var destArray = result[_key];
      var rest = path.substring(closeIndex + 1);
      if (Array.isArray(srcArray)) {
        if (rest.length) {
          // need to keep recursing
          result[_key] = srcArray.map(function (srcValue, srcIndex) {
            return initializeField(rest, srcValue, destArray && destArray[srcIndex]);
          });
        } else {
          result[_key] = srcArray.map(function (srcValue, srcIndex) {
            return makeEntry(srcValue, destArray && destArray[srcIndex] && destArray[srcIndex].value, overwriteValues);
          });
        }
      } else {
        result[_key] = [];
      }
    } else {
      result[path] = makeEntry(src && src[path], dest && dest[path] && dest[path].value, overwriteValues);
    }
    return result;
  };
  return fields.reduce(function (accumulator, field) {
    return initializeField(field, values, accumulator);
  }, _extends({}, state));
};

exports.default = initializeState;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reducer = __webpack_require__(433);

var _initializeState = __webpack_require__(674);

var _initializeState2 = _interopRequireDefault(_initializeState);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createInitialState = function createInitialState(data, fields, state) {
  var _extends2;

  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var markInitialized = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

  return _extends({}, (0, _initializeState2.default)(data, fields, state, overwriteValues), (_extends2 = {
    _asyncValidating: false,
    _active: undefined
  }, _extends2[_reducer.globalErrorKey] = undefined, _extends2._initialized = markInitialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
};

exports.default = createInitialState;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getDisplayName;
function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
}

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.untouch = exports.touch = exports.swapArrayValues = exports.submitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.removeArrayValue = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.autofill = exports.addArrayValue = undefined;

var _actionTypes = __webpack_require__(434);

var addArrayValue = exports.addArrayValue = function addArrayValue(path, value, index, fields) {
  return { type: _actionTypes.ADD_ARRAY_VALUE, path: path, value: value, index: index, fields: fields };
};

var autofill = exports.autofill = function autofill(field, value) {
  return { type: _actionTypes.AUTOFILL, field: field, value: value };
};

var blur = exports.blur = function blur(field, value) {
  return { type: _actionTypes.BLUR, field: field, value: value };
};

var change = exports.change = function change(field, value) {
  return { type: _actionTypes.CHANGE, field: field, value: value };
};

var destroy = exports.destroy = function destroy() {
  return { type: _actionTypes.DESTROY };
};

var focus = exports.focus = function focus(field) {
  return { type: _actionTypes.FOCUS, field: field };
};

var initialize = exports.initialize = function initialize(data, fields) {
  var overwriteValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!Array.isArray(fields)) {
    throw new Error('must provide fields array to initialize() action creator');
  }
  return { type: _actionTypes.INITIALIZE, data: data, fields: fields, overwriteValues: overwriteValues };
};

var removeArrayValue = exports.removeArrayValue = function removeArrayValue(path, index) {
  return { type: _actionTypes.REMOVE_ARRAY_VALUE, path: path, index: index };
};

var reset = exports.reset = function reset() {
  return { type: _actionTypes.RESET };
};

var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(field) {
  return { type: _actionTypes.START_ASYNC_VALIDATION, field: field };
};

var startSubmit = exports.startSubmit = function startSubmit() {
  return { type: _actionTypes.START_SUBMIT };
};

var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(errors) {
  return { type: _actionTypes.STOP_ASYNC_VALIDATION, errors: errors };
};

var stopSubmit = exports.stopSubmit = function stopSubmit(errors) {
  return { type: _actionTypes.STOP_SUBMIT, errors: errors };
};

var submitFailed = exports.submitFailed = function submitFailed() {
  return { type: _actionTypes.SUBMIT_FAILED };
};

var swapArrayValues = exports.swapArrayValues = function swapArrayValues(path, indexA, indexB) {
  return { type: _actionTypes.SWAP_ARRAY_VALUES, path: path, indexA: indexA, indexB: indexB };
};

var touch = exports.touch = function touch() {
  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
    fields[_key] = arguments[_key];
  }

  return { type: _actionTypes.TOUCH, fields: fields };
};

var untouch = exports.untouch = function untouch() {
  for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fields[_key2] = arguments[_key2];
  }

  return { type: _actionTypes.UNTOUCH, fields: fields };
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = bindActionData;

var _mapValues = __webpack_require__(435);

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Adds additional properties to the results of the function or map of functions passed
 */
function bindActionData(action, data) {
  if (typeof action === 'function') {
    return function () {
      return _extends({}, action.apply(undefined, arguments), data);
    };
  }
  if (typeof action === 'object') {
    return (0, _mapValues2.default)(action, function (value) {
      return bindActionData(value, data);
    });
  }
  return action;
}

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Given a state[field], get the value.
 *  Fallback to .initialValue when .value is undefined to prevent double render/initialize cycle.
 *  See {@link https://github.com/erikras/redux-form/issues/621}.
 */
var itemToValue = function itemToValue(_ref) {
  var value = _ref.value,
      initialValue = _ref.initialValue;
  return typeof value !== 'undefined' ? value : initialValue;
};

var getValue = function getValue(field, state, dest) {
  var dotIndex = field.indexOf('.');
  var openIndex = field.indexOf('[');
  var closeIndex = field.indexOf(']');
  if (openIndex > 0 && closeIndex !== openIndex + 1) {
    throw new Error('found [ not followed by ]');
  }
  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    // array field
    var key = field.substring(0, openIndex);
    var rest = field.substring(closeIndex + 1);
    if (rest[0] === '.') {
      rest = rest.substring(1);
    }
    var array = state && state[key] || [];
    if (rest) {
      if (!dest[key]) {
        dest[key] = [];
      }
      array.forEach(function (item, index) {
        if (!dest[key][index]) {
          dest[key][index] = {};
        }
        getValue(rest, item, dest[key][index]);
      });
    } else {
      dest[key] = array.map(itemToValue);
    }
  } else if (dotIndex > 0) {
    // subobject field
    var _key = field.substring(0, dotIndex);
    var _rest = field.substring(dotIndex + 1);
    if (!dest[_key]) {
      dest[_key] = {};
    }
    getValue(_rest, state && state[_key] || {}, dest[_key]);
  } else {
    dest[field] = state[field] && itemToValue(state[field]);
  }
};

var getValues = function getValues(fields, state) {
  return fields.reduce(function (accumulator, field) {
    getValue(field, state, accumulator);
    return accumulator;
  }, {});
};

exports.default = getValues;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isEvent = __webpack_require__(681);

var _isEvent2 = _interopRequireDefault(_isEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if ((0, _isEvent2.default)(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var _event$target = event.target,
        type = _event$target.type,
        value = _event$target.value,
        checked = _event$target.checked,
        files = _event$target.files,
        dataTransfer = event.dataTransfer;

    if (type === 'checkbox') {
      return checked;
    }
    if (type === 'radio') {
      return checked ? value : '';
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    if (value !== '' && (type === 'number' || type === 'range')) {
      return parseFloat(value);
    }
    return value;
  }
  // not an event, so must be either our value or an object containing our value in the 'value' key
  return event && typeof event === 'object' && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
  event;
};

exports.default = getValue;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

exports.default = isEvent;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var dataKey = exports.dataKey = 'value';
var createOnDragStart = function createOnDragStart(name, getValue) {
  return function (event) {
    event.dataTransfer.setData(dataKey, getValue());
  };
};

exports.default = createOnDragStart;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isChecked = function isChecked(value) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    var lower = value.toLowerCase();
    if (lower === 'true') {
      return true;
    }
    if (lower === 'false') {
      return false;
    }
  }
  return undefined;
};

exports.default = isChecked;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isEvent = __webpack_require__(681);

var _isEvent2 = _interopRequireDefault(_isEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var silenceEvent = function silenceEvent(event) {
  var is = (0, _isEvent2.default)(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

exports.default = silenceEvent;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(196);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 686 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('includes', __webpack_require__(1524));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1526),
    keys = __webpack_require__(108);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productReducers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__types__);
var _productReducers,_actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({hubOfflineNotifications:{status:false}});var productReducers=(_productReducers={},_defineProperty(_productReducers,__WEBPACK_IMPORTED_MODULE_4__constants__["k" /* SET_DEFAULT_MUTING_DONE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref){var _ref$payload=_ref.payload,productId=_ref$payload.productId,defaultMuting=_ref$payload.defaultMuting;var index=Object(__WEBPACK_IMPORTED_MODULE_3__selectors__["x" /* getProductIndexById */])(state,productId);return Object.assign({},state,{productItems:state.productItems.setIn([index,'state'],state.productItems.getIn([index,'state']).merge(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(defaultMuting)))});})),_defineProperty(_productReducers,__WEBPACK_IMPORTED_MODULE_4__constants__["o" /* TOGGLE_MONITORING_ALL_DONE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref2){var _ref2$payload=_ref2.payload,productId=_ref2$payload.productId,isMonitoring=_ref2$payload.isMonitoring;var index=Object(__WEBPACK_IMPORTED_MODULE_3__selectors__["x" /* getProductIndexById */])(state,productId);return Object.assign({},state,{productItems:state.productItems.setIn([index,'state','mute'],isMonitoring)});})),_defineProperty(_productReducers,__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* TOGGLE_MONITORING_SENSOR_DONE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref3){var _ref3$payload=_ref3.payload,productId=_ref3$payload.productId,isMonitoring=_ref3$payload.isMonitoring,sensorType=_ref3$payload.sensorType;var index=Object(__WEBPACK_IMPORTED_MODULE_3__selectors__["x" /* getProductIndexById */])(state,productId);return Object.assign({},state,{productItems:state.productItems.setIn([index,'state','sensors',sensorType],isMonitoring)});})),_productReducers);var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* CHANGE_SENSE_LOGS_SELECTED_DAY */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref4){var _ref4$payload=_ref4.payload,id=_ref4$payload.id,selectedDay=_ref4$payload.selectedDay;return state.withMutations(function(state){return state.setIn([id,selectedDay,'loadError'],false).setIn([id,selectedDay,'hasLoaded'],false).setIn([id,'selectedDay'],selectedDay);});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* DELETE_SENSE_EVENT_COMPLETE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref5){var _ref5$payload=_ref5.payload,id=_ref5$payload.id,mediaId=_ref5$payload.mediaId;var selectedDay=state.getIn([id,'selectedDay']);var dayEvents=state.getIn([id,selectedDay,'events']);var index=dayEvents.findIndex(function(log){return log.get('media')===mediaId;});return state.deleteIn([id,selectedDay,'events',index]);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* FLAG_SENSE_MEDIA_COMPLETE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref6){var _ref6$payload=_ref6.payload,id=_ref6$payload.id,mediaId=_ref6$payload.mediaId;var selectedDay=state.getIn([id,'selectedDay']);var dayEvents=state.getIn([id,selectedDay,'events']);var index=dayEvents.findIndex(function(log){return log.get('media')===mediaId;});return state.setIn([id,selectedDay,'events',index,'flagged'],true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["f" /* GET_SENSE_DAY_EVENT_LOGS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref7){var _ref7$payload=_ref7.payload,id=_ref7$payload.id,selectedDay=_ref7$payload.selectedDay;return state.setIn([id,selectedDay,'hasLoaded'],false);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* RECEIVE_SENSE_DAY_EVENT_LOGS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref8){var _ref8$payload=_ref8.payload,id=_ref8$payload.id,selectedDay=_ref8$payload.selectedDay,eventLogs=_ref8$payload.eventLogs;return state.withMutations(function(state){return state.setIn([id,selectedDay,'events'],eventLogs).setIn([id,selectedDay,'hasLoaded'],true);});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* RECEIVED_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref9){var status=_ref9.payload.status;return state.setIn(['hubOfflineNotifications','status'],status);})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])(actionHandlers,initialState));

/***/ }),
/* 690 */
/***/ (function(module, exports) {



/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(240);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 692 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 693 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 695 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(698);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(318);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(74);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return synchronousSagas; });
/* harmony export (immutable) */ __webpack_exports__["a"] = root;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_map__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flatten__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_sagas__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__alerts_sagas__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__application_sagas__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_settings_sagas__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__homes_sagas__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__acquire_devices_sagas__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ui_sensor_logs_audio_player_sagas__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__authentication_sagas__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__products_bulbs_sagas__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__camera_sagas__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_sagas__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__connected_care_invite_sagas__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__products_contact_sensor_sagas__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__cookies_sagas__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dashboard_sagas__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__devices_sagas__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__entitlements_sagas__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__groups_sagas__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__products_heating_hotwater_sagas__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__products_heating_sagas__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__holiday_mode_sagas__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__honeycomb_sagas__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__hub_sagas__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__products_leak_sensor_sagas__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__products_motion_sensor_sagas__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__install_nano1_upgrade_sagas__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__notifications_sagas__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__power_consumption_sagas__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__products_sagas__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__recipes_sagas__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ui_schedule_sagas__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__products_sense_sagas__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__text_control_sagas__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__products_thermostat_sagas__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__translations_sagas__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__user_sagas__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__weather_sagas__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__install_hue_bridge_sagas__ = __webpack_require__(1827);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(root);var forkSagas=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["a" /* all */],__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default()(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* fork */]),__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flatten___default.a);var synchronousSagas={actions:__WEBPACK_IMPORTED_MODULE_5__actions_sagas__["a" /* default */],holidayMode:__WEBPACK_IMPORTED_MODULE_25__holiday_mode_sagas__["a" /* default */],alert:__WEBPACK_IMPORTED_MODULE_6__alerts_sagas__["a" /* default */],appSettings:__WEBPACK_IMPORTED_MODULE_8__app_settings_sagas__["a" /* default */],application:__WEBPACK_IMPORTED_MODULE_7__application_sagas__["a" /* default */],aquireDevice:__WEBPACK_IMPORTED_MODULE_10__acquire_devices_sagas__["a" /* default */],audioPlayer:__WEBPACK_IMPORTED_MODULE_11__ui_sensor_logs_audio_player_sagas__["a" /* default */],authentication:__WEBPACK_IMPORTED_MODULE_12__authentication_sagas__["a" /* default */],bulb:__WEBPACK_IMPORTED_MODULE_13__products_bulbs_sagas__["a" /* default */],camera:__WEBPACK_IMPORTED_MODULE_14__camera_sagas__["a" /* default */],config:__WEBPACK_IMPORTED_MODULE_15__config_sagas__["a" /* default */],connectedCareInvite:__WEBPACK_IMPORTED_MODULE_16__connected_care_invite_sagas__["a" /* default */],cookie:__WEBPACK_IMPORTED_MODULE_18__cookies_sagas__["a" /* default */],device:__WEBPACK_IMPORTED_MODULE_20__devices_sagas__["a" /* default */],entitlement:__WEBPACK_IMPORTED_MODULE_21__entitlements_sagas__["a" /* default */],groups:__WEBPACK_IMPORTED_MODULE_22__groups_sagas__["a" /* default */],heatingHotwater:__WEBPACK_IMPORTED_MODULE_23__products_heating_hotwater_sagas__["a" /* default */],heating:__WEBPACK_IMPORTED_MODULE_24__products_heating_sagas__["a" /* default */],honeycomb:__WEBPACK_IMPORTED_MODULE_26__honeycomb_sagas__["a" /* default */],homes:__WEBPACK_IMPORTED_MODULE_9__homes_sagas__["a" /* default */],hub:__WEBPACK_IMPORTED_MODULE_27__hub_sagas__["a" /* default */],nano1Upgrade:__WEBPACK_IMPORTED_MODULE_30__install_nano1_upgrade_sagas__["a" /* default */],notification:__WEBPACK_IMPORTED_MODULE_31__notifications_sagas__["a" /* default */],powerConsumption:__WEBPACK_IMPORTED_MODULE_32__power_consumption_sagas__["a" /* default */],product:__WEBPACK_IMPORTED_MODULE_33__products_sagas__["a" /* default */],senseSaga:__WEBPACK_IMPORTED_MODULE_36__products_sense_sagas__["a" /* default */],textControl:__WEBPACK_IMPORTED_MODULE_37__text_control_sagas__["a" /* default */],thermostat:__WEBPACK_IMPORTED_MODULE_38__products_thermostat_sagas__["a" /* default */],translation:__WEBPACK_IMPORTED_MODULE_39__translations_sagas__["a" /* default */],user:__WEBPACK_IMPORTED_MODULE_40__user_sagas__["a" /* default */],weather:__WEBPACK_IMPORTED_MODULE_41__weather_sagas__["a" /* default */],recipe:__WEBPACK_IMPORTED_MODULE_34__recipes_sagas__["a" /* default */],schedule:__WEBPACK_IMPORTED_MODULE_35__ui_schedule_sagas__["a" /* default */],dashboard:__WEBPACK_IMPORTED_MODULE_19__dashboard_sagas__["a" /* default */],leakSensor:__WEBPACK_IMPORTED_MODULE_28__products_leak_sensor_sagas__["a" /* default */],motionSensor:__WEBPACK_IMPORTED_MODULE_29__products_motion_sensor_sagas__["a" /* default */],contactSensor:__WEBPACK_IMPORTED_MODULE_17__products_contact_sensor_sagas__["a" /* default */],hueBridge:__WEBPACK_IMPORTED_MODULE_42__install_hue_bridge_sagas__["a" /* default */]};function root(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function root$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return forkSagas(Object.values(synchronousSagas));case 2:case'end':return _context.stop();}}},_marked,this);}

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = injectGTMLoader;
/* harmony export (immutable) */ __webpack_exports__["b"] = isGTMActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
// @noflow
function injectGTMLoader(containerId){if(true){var s=document.createElement('script');s.type='text/javascript';s.innerText='(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\'});\n\t\tvar f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;\n\t\tj.src= \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);})\n\t\t(window,document,\'script\',\'dataLayer\',\''+containerId+'\');';document.getElementsByTagName('head')[0].appendChild(s);}}function isGTMActive(tag){return tag&&tag.get('active')&&__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().isBetween(tag.get('start'),tag.get('end'));}

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return POLL_NODE_EXISTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_POLL_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATION_FAILED; });
var POLL_NODE_EXISTS='hive/honeycomb/POLL_NODE_EXISTS';var MAX_POLL_TIMEOUT=60000;var CREATION_FAILED='FAILED';

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('values', __webpack_require__(688), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(694);
var bytesToUuid = __webpack_require__(695);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formToNewAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formToEditAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionToForm; });
/* unused harmony export transformEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return normaliseTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_values__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_curry__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v1__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid_v1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_actions__ = __webpack_require__(75);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// check if the minimum settings are present, otherwise use the default value
var validSettings=function validSettings(logic,settingsDefinitions,currentSettingsValues){var previousSettings=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};return logic.reduce(function(acc,l){var definition=settingsDefinitions[l.settingId];var settingValue=currentSettingsValues[definition.propertyName]!=null?currentSettingsValues[definition.propertyName]:definition.defaultValue;var newSettingsValue=Object.assign({},acc,_defineProperty({},definition.propertyName,settingValue));var childrenLogic=l.ifValue&&l.ifValue[settingValue];return childrenLogic?validSettings(childrenLogic,settingsDefinitions,currentSettingsValues,newSettingsValue):newSettingsValue;},previousSettings);};var flattenEvents=function flattenEvents(form,region){return[].concat(_toConsumableArray(form.when),_toConsumableArray(form.while),_toConsumableArray(form.then)).map(function(event){var definition=Object(__WEBPACK_IMPORTED_MODULE_6__constants_actions__["d" /* getAttributeDefinition */])(event.type,region);var normaliseSettings=definition.normaliseSettings||__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default.a;var settings=definition.settings?{settings:normaliseSettings(validSettings(definition.settings.logic,definition.settings.definitions,event.settings||{}))}:{};return Object.assign({group:event.group,type:event.type},event.id?{id:event.id}:{},event.duration&&event.duration>0?{duration:event.duration}:{},settings);});};var formToNewAction=__WEBPACK_IMPORTED_MODULE_4_lodash_fp_curry___default()(function(region,form){return{enabled:form.enabled,entitlements:[],events:flattenEvents(form,region),name:form.name,template:form.template.id+'.'+form.template.version};});var formToEditAction=__WEBPACK_IMPORTED_MODULE_4_lodash_fp_curry___default()(function(region,form,actionId){return{enabled:form.enabled,entitlements:[],events:flattenEvents(form,region),name:form.name,id:actionId};});var actionToForm=function actionToForm(action){var groups=action.events.reduce(function(acc,event){return Object.assign({},acc,_defineProperty({},event.group,[].concat(_toConsumableArray(acc[event.group]),[Object.assign({},event,{guid:__WEBPACK_IMPORTED_MODULE_5_uuid_v1___default()()})])));},{when:[],while:[],then:[]});var template=(action.template||__WEBPACK_IMPORTED_MODULE_6__constants_actions__["a" /* DEFAULT_TEMPLATE */]).split('.');return Object.assign({},action.duration?{duration:action.duration}:{},{enabled:action.enabled,id:action.id,name:action.name,status:'edit',template:{id:template[0],version:template[1]?parseInt(template[1],10):0}},groups);};var transformEvent=function transformEvent(event){return Object.assign({},event,{guid:__WEBPACK_IMPORTED_MODULE_5_uuid_v1___default()()},event.settings?{settings:Object.keys(event.settings).reduce(function(sets,key){// Flow complains about possible `event.settings` undefined
// but it is guaranteed to exist by condition above
// $FlowFixMe
return Object.assign({},sets,_defineProperty({},key,event.settings[key].value));},{})}:{});};var localeMetaFromTemplate=function localeMetaFromTemplate(template,locale){return template.meta[locale]||__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_find___default()(function(l){return l.default;}),__WEBPACK_IMPORTED_MODULE_0_lodash_fp_values___default.a)(template.meta)||{name:'',description:''};};var normaliseTemplate=function normaliseTemplate(template,locale){var groups=template.events.reduce(function(acc,event){return event.required||event.default?Object.assign({},acc,_defineProperty({},event.group,[].concat(_toConsumableArray(acc[event.group]),[transformEvent(event)]))):acc;},{when:[],while:[],then:[]});var localeMeta=localeMetaFromTemplate(template,locale);return Object.assign({description:localeMeta.description,name:localeMeta.name,tags:template.meta.tags,id:template.id,incompatible:template.incompatible||[]},groups);};

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEntitlements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveEntitlements; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var getEntitlements=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* GET_ENTITLEMENTS */]);var receiveEntitlements=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RECEIVE_ENTITLEMENTS */]);

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setHolidayModeSaga */
/* unused harmony export watchSetHolidayModeSaga */
/* unused harmony export watchHolidayModeDaemonSaga */
/* harmony export (immutable) */ __webpack_exports__["b"] = getHolidayModeDataSaga;
/* unused harmony export watchGetHolidayModeDataSaga */
/* unused harmony export disableHolidayModeSaga */
/* unused harmony export watchDisableHolidayModeSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_holiday_mode__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_routes__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__navigate__ = __webpack_require__(144);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setHolidayModeSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSetHolidayModeSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(holidayModeDaemonSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchHolidayModeDaemonSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getHolidayModeDataSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetHolidayModeDataSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(disableHolidayModeSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchDisableHolidayModeSaga);var checkHolidayModeDelay=120000;function setHolidayModeSaga(_ref){var _ref$payload=_ref.payload,start=_ref$payload.start,end=_ref$payload.end,temperature=_ref$payload.temperature;var _ref2,_ref3,err;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setHolidayModeSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__api_holiday_mode__["c" /* setHolidayMode */]),start,end,temperature);case 2:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);err=_ref3[1];_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["f" /* initiateHolidayMode */])(err));case 7:case'end':return _context.stop();}}},_marked,this);}function watchSetHolidayModeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSetHolidayModeSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__constants__["h" /* SET_HOLIDAY_MODE */],Object(__WEBPACK_IMPORTED_MODULE_11__handle_saga__["a" /* default */])(setHolidayModeSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function holidayModeDaemonSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function holidayModeDaemonSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(false){_context3.next=7;break;}_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["b" /* delay */],checkHolidayModeDelay);case 3:_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(getHolidayModeDataSaga);case 5:_context3.next=0;break;case 7:case'end':return _context3.stop();}}},_marked3,this);}function watchHolidayModeDaemonSaga(){var deamon;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchHolidayModeDaemonSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(false){_context4.next=12;break;}_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* INITIATE_HOLIDAYMODE */]);case 3:_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["d" /* fork */])(holidayModeDaemonSaga);case 5:deamon=_context4.sent;_context4.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* EXIT_HOLIDAY_MODE_SCREEN */]);case 8:_context4.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* cancel */])(deamon);case 10:_context4.next=0;break;case 12:case'end':return _context4.stop();}}},_marked4,this);}function getHolidayModeDataSaga(){var payload,anySuitableProducts,_ref4,_ref5,response,e;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getHolidayModeDataSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:payload={};// $FlowFixMe
anySuitableProducts=Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_9__products_selectors__["c" /* doesAnyProductHaveCapability */],{capability:__WEBPACK_IMPORTED_MODULE_7__constants_devices__["capabilities"].HOLIDAY_MODE});if(!anySuitableProducts){_context5.next=10;break;}_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__api_holiday_mode__["b" /* getHolidayMode */]));case 5:_ref4=_context5.sent;_ref5=_slicedToArray(_ref4,2);response=_ref5[0];e=_ref5[1];payload=e||response;case 10:_context5.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* initializeState */])(payload));case 12:case'end':return _context5.stop();}}},_marked5,this);}function watchGetHolidayModeDataSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetHolidayModeDataSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* INITIATE_HOLIDAYMODE */],Object(__WEBPACK_IMPORTED_MODULE_11__handle_saga__["a" /* default */])(getHolidayModeDataSaga));case 2:case'end':return _context6.stop();}}},_marked6,this);}function disableHolidayModeSaga(_ref6){var _ref6$payload=_ref6.payload,remain=_ref6$payload===undefined?false:_ref6$payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function disableHolidayModeSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(remain){_context7.next=3;break;}_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_8__constants_routes__["dashboard"]));case 3:_context7.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__api_holiday_mode__["a" /* disableHolidayMode */]));case 5:case'end':return _context7.stop();}}},_marked7,this);}function watchDisableHolidayModeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchDisableHolidayModeSaga$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* DISABLE_HOLIDAY_MODE */],Object(__WEBPACK_IMPORTED_MODULE_11__handle_saga__["a" /* default */])(disableHolidayModeSaga));case 2:case'end':return _context8.stop();}}},_marked8,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchHolidayModeDaemonSaga,watchDisableHolidayModeSaga,watchGetHolidayModeDataSaga,watchSetHolidayModeSaga]);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDashboardCustomisationSaga */
/* harmony export (immutable) */ __webpack_exports__["b"] = isDashboardCustomised;
/* unused harmony export saveDashboardCustomisationSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_dashboard__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__intl__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_constants__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_actions__ = __webpack_require__(106);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getDashboardCustomisationSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchDashboardCustomisationSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(isDashboardCustomised),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saveDashboardCustomisationSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSaveDashboardCustomisationSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addActionToDashboardSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchEndCreateAction);/***********************************
 *   GET DASHBOARD CUSTOMISATION   *
 ***********************************/function getDashboardCustomisationSaga(){var userId,products,actions,_ref,_ref2,customisation,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getDashboardCustomisationSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_16__user_selectors__["i" /* getUserId */]);case 2:userId=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_15__products_selectors__["z" /* getProductItems */]);case 5:products=_context.sent;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_12__actions_selectors__["f" /* getActionsList */]);case 8:actions=_context.sent;_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_17__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api_dashboard__["a" /* getDashboardCustomisation */]),userId);case 11:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);customisation=_ref2[0];error=_ref2[1];if(error){_context.next=19;break;}_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["m" /* receiveDashboardCustomisation */])({actions:actions,customisation:customisation,products:products}));case 18:return _context.abrupt('return',_context.sent);case 19:_context.next=21;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["m" /* receiveDashboardCustomisation */])({actions:actions,customisation:{pages:[]},products:products}));case 21:if(!(!error.status===404)){_context.next=24;break;}_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_9__intl__["a" /* customisationErrors */].fetchError,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 24:case'end':return _context.stop();}}},_marked,this);}function watchDashboardCustomisationSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchDashboardCustomisationSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["l" /* GET_DASHBOARD_CUSTOMISATION */],Object(__WEBPACK_IMPORTED_MODULE_18__handle_saga__["a" /* default */])(getDashboardCustomisationSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function isDashboardCustomised(){var userId,isDashboardCustomisationDataOn,_ref3,_ref4,pages,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function isDashboardCustomised$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_16__user_selectors__["i" /* getUserId */]);case 2:userId=_context3.sent;_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_7__config_selectors__["a" /* getConfig */],'features:dashboardCustomisationData');case 5:isDashboardCustomisationDataOn=_context3.sent;if(isDashboardCustomisationDataOn){_context3.next=8;break;}return _context3.abrupt('return',false);case 8:_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_17__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api_dashboard__["a" /* getDashboardCustomisation */]),userId);case 10:_ref3=_context3.sent;_ref4=_slicedToArray(_ref3,2);pages=_ref4[0].pages;error=_ref4[1];if(!error){_context3.next=18;break;}_context3.next=17;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_9__intl__["a" /* customisationErrors */].fetchError,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 17:return _context3.abrupt('return',_context3.sent);case 18:return _context3.abrupt('return',pages&&pages.length);case 19:case'end':return _context3.stop();}}},_marked3,this);}function saveDashboardCustomisationSaga(){var userId,hubNow,pages,sortedPages,products,actions,customisationPages,_ref5,_ref6,error,removedIds,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,id,alsoDeleteAction;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveDashboardCustomisationSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_16__user_selectors__["i" /* getUserId */]);case 2:userId=_context4.sent;_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__hub_selectors__["b" /* getCurrentTime */]);case 5:hubNow=_context4.sent;_context4.next=8;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["d" /* getDashboardGroups */]);case 8:pages=_context4.sent;if(pages){_context4.next=11;break;}return _context4.abrupt('return');case 11:sortedPages=pages.filter(function(p){return p.get('items').count()>0;}).map(function(p,index){return p.set('position',index);});//Filter out products and actions that don't exist
_context4.next=14;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_15__products_selectors__["z" /* getProductItems */]);case 14:products=_context4.sent;_context4.next=17;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_12__actions_selectors__["f" /* getActionsList */]);case 17:actions=_context4.sent;customisationPages=sortedPages.map(function(cp){return cp.set('items',cp.get('items').filter(function(item){return products.some(function(p){return p.get('id')===item.get('id');})||actions.some(function(a){return a.id===item.get('id');});}));});_context4.next=21;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_17__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api_dashboard__["b" /* saveDashboardCustomisation */]),userId,hubNow,customisationPages.toJS());case 21:_ref5=_context4.sent;_ref6=_slicedToArray(_ref5,2);error=_ref6[1];if(error){_context4.next=58;break;}_context4.next=27;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["h" /* getIdsToBeDeleted */]);case 27:removedIds=_context4.sent;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context4.prev=31;_iterator=removedIds[Symbol.iterator]();case 33:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context4.next=44;break;}id=_step.value;_context4.next=37;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_12__actions_selectors__["n" /* isQuickAction */],{actionId:id});case 37:alsoDeleteAction=_context4.sent;if(!alsoDeleteAction){_context4.next=41;break;}_context4.next=41;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_20__actions_actions__["d" /* attemptRemoveAction */])(id));case 41:_iteratorNormalCompletion=true;_context4.next=33;break;case 44:_context4.next=50;break;case 46:_context4.prev=46;_context4.t0=_context4['catch'](31);_didIteratorError=true;_iteratorError=_context4.t0;case 50:_context4.prev=50;_context4.prev=51;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 53:_context4.prev=53;if(!_didIteratorError){_context4.next=56;break;}throw _iteratorError;case 56:return _context4.finish(53);case 57:return _context4.finish(50);case 58:_context4.next=60;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["p" /* saveDashboardSuccess */])(error||Object(__WEBPACK_IMPORTED_MODULE_11_immutable__["fromJS"])({pages:customisationPages,lastUpdated:hubNow})));case 60:if(!error){_context4.next=63;break;}_context4.next=63;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.SAVE_FAILED,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 63:case'end':return _context4.stop();}}},_marked4,this,[[31,46,50,58],[51,,53,57]]);}function watchSaveDashboardCustomisationSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSaveDashboardCustomisationSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["o" /* SAVE_DASHBOARD_EDIT */],Object(__WEBPACK_IMPORTED_MODULE_18__handle_saga__["a" /* default */])(saveDashboardCustomisationSaga));case 2:case'end':return _context5.stop();}}},_marked5,this);}function addActionToDashboardSaga(_ref7){var hiveAction=_ref7.payload;var quickAction;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addActionToDashboardSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:quickAction=hiveAction.events.find(function(a){return a.group==='when'&&a.type===__WEBPACK_IMPORTED_MODULE_2__constants_actions__["b" /* actionTypes */].QUICK_ACTION;});if(!quickAction){_context6.next=6;break;}_context6.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* dashboardAddProduct */])(hiveAction.id));case 4:_context6.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["o" /* saveDashboardEdit */])());case 6:case'end':return _context6.stop();}}},_marked6,this);}function watchEndCreateAction(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchEndCreateAction$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_10__actions_constants__["i" /* END_ATTEMPT_CREATE_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_18__handle_saga__["a" /* default */])(addActionToDashboardSaga));case 2:case'end':return _context7.stop();}}},_marked7,this);}/*************************//* harmony default export */ __webpack_exports__["a"] = ([watchDashboardCustomisationSaga,watchEndCreateAction,watchSaveDashboardCustomisationSaga]);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getProductsSaga;
/* unused harmony export changeProductModeSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_app_settings__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_settings_selectors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_app_settings__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_products_products_api__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__groups_constants__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__devices_selectors__ = __webpack_require__(37);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProductsSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetProductsSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSaveGroupCompleteSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(changeProductModeSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeProductModeSaga);function getProductsSaga(){var _ref,_ref2,products,error,deviceGroupsEnabled,hubSupportsGroups,filteredProducts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProductsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_12__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__api__["j" /* products */].getProducts));case 2:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);products=_ref2[0];error=_ref2[1];_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_18__config_selectors__["a" /* getConfig */],'features:deviceGroups');case 8:deviceGroupsEnabled=_context.sent;_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_20__devices_selectors__["G" /* getHubHasCapability */],__WEBPACK_IMPORTED_MODULE_8__constants_devices__["capabilities"].PRODUCT_GROUP);case 11:hubSupportsGroups=_context.sent;filteredProducts=products?deviceGroupsEnabled&&hubSupportsGroups?products:Object(__WEBPACK_IMPORTED_MODULE_19__utils__["a" /* filterOutDeviceGroups */])(products):undefined;_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["e" /* receiveProducts */])(error||{products:filteredProducts,loadedAt:new Date()}));case 15:if(!error){_context.next=18;break;}_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* alerts */].types.ERROR));case 18:case'end':return _context.stop();}}},_marked,this);}function watchGetProductsSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetProductsSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* GET_PRODUCTS */],Object(__WEBPACK_IMPORTED_MODULE_13__handle_saga__["a" /* default */])(getProductsSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function watchSaveGroupCompleteSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSaveGroupCompleteSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_17__groups_constants__["b" /* SAVE_GROUP_COMPLETE */],Object(__WEBPACK_IMPORTED_MODULE_13__handle_saga__["a" /* default */])(getProductsSaga));case 2:case'end':return _context3.stop();}}},_marked3,this);}function changeProductModeSaga(action){var payload,productId,type,mode,currentSchedule,defaultTargetTemperature,props,cookieTarget,productType,update,userId,_ref3,_ref4,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function changeProductModeSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:payload=action.payload;productId=payload.productId,type=payload.type,mode=payload.mode,currentSchedule=payload.currentSchedule,defaultTargetTemperature=payload.defaultTargetTemperature;props={id:productId};cookieTarget=void 0;_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__selectors__["L" /* getTypeForProduct */],props);case 6:productType=_context4.sent;update={mode:mode};if(!(productType===__WEBPACK_IMPORTED_MODULE_8__constants_devices__["deviceTypes"].HEATING&&mode===__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* devices */].deviceModes.MANUAL)){_context4.next=13;break;}_context4.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_9__app_settings_selectors__["a" /* getAppSetting */],Object(__WEBPACK_IMPORTED_MODULE_7__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_14__constants_app_settings__["f" /* MANUAL_TARGET_SETTING */],productId));case 11:cookieTarget=_context4.sent;update.target=cookieTarget?parseFloat(cookieTarget):defaultTargetTemperature;case 13:_context4.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__user_selectors__["i" /* getUserId */]);case 15:userId=_context4.sent;_context4.next=18;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* productModeChangeUpdateProduct */])({userId:userId,mode:mode,type:type,productId:productId,currentSchedule:currentSchedule,defaultTargetTemperature:defaultTargetTemperature,cookieTarget:cookieTarget}));case 18:_context4.next=20;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_12__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_15__api_products_products_api__["patchProduct"]),update,productType,productId);case 20:_ref3=_context4.sent;_ref4=_slicedToArray(_ref3,2);error=_ref4[1];if(!error){_context4.next=28;break;}_context4.next=26;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* PRODUCT_MODE_CHANGE_UPDATE_PRODUCT */]));case 26:_context4.next=28;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* alerts */].types.ERROR));case 28:case'end':return _context4.stop();}}},_marked4,this);}function watchChangeProductModeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeProductModeSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* PRODUCT_MODE_CHANGE */],Object(__WEBPACK_IMPORTED_MODULE_13__handle_saga__["a" /* default */])(changeProductModeSaga));case 2:case'end':return _context5.stop();}}},_marked5,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchChangeProductModeSaga,watchGetProductsSaga,watchSaveGroupCompleteSaga]);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = padNumber;
// @noflow
/**
 * Pads a number to two significant digits
 * @param  {number} num
 * @return {string}
 */function padNumber(num){if(num>=0){return(num<10?'0':'')+num;}else{return(num>-10?'-0':'-')+Math.abs(num);}}

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({getEventsError:{id:'motion-sensor.getting-events-error',defaultMessage:"There was an error retrieving your device's events"}}));

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('memoize', __webpack_require__(576));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_devtools__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_devtools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_devtools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_dock_monitor__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_devtools_dock_monitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_devtools_dock_monitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_log_monitor__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_devtools_log_monitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_devtools_log_monitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_devtools__["createDevTools"])(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_redux_devtools_dock_monitor___default.a,{changePositionKey:'Q',defaultIsVisible:false,toggleVisibilityKey:'H'},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_redux_devtools_log_monitor___default.a,null))));

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.INIT_ACTION = exports.ActionCreators = exports.ActionTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.liftAction = liftAction;
exports.liftReducerWith = liftReducerWith;
exports.unliftState = unliftState;
exports.unliftStore = unliftStore;
exports.default = instrument;

var _difference = __webpack_require__(1833);

var _difference2 = _interopRequireDefault(_difference);

var _union = __webpack_require__(1835);

var _union2 = _interopRequireDefault(_union);

var _isPlainObject = __webpack_require__(308);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(650);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionTypes = exports.ActionTypes = {
  PERFORM_ACTION: 'PERFORM_ACTION',
  RESET: 'RESET',
  ROLLBACK: 'ROLLBACK',
  COMMIT: 'COMMIT',
  SWEEP: 'SWEEP',
  TOGGLE_ACTION: 'TOGGLE_ACTION',
  SET_ACTIONS_ACTIVE: 'SET_ACTIONS_ACTIVE',
  JUMP_TO_STATE: 'JUMP_TO_STATE',
  JUMP_TO_ACTION: 'JUMP_TO_ACTION',
  REORDER_ACTION: 'REORDER_ACTION',
  IMPORT_STATE: 'IMPORT_STATE',
  LOCK_CHANGES: 'LOCK_CHANGES',
  PAUSE_RECORDING: 'PAUSE_RECORDING'
};

/**
 * Action creators to change the History state.
 */
var ActionCreators = exports.ActionCreators = {
  performAction: function performAction(action) {
    if (!(0, _isPlainObject2.default)(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    return { type: ActionTypes.PERFORM_ACTION, action: action, timestamp: Date.now() };
  },
  reset: function reset() {
    return { type: ActionTypes.RESET, timestamp: Date.now() };
  },
  rollback: function rollback() {
    return { type: ActionTypes.ROLLBACK, timestamp: Date.now() };
  },
  commit: function commit() {
    return { type: ActionTypes.COMMIT, timestamp: Date.now() };
  },
  sweep: function sweep() {
    return { type: ActionTypes.SWEEP };
  },
  toggleAction: function toggleAction(id) {
    return { type: ActionTypes.TOGGLE_ACTION, id: id };
  },
  setActionsActive: function setActionsActive(start, end) {
    var active = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];

    return { type: ActionTypes.SET_ACTIONS_ACTIVE, start: start, end: end, active: active };
  },
  reorderAction: function reorderAction(actionId, beforeActionId) {
    return { type: ActionTypes.REORDER_ACTION, actionId: actionId, beforeActionId: beforeActionId };
  },
  jumpToState: function jumpToState(index) {
    return { type: ActionTypes.JUMP_TO_STATE, index: index };
  },
  jumpToAction: function jumpToAction(actionId) {
    return { type: ActionTypes.JUMP_TO_ACTION, actionId: actionId };
  },
  importState: function importState(nextLiftedState, noRecompute) {
    return { type: ActionTypes.IMPORT_STATE, nextLiftedState: nextLiftedState, noRecompute: noRecompute };
  },
  lockChanges: function lockChanges(status) {
    return { type: ActionTypes.LOCK_CHANGES, status: status };
  },
  pauseRecording: function pauseRecording(status) {
    return { type: ActionTypes.PAUSE_RECORDING, status: status };
  }
};

var INIT_ACTION = exports.INIT_ACTION = { type: '@@INIT' };

/**
 * Computes the next entry with exceptions catching.
 */
function computeWithTryCatch(reducer, action, state) {
  var nextState = state;
  var nextError = void 0;
  try {
    nextState = reducer(state, action);
  } catch (err) {
    nextError = err.toString();
    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && (typeof window.chrome !== 'undefined' || typeof window.process !== 'undefined' && window.process.type === 'renderer')) {
      // In Chrome, rethrowing provides better source map support
      setTimeout(function () {
        throw err;
      });
    } else {
      console.error(err);
    }
  }

  return {
    state: nextState,
    error: nextError
  };
}

/**
 * Computes the next entry in the log by applying an action.
 */
function computeNextEntry(reducer, action, state, shouldCatchErrors) {
  if (!shouldCatchErrors) {
    return { state: reducer(state, action) };
  }
  return computeWithTryCatch(reducer, action, state);
}

/**
 * Runs the reducer on invalidated actions to get a fresh computation log.
 */
function recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, shouldCatchErrors) {
  // Optimization: exit early and return the same reference
  // if we know nothing could have changed.
  if (!computedStates || minInvalidatedStateIndex === -1 || minInvalidatedStateIndex >= computedStates.length && computedStates.length === stagedActionIds.length) {
    return computedStates;
  }

  var nextComputedStates = computedStates.slice(0, minInvalidatedStateIndex);
  for (var i = minInvalidatedStateIndex; i < stagedActionIds.length; i++) {
    var actionId = stagedActionIds[i];
    var action = actionsById[actionId].action;

    var previousEntry = nextComputedStates[i - 1];
    var previousState = previousEntry ? previousEntry.state : committedState;

    var shouldSkip = skippedActionIds.indexOf(actionId) > -1;
    var entry = void 0;
    if (shouldSkip) {
      entry = previousEntry;
    } else {
      if (shouldCatchErrors && previousEntry && previousEntry.error) {
        entry = {
          state: previousState,
          error: 'Interrupted by an error up the chain'
        };
      } else {
        entry = computeNextEntry(reducer, action, previousState, shouldCatchErrors);
      }
    }
    nextComputedStates.push(entry);
  }

  return nextComputedStates;
}

/**
 * Lifts an app's action into an action on the lifted store.
 */
function liftAction(action) {
  return ActionCreators.performAction(action);
}

/**
 * Creates a history state reducer from an app's reducer.
 */
function liftReducerWith(reducer, initialCommittedState, monitorReducer, options) {
  var initialLiftedState = {
    monitorState: monitorReducer(undefined, {}),
    nextActionId: 1,
    actionsById: { 0: liftAction(INIT_ACTION) },
    stagedActionIds: [0],
    skippedActionIds: [],
    committedState: initialCommittedState,
    currentStateIndex: 0,
    computedStates: [],
    isLocked: options.shouldStartLocked === true,
    isPaused: options.shouldRecordChanges === false
  };

  /**
   * Manages how the history actions modify the history state.
   */
  return function (liftedState, liftedAction) {
    var _ref = liftedState || initialLiftedState;

    var monitorState = _ref.monitorState;
    var actionsById = _ref.actionsById;
    var nextActionId = _ref.nextActionId;
    var stagedActionIds = _ref.stagedActionIds;
    var skippedActionIds = _ref.skippedActionIds;
    var committedState = _ref.committedState;
    var currentStateIndex = _ref.currentStateIndex;
    var computedStates = _ref.computedStates;
    var isLocked = _ref.isLocked;
    var isPaused = _ref.isPaused;


    if (!liftedState) {
      // Prevent mutating initialLiftedState
      actionsById = _extends({}, actionsById);
    }

    function commitExcessActions(n) {
      // Auto-commits n-number of excess actions.
      var excess = n;
      var idsToDelete = stagedActionIds.slice(1, excess + 1);

      for (var i = 0; i < idsToDelete.length; i++) {
        if (computedStates[i + 1].error) {
          // Stop if error is found. Commit actions up to error.
          excess = i;
          idsToDelete = stagedActionIds.slice(1, excess + 1);
          break;
        } else {
          delete actionsById[idsToDelete[i]];
        }
      }

      skippedActionIds = skippedActionIds.filter(function (id) {
        return idsToDelete.indexOf(id) === -1;
      });
      stagedActionIds = [0].concat(stagedActionIds.slice(excess + 1));
      committedState = computedStates[excess].state;
      computedStates = computedStates.slice(excess);
      currentStateIndex = currentStateIndex > excess ? currentStateIndex - excess : 0;
    }

    function computePausedAction(shouldInit) {
      var _extends2;

      var computedState = void 0;
      if (shouldInit) {
        computedState = computedStates[currentStateIndex];
        monitorState = monitorReducer(monitorState, liftedAction);
      } else {
        computedState = computeNextEntry(reducer, liftedAction.action, computedStates[currentStateIndex].state, false);
      }
      if (!options.pauseActionType || nextActionId === 1) {
        return {
          monitorState: monitorState,
          actionsById: { 0: liftAction(INIT_ACTION) },
          nextActionId: 1,
          stagedActionIds: [0],
          skippedActionIds: [],
          committedState: computedState.state,
          currentStateIndex: 0,
          computedStates: [computedState],
          isLocked: isLocked,
          isPaused: true
        };
      }
      if (shouldInit) {
        if (currentStateIndex === stagedActionIds.length - 1) {
          currentStateIndex++;
        }
        stagedActionIds = [].concat(stagedActionIds, [nextActionId]);
        nextActionId++;
      }
      return {
        monitorState: monitorState,
        actionsById: _extends({}, actionsById, (_extends2 = {}, _extends2[nextActionId - 1] = liftAction({ type: options.pauseActionType }), _extends2)),
        nextActionId: nextActionId,
        stagedActionIds: stagedActionIds,
        skippedActionIds: skippedActionIds,
        committedState: committedState,
        currentStateIndex: currentStateIndex,
        computedStates: [].concat(computedStates.slice(0, stagedActionIds.length - 1), [computedState]),
        isLocked: isLocked,
        isPaused: true
      };
    }

    // By default, agressively recompute every state whatever happens.
    // This has O(n) performance, so we'll override this to a sensible
    // value whenever we feel like we don't have to recompute the states.
    var minInvalidatedStateIndex = 0;

    switch (liftedAction.type) {
      case ActionTypes.PERFORM_ACTION:
        {
          if (isLocked) return liftedState || initialLiftedState;
          if (isPaused) return computePausedAction();

          // Auto-commit as new actions come in.
          if (options.maxAge && stagedActionIds.length === options.maxAge) {
            commitExcessActions(1);
          }

          if (currentStateIndex === stagedActionIds.length - 1) {
            currentStateIndex++;
          }
          var actionId = nextActionId++;
          // Mutation! This is the hottest path, and we optimize on purpose.
          // It is safe because we set a new key in a cache dictionary.
          actionsById[actionId] = liftedAction;
          stagedActionIds = [].concat(stagedActionIds, [actionId]);
          // Optimization: we know that only the new action needs computing.
          minInvalidatedStateIndex = stagedActionIds.length - 1;
          break;
        }
      case ActionTypes.RESET:
        {
          // Get back to the state the store was created with.
          actionsById = { 0: liftAction(INIT_ACTION) };
          nextActionId = 1;
          stagedActionIds = [0];
          skippedActionIds = [];
          committedState = initialCommittedState;
          currentStateIndex = 0;
          computedStates = [];
          break;
        }
      case ActionTypes.COMMIT:
        {
          // Consider the last committed state the new starting point.
          // Squash any staged actions into a single committed state.
          actionsById = { 0: liftAction(INIT_ACTION) };
          nextActionId = 1;
          stagedActionIds = [0];
          skippedActionIds = [];
          committedState = computedStates[currentStateIndex].state;
          currentStateIndex = 0;
          computedStates = [];
          break;
        }
      case ActionTypes.ROLLBACK:
        {
          // Forget about any staged actions.
          // Start again from the last committed state.
          actionsById = { 0: liftAction(INIT_ACTION) };
          nextActionId = 1;
          stagedActionIds = [0];
          skippedActionIds = [];
          currentStateIndex = 0;
          computedStates = [];
          break;
        }
      case ActionTypes.TOGGLE_ACTION:
        {
          var _ret = function () {
            // Toggle whether an action with given ID is skipped.
            // Being skipped means it is a no-op during the computation.
            var actionId = liftedAction.id;

            var index = skippedActionIds.indexOf(actionId);
            if (index === -1) {
              skippedActionIds = [actionId].concat(skippedActionIds);
            } else {
              skippedActionIds = skippedActionIds.filter(function (id) {
                return id !== actionId;
              });
            }
            // Optimization: we know history before this action hasn't changed
            minInvalidatedStateIndex = stagedActionIds.indexOf(actionId);
            return 'break';
          }();

          if (_ret === 'break') break;
        }
      case ActionTypes.SET_ACTIONS_ACTIVE:
        {
          // Toggle whether an action with given ID is skipped.
          // Being skipped means it is a no-op during the computation.
          var start = liftedAction.start;
          var end = liftedAction.end;
          var active = liftedAction.active;

          var actionIds = [];
          for (var i = start; i < end; i++) {
            actionIds.push(i);
          }if (active) {
            skippedActionIds = (0, _difference2.default)(skippedActionIds, actionIds);
          } else {
            skippedActionIds = (0, _union2.default)(skippedActionIds, actionIds);
          }

          // Optimization: we know history before this action hasn't changed
          minInvalidatedStateIndex = stagedActionIds.indexOf(start);
          break;
        }
      case ActionTypes.JUMP_TO_STATE:
        {
          // Without recomputing anything, move the pointer that tell us
          // which state is considered the current one. Useful for sliders.
          currentStateIndex = liftedAction.index;
          // Optimization: we know the history has not changed.
          minInvalidatedStateIndex = Infinity;
          break;
        }
      case ActionTypes.JUMP_TO_ACTION:
        {
          // Jumps to a corresponding state to a specific action.
          // Useful when filtering actions.
          var _index = stagedActionIds.indexOf(liftedAction.actionId);
          if (_index !== -1) currentStateIndex = _index;
          minInvalidatedStateIndex = Infinity;
          break;
        }
      case ActionTypes.SWEEP:
        {
          // Forget any actions that are currently being skipped.
          stagedActionIds = (0, _difference2.default)(stagedActionIds, skippedActionIds);
          skippedActionIds = [];
          currentStateIndex = Math.min(currentStateIndex, stagedActionIds.length - 1);
          break;
        }
      case ActionTypes.REORDER_ACTION:
        {
          // Recompute actions in a new order.
          var _actionId = liftedAction.actionId;
          var idx = stagedActionIds.indexOf(_actionId);
          // do nothing in case the action is already removed or trying to move the first action
          if (idx < 1) break;
          var beforeActionId = liftedAction.beforeActionId;
          var newIdx = stagedActionIds.indexOf(beforeActionId);
          if (newIdx < 1) {
            // move to the beginning or to the end
            var count = stagedActionIds.length;
            newIdx = beforeActionId > stagedActionIds[count - 1] ? count : 1;
          }
          var diff = idx - newIdx;

          if (diff > 0) {
            // move left
            stagedActionIds = [].concat(stagedActionIds.slice(0, newIdx), [_actionId], stagedActionIds.slice(newIdx, idx), stagedActionIds.slice(idx + 1));
            minInvalidatedStateIndex = newIdx;
          } else if (diff < 0) {
            // move right
            stagedActionIds = [].concat(stagedActionIds.slice(0, idx), stagedActionIds.slice(idx + 1, newIdx), [_actionId], stagedActionIds.slice(newIdx));
            minInvalidatedStateIndex = idx;
          }
          break;
        }
      case ActionTypes.IMPORT_STATE:
        {
          if (Array.isArray(liftedAction.nextLiftedState)) {
            // recompute array of actions
            actionsById = { 0: liftAction(INIT_ACTION) };
            nextActionId = 1;
            stagedActionIds = [0];
            skippedActionIds = [];
            currentStateIndex = liftedAction.nextLiftedState.length;
            computedStates = [];
            committedState = liftedAction.preloadedState;
            minInvalidatedStateIndex = 0;
            // iterate through actions
            liftedAction.nextLiftedState.forEach(function (action) {
              actionsById[nextActionId] = liftAction(action);
              stagedActionIds.push(nextActionId);
              nextActionId++;
            });
          } else {
            var _liftedAction$nextLif = liftedAction.nextLiftedState;
            // Completely replace everything.

            monitorState = _liftedAction$nextLif.monitorState;
            actionsById = _liftedAction$nextLif.actionsById;
            nextActionId = _liftedAction$nextLif.nextActionId;
            stagedActionIds = _liftedAction$nextLif.stagedActionIds;
            skippedActionIds = _liftedAction$nextLif.skippedActionIds;
            committedState = _liftedAction$nextLif.committedState;
            currentStateIndex = _liftedAction$nextLif.currentStateIndex;
            computedStates = _liftedAction$nextLif.computedStates;


            if (liftedAction.noRecompute) {
              minInvalidatedStateIndex = Infinity;
            }
          }

          break;
        }
      case ActionTypes.LOCK_CHANGES:
        {
          isLocked = liftedAction.status;
          minInvalidatedStateIndex = Infinity;
          break;
        }
      case ActionTypes.PAUSE_RECORDING:
        {
          isPaused = liftedAction.status;
          if (isPaused) {
            return computePausedAction(true);
          }
          // Commit when unpausing
          actionsById = { 0: liftAction(INIT_ACTION) };
          nextActionId = 1;
          stagedActionIds = [0];
          skippedActionIds = [];
          committedState = computedStates[currentStateIndex].state;
          currentStateIndex = 0;
          computedStates = [];
          break;
        }
      case '@@redux/INIT':
        {
          if (options.shouldHotReload === false) {
            actionsById = { 0: liftAction(INIT_ACTION) };
            nextActionId = 1;
            stagedActionIds = [0];
            skippedActionIds = [];
            committedState = computedStates.length === 0 ? initialCommittedState : computedStates[currentStateIndex].state;
            currentStateIndex = 0;
            computedStates = [];
          }

          // Recompute states on hot reload and init.
          minInvalidatedStateIndex = 0;

          if (options.maxAge && stagedActionIds.length > options.maxAge) {
            // States must be recomputed before committing excess.
            computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);

            commitExcessActions(stagedActionIds.length - options.maxAge);

            // Avoid double computation.
            minInvalidatedStateIndex = Infinity;
          }

          break;
        }
      default:
        {
          // If the action is not recognized, it's a monitor action.
          // Optimization: a monitor action can't change history.
          minInvalidatedStateIndex = Infinity;
          break;
        }
    }

    computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
    monitorState = monitorReducer(monitorState, liftedAction);
    return {
      monitorState: monitorState,
      actionsById: actionsById,
      nextActionId: nextActionId,
      stagedActionIds: stagedActionIds,
      skippedActionIds: skippedActionIds,
      committedState: committedState,
      currentStateIndex: currentStateIndex,
      computedStates: computedStates,
      isLocked: isLocked,
      isPaused: isPaused
    };
  };
}

/**
 * Provides an app's view into the state of the lifted store.
 */
function unliftState(liftedState) {
  var computedStates = liftedState.computedStates;
  var currentStateIndex = liftedState.currentStateIndex;
  var state = computedStates[currentStateIndex].state;

  return state;
}

/**
 * Provides an app's view into the lifted store.
 */
function unliftStore(liftedStore, liftReducer) {
  var _extends3;

  var lastDefinedState = void 0;

  function getState() {
    var state = unliftState(liftedStore.getState());
    if (state !== undefined) {
      lastDefinedState = state;
    }
    return lastDefinedState;
  }

  return _extends({}, liftedStore, (_extends3 = {

    liftedStore: liftedStore,

    dispatch: function dispatch(action) {
      liftedStore.dispatch(liftAction(action));
      return action;
    },


    getState: getState,

    replaceReducer: function replaceReducer(nextReducer) {
      liftedStore.replaceReducer(liftReducer(nextReducer));
    }
  }, _extends3[_symbolObservable2.default] = function () {
    return _extends({}, liftedStore[_symbolObservable2.default](), {
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = liftedStore.subscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    });
  }, _extends3));
}

/**
 * Redux instrumentation store enhancer.
 */
function instrument() {
  var monitorReducer = arguments.length <= 0 || arguments[0] === undefined ? function () {
    return null;
  } : arguments[0];
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  /* eslint-disable no-eq-null */
  if (options.maxAge != null && options.maxAge < 2) {
    /* eslint-enable */
    throw new Error('DevTools.instrument({ maxAge }) option, if specified, ' + 'may not be less than 2.');
  }

  return function (createStore) {
    return function (reducer, initialState, enhancer) {

      function liftReducer(r) {
        if (typeof r !== 'function') {
          if (r && typeof r.default === 'function') {
            throw new Error('Expected the reducer to be a function. ' + 'Instead got an object with a "default" field. ' + 'Did you pass a module instead of the default export? ' + 'Try passing require(...).default instead.');
          }
          throw new Error('Expected the reducer to be a function.');
        }
        return liftReducerWith(r, initialState, monitorReducer, options);
      }

      var liftedStore = createStore(liftReducer(reducer), enhancer);
      if (liftedStore.liftedStore) {
        throw new Error('DevTools instrumentation should not be applied more than once. ' + 'Check your store configuration.');
      }

      return unliftStore(liftedStore, liftReducer);
    };
  };
}

/***/ }),
/* 715 */
/***/ (function(module, exports) {

/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = getNative;


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var POSITIONS = exports.POSITIONS = ['left', 'top', 'right', 'bottom'];

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toggleVisibility = toggleVisibility;
exports.changePosition = changePosition;
exports.changeSize = changeSize;
exports.changeMonitor = changeMonitor;
var TOGGLE_VISIBILITY = exports.TOGGLE_VISIBILITY = '@@redux-devtools-log-monitor/TOGGLE_VISIBILITY';
function toggleVisibility() {
  return { type: TOGGLE_VISIBILITY };
}

var CHANGE_POSITION = exports.CHANGE_POSITION = '@@redux-devtools-log-monitor/CHANGE_POSITION';
function changePosition() {
  return { type: CHANGE_POSITION };
}

var CHANGE_SIZE = exports.CHANGE_SIZE = '@@redux-devtools-log-monitor/CHANGE_SIZE';
function changeSize(size) {
  return { type: CHANGE_SIZE, size: size };
}

var CHANGE_MONITOR = exports.CHANGE_MONITOR = '@@redux-devtools-log-monitor/CHANGE_MONITOR';
function changeMonitor() {
  return { type: CHANGE_MONITOR };
}

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _threezerotwofour = __webpack_require__(1852);

exports.threezerotwofour = _interopRequire(_threezerotwofour);

var _apathy = __webpack_require__(1853);

exports.apathy = _interopRequire(_apathy);

var _ashes = __webpack_require__(1854);

exports.ashes = _interopRequire(_ashes);

var _atelierDune = __webpack_require__(1855);

exports.atelierDune = _interopRequire(_atelierDune);

var _atelierForest = __webpack_require__(1856);

exports.atelierForest = _interopRequire(_atelierForest);

var _atelierHeath = __webpack_require__(1857);

exports.atelierHeath = _interopRequire(_atelierHeath);

var _atelierLakeside = __webpack_require__(1858);

exports.atelierLakeside = _interopRequire(_atelierLakeside);

var _atelierSeaside = __webpack_require__(1859);

exports.atelierSeaside = _interopRequire(_atelierSeaside);

var _bespin = __webpack_require__(1860);

exports.bespin = _interopRequire(_bespin);

var _brewer = __webpack_require__(1861);

exports.brewer = _interopRequire(_brewer);

var _bright = __webpack_require__(1862);

exports.bright = _interopRequire(_bright);

var _chalk = __webpack_require__(1863);

exports.chalk = _interopRequire(_chalk);

var _codeschool = __webpack_require__(1864);

exports.codeschool = _interopRequire(_codeschool);

var _colors = __webpack_require__(1865);

exports.colors = _interopRequire(_colors);

var _default = __webpack_require__(1866);

exports['default'] = _interopRequire(_default);

var _eighties = __webpack_require__(1867);

exports.eighties = _interopRequire(_eighties);

var _embers = __webpack_require__(1868);

exports.embers = _interopRequire(_embers);

var _flat = __webpack_require__(1869);

exports.flat = _interopRequire(_flat);

var _google = __webpack_require__(1870);

exports.google = _interopRequire(_google);

var _grayscale = __webpack_require__(1871);

exports.grayscale = _interopRequire(_grayscale);

var _greenscreen = __webpack_require__(1872);

exports.greenscreen = _interopRequire(_greenscreen);

var _harmonic = __webpack_require__(1873);

exports.harmonic = _interopRequire(_harmonic);

var _hopscotch = __webpack_require__(1874);

exports.hopscotch = _interopRequire(_hopscotch);

var _isotope = __webpack_require__(1875);

exports.isotope = _interopRequire(_isotope);

var _marrakesh = __webpack_require__(1876);

exports.marrakesh = _interopRequire(_marrakesh);

var _mocha = __webpack_require__(1877);

exports.mocha = _interopRequire(_mocha);

var _monokai = __webpack_require__(1878);

exports.monokai = _interopRequire(_monokai);

var _ocean = __webpack_require__(1879);

exports.ocean = _interopRequire(_ocean);

var _paraiso = __webpack_require__(1880);

exports.paraiso = _interopRequire(_paraiso);

var _pop = __webpack_require__(1881);

exports.pop = _interopRequire(_pop);

var _railscasts = __webpack_require__(1882);

exports.railscasts = _interopRequire(_railscasts);

var _shapeshifter = __webpack_require__(1883);

exports.shapeshifter = _interopRequire(_shapeshifter);

var _solarized = __webpack_require__(1884);

exports.solarized = _interopRequire(_solarized);

var _summerfruit = __webpack_require__(1885);

exports.summerfruit = _interopRequire(_summerfruit);

var _tomorrow = __webpack_require__(1886);

exports.tomorrow = _interopRequire(_tomorrow);

var _tube = __webpack_require__(1887);

exports.tube = _interopRequire(_tube);

var _twilight = __webpack_require__(1888);

exports.twilight = _interopRequire(_twilight);

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.updateScrollTop = updateScrollTop;
exports.startConsecutiveToggle = startConsecutiveToggle;
var UPDATE_SCROLL_TOP = exports.UPDATE_SCROLL_TOP = '@@redux-devtools-log-monitor/UPDATE_SCROLL_TOP';
function updateScrollTop(scrollTop) {
  return { type: UPDATE_SCROLL_TOP, scrollTop: scrollTop };
}

var START_CONSECUTIVE_TOGGLE = exports.START_CONSECUTIVE_TOGGLE = '@@redux-devtools-log-monitor/START_CONSECUTIVE_TOGGLE';
function startConsecutiveToggle(id) {
  return { type: START_CONSECUTIVE_TOGGLE, id: id };
}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(243);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(459);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(460);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(478);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(323);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONNode = __webpack_require__(733);

var _JSONNode2 = _interopRequireDefault(_JSONNode);

var _createStylingFromTheme = __webpack_require__(1948);

var _createStylingFromTheme2 = _interopRequireDefault(_createStylingFromTheme);

var _reactBase16Styling = __webpack_require__(737);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var identity = function identity(value) {
  return value;
}; // ES6 + inline style port of JSONViewer https://bitbucket.org/davevedder/react-json-viewer/
// all credits and original code to the author
// Dave Vedder <veddermatic@gmail.com> http://www.eskimospy.com/
// port by Daniele Zannotti http://www.github.com/dzannotti <dzannotti@me.com>

var expandRootNode = function expandRootNode(keyName, data, level) {
  return level === 0;
};
var defaultItemString = function defaultItemString(type, data, itemType, itemString) {
  return _react2['default'].createElement(
    'span',
    null,
    itemType,
    ' ',
    itemString
  );
};
var defaultLabelRenderer = function defaultLabelRenderer(_ref) {
  var label = _ref[0];
  return _react2['default'].createElement(
    'span',
    null,
    label,
    ':'
  );
};
var noCustomNode = function noCustomNode() {
  return false;
};

function checkLegacyTheming(theme, props) {
  var deprecatedStylingMethodsMap = {
    getArrowStyle: 'arrow',
    getListStyle: 'nestedNodeChildren',
    getItemStringStyle: 'nestedNodeItemString',
    getLabelStyle: 'label',
    getValueStyle: 'valueText'
  };

  var deprecatedStylingMethods = (0, _keys2['default'])(deprecatedStylingMethodsMap).filter(function (name) {
    return props[name];
  });

  if (deprecatedStylingMethods.length > 0) {
    if (typeof theme === 'string') {
      theme = {
        extend: theme
      };
    } else {
      theme = (0, _extends3['default'])({}, theme);
    }

    deprecatedStylingMethods.forEach(function (name) {
      // eslint-disable-next-line no-console
      console.error('Styling method "' + name + '" is deprecated, use "theme" property instead');

      theme[deprecatedStylingMethodsMap[name]] = function (_ref2) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var style = _ref2.style;
        return {
          style: (0, _extends3['default'])({}, style, props[name].apply(props, args))
        };
      };
    });
  }

  return theme;
}

function getStateFromProps(props) {
  var theme = checkLegacyTheming(props.theme, props);
  if (props.invertTheme) {
    if (typeof theme === 'string') {
      theme = theme + ':inverted';
    } else if (theme && theme.extend) {
      if (typeof theme === 'string') {
        theme = (0, _extends3['default'])({}, theme, { extend: theme.extend + ':inverted' });
      } else {
        theme = (0, _extends3['default'])({}, theme, { extend: (0, _reactBase16Styling.invertTheme)(theme.extend) });
      }
    } else if (theme) {
      theme = (0, _reactBase16Styling.invertTheme)(theme);
    }
  }
  return {
    styling: (0, _createStylingFromTheme2['default'])(theme)
  };
}

var JSONTree = function (_React$Component) {
  (0, _inherits3['default'])(JSONTree, _React$Component);

  function JSONTree(props) {
    (0, _classCallCheck3['default'])(this, JSONTree);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.state = getStateFromProps(props);
    return _this;
  }

  JSONTree.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (['theme', 'invertTheme'].find(function (k) {
      return nextProps[k] !== _this2.props[k];
    })) {
      this.setState(getStateFromProps(nextProps));
    }
  };

  JSONTree.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this3 = this;

    return !!(0, _keys2['default'])(nextProps).find(function (k) {
      return k === 'keyPath' ? nextProps[k].join('/') !== _this3.props[k].join('/') : nextProps[k] !== _this3.props[k];
    });
  };

  JSONTree.prototype.render = function render() {
    var _props = this.props,
        value = _props.data,
        keyPath = _props.keyPath,
        postprocessValue = _props.postprocessValue,
        hideRoot = _props.hideRoot,
        theme = _props.theme,
        _ = _props.invertTheme,
        rest = (0, _objectWithoutProperties3['default'])(_props, ['data', 'keyPath', 'postprocessValue', 'hideRoot', 'theme', 'invertTheme']);
    var styling = this.state.styling;


    return _react2['default'].createElement(
      'ul',
      styling('tree'),
      _react2['default'].createElement(_JSONNode2['default'], (0, _extends3['default'])({}, (0, _extends3['default'])({ postprocessValue: postprocessValue, hideRoot: hideRoot, styling: styling }, rest), {
        keyPath: hideRoot ? [] : keyPath,
        value: postprocessValue(value)
      }))
    );
  };

  return JSONTree;
}(_react2['default'].Component);

JSONTree.propTypes = {
  data: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]).isRequired,
  hideRoot: _propTypes2['default'].bool,
  theme: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
  invertTheme: _propTypes2['default'].bool,
  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
  postprocessValue: _propTypes2['default'].func,
  sortObjectKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].bool])
};
JSONTree.defaultProps = {
  shouldExpandNode: expandRootNode,
  hideRoot: false,
  keyPath: ['root'],
  getItemString: defaultItemString,
  labelRenderer: defaultLabelRenderer,
  valueRenderer: identity,
  postprocessValue: identity,
  isCustomNode: noCustomNode,
  collectionLimit: 50,
  invertTheme: true
};
exports['default'] = JSONTree;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1896), __esModule: true };

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(465)
  , $export        = __webpack_require__(170)
  , redefine       = __webpack_require__(726)
  , hide           = __webpack_require__(203)
  , has            = __webpack_require__(171)
  , Iterators      = __webpack_require__(244)
  , $iterCreate    = __webpack_require__(1899)
  , setToStringTag = __webpack_require__(472)
  , getPrototypeOf = __webpack_require__(1905)
  , ITERATOR       = __webpack_require__(114)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1898);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(207) && !__webpack_require__(208)(function(){
  return Object.defineProperty(__webpack_require__(725)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(206)
  , document = __webpack_require__(140).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(203);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(171)
  , toIObject    = __webpack_require__(172)
  , arrayIndexOf = __webpack_require__(1901)(false)
  , IE_PROTO     = __webpack_require__(469)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(468);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(172)
  , gOPN      = __webpack_require__(730).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(727)
  , hiddenKeys = __webpack_require__(471).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(322)
  , createDesc     = __webpack_require__(320)
  , toIObject      = __webpack_require__(172)
  , toPrimitive    = __webpack_require__(466)
  , has            = __webpack_require__(171)
  , IE8_DOM_DEFINE = __webpack_require__(724)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(207) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(170)
  , core    = __webpack_require__(66)
  , fails   = __webpack_require__(208);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(243);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _objType = __webpack_require__(1932);

var _objType2 = _interopRequireDefault(_objType);

var _JSONObjectNode = __webpack_require__(1933);

var _JSONObjectNode2 = _interopRequireDefault(_JSONObjectNode);

var _JSONArrayNode = __webpack_require__(1941);

var _JSONArrayNode2 = _interopRequireDefault(_JSONArrayNode);

var _JSONIterableNode = __webpack_require__(1942);

var _JSONIterableNode2 = _interopRequireDefault(_JSONIterableNode);

var _JSONValueNode = __webpack_require__(1947);

var _JSONValueNode2 = _interopRequireDefault(_JSONValueNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var JSONNode = function JSONNode(_ref) {
  var getItemString = _ref.getItemString,
      keyPath = _ref.keyPath,
      labelRenderer = _ref.labelRenderer,
      styling = _ref.styling,
      value = _ref.value,
      valueRenderer = _ref.valueRenderer,
      isCustomNode = _ref.isCustomNode,
      rest = (0, _objectWithoutProperties3['default'])(_ref, ['getItemString', 'keyPath', 'labelRenderer', 'styling', 'value', 'valueRenderer', 'isCustomNode']);

  var nodeType = isCustomNode(value) ? 'Custom' : (0, _objType2['default'])(value);

  var simpleNodeProps = {
    getItemString: getItemString,
    key: keyPath[0],
    keyPath: keyPath,
    labelRenderer: labelRenderer,
    nodeType: nodeType,
    styling: styling,
    value: value,
    valueRenderer: valueRenderer
  };

  var nestedNodeProps = (0, _extends3['default'])({}, rest, simpleNodeProps, {
    data: value,
    isCustomNode: isCustomNode
  });

  switch (nodeType) {
    case 'Object':
    case 'Error':
    case 'WeakMap':
    case 'WeakSet':
      return _react2['default'].createElement(_JSONObjectNode2['default'], nestedNodeProps);
    case 'Array':
      return _react2['default'].createElement(_JSONArrayNode2['default'], nestedNodeProps);
    case 'Iterable':
    case 'Map':
    case 'Set':
      return _react2['default'].createElement(_JSONIterableNode2['default'], nestedNodeProps);
    case 'String':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter(raw) {
          return '"' + raw + '"';
        } }));
    case 'Number':
      return _react2['default'].createElement(_JSONValueNode2['default'], simpleNodeProps);
    case 'Boolean':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, {
        valueGetter: function valueGetter(raw) {
          return raw ? 'true' : 'false';
        }
      }));
    case 'Date':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, {
        valueGetter: function valueGetter(raw) {
          return raw.toISOString();
        }
      }));
    case 'Null':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter() {
          return 'null';
        } }));
    case 'Undefined':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter() {
          return 'undefined';
        } }));
    case 'Function':
    case 'Symbol':
      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, {
        valueGetter: function valueGetter(raw) {
          return raw.toString();
        }
      }));
    case 'Custom':
      return _react2['default'].createElement(_JSONValueNode2['default'], simpleNodeProps);
    default:
      return null;
  }
};

JSONNode.propTypes = {
  getItemString: _propTypes2['default'].func.isRequired,
  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
  labelRenderer: _propTypes2['default'].func.isRequired,
  styling: _propTypes2['default'].func.isRequired,
  value: _propTypes2['default'].any,
  valueRenderer: _propTypes2['default'].func.isRequired,
  isCustomNode: _propTypes2['default'].func.isRequired
};

exports['default'] = JSONNode;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1934), __esModule: true };

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var JSONArrow = function JSONArrow(_ref) {
  var styling = _ref.styling,
      arrowStyle = _ref.arrowStyle,
      expanded = _ref.expanded,
      nodeType = _ref.nodeType,
      onClick = _ref.onClick;
  return _react2['default'].createElement(
    'div',
    (0, _extends3['default'])({}, styling('arrowContainer', arrowStyle), { onClick: onClick }),
    _react2['default'].createElement(
      'div',
      styling(['arrow', 'arrowSign'], nodeType, expanded, arrowStyle),
      '\u25B6',
      arrowStyle === 'double' && _react2['default'].createElement(
        'div',
        styling(['arrowSign', 'arrowSignInner']),
        '\u25B6'
      )
    )
  );
};

JSONArrow.propTypes = {
  styling: _propTypes2['default'].func.isRequired,
  arrowStyle: _propTypes2['default'].oneOf(['single', 'double']),
  expanded: _propTypes2['default'].bool.isRequired,
  nodeType: _propTypes2['default'].string.isRequired,
  onClick: _propTypes2['default'].func.isRequired
};

JSONArrow.defaultProps = {
  arrowStyle: 'single'
};

exports['default'] = JSONArrow;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(468)
  , TAG = __webpack_require__(114)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBase16Theme = exports.createStyling = exports.invertTheme = undefined;

var _typeof2 = __webpack_require__(461);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(1949);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(323);

var _keys2 = _interopRequireDefault(_keys);

var _lodash = __webpack_require__(1953);

var _lodash2 = _interopRequireDefault(_lodash);

var _base = __webpack_require__(718);

var base16 = _interopRequireWildcard(_base);

var _rgb2hex = __webpack_require__(1954);

var _rgb2hex2 = _interopRequireDefault(_rgb2hex);

var _parse = __webpack_require__(1955);

var _parse2 = _interopRequireDefault(_parse);

var _lodash3 = __webpack_require__(1960);

var _lodash4 = _interopRequireDefault(_lodash3);

var _colorConverters = __webpack_require__(1961);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_BASE16 = base16.default;

var BASE16_KEYS = (0, _keys2.default)(DEFAULT_BASE16);

// we need a correcting factor, so that a dark, but not black background color
// converts to bright enough inversed color
var flip = function flip(x) {
  return x < 0.25 ? 1 : x < 0.5 ? 0.9 - x : 1.1 - x;
};

var invertColor = (0, _lodash4.default)(_parse2.default, _colorConverters.rgb2yuv, function (_ref) {
  var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
      y = _ref2[0],
      u = _ref2[1],
      v = _ref2[2];

  return [flip(y), u, v];
}, _colorConverters.yuv2rgb, _rgb2hex2.default);

var merger = function merger(styling) {
  return function (prevStyling) {
    return {
      className: [prevStyling.className, styling.className].filter(Boolean).join(' '),
      style: (0, _extends3.default)({}, prevStyling.style || {}, styling.style || {})
    };
  };
};

var mergeStyling = function mergeStyling(customStyling, defaultStyling) {
  if (customStyling === undefined) {
    return defaultStyling;
  }
  if (defaultStyling === undefined) {
    return customStyling;
  }

  var customType = typeof customStyling === 'undefined' ? 'undefined' : (0, _typeof3.default)(customStyling);
  var defaultType = typeof defaultStyling === 'undefined' ? 'undefined' : (0, _typeof3.default)(defaultStyling);

  switch (customType) {
    case 'string':
      switch (defaultType) {
        case 'string':
          return [defaultStyling, customStyling].filter(Boolean).join(' ');
        case 'object':
          return merger({ className: customStyling, style: defaultStyling });
        case 'function':
          return function (styling) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            return merger({
              className: customStyling
            })(defaultStyling.apply(undefined, [styling].concat(args)));
          };
      }
    case 'object':
      switch (defaultType) {
        case 'string':
          return merger({ className: defaultStyling, style: customStyling });
        case 'object':
          return (0, _extends3.default)({}, defaultStyling, customStyling);
        case 'function':
          return function (styling) {
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            return merger({
              style: customStyling
            })(defaultStyling.apply(undefined, [styling].concat(args)));
          };
      }
    case 'function':
      switch (defaultType) {
        case 'string':
          return function (styling) {
            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              args[_key3 - 1] = arguments[_key3];
            }

            return customStyling.apply(undefined, [merger(styling)({
              className: defaultStyling
            })].concat(args));
          };
        case 'object':
          return function (styling) {
            for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
              args[_key4 - 1] = arguments[_key4];
            }

            return customStyling.apply(undefined, [merger(styling)({
              style: defaultStyling
            })].concat(args));
          };
        case 'function':
          return function (styling) {
            for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
              args[_key5 - 1] = arguments[_key5];
            }

            return customStyling.apply(undefined, [defaultStyling.apply(undefined, [styling].concat(args))].concat(args));
          };
      }
  }
};

var mergeStylings = function mergeStylings(customStylings, defaultStylings) {
  var keys = (0, _keys2.default)(defaultStylings);
  for (var key in customStylings) {
    if (keys.indexOf(key) === -1) keys.push(key);
  }

  return keys.reduce(function (mergedStyling, key) {
    return mergedStyling[key] = mergeStyling(customStylings[key], defaultStylings[key]), mergedStyling;
  }, {});
};

var getStylingByKeys = function getStylingByKeys(mergedStyling, keys) {
  for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
    args[_key6 - 2] = arguments[_key6];
  }

  if (keys === null) {
    return mergedStyling;
  }

  if (!Array.isArray(keys)) {
    keys = [keys];
  }

  var styles = keys.map(function (key) {
    return mergedStyling[key];
  }).filter(Boolean);

  var props = styles.reduce(function (obj, s) {
    if (typeof s === 'string') {
      obj.className = [obj.className, s].filter(Boolean).join(' ');
    } else if ((typeof s === 'undefined' ? 'undefined' : (0, _typeof3.default)(s)) === 'object') {
      obj.style = (0, _extends3.default)({}, obj.style, s);
    } else if (typeof s === 'function') {
      obj = (0, _extends3.default)({}, obj, s.apply(undefined, [obj].concat(args)));
    }

    return obj;
  }, { className: '', style: {} });

  if (!props.className) {
    delete props.className;
  }

  if ((0, _keys2.default)(props.style).length === 0) {
    delete props.style;
  }

  return props;
};

var invertTheme = exports.invertTheme = function invertTheme(theme) {
  return (0, _keys2.default)(theme).reduce(function (t, key) {
    return t[key] = /^base/.test(key) ? invertColor(theme[key]) : key === 'scheme' ? theme[key] + ':inverted' : theme[key], t;
  }, {});
};

var createStyling = exports.createStyling = (0, _lodash2.default)(function (getStylingFromBase16) {
  for (var _len7 = arguments.length, args = Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
    args[_key7 - 3] = arguments[_key7];
  }

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var themeOrStyling = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$defaultBase = options.defaultBase16,
      defaultBase16 = _options$defaultBase === undefined ? DEFAULT_BASE16 : _options$defaultBase,
      _options$base16Themes = options.base16Themes,
      base16Themes = _options$base16Themes === undefined ? null : _options$base16Themes;


  var base16Theme = getBase16Theme(themeOrStyling, base16Themes);
  if (base16Theme) {
    themeOrStyling = (0, _extends3.default)({}, base16Theme, themeOrStyling);
  }

  var theme = BASE16_KEYS.reduce(function (t, key) {
    return t[key] = themeOrStyling[key] || defaultBase16[key], t;
  }, {});

  var customStyling = (0, _keys2.default)(themeOrStyling).reduce(function (s, key) {
    return BASE16_KEYS.indexOf(key) === -1 ? (s[key] = themeOrStyling[key], s) : s;
  }, {});

  var defaultStyling = getStylingFromBase16(theme);

  var mergedStyling = mergeStylings(customStyling, defaultStyling);

  return (0, _lodash2.default)(getStylingByKeys, 2).apply(undefined, [mergedStyling].concat(args));
}, 3);

var getBase16Theme = exports.getBase16Theme = function getBase16Theme(theme, base16Themes) {
  if (theme && theme.extend) {
    theme = theme.extend;
  }

  if (typeof theme === 'string') {
    var _theme$split = theme.split(':'),
        _theme$split2 = (0, _slicedToArray3.default)(_theme$split, 2),
        themeName = _theme$split2[0],
        modifier = _theme$split2[1];

    theme = (base16Themes || {})[themeName] || base16[themeName];
    if (modifier === 'inverted') {
      theme = invertTheme(theme);
    }
  }

  return theme && theme.hasOwnProperty('base00') ? theme : undefined;
};

/***/ }),
/* 738 */
/***/ (function(module, exports) {

var component = /-?\d+(\.\d+)?%?/g;
function extractComponents(color) {
  return color.match(component);
}

module.exports = extractComponents;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable no-unused-vars*/


var Lifecycle = function (_Component) {
	_inherits(Lifecycle, _Component);

	function Lifecycle() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Lifecycle);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Lifecycle.__proto__ || Object.getPrototypeOf(Lifecycle)).call.apply(_ref, [this].concat(args))), _this), _this.displayName = 'Lifecycle', _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Lifecycle, [{
		key: 'execute',
		value: function execute(fn) {
			var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
			var defaultValue = arguments[2];

			return fn ? fn.call.apply(fn, [this].concat(_toConsumableArray(args))) : defaultValue;
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			this.execute(this.props.componentWillMount);
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.execute(this.props.componentDidMount);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps() {
			for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
				args[_key2] = arguments[_key2];
			}

			this.execute(this.props.componentWillReceiveProps, args);
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate() {
			for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
				args[_key3] = arguments[_key3];
			}

			this.execute(this.props.componentWillUpdate, args);
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
				args[_key4] = arguments[_key4];
			}

			this.execute(this.props.componentDidUpdate, args);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.execute(this.props.componentWillUnmount);
		}
	}, {
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate() {
			for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
				args[_key5] = arguments[_key5];
			}

			return this.execute(this.props.shouldComponentUpdate, args, true);
		}
	}, {
		key: 'componentDidCatch',
		value: function componentDidCatch(error, info) {
			this.execute(this.props.componentDidCatch, [error, info]);
		}
	}, {
		key: 'render',
		value: function render() {
			var Comp = this.props.component;

			var _props = this.props,
			    componentWillMount = _props.componentWillMount,
			    componentDidMount = _props.componentDidMount,
			    componentWillReceiveProps = _props.componentWillReceiveProps,
			    componentWillUpdate = _props.componentWillUpdate,
			    componentDidUpdate = _props.componentDidUpdate,
			    componentWillUnmount = _props.componentWillUnmount,
			    shouldComponentUpdate = _props.shouldComponentUpdate,
			    componentDidCatch = _props.componentDidCatch,
			    realProps = _objectWithoutProperties(_props, ['componentWillMount', 'componentDidMount', 'componentWillReceiveProps', 'componentWillUpdate', 'componentDidUpdate', 'componentWillUnmount', 'shouldComponentUpdate', 'componentDidCatch']);

			return _react2.default.createElement(Comp, realProps);
		}
	}]);

	return Lifecycle;
}(_react.Component);

Lifecycle.propTypes = {
	component: _propTypes2.default.func.isRequired,
	componentDidMount: _propTypes2.default.func,
	componentDidUpdate: _propTypes2.default.func,
	componentWillMount: _propTypes2.default.func,
	componentWillReceiveProps: _propTypes2.default.func,
	componentWillUnmount: _propTypes2.default.func,
	componentWillUpdate: _propTypes2.default.func,
	shouldComponentUpdate: _propTypes2.default.func,
	componentDidCatch: _propTypes2.default.func
};
exports.default = Lifecycle;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _component = __webpack_require__(739);

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (component) {
	var firstProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	return function (mainProps) {
		return _react2.default.createElement(_component2.default, _extends({}, firstProps, mainProps, { component: component }));
	};
};

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_translations_selectors__ = __webpack_require__(262);
var mapStateToProps=function mapStateToProps(state){return{isLoading:Object(__WEBPACK_IMPORTED_MODULE_2__core_state_translations_selectors__["b" /* getTranslationsLoading */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]));

/***/ }),
/* 742 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isArguments;


/***/ }),
/* 743 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var arrayTag = '[object Array]',
    funcTag = '[object Function]';

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative(Array, 'isArray');

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
};

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 equivalents which return 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isArray;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__(742),
    isArray = __webpack_require__(743);

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER : length;
  return value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength(length) &&
    (isArray(object) || isArguments(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = keysIn;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(324),
    _assign = __webpack_require__(77);

var ReactNoopUpdateQueue = __webpack_require__(746);

var canDefineProperty = __webpack_require__(747);
var emptyObject = __webpack_require__(269);
var invariant = __webpack_require__(86);
var lowPriorityWarning = __webpack_require__(2004);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(325);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var getFunctionName = __webpack_require__(245);

function replacer(key, value) {
  if (typeof value === 'function') {
    return getFunctionName(value);
  }
  return value;
}

module.exports = function stringify(x) {
  try { // handle "Converting circular structure to JSON" error
    return JSON.stringify(x, replacer, 2);
  }
  catch (e) {
    return String(x);
  }
};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);
var isBoolean = __webpack_require__(327);

module.exports = irreducible('Boolean', isBoolean);


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);
var isNil = __webpack_require__(98);

module.exports = irreducible('Nil', isNil);


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);
var isNumber = __webpack_require__(754);

module.exports = irreducible('Number', isNumber);


/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = function isNumber(x) {
  return typeof x === 'number' && isFinite(x) && !isNaN(x);
};

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var isType = __webpack_require__(59);

module.exports = function isUnion(x) {
  return isType(x) && ( x.meta.kind === 'union' );
};

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var isFunction = __webpack_require__(58);
var getTypeName = __webpack_require__(53);
var isIdentity = __webpack_require__(117);
var create = __webpack_require__(118);
var is = __webpack_require__(119);
var isArray = __webpack_require__(116);

function getDefaultName(type) {
  return 'Array<' + getTypeName(type) + '>';
}

function list(type, name) {

  if (false) {
    assert(isFunction(type), function () { return 'Invalid argument type ' + assert.stringify(type) + ' supplied to list(type, [name]) combinator (expected a type)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to list(type, [name]) combinator (expected a string)'; });
  }

  var displayName = name || getDefaultName(type);
  var typeNameCache = getTypeName(type);
  var identity = isIdentity(type); // the list is identity iif type is identity

  function List(value, path) {

    if (true) {
      if (identity) {
        return value; // just trust the input if elements must not be hydrated
      }
    }

    if (false) {
      path = path || [displayName];
      assert(isArray(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of ' + typeNameCache + ')'; });
    }

    var idempotent = true; // will remain true if I can reutilise the input
    var ret = []; // make a temporary copy, will be discarded if idempotent remains true
    for (var i = 0, len = value.length; i < len; i++ ) {
      var actual = value[i];
      var instance = create(type, actual, (  false ? path.concat(i + ': ' + typeNameCache) : null ));
      idempotent = idempotent && ( actual === instance );
      ret.push(instance);
    }

    if (idempotent) { // implements idempotency
      ret = value;
    }

    if (false) {
      Object.freeze(ret);
    }

    return ret;
  }

  List.meta = {
    kind: 'list',
    type: type,
    name: name,
    identity: identity
  };

  List.displayName = displayName;

  List.is = function (x) {
    return isArray(x) && x.every(function (e) {
      return is(e, type);
    });
  };

  List.update = function (instance, patch) {
    return List(assert.update(instance, patch));
  };

  return List;
}

list.getDefaultName = getDefaultName;
module.exports = list;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var getTypeName = __webpack_require__(53);

function getDefaultInterfaceName(props) {
  return '{' + Object.keys(props).map(function (prop) {
    return prop + ': ' + getTypeName(props[prop]);
  }).join(', ') + '}';
}

module.exports = getDefaultInterfaceName;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isFunction = __webpack_require__(58);
var isArray = __webpack_require__(116);
var mixin = __webpack_require__(486);
var isStruct = __webpack_require__(2034);
var isInterface = __webpack_require__(2035);
var isObject = __webpack_require__(115);
var refinement = __webpack_require__(483);
var decompose = __webpack_require__(2036);

function compose(predicates, unrefinedType) {
  return predicates.reduce(function (type, predicate) {
    return refinement(type, predicate);
  }, unrefinedType);
}

function getProps(type) {
  return isObject(type) ? type : type.meta.props;
}

function getDefaultProps(type) {
  return isObject(type) ? null : type.meta.defaultProps;
}

function pushAll(arr, elements) {
  Array.prototype.push.apply(arr, elements);
}

function extend(combinator, mixins, options) {
  if (false) {
    assert(isFunction(combinator), function () { return 'Invalid argument combinator supplied to extend(combinator, mixins, options), expected a function'; });
    assert(isArray(mixins), function () { return 'Invalid argument mixins supplied to extend(combinator, mixins, options), expected an array'; });
  }
  var props = {};
  var prototype = {};
  var predicates = [];
  var defaultProps = {};
  mixins.forEach(function (x, i) {
    var decomposition = decompose(x);
    var unrefinedType = decomposition.unrefinedType;
    if (false) {
      assert(isObject(unrefinedType) || isStruct(unrefinedType) || isInterface(unrefinedType), function () { return 'Invalid argument mixins[' + i + '] supplied to extend(combinator, mixins, options), expected an object, struct, interface or a refinement (of struct or interface)'; });
    }
    pushAll(predicates, decomposition.predicates);
    mixin(props, getProps(unrefinedType));
    mixin(prototype, unrefinedType.prototype);
    mixin(defaultProps, getDefaultProps(unrefinedType), true);
  });
  options = combinator.getOptions(options);
  options.defaultProps = mixin(defaultProps, options.defaultProps, true);
  var result = compose(predicates, combinator(props, options));
  mixin(result.prototype, prototype);
  return result;
}

module.exports = extend;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var isFunction = __webpack_require__(58);
var getTypeName = __webpack_require__(53);
var isIdentity = __webpack_require__(117);
var isArray = __webpack_require__(116);
var create = __webpack_require__(118);
var is = __webpack_require__(119);

function getDefaultName(types) {
  return '[' + types.map(getTypeName).join(', ') + ']';
}

function tuple(types, name) {

  if (false) {
    assert(isArray(types) && types.every(isFunction), function () { return 'Invalid argument types ' + assert.stringify(types) + ' supplied to tuple(types, [name]) combinator (expected an array of types)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to tuple(types, [name]) combinator (expected a string)'; });
  }

  var displayName = name || getDefaultName(types);
  var identity = types.every(isIdentity);

  function Tuple(value, path) {

    if (true) {
      if (identity) {
        return value;
      }
    }

    if (false) {
      path = path || [displayName];
      assert(isArray(value) && value.length === types.length, function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of length ' + types.length + ')'; });
    }

    var idempotent = true;
    var ret = [];
    for (var i = 0, len = types.length; i < len; i++) {
      var expected = types[i];
      var actual = value[i];
      var instance = create(expected, actual, (  false ? path.concat(i + ': ' + getTypeName(expected)) : null ));
      idempotent = idempotent && ( actual === instance );
      ret.push(instance);
    }

    if (idempotent) { // implements idempotency
      ret = value;
    }

    if (false) {
      Object.freeze(ret);
    }

    return ret;
  }

  Tuple.meta = {
    kind: 'tuple',
    types: types,
    name: name,
    identity: identity
  };

  Tuple.displayName = displayName;

  Tuple.is = function (x) {
    return isArray(x) &&
      x.length === types.length &&
      types.every(function (type, i) {
        return is(x[i], type);
      });
  };

  Tuple.update = function (instance, patch) {
    return Tuple(assert.update(instance, patch));
  };

  return Tuple;
}

tuple.getDefaultName = getDefaultName;
module.exports = tuple;

/***/ }),
/* 760 */
/***/ (function(module, exports) {

function assign(x, y) {
  for (var k in y) {
    if (y.hasOwnProperty(k)) {
      x[k] = y[k];
    }
  }
  return x;
}

module.exports = assign;


/***/ }),
/* 761 */
/***/ (function(module, exports) {




/*
* @version    1.0.4
* @date       2015-03-13
* @stability  3 - Stable
* @author     Lauri Rooden <lauri@rooden.ee>
* @license    MIT License
*/


// In browser `this` refers to the window object,
// in NodeJS `this` refers to the exports.

this.cookie = function(name, value, ttl, path, domain, secure) {

	if (arguments.length > 1) {
		return document.cookie = name + "=" + encodeURIComponent(value) +
			(ttl ? "; expires=" + new Date(+new Date()+(ttl*1000)).toUTCString() : "") +
			(path   ? "; path=" + path : "") +
			(domain ? "; domain=" + domain : "") +
			(secure ? "; secure" : "")
	}

	return decodeURIComponent((("; "+document.cookie).split("; "+name+"=")[1]||"").split(";")[0])
}


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_subscriptions__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_utils_velocity_animations__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__attribute_types__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__intl__ = __webpack_require__(2111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(2112);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var defineSettingsList=function defineSettingsList(logic,settingsDefinitions,currentSettingsValues){var previousSettings=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[];return logic.reduce(function(acc,l){var parentSetting=settingsDefinitions[l.settingId];var currentSettings=[].concat(_toConsumableArray(acc),[parentSetting]);var currentParentValue=currentSettingsValues&&currentSettingsValues[parentSetting.propertyName]?currentSettingsValues[parentSetting.propertyName]:parentSetting.defaultValue;var childLogic=l.ifValue&&l.ifValue[currentParentValue];return childLogic?defineSettingsList(childLogic,settingsDefinitions,currentSettingsValues,currentSettings):currentSettings;},previousSettings);};var prepareSettings=function prepareSettings(logic,settingsDefinitions,currentSettingsValues,changedSettingId,newValue){var previousSettings=arguments.length>5&&arguments[5]!==undefined?arguments[5]:{};return logic.reduce(function(acc,l){var parentSetting=settingsDefinitions[l.settingId];var currentParentValue=changedSettingId===l.settingId?newValue:currentSettingsValues[parentSetting.propertyName]!=null?currentSettingsValues[parentSetting.propertyName]:parentSetting.defaultValue;var currentSettings=Object.assign({},acc,_defineProperty({},parentSetting.propertyName,currentParentValue));var childLogic=l.ifValue&&l.ifValue[currentParentValue];return childLogic?prepareSettings(childLogic,settingsDefinitions,currentSettingsValues,changedSettingId,newValue,currentSettings):currentSettings;},previousSettings);};var getDurationList=function getDurationList(status){return[{value:0,label:status==='ON'?__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].durationStayOn:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].durationStayOff},{value:30,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration30Seconds},{value:60,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration1Minute},{value:180,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration3Minutes},{value:300,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration5Minutes},{value:600,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration10Minutes},{value:900,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration15Minutes},{value:1800,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration30Minutes},{value:3600,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration1Hour},{value:7200,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration2Hours},{value:10800,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration3Hours},{value:14400,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration4Hours},{value:18000,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration5Hours},{value:21600,label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].duration6Hours}];};var ActionAttribute=function(_Component){_inherits(ActionAttribute,_Component);function ActionAttribute(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ActionAttribute);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ActionAttribute.__proto__||Object.getPrototypeOf(ActionAttribute)).call.apply(_ref,[this].concat(args))),_this),_this.state={isDetailVisible:false,wasDetailSeen:false},_this.showDetail=function(){return _this.setState({isDetailVisible:true,wasDetailSeen:true});},_this.hideDetail=function(){return _this.setState({isDetailVisible:false});},_this.attributeTitle=function(chooseLabel){var _this$props=_this.props,_this$props$event=_this$props.event,definition=_this$props$event.definition,devices=_this$props$event.devices,id=_this$props$event.id,formStatus=_this$props.formStatus;var wasDetailSeen=_this.state.wasDetailSeen;var selectedDevice=devices.find(function(d){return d.value===id;});var heatingHotwater=(definition.devices||[]).some(function(device){return[__WEBPACK_IMPORTED_MODULE_3__core_constants_devices__["deviceTypes"].HEATING,__WEBPACK_IMPORTED_MODULE_3__core_constants_devices__["deviceTypes"].HOT_WATER].includes(device);});return selectedDevice&&!heatingHotwater&&(formStatus==='edit'||formStatus==='new'&&wasDetailSeen||devices.length===1)?selectedDevice.label:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],chooseLabel);},_this.removeAttribute=function(){var _this$props2=_this.props,event=_this$props2.event,removeActionAttribute=_this$props2.removeActionAttribute;removeActionAttribute(event);},_this.handleChange=function(settings,settingId,newValue){var _this$props3=_this.props,definition=_this$props3.event.definition,hasSMS=_this$props3.hasSMS,setActionAttribute=_this$props3.setActionAttribute,showHiveLiveModal=_this$props3.showHiveLiveModal;settingId==='text'&&!hasSMS?showHiveLiveModal({feature:__WEBPACK_IMPORTED_MODULE_2__core_constants_subscriptions__["a" /* features */].textNotifications}):setActionAttribute('settings',definition.settings?prepareSettings(definition.settings.logic,definition.settings.definitions,settings,settingId,newValue):{});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ActionAttribute,[{key:'render',value:function render(){var _this2=this;var _props=this.props,actionId=_props.actionId,event=_props.event,setActionAttribute=_props.setActionAttribute;var isDetailVisible=this.state.isDetailVisible;var definition=event.definition,devices=event.devices,duration=event.duration,id=event.id,preSettings=event.settings;var settings=preSettings&&definition.processSettings?definition.processSettings(preSettings):preSettings;var settingsList=definition.settings?defineSettingsList(definition.settings.logic,definition.settings.definitions,settings):[];var visibleSettings=settingsList.filter(function(setting){return!setting.hide;});var detailsLength=(devices.length>1?1:0)+visibleSettings.length+(definition.hasDuration?1:0);var chooseLabel=definition.chooseLabel||__WEBPACK_IMPORTED_MODULE_10__intl__["a" /* default */].defaultChooseLabel;var removable=event.group!=='when';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["h" /* Main */],{detailsLength:detailsLength,isDetailVisible:isDetailVisible,isSchedule:definition.componentType==='schedule',removable:removable},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["g" /* Header */],{clickable:detailsLength&&!isDetailVisible,onClick:detailsLength&&!isDetailVisible?this.showDetail:null},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["c" /* AttributeIconContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["b" /* AttributeIcon */],{quickAction:event.type===__WEBPACK_IMPORTED_MODULE_5__core_constants_actions__["b" /* actionTypes */].QUICK_ACTION,type:definition.icon})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["k" /* TextSection */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["m" /* Title */],null,devices.length===1?devices[0].label:this.attributeTitle(chooseLabel)),definition.description&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["d" /* Description */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],definition.description))),detailsLength?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* ActionContainer */],{enter:{animation:__WEBPACK_IMPORTED_MODULE_7__core_utils_velocity_animations__["a" /* BounceIn */],duration:300},leave:{animation:__WEBPACK_IMPORTED_MODULE_7__core_utils_velocity_animations__["b" /* BounceOut */],duration:300},onClick:isDetailVisible?this.hideDetail:null},isDetailVisible?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["l" /* TickIcon */],{key:'tick',type:__WEBPACK_IMPORTED_MODULE_6__core_constants_icons_general_svg__["a" /* default */].TICK_SIMPLE}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["i" /* MoreIcon */],{key:'more',type:__WEBPACK_IMPORTED_MODULE_6__core_constants_icons_general_svg__["a" /* default */].MORE})):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["e" /* Detail */],null,devices.length>1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["f" /* DetailItem */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__attribute_types__["c" /* Select */],{currentValue:id,handleChange:function handleChange(deviceId){return setActionAttribute('id',deviceId);},label:chooseLabel,options:devices})),visibleSettings.map(function(s){return definition.componentType==='schedule'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["f" /* DetailItem */],{isSchedule:true,key:s.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__attribute_types__["b" /* Schedule */],{actionId:actionId})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["f" /* DetailItem */],{key:s.id},definition.componentType==='checkbox'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__attribute_types__["a" /* Checkbox */],{currentValue:settings&&settings[s.propertyName]!=null?settings[s.propertyName]:s.defaultValue,handleChange:function handleChange(newValue){return _this2.handleChange(settings||{},s.id,newValue);},label:s.chooseLabel}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__attribute_types__["c" /* Select */],{currentValue:settings&&settings[s.propertyName]?settings[s.propertyName]:s.defaultValue,handleChange:function handleChange(newValue){return setActionAttribute('settings',definition.settings?prepareSettings(definition.settings.logic,definition.settings.definitions,settings||{},s.id,newValue):{});},label:s.chooseLabel,options:s.values}));}),definition.hasDuration&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["f" /* DetailItem */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__attribute_types__["c" /* Select */],{currentValue:duration||0,handleChange:function handleChange(newDuration){return setActionAttribute('duration',newDuration);},label:__WEBPACK_IMPORTED_MODULE_8__core_constants_actions_intl__["a" /* default */].forDuration,options:getDurationList(settings?settings.status:(visibleSettings[0]||{}).defaultValue)})),removable&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["j" /* RemoveAttribute */],{onClick:this.removeAttribute},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__intl__["a" /* default */].removeFromAction))));}}]);return ActionAttribute;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ActionAttribute);

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(2052),
    createBaseEach = __webpack_require__(2057);

/**
 * The base implementation of `_.forEach` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object|string} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2053);

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(766);

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

module.exports = getLength;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 767 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(491),
    bindCallback = __webpack_require__(248);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent. If `customizer` is provided it's invoked to compare values.
 * If `customizer` returns `undefined` comparisons are handled by the method
 * instead. The `customizer` is bound to `thisArg` and invoked with up to
 * three arguments: (value, other [, index|key]).
 *
 * **Note:** This method supports comparing arrays, booleans, `Date` objects,
 * numbers, `Object` objects, regexes, and strings. Objects are compared by
 * their own, not inherited, enumerable properties. Functions and DOM nodes
 * are **not** supported. Provide a customizer function to extend support
 * for comparing other values.
 *
 * @static
 * @memberOf _
 * @alias eq
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize value comparisons.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var other = { 'user': 'fred' };
 *
 * object == other;
 * // => false
 *
 * _.isEqual(object, other);
 * // => true
 *
 * // using a customizer callback
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqual(array, other, function(value, other) {
 *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
 *     return true;
 *   }
 * });
 * // => true
 */
function isEqual(value, other, customizer, thisArg) {
  customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}

module.exports = isEqual;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(770),
    baseDifference = __webpack_require__(2065),
    baseFlatten = __webpack_require__(2072),
    bindCallback = __webpack_require__(248),
    keysIn = __webpack_require__(490),
    pickByArray = __webpack_require__(2074),
    pickByCallback = __webpack_require__(2075),
    restParam = __webpack_require__(771);

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable properties of `object` that are not omitted.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {Function|...(string|string[])} [predicate] The function invoked per
 *  iteration or property names to omit, specified as individual property
 *  names or arrays of property names.
 * @param {*} [thisArg] The `this` binding of `predicate`.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'user': 'fred', 'age': 40 };
 *
 * _.omit(object, 'age');
 * // => { 'user': 'fred' }
 *
 * _.omit(object, _.isNumber);
 * // => { 'user': 'fred' }
 */
var omit = restParam(function(object, props) {
  if (object == null) {
    return {};
  }
  if (typeof props[0] != 'function') {
    var props = arrayMap(baseFlatten(props), String);
    return pickByArray(object, baseDifference(keysIn(object), props));
  }
  var predicate = bindCallback(props[0], props[1], 3);
  return pickByCallback(object, function(value, key, object) {
    return !predicate(value, key, object);
  });
});

module.exports = omit;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 771 */
/***/ (function(module, exports) {

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function restParam(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        rest = Array(length);

    while (++index < length) {
      rest[index] = args[start + index];
    }
    switch (start) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, args[0], rest);
      case 2: return func.call(this, args[0], args[1], rest);
    }
    var otherArgs = Array(start + 1);
    index = -1;
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = rest;
    return func.apply(this, otherArgs);
  };
}

module.exports = restParam;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(120);

/**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path, pathKey) {
  if (object == null) {
    return;
  }
  if (pathKey !== undefined && pathKey in toObject(object)) {
    path = [pathKey];
  }
  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[path[index++]];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(121),
    toObject = __webpack_require__(120);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  var type = typeof value;
  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
    return true;
  }
  if (isArray(value)) {
    return false;
  }
  var result = !reIsDeepProp.test(value);
  return result || (object != null && value in toObject(object));
}

module.exports = isKey;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(2096),
    isArray = __webpack_require__(121);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */
function toPath(value) {
  if (isArray(value)) {
    return value;
  }
  var result = [];
  baseToString(value).replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
}

module.exports = toPath;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(766),
    basePropertyDeep = __webpack_require__(2097),
    isKey = __webpack_require__(774);

/**
 * Creates a function that returns the property value at `path` on a
 * given object.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': { 'c': 2 } } },
 *   { 'a': { 'b': { 'c': 1 } } }
 * ];
 *
 * _.map(objects, _.property('a.b.c'));
 * // => [2, 1]
 *
 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(496);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, _ref2) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact;
    var route = _ref2.route;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        component = _props.component,
        render = _props.render,
        children = _props.children;


    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && children), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(render && children), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props2 = this.props,
        children = _props2.children,
        component = _props2.component,
        render = _props2.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// this list is ordered by the keys code (http://keycode.info/)
/* harmony default export */ __webpack_exports__["a"] = ({ENTER:13,ESCAPE:27,SPACE:32,ARROW_LEFT:37,ARROW_UP:38,ARROW_RIGHT:39,ARROW_DOWN:40,KEY_0:48,KEY_1:49,KEY_2:50,KEY_3:51,KEY_4:52,KEY_5:53,KEY_6:54,KEY_7:55,KEY_8:56,KEY_9:57});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filtersType; });
var filtersType={BUILD_YOUR_OWN:'BUILD_YOUR_OWN',BY_CATEGORY:'BY_CATEGORY',BY_DEVICE:'BY_DEVICE',SHOW_ALL:'SHOW_ALL',WELCOME_HOME:'WELCOME_HOME'};

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({createAction:{id:'my-actions.createAction',defaultMessage:'Create new action'},numberAction:{id:'my-actions.numberAction',defaultMessage:'{amount, plural,\n\t\t\tone {Action:}\n\t\t\tother {Actions:}\n\t\t}'},enabledAction:{id:'my-actions.enabledAction',defaultMessage:'Enabled'},disabledAction:{id:'my-actions.disabledAction',defaultMessage:'Disabled'}}));

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WaitingIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2165);
function WaitingIndicator(_ref){var children=_ref.children,show=_ref.show;if(show){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* AnimationContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* LogoContainer */],null));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,children);}

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({myActions:{id:'actions-entry.my-actions',defaultMessage:'My Actions'},discoverActions:{id:'actions-entry.discover-actions',defaultMessage:'Discover Actions'},sideModalTitle:{id:'actions-entry.side-modal-title',defaultMessage:'Personalise'},confirmRemoveAction:{id:'actions-entry.confirm-remove-action',defaultMessage:'Remove this action?'},removeActionButton:{id:'actions-entry.remove-action-button',defaultMessage:'Remove Action'},notFullySupportedTitle:{id:'actions-entry.action-not-fully-supported-title',defaultMessage:'This Action is no longer fully supported'},notFullySupportedContent:{id:'actions-entry.action-not-fully-supported-content',defaultMessage:'It will still work, but can no longer be edited. Create a new Action to edit'}}));

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bariol_regular.264c746f6fd2bfb72714af1941fdfbff66bcf81adfd4ba6c7285f26d2423af8d.ttf";

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DaySelectorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DaySelectorItemWeekDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DaySelectorItemDayNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-around;\n'],['\n    display: flex;\n    justify-content: space-around;\n']),_templateObject2=_taggedTemplateLiteral(['\n    color: ',';\n    display: block;\n    font-size: 1.3rem;\n    text-align: center;\n'],['\n    color: ',';\n    display: block;\n    font-size: 1.3rem;\n    text-align: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n    cursor: pointer;\n    display: flex;\n    font-size: 1.3rem;\n    height: 3rem;\n    justify-content: center;\n    margin-top: 0.75rem;\n    text-align: center;\n    transition: color 0.3s ease-in-out;\n    width: 3rem;\n    align-items: center;\n    ',';\n'],['\n    cursor: pointer;\n    display: flex;\n    font-size: 1.3rem;\n    height: 3rem;\n    justify-content: center;\n    margin-top: 0.75rem;\n    text-align: center;\n    transition: color 0.3s ease-in-out;\n    width: 3rem;\n    align-items: center;\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n            cursor: default;\n            background-color: ',';\n            border-radius: 50%;\n            color: white;\n        '],['\n            cursor: default;\n            background-color: ',';\n            border-radius: 50%;\n            color: white;\n        ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DaySelectorList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ul(_templateObject);var DaySelectorItemWeekDay=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject2,function(_ref){var theme=_ref.theme;return theme.mainBrandColor;});var DaySelectorItemDayNumber=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject3,function(_ref2){var selected=_ref2.selected;return selected&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject4,function(_ref3){var theme=_ref3.theme;return theme.mainBrandColor;});});

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = markAsValueValidator;

var _symbols = __webpack_require__(788);

function markAsValueValidator(valueValidator) {
  valueValidator[_symbols.VALUE_VALIDATOR_SYMBOL] = true;
  return valueValidator;
}

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.VALUE_VALIDATOR_SYMBOL = undefined;

var _sym = __webpack_require__(2217);

var _sym2 = _interopRequireDefault(_sym);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VALUE_VALIDATOR_SYMBOL = exports.VALUE_VALIDATOR_SYMBOL = (0, _sym2.default)('VALUE_VALIDATOR'); /* eslint-disable import/prefer-default-export */

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isValueValidator;

var _symbols = __webpack_require__(788);

function isValueValidator(validator) {
  return validator[_symbols.VALUE_VALIDATOR_SYMBOL] === true;
}

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = internalCombineValidators;

var _parseFieldName = __webpack_require__(2226);

var _parseFieldName2 = _interopRequireDefault(_parseFieldName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function internalCombineValidators(validators) {
  var atRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function valuesValidator() {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var allValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(validators).reduce(function (errors, fieldName) {
      var parsedField = (0, _parseFieldName2.default)(fieldName);
      var validator = validators[parsedField.fullName];
      var value = values[parsedField.baseName];
      var finalAllValues = atRoot ? values : allValues;

      var errorMessage = parsedField.isArray ? (value || []).map(function (fieldValue) {
        return validator(fieldValue, finalAllValues);
      }) : validator(value, finalAllValues);

      if (errorMessage) {
        errors[parsedField.baseName] = errorMessage;
      }

      return errors;
    }, {});
  };
}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = valueMissing;
function valueMissing(value) {
  return value == null || typeof value === 'string' && value.trim() === '';
}

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_debounce__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progress__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_i18n_components_widgets_buttons_async_intl__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__ = __webpack_require__(342);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// Helpers
var getSaveTextStates=function getSaveTextStates(messages){var _ref;var nextMessages=Object.assign({},__WEBPACK_IMPORTED_MODULE_5__core_i18n_components_widgets_buttons_async_intl__["a" /* default */],messages);return _ref={},_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT,nextMessages.save),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVING,nextMessages.saving),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVED,nextMessages.saved),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVED_END,nextMessages.save),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR,nextMessages.error),_defineProperty(_ref,__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR_END,nextMessages.error),_ref;};var delayedSetStateShort=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_debounce___default()(1000,function(setState){return setState();});var delayedSetStateLong=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_debounce___default()(2000,function(setState){return setState();});var delayedSetStateForError=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_debounce___default()(2500,function(setState){return setState();});// Component
var AsyncButton=function(_React$Component){_inherits(AsyncButton,_React$Component);function AsyncButton(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,AsyncButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=AsyncButton.__proto__||Object.getPrototypeOf(AsyncButton)).call.apply(_ref2,[this].concat(args))),_this),_this._mounted=false,_this.state={saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT},_this.onClick=function(){var _this$props=_this.props,disabled=_this$props.disabled,onClick=_this$props.onClick;var saveState=_this.state.saveState;if(disabled||saveState!==__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT){return;}if(onClick){onClick();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AsyncButton,[{key:'componentDidMount',value:function componentDidMount(){this._mounted=true;}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this2=this;var saving=nextProps.saving,error=nextProps.error;var _props=this.props,lastSaving=_props.saving,_props$onAfterAnimati=_props.onAfterAnimation,afterAnimation=_props$onAfterAnimati===undefined?__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default.a:_props$onAfterAnimati;if(saving){this.setState({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVING});}else if(!saving&&lastSaving&&!error){this.setState({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVED});delayedSetStateShort(function(){// To prevent setState on unMounted component err
if(!_this2._mounted){return;}_this2.setState({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVED_END});afterAnimation({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVED_END});});delayedSetStateLong(function(){if(!_this2._mounted){return;}_this2.setState({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT});afterAnimation({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT});});}else if(error){this.setState({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR});delayedSetStateLong(function(){_this2.setState({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR_END});afterAnimation({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR_END});});delayedSetStateForError(function(){_this2.setState({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT});afterAnimation({saveState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT});});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._mounted=false;}},{key:'render',value:function render(){var _props2=this.props,disabled=_props2.disabled,_props2$messages=_props2.messages,messages=_props2$messages===undefined?__WEBPACK_IMPORTED_MODULE_5__core_i18n_components_widgets_buttons_async_intl__["a" /* default */]:_props2$messages,values=_props2.values,rest=_objectWithoutProperties(_props2,['disabled','messages','values']);var saveState=this.state.saveState;var saveTextStates=getSaveTextStates(messages);return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* AsyncBtn */],Object.assign({disabled:disabled,onClick:this.onClick,saveState:saveState},rest),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* ContentContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__progress__["a" /* default */],{saveState:saveState}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* SaveTextWrapper */],null,Object.keys(__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */]).map(function(key){return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* SaveText */],{key:key,saveState:saveState,thisState:__WEBPACK_IMPORTED_MODULE_7__core_constants_components_widgets_buttons_async__["b" /* saveStates */][key]},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_intl__["c" /* FormattedMessage */],Object.assign({},saveTextStates[key],{values:values})));})))));}}]);return AsyncButton;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AsyncButton);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_form_form_helpers__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var EditDeviceName=function EditDeviceName(_ref){var headingIntl=_ref.headingIntl,deviceName=_ref.deviceName,name=_ref.fields.name;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],headingIntl),':'),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["e" /* DeviceInfoPanelValueInput */],Object.assign({maxLength:20,minLength:1,placeholder:deviceName,type:'text'},Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_form_form_helpers__["a" /* getDOMOnlyProps */])(name))),name.touched&&name.error&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:'forms__validation forms__validation--show'},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */][name.error]))));};/* harmony default export */ __webpack_exports__["a"] = (EditDeviceName);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl__ = __webpack_require__(2250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var Component=Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["g" /* injectIntl */])((_temp=_class=function(_React$Component){_inherits(UnsavedChangesModal,_React$Component);function UnsavedChangesModal(){_classCallCheck(this,UnsavedChangesModal);return _possibleConstructorReturn(this,(UnsavedChangesModal.__proto__||Object.getPrototypeOf(UnsavedChangesModal)).apply(this,arguments));}_createClass(UnsavedChangesModal,[{key:'render',value:function render(){var _props=this.props,intl=_props.intl,showModal=_props.showModal;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_router__["Prompt"],{message:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_2__intl__["a" /* default */].description),when:showModal});}}]);return UnsavedChangesModal;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]),_class.props={showModal:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired},_temp)));/* harmony default export */ __webpack_exports__["a"] = (Component);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_translations_devices__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_i18n_components_widgets_remove_device_intl__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_components_widgets_remove_device_constants__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_components_widgets_remove_device_redux__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_components_widgets_remove_device__ = __webpack_require__(804);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapCategoryToText=function mapCategoryToText(category,type,device,manufacturer){var textMap=new Map([[category===__WEBPACK_IMPORTED_MODULE_6__core_components_widgets_remove_device_constants__["a" /* categories */].HUE,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({key:'remove-hue-text'},__WEBPACK_IMPORTED_MODULE_4__core_i18n_components_widgets_remove_device_intl__["a" /* default */].removeHueText))],[category===__WEBPACK_IMPORTED_MODULE_6__core_components_widgets_remove_device_constants__["a" /* categories */].ZONE,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({key:'remove-zone-text',values:{device:device}},__WEBPACK_IMPORTED_MODULE_4__core_i18n_components_widgets_remove_device_intl__["a" /* default */].cancelOrConfirmZone))],[category===__WEBPACK_IMPORTED_MODULE_6__core_components_widgets_remove_device_constants__["a" /* categories */].DEVICE,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:'remove-device-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_4__core_i18n_components_widgets_remove_device_intl__["a" /* default */].cancelOrConfirm,{values:{device:device}})),'\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({id:'devicetype'},Object(__WEBPACK_IMPORTED_MODULE_3__core_translations_devices__["a" /* findDeviceTypeMessage */])(type,manufacturer),{values:{amount:1}})))]]);return textMap.get(true);};var RemoveDeviceComponent=function(_Component){_inherits(RemoveDeviceComponent,_Component);function RemoveDeviceComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RemoveDeviceComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RemoveDeviceComponent.__proto__||Object.getPrototypeOf(RemoveDeviceComponent)).call.apply(_ref,[this].concat(args))),_this),_this.state={showRemoveModal:false},_this.showRemoveModal=function(e){e.preventDefault();_this.setState({showRemoveModal:true});},_this.hideRemoveModal=function(){_this.setState({showRemoveModal:false});},_this.remove=function(){_this.hideRemoveModal();_this.props.remove();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RemoveDeviceComponent,[{key:'render',value:function render(){var _props=this.props,deviceName=_props.deviceName,type=_props.type,deviceCategory=_props.deviceCategory,manufacturer=_props.manufacturer;var showRemoveModal=this.state.showRemoveModal;var deviceSpecificHeading=Object(__WEBPACK_IMPORTED_MODULE_8__core_components_widgets_remove_device__["a" /* mapCategoryToHeading */])(deviceCategory);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__modal__["a" /* default */],{contentLabel:'Remove Device Modal',isOpen:showRemoveModal,key:'remove-device-modal',onRequestClose:this.hideRemoveModal,onSave:this.remove,saveText:deviceSpecificHeading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],deviceSpecificHeading),'?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,mapCategoryToText(deviceCategory,type,deviceName,manufacturer))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* RemoveButton */],{alternate:true,key:'remove-device-button',onClick:this.showRemoveModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],deviceSpecificHeading))];}}]);return RemoveDeviceComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var RemoveDevice=function RemoveDevice(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__core_components_widgets_remove_device_redux__["a" /* default */],Object.assign({},props,{render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RemoveDeviceComponent,props);}}));};/* harmony default export */ __webpack_exports__["a"] = (RemoveDevice);

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(2257);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports['default'];

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidden(el) {
  return el.offsetWidth <= 0 && el.offsetHeight <= 0 || el.style.display === 'none';
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidden(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(tabbable);
}
module.exports = exports['default'];

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.tryForceFallback = tryForceFallback;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;
var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error('react-modal: No elements were found for selector ' + selector + '.');
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === 'string') {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = 'length' in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function tryForceFallback() {
  if (document && document.body) {
    // force fallback to document.body
    setElement(document.body);
    return true;
  }
  return false;
}

function validateElement(appElement) {
  if (!appElement && !globalElement && !tryForceFallback()) {
    throw new Error(['react-modal: Cannot fallback to `document.body`, because it\'s not ready or available.', 'If you are doing server-side rendering, use this function to defined an element.', '`Modal.setAppElement(el)` to make this accessible']);
  }
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || globalElement).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || globalElement).removeAttribute('aria-hidden');
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = document.body;
}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.add = add;
exports.remove = remove;
exports.totalCount = totalCount;
var classListMap = {};

function get() {
  return classListMap;
}

function add(bodyClass) {
  // Set variable and default if none
  if (!classListMap[bodyClass]) {
    classListMap[bodyClass] = 0;
  }
  classListMap[bodyClass] += 1;
  return bodyClass;
}

function remove(bodyClass) {
  if (classListMap[bodyClass]) {
    classListMap[bodyClass] -= 1;
  }
  return bodyClass;
}

function totalCount() {
  return Object.keys(classListMap).reduce(function (acc, curr) {
    return acc + classListMap[curr];
  }, 0);
}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(820);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
var youAreAbout='You are about to delete {device}.';/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({cancelOrConfirm:{id:'info-panel.cancel-or-confirm',defaultMessage:youAreAbout+' Please cancel to return to the device screen or confirm you wish to delete'},cancelOrConfirmZone:{id:'info-panel.cancel-or-confirm-zone',// eslint-disable-next-line max-len
defaultMessage:youAreAbout+' Please cancel to return to the device screen or confirm you wish to delete the thermostat and receiver for this zone.'},removeDeviceTitle:{id:'info-panel.remove-device-title',defaultMessage:'Remove device'},removeHueTitle:{id:'info-panel.remove-hue-title',defaultMessage:'Delete Philips Hue'},removeHueText:{id:'info-panel.remove-hue-text',defaultMessage:'Deleting the Philips Hue Bridge will remove all the devices connected to it.'},removeZoneTitle:{id:'info-panel.remove-zone-title',defaultMessage:'Remove zone'}}));

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return categories; });
var categories={HUE:'hue',ZONE:'zone',DEVICE:'device'};

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapCategoryToHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapStateToProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapDispatchToProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mergeProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_devices_actions__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_components_widgets_remove_device_intl__ = __webpack_require__(802);
var mapCategoryToHeading=function mapCategoryToHeading(category){var headingMap=new Map([[category===__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* categories */].HUE,__WEBPACK_IMPORTED_MODULE_5__i18n_components_widgets_remove_device_intl__["a" /* default */].removeHueTitle],[category===__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* categories */].ZONE,__WEBPACK_IMPORTED_MODULE_5__i18n_components_widgets_remove_device_intl__["a" /* default */].removeZoneTitle],[category===__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* categories */].DEVICE,__WEBPACK_IMPORTED_MODULE_5__i18n_components_widgets_remove_device_intl__["a" /* default */].removeDeviceTitle]]);return headingMap.get(true);};var mapCategoryToRemoveFunction=function mapCategoryToRemoveFunction(category,deviceHandler,zoneHandler,hueHandler){var functionMap=new Map([[category===__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* categories */].HUE,hueHandler],[category===__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* categories */].ZONE,zoneHandler],[category===__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* categories */].DEVICE,deviceHandler]]);return functionMap.get(true);};var getCategory=function getCategory(isHueDevice,zoneId){var categoryMap=new Map([[true,__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* categories */].DEVICE],[isHueDevice,__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* categories */].HUE],[zoneId,__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* categories */].ZONE]]);return categoryMap.get(true);};var mapStateToProps=function mapStateToProps(state,_ref){var deviceId=_ref.deviceId;var props={id:deviceId};var zoneId=Object(__WEBPACK_IMPORTED_MODULE_1__state_devices_selectors__["D" /* getDeviceZoneId */])(state,props);var zoneProducts=Object(__WEBPACK_IMPORTED_MODULE_3__state_products_selectors__["E" /* getProductsByZone */])(state,{id:deviceId,zone:zoneId});var isHueDevice=Object(__WEBPACK_IMPORTED_MODULE_1__state_devices_selectors__["R" /* getIsHueDevice */])(state,props);var hueBridge=Object(__WEBPACK_IMPORTED_MODULE_1__state_devices_selectors__["I" /* getHueBridge */])(state);// $FlowFixMe
return{deviceId:deviceId,deviceName:Object(__WEBPACK_IMPORTED_MODULE_1__state_devices_selectors__["s" /* getDeviceName */])(state,props).getOrElse(''),hueBridgeId:hueBridge&&hueBridge.id,manufacturer:Object(__WEBPACK_IMPORTED_MODULE_1__state_devices_selectors__["q" /* getDeviceManufacturer */])(state,props),type:Object(__WEBPACK_IMPORTED_MODULE_1__state_devices_selectors__["C" /* getDeviceType */])(state,props),deviceCategory:getCategory(isHueDevice,zoneId),zoneId:zoneId,zoneProducts:zoneProducts};};var mapDispatchToProps={removeDevice:__WEBPACK_IMPORTED_MODULE_2__state_devices_actions__["e" /* removeDevice */],removeZone:__WEBPACK_IMPORTED_MODULE_2__state_devices_actions__["g" /* removeZone */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var deviceId=stateProps.deviceId,hueBridgeId=stateProps.hueBridgeId,deviceCategory=stateProps.deviceCategory,zoneId=stateProps.zoneId,zoneProducts=stateProps.zoneProducts,deviceName=stateProps.deviceName,type=stateProps.type;var removeDevice=dispatchProps.removeDevice,removeZone=dispatchProps.removeZone;var deviceHandler=function deviceHandler(){return removeDevice({id:deviceId});};var zoneHandler=function zoneHandler(){return removeZone({id:zoneId,zoneProducts:zoneProducts});};var hueHandler=function hueHandler(){return removeDevice({id:hueBridgeId});};return Object.assign({},ownProps,{deviceCategory:deviceCategory,deviceName:deviceName,remove:mapCategoryToRemoveFunction(deviceCategory,deviceHandler,zoneHandler,hueHandler),type:type});};

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('groupBy', __webpack_require__(2266));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_translations_devices__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_translations_devices_intl__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_svg_icons__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_utils_form_form_helpers__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__intl__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_components_conditional_feature__ = __webpack_require__(338);
function DeviceListItem(_ref){var field=_ref.field,localeSuffix=_ref.localeSuffix,manufacturer=_ref.manufacturer,model=_ref.model,online=_ref.online,type=_ref.type,id=_ref.id,capabilities=_ref.capabilities,identifyDevice=_ref.identifyDevice,isNano1=_ref.isNano1;var isIdentifyDeviceEnabled=!isNano1&&online&&capabilities&&capabilities.includes(__WEBPACK_IMPORTED_MODULE_9__core_constants_devices__["capabilities"].IDENTIFY_DEVICE);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["h" /* Wrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* DeviceIconWrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["g" /* StyledSVGIcon */],{type:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_svg_icons__["a" /* deviceTypeToIcon */])({model:model,type:type,localeSuffix:localeSuffix})})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* ItemContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_7__intl__["a" /* default */].name,function(m){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["c" /* InputStyled */],Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_6__core_utils_form_form_helpers__["a" /* getDOMOnlyProps */])(field),{error:field.touched&&field.error||null,id:field.name,label:m,maxLength:20,touched:field.touched}));}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["f" /* StatusContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["e" /* Status */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3__core_translations_devices__["a" /* findDeviceTypeMessage */])(type,manufacturer,model),{values:{amount:1}})),': ',__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__core_translations_devices_intl__["d" /* deviceOnlineMessages */][online?'connected':'offline'])),isIdentifyDeviceEnabled&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__core_components_conditional_feature__["a" /* default */],{condition:function condition(featureFlags){return featureFlags.identifyProductButton;}},function(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* IdentifyButton */],{onClick:function onClick(){return identifyDevice(id,type);},type:'button'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__core_translations_devices_intl__["d" /* deviceOnlineMessages */].identify));}))));}/* harmony default export */ __webpack_exports__["a"] = (DeviceListItem);

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({events:{id:'logs-timeline.events',defaultMessage:'Events'},Motion:{id:'logs-timeline.motion',defaultMessage:'Motion'},Opened:{id:'logs-timeline.opened',defaultMessage:'Opened'},Closed:{id:'logs-timeline.closed',defaultMessage:'Closed'},motionDetected:{id:'logs-timeline.motion-detected',defaultMessage:'Motion Detected'}}));

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ANIMATION_KEY_IMPLODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ANIMATION_KEY_SLIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ANIMATION_SLIDE_ENTER_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ANIMATION_SLIDE_EXIT_DURATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANIMATION_IMPLODE_DURATION; });
var ANIMATION_KEY_IMPLODE='implode';var ANIMATION_KEY_SLIDE='slide';var ANIMATION_SLIDE_ENTER_DURATION=1000;var ANIMATION_SLIDE_EXIT_DURATION=1000;var ANIMATION_IMPLODE_DURATION=250;

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return RecipeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IconsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Producer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Consumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ProductIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ProductDeviceIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Details; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ControlPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ControlPanelIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ControlPanelToggleButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return OverlayContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_variables__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_icons_device_icon__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_icons__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_style__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(['\n\tfrom { opacity: 0; }\n\tto { opacity: 1; }\n'],['\n\tfrom { opacity: 0; }\n\tto { opacity: 1; }\n']),_templateObject2=_taggedTemplateLiteral(['flex: 1 0 20em;'],['flex: 1 0 20em;']),_templateObject3=_taggedTemplateLiteral(['\n    border-radius: ','em;\n    margin: ','em;\n    position: relative;\n    transition: box-shadow 0.3s;\n\n    ',' ',' &:hover {\n        box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);\n    }\n'],['\n    border-radius: ','em;\n    margin: ','em;\n    position: relative;\n    transition: box-shadow 0.3s;\n\n    ',' ',' &:hover {\n        box-shadow: 0 0 20px rgba(0, 0, 0, 0.4);\n    }\n']),_templateObject4=_taggedTemplateLiteral(['margin: ','em;'],['margin: ','em;']),_templateObject5=_taggedTemplateLiteral(['\n    display: flex;\n    height: ','em;\n'],['\n    display: flex;\n    height: ','em;\n']),_templateObject6=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    border-top-left-radius: ','em;\n    color: ',';\n    display: flex;\n    flex-basis: calc(50% - ','px); /* This is for IE11*/\n    flex: 0 0 calc(50% - ','px);\n    justify-content: center;\n'],['\n    align-items: center;\n    background-color: ',';\n    border-top-left-radius: ','em;\n    color: ',';\n    display: flex;\n    flex-basis: calc(50% - ','px); /* This is for IE11*/\n    flex: 0 0 calc(50% - ','px);\n    justify-content: center;\n']),_templateObject7=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    border-top-right-radius: ','em;\n    border-bottom: solid ','em transparent;\n    border-left: solid ','px ',';\n    border-top: solid ','em transparent;\n    color: ',';\n    display: flex;\n    flex-basis: calc(50% + ','px); /* This is for IE11*/\n    flex: 0 0 calc(50% + ','px);\n    justify-content: center;\n'],['\n    align-items: center;\n    background-color: ',';\n    border-top-right-radius: ','em;\n    border-bottom: solid ','em transparent;\n    border-left: solid ','px ',';\n    border-top: solid ','em transparent;\n    color: ',';\n    display: flex;\n    flex-basis: calc(50% + ','px); /* This is for IE11*/\n    flex: 0 0 calc(50% + ','px);\n    justify-content: center;\n']),_templateObject8=_taggedTemplateLiteral(['font-size: ','em;'],['font-size: ','em;']),_templateObject9=_taggedTemplateLiteral(['\n    border: solid 1px ',';\n    border-top: none;\n    border-bottom-left-radius: ','em;\n    border-bottom-right-radius: ','em;\n    padding: ','em;\n'],['\n    border: solid 1px ',';\n    border-top: none;\n    border-bottom-left-radius: ','em;\n    border-bottom-right-radius: ','em;\n    padding: ','em;\n']),_templateObject10=_taggedTemplateLiteral(['\n    height: ','em;\n    line-height: 1.5em;\n'],['\n    height: ','em;\n    line-height: 1.5em;\n']),_templateObject11=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    height: ','em;\n    justify-content: space-between;\n'],['\n    align-items: center;\n    display: flex;\n    height: ','em;\n    justify-content: space-between;\n']),_templateObject12=_taggedTemplateLiteral(['\n    cursor: pointer;\n    font-size: ','em;\n    opacity: ',';\n'],['\n    cursor: pointer;\n    font-size: ','em;\n    opacity: ',';\n']),_templateObject13=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    border-radius: ',';\n    display: flex;\n    height: ',';\n    justify-content: center;\n    left: ',';\n    position: absolute;\n    top: ',';\n    transition: 0.3s ',';\n    width: ',';\n'],['\n    align-items: center;\n    background-color: ',';\n    border-radius: ',';\n    display: flex;\n    height: ',';\n    justify-content: center;\n    left: ',';\n    position: absolute;\n    top: ',';\n    transition: 0.3s ',';\n    width: ',';\n']),_templateObject14=_taggedTemplateLiteral(['\n    animation: ',' 0.1s ',' forwards;\n    animation-delay: 0.3s;\n    background-color: white;\n    border-radius: ','em;\n    max-width: 80%;\n    opacity: 0;\n    overflow: hidden;\n    padding: 0.8em 1em;\n    width: auto;\n\n    & > div > button {\n        font-size: 0.8em;\n        margin: 1em 0.4em 0 0;\n        padding: 0.4em 1.2em;\n    }\n'],['\n    animation: ',' 0.1s ',' forwards;\n    animation-delay: 0.3s;\n    background-color: white;\n    border-radius: ','em;\n    max-width: 80%;\n    opacity: 0;\n    overflow: hidden;\n    padding: 0.8em 1em;\n    width: auto;\n\n    & > div > button {\n        font-size: 0.8em;\n        margin: 1em 0.4em 0 0;\n        padding: 0.4em 1.2em;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var iconSizeFactor=0.5;var controlPanelIconSize=2.2;var arrowWidth=10;var animOpacity=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var bezier='cubic-bezier(0.23, 1, 0.32, 1)';var RecipeItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2);var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_0__style_variables__["a" /* borderRadius */],__WEBPACK_IMPORTED_MODULE_0__style_variables__["g" /* marginMobile */],__WEBPACK_IMPORTED_MODULE_5__core_utils_style__["b" /* media */].tablet(_templateObject4,__WEBPACK_IMPORTED_MODULE_0__style_variables__["h" /* marginTablet */]),__WEBPACK_IMPORTED_MODULE_5__core_utils_style__["b" /* media */].desktop(_templateObject4,__WEBPACK_IMPORTED_MODULE_0__style_variables__["f" /* marginDesktop */]));var IconsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_0__style_variables__["e" /* iconsContainerHeight */]);var Producer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject6,function(p){return p.isEnabled?p.theme.mainBrandColor:p.theme.heavyGrey;},__WEBPACK_IMPORTED_MODULE_0__style_variables__["a" /* borderRadius */],function(p){return p.theme.white;},arrowWidth/2,arrowWidth/2);var Consumer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject7,function(p){return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["c" /* lighten */])(0.1,p.isEnabled?p.theme.mainBrandColor:p.theme.heavyGrey);},__WEBPACK_IMPORTED_MODULE_0__style_variables__["a" /* borderRadius */],__WEBPACK_IMPORTED_MODULE_0__style_variables__["e" /* iconsContainerHeight */]/2,arrowWidth,function(p){return p.isEnabled?p.theme.mainBrandColor:p.theme.heavyGrey;},__WEBPACK_IMPORTED_MODULE_0__style_variables__["e" /* iconsContainerHeight */]/2,function(p){return p.theme.white;},arrowWidth/2,arrowWidth/2);var ProductIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__core_icons__["a" /* default */])(_templateObject8,__WEBPACK_IMPORTED_MODULE_0__style_variables__["e" /* iconsContainerHeight */]*iconSizeFactor);var ProductDeviceIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3__core_icons_device_icon__["a" /* default */])(_templateObject8,__WEBPACK_IMPORTED_MODULE_0__style_variables__["e" /* iconsContainerHeight */]*iconSizeFactor);var Details=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject9,function(p){return p.isEnabled?p.theme.mainBrandColor:p.theme.heavyGrey;},__WEBPACK_IMPORTED_MODULE_0__style_variables__["a" /* borderRadius */],__WEBPACK_IMPORTED_MODULE_0__style_variables__["a" /* borderRadius */],__WEBPACK_IMPORTED_MODULE_0__style_variables__["c" /* detailsPadding */]);var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_0__style_variables__["j" /* textContainerHeight */]);var ControlPanel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject11,__WEBPACK_IMPORTED_MODULE_0__style_variables__["b" /* controlPanelHeight */]);var ControlPanelIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__core_icons__["a" /* default */])(_templateObject12,controlPanelIconSize,function(p){return p.isDisabled?0.2:1;});var ControlPanelToggleButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject8,controlPanelIconSize/3);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject13,function(p){return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["f" /* transparentize */])(0.2,p.theme.secondaryColor);},function(p){return p.show?__WEBPACK_IMPORTED_MODULE_0__style_variables__["a" /* borderRadius */]+'em':'50%';},function(p){return p.show?'100%':0;},function(p){return p.show?0:'50%';},function(p){return p.show?0:'50%';},bezier,function(p){return p.show?'100%':0;});var OverlayContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject14,animOpacity,bezier,__WEBPACK_IMPORTED_MODULE_0__style_variables__["a" /* borderRadius */]);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_recipes_selectors__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2367);
var mapStateToProps=function mapStateToProps(state,_ref){var consumerId=_ref.consumerId,producerId=_ref.producerId;return{consumerId:consumerId,currentPage:Object(__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_selectors__["d" /* getModalVisiblePage */])(state)||0,currentRecipe:Object(__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_selectors__["a" /* getCurrentRecipe */])(state),producerId:producerId,templates:Object(__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_selectors__["f" /* getTemplatesList */])(state,{consumerId:consumerId,producerId:producerId})};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tone-picker-white.dec9ff192fc5a12dcdc0d462f760793065104b05c865c41ef7d8cf801ea84e19.png";

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return radFromCoords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return coordsFromRadians; });
// @noflow
var radFromCoords=function radFromCoords(x,y,width,height){var center={x:width/2,y:height/2};var deltaX=x-center.x;var deltaY=y-center.y;var result=Math.atan2(deltaY,deltaX);return result<0?Math.abs(result):Math.PI*2-result;};var coordsFromRadians=function coordsFromRadians(radians,radius,width,height){var center={x:width/2,y:height/2};return{x:center.x+radius*Math.cos(-radians),y:center.y+radius*Math.sin(-radians)};};

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({off:{id:'picker.rgb-flipper-off',defaultMessage:'Off'},on:{id:'picker.rgb-flipper-on',defaultMessage:'On {brightness}%'},coolest:{id:'picker.white-mode-coolest',defaultMessage:'coolest white'},cool:{id:'picker.white-mode-cool',defaultMessage:'cool white'},mid:{id:'picker.white-mode-mid',defaultMessage:'mid white'},warm:{id:'picker.white-mode-warm',defaultMessage:'warm white'},warmest:{id:'picker.white-mode-warmest',defaultMessage:'warmest white'}}));

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(2412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(87);
var calculateFactors=function calculateFactors(items){var totalAngle=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Math.PI*1.5;return(/*270°*/items.map(function(_ref,index){var r=_ref.r,value=_ref.value;var angle=index*totalAngle/(items.length-1);return{r:r,rScale:(index+1)/items.length,value:value,xFactor:-Math.cos(angle),yFactor:-Math.sin(angle)};}));};var calculateFactorsImmutable=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"],calculateFactors);var mapStateToProps=function mapStateToProps(state,_ref2){var items=_ref2.items,match=_ref2.match;var id=match.params.id;return{items:calculateFactorsImmutable(items),isGroup:Object(__WEBPACK_IMPORTED_MODULE_4__core_state_products_selectors__["m" /* getIsGroupForProduct */])(state,{id:id})};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */])));

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__ = __webpack_require__(14);
var BLUE={r:69,g:180,b:255};var GREEN={r:66,g:168,b:118};var CELSIUS_MID_TEMP=26;var FAHRENHEIT_MID_TEMP=78;var mapStateToProps=function mapStateToProps(state,_ref){var isSingleBGColorOnly=_ref.isSingleBGColorOnly,mode=_ref.mode,minCool=_ref.minCool,maxCool=_ref.maxCool,disabled=_ref.disabled;var metric=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'products:cooling:metric');var maxTemp=maxCool||Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'products:cooling:maxTemp');var minTemp=minCool||Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'products:cooling:minTemp');var midTemp={C:CELSIUS_MID_TEMP,F:FAHRENHEIT_MID_TEMP};var aboveColor=isSingleBGColorOnly?null:GREEN;var belowColor=isSingleBGColorOnly?null:BLUE;return{aboveColor:aboveColor,bgColor:BLUE,belowColor:belowColor,interval:Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'products:cooling:interval'),maxTemp:maxTemp,metric:metric,midTemp:midTemp,minTemp:minTemp,mode:mode,disabled:disabled};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* default */]));

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_temperature__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__spinner_spinner_component__ = __webpack_require__(252);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DualSpinnerBase=function(_React$Component){_inherits(DualSpinnerBase,_React$Component);function DualSpinnerBase(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DualSpinnerBase);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DualSpinnerBase.__proto__||Object.getPrototypeOf(DualSpinnerBase)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(index){var _this$props=_this.props,handleChangeTemp=_this$props.handleChangeTemp,interval=_this$props.interval,maxTemp=_this$props.maxTemp,metric=_this$props.metric,mode=_this$props.mode;if(handleChangeTemp){var maxTempConverted=metric==='C'?maxTemp:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_temperature__["b" /* toFarenheit */])(maxTemp);var temp=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* getTempFromIndex */])({maxTemp:maxTempConverted,interval:interval,index:index});var platformTemp=metric==='C'?temp:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_temperature__["a" /* toCelsius */])(temp);handleChangeTemp(platformTemp,mode);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DualSpinnerBase,[{key:'render',value:function render(){var _props=this.props,aboveColor=_props.aboveColor,bgColor=_props.bgColor,belowColor=_props.belowColor,currentTemp=_props.currentTemp,disabled=_props.disabled,interval=_props.interval,isBoosting=_props.isBoosting,isUpdating=_props.isUpdating,maxTemp=_props.maxTemp,menuAbove=_props.menuAbove,metric=_props.metric,midTemp=_props.midTemp,minTemp=_props.minTemp,mode=_props.mode;var minTempConverted=metric==='C'?minTemp:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_temperature__["b" /* toFarenheit */])(minTemp);var maxTempConverted=metric==='C'?maxTemp:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_temperature__["b" /* toFarenheit */])(maxTemp);var midTempConverted=null;var midTempActual=null;if(typeof midTemp==='number'){midTempConverted=metric==='C'?midTemp:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_temperature__["b" /* toFarenheit */])(midTemp);}else{midTempActual=midTemp[metric];}var valuesRange=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* defineRangeValues */])({interval:interval,maxTemp:maxTempConverted,minTemp:minTempConverted});var colorsRange=aboveColor&&belowColor?Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* defineRangeColours */])({aboveColor:aboveColor,belowColor:belowColor,interval:interval,maxTemp:maxTempConverted,midTemp:midTempConverted||midTempActual,minTemp:minTempConverted}):null;var localeTemperature=metric==='C'?currentTemp:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_temperature__["b" /* toFarenheit */])(currentTemp);var currentIndex=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* getIndexFromTemp */])({interval:interval,maxTemp:maxTempConverted,minTemp:minTempConverted,temp:localeTemperature});return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* Wrapper */],{menuAbove:menuAbove},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* SpinnerContainerContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* SpinnerContainer */],null,isBoosting&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["j" /* BoostRings */],{alternative:true,mode:mode}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["k" /* BounceEffect */],{isWaiting:isUpdating,usePadding:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__spinner_spinner_component__["a" /* default */],{bgColor:bgColor,currentIndex:currentIndex,disabled:disabled,font:__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* DEFAULT_FONT */],handleChangeIndex:this.handleChange,purpose:'Spinner',rangeColors:colorsRange,rangeValues:valuesRange,style:{borderRadius:'100%',position:'absolute',top:0,left:0,height:'100%',width:'100%',outline:'none'}})))));}}]);return DualSpinnerBase;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DualSpinnerBase);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__ = __webpack_require__(14);
var YELLOW={r:246,g:199,b:42};var ORANGE={r:231,g:97,b:54};var CELSIUS_MID_TEMP=20.5;var mapStateToProps=function mapStateToProps(state,_ref){var isDualSpinner=_ref.isDualSpinner,isSingleBGColorOnly=_ref.isSingleBGColorOnly,mode=_ref.mode,isBoosting=_ref.isBoosting,maxHeat=_ref.maxHeat,minHeat=_ref.minHeat,comfortZone=_ref.comfortZone,disabled=_ref.disabled;var heatingMaxTempPath='products:heating:'+(isDualSpinner?'maxTempDual':'maxTemp');var metric=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'products:heating:metric');var maxTemp=maxHeat&&maxHeat-(isDualSpinner?comfortZone:0)||Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,heatingMaxTempPath);var minTemp=minHeat||Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'products:heating:minTemp');var midTemp=CELSIUS_MID_TEMP;var aboveColor=isSingleBGColorOnly?null:ORANGE;var belowColor=isSingleBGColorOnly?null:YELLOW;var interval=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'products:heating:interval');return{aboveColor:aboveColor,bgColor:ORANGE,belowColor:belowColor,interval:interval,maxTemp:maxTemp,metric:metric,midTemp:midTemp,minTemp:minTemp,mode:mode,isBoosting:isBoosting,disabled:disabled};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* default */]));

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_setup__ = __webpack_require__(2559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__user_setup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracker__ = __webpack_require__(2560);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__tracker__["a"]; });
/**
 * Universal Analytics (aka google analytics)
 *
 * Collection of hastily put together components to provide *almost* drop in
 * basic analytics
 */

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({error:{id:'devices.error',defaultMessage:'There was an error retrieving your devices'},nameChanged:{id:'device.name-changed',defaultMessage:'Device name changed successfully'},nameChangeError:{id:'device.name-change-error',defaultMessage:'Device name could not be changed'},deviceRemoved:{id:'device.removed',defaultMessage:'Device successfully removed'},deviceRemoveError:{id:'device.remove-error',defaultMessage:'Device could not be removed. Please try again'},groupRemoved:{id:'devices.group.removed',defaultMessage:'Group successfully removed'},groupRemoveError:{id:'devices.group.remove-error',defaultMessage:'Group could not be removed. Please try again'},hubOfflineError:{id:'devices.hub-offline-error',defaultMessage:'Sorry, your hub is not talking to us, it\'s appearing offline - check its connection. <a target="_blank" href="https://www.hivehome.com/in-app/hubs-not-talking">Need help?</a>'},thermostatOfflineError:{id:'devices.thermostatOfflineError',defaultMessage:'Sorry, your thermostat is not talking to us - check its connection. <a target="_blank" href="https://www.hivehome.com/thermostats-not-talking">Need help?</a>'},needHelp:{id:'devices.needHelp',defaultMessage:'Need help?'}}));

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.4ce0c5119dfe3d16a9ee00f5d8e3bf92ad44134da0cf00ad02726d000015968c.svg";

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acquireDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closePlacementAdvice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return finishInstallDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return finishedInstallDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadInstallDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return startAcquireDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stopAcquireDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return unloadInstallDevices; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var acquireDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACQUIRE_DEVICES */]);var closePlacementAdvice=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CLOSE_PLACEMENT_ADVICE */]);var finishInstallDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FINISH_INSTALL_DEVICES */]);var finishedInstallDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* FINISHED_INSTALL_DEVICES */]);var loadInstallDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* LOAD_INSTALL_DEVICES */]);var startAcquireDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* START_ACQUIRE_DEVICES */],function(){return new Date();});var stopAcquireDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STOP_ACQUIRE_DEVICES */]);var unloadInstallDevices=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* UNLOAD_INSTALL_DEVICES */]);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buttons__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(2495);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SideModal=function(_React$Component){_inherits(SideModal,_React$Component);function SideModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SideModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SideModal.__proto__||Object.getPrototypeOf(SideModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:_this.props.isOpen,hiding:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SideModal,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){var _this2=this;var isOpen=this.props.isOpen;if(isOpen&&!nextProps.isOpen){this.setState({hiding:true});setTimeout(function(){return _this2.setState({isOpen:false,hiding:false});},300);}else if(!isOpen&&nextProps.isOpen){this.setState({isOpen:true});}}},{key:'render',value:function render(){var _props=this.props,asyncButton=_props.asyncButton,closeButtonMessage=_props.closeButtonMessage,closeButtonPrimary=_props.closeButtonPrimary,children=_props.children,onRequestClose=_props.onRequestClose,title=_props.title,showButtons=_props.showButtons,navigationIcon=_props.navigationIcon;var _state=this.state,hiding=_state.hiding,isOpen=_state.isOpen;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* Main */],{contentLabel:'',hiding:hiding,isOpen:isOpen,onRequestClose:onRequestClose,shouldCloseOnOverlayClick:false,style:{overlay:hiding?__WEBPACK_IMPORTED_MODULE_2__styles__["k" /* overlayStyleHidding */]:__WEBPACK_IMPORTED_MODULE_2__styles__["j" /* overlayStyle */]}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],title,function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["i" /* TitleContainer */],null,navigationIcon&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* ArrowContainer */],{onClick:onRequestClose},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Arrow */],{onClick:onRequestClose,type:navigationIcon})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["h" /* Title */],{navigationIcon:navigationIcon},message));}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* Content */],{showButtons:showButtons},children),showButtons?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* ButtonsContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* Buttons */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],closeButtonMessage,function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* ModalButton */],{alternate:!closeButtonPrimary,onClick:onRequestClose},message);}),asyncButton&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__buttons__["a" /* AsyncButton */],asyncButton))):null);}}]);return SideModal;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SideModal.defaultProps={closeButtonMessage:__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].cancel,closeButtonPrimary:false,showButtons:true};/* harmony default export */ __webpack_exports__["a"] = (SideModal);

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('pick', __webpack_require__(2557));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('split', __webpack_require__(1533));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return iconForDevice; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isProductActive;
/* harmony export (immutable) */ __webpack_exports__["a"] = getHeatingTarget;
/* unused harmony export getHotwaterStatus */
/* harmony export (immutable) */ __webpack_exports__["f"] = makeProductLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNAIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isSensorLeaking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_icons_device__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_icons_devices_svg__ = __webpack_require__(177);
var _deviceModelToIcon,_true2,_false2,_true3,_false4,_true9,_false11,_deviceIconActiveMap,_customUrlFormatters;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var EU='EU';var NA='NA';var UK='UK';var HEATING_OFF_TARGET=1;var DUAL='dual';var HEAT='heat';var COOL='cool';var capabilityTypes=[DUAL,HEAT,COOL];var MODE_OFF='OFF';var MODE_AUTO='AUTO';var MODE_HEAT='HEAT';var MODE_COOL='COOL';// Icons where models with the same device type have different icons
var deviceModelToIcon=(_deviceModelToIcon={},_defineProperty(_deviceModelToIcon,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].NANO1,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["OLD_HUB"]),_defineProperty(_deviceModelToIcon,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].NANO2,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["NEW_HUB"]),_defineProperty(_deviceModelToIcon,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].SLR1,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["RECEIVER_SINGLE"]),_defineProperty(_deviceModelToIcon,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].SLR2,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["RECEIVER_DUAL"]),_defineProperty(_deviceModelToIcon,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].SLT1,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT1"]),_defineProperty(_deviceModelToIcon,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].SLT2,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT2"]),_defineProperty(_deviceModelToIcon,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].SLT3,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT3"]),_defineProperty(_deviceModelToIcon,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].SLT3b,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT3"]),_defineProperty(_deviceModelToIcon,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModels"].SLT4,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT3"]),_deviceModelToIcon);var lightIconsMap={true:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["LIGHT_ON"]),false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["LIGHT_OFF"])};var deviceIconActiveMap=(_deviceIconActiveMap={},_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].ACTIVE_PLUG,{true:(_true2={},_defineProperty(_true2,EU,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_OFF_EU"]),_defineProperty(_true2,NA,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_OFF_NA"]),_defineProperty(_true2,UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_ON"]),_true2),false:(_false2={},_defineProperty(_false2,EU,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_OFF_EU"]),_defineProperty(_false2,NA,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_OFF_NA"]),_defineProperty(_false2,UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_OFF"]),_false2)}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].BOILER_MODULE,{false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["RECEIVER_DUAL"])}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].NA_THERMOSTAT,{true:(_true3={},_defineProperty(_true3,UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT3"]),_defineProperty(_true3,NA,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT3"]),_true3),false:(_false4={},_defineProperty(_false4,UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT3"]),_defineProperty(_false4,NA,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT3"]),_false4)}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,lightIconsMap),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_LIGHT,lightIconsMap),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].CONTACT_SENSOR,{true:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["CONTACT_SENSOR_OPEN"]),false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["CONTACT_SENSOR_CLOSED"])}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HEATING,{true:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["HEATING_ON"]),false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["HEATING_OFF"])}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HOT_WATER,{true:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["HOT_WATER_ON"]),false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["HOT_WATER_OFF"])}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HUB,{false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["NEW_HUB"])}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].MOTION_SENSOR,{true:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["MOTION_SENSOR_ON"]),false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["MOTION_SENSOR_OFF"])}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].SIGNAL_BOOSTER,{true:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SIGNAL_BOOSTER_ON"]),false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SIGNAL_BOOSTER_OFF"])}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].SMART_PLUG,{true:(_true9={},_defineProperty(_true9,EU,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_ON_EU"]),_defineProperty(_true9,NA,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_ON_NA"]),_defineProperty(_true9,UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_ON"]),_true9),false:(_false11={},_defineProperty(_false11,EU,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_OFF_EU"]),_defineProperty(_false11,NA,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_OFF_NA"]),_defineProperty(_false11,UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["SMART_PLUG_OFF"]),_false11)}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].THERMOSTAT_UI,{true:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT3"]),false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["STAT3"])}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].TUNEABLE_LIGHT,lightIconsMap),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].WARM_WHITE_LIGHT,lightIconsMap),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].LEAK_SENSOR,{true:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["LEAK_SENSOR_ON"]),false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["LEAK_SENSOR_OFF"])}),_defineProperty(_deviceIconActiveMap,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HIVE_BUTTON,{true:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["BUTTON_ON"]),false:_defineProperty({},UK,__WEBPACK_IMPORTED_MODULE_0__constants_icons_device__["BUTTON_OFF"])}),_deviceIconActiveMap);var iconForDevice=function iconForDevice(_ref){var type=_ref.type,model=_ref.model,_ref$active=_ref.active,active=_ref$active===undefined?false:_ref$active,_ref$localeSuffix=_ref.localeSuffix,localeSuffix=_ref$localeSuffix===undefined?UK:_ref$localeSuffix;return deviceModelToIcon[model]||(deviceIconActiveMap[type]?deviceIconActiveMap[type][active][localeSuffix]||deviceIconActiveMap[type][active][UK]:undefined);};var getIsDualModeActive=function getIsDualModeActive(product){var _truthMap;var currentMode=product.getIn(['state','controlMode'],'OFF');var currentHeat=product.getIn(['state','heat'],0);var currentCool=product.getIn(['state','cool'],0);var currentTemperature=product.getIn(['props','temperature'],0);var truthMap=(_truthMap={},_defineProperty(_truthMap,currentMode===MODE_AUTO,currentCool<currentTemperature||currentHeat>currentTemperature),_defineProperty(_truthMap,currentMode===MODE_HEAT,currentHeat>currentTemperature),_defineProperty(_truthMap,currentMode===MODE_COOL,currentCool<currentTemperature),_truthMap);return truthMap[true];};function isProductActive(product,state){if(!product.getIn(['props','online'])||product.getIn(['props','error'])){return false;}var type=product.get('type');if(type===__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].LEAK_SENSOR){return product.getIn(['props','status'])==='ON';}if(type===__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].CONTACT_SENSOR){return product.getIn(['props','status'])==='OPEN';}if(type===__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HEATING){var componentId=Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["c" /* createComponentId */])(__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HEATING,product.get('id'));var currentSchedule=Object(__WEBPACK_IMPORTED_MODULE_3__state_ui_schedule_selectors__["c" /* getCurrentScheduleEvent */])(state,{componentId:componentId,saved:true});var inside=product.getIn(['props','temperature']);var target=getHeatingTarget(product,currentSchedule);return target>inside;}if(type===__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HOT_WATER){var _componentId=Object(__WEBPACK_IMPORTED_MODULE_2__schedule__["c" /* createComponentId */])(__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].HOT_WATER,product.get('id'));var _currentSchedule=Object(__WEBPACK_IMPORTED_MODULE_3__state_ui_schedule_selectors__["c" /* getCurrentScheduleEvent */])(state,{componentId:_componentId,saved:true});return getHotwaterStatus(product,_currentSchedule)==='ON';}if(type===__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].NA_THERMOSTAT){var _truthMap2;if(!product.getIn(['state','status'],false)){return false;}var statType=product.getIn(['props','capabilities']).find(function(c){return capabilityTypes.includes(c);});var currentHeat=product.getIn(['state','heat'],0);var currentCool=product.getIn(['state','cool'],0);var currentTemperature=product.getIn(['props','temperature'],0);var truthMap=(_truthMap2={},_defineProperty(_truthMap2,statType===COOL,currentCool<currentTemperature),_defineProperty(_truthMap2,statType===HEAT,currentHeat>currentTemperature),_defineProperty(_truthMap2,statType===DUAL,getIsDualModeActive(product)),_truthMap2);return truthMap[true];}if(__WEBPACK_IMPORTED_MODULE_1__constants_devices__["bulbTypes"].includes(type)){return product.getIn(['state','status'])==='ON';}if(type===__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].MOTION_SENSOR){return product.getIn(['props','motion','status']);}if(__WEBPACK_IMPORTED_MODULE_1__constants_devices__["plugTypes"].includes(type)){return product.getIn(['state','status'])==='ON';}return false;}function getHeatingTarget(product,currentSchedule){var mode=product.getIn(['state','mode']);var frostProtection=product.getIn(['state','frostProtection'],7);var scheduleOverride=product.getIn(['props','scheduleOverride']);var scheduleTarget=currentSchedule.getIn(['value','target']);var target=product.getIn(['state','target']);var calculatedTarget=mode==='SCHEDULE'&&!scheduleOverride?scheduleTarget:mode===__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceModes"].OFF?frostProtection:target;return calculatedTarget===HEATING_OFF_TARGET?frostProtection:calculatedTarget;}function getHotwaterStatus(product,currentSchedule){var mode=product.getIn(['state','mode']);if(mode==='SCHEDULE'){return currentSchedule.getIn(['value','status'],'OFF');}else{return mode!=='OFF'?'ON':'OFF';}}var bulbToUrl=function bulbToUrl(p){return'/products/bulb/'+p.get('id');};// Sometimes we want urls that don't match 1-1 with the product type
// Examples include our 3 bulbs, and thermostats where
// we want /bulb/ and /thermostat/ respectively.
var customUrlFormatters=(_customUrlFormatters={},_defineProperty(_customUrlFormatters,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,bulbToUrl),_defineProperty(_customUrlFormatters,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].COLOR_LIGHT,bulbToUrl),_defineProperty(_customUrlFormatters,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].TUNEABLE_LIGHT,bulbToUrl),_defineProperty(_customUrlFormatters,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].WARM_WHITE_LIGHT,bulbToUrl),_defineProperty(_customUrlFormatters,__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].NA_THERMOSTAT,function(p){return'/products/thermostat/'+p.get('id');}),_defineProperty(_customUrlFormatters,'default',function _default(p){return'/products/'+p.get('type')+'/'+p.get('id');}),_customUrlFormatters);function makeProductLink(product){var type=product&&product.get('type');var formatter=customUrlFormatters[type]||customUrlFormatters.default;return formatter(product);}var getDualModeIcons=function getDualModeIcons(product){var _truthMap3;var currentMode=product.getIn(['state','controlMode'],'OFF');var truthMap=(_truthMap3={},_defineProperty(_truthMap3,currentMode===MODE_OFF,[]),_defineProperty(_truthMap3,currentMode===MODE_AUTO,[__WEBPACK_IMPORTED_MODULE_4__constants_icons_devices_svg__["a" /* default */].COOLING,__WEBPACK_IMPORTED_MODULE_4__constants_icons_devices_svg__["a" /* default */].HEATING]),_defineProperty(_truthMap3,currentMode===MODE_HEAT,[__WEBPACK_IMPORTED_MODULE_4__constants_icons_devices_svg__["a" /* default */].HEATING]),_defineProperty(_truthMap3,currentMode===MODE_COOL,[__WEBPACK_IMPORTED_MODULE_4__constants_icons_devices_svg__["a" /* default */].COOLING]),_truthMap3);return truthMap[true];};var getNAIcons=function getNAIcons(product){var _truthMap4;if(!product.getIn(['state','status'],false)){return[];}var statType=product.getIn(['props','capabilities']).find(function(c){return capabilityTypes.includes(c);});var truthMap=(_truthMap4={},_defineProperty(_truthMap4,statType===DUAL,getDualModeIcons(product)),_defineProperty(_truthMap4,statType===HEAT,[__WEBPACK_IMPORTED_MODULE_4__constants_icons_devices_svg__["a" /* default */].HEATING]),_defineProperty(_truthMap4,statType===COOL,[__WEBPACK_IMPORTED_MODULE_4__constants_icons_devices_svg__["a" /* default */].COOLING]),_truthMap4);return truthMap[true];};var isSensorLeaking=function isSensorLeaking(product){return['LOW','HIGH'].includes(product.getIn(['props','leaking']));};

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLOSED */
/* unused harmony export DOG_BARK */
/* unused harmony export FLOW_DETECTED */
/* unused harmony export GLASS_BREAK */
/* unused harmony export LEAK_DETECTED */
/* unused harmony export LEAK_FIXED */
/* unused harmony export MOTION */
/* unused harmony export MUTE */
/* unused harmony export OPENED */
/* unused harmony export SMOKE_CO */
/* unused harmony export SOMETHING_ELSE */
/* unused harmony export SOUND */
/* unused harmony export UNMUTE */
/* unused harmony export USER_INTENDED_USAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sensorLogTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return senseSensorTypes; });
var CLOSED='Closed';var DOG_BARK='DOG_BARK';var FLOW_DETECTED='FLOW_DETECTED';var GLASS_BREAK='GLASS_BREAK';var LEAK_DETECTED='LEAK_DETECTED';var LEAK_FIXED='LEAK_FIXED';var MOTION='Motion';var MUTE='Mute';var OPENED='Opened';var SMOKE_CO='SMOKE_CO';var SOMETHING_ELSE='SOMETHING_ELSE';var SOUND='Sound';var UNMUTE='Unmute';var USER_INTENDED_USAGE='USER_INTENDED_USAGE';var sensorLogTypes={CLOSED:CLOSED,FLOW_DETECTED:FLOW_DETECTED,LEAK_DETECTED:LEAK_DETECTED,LEAK_FIXED:LEAK_FIXED,MOTION:MOTION,MUTE:MUTE,OPENED:OPENED,SOUND:SOUND,UNMUTE:UNMUTE,USER_INTENDED_USAGE:USER_INTENDED_USAGE};var senseSensorTypes={DOG_BARK:DOG_BARK,GLASS_BREAK:GLASS_BREAK,SMOKE_CO:SMOKE_CO,SOMETHING_ELSE:SOMETHING_ELSE};

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__product_page__ = __webpack_require__(2525);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__product_page__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__standard_layouts_standard_component__ = __webpack_require__(530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__standard_layouts_standard_component__["a"]; });


/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setHeatingTarget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setHeatingTargetUpdateProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setHeatingTargetSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTemperatureHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTemperatureHistorySuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectTemperatureHistoryPeriod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toggleReadyBy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var setHeatingTarget=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SET_TARGET_TEMPERATURE */]);var setHeatingTargetUpdateProduct=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SET_TARGET_TEMPERATURE_UPDATE_PRODUCT */]);var setHeatingTargetSuccess=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_TARGET_TEMPERATURE_SUCCESS */]);var getTemperatureHistory=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* GET_TEMPERATURE_HISTORY */]);var getTemperatureHistorySuccess=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* GET_TEMPERATURE_HISTORY_SUCCESS */]);var selectTemperatureHistoryPeriod=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SELECT_PERIOD */]);var toggleReadyBy=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* TOGGLE_READY_BY */]);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getHubOfflineNotificationsStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return setHubOfflineNotificationsStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setDefaultMuting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setDefaultMutingDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return receivedHubOfflineNotificationsStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return toggleMonitoringAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return toggleMonitoringAllDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return toggleMonitoringSensor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return toggleMonitoringSensorDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeSenseLogsSelectedDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteSenseEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return deleteSenseEventComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return flagSenseMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return flagSenseMediaComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSenseDayEventLogs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return receiveSenseDayEventLogs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return stopSenseDayEventLogsPolling; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(444);
var getHubOfflineNotificationsStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* GET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS */]);var setHubOfflineNotificationsStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* SET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS */]);var setDefaultMuting=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* SET_DEFAULT_MUTING */]);var setDefaultMutingDone=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* SET_DEFAULT_MUTING_DONE */]);var receivedHubOfflineNotificationsStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* RECEIVED_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS */]);var toggleMonitoringAll=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* TOGGLE_MONITORING_ALL */]);var toggleMonitoringAllDone=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* TOGGLE_MONITORING_ALL_DONE */]);var toggleMonitoringSensor=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* TOGGLE_MONITORING_SENSOR */]);var toggleMonitoringSensorDone=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* TOGGLE_MONITORING_SENSOR_DONE */]);var changeSenseLogsSelectedDay=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CHANGE_SENSE_LOGS_SELECTED_DAY */],function(id,selectedDay){return{id:id,selectedDay:selectedDay};});var deleteSenseEvent=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* DELETE_SENSE_EVENT */],function(id,mediaId){return{id:id,mediaId:mediaId};});var deleteSenseEventComplete=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* DELETE_SENSE_EVENT_COMPLETE */],function(id,mediaId,error){return{id:id,mediaId:mediaId,error:error};});var flagSenseMedia=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* FLAG_SENSE_MEDIA */],function(id,mediaId,flag){return{id:id,mediaId:mediaId,flag:flag};});var flagSenseMediaComplete=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* FLAG_SENSE_MEDIA_COMPLETE */],function(id,mediaId,flag,error){return{id:id,mediaId:mediaId,flag:flag,error:error};});var getSenseDayEventLogs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* GET_SENSE_DAY_EVENT_LOGS */],function(id,selectedDay){return{id:id,selectedDay:selectedDay};});var receiveSenseDayEventLogs=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* RECEIVE_SENSE_DAY_EVENT_LOGS */],function(id,selectedDay,eventLogs,error){return{id:id,selectedDay:selectedDay,eventLogs:eventLogs,error:error};});var stopSenseDayEventLogsPolling=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* STOP_SENSE_DAY_EVENT_LOGS_POLLING */]);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_recipes_selectors__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__(2357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_recipes__ = __webpack_require__(133);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var RecipesListContainer=function(_React$Component){_inherits(RecipesListContainer,_React$Component);function RecipesListContainer(){_classCallCheck(this,RecipesListContainer);return _possibleConstructorReturn(this,(RecipesListContainer.__proto__||Object.getPrototypeOf(RecipesListContainer)).apply(this,arguments));}_createClass(RecipesListContainer,[{key:'componentDidMount',value:function componentDidMount(){var getRecipes=this.props.getRecipes;getRecipes();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */],this.props);}}]);return RecipesListContainer;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);RecipesListContainer.propTypes={getRecipes:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired};var mapStateToProps=function mapStateToProps(state,_ref){var consumerId=_ref.consumerId,producerId=_ref.producerId;var currentRecipe=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_selectors__["a" /* getCurrentRecipe */])(state);var readyToSave=!!currentRecipe&&// 1st check if is there any recipe
// then check it is not already being created or updated
![__WEBPACK_IMPORTED_MODULE_6__core_constants_recipes__["c" /* recipeStatus */].CREATING,__WEBPACK_IMPORTED_MODULE_6__core_constants_recipes__["c" /* recipeStatus */].UPDATING].includes(currentRecipe.get('status'))&&currentRecipe.getIn(['data','producer'])!==-1&&(// then if is there a producer selected
currentRecipe.get('isNotification')===true?// if notification then is there at least one notification type selected
currentRecipe.getIn(['data','action','value']).includes(true):currentRecipe.getIn(['data','consumer'])!==-1);// otherwise if is there a consumer selected
return{canAddRecipe:Object(__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_selectors__["f" /* getTemplatesList */])(state,{producerId:producerId,consumerId:consumerId}).size>0,consumerId:consumerId,currentRecipe:currentRecipe,isFirsLoadingDone:Object(__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_selectors__["c" /* getIsFirstLoadingDone */])(state),modalVisiblePage:Object(__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_selectors__["d" /* getModalVisiblePage */])(state),producerId:producerId,readyToSave:readyToSave,recipes:Object(__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_selectors__["e" /* getRecipesList */])(state,{producerId:producerId,consumerId:consumerId})};};var mapDispatchToProps={attemptCreateRecipe:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["a" /* attemptCreateRecipe */],attemptUpdateRecipe:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["c" /* attemptUpdateRecipe */],cancelTemplate:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["e" /* cancelTemplate */],getRecipes:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["h" /* getRecipes */],showTemplateList:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["p" /* showTemplateList */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var attemptCreateRecipe=dispatchProps.attemptCreateRecipe,attemptUpdateRecipe=dispatchProps.attemptUpdateRecipe;var currentRecipe=stateProps.currentRecipe;return Object.assign({},stateProps,dispatchProps,ownProps,{saveRecipe:function saveRecipe(){return currentRecipe.get('status')===__WEBPACK_IMPORTED_MODULE_6__core_constants_recipes__["c" /* recipeStatus */].EDITING?attemptUpdateRecipe(currentRecipe):attemptCreateRecipe({newRecipe:currentRecipe});}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(RecipesListContainer));

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_routing_loader__ = __webpack_require__(2554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__async_loader__ = __webpack_require__(2555);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var AsyncRoute=function AsyncRoute(_ref,_ref2){var store=_ref2.store;var entry=_ref.entry,rest=_objectWithoutProperties(_ref,['entry']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],Object.assign({},rest,{render:function render(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_widgets__["F" /* LoadTransition */],{transitionKey:entry},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__components_routing_loader__["a" /* default */],Object.assign({entry:entry},rest,props,{load:function load(){return Object(__WEBPACK_IMPORTED_MODULE_5__async_loader__["a" /* default */])(entry,store);}})));}}));};AsyncRoute.contextTypes={store:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (AsyncRoute);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAcquireDevices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAcquiredDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return errorsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getInstallInProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPlacementAdvice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
var getAcquireDevices=function getAcquireDevices(state){return state.acquireDevices;};var getAcquiredDevices=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAcquireDevices],function(acquireDevices){return acquireDevices.devices;});var errorsSelector=function errorsSelector(_ref){var acquireDevices=_ref.acquireDevices;return acquireDevices.errors;};var getInstallInProgress=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAcquireDevices],function(acquireDevices){return acquireDevices.installInProgress;});var getPlacementAdvice=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAcquireDevices,function(acquireDevices){return acquireDevices.placementAdvice;});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIsUpgrading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUpgradeStartTime; });
/* unused harmony export getHive2IsUpgrading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHive2UpgradeFinished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHive2UpgradeRouteState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
var getState=function getState(state){return state.hive2Upgrade||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});};var getIsUpgrading=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getState,function(state){return state.get('hive2IsUpgrading');});var getUpgradeStartTime=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getState,function(state){return state.get('hive2UpgradeStartTime');});var getHive2IsUpgrading=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getState,function(state){return state.get('hive2IsUpgrading');});var getHive2UpgradeFinished=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getState,function(state){return state.get('hive2UpgradeFinished');});var getHive2UpgradeRouteState=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getState,function(state){return state.get('hive2UpgradeRouteState');});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initialiseResetPasswordState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialiseForgottenPasswordState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return sendPasswordResetEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return passwordEmailRequestSent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearResetPasswordError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return passwordResetRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var initialiseResetPasswordState=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* RESET_PASSWORD_READY */]);var initialiseForgottenPasswordState=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FORGOTTEN_PASSWORD_READY */]);var sendPasswordResetEmail=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST */]);var passwordEmailRequestSent=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT */]);var resetPassword=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* RESET_PASSWORD */]);var clearResetPasswordError=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CLEAR_RESET_PASSWORD_ERROR */]);var changePassword=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* RESETTING_PASSWORD */],function(newPassword,existingPassword,userId){return{newPassword:newPassword,existingPassword:existingPassword,userId:userId};});var passwordResetRequest=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PASSWORD_RESET_REQUEST */],function(password,token,email){return{password:password,token:token,email:email};});

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFrostProtectionForHeating */
/* unused harmony export getAllHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIsSettingTemperature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedPeriod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIsReadyByEnabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_periods__ = __webpack_require__(351);
var getFrostProtectionForHeating=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_0__selectors__["J" /* getStateForProduct */],function(state){return state.get('frostProtection',7);});var getAllHistory=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_0__selectors__["e" /* getAllProducts */],function(state){return state.history;});var getPeriodFromProps=function getPeriodFromProps(_,_ref){var period=_ref.period;return period;};var getIsSettingTemperature=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_0__selectors__["y" /* getProductItemById */],function(product){return product.get('isSettingTemperature')||false;});var getHistory=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getAllHistory,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */],getPeriodFromProps,function(history,id,period){return history.get(id,Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({})).get(period.constant,Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({}));});var getSelectedPeriod=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getAllHistory,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */],function(history,id){return history.getIn([id,__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* SELECTED_PERIOD */]],__WEBPACK_IMPORTED_MODULE_5__constants_periods__["TODAY"]);});var getIsReadyByEnabled=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_0__selectors__["J" /* getStateForProduct */],function(state){return state&&state.get('optimumStart')||false;});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return analyticsSharingToggled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pinSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetPinError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setPin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return settingPin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return toggleAnalyticsSharingAllowed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(449);
var analyticsSharingToggled=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ANALYTICS_SHARING_TOGGLED */]);var pinSet=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* PIN_SET */]);var resetPinError=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* RESET_PIN_ERROR */]);var setPin=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* SET_PIN */]);var settingPin=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* SETTING_PIN */]);var toggleAnalyticsSharingAllowed=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* TOGGLE_ANALYTICS_SHARING_ALLOWED */]);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Button;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(333);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}/**
 * Represents a wrapper around a `button` component.
 *
 * alternate: whether or not to show a different style
 */function Button(_ref){var alternate=_ref.alternate,children=_ref.children,props=_objectWithoutProperties(_ref,['alternate','children']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* StyledButton */],Object.assign({},props,{alternate:alternate}),children);}

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return saveGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return saveGroupPending; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return saveGroupComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeSaveNewGroupComplete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var saveGroup=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* SAVE_GROUP */]);var saveGroupPending=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* SAVE_GROUP_PENDING */]);var saveGroupComplete=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* SAVE_GROUP_COMPLETE */]);var makeSaveNewGroupComplete=function makeSaveNewGroupComplete(_ref){var name=_ref.name,consumers=_ref.consumers;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SAVE_NEW_GROUP_COMPLETE */],function(_ref2){var nodeId=_ref2.nodeId;return{id:nodeId,name:name,consumers:consumers};});};

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('concat', __webpack_require__(1811));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54),
    now = __webpack_require__(2195),
    toNumber = __webpack_require__(268);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.matchesPattern = exports.isRequiredIf = exports.matchesField = exports.isRequired = exports.isOneOf = exports.isNumeric = exports.isAlphaNumeric = exports.isAlphabetic = exports.hasLengthLessThan = exports.hasLengthGreaterThan = exports.hasLengthBetween = exports.combineValidators = exports.composeValidators = exports.createValidator = undefined;

var _createValidator2 = __webpack_require__(122);

var _createValidator3 = _interopRequireDefault(_createValidator2);

var _composeValidators2 = __webpack_require__(2218);

var _composeValidators3 = _interopRequireDefault(_composeValidators2);

var _combineValidators2 = __webpack_require__(2225);

var _combineValidators3 = _interopRequireDefault(_combineValidators2);

var _hasLengthBetween2 = __webpack_require__(2230);

var _hasLengthBetween3 = _interopRequireDefault(_hasLengthBetween2);

var _hasLengthGreaterThan2 = __webpack_require__(2231);

var _hasLengthGreaterThan3 = _interopRequireDefault(_hasLengthGreaterThan2);

var _hasLengthLessThan2 = __webpack_require__(2232);

var _hasLengthLessThan3 = _interopRequireDefault(_hasLengthLessThan2);

var _isAlphabetic2 = __webpack_require__(2233);

var _isAlphabetic3 = _interopRequireDefault(_isAlphabetic2);

var _isAlphaNumeric2 = __webpack_require__(2234);

var _isAlphaNumeric3 = _interopRequireDefault(_isAlphaNumeric2);

var _isNumeric2 = __webpack_require__(2235);

var _isNumeric3 = _interopRequireDefault(_isNumeric2);

var _isOneOf2 = __webpack_require__(2236);

var _isOneOf3 = _interopRequireDefault(_isOneOf2);

var _isRequired2 = __webpack_require__(2237);

var _isRequired3 = _interopRequireDefault(_isRequired2);

var _matchesField2 = __webpack_require__(2238);

var _matchesField3 = _interopRequireDefault(_matchesField2);

var _isRequiredIf2 = __webpack_require__(2239);

var _isRequiredIf3 = _interopRequireDefault(_isRequiredIf2);

var _matchesPattern2 = __webpack_require__(2240);

var _matchesPattern3 = _interopRequireDefault(_matchesPattern2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createValidator = _createValidator3.default;
exports.composeValidators = _composeValidators3.default;
exports.combineValidators = _combineValidators3.default;
exports.hasLengthBetween = _hasLengthBetween3.default;
exports.hasLengthGreaterThan = _hasLengthGreaterThan3.default;
exports.hasLengthLessThan = _hasLengthLessThan3.default;
exports.isAlphabetic = _isAlphabetic3.default;
exports.isAlphaNumeric = _isAlphaNumeric3.default;
exports.isNumeric = _isNumeric3.default;
exports.isOneOf = _isOneOf3.default;
exports.isRequired = _isRequired3.default;
exports.matchesField = _matchesField3.default;
exports.isRequiredIf = _isRequiredIf3.default;
exports.matchesPattern = _matchesPattern3.default;

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    font-size: \'1.5rem\';\n    font-weight: ',';\n'],['\n    font-size: \'1.5rem\';\n    font-weight: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].h2(_templateObject,function(_ref){var slim=_ref.slim;return slim?400:500;}));

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIVE2_UPGRADE_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIVE2_UPGRADE_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HIVE2_UPGRADE_SET_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIVE2_UPGRADED_FINISHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HIVE2_UPGRADE_RESET; });
var HIVE2_UPGRADE_CANCEL='hive/install/hive2-upgrade/HIVE2_UPGRADE_CANCEL';var HIVE2_UPGRADE_START='hive/install/hive2-upgrade/HIVE2_UPGRADE_START';var HIVE2_UPGRADE_SET_STATE='hive/install/hive2-upgrade/HIVE2_UPGRADE_SET_STATE';var HIVE2_UPGRADED_FINISHED='hive/install/hive2-upgrade/HIVE2_UPGRADED_FINISHED';var HIVE2_UPGRADE_RESET='hive/install/hive2-upgrade/HIVE2_UPGRADE_RESET';

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INSTALL_HUB_FORM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INSTALL_HUB_FORM_FIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPGRADE_NANO1_HUB_FORM_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPGRADE_NANO1_HUB_FORM_FIELD_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_PIN_FORM_NAME; });
var INSTALL_HUB_FORM_NAME='install-hub';var INSTALL_HUB_FORM_FIELD_NAME='codes';var UPGRADE_NANO1_HUB_FORM_NAME='install-nano1-upgrade-claim-hub';var UPGRADE_NANO1_HUB_FORM_FIELD_NAME='codes';var CHANGE_PIN_FORM_NAME='change-pin';

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_MOBILE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_MOBILE_MENU; });
var HIDE_MOBILE_MENU='hive/menu/HIDE_MOBILE_MENU';var TOGGLE_MOBILE_MENU='hive/menu/TOGGLE_MOBILE_MENU';

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAlerts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAlertItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAlertById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
var getAlerts=function getAlerts(state){return state.alerts||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});};var getAlertItems=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAlerts],function(alerts){return alerts.get('alertItems',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([]));});var getAlertById=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAlertItems,function(state,id){return id;}],function(alertItems,id){return alertItems.find(function(alert){return alert.get('id')===id;});});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return upgradeStartTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isUpgrading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return upgradeNewSLT3Finished; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return upgradeRouteState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
var getState=function getState(state){return state.sltSlt3bUpgrade||Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});};var upgradeStartTime=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getState,function(state){return state.get('sltSlt3bUpgradeStartTime');});var isUpgrading=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getState,function(state){return state.get('sltSlt3bUpgradeIsUpgrading');});var upgradeNewSLT3Finished=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getState,function(state){return state.get('sltSlt3bUpgradeFinished');});var upgradeRouteState=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getState,function(state){return state.get('sltSlt3bUpgradeRouteState');});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkServiceOutageStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receiveServiceOutage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showAlertNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hideAlertNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(450);
var checkServiceOutageStatus=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CHECK_SERVICE_OUTAGE_STATUS */],function(serviceUrlBase,userLocale){return{serviceUrlBase:serviceUrlBase,userLocale:userLocale};});var receiveServiceOutage=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* RECEIVE_SERVICE_OUTAGE_STATUS */]);var showAlertNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* SHOW_ALERT_NOTIFICATION */]);var hideAlertNotification=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* HIDE_ALERT_NOTIFICATION */]);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeMotionSensorSelectedDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeMotionSensorZoomLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeEventsCurrentDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadMotionSensorPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return motionSensorPageReady; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return receiveMotionSensorEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return unloadMotionSensorPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var changeMotionSensorSelectedDay=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CHANGE_MOTION_SENSOR_SELECTED_DAY */]);var changeMotionSensorZoomLevel=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_MOTION_SENSOR_ZOOM_LEVEL */]);var changeEventsCurrentDay=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANGE_EVENTS_CURRENT_DAY */]);var loadMotionSensorPage=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* LOAD_MOTION_SENSOR_PAGE */],function(id,now,timezone){return{id:id,now:now,timezone:timezone};});var motionSensorPageReady=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* MOTION_SENSOR_PAGE_READY */]);var receiveMotionSensorEvents=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* RECEIVE_MOTION_SENSOR_EVENTS */],function(day,data,id){return{day:day,data:data,id:id};});var unloadMotionSensorPage=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* UNLOAD_MOTION_SENSOR_PAGE */]);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHasLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSelectedDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSelectedDayAsMoment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getHasDayDataLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSelectedDaysEvents; });
/* unused harmony export getTodaysEvents */
/* unused harmony export getAllEvents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getLastEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getIsActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getZoomLevel; });
/* unused harmony export getEventsCurrentDay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEventsCurrentDayAsMoment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var getState=function getState(state){return state.motionSensor;};var getHasLoaded=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'hasLoaded']);});var getSelectedDay=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'selectedDay']);});var getSelectedDayAsMoment=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getSelectedDay,__WEBPACK_IMPORTED_MODULE_0__hub_selectors__["k" /* getTimezone */]],function(selectedDay,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(selectedDay,timezone);});var getHasDayDataLoaded=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'hasLoadedDayData'],false);});var getEvents=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'events'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]));});var getSelectedDaysEvents=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getSelectedDay,getEvents],function(selectedDay,events){return events?events.get(selectedDay,Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([])):Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]);});var getTodaysEvents=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_0__hub_selectors__["l" /* getTodayAsString */],getEvents],function(today,events){return events.get(today,Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]));});var getAllEvents=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getEvents],function(events){return events?Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(events.reduce(function(all,list){return[].concat(_toConsumableArray(all),_toConsumableArray(list));},[]).sort(function(a,b){return a.start-b.start;})):Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]);});// $FlowFixMe
var getLastEvent=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getAllEvents],function(events){return events.first()||Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({});});var getIsActive=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getLastEvent],function(event){return event.get('inMotion',false);});var getZoomLevel=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'zoomLevel']);});var getEventsCurrentDay=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */],__WEBPACK_IMPORTED_MODULE_0__hub_selectors__["l" /* getTodayAsString */]],function(sensor,id,today){return sensor.getIn([id,'eventsCurrentDay'],today);});var getEventsCurrentDayAsMoment=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getEventsCurrentDay,__WEBPACK_IMPORTED_MODULE_0__hub_selectors__["k" /* getTimezone */]],function(currentDay,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(currentDay,timezone);});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
// @noflow
// Code take from a previous version of react-router that has formatPattern as part of its interface
function escapeRegExp(string){return string.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');}function _compilePattern(pattern){var regexpSource='';var paramNames=[];var tokens=[];var match=void 0,lastIndex=0;var matcher=/:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;// eslint-disable-next-line
while(match=matcher.exec(pattern)){if(match.index!==lastIndex){tokens.push(pattern.slice(lastIndex,match.index));regexpSource+=escapeRegExp(pattern.slice(lastIndex,match.index));}if(match[1]){regexpSource+='([^/]+)';paramNames.push(match[1]);}else if(match[0]==='**'){regexpSource+='(.*)';paramNames.push('splat');}else if(match[0]==='*'){regexpSource+='(.*?)';paramNames.push('splat');}else if(match[0]==='('){regexpSource+='(?:';}else if(match[0]===')'){regexpSource+=')?';}tokens.push(match[0]);lastIndex=matcher.lastIndex;}if(lastIndex!==pattern.length){tokens.push(pattern.slice(lastIndex,pattern.length));regexpSource+=escapeRegExp(pattern.slice(lastIndex,pattern.length));}return{pattern:pattern,regexpSource:regexpSource,paramNames:paramNames,tokens:tokens};}var CompiledPatternsCache=Object.create(null);function compilePattern(pattern){if(!CompiledPatternsCache[pattern]){CompiledPatternsCache[pattern]=_compilePattern(pattern);}return CompiledPatternsCache[pattern];}/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */function formatPattern(pattern,params){params=params||{};var _compilePattern2=compilePattern(pattern),tokens=_compilePattern2.tokens;var parenCount=0,pathname='',splatIndex=0;var parenHistory=[];var token=void 0,paramName=void 0,paramValue=void 0;for(var i=0,len=tokens.length;i<len;++i){token=tokens[i];if(token==='*'||token==='**'){paramValue=Array.isArray(params.splat)?params.splat[splatIndex++]:params.splat;if(paramValue!=null){pathname+=encodeURI(paramValue);}}else if(token==='('){parenHistory[parenCount]='';parenCount+=1;}else if(token===')'){var parenText=parenHistory.pop();parenCount-=1;if(parenCount){parenHistory[parenCount-1]+=parenText;}else{pathname+=parenText;}}else if(token.charAt(0)===':'){paramName=token.substring(1);paramValue=params[paramName];if(paramValue==null){if(parenCount){parenHistory[parenCount-1]='';var curTokenIdx=tokens.indexOf(token);var tokensSubset=tokens.slice(curTokenIdx,tokens.length);var nextParenIdx=-1;for(var _i=0;_i<tokensSubset.length;_i++){if(tokensSubset[_i]===')'){nextParenIdx=_i;break;}}// jump to ending paren
i=curTokenIdx+nextParenIdx-1;}}else if(parenCount){parenHistory[parenCount-1]+=encodeURIComponent(paramValue);}else{pathname+=encodeURIComponent(paramValue);}}else{if(parenCount){parenHistory[parenCount-1]+=token;}else{pathname+=token;}}}return pathname.replace(/\/+/g,'/');}

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/**
 * This is necessary because React Native fails when it finds components that weren't imported from anywhere (like when
 * you use standard HTML/SVG tags). By putting these components in a module, we can easily swap them for the ones from
 * react-native-svg on the native side.
 *//* harmony default export */ __webpack_exports__["a"] = ({Svg:function Svg(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',props);},G:function G(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',props);},Path:function Path(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',props);},Line:function Line(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',props);},Circle:function Circle(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',props);},Ellipse:function Ellipse(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ellipse',props);},LinearGradient:function LinearGradient(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('linearGradient',props);},RadialGradient:function RadialGradient(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('radialGradient',props);},Polygon:function Polygon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',props);},Polyline:function Polyline(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polyline',props);},Rect:function Rect(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',props);},Symbol:function Symbol(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('symbol',props);},Text:function Text(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',props);},Use:function Use(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('use',props);},Defs:function Defs(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('defs',props);},Stop:function Stop(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('stop',props);}});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TextBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SecondaryTextBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__ = __webpack_require__(20);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    padding: 1em 0;\n'],['\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    padding: 1em 0;\n']),_templateObject2=_taggedTemplateLiteral(['\n    background-color: ',';\n    border-radius: 50%;\n    padding: ',';\n'],['\n    background-color: ',';\n    border-radius: 50%;\n    padding: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n    height: 6em;\n    width: 6em;\n    & g {\n        fill: ','\n    }\n'],['\n    height: 6em;\n    width: 6em;\n    & g {\n        fill: ','\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    text-align: center;\n    line-height: 1.4;\n    margin-top: 0;\n    white-space: pre;\n    & span {\n        display: block;\n    }\n'],['\n    text-align: center;\n    line-height: 1.4;\n    margin-top: 0;\n    white-space: pre;\n    & span {\n        display: block;\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    color: ',';\n    font-size: 0.9em;\n'],['\n    color: ',';\n    font-size: 0.9em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var IconContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(_ref){var isModal=_ref.isModal,theme=_ref.theme;return isModal?theme.lightGrey:'transparent';},function(props){return props.isModal?'3em':0;});var ActionIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */]).attrs({type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].ACTIONS})(_templateObject3,function(props){return props.theme.mainBrandColor;});var TextBody=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].p(_templateObject4);var SecondaryTextBody=TextBody.extend(_templateObject5,function(props){return props.theme.heavyGrey;});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "accountStatuses", function() { return accountStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loginStatuses", function() { return loginStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "messages", function() { return messages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEED_HELP_HREF", function() { return NEED_HELP_HREF; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
var accountStatuses={MISSING_HUB:'MISSING_HUB',PMZ_FIRMWARE:'PMZ_FIRMWARE'};var loginStatuses={ACCOUNT_LOCKED:'ACCOUNT_LOCKED',NOT_AUTHORIZED:'NOT_AUTHORIZED',OK:'OK'};var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({missingUsernamePassword:{id:'application.missing-username-password',defaultMessage:'We need your username and password to continue. {needHelp}'},needHelp:{id:'application.need-help',defaultMessage:'Need help?'}});var NEED_HELP_HREF='https://www.hivehome.com/cant-find-details';

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return audioDataReceived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAudioData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var audioDataReceived=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AUDIO_DATA_RECEIVED */]);var clearData=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CLEAR_DATA */]);var getAudioData=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* GET_AUDIO_DATA */]);

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('curryN', __webpack_require__(382));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changeSelectedDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return changeZoomLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeEventsCurrentDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pageReady; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return receiveEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return unloadPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var changeSelectedDay=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CHANGE_SELECTED_DAY */]);var changeZoomLevel=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_ZOOM_LEVEL */]);var changeEventsCurrentDay=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANGE_EVENTS_CURRENT_DAY */]);var loadPage=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* LOAD_PAGE */],function(id,now,timezone){return{id:id,now:now,timezone:timezone};});var pageReady=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PAGE_READY */]);var receiveEvents=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* RECEIVE_EVENTS */],function(day,data,id){return{day:day,data:data,id:id};});var unloadPage=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* UNLOAD_PAGE */]);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getHasLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSelectedDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSelectedDayAsMoment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getHasDayDataLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSelectedDaysEvents; });
/* unused harmony export getTodaysEvents */
/* unused harmony export getMostRecentDay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLastEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getZoomLevel; });
/* unused harmony export getEventsCurrentDay */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getEventsCurrentDayAsMoment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
var getState=function getState(state){return state.contactSensor;};var getHasLoaded=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'hasLoaded']);});var getSelectedDay=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'selectedDay']);});var getSelectedDayAsMoment=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getSelectedDay,__WEBPACK_IMPORTED_MODULE_0__hub_selectors__["k" /* getTimezone */]],function(selectedDay,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(selectedDay,timezone);});var getHasDayDataLoaded=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'hasLoadedDayData'],false);});var getEvents=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'events'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]));});var getSelectedDaysEvents=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getSelectedDay,getEvents],function(selectedDay,events){return events?events.get(selectedDay,Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([])):Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]);});var getTodaysEvents=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_0__hub_selectors__["l" /* getTodayAsString */],getEvents],function(today,events){return events.get(today,Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]));});var getMostRecentDay=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getEvents],function(events){return events&&events.filter(function(event){return event&&event.size;}).keySeq().toArray().sort().reverse()[0];});var getLastEvent=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getEvents,getMostRecentDay],function(events,day){return day?events.get(day).first():Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({});});var getZoomLevel=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */]],function(sensor,id){return sensor.getIn([id,'zoomLevel']);});var getEventsCurrentDay=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getState,__WEBPACK_IMPORTED_MODULE_3__selectors__["c" /* getIdFromProps */],__WEBPACK_IMPORTED_MODULE_0__hub_selectors__["l" /* getTodayAsString */]],function(sensor,id,today){return sensor.getIn([id,'eventsCurrentDay'],today);});var getEventsCurrentDayAsMoment=Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([getEventsCurrentDay,__WEBPACK_IMPORTED_MODULE_0__hub_selectors__["k" /* getTimezone */]],function(currentDay,timezone){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(currentDay,timezone);});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return searchForBridge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bridgeNodeCreated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pollBridgeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bridgeStatusUpdated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return pairWithBridge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addChildrenToDashboard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var searchForBridge=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* SEARCH_FOR_BRIDGE */],function(bridgeId){return{bridgeId:bridgeId};});var bridgeNodeCreated=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* BRIDGE_NODE_CREATED */]);var pollBridgeStatus=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* POLL_HUE_BRIDGE_STATUS */],function(bridgeId,currentStatus){return{bridgeId:bridgeId,currentStatus:currentStatus};});var bridgeStatusUpdated=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* BRIDGE_STATUS_UPDATE */]);var pairWithBridge=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* PAIR_WITH_BRIDGE */],function(bridgeId){return{bridgeId:bridgeId,currentStatus:__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* hueBridgeStatuses */].RETRY};});var addChildrenToDashboard=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ADD_CHILDREN_TO_DASHBOARD */],function(parent){return{parent:parent};});

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1965);
var objectAssign = __webpack_require__(77);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FadeIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FadeOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FlipXIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FlipXOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BounceIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BounceOut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_velocity_react__);
var FadeIn=__WEBPACK_IMPORTED_MODULE_0_velocity_react__["velocityHelpers"].registerEffect({calls:[[{opacity:[1,0]},1,{easing:'ease-out'}]]});var FadeOut=__WEBPACK_IMPORTED_MODULE_0_velocity_react__["velocityHelpers"].registerEffect({calls:[[{opacity:[0,1]},1,{easing:'ease-out'}]]});var FlipXIn=__WEBPACK_IMPORTED_MODULE_0_velocity_react__["velocityHelpers"].registerEffect({calls:[[{rotateX:[0,90]},1,{easing:'ease-out'}]]});var FlipXOut=__WEBPACK_IMPORTED_MODULE_0_velocity_react__["velocityHelpers"].registerEffect({calls:[[{rotateX:[-90,0]},1,{easing:'ease-out'}]]});var BounceIn=__WEBPACK_IMPORTED_MODULE_0_velocity_react__["velocityHelpers"].registerEffect({calls:[[{scale:[1,0],opacity:[1,0]},1,{easing:'spring'}]]});var BounceOut=__WEBPACK_IMPORTED_MODULE_0_velocity_react__["velocityHelpers"].registerEffect({calls:[[{scale:[0,1],opacity:[0,1]},1,{easing:'spring'}]]});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__item__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_custom_prop_types__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_utils_periods__ = __webpack_require__(528);
// @noflow
var DaySelector=function DaySelector(_ref){var endDay=_ref.endDay,onSelectDay=_ref.onSelectDay,selectedDay=_ref.selectedDay,startDay=_ref.startDay;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* DaySelectorList */],{'data-qa':'day-selector-base'},Object(__WEBPACK_IMPORTED_MODULE_6__core_utils_periods__["b" /* daysBetween */])(startDay,endDay).map(function(day){return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('li',{key:day.format('DD-MM')},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__item__["a" /* default */],{day:day,onSelect:function onSelect(e){e.preventDefault();onSelectDay(day.format('YYYY-MM-DD'));},selected:day.isSame(selectedDay,'day')}));}));};DaySelector.propTypes={endDay:Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_custom_prop_types__["b" /* isDependentOn */])(['startDay'],function(value,startDay){return value.isAfter(startDay);},__WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__["momentObj"].isRequired),onSelectDay:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,selectedDay:__WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__["momentObj"].isRequired,startDay:__WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__["momentObj"].isRequired};/* harmony default export */ __webpack_exports__["a"] = (DaySelector);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popup_item__ = __webpack_require__(2214);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContextMenu=function(_React$Component){_inherits(ContextMenu,_React$Component);function ContextMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContextMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContextMenu.__proto__||Object.getPrototypeOf(ContextMenu)).call.apply(_ref,[this].concat(args))),_this),_this.state={selected:false,selectedItem:null},_this.show=function(e){e.stopPropagation();if(!_this.state.selected){_this.setState({selected:true,selectedItem:null});}},_this.close=function(e){e.stopPropagation();if(_this.state.selected){_this.setState({selected:false});}},_this.keyDown=function(e){var _switchCase;var switchCase=(_switchCase={},_defineProperty(_switchCase,__WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__["a" /* default */].SPACE,function(){e.preventDefault();_this.show(e);}),_defineProperty(_switchCase,__WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__["a" /* default */].ARROW_UP,function(){e.preventDefault();var selectedItem=_this.state.selectedItem;if(selectedItem===null){_this.setState({selectedItem:0});}else if(typeof selectedItem==='number'&&selectedItem>0){_this.setState({selectedItem:selectedItem-1});}}),_defineProperty(_switchCase,__WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__["a" /* default */].ARROW_DOWN,function(){e.preventDefault();var selectedItem=_this.state.selectedItem;if(selectedItem===null){_this.setState({selectedItem:0});}else if(typeof selectedItem==='number'&&selectedItem<__WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(_this.props.children)-1){_this.setState({selectedItem:selectedItem+1});}}),_defineProperty(_switchCase,__WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__["a" /* default */].ESCAPE,function(){_this.close(e);}),_defineProperty(_switchCase,__WEBPACK_IMPORTED_MODULE_3__core_constants_key_codes__["a" /* default */].ENTER,function(){var selectedItem=_this.state.selectedItem;if(typeof selectedItem==='number'){_this.triggerAction(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(_this.props.children)[selectedItem].props.action);}}),_switchCase);if(typeof switchCase[e.keyCode]==='function'){switchCase[e.keyCode]();}},_this.triggerAction=function(action){_this.setState({selected:false});action();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContextMenu,[{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,left=_props.left;var _state=this.state,selected=_state.selected,selectedItem=_state.selectedItem;if(!children){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Base */],null);}var childrenWithProps=__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(child,index){return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](child,{index:index,action:function action(e){e.stopPropagation();_this2.triggerAction(child.props.action);},selected:selectedItem===index});});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Base */],{onBlur:this.close,onKeyDown:this.keyDown,selected:selected,tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',{onClick:selected?this.close:this.show},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* MainIcon */],{selected:selected,type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].MORE})),selected&&[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* Popup */],{key:'popup',left:left,selected:selected},childrenWithProps),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["i" /* ShadowMask */],{key:'mask'})]);}}]);return ContextMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ContextMenu.Item=__WEBPACK_IMPORTED_MODULE_4__popup_item__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (ContextMenu);

/***/ }),
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MIN_TARGET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_TARGET; });
var MIN_TARGET=5;var MAX_TARGET=32;

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PRODUCTS_HEATING_HISTORY */
/* unused harmony export PRODUCTS_HEATING_HISTORY_FETCHING */
/* unused harmony export PRODUCTS_SUCCESS */
/* unused harmony export PRODUCTS_HEATING_HISTORY_ERROR */
/* unused harmony export PRODUCTS_PATH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LEAK_STATUS_NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LEAK_STATUS_LOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEAK_STATUS_HIGH; });
var PRODUCTS_HEATING_HISTORY='PRODUCTS_HEATING_HISTORY';var PRODUCTS_HEATING_HISTORY_FETCHING='PRODUCTS_HEATING_HISTORY_FETCHING';var PRODUCTS_SUCCESS='PRODUCTS_SUCCESS';var PRODUCTS_HEATING_HISTORY_ERROR='PRODUCTS_HEATING_HISTORY_ERROR';var PRODUCTS_PATH='products';var LEAK_STATUS_NONE='NONE';var LEAK_STATUS_LOW='LOW';var LEAK_STATUS_HIGH='HIGH';

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resetPassword */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forgotPassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* eslint-disable max-len */var resetPassword=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({RESET_PASSWORD_SUCCESS_HEADER:{id:'auth.reset-password.success-header',defaultMessage:'Change Password'},RESET_PASSWORD_SUCCESS_BODY:{id:'auth.reset-password.success-body',defaultMessage:'Password changed correctly'},RESET_PASSWORD_SUCCESS_BUTTON_TEXT:{id:'auth.reset-password.success-button',defaultMessage:'Login'},RESET_PASSWORD_ERROR_HEADER:{id:'auth.reset-password.error-header',defaultMessage:'Ooops, something went wrong!'},RESET_PASSWORD_ERROR_BUTTON_TEXT:{id:'auth.reset-password.retry',defaultMessage:'Retry'},RESET_PASSWORD_ERROR_BODY:{id:'auth.reset-password.unexpected-error',defaultMessage:"We're sorry, something unexpected has happened. Please try again in a few minutes' time."}});var forgotPassword=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({FORGOTTEN_PASSWORD_SUCCESS_HEADER:{id:'auth.forgot-password.success-header',defaultMessage:'Success: Password reset email sent'},FORGOTTEN_PASSWORD_SUCCESS_BODY:{id:'auth.forgot-password.success-body',defaultMessage:'To reset your password, please click the link in the email we have sent to the address you provided. Sometimes it can go into the junk mail folder, so please check that folder too.'},FORGOTTEN_PASSWORD_ERROR_HEADER:{id:'auth.forgot-password.error-header',defaultMessage:'Ooops, something went wrong!'},FORGOTTEN_PASSWORD_ERROR_BODY:{id:'auth.forgot-password.error-body',defaultMessage:"We're sorry, something unexpected has happened. Please try again in a few minutes' time."}});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return initiateHolidayMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return initializeState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateSelected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return exitHolidayModeScreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setHolidayMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return temperatureChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return timeChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return editingHolidayMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return disableHolidayMode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_curry__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
var initiateHolidayMode=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* INITIATE_HOLIDAYMODE */]);var initializeState=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* INITIALIZE_STATE */]);var dateSelected=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* DATE_SELECTED */],function(timezone,date){return{timezone:timezone,date:date};});var exitHolidayModeScreen=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* EXIT_HOLIDAY_MODE_SCREEN */]);var setHolidayMode=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* SET_HOLIDAY_MODE */],function(start,end,temperature,e){return{start:start,end:end,temperature:temperature,event:e};});var temperatureChange=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* TEMPERATURE_CHANGE */]);var timeChange=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_curry___default()(function(position,timezone,time){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* TIME_CHANGE */],payload:{position:position,time:time,timezone:timezone}};});var editingHolidayMode=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* EDITING_HOLIDAY_MODE */]);var disableHolidayMode=Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* DISABLE_HOLIDAY_MODE */]);

/***/ }),
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return changeZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receivedNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return saveNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return saveNotificationsError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return savedNotifications; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var changeZone=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANGE_ZONE */]);var loadNotifications=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* LOAD_NOTIFICATIONS */]);var receivedNotifications=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RECEIVED_NOTIFICATIONS */]);var saveNotifications=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SAVE_NOTIFICATIONS */]);var saveNotificationsError=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SAVE_NOTIFICATIONS_ERROR */]);var savedNotifications=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SAVED_NOTIFICATIONS */]);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPowerConsumption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receivePowerConsumption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return showEstimatedCostModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hideEstimatedCostModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var getPowerConsumption=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* GET_POWER_CONSUMPTION */]);var receivePowerConsumption=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* RECEIVE_POWER_CONSUMPTION */]);var showEstimatedCostModal=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SHOW_ESTIMATED_COST_MODAL */]);var hideEstimatedCostModal=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* HIDE_ESTIMATED_COST_MODAL */]);

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return receivedServerErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receivedContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return saveContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return savedContacts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var receivedServerErrors=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* RECEIVED_SERVER_ERRORS */]);var getContacts=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* GET_CONTACTS */]);var receivedContacts=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RECEIVED_CONTACTS */]);var saveContacts=function saveContacts(formId){return Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SAVE_CONTACTS */],function(_ref){var contacts=_ref.contacts;return{formId:formId,contacts:contacts};});};var savedContacts=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SAVED_CONTACTS */]);

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getServerErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIsLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTextControlContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIsSaving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHasError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
var getTextControl=function getTextControl(state){return state.textControl;};var getServerErrors=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getTextControl,function(textControl){return textControl.get('server_errors');});var getIsLoading=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getTextControl,function(textControl){return textControl.get('loading');});var getTextControlContacts=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getTextControl,function(textControl){return textControl.get('contacts',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([]));});var getIsSaving=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getTextControl,function(textControl){return textControl.get('saving');});var getHasError=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getTextControl,function(textControl){return textControl.get('hasError');});

/***/ }),
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tabs__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuerystringTabManager=function(_React$Component){_inherits(QuerystringTabManager,_React$Component);function QuerystringTabManager(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QuerystringTabManager);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QuerystringTabManager.__proto__||Object.getPrototypeOf(QuerystringTabManager)).call.apply(_ref,[this].concat(args))),_this),_this.state={tab:0},_this.tabChange=function(index){_this.setState({tab:index});},_this.setupCurrentTab=function(_ref2){var tabGroup=_ref2.tabGroup,children=_ref2.children,location=_ref2.location;var qs=new URLSearchParams(location.search);var qsVal=qs.get(tabGroup);var index=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(c){return c.props.name===qsVal;},children.props.children);_this.tabChange(index>=0?index:_this.state.tab);},_this.renderTab=function(_ref3){var maybeIcon=_ref3.maybeIcon,label=_ref3.label,onClick=_ref3.onClick,name=_ref3.name;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{onMouseDown:onClick,to:{search:'?'+_this.props.tabGroup+'='+name}},maybeIcon,label);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QuerystringTabManager,[{key:'componentDidMount',value:function componentDidMount(){this.setupCurrentTab(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setupCurrentTab(nextProps);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(this.props.children,{onTabChange:this.tabChange,selectedTabIndex:this.state.tab,renderTab:this.renderTab});}}]);return QuerystringTabManager;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router__["withRouter"])(QuerystringTabManager));

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_first__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(87);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var TabScreen=function TabScreen(_ref){var path=_ref.path,Component=_ref.component,props=_objectWithoutProperties(_ref,['path','component']);// Return null because this function is statically analyzed and never rendered.
return null;};// Important - if the component that is using the TabSwitch is a connected component,
// then in the connected needs to be wrapped with withRouter from react-router-dom
// this is to stop the history props update from being blocked, see below article for more details:
// https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md
var TabSwitch=function(_React$Component){_inherits(TabSwitch,_React$Component);function TabSwitch(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,TabSwitch);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=TabSwitch.__proto__||Object.getPrototypeOf(TabSwitch)).call.apply(_ref2,[this].concat(args))),_this),_this.state={component:'div',nextProps:{}},_this.setUpComponent=function(_ref3){var children=_ref3.children,tabGroup=_ref3.tabGroup,props=_objectWithoutProperties(_ref3,['children','tabGroup']);var qsVal=new URLSearchParams(props.history.location.search).get(tabGroup);var c=__WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children);var _ref4=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_find___default()(function(x){return x.props.name===qsVal;},c)||__WEBPACK_IMPORTED_MODULE_0_lodash_fp_first___default()(c),_ref4$props=_ref4.props,component=_ref4$props.component,nextProps=_objectWithoutProperties(_ref4$props,['component']);_this.setState({component:component,nextProps:nextProps});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TabSwitch,[{key:'componentDidMount',value:function componentDidMount(){this.setUpComponent(this.props);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.setUpComponent(nextProps);}},{key:'render',value:function render(){var _state=this.state,Component=_state.component,props=_state.nextProps;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component,props);}}]);return TabSwitch;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);TabSwitch.Screen=TabScreen;var TabContentRouter=function(_React$Component2){_inherits(TabContentRouter,_React$Component2);function TabContentRouter(){_classCallCheck(this,TabContentRouter);return _possibleConstructorReturn(this,(TabContentRouter.__proto__||Object.getPrototypeOf(TabContentRouter)).apply(this,arguments));}_createClass(TabContentRouter,[{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Route */],{render:function render(_ref5){var history=_ref5.history;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TabSwitch,Object.assign({},_this3.props,{history:history}));}});}}]);return TabContentRouter;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);TabContentRouter.Screen=TabScreen;/* harmony default export */ __webpack_exports__["a"] = (TabContentRouter);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_actions_actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_state_actions_selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_state_actions_utils__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_utils_schedule__ = __webpack_require__(181);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var extendForm=function extendForm(state){var form=Object(__WEBPACK_IMPORTED_MODULE_6__core_state_actions_selectors__["d" /* getActionForm */])(state);if(form==='none'){return;}var region=Object(__WEBPACK_IMPORTED_MODULE_5__core_state_config_selectors__["d" /* getIconLocaleSuffix */])(state);var extendGroup=function extendGroup(group){return group.reduce(function(acc,event,index){var definition=Object(__WEBPACK_IMPORTED_MODULE_4__core_constants_actions__["d" /* getAttributeDefinition */])(event.type,region);// $FlowFixMe
var devices=Object(__WEBPACK_IMPORTED_MODULE_6__core_state_actions_selectors__["o" /* listDevicesForActionAttribute */])(state,{types:definition.devices||[]}).filter(// check the device is not already used in another event of the same type
function(device){return!group.some(function(e,i){return e.type===event.type&&i!==index&&e.id===device.value;});});return definition.devices&&devices.length===0?acc:[].concat(_toConsumableArray(acc),[Object.assign({},event,{definition:definition,devices:devices})]);},[]);};var extendGroups=function extendGroups(form){return['when','while','then'].reduce(function(groups,group){return Object.assign({},groups,_defineProperty({},group,extendGroup(form[group])));},{});};var extendedGroups=extendGroups(form);return Object.assign({},form,extendedGroups,form.status==='edit'?{id:form.id}:{});};var updateEventSchedule=function updateEventSchedule(schedule){return function(action){var findScheduleEventAndUpdateSchedule=function findScheduleEventAndUpdateSchedule(acc,event){return[].concat(_toConsumableArray(acc),[event.type==='schedule'?Object.assign({},event,{settings:Object.assign({},event.settings,{schedule:schedule.toJS()})}):event]);};return schedule?Object.assign({},action,{events:action.events.reduce(findScheduleEventAndUpdateSchedule,[])}):action;};};var mapStateToProps=function mapStateToProps(state){var region=Object(__WEBPACK_IMPORTED_MODULE_5__core_state_config_selectors__["d" /* getIconLocaleSuffix */])(state);var schedule=Object(__WEBPACK_IMPORTED_MODULE_8__core_state_ui_schedule_selectors__["j" /* getScheduleData */])(state,{componentId:__WEBPACK_IMPORTED_MODULE_9__core_utils_schedule__["a" /* actionFormComponentId */]});var savingState=Object(__WEBPACK_IMPORTED_MODULE_6__core_state_actions_selectors__["a" /* currentSavingState */])(state);return{extendedForm:extendForm(state),region:region,savingState:savingState,schedule:schedule};};var mapDispatchToProps={attemptCreateAction:__WEBPACK_IMPORTED_MODULE_3__core_state_actions_actions__["b" /* attemptCreateAction */],attemptEditAction:__WEBPACK_IMPORTED_MODULE_3__core_state_actions_actions__["c" /* attemptEditAction */],attemptRemoveAction:__WEBPACK_IMPORTED_MODULE_3__core_state_actions_actions__["d" /* attemptRemoveAction */],cancelForm:__WEBPACK_IMPORTED_MODULE_3__core_state_actions_actions__["f" /* cancelForm */]};var mergeProps=function mergeProps(_ref,dispatchProps,ownProps){var schedule=_ref.schedule,restStateProps=_objectWithoutProperties(_ref,['schedule']);var extendedForm=restStateProps.extendedForm,region=restStateProps.region;var attemptCreateAction=dispatchProps.attemptCreateAction,attemptEditAction=dispatchProps.attemptEditAction,loadForm=dispatchProps.loadForm,restDispatchProps=_objectWithoutProperties(dispatchProps,['attemptCreateAction','attemptEditAction','loadForm']);var updateSchedule=updateEventSchedule(schedule);return Object.assign({},restStateProps,restDispatchProps,ownProps,{saveAction:function saveAction(editedName){if(extendedForm){var editedForm=editedName?Object.assign({},extendedForm,{name:editedName}):extendedForm;extendedForm.status==='new'?__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default()(attemptCreateAction,updateSchedule,Object(__WEBPACK_IMPORTED_MODULE_7__core_state_actions_utils__["c" /* formToNewAction */])(region))(editedForm):__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default()(attemptEditAction,updateSchedule,Object(__WEBPACK_IMPORTED_MODULE_7__core_state_actions_utils__["b" /* formToEditAction */])(region))(editedForm,editedForm.id||'');}}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2277);
var NumberedList=function NumberedList(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* List */],null,__WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children,function(item){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Item */],{key:item.key},item);}));};/* harmony default export */ __webpack_exports__["a"] = (NumberedList);

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(4);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(130);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(807);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IconMenu=function(_React$Component){_inherits(IconMenu,_React$Component);function IconMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IconMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IconMenu.__proto__||Object.getPrototypeOf(IconMenu)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(key){_this.props.handleChange(key);},_this.renderMenuItem=function(menuItem,disabled){var isSelected=_this.props.selectedKey===menuItem.key;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Item */],{disabled:disabled,isSelected:isSelected,key:menuItem.key,onClick:function onClick(){return!disabled&&_this.handleClick(menuItem.key);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Icons */],null,menuItem.icons.map(function(icon){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Icon */],{disabled:disabled,isSelected:isSelected,key:icon,type:icon});})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],menuItem.label));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IconMenu,[{key:'render',value:function render(){var _this2=this;var _props=this.props,items=_props.items,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* IconMenuContainer */],null,items.map(function(menuItem){return _this2.renderMenuItem(menuItem,disabled);}));}}]);return IconMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (IconMenu);

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = Link;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom_Link__ = __webpack_require__(2293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_dom_Link__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
Link.propTypes={alternate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,currentHost:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,currentHref:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,href:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,target:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};/**
 * Represents a normal inline link. If the `href` is an internal link then it
 * renders a wrapper around React Router's `<Link>`. If it's external then it
 * renders a normal `<a>`.
 */function Link(_ref){var alternate=_ref.alternate,children=_ref.children,className=_ref.className,_ref$currentHost=_ref.currentHost,currentHost=_ref$currentHost===undefined?global.location.host:_ref$currentHost,_ref$currentHref=_ref.currentHref,currentHref=_ref$currentHref===undefined?global.location.href:_ref$currentHref,href=_ref.href,_ref$target=_ref.target,target=_ref$target===undefined?'_blank':_ref$target,props=_objectWithoutProperties(_ref,['alternate','children','className','currentHost','currentHref','href','target']);if(isExternalHref(currentHost,currentHref,href)){return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StyledExternalLink */],Object.assign({alternate:alternate},props,{className:className,href:href,rel:'external noopener',target:target}),children);}return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* StyledRouterLink */],{alternate:alternate},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom_Link___default.a,Object.assign({},props,{className:className,to:href}),children));}/**
 * Calculates whether `href` would be an external link
 * @param  {String}  currentHost the host of the current site
 * @param  {String}  currentHref the href of the current site
 * @param  {String}  href        the proposed href
 * @return {Boolean}             whether the proposed href would be external
 */function isExternalHref(currentHost,currentHref,href){var url=Object(__WEBPACK_IMPORTED_MODULE_0_url__["resolve"])(currentHref,href);var urlParts=Object(__WEBPACK_IMPORTED_MODULE_0_url__["parse"])(url);return urlParts.host!==currentHost;}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_get__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__(2328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__intl__ = __webpack_require__(2329);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModeSelectorBlock=function(_React$Component){_inherits(ModeSelectorBlock,_React$Component);function ModeSelectorBlock(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModeSelectorBlock);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModeSelectorBlock.__proto__||Object.getPrototypeOf(ModeSelectorBlock)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeAnimate:false,descriptionUseImplodeAnimation:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModeSelectorBlock,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _props=this.props,modes=_props.modes,prevValue=_props.value;var value=nextProps.value;var hasPrevDescription=!!__WEBPACK_IMPORTED_MODULE_1_lodash_fp_get___default()('description')(modes[prevValue]);var hasNextDescription=!!__WEBPACK_IMPORTED_MODULE_1_lodash_fp_get___default()('description')(modes[value]);var descriptionUseImplodeAnimation=hasPrevDescription&&hasNextDescription;var activeAnimate=value!==prevValue?!this.state.activeAnimate:this.state.activeAnimate;this.setState({activeAnimate:activeAnimate,descriptionUseImplodeAnimation:descriptionUseImplodeAnimation});}},{key:'render',value:function render(){var _props2=this.props,intl=_props2.intl,modes=_props2.modes,onChange=_props2.onChange,purpose=_props2.purpose,value=_props2.value,disabled=_props2.disabled;var _ref2=intl||{},formatMessage=_ref2.formatMessage;var _state=this.state,activeAnimate=_state.activeAnimate,descriptionUseImplodeAnimation=_state.descriptionUseImplodeAnimation;var descriptionAnimationClass=descriptionUseImplodeAnimation?__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ANIMATION_KEY_IMPLODE */]:__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* ANIMATION_KEY_SLIDE */];var descriptionEnterDuration=descriptionUseImplodeAnimation?__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ANIMATION_IMPLODE_DURATION */]:__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* ANIMATION_SLIDE_ENTER_DURATION */];var descriptionExitDuration=(descriptionUseImplodeAnimation?__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ANIMATION_IMPLODE_DURATION */]:__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* ANIMATION_SLIDE_EXIT_DURATION */])-50;var itemWidth=100/modes.length;var purposeValue=formatMessage(purpose);return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["h" /* ModeSelector */],{'aria-label':purposeValue,role:'region'},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["g" /* ModeItemWrapper */],null,modes.map(function(_ref3,index){var name=_ref3.name,icons=_ref3.icons;var modeName=(typeof name==='undefined'?'undefined':_typeof(name))==='object'&&name.id?formatMessage(name):name;var ariaLabel=typeof modeName==='string'?modeName:'';return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["f" /* ModeItem */],{'aria-label':ariaLabel,'data-qa':'mode-selector-'+ariaLabel.toLowerCase(),disabled:disabled,itemWidth:itemWidth,key:index,onClick:function onClick(){return!disabled&&onChange(index);}},icons&&icons.map(function(icon,i){return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["e" /* ModeIcon */],{key:''+icon,type:icon});}),modeName);}),value>-1&&__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* ActiveIndicatorWrapper */],{itemCount:modes.length,itemWidth:itemWidth,selectedIndex:value},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* ActiveIndicator */],{activeAnimate:activeAnimate,disabled:disabled}))),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* DescriptionWrapper */],null,modes.map(function(_ref4,index){var description=_ref4.description;if(description){var descriptionValue=(typeof description==='undefined'?'undefined':_typeof(description))==='object'&&description.id?formatMessage(description):description;var ariaLabel=typeof descriptionValue==='string'?descriptionValue:'';return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["i" /* TransitionWrapper */],{classNames:descriptionAnimationClass,'in':index===value,key:'description-'+index,mountOnEnter:true,timeout:{enter:descriptionEnterDuration,exit:descriptionExitDuration},unmountOnExit:true},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Description */],{'aria-label':ariaLabel,'aria-live':'polite','data-qa':'mode-selector-description'},descriptionValue)));}return null;})));}}]);return ModeSelectorBlock;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);//$FlowFixMe // Bug with intersection type of React$StatelessFunctionalComponent
ModeSelectorBlock.defaultProps={purpose:__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].purpose};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["g" /* injectIntl */])(ModeSelectorBlock));

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTON_OFF", function() { return BUTTON_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTON_ON", function() { return BUTTON_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAMERA_OFF", function() { return CAMERA_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAMERA_ON", function() { return CAMERA_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTACT_SENSOR_CLOSED", function() { return CONTACT_SENSOR_CLOSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTACT_SENSOR_OPEN", function() { return CONTACT_SENSOR_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COOLING", function() { return COOLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FAN_OFF", function() { return FAN_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FAN_ON", function() { return FAN_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEATING_OFF", function() { return HEATING_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEATING_ON", function() { return HEATING_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEATING_OFF_NA", function() { return HEATING_OFF_NA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEATING_ON_NA", function() { return HEATING_ON_NA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOT_WATER_OFF", function() { return HOT_WATER_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOT_WATER_ON", function() { return HOT_WATER_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HUMIDITY", function() { return HUMIDITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT_OFF", function() { return LIGHT_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT_ON", function() { return LIGHT_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEAK_SENSOR_OFF", function() { return LEAK_SENSOR_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEAK_SENSOR_ON", function() { return LEAK_SENSOR_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOTION_SENSOR_OFF", function() { return MOTION_SENSOR_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOTION_SENSOR_ON", function() { return MOTION_SENSOR_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEW_HUB", function() { return NEW_HUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OLD_HUB", function() { return OLD_HUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RECEIVER_DUAL", function() { return RECEIVER_DUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RECEIVER_SINGLE", function() { return RECEIVER_SINGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BOOSTER_OFF", function() { return SIGNAL_BOOSTER_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BOOSTER_ON", function() { return SIGNAL_BOOSTER_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BOOSTER2_OFF", function() { return SIGNAL_BOOSTER2_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BOOSTER2_ON", function() { return SIGNAL_BOOSTER2_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SENCE_OFF", function() { return SENCE_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SENCE_ON", function() { return SENCE_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMART_PLUG_OFF", function() { return SMART_PLUG_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMART_PLUG_ON", function() { return SMART_PLUG_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMART_PLUG_OFF_NA", function() { return SMART_PLUG_OFF_NA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMART_PLUG_ON_NA", function() { return SMART_PLUG_ON_NA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMART_PLUG_OFF_IN", function() { return SMART_PLUG_OFF_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMART_PLUG_ON_IN", function() { return SMART_PLUG_ON_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMART_PLUG_OFF_EU", function() { return SMART_PLUG_OFF_EU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMART_PLUG_ON_EU", function() { return SMART_PLUG_ON_EU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_DUO_EU", function() { return SOCKET_DUO_EU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_DUO_IN", function() { return SOCKET_DUO_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_DUO_NA", function() { return SOCKET_DUO_NA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_DUO", function() { return SOCKET_DUO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_OFF_GENERIC", function() { return SOCKET_OFF_GENERIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_ON_GENERIC", function() { return SOCKET_ON_GENERIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_OFF", function() { return SOCKET_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_ON", function() { return SOCKET_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_OFF_NA", function() { return SOCKET_OFF_NA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_ON_NA", function() { return SOCKET_ON_NA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_OFF_IN", function() { return SOCKET_OFF_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_ON_IN", function() { return SOCKET_ON_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_OFF_EU", function() { return SOCKET_OFF_EU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKET_ON_EU", function() { return SOCKET_ON_EU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCH_OFF", function() { return SWITCH_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWITCH_ON", function() { return SWITCH_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAT1", function() { return STAT1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAT2", function() { return STAT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAT3", function() { return STAT3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAT3_ON", function() { return STAT3_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THERMOMETER", function() { return THERMOMETER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WATER_FLOW_OFF", function() { return WATER_FLOW_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WATER_FLOW_ON", function() { return WATER_FLOW_ON; });
var BUTTON_OFF='1';var BUTTON_ON='2';var CAMERA_OFF='J';var CAMERA_ON='K';var CONTACT_SENSOR_CLOSED='U';var CONTACT_SENSOR_OPEN='V';var COOLING='F';var FAN_OFF='B';var FAN_ON='C';var HEATING_OFF='i';var HEATING_ON='j';var HEATING_OFF_NA='Q';var HEATING_ON_NA='R';var HOT_WATER_OFF='k';var HOT_WATER_ON='l';var HUMIDITY='A';var LIGHT_OFF='u';var LIGHT_ON='v';var LEAK_SENSOR_OFF='S';var LEAK_SENSOR_ON='T';var MOTION_SENSOR_OFF='q';var MOTION_SENSOR_ON='r';var NEW_HUB='b';var OLD_HUB='a';var RECEIVER_DUAL='d';var RECEIVER_SINGLE='c';var SIGNAL_BOOSTER_OFF='h';var SIGNAL_BOOSTER_ON='N';var SIGNAL_BOOSTER2_OFF='O';var SIGNAL_BOOSTER2_ON='P';var SENCE_OFF='L';var SENCE_ON='M';var SMART_PLUG_OFF='o';var SMART_PLUG_ON='p';var SMART_PLUG_OFF_NA='G';var SMART_PLUG_ON_NA='H';var SMART_PLUG_OFF_IN='3';var SMART_PLUG_ON_IN='4';var SMART_PLUG_OFF_EU='5';var SMART_PLUG_ON_EU='6';var SOCKET_DUO_EU='}';var SOCKET_DUO_IN='{';var SOCKET_DUO_NA=']';var SOCKET_DUO='[';var SOCKET_OFF_GENERIC='w';var SOCKET_ON_GENERIC='x';var SOCKET_OFF='7';var SOCKET_ON='8';var SOCKET_OFF_NA='9';var SOCKET_ON_NA='0';var SOCKET_OFF_IN='!';var SOCKET_ON_IN='@';var SOCKET_OFF_EU='$';var SOCKET_ON_EU='%';var SWITCH_OFF='y';var SWITCH_ON='z';var STAT1='e';var STAT2='f';var STAT3='g';var STAT3_ON='(';var THERMOMETER='I';var WATER_FLOW_OFF='X';var WATER_FLOW_ON='W';

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tone-picker-colour.713c6b758df2b36a08e6800d9a9ceca9d4f4ae4ee3f689590c85a58b8040c576.png";

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('inRange', __webpack_require__(2400));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__standard_brightness_picker__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__widgets_flipper_rgb_flipper__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dimmer_menu__ = __webpack_require__(2444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menu__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__picker_menu__ = __webpack_require__(2445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_tone_picker_white_png__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_images_tone_picker_white_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_images_tone_picker_white_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ColorTuneable=function(_Component){_inherits(ColorTuneable,_Component);function ColorTuneable(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ColorTuneable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ColorTuneable.__proto__||Object.getPrototypeOf(ColorTuneable)).call.apply(_ref,[this].concat(args))),_this),_this.state={showBrightnessPicker:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ColorTuneable,[{key:'switchComponent',value:function switchComponent(showBrightnessPicker){this.setState({showBrightnessPicker:showBrightnessPicker});}},{key:'switchPicker',value:function switchPicker(){this.setState({showBrightnessPicker:false});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,isOn=_props.isOn,isSaving=_props.isSaving,isToggling=_props.isToggling,toggleLightbulb=_props.toggleLightbulb,bulbBrightness=_props.bulbBrightness,valueChanged=_props.valueChanged,productId=_props.productId,delayRendering=_props.delayRendering,rgb=_props.rgb,rangeValue=_props.rangeValue,bulbType=_props.bulbType,_props$handleRadiusPe=_props.handleRadiusPercent,handleRadiusPercent=_props$handleRadiusPe===undefined?5:_props$handleRadiusPe,_props$pickerDepthPer=_props.pickerDepthPercent,pickerDepthPercent=_props$pickerDepthPer===undefined?5:_props$pickerDepthPer,changeColor=_props.changeColor,debug=_props.debug,logger=_props.logger,isSmall=_props.isSmall,additionalMenuItems=_props.additionalMenuItems;var showBrightnessPicker=this.state.showBrightnessPicker;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* BulbFlipperWrapper */],null,showBrightnessPicker?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__standard_brightness_picker__["a" /* default */],{isOn:isOn,isSaving:isSaving,isSmall:isSmall,isToggling:isToggling,toggleLightbulb:toggleLightbulb,value:bulbBrightness,valueChanged:valueChanged}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__widgets_flipper_rgb_flipper__["a" /* default */],{bulbBrightness:bulbBrightness,bulbType:bulbType,changeColor:changeColor,colourStartRadians:3.52,colourStopRadians:5.9,debug:debug,delayRendering:delayRendering,handleRadiusPercent:handleRadiusPercent,image:__WEBPACK_IMPORTED_MODULE_8__assets_images_tone_picker_white_png___default.a,isCustomRange:true,isOn:isOn,isSaving:isSaving,isSmall:isSmall,isToggling:isToggling,logger:logger,pickerDepthPercent:pickerDepthPercent,productId:productId,rangeValue:rangeValue,rgb:rgb,toggleLightbulb:toggleLightbulb}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__menu__["b" /* MenuContainer */],{isSmall:isSmall},showBrightnessPicker?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__dimmer_menu__["a" /* default */],{additionalItems:additionalMenuItems,isOn:isOn,onClick:function onClick(){return _this2.switchComponent(!showBrightnessPicker);}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__picker_menu__["a" /* default */],{additionalItems:additionalMenuItems,isOn:isOn,toggleDimmer:function toggleDimmer(){return _this2.switchComponent(!showBrightnessPicker);}})));}}]);return ColorTuneable;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ColorTuneable);

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__standard_brightness_picker__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dimmer_menu__ = __webpack_require__(2449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__menu__ = __webpack_require__(123);
var WarmWhiteBulb=function WarmWhiteBulb(_ref){var _ref$additionalMenuIt=_ref.additionalMenuItems,additionalMenuItems=_ref$additionalMenuIt===undefined?[]:_ref$additionalMenuIt,bulbBrightness=_ref.bulbBrightness,isOn=_ref.isOn,isSaving=_ref.isSaving,isSmall=_ref.isSmall,isToggling=_ref.isToggling,toggleLightbulb=_ref.toggleLightbulb,valueChanged=_ref.valueChanged;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* BulbFlipperWrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__standard_brightness_picker__["a" /* default */],{isOn:isOn,isSaving:isSaving,isSmall:isSmall,isToggling:isToggling,toggleLightbulb:toggleLightbulb,value:bulbBrightness,valueChanged:valueChanged}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__menu__["b" /* MenuContainer */],{isSmall:isSmall},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__dimmer_menu__["a" /* default */],{additionalItems:additionalMenuItems,isOn:isOn})));};/* harmony default export */ __webpack_exports__["a"] = (WarmWhiteBulb);

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1017);
__webpack_require__(1022);
module.exports = __webpack_require__(2565);


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(1018).enable();
  window.Promise = __webpack_require__(1020);
}

// fetch() polyfill for making API calls.
__webpack_require__(1021);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(77);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(539);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(539);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 1021 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pickBy__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_config_constants__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__polyfills__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_ga__ = __webpack_require__(411);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();// @noflow
// We config raven/sentry before nearly everything to allow us to catch as many error
// as possible.
if(__WEBPACK_IMPORTED_MODULE_4__core_state_config_constants__["d" /* ENVIRONMENT_CONFIG */].sentryDSN){// '----' is the default value injected by our CRA fork when build number is unknown
var buildNumber="26822";var sentryConfig=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pickBy___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_identity___default.a,{release:buildNumber&&buildNumber!=='----'&&buildNumber,environment:__WEBPACK_IMPORTED_MODULE_4__core_state_config_constants__["d" /* ENVIRONMENT_CONFIG */].environment});__WEBPACK_IMPORTED_MODULE_6_raven_js___default.a.config(__WEBPACK_IMPORTED_MODULE_4__core_state_config_constants__["d" /* ENVIRONMENT_CONFIG */].sentryDSN,sentryConfig).install();}// If UATrackingID is undefined then there will only be a console warning
__WEBPACK_IMPORTED_MODULE_7_react_ga__["a" /* default */].initialize(__WEBPACK_IMPORTED_MODULE_4__core_state_config_constants__["d" /* ENVIRONMENT_CONFIG */].UATrackingID);Object(__WEBPACK_IMPORTED_MODULE_5__polyfills__["a" /* initializePolyfills */])().then(// load up all possible timezone locales we might use ahead of time
function(){return Promise.all(["en-gb","en-ca","en-ie","en-us","es-us","fr-ca","fr-fr","it-it"].map(function(l){var _l$split=l.split('-'),_l$split2=_slicedToArray(_l$split,1),country=_l$split2[0];return Promise.all([__webpack_require__(617)("./"+l).catch(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop___default.a),__webpack_require__(617)("./"+country).catch(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop___default.a)]);}));}).then(function(){// Using `require` statements here instead of `import` lets us
// carefully control the order and timing of what code is ran.
//
// We want to make sure all polyfills happen before we start
// running the code in the rest of the app otherwise we may
// get errors from code that depends on one of the polyfills
// being present.
__webpack_require__(1333).run();},function(err){// We will need to consider what to do here - ask to refresh? check network?
console.error('There was an error polyfilling features. '+err.message);});

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('pickBy', __webpack_require__(1113));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(1025),
    fallbackHolder = __webpack_require__(9);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isFunction': util.isFunction,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isFunction = helpers.isFunction,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null) {
        nested[path[index]] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 1025 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(1027),
  'assign': __webpack_require__(558),
  'clone': __webpack_require__(1055),
  'curry': __webpack_require__(382),
  'forEach': __webpack_require__(367),
  'isArray': __webpack_require__(32),
  'isFunction': __webpack_require__(275),
  'iteratee': __webpack_require__(1094),
  'keys': __webpack_require__(371),
  'rearg': __webpack_require__(1110),
  'toInteger': __webpack_require__(107),
  'toPath': __webpack_require__(1112)
};


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(360);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(275),
    isMasked = __webpack_require__(1031),
    isObject = __webpack_require__(54),
    toSource = __webpack_require__(544);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(185);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1032);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(52);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(276),
    root = __webpack_require__(52);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(278),
    createCtor = __webpack_require__(276),
    createHybrid = __webpack_require__(545),
    createRecurry = __webpack_require__(548),
    getHolder = __webpack_require__(557),
    replaceHolders = __webpack_require__(368),
    root = __webpack_require__(52);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(361),
    LodashWrapper = __webpack_require__(365),
    baseLodash = __webpack_require__(362),
    isArray = __webpack_require__(32),
    isObjectLike = __webpack_require__(91),
    wrapperClone = __webpack_require__(1039);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(361),
    LodashWrapper = __webpack_require__(365),
    copyArray = __webpack_require__(186);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1040 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1043),
    defineProperty = __webpack_require__(554),
    identity = __webpack_require__(150);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1043 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(367),
    arrayIncludes = __webpack_require__(279);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 1045 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1046 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(186),
    isIndex = __webpack_require__(223);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(278),
    createCtor = __webpack_require__(276),
    root = __webpack_require__(52);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(546),
    composeArgsRight = __webpack_require__(547),
    replaceHolders = __webpack_require__(368);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(134),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1052 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(134),
    isLength = __webpack_require__(370),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(561);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(372);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 1056 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(284);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(284);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(284);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(284);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(283);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1062 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1063 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(283),
    Map = __webpack_require__(373),
    MapCache = __webpack_require__(374);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1067),
    ListCache = __webpack_require__(283),
    Map = __webpack_require__(373);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1068),
    hashDelete = __webpack_require__(1069),
    hashGet = __webpack_require__(1070),
    hashHas = __webpack_require__(1071),
    hashSet = __webpack_require__(1072);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(285);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1069 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(285);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(285);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(285);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(286);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1074 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(286);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(286);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(286);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(152),
    keysIn = __webpack_require__(287);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(54),
    isPrototype = __webpack_require__(229),
    nativeKeysIn = __webpack_require__(1080);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1080 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(152),
    getSymbols = __webpack_require__(375);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(152),
    getSymbolsIn = __webpack_require__(564);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151),
    root = __webpack_require__(52);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1085 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(379),
    cloneDataView = __webpack_require__(1087),
    cloneMap = __webpack_require__(1088),
    cloneRegExp = __webpack_require__(1090),
    cloneSet = __webpack_require__(1091),
    cloneSymbol = __webpack_require__(1093),
    cloneTypedArray = __webpack_require__(569);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(379);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(1089),
    arrayReduce = __webpack_require__(380),
    mapToArray = __webpack_require__(381);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(1092),
    arrayReduce = __webpack_require__(380),
    setToArray = __webpack_require__(289);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(185);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(372),
    baseIteratee = __webpack_require__(55);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1096),
    getMatchData = __webpack_require__(1102),
    matchesStrictComparable = __webpack_require__(574);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(282),
    baseIsEqual = __webpack_require__(383);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(282),
    equalArrays = __webpack_require__(571),
    equalByTag = __webpack_require__(1100),
    equalObjects = __webpack_require__(1101),
    getTag = __webpack_require__(288),
    isArray = __webpack_require__(32),
    isBuffer = __webpack_require__(227),
    isTypedArray = __webpack_require__(281);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1098 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(185),
    Uint8Array = __webpack_require__(568),
    eq = __webpack_require__(225),
    equalArrays = __webpack_require__(571),
    mapToArray = __webpack_require__(381),
    setToArray = __webpack_require__(289);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(565);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(573),
    keys = __webpack_require__(108);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(383),
    get = __webpack_require__(292),
    hasIn = __webpack_require__(578),
    isKey = __webpack_require__(384),
    isStrictComparable = __webpack_require__(573),
    matchesStrictComparable = __webpack_require__(574),
    toKey = __webpack_require__(153);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(576);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(189),
    isArguments = __webpack_require__(226),
    isArray = __webpack_require__(32),
    isIndex = __webpack_require__(223),
    isLength = __webpack_require__(370),
    toKey = __webpack_require__(153);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1108),
    basePropertyDeep = __webpack_require__(1109),
    isKey = __webpack_require__(384),
    toKey = __webpack_require__(153);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1108 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(293);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(360),
    flatRest = __webpack_require__(294);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(185),
    isArguments = __webpack_require__(226),
    isArray = __webpack_require__(32);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82),
    copyArray = __webpack_require__(186),
    isArray = __webpack_require__(32),
    isSymbol = __webpack_require__(187),
    stringToPath = __webpack_require__(575),
    toKey = __webpack_require__(153),
    toString = __webpack_require__(190);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82),
    baseIteratee = __webpack_require__(55),
    basePickBy = __webpack_require__(581),
    getAllKeysIn = __webpack_require__(378);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1115);

__webpack_require__(1293);

__webpack_require__(1294);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1116);
__webpack_require__(1119);
__webpack_require__(1120);
__webpack_require__(1121);
__webpack_require__(1122);
__webpack_require__(1123);
__webpack_require__(1124);
__webpack_require__(1125);
__webpack_require__(1126);
__webpack_require__(1127);
__webpack_require__(1128);
__webpack_require__(1129);
__webpack_require__(1130);
__webpack_require__(1131);
__webpack_require__(1132);
__webpack_require__(1133);
__webpack_require__(1134);
__webpack_require__(1135);
__webpack_require__(1136);
__webpack_require__(1137);
__webpack_require__(1138);
__webpack_require__(1139);
__webpack_require__(1140);
__webpack_require__(1141);
__webpack_require__(1142);
__webpack_require__(1143);
__webpack_require__(1144);
__webpack_require__(1145);
__webpack_require__(1146);
__webpack_require__(1147);
__webpack_require__(1148);
__webpack_require__(1149);
__webpack_require__(1150);
__webpack_require__(1151);
__webpack_require__(1152);
__webpack_require__(1153);
__webpack_require__(1154);
__webpack_require__(1155);
__webpack_require__(1156);
__webpack_require__(1157);
__webpack_require__(1158);
__webpack_require__(1159);
__webpack_require__(1160);
__webpack_require__(1161);
__webpack_require__(1162);
__webpack_require__(1163);
__webpack_require__(1164);
__webpack_require__(1165);
__webpack_require__(1166);
__webpack_require__(1167);
__webpack_require__(1168);
__webpack_require__(1169);
__webpack_require__(1170);
__webpack_require__(1171);
__webpack_require__(1172);
__webpack_require__(1173);
__webpack_require__(1174);
__webpack_require__(1175);
__webpack_require__(1176);
__webpack_require__(1177);
__webpack_require__(1178);
__webpack_require__(1179);
__webpack_require__(1180);
__webpack_require__(1181);
__webpack_require__(1182);
__webpack_require__(1183);
__webpack_require__(1184);
__webpack_require__(1185);
__webpack_require__(1186);
__webpack_require__(1187);
__webpack_require__(1188);
__webpack_require__(1189);
__webpack_require__(1190);
__webpack_require__(1191);
__webpack_require__(1192);
__webpack_require__(1193);
__webpack_require__(1194);
__webpack_require__(1195);
__webpack_require__(1196);
__webpack_require__(1198);
__webpack_require__(1199);
__webpack_require__(1200);
__webpack_require__(1201);
__webpack_require__(1202);
__webpack_require__(1203);
__webpack_require__(1204);
__webpack_require__(1207);
__webpack_require__(1208);
__webpack_require__(1209);
__webpack_require__(1210);
__webpack_require__(1211);
__webpack_require__(1212);
__webpack_require__(1213);
__webpack_require__(1214);
__webpack_require__(1215);
__webpack_require__(1216);
__webpack_require__(1217);
__webpack_require__(1218);
__webpack_require__(1219);
__webpack_require__(406);
__webpack_require__(1220);
__webpack_require__(1221);
__webpack_require__(600);
__webpack_require__(1222);
__webpack_require__(1223);
__webpack_require__(1224);
__webpack_require__(1225);
__webpack_require__(1226);
__webpack_require__(601);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(1227);
__webpack_require__(1228);
__webpack_require__(1229);
__webpack_require__(1230);
__webpack_require__(1231);
__webpack_require__(1232);
__webpack_require__(1233);
__webpack_require__(1234);
__webpack_require__(1235);
__webpack_require__(1236);
__webpack_require__(1237);
__webpack_require__(1238);
__webpack_require__(1239);
__webpack_require__(1240);
__webpack_require__(1241);
__webpack_require__(1242);
__webpack_require__(1243);
__webpack_require__(1244);
__webpack_require__(1245);
__webpack_require__(1246);
__webpack_require__(1247);
__webpack_require__(1248);
__webpack_require__(1249);
__webpack_require__(1250);
__webpack_require__(1251);
__webpack_require__(1252);
__webpack_require__(1253);
__webpack_require__(1254);
__webpack_require__(1255);
__webpack_require__(1256);
__webpack_require__(1257);
__webpack_require__(1258);
__webpack_require__(1259);
__webpack_require__(1260);
__webpack_require__(1261);
__webpack_require__(1262);
__webpack_require__(1263);
__webpack_require__(1264);
__webpack_require__(1265);
__webpack_require__(1266);
__webpack_require__(1267);
__webpack_require__(1268);
__webpack_require__(1269);
__webpack_require__(1270);
__webpack_require__(1271);
__webpack_require__(1272);
__webpack_require__(1273);
__webpack_require__(1274);
__webpack_require__(1275);
__webpack_require__(1276);
__webpack_require__(1277);
__webpack_require__(1278);
__webpack_require__(1279);
__webpack_require__(1280);
__webpack_require__(1281);
__webpack_require__(1282);
__webpack_require__(1283);
__webpack_require__(1284);
__webpack_require__(1285);
__webpack_require__(1286);
__webpack_require__(1287);
__webpack_require__(1288);
__webpack_require__(1291);
__webpack_require__(1292);
module.exports = __webpack_require__(109);

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(22)
  , has            = __webpack_require__(56)
  , DESCRIPTORS    = __webpack_require__(34)
  , $export        = __webpack_require__(3)
  , redefine       = __webpack_require__(62)
  , META           = __webpack_require__(136).KEY
  , $fails         = __webpack_require__(25)
  , shared         = __webpack_require__(295)
  , setToStringTag = __webpack_require__(191)
  , uid            = __webpack_require__(154)
  , wks            = __webpack_require__(33)
  , wksExt         = __webpack_require__(584)
  , wksDefine      = __webpack_require__(386)
  , keyOf          = __webpack_require__(1117)
  , enumKeys       = __webpack_require__(1118)
  , isArray        = __webpack_require__(389)
  , anObject       = __webpack_require__(16)
  , toIObject      = __webpack_require__(64)
  , toPrimitive    = __webpack_require__(93)
  , createDesc     = __webpack_require__(135)
  , _create        = __webpack_require__(158)
  , gOPNExt        = __webpack_require__(587)
  , $GOPD          = __webpack_require__(72)
  , $DP            = __webpack_require__(35)
  , $keys          = __webpack_require__(156)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(159).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(233).f  = $propertyIsEnumerable;
  __webpack_require__(297).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(155)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(61)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(156)
  , toIObject = __webpack_require__(64);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(156)
  , gOPS    = __webpack_require__(297)
  , pIE     = __webpack_require__(233);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(158)});

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(34), 'Object', {defineProperty: __webpack_require__(35).f});

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(34), 'Object', {defineProperties: __webpack_require__(586)});

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(64)
  , $getOwnPropertyDescriptor = __webpack_require__(72).f;

__webpack_require__(94)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(48)
  , $getPrototypeOf = __webpack_require__(73);

__webpack_require__(94)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(48)
  , $keys    = __webpack_require__(156);

__webpack_require__(94)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(94)('getOwnPropertyNames', function(){
  return __webpack_require__(587).f;
});

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(31)
  , meta     = __webpack_require__(136).onFreeze;

__webpack_require__(94)('freeze', function($freeze){
  return function freeze(it){
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(31)
  , meta     = __webpack_require__(136).onFreeze;

__webpack_require__(94)('seal', function($seal){
  return function seal(it){
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(31)
  , meta     = __webpack_require__(136).onFreeze;

__webpack_require__(94)('preventExtensions', function($preventExtensions){
  return function preventExtensions(it){
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(31);

__webpack_require__(94)('isFrozen', function($isFrozen){
  return function isFrozen(it){
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(31);

__webpack_require__(94)('isSealed', function($isSealed){
  return function isSealed(it){
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(31);

__webpack_require__(94)('isExtensible', function($isExtensible){
  return function isExtensible(it){
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(3);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(588)});

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(3);
$export($export.S, 'Object', {is: __webpack_require__(589)});

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(3);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(391).set});

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(234)
  , test    = {};
test[__webpack_require__(33)('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  __webpack_require__(62)(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(3);

$export($export.P, 'Function', {bind: __webpack_require__(590)});

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(35).f
  , createDesc = __webpack_require__(135)
  , has        = __webpack_require__(56)
  , FProto     = Function.prototype
  , nameRE     = /^\s*function ([^ (]*)/
  , NAME       = 'name';

var isExtensible = Object.isExtensible || function(){
  return true;
};

// 19.2.4.2 name
NAME in FProto || __webpack_require__(34) && dP(FProto, NAME, {
  configurable: true,
  get: function(){
    try {
      var that = this
        , name = ('' + that).match(nameRE)[1];
      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
      return name;
    } catch(e){
      return '';
    }
  }
});

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject       = __webpack_require__(31)
  , getPrototypeOf = __webpack_require__(73)
  , HAS_INSTANCE   = __webpack_require__(33)('hasInstance')
  , FunctionProto  = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(35).f(FunctionProto, HAS_INSTANCE, {value: function(O){
  if(typeof this != 'function' || !isObject(O))return false;
  if(!isObject(this.prototype))return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
  return false;
}});

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(3)
  , $parseInt = __webpack_require__(591);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

var $export     = __webpack_require__(3)
  , $parseFloat = __webpack_require__(592);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global            = __webpack_require__(22)
  , has               = __webpack_require__(56)
  , cof               = __webpack_require__(83)
  , inheritIfRequired = __webpack_require__(393)
  , toPrimitive       = __webpack_require__(93)
  , fails             = __webpack_require__(25)
  , gOPN              = __webpack_require__(159).f
  , gOPD              = __webpack_require__(72).f
  , dP                = __webpack_require__(35).f
  , $trim             = __webpack_require__(192).trim
  , NUMBER            = 'Number'
  , $Number           = global[NUMBER]
  , Base              = $Number
  , proto             = $Number.prototype
  // Opera ~12 has broken Object#toString
  , BROKEN_COF        = cof(__webpack_require__(158)(proto)) == NUMBER
  , TRIM              = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function(argument){
  var it = toPrimitive(argument, false);
  if(typeof it == 'string' && it.length > 2){
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0)
      , third, radix, maxCode;
    if(first === 43 || first === 45){
      third = it.charCodeAt(2);
      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if(first === 48){
      switch(it.charCodeAt(1)){
        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default : return +it;
      }
      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if(code < 48 || code > maxCode)return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
  $Number = function Number(value){
    var it = arguments.length < 1 ? 0 : value
      , that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for(var keys = __webpack_require__(34) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++){
    if(has(Base, key = keys[j]) && !has($Number, key)){
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(62)(global, NUMBER, $Number);
}

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(3)
  , toInteger    = __webpack_require__(137)
  , aNumberValue = __webpack_require__(593)
  , repeat       = __webpack_require__(394)
  , $toFixed     = 1..toFixed
  , floor        = Math.floor
  , data         = [0, 0, 0, 0, 0, 0]
  , ERROR        = 'Number.toFixed: incorrect invocation!'
  , ZERO         = '0';

var multiply = function(n, c){
  var i  = -1
    , c2 = c;
  while(++i < 6){
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function(n){
  var i = 6
    , c = 0;
  while(--i >= 0){
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function(){
  var i = 6
    , s = '';
  while(--i >= 0){
    if(s !== '' || i === 0 || data[i] !== 0){
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function(x, n, acc){
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function(x){
  var n  = 0
    , x2 = x;
  while(x2 >= 4096){
    n += 12;
    x2 /= 4096;
  }
  while(x2 >= 2){
    n  += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128..toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(25)(function(){
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits){
    var x = aNumberValue(this, ERROR)
      , f = toInteger(fractionDigits)
      , s = ''
      , m = ZERO
      , e, z, j, k;
    if(f < 0 || f > 20)throw RangeError(ERROR);
    if(x != x)return 'NaN';
    if(x <= -1e21 || x >= 1e21)return String(x);
    if(x < 0){
      s = '-';
      x = -x;
    }
    if(x > 1e-21){
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if(e > 0){
        multiply(0, z);
        j = f;
        while(j >= 7){
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while(j >= 23){
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if(f > 0){
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(3)
  , $fails       = __webpack_require__(25)
  , aNumberValue = __webpack_require__(593)
  , $toPrecision = 1..toPrecision;

$export($export.P + $export.F * ($fails(function(){
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function(){
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision){
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
  }
});

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(3);

$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export   = __webpack_require__(3)
  , _isFinite = __webpack_require__(22).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it){
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', {isInteger: __webpack_require__(594)});

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', {
  isNaN: function isNaN(number){
    return number != number;
  }
});

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export   = __webpack_require__(3)
  , isInteger = __webpack_require__(594)
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var $export     = __webpack_require__(3)
  , $parseFloat = __webpack_require__(592);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(3)
  , $parseInt = __webpack_require__(591);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(3)
  , log1p   = __webpack_require__(595)
  , sqrt    = Math.sqrt
  , $acosh  = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x){
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(3)
  , $asinh  = Math.asinh;

function asinh(x){
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0 
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(3)
  , $atanh  = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0 
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x){
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(3)
  , sign    = __webpack_require__(395);

$export($export.S, 'Math', {
  cbrt: function cbrt(x){
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clz32: function clz32(x){
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(3)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x){
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(3)
  , $expm1  = __webpack_require__(396);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export   = __webpack_require__(3)
  , sign      = __webpack_require__(395)
  , pow       = Math.pow
  , EPSILON   = pow(2, -52)
  , EPSILON32 = pow(2, -23)
  , MAX32     = pow(2, 127) * (2 - EPSILON32)
  , MIN32     = pow(2, -126);

var roundTiesToEven = function(n){
  return n + 1 / EPSILON - 1 / EPSILON;
};


$export($export.S, 'Math', {
  fround: function fround(x){
    var $abs  = Math.abs(x)
      , $sign = sign(x)
      , a, result;
    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
    a = (1 + EPSILON32 / EPSILON) * $abs;
    result = a - (a - $abs);
    if(result > MAX32 || result != result)return $sign * Infinity;
    return $sign * result;
  }
});

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(3)
  , abs     = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
    var sum  = 0
      , i    = 0
      , aLen = arguments.length
      , larg = 0
      , arg, div;
    while(i < aLen){
      arg = abs(arguments[i++]);
      if(larg < arg){
        div  = larg / arg;
        sum  = sum * div * div + 1;
        larg = arg;
      } else if(arg > 0){
        div  = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(3)
  , $imul   = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(25)(function(){
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y){
    var UINT16 = 0xffff
      , xn = +x
      , yn = +y
      , xl = UINT16 & xn
      , yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log10: function log10(x){
    return Math.log(x) / Math.LN10;
  }
});

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {log1p: __webpack_require__(595)});

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log2: function log2(x){
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {sign: __webpack_require__(395)});

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(3)
  , expm1   = __webpack_require__(396)
  , exp     = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(25)(function(){
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x){
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(3)
  , expm1   = __webpack_require__(396)
  , exp     = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x){
    var a = expm1(x = +x)
      , b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  trunc: function trunc(it){
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var $export        = __webpack_require__(3)
  , toIndex        = __webpack_require__(157)
  , fromCharCode   = String.fromCharCode
  , $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
    var res  = []
      , aLen = arguments.length
      , i    = 0
      , code;
    while(aLen > i){
      code = +arguments[i++];
      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var $export   = __webpack_require__(3)
  , toIObject = __webpack_require__(64)
  , toLength  = __webpack_require__(43);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite){
    var tpl  = toIObject(callSite.raw)
      , len  = toLength(tpl.length)
      , aLen = arguments.length
      , res  = []
      , i    = 0;
    while(len > i){
      res.push(String(tpl[i++]));
      if(i < aLen)res.push(String(arguments[i]));
    } return res.join('');
  }
});

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(192)('trim', function($trim){
  return function trim(){
    return $trim(this, 3);
  };
});

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(397)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(398)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3)
  , $at     = __webpack_require__(397)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export   = __webpack_require__(3)
  , toLength  = __webpack_require__(43)
  , context   = __webpack_require__(400)
  , ENDS_WITH = 'endsWith'
  , $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(401)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /*, endPosition = @length */){
    var that = context(this, searchString, ENDS_WITH)
      , endPosition = arguments.length > 1 ? arguments[1] : undefined
      , len    = toLength(that.length)
      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
      , search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export  = __webpack_require__(3)
  , context  = __webpack_require__(400)
  , INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(401)(INCLUDES), 'String', {
  includes: function includes(searchString /*, position = 0 */){
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(394)
});

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export     = __webpack_require__(3)
  , toLength    = __webpack_require__(43)
  , context     = __webpack_require__(400)
  , STARTS_WITH = 'startsWith'
  , $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(401)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /*, position = 0 */){
    var that   = context(this, searchString, STARTS_WITH)
      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
      , search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(65)('anchor', function(createHTML){
  return function anchor(name){
    return createHTML(this, 'a', 'name', name);
  }
});

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(65)('big', function(createHTML){
  return function big(){
    return createHTML(this, 'big', '', '');
  }
});

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(65)('blink', function(createHTML){
  return function blink(){
    return createHTML(this, 'blink', '', '');
  }
});

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(65)('bold', function(createHTML){
  return function bold(){
    return createHTML(this, 'b', '', '');
  }
});

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(65)('fixed', function(createHTML){
  return function fixed(){
    return createHTML(this, 'tt', '', '');
  }
});

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(65)('fontcolor', function(createHTML){
  return function fontcolor(color){
    return createHTML(this, 'font', 'color', color);
  }
});

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(65)('fontsize', function(createHTML){
  return function fontsize(size){
    return createHTML(this, 'font', 'size', size);
  }
});

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(65)('italics', function(createHTML){
  return function italics(){
    return createHTML(this, 'i', '', '');
  }
});

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(65)('link', function(createHTML){
  return function link(url){
    return createHTML(this, 'a', 'href', url);
  }
});

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(65)('small', function(createHTML){
  return function small(){
    return createHTML(this, 'small', '', '');
  }
});

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(65)('strike', function(createHTML){
  return function strike(){
    return createHTML(this, 'strike', '', '');
  }
});

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(65)('sub', function(createHTML){
  return function sub(){
    return createHTML(this, 'sub', '', '');
  }
});

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(65)('sup', function(createHTML){
  return function sup(){
    return createHTML(this, 'sup', '', '');
  }
});

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(3);

$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export     = __webpack_require__(3)
  , toObject    = __webpack_require__(48)
  , toPrimitive = __webpack_require__(93);

$export($export.P + $export.F * __webpack_require__(25)(function(){
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
}), 'Date', {
  toJSON: function toJSON(key){
    var O  = toObject(this)
      , pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(3)
  , fails   = __webpack_require__(25)
  , getTime = Date.prototype.getTime;

var lz = function(num){
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (fails(function(){
  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
}) || !fails(function(){
  new Date(NaN).toISOString();
})), 'Date', {
  toISOString: function toISOString(){
    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
    var d = this
      , y = d.getUTCFullYear()
      , m = d.getUTCMilliseconds()
      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
  }
});

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto    = Date.prototype
  , INVALID_DATE = 'Invalid Date'
  , TO_STRING    = 'toString'
  , $toString    = DateProto[TO_STRING]
  , getTime      = DateProto.getTime;
if(new Date(NaN) + '' != INVALID_DATE){
  __webpack_require__(62)(DateProto, TO_STRING, function toString(){
    var value = getTime.call(this);
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(33)('toPrimitive')
  , proto        = Date.prototype;

if(!(TO_PRIMITIVE in proto))__webpack_require__(61)(proto, TO_PRIMITIVE, __webpack_require__(1197));

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject    = __webpack_require__(16)
  , toPrimitive = __webpack_require__(93)
  , NUMBER      = 'number';

module.exports = function(hint){
  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(3);

$export($export.S, 'Array', {isArray: __webpack_require__(389)});

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(110)
  , $export        = __webpack_require__(3)
  , toObject       = __webpack_require__(48)
  , call           = __webpack_require__(596)
  , isArrayIter    = __webpack_require__(402)
  , toLength       = __webpack_require__(43)
  , createProperty = __webpack_require__(403)
  , getIterFn      = __webpack_require__(404);

$export($export.S + $export.F * !__webpack_require__(300)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export        = __webpack_require__(3)
  , createProperty = __webpack_require__(403);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(25)(function(){
  function F(){}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */){
    var index  = 0
      , aLen   = arguments.length
      , result = new (typeof this == 'function' ? this : Array)(aLen);
    while(aLen > index)createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export   = __webpack_require__(3)
  , toIObject = __webpack_require__(64)
  , arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(232) != Object || !__webpack_require__(85)(arrayJoin)), 'Array', {
  join: function join(separator){
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export    = __webpack_require__(3)
  , html       = __webpack_require__(390)
  , cof        = __webpack_require__(83)
  , toIndex    = __webpack_require__(157)
  , toLength   = __webpack_require__(43)
  , arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(25)(function(){
  if(html)arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end){
    var len   = toLength(this.length)
      , klass = cof(this);
    end = end === undefined ? len : end;
    if(klass == 'Array')return arraySlice.call(this, begin, end);
    var start  = toIndex(begin, len)
      , upTo   = toIndex(end, len)
      , size   = toLength(upTo - start)
      , cloned = Array(size)
      , i      = 0;
    for(; i < size; i++)cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export   = __webpack_require__(3)
  , aFunction = __webpack_require__(63)
  , toObject  = __webpack_require__(48)
  , fails     = __webpack_require__(25)
  , $sort     = [].sort
  , test      = [1, 2, 3];

$export($export.P + $export.F * (fails(function(){
  // IE8-
  test.sort(undefined);
}) || !fails(function(){
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(85)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn){
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export  = __webpack_require__(3)
  , $forEach = __webpack_require__(95)(0)
  , STRICT   = __webpack_require__(85)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */){
    return $forEach(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1206);

module.exports = function(original, length){
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31)
  , isArray  = __webpack_require__(389)
  , SPECIES  = __webpack_require__(33)('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3)
  , $map    = __webpack_require__(95)(1);

$export($export.P + $export.F * !__webpack_require__(85)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */){
    return $map(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3)
  , $filter = __webpack_require__(95)(2);

$export($export.P + $export.F * !__webpack_require__(85)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */){
    return $filter(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3)
  , $some   = __webpack_require__(95)(3);

$export($export.P + $export.F * !__webpack_require__(85)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */){
    return $some(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3)
  , $every  = __webpack_require__(95)(4);

$export($export.P + $export.F * !__webpack_require__(85)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */){
    return $every(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3)
  , $reduce = __webpack_require__(597);

$export($export.P + $export.F * !__webpack_require__(85)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3)
  , $reduce = __webpack_require__(597);

$export($export.P + $export.F * !__webpack_require__(85)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */){
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export       = __webpack_require__(3)
  , $indexOf      = __webpack_require__(296)(false)
  , $native       = [].indexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(85)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export       = __webpack_require__(3)
  , toIObject     = __webpack_require__(64)
  , toInteger     = __webpack_require__(137)
  , toLength      = __webpack_require__(43)
  , $native       = [].lastIndexOf
  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(85)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
    // convert -0 to +0
    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
    var O      = toIObject(this)
      , length = toLength(O.length)
      , index  = length - 1;
    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
    if(index < 0)index = length + index;
    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
    return -1;
  }
});

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', {copyWithin: __webpack_require__(598)});

__webpack_require__(194)('copyWithin');

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', {fill: __webpack_require__(405)});

__webpack_require__(194)('fill');

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(3)
  , $find   = __webpack_require__(95)(5)
  , KEY     = 'find'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(194)(KEY);

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(3)
  , $find   = __webpack_require__(95)(6)
  , KEY     = 'findIndex'
  , forced  = true;
// Shouldn't skip holes
if(KEY in [])Array(1)[KEY](function(){ forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn/*, that = undefined */){
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(194)(KEY);

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(160)('Array');

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var global            = __webpack_require__(22)
  , inheritIfRequired = __webpack_require__(393)
  , dP                = __webpack_require__(35).f
  , gOPN              = __webpack_require__(159).f
  , isRegExp          = __webpack_require__(299)
  , $flags            = __webpack_require__(301)
  , $RegExp           = global.RegExp
  , Base              = $RegExp
  , proto             = $RegExp.prototype
  , re1               = /a/g
  , re2               = /a/g
  // "new" creates a new object, old webkit buggy here
  , CORRECT_NEW       = new $RegExp(re1) !== re1;

if(__webpack_require__(34) && (!CORRECT_NEW || __webpack_require__(25)(function(){
  re2[__webpack_require__(33)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))){
  $RegExp = function RegExp(p, f){
    var tiRE = this instanceof $RegExp
      , piRE = isRegExp(p)
      , fiU  = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function(key){
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function(){ return Base[key]; },
      set: function(it){ Base[key] = it; }
    });
  };
  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(62)(global, 'RegExp', $RegExp);
}

__webpack_require__(160)('RegExp');

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(600);
var anObject    = __webpack_require__(16)
  , $flags      = __webpack_require__(301)
  , DESCRIPTORS = __webpack_require__(34)
  , TO_STRING   = 'toString'
  , $toString   = /./[TO_STRING];

var define = function(fn){
  __webpack_require__(62)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if(__webpack_require__(25)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
  define(function toString(){
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if($toString.name != TO_STRING){
  define(function toString(){
    return $toString.call(this);
  });
}

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(302)('match', 1, function(defined, MATCH, $match){
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(302)('replace', 2, function(defined, REPLACE, $replace){
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue){
    'use strict';
    var O  = defined(this)
      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(302)('search', 1, function(defined, SEARCH, $search){
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp){
    'use strict';
    var O  = defined(this)
      , fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(302)('split', 2, function(defined, SPLIT, $split){
  'use strict';
  var isRegExp   = __webpack_require__(299)
    , _split     = $split
    , $push      = [].push
    , $SPLIT     = 'split'
    , LENGTH     = 'length'
    , LAST_INDEX = 'lastIndex';
  if(
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ){
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function(separator, limit){
      var string = String(this);
      if(separator === undefined && limit === 0)return [];
      // If `separator` is not a regex, use native split
      if(!isRegExp(separator))return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while(match = separatorCopy.exec(string)){
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if(lastIndex > lastLastIndex){
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
          });
          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if(output[LENGTH] >= splitLimit)break;
        }
        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if(lastLastIndex === string[LENGTH]){
        if(lastLength || !separatorCopy.test(''))output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
    $split = function(separator, limit){
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit){
    var O  = defined(this)
      , fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(155)
  , global             = __webpack_require__(22)
  , ctx                = __webpack_require__(110)
  , classof            = __webpack_require__(234)
  , $export            = __webpack_require__(3)
  , isObject           = __webpack_require__(31)
  , aFunction          = __webpack_require__(63)
  , anInstance         = __webpack_require__(161)
  , forOf              = __webpack_require__(195)
  , speciesConstructor = __webpack_require__(407)
  , task               = __webpack_require__(408).set
  , microtask          = __webpack_require__(409)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(33)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(162)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(191)($Promise, PROMISE);
__webpack_require__(160)(PROMISE);
Wrapper = __webpack_require__(109)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(300)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(605);

// 23.4 WeakSet Objects
__webpack_require__(303)('WeakSet', function(get){
  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value){
    return weak.def(this, value, true);
  }
}, weak, false, true);

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export      = __webpack_require__(3)
  , $typed       = __webpack_require__(304)
  , buffer       = __webpack_require__(410)
  , anObject     = __webpack_require__(16)
  , toIndex      = __webpack_require__(157)
  , toLength     = __webpack_require__(43)
  , isObject     = __webpack_require__(31)
  , ArrayBuffer  = __webpack_require__(22).ArrayBuffer
  , speciesConstructor = __webpack_require__(407)
  , $ArrayBuffer = buffer.ArrayBuffer
  , $DataView    = buffer.DataView
  , $isView      = $typed.ABV && ArrayBuffer.isView
  , $slice       = $ArrayBuffer.prototype.slice
  , VIEW         = $typed.VIEW
  , ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it){
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(25)(function(){
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end){
    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
    var len    = anObject(this).byteLength
      , first  = toIndex(start, len)
      , final  = toIndex(end === undefined ? len : end, len)
      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
      , viewS  = new $DataView(this)
      , viewT  = new $DataView(result)
      , index  = 0;
    while(first < final){
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(160)(ARRAY_BUFFER);

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
$export($export.G + $export.W + $export.F * !__webpack_require__(304).ABV, {
  DataView: __webpack_require__(410).DataView
});

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Int8', 1, function(init){
  return function Int8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Uint8', 1, function(init){
  return function Uint8Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Uint8', 1, function(init){
  return function Uint8ClampedArray(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
}, true);

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Int16', 2, function(init){
  return function Int16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Uint16', 2, function(init){
  return function Uint16Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Int32', 4, function(init){
  return function Int32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Uint32', 4, function(init){
  return function Uint32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Float32', 4, function(init){
  return function Float32Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(111)('Float64', 8, function(init){
  return function Float64Array(data, byteOffset, length){
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export   = __webpack_require__(3)
  , aFunction = __webpack_require__(63)
  , anObject  = __webpack_require__(16)
  , rApply    = (__webpack_require__(22).Reflect || {}).apply
  , fApply    = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(25)(function(){
  rApply(function(){});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList){
    var T = aFunction(target)
      , L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export    = __webpack_require__(3)
  , create     = __webpack_require__(158)
  , aFunction  = __webpack_require__(63)
  , anObject   = __webpack_require__(16)
  , isObject   = __webpack_require__(31)
  , fails      = __webpack_require__(25)
  , bind       = __webpack_require__(590)
  , rConstruct = (__webpack_require__(22).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function(){
  function F(){}
  return !(rConstruct(function(){}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function(){
  rConstruct(function(){});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /*, newTarget*/){
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
    if(Target == newTarget){
      // w/o altered newTarget, optimization for 0-4 arguments
      switch(args.length){
        case 0: return new Target;
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args));
    }
    // with altered newTarget, not support built-in constructors
    var proto    = newTarget.prototype
      , instance = create(isObject(proto) ? proto : Object.prototype)
      , result   = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP          = __webpack_require__(35)
  , $export     = __webpack_require__(3)
  , anObject    = __webpack_require__(16)
  , toPrimitive = __webpack_require__(93);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(25)(function(){
  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes){
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export  = __webpack_require__(3)
  , gOPD     = __webpack_require__(72).f
  , anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey){
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export  = __webpack_require__(3)
  , anObject = __webpack_require__(16);
var Enumerate = function(iterated){
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = []       // keys
    , key;
  for(key in iterated)keys.push(key);
};
__webpack_require__(399)(Enumerate, 'Object', function(){
  var that = this
    , keys = that._k
    , key;
  do {
    if(that._i >= keys.length)return {value: undefined, done: true};
  } while(!((key = keys[that._i++]) in that._t));
  return {value: key, done: false};
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target){
    return new Enumerate(target);
  }
});

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD           = __webpack_require__(72)
  , getPrototypeOf = __webpack_require__(73)
  , has            = __webpack_require__(56)
  , $export        = __webpack_require__(3)
  , isObject       = __webpack_require__(31)
  , anObject       = __webpack_require__(16);

function get(target, propertyKey/*, receiver*/){
  var receiver = arguments.length < 3 ? target : arguments[2]
    , desc, proto;
  if(anObject(target) === receiver)return target[propertyKey];
  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', {get: get});

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD     = __webpack_require__(72)
  , $export  = __webpack_require__(3)
  , anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return gOPD.f(anObject(target), propertyKey);
  }
});

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export  = __webpack_require__(3)
  , getProto = __webpack_require__(73)
  , anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target){
    return getProto(anObject(target));
  }
});

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey){
    return propertyKey in target;
  }
});

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export       = __webpack_require__(3)
  , anObject      = __webpack_require__(16)
  , $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target){
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', {ownKeys: __webpack_require__(606)});

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export            = __webpack_require__(3)
  , anObject           = __webpack_require__(16)
  , $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target){
    anObject(target);
    try {
      if($preventExtensions)$preventExtensions(target);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP             = __webpack_require__(35)
  , gOPD           = __webpack_require__(72)
  , getPrototypeOf = __webpack_require__(73)
  , has            = __webpack_require__(56)
  , $export        = __webpack_require__(3)
  , createDesc     = __webpack_require__(135)
  , anObject       = __webpack_require__(16)
  , isObject       = __webpack_require__(31);

function set(target, propertyKey, V/*, receiver*/){
  var receiver = arguments.length < 4 ? target : arguments[3]
    , ownDesc  = gOPD.f(anObject(target), propertyKey)
    , existingDescriptor, proto;
  if(!ownDesc){
    if(isObject(proto = getPrototypeOf(target))){
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if(has(ownDesc, 'value')){
    if(ownDesc.writable === false || !isObject(receiver))return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', {set: set});

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export  = __webpack_require__(3)
  , setProto = __webpack_require__(391);

if(setProto)$export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto){
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch(e){
      return false;
    }
  }
});

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export   = __webpack_require__(3)
  , $includes = __webpack_require__(296)(true);

$export($export.P, 'Array', {
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(194)('includes');

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(3)
  , $at     = __webpack_require__(397)(true);

$export($export.P, 'String', {
  at: function at(pos){
    return $at(this, pos);
  }
});

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3)
  , $pad    = __webpack_require__(607);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3)
  , $pad    = __webpack_require__(607);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(192)('trimLeft', function($trim){
  return function trimLeft(){
    return $trim(this, 1);
  };
}, 'trimStart');

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(192)('trimRight', function($trim){
  return function trimRight(){
    return $trim(this, 2);
  };
}, 'trimEnd');

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export     = __webpack_require__(3)
  , defined     = __webpack_require__(84)
  , toLength    = __webpack_require__(43)
  , isRegExp    = __webpack_require__(299)
  , getFlags    = __webpack_require__(301)
  , RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function(regexp, string){
  this._r = regexp;
  this._s = string;
};

__webpack_require__(399)($RegExpStringIterator, 'RegExp String', function next(){
  var match = this._r.exec(this._s);
  return {value: match, done: match === null};
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp){
    defined(this);
    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
    var S     = String(this)
      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(386)('asyncIterator');

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(386)('observable');

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export        = __webpack_require__(3)
  , ownKeys        = __webpack_require__(606)
  , toIObject      = __webpack_require__(64)
  , gOPD           = __webpack_require__(72)
  , createProperty = __webpack_require__(403);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
    var O       = toIObject(object)
      , getDesc = gOPD.f
      , keys    = ownKeys(O)
      , result  = {}
      , i       = 0
      , key;
    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
    return result;
  }
});

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3)
  , $values = __webpack_require__(608)(false);

$export($export.S, 'Object', {
  values: function values(it){
    return $values(it);
  }
});

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export  = __webpack_require__(3)
  , $entries = __webpack_require__(608)(true);

$export($export.S, 'Object', {
  entries: function entries(it){
    return $entries(it);
  }
});

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(3)
  , toObject        = __webpack_require__(48)
  , aFunction       = __webpack_require__(63)
  , $defineProperty = __webpack_require__(35);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(34) && $export($export.P + __webpack_require__(305), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter){
    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export         = __webpack_require__(3)
  , toObject        = __webpack_require__(48)
  , aFunction       = __webpack_require__(63)
  , $defineProperty = __webpack_require__(35);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(34) && $export($export.P + __webpack_require__(305), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter){
    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
  }
});

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(3)
  , toObject                 = __webpack_require__(48)
  , toPrimitive              = __webpack_require__(93)
  , getPrototypeOf           = __webpack_require__(73)
  , getOwnPropertyDescriptor = __webpack_require__(72).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(34) && $export($export.P + __webpack_require__(305), 'Object', {
  __lookupGetter__: function __lookupGetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.get;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export                  = __webpack_require__(3)
  , toObject                 = __webpack_require__(48)
  , toPrimitive              = __webpack_require__(93)
  , getPrototypeOf           = __webpack_require__(73)
  , getOwnPropertyDescriptor = __webpack_require__(72).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(34) && $export($export.P + __webpack_require__(305), 'Object', {
  __lookupSetter__: function __lookupSetter__(P){
    var O = toObject(this)
      , K = toPrimitive(P, true)
      , D;
    do {
      if(D = getOwnPropertyDescriptor(O, K))return D.set;
    } while(O = getPrototypeOf(O));
  }
});

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(3);

$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(609)('Map')});

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export  = __webpack_require__(3);

$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(609)('Set')});

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-global
var $export = __webpack_require__(3);

$export($export.S, 'System', {global: __webpack_require__(22)});

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(3)
  , cof     = __webpack_require__(83);

$export($export.S, 'Error', {
  isError: function isError(it){
    return cof(it) === 'Error';
  }
});

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1){
    var $x0 = x0 >>> 0
      , $x1 = x1 >>> 0
      , $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  imulh: function imulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >> 16
      , v1 = $v >> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  umulh: function umulh(u, v){
    var UINT16 = 0xffff
      , $u = +u
      , $v = +v
      , u0 = $u & UINT16
      , v0 = $v & UINT16
      , u1 = $u >>> 16
      , v1 = $v >>> 16
      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                  = __webpack_require__(112)
  , anObject                  = __webpack_require__(16)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
}});

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(112)
  , anObject               = __webpack_require__(16)
  , toMetaKey              = metadata.key
  , getOrCreateMetadataMap = metadata.map
  , store                  = metadata.store;

metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
  if(metadataMap.size)return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
}});

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(112)
  , anObject               = __webpack_require__(16)
  , getPrototypeOf         = __webpack_require__(73)
  , ordinaryHasOwnMetadata = metadata.has
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

var ordinaryGetMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

var Set                     = __webpack_require__(603)
  , from                    = __webpack_require__(610)
  , metadata                = __webpack_require__(112)
  , anObject                = __webpack_require__(16)
  , getPrototypeOf          = __webpack_require__(73)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

var ordinaryMetadataKeys = function(O, P){
  var oKeys  = ordinaryOwnMetadataKeys(O, P)
    , parent = getPrototypeOf(O);
  if(parent === null)return oKeys;
  var pKeys  = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(112)
  , anObject               = __webpack_require__(16)
  , ordinaryGetOwnMetadata = metadata.get
  , toMetaKey              = metadata.key;

metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                = __webpack_require__(112)
  , anObject                = __webpack_require__(16)
  , ordinaryOwnMetadataKeys = metadata.keys
  , toMetaKey               = metadata.key;

metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
}});

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(112)
  , anObject               = __webpack_require__(16)
  , getPrototypeOf         = __webpack_require__(73)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

var ordinaryHasMetadata = function(MetadataKey, O, P){
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if(hasOwn)return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var metadata               = __webpack_require__(112)
  , anObject               = __webpack_require__(16)
  , ordinaryHasOwnMetadata = metadata.has
  , toMetaKey              = metadata.key;

metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
}});

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

var metadata                  = __webpack_require__(112)
  , anObject                  = __webpack_require__(16)
  , aFunction                 = __webpack_require__(63)
  , toMetaKey                 = metadata.key
  , ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({metadata: function metadata(metadataKey, metadataValue){
  return function decorator(target, targetKey){
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
}});

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export   = __webpack_require__(3)
  , microtask = __webpack_require__(409)()
  , process   = __webpack_require__(22).process
  , isNode    = __webpack_require__(83)(process) == 'process';

$export($export.G, {
  asap: function asap(fn){
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export     = __webpack_require__(3)
  , global      = __webpack_require__(22)
  , core        = __webpack_require__(109)
  , microtask   = __webpack_require__(409)()
  , OBSERVABLE  = __webpack_require__(33)('observable')
  , aFunction   = __webpack_require__(63)
  , anObject    = __webpack_require__(16)
  , anInstance  = __webpack_require__(161)
  , redefineAll = __webpack_require__(162)
  , hide        = __webpack_require__(61)
  , forOf       = __webpack_require__(195)
  , RETURN      = forOf.RETURN;

var getMethod = function(fn){
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function(subscription){
  var cleanup = subscription._c;
  if(cleanup){
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function(subscription){
  return subscription._o === undefined;
};

var closeSubscription = function(subscription){
  if(!subscriptionClosed(subscription)){
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function(observer, subscriber){
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup      = subscriber(observer)
      , subscription = cleanup;
    if(cleanup != null){
      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch(e){
    observer.error(e);
    return;
  } if(subscriptionClosed(this))cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe(){ closeSubscription(this); }
});

var SubscriptionObserver = function(subscription){
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if(m)return m.call(observer, value);
      } catch(e){
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value){
    var subscription = this._s;
    if(subscriptionClosed(subscription))throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if(!m)throw value;
      value = m.call(observer, value);
    } catch(e){
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value){
    var subscription = this._s;
    if(!subscriptionClosed(subscription)){
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch(e){
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber){
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer){
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn){
    var that = this;
    return new (core.Promise || global.Promise)(function(resolve, reject){
      aFunction(fn);
      var subscription = that.subscribe({
        next : function(value){
          try {
            return fn(value);
          } catch(e){
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x){
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if(method){
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function(observer){
        return observable.subscribe(observer);
      });
    }
    return new C(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          try {
            if(forOf(x, false, function(it){
              observer.next(it);
              if(done)return RETURN;
            }) === RETURN)return;
          } catch(e){
            if(done)throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  },
  of: function of(){
    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function(observer){
      var done = false;
      microtask(function(){
        if(!done){
          for(var i = 0; i < items.length; ++i){
            observer.next(items[i]);
            if(done)return;
          } observer.complete();
        }
      });
      return function(){ done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function(){ return this; });

$export($export.G, {Observable: $Observable});

__webpack_require__(160)('Observable');

/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global     = __webpack_require__(22)
  , $export    = __webpack_require__(3)
  , invoke     = __webpack_require__(298)
  , partial    = __webpack_require__(1289)
  , navigator  = global.navigator
  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function(set){
  return MSIE ? function(fn, time /*, ...args */){
    return set(invoke(
      partial,
      [].slice.call(arguments, 2),
      typeof fn == 'function' ? fn : Function(fn)
    ), time);
  } : set;
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout:  wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var path      = __webpack_require__(1290)
  , invoke    = __webpack_require__(298)
  , aFunction = __webpack_require__(63);
module.exports = function(/* ...pargs */){
  var fn     = aFunction(this)
    , length = arguments.length
    , pargs  = Array(length)
    , i      = 0
    , _      = path._
    , holder = false;
  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
  return function(/* ...args */){
    var that = this
      , aLen = arguments.length
      , j = 0, k = 0, args;
    if(!holder && !aLen)return invoke(fn, pargs, that);
    args = pargs.slice();
    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
    while(aLen > k)args.push(arguments[k++]);
    return invoke(fn, args, that);
  };
};

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(22);

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3)
  , $task   = __webpack_require__(408);
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators    = __webpack_require__(406)
  , redefine      = __webpack_require__(62)
  , global        = __webpack_require__(22)
  , hide          = __webpack_require__(61)
  , Iterators     = __webpack_require__(193)
  , wks           = __webpack_require__(33)
  , ITERATOR      = wks('iterator')
  , TO_STRING_TAG = wks('toStringTag')
  , ArrayValues   = Iterators.Array;

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype
    , key;
  if(proto){
    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
  }
}

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1295);
module.exports = __webpack_require__(109).RegExp.escape;

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(3)
  , $re     = __webpack_require__(1296)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ }),
/* 1296 */
/***/ (function(module, exports) {

module.exports = function(regExp, replace){
  var replacer = replace === Object(replace) ? function(part){
    return replace[part];
  } : replace;
  return function(it){
    return String(it).replace(regExp, replacer);
  };
};

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = initializePolyfills;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_search_params_polyfill__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url_search_params_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url_search_params_polyfill__);
// This contains what `react-intl` needs for all versions of English
// so it's loaded upfront as our default is UK English.
Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* addLocaleData */])(__WEBPACK_IMPORTED_MODULE_1_react_intl_locale_data_en___default.a);function initializePolyfills(){return Promise.all([polyfillIntl()]);}function polyfillIntl(){return new Promise(function(resolve,reject){if('Intl'in global){return resolve();}__webpack_require__.e/* require.ensure */(199).then((function(require){__webpack_require__(2580);__webpack_require__(2581);resolve();}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);});}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1300), src$en$$ = __webpack_require__(1305);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(612), src$es5$$ = __webpack_require__(1301), src$compiler$$ = __webpack_require__(1302), intl$messageformat$parser$$ = __webpack_require__(1303);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
        return messageFormat._format(pattern, values);
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
            throw new Error('A value must be provided for: ' + id);
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(612);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value) {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1304)['default'];
exports['default'] = exports;


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = [],
        peg$c1 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements
                };
            },
        peg$c2 = peg$FAILED,
        peg$c3 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c4 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText
                };
            },
        peg$c5 = /^[^ \t\n\r,.+={}#]/,
        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c7 = "{",
        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c9 = null,
        peg$c10 = ",",
        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
        peg$c12 = "}",
        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c14 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2]
                };
            },
        peg$c15 = "number",
        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c17 = "date",
        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c19 = "time",
        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c21 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2]
                };
            },
        peg$c22 = "plural",
        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                };
            },
        peg$c25 = "selectordinal",
        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c27 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                }
            },
        peg$c28 = "select",
        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c30 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options
                };
            },
        peg$c31 = "=",
        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c33 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern
                };
            },
        peg$c34 = "offset:",
        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c36 = function(number) {
                return number;
            },
        peg$c37 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options
                };
            },
        peg$c38 = { type: "other", description: "whitespace" },
        peg$c39 = /^[ \t\n\r]/,
        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c41 = { type: "other", description: "optionalWhitespace" },
        peg$c42 = /^[0-9]/,
        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c44 = /^[0-9a-f]/i,
        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c46 = "0",
        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c48 = /^[1-9]/,
        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c50 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
        peg$c53 = "\\\\",
        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c55 = function() { return '\\'; },
        peg$c56 = "\\#",
        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c58 = function() { return '\\#'; },
        peg$c59 = "\\{",
        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c61 = function() { return '\u007B'; },
        peg$c62 = "\\}",
        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c64 = function() { return '\u007D'; },
        peg$c65 = "\\u",
        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c67 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c68 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$c2;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c2;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c2;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c5.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c5.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
          }
        } else {
          s1 = peg$c2;
        }
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c8); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c10;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c11); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$c2;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$c2;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$c2;
              }
              if (s5 === peg$FAILED) {
                s5 = peg$c9;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c12;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c14(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c15) {
        s1 = peg$c15;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c16); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c17) {
          s1 = peg$c17;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c18); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c20); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c10;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c2;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c2;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c2;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$c9;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c21(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c28) {
        s1 = peg$c28;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$c2;
              }
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c31;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$c2;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c7;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c12;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s0;
                      s1 = peg$c33(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c2;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c36(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = peg$c9;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$c2;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c37(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s0 = peg$c2;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c42.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c43); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c44.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c46;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
        if (s2 !== peg$FAILED) {
          s2 = input.substring(s1, peg$currPos);
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c50(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c51.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c53) {
          s1 = peg$c53;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c54); }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c55();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c56) {
            s1 = peg$c56;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c58();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c59) {
              s1 = peg$c59;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c60); }
            }
            if (s1 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c61();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c62) {
                s1 = peg$c62;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c63); }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c64();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c65) {
                  s1 = peg$c65;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$c2;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$c2;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$c2;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$c2;
                  }
                  if (s3 !== peg$FAILED) {
                    s3 = input.substring(s2, peg$currPos);
                  }
                  s2 = s3;
                  if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c67(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c68(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(1308)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(1313);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(1309), src$en$$ = __webpack_require__(1312);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__(611), src$diff$$ = __webpack_require__(1310), src$es5$$ = __webpack_require__(1311);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45,  // seconds to minute
        minute: 45,  // minutes to hour
        hour  : 22,  // hours to day
        day   : 26,  // days to month
        month : 11   // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;

    for (i = 0, l = FIELDS.length; i < l; i += 1) {
        units = FIELDS[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond: millisecond,
        second     : second,
        minute     : minute,
        hour       : hour,
        day        : day,
        week       : week,
        month      : month,
        year       : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(100);
var invariant = __webpack_require__(86);
var ReactPropTypesSecret = __webpack_require__(613);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(77),n=__webpack_require__(269),p=__webpack_require__(100),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.portal"):60106,u=q?Symbol["for"]("react.fragment"):60107,v=q?Symbol["for"]("react.strict_mode"):60108,w=q?Symbol["for"]("react.provider"):60109,x=q?Symbol["for"]("react.context"):60110,y=q?Symbol["for"]("react.async_mode"):60111,z=q?Symbol["for"]("react.forward_ref"):60112,A="function"===
typeof Symbol&&Symbol.iterator;function B(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function D(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||C}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}
E.prototype=D.prototype;function F(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||C}var G=F.prototype=new E;G.constructor=F;m(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I=Object.prototype.hasOwnProperty,J={key:!0,ref:!0,__self:!0,__source:!0};
function K(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)I.call(b,c)&&!J.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:h,props:d,_owner:H.current}}
function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g,N=[];function O(a,b,e,c){if(N.length){var d=N.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function P(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>N.length&&N.push(a)}
function Q(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:g=!0}}if(g)return e(c,a,""===b?"."+R(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+R(d,h);g+=Q(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+R(d,h++),g+=Q(d,f,e,c);else"object"===d&&(e=""+a,B("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function R(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function S(a,b){a.func.call(a.context,b,a.count++)}
function T(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?U(a,c,e,p.thatReturnsArgument):null!=a&&(L(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(M,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function U(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(M,"$\x26/")+"/");b=O(b,g,c,d);null==a||Q(a,"",T,b);P(b)}
var V={Children:{map:function(a,b,e){if(null==a)return a;var c=[];U(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=O(null,null,b,e);null==a||Q(a,"",S,b);P(b)},count:function(a){return null==a?0:Q(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];U(a,b,null,p.thatReturnsArgument);return b},only:function(a){L(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:x,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:w,context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:z,render:a}},Fragment:u,StrictMode:v,unstable_AsyncMode:y,createElement:K,cloneElement:function(a,b,e){var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=H.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&(k=a.type.defaultProps);for(c in b)I.call(b,
c)&&!J.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:r,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=K.bind(null,a);b.type=a;return b},isValidElement:L,version:"16.3.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:H,assign:m}},W=Object.freeze({default:V}),X=W&&V||W;
module.exports=X["default"]?X["default"]:X;


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(1317)['default'];
exports['default'] = exports;


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var src$es5$$ = __webpack_require__(1318);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill

var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

(function(self) {
    'use strict';

    var nativeURLSearchParams = self.URLSearchParams ? self.URLSearchParams : null,
        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
        __URLSearchParams__ = "__URLSearchParams__",
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor) {
        return;
    }


    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }

        this [__URLSearchParams__] = parseToDict(search);
    }


    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function(name, value) {
        appendTo(this [__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype.delete = function(name) {
        delete this [__URLSearchParams__] [name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function(name) {
        var dict = this [__URLSearchParams__];
        return name in dict ? dict [name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function(name) {
        return name in this [__URLSearchParams__];
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this [__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };


    /*
     * Apply polifill to global object and append other prototype into it
     */
    self.URLSearchParams = (nativeURLSearchParams && !isSupportObjectConstructor) ?
        new Proxy(nativeURLSearchParams, {
            construct: function(target, args) {
                return new target((new URLSearchParamsPolyfill(args[0]).toString()));
            }
        }) :
        URLSearchParamsPolyfill;


    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this.delete(keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i], values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name]);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push([item]);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };


    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }


    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }

    function decode(str) {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    }

    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {done: value === undefined, value: value};
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function() {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            for (var i in search) {
                if (search.hasOwnProperty(i)) {
                    var str = typeof search [i] === 'string' ? search [i] : JSON.stringify(search [i]);
                    appendTo(dict, i, str);
                }
            }

        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs [j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        if (name in dict) {
            dict[name].push('' + value);
        } else {
            dict[name] = ['' + value];
        }
    }

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false */

var TraceKit = __webpack_require__(1321);
var stringify = __webpack_require__(1322);
var RavenConfigError = __webpack_require__(1323);

var utils = __webpack_require__(615);
var isError = utils.isError;
var isObject = utils.isObject;
var isErrorEvent = utils.isErrorEvent;
var isUndefined = utils.isUndefined;
var isFunction = utils.isFunction;
var isString = utils.isString;
var isArray = utils.isArray;
var isEmptyObject = utils.isEmptyObject;
var each = utils.each;
var objectMerge = utils.objectMerge;
var truncate = utils.truncate;
var objectFrozen = utils.objectFrozen;
var hasKey = utils.hasKey;
var joinRegExp = utils.joinRegExp;
var urlencode = utils.urlencode;
var uuid4 = utils.uuid4;
var htmlTreeAsString = utils.htmlTreeAsString;
var isSameException = utils.isSameException;
var isSameStacktrace = utils.isSameStacktrace;
var parseUrl = utils.parseUrl;
var fill = utils.fill;
var supportsFetch = utils.supportsFetch;

var wrapConsoleMethod = __webpack_require__(1324).wrapMethod;

var dsnKeys = 'source protocol user pass host port path'.split(' '),
  dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;

function now() {
  return +new Date();
}

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var _document = _window.document;
var _navigator = _window.navigator;

function keepOriginalCallback(original, callback) {
  return isFunction(callback)
    ? function(data) {
        return callback(data, original);
      }
    : callback;
}

// First, check for JSON support
// If there is no JSON, we no-op the core features of Raven
// since JSON is required to encode the payload
function Raven() {
  this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
  // Raven can run in contexts where there's no document (react-native)
  this._hasDocument = !isUndefined(_document);
  this._hasNavigator = !isUndefined(_navigator);
  this._lastCapturedException = null;
  this._lastData = null;
  this._lastEventId = null;
  this._globalServer = null;
  this._globalKey = null;
  this._globalProject = null;
  this._globalContext = {};
  this._globalOptions = {
    logger: 'javascript',
    ignoreErrors: [],
    ignoreUrls: [],
    whitelistUrls: [],
    includePaths: [],
    headers: null,
    collectWindowErrors: true,
    maxMessageLength: 0,

    // By default, truncates URL values to 250 chars
    maxUrlLength: 250,
    stackTraceLimit: 50,
    autoBreadcrumbs: true,
    instrument: true,
    sampleRate: 1
  };
  this._ignoreOnError = 0;
  this._isRavenInstalled = false;
  this._originalErrorStackTraceLimit = Error.stackTraceLimit;
  // capture references to window.console *and* all its methods first
  // before the console plugin has a chance to monkey patch
  this._originalConsole = _window.console || {};
  this._originalConsoleMethods = {};
  this._plugins = [];
  this._startTime = now();
  this._wrappedBuiltIns = [];
  this._breadcrumbs = [];
  this._lastCapturedEvent = null;
  this._keypressTimeout;
  this._location = _window.location;
  this._lastHref = this._location && this._location.href;
  this._resetBackoff();

  // eslint-disable-next-line guard-for-in
  for (var method in this._originalConsole) {
    this._originalConsoleMethods[method] = this._originalConsole[method];
  }
}

/*
 * The core Raven singleton
 *
 * @this {Raven}
 */

Raven.prototype = {
  // Hardcode version string so that raven source can be loaded directly via
  // webpack (using a build step causes webpack #1617). Grunt verifies that
  // this value matches package.json during build.
  //   See: https://github.com/getsentry/raven-js/issues/465
  VERSION: '3.21.0',

  debug: false,

  TraceKit: TraceKit, // alias to TraceKit

  /*
     * Configure Raven with a DSN and extra options
     *
     * @param {string} dsn The public Sentry DSN
     * @param {object} options Set of global options [optional]
     * @return {Raven}
     */
  config: function(dsn, options) {
    var self = this;

    if (self._globalServer) {
      this._logDebug('error', 'Error: Raven has already been configured');
      return self;
    }
    if (!dsn) return self;

    var globalOptions = self._globalOptions;

    // merge in options
    if (options) {
      each(options, function(key, value) {
        // tags and extra are special and need to be put into context
        if (key === 'tags' || key === 'extra' || key === 'user') {
          self._globalContext[key] = value;
        } else {
          globalOptions[key] = value;
        }
      });
    }

    self.setDSN(dsn);

    // "Script error." is hard coded into browsers for errors that it can't read.
    // this is the result of a script being pulled in from an external domain and CORS.
    globalOptions.ignoreErrors.push(/^Script error\.?$/);
    globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);

    // join regexp rules into one big rule
    globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
    globalOptions.ignoreUrls = globalOptions.ignoreUrls.length
      ? joinRegExp(globalOptions.ignoreUrls)
      : false;
    globalOptions.whitelistUrls = globalOptions.whitelistUrls.length
      ? joinRegExp(globalOptions.whitelistUrls)
      : false;
    globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
    globalOptions.maxBreadcrumbs = Math.max(
      0,
      Math.min(globalOptions.maxBreadcrumbs || 100, 100)
    ); // default and hard limit is 100

    var autoBreadcrumbDefaults = {
      xhr: true,
      console: true,
      dom: true,
      location: true,
      sentry: true
    };

    var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
    if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
      autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
    } else if (autoBreadcrumbs !== false) {
      autoBreadcrumbs = autoBreadcrumbDefaults;
    }
    globalOptions.autoBreadcrumbs = autoBreadcrumbs;

    var instrumentDefaults = {
      tryCatch: true
    };

    var instrument = globalOptions.instrument;
    if ({}.toString.call(instrument) === '[object Object]') {
      instrument = objectMerge(instrumentDefaults, instrument);
    } else if (instrument !== false) {
      instrument = instrumentDefaults;
    }
    globalOptions.instrument = instrument;

    TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;

    // return for chaining
    return self;
  },

  /*
     * Installs a global window.onerror error handler
     * to capture and report uncaught exceptions.
     * At this point, install() is required to be called due
     * to the way TraceKit is set up.
     *
     * @return {Raven}
     */
  install: function() {
    var self = this;
    if (self.isSetup() && !self._isRavenInstalled) {
      TraceKit.report.subscribe(function() {
        self._handleOnErrorStackInfo.apply(self, arguments);
      });

      self._patchFunctionToString();

      if (self._globalOptions.instrument && self._globalOptions.instrument.tryCatch) {
        self._instrumentTryCatch();
      }

      if (self._globalOptions.autoBreadcrumbs) self._instrumentBreadcrumbs();

      // Install all of the plugins
      self._drainPlugins();

      self._isRavenInstalled = true;
    }

    Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
    return this;
  },

  /*
     * Set the DSN (can be called multiple time unlike config)
     *
     * @param {string} dsn The public Sentry DSN
     */
  setDSN: function(dsn) {
    var self = this,
      uri = self._parseDSN(dsn),
      lastSlash = uri.path.lastIndexOf('/'),
      path = uri.path.substr(1, lastSlash);

    self._dsn = dsn;
    self._globalKey = uri.user;
    self._globalSecret = uri.pass && uri.pass.substr(1);
    self._globalProject = uri.path.substr(lastSlash + 1);

    self._globalServer = self._getGlobalServer(uri);

    self._globalEndpoint =
      self._globalServer + '/' + path + 'api/' + self._globalProject + '/store/';

    // Reset backoff state since we may be pointing at a
    // new project/server
    this._resetBackoff();
  },

  /*
     * Wrap code within a context so Raven can capture errors
     * reliably across domains that is executed immediately.
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The callback to be immediately executed within the context
     * @param {array} args An array of arguments to be called with the callback [optional]
     */
  context: function(options, func, args) {
    if (isFunction(options)) {
      args = func || [];
      func = options;
      options = undefined;
    }

    return this.wrap(options, func).apply(this, args);
  },

  /*
     * Wrap code within a context and returns back a new function to be executed
     *
     * @param {object} options A specific set of options for this context [optional]
     * @param {function} func The function to be wrapped in a new context
     * @param {function} func A function to call before the try/catch wrapper [optional, private]
     * @return {function} The newly wrapped functions with a context
     */
  wrap: function(options, func, _before) {
    var self = this;
    // 1 argument has been passed, and it's not a function
    // so just return it
    if (isUndefined(func) && !isFunction(options)) {
      return options;
    }

    // options is optional
    if (isFunction(options)) {
      func = options;
      options = undefined;
    }

    // At this point, we've passed along 2 arguments, and the second one
    // is not a function either, so we'll just return the second argument.
    if (!isFunction(func)) {
      return func;
    }

    // We don't wanna wrap it twice!
    try {
      if (func.__raven__) {
        return func;
      }

      // If this has already been wrapped in the past, return that
      if (func.__raven_wrapper__) {
        return func.__raven_wrapper__;
      }
    } catch (e) {
      // Just accessing custom props in some Selenium environments
      // can cause a "Permission denied" exception (see raven-js#495).
      // Bail on wrapping and return the function as-is (defers to window.onerror).
      return func;
    }

    function wrapped() {
      var args = [],
        i = arguments.length,
        deep = !options || (options && options.deep !== false);

      if (_before && isFunction(_before)) {
        _before.apply(this, arguments);
      }

      // Recursively wrap all of a function's arguments that are
      // functions themselves.
      while (i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];

      try {
        // Attempt to invoke user-land function
        // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
        //       means Raven caught an error invoking your application code. This is
        //       expected behavior and NOT indicative of a bug with Raven.js.
        return func.apply(this, args);
      } catch (e) {
        self._ignoreNextOnError();
        self.captureException(e, options);
        throw e;
      }
    }

    // copy over properties of the old function
    for (var property in func) {
      if (hasKey(func, property)) {
        wrapped[property] = func[property];
      }
    }
    wrapped.prototype = func.prototype;

    func.__raven_wrapper__ = wrapped;
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    wrapped.__raven__ = true;
    wrapped.__orig__ = func;

    return wrapped;
  },

  /*
     * Uninstalls the global error handler.
     *
     * @return {Raven}
     */
  uninstall: function() {
    TraceKit.report.uninstall();

    this._unpatchFunctionToString();
    this._restoreBuiltIns();

    Error.stackTraceLimit = this._originalErrorStackTraceLimit;
    this._isRavenInstalled = false;

    return this;
  },

  /*
     * Manually capture an exception and send it over to Sentry
     *
     * @param {error} ex An exception to be logged
     * @param {object} options A specific set of options for this error [optional]
     * @return {Raven}
     */
  captureException: function(ex, options) {
    // Cases for sending ex as a message, rather than an exception
    var isNotError = !isError(ex);
    var isNotErrorEvent = !isErrorEvent(ex);
    var isErrorEventWithoutError = isErrorEvent(ex) && !ex.error;

    if ((isNotError && isNotErrorEvent) || isErrorEventWithoutError) {
      return this.captureMessage(
        ex,
        objectMerge(
          {
            trimHeadFrames: 1,
            stacktrace: true // if we fall back to captureMessage, default to attempting a new trace
          },
          options
        )
      );
    }

    // Get actual Error from ErrorEvent
    if (isErrorEvent(ex)) ex = ex.error;

    // Store the raw exception object for potential debugging and introspection
    this._lastCapturedException = ex;

    // TraceKit.report will re-raise any exception passed to it,
    // which means you have to wrap it in try/catch. Instead, we
    // can wrap it here and only re-raise if TraceKit.report
    // raises an exception different from the one we asked to
    // report on.
    try {
      var stack = TraceKit.computeStackTrace(ex);
      this._handleStackInfo(stack, options);
    } catch (ex1) {
      if (ex !== ex1) {
        throw ex1;
      }
    }

    return this;
  },

  /*
     * Manually send a message to Sentry
     *
     * @param {string} msg A plain message to be captured in Sentry
     * @param {object} options A specific set of options for this message [optional]
     * @return {Raven}
     */
  captureMessage: function(msg, options) {
    // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
    // early call; we'll error on the side of logging anything called before configuration since it's
    // probably something you should see:
    if (
      !!this._globalOptions.ignoreErrors.test &&
      this._globalOptions.ignoreErrors.test(msg)
    ) {
      return;
    }

    options = options || {};

    var data = objectMerge(
      {
        message: msg + '' // Make sure it's actually a string
      },
      options
    );

    var ex;
    // Generate a "synthetic" stack trace from this point.
    // NOTE: If you are a Sentry user, and you are seeing this stack frame, it is NOT indicative
    //       of a bug with Raven.js. Sentry generates synthetic traces either by configuration,
    //       or if it catches a thrown object without a "stack" property.
    try {
      throw new Error(msg);
    } catch (ex1) {
      ex = ex1;
    }

    // null exception name so `Error` isn't prefixed to msg
    ex.name = null;
    var stack = TraceKit.computeStackTrace(ex);

    // stack[0] is `throw new Error(msg)` call itself, we are interested in the frame that was just before that, stack[1]
    var initialCall = isArray(stack.stack) && stack.stack[1];
    var fileurl = (initialCall && initialCall.url) || '';

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
      options = objectMerge(
        {
          // fingerprint on msg, not stack trace (legacy behavior, could be
          // revisited)
          fingerprint: msg,
          // since we know this is a synthetic trace, the top N-most frames
          // MUST be from Raven.js, so mark them as in_app later by setting
          // trimHeadFrames
          trimHeadFrames: (options.trimHeadFrames || 0) + 1
        },
        options
      );

      var frames = this._prepareFrames(stack, options);
      data.stacktrace = {
        // Sentry expects frames oldest to newest
        frames: frames.reverse()
      };
    }

    // Fire away!
    this._send(data);

    return this;
  },

  captureBreadcrumb: function(obj) {
    var crumb = objectMerge(
      {
        timestamp: now() / 1000
      },
      obj
    );

    if (isFunction(this._globalOptions.breadcrumbCallback)) {
      var result = this._globalOptions.breadcrumbCallback(crumb);

      if (isObject(result) && !isEmptyObject(result)) {
        crumb = result;
      } else if (result === false) {
        return this;
      }
    }

    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
      this._breadcrumbs.shift();
    }
    return this;
  },

  addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
    var pluginArgs = [].slice.call(arguments, 1);

    this._plugins.push([plugin, pluginArgs]);
    if (this._isRavenInstalled) {
      this._drainPlugins();
    }

    return this;
  },

  /*
     * Set/clear a user to be sent along with the payload.
     *
     * @param {object} user An object representing user data [optional]
     * @return {Raven}
     */
  setUserContext: function(user) {
    // Intentionally do not merge here since that's an unexpected behavior.
    this._globalContext.user = user;

    return this;
  },

  /*
     * Merge extra attributes to be sent along with the payload.
     *
     * @param {object} extra An object representing extra data [optional]
     * @return {Raven}
     */
  setExtraContext: function(extra) {
    this._mergeContext('extra', extra);

    return this;
  },

  /*
     * Merge tags to be sent along with the payload.
     *
     * @param {object} tags An object representing tags [optional]
     * @return {Raven}
     */
  setTagsContext: function(tags) {
    this._mergeContext('tags', tags);

    return this;
  },

  /*
     * Clear all of the context.
     *
     * @return {Raven}
     */
  clearContext: function() {
    this._globalContext = {};

    return this;
  },

  /*
     * Get a copy of the current context. This cannot be mutated.
     *
     * @return {object} copy of context
     */
  getContext: function() {
    // lol javascript
    return JSON.parse(stringify(this._globalContext));
  },

  /*
     * Set environment of application
     *
     * @param {string} environment Typically something like 'production'.
     * @return {Raven}
     */
  setEnvironment: function(environment) {
    this._globalOptions.environment = environment;

    return this;
  },

  /*
     * Set release version of application
     *
     * @param {string} release Typically something like a git SHA to identify version
     * @return {Raven}
     */
  setRelease: function(release) {
    this._globalOptions.release = release;

    return this;
  },

  /*
     * Set the dataCallback option
     *
     * @param {function} callback The callback to run which allows the
     *                            data blob to be mutated before sending
     * @return {Raven}
     */
  setDataCallback: function(callback) {
    var original = this._globalOptions.dataCallback;
    this._globalOptions.dataCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the breadcrumbCallback option
     *
     * @param {function} callback The callback to run which allows filtering
     *                            or mutating breadcrumbs
     * @return {Raven}
     */
  setBreadcrumbCallback: function(callback) {
    var original = this._globalOptions.breadcrumbCallback;
    this._globalOptions.breadcrumbCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /*
     * Set the shouldSendCallback option
     *
     * @param {function} callback The callback to run which allows
     *                            introspecting the blob before sending
     * @return {Raven}
     */
  setShouldSendCallback: function(callback) {
    var original = this._globalOptions.shouldSendCallback;
    this._globalOptions.shouldSendCallback = keepOriginalCallback(original, callback);
    return this;
  },

  /**
   * Override the default HTTP transport mechanism that transmits data
   * to the Sentry server.
   *
   * @param {function} transport Function invoked instead of the default
   *                             `makeRequest` handler.
   *
   * @return {Raven}
   */
  setTransport: function(transport) {
    this._globalOptions.transport = transport;

    return this;
  },

  /*
     * Get the latest raw exception that was captured by Raven.
     *
     * @return {error}
     */
  lastException: function() {
    return this._lastCapturedException;
  },

  /*
     * Get the last event id
     *
     * @return {string}
     */
  lastEventId: function() {
    return this._lastEventId;
  },

  /*
     * Determine if Raven is setup and ready to go.
     *
     * @return {boolean}
     */
  isSetup: function() {
    if (!this._hasJSON) return false; // needs JSON support
    if (!this._globalServer) {
      if (!this.ravenNotConfiguredError) {
        this.ravenNotConfiguredError = true;
        this._logDebug('error', 'Error: Raven has not been configured.');
      }
      return false;
    }
    return true;
  },

  afterLoad: function() {
    // TODO: remove window dependence?

    // Attempt to initialize Raven on load
    var RavenConfig = _window.RavenConfig;
    if (RavenConfig) {
      this.config(RavenConfig.dsn, RavenConfig.config).install();
    }
  },

  showReportDialog: function(options) {
    if (
      !_document // doesn't work without a document (React native)
    )
      return;

    options = options || {};

    var lastEventId = options.eventId || this.lastEventId();
    if (!lastEventId) {
      throw new RavenConfigError('Missing eventId');
    }

    var dsn = options.dsn || this._dsn;
    if (!dsn) {
      throw new RavenConfigError('Missing DSN');
    }

    var encode = encodeURIComponent;
    var qs = '';
    qs += '?eventId=' + encode(lastEventId);
    qs += '&dsn=' + encode(dsn);

    var user = options.user || this._globalContext.user;
    if (user) {
      if (user.name) qs += '&name=' + encode(user.name);
      if (user.email) qs += '&email=' + encode(user.email);
    }

    var globalServer = this._getGlobalServer(this._parseDSN(dsn));

    var script = _document.createElement('script');
    script.async = true;
    script.src = globalServer + '/api/embed/error-page/' + qs;
    (_document.head || _document.body).appendChild(script);
  },

  /**** Private functions ****/
  _ignoreNextOnError: function() {
    var self = this;
    this._ignoreOnError += 1;
    setTimeout(function() {
      // onerror should trigger before setTimeout
      self._ignoreOnError -= 1;
    });
  },

  _triggerEvent: function(eventType, options) {
    // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
    var evt, key;

    if (!this._hasDocument) return;

    options = options || {};

    eventType = 'raven' + eventType.substr(0, 1).toUpperCase() + eventType.substr(1);

    if (_document.createEvent) {
      evt = _document.createEvent('HTMLEvents');
      evt.initEvent(eventType, true, true);
    } else {
      evt = _document.createEventObject();
      evt.eventType = eventType;
    }

    for (key in options)
      if (hasKey(options, key)) {
        evt[key] = options[key];
      }

    if (_document.createEvent) {
      // IE9 if standards
      _document.dispatchEvent(evt);
    } else {
      // IE8 regardless of Quirks or Standards
      // IE9 if quirks
      try {
        _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
      } catch (e) {
        // Do nothing
      }
    }
  },

  /**
   * Wraps addEventListener to capture UI breadcrumbs
   * @param evtName the event name (e.g. "click")
   * @returns {Function}
   * @private
   */
  _breadcrumbEventHandler: function(evtName) {
    var self = this;
    return function(evt) {
      // reset keypress timeout; e.g. triggering a 'click' after
      // a 'keypress' will reset the keypress debounce so that a new
      // set of keypresses can be recorded
      self._keypressTimeout = null;

      // It's possible this handler might trigger multiple times for the same
      // event (e.g. event propagation through node ancestors). Ignore if we've
      // already captured the event.
      if (self._lastCapturedEvent === evt) return;

      self._lastCapturedEvent = evt;

      // try/catch both:
      // - accessing evt.target (see getsentry/raven-js#838, #768)
      // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
      //   can throw an exception in some circumstances.
      var target;
      try {
        target = htmlTreeAsString(evt.target);
      } catch (e) {
        target = '<unknown>';
      }

      self.captureBreadcrumb({
        category: 'ui.' + evtName, // e.g. ui.click, ui.input
        message: target
      });
    };
  },

  /**
   * Wraps addEventListener to capture keypress UI events
   * @returns {Function}
   * @private
   */
  _keypressEventHandler: function() {
    var self = this,
      debounceDuration = 1000; // milliseconds

    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(evt) {
      var target;
      try {
        target = evt.target;
      } catch (e) {
        // just accessing event properties can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/raven-js/issues/838
        return;
      }
      var tagName = target && target.tagName;

      // only consider keypress events on actual input elements
      // this will disregard keypresses targeting body (e.g. tabbing
      // through elements, hotkeys, etc)
      if (
        !tagName ||
        (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
      )
        return;

      // record first keypress in a series, but ignore subsequent
      // keypresses until debounce clears
      var timeout = self._keypressTimeout;
      if (!timeout) {
        self._breadcrumbEventHandler('input')(evt);
      }
      clearTimeout(timeout);
      self._keypressTimeout = setTimeout(function() {
        self._keypressTimeout = null;
      }, debounceDuration);
    };
  },

  /**
   * Captures a breadcrumb of type "navigation", normalizing input URLs
   * @param to the originating URL
   * @param from the target URL
   * @private
   */
  _captureUrlChange: function(from, to) {
    var parsedLoc = parseUrl(this._location.href);
    var parsedTo = parseUrl(to);
    var parsedFrom = parseUrl(from);

    // because onpopstate only tells you the "new" (to) value of location.href, and
    // not the previous (from) value, we need to track the value of the current URL
    // state ourselves
    this._lastHref = to;

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
      to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
      from = parsedFrom.relative;

    this.captureBreadcrumb({
      category: 'navigation',
      data: {
        to: to,
        from: from
      }
    });
  },

  _patchFunctionToString: function() {
    var self = this;
    self._originalFunctionToString = Function.prototype.toString;
    // eslint-disable-next-line no-extend-native
    Function.prototype.toString = function() {
      if (typeof this === 'function' && this.__raven__) {
        return self._originalFunctionToString.apply(this.__orig__, arguments);
      }
      return self._originalFunctionToString.apply(this, arguments);
    };
  },

  _unpatchFunctionToString: function() {
    if (this._originalFunctionToString) {
      // eslint-disable-next-line no-extend-native
      Function.prototype.toString = this._originalFunctionToString;
    }
  },

  /**
   * Wrap timer functions and event targets to catch errors and provide
   * better metadata.
   */
  _instrumentTryCatch: function() {
    var self = this;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapTimeFn(orig) {
      return function(fn, t) {
        // preserve arity
        // Make a copy of the arguments to prevent deoptimization
        // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = arguments[i];
        }
        var originalCallback = args[0];
        if (isFunction(originalCallback)) {
          args[0] = self.wrap(originalCallback);
        }

        // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
        // also supports only two arguments and doesn't care what this is, so we
        // can just call the original function directly.
        if (orig.apply) {
          return orig.apply(this, args);
        } else {
          return orig(args[0], args[1]);
        }
      };
    }

    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    function wrapEventTarget(global) {
      var proto = _window[global] && _window[global].prototype;
      if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
        fill(
          proto,
          'addEventListener',
          function(orig) {
            return function(evtName, fn, capture, secure) {
              // preserve arity
              try {
                if (fn && fn.handleEvent) {
                  fn.handleEvent = self.wrap(fn.handleEvent);
                }
              } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
              }

              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
              // so that we don't have more than one wrapper function
              var before, clickHandler, keypressHandler;

              if (
                autoBreadcrumbs &&
                autoBreadcrumbs.dom &&
                (global === 'EventTarget' || global === 'Node')
              ) {
                // NOTE: generating multiple handlers per addEventListener invocation, should
                //       revisit and verify we can just use one (almost certainly)
                clickHandler = self._breadcrumbEventHandler('click');
                keypressHandler = self._keypressEventHandler();
                before = function(evt) {
                  // need to intercept every DOM event in `before` argument, in case that
                  // same wrapped method is re-used for different events (e.g. mousemove THEN click)
                  // see #724
                  if (!evt) return;

                  var eventType;
                  try {
                    eventType = evt.type;
                  } catch (e) {
                    // just accessing event properties can throw an exception in some rare circumstances
                    // see: https://github.com/getsentry/raven-js/issues/838
                    return;
                  }
                  if (eventType === 'click') return clickHandler(evt);
                  else if (eventType === 'keypress') return keypressHandler(evt);
                };
              }
              return orig.call(
                this,
                evtName,
                self.wrap(fn, undefined, before),
                capture,
                secure
              );
            };
          },
          wrappedBuiltIns
        );
        fill(
          proto,
          'removeEventListener',
          function(orig) {
            return function(evt, fn, capture, secure) {
              try {
                fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__ : fn);
              } catch (e) {
                // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
              }
              return orig.call(this, evt, fn, capture, secure);
            };
          },
          wrappedBuiltIns
        );
      }
    }

    fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
    fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
    if (_window.requestAnimationFrame) {
      fill(
        _window,
        'requestAnimationFrame',
        function(orig) {
          return function(cb) {
            return orig(self.wrap(cb));
          };
        },
        wrappedBuiltIns
      );
    }

    // event targets borrowed from bugsnag-js:
    // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
    var eventTargets = [
      'EventTarget',
      'Window',
      'Node',
      'ApplicationCache',
      'AudioTrackList',
      'ChannelMergerNode',
      'CryptoOperation',
      'EventSource',
      'FileReader',
      'HTMLUnknownElement',
      'IDBDatabase',
      'IDBRequest',
      'IDBTransaction',
      'KeyOperation',
      'MediaController',
      'MessagePort',
      'ModalWindow',
      'Notification',
      'SVGElementInstance',
      'Screen',
      'TextTrack',
      'TextTrackCue',
      'TextTrackList',
      'WebSocket',
      'WebSocketWorker',
      'Worker',
      'XMLHttpRequest',
      'XMLHttpRequestEventTarget',
      'XMLHttpRequestUpload'
    ];
    for (var i = 0; i < eventTargets.length; i++) {
      wrapEventTarget(eventTargets[i]);
    }
  },

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - XMLHttpRequests
   *  - DOM interactions (click/typing)
   *  - window.location changes
   *  - console
   *
   * Can be disabled or individually configured via the `autoBreadcrumbs` config option
   */
  _instrumentBreadcrumbs: function() {
    var self = this;
    var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;

    var wrappedBuiltIns = self._wrappedBuiltIns;

    function wrapProp(prop, xhr) {
      if (prop in xhr && isFunction(xhr[prop])) {
        fill(xhr, prop, function(orig) {
          return self.wrap(orig);
        }); // intentionally don't track filled methods on XHR instances
      }
    }

    if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
      var xhrproto = XMLHttpRequest.prototype;
      fill(
        xhrproto,
        'open',
        function(origOpen) {
          return function(method, url) {
            // preserve arity

            // if Sentry key appears in URL, don't capture
            if (isString(url) && url.indexOf(self._globalKey) === -1) {
              this.__raven_xhr = {
                method: method,
                url: url,
                status_code: null
              };
            }

            return origOpen.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );

      fill(
        xhrproto,
        'send',
        function(origSend) {
          return function() {
            // preserve arity
            var xhr = this;

            function onreadystatechangeHandler() {
              if (xhr.__raven_xhr && xhr.readyState === 4) {
                try {
                  // touching statusCode in some platforms throws
                  // an exception
                  xhr.__raven_xhr.status_code = xhr.status;
                } catch (e) {
                  /* do nothing */
                }

                self.captureBreadcrumb({
                  type: 'http',
                  category: 'xhr',
                  data: xhr.__raven_xhr
                });
              }
            }

            var props = ['onload', 'onerror', 'onprogress'];
            for (var j = 0; j < props.length; j++) {
              wrapProp(props[j], xhr);
            }

            if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
              fill(
                xhr,
                'onreadystatechange',
                function(orig) {
                  return self.wrap(orig, undefined, onreadystatechangeHandler);
                } /* intentionally don't track this instrumentation */
              );
            } else {
              // if onreadystatechange wasn't actually set by the page on this xhr, we
              // are free to set our own and capture the breadcrumb
              xhr.onreadystatechange = onreadystatechangeHandler;
            }

            return origSend.apply(this, arguments);
          };
        },
        wrappedBuiltIns
      );
    }

    if (autoBreadcrumbs.xhr && supportsFetch()) {
      fill(
        _window,
        'fetch',
        function(origFetch) {
          return function() {
            // preserve arity
            // Make a copy of the arguments to prevent deoptimization
            // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
            var args = new Array(arguments.length);
            for (var i = 0; i < args.length; ++i) {
              args[i] = arguments[i];
            }

            var fetchInput = args[0];
            var method = 'GET';
            var url;

            if (typeof fetchInput === 'string') {
              url = fetchInput;
            } else if ('Request' in _window && fetchInput instanceof _window.Request) {
              url = fetchInput.url;
              if (fetchInput.method) {
                method = fetchInput.method;
              }
            } else {
              url = '' + fetchInput;
            }

            // if Sentry key appears in URL, don't capture, as it's our own request
            if (url.indexOf(self._globalKey) !== -1) {
              return origFetch.apply(this, args);
            }

            if (args[1] && args[1].method) {
              method = args[1].method;
            }

            var fetchData = {
              method: method,
              url: url,
              status_code: null
            };

            self.captureBreadcrumb({
              type: 'http',
              category: 'fetch',
              data: fetchData
            });

            return origFetch.apply(this, args).then(function(response) {
              fetchData.status_code = response.status;

              return response;
            });
          };
        },
        wrappedBuiltIns
      );
    }

    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    if (autoBreadcrumbs.dom && this._hasDocument) {
      if (_document.addEventListener) {
        _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
        _document.addEventListener('keypress', self._keypressEventHandler(), false);
      } else {
        // IE8 Compatibility
        _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
        _document.attachEvent('onkeypress', self._keypressEventHandler());
      }
    }

    // record navigation (URL) changes
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var chrome = _window.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasPushAndReplaceState =
      !isChromePackagedApp &&
      _window.history &&
      history.pushState &&
      history.replaceState;
    if (autoBreadcrumbs.location && hasPushAndReplaceState) {
      // TODO: remove onpopstate handler on uninstall()
      var oldOnPopState = _window.onpopstate;
      _window.onpopstate = function() {
        var currentHref = self._location.href;
        self._captureUrlChange(self._lastHref, currentHref);

        if (oldOnPopState) {
          return oldOnPopState.apply(this, arguments);
        }
      };

      var historyReplacementFunction = function(origHistFunction) {
        // note history.pushState.length is 0; intentionally not declaring
        // params to preserve 0 arity
        return function(/* state, title, url */) {
          var url = arguments.length > 2 ? arguments[2] : undefined;

          // url argument is optional
          if (url) {
            // coerce to string (this is what pushState does)
            self._captureUrlChange(self._lastHref, url + '');
          }

          return origHistFunction.apply(this, arguments);
        };
      };

      fill(history, 'pushState', historyReplacementFunction, wrappedBuiltIns);
      fill(history, 'replaceState', historyReplacementFunction, wrappedBuiltIns);
    }

    if (autoBreadcrumbs.console && 'console' in _window && console.log) {
      // console
      var consoleMethodCallback = function(msg, data) {
        self.captureBreadcrumb({
          message: msg,
          level: data.level,
          category: 'console'
        });
      };

      each(['debug', 'info', 'warn', 'error', 'log'], function(_, level) {
        wrapConsoleMethod(console, level, consoleMethodCallback);
      });
    }
  },

  _restoreBuiltIns: function() {
    // restore any wrapped builtins
    var builtin;
    while (this._wrappedBuiltIns.length) {
      builtin = this._wrappedBuiltIns.shift();

      var obj = builtin[0],
        name = builtin[1],
        orig = builtin[2];

      obj[name] = orig;
    }
  },

  _drainPlugins: function() {
    var self = this;

    // FIX ME TODO
    each(this._plugins, function(_, plugin) {
      var installer = plugin[0];
      var args = plugin[1];
      installer.apply(self, [self].concat(args));
    });
  },

  _parseDSN: function(str) {
    var m = dsnPattern.exec(str),
      dsn = {},
      i = 7;

    try {
      while (i--) dsn[dsnKeys[i]] = m[i] || '';
    } catch (e) {
      throw new RavenConfigError('Invalid DSN: ' + str);
    }

    if (dsn.pass && !this._globalOptions.allowSecretKey) {
      throw new RavenConfigError(
        'Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key'
      );
    }

    return dsn;
  },

  _getGlobalServer: function(uri) {
    // assemble the endpoint from the uri pieces
    var globalServer = '//' + uri.host + (uri.port ? ':' + uri.port : '');

    if (uri.protocol) {
      globalServer = uri.protocol + ':' + globalServer;
    }
    return globalServer;
  },

  _handleOnErrorStackInfo: function() {
    // if we are intentionally ignoring errors via onerror, bail out
    if (!this._ignoreOnError) {
      this._handleStackInfo.apply(this, arguments);
    }
  },

  _handleStackInfo: function(stackInfo, options) {
    var frames = this._prepareFrames(stackInfo, options);

    this._triggerEvent('handle', {
      stackInfo: stackInfo,
      options: options
    });

    this._processException(
      stackInfo.name,
      stackInfo.message,
      stackInfo.url,
      stackInfo.lineno,
      frames,
      options
    );
  },

  _prepareFrames: function(stackInfo, options) {
    var self = this;
    var frames = [];
    if (stackInfo.stack && stackInfo.stack.length) {
      each(stackInfo.stack, function(i, stack) {
        var frame = self._normalizeFrame(stack, stackInfo.url);
        if (frame) {
          frames.push(frame);
        }
      });

      // e.g. frames captured via captureMessage throw
      if (options && options.trimHeadFrames) {
        for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
          frames[j].in_app = false;
        }
      }
    }
    frames = frames.slice(0, this._globalOptions.stackTraceLimit);
    return frames;
  },

  _normalizeFrame: function(frame, stackInfoUrl) {
    // normalize the frames data
    var normalized = {
      filename: frame.url,
      lineno: frame.line,
      colno: frame.column,
      function: frame.func || '?'
    };

    // Case when we don't have any information about the error
    // E.g. throwing a string or raw object, instead of an `Error` in Firefox
    // Generating synthetic error doesn't add any value here
    //
    // We should probably somehow let a user know that they should fix their code
    if (!frame.url) {
      normalized.filename = stackInfoUrl; // fallback to whole stacks url from onerror handler
    }

    normalized.in_app = !// determine if an exception came from outside of our app
    // first we check the global includePaths list.
    (
      (!!this._globalOptions.includePaths.test &&
        !this._globalOptions.includePaths.test(normalized.filename)) ||
      // Now we check for fun, if the function name is Raven or TraceKit
      /(Raven|TraceKit)\./.test(normalized['function']) ||
      // finally, we do a last ditch effort and check for raven.min.js
      /raven\.(min\.)?js$/.test(normalized.filename)
    );

    return normalized;
  },

  _processException: function(type, message, fileurl, lineno, frames, options) {
    var prefixedMessage = (type ? type + ': ' : '') + (message || '');
    if (
      !!this._globalOptions.ignoreErrors.test &&
      (this._globalOptions.ignoreErrors.test(message) ||
        this._globalOptions.ignoreErrors.test(prefixedMessage))
    ) {
      return;
    }

    var stacktrace;

    if (frames && frames.length) {
      fileurl = frames[0].filename || fileurl;
      // Sentry expects frames oldest to newest
      // and JS sends them as newest to oldest
      frames.reverse();
      stacktrace = {frames: frames};
    } else if (fileurl) {
      stacktrace = {
        frames: [
          {
            filename: fileurl,
            lineno: lineno,
            in_app: true
          }
        ]
      };
    }

    if (
      !!this._globalOptions.ignoreUrls.test &&
      this._globalOptions.ignoreUrls.test(fileurl)
    ) {
      return;
    }

    if (
      !!this._globalOptions.whitelistUrls.test &&
      !this._globalOptions.whitelistUrls.test(fileurl)
    ) {
      return;
    }

    var data = objectMerge(
      {
        // sentry.interfaces.Exception
        exception: {
          values: [
            {
              type: type,
              value: message,
              stacktrace: stacktrace
            }
          ]
        },
        culprit: fileurl
      },
      options
    );

    // Fire away!
    this._send(data);
  },

  _trimPacket: function(data) {
    // For now, we only want to truncate the two different messages
    // but this could/should be expanded to just trim everything
    var max = this._globalOptions.maxMessageLength;
    if (data.message) {
      data.message = truncate(data.message, max);
    }
    if (data.exception) {
      var exception = data.exception.values[0];
      exception.value = truncate(exception.value, max);
    }

    var request = data.request;
    if (request) {
      if (request.url) {
        request.url = truncate(request.url, this._globalOptions.maxUrlLength);
      }
      if (request.Referer) {
        request.Referer = truncate(request.Referer, this._globalOptions.maxUrlLength);
      }
    }

    if (data.breadcrumbs && data.breadcrumbs.values)
      this._trimBreadcrumbs(data.breadcrumbs);

    return data;
  },

  /**
   * Truncate breadcrumb values (right now just URLs)
   */
  _trimBreadcrumbs: function(breadcrumbs) {
    // known breadcrumb properties with urls
    // TODO: also consider arbitrary prop values that start with (https?)?://
    var urlProps = ['to', 'from', 'url'],
      urlProp,
      crumb,
      data;

    for (var i = 0; i < breadcrumbs.values.length; ++i) {
      crumb = breadcrumbs.values[i];
      if (
        !crumb.hasOwnProperty('data') ||
        !isObject(crumb.data) ||
        objectFrozen(crumb.data)
      )
        continue;

      data = objectMerge({}, crumb.data);
      for (var j = 0; j < urlProps.length; ++j) {
        urlProp = urlProps[j];
        if (data.hasOwnProperty(urlProp) && data[urlProp]) {
          data[urlProp] = truncate(data[urlProp], this._globalOptions.maxUrlLength);
        }
      }
      breadcrumbs.values[i].data = data;
    }
  },

  _getHttpData: function() {
    if (!this._hasNavigator && !this._hasDocument) return;
    var httpData = {};

    if (this._hasNavigator && _navigator.userAgent) {
      httpData.headers = {
        'User-Agent': navigator.userAgent
      };
    }

    if (this._hasDocument) {
      if (_document.location && _document.location.href) {
        httpData.url = _document.location.href;
      }
      if (_document.referrer) {
        if (!httpData.headers) httpData.headers = {};
        httpData.headers.Referer = _document.referrer;
      }
    }

    return httpData;
  },

  _resetBackoff: function() {
    this._backoffDuration = 0;
    this._backoffStart = null;
  },

  _shouldBackoff: function() {
    return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
  },

  /**
   * Returns true if the in-process data payload matches the signature
   * of the previously-sent data
   *
   * NOTE: This has to be done at this level because TraceKit can generate
   *       data from window.onerror WITHOUT an exception object (IE8, IE9,
   *       other old browsers). This can take the form of an "exception"
   *       data object with a single frame (derived from the onerror args).
   */
  _isRepeatData: function(current) {
    var last = this._lastData;

    if (
      !last ||
      current.message !== last.message || // defined for captureMessage
      current.culprit !== last.culprit // defined for captureException/onerror
    )
      return false;

    // Stacktrace interface (i.e. from captureMessage)
    if (current.stacktrace || last.stacktrace) {
      return isSameStacktrace(current.stacktrace, last.stacktrace);
    } else if (current.exception || last.exception) {
      // Exception interface (i.e. from captureException/onerror)
      return isSameException(current.exception, last.exception);
    }

    return true;
  },

  _setBackoffState: function(request) {
    // If we are already in a backoff state, don't change anything
    if (this._shouldBackoff()) {
      return;
    }

    var status = request.status;

    // 400 - project_id doesn't exist or some other fatal
    // 401 - invalid/revoked dsn
    // 429 - too many requests
    if (!(status === 400 || status === 401 || status === 429)) return;

    var retry;
    try {
      // If Retry-After is not in Access-Control-Expose-Headers, most
      // browsers will throw an exception trying to access it
      if (supportsFetch()) {
        retry = request.headers.get('Retry-After');
      } else {
        retry = request.getResponseHeader('Retry-After');
      }

      // Retry-After is returned in seconds
      retry = parseInt(retry, 10) * 1000;
    } catch (e) {
      /* eslint no-empty:0 */
    }

    this._backoffDuration = retry
      ? // If Sentry server returned a Retry-After value, use it
        retry
      : // Otherwise, double the last backoff duration (starts at 1 sec)
        this._backoffDuration * 2 || 1000;

    this._backoffStart = now();
  },

  _send: function(data) {
    var globalOptions = this._globalOptions;

    var baseData = {
        project: this._globalProject,
        logger: globalOptions.logger,
        platform: 'javascript'
      },
      httpData = this._getHttpData();

    if (httpData) {
      baseData.request = httpData;
    }

    // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
    if (data.trimHeadFrames) delete data.trimHeadFrames;

    data = objectMerge(baseData, data);

    // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
    data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
    data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);

    // Send along our own collected metadata with extra
    data.extra['session:duration'] = now() - this._startTime;

    if (this._breadcrumbs && this._breadcrumbs.length > 0) {
      // intentionally make shallow copy so that additions
      // to breadcrumbs aren't accidentally sent in this request
      data.breadcrumbs = {
        values: [].slice.call(this._breadcrumbs, 0)
      };
    }

    // If there are no tags/extra, strip the key from the payload alltogther.
    if (isEmptyObject(data.tags)) delete data.tags;

    if (this._globalContext.user) {
      // sentry.interfaces.User
      data.user = this._globalContext.user;
    }

    // Include the environment if it's defined in globalOptions
    if (globalOptions.environment) data.environment = globalOptions.environment;

    // Include the release if it's defined in globalOptions
    if (globalOptions.release) data.release = globalOptions.release;

    // Include server_name if it's defined in globalOptions
    if (globalOptions.serverName) data.server_name = globalOptions.serverName;

    if (isFunction(globalOptions.dataCallback)) {
      data = globalOptions.dataCallback(data) || data;
    }

    // Why??????????
    if (!data || isEmptyObject(data)) {
      return;
    }

    // Check if the request should be filtered or not
    if (
      isFunction(globalOptions.shouldSendCallback) &&
      !globalOptions.shouldSendCallback(data)
    ) {
      return;
    }

    // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
    // so drop requests until "cool-off" period has elapsed.
    if (this._shouldBackoff()) {
      this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
      return;
    }

    if (typeof globalOptions.sampleRate === 'number') {
      if (Math.random() < globalOptions.sampleRate) {
        this._sendProcessedPayload(data);
      }
    } else {
      this._sendProcessedPayload(data);
    }
  },

  _getUuid: function() {
    return uuid4();
  },

  _sendProcessedPayload: function(data, callback) {
    var self = this;
    var globalOptions = this._globalOptions;

    if (!this.isSetup()) return;

    // Try and clean up the packet before sending by truncating long values
    data = this._trimPacket(data);

    // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
    // but this would require copying an un-truncated copy of the data packet, which can be
    // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
    if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
      this._logDebug('warn', 'Raven dropped repeat event: ', data);
      return;
    }

    // Send along an event_id if not explicitly passed.
    // This event_id can be used to reference the error within Sentry itself.
    // Set lastEventId after we know the error should actually be sent
    this._lastEventId = data.event_id || (data.event_id = this._getUuid());

    // Store outbound payload after trim
    this._lastData = data;

    this._logDebug('debug', 'Raven about to send:', data);

    var auth = {
      sentry_version: '7',
      sentry_client: 'raven-js/' + this.VERSION,
      sentry_key: this._globalKey
    };

    if (this._globalSecret) {
      auth.sentry_secret = this._globalSecret;
    }

    var exception = data.exception && data.exception.values[0];

    // only capture 'sentry' breadcrumb is autoBreadcrumbs is truthy
    if (
      this._globalOptions.autoBreadcrumbs &&
      this._globalOptions.autoBreadcrumbs.sentry
    ) {
      this.captureBreadcrumb({
        category: 'sentry',
        message: exception
          ? (exception.type ? exception.type + ': ' : '') + exception.value
          : data.message,
        event_id: data.event_id,
        level: data.level || 'error' // presume error unless specified
      });
    }

    var url = this._globalEndpoint;
    (globalOptions.transport || this._makeRequest).call(this, {
      url: url,
      auth: auth,
      data: data,
      options: globalOptions,
      onSuccess: function success() {
        self._resetBackoff();

        self._triggerEvent('success', {
          data: data,
          src: url
        });
        callback && callback();
      },
      onError: function failure(error) {
        self._logDebug('error', 'Raven transport failed to send: ', error);

        if (error.request) {
          self._setBackoffState(error.request);
        }

        self._triggerEvent('failure', {
          data: data,
          src: url
        });
        error = error || new Error('Raven send failed (no additional details provided)');
        callback && callback(error);
      }
    });
  },

  _makeRequest: function(opts) {
    // Auth is intentionally sent as part of query string (NOT as custom HTTP header) to avoid preflight CORS requests
    var url = opts.url + '?' + urlencode(opts.auth);

    var evaluatedHeaders = null;
    if (opts.options.headers) {
      evaluatedHeaders = this._evaluateHeaders(opts.options.headers);
    }

    if (supportsFetch()) {
      var fetchOptions = {
        method: 'POST',
        body: stringify(opts.data)
      };

      if (evaluatedHeaders) {
        fetchOptions.headers = evaluatedHeaders;
      }

      return _window
        .fetch(url, fetchOptions)
        .then(function(response) {
          if (response.ok) {
            opts.onSuccess && opts.onSuccess();
          } else {
            var error = new Error('Sentry error code: ' + response.status);
            // It's called request only to keep compatibility with XHR interface
            // and not add more redundant checks in setBackoffState method
            error.request = response;
            opts.onError && opts.onError(error);
          }
        })
        ['catch'](function() {
          opts.onError &&
            opts.onError(new Error('Sentry error code: network unavailable'));
        });
    }

    var request = _window.XMLHttpRequest && new _window.XMLHttpRequest();
    if (!request) return;

    // if browser doesn't support CORS (e.g. IE7), we are out of luck
    var hasCORS = 'withCredentials' in request || typeof XDomainRequest !== 'undefined';

    if (!hasCORS) return;

    if ('withCredentials' in request) {
      request.onreadystatechange = function() {
        if (request.readyState !== 4) {
          return;
        } else if (request.status === 200) {
          opts.onSuccess && opts.onSuccess();
        } else if (opts.onError) {
          var err = new Error('Sentry error code: ' + request.status);
          err.request = request;
          opts.onError(err);
        }
      };
    } else {
      request = new XDomainRequest();
      // xdomainrequest cannot go http -> https (or vice versa),
      // so always use protocol relative
      url = url.replace(/^https?:/, '');

      // onreadystatechange not supported by XDomainRequest
      if (opts.onSuccess) {
        request.onload = opts.onSuccess;
      }
      if (opts.onError) {
        request.onerror = function() {
          var err = new Error('Sentry error code: XDomainRequest');
          err.request = request;
          opts.onError(err);
        };
      }
    }

    request.open('POST', url);

    if (evaluatedHeaders) {
      each(evaluatedHeaders, function(key, value) {
        request.setRequestHeader(key, value);
      });
    }

    request.send(stringify(opts.data));
  },

  _evaluateHeaders: function(headers) {
    var evaluatedHeaders = {};

    for (var key in headers) {
      if (headers.hasOwnProperty(key)) {
        var value = headers[key];
        evaluatedHeaders[key] = typeof value === 'function' ? value() : value;
      }
    }

    return evaluatedHeaders;
  },

  _logDebug: function(level) {
    if (this._originalConsoleMethods[level] && this.debug) {
      // In IE<10 console methods do not have their own 'apply' method
      Function.prototype.apply.call(
        this._originalConsoleMethods[level],
        this._originalConsole,
        [].slice.call(arguments, 1)
      );
    }
  },

  _mergeContext: function(key, context) {
    if (isUndefined(context)) {
      delete this._globalContext[key];
    } else {
      this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
    }
  }
};

// Deprecations
Raven.prototype.setUser = Raven.prototype.setUserContext;
Raven.prototype.setReleaseContext = Raven.prototype.setRelease;

module.exports = Raven;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var utils = __webpack_require__(615);

/*
 TraceKit - Cross brower stack traces

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/

var TraceKit = {
  collectWindowErrors: true,
  debug: false
};

// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
var _window =
  typeof window !== 'undefined'
    ? window
    : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;

function getLocationHref() {
  if (typeof document === 'undefined' || document.location == null) return '';

  return document.location.href;
}

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
  var handlers = [],
    lastArgs = null,
    lastException = null,
    lastExceptionStack = null;

  /**
     * Add a crash handler.
     * @param {Function} handler
     */
  function subscribe(handler) {
    installGlobalHandler();
    handlers.push(handler);
  }

  /**
     * Remove a crash handler.
     * @param {Function} handler
     */
  function unsubscribe(handler) {
    for (var i = handlers.length - 1; i >= 0; --i) {
      if (handlers[i] === handler) {
        handlers.splice(i, 1);
      }
    }
  }

  /**
     * Remove all crash handlers.
     */
  function unsubscribeAll() {
    uninstallGlobalHandler();
    handlers = [];
  }

  /**
     * Dispatch stack information to all handlers.
     * @param {Object.<string, *>} stack
     */
  function notifyHandlers(stack, isWindowError) {
    var exception = null;
    if (isWindowError && !TraceKit.collectWindowErrors) {
      return;
    }
    for (var i in handlers) {
      if (handlers.hasOwnProperty(i)) {
        try {
          handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
        } catch (inner) {
          exception = inner;
        }
      }
    }

    if (exception) {
      throw exception;
    }
  }

  var _oldOnerrorHandler, _onErrorHandlerInstalled;

  /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} msg Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error
     * occurred.
     * @param {?(number|string)} colNo The column number at which the error
     * occurred.
     * @param {?Error} ex The actual Error object.
     */
  function traceKitWindowOnError(msg, url, lineNo, colNo, ex) {
    var stack = null;
    // If 'ex' is ErrorEvent, get real Error from inside
    var exception = utils.isErrorEvent(ex) ? ex.error : ex;
    // If 'msg' is ErrorEvent, get real message from inside
    var message = utils.isErrorEvent(msg) ? msg.message : msg;

    if (lastExceptionStack) {
      TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(
        lastExceptionStack,
        url,
        lineNo,
        message
      );
      processLastException();
    } else if (exception && utils.isError(exception)) {
      // non-string `exception` arg; attempt to extract stack trace

      // New chrome and blink send along a real error object
      // Let's just report that like a normal error.
      // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
      stack = TraceKit.computeStackTrace(exception);
      notifyHandlers(stack, true);
    } else {
      var location = {
        url: url,
        line: lineNo,
        column: colNo
      };

      var name = undefined;
      var groups;

      if ({}.toString.call(message) === '[object String]') {
        var groups = message.match(ERROR_TYPES_RE);
        if (groups) {
          name = groups[1];
          message = groups[2];
        }
      }

      location.func = UNKNOWN_FUNCTION;

      stack = {
        name: name,
        message: message,
        url: getLocationHref(),
        stack: [location]
      };
      notifyHandlers(stack, true);
    }

    if (_oldOnerrorHandler) {
      return _oldOnerrorHandler.apply(this, arguments);
    }

    return false;
  }

  function installGlobalHandler() {
    if (_onErrorHandlerInstalled) {
      return;
    }
    _oldOnerrorHandler = _window.onerror;
    _window.onerror = traceKitWindowOnError;
    _onErrorHandlerInstalled = true;
  }

  function uninstallGlobalHandler() {
    if (!_onErrorHandlerInstalled) {
      return;
    }
    _window.onerror = _oldOnerrorHandler;
    _onErrorHandlerInstalled = false;
    _oldOnerrorHandler = undefined;
  }

  function processLastException() {
    var _lastExceptionStack = lastExceptionStack,
      _lastArgs = lastArgs;
    lastArgs = null;
    lastExceptionStack = null;
    lastException = null;
    notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
  }

  /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @param {?boolean} rethrow If false, do not re-throw the exception.
     * Only used for window.onerror to not cause an infinite loop of
     * rethrowing.
     */
  function report(ex, rethrow) {
    var args = _slice.call(arguments, 1);
    if (lastExceptionStack) {
      if (lastException === ex) {
        return; // already caught by an inner catch block, ignore
      } else {
        processLastException();
      }
    }

    var stack = TraceKit.computeStackTrace(ex);
    lastExceptionStack = stack;
    lastException = ex;
    lastArgs = args;

    // If the stack trace is incomplete, wait for 2 seconds for
    // slow slow IE to see if onerror occurs or not before reporting
    // this exception; otherwise, we will end up with an incomplete
    // stack trace
    setTimeout(function() {
      if (lastException === ex) {
        processLastException();
      }
    }, stack.incomplete ? 2000 : 0);

    if (rethrow !== false) {
      throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
  }

  report.subscribe = subscribe;
  report.unsubscribe = unsubscribe;
  report.uninstall = unsubscribeAll;
  return report;
})();

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
  // Contents of Exception in various browsers.
  //
  // SAFARI:
  // ex.message = Can't find variable: qq
  // ex.line = 59
  // ex.sourceId = 580238192
  // ex.sourceURL = http://...
  // ex.expressionBeginOffset = 96
  // ex.expressionCaretOffset = 98
  // ex.expressionEndOffset = 98
  // ex.name = ReferenceError
  //
  // FIREFOX:
  // ex.message = qq is not defined
  // ex.fileName = http://...
  // ex.lineNumber = 59
  // ex.columnNumber = 69
  // ex.stack = ...stack trace... (see the example below)
  // ex.name = ReferenceError
  //
  // CHROME:
  // ex.message = qq is not defined
  // ex.name = ReferenceError
  // ex.type = not_defined
  // ex.arguments = ['aa']
  // ex.stack = ...stack trace...
  //
  // INTERNET EXPLORER:
  // ex.message = ...
  // ex.name = ReferenceError
  //
  // OPERA:
  // ex.message = ...message... (see the example below)
  // ex.name = ReferenceError
  // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
  // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

  /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
  function computeStackTraceFromStackProp(ex) {
    if (typeof ex.stack === 'undefined' || !ex.stack) return;

    var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
      gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i,
      winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
      // Used to additionally parse URL/line/column from eval frames
      geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
      chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/,
      lines = ex.stack.split('\n'),
      stack = [],
      submatch,
      parts,
      element,
      reference = /^(.*) is undefined$/.exec(ex.message);

    for (var i = 0, j = lines.length; i < j; ++i) {
      if ((parts = chrome.exec(lines[i]))) {
        var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval && (submatch = chromeEval.exec(parts[2]))) {
          // throw out eval line/column and use top-most line/column number
          parts[2] = submatch[1]; // url
          parts[3] = submatch[2]; // line
          parts[4] = submatch[3]; // column
        }
        element = {
          url: !isNative ? parts[2] : null,
          func: parts[1] || UNKNOWN_FUNCTION,
          args: isNative ? [parts[2]] : [],
          line: parts[3] ? +parts[3] : null,
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = winjs.exec(lines[i]))) {
        element = {
          url: parts[2],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: [],
          line: +parts[3],
          column: parts[4] ? +parts[4] : null
        };
      } else if ((parts = gecko.exec(lines[i]))) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval && (submatch = geckoEval.exec(parts[3]))) {
          // throw out eval line/column and use top-most line number
          parts[3] = submatch[1];
          parts[4] = submatch[2];
          parts[5] = null; // no column when eval
        } else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
          // FireFox uses this awesome columnNumber property for its top frame
          // Also note, Firefox's column number is 0-based and everything else expects 1-based,
          // so adding 1
          // NOTE: this hack doesn't work if top-most frame is eval
          stack[0].column = ex.columnNumber + 1;
        }
        element = {
          url: parts[3],
          func: parts[1] || UNKNOWN_FUNCTION,
          args: parts[2] ? parts[2].split(',') : [],
          line: parts[4] ? +parts[4] : null,
          column: parts[5] ? +parts[5] : null
        };
      } else {
        continue;
      }

      if (!element.func && element.line) {
        element.func = UNKNOWN_FUNCTION;
      }

      stack.push(element);
    }

    if (!stack.length) {
      return null;
    }

    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
  }

  /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {Object.<string, *>} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     */
  function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
    var initial = {
      url: url,
      line: lineNo
    };

    if (initial.url && initial.line) {
      stackInfo.incomplete = false;

      if (!initial.func) {
        initial.func = UNKNOWN_FUNCTION;
      }

      if (stackInfo.stack.length > 0) {
        if (stackInfo.stack[0].url === initial.url) {
          if (stackInfo.stack[0].line === initial.line) {
            return false; // already in stack trace
          } else if (
            !stackInfo.stack[0].line &&
            stackInfo.stack[0].func === initial.func
          ) {
            stackInfo.stack[0].line = initial.line;
            return false;
          }
        }
      }

      stackInfo.stack.unshift(initial);
      stackInfo.partial = true;
      return true;
    } else {
      stackInfo.incomplete = true;
    }

    return false;
  }

  /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
  function computeStackTraceByWalkingCallerChain(ex, depth) {
    var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
      stack = [],
      funcs = {},
      recursion = false,
      parts,
      item,
      source;

    for (
      var curr = computeStackTraceByWalkingCallerChain.caller;
      curr && !recursion;
      curr = curr.caller
    ) {
      if (curr === computeStackTrace || curr === TraceKit.report) {
        // console.log('skipping internal function');
        continue;
      }

      item = {
        url: null,
        func: UNKNOWN_FUNCTION,
        line: null,
        column: null
      };

      if (curr.name) {
        item.func = curr.name;
      } else if ((parts = functionName.exec(curr.toString()))) {
        item.func = parts[1];
      }

      if (typeof item.func === 'undefined') {
        try {
          item.func = parts.input.substring(0, parts.input.indexOf('{'));
        } catch (e) {}
      }

      if (funcs['' + curr]) {
        recursion = true;
      } else {
        funcs['' + curr] = true;
      }

      stack.push(item);
    }

    if (depth) {
      // console.log('depth is ' + depth);
      // console.log('stack is ' + stack.length);
      stack.splice(0, depth);
    }

    var result = {
      name: ex.name,
      message: ex.message,
      url: getLocationHref(),
      stack: stack
    };
    augmentStackTraceWithInitialElement(
      result,
      ex.sourceURL || ex.fileName,
      ex.line || ex.lineNumber,
      ex.message || ex.description
    );
    return result;
  }

  /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     */
  function computeStackTrace(ex, depth) {
    var stack = null;
    depth = depth == null ? 0 : +depth;

    try {
      stack = computeStackTraceFromStackProp(ex);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }

    try {
      stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
      if (stack) {
        return stack;
      }
    } catch (e) {
      if (TraceKit.debug) {
        throw e;
      }
    }
    return {
      name: ex.name,
      message: ex.message,
      url: getLocationHref()
    };
  }

  computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
  computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;

  return computeStackTrace;
})();

module.exports = TraceKit;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

/*
 json-stringify-safe
 Like JSON.stringify, but doesn't throw on circular references.

 Originally forked from https://github.com/isaacs/json-stringify-safe
 version 5.0.1 on 3/8/2017 and modified to handle Errors serialization
 and IE8 compatibility. Tests for this are in test/vendor.

 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
*/

exports = module.exports = stringify;
exports.getSerialize = serializer;

function indexOf(haystack, needle) {
  for (var i = 0; i < haystack.length; ++i) {
    if (haystack[i] === needle) return i;
  }
  return -1;
}

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}

// https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
function stringifyError(value) {
  var err = {
    // These properties are implemented as magical getters and don't show up in for in
    stack: value.stack,
    message: value.message,
    name: value.name
  };

  for (var i in value) {
    if (Object.prototype.hasOwnProperty.call(value, i)) {
      err[i] = value[i];
    }
  }

  return err;
}

function serializer(replacer, cycleReplacer) {
  var stack = [];
  var keys = [];

  if (cycleReplacer == null) {
    cycleReplacer = function(key, value) {
      if (stack[0] === value) {
        return '[Circular ~]';
      }
      return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']';
    };
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = indexOf(stack, this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);

      if (~indexOf(stack, value)) {
        value = cycleReplacer.call(this, key, value);
      }
    } else {
      stack.push(value);
    }

    return replacer == null
      ? value instanceof Error ? stringifyError(value) : value
      : replacer.call(this, key, value);
  };
}


/***/ }),
/* 1323 */
/***/ (function(module, exports) {

function RavenConfigError(message) {
  this.name = 'RavenConfigError';
  this.message = message;
}
RavenConfigError.prototype = new Error();
RavenConfigError.prototype.constructor = RavenConfigError;

module.exports = RavenConfigError;


/***/ }),
/* 1324 */
/***/ (function(module, exports) {

var wrapMethod = function(console, level, callback) {
  var originalConsoleLevel = console[level];
  var originalConsole = console;

  if (!(level in console)) {
    return;
  }

  var sentryLevel = level === 'warn' ? 'warning' : level;

  console[level] = function() {
    var args = [].slice.call(arguments);

    var msg = '' + args.join(' ');
    var data = {level: sentryLevel, logger: 'console', extra: {arguments: args}};

    if (level === 'assert') {
      if (args[0] === false) {
        // Default browsers message
        msg = 'Assertion failed: ' + (args.slice(1).join(' ') || 'console.assert');
        data.extra.arguments = args.slice(1);
        callback && callback(msg, data);
      }
    } else {
      callback && callback(msg, data);
    }

    // this fails for some browsers. :(
    if (originalConsoleLevel) {
      // IE9 doesn't allow calling apply on console functions directly
      // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
      Function.prototype.apply.call(originalConsoleLevel, originalConsole, args);
    }
  };
};

module.exports = {
  wrapMethod: wrapMethod
};


/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mightBeEmail__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toTitleCase__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__console_warn__ = __webpack_require__(412);



var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__mightBeEmail__["a" /* default */])(s)) {
    Object(__WEBPACK_IMPORTED_MODULE_2__console_warn__["a" /* default */])('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__toTitleCase__["a" /* default */])(s);
  }

  return s;
}

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mightBeEmail;
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return /[^@]+@[^@]+/.test(s);
}

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toTitleCase;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trim__ = __webpack_require__(616);
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__trim__["a" /* default */])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeLeadingSlash;
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

});

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
function log(s) {
  console.info('[react-ga]', s);
}

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gaCalls */
var gaCalls = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push(args.concat());
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OutboundLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_console_warn__ = __webpack_require__(412);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        });
      } else {
        OutboundLink.trackLink(eventMeta, function () {});
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties(_this$props2, ["to"]);

      var props = _objectSpread({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(OutboundLink, "trackLink", function () {
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_console_warn__["a" /* default */])('ga tracking not enabled');
});

_defineProperty(OutboundLink, "propTypes", {
  eventLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

_defineProperty(OutboundLink, "defaultProps", {
  target: null,
  to: null,
  onClick: null
});



/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "run", function() { return run; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_stylesheets_index_css__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_stylesheets_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_stylesheets_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_animate__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_velocity_animate_velocity_ui__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_velocity_animate_velocity_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_velocity_animate_velocity_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_state_store__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__drivers_cookie__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_state_application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_query_string__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__registerServiceWorker__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__root__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__core_state_config_selectors__ = __webpack_require__(14);
var initialiseSession=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(token,store){var state,multiHomeEnabled,response,deviceGroupsEnabled;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;// This is a short-term hack for now. Once we upgrade to React Router v4
// we can bring this into a component/container and not render routes until
// login has been completed.
state=store.getState();multiHomeEnabled=Object(__WEBPACK_IMPORTED_MODULE_14__core_state_config_selectors__["c" /* getFeatureFlag */])(state,'multiHome');_context2.next=5;return __WEBPACK_IMPORTED_MODULE_5__core_api__["c" /* auth */].adminLogin(token,multiHomeEnabled).then(function(res){return res.json();});case 5:response=_context2.sent;deviceGroupsEnabled=Object(__WEBPACK_IMPORTED_MODULE_14__core_state_config_selectors__["c" /* getFeatureFlag */])(state,'deviceGroups');store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__core_state_application_actions__["h" /* logIn */])(Object.assign({},response,{deviceGroupsEnabled:deviceGroupsEnabled,token:token})));_context2.next=14;break;case 10:_context2.prev=10;_context2.t0=_context2['catch'](0);__WEBPACK_IMPORTED_MODULE_7__drivers_cookie__["a" /* default */].remove('token');__WEBPACK_IMPORTED_MODULE_7__drivers_cookie__["a" /* default */].remove('endpoint');case 14:case'end':return _context2.stop();}}},_callee2,this,[[0,10]]);}));return function initialiseSession(_x,_x2){return _ref2.apply(this,arguments);};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// <--- Make sure this stays first
var FLST_PATH='/flst/auth/apilogin/api/';var run=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var store,token,hiveLogo;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:configureMoment();store=Object(__WEBPACK_IMPORTED_MODULE_6__core_state_store__["a" /* default */])();token=getToken();if(!token){_context.next=6;break;}_context.next=6;return initialiseSession(token,store);case 6:// This starts the 300ms fade for the splash screen
hiveLogo=document.querySelector('.hive-logo');if(hiveLogo!==null){hiveLogo.setAttribute('class','hive-logo hive-logo--fade-out');hiveLogo.addEventListener('transitionend',function(){return renderApp(store);});}else{renderApp(store);}Object(__WEBPACK_IMPORTED_MODULE_12__registerServiceWorker__["a" /* unregister */])();case 9:case'end':return _context.stop();}}},_callee,this);}));return function run(){return _ref.apply(this,arguments);};}();function getToken(){// mobile apps supply token via query params
var _queryString$parse=__WEBPACK_IMPORTED_MODULE_10_query_string___default.a.parse(global.location.search),queryToken=_queryString$parse.token;// preferred method is to supply token via url fragment, SSO supplies token as id_token
var _queryString$parse2=__WEBPACK_IMPORTED_MODULE_10_query_string___default.a.parse(global.location.hash),hashToken=_queryString$parse2.token,ssoToken=_queryString$parse2.id_token;// FLST can supply token as a path parameter (deprecated)
var pathToken=global.location.pathname.indexOf(FLST_PATH)===0?global.location.pathname.substr(global.location.pathname.lastIndexOf('/')+1):undefined;return ssoToken||hashToken||queryToken||pathToken||__WEBPACK_IMPORTED_MODULE_7__drivers_cookie__["a" /* default */].get('token');}function configureMoment(){__WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.relativeTimeThreshold('s',59);__WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.relativeTimeThreshold('m',59);__WEBPACK_IMPORTED_MODULE_9_moment_timezone___default.a.relativeTimeThreshold('h',23);}function renderApp(store){__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__root__["a" /* default */],{store:store}),document.getElementById('app'));}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1335);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1335 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getTemplates"] = getTemplates;
/* harmony export (immutable) */ __webpack_exports__["getActions"] = getActions;
/* harmony export (immutable) */ __webpack_exports__["createHiveAction"] = createHiveAction;
/* harmony export (immutable) */ __webpack_exports__["editAction"] = editAction;
/* harmony export (immutable) */ __webpack_exports__["removeAction"] = removeAction;
/* harmony export (immutable) */ __webpack_exports__["triggerQuickAction"] = triggerQuickAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
function getTemplates(templatesVersion){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])('action-templates?version='+templatesVersion);}function getActions(){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])('actions');}function createHiveAction(newAction){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('actions',newAction);}function editAction(action,id){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["d" /* httpPut */])('actions/'+id,action);}function removeAction(actionId){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["a" /* httpDelete */])('actions/'+actionId);}function triggerQuickAction(actionId){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('actions/'+actionId+'/quick-action');}

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * tiny-cookie - A tiny cookie manipulation plugin
 * https://github.com/Alex1990/tiny-cookie
 * Under the MIT license | (c) Alex Chao
 */

!(function(root, factory) {

  // Uses CommonJS, AMD or browser global to create a jQuery plugin.
  // See: https://github.com/umdjs/umd
  if (true) {
    // Expose this plugin as an AMD module. Register an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    // Node/CommonJS module
    module.exports = factory();
  } else {
    // Browser globals 
    root.Cookie = factory();
  }

}(this, function() {

  'use strict';

  // The public function which can get/set/remove cookie.
  function Cookie(key, value, opts) {
    if (value === void 0) {
      return Cookie.get(key);
    } else if (value === null) {
      Cookie.remove(key);
    } else {
      Cookie.set(key, value, opts);
    }
  }

  // Check if the cookie is enabled.
  Cookie.enabled = function() {
    var key = '__test_key';
    var enabled;

    document.cookie = key + '=1';
    enabled = !!document.cookie;

    if (enabled) Cookie.remove(key);

    return enabled;
  };

  // Get the cookie value by the key.
  Cookie.get = function(key, raw) {
    if (typeof key !== 'string' || !key) return null;

    key = '(?:^|; )' + escapeRe(key) + '(?:=([^;]*?))?(?:;|$)';

    var reKey = new RegExp(key);
    var res = reKey.exec(document.cookie);

    return res !== null ? (raw ? res[1] : decodeURIComponent(res[1])) : null;
  };

  // Get the cookie's value without decoding.
  Cookie.getRaw = function(key) {
    return Cookie.get(key, true);
  };

  // Set a cookie.
  Cookie.set = function(key, value, raw, opts) {
    if (raw !== true) {
      opts = raw;
      raw = false;
    }
    opts = opts ? convert(opts) : convert({});
    var cookie = key + '=' + (raw ? value : encodeURIComponent(value)) + opts;
    document.cookie = cookie;
  };

  // Set a cookie without encoding the value.
  Cookie.setRaw = function(key, value, opts) {
    Cookie.set(key, value, true, opts);
  };

  // Remove a cookie by the specified key.
  Cookie.remove = function(key) {
    Cookie.set(key, 'a', { expires: new Date() });
  };

  // Helper function
  // ---------------

  // Escape special characters.
  function escapeRe(str) {
    return str.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
  }

  // Convert an object to a cookie option string.
  function convert(opts) {
    var res = '';

    for (var p in opts) {
      if (opts.hasOwnProperty(p)) {

        if (p === 'expires') {
          var expires = opts[p];
          if (typeof expires !== 'object') {
            expires += typeof expires === 'number' ? 'D' : '';
            expires = computeExpires(expires);
          }
          opts[p] = expires.toUTCString();
        }

        if (p === 'secure') {
          if (opts[p]) {
            res += ';' + p;
          }

          continue;
        }

        res += ';' + p + '=' + opts[p];
      }
    }

    if (!opts.hasOwnProperty('path')) {
      res += ';path=/';
    }

    return res;
  }

  // Return a future date by the given string.
  function computeExpires(str) {
    var expires = new Date();
    var lastCh = str.charAt(str.length - 1);
    var value = parseInt(str, 10);

    switch (lastCh) {
      case 'Y': expires.setFullYear(expires.getFullYear() + value); break;
      case 'M': expires.setMonth(expires.getMonth() + value); break;
      case 'D': expires.setDate(expires.getDate() + value); break;
      case 'h': expires.setHours(expires.getHours() + value); break;
      case 'm': expires.setMinutes(expires.getMinutes() + value); break;
      case 's': expires.setSeconds(expires.getSeconds() + value); break;
      default: expires = new Date(str);
    }

    return expires;
  }

  return Cookie;

}));


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(380),
    baseEach = __webpack_require__(196),
    baseIteratee = __webpack_require__(55),
    baseReduce = __webpack_require__(1343),
    isArray = __webpack_require__(32);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 1341 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(92);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1343 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(1345),
    createAssigner = __webpack_require__(624);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(282),
    assignMergeValue = __webpack_require__(623),
    baseFor = __webpack_require__(621),
    baseMergeDeep = __webpack_require__(1346),
    isObject = __webpack_require__(54),
    keysIn = __webpack_require__(287);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(623),
    cloneBuffer = __webpack_require__(562),
    cloneTypedArray = __webpack_require__(569),
    copyArray = __webpack_require__(186),
    initCloneObject = __webpack_require__(570),
    isArguments = __webpack_require__(226),
    isArray = __webpack_require__(32),
    isArrayLikeObject = __webpack_require__(307),
    isBuffer = __webpack_require__(227),
    isFunction = __webpack_require__(275),
    isObject = __webpack_require__(54),
    isPlainObject = __webpack_require__(308),
    isTypedArray = __webpack_require__(281),
    toPlainObject = __webpack_require__(1347);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(152),
    keysIn = __webpack_require__(287);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_routes__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_amazon_appstore_default_svg__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_amazon_appstore_default_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icons_amazon_appstore_default_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_menu__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state_app_settings_constants__ = __webpack_require__(180);
var _discoverNewFeatures;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var config={actions:{defaultSchedule:{monday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],tuesday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],wednesday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],thursday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],friday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],saturday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],sunday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}]},requiredDeviceUrl:{'contact-sensor':'https://www.hivehome.com/products/hive-window-door-sensor','hive-camera-sensor':'https://www.hivehome.com/products/hive-view','motion-sensor':'https://www.hivehome.com/products/hive-motion-sensor','na-temperature':'https://www.hivehome.com/us/products/hive-active-thermostat',temperature:'https://www.hivehome.com/products/hive-active-heating'},templatesVersion:1},acquireDevices:{attemptsBeforeWarning:5,attemptsBeforeTroubleshooting:10,pollExpiry:600000,pollInterval:5000},alerts:{expiry:5000},confirmHubDiscovery:false,cannotRemoveDevice:{hub:__WEBPACK_IMPORTED_MODULE_2__constants_devices__["deviceTypes"].HUB,leakSensor:__WEBPACK_IMPORTED_MODULE_2__constants_devices__["deviceTypes"].LEAK_SENSOR,naThermostat:__WEBPACK_IMPORTED_MODULE_2__constants_devices__["deviceTypes"].NA_THERMOSTAT},features:{activeplugPowerConsumption:false,batteryAlerts:true,dev:false,dashboardCustomisation:true,dashboardCustomisationData:true,// Used in place of dashboardCustomisation until features are completed
deviceGroups:false,devicegroupSchedule:false,emergencyHeat:true,helpAndSupportMenuLink:true,holidayMode:true,hueSchedule:false,hueMimic:false,installAddZone:true,installCamera:true,installHiveHub:true,installHiveHub360:false,installHiveView:false,installLeakSensor:false,installOtherDevices:true,installPhilipsHue:false,installNano1Upgrade:false,installNano1Upgrade360:false,installUpgradeHive2:false,installZones:true,leakSensor:true,mimicMode:true,mimicModeUpsell:true,mySubscriptions:false,newActions:true,notifications:true,readyBy:false,// actual Ready By feature
readyByOnboarding:false,// setting up Ready By that is not launching with Ready By for now
recipes:true,shopMenuLink:true,textControl:true,upgradeNano1Hub:false,setPin:true,hotWaterAdvance:true,hiveButton:false,manageDevicesModal:true,serviceOutageStatusCheck:false,showPhoneNumber:true,multiHome:false,slt3Replacement:false,identifyProductButton:false},discoverNewFeatures:(_discoverNewFeatures={},_defineProperty(_discoverNewFeatures,__WEBPACK_IMPORTED_MODULE_5__state_app_settings_constants__["b" /* DISCOVER_FEATURES */].ACTIONS2,true),_defineProperty(_discoverNewFeatures,__WEBPACK_IMPORTED_MODULE_5__state_app_settings_constants__["b" /* DISCOVER_FEATURES */].GROUPS,false),_defineProperty(_discoverNewFeatures,__WEBPACK_IMPORTED_MODULE_5__state_app_settings_constants__["b" /* DISCOVER_FEATURES */].HUE,false),_discoverNewFeatures),footer:{showDetailedFooter:false},help:{amazonAppstoreImage:__WEBPACK_IMPORTED_MODULE_1__icons_amazon_appstore_default_svg___default.a,amazonAppstoreLink:'https://www.amazon.co.uk/gp/mas/dl/android?asin=B00KLZFPYK',createAccountLink:'https://www.hivehome.com/register',helpLink:'https://www.hivehome.com/user-guides',hiveActions:'https://www.hivehome.com/actions',mainLink:'https://www.hivehome.com/',supportHours:'8am–9pm seven days a week',// eslint-disable-next-line max-len
faqLink:'https://www.hivehome.com/support/Help_Using_Hive/HUH_General/How-to-amend-schedules-using-the-website-dashboard',mainLinkText:'hivehome.com',termsConditionsLink:'https://www.hivehome.com/terms',hubPlacementGuide:'https://www.hivehome.com/faqs/Help_installing_Hive/HIH_General/Where-is-the-best-place-to-position-my-Hive-Hub',itunesLink:'https://itunes.apple.com/gb/app/hive/id712829172?mt=8',googlePlayLink:'https://play.google.com/store/apps/details?id=uk.co.centrica.hive&hl=en_GB',webshopUrl:'https://www.hivehome.com/products/categories/lights'// eslint-disable-line max-len
},holidayMode:{emergencyHeatTemperature:25,temperatureWarningValue:12.5,singleEditor:true},iconLocaleSuffix:'UK',installZones:{attemptsBeforeWarning:5,attemptsBeforeTroubleshooting:10,pollExpiry:600000,pollInterval:5000},temperatureUnit:'C',menu:[{id:'menu.home',icon:__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].DASHBOARD,subItems:[{id:'menu.home.overview',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["dashboard"]},{id:'menu.home.manage',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["manageHome"]}]},{icon:__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].DASHBOARD,id:'menu.dashboard',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["dashboard"]},{icon:__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].ACTIONS,id:'menu.recipes',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["recipes"],conditions:{canUseActions:true}},{icon:__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].SETTINGS,id:'menu.settings',subItems:[{id:'menu.settings-manage-devices',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["devices"],conditions:{hasManageableDevices:true}},{id:'menu.settings-install',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["install"]},{id:'menu.my-account',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["myAccount"]},{id:'menu.settings-change-password',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["changePassword"]},{id:'menu.settings-set-pin',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["changePin"],conditions:{feature:'setPin'}},{id:'menu.settings-notifications',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["notifications"],conditions:{feature:'notifications',hasHub:true,hasHeating:true,hasActions1:true}},{id:'menu.settings-text-control',link:__WEBPACK_IMPORTED_MODULE_0__constants_routes__["textControl"],conditions:{feature:'textControl',hasHub:true,hasHeating:true,hasPMZ:false}},{id:'menu.settings-logout',onClick:function onClick(props){return props.logOut();}}]},{icon:__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].HELP,id:'menu.help',staticLink:{url:'https://www.hivehome.com/support',target:'_blank'},conditions:{feature:'helpAndSupportMenuLink'}},{icon:__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].SHOP,id:'menu.shop',template:__WEBPACK_IMPORTED_MODULE_4__constants_menu__["a" /* menuTemplates */].SHOP,conditions:{feature:'shopMenuLink'},staticLink:{url:'https://www.hivehome.com/products'}},{icon:__WEBPACK_IMPORTED_MODULE_3__constants_icons_general_svg__["a" /* default */].DEMO,id:'Dev',link:'/dev',conditions:{feature:'dev'}}],notifications:{defaults:{hotEnabled:false,hotTemperature:25,coldEnabled:false,coldTemperature:10,warningsEnabled:false},minTemp:5,maxTemp:32},products:{bulbs:{maxTemperature:6535,minTemperature:2700,offWhiteHue:23,offWhiteSaturation:20},colourtuneablelight:{defaultBrightness:100,defaultHue:0,defaultSaturation:99,defaultTemperature:2700},colourlight:{defaultBrightness:100,defaultHue:0,defaultSaturation:99,defaultTemperature:2700},cooling:{defaultTemp:26,interval:0.5,maxTemp:32,metric:'C',defaultBoostTarget:25.5,defaultBoostDuration:60,minTemp:16.5},heating:{defaultTemp:20,frostProtection:7,interval:0.5,maxTemp:32,maxTempDual:30.5,metric:'C',minTemp:5,defaultBoostDuration:60,defaultBoostTarget:22},hotwater:{defaultBoostDuration:60},tuneablelight:{defaultBrightness:100,defaultTemperature:2700},warmwhitelight:{defaultBrightness:80}},recipes:{defaultSchedule:{monday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],tuesday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],wednesday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],thursday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],friday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],saturday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}],sunday:[{start:390,value:{state:'ARM'}},{start:510,value:{state:'ARM'}},{start:960,value:{state:'ARM'}},{start:1290,value:{state:'ARM'}}]},notifications:{email:true,push:true,sms:false}},subscriptions:{hiveLiveUrl:'https://www.hivehome.com/products/hive-live'},upgradeThermostat:{pollExpiry:300000},upgradeNano1Hub:{available:true},user:{inactiveTimeout:1200000},v2JWTVerifyKey:'26378263789',weather:{}};/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/amazon-appstore-default.85a8922ad81ea5ff3d8b40d9ec5a2a63718172cdf8e6ba22e728d75250f564fc.svg";

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(415);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNull);


/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(628);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (isUndefined);


/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_js__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values_js__ = __webpack_require__(1363);






/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? collection : Object(__WEBPACK_IMPORTED_MODULE_4__values_js__["a" /* default */])(collection);
  fromIndex = (fromIndex && !guard) ? Object(__WEBPACK_IMPORTED_MODULE_3__toInteger_js__["a" /* default */])(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && Object(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(collection, value, fromIndex) > -1);
}

/* harmony default export */ __webpack_exports__["a"] = (includes);


/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__ = __webpack_require__(1359);




/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? Object(__WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__["a" /* default */])(array, value, fromIndex)
    : Object(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__["a" /* default */], fromIndex);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIndexOf);


/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFindIndex);


/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNaN);


/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (strictIndexOf);


/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toFinite_js__ = __webpack_require__(1361);


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__toFinite_js__["a" /* default */])(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toInteger);


/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toNumber_js__ = __webpack_require__(1362);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = Object(__WEBPACK_IMPORTED_MODULE_0__toNumber_js__["a" /* default */])(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toFinite);


/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(419);



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseValues_js__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(1365);



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : Object(__WEBPACK_IMPORTED_MODULE_0__baseValues_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (values);


/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(631);


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseValues);


/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(417);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(634);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(166);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(628);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(634);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(138);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(641);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(1377);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(138);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(138);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(138);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(138);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(138);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(1384);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(419);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isMap__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reduce_reducers__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reduce_reducers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reduce_reducers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handleAction__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ownKeys__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flattenUtils__ = __webpack_require__(642);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









function get(key, x) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isMap__["a" /* default */])(x) ? x.get(key) : x[key];
}

function handleActions(handlers, defaultState) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(handlers) || Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isMap__["a" /* default */])(handlers), 'Expected handlers to be a plain object.');
  var flattenedReducerMap = Object(__WEBPACK_IMPORTED_MODULE_6__flattenUtils__["c" /* flattenReducerMap */])(handlers, options);
  var reducers = Object(__WEBPACK_IMPORTED_MODULE_5__ownKeys__["a" /* default */])(flattenedReducerMap).map(function (type) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__handleAction__["a" /* default */])(type, get(type, flattenedReducerMap), defaultState);
  });
  var reducer = __WEBPACK_IMPORTED_MODULE_2_reduce_reducers___default.a.apply(undefined, _toConsumableArray(reducers));
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    return reducer(state, action);
  };
}

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == mapTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMap);


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = reduceReducers;

function reduceReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasGeneratorInterface;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownKeys__ = __webpack_require__(422);


function hasGeneratorInterface(handler) {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_0__ownKeys__["a" /* default */])(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_last__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_isNil__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__createAction__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__arrayToObject__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flattenUtils__ = __webpack_require__(642);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }














function createActions(actionMap) {
  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_last__["a" /* default */])(identityActions)) ? identityActions.pop() : {};
  __WEBPACK_IMPORTED_MODULE_9_invariant___default()(identityActions.every(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */]) && (Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */])(actionMap) || Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(actionMap)), 'Expected optional object followed by string action types');
  if (Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */])(actionMap)) {
    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
  }
  return _extends({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
}

function actionCreatorsFromActionMap(actionMap, options) {
  var flatActionMap = Object(__WEBPACK_IMPORTED_MODULE_11__flattenUtils__["b" /* flattenActionMap */])(actionMap, options);
  var flatActionCreators = actionMapToActionCreators(flatActionMap);
  return Object(__WEBPACK_IMPORTED_MODULE_11__flattenUtils__["d" /* unflattenActionCreators */])(flatActionCreators, options);
}

function actionMapToActionCreators(actionMap) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      prefix = _ref.prefix,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === undefined ? __WEBPACK_IMPORTED_MODULE_11__flattenUtils__["a" /* defaultNamespace */] : _ref$namespace;

  function isValidActionMapValue(actionMapValue) {
    if (Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(actionMapValue) || Object(__WEBPACK_IMPORTED_MODULE_7_lodash_es_isNil__["a" /* default */])(actionMapValue)) {
      return true;
    } else if (Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__["a" /* default */])(actionMapValue)) {
      var _actionMapValue = _slicedToArray(actionMapValue, 2),
          _actionMapValue$ = _actionMapValue[0],
          payload = _actionMapValue$ === undefined ? __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__["a" /* default */] : _actionMapValue$,
          meta = _actionMapValue[1];

      return Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(payload) && Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(meta);
    }
    return false;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(Object.keys(actionMap), function (partialActionCreators, type) {
    var actionMapValue = actionMap[type];
    __WEBPACK_IMPORTED_MODULE_9_invariant___default()(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ('functions for ' + type));
    var prefixedType = prefix ? '' + prefix + namespace + type : type;
    var actionCreator = Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__["a" /* default */])(actionMapValue) ? __WEBPACK_IMPORTED_MODULE_8__createAction__["a" /* default */].apply(undefined, [prefixedType].concat(_toConsumableArray(actionMapValue))) : Object(__WEBPACK_IMPORTED_MODULE_8__createAction__["a" /* default */])(prefixedType, actionMapValue);
    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
  });
}

function actionCreatorsFromIdentityActions(identityActions, options) {
  var actionMap = Object(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(identityActions, function (partialActionMap, type) {
    return _extends({}, partialActionMap, _defineProperty({}, type, __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__["a" /* default */]));
  });
  var actionCreators = actionMapToActionCreators(actionMap, options);
  return Object(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(Object.keys(actionCreators), function (partialActionCreators, type) {
    return _extends({}, partialActionCreators, _defineProperty({}, Object(__WEBPACK_IMPORTED_MODULE_0__camelCase__["a" /* default */])(type), actionCreators[type]));
  });
}

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (last);


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188)(module), __webpack_require__(21)))

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1395);
exports.encode = exports.stringify = __webpack_require__(1396);


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getAppConfig"] = getAppConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
function getAppConfig(platform,config){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])('apps/'+platform+'/'+config,false,false);}

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["login"] = login;
/* harmony export (immutable) */ __webpack_exports__["adminLogin"] = adminLogin;
/* harmony export (immutable) */ __webpack_exports__["logout"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drivers_cookie__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url__);
function login(username,password){var multiHomeEnabled=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var loginURL=__WEBPACK_IMPORTED_MODULE_2_url___default.a.format({pathname:'global/login'});var body={username:username,password:password,devices:true,products:true,actions:true,homes:multiHomeEnabled};return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])(loginURL,body,false,false);}function adminLogin(token){var multiHomeEnabled=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var body={token:token,devices:true,products:true,actions:true,homes:multiHomeEnabled};var endpoint=__WEBPACK_IMPORTED_MODULE_1__drivers_cookie__["a" /* default */].get('endpoint');var adminLoginURL=__WEBPACK_IMPORTED_MODULE_2_url___default.a.format({pathname:(endpoint?'auth':'global')+'/admin-login'});return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])(adminLoginURL,body,false,false,endpoint);}function logout(){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["a" /* httpDelete */])('auth/logout');}

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = changePassword;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
// @noflow
function changePassword(newPassword,oldPassword,id){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('user/'+id+'/set-password',{password:newPassword,oldPassword:oldPassword},true);}

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendPasswordResetEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
// @noflow
function sendPasswordResetEmail(email){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('global/send-password-reset',{email:email},false,false);}

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["get"] = get;
/* harmony export (immutable) */ __webpack_exports__["save"] = save;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
var endpoint='/heating-notifications';function get(){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])(endpoint);}function save(id,coldEnabled,coldTemperature,hotEnabled,hotTemperature){var payload={hot:{enabled:hotEnabled,temperature:hotTemperature},cold:{enabled:coldEnabled,temperature:coldTemperature}};return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])(endpoint+'/'+id,payload);}

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resetPassword;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
// @noflow
function resetPassword(password,token,email){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('global/reset-password',{password:password,token:token,email:email},false,false);}

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["setAllowAnalyticsSharing"] = setAllowAnalyticsSharing;
/* harmony export (immutable) */ __webpack_exports__["setPin"] = setPin;
/* harmony export (immutable) */ __webpack_exports__["getAttribute"] = getAttribute;
/* harmony export (immutable) */ __webpack_exports__["setAttribute"] = setAttribute;
/* harmony export (immutable) */ __webpack_exports__["getAlerts"] = getAlerts;
/* harmony export (immutable) */ __webpack_exports__["setAlerts"] = setAlerts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
function setAllowAnalyticsSharing(userId,allowAnalyticsSharing){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('user/'+userId+'/set-media',{allowAnalyticsSharing:allowAnalyticsSharing});}function setPin(userId,pin){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('user/'+userId+'/set-pin',{pin:pin});}function getAttribute(userId,attribute){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])('web/user/'+userId+'/attributes/'+attribute);}function setAttribute(userId,attribute,settingsData){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('web/user/'+userId+'/attributes/'+attribute,settingsData);}function getAlerts(userId){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('user/'+userId+'/get-alerts');}function setAlerts(userId,alerts){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('user/'+userId+'/set-alerts',alerts);}

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setupHeaders", function() { return setupHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameHome", function() { return renameHome; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__drivers_cookie__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_config__ = __webpack_require__(270);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var setupHeaders=function setupHeaders(token){var apiKey=Object(__WEBPACK_IMPORTED_MODULE_2__state_config__["b" /* getFromConfig */])('homes:homeServiceApiKey');return{'Content-Type':'application/json','x-api-key':apiKey,Authorization:'Bearer '+token};};var renameHome=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(name,homeId,userId){var endpoint,token,headers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:endpoint=Object(__WEBPACK_IMPORTED_MODULE_2__state_config__["b" /* getFromConfig */])('homes:homeServiceUrl')+'/owner/'+userId+'/home/'+homeId+'/rename';token=__WEBPACK_IMPORTED_MODULE_1__drivers_cookie__["a" /* default */].get('token');headers=setupHeaders(token);return _context.abrupt('return',fetch(endpoint,{headers:headers,method:'PUT',body:JSON.stringify({name:name})}));case 4:case'end':return _context.stop();}}},_callee,this);}));return function renameHome(_x,_x2,_x3){return _ref.apply(this,arguments);};}();

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getServiceOutage"] = getServiceOutage;
function getServiceOutage(serviceUrlBase,locale){return fetch(""+serviceUrlBase+locale+".json");}

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(1407);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21), __webpack_require__(188)(module)))

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(651);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(652);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_merge__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__acquire_devices__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__alerts__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__application__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_settings__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ui_sensor_logs_audio_player___ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__authentication__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ui_bulbs__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__connected_care_invite__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__products_contact_sensor__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cookies__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dashboard__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__devices__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__entitlements__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__form__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__groups__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__homes__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__holiday_mode__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hub__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__products_leak_sensor__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__menu__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__products_motion_sensor__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__install_nano1_upgrade__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__install_hue_bridge__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__navigate__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__notifications__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__power_consumption__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__products__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__recipes__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ui_schedule__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__products_sense___ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__settings_modal__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__text_control__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__translations__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__user__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__weather__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__service_outage__ = __webpack_require__(1545);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var getSyncReducers=function getSyncReducers(){return{acquireDevices:__WEBPACK_IMPORTED_MODULE_1__acquire_devices__["a" /* default */],actions:__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],alerts:__WEBPACK_IMPORTED_MODULE_3__alerts__["a" /* default */],application:__WEBPACK_IMPORTED_MODULE_4__application__["a" /* default */],appSettings:__WEBPACK_IMPORTED_MODULE_5__app_settings__["a" /* default */],audioPlayer:__WEBPACK_IMPORTED_MODULE_6__ui_sensor_logs_audio_player___["a" /* default */],authentication:__WEBPACK_IMPORTED_MODULE_7__authentication__["a" /* default */],bulbsUi:__WEBPACK_IMPORTED_MODULE_8__ui_bulbs__["b" /* default */],config:__WEBPACK_IMPORTED_MODULE_10__config__["a" /* default */],connectedCareInvite:__WEBPACK_IMPORTED_MODULE_11__connected_care_invite__["a" /* default */],contactSensor:__WEBPACK_IMPORTED_MODULE_12__products_contact_sensor__["a" /* default */],cookies:__WEBPACK_IMPORTED_MODULE_13__cookies__["a" /* default */],dashboard:__WEBPACK_IMPORTED_MODULE_14__dashboard__["a" /* default */],devices:__WEBPACK_IMPORTED_MODULE_15__devices__["a" /* default */],entitlements:__WEBPACK_IMPORTED_MODULE_16__entitlements__["a" /* default */],form:__WEBPACK_IMPORTED_MODULE_17__form__["a" /* default */],groups:__WEBPACK_IMPORTED_MODULE_18__groups__["a" /* default */],homes:__WEBPACK_IMPORTED_MODULE_19__homes__["a" /* default */],holidayMode:__WEBPACK_IMPORTED_MODULE_20__holiday_mode__["a" /* default */],hub:__WEBPACK_IMPORTED_MODULE_21__hub__["a" /* default */],hueBridgeInstallation:__WEBPACK_IMPORTED_MODULE_27__install_hue_bridge__["a" /* default */],leakSensor:__WEBPACK_IMPORTED_MODULE_22__products_leak_sensor__["a" /* default */],menu:__WEBPACK_IMPORTED_MODULE_24__menu__["a" /* default */],motionSensor:__WEBPACK_IMPORTED_MODULE_25__products_motion_sensor__["a" /* default */],installNano1Upgrade:__WEBPACK_IMPORTED_MODULE_26__install_nano1_upgrade__["a" /* default */],navigate:__WEBPACK_IMPORTED_MODULE_28__navigate__["a" /* default */],notifications:__WEBPACK_IMPORTED_MODULE_29__notifications__["a" /* default */],powerConsumption:__WEBPACK_IMPORTED_MODULE_30__power_consumption__["a" /* default */],products:__WEBPACK_IMPORTED_MODULE_31__products__["a" /* default */],recipes:__WEBPACK_IMPORTED_MODULE_32__recipes__["a" /* default */],schedules2:__WEBPACK_IMPORTED_MODULE_33__ui_schedule__["a" /* default */],sense:__WEBPACK_IMPORTED_MODULE_34__products_sense___["a" /* default */],serviceOutage:__WEBPACK_IMPORTED_MODULE_40__service_outage__["a" /* default */],settingsModal:__WEBPACK_IMPORTED_MODULE_35__settings_modal__["a" /* default */],textControl:__WEBPACK_IMPORTED_MODULE_36__text_control__["a" /* default */],translations:__WEBPACK_IMPORTED_MODULE_37__translations__["a" /* default */],user:__WEBPACK_IMPORTED_MODULE_38__user__["a" /* default */],weather:__WEBPACK_IMPORTED_MODULE_39__weather__["a" /* default */]};};var combineReducersWithAsync=function combineReducersWithAsync(){var asyncReducers=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var syncReducers=getSyncReducers();var asyncKeys=Object.keys(asyncReducers);var asyncAndComposedDuplicateReducers=asyncKeys.reduce(function(agg,key){var asyncReducer=asyncReducers[key];var syncReducer=syncReducers[key];var _asyncReducer$reduce=asyncReducer.reduce,reduce=_asyncReducer$reduce===undefined?asyncReducer:_asyncReducer$reduce;// If a sync reducer already exists for this branch,
// and the asyncReducer identifies itself as being mergable,
// compose the new async one with the sync one.
var nextReducer=syncReducer&&asyncReducer.mergable?function(state,action){// If we know the state is null/undefined we know that each reducer
// will return a `defaultState` object.
// For this reason we can't simply compose the calls because sync(state) will return a defaultState
// and async(defaultSyncState) will receive it, thus not returning it's own defaultState.
// Let's call them separately and merge the two defaultStates together.
if(state===null||state===undefined){var syncDefaultState=syncReducer(state,action);var asyncDefaultState=reduce(state,action);return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_merge___default()(syncDefaultState,asyncDefaultState);}return reduce(syncReducer(state,action),action);}:reduce;return Object.assign({},agg,_defineProperty({},key,nextReducer));},{});return Object(__WEBPACK_IMPORTED_MODULE_9_redux__["combineReducers"])(Object.assign({},syncReducers,asyncAndComposedDuplicateReducers));};function createReducer(asyncReducers){var combinedReducers=combineReducersWithAsync(asyncReducers);return function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_23__application_actions__["a" /* ResetState */].toString()){state=undefined;}return combinedReducers(state,action);};}

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={devices:[],errors:0,finishedAcquiring:false,installInProgress:false,placementAdvice:__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PLACEMENT_ADVICE_TYPES */].NOT_SHOWN,startTime:undefined};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ACQUIRE_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var devices=_ref.payload;var placementAdvice=state.placementAdvice;if(placementAdvice!==__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PLACEMENT_ADVICE_TYPES */].SHOWN){var adviceNeeded=devices.some(function(_ref2){var type=_ref2.type;return type===__WEBPACK_IMPORTED_MODULE_1__constants_devices__["deviceTypes"].SIGNAL_BOOSTER;});placementAdvice=adviceNeeded?__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PLACEMENT_ADVICE_TYPES */].SHOW:__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PLACEMENT_ADVICE_TYPES */].NOT_SHOWN;}return Object.assign({},state,{devices:devices,placementAdvice:placementAdvice,errors:0});},function(state){return Object.assign({},state,{errors:state.errors+1});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CLOSE_PLACEMENT_ADVICE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{placementAdvice:__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PLACEMENT_ADVICE_TYPES */].SHOWN});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FINISH_INSTALL_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{installInProgress:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* FINISHED_INSTALL_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{installInProgress:false});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* START_ACQUIRE_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref3){var time=_ref3.payload;return Object.assign({},state,{devices:[],errors:0,finishedAcquiring:false,placementAdvice:__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PLACEMENT_ADVICE_TYPES */].NOT_SHOWN,startTime:time});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* STOP_ACQUIRE_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{errors:0,finishedAcquiring:true,startTime:undefined});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* UNLOAD_INSTALL_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{devices:[]});})),_handleActions),initialState));

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={actionForm:'none',actionsBeingDeleted:[],actions:[],loadingActions:false,loadingTemplates:false,savingState:'done',templates:[],triggerActionsList:[]};var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ADD_ACTION_ATTRIBUTE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref){var event=_ref.payload;return Object.assign({},state,state.actionForm==='none'||!event?{}:{actionForm:Object.assign({},state.actionForm,_defineProperty({},event.group,[].concat(_toConsumableArray(state.actionForm[event.group]),[event])))});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ATTEMPT_CREATE_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{savingState:'saving'});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ATTEMPT_EDIT_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{savingState:'saving'});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ATTEMPT_REMOVE_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref2){var actionId=_ref2.payload;return Object.assign({},state,{actionsBeingDeleted:[].concat(_toConsumableArray(state.actionsBeingDeleted),[actionId]),savingState:'saving'});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ATTEMPT_TRIGGER_QUICK_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref3){var actionId=_ref3.payload;return Object.assign({},state,{triggerActionsList:[].concat(_toConsumableArray(state.triggerActionsList.filter(function(a){return a.id!==actionId;})),[{id:actionId,displayState:__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* TRIGGERED */]}])});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* CANCEL_FORM */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{actionForm:'none'});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["g" /* EDIT_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref4){var action=_ref4.payload;var actionsWithEdit=state.actions.map(function(a){return a.id!==action.id?a:Object.assign({},a,action);});return Object.assign({},state,{actions:actionsWithEdit});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["h" /* END_ATTEMPT */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{actionForm:'none',savingState:'done'});},function(state){return Object.assign({},state,{savingState:'failed'});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* END_ATTEMPT_CREATE_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref5){var newAction=_ref5.payload;return Object.assign({},state,{actions:[].concat(_toConsumableArray(state.actions),[newAction]),actionForm:'none',savingState:'done'});},function(state){return Object.assign({},state,{savingState:'failed'});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* GET_ACTIONS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{loadingActions:true});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* GET_TEMPLATES */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{loadingTemplates:true});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* LOAD_FORM */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref6){var form=_ref6.payload;return Object.assign({},state,{actionForm:form});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* RECEIVE_ACTIONS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref7){var actions=_ref7.payload;return Object.assign({},state,{actions:actions,loadingActions:false});},function(state){return Object.assign({},state,{loadingActions:false});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* RECEIVE_TEMPLATES */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref8){var templates=_ref8.payload.templates;return Object.assign({},state,{templates:templates,loadingTemplates:false});},function(state){return Object.assign({},state,{loadingTemplates:false});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* REMOVE_ACTION_ATTRIBUTE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref9){var event=_ref9.payload;return Object.assign({},state,state.actionForm==='none'||!event?{}:{actionForm:Object.assign({},state.actionForm,_defineProperty({},event.group,state.actionForm[event.group].filter(function(e){return!(event&&e.type===event.type&&(!e.id||e.id===event.id));})))});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* REMOVE_ACTION_FROM_LIST */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref10){var actionId=_ref10.payload;return Object.assign({},state,{actions:state.actions.filter(function(a){return a.id!==actionId;})});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* REMOVE_ACTION_FROM_DELETE_LIST */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref11){var actionId=_ref11.payload;return Object.assign({},state,{actionsBeingDeleted:state.actionsBeingDeleted.reduce(function(acc,action){return action===actionId?acc:[].concat(_toConsumableArray(acc),[action]);},[]),actions:state.actions.filter(function(a){return a.id!==actionId;})});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* RESET_QUICK_ACTION_STATUS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref12){var actionId=_ref12.payload;return Object.assign({},state,{triggerActionsList:[].concat(_toConsumableArray(state.triggerActionsList.filter(function(a){return a.id!==actionId;})),[{id:actionId,displayState:__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* IDLE */]}])});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_ACTION_FORM */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref13){var payload=_ref13.payload;return Object.assign({},state,state.actionForm==='none'||!payload?{}:{actionForm:Object.assign({},state.actionForm,_defineProperty({},payload.propertyName,payload.newValue))});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* SET_ACTION_ATTRIBUTE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref14){var payload=_ref14.payload;var setAttributeFromGroup=function setAttributeFromGroup(all,item,index){return payload&&payload.attributeIndex===index?[].concat(_toConsumableArray(all),[Object.assign({},item,_defineProperty({},payload.attributeProperty,payload.newValue))]):[].concat(_toConsumableArray(all),[item]);};return Object.assign({},state,state.actionForm==='none'||!payload?{}:{actionForm:Object.assign({},state.actionForm,_defineProperty({},payload.group,state.actionForm[payload.group].reduce(setAttributeFromGroup,[])))});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* TRIGGER_QUICK_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref15){var actionId=_ref15.payload;return Object.assign({},state,{triggerActionsList:[].concat(_toConsumableArray(state.triggerActionsList.filter(function(a){return a.id!==actionId;})),[{id:actionId,displayState:__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* SUCCESS */]}])});},function(state,_ref16){var error=_ref16.payload;return Object.assign({},state,{triggerActionsList:[].concat(_toConsumableArray(state.triggerActionsList.filter(function(a){return a.id!==error.message;})),[{id:error.message,displayState:__WEBPACK_IMPORTED_MODULE_1__constants__["j" /* ERROR */]}])});})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])(actionHandlers,initialState));

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DISMISS_ALERT */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var id=_ref.payload;return(// $FlowFixMe
state.update('alertItems',function(alerts){return alerts.filter(function(a){return a.get('id')!==id;});}));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* DISMISS_ALL_ALERTS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('alertItems',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([]));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* REQUEST_ALERT */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref2){var payload=_ref2.payload;return(// $FlowFixMe
state.update('alertItems',function(alerts){return alerts.filter(function(x){return x.get('type')!==payload.type&&x.getIn(['text','id'])!==payload.text.id;}).push(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload));}));})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({alertItems:[]})));

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handle_reduce__ = __webpack_require__(17);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var EN_GB='en-GB';var IE='IE';var EN_IE='en-IE';var LOCALE_MAPPINGS=_defineProperty({},EN_GB+IE,EN_IE);var actionHandlers=new Map([// $FlowFixMe
[__WEBPACK_IMPORTED_MODULE_1__actions__["c" /* attemptLogIn */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('loggingIn',true);})],[__WEBPACK_IMPORTED_MODULE_1__actions__["h" /* logIn */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,action){return(// $FlowFixMe
state.merge({locale:LOCALE_MAPPINGS[action.payload.user.locale+action.payload.user.countryCode]||action.payload.user.locale,token:action.payload.token,beekeeperEndpoint:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default()(undefined,'payload.platform.endpoint',action),honeycombEndpoint:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default()(undefined,'payload.platform.honeycomb',action)}));})],[__WEBPACK_IMPORTED_MODULE_1__actions__["i" /* logInComplete */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return(// $FlowFixMe
state.withMutations(function(state){return state.set('loginComplete',true).set('loggingInError',false).set('loggingIn',false);}));},// $FlowFixMe
function(state){return state.withMutations(function(state){return state.set('loggingInError',true).set('loggingIn',false);});})],[__WEBPACK_IMPORTED_MODULE_1__actions__["j" /* logInReset */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return(// $FlowFixMe
state.withMutations(function(state){return state.set('loggingInError',false).set('loggingIn',false);}));})],[__WEBPACK_IMPORTED_MODULE_1__actions__["k" /* logOut */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,action){return(// $FlowFixMe
state.merge({token:undefined,beekeeperEndpoint:undefined,honeycombEndpoint:undefined,loggingOut:true}));})],[__WEBPACK_IMPORTED_MODULE_1__actions__["m" /* showHiveLiveModal */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref){var feature=_ref.payload.feature;return(// $FlowFixMe
state.set('showHiveLiveModal',feature));})],// $FlowFixMe
[__WEBPACK_IMPORTED_MODULE_1__actions__["d" /* hideHiveLiveModal */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('showHiveLiveModal',false);})],[__WEBPACK_IMPORTED_MODULE_1__actions__["l" /* receiveGTMOffers */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref2){var offers=_ref2.payload;return(// $FlowFixMe
state.set('hive-offers',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(offers)));})],[__WEBPACK_IMPORTED_MODULE_1__actions__["p" /* showWelcomeMessage */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref3){var welcomeMessage=_ref3.payload;return(// $FlowFixMe
state.set('welcomeMessage',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(welcomeMessage)).set('showWelcomeMessage',true));})],// $FlowFixMe
[__WEBPACK_IMPORTED_MODULE_1__actions__["g" /* hideWelcomeMessage */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('showWelcomeMessage',false);})],// $FlowFixMe
[__WEBPACK_IMPORTED_MODULE_1__actions__["o" /* showLeakSensorModal */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('showLeakSensorModal',true);})],// $FlowFixMe
[__WEBPACK_IMPORTED_MODULE_1__actions__["f" /* hideLeakSensorModal */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('showLeakSensorModal',false);})],// $FlowFixMe
[__WEBPACK_IMPORTED_MODULE_1__actions__["n" /* showHumidityControl */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('showHumidityControl',true);})],// $FlowFixMe
[__WEBPACK_IMPORTED_MODULE_1__actions__["e" /* hideHumidityControl */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('showHumidityControl',false);})],// $FlowFixMe
[__WEBPACK_IMPORTED_MODULE_1__actions__["q" /* startLoginAnimation */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('playLoginAnimation',true);})],// $FlowFixMe
[__WEBPACK_IMPORTED_MODULE_1__actions__["r" /* stopLoginAnimation */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('playLoginAnimation',false);})]]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({loginComplete:false,loggingIn:false,loggingInError:false,showWelcomeMessage:false,showHumidityControl:false,showLeakSensorModal:false,playLoginAnimation:false,showServiceOutage:false})));

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SET_APP_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;var nextSettings=state.get('settings').merge(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload));return state.set('settings',nextSettings);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* GET_APP_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('loading',true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* RECEIVE_APP_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref2){var payload=_ref2.payload;return state.withMutations(function(state){return state.set('loading',false).set('settings',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload));});})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({settings:{},loading:false})));

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({data:null});var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* AUDIO_DATA_RECEIVED */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var data=_ref.payload.data;return state.set('data',data);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CLEAR_DATA */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('data',null);})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandlers,defaultState));

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={forgottenPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FORGOTTEN_PASSWORD_READY */],resetPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* RESET_PASSWORD_READY */]};var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CLEAR_RESET_PASSWORD_ERROR */],function(state){return{resetPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* RESET_PASSWORD_READY */]};}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FORGOTTEN_PASSWORD_READY */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(){return{forgottenPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* FORGOTTEN_PASSWORD_READY */]};})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(){return{forgottenPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST */]};})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return{forgottenPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT */]};},function(state){return{forgottenPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* FORGOTTEN_PASSWORD_ERROR */]};})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* RESET_PASSWORD_READY */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(){return{resetPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* RESET_PASSWORD_READY */]};})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* RESETTING_PASSWORD */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(){return{resetPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* RESETTING_PASSWORD */]};},function(){return{resetPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* RESETTING_PASSWORD */]};})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PASSWORD_RESET_REQUEST */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(){return{resetPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* RESETTING_PASSWORD */]};})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* RESET_PASSWORD */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return{resetPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* RESET_PASSWORD_SUCCESS */]};},function(state,_ref){var payload=_ref.payload;return{resetPasswordState:__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* RESET_PASSWORD_ERROR */]};})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])(actionHandlers,initialState));

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('assign', __webpack_require__(1421));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(280),
    copyObject = __webpack_require__(152),
    createAssigner = __webpack_require__(624),
    isArrayLike = __webpack_require__(92),
    isPrototype = __webpack_require__(229),
    keys = __webpack_require__(108);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('isObject', __webpack_require__(54), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: experimental
 * name: module folktale/adt/union/derivations
 */
module.exports = {
  serialization: __webpack_require__(1424),
  equality: __webpack_require__(1427),
  debugRepresentation: __webpack_require__(1432)
};

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

// --[ Dependencies ]---------------------------------------------------
var _require = __webpack_require__(198),
    tagSymbol = _require.tagSymbol,
    typeSymbol = _require.typeSymbol;

var mapValues = __webpack_require__(1425);
var values = __webpack_require__(1426);
var extend = __webpack_require__(239);

// --[ Constants ]------------------------------------------------------
var typeJsonKey = '@@type';
var tagJsonKey = '@@tag';
var valueJsonKey = '@@value';

// --[ Helpers ]--------------------------------------------------------

/*~
 * type: ((Object 'a) => 'b) => ([Object 'a]) => Object 'b  
 */
var arrayToObject = function arrayToObject(extractKey) {
  return function (array) {
    return array.reduce(function (object, element) {
      object[extractKey(element)] = element;
      return object;
    }, {});
  };
};

/*~
 * type: (String) => (Object 'a) => 'a | None 
 */
var property = function property(propertyName) {
  return function (object) {
    return object[propertyName];
  };
};

/*~
 * type: ([Object 'a]) => Object 'a 
 */
var indexByType = arrayToObject(property(typeSymbol));

/*~
 * type: (String, String) => Bool
 */
var assertType = function assertType(given, expected) {
  if (expected !== given) {
    throw new TypeError('\n       The JSON structure was generated from ' + expected + '.\n       You are trying to parse it as ' + given + '. \n    ');
  }
};

/*~
 * type: |
 *   type JSONSerialisation = {
 *     "@@type":  String,
 *     "@@tag":   String,
 *     "@@value": Object Any
 *   }
 *   type JSONParser = {
 *     fromJSON: (JSONSerialisation, Array JSONParser) => Variant
 *   }
 * 
 *   (Object JSONParser) => (JSONSerialisation) => Any
 */
var parseValue = function parseValue(parsers) {
  return function (value) {
    if (value !== null && typeof value[typeJsonKey] === 'string') {
      var type = value[typeJsonKey];
      if (parsers[type]) {
        return parsers[type].fromJSON(value, parsers, true);
      } else {
        return value;
      }
    } else {
      return value;
    }
  };
};

/*~
 * type: ('a) => JSON
 */
var serializeValue = function serializeValue(value) {
  return value === undefined ? null : value !== null && typeof value.toJSON === 'function' ? value.toJSON() : /* otherwise */value;
};

// --[ Implementation ]-------------------------------------------------

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   (Variant, ADT) => Void 
 */
var serialization = function serialization(variant, adt) {
  var typeName = adt[typeSymbol];
  var tagName = variant.prototype[tagSymbol];

  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   type JSONSerialisation = {
   *     "@@type":  String,
   *     "@@tag":   String,
   *     "@@value": Object Any
   *   }
   * 
   *   Variant . () => JSONSerialisation
   */
  variant.prototype.toJSON = function () {
    var _ref;

    return _ref = {}, _defineProperty(_ref, typeJsonKey, typeName), _defineProperty(_ref, tagJsonKey, tagName), _defineProperty(_ref, valueJsonKey, mapValues(this, serializeValue)), _ref;
  };

  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   type JSONSerialisation = {
   *     "@@type":  String,
   *     "@@tag":   String,
   *     "@@value": Object Any
   *   }
   *   type JSONParser = {
   *     fromJSON: (JSONSerialisation, Array JSONParser) => Variant
   *   }
   * 
   *   (JSONSerialisation, Array JSONParser) => Variant
   */
  adt.fromJSON = function (value) {
    var parsers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _defineProperty({}, typeName, adt);
    var keysIndicateType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var valueTypeName = value[typeJsonKey];
    var valueTagName = value[tagJsonKey];
    var valueContents = value[valueJsonKey];
    assertType(typeName, valueTypeName);
    var parsersByType = keysIndicateType ? parsers : /*otherwise*/indexByType(values(parsers));

    var parsedValue = mapValues(valueContents, parseValue(parsersByType));
    return extend(Object.create(adt[valueTagName].prototype), parsedValue);
  };
};

// --[ Exports ]--------------------------------------------------------
module.exports = serialization;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: stable
 * authors:
 *   - Quildreen Motta
 *
 * complexity: O(n), n is the number of own enumerable properties.
 * type: |
 *   (Object 'a, ('a) => 'b) => Object 'b
 */
var mapValues = function mapValues(object, transformation) {
  var keys = Object.keys(object);
  var result = {};

  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    result[key] = transformation(object[key]);
  }

  return result;
};

// --[ Convenience ]---------------------------------------------------

/*~
 * stability: stable
 * authors:
 *   - Quildreen Motta
 * 
 * complexity: O(n), n is the number of own enumerable properties.
 * type: |
 *   (Object 'a) . (('a) => 'b) => Object 'b
 */
mapValues.infix = function (transformation) {
  return mapValues(this, transformation);
};

// --[ Exports ]-------------------------------------------------------
module.exports = mapValues;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability : stable
 * authors:
 *   - Quildreen Motta
 *
 * complexity : O(n), n is the number of own enumerable properties.
 * type: |
 *   (Object 'a) => Array 'a
 */
var values = function values(object) {
  return Object.keys(object).map(function (k) {
    return object[k];
  });
};

// --[ Exports ]-------------------------------------------------------
module.exports = values;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

// --[ Dependencies ]---------------------------------------------------
var assertType = __webpack_require__(310);
var flEquals = __webpack_require__(1428);
var fl = __webpack_require__(654);
var provideAliases = __webpack_require__(311);
var copyDocs = __webpack_require__(655);

var _require = __webpack_require__(198),
    tagSymbol = _require.tagSymbol,
    typeSymbol = _require.typeSymbol;

var toString = Object.prototype.toString;
var prototypeOf = Object.getPrototypeOf;

// --[ Helpers ]--------------------------------------------------------

/*~
 * type: (Any) => Boolean
 */
var isSetoid = function isSetoid(value) {
  return value != null && (typeof value[fl.equals] === 'function' || typeof value.equals === 'function');
};

/*~
 * type: (Variant, Variant) => Boolean
 */
var sameType = function sameType(a, b) {
  return a[typeSymbol] === b[typeSymbol] && a[tagSymbol] === b[tagSymbol];
};

var isPlainObject = function isPlainObject(object) {
  if (Object(object) !== object) return false;

  return !prototypeOf(object) || !object.toString || toString.call(object) === object.toString();
};

var deepEquals = function deepEquals(a, b) {
  if (a === b) return true;

  var leftSetoid = isSetoid(a);
  var rightSetoid = isSetoid(b);
  if (leftSetoid) {
    if (rightSetoid) return flEquals(a, b);else return false;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every(function (x, i) {
      return deepEquals(x, b[i]);
    });
  }

  if (isPlainObject(a) && isPlainObject(b)) {
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    var setB = new Set(keysB);
    return keysA.length === keysB.length && prototypeOf(a) === prototypeOf(b) && keysA.every(function (k) {
      return setB.has(k) && a[k] === b[k];
    });
  }

  return false;
};

// --[ Implementation ]------------------------------------------------
/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   (('a, 'a) => Boolean) => (Variant, Union) => Void
 */
var createDerivation = function createDerivation(valuesEqual) {
  /*~
   * type: ('a, 'a) => Boolean
   */
  var equals = function equals(a, b) {
    // identical objects must be equal
    if (a === b) return true;

    // we require both values to be setoids if one of them is
    var leftSetoid = isSetoid(a);
    var rightSetoid = isSetoid(b);
    if (leftSetoid) {
      if (rightSetoid) return flEquals(a, b);else return false;
    }

    // fall back to the provided equality
    return valuesEqual(a, b);
  };

  /*~
   * type: (Object Any, Object Any, Array String) => Boolean
   */
  var compositesEqual = function compositesEqual(a, b, keys) {
    for (var i = 0; i < keys.length; ++i) {
      var keyA = a[keys[i]];
      var keyB = b[keys[i]];
      if (!equals(keyA, keyB)) {
        return false;
      }
    }
    return true;
  };

  var derivation = function derivation(variant, adt) {
    /*~
     * stability: experimental
     * module: null
     * authors:
     *   - "@boris-marinov"
     *   - Quildreen Motta
     * 
     * type: |
     *   forall S, a:
     *     (S a).(S a) => Boolean
     *   where S is Setoid
     */
    variant.prototype.equals = function (value) {
      assertType(adt)(this[tagSymbol] + '#equals', value);
      return sameType(this, value) && compositesEqual(this, value, Object.keys(this));
    };
    provideAliases(variant.prototype);
    return variant;
  };
  copyDocs(createDerivation, derivation, {
    type: '(Variant, Union) => Void'
  });

  return derivation;
};

// --[ Exports ]-------------------------------------------------------

/*~~inheritsMeta: createDerivation */
module.exports = createDerivation(deepEquals);

module.exports.withCustomComparison = createDerivation;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(654),
    flEquals = _require.equals;

var curry = __webpack_require__(1429);
var warn = __webpack_require__(1430)('equals');
var unsupported = __webpack_require__(1431)('equals');

var isNew = function isNew(a) {
  return typeof a[flEquals] === 'function';
};
var isOld = function isOld(a) {
  return typeof a.equals === 'function';
};

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 *   - Quildreen Motta
 * 
 * type: |
 *   forall S, a:
 *     (S a, S a) => Boolean
 *   where S is Setoid
 */
var equals = function equals(setoidLeft, setoidRight) {
  return isNew(setoidLeft) ? setoidLeft[flEquals](setoidRight) : isOld(setoidLeft) ? warn(setoidLeft.equals(setoidRight)) : /*otherwise*/unsupported(setoidLeft);
};

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 *   - Quildreen Motta
 * 
 * type: |
 *   forall S, a:
 *     (S a) => (S a) => Boolean
 *   where S is Setoid
 */
equals.curried = curry(2, function (setoidRight, setoidLeft) {
  return (// eslint-disable-line no-magic-numbers
    equals(setoidLeft, setoidRight)
  );
});

/*~
 * stability: experimental
 * authors:
 *   - Quildreen Motta
 * 
 * type: |
 *   forall S, a:
 *     (S a).(S a) => Boolean
 *   where S is Setoid
 */
equals.infix = function (aSetoid) {
  return equals(this, aSetoid);
};

module.exports = equals;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

/*~
 * stability: experimental
 * authors:
 *   - Quildreen Motta
 *
 * type: |
 *   (Number, (Any...) => 'a) => Any... => 'a or ((Any...) => 'a)
 */
var curry = function curry(arity, fn) {
  var curried = function curried(oldArgs) {
    return function () {
      for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
        newArgs[_key] = arguments[_key];
      }

      var allArgs = oldArgs.concat(newArgs);
      var argCount = allArgs.length;

      return argCount < arity ? curried(allArgs) : /* otherwise */fn.apply(undefined, _toConsumableArray(allArgs));
    };
  };

  return curried([]);
};

// --[ Exports ]-------------------------------------------------------
module.exports = curry;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var deprecated = __webpack_require__(238);

module.exports = function (methodName) {
  return function (result) {
    deprecated('Type.' + methodName + '() is being deprecated in favour of Type[\'fantasy-land/' + methodName + '\'](). \n    Your data structure is using the old-style fantasy-land methods,\n    and these won\'t be supported in Folktale 3');
    return result;
  };
};

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

module.exports = function (methodName) {
  return function (object) {
    throw new TypeError(object + " does not have a method '" + methodName + "'.");
  };
};

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

// --[ Dependencies ]---------------------------------------------------
var _require = __webpack_require__(198),
    tagSymbol = _require.tagSymbol,
    typeSymbol = _require.typeSymbol;

// --[ Helpers ]--------------------------------------------------------
/*~
 * type: (Object Any) => String
 */


var objectToKeyValuePairs = function objectToKeyValuePairs(object) {
  return Object.keys(object).map(function (key) {
    return key + ': ' + showValue(object[key]);
  }).join(', ');
};

/*~
 * type: (Object Any).() => String
 */
var plainObjectToString = function plainObjectToString() {
  return '{ ' + objectToKeyValuePairs(this) + ' }';
};

/*~
 * type: (Array Any).() => String
 */
var arrayToString = function arrayToString() {
  return '[' + this.map(showValue).join(', ') + ']';
};

/*~
 * type: (Function) => String
 */
var functionNameToString = function functionNameToString(fn) {
  return fn.name !== '' ? ': ' + fn.name : '';
};

/*~
 * type: (Function) => String
 */
var functionToString = function functionToString(fn) {
  return '[Function' + functionNameToString(fn) + ']';
};

/*~
 * type: () => String
 */
var nullToString = function nullToString() {
  return 'null';
};

/*~
 * type: (Any) => Bool
 */
var isPlainObject = function isPlainObject(object) {
  return !object.toString || object.toString === Object.prototype.toString;
};

/*~
 * type: (Null | Object Any) => String
 */
var objectToString = function objectToString(object) {
  return object === null ? nullToString : Array.isArray(object) ? arrayToString : isPlainObject(object) ? plainObjectToString : /* otherwise */object.toString;
};

/*~
 * type: (Any) => String
 */
var showValue = function showValue(value) {
  return typeof value === 'undefined' ? 'undefined' : typeof value === 'function' ? functionToString(value) : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' ? value.toString() : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? objectToString(value).call(value) : /* otherwise */JSON.stringify(value);
};

// --[ Implementation ]------------------------------------------------

/*~
 * stability: experimental
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   (Variant, Union) => Void
 */
var debugRepresentation = function debugRepresentation(variant, adt) {
  // eslint-disable-line max-statements
  var typeName = adt[typeSymbol];
  var variantName = adt[typeSymbol] + '.' + variant.prototype[tagSymbol];

  // (for Object.prototype.toString)
  adt[Symbol.toStringTag] = typeName;
  variant.prototype[Symbol.toStringTag] = variantName;

  // (regular JavaScript representations)
  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   () => String
   */
  adt.toString = function () {
    return typeName;
  };

  /*~
   * stability: experimental
   * mmodule: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   () => String
   */
  variant.toString = function () {
    return variantName;
  };

  /*~
   * stability: experimental
   * module: null
   * authors:
   *   - "@boris-marinov"
   * 
   * type: |
   *   (Union).() => String
   */
  variant.prototype.toString = function () {
    return variantName + '(' + plainObjectToString.call(this) + ')';
  };

  // (Node REPL representations)
  adt.inspect = adt.toString;
  variant.inspect = variant.toString;
  variant.prototype.inspect = variant.prototype.toString;

  return variant;
};

// --[ Exports ]-------------------------------------------------------
module.exports = debugRepresentation;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(656),
    Error = _require.Error,
    Ok = _require.Ok;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *     (Maybe a, b) => Result b a
 */


var maybeToResult = function maybeToResult(aMaybe, failureValue) {
  return aMaybe.matchWith({
    Nothing: function Nothing() {
      return Error(failureValue);
    },
    Just: function Just(_ref) {
      var value = _ref.value;
      return Ok(value);
    }
  });
};

module.exports = maybeToResult;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(657),
    Success = _require.Success,
    Failure = _require.Failure;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *     (Result a b) => Validation a b
 */


var resultToValidation = function resultToValidation(aResult) {
  return aResult.matchWith({
    Error: function Error(_ref) {
      var value = _ref.value;
      return Failure(value);
    },
    Ok: function Ok(_ref2) {
      var value = _ref2.value;
      return Success(value);
    }
  });
};

module.exports = resultToValidation;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(656),
    Error = _require.Error,
    Ok = _require.Ok;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *      (Validation a b) => Result a b
 */


var validationToResult = function validationToResult(aValidation) {
  return aValidation.matchWith({
    Failure: function Failure(_ref) {
      var value = _ref.value;
      return Error(value);
    },
    Success: function Success(_ref2) {
      var value = _ref2.value;
      return Ok(value);
    }
  });
};

module.exports = validationToResult;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(657),
    Success = _require.Success,
    Failure = _require.Failure;

/*~
 * stability: stable
 * authors:
 *   - "@boris-marinov"
 * 
 * type: |
 *   forall a, b:
 *     (Maybe a, b) => Validation b a
 */


var maybeToValidation = function maybeToValidation(aMaybe, failureValue) {
  return aMaybe.matchWith({
    Nothing: function Nothing() {
      return Failure(failureValue);
    },
    Just: function Just(_ref) {
      var value = _ref.value;
      return Success(value);
    }
  });
};

module.exports = maybeToValidation;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//----------------------------------------------------------------------
//
// This source file is part of the Folktale project.
//
// Licensed under MIT. See LICENCE for full licence information.
// See CONTRIBUTORS for the list of contributors to the project.
//
//----------------------------------------------------------------------

var _require = __webpack_require__(309),
    Nothing = _require.Nothing,
    Just = _require.Just;

/*~
 * stability: stable
 * authors:
 *   - Quildreen Motta
 * 
 * type: |
 *   forall a:
 *     (a or None) => Maybe a
 */


var nullableToMaybe = function nullableToMaybe(a) {
  return a != null ? Just(a) : /*else*/Nothing();
};

module.exports = nullableToMaybe;

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(533);
var _fromJS;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var IS_TOKEN_INVALID='isTokenInvalid';var IS_VALIDATING_TOKEN='isValidatingToken';var IS_TOKEN_VALIDATION_COMPLETE='isTokenValidationComplete';var IS_ACCEPTING_INVITE='isAcceptingToken';var IS_TOKEN_ACCEPTED='isTokenAccepted';var HAS_ERROR_ACCEPTING_TOKEN='hasErrorAcceptingToken';var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])((_fromJS={},_defineProperty(_fromJS,IS_TOKEN_INVALID,false),_defineProperty(_fromJS,IS_VALIDATING_TOKEN,false),_defineProperty(_fromJS,IS_ACCEPTING_INVITE,false),_defineProperty(_fromJS,IS_TOKEN_ACCEPTED,false),_defineProperty(_fromJS,IS_TOKEN_VALIDATION_COMPLETE,false),_defineProperty(_fromJS,HAS_ERROR_ACCEPTING_TOKEN,false),_fromJS));var actionHandlers=new Map([[__WEBPACK_IMPORTED_MODULE_3__actions__["c" /* attemptValidateToken */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){var _state$merge;return state.merge((_state$merge={},_defineProperty(_state$merge,IS_TOKEN_INVALID,false),_defineProperty(_state$merge,IS_VALIDATING_TOKEN,true),_defineProperty(_state$merge,IS_TOKEN_VALIDATION_COMPLETE,false),_state$merge));})],[__WEBPACK_IMPORTED_MODULE_3__actions__["d" /* validateToken */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){var _state$merge2;return state.merge((_state$merge2={},_defineProperty(_state$merge2,IS_TOKEN_INVALID,false),_defineProperty(_state$merge2,IS_VALIDATING_TOKEN,false),_defineProperty(_state$merge2,IS_TOKEN_VALIDATION_COMPLETE,true),_state$merge2));},function(state){var _state$merge3;return state.merge((_state$merge3={},_defineProperty(_state$merge3,IS_TOKEN_INVALID,true),_defineProperty(_state$merge3,IS_VALIDATING_TOKEN,false),_defineProperty(_state$merge3,IS_TOKEN_VALIDATION_COMPLETE,true),_state$merge3));})],[__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* attemptAcceptInvite */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return state.withMutations(function(state){return state.set(IS_ACCEPTING_INVITE,true).set(HAS_ERROR_ACCEPTING_TOKEN,false);});})],[__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* acceptInvite */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return state.withMutations(function(state){return state.set(IS_TOKEN_ACCEPTED,true).set(IS_ACCEPTING_INVITE,false);});},function(state){return state.withMutations(function(state){return state.set(IS_TOKEN_ACCEPTED,false).set(IS_ACCEPTING_INVITE,false).set(HAS_ERROR_ACCEPTING_TOKEN,true);});})]]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])(actionHandlers,initialState));

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
var _actionHandler;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});var actionHandler=(_actionHandler={},_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CHANGE_SELECTED_DAY */],function(state,_ref){var _ref$payload=_ref.payload,id=_ref$payload.id,day=_ref$payload.day;return state.setIn([id,'selectedDay'],day).setIn([id,'hasLoadedDayData'],false);}),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_ZOOM_LEVEL */],function(state,_ref2){var _ref2$payload=_ref2.payload,id=_ref2$payload.id,zoomLevel=_ref2$payload.zoomLevel;return state.setIn([id,'zoomLevel'],zoomLevel);}),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANGE_EVENTS_CURRENT_DAY */],function(state,_ref3){var _ref3$payload=_ref3.payload,id=_ref3$payload.id,day=_ref3$payload.day;return state.setIn([id,'eventsCurrentDay'],day);}),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PAGE_READY */],function(state,_ref4){var id=_ref4.payload.id;return state.setIn([id,'hasLoaded'],true);}),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* RECEIVE_EVENTS */],function(state,_ref5){var _ref5$payload=_ref5.payload,data=_ref5$payload.data,day=_ref5$payload.day,id=_ref5$payload.id;return state.setIn([id,'events',day],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(data)).setIn([id,'hasLoadedDayData'],true);}),_actionHandler);// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandler,initialState));

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* COOKIES_LOADED */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;return state.merge(payload);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* COOKIE_SET */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref2){var _ref2$payload=_ref2.payload,key=_ref2$payload.key,value=_ref2$payload.value;return state.set(key,value);})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({})));

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__devices_constants__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__productsAsDefaultCustomisation__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboardItemPositionById__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__install_upgrade_thermostat_hive2_constants__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__nextAvailableProductSlot__ = __webpack_require__(662);
var _handlers;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({currentPage:0,customisation:{},idsToBeDeleted:[],previousCustomisation:undefined,displayAllProducts:false,hasUnsavedChanges:false,isEditModeOn:false,isFetching:false,isLoaded:false,isAddModeOn:false,nextAddProductPosition:undefined,lastProductAdded:undefined,lastProductSwapped:undefined,removedDevices:[],shouldRedirectToPostinstallGroups:false});var setReceiveCustomisationState=function setReceiveCustomisationState(state,customisationData){return state.withMutations(function(state){return state.set('isFetching',false).set('isLoaded',true).set('customisation',customisationData);});};var handlers=(_handlers={},_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["l" /* GET_DASHBOARD_CUSTOMISATION */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return state.set('isFetching',true);})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_CURRENT_DASHBOARD_PAGE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;return state.set('currentPage',payload);})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* RECEIVE_DASHBOARD_CUSTOMISATION */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref2){var payload=_ref2.payload;var actions=payload.actions,customisation=payload.customisation,products=payload.products;if(!customisation||!customisation.pages){if(products.size>0){return setReceiveCustomisationState(state,Object(__WEBPACK_IMPORTED_MODULE_2__productsAsDefaultCustomisation__["a" /* default */])(products));}return state;}if(customisation.pages.length===0){return setReceiveCustomisationState(state,Object(__WEBPACK_IMPORTED_MODULE_2__productsAsDefaultCustomisation__["a" /* default */])(products));}if(products.size>0){// $FlowFixMe
var filteredCustomisationData=Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(customisation.pages).map(function(cp){return cp.set('items',cp.get('items').filter(function(item){return products.some(function(p){return p.get('id')===item.get('id');})||actions.some(function(a){return a.id===item.get('id');});}));});var isEmpty=filteredCustomisationData.filter(function(cp){return cp.get('items').count();}).count()===0;return isEmpty?setReceiveCustomisationState(state,Object(__WEBPACK_IMPORTED_MODULE_2__productsAsDefaultCustomisation__["a" /* default */])(products)):setReceiveCustomisationState(state,Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({lastUpdated:customisation.lastUpdated,pages:filteredCustomisationData}));}})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SAVE_DASHBOARD_SUCCESS */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref3){var payload=_ref3.payload;return(// $FlowFixMe
state.withMutations(function(state){return state.set('customisation',payload).set('isEditModeOn',false).set('previousCustomisation',undefined).set('lastProductAdded',undefined).set('lastProductSwapped',undefined).set('hasUnsavedChanges',false).set('idsToBeDeleted',new __WEBPACK_IMPORTED_MODULE_4_immutable__["List"]()).set('isLoaded',true);}));})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* DISPLAY_ALL_PRODUCTS */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref4){var payload=_ref4.payload;return state.set('displayAllProducts',payload);})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* DASHBOARD_EDIT_ON */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){// $FlowFixMe
var currentCustomisationState=state.getIn(['customisation','pages']);// $FlowFixMe
var pages=state.getIn(['customisation','pages']);var newPosition=pages.count();var newPage=pages.push(Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({items:[],position:newPosition}));// $FlowFixMe
return state.withMutations(function(state){return state.set('isEditModeOn',true).setIn(['customisation','pages'],newPage).set('previousCustomisation',currentCustomisationState);});})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CANCEL_DASHBOARD_EDIT */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){// $FlowFixMe
var previousCustomisation=state.get('previousCustomisation');if(previousCustomisation){// $FlowFixMe
return state.withMutations(function(state){return state.setIn(['customisation','pages'],previousCustomisation).set('previousCustomisation',undefined).set('lastProductAdded',undefined).set('hasUnsavedChanges',false).set('isEditModeOn',false).set('idsToBeDeleted',new __WEBPACK_IMPORTED_MODULE_4_immutable__["List"]());});}else{// $FlowFixMe
return state.set('isEditModeOn',false);}})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["r" /* UPDATE_CELL_POSITION */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref5){var payload=_ref5.payload;var currentPosition=payload.currentPosition,newDropPosition=payload.newDropPosition,dragId=payload.dragId;var _newDropPosition$spli=newDropPosition.split(':'),_newDropPosition$spli2=_slicedToArray(_newDropPosition$spli,2),dropItemPageIndex=_newDropPosition$spli2[0],dropItemPositionIndex=_newDropPosition$spli2[1];var _currentPosition$spli=currentPosition.split(':'),_currentPosition$spli2=_slicedToArray(_currentPosition$spli,2),dragItemPageIndex=_currentPosition$spli2[0],dragItemPositionIndex=_currentPosition$spli2[1];var updatedCell=Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({id:dragId,position:parseInt(dropItemPositionIndex,10),type:'node'});var dragItemPagePath=['customisation','pages',dragItemPageIndex,'items'];// $FlowFixMe
var dragItemIndex=state.getIn([].concat(dragItemPagePath)).findIndex(function(p){return p.get('id')===dragId;});// $FlowFixMe
var previousCustomisation=state.get('previousCustomisation');var newState=state;if(!previousCustomisation){// $FlowFixMe
var currentCustomisationState=state.getIn(['customisation','pages']);// $FlowFixMe
newState=state.set('previousCustomisation',currentCustomisationState);}// $FlowFixMe
newState=newState.deleteIn([].concat(dragItemPagePath,[dragItemIndex]));var dropItemPagePath=['customisation','pages',dropItemPageIndex,'items'];var dropItemPageEndIndex=newState.getIn([].concat(dropItemPagePath)).count();newState=newState.setIn([].concat(dropItemPagePath,[dropItemPageEndIndex]),updatedCell);// $FlowFixMe
var existingItem=state.getIn([].concat(dropItemPagePath)).find(function(p){return p.get('position')===parseInt(dropItemPositionIndex,10)&&p.get('id')!==dragId;});if(existingItem){var existingItemIndex=newState.getIn([].concat(dropItemPagePath)).findIndex(function(p){return p.get('position')===parseInt(dropItemPositionIndex,10)&&p.get('id')!==dragId;});newState=newState.deleteIn([].concat(dropItemPagePath,[existingItemIndex]));var dragItemPageEndIndex=newState.getIn([].concat(dragItemPagePath)).count();var updatedExistingItem=existingItem.set('position',parseInt(dragItemPositionIndex,10));newState=newState.withMutations(function(tempState){return tempState.setIn([].concat(dragItemPagePath,[dragItemPageEndIndex]),updatedExistingItem).set('lastProductSwapped',existingItem.get('id'));});}return newState;})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* DELETE_CELL */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref6){var payload=_ref6.payload;var position=payload.position;var _position$split=position.split(':'),_position$split2=_slicedToArray(_position$split,2),page=_position$split2[0],pagePosition=_position$split2[1];// $FlowFixMe
var index=state.getIn(['customisation','pages',page,'items']).findIndex(function(m){return m.get('position')===parseInt(pagePosition,10);});// $FlowFixMe
var idToBeDeleted=state.getIn(['customisation','pages',page,'items',index,'id']);// $FlowFixMe
var nextIdsToBeDeletedIndex=state.get('idsToBeDeleted').size;// $FlowFixMe
var previousCustomisation=state.get('previousCustomisation');if(!previousCustomisation){// $FlowFixMe
var currentCustomisationState=state.getIn(['customisation','pages']);// $FlowFixMe
return state.withMutations(function(s){return s.set('previousCustomisation',currentCustomisationState).setIn(['idsToBeDeleted',nextIdsToBeDeletedIndex],idToBeDeleted).deleteIn(['customisation','pages',page,'items',index]);});}// $FlowFixMe
return state.withMutations(function(s){return s.deleteIn(['customisation','pages',page,'items',index]).setIn(['idsToBeDeleted',nextIdsToBeDeletedIndex],idToBeDeleted);});})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ADD_NEW_DASHBOARD_PAGE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){// $FlowFixMe
var pages=state.getIn(['customisation','pages']);var newPosition=pages.count();var newPage=pages.push(Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({items:[],position:newPosition}));// $FlowFixMe
var previousCustomisation=state.get('previousCustomisation');if(!previousCustomisation){// $FlowFixMe
var currentCustomisationState=state.getIn(['customisation','pages']);// $FlowFixMe
return state.withMutations(function(state){return state.set('previousCustomisation',currentCustomisationState).setIn(['customisation','pages'],newPage);});}// $FlowFixMe
return state.setIn(['customisation','pages'],newPage);})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* DASHBOARD_ADD_PRODUCT_ON */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return state.set('isAddModeOn',true);})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* DASHBOARD_ADD_PRODUCT_OFF */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return(// $FlowFixMe
state.withMutations(function(state){return state.set('isAddModeOn',false).set('nextAddProductPosition',undefined);}));})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DASHBOARD_ADD_PRODUCT */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref7){var _ref7$payload=_ref7.payload,productId=_ref7$payload.productId,turnEditModeOn=_ref7$payload.turnEditModeOn;// $FlowFixMe
var nextAddProductPosition=state.get('nextAddProductPosition');// $FlowFixMe
var nextAvailableSlot=Object(__WEBPACK_IMPORTED_MODULE_8__nextAvailableProductSlot__["a" /* default */])(state.getIn(['customisation','pages'],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])()));// $FlowFixMe
var previousCustomisation=state.get('previousCustomisation');// $FlowFixMe
var currentCustomisationState=state.getIn(['customisation','pages']);// $FlowFixMe
var page=nextAddProductPosition?nextAddProductPosition.get('page'):nextAvailableSlot.get('page');var pagePosition=nextAddProductPosition?nextAddProductPosition.get('position'):// $FlowFixMe
nextAvailableSlot.get('position');// $FlowFixMe
if(page>-1&&pagePosition>-1){// $FlowFixMe
var itemPosition=state.getIn(['customisation','pages',page,'items']).count();// $FlowFixMe
return state.withMutations(function(state){return state.setIn(['customisation','pages',page,'items',itemPosition],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({id:productId,position:pagePosition,type:'node'})).set('previousCustomisation',!previousCustomisation?currentCustomisationState:previousCustomisation).set('nextAddProductPosition',undefined).set('isAddModeOn',false).set('isEditModeOn',turnEditModeOn).set('lastProductAdded',productId).set('currentPage',page).set('hasUnsavedChanges',true);});}else{// $FlowFixMe
var pages=state.getIn(['customisation','pages']);var nextIndex=pages?pages.count():0;// $FlowFixMe
var nextState=state.updateIn(['customisation','pages'],function(currentPages){return currentPages||Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])([]);});// $FlowFixMe
return nextState.withMutations(function(state){return state.setIn(['customisation','pages',nextIndex],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({items:[{id:productId,position:0,type:'node'}],position:nextIndex})).set('previousCustomisation',!previousCustomisation?currentCustomisationState:previousCustomisation).set('nextAddProductPosition',undefined).set('isAddModeOn',false).set('isEditModeOn',turnEditModeOn).set('lastProductAdded',productId).set('currentPage',nextIndex).set('hasUnsavedChanges',true);});}})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* DASHBOARD_REMOVE_PRODUCTS */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref8){var ids=_ref8.payload.ids;return ids.reduce(function(state,id){var position=Object(__WEBPACK_IMPORTED_MODULE_3__dashboardItemPositionById__["a" /* default */])(state.getIn(['customisation','pages']),id);if(!position){return state;}var _position$split3=position.split(':'),_position$split4=_slicedToArray(_position$split3,2),page=_position$split4[0],pagePosition=_position$split4[1];var index=state.getIn(['customisation','pages',page,'items']).findIndex(function(m){return m.get('position')===parseInt(pagePosition,10);});return state.withMutations(function(state){return state.deleteIn(['customisation','pages',page,'items',index]).setIn(['removedDevices',state.get('removedDevices').size],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({id:id,position:position}));});},state);})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DASHBOARD_ADD_NEXT_PRODUCT_POSITION */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref9){var payload=_ref9.payload;var position=payload.position;var positionMap=Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({page:parseInt(position.split(':')[0],10),position:parseInt(position.split(':')[1],10)});// $FlowFixMe
return state.withMutations(function(state){return state.set('nextAddProductPosition',positionMap).set('isAddModeOn',true);});})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_1__devices_constants__["g" /* REMOVE_DEVICE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref10){var payload=_ref10.payload;var id=payload.id;var position=Object(__WEBPACK_IMPORTED_MODULE_3__dashboardItemPositionById__["a" /* default */])(state.getIn(['customisation','pages']),id);if(position){var _position$split5=position.split(':'),_position$split6=_slicedToArray(_position$split5,2),page=_position$split6[0],pagePosition=_position$split6[1];var index=state.getIn(['customisation','pages',page,'items']).findIndex(function(m){return m.get('position')===parseInt(pagePosition,10);});return state.withMutations(function(state){return state.deleteIn(['customisation','pages',page,'items',index]).setIn(['removedDevices',state.get('removedDevices').size],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({id:id,position:position}));});}return state;})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_1__devices_constants__["i" /* REMOVE_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref11){var payload=_ref11.payload;var zoneProducts=payload.zoneProducts;if(!zoneProducts.size){return state;}return zoneProducts.reduce(function(all,product){var id=product.get('id');var position=Object(__WEBPACK_IMPORTED_MODULE_3__dashboardItemPositionById__["a" /* default */])(all.getIn(['customisation','pages']),id);if(position){var _position$split7=position.split(':'),_position$split8=_slicedToArray(_position$split7,2),page=_position$split8[0],pagePosition=_position$split8[1];var index=all.getIn(['customisation','pages',page,'items']).findIndex(function(m){return m.get('position')===parseInt(pagePosition,10);});return all.withMutations(function(tempState){return tempState.deleteIn(['customisation','pages',page,'items',index]).setIn(['removedDevices',all.get('removedDevices').size],Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({id:id,position:position}));});}return all;},state);})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_1__devices_constants__["h" /* REMOVE_DEVICE_ERROR */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){var removedDevices=state.get('removedDevices');if(!removedDevices.size){return state;}return removedDevices.reduce(function(all,device){var _device$get$split=device.get('position').split(':'),_device$get$split2=_slicedToArray(_device$get$split,2),page=_device$get$split2[0],pagePosition=_device$get$split2[1];var itemToRestore=Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({id:device.get('id'),position:parseInt(pagePosition,10),type:'node'});return all.setIn(['customisation','pages',page,'items',all.getIn(['customisation','pages',page,'items']).size],itemToRestore);},state);})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_1__devices_constants__["e" /* REMOVED_DEVICE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return state.set('removedDevices',Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])([]));})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_1__devices_constants__["f" /* REMOVED_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return state.set('removedDevices',Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])([]));})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_7__install_upgrade_thermostat_hive2_constants__["e" /* HIVE2_UPGRADE_START */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref12){var oldStatProducts=_ref12.payload.oldStatProducts;if(oldStatProducts.size===0){return state;}return oldStatProducts.reduce(function(all,product){var id=product.get('id');var position=Object(__WEBPACK_IMPORTED_MODULE_3__dashboardItemPositionById__["a" /* default */])(all.getIn(['customisation','pages']),id);if(position){var _position$split9=position.split(':'),_position$split10=_slicedToArray(_position$split9,2),page=_position$split10[0],pagePosition=_position$split10[1];var index=all.getIn(['customisation','pages',page,'items']).findIndex(function(m){return m.get('position')===parseInt(pagePosition,10);});return all.deleteIn(['customisation','pages',page,'items',index]);}return all;},state);})),_defineProperty(_handlers,__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* REDIRECT_TO_POSTINSTALL_GROUPS */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref13){var payload=_ref13.payload;return(// $FlowFixMe
state.set('shouldRedirectToPostinstallGroups',payload));})),_handlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_actions__["b" /* handleActions */])(handlers,initialState));

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_dashboard__ = __webpack_require__(534);
// $FlowFixMe
var emptyDashboardCustomisationMap=function emptyDashboardCustomisationMap(){return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({pages:[{items:[],position:0}]});};var productsAsDefaultCustomisation=function productsAsDefaultCustomisation(products){if(!products||products.size===0){return emptyDashboardCustomisationMap();}var iterations=Math.ceil(products.count()/__WEBPACK_IMPORTED_MODULE_2__constants_dashboard__["a" /* GROUP_SIZE */]);var productsAsGroups=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,iterations).reduce(function(all,item,i){var start=i*__WEBPACK_IMPORTED_MODULE_2__constants_dashboard__["a" /* GROUP_SIZE */];var end=(i+1)*__WEBPACK_IMPORTED_MODULE_2__constants_dashboard__["a" /* GROUP_SIZE */];return all.push(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({position:i,items:products.slice(start,end).map(function(p,position){return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({position:position,type:'node',id:p.get('id')});})}));},Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({pages:productsAsGroups});};/* harmony default export */ __webpack_exports__["a"] = (productsAsDefaultCustomisation);

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1444),
    isIterateeCall = __webpack_require__(163),
    toFinite = __webpack_require__(369);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1444 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sortDevices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__install_hub_constants__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__install_hue_bridge_constants__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__camera_constants__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__acquire_devices_constants__ = __webpack_require__(271);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var stringCompare=function stringCompare(a,b){return new Map([[true,0],[a>b,1],[a<b,-1]]).get(true)||0;};var sortDevices=function sortDevices(_ref,_ref2){var sortOrder=_ref.sortOrder,_ref$state=_ref.state,_ref$state$name=_ref$state.name,name=_ref$state$name===undefined?'':_ref$state$name,_ref$state$zoneName=_ref$state.zoneName,zoneName=_ref$state$zoneName===undefined?name:_ref$state$zoneName;var sortOrderB=_ref2.sortOrder,_ref2$state=_ref2.state,_ref2$state$name=_ref2$state.name,nameB=_ref2$state$name===undefined?'':_ref2$state$name,_ref2$state$zoneName=_ref2$state.zoneName,zoneNameB=_ref2$state$zoneName===undefined?nameB:_ref2$state$zoneName;return sortOrder===sortOrderB?stringCompare(zoneName.toLowerCase(),zoneNameB.toLowerCase()):sortOrder-sortOrderB;};var initialState={deviceItems:[],hasError:false,hasRestartingError:false,isFetching:false,isRemoving:false,isLoaded:false,isRestarting:false};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_8__acquire_devices_constants__["g" /* START_ACQUIRE_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){var hubIndex=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.type==='hub';},state.deviceItems);// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).setIn(['deviceItems',hubIndex,'state','discovery'],true).toJS();})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_8__acquire_devices_constants__["h" /* STOP_ACQUIRE_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){var hubIndex=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.type==='hub';},state.deviceItems);// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).setIn(['deviceItems',hubIndex,'state','discovery'],false).toJS();})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__install_hub_constants__["b" /* CLAIM_HUB */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref3){var payload=_ref3.payload;return Object.assign({},state,{deviceItems:[].concat(_toConsumableArray(state.deviceItems),[payload])});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_4__install_hue_bridge_constants__["d" /* BRIDGE_STATUS_UPDATE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref4){var payload=_ref4.payload;var bridgeIndex=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.id===payload.id;},state.deviceItems);if(bridgeIndex<0){// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).updateIn(['deviceItems'],function(items){return items.push(payload);}).toJS();}// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).setIn(['deviceItems',bridgeIndex],payload).toJS();})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_4__install_hue_bridge_constants__["e" /* PAIR_WITH_BRIDGE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref5){var _ref5$payload=_ref5.payload,bridgeId=_ref5$payload.bridgeId,currentStatus=_ref5$payload.currentStatus;var bridgeIndex=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.id===bridgeId;},state.deviceItems);// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).setIn(['deviceItems',bridgeIndex,'props','status'],currentStatus).toJS();})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_4__install_hue_bridge_constants__["g" /* SEARCH_FOR_BRIDGE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref6){var bridgeId=_ref6.payload.bridgeId;var bridgeIndex=bridgeId?__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.id===bridgeId;},state.deviceItems):-1;if(bridgeIndex<0){return state;}// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).setIn(['deviceItems',bridgeIndex,'props','status'],__WEBPACK_IMPORTED_MODULE_4__install_hue_bridge_constants__["h" /* hueBridgeStatuses */].SEARCHING).toJS();})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_5__camera_constants__["a" /* CAMERA_SETTINGS_UPDATED */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref7){var _ref7$payload=_ref7.payload,cameraId=_ref7$payload.cameraId,data=_ref7$payload.data;var cameraIndex=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.props.hardwareIdentifier===cameraId;},state.deviceItems);if(cameraIndex<0){return state;}// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).mergeIn(['deviceItems',cameraIndex,'state'],data).toJS();})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["o" /* REQUEST_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{isFetching:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["d" /* RECEIVE_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref8){var payload=_ref8.payload;return Object.assign({},state,{isFetching:false,hasError:false,isLoaded:true,deviceItems:payload});},function(state){return Object.assign({},state,{isFetching:false,hasError:true,isLoaded:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["l" /* RENAME_DEVICE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{saving:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* RENAMED_DEVICE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref9){var _ref9$payload=_ref9.payload,productId=_ref9$payload.productId,name=_ref9$payload.name;var index=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.id===productId;},state.deviceItems);// $FlowFixMe
var updated=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).setIn(['deviceItems',index,'state','name'],name).set('saving',false).toJS();return Object.assign({},updated,{deviceItems:updated.deviceItems.sort(sortDevices)});},function(state){return state.set('saving',false);})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["g" /* REMOVE_DEVICE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{isRemoving:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["h" /* REMOVE_DEVICE_ERROR */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{hasError:true,isRemoving:false});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* REMOVED_DEVICE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref10){var id=_ref10.payload.id;return Object.assign({},state,{deviceItems:state.deviceItems.filter(function(d){return d.id!==id&&d.parent!==id;}),isRemoving:false});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["n" /* RENAME_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{saving:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["k" /* RENAMED_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref11){var _ref11$payload=_ref11.payload,productId=_ref11$payload.productId,name=_ref11$payload.name;var index=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.id===productId;},state.deviceItems);var sibling=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.id===(state.deviceItems[index].props.tui||state.deviceItems[index].props.zone);},state.deviceItems);// $FlowFixMe
var nextState=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).setIn(['deviceItems',index,'state','name'],name).setIn(['deviceItems',index,'state','zoneName'],name);if(sibling){nextState=nextState.setIn(['deviceItems',sibling,'state','name'],name).setIn(['deviceItems',sibling,'state','zoneName'],name);}return nextState.set('saving',false).toJS();})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["i" /* REMOVE_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{isRemoving:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["f" /* REMOVED_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref12){var id=_ref12.payload.id;var index=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.id===id;},state.deviceItems);//change deviceItems to state.deviceItems
var sameZone=state.deviceItems[index].props.zone;// $FlowFixMe
var result=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(state).deleteIn(['deviceItems',index]).set('isRemoving',false).toJS();var sibling=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_findIndex___default()(function(x){return x.props.zone===sameZone;},result.deviceItems);if(sibling){// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(result).deleteIn(['deviceItems',sibling]).toJS();}return result;})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["q" /* RESTART_HUB */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{isRestarting:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_7__constants__["p" /* RESTARTED_HUB */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref13){var payload=_ref13.payload;return Object.assign({},state,{hasRestartingError:false,isRestarting:false});},function(state){return Object.assign({},state,{hasRestartingError:true,isRestarting:false});})),_handleActions),initialState));

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* GET_ENTITLEMENTS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('loading',true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RECEIVE_ENTITLEMENTS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;return(// $FlowFixMe
state.withMutations(function(state){return state.set('loading',false).set('config',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload));}));},// $FlowFixMe
function(state){return state.set('loading',false);})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({config:{},loading:false})));

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_takeRight__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_takeRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_takeRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_take__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_map__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(846);
var _formReducer$normaliz;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var normalizeLettersNumbers=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default()(function(field){return Object.assign({},field,{value:/^[a-z0-9]{1}$/i.test(field.value)?field.value.toUpperCase():''});});var normalizeNumbers=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default()(function(field){return Object.assign({},field,{value:/^[0-9]{1}$/i.test(field.value)?field.value:''});});var normalizeFirstThree=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_take___default()(3),normalizeLettersNumbers);var normalizeLastThree=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_takeRight___default()(3),normalizeNumbers);var normalizePin=function normalizePin(value,previousValue){if(!value){return value;}return /^[0-9]{0,4}$/i.test(value)?value:previousValue;};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_redux_form__["reducer"].normalize((_formReducer$normaliz={},_defineProperty(_formReducer$normaliz,__WEBPACK_IMPORTED_MODULE_5__constants__["c" /* INSTALL_HUB_FORM_NAME */],_defineProperty({},__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* INSTALL_HUB_FORM_FIELD_NAME */]+'[]',function undefined(values){return values&&[].concat(_toConsumableArray(normalizeFirstThree(values)),_toConsumableArray(normalizeLastThree(values)));})),_defineProperty(_formReducer$normaliz,__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* UPGRADE_NANO1_HUB_FORM_NAME */],_defineProperty({},__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* UPGRADE_NANO1_HUB_FORM_FIELD_NAME */]+'[]',function undefined(values){return values&&[].concat(_toConsumableArray(normalizeFirstThree(values)),_toConsumableArray(normalizeLastThree(values)));})),_defineProperty(_formReducer$normaliz,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CHANGE_PIN_FORM_NAME */],{pin:normalizePin,confirm:normalizePin}),_formReducer$normaliz)));

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(240),
    toInteger = __webpack_require__(107);

/**
 * Creates a slice of `array` with `n` elements taken from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.takeRight([1, 2, 3]);
 * // => [3]
 *
 * _.takeRight([1, 2, 3], 2);
 * // => [2, 3]
 *
 * _.takeRight([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.takeRight([1, 2, 3], 0);
 * // => []
 */
function takeRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  n = length - n;
  return baseSlice(array, n < 0 ? 0 : n, length);
}

module.exports = takeRight;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(240),
    toInteger = __webpack_require__(107);

/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : toInteger(n);
  return baseSlice(array, 0, n < 0 ? 0 : n);
}

module.exports = take;


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82),
    baseIteratee = __webpack_require__(55),
    baseMap = __webpack_require__(665),
    isArray = __webpack_require__(32);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(666);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(432);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  Provider.displayName = 'Provider';

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(1459);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(669);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(669);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(670);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(1460);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(432);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createAll;

var _reducer = __webpack_require__(433);

var _reducer2 = _interopRequireDefault(_reducer);

var _createReduxForm = __webpack_require__(1465);

var _createReduxForm2 = _interopRequireDefault(_createReduxForm);

var _mapValues = __webpack_require__(435);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _bindActionData = __webpack_require__(678);

var _bindActionData2 = _interopRequireDefault(_bindActionData);

var _actions = __webpack_require__(677);

var actions = _interopRequireWildcard(_actions);

var _actionTypes = __webpack_require__(434);

var actionTypes = _interopRequireWildcard(_actionTypes);

var _createPropTypes = __webpack_require__(1487);

var _createPropTypes2 = _interopRequireDefault(_createPropTypes);

var _getValuesFromState = __webpack_require__(673);

var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// bind form as first parameter of action creators
var boundActions = _extends({}, (0, _mapValues2.default)(_extends({}, actions, {
  autofillWithKey: function autofillWithKey(key) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (0, _bindActionData2.default)(actions.autofill, { key: key }).apply(undefined, args);
  },
  changeWithKey: function changeWithKey(key) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return (0, _bindActionData2.default)(actions.change, { key: key }).apply(undefined, args);
  },
  initializeWithKey: function initializeWithKey(key) {
    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    return (0, _bindActionData2.default)(actions.initialize, { key: key }).apply(undefined, args);
  },
  reset: function reset(key) {
    return (0, _bindActionData2.default)(actions.reset, { key: key })();
  },
  touchWithKey: function touchWithKey(key) {
    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }

    return (0, _bindActionData2.default)(actions.touch, { key: key }).apply(undefined, args);
  },
  untouchWithKey: function untouchWithKey(key) {
    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      args[_key5 - 1] = arguments[_key5];
    }

    return (0, _bindActionData2.default)(actions.untouch, { key: key }).apply(undefined, args);
  },
  destroy: function destroy(key) {
    return (0, _bindActionData2.default)(actions.destroy, { key: key })();
  }
}), function (action) {
  return function (form) {
    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      args[_key6 - 1] = arguments[_key6];
    }

    return (0, _bindActionData2.default)(action, { form: form }).apply(undefined, args);
  };
}));

var addArrayValue = boundActions.addArrayValue;
var autofill = boundActions.autofill;
var autofillWithKey = boundActions.autofillWithKey;
var blur = boundActions.blur;
var change = boundActions.change;
var changeWithKey = boundActions.changeWithKey;
var destroy = boundActions.destroy;
var focus = boundActions.focus;
var initialize = boundActions.initialize;
var initializeWithKey = boundActions.initializeWithKey;
var removeArrayValue = boundActions.removeArrayValue;
var reset = boundActions.reset;
var startAsyncValidation = boundActions.startAsyncValidation;
var startSubmit = boundActions.startSubmit;
var stopAsyncValidation = boundActions.stopAsyncValidation;
var stopSubmit = boundActions.stopSubmit;
var submitFailed = boundActions.submitFailed;
var swapArrayValues = boundActions.swapArrayValues;
var touch = boundActions.touch;
var touchWithKey = boundActions.touchWithKey;
var untouch = boundActions.untouch;
var untouchWithKey = boundActions.untouchWithKey;

function createAll(isReactNative, React, connect) {
  return {
    actionTypes: actionTypes,
    addArrayValue: addArrayValue,
    autofill: autofill,
    autofillWithKey: autofillWithKey,
    blur: blur,
    change: change,
    changeWithKey: changeWithKey,
    destroy: destroy,
    focus: focus,
    getValues: _getValuesFromState2.default,
    initialize: initialize,
    initializeWithKey: initializeWithKey,
    propTypes: (0, _createPropTypes2.default)(),
    reduxForm: (0, _createReduxForm2.default)(isReactNative, React, connect),
    reducer: _reducer2.default,
    removeArrayValue: removeArrayValue,
    reset: reset,
    startAsyncValidation: startAsyncValidation,
    startSubmit: startSubmit,
    stopAsyncValidation: stopAsyncValidation,
    stopSubmit: stopSubmit,
    submitFailed: submitFailed,
    swapArrayValues: swapArrayValues,
    touch: touch,
    touchWithKey: touchWithKey,
    untouch: untouch,
    untouchWithKey: untouchWithKey
  };
}

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _fieldValue = __webpack_require__(199);

var reset = function reset(value) {
  return (0, _fieldValue.makeFieldValue)(value === undefined || value && value.initial === undefined ? {} : { initial: value.initial, value: value.initial });
};

/**
 * Sets the initial values into the state and returns a new copy of the state
 */
var resetState = function resetState(values) {
  return values ? Object.keys(values).reduce(function (accumulator, key) {
    var value = values[key];
    if (Array.isArray(value)) {
      accumulator[key] = value.map(function (item) {
        return (0, _fieldValue.isFieldValue)(item) ? reset(item) : resetState(item);
      });
    } else if (value) {
      if ((0, _fieldValue.isFieldValue)(value)) {
        accumulator[key] = reset(value);
      } else if (typeof value === 'object' && value !== null) {
        accumulator[key] = resetState(value);
      } else {
        accumulator[key] = value;
      }
    }
    return accumulator;
  }, {}) : values;
};

exports.default = resetState;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _fieldValue = __webpack_require__(199);

var isMetaKey = function isMetaKey(key) {
  return key[0] === '_';
};

/**
 * Sets an error on a field deep in the tree, returning a new copy of the state
 */
var setErrors = function setErrors(state, errors, destKey) {
  var clear = function clear() {
    if (Array.isArray(state)) {
      return state.map(function (stateItem, index) {
        return setErrors(stateItem, errors && errors[index], destKey);
      });
    }
    if (state && typeof state === 'object') {
      var result = Object.keys(state).reduce(function (accumulator, key) {
        var _extends2;

        return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[key] = setErrors(state[key], errors && errors[key], destKey), _extends2));
      }, state);
      if ((0, _fieldValue.isFieldValue)(state)) {
        (0, _fieldValue.makeFieldValue)(result);
      }
      return result;
    }
    return (0, _fieldValue.makeFieldValue)(state);
  };
  if (typeof File !== 'undefined' && state instanceof File) {
    return state;
  }
  if (!errors) {
    if (!state) {
      return state;
    }
    if (state[destKey]) {
      var copy = _extends({}, state);
      delete copy[destKey];
      return (0, _fieldValue.makeFieldValue)(copy);
    }
    return clear();
  }
  if (typeof errors === 'string') {
    var _extends3;

    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends3 = {}, _extends3[destKey] = errors, _extends3)));
  }
  if (Array.isArray(errors)) {
    if (!state || Array.isArray(state)) {
      var _copy = (state || []).map(function (stateItem, index) {
        return setErrors(stateItem, errors[index], destKey);
      });
      errors.forEach(function (errorItem, index) {
        return _copy[index] = setErrors(_copy[index], errorItem, destKey);
      });
      return _copy;
    }
    return setErrors(state, errors[0], destKey); // use first error
  }
  if ((0, _fieldValue.isFieldValue)(state)) {
    var _extends4;

    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends4 = {}, _extends4[destKey] = errors, _extends4)));
  }
  var errorKeys = Object.keys(errors);
  if (!errorKeys.length && !state) {
    return state;
  }
  return errorKeys.reduce(function (accumulator, key) {
    var _extends5;

    return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[key] = setErrors(state && state[key], errors[key], destKey), _extends5));
  }, clear() || {});
};

exports.default = setErrors;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = normalizeFields;

var _fieldValue = __webpack_require__(199);

function extractKey(field) {
  var dotIndex = field.indexOf('.');
  var openIndex = field.indexOf('[');
  var closeIndex = field.indexOf(']');

  if (openIndex > 0 && closeIndex !== openIndex + 1) {
    throw new Error('found [ not followed by ]');
  }

  var isArray = openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex);
  var key = void 0;
  var nestedPath = void 0;

  if (isArray) {
    key = field.substring(0, openIndex);
    nestedPath = field.substring(closeIndex + 1);

    if (nestedPath[0] === '.') {
      nestedPath = nestedPath.substring(1);
    }
  } else if (dotIndex > 0) {
    key = field.substring(0, dotIndex);
    nestedPath = field.substring(dotIndex + 1);
  } else {
    key = field;
  }

  return { isArray: isArray, key: key, nestedPath: nestedPath };
}

function normalizeField(field, fullFieldPath, state, previousState, values, previousValues, normalizers) {
  if (field.isArray) {
    if (field.nestedPath) {
      var array = state && state[field.key] || [];
      var previousArray = previousState && previousState[field.key] || [];
      var nestedField = extractKey(field.nestedPath);

      return array.map(function (nestedState, i) {
        nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousArray[i], values, previousValues, normalizers);

        return nestedState;
      });
    }

    var _normalizer = normalizers[fullFieldPath];

    var result = _normalizer(state && state[field.key], previousState && previousState[field.key], values, previousValues);
    return field.isArray ? result && result.map(_fieldValue.makeFieldValue) : result;
  } else if (field.nestedPath) {
    var nestedState = state && state[field.key] || {};
    var _nestedField = extractKey(field.nestedPath);

    nestedState[_nestedField.key] = normalizeField(_nestedField, fullFieldPath, nestedState, previousState && previousState[field.key], values, previousValues, normalizers);

    return nestedState;
  }

  var finalField = state && Object.assign({}, state[field.key] || {});
  var normalizer = normalizers[fullFieldPath];

  finalField.value = normalizer(finalField.value, previousState && previousState[field.key] && previousState[field.key].value, values, previousValues);

  return (0, _fieldValue.makeFieldValue)(finalField);
}

function normalizeFields(normalizers, state, previousState, values, previousValues) {
  var newState = Object.keys(normalizers).reduce(function (accumulator, field) {
    var extracted = extractKey(field);

    accumulator[extracted.key] = normalizeField(extracted, field, state, previousState, values, previousValues, normalizers);

    return accumulator;
  }, {});

  return _extends({}, state, newState);
}

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createReduxFormConnector = __webpack_require__(1466);

var _createReduxFormConnector2 = _interopRequireDefault(_createReduxFormConnector);

var _hoistNonReactStatics = __webpack_require__(312);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(isReactNative, React, connect) {
  var Component = React.Component;

  var reduxFormConnector = (0, _createReduxFormConnector2.default)(isReactNative, React, connect);
  return function (config, mapStateToProps, mapDispatchToProps, mergeProps, options) {
    return function (WrappedComponent) {
      var ReduxFormConnector = reduxFormConnector(WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options);

      var _ref = options || {},
          _ref$withRef = _ref.withRef,
          withRef = _ref$withRef === undefined ? false : _ref$withRef;

      var configWithDefaults = _extends({
        overwriteOnInitialValuesChange: true,
        touchOnBlur: true,
        touchOnChange: false,
        destroyOnUnmount: true
      }, config);

      var ConnectedForm = function (_Component) {
        _inherits(ConnectedForm, _Component);

        function ConnectedForm(props) {
          _classCallCheck(this, ConnectedForm);

          var _this = _possibleConstructorReturn(this, _Component.call(this, props));

          _this.handleSubmitPassback = _this.handleSubmitPassback.bind(_this);
          return _this;
        }

        ConnectedForm.prototype.getWrappedInstance = function getWrappedInstance() {
          (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
          return this.refs.wrappedInstance.refs.wrappedInstance.getWrappedInstance().refs.wrappedInstance;
        };

        ConnectedForm.prototype.handleSubmitPassback = function handleSubmitPassback(submit) {
          this.submit = submit;
        };

        ConnectedForm.prototype.render = function render() {
          if (withRef) {
            return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
              ref: 'wrappedInstance',
              submitPassback: this.handleSubmitPassback }));
          }
          return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
            submitPassback: this.handleSubmitPassback }));
        };

        return ConnectedForm;
      }(Component);

      return (0, _hoistNonReactStatics2.default)(ConnectedForm, WrappedComponent);
    };
  };
};

exports.default = createReduxForm;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _noGetters = __webpack_require__(1467);

var _noGetters2 = _interopRequireDefault(_noGetters);

var _getDisplayName = __webpack_require__(676);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _createHigherOrderComponent = __webpack_require__(1471);

var _createHigherOrderComponent2 = _interopRequireDefault(_createHigherOrderComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This component tracks props that affect how the form is mounted to the store. Normally these should not change,
 * but if they do, the connected components below it need to be redefined.
 */
var createReduxFormConnector = function createReduxFormConnector(isReactNative, React, connect) {
  return function (WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
    var Component = React.Component;

    var _ref = options || {},
        _ref$withRef = _ref.withRef,
        withRef = _ref$withRef === undefined ? false : _ref$withRef;

    var ReduxFormConnector = function (_Component) {
      _inherits(ReduxFormConnector, _Component);

      function ReduxFormConnector(props) {
        _classCallCheck(this, ReduxFormConnector);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.cache = new _noGetters2.default(_this, {
          ReduxForm: {
            params: [
            // props that effect how redux-form connects to the redux store
            'reduxMountPoint', 'form', 'formKey', 'getFormState'],
            fn: (0, _createHigherOrderComponent2.default)(props, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options)
          }
        });
        return _this;
      }

      ReduxFormConnector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.cache.componentWillReceiveProps(nextProps);
      };

      ReduxFormConnector.prototype.render = function render() {
        var ReduxForm = this.cache.get('ReduxForm');
        // remove some redux-form config-only props

        var _props = this.props,
            reduxMountPoint = _props.reduxMountPoint,
            destroyOnUnmount = _props.destroyOnUnmount,
            form = _props.form,
            getFormState = _props.getFormState,
            touchOnBlur = _props.touchOnBlur,
            touchOnChange = _props.touchOnChange,
            passableProps = _objectWithoutProperties(_props, ['reduxMountPoint', 'destroyOnUnmount', 'form', 'getFormState', 'touchOnBlur', 'touchOnChange']); // eslint-disable-line no-redeclare


        if (withRef) {
          return React.createElement(ReduxForm, _extends({}, passableProps, { ref: 'wrappedInstance' }));
        }
        return React.createElement(ReduxForm, passableProps);
      };

      return ReduxFormConnector;
    }(Component);

    ReduxFormConnector.displayName = 'ReduxFormConnector(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
    ReduxFormConnector.WrappedComponent = WrappedComponent;
    ReduxFormConnector.propTypes = {
      destroyOnUnmount: _propTypes2.default.bool,
      reduxMountPoint: _propTypes2.default.string,
      form: _propTypes2.default.string.isRequired,
      formKey: _propTypes2.default.string,
      getFormState: _propTypes2.default.func,
      touchOnBlur: _propTypes2.default.bool,
      touchOnChange: _propTypes2.default.bool
    };
    ReduxFormConnector.defaultProps = {
      reduxMountPoint: 'form',
      getFormState: function getFormState(state, reduxMountPoint) {
        return state[reduxMountPoint];
      }
    };
    return ReduxFormConnector;
  };
};

exports.default = createReduxFormConnector;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1468);


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _deepEqual = __webpack_require__(509);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

function intersects(array1, array2) {
  return !!(array1 && array2 && array1.some(function (item) {
    return ~array2.indexOf(item);
  }));
}

var LazyCache = (function () {
  function LazyCache(component, calculators) {
    var _this = this;

    _classCallCheck(this, LazyCache);

    this.component = component;
    this.allProps = [];
    this.cache = Object.keys(calculators).reduce(function (accumulator, key) {
      var _extends2;

      var calculator = calculators[key];
      var fn = calculator.fn;
      var paramNames = calculator.params;
      paramNames.forEach(function (param) {
        if (! ~_this.allProps.indexOf(param)) {
          _this.allProps.push(param);
        }
      });
      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = {
        value: undefined,
        props: paramNames,
        fn: fn
      }, _extends2));
    }, {});
  }

  LazyCache.prototype.get = function get(key) {
    var component = this.component;
    var _cache$key = this.cache[key];
    var value = _cache$key.value;
    var fn = _cache$key.fn;
    var props = _cache$key.props;

    if (value !== undefined) {
      return value;
    }
    var params = props.map(function (prop) {
      return component.props[prop];
    });
    var result = fn.apply(undefined, params);
    this.cache[key].value = result;
    return result;
  };

  LazyCache.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var component = this.component;

    var diffProps = [];
    this.allProps.forEach(function (prop) {
      if (!_deepEqual2['default'](component.props[prop], nextProps[prop])) {
        diffProps.push(prop);
      }
    });
    if (diffProps.length) {
      Object.keys(this.cache).forEach(function (key) {
        if (intersects(diffProps, _this2.cache[key].props)) {
          delete _this2.cache[key].value; // uncache value
        }
      });
    }
  };

  return LazyCache;
})();

exports['default'] = LazyCache;
module.exports = exports['default'];

/***/ }),
/* 1469 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 1470 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _actions = __webpack_require__(677);

var importedActions = _interopRequireWildcard(_actions);

var _getDisplayName = __webpack_require__(676);

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

var _reducer = __webpack_require__(433);

var _deepEqual = __webpack_require__(509);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _bindActionData = __webpack_require__(678);

var _bindActionData2 = _interopRequireDefault(_bindActionData);

var _getValues = __webpack_require__(679);

var _getValues2 = _interopRequireDefault(_getValues);

var _isValid = __webpack_require__(313);

var _isValid2 = _interopRequireDefault(_isValid);

var _readFields = __webpack_require__(1472);

var _readFields2 = _interopRequireDefault(_readFields);

var _handleSubmit2 = __webpack_require__(1482);

var _handleSubmit3 = _interopRequireDefault(_handleSubmit2);

var _asyncValidation = __webpack_require__(1483);

var _asyncValidation2 = _interopRequireDefault(_asyncValidation);

var _silenceEvents = __webpack_require__(1484);

var _silenceEvents2 = _interopRequireDefault(_silenceEvents);

var _silenceEvent = __webpack_require__(684);

var _silenceEvent2 = _interopRequireDefault(_silenceEvent);

var _wrapMapDispatchToProps = __webpack_require__(1485);

var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);

var _wrapMapStateToProps = __webpack_require__(1486);

var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);

var _createInitialState = __webpack_require__(675);

var _createInitialState2 = _interopRequireDefault(_createInitialState);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Creates a HOC that knows how to create redux-connected sub-components.
 */
var createHigherOrderComponent = function createHigherOrderComponent(config, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
  var Component = React.Component;

  return function (reduxMountPoint, formName, formKey, getFormState) {
    var _ref = options || {},
        _ref$withRef = _ref.withRef,
        withRef = _ref$withRef === undefined ? false : _ref$withRef;

    var ReduxForm = function (_Component) {
      _inherits(ReduxForm, _Component);

      function ReduxForm(props) {
        _classCallCheck(this, ReduxForm);

        // bind functions
        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.asyncValidate = _this.asyncValidate.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        var _this$props = _this.props,
            initialValues = _this$props.initialValues,
            submitPassback = _this$props.submitPassback;
        // Check if form state was initialized, if not, initialize it.

        var form = (0, _deepEqual2.default)(props.form, _reducer.initialState) ? (0, _createInitialState2.default)(initialValues, config.fields, {}, true, false) : props.form;
        _this.fields = (0, _readFields2.default)(_extends({}, props, { form: form }), {}, {}, _this.asyncValidate, isReactNative);
        submitPassback(function () {
          return _this.handleSubmit();
        }); // wrapped in function to disallow params
        return _this;
      }

      ReduxForm.prototype.componentWillMount = function componentWillMount() {
        var _props = this.props,
            fields = _props.fields,
            form = _props.form,
            initialize = _props.initialize,
            initialValues = _props.initialValues;

        if (initialValues && !form._initialized) {
          initialize(initialValues, fields);
        }
      };

      ReduxForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!(0, _deepEqual2.default)(this.props.fields, nextProps.fields) || !(0, _deepEqual2.default)(this.props.form, nextProps.form, { strict: true })) {
          this.fields = (0, _readFields2.default)(nextProps, this.props, this.fields, this.asyncValidate, isReactNative);
        }
        if (!(0, _deepEqual2.default)(this.props.initialValues, nextProps.initialValues)) {
          this.props.initialize(nextProps.initialValues, nextProps.fields, this.props.overwriteOnInitialValuesChange || !this.props.form._initialized);
        }
      };

      ReduxForm.prototype.componentWillUnmount = function componentWillUnmount() {
        if (config.destroyOnUnmount) {
          this.props.destroy();
        }
      };

      ReduxForm.prototype.asyncValidate = function asyncValidate(name, value) {
        var _this2 = this;

        var _props2 = this.props,
            alwaysAsyncValidate = _props2.alwaysAsyncValidate,
            asyncValidate = _props2.asyncValidate,
            dispatch = _props2.dispatch,
            fields = _props2.fields,
            form = _props2.form,
            startAsyncValidation = _props2.startAsyncValidation,
            stopAsyncValidation = _props2.stopAsyncValidation,
            validate = _props2.validate;

        var isSubmitting = !name;
        if (asyncValidate) {
          var values = (0, _getValues2.default)(fields, form);
          if (name) {
            values[name] = value;
          }
          var syncErrors = validate(values, this.props);
          var allPristine = this.fields._meta.allPristine;

          var initialized = form._initialized;

          // if blur validating, only run async validate if sync validation passes
          // and submitting (not blur validation) or form is dirty or form was never initialized
          // unless alwaysAsyncValidate is true
          var syncValidationPasses = isSubmitting || (0, _isValid2.default)(syncErrors[name]);
          if (alwaysAsyncValidate || syncValidationPasses && (isSubmitting || !allPristine || !initialized)) {
            return (0, _asyncValidation2.default)(function () {
              return asyncValidate(values, dispatch, _this2.props);
            }, startAsyncValidation, stopAsyncValidation, name);
          }
        }
      };

      ReduxForm.prototype.handleSubmit = function handleSubmit(submitOrEvent) {
        var _this3 = this;

        var _props3 = this.props,
            onSubmit = _props3.onSubmit,
            fields = _props3.fields,
            form = _props3.form;

        var check = function check(submit) {
          if (!submit || typeof submit !== 'function') {
            throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
          }
          return submit;
        };
        return !submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent) ?
        // submitOrEvent is an event: fire submit
        (0, _handleSubmit3.default)(check(onSubmit), (0, _getValues2.default)(fields, form), this.props, this.asyncValidate) :
        // submitOrEvent is the submit function: return deferred submit thunk
        (0, _silenceEvents2.default)(function () {
          return (0, _handleSubmit3.default)(check(submitOrEvent), (0, _getValues2.default)(fields, form), _this3.props, _this3.asyncValidate);
        });
      };

      ReduxForm.prototype.render = function render() {
        var _this4 = this,
            _ref2;

        var allFields = this.fields;

        var _props4 = this.props,
            addArrayValue = _props4.addArrayValue,
            asyncBlurFields = _props4.asyncBlurFields,
            autofill = _props4.autofill,
            blur = _props4.blur,
            change = _props4.change,
            destroy = _props4.destroy,
            focus = _props4.focus,
            fields = _props4.fields,
            form = _props4.form,
            initialValues = _props4.initialValues,
            initialize = _props4.initialize,
            onSubmit = _props4.onSubmit,
            propNamespace = _props4.propNamespace,
            reset = _props4.reset,
            removeArrayValue = _props4.removeArrayValue,
            returnRejectedSubmitPromise = _props4.returnRejectedSubmitPromise,
            startAsyncValidation = _props4.startAsyncValidation,
            startSubmit = _props4.startSubmit,
            stopAsyncValidation = _props4.stopAsyncValidation,
            stopSubmit = _props4.stopSubmit,
            submitFailed = _props4.submitFailed,
            swapArrayValues = _props4.swapArrayValues,
            touch = _props4.touch,
            untouch = _props4.untouch,
            validate = _props4.validate,
            passableProps = _objectWithoutProperties(_props4, ['addArrayValue', 'asyncBlurFields', 'autofill', 'blur', 'change', 'destroy', 'focus', 'fields', 'form', 'initialValues', 'initialize', 'onSubmit', 'propNamespace', 'reset', 'removeArrayValue', 'returnRejectedSubmitPromise', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitFailed', 'swapArrayValues', 'touch', 'untouch', 'validate']); // eslint-disable-line no-redeclare


        var _allFields$_meta = allFields._meta,
            allPristine = _allFields$_meta.allPristine,
            allValid = _allFields$_meta.allValid,
            errors = _allFields$_meta.errors,
            formError = _allFields$_meta.formError,
            values = _allFields$_meta.values;


        var props = {
          // State:
          active: form._active,
          asyncValidating: form._asyncValidating,
          dirty: !allPristine,
          error: formError,
          errors: errors,
          fields: allFields,
          formKey: formKey,
          invalid: !allValid,
          pristine: allPristine,
          submitting: form._submitting,
          submitFailed: form._submitFailed,
          valid: allValid,
          values: values,

          // Actions:
          asyncValidate: (0, _silenceEvents2.default)(function () {
            return _this4.asyncValidate();
          }),
          // ^ doesn't just pass this.asyncValidate to disallow values passing
          destroyForm: (0, _silenceEvents2.default)(destroy),
          handleSubmit: this.handleSubmit,
          initializeForm: (0, _silenceEvents2.default)(function (initValues) {
            return initialize(initValues, fields);
          }),
          resetForm: (0, _silenceEvents2.default)(reset),
          touch: (0, _silenceEvents2.default)(function () {
            return touch.apply(undefined, arguments);
          }),
          touchAll: (0, _silenceEvents2.default)(function () {
            return touch.apply(undefined, fields);
          }),
          untouch: (0, _silenceEvents2.default)(function () {
            return untouch.apply(undefined, arguments);
          }),
          untouchAll: (0, _silenceEvents2.default)(function () {
            return untouch.apply(undefined, fields);
          })
        };
        var passedProps = propNamespace ? (_ref2 = {}, _ref2[propNamespace] = props, _ref2) : props;
        if (withRef) {
          return React.createElement(WrappedComponent, _extends({}, _extends({}, passableProps, passedProps), { ref: 'wrappedInstance' }));
        }
        return React.createElement(WrappedComponent, _extends({}, passableProps, passedProps));
      };

      return ReduxForm;
    }(Component);

    ReduxForm.displayName = 'ReduxForm(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
    ReduxForm.WrappedComponent = WrappedComponent;
    ReduxForm.propTypes = {
      // props:
      alwaysAsyncValidate: _propTypes2.default.bool,
      asyncBlurFields: _propTypes2.default.arrayOf(_propTypes2.default.string),
      asyncValidate: _propTypes2.default.func,
      dispatch: _propTypes2.default.func.isRequired,
      fields: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
      form: _propTypes2.default.object,
      initialValues: _propTypes2.default.any,
      onSubmit: _propTypes2.default.func,
      onSubmitSuccess: _propTypes2.default.func,
      onSubmitFail: _propTypes2.default.func,
      overwriteOnInitialValuesChange: _propTypes2.default.bool.isRequired,
      propNamespace: _propTypes2.default.string,
      readonly: _propTypes2.default.bool,
      returnRejectedSubmitPromise: _propTypes2.default.bool,
      submitPassback: _propTypes2.default.func.isRequired,
      validate: _propTypes2.default.func,

      // actions:
      addArrayValue: _propTypes2.default.func.isRequired,
      autofill: _propTypes2.default.func.isRequired,
      blur: _propTypes2.default.func.isRequired,
      change: _propTypes2.default.func.isRequired,
      destroy: _propTypes2.default.func.isRequired,
      focus: _propTypes2.default.func.isRequired,
      initialize: _propTypes2.default.func.isRequired,
      removeArrayValue: _propTypes2.default.func.isRequired,
      reset: _propTypes2.default.func.isRequired,
      startAsyncValidation: _propTypes2.default.func.isRequired,
      startSubmit: _propTypes2.default.func.isRequired,
      stopAsyncValidation: _propTypes2.default.func.isRequired,
      stopSubmit: _propTypes2.default.func.isRequired,
      submitFailed: _propTypes2.default.func.isRequired,
      swapArrayValues: _propTypes2.default.func.isRequired,
      touch: _propTypes2.default.func.isRequired,
      untouch: _propTypes2.default.func.isRequired
    };
    ReduxForm.defaultProps = {
      asyncBlurFields: [],
      form: _reducer.initialState,
      readonly: false,
      returnRejectedSubmitPromise: false,
      validate: function validate() {
        return {};
      }
    };

    // bind touch flags to blur and change
    var unboundActions = _extends({}, importedActions, {
      blur: (0, _bindActionData2.default)(importedActions.blur, {
        touch: !!config.touchOnBlur
      }),
      change: (0, _bindActionData2.default)(importedActions.change, {
        touch: !!config.touchOnChange
      })
    });

    // make redux connector with or without form key
    var decorate = formKey !== undefined && formKey !== null ? connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
      var formState = getFormState(state, reduxMountPoint);
      if (!formState) {
        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
      }
      return formState && formState[formName] && formState[formName][formKey];
    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, {
      form: formName,
      key: formKey
    })), mergeProps, options) : connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
      var formState = getFormState(state, reduxMountPoint);
      if (!formState) {
        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
      }
      return formState && formState[formName];
    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, { form: formName })), mergeProps, options);

    return decorate(ReduxForm);
  };
};

exports.default = createHigherOrderComponent;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _readField = __webpack_require__(1473);

var _readField2 = _interopRequireDefault(_readField);

var _write = __webpack_require__(672);

var _write2 = _interopRequireDefault(_write);

var _getValues = __webpack_require__(679);

var _getValues2 = _interopRequireDefault(_getValues);

var _removeField = __webpack_require__(1481);

var _removeField2 = _interopRequireDefault(_removeField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Reads props and generates (or updates) field structure
 */
var readFields = function readFields(props, previousProps, myFields, asyncValidate, isReactNative) {
  var fields = props.fields,
      form = props.form,
      validate = props.validate;

  var previousFields = previousProps.fields;
  var values = (0, _getValues2.default)(fields, form);
  var syncErrors = validate(values, props) || {};
  var errors = {};
  var formError = syncErrors._error || form._error;
  var allValid = !formError;
  var allPristine = true;
  var tally = function tally(field) {
    if (field.error) {
      errors = (0, _write2.default)(field.name, field.error, errors);
      allValid = false;
    }
    if (field.dirty) {
      allPristine = false;
    }
  };
  var fieldObjects = previousFields ? previousFields.reduce(function (accumulator, previousField) {
    return ~fields.indexOf(previousField) ? accumulator : (0, _removeField2.default)(accumulator, previousField);
  }, _extends({}, myFields)) : _extends({}, myFields);
  fields.forEach(function (name) {
    (0, _readField2.default)(form, name, undefined, fieldObjects, syncErrors, asyncValidate, isReactNative, props, tally);
  });
  Object.defineProperty(fieldObjects, '_meta', {
    value: {
      allPristine: allPristine,
      allValid: allValid,
      values: values,
      errors: errors,
      formError: formError
    }
  });
  return fieldObjects;
};
exports.default = readFields;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createOnBlur = __webpack_require__(1474);

var _createOnBlur2 = _interopRequireDefault(_createOnBlur);

var _createOnChange = __webpack_require__(1475);

var _createOnChange2 = _interopRequireDefault(_createOnChange);

var _createOnDragStart = __webpack_require__(682);

var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);

var _createOnDrop = __webpack_require__(1476);

var _createOnDrop2 = _interopRequireDefault(_createOnDrop);

var _createOnFocus = __webpack_require__(1477);

var _createOnFocus2 = _interopRequireDefault(_createOnFocus);

var _silencePromise = __webpack_require__(1478);

var _silencePromise2 = _interopRequireDefault(_silencePromise);

var _read = __webpack_require__(671);

var _read2 = _interopRequireDefault(_read);

var _updateField = __webpack_require__(1479);

var _updateField2 = _interopRequireDefault(_updateField);

var _isChecked = __webpack_require__(683);

var _isChecked2 = _interopRequireDefault(_isChecked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getSuffix(input, closeIndex) {
  var suffix = input.substring(closeIndex + 1);
  if (suffix[0] === '.') {
    suffix = suffix.substring(1);
  }
  return suffix;
}

var getNextKey = function getNextKey(path) {
  var dotIndex = path.indexOf('.');
  var openIndex = path.indexOf('[');
  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    return path.substring(0, openIndex);
  }
  return dotIndex > 0 ? path.substring(0, dotIndex) : path;
};

var shouldAsyncValidate = function shouldAsyncValidate(name, asyncBlurFields) {
  return (
    // remove array indices
    ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'))
  );
};

var readField = function readField(state, fieldName) {
  var pathToHere = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var fields = arguments[3];
  var syncErrors = arguments[4];
  var asyncValidate = arguments[5];
  var isReactNative = arguments[6];
  var props = arguments[7];
  var callback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : function () {
    return null;
  };
  var prefix = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
  var asyncBlurFields = props.asyncBlurFields,
      autofill = props.autofill,
      blur = props.blur,
      change = props.change,
      focus = props.focus,
      form = props.form,
      initialValues = props.initialValues,
      readonly = props.readonly,
      addArrayValue = props.addArrayValue,
      removeArrayValue = props.removeArrayValue,
      swapArrayValues = props.swapArrayValues;

  var dotIndex = fieldName.indexOf('.');
  var openIndex = fieldName.indexOf('[');
  var closeIndex = fieldName.indexOf(']');
  if (openIndex > 0 && closeIndex !== openIndex + 1) {
    throw new Error('found [ not followed by ]');
  }

  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    // array field
    var key = fieldName.substring(0, openIndex);
    var rest = getSuffix(fieldName, closeIndex);
    var stateArray = state && state[key] || [];
    var fullPrefix = prefix + fieldName.substring(0, closeIndex + 1);
    var subfields = props.fields.reduce(function (accumulator, field) {
      if (field.indexOf(fullPrefix) === 0) {
        accumulator.push(field);
      }
      return accumulator;
    }, []).map(function (field) {
      return getSuffix(field, prefix.length + closeIndex);
    });
    var addMethods = function addMethods(dest) {
      Object.defineProperty(dest, 'addField', {
        value: function value(_value, index) {
          return addArrayValue(pathToHere + key, _value, index, subfields);
        }
      });
      Object.defineProperty(dest, 'removeField', {
        value: function value(index) {
          return removeArrayValue(pathToHere + key, index);
        }
      });
      Object.defineProperty(dest, 'swapFields', {
        value: function value(indexA, indexB) {
          return swapArrayValues(pathToHere + key, indexA, indexB);
        }
      });
      return dest;
    };
    if (!fields[key] || fields[key].length !== stateArray.length) {
      fields[key] = fields[key] ? [].concat(fields[key]) : [];
      addMethods(fields[key]);
    }
    var fieldArray = fields[key];
    var changed = false;
    stateArray.forEach(function (fieldState, index) {
      if (rest && !fieldArray[index]) {
        fieldArray[index] = {};
        changed = true;
      }
      var dest = rest ? fieldArray[index] : {};
      var nextPath = '' + pathToHere + key + '[' + index + ']' + (rest ? '.' : '');
      var nextPrefix = '' + prefix + key + '[]' + (rest ? '.' : '');

      var result = readField(fieldState, rest, nextPath, dest, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
      if (fieldArray[index] !== result) {
        if (rest) {
          // if something's after [] in field name, the array item is an object field
          // we need it to compare !== to the original (so react re-renders appropriately)
          result = _extends({}, dest);
        }
        fieldArray[index] = result;
        changed = true;
      }
    });
    if (fieldArray.length > stateArray.length) {
      // remove extra items that aren't in state array
      fieldArray.splice(stateArray.length, fieldArray.length - stateArray.length);
    }
    if (changed) {
      fieldArray = addMethods([].concat(fieldArray));
    }
    fields[key] = fieldArray;
    return fieldArray;
  }
  if (dotIndex > 0) {
    // subobject field
    var _key = fieldName.substring(0, dotIndex);
    var _rest = fieldName.substring(dotIndex + 1);
    var subobject = fields[_key] || {};
    var nextPath = pathToHere + _key + '.';
    var nextKey = getNextKey(_rest);
    var nextPrefix = prefix + _key + '.';
    var previous = subobject[nextKey];
    var result = readField(state[_key] || {}, _rest, nextPath, subobject, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
    if (result !== previous) {
      var _extends2;

      subobject = _extends({}, subobject, (_extends2 = {}, _extends2[nextKey] = result, _extends2));
    }
    fields[_key] = subobject;
    return subobject;
  }
  var name = pathToHere + fieldName;
  var field = fields[fieldName] || {};
  if (field.name !== name) {
    var onChange = (0, _createOnChange2.default)(name, change, isReactNative);
    var initialFormValue = (0, _read2.default)(name + '.initial', form);
    var initialValue = initialFormValue || (0, _read2.default)(name, initialValues);
    initialValue = initialValue === undefined ? '' : initialValue;
    field.name = name;
    field.checked = (0, _isChecked2.default)(initialValue);
    field.value = initialValue;
    field.initialValue = initialValue;
    if (!readonly) {
      field.autofill = function (value) {
        return autofill(name, value);
      };
      field.onBlur = (0, _createOnBlur2.default)(name, blur, isReactNative, shouldAsyncValidate(name, asyncBlurFields) && function (blurName, blurValue) {
        return (0, _silencePromise2.default)(asyncValidate(blurName, blurValue));
      });
      field.onChange = onChange;
      field.onDragStart = (0, _createOnDragStart2.default)(name, function () {
        return field.value;
      });
      field.onDrop = (0, _createOnDrop2.default)(name, change);
      field.onFocus = (0, _createOnFocus2.default)(name, focus);
      field.onUpdate = onChange; // alias to support belle. https://github.com/nikgraf/belle/issues/58
    }
    field.valid = true;
    field.invalid = false;
    Object.defineProperty(field, '_isField', { value: true });
  }

  var fieldState = (fieldName ? state[fieldName] : state) || {};
  var syncError = (0, _read2.default)(name, syncErrors);
  var updated = (0, _updateField2.default)(field, fieldState, name === form._active, syncError);
  if (fieldName || fields[fieldName] !== updated) {
    fields[fieldName] = updated;
  }
  callback(updated);
  return updated;
};

exports.default = readField;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getValue = __webpack_require__(680);

var _getValue2 = _interopRequireDefault(_getValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createOnBlur = function createOnBlur(name, blur, isReactNative, afterBlur) {
  return function (event) {
    var value = (0, _getValue2.default)(event, isReactNative);
    blur(name, value);
    if (afterBlur) {
      afterBlur(name, value);
    }
  };
};
exports.default = createOnBlur;

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getValue = __webpack_require__(680);

var _getValue2 = _interopRequireDefault(_getValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createOnChange = function createOnChange(name, change, isReactNative) {
  return function (event) {
    return change(name, (0, _getValue2.default)(event, isReactNative));
  };
};
exports.default = createOnChange;

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createOnDragStart = __webpack_require__(682);

var createOnDrop = function createOnDrop(name, change) {
  return function (event) {
    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
  };
};
exports.default = createOnDrop;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var createOnFocus = function createOnFocus(name, focus) {
  return function () {
    return focus(name);
  };
};
exports.default = createOnFocus;

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isPromise = __webpack_require__(436);

var _isPromise2 = _interopRequireDefault(_isPromise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {
  return undefined;
};

var silencePromise = function silencePromise(promise) {
  return (0, _isPromise2.default)(promise) ? promise.then(noop, noop) : promise;
};

exports.default = silencePromise;

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _isPristine = __webpack_require__(1480);

var _isPristine2 = _interopRequireDefault(_isPristine);

var _isValid = __webpack_require__(313);

var _isValid2 = _interopRequireDefault(_isValid);

var _isChecked = __webpack_require__(683);

var _isChecked2 = _interopRequireDefault(_isChecked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Updates a field object from the store values
 */
var updateField = function updateField(field, formField, active, syncError) {
  var diff = {};
  var formFieldValue = formField.value === undefined ? '' : formField.value;

  // update field value
  if (field.value !== formFieldValue) {
    diff.value = formFieldValue;
    diff.checked = (0, _isChecked2.default)(formFieldValue);
  }

  // update dirty/pristine
  var pristine = (0, _isPristine2.default)(formFieldValue, formField.initial);
  if (field.pristine !== pristine) {
    diff.dirty = !pristine;
    diff.pristine = pristine;
  }

  // update field error
  var error = syncError || formField.submitError || formField.asyncError;
  if (error !== field.error) {
    diff.error = error;
  }
  var valid = (0, _isValid2.default)(error);
  if (field.valid !== valid) {
    diff.invalid = !valid;
    diff.valid = valid;
  }

  if (active !== field.active) {
    diff.active = active;
  }
  var touched = !!formField.touched;
  if (touched !== field.touched) {
    diff.touched = touched;
  }
  var visited = !!formField.visited;
  if (visited !== field.visited) {
    diff.visited = visited;
  }
  var autofilled = !!formField.autofilled;
  if (autofilled !== field.autofilled) {
    diff.autofilled = autofilled;
  }

  if ('initial' in formField && formField.initial !== field.initialValue) {
    field.initialValue = formField.initial;
  }

  return Object.keys(diff).length ? _extends({}, field, diff) : field;
};
exports.default = updateField;

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isPristine;
function isPristine(initial, data) {
  if (initial === data) {
    return true;
  }
  if (typeof initial === 'boolean' || typeof data === 'boolean') {
    return initial === data;
  } else if (initial instanceof Date && data instanceof Date) {
    return initial.getTime() === data.getTime();
  } else if (initial && typeof initial === 'object') {
    if (!data || typeof data !== 'object') {
      return false;
    }
    var initialKeys = Object.keys(initial);
    var dataKeys = Object.keys(data);
    if (initialKeys.length !== dataKeys.length) {
      return false;
    }
    for (var index = 0; index < dataKeys.length; index++) {
      var key = dataKeys[index];
      if (!isPristine(initial[key], data[key])) {
        return false;
      }
    }
  } else if (initial || data) {
    // allow '' to equate to undefined or null
    return initial === data;
  } else if (initial === null && data === 0 || initial === 0 && data === null) {
    return false;
  }
  return true;
}

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var without = function without(object, key) {
  var copy = _extends({}, object);
  delete copy[key];
  return copy;
};

var removeField = function removeField(fields, path) {
  var dotIndex = path.indexOf('.');
  var openIndex = path.indexOf('[');
  var closeIndex = path.indexOf(']');
  if (openIndex > 0 && closeIndex !== openIndex + 1) {
    throw new Error('found [ not followed by ]');
  }
  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
    // array field
    var key = path.substring(0, openIndex);
    if (!Array.isArray(fields[key])) {
      return without(fields, key);
    }
    var rest = path.substring(closeIndex + 1);
    if (rest[0] === '.') {
      rest = rest.substring(1);
    }
    if (rest) {
      var _extends2;

      var copy = [];
      fields[key].forEach(function (item, index) {
        var result = removeField(item, rest);
        if (Object.keys(result).length) {
          copy[index] = result;
        }
      });
      return copy.length ? _extends({}, fields, (_extends2 = {}, _extends2[key] = copy, _extends2)) : without(fields, key);
    }
    return without(fields, key);
  }
  if (dotIndex > 0) {
    var _extends3;

    // subobject field
    var _key = path.substring(0, dotIndex);
    var _rest = path.substring(dotIndex + 1);
    if (!fields[_key]) {
      return fields;
    }
    var result = removeField(fields[_key], _rest);
    return Object.keys(result).length ? _extends({}, fields, (_extends3 = {}, _extends3[_key] = removeField(fields[_key], _rest), _extends3)) : without(fields, _key);
  }
  return without(fields, path);
};

exports.default = removeField;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isPromise = __webpack_require__(436);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _isValid = __webpack_require__(313);

var _isValid2 = _interopRequireDefault(_isValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleSubmit = function handleSubmit(submit, values, props, asyncValidate) {
  var dispatch = props.dispatch,
      fields = props.fields,
      onSubmitSuccess = props.onSubmitSuccess,
      onSubmitFail = props.onSubmitFail,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      submitFailed = props.submitFailed,
      returnRejectedSubmitPromise = props.returnRejectedSubmitPromise,
      touch = props.touch,
      validate = props.validate;

  var syncErrors = validate(values, props);
  touch.apply(undefined, fields); // touch all fields
  if ((0, _isValid2.default)(syncErrors)) {
    var doSubmit = function doSubmit() {
      var result = submit(values, dispatch, props);
      if ((0, _isPromise2.default)(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult);
          }
          return submitResult;
        }, function (submitError) {
          stopSubmit(submitError);
          if (onSubmitFail) {
            onSubmitFail(submitError);
          }
          if (returnRejectedSubmitPromise) {
            return Promise.reject(submitError);
          }
        });
      }
      if (onSubmitSuccess) {
        onSubmitSuccess(result);
      }
      return result;
    };
    var asyncValidateResult = asyncValidate();
    return (0, _isPromise2.default)(asyncValidateResult) ?
    // asyncValidateResult will be rejected if async validation failed
    asyncValidateResult.then(doSubmit, function () {
      submitFailed();
      if (onSubmitFail) {
        onSubmitFail();
      }
      return returnRejectedSubmitPromise ? Promise.reject() : Promise.resolve();
    }) : doSubmit(); // no async validation, so submit
  }
  submitFailed();

  if (onSubmitFail) {
    onSubmitFail(syncErrors);
  }

  if (returnRejectedSubmitPromise) {
    return Promise.reject(syncErrors);
  }
};

exports.default = handleSubmit;

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isPromise = __webpack_require__(436);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _isValid = __webpack_require__(313);

var _isValid2 = _interopRequireDefault(_isValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!(0, _isPromise2.default)(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (!(0, _isValid2.default)(errors)) {
        stop(errors);
        return Promise.reject();
      } else if (rejected) {
        stop();
        throw new Error('Asynchronous validation promise was rejected without errors.');
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

exports.default = asyncValidation;

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _silenceEvent = __webpack_require__(684);

var _silenceEvent2 = _interopRequireDefault(_silenceEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

exports.default = silenceEvents;

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(222);

var wrapMapDispatchToProps = function wrapMapDispatchToProps(mapDispatchToProps, actionCreators) {
  if (mapDispatchToProps) {
    if (typeof mapDispatchToProps === 'function') {
      if (mapDispatchToProps.length > 1) {
        return function (dispatch, ownProps) {
          return _extends({
            dispatch: dispatch
          }, mapDispatchToProps(dispatch, ownProps), (0, _redux.bindActionCreators)(actionCreators, dispatch));
        };
      }
      return function (dispatch) {
        return _extends({
          dispatch: dispatch
        }, mapDispatchToProps(dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
      };
    }
    return function (dispatch) {
      return _extends({
        dispatch: dispatch
      }, (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
    };
  }
  return function (dispatch) {
    return _extends({
      dispatch: dispatch
    }, (0, _redux.bindActionCreators)(actionCreators, dispatch));
  };
};

exports.default = wrapMapDispatchToProps;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var wrapMapStateToProps = function wrapMapStateToProps(mapStateToProps, getForm) {
  if (mapStateToProps) {
    if (typeof mapStateToProps !== 'function') {
      throw new Error('mapStateToProps must be a function');
    }
    if (mapStateToProps.length > 1) {
      return function (state, ownProps) {
        return _extends({}, mapStateToProps(state, ownProps), {
          form: getForm(state)
        });
      };
    }
    return function (state) {
      return _extends({}, mapStateToProps(state), {
        form: getForm(state)
      });
    };
  }
  return function (state) {
    return {
      form: getForm(state)
    };
  };
};

exports.default = wrapMapStateToProps;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createPropTypes = function createPropTypes() {
  return {
    // State:
    active: _propTypes2.default.string, // currently active field
    asyncValidating: _propTypes2.default.bool.isRequired, // true if async validation is running
    autofilled: _propTypes2.default.bool, // true if set programmatically by autofill
    dirty: _propTypes2.default.bool.isRequired, // true if any values are different from initialValues
    error: _propTypes2.default.any, // form-wide error from '_error' key in validation result
    errors: _propTypes2.default.object, // a map of errors corresponding to structure of form data (result of validation)
    fields: _propTypes2.default.object.isRequired, // the map of fields
    formKey: _propTypes2.default.any, // the form key if one was provided (used when doing multirecord forms)
    invalid: _propTypes2.default.bool.isRequired, // true if there are any validation errors
    pristine: _propTypes2.default.bool.isRequired, // true if the values are the same as initialValues
    submitting: _propTypes2.default.bool.isRequired, // true if the form is in the process of being submitted
    submitFailed: _propTypes2.default.bool.isRequired, // true if the form was submitted and failed for any reason
    valid: _propTypes2.default.bool.isRequired, // true if there are no validation errors
    values: _propTypes2.default.object.isRequired, // the values of the form as they will be submitted

    // Actions:
    asyncValidate: _propTypes2.default.func.isRequired, // function to trigger async validation
    destroyForm: _propTypes2.default.func.isRequired, // action to destroy the form's data in Redux
    handleSubmit: _propTypes2.default.func.isRequired, // function to submit the form
    initializeForm: _propTypes2.default.func.isRequired, // action to initialize form data
    resetForm: _propTypes2.default.func.isRequired, // action to reset the form data to previously initialized values
    touch: _propTypes2.default.func.isRequired, // action to mark fields as touched
    touchAll: _propTypes2.default.func.isRequired, // action to mark ALL fields as touched
    untouch: _propTypes2.default.func.isRequired, // action to mark fields as untouched
    untouchAll: _propTypes2.default.func.isRequired // action to mark ALL fields as untouched
  };
};

exports.default = createPropTypes;

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(314);
var _reducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({saving:false});var reducers=(_reducers={},_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* SAVE_GROUP_PENDING */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return state.set('saving',true);})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SAVE_GROUP_COMPLETE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return state.set('saving',false);})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SAVE_NEW_GROUP_COMPLETE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return state.set('saving',false);})),_reducers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])(reducers,defaultState));

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_set__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_findIndex__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* receiveHomes */].toString(),Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref){var homes=_ref.payload.homes;return Object.assign({},state,{homeItems:homes||[]});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* renameHome */].toString(),Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref2){var payload=_ref2.payload;return Object.assign({},state,{isRenaming:true});},function(state){return Object.assign({},state,{isRenaming:false});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* renamedHome */].toString(),Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref3){var payload=_ref3.payload;var index=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_findIndex___default()(function(x){return x.id===payload.home;},state.homeItems);if(index>-1){return Object.assign({},__WEBPACK_IMPORTED_MODULE_0_lodash_fp_set___default()(['homeItems',index,'name'],payload.name,Object.assign({},state)),{isRenaming:false});}return Object.assign({},state,{homeItems:[].concat(_toConsumableArray(state.homeItems),[payload]),isRenaming:false});})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["b" /* handleActions */])(actionHandlers,{homeItems:[],isRenaming:false}));

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('set', __webpack_require__(1491));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(582);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
var _reducers;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var bool=Boolean;var roundMinutesToNext5=function roundMinutesToNext5(date){return date.clone().minutes(Math.ceil((date.minutes()+1)/5)*5).seconds(0).milliseconds(0);};var reducers=(_reducers={},_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* EDITING_HOLIDAY_MODE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('editing',true);})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* DISABLE_HOLIDAY_MODE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return(// $FlowFixMe
state.set('enabled',false).set('active',false).set('editing',false));})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* INITIATE_HOLIDAYMODE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('initialized',false);})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* INITIALIZE_STATE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;var now=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().valueOf();// $FlowFixMe
var start=payload.start,end=payload.end,enabled=payload.enabled;var startTime=start||__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().add(5,'minutes').valueOf();var endTime=end||__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().add(5,'minutes').add(7,'days').valueOf();if(!enabled&&__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(startTime).isBefore(__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(now))){startTime=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().add(5,'minutes').valueOf();endTime=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().add(5,'minutes').add(7,'days').valueOf();}return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(Object.assign({},payload,{start:startTime,end:endTime,initialized:true,showEnd:true,active:enabled&&startTime<=now&&endTime>now}));})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* SET_HOLIDAY_MODE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('initialized',false).set('editing',false);})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* TIME_CHANGE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref2){var payload=_ref2.payload;var currentSavedDate=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(state.get(payload.position,__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()())).tz(payload.timezone);var _payload$time$split=payload.time.split(':'),_payload$time$split2=_slicedToArray(_payload$time$split,2),hours=_payload$time$split2[0],mins=_payload$time$split2[1];var nextDate=currentSavedDate.clone().hours(hours).minutes(mins);// $FlowFixMe
return state.set(payload.position,nextDate.valueOf());})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TEMPERATURE_CHANGE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref3){var payload=_ref3.payload;return state.set('temperature',payload);})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DATE_SELECTED */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref4){var _ref4$payload=_ref4.payload,timezone=_ref4$payload.timezone,date=_ref4$payload.date;var start=// $FlowFixMe
state.get('start')||__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(new Date(date)).tz(timezone).valueOf();var end=// $FlowFixMe
state.get('end')||__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(new Date(date)).tz(timezone).valueOf();// $FlowFixMe
var showEnd=state.get('showEnd',true);var momentStart=roundMinutesToNext5(__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(start).tz(timezone));var momentEnd=roundMinutesToNext5(__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(end).tz(timezone));var newDate=roundMinutesToNext5(__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(new Date(date)).tz(timezone));var conditionsMap=new Map([[true,function(){var prevDate=start?momentEnd:momentStart;var nextDate=newDate.hours(prevDate.hours()).minutes(prevDate.minutes());// $FlowFixMe
return state.set(start?'end':'start',nextDate.valueOf()).set('showEnd',true);}],[bool(start&&newDate.isBefore(momentStart)),function(){var nextStart=newDate.hours(momentStart.hours()).minutes(momentStart.minutes());var nextEnd=end?momentStart.hours(momentEnd.hours()).minutes(momentEnd.minutes()):momentStart;// $FlowFixMe
return state.set('start',nextStart.valueOf()).set('end',nextEnd.valueOf()).set('showEnd',true);}],// $FlowFixMe fix for state.set('showEnd', false)
[bool(start&&momentStart.isSame(newDate,'date')),function(){return state.set('showEnd',false);}],[bool(start&&showEnd),function(){var nextStart=newDate.hours(momentStart.hours()).minutes(momentStart.minutes());// $FlowFixMe
return state.set('start',nextStart.valueOf()).set('showEnd',false);}]]).get(true);var nextState=conditionsMap&&conditionsMap();return nextState;})),_reducers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(// $FlowFixMe
reducers,// $FlowFixMe
Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({initialized:false,editing:false})));

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.13
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(335)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.13",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName){
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			if (split[5]) {
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		return !!(m._a && (m._tzm === undefined));
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.offset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2017b",
	"zones": [
		"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
		"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
		"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
		"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
		"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
		"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
		"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
		"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
		"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
		"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
		"Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
		"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
		"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5",
		"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
		"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
		"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
		"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
		"Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4",
		"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
		"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
		"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
		"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
		"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
		"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
		"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
		"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0",
		"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
		"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0",
		"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
		"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0",
		"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0",
		"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
		"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0",
		"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0",
		"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
		"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
		"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
		"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
		"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
		"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
		"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
		"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
		"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
		"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
		"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
		"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
		"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
		"America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
		"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
		"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
		"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
		"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
		"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
		"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
		"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
		"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
		"America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
		"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
		"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
		"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
		"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
		"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
		"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
		"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
		"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
		"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
		"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
		"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
		"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
		"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
		"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
		"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
		"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
		"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
		"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
		"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
		"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
		"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
		"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
		"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
		"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
		"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
		"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
		"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
		"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
		"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
		"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
		"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
		"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
		"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
		"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
		"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
		"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
		"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
		"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
		"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
		"America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
		"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
		"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
		"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
		"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
		"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
		"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
		"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
		"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
		"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
		"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
		"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
		"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0",
		"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
		"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
		"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
		"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
		"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
		"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
		"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
		"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
		"America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
		"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
		"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
		"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
		"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
		"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
		"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
		"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
		"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
		"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
		"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
		"Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
		"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
		"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
		"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
		"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
		"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
		"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
		"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
		"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
		"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
		"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
		"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
		"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
		"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
		"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
		"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
		"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
		"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
		"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
		"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
		"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
		"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
		"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
		"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
		"Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6",
		"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
		"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
		"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
		"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
		"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
		"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
		"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
		"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
		"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
		"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0",
		"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
		"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
		"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
		"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
		"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
		"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
		"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
		"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
		"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
		"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
		"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
		"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
		"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
		"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
		"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
		"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
		"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
		"Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4",
		"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
		"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
		"Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
		"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
		"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
		"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
		"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
		"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
		"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
		"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5",
		"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
		"Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5",
		"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
		"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
		"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
		"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
		"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
		"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
		"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
		"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
		"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
		"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
		"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
		"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
		"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
		"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
		"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
		"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
		"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
		"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
		"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
		"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
		"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
		"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
		"Atlantic/South_Georgia|-02|20|0||30",
		"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
		"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
		"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
		"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
		"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
		"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
		"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
		"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
		"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
		"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
		"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
		"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
		"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
		"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
		"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"EST|EST|50|0|",
		"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Etc/GMT+0|GMT|0|0|",
		"Etc/GMT+1|-01|10|0|",
		"Etc/GMT+10|-10|a0|0|",
		"Etc/GMT+11|-11|b0|0|",
		"Etc/GMT+12|-12|c0|0|",
		"Etc/GMT+3|-03|30|0|",
		"Etc/GMT+4|-04|40|0|",
		"Etc/GMT+5|-05|50|0|",
		"Etc/GMT+6|-06|60|0|",
		"Etc/GMT+7|-07|70|0|",
		"Etc/GMT+8|-08|80|0|",
		"Etc/GMT+9|-09|90|0|",
		"Etc/GMT-1|+01|-10|0|",
		"Pacific/Port_Moresby|+10|-a0|0||25e4",
		"Pacific/Pohnpei|+11|-b0|0||34e3",
		"Pacific/Tarawa|+12|-c0|0||29e3",
		"Etc/GMT-13|+13|-d0|0|",
		"Etc/GMT-14|+14|-e0|0|",
		"Etc/GMT-2|+02|-20|0|",
		"Etc/GMT-3|+03|-30|0|",
		"Etc/GMT-4|+04|-40|0|",
		"Etc/GMT-5|+05|-50|0|",
		"Etc/GMT-6|+06|-60|0|",
		"Indian/Christmas|+07|-70|0||21e2",
		"Etc/GMT-8|+08|-80|0|",
		"Pacific/Palau|+09|-90|0||21e3",
		"Etc/UCT|UCT|0|0|",
		"Etc/UTC|UTC|0|0|",
		"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
		"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
		"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
		"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
		"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
		"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
		"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
		"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
		"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
		"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
		"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
		"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
		"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
		"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
		"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
		"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
		"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
		"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
		"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
		"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
		"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
		"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
		"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
		"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
		"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
		"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
		"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
		"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
		"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
		"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
		"HST|HST|a0|0|",
		"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
		"Indian/Cocos|+0630|-6u|0||596",
		"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
		"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
		"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
		"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
		"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
		"Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3",
		"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"MST|MST|70|0|",
		"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
		"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
		"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
		"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
		"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1",
		"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
		"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4",
		"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
		"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
		"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
		"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
		"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
		"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2",
		"Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2",
		"Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3",
		"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
		"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
		"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
		"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
		"Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
		"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
		"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
		"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
		"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
		"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3",
		"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
	],
	"links": [
		"Africa/Abidjan|Africa/Bamako",
		"Africa/Abidjan|Africa/Banjul",
		"Africa/Abidjan|Africa/Conakry",
		"Africa/Abidjan|Africa/Dakar",
		"Africa/Abidjan|Africa/Freetown",
		"Africa/Abidjan|Africa/Lome",
		"Africa/Abidjan|Africa/Nouakchott",
		"Africa/Abidjan|Africa/Ouagadougou",
		"Africa/Abidjan|Africa/Sao_Tome",
		"Africa/Abidjan|Africa/Timbuktu",
		"Africa/Abidjan|Atlantic/St_Helena",
		"Africa/Cairo|Egypt",
		"Africa/Johannesburg|Africa/Maseru",
		"Africa/Johannesburg|Africa/Mbabane",
		"Africa/Khartoum|Africa/Juba",
		"Africa/Lagos|Africa/Bangui",
		"Africa/Lagos|Africa/Brazzaville",
		"Africa/Lagos|Africa/Douala",
		"Africa/Lagos|Africa/Kinshasa",
		"Africa/Lagos|Africa/Libreville",
		"Africa/Lagos|Africa/Luanda",
		"Africa/Lagos|Africa/Malabo",
		"Africa/Lagos|Africa/Niamey",
		"Africa/Lagos|Africa/Porto-Novo",
		"Africa/Maputo|Africa/Blantyre",
		"Africa/Maputo|Africa/Bujumbura",
		"Africa/Maputo|Africa/Gaborone",
		"Africa/Maputo|Africa/Harare",
		"Africa/Maputo|Africa/Kigali",
		"Africa/Maputo|Africa/Lubumbashi",
		"Africa/Maputo|Africa/Lusaka",
		"Africa/Nairobi|Africa/Addis_Ababa",
		"Africa/Nairobi|Africa/Asmara",
		"Africa/Nairobi|Africa/Asmera",
		"Africa/Nairobi|Africa/Dar_es_Salaam",
		"Africa/Nairobi|Africa/Djibouti",
		"Africa/Nairobi|Africa/Kampala",
		"Africa/Nairobi|Africa/Mogadishu",
		"Africa/Nairobi|Indian/Antananarivo",
		"Africa/Nairobi|Indian/Comoro",
		"Africa/Nairobi|Indian/Mayotte",
		"Africa/Tripoli|Libya",
		"America/Adak|America/Atka",
		"America/Adak|US/Aleutian",
		"America/Anchorage|US/Alaska",
		"America/Argentina/Buenos_Aires|America/Buenos_Aires",
		"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
		"America/Argentina/Catamarca|America/Catamarca",
		"America/Argentina/Cordoba|America/Cordoba",
		"America/Argentina/Cordoba|America/Rosario",
		"America/Argentina/Jujuy|America/Jujuy",
		"America/Argentina/Mendoza|America/Mendoza",
		"America/Atikokan|America/Coral_Harbour",
		"America/Chicago|US/Central",
		"America/Curacao|America/Aruba",
		"America/Curacao|America/Kralendijk",
		"America/Curacao|America/Lower_Princes",
		"America/Denver|America/Shiprock",
		"America/Denver|Navajo",
		"America/Denver|US/Mountain",
		"America/Detroit|US/Michigan",
		"America/Edmonton|Canada/Mountain",
		"America/Fort_Wayne|America/Indiana/Indianapolis",
		"America/Fort_Wayne|America/Indianapolis",
		"America/Fort_Wayne|US/East-Indiana",
		"America/Halifax|Canada/Atlantic",
		"America/Havana|Cuba",
		"America/Indiana/Knox|America/Knox_IN",
		"America/Indiana/Knox|US/Indiana-Starke",
		"America/Jamaica|Jamaica",
		"America/Kentucky/Louisville|America/Louisville",
		"America/Los_Angeles|US/Pacific",
		"America/Los_Angeles|US/Pacific-New",
		"America/Manaus|Brazil/West",
		"America/Mazatlan|Mexico/BajaSur",
		"America/Mexico_City|Mexico/General",
		"America/New_York|US/Eastern",
		"America/Noronha|Brazil/DeNoronha",
		"America/Panama|America/Cayman",
		"America/Phoenix|US/Arizona",
		"America/Port_of_Spain|America/Anguilla",
		"America/Port_of_Spain|America/Antigua",
		"America/Port_of_Spain|America/Dominica",
		"America/Port_of_Spain|America/Grenada",
		"America/Port_of_Spain|America/Guadeloupe",
		"America/Port_of_Spain|America/Marigot",
		"America/Port_of_Spain|America/Montserrat",
		"America/Port_of_Spain|America/St_Barthelemy",
		"America/Port_of_Spain|America/St_Kitts",
		"America/Port_of_Spain|America/St_Lucia",
		"America/Port_of_Spain|America/St_Thomas",
		"America/Port_of_Spain|America/St_Vincent",
		"America/Port_of_Spain|America/Tortola",
		"America/Port_of_Spain|America/Virgin",
		"America/Regina|Canada/East-Saskatchewan",
		"America/Regina|Canada/Saskatchewan",
		"America/Rio_Branco|America/Porto_Acre",
		"America/Rio_Branco|Brazil/Acre",
		"America/Santiago|Chile/Continental",
		"America/Sao_Paulo|Brazil/East",
		"America/St_Johns|Canada/Newfoundland",
		"America/Tijuana|America/Ensenada",
		"America/Tijuana|America/Santa_Isabel",
		"America/Tijuana|Mexico/BajaNorte",
		"America/Toronto|America/Montreal",
		"America/Toronto|Canada/Eastern",
		"America/Vancouver|Canada/Pacific",
		"America/Whitehorse|Canada/Yukon",
		"America/Winnipeg|Canada/Central",
		"Asia/Ashgabat|Asia/Ashkhabad",
		"Asia/Bangkok|Asia/Phnom_Penh",
		"Asia/Bangkok|Asia/Vientiane",
		"Asia/Dhaka|Asia/Dacca",
		"Asia/Dubai|Asia/Muscat",
		"Asia/Ho_Chi_Minh|Asia/Saigon",
		"Asia/Hong_Kong|Hongkong",
		"Asia/Jerusalem|Asia/Tel_Aviv",
		"Asia/Jerusalem|Israel",
		"Asia/Kathmandu|Asia/Katmandu",
		"Asia/Kolkata|Asia/Calcutta",
		"Asia/Kuala_Lumpur|Asia/Singapore",
		"Asia/Kuala_Lumpur|Singapore",
		"Asia/Macau|Asia/Macao",
		"Asia/Makassar|Asia/Ujung_Pandang",
		"Asia/Nicosia|Europe/Nicosia",
		"Asia/Qatar|Asia/Bahrain",
		"Asia/Rangoon|Asia/Yangon",
		"Asia/Riyadh|Asia/Aden",
		"Asia/Riyadh|Asia/Kuwait",
		"Asia/Seoul|ROK",
		"Asia/Shanghai|Asia/Chongqing",
		"Asia/Shanghai|Asia/Chungking",
		"Asia/Shanghai|Asia/Harbin",
		"Asia/Shanghai|PRC",
		"Asia/Taipei|ROC",
		"Asia/Tehran|Iran",
		"Asia/Thimphu|Asia/Thimbu",
		"Asia/Tokyo|Japan",
		"Asia/Ulaanbaatar|Asia/Ulan_Bator",
		"Asia/Urumqi|Asia/Kashgar",
		"Atlantic/Faroe|Atlantic/Faeroe",
		"Atlantic/Reykjavik|Iceland",
		"Atlantic/South_Georgia|Etc/GMT+2",
		"Australia/Adelaide|Australia/South",
		"Australia/Brisbane|Australia/Queensland",
		"Australia/Broken_Hill|Australia/Yancowinna",
		"Australia/Darwin|Australia/North",
		"Australia/Hobart|Australia/Tasmania",
		"Australia/Lord_Howe|Australia/LHI",
		"Australia/Melbourne|Australia/Victoria",
		"Australia/Perth|Australia/West",
		"Australia/Sydney|Australia/ACT",
		"Australia/Sydney|Australia/Canberra",
		"Australia/Sydney|Australia/NSW",
		"Etc/GMT+0|Etc/GMT",
		"Etc/GMT+0|Etc/GMT-0",
		"Etc/GMT+0|Etc/GMT0",
		"Etc/GMT+0|Etc/Greenwich",
		"Etc/GMT+0|GMT",
		"Etc/GMT+0|GMT+0",
		"Etc/GMT+0|GMT-0",
		"Etc/GMT+0|GMT0",
		"Etc/GMT+0|Greenwich",
		"Etc/UCT|UCT",
		"Etc/UTC|Etc/Universal",
		"Etc/UTC|Etc/Zulu",
		"Etc/UTC|UTC",
		"Etc/UTC|Universal",
		"Etc/UTC|Zulu",
		"Europe/Belgrade|Europe/Ljubljana",
		"Europe/Belgrade|Europe/Podgorica",
		"Europe/Belgrade|Europe/Sarajevo",
		"Europe/Belgrade|Europe/Skopje",
		"Europe/Belgrade|Europe/Zagreb",
		"Europe/Chisinau|Europe/Tiraspol",
		"Europe/Dublin|Eire",
		"Europe/Helsinki|Europe/Mariehamn",
		"Europe/Istanbul|Asia/Istanbul",
		"Europe/Istanbul|Turkey",
		"Europe/Lisbon|Portugal",
		"Europe/London|Europe/Belfast",
		"Europe/London|Europe/Guernsey",
		"Europe/London|Europe/Isle_of_Man",
		"Europe/London|Europe/Jersey",
		"Europe/London|GB",
		"Europe/London|GB-Eire",
		"Europe/Moscow|W-SU",
		"Europe/Oslo|Arctic/Longyearbyen",
		"Europe/Oslo|Atlantic/Jan_Mayen",
		"Europe/Prague|Europe/Bratislava",
		"Europe/Rome|Europe/San_Marino",
		"Europe/Rome|Europe/Vatican",
		"Europe/Warsaw|Poland",
		"Europe/Zurich|Europe/Busingen",
		"Europe/Zurich|Europe/Vaduz",
		"Indian/Christmas|Etc/GMT-7",
		"Pacific/Auckland|Antarctica/McMurdo",
		"Pacific/Auckland|Antarctica/South_Pole",
		"Pacific/Auckland|NZ",
		"Pacific/Chatham|NZ-CHAT",
		"Pacific/Easter|Chile/EasterIsland",
		"Pacific/Guam|Pacific/Saipan",
		"Pacific/Honolulu|Pacific/Johnston",
		"Pacific/Honolulu|US/Hawaii",
		"Pacific/Kwajalein|Kwajalein",
		"Pacific/Pago_Pago|Pacific/Midway",
		"Pacific/Pago_Pago|Pacific/Samoa",
		"Pacific/Pago_Pago|US/Samoa",
		"Pacific/Palau|Etc/GMT-9",
		"Pacific/Pohnpei|Etc/GMT-11",
		"Pacific/Pohnpei|Pacific/Ponape",
		"Pacific/Port_Moresby|Etc/GMT-10",
		"Pacific/Port_Moresby|Pacific/Chuuk",
		"Pacific/Port_Moresby|Pacific/Truk",
		"Pacific/Port_Moresby|Pacific/Yap",
		"Pacific/Tarawa|Etc/GMT-12",
		"Pacific/Tarawa|Pacific/Funafuti",
		"Pacific/Tarawa|Pacific/Wake",
		"Pacific/Tarawa|Pacific/Wallis"
	]
};

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__install_hub_constants__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__devices_constants__ = __webpack_require__(167);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_1__install_hub_constants__["b" /* CLAIM_HUB */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state){return state.set('hasHub',true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DATE_TIME_INTERVAL */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;return state.set('currentTime',payload);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_7__application_actions__["h" /* logIn */].toString(),Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref2){var user=_ref2.payload.user;return state.set('timezone',user.timezone);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_8__devices_constants__["d" /* RECEIVE_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_reduce__["a" /* default */])(function(state,_ref3){var payload=_ref3.payload;var hub=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_find___default()(function(x){return x.type===__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* devices */].deviceTypes.HUB;},payload);var nextState=state.set('hasHub',!!hub);return hub?nextState.set('pmzStatus',hub.props.pmz):nextState;})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({currentTime:undefined,hasHub:undefined,timezone:undefined})));

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1497),
    findIndex = __webpack_require__(429);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(55),
    isArrayLike = __webpack_require__(92),
    keys = __webpack_require__(108);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generic", function() { return generic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forgottenPasswordMessages", function() { return forgottenPasswordMessages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/*eslint max-len:0*/var generic=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({UNEXPECTED_ERROR:{id:'feedback.generic.try-again',defaultMessage:'Oops! An unexpected error has occurred. Please refresh to continue or try again later.'},SAVE_FAILED:{id:'feedback.generic.save-failed',defaultMessage:'Oops! An unexpected error has occurred. Changes were not saved, please try again.'},NOTHING_TO_SAVE:{id:'feedback.generic.nothing-to-save',defaultMessage:'Nothing to save!'},UPDATE_SUCCESSFUL:{id:'feedback.generic.update-successful',defaultMessage:'Changes successfully updated.'}});var forgottenPasswordMessages={FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT:'A password reminder email has been sent'};

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GETTING_HOLIDAY_MODE */
/* unused harmony export RECEIVED_HOLIDAY_MODE */
/* unused harmony export ERROR_HOLIDAY_MODE */
var GETTING_HOLIDAY_MODE='GETTING_HOLIDAY_MODE';var RECEIVED_HOLIDAY_MODE='RECEIVED_HOLIDAY_MODE';var ERROR_HOLIDAY_MODE='ERROR_HOLIDAY_MODE';

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TYPE */
/* unused harmony export PAYLOAD */
/* unused harmony export COMPONENT */
/* unused harmony export COMPONENT_ID */
/* unused harmony export DATA */
/* unused harmony export STATUS */
var TYPE='type';var PAYLOAD='payload';var COMPONENT='component';var COMPONENT_ID='componentId';var DATA='data';var STATUS='status';

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TEXT_CONTROL_CONTACTS */
/* unused harmony export SETTING_TEXT_CONTROL_CONTACTS */
/* unused harmony export TEXT_CONTROL_CONTACTS_FETCHING */
/* unused harmony export TEXT_CONTROL_CONTACTS_SENT */
/* unused harmony export TEXT_CONTROL_CONTACTS_SUCCESS */
/* unused harmony export TEXT_CONTROL_INITIALISING */
/* unused harmony export DELETING_TEXT_CONTROL_CONTACTS */
/* unused harmony export UPDATING_TEXT_CONTROL_CONTACTS */
/* unused harmony export TEXT_CONTROL_SET_UNDO_VALUES */
/* unused harmony export TEXT_CONTROL_CONTACTS_ERROR */
/* unused harmony export NEW_FORM_DATA */
/* unused harmony export MAX_USERS */
var TEXT_CONTROL_CONTACTS='TEXT_CONTROL_CONTACTS';var SETTING_TEXT_CONTROL_CONTACTS='SETTING_TEXT_CONTROL_CONTACTS';var TEXT_CONTROL_CONTACTS_FETCHING='TEXT_CONTROL_CONTACTS_FETCHING';var TEXT_CONTROL_CONTACTS_SENT='TEXT_CONTROL_CONTACTS_SENT';var TEXT_CONTROL_CONTACTS_SUCCESS='TEXT_CONTROL_CONTACTS_SUCCESS';var TEXT_CONTROL_INITIALISING='TEXT_CONTROL_INITIALISING';var DELETING_TEXT_CONTROL_CONTACTS='DELETING_TEXT_CONTROL_CONTACTS';var UPDATING_TEXT_CONTROL_CONTACTS='UPDATING_TEXT_CONTROL_CONTACTS';var TEXT_CONTROL_SET_UNDO_VALUES='TEXT_CONTROL_SET_UNDO_VALUES';var TEXT_CONTROL_CONTACTS_ERROR='TEXT_CONTROL_CONTACTS_ERROR';var NEW_FORM_DATA='NEW_FORM_DATA';var MAX_USERS=5;

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(438);
var _actionHandler;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();var actionHandler=(_actionHandler={},_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref){var id=_ref.payload.id;return state.setIn([id,'hasLoaded'],false);})),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* LEAK_SENSOR_PAGE_READY */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref2){var id=_ref2.payload.id;return state.setIn([id,'hasLoaded'],true);})),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* LEAK_SENSOR_RECEIVE_EVENTS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref3){var _ref3$payload=_ref3.payload,data=_ref3$payload.data,day=_ref3$payload.day,id=_ref3$payload.id;return state.withMutations(function(tempState){return tempState.setIn([id,'events',day],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(data)).setIn([id,'hasLoaded'],true);});})),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* LEAK_SENSOR_SET_CURRENT_DAY */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref4){var _ref4$payload=_ref4.payload,id=_ref4$payload.id,day=_ref4$payload.day;return state.setIn([id,'eventsCurrentDay'],day);})),_actionHandler);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])(actionHandler,initialState));

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={isMobileMenuShown:false};var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* HIDE_MOBILE_MENU */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(){return{isMobileMenuShown:false};})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* TOGGLE_MOBILE_MENU */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return{isMobileMenuShown:!state.isMobileMenuShown};})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])(actionHandlers,initialState));

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionHandler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
var _actionHandler;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});var actionHandler=(_actionHandler={},_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CHANGE_MOTION_SENSOR_SELECTED_DAY */],function(state,_ref){var _ref$payload=_ref.payload,id=_ref$payload.id,day=_ref$payload.day;return state.setIn([id,'selectedDay'],day).setIn([id,'hasLoadedDayData'],false);}),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_MOTION_SENSOR_ZOOM_LEVEL */],function(state,_ref2){var _ref2$payload=_ref2.payload,id=_ref2$payload.id,zoomLevel=_ref2$payload.zoomLevel;return state.setIn([id,'zoomLevel'],zoomLevel);}),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANGE_EVENTS_CURRENT_DAY */],function(state,_ref3){var _ref3$payload=_ref3.payload,id=_ref3$payload.id,day=_ref3$payload.day;return state.setIn([id,'eventsCurrentDay'],day);}),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* MOTION_SENSOR_PAGE_READY */],function(state,_ref4){var id=_ref4.payload.id;return state.setIn([id,'hasLoaded'],true);}),_defineProperty(_actionHandler,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* RECEIVE_MOTION_SENSOR_EVENTS */],function(state,_ref5){var _ref5$payload=_ref5.payload,data=_ref5$payload.data,day=_ref5$payload.day,id=_ref5$payload.id;return state.setIn([id,'events',day],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(data)).setIn([id,'hasLoadedDayData'],true);}),_actionHandler);// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandler,initialState));

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* MIGRATION_STATUS_REQUEST */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('isLoadingStatus',true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* MIGRATION_STATUS_RESPONSE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var status=_ref.payload.status;return(// $FlowFixMe
state.set('isLoadingStatus',false).set('error',false).set('status',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(status)));},function(state,_ref2){var code=_ref2.payload.code;return(// $FlowFixMe
state.set('isLoadingStatus',false).set('error',true).set('errorCode',code));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["u" /* START_MIGRATION_REQUEST */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('isStartingMigration',true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["v" /* START_MIGRATION_RESPONSE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(// $FlowFixMe
function(state){return state.set('isStartingMigration',false).set('error',false);},function(state,_ref3){var code=_ref3.payload.code;return(// $FlowFixMe
state.set('isStartingMigration',false).set('error',true).set('errorCode',code));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* PROGRESS_INSTALL_STAGE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref4){var payload=_ref4.payload;return state.set('installStage',payload);})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({isLoadingStatus:false,isStartingMigration:false,status:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({}),error:false,errorCode:'',installStage:__WEBPACK_IMPORTED_MODULE_0__constants__["r" /* STAGE_START */]})));

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(257);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState={error:null};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* BRIDGE_NODE_CREATED */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a,function(_,_ref){var payload=_ref.payload;return{error:payload};})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* SEARCH_FOR_BRIDGE */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(){return{error:null};})),_handleActions),initialState));

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _handleActions;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var initialState={isLoading:true,isSaving:false,hasError:false,notifications:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([])};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CHANGE_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;return Object.assign({},state,{productId:payload});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RECEIVED_NOTIFICATIONS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref2){var payload=_ref2.payload;return{isLoading:false,hasError:false,// $FlowFixMe
notifications:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).entrySeq().map(function(_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],item=_ref4[1];return item.set('id',key);}).toList()};})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SAVE_NOTIFICATIONS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{isSaving:true,hasError:false});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SAVE_NOTIFICATIONS_ERROR */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{isSaving:false,hasError:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* SAVED_NOTIFICATIONS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(_ref5,_ref6){var payload=_ref6.payload;var notifications=_ref5.notifications,state=_objectWithoutProperties(_ref5,['notifications']);// $FlowFixMe
var itemIndex=notifications.findIndex(function(x){return x.get('id')===payload.id;});return Object.assign({},state,{isSaving:false,// $FlowFixMe
notifications:notifications.set(itemIndex,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload))});})),_handleActions),initialState));

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* RECEIVE_POWER_CONSUMPTION */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;return state.set('average',payload.average);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SHOW_ESTIMATED_COST_MODAL */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('showEstimatedCostModal',true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* HIDE_ESTIMATED_COST_MODAL */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('showEstimatedCostModal',false);})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({average:null,showEstimatedCostModal:false})));

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reducers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__holiday_mode_constants__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bulbs___ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sense___ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(258);
var _reducers;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var changeProductState=Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* undoable */])(function(state,_ref){var payload=_ref.payload;var currentProductIndex=Object(__WEBPACK_IMPORTED_MODULE_6__selectors__["x" /* getProductIndexById */])(state,payload.productId);if(currentProductIndex===-1){return state;}var productItem=state.productItems.get(currentProductIndex);var updatedProductItem=productItem.mergeDeepIn(['state'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(payload.productStateChanges));return Object.assign({},state,{productItems:state.productItems.set(currentProductIndex,updatedProductItem)});}));var holidayModeProds=['heating','hotwater'];var reducers=(_reducers={},_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__holiday_mode_constants__["h" /* SET_HOLIDAY_MODE */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{productItems:state.productItems.map(function(pi){return holidayModeProds.includes(pi.get('type'))?pi.setIn(['props','holidayMode','enabled'],true):pi;})});})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_0__holiday_mode_constants__["c" /* DISABLE_HOLIDAY_MODE */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{productItems:state.productItems.map(function(pi){return holidayModeProds.includes(pi.get('type'))?pi.setIn(['props','holidayMode','enabled'],false):pi;})});})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* GET_PRODUCTS */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(function(state){return Object.assign({},state,{isFetching:true});})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* RECEIVE_PRODUCTS */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(function(state,_ref2){var _ref2$payload=_ref2.payload,products=_ref2$payload.products,loadedAt=_ref2$payload.loadedAt;return Object.assign({},state,{isFetching:false,isLoaded:true,hasError:false,loadedAt:loadedAt,productItems:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(products)});},function(state,_ref3){var loadedAt=_ref3.payload.loadedAt;return Object.assign({},state,{isFetching:false,isLoaded:true,hasError:true,loadedAt:loadedAt});})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* PRODUCT_MODE_CHANGE_UPDATE_PRODUCT */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* undoable */])(function(state,_ref4){var _ref4$payload=_ref4.payload,userId=_ref4$payload.userId,mode=_ref4$payload.mode,productId=_ref4$payload.productId,currentSchedule=_ref4$payload.currentSchedule,defaultTargetTemperature=_ref4$payload.defaultTargetTemperature,cookieTarget=_ref4$payload.cookieTarget;var index=Object(__WEBPACK_IMPORTED_MODULE_6__selectors__["x" /* getProductIndexById */])(state,productId);var currentState=state.productItems.getIn([index,'state']);var type=state.productItems.getIn([index,'type']);var nextState=currentState.set('mode',mode);if(type==='hotwater'){nextState=nextState.set('status',[__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModes"].MANUAL,__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModes"].BOOST].includes(mode)?__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModes"].ON:__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModes"].OFF);}if(mode==='SCHEDULE'&&currentSchedule){var scheduleValue=currentSchedule.get('value');nextState=nextState.merge(scheduleValue);}if(type==='heating'){var frostProtection=currentState.get('frostProtection',7);if(mode===__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModes"].OFF){nextState=nextState.set('target',frostProtection);}else if(mode===__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModes"].MANUAL){var nextTarget=cookieTarget?parseFloat(cookieTarget):defaultTargetTemperature;nextState=nextState.set('target',nextTarget);state.productItems=state.productItems.setIn([index,'props','previous'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({mode:__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModes"].MANUAL,target:nextTarget}));}if(mode!==__WEBPACK_IMPORTED_MODULE_5__constants_devices__["deviceModes"].MANUAL){state.productItems=state.productItems.setIn([index,'props','previous'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({mode:mode}));}}else if(type==='hotwater'){state.productItems=state.productItems.setIn([index,'props','previous'],Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({mode:mode}));}return Object.assign({},state,{productItems:state.productItems.setIn([index,'state'],nextState)});}))),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* MODIFY_PRODUCT_STATE */],changeProductState),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_2__constants__["k" /* UNDO_PRODUCT_CHANGE */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(function(state,_ref5){var payload=_ref5.payload;var _state$previous$get=state.previous.get(payload,[]),_state$previous$get2=_slicedToArray(_state$previous$get,2),index=_state$previous$get2[0],original=_state$previous$get2[1];return Object.assign({},state,{previous:state.previous.delete(payload),productItems:state.productItems.set(index,original)});})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_2__constants__["i" /* RENAME_PRODUCT */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(function(state,_ref6){var _ref6$payload=_ref6.payload,productId=_ref6$payload.productId,name=_ref6$payload.name;var index=Object(__WEBPACK_IMPORTED_MODULE_6__selectors__["x" /* getProductIndexById */])(state,productId);return Object.assign({},state,{productItems:state.productItems.setIn([index,'state','name'],name)});})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* REMOVE_PRODUCT */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(function(state,_ref7){var id=_ref7.payload.id;return Object.assign({},state,{productItems:state.productItems.filter(function(p){return p.id!==id&&p.parent!==id;})});})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_2__constants__["j" /* RENAME_PRODUCT_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(function(state,_ref8){var _ref8$payload=_ref8.payload,productId=_ref8$payload.productId,name=_ref8$payload.name,zoneId=_ref8$payload.zoneId;var updatedProductItems=state.productItems.map(function(p){return p.getIn(['props','zone'])===zoneId?p.setIn(['state','name'],name).setIn(['state','zoneName'],name):p;});return Object.assign({},state,{productItems:updatedProductItems});})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_2__constants__["h" /* REMOVE_PRODUCT_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_reduce__["a" /* default */])(function(state,_ref9){var _ref9$payload=_ref9.payload,id=_ref9$payload.id,zoneId=_ref9$payload.zoneId;return Object.assign({},state,{productItems:state.productItems.filter(function(p){return p.id!==id&&p.getIn(['props','zone'])!==zoneId;})});})),_reducers);var defaultState={isFetching:false,hasError:false,isLoaded:false,history:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({}),productItems:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([]),previous:Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({})};var productReducers=Object.assign({},reducers,__WEBPACK_IMPORTED_MODULE_3__bulbs___["a" /* default */],__WEBPACK_IMPORTED_MODULE_4__sense___["b" /* productReducers */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux_actions__["b" /* handleActions */])(productReducers,defaultState));

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(258);
var _CHANGE_BRIGHTNESS$TO;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (_CHANGE_BRIGHTNESS$TO={},_defineProperty(_CHANGE_BRIGHTNESS$TO,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* CHANGE_BRIGHTNESS */],Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* undoable */])(function(state,_ref){var _ref$payload=_ref.payload,productId=_ref$payload.productId,brightness=_ref$payload.brightness;try{var index=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["x" /* getProductIndexById */])(state,productId);return Object.assign({},state,{productItems:state.productItems.setIn([index,'isSaving'],true).setIn([index,'state','value'],brightness).setIn([index,'state','brightness'],brightness).setIn([index,'state','status'],'ON')});}catch(e){return state;}})),_defineProperty(_CHANGE_BRIGHTNESS$TO,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* TOGGLE_DONE */],function(state,_ref2){var payload=_ref2.payload;// $FlowFixMe
var index=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["x" /* getProductIndexById */])(state,payload.productId);return Object.assign({},state,{// $FlowFixMe
productItems:state.productItems.setIn([index,'isToggling'],false)});}),_defineProperty(_CHANGE_BRIGHTNESS$TO,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BULB_SAVED */],function(state,_ref3){var payload=_ref3.payload;var index=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["x" /* getProductIndexById */])(state,payload.productId);return Object.assign({},state,{productItems:state.productItems.setIn([index,'isSaving'],false)});}),_defineProperty(_CHANGE_BRIGHTNESS$TO,__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* TOGGLE_LIGHTBULB */],Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* undoable */])(function(state,_ref4){var payload=_ref4.payload;var index=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["x" /* getProductIndexById */])(state,payload.productId);return Object.assign({},state,{productItems:state.productItems.updateIn([index,'state','status'],function(item){return item==='ON'?'OFF':'ON';}).setIn([index,'isToggling'],true)});})),_defineProperty(_CHANGE_BRIGHTNESS$TO,__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* COLOR_CHANGED */],Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* undoable */])(function(state,_ref5){var payload=_ref5.payload;var _payload$hsv=payload.hsv,h=_payload$hsv.h,s=_payload$hsv.s;var index=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["x" /* getProductIndexById */])(state,payload.productId);return payload.isCustomRange?Object.assign({},state,{productItems:state.productItems.setIn([index,'state','colourTemperature'],payload.valueInRange).setIn([index,'isSaving'],true)}):Object.assign({},state,{productItems:state.productItems.withMutations(function(items){return items.setIn([index,'isSaving'],true).setIn([index,'state','hue'],h).setIn([index,'state','saturation'],s);})});})),_defineProperty(_CHANGE_BRIGHTNESS$TO,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_COLOR_MODE */],Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* undoable */])(function(state,_ref6){var _ref6$payload=_ref6.payload,productId=_ref6$payload.productId,mode=_ref6$payload.mode;var index=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["x" /* getProductIndexById */])(state,productId);return Object.assign({},state,{productItems:state.productItems.setIn([index,'state','colourMode'],mode)});})),_CHANGE_BRIGHTNESS$TO);

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(572),
    baseIteratee = __webpack_require__(55),
    baseSome = __webpack_require__(1512),
    isArray = __webpack_require__(32),
    isIterateeCall = __webpack_require__(163);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(196);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(132);


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(666);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('uniq', __webpack_require__(1516), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(442);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(567),
    noop = __webpack_require__(364),
    setToArray = __webpack_require__(289);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('reject', __webpack_require__(1519));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(376),
    baseFilter = __webpack_require__(685),
    baseIteratee = __webpack_require__(55),
    isArray = __webpack_require__(32),
    negate = __webpack_require__(686);

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('negate', __webpack_require__(686), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(383);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('isEmpty', __webpack_require__(1523), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(371),
    getTag = __webpack_require__(288),
    isArguments = __webpack_require__(226),
    isArray = __webpack_require__(32),
    isArrayLike = __webpack_require__(92),
    isBuffer = __webpack_require__(227),
    isPrototype = __webpack_require__(229),
    isTypedArray = __webpack_require__(281);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(555),
    isArrayLike = __webpack_require__(92),
    isString = __webpack_require__(1525),
    toInteger = __webpack_require__(107),
    values = __webpack_require__(688);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(134),
    isArray = __webpack_require__(32),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(376),
    baseFilter = __webpack_require__(685),
    baseIteratee = __webpack_require__(55),
    isArray = __webpack_require__(32);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('defaultTo', __webpack_require__(1529));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1529 */
/***/ (function(module, exports) {

/**
 * Checks `value` to determine whether a default value should be returned in
 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
 * or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.14.0
 * @category Util
 * @param {*} value The value to check.
 * @param {*} defaultValue The default value.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * _.defaultTo(1, 10);
 * // => 1
 *
 * _.defaultTo(undefined, 10);
 * // => 10
 */
function defaultTo(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value;
}

module.exports = defaultTo;


/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_recipes__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_recipes__ = __webpack_require__(133);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var initialState=Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({currentRecipe:null,hasError:false,isFetching:false,isFirstLoadingDone:false,isLoaded:false,modalVisiblePage:null,recipes:{},templates:[]});var normaliseRecipes=function normaliseRecipes(recipes){return recipes?recipes.reduce(function(recipes,recipe){return Object.assign({},recipes,_defineProperty({},recipe.id,{data:recipe,status:__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].DISPLAYING}));},{}):{};};var updateCurrentRecipeConsumerProperties=function updateCurrentRecipeConsumerProperties(state,consumerType,recipe){if(!consumerType){// $FlowFixMe
var templateName=state.getIn(['currentRecipe','name']);// for now we use the 1st consumer type in the list of possible consumers, if in the future there
// will be different properites between types (e.g. difference between lights) then the logic needs
// to be changed (may happen when we get the advance recipes requirements)
consumerType=__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["e" /* templates */][templateName].consumer.types[0];}var consumerPropertiesList=Object(__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["b" /* getConsumerPropertiesList */])(consumerType,// $FlowFixMe
state.getIn(['currentRecipe','consumerPropertiesList']),recipe);// $FlowFixMe
return state.setIn(['currentRecipe','consumerPropertiesList'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(consumerPropertiesList));};var selectRecipe=function selectRecipe(state,recipe,consumerType,isEditingSchedule){var isNotification=recipe.get('consumer')===undefined;// $FlowFixMe
state=state.withMutations(function(s){return s.set('currentRecipe',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({isActive:true,data:recipe,isNotification:isNotification,status:__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].EDITING})).set('modalVisiblePage',isEditingSchedule?2:1);});if(!isNotification){state=updateCurrentRecipeConsumerProperties(state,consumerType,recipe);}return state;};var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ATTEMPT_CREATE_RECIPE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.setIn(['currentRecipe','status'],__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].CREATING);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ATTEMPT_DELETE_RECIPE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref){var recipeId=_ref.payload;return(// $FlowFixMe
state.setIn(['recipes',recipeId,'status'],__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].DELETING));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* ATTEMPT_UPDATE_RECIPE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref2){var recipe=_ref2.payload;// $FlowFixMe
if(state.get('currentRecipe')){// $FlowFixMe
state=state.setIn(['currentRecipe','status'],__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].UPDATING);}// $FlowFixMe
return state.setIn(['recipes',recipe.getIn(['data','id']),'status'],__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].UPDATING);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* CANCEL_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref3){var recipeId=_ref3.payload;return(// $FlowFixMe
state.setIn(['recipes',recipeId,'status'],__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].DISPLAYING));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* CANCEL_TEMPLATE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return(// $FlowFixMe
state.withMutations(function(s){return s.set('currentRecipe',null).set('modalVisiblePage',null);}));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EDIT_RECIPE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref4){var _ref4$payload=_ref4.payload,recipeData=_ref4$payload.recipeData,consumerType=_ref4$payload.consumerType;return selectRecipe(state,recipeData,consumerType);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* EDIT_SCHEDULE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref5){var _ref5$payload=_ref5.payload,recipeData=_ref5$payload.recipeData,consumerType=_ref5$payload.consumerType;return selectRecipe(state,recipeData,consumerType,true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* GET_RECIPES */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('isFetching',true);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* HANDLE_NOTIFICATION_CHANGE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref6){var key=_ref6.payload;var path=['currentRecipe','data','action','value',key];// $FlowFixMe
return state.setIn(path,!state.getIn(path));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* HANDLE_PROPERTY_CHANGE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref7){var _ref7$payload=_ref7.payload,index=_ref7$payload.index,property=_ref7$payload.property,consumerType=_ref7$payload.consumerType;// $FlowFixMe
var propertyIndex=state.getIn(['currentRecipe','consumerPropertiesList']).findIndex(function(p){return p.get('type')===property;});// $FlowFixMe
state=state.setIn(['currentRecipe','consumerPropertiesList',propertyIndex,'selectedIndex'],index);state=updateCurrentRecipeConsumerProperties(state,consumerType);return state.set('currentRecipe',Object(__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["f" /* updateActionsValue */])(state.get('currentRecipe')));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* HIDE_MODAL */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('modalVisiblePage',null);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["l" /* RECEIVE_RECIPES */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref8){var payload=_ref8.payload;return(// $FlowFixMe
state.withMutations(function(state){return state.set('isFetching',false).set('isLoaded',true).set('hasError',false).set('recipes',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(normaliseRecipes(payload.recipes))).set('templates',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(payload.templates));}));},function(state){return(// $FlowFixMe
state.withMutations(function(state){return state.set('isFetching',false).set('isLoaded',true).set('hasError',true).set('recipes',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({})).set('templates',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])([]));}));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* REQUEST_CONFIRM_DELETE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref9){var recipeId=_ref9.payload;return(// $FlowFixMe
state.setIn(['recipes',recipeId,'status'],__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].CONFIRMING));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["n" /* SELECT_CONSUMER */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref10){var consumerId=_ref10.payload;state=updateCurrentRecipeConsumerProperties(state);state=state.set('currentRecipe',Object(__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["f" /* updateActionsValue */])(state.get('currentRecipe')));return state.setIn(['currentRecipe','data','consumer'],consumerId);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["o" /* SELECT_PRODUCER */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref11){var _ref11$payload=_ref11.payload,producerId=_ref11$payload.producerId,specificConsumerId=_ref11$payload.specificConsumerId;// if it has a consumer then the id has to be reset
// $FlowFixMe
if(state.getIn(['currentRecipe','isNotification'])===false){// $FlowFixMe
var template=state.get('templates').find(function(t){return t.get('name')===state.getIn(['currentRecipe','name']);});var consumers=template.get('producers').find(function(p){return p.get('id')===producerId;}).get('consumers');var consumerId=-1;if(specificConsumerId){// this is for when the recipes are displayed in a consumer product page
consumerId=specificConsumerId;}else if(consumers.size===1){// if there is one only one possible consumer then put it as selected by default
consumerId=consumers.get(0);}// if there is a consumerId then get its properties
if(consumerId!==-1){state=updateCurrentRecipeConsumerProperties(state);state=state.set('currentRecipe',Object(__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["f" /* updateActionsValue */])(state.get('currentRecipe')));}// $FlowFixMe
state=state.setIn(['currentRecipe','data','consumer'],consumerId);}// $FlowFixMe
return state.setIn(['currentRecipe','data','producer'],producerId);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["p" /* SELECT_TEMPLATE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref12){var _ref12$payload=_ref12.payload,producerId=_ref12$payload.producerId,templateName=_ref12$payload.templateName,specificConsumerId=_ref12$payload.specificConsumerId;var definition=__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["e" /* templates */][templateName];// $FlowFixMe
var template=state.get('templates').find(function(t){return t.get('name')===templateName;});var isNotification=definition.isNotification===true;var producer=-1;if(producerId){producer=producerId;}else if(template.get('producers').size===1){// if there is one only one possible producer then put it as selected by default
producer=template.getIn(['producers',0,'id']);}// $FlowFixMe
state=state.withMutations(function(s){return s.set('currentRecipe',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({data:{action:template.get('action'),producer:producer,trigger:template.get('trigger')},isActive:definition.producer.active,isNotification:isNotification,name:templateName,status:__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].DEFINING})).set('modalVisiblePage',1);});if(!isNotification){var consumerId=-1;// if there is only one producer check if there is also only one consumer for this producer
if(producer!==-1){if(specificConsumerId){// this is for when the recipes are displayed in a consumer product page
consumerId=specificConsumerId;}else{var consumers=template.get('producers').find(function(p){return p.get('id')===producer;}).get('consumers');// if there is one only one possible consumer then put it as selected by default
if(consumers.size===1){consumerId=consumers.get(0);}}}// if there is a consumerId then get its properties
if(consumerId!==-1){state=updateCurrentRecipeConsumerProperties(state);state=state.set('currentRecipe',Object(__WEBPACK_IMPORTED_MODULE_1__utils_recipes__["f" /* updateActionsValue */])(state.get('currentRecipe')));}state=state.setIn(['currentRecipe','data','consumer'],consumerId);}return state;})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["q" /* SHOW_TEMPLATES_LIST */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){return state.set('modalVisiblePage',0);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["r" /* TOGGLE_SCHEDULE_STATE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state){var path=['currentRecipe','data','scheduled'];// $FlowFixMe
return state.setIn(path,!state.getIn(path));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["s" /* UPDATE_DATA */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref13){var _ref13$payload=_ref13.payload,recipes=_ref13$payload.recipes,templates=_ref13$payload.templates;// $FlowFixMe
return state.withMutations(function(state){return state.set('recipes',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(normaliseRecipes(recipes))).set('templates',Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(templates)).set('currentRecipe',null).set('modalVisiblePage',null);});})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["t" /* UPDATE_RECIPE */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_reduce__["a" /* default */])(function(state,_ref14){var recipeData=_ref14.payload;return(// $FlowFixMe
state.withMutations(function(state){return state.setIn(['recipes',recipeData.id,'status'],__WEBPACK_IMPORTED_MODULE_5__constants_recipes__["c" /* recipeStatus */].DISPLAYING).setIn(['recipes',recipeData.id,'data'],Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(recipeData)).set('modalVisiblePage',null);}));})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_actions__["b" /* handleActions */])(actionHandlers,initialState));

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({// Duration
for:{id:'recipes-duration.for',defaultMessage:'For',description:'"For" from e.g. "For 15 min"'},_30seconds:{id:'recipes-duration._30seconds',defaultMessage:'30 seconds'},_1minute:{id:'recipes-duration._1minute',defaultMessage:'1 minute'},_3minutes:{id:'recipes-duration._3minutes',defaultMessage:'3 minutes'},_5minutes:{id:'recipes-duration._5minutes',defaultMessage:'5 minutes'},_10minutes:{id:'recipes-duration._10minutes',defaultMessage:'10 minutes'},_15minutes:{id:'recipes-duration._15minutes',defaultMessage:'15 minutes'},indefinitely:{id:'recipes-duration.indefintely',defaultMessage:'Indefinitely'},// Change Plug On/Off
plugLabel:{id:'recipes-plug.plug-label',defaultMessage:'Turn',description:'label for the dropdown showing the different states a user can choose for the plugs (on/off)'},plugOn:{id:'recipes-plug.plug-on',defaultMessage:'On',description:'A state of a plug that can be selected in the dropdown'},plugOff:{id:'recipes-plug.plug-off',defaultMessage:'Off',description:'A state of a plug that can be selected in the dropdown'},// Change Light On/Off
lightLabel:{id:'recipes-light.light-label',defaultMessage:'Turn',description:'label for the dropdown showing the different states a user can choose for the lights (on/off)'},lightOn:{id:'recipes-light.light-on',defaultMessage:'On',description:'A state of a light that can be selected in the dropdown'},lightOff:{id:'recipes-light.light-off',defaultMessage:'Off',description:'A state of a light that can be selected in the dropdown'},// Change Heating Mode
heatingModeLabel:{id:'recipes-heating.heating-mode-label',defaultMessage:'Set to',description:'label for the dropdown showing the different heating modes a user can choose'},heatingScheduleMode:{id:'recipes-heating.heating-schedule-mode',defaultMessage:'Schedule',description:'Heating Schedule Mode'},heatingManualMode:{id:'recipes-heating.heating-manual-mode',defaultMessage:'Manual',description:'Heating Manual Mode'},heatingOffMode:{id:'recipes-heating.heating-off-mode',defaultMessage:'Off',description:'Heating Off Mode'},heatingBoostMode:{id:'recipes-heating.heating-boost-mode',defaultMessage:'Boost',description:'Heating Boost Mode'},heatingTargetLabel:{id:'recipes-heating.heating-target-label',defaultMessage:'Set target to',description:'label for the range of temperatures a user can choose'},heatingBoostLabel:{id:'recipes-heating.heating-boost-label',defaultMessage:'For duration',description:'label for the boost duration a user can choose'},heatingBoostDuration030:{id:'recipes-heating.heating-boost-duration-030',defaultMessage:'30 minutes'},heatingBoostDuration1:{id:'recipes-heating.heating-boost-duration-1',defaultMessage:'1 hour'},heatingBoostDuration2:{id:'recipes-heating.heating-boost-duration-2',defaultMessage:'2 hours'},heatingBoostDuration3:{id:'recipes-heating.heating-boost-duration-3',defaultMessage:'3 hours'},heatingBoostDuration4:{id:'recipes-heating.heating-boost-duration-4',defaultMessage:'4 hours'},heatingBoostDuration5:{id:'recipes-heating.heating-boost-duration-5',defaultMessage:'5 hours'},heatingBoostDuration6:{id:'recipes-heating.heating-boost-duration-6',defaultMessage:'6 hours'}}));

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_reduce__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flow__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_filter__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_schedule__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__recipes_constants__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_constants__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_schedule__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_days__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__products_constants__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uuid_v4__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_immutable__ = __webpack_require__(103);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var MIN_EVENTS_PER_DAY=1;var MINIMUM_EVENT_DURATION=15;var MINUTES_IN_DAY=1440;var colourTuneableProps=['colourMode','hue','saturation','status','value'];var tuneableProps=['brightness','colourMode','colourTemperature','status'];var warmWhiteProps=['brightness','status'];var allowedPropsBasedOnType=new Map([[__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["c" /* scheduleType */].COLOUR_TUNEABLE_LIGHT,colourTuneableProps],[__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["c" /* scheduleType */].TUNEABLE_LIGHT,tuneableProps],[__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["c" /* scheduleType */].WARM_WHITE_LIGHT,warmWhiteProps]]);var valueMapper=function valueMapper(type){return function(value){// For tuneable lights we need to set the colourMode to WHITE
// so that if a colour light is added to the group, we still show the
// tuneable portion of the picker when editing an event
// if no colourMode is present on an event, the picker defaults to the colour portion
if(type===__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["c" /* scheduleType */].TUNEABLE_LIGHT){return value.set('colourMode',__WEBPACK_IMPORTED_MODULE_6__constants_devices__["bulbModes"].white);}return value;};};var filterEventValues=function filterEventValues(event){if(event.getIn(['value','status'])===__WEBPACK_IMPORTED_MODULE_6__constants_devices__["deviceModes"].OFF){return event;}var type=event.get('type');type=type===__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["c" /* scheduleType */].COLOUR_TUNEABLE_LIGHT&&event.getIn(['value','colourMode'])===__WEBPACK_IMPORTED_MODULE_6__constants_devices__["bulbModes"].white?__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["c" /* scheduleType */].TUNEABLE_LIGHT:type;var value=event.get('value');var allowedProps=allowedPropsBasedOnType.get(type);if(!allowedProps){return event;}var mapValue=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default()(valueMapper(type),Object(__WEBPACK_IMPORTED_MODULE_16__utils_immutable__["g" /* pick */])(allowedProps));var nextValues=allowedProps?mapValue(value):value;if(type==='warmwhitelight'){event.set('colourMode',__WEBPACK_IMPORTED_MODULE_6__constants_devices__["bulbModes"].white);}return event.set('value',nextValues);};var updateEventStartTime=function updateEventStartTime(daySchedule,newStartTime,eventIndex){return daySchedule.map(function(event,i){var timeStart=new Map([[i===eventIndex,newStartTime],[i<eventIndex,Math.min(event.get('start'),newStartTime-(eventIndex-i)*MINIMUM_EVENT_DURATION)],[i>eventIndex,Math.max(event.get('start'),newStartTime+(i-eventIndex)*MINIMUM_EVENT_DURATION)]]).get(true);return event.set('start',timeStart);});};/**
 * Get the schedule from the component if it exists otherwise get it from the data which the component is linked to.
 * A component only contains a copy of a schedule from the data object if this one has been modified and those
 * modifications are not saved nor undone
 * @param  {Map} 	state       The state of the schedule section
 * @param  {string} componentId The id of the schedule component
 * @return {Map} 	A schedule object
 */var getSchedule=function getSchedule(state,componentId){var dataId=Object(__WEBPACK_IMPORTED_MODULE_5__utils_schedule__["d" /* getDataIdFromComponent */])(componentId);// $FlowFixMe
return state.getIn(['components',componentId,'schedule'],state.getIn(['data',dataId,'schedule']));};// $FlowFixMe
var prepareSchedule=function prepareSchedule(schedule){return schedule.map(function(day){return day.map(function(event){return event.set('guid',__WEBPACK_IMPORTED_MODULE_14_uuid_v4___default()());});});};var updateRecipesSchedule=function updateRecipesSchedule(state,_ref){var error=_ref.error,recipes=_ref.payload.recipes;return error?state:recipes.reduce(function(newState,_ref2){var id=_ref2.id,schedule=_ref2.schedule;if(schedule){schedule=prepareSchedule(Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])(schedule));}return newState.setIn(['data',id],Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])({schedule:schedule,scheduleType:__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["c" /* scheduleType */].RECIPE}));},state);};var updateAction=Object(__WEBPACK_IMPORTED_MODULE_15__handle_reduce__["a" /* default */])(function(state,_ref3){var action=_ref3.payload;var scheduleEvent=action.events.find(function(event){return event.type==='schedule';});return scheduleEvent?// $FlowFixMe
state.setIn(['data',action.id,'schedule'],__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default()(prepareSchedule,__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])(scheduleEvent.settings.schedule)):state;});var initialState=Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])({components:{},data:{}});var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ADD_EVENT */],function(state,_ref4){var _ref4$payload=_ref4.payload,componentId=_ref4$payload.componentId,defaultEventValue=_ref4$payload.defaultEventValue,eventToSplit=_ref4$payload.eventToSplit,maxEvents=_ref4$payload.maxEvents;var schedule=getSchedule(state,componentId);// $FlowFixMe
var selectedDay=state.getIn(['components',componentId,'selectedDay']);var daySchedule=schedule.get(__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][selectedDay]);// check the number of events in the selected day
if(daySchedule.size>=maxEvents){return state;}var nextEventIndex=eventToSplit.get('dayIndex')===selectedDay?eventToSplit.get('eventIndex')+1:0;var nextEventTime=daySchedule.getIn([nextEventIndex,'start'],MINUTES_IN_DAY);// check that the event can be split
if(nextEventIndex===0?nextEventTime<MINIMUM_EVENT_DURATION:nextEventTime-eventToSplit.get('start')<2*MINIMUM_EVENT_DURATION){return state;}var splitTime=nextEventTime-MINIMUM_EVENT_DURATION;daySchedule=daySchedule.insert(nextEventIndex,Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])({guid:__WEBPACK_IMPORTED_MODULE_14_uuid_v4___default()(),start:splitTime,value:defaultEventValue?Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])(defaultEventValue):eventToSplit.get('value')}));schedule=schedule.set(__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][selectedDay],daySchedule);// $FlowFixMe
return state.setIn(['components',componentId,'schedule'],schedule);}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ADD_SCHEDULE_DATA */],function(state,_ref5){var _ref5$payload=_ref5.payload,dataId=_ref5$payload.dataId,schedule=_ref5$payload.schedule,scheduleType=_ref5$payload.scheduleType;// add a guid to each event for animation purpose
schedule=prepareSchedule(schedule);// $FlowFixMe
return state.setIn(['data',dataId],Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])({schedule:schedule,scheduleType:scheduleType}));}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* ATTEMPT_SAVE_SCHEDULE */],function(state,_ref6){var componentId=_ref6.payload.componentId;return(// $FlowFixMe
state.setIn(['components',componentId,'isSavingSchedule'],true));}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* CANCEL_SAVE_SCHEDULE */],function(state,_ref7){var componentId=_ref7.payload.componentId;return(// $FlowFixMe
state.setIn(['components',componentId,'isSavingSchedule'],false));}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["e" /* CHANGE_MODE */],function(state,_ref8){var _ref8$payload=_ref8.payload,componentId=_ref8$payload.componentId,scheduleMode=_ref8$payload.scheduleMode;var path=['components',componentId,'scheduleMode'];// $FlowFixMe
var current=state.getIn(path);// $FlowFixMe
return state.withMutations(function(s){var newMode=scheduleMode===current?__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["b" /* scheduleModesEnum */].DEFAULT:scheduleMode;s=s.setIn(path,newMode).setIn(['components',componentId,'selectedEvent'],null);s=newMode===__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["b" /* scheduleModesEnum */].COPY_DAY?s.setIn(['components',componentId,'selectedDay'],null):s.setIn(['components',componentId,'copyDay'],null);return s;});}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["f" /* COMPLETE_SAVE_SCHEDULE */],function(state,_ref9){var componentId=_ref9.payload.componentId;var dataId=Object(__WEBPACK_IMPORTED_MODULE_5__utils_schedule__["d" /* getDataIdFromComponent */])(componentId);// $FlowFixMe
var currentDataSchedule=state.getIn(['data',dataId,'schedule']);// $FlowFixMe
return state.withMutations(function(map){return map.setIn(['data',dataId,'schedule'],// $FlowFixMe
state.getIn(['components',componentId,'schedule'])||currentDataSchedule).deleteIn(['components',componentId,'schedule']).setIn(['components',componentId,'isSavingSchedule'],false).setIn(['components',componentId,'copyDay'],null).setIn(['components',componentId,'scheduleMode'],__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["b" /* scheduleModesEnum */].DEFAULT).setIn(['components',componentId,'showingPopup'],false).setIn(['components',componentId,'selectedEvent'],null).setIn(['components',componentId,'selectedDay'],null);});}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["g" /* COPY_DAY_EVENTS */],function(state,_ref10){var _ref10$payload=_ref10.payload,componentId=_ref10$payload.componentId,dayIndex=_ref10$payload.dayIndex;var path=['components',componentId,'copyDay'];// $FlowFixMe
var copyDay=state.getIn(path,null);if(copyDay===null){// $FlowFixMe
return state.setIn(path,Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])({dayToCopy:dayIndex,copyToList:[]}));}else if(copyDay.get('dayToCopy')===dayIndex){// deselect the day to be copied
// $FlowFixMe
return state.deleteIn(path);}else if(!copyDay.get('copyToList').includes(dayIndex)){var schedule=getSchedule(state,componentId);// get the events from the day to copy and apply a new guid
var copyDaySchedule=schedule.get(__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][copyDay.get('dayToCopy')]).map(function(event){return event.set('guid',__WEBPACK_IMPORTED_MODULE_14_uuid_v4___default()());});// get the events of the day being overwritten so we can store and undo if neccessary
var dayCopyingToSchedule=schedule.get(__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][dayIndex]);// $FlowFixMe
return state.withMutations(function(s){return s.setIn(['components',componentId,'schedule'],schedule.set(__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][dayIndex],copyDaySchedule)).setIn(path,copyDay.set('copyToList',copyDay.get('copyToList').push(dayIndex))).setIn([].concat(path,['copyToListOriginalEvents',__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][dayIndex]]),dayCopyingToSchedule);});}else if(copyDay.get('copyToList').includes(dayIndex)){// $FlowFixMe
var originalDayEvents=state.getIn([].concat(path,['copyToListOriginalEvents',__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][dayIndex]]));// $FlowFixMe
var indexInList=state.getIn([].concat(path,['copyToList'])).indexOf(dayIndex);// $FlowFixMe
return state.withMutations(function(s){return s.setIn(['components',componentId,'schedule',__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][dayIndex]],originalDayEvents).deleteIn([].concat(path,['copyToList',indexInList])).deleteIn([].concat(path,['copyToListOriginalEvents',__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][dayIndex]]));});}return state;}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* DELETE_EVENT */],function(state,_ref11){var _ref11$payload=_ref11.payload,componentId=_ref11$payload.componentId,eventToDelete=_ref11$payload.eventToDelete;var schedule=getSchedule(state,componentId);// $FlowFixMe
var selectedDay=state.getIn(['components',componentId,'selectedDay']);// Do not allow to delete the event that started the day before
if(eventToDelete.get('dayIndex')!==selectedDay){return state;}var daySchedule=schedule.get(__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][selectedDay]);// check the number of events in the selected day
if(daySchedule.size<=MIN_EVENTS_PER_DAY){return state;}daySchedule=daySchedule.delete(eventToDelete.get('eventIndex'));schedule=schedule.set(__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][selectedDay],daySchedule);// $FlowFixMe
return state.setIn(['components',componentId,'schedule'],schedule);}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["i" /* DESELECT_SCHEDULE_DAY */],function(state,_ref12){var componentId=_ref12.payload.componentId;return(// $FlowFixMe
state.setIn(['components',componentId,'showingPopup'],false).setIn(['components',componentId,'selectedDay'],null));}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* HIDE_POPUP */],function(state,_ref13){var componentId=_ref13.payload.componentId;return(// $FlowFixMe
state.setIn(['components',componentId,'showingPopup'],false));}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_13__products_constants__["f" /* RECEIVE_PRODUCTS */],function(state,_ref14){var error=_ref14.error,payload=_ref14.payload;if(error){return state;}return __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flow___default()(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_filter___default()(function(product){return product.state.schedule;}),__WEBPACK_IMPORTED_MODULE_0_lodash_fp_reduce___default()(function(newState,product){var schedule=prepareSchedule(Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])(product.state.schedule));return newState.setIn(['data',product.id],Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])({schedule:schedule,scheduleType:Object(__WEBPACK_IMPORTED_MODULE_5__utils_schedule__["e" /* getScheduleType */])(product)}));},state))(payload.products);}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_7__recipes_constants__["l" /* RECEIVE_RECIPES */],updateRecipesSchedule),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["k" /* OVERRIDE_SCHEDULE */],function(state,_ref15){var _ref15$payload=_ref15.payload,componentId=_ref15$payload.componentId,schedule=_ref15$payload.schedule,scheduleType=_ref15$payload.scheduleType;var dataId=Object(__WEBPACK_IMPORTED_MODULE_5__utils_schedule__["d" /* getDataIdFromComponent */])(componentId);// $FlowFixMe
return state.withMutations(function(map){return map.setIn(['data',dataId,'schedule'],prepareSchedule(schedule)).setIn(['data',dataId,'scheduleType'],scheduleType).deleteIn(['components',componentId,'schedule']);});}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["l" /* RESET_SCHEDULE */],function(state,_ref16){var _ref16$payload=_ref16.payload,componentId=_ref16$payload.componentId,defaultSchedule=_ref16$payload.defaultSchedule;return(// $FlowFixMe
state.mergeIn(['components',componentId],{copyDay:null,// $FlowFixMe
schedule:Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])(defaultSchedule).map(function(day){return day.map(function(event){return event.set('guid',__WEBPACK_IMPORTED_MODULE_14_uuid_v4___default()());});}),selectedEvent:null,selectedDay:null,scheduleMode:__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["b" /* scheduleModesEnum */].DEFAULT,showingPopup:false}));}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* SELECT_DAY */],function(state,_ref17){var _ref17$payload=_ref17.payload,componentId=_ref17$payload.componentId,dayIndex=_ref17$payload.dayIndex;var path=['components',componentId,'selectedDay'];// $FlowFixMe
var currentDayIndex=state.getIn(path);var isColapsing=currentDayIndex!=null;if(isColapsing){// $FlowFixMe
state=state.setIn(['components',componentId,'selectedEvent'],null);}// $FlowFixMe
return state.setIn(path,isColapsing?null:dayIndex);}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["n" /* SELECT_EVENT */],function(state,_ref18){var _ref18$payload=_ref18.payload,componentId=_ref18$payload.componentId,event=_ref18$payload.event;return(// $FlowFixMe
state.setIn(['components',componentId,'selectedEvent'],event));}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["p" /* SHOW_POPUP */],function(state,_ref19){var componentId=_ref19.payload.componentId;return(// $FlowFixMe
state.setIn(['components',componentId,'showingPopup'],true));}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* UNDO_ALL */],function(state,_ref20){var componentId=_ref20.payload.componentId;return(// $FlowFixMe
state.mergeIn(['components',componentId],{copyDay:null,scheduleMode:__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["b" /* scheduleModesEnum */].DEFAULT,selectedEvent:null,selectedDay:null,showingPopup:false}).deleteIn(['components',componentId,'schedule']));}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["s" /* UPDATE_EVENT_START */],function(state,_ref21){var _ref21$payload=_ref21.payload,componentId=_ref21$payload.componentId,dayIndex=_ref21$payload.dayIndex,eventIndex=_ref21$payload.eventIndex,newStartTime=_ref21$payload.newStartTime;var schedule=getSchedule(state,componentId);var daySchedule=schedule.get(__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][dayIndex]);daySchedule=updateEventStartTime(daySchedule,newStartTime,eventIndex);schedule=schedule.set(__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][dayIndex],daySchedule);// $FlowFixMe
return state.withMutations(function(s){return s.setIn(['components',componentId,'schedule'],schedule).setIn(['components',componentId,'selectedEvent','start'],newStartTime);});}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["r" /* UPDATE_DAILY_START_TIMES */],function(state,_ref22){var _ref22$payload=_ref22.payload,componentId=_ref22$payload.componentId,timeDifference=_ref22$payload.timeDifference;var oldSchedule=getSchedule(state,componentId);var days=__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */].slice(1);var newSchedule=days.reduce(function(schedule,day){var oldDaySchedule=schedule.get(day);var newStartTime=Math.max(oldDaySchedule.first().get('start')+timeDifference,0);var newDaySchedule=updateEventStartTime(oldDaySchedule,newStartTime,0);return schedule.set(day,newDaySchedule);},oldSchedule);// $FlowFixMe
return state.withMutations(function(s){return s.setIn(['components',componentId,'schedule'],newSchedule);});}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["t" /* UPDATE_EVENT_VALUE */],function(state,_ref23){var _ref23$payload=_ref23.payload,componentId=_ref23$payload.componentId,updatedEvent=_ref23$payload.updatedEvent;var nextUpdatedEvent=filterEventValues(updatedEvent);var schedule=getSchedule(state,componentId);schedule=schedule.setIn([__WEBPACK_IMPORTED_MODULE_12__constants_days__["a" /* listDays */][updatedEvent.get('dayIndex')],updatedEvent.get('eventIndex')],nextUpdatedEvent);// $FlowFixMe
return state.withMutations(function(s){return s.setIn(['components',componentId,'schedule'],schedule).setIn(['components',componentId,'selectedEvent'],nextUpdatedEvent);});}),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_7__recipes_constants__["s" /* UPDATE_DATA */],updateRecipesSchedule),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_8__actions_constants__["o" /* RECEIVE_ACTIONS */],Object(__WEBPACK_IMPORTED_MODULE_15__handle_reduce__["a" /* default */])(function(state,_ref24// $FlowFixMe
){var actions=_ref24.payload;return actions.reduce(function(newState,action){var scheduleEvent=action.events.find(function(event){return event.type==='schedule';});return scheduleEvent?// $FlowFixMe
newState.setIn(['data',action.id],Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])({// $FlowFixMe
schedule:__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default()(prepareSchedule,__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])(scheduleEvent.settings.schedule),scheduleType:__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["c" /* scheduleType */].RECIPE})):newState;},state);})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_4__constants__["o" /* SETUP_ACTION_FORM_SCHEDULE */],Object(__WEBPACK_IMPORTED_MODULE_15__handle_reduce__["a" /* default */])(function(state,_ref25){var _ref25$payload=_ref25.payload,defaultSchedule=_ref25$payload.defaultSchedule,schedule=_ref25$payload.schedule;// $FlowFixMe
return state.deleteIn(['components',__WEBPACK_IMPORTED_MODULE_5__utils_schedule__["a" /* actionFormComponentId */]]).setIn(['data',__WEBPACK_IMPORTED_MODULE_5__utils_schedule__["b" /* actionFormDataId */]],Object(__WEBPACK_IMPORTED_MODULE_10_immutable__["fromJS"])({schedule:schedule||prepareSchedule(defaultSchedule),scheduleType:__WEBPACK_IMPORTED_MODULE_9__constants_schedule__["c" /* scheduleType */].RECIPE}));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_8__actions_constants__["g" /* EDIT_ACTION */],updateAction),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_8__actions_constants__["i" /* END_ATTEMPT_CREATE_ACTION */],updateAction),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_redux_actions__["b" /* handleActions */])(actionHandlers,initialState));

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(577),
    castSlice = __webpack_require__(691),
    hasUnicode = __webpack_require__(692),
    isIterateeCall = __webpack_require__(163),
    isRegExp = __webpack_require__(1534),
    stringToArray = __webpack_require__(1536),
    toString = __webpack_require__(190);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(1535),
    baseUnary = __webpack_require__(228),
    nodeUtil = __webpack_require__(560);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(134),
    isObjectLike = __webpack_require__(91);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1537),
    hasUnicode = __webpack_require__(692),
    unicodeToArray = __webpack_require__(1538);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 1537 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1538 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(694);
var bytesToUuid = __webpack_require__(695);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({modal:__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NONE */],type:null,id:null,setting:null});var actionHandlers=new Map([[__WEBPACK_IMPORTED_MODULE_2__actions__["e" /* openSettingsModal */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;if(payload.modal===__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* PRIMARY */]){// $FlowFixMe
return state.withMutations(function(state){return state.set('modal',__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* PRIMARY */]).set('type',payload.type).set('id',payload.id).set('props',payload.props);});}if(payload.modal===__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* SECONDARY */]){// $FlowFixMe
return state.withMutations(function(state){return state.set('modal',__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* SECONDARY */]).set('setting',payload.setting);});}return initialState;})],[__WEBPACK_IMPORTED_MODULE_2__actions__["d" /* closeSettingsModal */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref2){var payload=_ref2.payload;if(payload.modal===__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* PRIMARY */]){// $FlowFixMe
return state.withMutations(function(state){return state.set('modal',__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* NONE */]).set('type',null).set('id',null).set('setting',null);});}if(payload.modal===__WEBPACK_IMPORTED_MODULE_2__actions__["c" /* SECONDARY */]){// $FlowFixMe
return state.set('modal',__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* PRIMARY */]);}return initialState;})]]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])(actionHandlers,initialState));

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _handleActions;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])((_handleActions={},_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* RECEIVED_SERVER_ERRORS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;return state.set('server_errors',payload);})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* FORM_INITIALIZE */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.set('loading',false);})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* SAVE_CONTACTS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return state.merge({saving:true,hasError:false});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* SAVED_CONTACTS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref2){var _ref2$payload=_ref2.payload,_ref2$payload$addedCo=_ref2$payload.addedContacts,addedContacts=_ref2$payload$addedCo===undefined?[]:_ref2$payload$addedCo,_ref2$payload$updated=_ref2$payload.updatedContacts,updatedContacts=_ref2$payload$updated===undefined?[]:_ref2$payload$updated;return(// $FlowFixMe
state.set('contacts',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([].concat(_toConsumableArray(updatedContacts),_toConsumableArray(addedContacts)))).set('saving',false));},// $FlowFixMe
function(state){return state.merge({saving:false,hasError:true});})),_defineProperty(_handleActions,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* RECEIVED_CONTACTS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref3){var payload=_ref3.payload;return(// $FlowFixMe
state.set('loading',false).set('contacts',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload)));})),_handleActions),Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({saving:false,loading:true,hasError:false,contacts:[]})));

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_reduce__ = __webpack_require__(17);
var _actionHandlers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var actionHandlers=(_actionHandlers={},_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ATTEMPT_LOAD_TRANSLATIONS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state){return(// $FlowFixMe
state.withMutations(function(map){return map.set('loading',true).set('error',false);}));})),_defineProperty(_actionHandlers,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* LOAD_TRANSLATIONS */],Object(__WEBPACK_IMPORTED_MODULE_3__handle_reduce__["a" /* default */])(function(state,_ref){var translations=_ref.payload;return(// $FlowFixMe
state.withMutations(function(map){return map.set('translations',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(translations)).set('loading',false);}));},// $FlowFixMe
function(state){return state.withMutations(function(map){return map.set('error',true).set('loading',false);});})),_actionHandlers);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_actions__["b" /* handleActions */])(actionHandlers,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({loading:true})));

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__products_constants__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recipes_constants__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__weather_constants__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__devices_constants__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hub_constants__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__holiday_mode_constants__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__notifications_constants__ = __webpack_require__(316);
// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])({});var action=arguments[1];var nextState=state;switch(action.type){case __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ANALYTICS_SHARING_TOGGLED */]:nextState=Object(__WEBPACK_IMPORTED_MODULE_7__handle_reduce__["a" /* default */])(function(){return(// SENSEDO PASS RESPONSE FROM API
state.setIn(['media','allowAnalyticsSharing'],!state.getIn(['media','allowAnalyticsSharing'])));})(state,action);break;case __WEBPACK_IMPORTED_MODULE_9__application_actions__["h" /* logIn */].toString():nextState=Object(__WEBPACK_IMPORTED_MODULE_7__handle_reduce__["a" /* default */])(function(){return state.set('userDetails',Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(action.payload.user)).set('alerts',Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(action.payload.alerts)).set('media',Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(action.payload.media));})(state,action);break;case __WEBPACK_IMPORTED_MODULE_4__constants__["b" /* PIN_SET */]:nextState=Object(__WEBPACK_IMPORTED_MODULE_7__handle_reduce__["a" /* default */])(function(){return state.withMutations(function(state){return state.set('settingPin',false).set('settingPinError',false);});})(state,action);break;case __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* RESET_PIN_ERROR */]:nextState=Object(__WEBPACK_IMPORTED_MODULE_7__handle_reduce__["a" /* default */])(function(){return state.set('settingPinError',false);})(state,action);break;case __WEBPACK_IMPORTED_MODULE_10__notifications_constants__["e" /* SAVE_NOTIFICATIONS */]:nextState=Object(__WEBPACK_IMPORTED_MODULE_7__handle_reduce__["a" /* default */])(function(){return state.setIn(['alerts','warningsEmail'],action.payload.warningsEnabled);})(state,action);break;case __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* SETTING_PIN */]:nextState=Object(__WEBPACK_IMPORTED_MODULE_7__handle_reduce__["a" /* default */])(function(){return state.withMutations(function(state){return state.set('settingPin',true).set('settingPinError',false);});},function(){return state.withMutations(function(state){return state.set('settingPin',false).set('settingPinError',true);});})(state,action);break;default:break;}var blacklistedActionTypes=[__WEBPACK_IMPORTED_MODULE_5__hub_constants__["a" /* DATE_TIME_INTERVAL */],__WEBPACK_IMPORTED_MODULE_0__products_constants__["a" /* GET_PRODUCTS */],__WEBPACK_IMPORTED_MODULE_1__recipes_constants__["h" /* GET_RECIPES */],__WEBPACK_IMPORTED_MODULE_2__weather_constants__["a" /* GET_WEATHER */],__WEBPACK_IMPORTED_MODULE_8__holiday_mode_constants__["f" /* INITIALIZE_STATE */],__WEBPACK_IMPORTED_MODULE_3__devices_constants__["a" /* LOAD_DEVICES */],__WEBPACK_IMPORTED_MODULE_3__devices_constants__["d" /* RECEIVE_DEVICES */],__WEBPACK_IMPORTED_MODULE_0__products_constants__["f" /* RECEIVE_PRODUCTS */],__WEBPACK_IMPORTED_MODULE_1__recipes_constants__["l" /* RECEIVE_RECIPES */],__WEBPACK_IMPORTED_MODULE_2__weather_constants__["b" /* RECEIVED_WEATHER */],__WEBPACK_IMPORTED_MODULE_3__devices_constants__["o" /* REQUEST_DEVICES */]];if(!blacklistedActionTypes.includes(action.type)&&action.meta&&action.meta.activityStamp){nextState=nextState.set('lastActivity',action.meta.activityStamp);}return nextState;});

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(317);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({icon:'',description:'',temperature:{}});var reducers=_defineProperty({},__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* RECEIVED_WEATHER */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state,_ref){var payload=_ref.payload;return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(payload.weather);}));/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["b" /* handleActions */])(reducers,defaultState));

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reducers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handle_reduce__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(450);
var _reducers;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var reducers=(_reducers={},_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* CHECK_SERVICE_OUTAGE_STATUS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return state.set('isFetching',true);})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* RECEIVE_SERVICE_OUTAGE_STATUS */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(// $FlowFixMe
function(state,_ref){var payload=_ref.payload;return(// $FlowFixMe
state.withMutations(function(state){return state.set('isFetching',false).set('isLoaded',true).set('hasError',false).set('payload',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload)).set('showServiceOutage',true);}));},function(state){return(// $FlowFixMe
state.withMutations(function(state){return state.set('isFetching',false).set('isLoaded',true).set('hasError',true).set('payload',Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({})).set('showServiceOutage',false);}));})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SHOW_ALERT_NOTIFICATION */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return state.set('showServiceOutage',true);})),_defineProperty(_reducers,__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* HIDE_ALERT_NOTIFICATION */],Object(__WEBPACK_IMPORTED_MODULE_2__handle_reduce__["a" /* default */])(function(state){return state.set('showServiceOutage',false);})),_reducers);var defaultState=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({isFetching:false,hasError:false,isLoaded:false,showServiceOutage:false,payload:{}});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])(reducers,defaultState));

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(697);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(202);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(202);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(74);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(74);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* unused harmony reexport is */
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(168);
/* unused harmony reexport asEffect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(698);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();// @noflow
var trackersMap=Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({});var createMiddleware=function createMiddleware(satellite,myData){return function(store){return function(next){return function(action){var type=action.type,payload=action.payload;var handlers=trackersMap.get(type);var state=store.getState();var dispatch=store.dispatch;var params=[payload,state,dispatch];if(!satellite||!handlers){return next(action);}handlers.forEach(function(handler){var condition=handler.get('condition',function(){return true;});var event=handler.get('event',__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default.a).apply(undefined,params);var values=handler.get('values',__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default.a);if(!condition.apply(undefined,params)){return;}satellite.data.customVars={};var valuesToMap=values.apply(undefined,params)||{};Object.entries(valuesToMap).forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),k=_ref2[0],v=_ref2[1];return satellite.setVar(k,v);});satellite.track(event);});return next(action);};};};};createMiddleware.registerTrackers=function(trackers){return trackers.forEach(function(tracker){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.entries(tracker)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _ref3=_step.value;var _ref4=_slicedToArray(_ref3,2);var k=_ref4[0];var v=_ref4[1];var nextValue=trackersMap.get(k,Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());trackersMap=trackersMap.set(k,nextValue.merge(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(v)));}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}});};/* harmony default export */ __webpack_exports__["a"] = (createMiddleware);

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('flatten', __webpack_require__(579), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTemplates */
/* unused harmony export getListActions */
/* unused harmony export attemptCreateHiveAction */
/* unused harmony export attemptEditAction */
/* unused harmony export attemptRemoveAction */
/* unused harmony export attemptTriggerQuickAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__honeycomb_actions__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants_alerts__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_errors__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__dashboard_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__dashboard_selectors__ = __webpack_require__(260);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getTemplates),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetTemplates),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getListActions),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetActions),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attemptCreateHiveAction),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchCreateAction),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attemptEditAction),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchEditAction),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attemptRemoveAction),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchRemoveAction),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attemptTriggerQuickAction),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchTriggerQuickAction);/*********************
 *   GET TEMPLATES   *
 *********************/function getTemplates(){var templatesVersion,_ref,_ref2,_ref2$,response,error,is404;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getTemplates$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__config_selectors__["a" /* getConfig */],'actions:templatesVersion');case 2:templatesVersion=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__api__["a" /* actions */].getTemplates),templatesVersion);case 5:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);_ref2$=_ref2[0];response=_ref2$===undefined?{}:_ref2$;error=_ref2[1];is404=error&&error.status===404;_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["n" /* receiveTemplates */])(error?is404?response:error:response));case 13:case'end':return _context.stop();}}},_marked,this);}function watchGetTemplates(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetTemplates$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_8__constants__["l" /* GET_TEMPLATES */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_saga__["a" /* default */])(getTemplates));case 2:case'end':return _context2.stop();}}},_marked2,this);}/*******************
 *   GET ACTIONS   *
 *******************/function getListActions(){var _ref3,_ref4,_ref4$,response,error,is404;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getListActions$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__api__["a" /* actions */].getActions));case 2:_ref3=_context3.sent;_ref4=_slicedToArray(_ref3,2);_ref4$=_ref4[0];response=_ref4$===undefined?{}:_ref4$;error=_ref4[1];is404=error&&error.status===404;_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["m" /* receiveActions */])(error?is404?response:error:response));case 10:case'end':return _context3.stop();}}},_marked3,this);}function watchGetActions(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetActions$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_8__constants__["k" /* GET_ACTIONS */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_saga__["a" /* default */])(getListActions));case 2:case'end':return _context4.stop();}}},_marked4,this);}/*********************
 *   CREATE ACTION   *
 *********************/function attemptCreateHiveAction(_ref5){var action=_ref5.payload;var _ref6,_ref7,response,error,pollId,hubTime,timeZone,now;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attemptCreateHiveAction$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__api__["a" /* actions */].createHiveAction),action);case 2:_ref6=_context5.sent;_ref7=_slicedToArray(_ref6,2);response=_ref7[0];error=_ref7[1];if(!error){_context5.next=10;break;}_context5.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["h" /* endAttempt */])(error));case 9:return _context5.abrupt('return');case 10:pollId=response.poll;_context5.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__hub_selectors__["b" /* getCurrentTime */]);case 13:hubTime=_context5.sent;_context5.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__hub_selectors__["k" /* getTimezone */]);case 16:timeZone=_context5.sent;now=__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz(hubTime,timeZone).valueOf();_context5.next=20;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__honeycomb_actions__["a" /* pollNodeExists */])({id:pollId,nextAction:Object(__WEBPACK_IMPORTED_MODULE_9__actions__["l" /* makeEndAttemptCreateAction */])({newAction:action,created:now})}));case 20:case'end':return _context5.stop();}}},_marked5,this);}function watchCreateAction(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchCreateAction$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_8__constants__["b" /* ATTEMPT_CREATE_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_saga__["a" /* default */])(attemptCreateHiveAction));case 2:case'end':return _context6.stop();}}},_marked6,this);}/*********************
 *   EDIT ACTION   *
 *********************/function attemptEditAction(_ref8){var action=_ref8.payload;var _ref9,_ref10,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attemptEditAction$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(action){_context7.next=4;break;}_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["h" /* endAttempt */])(new Error('Error: No action to be edited')));case 3:return _context7.abrupt('return');case 4:_context7.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__api__["a" /* actions */].editAction),action,action.id);case 6:_ref9=_context7.sent;_ref10=_slicedToArray(_ref9,2);error=_ref10[1];if(!error){_context7.next=15;break;}_context7.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["h" /* endAttempt */])(error));case 12:_context7.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_14__constants_errors__["a" /* generalErrorMessages */].tryAgain,__WEBPACK_IMPORTED_MODULE_13__constants_alerts__["types"].ERROR));case 14:return _context7.abrupt('return');case 15:_context7.next=17;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["h" /* endAttempt */])());case 17:_context7.next=19;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["g" /* editAction */])(action));case 19:case'end':return _context7.stop();}}},_marked7,this);}function watchEditAction(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchEditAction$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* ATTEMPT_EDIT_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_saga__["a" /* default */])(attemptEditAction));case 2:case'end':return _context8.stop();}}},_marked8,this);}/*********************
 *   REMOVE ACTION   *
 *********************/function attemptRemoveAction(_ref11){var actionId=_ref11.payload;var _ref12,_ref13,error,deleteFromDashboard,existsOnDashboard;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attemptRemoveAction$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__api__["a" /* actions */].removeAction),actionId);case 2:_ref12=_context9.sent;_ref13=_slicedToArray(_ref12,2);error=_ref13[1];if(!error){_context9.next=13;break;}_context9.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["h" /* endAttempt */])(error));case 8:_context9.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["p" /* removeActionFromDeleteList */])(actionId));case 10:_context9.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_14__constants_errors__["a" /* generalErrorMessages */].tryAgain,__WEBPACK_IMPORTED_MODULE_13__constants_alerts__["types"].ERROR));case 12:return _context9.abrupt('return');case 13:_context9.next=15;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_15__selectors__["n" /* isQuickAction */],{actionId:actionId});case 15:deleteFromDashboard=_context9.sent;if(!deleteFromDashboard){_context9.next=25;break;}_context9.next=19;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_17__dashboard_selectors__["e" /* getDashboardItemPositionById */],{id:actionId});case 19:existsOnDashboard=_context9.sent;if(!existsOnDashboard){_context9.next=25;break;}_context9.next=23;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__dashboard_actions__["i" /* dashboardRemoveProducts */])({ids:[actionId]}));case 23:_context9.next=25;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__dashboard_actions__["o" /* saveDashboardEdit */])());case 25:_context9.next=27;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["h" /* endAttempt */])());case 27:_context9.next=29;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["p" /* removeActionFromDeleteList */])(actionId));case 29:_context9.next=31;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["q" /* removeActionFromList */])(actionId));case 31:case'end':return _context9.stop();}}},_marked9,this);}function watchRemoveAction(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchRemoveAction$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_8__constants__["d" /* ATTEMPT_REMOVE_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_saga__["a" /* default */])(attemptRemoveAction));case 2:case'end':return _context10.stop();}}},_marked10,this);}function attemptTriggerQuickAction(_ref14){var actionId=_ref14.payload;var _ref15,_ref16,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attemptTriggerQuickAction$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__api__["a" /* actions */].triggerQuickAction),actionId);case 2:_ref15=_context11.sent;_ref16=_slicedToArray(_ref15,2);error=_ref16[1];if(!error){_context11.next=11;break;}_context11.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["u" /* triggerQuickAction */])(new Error(actionId)));case 8:_context11.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_14__constants_errors__["a" /* generalErrorMessages */].tryAgain,__WEBPACK_IMPORTED_MODULE_13__constants_alerts__["types"].ERROR));case 10:return _context11.abrupt('return');case 11:_context11.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["u" /* triggerQuickAction */])(actionId));case 13:case'end':return _context11.stop();}}},_marked11,this);}function watchTriggerQuickAction(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchTriggerQuickAction$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* ATTEMPT_TRIGGER_QUICK_ACTION */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_saga__["a" /* default */])(attemptTriggerQuickAction));case 2:case'end':return _context12.stop();}}},_marked12,this);}/*********************//* harmony default export */ __webpack_exports__["a"] = ([watchCreateAction,watchEditAction,watchGetActions,watchGetTemplates,watchRemoveAction,watchTriggerQuickAction]);

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('head', __webpack_require__(1555), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1555 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAllCookies; });
/* unused harmony export getCookie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_selectors__ = __webpack_require__(60);
var getAllCookies=function getAllCookies(state){return state.cookies;};var getCookieKeyFromProps=function getCookieKeyFromProps(_,key){return key;};var getCookie=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(getAllCookies,__WEBPACK_IMPORTED_MODULE_2__user_selectors__["i" /* getUserId */],getCookieKeyFromProps,function(cookies,id,key){return cookies&&cookies.get(id+'-'+key);});

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('toLower', __webpack_require__(1558), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(190);

/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return toString(value).toLowerCase();
}

module.exports = toLower;


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('join', __webpack_require__(1560));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1560 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

module.exports = join;


/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_button__ = __webpack_require__(1562);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__action_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__appliance__ = __webpack_require__(1563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__appliance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__boiler_module_slr1__ = __webpack_require__(1564);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__boiler_module_slr1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boiler_module_slr2__ = __webpack_require__(1565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__boiler_module_slr2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_off__ = __webpack_require__(1566);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__button_off__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__camera_deharo__ = __webpack_require__(1567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__camera_deharo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__camera_off__ = __webpack_require__(1568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__camera_off__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colour_picker__ = __webpack_require__(1569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__colour_picker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cooling__ = __webpack_require__(1570);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__cooling__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__door_sensor_closed__ = __webpack_require__(1571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__door_sensor_closed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__double_tap__ = __webpack_require__(1572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__double_tap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__duo_socket_eu__ = __webpack_require__(1573);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__duo_socket_eu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__duo_socket_in__ = __webpack_require__(1574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__duo_socket_in__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__duo_socket_na__ = __webpack_require__(1575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__duo_socket_na__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__duo_socket_uk__ = __webpack_require__(1576);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__duo_socket_uk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fan_off__ = __webpack_require__(1577);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__fan_off__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fan_on__ = __webpack_require__(1578);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__fan_on__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__flame_na__ = __webpack_require__(1579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__flame_na__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generic_temp__ = __webpack_require__(1580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__generic_temp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__heating__ = __webpack_require__(1581);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__heating__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__hive_button__ = __webpack_require__(1582);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_20__hive_button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hot_water__ = __webpack_require__(1583);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_21__hot_water__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__hot_water_on__ = __webpack_require__(1584);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_22__hot_water_on__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__hub_nano1__ = __webpack_require__(1585);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_23__hub_nano1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__hub_nano2__ = __webpack_require__(1586);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_24__hub_nano2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__humidity__ = __webpack_require__(1587);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_25__humidity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__leak_sensor__ = __webpack_require__(1588);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_26__leak_sensor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__light__ = __webpack_require__(1589);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_27__light__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__light_double__ = __webpack_require__(1590);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_28__light_double__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__link_broken__ = __webpack_require__(1591);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_29__link_broken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__linked__ = __webpack_require__(1592);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_30__linked__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__long_press__ = __webpack_require__(1593);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_31__long_press__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__motion_sensor__ = __webpack_require__(1594);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_32__motion_sensor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__one_tap__ = __webpack_require__(1595);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_33__one_tap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__philips_hue_bridge__ = __webpack_require__(1596);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_34__philips_hue_bridge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__plug_eu__ = __webpack_require__(1597);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_35__plug_eu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__plug_in__ = __webpack_require__(1598);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_36__plug_in__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__plug_na__ = __webpack_require__(1599);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_37__plug_na__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__plug_uk__ = __webpack_require__(1600);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_38__plug_uk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__sense__ = __webpack_require__(1601);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_39__sense__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__signal_boost__ = __webpack_require__(1602);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_40__signal_boost__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__signal_booster_plug__ = __webpack_require__(1603);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_41__signal_booster_plug__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__socket_eu__ = __webpack_require__(1604);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_42__socket_eu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__socket_in__ = __webpack_require__(1605);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_43__socket_in__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__socket_na__ = __webpack_require__(1606);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_44__socket_na__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__socket_uk__ = __webpack_require__(1607);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_45__socket_uk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__switch__ = __webpack_require__(1608);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_46__switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__tanks__ = __webpack_require__(1609);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_47__tanks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__thermostat_slt1__ = __webpack_require__(1610);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_48__thermostat_slt1__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__thermostat_slt2__ = __webpack_require__(1611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_49__thermostat_slt2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__thermostat_slt3__ = __webpack_require__(1612);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_50__thermostat_slt3__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__toilets__ = __webpack_require__(1613);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_51__toilets__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__water_flowing__ = __webpack_require__(1614);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_52__water_flowing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__water_not_flowing__ = __webpack_require__(1615);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_53__water_not_flowing__["a"]; });


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ActionButton=function ActionButton(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.09,31.51c-1.71,0-2.68-.89-2.68-2.44V18.51a.5.5,0,0,1,1,0V29.07c0,.67.19,1.44,1.68,1.44s1.68-.77,1.68-1.44V13.17a.5.5,0,0,1,1,0v15.9C25.77,30.62,24.79,31.51,23.09,31.51Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.26,23.89l-.4,0c-2-.18-2.22-1.76-2.22-3.27v-4a.5.5,0,0,1,1,0v4c0,1.82.44,2.2,1.32,2.28a1.84,1.84,0,0,0,1.38-.27.51.51,0,0,1,.7,0,.49.49,0,0,1,0,.69A2.54,2.54,0,0,1,15.26,23.89Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.26,21.8a2.56,2.56,0,0,1-1.66-.52,3.46,3.46,0,0,1-1.07-2.66c-.12-1.91-.16-2.93-.16-5.21a13.67,13.67,0,0,1,3.3-9.19.5.5,0,0,1,.71.7,12.92,12.92,0,0,0-3,8.49c0,2.25,0,3.26.16,5.14a2.63,2.63,0,0,0,.7,1.94,2.1,2.1,0,0,0,1.68.24.5.5,0,1,1,.16,1A4.94,4.94,0,0,1,12.26,21.8Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.6,20.59a7.06,7.06,0,0,1-1.5-.15.5.5,0,0,1,.28-1,6.54,6.54,0,0,0,1.22.11c.84,0,1.42-.7,1.55-1.87a32.51,32.51,0,0,0,.24-3.51,7,7,0,0,0-1.41-5,26.71,26.71,0,0,0-4.4-4.32.5.5,0,1,1,.61-.79A27.3,27.3,0,0,1,27.8,8.63a8,8,0,0,1,1.59,5.59,32.78,32.78,0,0,1-.25,3.62C29,19.53,28,20.59,26.6,20.59Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M18.65,25.18c-1.2,0-2.62-.62-2.62-3.55V18a.5.5,0,0,1,1,0v3.61c0,2.26.87,2.55,1.62,2.55a4.31,4.31,0,0,0,1.91-.34.5.5,0,0,1,.49.87A5,5,0,0,1,18.65,25.18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'7',x:'19.34',y:'32.57'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'14.5',x:'15.84',y:'34.51'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (ActionButton);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Appliance=function Appliance(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.94,35.31H6.06a1.8,1.8,0,0,1-1.8-1.8V6.28a1.8,1.8,0,0,1,1.8-1.8H33.94a1.8,1.8,0,0,1,1.8,1.8V33.51A1.8,1.8,0,0,1,33.94,35.31ZM6.06,5.48a.8.8,0,0,0-.8.8V33.51a.8.8,0,0,0,.8.8H33.94a.8.8,0,0,0,.8-.8V6.28a.8.8,0,0,0-.8-.8Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'30.48',x:'4.76',y:'8.7'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,29.47a8.61,8.61,0,1,1,8.6-8.6A8.61,8.61,0,0,1,20,29.47Zm0-16.21a7.61,7.61,0,1,0,7.6,7.61A7.61,7.61,0,0,0,20,13.26Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,25.42a4.55,4.55,0,1,1,4.55-4.55A4.56,4.56,0,0,1,20,25.42Zm0-8.1a3.55,3.55,0,1,0,3.55,3.55A3.56,3.56,0,0,0,20,17.31Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1.3',rx:'0.49',ry:'0.49',width:'1.95',x:'7.36',y:'34.68'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1.3',rx:'0.49',ry:'0.49',width:'1.95',x:'30.7',y:'34.68'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.43,21.08a.51.51,0,0,1-.5-.5,1.42,1.42,0,0,0-1.42-1.42.5.5,0,1,1,0-1,2.42,2.42,0,0,1,2.42,2.42A.5.5,0,0,1,22.43,21.08Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.44,7.59h1.14a.5.5,0,1,0,0-1H11.44a.5.5,0,1,0,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.52,7.59H9.66a.5.5,0,1,0,0-1H8.52a.5.5,0,1,0,0,1Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Appliance);

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var BoilerModuleSLR1=function BoilerModuleSLR1(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.56,32H10.44A2.48,2.48,0,0,1,8,29.56V10.44A2.48,2.48,0,0,1,10.44,8H29.56A2.48,2.48,0,0,1,32,10.44V29.56A2.48,2.48,0,0,1,29.56,32ZM10.44,9A1.48,1.48,0,0,0,9,10.44V29.56A1.48,1.48,0,0,0,10.44,31H29.56A1.48,1.48,0,0,0,31,29.56V10.44A1.48,1.48,0,0,0,29.56,9Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.92,11.15a1.48,1.48,0,1,0,1.48,1.48A1.48,1.48,0,0,0,26.92,11.15Zm0,13.69a2,2,0,1,0,2,2A2,2,0,0,0,26.92,24.84Zm0-5.94a2,2,0,1,0,2,2A2,2,0,0,0,26.92,18.9Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (BoilerModuleSLR1);

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var BoilerModuleSLR2=function BoilerModuleSLR2(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.56,32H10.44A2.48,2.48,0,0,1,8,29.56V10.44A2.48,2.48,0,0,1,10.44,8H29.56A2.48,2.48,0,0,1,32,10.44V29.56A2.48,2.48,0,0,1,29.56,32ZM10.44,9A1.48,1.48,0,0,0,9,10.44V29.56A1.48,1.48,0,0,0,10.44,31H29.56A1.48,1.48,0,0,0,31,29.56V10.44A1.48,1.48,0,0,0,29.56,9Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.93,11.48A1.48,1.48,0,1,0,28.41,13,1.48,1.48,0,0,0,26.93,11.48Zm0,13.69a2,2,0,1,0,2,2A2,2,0,0,0,26.93,25.17Zm0-5.44a1.48,1.48,0,1,0,1.48,1.48A1.48,1.48,0,0,0,26.93,19.73Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21,25.17a2,2,0,1,0,2,2A2,2,0,0,0,21,25.17Zm0-5.44a1.48,1.48,0,1,0,1.48,1.48A1.48,1.48,0,0,0,21,19.73Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (BoilerModuleSLR2);

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ButtonOff=function ButtonOff(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,32A12,12,0,1,1,32,20,12.06,12.06,0,0,1,20,32ZM20,9A11,11,0,1,0,31,20,11.06,11.06,0,0,0,20,9Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.54,36H8.46A4.46,4.46,0,0,1,4,31.54V8.46A4.46,4.46,0,0,1,8.46,4H31.54A4.46,4.46,0,0,1,36,8.46V31.54A4.46,4.46,0,0,1,31.54,36ZM8.46,5A3.46,3.46,0,0,0,5,8.46V31.54A3.46,3.46,0,0,0,8.46,35H31.54A3.46,3.46,0,0,0,35,31.54V8.46A3.46,3.46,0,0,0,31.54,5Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (ButtonOff);

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CameraDeharo=function CameraDeharo(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,Object.assign({},gProps,{transform:'translate(-66.000000, -288.000000)'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,{transform:'translate(16.000000, 160.000000)'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M84.5,130.2H55.6c-0.4,0-0.8,0.2-1.2,0.5c-0.3,0.4-0.5,0.8-0.5,1.2v28.9c0,0.5,0.2,0.9,0.5,1.2c0.3,0.3,0.7,0.5,1.2,0.5 h7.8c0.1,1.1,0.5,1.9,1.2,2.6c0.8,0.7,1.7,1,2.7,1h5.5c1.1,0,2-0.3,2.7-1c0.8-0.7,1.2-1.5,1.2-2.6h7.8c1.2,0,1.8-0.6,1.8-1.7V132 c0-0.4-0.2-0.9-0.5-1.2C85.4,130.4,85,130.2,84.5,130.2L84.5,130.2z M72.8,165.3h-5.4c-0.8,0-1.5-0.3-2.1-0.8 c-0.6-0.5-0.9-1.2-1.1-1.9h11.6c-0.1,0.8-0.5,1.4-1.1,1.9C74.2,165,73.5,165.3,72.8,165.3L72.8,165.3z M85.3,160.9 c0,0.5-0.3,0.8-0.8,0.8H55.6c-0.5,0-0.8-0.3-0.8-0.8V132c0-0.6,0.3-0.8,0.8-0.8h28.9c0.6,0,0.8,0.3,0.8,0.8V160.9z M70.1,141.8 c-1.3,0-2.4,0.5-3.3,1.4c-0.9,0.9-1.4,2-1.4,3.3c0,1.3,0.5,2.4,1.4,3.3c0.9,0.9,2,1.4,3.3,1.4s2.4-0.5,3.3-1.4 c0.9-0.9,1.4-2,1.4-3.3c0-1.3-0.5-2.4-1.4-3.3C72.5,142.2,71.4,141.8,70.1,141.8L70.1,141.8z M70.1,150.3c-1.1,0-2-0.4-2.7-1.1 c-0.7-0.7-1.1-1.6-1.1-2.7s0.4-2,1.1-2.7c0.7-0.7,1.6-1.1,2.7-1.1c1.1,0,2,0.4,2.7,1.1c0.7,0.7,1.1,1.6,1.1,2.7s-0.4,2-1.1,2.7 C72,149.9,71.1,150.3,70.1,150.3L70.1,150.3z M70.1,138.4c-2.2,0-4.2,0.8-5.8,2.4c-1.6,1.6-2.4,3.5-2.4,5.7c0,2.2,0.8,4.2,2.4,5.8 c1.6,1.6,3.5,2.4,5.8,2.4c2.2,0,4.2-0.8,5.8-2.4s2.4-3.5,2.4-5.8c0-2.2-0.8-4.2-2.4-5.7S72.3,138.4,70.1,138.4L70.1,138.4z M70.1,153.6c-2,0-3.7-0.7-5.1-2.1c-1.4-1.4-2.1-3.1-2.1-5.1c0-2,0.7-3.7,2.1-5.1c1.4-1.4,3.1-2.1,5.1-2.1c2,0,3.7,0.7,5.1,2.1 c1.4,1.4,2.1,3.1,2.1,5.1c0,2-0.7,3.7-2.1,5.1S72,153.6,70.1,153.6L70.1,153.6z'})));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (CameraDeharo);

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CameraOff=function CameraOff(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.77,12.88a.5.5,0,0,1-.5-.5V8.76A1.49,1.49,0,0,1,8.75,7.27h3.63a.5.5,0,0,1,0,1H8.75a.49.49,0,0,0-.49.49v3.63A.5.5,0,0,1,7.77,12.88Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.25,32.73H27.62a.5.5,0,0,1,0-1h3.63a.49.49,0,0,0,.49-.49V27.62a.5.5,0,0,1,1,0v3.63A1.49,1.49,0,0,1,31.25,32.73Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,28.75A8.74,8.74,0,1,1,28.75,20,8.75,8.75,0,0,1,20,28.75Zm0-16.49A7.74,7.74,0,1,0,27.75,20,7.75,7.75,0,0,0,20,12.26Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,25.61A5.61,5.61,0,1,1,25.61,20,5.62,5.62,0,0,1,20,25.61Zm0-10.22A4.61,4.61,0,1,0,24.61,20,4.62,4.62,0,0,0,20,15.39Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.16,20.64a.5.5,0,0,1-.5-.5,3.55,3.55,0,0,1,2.68-3.45.5.5,0,0,1,.24,1,2.55,2.55,0,0,0-1.93,2.48A.5.5,0,0,1,17.16,20.64Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (CameraOff);

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ColourPicker=function ColourPicker(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.42,19.68a3.3,3.3,0,1,1,3.3-3.3A3.31,3.31,0,0,1,11.42,19.68Zm0-5.61a2.3,2.3,0,1,0,2.3,2.3A2.31,2.31,0,0,0,11.42,14.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.25,19a3.3,3.3,0,1,1,3.3-3.3A3.31,3.31,0,0,1,28.25,19Zm0-5.61a2.3,2.3,0,1,0,2.3,2.3A2.31,2.31,0,0,0,28.25,13.41Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.67,14.73a3.3,3.3,0,1,1,3.3-3.3A3.31,3.31,0,0,1,19.67,14.73Zm0-5.61a2.3,2.3,0,1,0,2.3,2.3A2.31,2.31,0,0,0,19.67,9.12Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13.4,28.58a3.3,3.3,0,1,1,3.3-3.3A3.31,3.31,0,0,1,13.4,28.58Zm0-5.61a2.3,2.3,0,1,0,2.3,2.3A2.31,2.31,0,0,0,13.4,23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.25,36a15.15,15.15,0,0,1-5.33-1.28,16,16,0,0,1,1.47-30c7.25-2.19,15.36.93,18.89,7.24,1.91,3.43,2.83,8.81-.89,12.64-2.47,2.55-5.55,2.76-8.76,2.76-1.68,0-2.49.46-2.8,1.59a2.5,2.5,0,0,0,.52,2,3.38,3.38,0,0,1,.6,2.81,3,3,0,0,1-1.61,1.91A4.88,4.88,0,0,1,19.25,36Zm.9-31a15.48,15.48,0,0,0-4.48.66A15,15,0,0,0,14.3,33.84c2.17.91,5,1.63,6.6.89A2,2,0,0,0,22,33.45a2.49,2.49,0,0,0-.51-2,3.39,3.39,0,0,1-.61-2.73c.57-2.08,2.42-2.32,3.76-2.32,3.09,0,5.83-.18,8-2.46,3.34-3.44,2.48-8.32.73-11.46h0A15.17,15.17,0,0,0,20.15,5Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (ColourPicker);

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Cooling=function Cooling(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0v31A.5.5,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,10.61a.5.5,0,0,1-.22-.05L14.5,7.92A.5.5,0,0,1,14.95,7l5.28,2.64a.5.5,0,0,1-.22.95Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,10.61a.5.5,0,0,1-.22-.95L25.05,7a.5.5,0,0,1,.45.89l-5.28,2.64A.5.5,0,0,1,20,10.61Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.72,33a.5.5,0,0,1-.22-.95l5.28-2.64a.5.5,0,0,1,.45.89L14.95,33A.49.49,0,0,1,14.72,33Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.28,33a.49.49,0,0,1-.22-.05l-5.28-2.64a.5.5,0,0,1,.45-.89l5.28,2.64a.5.5,0,0,1-.22.95Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7,28.94A.5.5,0,0,1,6.73,28l26-16.88a.5.5,0,1,1,.54.84l-26,16.88A.5.5,0,0,1,7,28.94Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.3,15.11a.5.5,0,0,1-.5-.44l-.66-5.86a.5.5,0,1,1,1-.11l.66,5.86a.5.5,0,0,1-.44.55Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.38,18.1a.5.5,0,0,1-.25-.07L28,15a.5.5,0,0,1,.51-.86l5.09,3a.5.5,0,0,1-.25.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.7,25.89a.5.5,0,0,1-.25-.07l-5.09-3A.5.5,0,1,1,6.87,22L12,25a.5.5,0,0,1-.25.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.36,31.75a.5.5,0,0,1-.5-.44l-.66-5.86a.5.5,0,1,1,1-.11l.66,5.86a.5.5,0,0,1-.44.55Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33,28.94a.5.5,0,0,1-.27-.08L6.73,12a.5.5,0,1,1,.54-.84L33.27,28a.5.5,0,0,1-.27.92Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M6.62,18.1a.5.5,0,0,1-.25-.93l5.09-3A.5.5,0,0,1,12,15L6.87,18A.5.5,0,0,1,6.62,18.1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.7,15.11h-.06a.5.5,0,0,1-.44-.55l.66-5.86a.5.5,0,1,1,1,.11l-.66,5.86A.5.5,0,0,1,11.7,15.11Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.64,31.75h-.06a.5.5,0,0,1-.44-.55l.66-5.86a.5.5,0,1,1,1,.11l-.66,5.86A.5.5,0,0,1,27.64,31.75Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.3,25.89A.5.5,0,0,1,28,25l5.09-3a.5.5,0,1,1,.51.86l-5.09,3A.5.5,0,0,1,28.3,25.89Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Cooling);

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var DoorSensorClosed=function DoorSensorClosed(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.87,36H12.58a3.14,3.14,0,0,1-3.14-3.14V7.14A3.14,3.14,0,0,1,12.58,4h4.29A3.14,3.14,0,0,1,20,7.14V32.86A3.14,3.14,0,0,1,16.87,36ZM12.58,5a2.14,2.14,0,0,0-2.14,2.14V32.86A2.14,2.14,0,0,0,12.58,35h4.29A2.14,2.14,0,0,0,19,32.86V7.14A2.14,2.14,0,0,0,16.87,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.42,36H25.11A3.14,3.14,0,0,1,22,32.86V7.14A3.14,3.14,0,0,1,25.11,4h2.31a3.14,3.14,0,0,1,3.14,3.14V32.86A3.14,3.14,0,0,1,27.42,36ZM25.11,5A2.14,2.14,0,0,0,23,7.14V32.86A2.14,2.14,0,0,0,25.11,35h2.31a2.14,2.14,0,0,0,2.14-2.14V7.14A2.14,2.14,0,0,0,27.42,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'9.23',x:'10.11',y:'23.79'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'7.25',x:'22.64',y:'23.79'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (DoorSensorClosed);

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var DoubleTap=function DoubleTap(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.95,27.71a.5.5,0,0,1-.5-.5V12.4A2.21,2.21,0,0,1,18,10.08,2.21,2.21,0,0,1,20.5,12.4v9.85a.5.5,0,0,1-1,0V12.4c0-.62-.17-1.32-1.53-1.32s-1.53.71-1.53,1.32v14.8A.5.5,0,0,1,15.95,27.71Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.21,24.55a.5.5,0,0,1-.5-.5V20.36c0-1.66-.49-2-1.28-2.11a1.57,1.57,0,0,0-1.17.21.51.51,0,0,1-.7,0,.49.49,0,0,1,0-.68,2.37,2.37,0,0,1,2-.51c2,.18,2.18,1.86,2.18,3.11v3.69A.5.5,0,0,1,27.21,24.55Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.12,35.93a.5.5,0,0,1-.36-.85,12.23,12.23,0,0,0,2.78-8c0-2.12,0-3.07-.15-4.83a2.5,2.5,0,0,0-.62-1.84,1.81,1.81,0,0,0-1.45-.2.5.5,0,0,1-.16-1,2.72,2.72,0,0,1,2.23.4,3.44,3.44,0,0,1,1,2.56c.11,1.79.15,2.75.15,4.9a13,13,0,0,1-3.06,8.66A.5.5,0,0,1,27.12,35.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M18,36a.5.5,0,0,1-.31-.11,25.38,25.38,0,0,1-4.27-4.26,7.6,7.6,0,0,1-1.48-5.27A31.68,31.68,0,0,1,12.18,23c.17-1.6,1.09-2.61,2.39-2.61a6.46,6.46,0,0,1,1.4.14.5.5,0,1,1-.29,1,6,6,0,0,0-1.11-.1c-.76,0-1.28.65-1.4,1.73a31.28,31.28,0,0,0-.23,3.3,6.67,6.67,0,0,0,1.3,4.68,24.87,24.87,0,0,0,4.07,4.05A.5.5,0,0,1,18,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.05,23.2a.5.5,0,0,1-.5-.5V19.4C23.55,17,22.39,17,22,17a4.05,4.05,0,0,0-1.71.28.51.51,0,0,1-.67-.21.5.5,0,0,1,.19-.67A4.74,4.74,0,0,1,22,16c1.62,0,2.55,1.23,2.55,3.37v3.3A.5.5,0,0,1,24.05,23.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23,13a.5.5,0,0,1-.5-.5,4.57,4.57,0,0,0-9.13,0,.5.5,0,0,1-1,0,5.57,5.57,0,0,1,11.13,0A.5.5,0,0,1,23,13Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26,13a.5.5,0,0,1-.5-.5,7.51,7.51,0,0,0-15,0,.5.5,0,0,1-1,0,8.51,8.51,0,0,1,17,0A.5.5,0,0,1,26,13Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (DoubleTap);

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var DuoSocketEU=function DuoSocketEU(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.23,36H10.77a1.82,1.82,0,0,1-1.82-1.82V5.82A1.82,1.82,0,0,1,10.77,4H29.23a1.82,1.82,0,0,1,1.82,1.82V34.18A1.82,1.82,0,0,1,29.23,36ZM10.77,5a.82.82,0,0,0-.82.82V34.18a.82.82,0,0,0,.82.82H29.23a.82.82,0,0,0,.82-.82V5.82A.82.82,0,0,0,29.23,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,34a6.73,6.73,0,1,1,6.73-6.73A6.74,6.74,0,0,1,20,34Zm0-12.46a5.73,5.73,0,1,0,5.73,5.73A5.74,5.74,0,0,0,20,21.53Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,19.47a6.73,6.73,0,1,1,6.73-6.73A6.74,6.74,0,0,1,20,19.47ZM20,7a5.73,5.73,0,1,0,5.73,5.73A5.74,5.74,0,0,0,20,7Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'22.84',cy:'27.26',r:'1.22'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'17.16',cy:'27.26',r:'1.22'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'22.84',cy:'12.74',r:'1.22'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'17.16',cy:'12.74',r:'1.22'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (DuoSocketEU);

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var DuoSocketIN=function DuoSocketIN(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M34.18,31.05H5.82A1.82,1.82,0,0,1,4,29.23V10.77A1.82,1.82,0,0,1,5.82,8.95H34.18A1.82,1.82,0,0,1,36,10.77V29.23A1.82,1.82,0,0,1,34.18,31.05ZM5.82,9.95a.82.82,0,0,0-.82.82V29.23a.82.82,0,0,0,.82.82H34.18a.82.82,0,0,0,.82-.82V10.77a.82.82,0,0,0-.82-.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'13',cy:'18',r:'1.25'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'10.5',cy:'22.38',r:'1.25'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'15.5',cy:'22.38',r:'1.25'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'27',cy:'18',r:'1.25'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'24.5',cy:'22.38',r:'1.25'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'29.5',cy:'22.38',r:'1.25'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (DuoSocketIN);

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var DuoSocketNA=function DuoSocketNA(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.23,36H10.77a1.82,1.82,0,0,1-1.82-1.82V5.82A1.82,1.82,0,0,1,10.77,4H29.23a1.82,1.82,0,0,1,1.82,1.82V34.18A1.82,1.82,0,0,1,29.23,36ZM10.77,5a.82.82,0,0,0-.82.82V34.18a.82.82,0,0,0,.82.82H29.23a.82.82,0,0,0,.82-.82V5.82A.82.82,0,0,0,29.23,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.19,19.18H15.76L14,16a6.38,6.38,0,0,1,0-7.29L15.8,6.31h8.35L26,8.89A6.2,6.2,0,0,1,26,16Zm-7.83-1H23.6l1.53-2.72a5.22,5.22,0,0,0,0-6L23.64,7.31H16.32l-1.44,2a5.4,5.4,0,0,0,0,6.18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.19,33.69H15.76L14,30.54a6.38,6.38,0,0,1,0-7.29l1.74-2.43h8.35L26,23.41a6.2,6.2,0,0,1,0,7.1Zm-7.83-1H23.6L25.13,30a5.22,5.22,0,0,0,0-6l-1.52-2.16H16.32l-1.44,2a5.4,5.4,0,0,0,0,6.18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.75,9.12a.46.46,0,0,0-.5.41v3.21a.51.51,0,0,0,1,0V9.53A.46.46,0,0,0,16.75,9.12Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.25,9.12a.46.46,0,0,0-.5.41v3.21a.51.51,0,0,0,1,0V9.53A.46.46,0,0,0,23.25,9.12Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,13.63a.46.46,0,0,0-.5.41V16.1a.51.51,0,0,0,1,0V14A.46.46,0,0,0,20,13.63Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.75,23.63a.46.46,0,0,0-.5.41v3.21a.51.51,0,0,0,1,0V24A.46.46,0,0,0,16.75,23.63Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.25,23.63a.46.46,0,0,0-.5.41v3.21a.51.51,0,0,0,1,0V24A.46.46,0,0,0,23.25,23.63Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,28.14a.46.46,0,0,0-.5.41v2.06a.51.51,0,0,0,1,0V28.55A.46.46,0,0,0,20,28.14Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (DuoSocketNA);

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var DuoSocketUK=function DuoSocketUK(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M34.18,31.05H5.82A1.82,1.82,0,0,1,4,29.23V10.77A1.82,1.82,0,0,1,5.82,8.95H34.18A1.82,1.82,0,0,1,36,10.77V29.23A1.82,1.82,0,0,1,34.18,31.05ZM5.82,9.95a.82.82,0,0,0-.82.82V29.23a.82.82,0,0,0,.82.82H34.18a.82.82,0,0,0,.82-.82V10.77a.82.82,0,0,0-.82-.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.31,16.35c-.22,0-.81.18-.81.41v2.84c0,.22.59.41.81.41s.81-.18.81-.41V16.75C28.12,16.53,27.53,16.35,27.31,16.35Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.68,22.84c0-.22-.14-.81-.32-.81H23.16c-.17,0-.32.59-.32.81s.14.81.32.81h2.21C25.54,23.65,25.68,23.07,25.68,22.84Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.77,22.84c0-.22-.14-.81-.32-.81H29.25c-.17,0-.32.59-.32.81s.14.81.32.81h2.21C31.63,23.65,31.77,23.07,31.77,22.84Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.69,16.35c-.22,0-.81.18-.81.41v2.84c0,.22.59.41.81.41s.81-.18.81-.41V16.75C13.51,16.53,12.92,16.35,12.69,16.35Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.07,22.84c0-.22-.14-.81-.32-.81H8.54c-.17,0-.32.59-.32.81s.14.81.32.81h2.21C10.93,23.65,11.07,23.07,11.07,22.84Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.16,22.84c0-.22-.14-.81-.32-.81H14.63c-.17,0-.32.59-.32.81s.14.81.32.81h2.21C17,23.65,17.16,23.07,17.16,22.84Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (DuoSocketUK);

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var FanOff=function FanOff(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.9,36a3,3,0,0,1-2.34-1.25,4.36,4.36,0,0,1-.41-.94,3.47,3.47,0,0,1,0-1.74,6.29,6.29,0,0,0,.22-1.6A5.09,5.09,0,0,0,22.81,26a2.84,2.84,0,0,1-.27-.2l-.16-.12.56-.83.23.18.16.12a6.07,6.07,0,0,1,3.07,5.29,7.32,7.32,0,0,1-.26,1.87,2.46,2.46,0,0,0,0,1.21,3.38,3.38,0,0,0,.28.65,1.91,1.91,0,0,0,2.37.57,13.68,13.68,0,0,0,5.1-5.1A7.14,7.14,0,0,0,34.77,24a6.53,6.53,0,0,0-1.22-2.61,7.25,7.25,0,0,0-1.86-1.68,6.48,6.48,0,0,0-3.31-.92,6.1,6.1,0,0,0-3.36,1L24.47,19a7.1,7.1,0,0,1,3.91-1.13,7.5,7.5,0,0,1,3.84,1.07,8.26,8.26,0,0,1,2.12,1.91,7.48,7.48,0,0,1,1.4,3,8.13,8.13,0,0,1-1,6.4,14.65,14.65,0,0,1-5.46,5.45A2.68,2.68,0,0,1,27.9,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.84,33.66a8,8,0,0,1-7-4.39A15.09,15.09,0,0,1,4,21.75a3.07,3.07,0,0,1,2.88-2.92H7a2.88,2.88,0,0,1,2.17,1,6.38,6.38,0,0,0,1.24,1,4.91,4.91,0,0,0,5-.1A2.09,2.09,0,0,1,16,20.5l.34.94h0a1.26,1.26,0,0,0-.3.13,5.92,5.92,0,0,1-6.11.12,7.37,7.37,0,0,1-1.46-1.17A1.89,1.89,0,0,0,7,19.83a2.06,2.06,0,0,0-2,2,14.07,14.07,0,0,0,1.73,7,7,7,0,0,0,6.1,3.87,7,7,0,0,0,.93-.08l.12,0a6.22,6.22,0,0,0,2.17-.78,6.9,6.9,0,0,0,3.35-6h1a7.89,7.89,0,0,1-3.83,6.85,7.24,7.24,0,0,1-2.54.91l-.14,0A7.85,7.85,0,0,1,12.84,33.66Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.84,18.71A8,8,0,0,1,13,11.86,7.8,7.8,0,0,1,14,8a7.18,7.18,0,0,1,1.35-1.76A8,8,0,0,1,20.87,4h.29a14.37,14.37,0,0,1,7.3,2.17,2.93,2.93,0,0,1,.93,4,3,3,0,0,1-2,1.48,5.68,5.68,0,0,0-1.44.58,5,5,0,0,0-2.47,4.54,2.45,2.45,0,0,1-.06.63l-1-.24a1.46,1.46,0,0,0,0-.38,6,6,0,0,1,3-5.41,6.66,6.66,0,0,1,1.71-.69A2.14,2.14,0,0,0,28.76,9a1.93,1.93,0,0,0-.86-2,13.34,13.34,0,0,0-6.76-2h-.27A7,7,0,0,0,16,7a6.14,6.14,0,0,0-1.17,1.53,6.8,6.8,0,0,0-.9,3.39,7,7,0,0,0,3.39,6Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.58,26.27a5.12,5.12,0,1,1,5.12-5.12A5.12,5.12,0,0,1,20.58,26.27Zm0-9.23a4.12,4.12,0,1,0,4.12,4.12A4.12,4.12,0,0,0,20.58,17Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.17,11.08a.5.5,0,0,1-.5-.5,3.55,3.55,0,0,1,2.68-3.45.5.5,0,1,1,.25,1,2.55,2.55,0,0,0-1.93,2.48A.5.5,0,0,1,16.17,11.08Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (FanOff);

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var FanOn=function FanOn(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27,36a13.87,13.87,0,0,1-7-1.89.5.5,0,1,1,.5-.86A12.86,12.86,0,0,0,27.93,35,.5.5,0,0,1,28,36Q27.51,36,27,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.73,32.45h-.07a10.47,10.47,0,0,1-3.38-1.05.5.5,0,0,1,.45-.89,9.47,9.47,0,0,0,3.05,1,.5.5,0,0,1-.06,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.37,13.32a.5.5,0,0,1-.46-.31,12.87,12.87,0,0,0-4.82-5.87.5.5,0,0,1,.55-.83,13.87,13.87,0,0,1,5.19,6.33.5.5,0,0,1-.27.65A.49.49,0,0,1,33.37,13.32Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.94,14.12a.5.5,0,0,1-.45-.28,9.45,9.45,0,0,0-1.85-2.62.5.5,0,0,1,.71-.71,10.45,10.45,0,0,1,2,2.9.5.5,0,0,1-.45.72Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M4.7,21.36H4.59a.5.5,0,0,1-.37-.6,13.88,13.88,0,0,1,4.11-7.08A.5.5,0,0,1,9,14.4,12.88,12.88,0,0,0,5.19,21,.5.5,0,0,1,4.7,21.36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.66,20.38a.5.5,0,0,1-.46-.7,10.48,10.48,0,0,1,2.05-3.05.5.5,0,0,1,.72.69,9.44,9.44,0,0,0-1.86,2.76A.5.5,0,0,1,8.66,20.38Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.84,18.71A8,8,0,0,1,13,11.86,7.8,7.8,0,0,1,14,8a7.19,7.19,0,0,1,1.35-1.76A8,8,0,0,1,20.88,4h.29a14.38,14.38,0,0,1,7.3,2.17,2.93,2.93,0,0,1,1.28,3.05,2.88,2.88,0,0,1-.35.9,3,3,0,0,1-2,1.48,6,6,0,0,0-1.44.58,5,5,0,0,0-2.47,4.54,2.42,2.42,0,0,1-.06.63l-1-.24a1.45,1.45,0,0,0,0-.38,6,6,0,0,1,3-5.41,6.87,6.87,0,0,1,1.71-.69,2,2,0,0,0,1.34-1A1.93,1.93,0,0,0,27.9,7a13.34,13.34,0,0,0-6.76-2h-.27A7,7,0,0,0,16,7a6.16,6.16,0,0,0-1.17,1.53,6.79,6.79,0,0,0-.9,3.39,7,7,0,0,0,3.39,6Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.89,36a3,3,0,0,1-2.34-1.25,4.34,4.34,0,0,1-.41-.94,3.46,3.46,0,0,1,0-1.74,6.37,6.37,0,0,0,.22-1.6A5.09,5.09,0,0,0,22.82,26a2.85,2.85,0,0,1-.27-.2l-.16-.12.56-.83.23.18.16.12a6.07,6.07,0,0,1,3.07,5.29,7.35,7.35,0,0,1-.26,1.87,2.46,2.46,0,0,0,0,1.21,3.35,3.35,0,0,0,.28.65,1.9,1.9,0,0,0,2.37.57,13.68,13.68,0,0,0,5.1-5.1A7.14,7.14,0,0,0,34.77,24a6.52,6.52,0,0,0-1.22-2.61,7.25,7.25,0,0,0-1.86-1.68,6.48,6.48,0,0,0-3.31-.92,6.1,6.1,0,0,0-3.36,1L24.47,19a7.1,7.1,0,0,1,3.9-1.13,7.5,7.5,0,0,1,3.84,1.07,8.25,8.25,0,0,1,2.12,1.92,7.47,7.47,0,0,1,1.4,3,8.13,8.13,0,0,1-1,6.4,14.64,14.64,0,0,1-5.46,5.45A2.68,2.68,0,0,1,27.89,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.84,33.66a8,8,0,0,1-7-4.39A15.08,15.08,0,0,1,4,21.74a3.07,3.07,0,0,1,2.88-2.92H7a2.88,2.88,0,0,1,2.17,1,6.35,6.35,0,0,0,1.24,1,4.92,4.92,0,0,0,5-.1A2.16,2.16,0,0,1,16,20.5l.32.95a1.29,1.29,0,0,0-.32.14,5.92,5.92,0,0,1-6.11.11,7.37,7.37,0,0,1-1.46-1.17A1.88,1.88,0,0,0,7,19.83a2.06,2.06,0,0,0-2,2,14,14,0,0,0,1.73,7,7,7,0,0,0,6.1,3.87,7,7,0,0,0,.93-.08l.12,0a6.22,6.22,0,0,0,2.17-.77,6.91,6.91,0,0,0,3.35-6h1a7.89,7.89,0,0,1-3.83,6.85,7.23,7.23,0,0,1-2.54.91l-.14,0A7.83,7.83,0,0,1,12.84,33.66Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.58,26.27a5.12,5.12,0,1,1,5.12-5.12A5.12,5.12,0,0,1,20.58,26.27Zm0-9.23a4.12,4.12,0,1,0,4.12,4.12A4.12,4.12,0,0,0,20.58,17Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.17,11.08a.5.5,0,0,1-.5-.5,3.55,3.55,0,0,1,2.68-3.45.5.5,0,0,1,.24,1,2.55,2.55,0,0,0-1.93,2.48A.5.5,0,0,1,16.17,11.08Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (FanOn);

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var FlameNA=function FlameNA(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.76,36A6.32,6.32,0,0,1,15,32.28a7.89,7.89,0,0,1-.79-3.62,8.2,8.2,0,0,1,.24-1.85,8.86,8.86,0,0,1,1-2.4,24.6,24.6,0,0,1,1.42-2.1c.33-.46.67-.92,1-1.4a17.51,17.51,0,0,0,1.83-3.67,15.59,15.59,0,0,0,.79-7.52,15.5,15.5,0,0,0-1.17-4l-.1-.25a1.09,1.09,0,0,1,.08-1,.9.9,0,0,1,1.12-.32l.18.09A12.26,12.26,0,0,1,25,7.46,13.08,13.08,0,0,1,27.69,14a28.18,28.18,0,0,1-.45,6.22c-.07.46-.14,1-.19,1.37a22.08,22.08,0,0,0,1.5-7.72,1,1,0,0,1,.92-1,.87.87,0,0,1,.6.25,10.17,10.17,0,0,1,1.64,2.06c3.2,5.23,1.46,11.69-1.5,15.48A13.65,13.65,0,0,1,21.42,36,6.41,6.41,0,0,1,20.76,36ZM20.1,5.07h0l.08.2a16.46,16.46,0,0,1,1.25,4.29,16.57,16.57,0,0,1-.83,8,18.47,18.47,0,0,1-1.94,3.88c-.32.49-.66,1-1,1.44a24.06,24.06,0,0,0-1.36,2A7.86,7.86,0,0,0,15.43,27a7.29,7.29,0,0,0-.21,1.63,6.9,6.9,0,0,0,.69,3.17A5.34,5.34,0,0,0,21.32,35a12.63,12.63,0,0,0,8.11-4.91c2.76-3.52,4.38-9.52,1.43-14.35A9.27,9.27,0,0,0,29.55,14c0,3.21-1.27,9.28-2.86,9.28a.74.74,0,0,1-.47-.17l-.09-.1c-.22-.32-.17-.81.13-2.94a27.58,27.58,0,0,0,.45-6,12.06,12.06,0,0,0-2.44-6,11.12,11.12,0,0,0-4.15-3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13.17,32.16a.89.89,0,0,1-.49-.15,13.63,13.63,0,0,1-3.25-3.06,11.82,11.82,0,0,1-2.85-6.83c-.08-3.17,1.7-5.69,3.26-7.91l.38-.54A32.23,32.23,0,0,0,12.86,9.3a10.91,10.91,0,0,0,1-2.89.94.94,0,0,1,.91-.82.9.9,0,0,1,.81.54A16,16,0,0,1,17,11.21a17.59,17.59,0,0,1-.55,6.3,22.23,22.23,0,0,1-2.13,4.85l-.28.52a7.93,7.93,0,0,0-.25,7.48c.05.08.11.18.17.3a1,1,0,0,1,0,1A.91.91,0,0,1,13.17,32.16ZM14.86,6.83a12.55,12.55,0,0,1-1.09,2.92A33.63,33.63,0,0,1,11,14.23l-.38.55C9.12,17,7.52,19.24,7.59,22.08a10.89,10.89,0,0,0,2.64,6.25A12.73,12.73,0,0,0,13,31L13,30.92l-.08-.14a9,9,0,0,1,.28-8.36l.28-.52a21.52,21.52,0,0,0,2-4.64A16.63,16.63,0,0,0,16,11.31,15.13,15.13,0,0,0,14.86,6.83Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (FlameNA);

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var GenericTemp=function GenericTemp(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a5.52,5.52,0,0,1-4-9.12V8a4.09,4.09,0,0,1,8.17,0V26.92a6.57,6.57,0,0,1,1.28,3.62A5.52,5.52,0,0,1,20,36ZM20,5a3.09,3.09,0,0,0-3.08,3V27.29l-.15.15a4.35,4.35,0,0,0-1.18,3.1A4.41,4.41,0,0,0,20,35a4.51,4.51,0,0,0,4.44-4.46,5.67,5.67,0,0,0-1.19-3.16l-.1-.13V8A3.09,3.09,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,33.12a2.5,2.5,0,1,1,2.5-2.5A2.5,2.5,0,0,1,20,33.12Zm0-4a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,20,29.12Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,28.83a.5.5,0,0,1-.5-.5V13a.5.5,0,1,1,1,0V28.33A.5.5,0,0,1,20,28.83Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (GenericTemp);

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Heating=function Heating(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,32.21a5.3,5.3,0,0,1-3.71-1.54,5.74,5.74,0,0,1-1.57-4.14A13.08,13.08,0,0,1,17,19.39a20.82,20.82,0,0,1,2.08-2.65,1.23,1.23,0,0,1,1.74,0,20.83,20.83,0,0,1,2.08,2.64,13.09,13.09,0,0,1,2.33,7.15,5.74,5.74,0,0,1-1.57,4.13A5.31,5.31,0,0,1,20,32.21Zm0-14.84a.19.19,0,0,0-.14.06,19.81,19.81,0,0,0-2,2.51,12.09,12.09,0,0,0-2.16,6.57A4.79,4.79,0,0,0,17,30a4.23,4.23,0,0,0,6,0,4.79,4.79,0,0,0,1.28-3.45,12.1,12.1,0,0,0-2.17-6.58,19.86,19.86,0,0,0-2-2.51A.19.19,0,0,0,20,17.37Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a10.14,10.14,0,0,1-7.18-3.06c-2-2-3-4.73-3-8.26-.13-5.79,2.46-11.14,4.65-14.61a42.85,42.85,0,0,1,4.19-5.45,1.94,1.94,0,0,1,2.78,0,42.76,42.76,0,0,1,4.18,5.45c2.19,3.47,4.78,8.82,4.65,14.61-.08,3.53-1.07,6.23-3,8.26A10.14,10.14,0,0,1,20,36ZM20,5a.87.87,0,0,0-.65.29,41.86,41.86,0,0,0-4.08,5.32c-2.11,3.35-4.61,8.5-4.49,14,.07,3.26,1,5.75,2.76,7.59a9,9,0,0,0,12.93,0c1.78-1.84,2.69-4.32,2.76-7.58.12-5.54-2.37-10.7-4.49-14.05a41.82,41.82,0,0,0-4.08-5.31A.87.87,0,0,0,20,5Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Heating);

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HiveButton=function HiveButton(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,32A12,12,0,1,1,32,20,12.06,12.06,0,0,1,20,32ZM20,9A11,11,0,1,0,31,20,11.06,11.06,0,0,0,20,9Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.54,36H8.46A4.46,4.46,0,0,1,4,31.54V8.46A4.46,4.46,0,0,1,8.46,4H31.54A4.46,4.46,0,0,1,36,8.46V31.54A4.46,4.46,0,0,1,31.54,36ZM8.46,5A3.46,3.46,0,0,0,5,8.46V31.54A3.46,3.46,0,0,0,8.46,35H31.54A3.46,3.46,0,0,0,35,31.54V8.46A3.46,3.46,0,0,0,31.54,5Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (HiveButton);

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HotWater=function HotWater(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.38,12.73a3.14,3.14,0,1,1,3.14-3.14A3.14,3.14,0,0,1,15.38,12.73Zm0-5.28a2.14,2.14,0,1,0,2.14,2.14A2.14,2.14,0,0,0,15.38,7.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.23,12.73a3.14,3.14,0,1,1,3.14-3.14A3.14,3.14,0,0,1,29.23,12.73Zm0-5.28a2.14,2.14,0,1,0,2.14,2.14A2.14,2.14,0,0,0,29.23,7.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.45,9.92h-1a2.14,2.14,0,0,0-4.28,0h-1a3.14,3.14,0,0,1,6.28,0Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'8.57',x:'18.02',y:'9.09'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'3.96',width:'1',x:'21.81',y:'9.59'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.31,26.58a6.79,6.79,0,0,1-6.22-4.12H9.29v3.79H4v-5c0-2.43,2.38-4.13,5.78-4.13h6.31a6.76,6.76,0,0,1,12.44,0H36v5.29H28.53A6.79,6.79,0,0,1,22.31,26.58Zm-14-5.12h8.49l.12.33a5.76,5.76,0,0,0,10.82,0l.12-.33H35V18.17H27.84l-.12-.33a5.76,5.76,0,0,0-10.82,0l-.12.33h-7C7,18.17,5,19.46,5,21.3v4H8.29Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M6.48,33.55a2,2,0,0,1-2-2A7.67,7.67,0,0,1,5.79,28a.85.85,0,0,1,1.38,0,7.69,7.69,0,0,1,1.29,3.59A2,2,0,0,1,6.48,33.55Zm0-4.78a6.54,6.54,0,0,0-1,2.81,1,1,0,0,0,2,0A6.57,6.57,0,0,0,6.48,28.76Zm-.15-.24h0Zm.3,0h0Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.39,18.45a.5.5,0,0,1-.48-.35,3.38,3.38,0,0,0-3-2.37.5.5,0,0,1-.47-.53.49.49,0,0,1,.52-.47,4.38,4.38,0,0,1,3.95,3.07.5.5,0,0,1-.33.63Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (HotWater);

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HotWaterOn=function HotWaterOn(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21.809,10.092 L18.4820127,10.092 C18.2417763,11.5860435 16.9427935,12.7301 15.3828,12.7301 C13.6528,12.7301 12.2448,11.3231 12.2448,9.5921 C12.2448,7.8621 13.6528,6.4541 15.3828,6.4541 C16.9426404,6.4541 18.2415213,7.59874491 18.4819419,9.092 L19.2817142,9.092 C19.6465965,7.763269 20.8654607,6.7839 22.3083,6.7839 C23.7519733,6.7839 24.970976,7.763269 25.3358812,9.092 L26.1352581,9.092 C26.3756787,7.59874491 27.6745596,6.4541 29.2344,6.4541 C30.9644,6.4541 32.3724,7.8621 32.3724,9.5921 C32.3724,11.3231 30.9644,12.7301 29.2344,12.7301 C27.6744065,12.7301 26.3754237,11.5860435 26.1351873,10.092 L22.809,10.092 L22.809,13.0682702 C25.3165043,13.2565326 27.5395991,14.8462616 28.5301,17.1715 L36.0001,17.1715 L36.0001,22.4595 L28.5301,22.4595 C27.4741,24.9385 25.0171,26.5815 22.3081,26.5815 C19.6001,26.5815 17.1421,24.9385 16.0871,22.4595 L9.2871,22.4595 L9.2871,26.2515 L4.0001,26.2515 L4.0001,21.2995 C4.0001,18.8695 6.3751,17.1715 9.7761,17.1715 L16.0871,17.1715 C17.0768782,14.8457558 19.301547,13.255841 21.809,13.0681475 L21.809,10.092 Z M24.2796761,9.092 C23.955014,8.32406571 23.1938972,7.7839 22.3083,7.7839 C21.4234534,7.7839 20.6625238,8.32406571 20.3379084,9.092 L24.2796761,9.092 L24.2796761,9.092 Z M8.2871,21.4595 L16.7761,21.4595 L16.8961,21.7885 C17.7251,24.0575 19.8991,25.5815 22.3081,25.5815 C24.7181,25.5815 26.8921,24.0575 27.7211,21.7885 L27.8411,21.4595 L35.0001,21.4595 L35.0001,18.1715 L27.8411,18.1715 L27.7211,17.8435 C26.8921,15.5745 24.7181,14.0495 22.3081,14.0495 C19.8991,14.0495 17.7251,15.5745 16.8961,17.8435 L16.7761,18.1715 L9.7761,18.1715 C6.9641,18.1715 5.0001,19.4585 5.0001,21.2995 L5.0001,25.2515 L8.2871,25.2515 L8.2871,21.4595 Z M15.3828,7.4541 C14.2038,7.4541 13.2448,8.4131 13.2448,9.5921 C13.2448,10.7711 14.2038,11.7301 15.3828,11.7301 C16.5628,11.7301 17.5218,10.7711 17.5218,9.5921 C17.5218,8.4131 16.5628,7.4541 15.3828,7.4541 Z M29.2344,7.4541 C28.0544,7.4541 27.0954,8.4131 27.0954,9.5921 C27.0954,10.7711 28.0544,11.7301 29.2344,11.7301 C30.4134,11.7301 31.3724,10.7711 31.3724,9.5921 C31.3724,8.4131 30.4134,7.4541 29.2344,7.4541 Z M6.4808,33.5455 C5.3868,33.5455 4.4958,32.6615 4.4958,31.5745 C4.4958,30.6335 5.0298,29.1545 5.7938,27.9785 C6.0958,27.5025 6.8768,27.5065 7.1758,27.9865 C7.9328,29.1565 8.4638,30.6345 8.4638,31.5745 C8.4638,32.6615 7.5738,33.5455 6.4808,33.5455 Z M26.3896,18.4546 C26.1756,18.4546 25.9786,18.3166 25.9116,18.1016 C25.4976,16.7576 24.2746,15.8066 22.8686,15.7336 C22.5916,15.7186 22.3796,15.4836 22.3946,15.2076 C22.4096,14.9336 22.6256,14.7236 22.9186,14.7346 C24.7436,14.8296 26.3296,16.0636 26.8676,17.8076 C26.9496,18.0716 26.8006,18.3506 26.5366,18.4326 C26.4886,18.4476 26.4386,18.4546 26.3896,18.4546 Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (HotWaterOn);

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HubNano1=function HubNano1(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.34,10.62a1,1,0,0,1,1,1V28.34a1,1,0,0,1-1,1H11.66a1,1,0,0,1-1-1V11.66a1,1,0,0,1,1-1H28.34m0-1H11.66a2,2,0,0,0-2,2V28.34a2,2,0,0,0,2,2H28.34a2,2,0,0,0,2-2V11.66a2,2,0,0,0-2-2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'20',cy:'20',r:'1.02'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.62,23.16a.5.5,0,0,1-.33-.13,4.07,4.07,0,0,1,0-6.07.5.5,0,0,1,.67.75,3.07,3.07,0,0,0,0,4.58.5.5,0,0,1-.33.87Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.25,24.69a.5.5,0,0,1-.33-.13,6.12,6.12,0,0,1,0-9.12.5.5,0,1,1,.67.75,5.12,5.12,0,0,0,0,7.63.5.5,0,0,1-.33.87Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.38,23.16a.5.5,0,0,1-.33-.87,3.07,3.07,0,0,0,0-4.58.5.5,0,1,1,.67-.75,4.07,4.07,0,0,1,0,6.07A.5.5,0,0,1,22.38,23.16Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.74,24.69a.5.5,0,0,1-.33-.87,5.12,5.12,0,0,0,0-7.63.5.5,0,0,1,.67-.75,6.12,6.12,0,0,1,0,9.12A.5.5,0,0,1,23.74,24.69Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (HubNano1);

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HubNano2=function HubNano2(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.43,9.07a1.49,1.49,0,0,1,1.5,1.55V28.92c0,1.86-.68,2-1.5,2H23.2a4.52,4.52,0,0,1-2.48-.64,14.81,14.81,0,0,0-2.36-1,22.59,22.59,0,0,0-4.74-1h-3a1.85,1.85,0,0,1-1.55-1.66v-16a1.56,1.56,0,0,1,1.56-1.56h18.8m0-1H10.63a2.56,2.56,0,0,0-2.56,2.56v16a2.82,2.82,0,0,0,2.55,2.66h2.94a21.7,21.7,0,0,1,4.5,1,13.77,13.77,0,0,1,2.22.92,5.5,5.5,0,0,0,2.93.74h6.23c1.37,0,2.5-.6,2.5-3V10.63a2.48,2.48,0,0,0-2.5-2.55Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'27.04',cy:'12.96',r:'1.98'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'27.04',cy:'18.24',r:'1.98'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'27.04',cy:'23.52',r:'1.98'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (HubNano2);

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Humidity=function Humidity(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.83,23.6A2.57,2.57,0,1,1,18.39,21,2.57,2.57,0,0,1,15.83,23.6Zm0-4.13A1.57,1.57,0,1,0,17.39,21,1.57,1.57,0,0,0,15.83,19.47Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.09,30.58A2.57,2.57,0,1,1,26.66,28,2.57,2.57,0,0,1,24.09,30.58Zm0-4.13A1.57,1.57,0,1,0,25.66,28,1.57,1.57,0,0,0,24.09,26.44Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.1,30a.5.5,0,0,1-.35-.85L25,18.92a.5.5,0,0,1,.71.71L15.46,29.86A.5.5,0,0,1,15.1,30Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A10.9,10.9,0,0,1,9.15,25.32c0-.07,0-.13,0-.2l.06-1.18A15,15,0,0,1,11,17.8L17.86,5.27a2.44,2.44,0,0,1,4.29,0L29,17.78a15.16,15.16,0,0,1,1.82,6.15v.16a8.27,8.27,0,0,1,.06,1.06A10.87,10.87,0,0,1,20,36ZM20,5a1.42,1.42,0,0,0-1.27.75L11.91,18.28A14,14,0,0,0,10.21,24l-.06,1.3a9.86,9.86,0,0,0,19.71-.16,8.24,8.24,0,0,0-.06-1V24a14.15,14.15,0,0,0-1.7-5.71L21.27,5.75A1.42,1.42,0,0,0,20,5Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Humidity);

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LeakSensor=function LeakSensor(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21,36l-1,0c-3.25.16-5.39-.4-6.9-1.8s-2.29-3.59-2.4-6.87C10.5,23,11.92,20.17,14.87,19l.3.42L15,19a8.22,8.22,0,0,1,.8-.32,7.69,7.69,0,0,0,2.37-1.12A2.87,2.87,0,0,1,20,16.75a3.56,3.56,0,0,1,1.82.73,11.09,11.09,0,0,0,2.43,1.17c.39.15.66.26.8.34,3,1.18,4.44,4,4.3,8.32-.11,3.28-.87,5.46-2.4,6.87C25.6,35.42,23.7,36,21,36Zm-1-1,1,0c2.49,0,4.12-.48,5.29-1.56,1.32-1.22,2-3.18,2.08-6.17.13-3.88-1.07-6.34-3.58-7.32l-.17-.07c-.14-.07-.37-.16-.69-.29a9.66,9.66,0,0,1-2.81-1.43A3.13,3.13,0,0,0,20,17.75a2,2,0,0,0-1.08.41A7.37,7.37,0,0,1,16.1,19.6a7.21,7.21,0,0,0-.69.27l-.14.06c-2.55,1-3.76,3.46-3.63,7.34.1,3,.76,5,2.08,6.17S17,35.12,20,35Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'5.96',width:'1',x:'19.5',y:'11.29'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,11.79a2.37,2.37,0,0,1-2.31-2.24V6.31a2.31,2.31,0,0,1,4.63,0V9.55A2.37,2.37,0,0,1,20,11.79ZM20,5a1.32,1.32,0,0,0-1.31,1.31V9.55a1.32,1.32,0,0,0,2.63,0V6.31A1.32,1.32,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,33.53a6.44,6.44,0,1,1,6.44-6.44A6.44,6.44,0,0,1,20,33.53Zm0-11.87a5.44,5.44,0,1,0,5.44,5.44A5.44,5.44,0,0,0,20,21.65Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (LeakSensor);

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Light=function Light(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27,17.7H13A1.49,1.49,0,0,1,11.53,17a10.32,10.32,0,0,1-.91-4.21C10.62,7.95,14.82,4,20,4c8.7,0,9.34,7.68,9.36,8a10.38,10.38,0,0,1-.9,5A1.49,1.49,0,0,1,27,17.7ZM20,5c-4.61,0-8.37,3.5-8.37,7.8a9.3,9.3,0,0,0,.8,3.76c0,.07.11.14.56.14H27c.45,0,.53-.07.56-.14a9.42,9.42,0,0,0,.8-4.43h0C28.34,11.82,27.89,5,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21.77,36H18.21a2.38,2.38,0,0,1-2.4-2.29v-.77a1.5,1.5,0,0,1-.45-.88l-.06-.48a33.66,33.66,0,0,0-1-5.41,33.15,33.15,0,0,0-1.35-3.61A5.77,5.77,0,0,1,12.25,20c0-1.5,1.43-1.5,1.9-1.5H26c.65,0,1.12,0,1.45.34A1.53,1.53,0,0,1,27.78,20a5.76,5.76,0,0,1-.7,2.55,31.28,31.28,0,0,0-1.39,3.67,33.62,33.62,0,0,0-1,5.4l-.06.47a1.49,1.49,0,0,1-.37.8v.77A2.46,2.46,0,0,1,21.77,36ZM14.15,19.51c-.9,0-.9.21-.9.5a4.9,4.9,0,0,0,.6,2.16,34,34,0,0,1,1.39,3.71,33.94,33.94,0,0,1,1,5.59l.06.47a.49.49,0,0,0,.22.34l.24.15v1.29A1.37,1.37,0,0,0,18.21,35h3.56a1.45,1.45,0,0,0,1.48-1.37V32.4l.19-.15a.49.49,0,0,0,.19-.32l.06-.46a34.47,34.47,0,0,1,1-5.58,32.16,32.16,0,0,1,1.43-3.77A4.81,4.81,0,0,0,26.78,20a.91.91,0,0,0-.05-.43,3.61,3.61,0,0,0-.74,0Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'7.46',x:'16.27',y:'32.26'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25,12.17a.5.5,0,0,1-.5-.5c0-1.35-1.21-2.52-3-2.87a.5.5,0,0,1,.19-1c2.21.44,3.76,2,3.76,3.85A.5.5,0,0,1,25,12.17Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Light);

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Light=function Light(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.6651595,27.7179565 L11.69666,27.4533498 C11.7915935,26.6549569 11.9891578,24.9930232 12.366326,23.7445786 C12.7383627,22.5147477 13.0539524,21.7761844 13.2848717,21.2370531 C13.5478631,20.6214728 13.6800003,20.3116884 13.6800003,19.8084549 C13.6800003,19.5804376 13.6479282,19.5279205 13.6466453,19.5259262 C13.6004614,19.4993352 13.3618448,19.5026591 13.1706949,19.5 L5.57537395,19.5 C5,19.5 5,19.6382729 5,19.8310572 C5,20.3429328 5.12957139,20.6520524 5.38678985,21.2682974 C5.60872896,21.7987867 5.91213128,22.5247193 6.27775352,23.734607 C6.65492173,24.9810573 6.84478871,26.5864852 6.94677808,27.4486964 L6.97939253,27.7179565 L11.6651595,27.7179565 Z M11.4157082,28.7179565 L7.27904531,28.7179565 L7.27904531,28.9444367 C7.27904531,29.4084486 7.69149285,29.8000002 8.17963062,29.8000002 L10.4650903,29.8000002 C10.9801687,29.8000002 11.4157082,29.3845168 11.4157082,28.8925844 L11.4157082,28.7179565 Z M4.62113007,17.7167171 C4.39425436,17.7167171 3.86212769,17.7167171 3.62287695,17.2457781 C3.1931881,16.3974005 3,15.1791467 3,14.3479566 C3,11.0128837 5.88888403,8.30000019 9.43914512,8.30000019 C15.4190388,8.30000019 15.8597277,13.5793292 15.8769152,13.833705 C15.9635405,14.9502085 15.7077897,16.3527129 15.2561008,17.2444031 C15.0161626,17.7167171 14.4840359,17.7167171 14.2571602,17.7167171 L4.62113007,17.7167171 Z M4,14.2460326 C4,15.064345 4.21319259,16.0456855 4.51868196,16.6330942 C4.54013122,16.6749614 4.58887952,16.7200003 4.8826693,16.7200003 L13.9927525,16.7200003 C14.2865423,16.7200003 14.3352906,16.674327 14.3573898,16.6318255 C14.7304768,15.9137405 14.9488692,14.7313108 14.8760718,13.8197489 C14.8656721,13.6269063 14.5738323,9.30000019 9.4377109,9.30000019 C6.43936517,9.30000019 4,11.5189589 4,14.2460326 Z M8.0954503,30.5271626 C7.1989475,30.5271626 6.44269513,29.8073478 6.44269513,28.9548452 L6.44269513,28.426156 C6.27563211,28.2666555 6.16356926,28.0514673 6.13331917,27.8218416 L6.09206904,27.4918406 C5.99238123,26.6833381 5.78681808,25.0017078 5.40112938,23.772454 C5.01956569,22.5555752 4.7026272,21.8233854 4.47162647,21.2898837 C4.17737555,20.6113191 4,20.2015678 4,19.5298782 C4,18.5 4.98175307,18.5 5.30419158,18.5 L13.4435295,18.5 C13.8904059,18.50275 14.2107819,18.498625 14.4431576,18.7310007 C14.6507833,18.9379389 14.6782834,19.2390648 14.6782834,19.5065031 C14.6782834,20.1726927 14.4864703,20.6058191 14.1956569,21.2623836 C13.9550311,21.8048228 13.6257176,22.5480127 13.2393414,23.7827665 C12.8529652,25.0140829 12.6467145,26.6909006 12.5477142,27.4966531 L12.5071516,27.8211541 C12.480339,28.0239673 12.3889012,28.2157804 12.2514008,28.3684058 L12.2514008,28.90122 C12.2514008,29.7825978 11.4697108,30.5271626 10.5450205,30.5271626 L8.0954503,30.5271626 Z M30.8141934,32.257 L30.8246,32.2489 C30.9266,32.1699 30.9946,32.0539 31.0116,31.9319 L31.0686,31.4699 C31.2166,30.2689 31.5246,27.7689 32.1126,25.8909 C32.6926,24.0409 33.1846,22.9299 33.5446,22.1189 C33.9546,21.1929 34.1606,20.7269 34.1606,19.9699 C34.1606,19.6269 34.1106,19.5479 34.1086,19.5449 C34.0366,19.5049 33.6646,19.5099 33.3666,19.5059 L21.5256,19.5059 C20.6286,19.5059 20.6286,19.7139 20.6286,20.0039 C20.6286,20.7739 20.8306,21.2389 21.2316,22.1659 C21.5776,22.9639 22.0506,24.0559 22.6206,25.8759 C23.2086,27.7509 23.5046,30.1659 23.6636,31.4629 L23.7226,31.9329 C23.7400129,32.0612055 23.8111803,32.180272 23.9160885,32.257 L30.8141934,32.257 Z M30.6306,33.257 L24.1816,33.257 L24.1816,33.7129 C24.1816,34.4109 24.8246,34.9999 25.5856,34.9999 L29.1486,34.9999 C29.9516,34.9999 30.6306,34.3749 30.6306,33.6349 L30.6306,33.257 Z M34.374,17.697 L20.358,17.697 C20.028,17.697 19.254,17.697 18.906,17.012 C18.281,15.778 18,14.006 18,12.797 C18,7.946 22.202,4 27.366,4 C36.064,4 36.705,11.679 36.73,12.049 C36.856,13.673 36.484,15.713 35.827,17.01 C35.478,17.697 34.704,17.697 34.374,17.697 Z M27.366,5 C22.753,5 19,8.498 19,12.797 C19,14.087 19.328,15.634 19.798,16.56 C19.831,16.626 19.906,16.697 20.358,16.697 L34.374,16.697 C34.826,16.697 34.901,16.625 34.935,16.558 C35.509,15.426 35.845,13.562 35.733,12.125 L35.732,12.112 C35.717,11.821 35.268,5 27.366,5 Z M29.1486,35.9999 L25.5856,35.9999 C24.2816,35.9999 23.1816,34.9529 23.1816,33.7129 L23.1816,32.9439 C22.9386,32.7119 22.7756,32.3989 22.7316,32.0649 L22.6716,31.5849 C22.5266,30.4089 22.2276,27.9629 21.6666,26.1749 C21.1116,24.4049 20.6506,23.3399 20.3146,22.5639 C19.8866,21.5769 19.6286,20.9809 19.6286,20.0039 C19.6286,18.5059 21.0566,18.5059 21.5256,18.5059 L33.3646,18.5059 C34.0146,18.5099 34.4806,18.5039 34.8186,18.8419 C35.1206,19.1429 35.1606,19.5809 35.1606,19.9699 C35.1606,20.9389 34.8816,21.5689 34.4586,22.5239 C34.1086,23.3129 33.6296,24.3939 33.0676,26.1899 C32.5056,27.9809 32.2056,30.4199 32.0616,31.5919 L32.0026,32.0639 C31.9636,32.3589 31.8306,32.6379 31.6306,32.8599 L31.6306,33.6349 C31.6306,34.9169 30.4936,35.9999 29.1486,35.9999 Z M32.3645,12.167 C32.0885,12.167 31.8645,11.943 31.8645,11.667 C31.8645,10.321 30.6505,9.143 28.9115,8.801 C28.6405,8.748 28.4645,8.485 28.5175,8.214 C28.5705,7.943 28.8335,7.766 29.1045,7.82 C31.3185,8.255 32.8645,9.837 32.8645,11.667 C32.8645,11.943 32.6405,12.167 32.3645,12.167 Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Light);

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LinkBroken=function LinkBroken(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.87,27.33a2,2,0,0,1-1.79-1.14L4.18,20a2,2,0,0,1,1-2.62l7.69-3.59a2,2,0,0,1,2.62,1l2.9,6.21a2,2,0,0,1-1,2.62L9.7,27.14A2,2,0,0,1,8.87,27.33Zm4.79-12.74a1,1,0,0,0-.41.09L5.56,18.27a1,1,0,0,0-.47,1.29L8,25.77a1,1,0,0,0,1.29.47L17,22.65a1,1,0,0,0,.47-1.29l-2.9-6.21a1,1,0,0,0-.88-.56Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.15,19.61a.5.5,0,0,1-.21-1L17.49,17a.5.5,0,1,1,.42.91l-3.55,1.65A.5.5,0,0,1,14.15,19.61Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.13,27.33a2,2,0,0,1-.83-.18l-7.69-3.59a2,2,0,0,1-1-2.62l2.9-6.21a2,2,0,0,1,2.62-1l7.69,3.59a2,2,0,0,1,1,2.62l-2.9,6.21A2,2,0,0,1,31.13,27.33ZM23,22.65l7.69,3.59A1,1,0,0,0,32,25.77l2.9-6.21a1,1,0,0,0-.47-1.29l-7.69-3.59a1,1,0,0,0-1.29.47l-2.9,6.21A1,1,0,0,0,23,22.65Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.85,19.61a.5.5,0,0,1-.21,0l-3.55-1.65a.5.5,0,1,1,.42-.91l3.55,1.65a.5.5,0,0,1-.21,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.06,24.39l-.13,0a.5.5,0,0,1-.35-.61L21.45,13a.5.5,0,0,1,1,.26L19.55,24A.5.5,0,0,1,19.06,24.39Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (LinkBroken);

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Linked=function Linked(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.7,26.6H6.48A2.48,2.48,0,0,1,4,24.12V15.88A2.48,2.48,0,0,1,6.48,13.4H16.7a2.48,2.48,0,0,1,2.48,2.48v8.25A2.48,2.48,0,0,1,16.7,26.6ZM6.48,14.4A1.48,1.48,0,0,0,5,15.88v8.25A1.48,1.48,0,0,0,6.48,25.6H16.7a1.48,1.48,0,0,0,1.48-1.48V15.88A1.48,1.48,0,0,0,16.7,14.4Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,26.6H23.3a2.48,2.48,0,0,1-2.48-2.48V15.88A2.48,2.48,0,0,1,23.3,13.4H33.52A2.48,2.48,0,0,1,36,15.88v8.25A2.48,2.48,0,0,1,33.52,26.6ZM23.3,14.4a1.48,1.48,0,0,0-1.48,1.48v8.25A1.48,1.48,0,0,0,23.3,25.6H33.52A1.48,1.48,0,0,0,35,24.12V15.88a1.48,1.48,0,0,0-1.48-1.48Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.76,20.5H13.24a.5.5,0,1,1,0-1H26.76a.5.5,0,1,1,0,1Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Linked);

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LongPress=function LongPress(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.92,26.57a.5.5,0,0,1-.5-.5V9.91c0-1.6,1-2.52,2.78-2.52S18,8.3,18,9.91V21a.5.5,0,0,1-1,0V9.91c0-.65-.18-1.52-1.78-1.52s-1.78.87-1.78,1.52V26.07A.5.5,0,0,1,12.92,26.57Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.56,23a.5.5,0,0,1-.5-.5v-3.8c0-1.89-.53-2.31-1.44-2.39s-1.21.2-1.21.21a.48.48,0,0,1-.69.11.51.51,0,0,1-.11-.71c.09-.12.6-.73,2.1-.6,2.08.19,2.35,1.91,2.35,3.39v3.8A.5.5,0,0,1,25.56,23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.56,35.93a.5.5,0,0,1-.36-.85,13.49,13.49,0,0,0,3.14-8.86c0-2.35,0-3.4-.17-5.36a2.75,2.75,0,0,0-.73-2,2.19,2.19,0,0,0-1.76-.25.5.5,0,0,1-.16-1,3.1,3.1,0,0,1,2.54.46,3.59,3.59,0,0,1,1.11,2.76c.13,2,.17,3,.17,5.42a14.24,14.24,0,0,1-3.42,9.56A.5.5,0,0,1,25.56,35.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.31,36a.49.49,0,0,1-.31-.11,28.27,28.27,0,0,1-4.79-4.71,8.29,8.29,0,0,1-1.65-5.81,34.22,34.22,0,0,1,.26-3.77c.19-1.75,1.2-2.84,2.62-2.84a7.27,7.27,0,0,1,1.55.16.5.5,0,1,1-.28,1,6.83,6.83,0,0,0-1.27-.12c-.88,0-1.49.73-1.63,2a34.17,34.17,0,0,0-.25,3.66A7.36,7.36,0,0,0,11,30.6a27.84,27.84,0,0,0,4.58,4.5.5.5,0,0,1-.31.89Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22,22a.5.5,0,0,1-.5-.5V17.66C21.52,15,20.2,15,19.77,15a3.89,3.89,0,0,0-1.93.4.5.5,0,0,1-.69-.15.5.5,0,0,1,.14-.69A4.63,4.63,0,0,1,19.77,14c1,0,2.76.48,2.76,3.68v3.86A.5.5,0,0,1,22,22Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.42,10a.5.5,0,0,1-.5-.5,4.64,4.64,0,0,0-9.28,0,.5.5,0,0,1-1,0,5.64,5.64,0,0,1,11.28,0A.5.5,0,0,1,20.42,10Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.2,12.6A4.2,4.2,0,0,1,23,8.44a4.24,4.24,0,0,1,8.47,0A4.2,4.2,0,0,1,27.2,12.6Zm0-7.32A3.2,3.2,0,0,0,24,8.44a3.24,3.24,0,0,0,6.47,0A3.2,3.2,0,0,0,27.2,5.28Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.1,8.87H26.58V5.94a.5.5,0,1,1,1,0V7.87H29.1a.5.5,0,0,1,0,1Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (LongPress);

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var MotionSensor=function MotionSensor(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,23.63A3.63,3.63,0,1,1,23.63,20,3.64,3.64,0,0,1,20,23.63Zm0-6.27A2.63,2.63,0,1,0,22.63,20,2.64,2.64,0,0,0,20,17.37Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.06,28a.5.5,0,0,1-.31-.11,10.06,10.06,0,0,1,0-15.78.5.5,0,0,1,.62.78,9.06,9.06,0,0,0,0,14.21.5.5,0,0,1-.31.89Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M9.78,32.15A.5.5,0,0,1,9.45,32,16,16,0,0,1,9.45,8a.5.5,0,1,1,.66.75,15,15,0,0,0,0,22.55.5.5,0,0,1-.33.88Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.94,28a.5.5,0,0,1-.31-.89,9.06,9.06,0,0,0,0-14.21.5.5,0,1,1,.62-.78,10.06,10.06,0,0,1,0,15.78A.49.49,0,0,1,25.94,28Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.22,32.15a.5.5,0,0,1-.33-.88,15,15,0,0,0,0-22.55A.5.5,0,1,1,30.55,8a16,16,0,0,1,0,24.05A.5.5,0,0,1,30.22,32.15Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (MotionSensor);

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var OneTap=function OneTap(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.15,26.84a.5.5,0,0,1-.5-.5V10c0-1.6,1-2.51,2.74-2.51s2.74.92,2.74,2.51V20.87a.5.5,0,0,1-1,0V10c0-.65-.18-1.51-1.74-1.51s-1.74.86-1.74,1.51V26.34A.5.5,0,0,1,14.15,26.84Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.59,23.36a.5.5,0,0,1-.5-.5V18.78c0-1.87-.56-2.3-1.46-2.38a1.93,1.93,0,0,0-1.36.22.51.51,0,0,1-.7,0,.49.49,0,0,1,0-.69,2.71,2.71,0,0,1,2.14-.49c2.12.2,2.36,2,2.36,3.38v4.08A.5.5,0,0,1,26.59,23.36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.49,35.93a.5.5,0,0,1-.36-.85,13.55,13.55,0,0,0,3.08-8.83c0-2.34,0-3.39-.17-5.34a2.76,2.76,0,0,0-.71-2.06,2.09,2.09,0,0,0-1.67-.24.5.5,0,0,1-.16-1,3,3,0,0,1,2.46.44A3.79,3.79,0,0,1,30,20.85c.13,2,.17,3,.17,5.41a14.3,14.3,0,0,1-3.36,9.52A.5.5,0,0,1,26.49,35.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.42,36a.5.5,0,0,1-.31-.11,27.93,27.93,0,0,1-4.7-4.7,8.34,8.34,0,0,1-1.62-5.79A34.94,34.94,0,0,1,10,21.65c.19-1.74,1.18-2.83,2.58-2.83a7.06,7.06,0,0,1,1.53.16.5.5,0,0,1-.29,1,6.52,6.52,0,0,0-1.24-.11c-.86,0-1.46.73-1.59,2a34.56,34.56,0,0,0-.25,3.65,7.41,7.41,0,0,0,1.44,5.2,27.56,27.56,0,0,0,4.5,4.49.5.5,0,0,1-.31.89Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.11,21.87a.5.5,0,0,1-.5-.5V17.72c0-1.77-.59-2.67-1.76-2.67a4.49,4.49,0,0,0-1.91.32.5.5,0,0,1-.48-.88,5.18,5.18,0,0,1,2.39-.44c1.75,0,2.76,1.34,2.76,3.67v3.65A.5.5,0,0,1,23.11,21.87Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22,10.55a.5.5,0,0,1-.5-.5,5.09,5.09,0,0,0-10.19,0,.5.5,0,0,1-1,0,6.09,6.09,0,0,1,12.19,0A.5.5,0,0,1,22,10.55Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (OneTap);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PhilipsHueBridge=function PhilipsHueBridge(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,Object.assign({},gProps,{transform:'translate(4.000000, 4.000000)'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8,0 L24,0 C28.418278,-8.11624501e-16 32,3.581722 32,8 L32,24 C32,28.418278 28.418278,32 24,32 L8,32 C3.581722,32 5.41083001e-16,28.418278 0,24 L0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z M8,1 C4.13400675,1 1,4.13400675 1,8 L1,24 C1,27.8659932 4.13400675,31 8,31 L24,31 C27.8659932,31 31,27.8659932 31,24 L31,8 C31,4.13400675 27.8659932,1 24,1 L8,1 Z M16,21.5 C12.9624339,21.5 10.5,19.0375661 10.5,16 C10.5,12.9624339 12.9624339,10.5 16,10.5 C18.0058891,10.5 19.822706,11.5833535 20.7914963,13.2979189 C21.2535771,14.1157096 21.5,15.0405238 21.5,16 C21.5,19.0375661 19.0375661,21.5 16,21.5 Z M16,20.5 C18.4852814,20.5 20.5,18.4852814 20.5,16 C20.5,15.2140458 20.2986857,14.4585222 19.9208657,13.7898562 C19.1277145,12.386137 17.6416357,11.5 16,11.5 C13.5147186,11.5 11.5,13.5147186 11.5,16 C11.5,18.4852814 13.5147186,20.5 16,20.5 Z M15.98,4 C17.0735238,4 17.96,4.8864762 17.96,5.98000002 C17.96,7.07352383 17.0735238,7.96000004 15.98,7.96000004 C14.8864762,7.96000004 14,7.07352383 14,5.98000002 C14,4.8864762 14.8864762,4 15.98,4 Z M22.98,4 C24.0735238,4 24.96,4.8864762 24.96,5.98000002 C24.96,7.07352383 24.0735238,7.96000004 22.98,7.96000004 C21.8864762,7.96000004 21,7.07352383 21,5.98000002 C21,4.8864762 21.8864762,4 22.98,4 Z M8.98000002,4 C10.0735238,4 10.96,4.8864762 10.96,5.98000002 C10.96,7.07352383 10.0735238,7.96000004 8.98000002,7.96000004 C7.8864762,7.96000004 7,7.07352383 7,5.98000002 C7,4.8864762 7.8864762,4 8.98000002,4 Z'})));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (PhilipsHueBridge);

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PlugEU=function PlugEU(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.4559,36 L16.5439,36 C13.7229,36 11.4269,33.704 11.4269,30.883 L11.4269,9.117 C11.4269,6.296 13.7229,4 16.5439,4 L23.4559,4 C26.2769,4 28.5729,6.296 28.5729,9.117 L28.5729,30.883 C28.5729,33.704 26.2769,36 23.4559,36 Z M16.5439,5 C14.2729,5 12.4269,6.847 12.4269,9.117 L12.4269,30.883 C12.4269,33.153 14.2729,35 16.5439,35 L23.4559,35 C25.7269,35 27.5729,33.153 27.5729,30.883 L27.5729,9.117 C27.5729,6.847 25.7269,5 23.4559,5 L16.5439,5 Z M17.615937,26.7041 C18.1680098,26.7041 18.6156,27.1515394 18.6156,27.7041 C18.6156,28.2566606 18.1680098,28.7041 17.615937,28.7041 C17.0631902,28.7041 16.6156,28.2566606 16.6156,27.7041 C16.6156,27.1515394 17.0631902,26.7041 17.615937,26.7041 Z M22.417063,26.7041 C22.9698098,26.7041 23.4174,27.1515394 23.4174,27.7041 C23.4174,28.2566606 22.9698098,28.7041 22.417063,28.7041 C21.8649902,28.7041 21.4174,28.2566606 21.4174,27.7041 C21.4174,27.1515394 21.8649902,26.7041 22.417063,26.7041 Z M14.7236,11.1924 C14.7166,11.1924 14.7086,11.1924 14.7016,11.1914 C14.4246,11.1794 14.2116,10.9454 14.2246,10.6704 C14.3046,8.8854 15.5436,7.3394 17.2386,6.9104 C17.5076,6.8384 17.7776,7.0044 17.8456,7.2714 C17.9136,7.5394 17.7516,7.8114 17.4846,7.8794 C16.2136,8.2024 15.2846,9.3684 15.2226,10.7144 C15.2106,10.9834 14.9906,11.1924 14.7236,11.1924 Z M20,33.5 C16.6862915,33.5 14,30.8137085 14,27.5 C14,24.1862915 16.6862915,21.5 20,21.5 C23.3137085,21.5 26,24.1862915 26,27.5 C26,30.8137085 23.3137085,33.5 20,33.5 Z M20,32.5 C22.7614237,32.5 25,30.2614237 25,27.5 C25,24.7385763 22.7614237,22.5 20,22.5 C17.2385763,22.5 15,24.7385763 15,27.5 C15,30.2614237 17.2385763,32.5 20,32.5 Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (PlugEU);

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PlugIN=function PlugIN(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.72,11.19h0a.5.5,0,0,1-.48-.52,4.07,4.07,0,0,1,3-3.76.5.5,0,0,1,.25,1,3.07,3.07,0,0,0-2.26,2.84A.5.5,0,0,1,14.72,11.19Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.46,36H16.54a5.12,5.12,0,0,1-5.12-5.12V9.12A5.12,5.12,0,0,1,16.54,4h6.91a5.12,5.12,0,0,1,5.12,5.12V30.88A5.12,5.12,0,0,1,23.46,36ZM16.54,5a4.12,4.12,0,0,0-4.12,4.12V30.88A4.12,4.12,0,0,0,16.54,35h6.91a4.12,4.12,0,0,0,4.12-4.12V9.12A4.12,4.12,0,0,0,23.46,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'20',cy:'23.89',r:'1.53'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'16.95',cy:'29.22',r:'1.53'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'23.05',cy:'29.22',r:'1.53'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (PlugIN);

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PlugNA=function PlugNA(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.72,11.19h0a.5.5,0,0,1-.48-.52,4.07,4.07,0,0,1,3-3.76.5.5,0,1,1,.25,1,3.07,3.07,0,0,0-2.26,2.84A.5.5,0,0,1,14.72,11.19Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.46,36H16.54a5.12,5.12,0,0,1-5.12-5.12V9.12A5.12,5.12,0,0,1,16.54,4h6.91a5.12,5.12,0,0,1,5.12,5.12V30.88A5.12,5.12,0,0,1,23.46,36ZM16.54,5a4.12,4.12,0,0,0-4.12,4.12V30.88A4.12,4.12,0,0,0,16.54,35h6.91a4.12,4.12,0,0,0,4.12-4.12V9.12A4.12,4.12,0,0,0,23.46,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16,23.56a.46.46,0,0,0-.5.41v3.71a.51.51,0,0,0,1,0V24A.46.46,0,0,0,16,23.56Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24,23.56a.46.46,0,0,0-.5.41v3.71a.51.51,0,0,0,1,0V24A.46.46,0,0,0,24,23.56Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,28.88a.46.46,0,0,0-.5.41v2.06a.51.51,0,0,0,1,0V29.29A.46.46,0,0,0,20,28.88Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (PlugNA);

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PlugUK=function PlugUK(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.72,11.19h0a.5.5,0,0,1-.48-.52,4.07,4.07,0,0,1,3-3.76.5.5,0,0,1,.25,1,3.07,3.07,0,0,0-2.26,2.84A.5.5,0,0,1,14.72,11.19Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.46,36H16.54a5.12,5.12,0,0,1-5.12-5.12V9.12A5.12,5.12,0,0,1,16.54,4h6.91a5.12,5.12,0,0,1,5.12,5.12V30.88A5.12,5.12,0,0,1,23.46,36ZM16.54,5a4.12,4.12,0,0,0-4.12,4.12V30.88A4.12,4.12,0,0,0,16.54,35h6.91a4.12,4.12,0,0,0,4.12-4.12V9.12A4.12,4.12,0,0,0,23.46,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.3,29.07c0-.28-.12-.5-.27-.5H14.57c-.15,0-.27.22-.27.5s.12.5.27.5H17C17.17,29.57,17.3,29.35,17.3,29.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.7,29.07c0-.28-.12-.5-.27-.5H23c-.15,0-.27.22-.27.5s.12.5.27.5h2.45C25.58,29.57,25.7,29.35,25.7,29.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.25,21.32a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,1,0v-3A.5.5,0,0,0,20.25,21.32Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (PlugUK);

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Sense=function Sense(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,9.47c-2.3,0-6.2-.42-6.2-2s3.9-2,6.2-2,6.2.42,6.2,2S22.3,9.47,20,9.47Zm0-3c-3.13,0-5.05.67-5.2,1,.15.3,2.08,1,5.2,1s5-.64,5.19-1C25,7.1,23.05,6.47,20,6.47Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,10.94c-5.25,0-10.56-1.19-10.56-3.47S14.75,4,20,4,30.56,5.19,30.56,7.47,25.25,10.94,20,10.94ZM20,5c-5.83,0-9.56,1.46-9.56,2.47S14.17,9.94,20,9.94s9.56-1.46,9.56-2.47S25.83,5,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,30.39c-5.25,0-10.56-1.19-10.56-3.47a.5.5,0,0,1,1,0c0,1,3.72,2.47,9.56,2.47s9.56-1.46,9.56-2.47a.5.5,0,0,1,1,0C30.56,29.2,25.25,30.39,20,30.39Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.13,36H16.87a7.43,7.43,0,0,1-7.43-7.43V7.47a.5.5,0,0,1,1,0V28.57A6.43,6.43,0,0,0,16.87,35h6.27a6.43,6.43,0,0,0,6.43-6.43V7.47a.5.5,0,1,1,1,0V28.57A7.43,7.43,0,0,1,23.13,36Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Sense);

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SignalBoost=function SignalBoost(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'26.93',cy:'26.74',r:'1.98'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (SignalBoost);

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SignalBoosterPlug=function SignalBoosterPlug(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15,5 C13.3431458,5 12,6.34314575 12,8 L12,27 C12,31.418278 15.581722,35 20,35 C24.418278,35 28,31.418278 28,27 L28,8 C28,6.34314575 26.6568542,5 25,5 L15,5 Z M15,4 L25,4 C27.209139,4 29,5.790861 29,8 L29,27 C29,31.9705627 24.9705627,36 20,36 C15.0294373,36 11,31.9705627 11,27 L11,8 C11,5.790861 12.790861,4 15,4 Z M22.5,19 C22.2238576,19 22,19.2238576 22,19.5 C22,19.7761424 22.2238576,20 22.5,20 L25.5,20 C25.7761424,20 26,19.7761424 26,19.5 C26,19.2238576 25.7761424,19 25.5,19 L22.5,19 Z M14.5,19 C14.2238576,19 14,19.2238576 14,19.5 C14,19.7761424 14.2238576,20 14.5,20 L17.5,20 C17.7761424,20 18,19.7761424 18,19.5 C18,19.2238576 17.7761424,19 17.5,19 L14.5,19 Z M20,12 C19.724,12 19.5,12.224 19.5,12.5 L19.5,15.5 C19.5,15.776 19.724,16 20,16 C20.276,16 20.5,15.776 20.5,15.5 L20.5,12.5 C20.5,12.224 20.276,12 20,12 Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (SignalBoosterPlug);

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SocketEU=function SocketEU(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,28.58A8.58,8.58,0,1,1,28.58,20,8.59,8.59,0,0,1,20,28.58Zm0-16.16A7.58,7.58,0,1,0,27.58,20,7.59,7.59,0,0,0,20,12.42Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'16.54',cy:'20',r:'1.48'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'23.46',cy:'20',r:'1.48'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (SocketEU);

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SocketIN=function SocketIN(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M34.18,36H5.82A1.82,1.82,0,0,1,4,34.18V5.82A1.82,1.82,0,0,1,5.82,4H34.18A1.82,1.82,0,0,1,36,5.82V34.18A1.82,1.82,0,0,1,34.18,36ZM5.82,5A.82.82,0,0,0,5,5.82V34.18a.82.82,0,0,0,.82.82H34.18a.82.82,0,0,0,.82-.82V5.82A.82.82,0,0,0,34.18,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'20',cy:'16.54',r:'1.98'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'16.04',cy:'23.46',r:'1.98'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'23.96',cy:'23.46',r:'1.98'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (SocketIN);

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SocketNA=function SocketNA(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M34.18,36H5.82A1.82,1.82,0,0,1,4,34.18V5.82A1.82,1.82,0,0,1,5.82,4H34.18A1.82,1.82,0,0,1,36,5.82V34.18A1.82,1.82,0,0,1,34.18,36ZM5.82,5A.82.82,0,0,0,5,5.82V34.18a.82.82,0,0,0,.82.82H34.18a.82.82,0,0,0,.82-.82V5.82A.82.82,0,0,0,34.18,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.08,28.58H14.86l-2.08-4.22a9.25,9.25,0,0,1,0-9.69l2.1-3.25H25l2.2,3.46a9,9,0,0,1,0,9.41Zm-9.59-1h9l1.91-3.77a8,8,0,0,0,0-8.39l-1.9-3h-9l-1.8,2.79a8.26,8.26,0,0,0,0,8.67Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16,15.89a.46.46,0,0,0-.5.41V20a.51.51,0,0,0,1,0V16.31A.46.46,0,0,0,16,15.89Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24,15.89a.46.46,0,0,0-.5.41V20a.51.51,0,0,0,1,0V16.31A.46.46,0,0,0,24,15.89Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,21.21a.46.46,0,0,0-.5.41v2.06a.51.51,0,0,0,1,0V21.62A.46.46,0,0,0,20,21.21Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (SocketNA);

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SocketUK=function SocketUK(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M34.18,36H5.82A1.82,1.82,0,0,1,4,34.18V5.82A1.82,1.82,0,0,1,5.82,4H34.18A1.82,1.82,0,0,1,36,5.82V34.18A1.82,1.82,0,0,1,34.18,36ZM5.82,5A.82.82,0,0,0,5,5.82V34.18a.82.82,0,0,0,.82.82H34.18a.82.82,0,0,0,.82-.82V5.82A.82.82,0,0,0,34.18,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,15.55c-.27,0-1,.22-1,.49v3.46c0,.27.72.49,1,.49s1-.22,1-.49V16C21,15.77,20.27,15.55,20,15.55Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M18,23.46c0-.27-.17-1-.38-1H14.94c-.21,0-.38.72-.38,1s.17,1,.38,1h2.69C17.85,24.45,18,23.74,18,23.46Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.44,23.46c0-.27-.17-1-.38-1H22.36c-.21,0-.38.72-.38,1s.17,1,.38,1h2.69C25.27,24.45,25.44,23.74,25.44,23.46Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (SocketUK);

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Switch=function Switch(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.2,36H7.8A3.8,3.8,0,0,1,4,32.2V7.8A3.8,3.8,0,0,1,7.8,4H32.2A3.8,3.8,0,0,1,36,7.8V32.2A3.8,3.8,0,0,1,32.2,36ZM7.8,5A2.8,2.8,0,0,0,5,7.8V32.2A2.8,2.8,0,0,0,7.8,35H32.2A2.8,2.8,0,0,0,35,32.2V7.8A2.8,2.8,0,0,0,32.2,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23,29.07H17a3.14,3.14,0,0,1-3.14-3.14V14.06A3.14,3.14,0,0,1,17,10.93H23a3.14,3.14,0,0,1,3.14,3.14V25.94A3.14,3.14,0,0,1,23,29.07ZM17,11.93a2.14,2.14,0,0,0-2.14,2.14V25.94A2.14,2.14,0,0,0,17,28.07H23a2.14,2.14,0,0,0,2.14-2.14V14.06A2.14,2.14,0,0,0,23,11.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'20',cy:'8.13',r:'0.99'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'20',cy:'31.87',r:'0.99'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Tanks=function Tanks(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.66,30.46H8.72L4,10.15a.5.5,0,0,1,1-.23L9.51,29.46H30.85L35,9.93a.5.5,0,1,1,1,.21Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.44,14.2a13.46,13.46,0,0,1-4.1-.84l-.32-.1a8.6,8.6,0,0,0-2.56-.48,14,14,0,0,0-3.76.75l-.35.11A11.82,11.82,0,0,1,17,14.2a10.52,10.52,0,0,1-3.31-.63,12.35,12.35,0,0,0-3.8-.8A9.9,9.9,0,0,0,5.62,14a.5.5,0,1,1-.48-.88A10.79,10.79,0,0,1,9.9,11.77a13.26,13.26,0,0,1,4.15.86,9.55,9.55,0,0,0,3,.57,10.91,10.91,0,0,0,3-.52l.35-.11a14.84,14.84,0,0,1,4.07-.8,9.44,9.44,0,0,1,2.86.53l.34.11a12.13,12.13,0,0,0,3.77.79,8.18,8.18,0,0,0,2.48-.51l.55-.18a.5.5,0,1,1,.3,1l-.55.18A9,9,0,0,1,31.44,14.2Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Tanks);

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ThermostatSLT1=function ThermostatSLT1(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17,22.22H9.43a1.49,1.49,0,0,1-1.49-1.49V15.31a1.49,1.49,0,0,1,1.49-1.49H17a1.49,1.49,0,0,1,1.49,1.49v5.43A1.49,1.49,0,0,1,17,22.22Zm-7.59-7.4a.49.49,0,0,0-.49.49v5.43a.49.49,0,0,0,.49.49H17a.49.49,0,0,0,.49-.49V15.31a.49.49,0,0,0-.49-.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.75,32.29l-1.4,0a48.28,48.28,0,0,1-5-.41q-1.24-.17-2.47-.4l-.63-.1-.8-.12a3.05,3.05,0,0,1-2.48-3v-17a2.44,2.44,0,0,1,.71-1.72,3.29,3.29,0,0,1,1.63-.83,47.79,47.79,0,0,1,10.42-1,48.3,48.3,0,0,1,7.3.56l.18,0a47.22,47.22,0,0,0,7.15.54h2.17A2.44,2.44,0,0,1,36,11.28V28.72a2.44,2.44,0,0,1-2.44,2.44H31.39a47.25,47.25,0,0,0-7.16.55l-.17,0A48.34,48.34,0,0,1,16.75,32.29Zm0-23.58a46.78,46.78,0,0,0-10.21,1,2.27,2.27,0,0,0-1.13.56,1.44,1.44,0,0,0-.42,1v17a2.05,2.05,0,0,0,1.67,2l.75.12.67.1q1.2.23,2.42.39a47.12,47.12,0,0,0,4.88.4,47.5,47.5,0,0,0,8.52-.53l.17,0a48.28,48.28,0,0,1,7.31-.56h2.17A1.44,1.44,0,0,0,35,28.72V11.28a1.44,1.44,0,0,0-1.44-1.44H31.39a48.25,48.25,0,0,1-7.31-.56l-.18,0A47.28,47.28,0,0,0,16.75,8.71Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.07,28.43A50.92,50.92,0,0,1,5.15,27.25,1.65,1.65,0,0,1,4,25.69V14.31a1.64,1.64,0,0,1,1.15-1.55,51.88,51.88,0,0,1,11-1.18c2.12,0,6.12.3,7.74.43H24a54.2,54.2,0,0,0,8.06.43H36v15H32.06a53.66,53.66,0,0,0-8,.51C23.07,28,18.42,28.43,16.07,28.43Zm.06-15.86A50.87,50.87,0,0,0,5.36,13.73a.68.68,0,0,0-.36.58V25.69a.69.69,0,0,0,.37.58,49.9,49.9,0,0,0,10.7,1.16c2.36,0,7.26-.47,7.81-.52a54.66,54.66,0,0,1,8.18-.52H35v-13H32.06A55.18,55.18,0,0,1,23.87,13h-.08C22.18,12.87,18.22,12.57,16.13,12.57Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21.28,15.07h0a.5.5,0,0,0-.49.49v2a.15.15,0,0,0,.15.15h.7a.15.15,0,0,0,.15-.15v-2A.46.46,0,0,0,21.28,15.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21.54,18.67h-.6a.2.2,0,0,0-.2.2v1.84a.46.46,0,0,0,.46.46.55.55,0,0,0,.54-.54V18.87A.2.2,0,0,0,21.54,18.67Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',rx:'0.33',ry:'0.33',width:'2.83',x:'9.68',y:'23.87'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',rx:'0.33',ry:'0.33',width:'2.83',x:'14.13',y:'23.87'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (ThermostatSLT1);

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ThermostatSLT2=function ThermostatSLT2(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.53,33.09H7.47A3.47,3.47,0,0,1,4,29.63V10.37A3.47,3.47,0,0,1,7.47,6.91H32.53A3.47,3.47,0,0,1,36,10.37V29.63A3.47,3.47,0,0,1,32.53,33.09ZM7.47,7.91A2.47,2.47,0,0,0,5,10.37V29.63a2.47,2.47,0,0,0,2.47,2.47H32.53A2.47,2.47,0,0,0,35,29.63V10.37a2.47,2.47,0,0,0-2.47-2.47Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.67,22.88H10.44A3.47,3.47,0,0,1,7,19.41V13.34a3.47,3.47,0,0,1,3.47-3.47h9.23a3.47,3.47,0,0,1,3.47,3.47v6.07A3.47,3.47,0,0,1,19.67,22.88Zm-9.23-12A2.47,2.47,0,0,0,8,13.34v6.07a2.47,2.47,0,0,0,2.47,2.47h9.23a2.47,2.47,0,0,0,2.47-2.47V13.34a2.47,2.47,0,0,0-2.47-2.47Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'30.67',x:'4.5',y:'27.42'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'30.79',cy:'15.71',r:'1.48'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'30.79',cy:'20',r:'1.48'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'30.79',cy:'11.43',r:'1.48'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (ThermostatSLT2);

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ThermostatSLT3=function ThermostatSLT3(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,25.45a6.77,6.77,0,1,1,6.77-6.77A6.77,6.77,0,0,1,20,25.45Zm0-12.53a5.77,5.77,0,1,0,5.77,5.77A5.77,5.77,0,0,0,20,12.92Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,36h-27A2.48,2.48,0,0,1,4,33.52v-27A2.48,2.48,0,0,1,6.48,4h27A2.48,2.48,0,0,1,36,6.48v27A2.48,2.48,0,0,1,33.52,36ZM6.48,5A1.48,1.48,0,0,0,5,6.48v27A1.48,1.48,0,0,0,6.48,35h27A1.48,1.48,0,0,0,35,33.52v-27A1.48,1.48,0,0,0,33.52,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'28.9',cy:'30.22',r:'1.98'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'20',cy:'30.22',r:'1.98'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'11.1',cy:'30.22',r:'1.98'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (ThermostatSLT3);

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Toilets=function Toilets(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.1,36c-3.29,0-5.51-2.58-5.51-6.42V24.89h1v4.69c0,3.29,1.77,5.42,4.51,5.42s4.51-2.13,4.51-5.42V29.2a.8.8,0,0,1,.17-.65.74.74,0,0,1,.57-.22h1.16V25.51H28.35c-2.49,0-3.55,1.1-3.55,3.69v.38c0,1.35-.21,2.59-1.69,2.59s-1.69-1.25-1.69-2.59V24.89h1v4.69c0,1.59.34,1.59.69,1.59s.69,0,.69-1.59V29.2c0-3.15,1.49-4.69,4.55-4.69h1.32c.39,0,.84.26.84,1v2.88a.83.83,0,0,1-.84,1H28.61v.25C28.61,33.42,26.4,36,23.1,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21.68,25.53H18.32a1,1,0,0,1-1-1V22.91h1v1.62h3.36V22.91h1v1.62A1,1,0,0,1,21.68,25.53Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21.93,5.76h-1V5H19l0,.76h-1V4.93A1,1,0,0,1,19,4H21.1a.9.9,0,0,1,.83.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.48,23.46h-19a2,2,0,0,1-2-2V7.36a2,2,0,0,1,2-2h19a2,2,0,0,1,2,2V21.45A2,2,0,0,1,29.48,23.46Zm-19-17.1a1,1,0,0,0-1,1V21.45a1,1,0,0,0,1,1h19a1,1,0,0,0,1-1V7.36a1,1,0,0,0-1-1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'21.89',x:'9.05',y:'7.65'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (Toilets);

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var WaterFlowing=function WaterFlowing(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.46,14.76a20.47,20.47,0,0,1-6.62-1.55,19.75,19.75,0,0,0-6.29-1.49,19.78,19.78,0,0,0-6.3,1.49c-.88.31-1.74.61-2.6.87a.5.5,0,1,1-.28-1c.84-.25,1.69-.55,2.51-.84a20.64,20.64,0,0,1,6.67-1.56,20.47,20.47,0,0,1,6.62,1.55,19.75,19.75,0,0,0,6.29,1.49,19.74,19.74,0,0,0,6.28-1.49c.88-.31,1.75-.62,2.62-.87a.5.5,0,1,1,.28,1c-.84.25-1.7.55-2.54.84A20.58,20.58,0,0,1,26.46,14.76Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.46,22a20.47,20.47,0,0,1-6.62-1.55A19.75,19.75,0,0,0,13.54,19a19.78,19.78,0,0,0-6.3,1.49c-.85.3-1.73.61-2.6.87a.5.5,0,0,1-.28-1c.85-.25,1.72-.56,2.55-.85A20.51,20.51,0,0,1,13.54,18a20.47,20.47,0,0,1,6.62,1.55A19.75,19.75,0,0,0,26.46,21a19.75,19.75,0,0,0,6.29-1.49c.81-.28,1.72-.61,2.61-.87a.5.5,0,0,1,.28,1c-.86.25-1.76.57-2.56.85A20.46,20.46,0,0,1,26.46,22Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.46,29.27a20.47,20.47,0,0,1-6.62-1.55,19.75,19.75,0,0,0-6.29-1.49,19.74,19.74,0,0,0-6.3,1.49c-.88.31-1.74.61-2.6.87a.5.5,0,1,1-.28-1c.84-.25,1.69-.55,2.51-.84a20.59,20.59,0,0,1,6.67-1.56,20.47,20.47,0,0,1,6.62,1.55,19.75,19.75,0,0,0,6.29,1.49,19.76,19.76,0,0,0,6.29-1.49c.87-.31,1.74-.61,2.61-.87a.5.5,0,0,1,.28,1c-.84.25-1.7.55-2.54.85A20.58,20.58,0,0,1,26.46,29.27Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (WaterFlowing);

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var WaterNotFlowing=function WaterNotFlowing(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};/*eslint-disable max-len */return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.46,15.1a20.46,20.46,0,0,1-6.62-1.55,19.74,19.74,0,0,0-6.29-1.49,19.78,19.78,0,0,0-6.3,1.49c-.87.31-1.74.61-2.6.87a.5.5,0,1,1-.28-1c.84-.25,1.69-.55,2.52-.84a20.6,20.6,0,0,1,6.66-1.56,20.47,20.47,0,0,1,6.62,1.55,19.73,19.73,0,0,0,6.29,1.49,19.75,19.75,0,0,0,6.29-1.49c.86-.3,1.73-.61,2.61-.87a.5.5,0,0,1,.28,1c-.86.25-1.72.56-2.56.85A20.5,20.5,0,0,1,26.46,15.1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.46,22.35a20.46,20.46,0,0,1-6.62-1.55,19.74,19.74,0,0,0-6.29-1.49,19.78,19.78,0,0,0-6.3,1.49c-.85.3-1.72.61-2.6.87a.5.5,0,1,1-.28-1c.85-.25,1.72-.56,2.55-.85a20.51,20.51,0,0,1,6.63-1.55,20.47,20.47,0,0,1,6.62,1.55,19.73,19.73,0,0,0,6.29,1.49,19.77,19.77,0,0,0,6.29-1.49c.8-.28,1.71-.6,2.61-.87a.5.5,0,0,1,.28,1c-.87.26-1.77.57-2.56.85A20.51,20.51,0,0,1,26.46,22.35Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.46,29.61a20.46,20.46,0,0,1-6.62-1.55,19.74,19.74,0,0,0-6.29-1.49,19.78,19.78,0,0,0-6.3,1.49c-.87.31-1.74.61-2.6.87a.5.5,0,1,1-.28-1c.84-.25,1.69-.55,2.52-.84a20.6,20.6,0,0,1,6.66-1.56,20.47,20.47,0,0,1,6.62,1.55,19.73,19.73,0,0,0,6.29,1.49,19.75,19.75,0,0,0,6.29-1.49c.88-.31,1.75-.62,2.61-.87a.5.5,0,1,1,.28,1c-.84.25-1.7.55-2.53.84A20.6,20.6,0,0,1,26.46,29.61Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.7,33l-.13,0a.5.5,0,0,1-.36-.61L22.48,8.34a.5.5,0,0,1,1,.25L17.19,32.66A.5.5,0,0,1,16.7,33Z'}));/*eslint-enable max-len */};/* harmony default export */ __webpack_exports__["a"] = (WaterNotFlowing);

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1617);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__add_devices__ = __webpack_require__(1618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__add_devices__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrow_down__ = __webpack_require__(1619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__arrow_down__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__arrow_left__ = __webpack_require__(1620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__arrow_left__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__arrow_left_shaft__ = __webpack_require__(1621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__arrow_left_shaft__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__arrow_right__ = __webpack_require__(1622);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__arrow_right__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__arrow_right_double__ = __webpack_require__(1623);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__arrow_right_double__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__arrow_up__ = __webpack_require__(1624);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__arrow_up__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__battery_empty__ = __webpack_require__(1625);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__battery_empty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__battery_full__ = __webpack_require__(1626);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__battery_full__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__battery_low__ = __webpack_require__(1627);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__battery_low__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__battery_normal__ = __webpack_require__(1628);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__battery_normal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__boost__ = __webpack_require__(1629);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__boost__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bord_gais_logo__ = __webpack_require__(1630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__bord_gais_logo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__call__ = __webpack_require__(1631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__call__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__circle_filled__ = __webpack_require__(1632);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__circle_filled__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__circle_outline__ = __webpack_require__(1633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__circle_outline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__close__ = __webpack_require__(1634);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__close__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__close_heavy__ = __webpack_require__(1635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__close_heavy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__color_palete__ = __webpack_require__(1636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__color_palete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__color_picker__ = __webpack_require__(1637);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_20__color_picker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__comfort__ = __webpack_require__(1638);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_21__comfort__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__connected__ = __webpack_require__(1639);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_22__connected__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__control_page__ = __webpack_require__(1640);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_23__control_page__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__copy__ = __webpack_require__(1641);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_24__copy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__create__ = __webpack_require__(1642);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_25__create__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__create_plus__ = __webpack_require__(1643);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_26__create_plus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__dashboard__ = __webpack_require__(1644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_27__dashboard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__demo__ = __webpack_require__(1645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_28__demo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__dimmer__ = __webpack_require__(1646);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_29__dimmer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__discover__ = __webpack_require__(1647);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_30__discover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__dog_bark__ = __webpack_require__(1648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_31__dog_bark__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__download__ = __webpack_require__(1649);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_32__download__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__edit__ = __webpack_require__(1650);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_33__edit__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__efficiency__ = __webpack_require__(1651);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_34__efficiency__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__exclamation__ = __webpack_require__(1652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_35__exclamation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__frost_protection__ = __webpack_require__(1653);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_36__frost_protection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__glass_break__ = __webpack_require__(1654);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_37__glass_break__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__graphs__ = __webpack_require__(1655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_38__graphs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__group_control__ = __webpack_require__(1656);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_39__group_control__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__heating_page__ = __webpack_require__(1657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_40__heating_page__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__help__ = __webpack_require__(1658);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_41__help__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__hive_icon__ = __webpack_require__(1659);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_42__hive_icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__holidays__ = __webpack_require__(1660);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_43__holidays__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__home__ = __webpack_require__(1661);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_44__home__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__hot_water__ = __webpack_require__(1662);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_45__hot_water__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__incorrect_sound__ = __webpack_require__(1663);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_46__incorrect_sound__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__info__ = __webpack_require__(1664);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_47__info__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__install_device__ = __webpack_require__(1665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_48__install_device__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__link__ = __webpack_require__(1666);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_49__link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__link_broken__ = __webpack_require__(1667);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_50__link_broken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__list_device_menu__ = __webpack_require__(1668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_51__list_device_menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__lock_closed__ = __webpack_require__(1669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_52__lock_closed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__logout__ = __webpack_require__(1670);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_53__logout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__manage_device__ = __webpack_require__(1671);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_54__manage_device__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__menu__ = __webpack_require__(1672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_55__menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__microphone_off__ = __webpack_require__(1673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_56__microphone_off__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__microphone_on__ = __webpack_require__(1674);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_57__microphone_on__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__mimic__ = __webpack_require__(1675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_58__mimic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__minus__ = __webpack_require__(1676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_59__minus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__monitor_sense__ = __webpack_require__(1677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_60__monitor_sense__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__monitoring_off__ = __webpack_require__(1678);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_61__monitoring_off__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__monitoring_on__ = __webpack_require__(1679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return __WEBPACK_IMPORTED_MODULE_62__monitoring_on__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__moods__ = __webpack_require__(1680);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_63__moods__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__more__ = __webpack_require__(1681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_64__more__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__more_vertical__ = __webpack_require__(1682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_65__more_vertical__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__multi_profile__ = __webpack_require__(1683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_66__multi_profile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__notifications__ = __webpack_require__(1684);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_67__notifications__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__notifications_off__ = __webpack_require__(1685);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_68__notifications_off__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__overflow__ = __webpack_require__(1686);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_69__overflow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__pause__ = __webpack_require__(1687);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_70__pause__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__pause_simple__ = __webpack_require__(1688);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_71__pause_simple__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__play__ = __webpack_require__(1689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_72__play__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__play_simple__ = __webpack_require__(1690);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_73__play_simple__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__plus__ = __webpack_require__(1691);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_74__plus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__question__ = __webpack_require__(1692);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_75__question__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__reassurance__ = __webpack_require__(1693);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_76__reassurance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__recipes__ = __webpack_require__(1694);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_77__recipes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__reset_reload__ = __webpack_require__(1695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_78__reset_reload__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__schedule__ = __webpack_require__(1696);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_79__schedule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__search__ = __webpack_require__(1697);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_80__search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__settings__ = __webpack_require__(1698);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_81__settings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__shop__ = __webpack_require__(1699);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_82__shop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__signal_1_bars__ = __webpack_require__(1700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_83__signal_1_bars__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__signal_2_bars__ = __webpack_require__(1701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_84__signal_2_bars__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__signal_3_bars__ = __webpack_require__(1702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_85__signal_3_bars__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__signal_4_bars__ = __webpack_require__(1703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_86__signal_4_bars__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__smoke_co__ = __webpack_require__(1704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_87__smoke_co__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__smoke_co2__ = __webpack_require__(1705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_88__smoke_co2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__sound_cam__ = __webpack_require__(1706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_89__sound_cam__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__sound_off__ = __webpack_require__(1707);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_90__sound_off__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__sound_on__ = __webpack_require__(1708);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_91__sound_on__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__stop__ = __webpack_require__(1709);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_92__stop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__stop_simple__ = __webpack_require__(1710);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_93__stop_simple__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__tick_one__ = __webpack_require__(1711);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_94__tick_one__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__tick_simple__ = __webpack_require__(1712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return __WEBPACK_IMPORTED_MODULE_95__tick_simple__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__tone__ = __webpack_require__(1713);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return __WEBPACK_IMPORTED_MODULE_96__tone__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__trash__ = __webpack_require__(1714);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return __WEBPACK_IMPORTED_MODULE_97__trash__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__user_profile__ = __webpack_require__(1715);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return __WEBPACK_IMPORTED_MODULE_98__user_profile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__welcome_home__ = __webpack_require__(1716);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return __WEBPACK_IMPORTED_MODULE_99__welcome_home__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__wifi__ = __webpack_require__(1717);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return __WEBPACK_IMPORTED_MODULE_100__wifi__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__wifi_0_bars__ = __webpack_require__(1718);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return __WEBPACK_IMPORTED_MODULE_101__wifi_0_bars__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__wifi_1_bars__ = __webpack_require__(1719);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return __WEBPACK_IMPORTED_MODULE_102__wifi_1_bars__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__wifi_2_bars__ = __webpack_require__(1720);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return __WEBPACK_IMPORTED_MODULE_103__wifi_2_bars__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__wifi_3_bars__ = __webpack_require__(1721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return __WEBPACK_IMPORTED_MODULE_104__wifi_3_bars__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__wifi_off__ = __webpack_require__(1722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return __WEBPACK_IMPORTED_MODULE_105__wifi_off__["a"]; });


/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Actions=function Actions(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(G,gProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M16.4017437,16.9140195 C14.6525541,15.749152 13.5,13.7591727 13.5,11.5 C13.5,7.91014913 16.4101491,5 20,5 C23.5898509,5 26.5,7.91014913 26.5,11.5 C26.5,15.0898509 23.5898509,18 20,18 C19.0266281,18 18.1032278,17.7860462 17.2742621,17.4026016 L14.0982563,23.0859805 C15.7171873,24.1641026 16.8250347,25.9490235 16.9810552,28 L23.0189448,28 C23.2742573,24.6437761 26.0783851,22 29.5,22 C33.0898509,22 36,24.9101491 36,28.5 C36,32.0898509 33.0898509,35 29.5,35 C26.0783851,35 23.2742573,32.3562239 23.0189448,29 L16.9810552,29 C16.7257427,32.3562239 13.9216149,35 10.5,35 C6.91014913,35 4,32.0898509 4,28.5 C4,24.9101491 6.91014913,22 10.5,22 C11.4733719,22 12.3967722,22.2139538 13.2257379,22.5973984 L16.4017437,16.9140195 Z M29.5,34 C32.5375661,34 35,31.5375661 35,28.5 C35,25.4624339 32.5375661,23 29.5,23 C26.4624339,23 24,25.4624339 24,28.5 C24,31.5375661 26.4624339,34 29.5,34 Z M10.5,34 C13.5375661,34 16,31.5375661 16,28.5 C16,25.4624339 13.5375661,23 10.5,23 C7.46243388,23 5,25.4624339 5,28.5 C5,31.5375661 7.46243388,34 10.5,34 Z M20,17 C23.0375661,17 25.5,14.5375661 25.5,11.5 C25.5,8.46243388 23.0375661,6 20,6 C16.9624339,6 14.5,8.46243388 14.5,11.5 C14.5,14.5375661 16.9624339,17 20,17 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Actions);

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SenseOff=function SenseOff(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,28a1,1,0,0,1-1-1V13a1,1,0,0,1,2,0V27A1,1,0,0,1,20,28Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27,21H13a1,1,0,0,1,0-2H27a1,1,0,0,1,0,2Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SenseOff);

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ArrowDown=function ArrowDown(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.13,28.57a1,1,0,0,1-.71-.29L4.29,13.14a1,1,0,0,1,1.41-1.41L20.13,26.15,34.29,12a1,1,0,0,1,1.41,1.41L20.84,28.27A1,1,0,0,1,20.13,28.57Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ArrowDown);

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ArrowLeft=function ArrowLeft(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.57,36a1,1,0,0,1-.71-.29L11.73,20.57a1,1,0,0,1,0-1.41L26.59,4.29A1,1,0,0,1,28,5.71L13.85,19.87,28.27,34.29A1,1,0,0,1,27.57,36Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ArrowLeft);

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ArrowLeftShaft=function ArrowLeftShaft(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.125,18.125 L21.3125,8.9375 C22.0373737,8.21262627 22.0373737,7.03737373 21.3125,6.3125 L21.3125,6.3125 C20.5876263,5.58762627 19.4123737,5.58762627 18.6875,6.3125 L6.41421356,18.5857864 C5.63316498,19.366835 5.63316498,20.633165 6.41421356,21.4142136 L18.6875,33.6875 C19.4123737,34.4123737 20.5876263,34.4123737 21.3125,33.6875 L21.3125,33.6875 C22.0373737,32.9626263 22.0373737,31.7873737 21.3125,31.0625 L12.125,21.875 L33.125,21.875 C34.1605339,21.875 35,21.0355339 35,20 L35,20 C35,18.9644661 34.1605339,18.125 33.125,18.125 L12.125,18.125 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ArrowLeftShaft);

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ArrowRight=function ArrowRight(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.43,36a1,1,0,0,1-.71-1.71L26.15,19.87,12,5.71a1,1,0,0,1,1.41-1.41L28.27,19.16a1,1,0,0,1,0,1.41L13.14,35.71A1,1,0,0,1,12.43,36Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ArrowRight);

/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ArrowRightDouble=function ArrowRightDouble(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.2551089,32.9199586 L33.0187453,19.9700003 L20.2551089,7.02004196 C19.5671845,6.32207538 19.5753253,5.1985888 20.2732919,4.51066444 C20.9712585,3.82274009 22.0947451,3.83088093 22.7826694,4.52884751 L38.0016574,19.9700003 L22.7826694,35.411153 C22.0947451,36.1091196 20.9712585,36.1172604 20.2732919,35.4293361 C19.5753253,34.7414117 19.5671845,33.6179252 20.2551089,32.9199586 Z M2.51066444,32.9199586 L15.2743009,19.9700003 L2.51066444,7.02004196 C1.82274009,6.32207538 1.83088093,5.1985888 2.52884751,4.51066444 C3.22681409,3.82274009 4.35030067,3.83088093 5.03822503,4.52884751 L20.257213,19.9700003 L5.03822503,35.411153 C4.35030067,36.1091196 3.22681409,36.1172604 2.52884751,35.4293361 C1.83088093,34.7414117 1.82274009,33.6179252 2.51066444,32.9199586 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ArrowRightDouble);

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ArrowUp=function ArrowUp(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35,28.57a1,1,0,0,1-.71-.29L19.87,13.85,5.71,28a1,1,0,0,1-1.41-1.41L19.16,11.73a1,1,0,0,1,1.41,0L35.71,26.86A1,1,0,0,1,35,28.57Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ArrowUp);

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var BatteryEmpty=function BatteryEmpty(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.78,28.25H7.64A3.64,3.64,0,0,1,4,24.61V15.39a3.64,3.64,0,0,1,3.64-3.64H29.54a3.64,3.64,0,0,1,3.64,3.64v.53l1.76.05A1.06,1.06,0,0,1,36,17v6.64a1.06,1.06,0,0,1-1.05,1.05H33.24l-.05.12A3.41,3.41,0,0,1,29.78,28.25ZM7.64,12.75A2.64,2.64,0,0,0,5,15.39v9.22a2.64,2.64,0,0,0,2.64,2.64H29.78a2.41,2.41,0,0,0,2.4-2.4,1.07,1.07,0,0,1,1.05-1.12h1.71L35,17,34.95,17H33.24a1.06,1.06,0,0,1-1.05-1.05v-.53a2.64,2.64,0,0,0-2.64-2.64Z'}));};/* harmony default export */ __webpack_exports__["a"] = (BatteryEmpty);

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var BatteryFull=function BatteryFull(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'9.86',rx:'1.41',ry:'1.41',width:'22.55',x:'7.32',y:'15.07'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.78,28.25H7.64A3.64,3.64,0,0,1,4,24.61V15.39a3.64,3.64,0,0,1,3.64-3.64H29.54a3.64,3.64,0,0,1,3.64,3.64v.53l1.76.05A1.06,1.06,0,0,1,36,17v6.64a1.06,1.06,0,0,1-1.05,1.05H33.24l-.05.12A3.41,3.41,0,0,1,29.78,28.25ZM7.64,12.75A2.64,2.64,0,0,0,5,15.39v9.22a2.64,2.64,0,0,0,2.64,2.64H29.78a2.41,2.41,0,0,0,2.4-2.4,1.07,1.07,0,0,1,1.05-1.12h1.71L35,17,34.95,17H33.24a1.06,1.06,0,0,1-1.05-1.05v-.53a2.64,2.64,0,0,0-2.64-2.64Z'}));};/* harmony default export */ __webpack_exports__["a"] = (BatteryFull);

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var BatteryLow=function BatteryLow(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'9.86',rx:'1.41',ry:'1.41',width:'7.75',x:'7.32',y:'15.07'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.78,28.25H7.64A3.64,3.64,0,0,1,4,24.61V15.39a3.64,3.64,0,0,1,3.64-3.64H29.54a3.64,3.64,0,0,1,3.64,3.64v.53l1.76.05A1.06,1.06,0,0,1,36,17v6.64a1.06,1.06,0,0,1-1.05,1.05H33.24l-.05.12A3.41,3.41,0,0,1,29.78,28.25ZM7.64,12.75A2.64,2.64,0,0,0,5,15.39v9.22a2.64,2.64,0,0,0,2.64,2.64H29.78a2.41,2.41,0,0,0,2.4-2.4,1.07,1.07,0,0,1,1.05-1.12h1.71L35,17,34.95,17H33.24a1.06,1.06,0,0,1-1.05-1.05v-.53a2.64,2.64,0,0,0-2.64-2.64Z'}));};/* harmony default export */ __webpack_exports__["a"] = (BatteryLow);

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var BatteryNormal=function BatteryNormal(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'9.86',rx:'1.41',ry:'1.41',width:'15.5',x:'7.32',y:'15.07'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.78,28.25H7.64A3.64,3.64,0,0,1,4,24.61V15.39a3.64,3.64,0,0,1,3.64-3.64H29.54a3.64,3.64,0,0,1,3.64,3.64v.53l1.76.05A1.06,1.06,0,0,1,36,17v6.64a1.06,1.06,0,0,1-1.05,1.05H33.24l-.05.12A3.41,3.41,0,0,1,29.78,28.25ZM7.64,12.75A2.64,2.64,0,0,0,5,15.39v9.22a2.64,2.64,0,0,0,2.64,2.64H29.78a2.41,2.41,0,0,0,2.4-2.4,1.07,1.07,0,0,1,1.05-1.12h1.71L35,17,34.95,17H33.24a1.06,1.06,0,0,1-1.05-1.05v-.53a2.64,2.64,0,0,0-2.64-2.64Z'}));};/* harmony default export */ __webpack_exports__["a"] = (BatteryNormal);

/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Boost=function Boost(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,32A12,12,0,1,1,32,20,12,12,0,0,1,20,32ZM20,9A11,11,0,1,0,31,20,11,11,0,0,0,20,9Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,28a8,8,0,1,1,8-8A8,8,0,0,1,20,28Zm0-15a7,7,0,1,0,7,7A7,7,0,0,0,20,13Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'20',cy:'20',r:'3.5'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,24a4,4,0,1,1,4-4A4,4,0,0,1,20,24Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,20,17Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Boost);

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var BordGaisLogo=function BordGaisLogo(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M4,17.29a.18.18,0,0,1,.18-.18H5.37a.16.16,0,1,1,0,.33h-1V18h.88a.16.16,0,1,1,0,.33H4.36V19A.18.18,0,0,1,4,19Zm1.81.48A.17.17,0,0,1,6,17.59a.18.18,0,0,1,.18.18v.16a.49.49,0,0,1,.39-.34.16.16,0,0,1,.17.17.16.16,0,0,1-.14.17c-.25,0-.42.24-.42.6V19a.18.18,0,0,1-.18.17A.17.17,0,0,1,5.81,19Zm1,.62h0a.82.82,0,0,1,1.64,0h0a.8.8,0,0,1-.82.8A.79.79,0,0,1,6.81,18.38Zm1.28,0h0a.47.47,0,0,0-.47-.49.46.46,0,0,0-.46.49h0a.47.47,0,0,0,.47.49A.46.46,0,0,0,8.09,18.38Zm.65-.62a.17.17,0,0,1,.17-.18.18.18,0,0,1,.18.18v.07a.55.55,0,0,1,.47-.26.49.49,0,0,1,.46.27.62.62,0,0,1,.52-.27.52.52,0,0,1,.54.59V19a.17.17,0,0,1-.17.17.17.17,0,0,1-.18-.17v-.71c0-.24-.11-.37-.31-.37s-.33.13-.33.38V19a.18.18,0,0,1-.35,0v-.71c0-.24-.12-.37-.31-.37a.34.34,0,0,0-.33.38V19a.18.18,0,0,1-.35,0Zm11.63-.17c.3,0,.51-.12.52-.36h0c0-.21-.16-.34-.47-.34h-.68v.71Zm.11,1.14c.32,0,.52-.13.53-.37h0c0-.23-.17-.36-.55-.36h-.75l0,.74Zm-1.21-2a.24.24,0,0,1,.24-.24h1a1,1,0,0,1,.7.24.59.59,0,0,1,.17.45h0a.66.66,0,0,1-.4.6.64.64,0,0,1,.52.65h0c0,.48-.41.74-1,.74h-1a.23.23,0,0,1-.23-.24Zm4.13,1.45h0a.61.61,0,0,0-.61-.65.62.62,0,0,0-.62.64h0a.61.61,0,0,0,.61.65.62.62,0,0,0,.63-.64m-1.7,0h0a1.09,1.09,0,0,1,1.11-1.06,1,1,0,0,1,1.06,1.05h0a1.09,1.09,0,0,1-1.11,1.06,1,1,0,0,1-1.05-1m2.47.79a.22.22,0,0,0,.23.23.24.24,0,0,0,.24-.23v-.6a.71.71,0,0,1,.57-.79.22.22,0,0,0,.19-.22.21.21,0,0,0-.23-.23.66.66,0,0,0-.52.45v-.21a.23.23,0,0,0-.23-.23.24.24,0,0,0-.24.23Zm1.76-.81h0a.59.59,0,0,0,.57.65.63.63,0,0,0,.6-.65h0a.59.59,0,0,0-.57-.65.61.61,0,0,0-.6.65m1.61.81a.23.23,0,0,1-.24.23.22.22,0,0,1-.23-.23v-.13a.83.83,0,0,1-.7.38,1,1,0,0,1-.92-1.05h0a1,1,0,0,1,1-1.05.81.81,0,0,1,.68.36l0-.88a.23.23,0,0,1,.24-.23.22.22,0,0,1,.23.23Zm1-1.12a1.3,1.3,0,0,0,1.37,1.38,1.75,1.75,0,0,0,1-.29.33.33,0,0,0,.17-.3v-.72a.23.23,0,0,0-.23-.24h-.75a.21.21,0,0,0-.22.21.2.2,0,0,0,.21.2h.53v.5a1.12,1.12,0,0,1-.65.2.88.88,0,0,1-.89-1h0a.93.93,0,0,1,.89-.95,1,1,0,0,1,.65.21.24.24,0,0,0,.14.05.24.24,0,0,0,.24-.23.23.23,0,0,0-.09-.19,1.44,1.44,0,0,0-.91-.27,1.4,1.4,0,0,0-1.42,1.39h0m3.7-1a.18.18,0,0,1,0-.08l.23-.34a.22.22,0,0,1,.19-.11c.12,0,.28.08.27.15a.17.17,0,0,1-.07.12l-.26.25a.36.36,0,0,1-.28.1c-.07,0-.11,0-.11-.08m.51,1.62v-.14a1.28,1.28,0,0,0-.46-.08c-.3,0-.48.13-.48.34h0c0,.2.17.31.39.31a.49.49,0,0,0,.55-.43m-1.39.15h0c0-.44.36-.65.85-.65a1.68,1.68,0,0,1,.54.08v0c0-.29-.17-.44-.49-.44a1.22,1.22,0,0,0-.45.08h-.07a.19.19,0,0,1-.19-.19.21.21,0,0,1,.13-.18,1.77,1.77,0,0,1,.66-.12.89.89,0,0,1,.67.23.83.83,0,0,1,.21.63l0,1a.23.23,0,0,1-.23.22.21.21,0,0,1-.22-.2V18.9a.84.84,0,0,1-.67.3.63.63,0,0,1-.71-.63m2.27-2a.24.24,0,0,1,.27-.23.23.23,0,0,1,.26.23v0a.25.25,0,0,1-.27.23.24.24,0,0,1-.26-.23Zm0,.76a.24.24,0,0,1,.24-.23.23.23,0,0,1,.23.23l0,1.6a.24.24,0,0,1-.24.23.22.22,0,0,1-.23-.23Zm.81,1.61a1.37,1.37,0,0,0,.77.24c.42,0,.76-.21.77-.64h0c0-.36-.32-.5-.62-.59s-.45-.14-.45-.29h0c0-.12.11-.2.29-.2a1.09,1.09,0,0,1,.47.14l.09,0a.19.19,0,0,0,.09-.36,1.38,1.38,0,0,0-.63-.16.66.66,0,0,0-.74.62h0c0,.39.32.51.62.59s.45.13.45.28h0c0,.13-.12.22-.32.22a1.06,1.06,0,0,1-.58-.2.2.2,0,0,0-.1,0,.19.19,0,0,0-.19.19.17.17,0,0,0,.08.16M19.16,22.36a.15.15,0,0,0,.15.15H21a.14.14,0,0,0,.14-.14.13.13,0,0,0-.14-.14H19.46l0-.94h1.35a.14.14,0,0,0,.14-.14.14.14,0,0,0-.14-.14H19.49l0-.92H21a.14.14,0,0,0,.14-.14.13.13,0,0,0-.14-.14H19.36a.16.16,0,0,0-.15.15l-.05,2.38m2.37,0a.14.14,0,0,0,.15.15.15.15,0,0,0,.15-.15l0-1a.6.6,0,0,1,.61-.62.52.52,0,0,1,.54.6l0,1a.14.14,0,0,0,.15.15.15.15,0,0,0,.15-.15l0-1.1a.71.71,0,0,0-.74-.79.77.77,0,0,0-.69.39v-.22a.14.14,0,0,0-.15-.15.15.15,0,0,0-.15.15Zm3.69-1a.64.64,0,0,0-.62-.68.7.7,0,0,0-.66.68Zm-.61,1.15a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1,.91.91,0,0,1,.9,1,.14.14,0,0,1-.14.14H23.94a.68.68,0,0,0,.69.67.83.83,0,0,0,.58-.23.14.14,0,0,1,.09,0,.13.13,0,0,1,.13.13.13.13,0,0,1,0,.1,1,1,0,0,1-.76.3m1.26-.18a.14.14,0,0,0,.15.15.15.15,0,0,0,.15-.15V21.7a.83.83,0,0,1,.72-.91.15.15,0,0,0,.13-.15.14.14,0,0,0-.14-.15.85.85,0,0,0-.7.53v-.37a.14.14,0,0,0-.15-.15.15.15,0,0,0-.15.15Zm2.95-1h0a.71.71,0,0,0-1.42,0h0a.66.66,0,0,0,.67.68.72.72,0,0,0,.74-.67M27.23,22.9a.13.13,0,0,1-.07-.12.14.14,0,0,1,.14-.13l.06,0a1.23,1.23,0,0,0,.7.22.67.67,0,0,0,.74-.71v-.23a1,1,0,0,1-.79.42.9.9,0,0,1-.91-.93h0a1,1,0,0,1,1-.94.91.91,0,0,1,.77.4v-.23a.15.15,0,0,1,.15-.15.15.15,0,0,1,.15.15l0,1.51a1,1,0,0,1-.27.7,1.07,1.07,0,0,1-.76.26,1.53,1.53,0,0,1-.83-.23m2.31.18a.93.93,0,0,0,.33.06c.3,0,.49-.15.68-.56l.82-1.85a.26.26,0,0,0,0-.07.14.14,0,0,0-.14-.15.15.15,0,0,0-.14.11l-.65,1.56-.66-1.56a.15.15,0,0,0-.15-.12.15.15,0,0,0-.15.15.2.2,0,0,0,0,.08l.79,1.76,0,0c-.11.24-.22.35-.41.35a.61.61,0,0,1-.21,0l-.07,0a.13.13,0,0,0,0,.25M13,22.7A1.58,1.58,0,0,0,14,22a1.12,1.12,0,0,0,.28-.88,4.54,4.54,0,0,1,.92-4.25l.07-.09.06.1a3.83,3.83,0,0,1,.12,3.95c-.14.26-.28.7-.17.88a.22.22,0,0,0,.21.09h.05c.61-.05,1.17-.81,1.38-1.2a6.82,6.82,0,0,0,.88-3.25,4.62,4.62,0,0,0-1-2.93.26.26,0,0,0-.21-.1,1.39,1.39,0,0,0-.74.37,9.88,9.88,0,0,0-2.9,3.73,5.49,5.49,0,0,0-.23,4.06c.06.18.17.26.31.26m6,3c.49,0,1-.72,1-1.14a.27.27,0,0,0-.3-.31,6.84,6.84,0,0,1-4.7-1.83.38.38,0,0,0-.27-.11,1,1,0,0,0-.61.32,6,6,0,0,1-3.24,1.54,1.44,1.44,0,0,0-1,1.25.2.2,0,0,0,.23.21h.06A8,8,0,0,0,14.18,24l.05,0,.05,0a7.57,7.57,0,0,0,4.77,1.74h0'}));};/* harmony default export */ __webpack_exports__["a"] = (BordGaisLogo);

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Call=function Call(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.42,36H21.5a7.08,7.08,0,0,1-4.1-1.3,7.26,7.26,0,0,1-2.61-3.4,29.35,29.35,0,0,1,0-22.6A7.18,7.18,0,0,1,21.5,4h3.92a2,2,0,0,1,2,2.39l-1,6.2a2,2,0,0,1-2,1.71H20.7c-.92,5.57-.92,5.83,0,11.4h3.7a2,2,0,0,1,2,1.71l1,6.2a2,2,0,0,1-2,2.39ZM21.5,5a6.18,6.18,0,0,0-5.78,4,28.37,28.37,0,0,0,0,21.92A6.25,6.25,0,0,0,18,33.88,6.1,6.1,0,0,0,21.5,35h3.92a1.05,1.05,0,0,0,1-1.22l-1-6.2a1,1,0,0,0-1-.88H19.85l-.07-.42c-1-6.22-1-6.34,0-12.56l.07-.42h4.54a1,1,0,0,0,1-.88l1-6.2a1.05,1.05,0,0,0-1-1.22Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Call);

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CircleFilled=function CircleFilled(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'20',cy:'20',r:'15.5'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CircleFilled);

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CircleOutline=function CircleOutline(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CircleOutline);

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Close=function Close(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.77,28.23a1,1,0,0,1-.71-1.71L26.52,12.07a1,1,0,0,1,1.41,1.41L13.48,27.93A1,1,0,0,1,12.77,28.23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.23,28.23a1,1,0,0,1-.71-.29L12.07,13.48a1,1,0,0,1,1.41-1.41L27.93,26.52a1,1,0,0,1-.71,1.71Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Close);

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CloseHeavy=function CloseHeavy(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M10,31a1,1,0,0,1-.71-1.71l20-20a1,1,0,0,1,1.41,1.41l-20,20A1,1,0,0,1,10,31Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30,31a1,1,0,0,1-.71-.29l-20-20a1,1,0,0,1,1.41-1.41l20,20A1,1,0,0,1,30,31Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CloseHeavy);

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ColorPalete=function ColorPalete(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.42,19.68a3.3,3.3,0,1,1,3.3-3.3A3.31,3.31,0,0,1,11.42,19.68Zm0-5.61a2.3,2.3,0,1,0,2.3,2.3A2.31,2.31,0,0,0,11.42,14.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.25,19a3.3,3.3,0,1,1,3.3-3.3A3.31,3.31,0,0,1,28.25,19Zm0-5.61a2.3,2.3,0,1,0,2.3,2.3A2.31,2.31,0,0,0,28.25,13.41Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.67,14.73a3.3,3.3,0,1,1,3.3-3.3A3.31,3.31,0,0,1,19.67,14.73Zm0-5.61a2.3,2.3,0,1,0,2.3,2.3A2.31,2.31,0,0,0,19.67,9.12Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13.4,28.58a3.3,3.3,0,1,1,3.3-3.3A3.31,3.31,0,0,1,13.4,28.58Zm0-5.61a2.3,2.3,0,1,0,2.3,2.3A2.31,2.31,0,0,0,13.4,23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.82,36A16.14,16.14,0,0,1,4.23,22.74,15.9,15.9,0,0,1,16.93,4.32,16.53,16.53,0,0,1,34.29,12h0a11.08,11.08,0,0,1,1,9.65A9.06,9.06,0,0,1,27,27.38H23.88A2,2,0,0,0,22,28.58a1.9,1.9,0,0,0,.27,2.2A3.19,3.19,0,0,1,23,33.46,3.13,3.13,0,0,1,19.82,36Zm.31-31a15.18,15.18,0,0,0-3,.3A14.91,14.91,0,0,0,5.22,22.58,15.12,15.12,0,0,0,19.82,35,2.13,2.13,0,0,0,22,33.26a2.2,2.2,0,0,0-.58-1.86,2.9,2.9,0,0,1-.39-3.25,3,3,0,0,1,2.77-1.76H27a8,8,0,0,0,7.41-5.13,10.12,10.12,0,0,0-1-8.81h0A15.26,15.26,0,0,0,20.14,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ColorPalete);

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ColourPicker=function ColourPicker(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.51,36a2.69,2.69,0,0,1-1.92-.8,2.73,2.73,0,0,1-.79-1.95c0-1.11,1.14-2.74,1.82-3.61a1.21,1.21,0,0,1,1.87,0c0,.05,1.79,2.19,1.79,3.58A2.82,2.82,0,0,1,8.51,36Zm0-5.81a.23.23,0,0,0-.14.08,6.89,6.89,0,0,0-1.6,3,1.74,1.74,0,0,0,.5,1.24,1.7,1.7,0,0,0,1.21.5,1.83,1.83,0,0,0,1.77-1.77,7.27,7.27,0,0,0-1.6-3A.17.17,0,0,0,8.54,30.19Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.48,21.56a2.89,2.89,0,0,1-1.77-1l-6.29-6.29a3.42,3.42,0,0,1-1.07-1.85,2.23,2.23,0,0,1,.84-1.71l.51-.52A2.39,2.39,0,0,1,21.08,10l4-4c2.36-2.36,5.59-2.54,7.69-.44s1.83,4.85-.68,7.4l-4,4a2.21,2.21,0,0,1,.57,1.43,2.45,2.45,0,0,1-.83,1.72l-.68.68A2.25,2.25,0,0,1,25.48,21.56Zm-6-11.19a1.55,1.55,0,0,0-1.09.54l-.56.56a1.29,1.29,0,0,0-.5.93,2.69,2.69,0,0,0,.77,1.16l6.32,6.32a2.09,2.09,0,0,0,1,.68,1.3,1.3,0,0,0,1-.51l.7-.7a1.51,1.51,0,0,0,.54-1,1.59,1.59,0,0,0-.62-1.09l-.35-.35,4.73-4.73c2.1-2.14,2.35-4.32.68-6s-4.3-1.54-6.27.44l-4.71,4.71L20.77,11A1.83,1.83,0,0,0,19.51,10.37Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M9.24,26.7a.5.5,0,0,1-.35-.85l.6-.6c-.2-1.36.07-1.63.18-1.73l8.81-8.81.71.71-8.75,8.75a5,5,0,0,0,.08,1.17.5.5,0,0,1-.14.44l-.78.78A.5.5,0,0,1,9.24,26.7Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.63,29.23a.5.5,0,0,1-.35-.85L12,27.6a.5.5,0,0,1,.44-.14,4.86,4.86,0,0,0,1.17.08l8.75-8.75.71.71-8.81,8.81c-.11.11-.37.38-1.73.18l-.6.6A.5.5,0,0,1,11.63,29.23Zm2.07-1.7Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ColourPicker);

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Comfort=function Comfort(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11,28.0031245 L11,29.504611 C11,29.7782068 10.7680664,30 10.5,30 C10.2238576,30 10,29.7842474 10,29.504611 L10,28.0031245 L7.67964444,28.0031245 C6.79537778,28.0031245 6.07644444,27.2838356 6.07644444,26.3999245 C6.07644444,26.308603 6.20302222,25.7755689 6.20302222,25.7755689 L5.54598439,25.4969362 C4.6147594,24.9666429 4,23.971992 4,22.8731689 L4,18.5569778 C4,16.9493861 5.26139035,15.6308493 6.8464,15.5391384 L8.00860596,15.5632 L8.00860596,13.9464889 C8.00860596,11.2190222 10.2334205,9 12.9612427,9 L27.0672607,9 C29.7947274,9 31.9985962,11.2190222 31.9985962,13.9464889 L31.9985962,15.5632 L33.1536,15.5632 C34.7386097,15.6308493 36,16.9493861 36,18.5569778 L36,22.8731689 C36,23.9947562 35.3849898,24.9741296 34.4754307,25.495202 L33.7991111,25.7798356 C33.7991111,25.7798356 33.9242667,26.3168412 33.9242667,26.3999245 C33.9242667,27.2841912 33.2049778,28.0031245 32.3210667,28.0031245 L30,28.0031245 L30,29.504611 C30,29.7782068 29.7680664,30 29.5,30 C29.2238576,30 29,29.7842474 29,29.504611 L29,28.0031245 L11,28.0031245 L11,28.0031245 Z M32.9770667,16.5340444 L31.0137496,16.7064174 L31.0137496,13.9464889 C31.0137496,11.771307 29.2424427,10 27.0672607,10 L12.9612427,10 C10.785839,10 9.01475379,11.7711731 9.01475379,13.9464889 L9.01475379,16.7033168 L7.02293333,16.5340444 C5.90837364,16.5340444 5,17.4424181 5,18.5569778 L5,22.8731689 C5,23.7589172 5.611668,24.5608726 6.4835817,24.8157323 L7.56252577,25.1311068 C7.56252577,25.1311068 7.07644444,26.3177137 7.07644444,26.3999245 C7.07644444,26.7317079 7.34781952,27.0031245 7.67964444,27.0031245 L32.3210667,27.0031245 C32.65285,27.0031245 32.9242667,26.7317494 32.9242667,26.3999245 C32.9242667,26.319039 32.4389185,25.125834 32.4389185,25.125834 L33.5265294,24.817703 C34.3901153,24.5730405 35,23.780571 35,22.8731689 L35,18.5569778 C35,17.4424181 34.0916264,16.5340444 32.9770667,16.5340444 Z M34.0064403,22.1214948 C34.0064403,23.0548282 33.3383514,23.8261333 32.4547959,24 C32.4110626,24.0021333 7.64728889,24.0053333 7.61528889,24 C6.6944,23.8496 6,23.0127501 6,22.080839 L6,18.9235556 C6,17.8629333 6.86293333,17 7.92355556,17 L8.35128889,17 C9.41191111,17 10.2748444,17.8629333 10.2748444,18.9235556 L10.2748444,19.454167 C10.2748444,20.0038559 10.7299556,20.0038559 11.2576,20.0038559 L29.181907,20.0042114 C29.4851959,20.0042114 29.7315959,19.758167 29.7315959,19.4545225 L29.7315959,18.9235556 C29.7315959,17.8629333 30.5945292,17 31.6551514,17 L32.0828848,17 C33.143507,17 34.0064403,17.8629333 34.0064403,18.9235556 L34.0064403,22.1214948 Z M33.0064403,22.1214948 L33.0064403,18.9235556 C33.0064403,18.4152181 32.5912222,18 32.0828848,18 L31.6551514,18 C31.146814,18 30.7315959,18.4152181 30.7315959,18.9235556 L30.7315959,19.4545225 C30.7315959,20.310429 30.0375035,21.0042114 29.1818872,21.0042114 L11.2576,21.0038559 C10.7320036,21.0038559 10.5233445,20.9885209 10.2112655,20.8692147 C9.62098833,20.6435549 9.27484444,20.1179933 9.27484444,19.454167 L9.27484444,18.9235556 C9.27484444,18.4152181 8.85962636,18 8.35128889,18 L7.92355556,18 C7.41521808,18 7,18.4152181 7,18.9235556 L7,22.080839 C7,22.5297213 7.34618307,22.9428005 7.77968788,23.0136061 C7.71259572,23.0024241 30.891934,23.0005771 32.3357206,23.0011268 C32.7285982,22.8902233 33.0064403,22.5345431 33.0064403,22.1214948 Z M19.5,10 L20.5,10 L20.5,20 L19.5,20 L19.5,10 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Comfort);

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Connected=function Connected(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.37,29.86H18.6c-5.92,0-10.22-3.84-10.22-9.14V19.28c0-5.29,4.3-9.14,10.22-9.14h6.76a5.15,5.15,0,0,1,5.26,5v9.68A5.15,5.15,0,0,1,25.37,29.86ZM18.6,11.14c-5.34,0-9.22,3.42-9.22,8.14v1.44c0,4.72,3.88,8.14,9.22,8.14h6.76a4.2,4.2,0,0,0,4.26-4V15.16a4.2,4.2,0,0,0-4.26-4Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,17.22H30.23a.5.5,0,0,1,0-1H35.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,23.78H30.23a.5.5,0,0,1,0-1H35.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.82,20.5H4.5a.5.5,0,0,1,0-1H8.82a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.25,18a.5.5,0,0,1-.5-.5c0-1.35-1.21-2.52-3-2.87a.5.5,0,1,1,.19-1c2.21.43,3.76,2,3.76,3.85A.5.5,0,0,1,26.25,18Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Connected);

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ControlPage=function ControlPage(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.61,23.51a6.18,6.18,0,1,1,6.18-6.18A6.19,6.19,0,0,1,11.61,23.51Zm0-11.37a5.18,5.18,0,1,0,5.18,5.18A5.19,5.19,0,0,0,11.61,12.15Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.61,36a.5.5,0,0,1-.5-.5V26.09a.5.5,0,0,1,1,0V35.5A.5.5,0,0,1,11.61,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.61,9.65a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0V9.15A.5.5,0,0,1,11.61,9.65Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.39,28.85a6.18,6.18,0,1,1,6.18-6.18A6.19,6.19,0,0,1,28.39,28.85Zm0-11.37a5.18,5.18,0,1,0,5.18,5.18A5.19,5.19,0,0,0,28.39,17.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.39,14.41a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0v9.41A.5.5,0,0,1,28.39,14.41Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.39,36a.5.5,0,0,1-.5-.5V30.85a.5.5,0,0,1,1,0V35.5A.5.5,0,0,1,28.39,36Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ControlPage);

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Copy=function Copy(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.21,36h-15a3.5,3.5,0,0,1-3.5-3.5v-19a3.5,3.5,0,0,1,3.5-3.5h15a3.5,3.5,0,0,1,3.5,3.5v19A3.5,3.5,0,0,1,30.21,36Zm-15-25a2.5,2.5,0,0,0-2.5,2.5v19a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5v-19a2.5,2.5,0,0,0-2.5-2.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M9.88,30H8.42c-1.12,0-2-1.5-2-3.5V7.5A3.5,3.5,0,0,1,10,4H25c2,0,3.5,1,3.5,2.27V8a.5.5,0,0,1-1,0V6.27C27.46,5.67,26.39,5,25,5H10a2.5,2.5,0,0,0-2.5,2.5v19c0,1.5.58,2.5,1,2.5H9.88a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28,13.54a.5.5,0,0,1-.5-.5V11a.5.5,0,0,1,1,0v2A.5.5,0,0,1,28,13.54Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25,30H22.2a.5.5,0,0,1,0-1H25a2.48,2.48,0,0,0,1.47-.48.5.5,0,1,1,.59.81A3.47,3.47,0,0,1,25,30Zm3-6a.5.5,0,0,1-.5-.5V18.86a.5.5,0,0,1,1,0v4.65A.5.5,0,0,1,28,24Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.38,30h-2a.5.5,0,0,1,0-1h2a.5.5,0,0,1,0,1Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Copy);

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Create=function Create(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,20.43a.5.5,0,0,1-.24-.06l-6.93-3.85a.5.5,0,0,1-.26-.44V8.35a.5.5,0,0,1,.26-.44L19.8,4.06a.5.5,0,0,1,.49,0l6.84,3.85a.5.5,0,0,1,.25.44v7.73a.5.5,0,0,1-.25.44l-6.84,3.85A.5.5,0,0,1,20,20.43Zm-6.43-4.64L20,19.36l6.34-3.57V8.64L20,5.07,13.61,8.64Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.44,36a.5.5,0,0,1-.24-.06L4.26,32.09A.5.5,0,0,1,4,31.65V23.92a.5.5,0,0,1,.26-.44l6.94-3.85a.5.5,0,0,1,.49,0l6.84,3.85a.5.5,0,0,1,.25.44v7.73a.5.5,0,0,1-.25.44l-6.84,3.85A.5.5,0,0,1,11.44,36ZM5,31.36l6.43,3.57,6.34-3.57V24.21l-6.34-3.57L5,24.21Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.66,36a.5.5,0,0,1-.24-.06l-6.94-3.85a.5.5,0,0,1-.26-.44V23.92a.5.5,0,0,1,.26-.44l6.94-3.85a.5.5,0,0,1,.49,0l6.84,3.85a.5.5,0,0,1,.25.44v7.73a.5.5,0,0,1-.25.44L28.9,35.94A.5.5,0,0,1,28.66,36Zm-6.44-4.64,6.43,3.57L35,31.36V24.21l-6.34-3.57-6.43,3.57Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Create);

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CreatePlus=function CreatePlus(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,25.5a.5.5,0,0,1-.5-.5V15a.5.5,0,0,1,1,0V25A.5.5,0,0,1,20,25.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25,20.5H15a.5.5,0,0,1,0-1H25a.5.5,0,1,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.09,36a.5.5,0,0,1-.24-.06L5.92,28.21a.5.5,0,0,1-.26-.44V12.23a.5.5,0,0,1,.26-.44L19.85,4.06a.5.5,0,0,1,.49,0L34.08,11.8a.5.5,0,0,1,.25.44V27.77a.5.5,0,0,1-.25.44L20.34,35.94A.5.5,0,0,1,20.09,36ZM6.66,27.47l13.43,7.45,13.25-7.45v-15L20.09,5.07,6.66,12.53Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CreatePlus);

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Dashboard=function Dashboard(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,4.12a3.56,3.56,0,1,0,3.56,3.56A3.56,3.56,0,0,0,20,4.12Zm12.44,6A3.56,3.56,0,1,0,36,13.67a3.56,3.56,0,0,0-3.56-3.56Zm-24.89,0a3.56,3.56,0,1,0,3.56,3.56,3.56,3.56,0,0,0-3.56-3.56ZM20,16.44A3.56,3.56,0,1,0,23.56,20,3.56,3.56,0,0,0,20,16.44Zm12.44,6.4A3.56,3.56,0,1,0,36,26.4a3.56,3.56,0,0,0-3.56-3.56Zm-24.89,0a3.56,3.56,0,1,0,3.56,3.56,3.56,3.56,0,0,0-3.56-3.56ZM20,28.77a3.56,3.56,0,1,0,3.56,3.56A3.56,3.56,0,0,0,20,28.77Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Dashboard);

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Demo=function Demo(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.27,36H13.73a5.51,5.51,0,0,1-5.5-5.5V9.5A5.51,5.51,0,0,1,13.73,4H26.27a5.51,5.51,0,0,1,5.5,5.5v21A5.51,5.51,0,0,1,26.27,36ZM13.73,5a4.5,4.5,0,0,0-4.5,4.5v21a4.5,4.5,0,0,0,4.5,4.5H26.27a4.5,4.5,0,0,0,4.5-4.5V9.5A4.5,4.5,0,0,0,26.27,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'22.55',x:'8.73',y:'11.74'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'22.55',x:'8.73',y:'27.26'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.61,9.06h-6a.5.5,0,0,1,0-1h6a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'16.39',cy:'8.56',r:'1'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'20',cy:'31.75',r:'1.5'}));};/* harmony default export */ __webpack_exports__["a"] = (Demo);

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Dimmer=function Dimmer(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'32',cy:'30.32',r:'2.58'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'33.94',cy:'23.1',r:'2.06'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'32',cy:'15.87',r:'1.81'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'26.71',cy:'10.58',r:'1.81'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'19.48',cy:'8.65',r:'1.55'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'12.26',cy:'10.58',r:'1.29'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'6.97',cy:'15.87',r:'1.03'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'5.03',cy:'23.1',r:'1.03'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'6.97',cy:'30.32',r:'1.03'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,32.63a9.53,9.53,0,1,1,9.53-9.53A9.54,9.54,0,0,1,20,32.63Zm0-18.06a8.53,8.53,0,1,0,8.53,8.53A8.54,8.54,0,0,0,20,14.56Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Dimmer);

/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Discover=function Discover(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.1950597,26.3968721 C13.2547551,24.9371157 12,22.6150897 12,20 C12,17.3849103 13.2547551,15.0628843 15.1950597,13.6031279 C11.2432672,14.615905 7.74792325,16.8601188 5.25607854,20 C7.74792325,23.1398812 11.2432672,25.384095 15.1950597,26.3968721 Z M24.8049403,13.6031279 C26.7452449,15.0628843 28,17.3849103 28,20 C28,22.6150897 26.7452449,24.9371157 24.8049403,26.3968721 C28.7567328,25.384095 32.2520767,23.1398812 34.7439215,20 C32.2520767,16.8601188 28.7567328,14.615905 24.8049403,13.6031279 Z M20,12 C26.6245193,12 32.477277,15.1640424 36,20 C32.477277,24.8359576 26.6245193,28 20,28 C13.3754807,28 7.52272299,24.8359576 4,20 C7.52272299,15.1640424 13.3754807,12 20,12 Z M20,27 C23.8659932,27 27,23.8659932 27,20 C27,16.1340068 23.8659932,13 20,13 C16.1340068,13 13,16.1340068 13,20 C13,23.8659932 16.1340068,27 20,27 Z M20,24 C17.790861,24 16,22.209139 16,20 C16,17.790861 17.790861,16 20,16 C22.209139,16 24,17.790861 24,20 C24,22.209139 22.209139,24 20,24 Z M20,23 C21.6568542,23 23,21.6568542 23,20 C23,18.3431458 21.6568542,17 20,17 C18.3431458,17 17,18.3431458 17,20 C17,21.6568542 18.3431458,23 20,23 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Discover);

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var DogBark=function DogBark(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M4.74124198,21.1214225 C3.00638159,19.1677482 2.49560096,15.5962577 3.53744424,12.0143904 C4.90874142,7.29985743 8.51702707,4.15272516 11.783304,5.20235979 C12.3884475,5.39682571 12.7862241,5.90229235 13.0048567,6.65346727 C15.0990574,5.59658286 17.4742507,5 19.9914991,5 C22.5146909,5 24.895156,5.59940334 26.9929705,6.66096111 C27.2111355,5.90565388 27.6095423,5.39747168 28.216696,5.20235979 C31.4829729,4.15272516 35.0912586,7.29985743 36.4625558,12.0143904 C37.50811,15.609016 36.98996,19.1931909 35.2401731,21.1422374 C34.6452028,28.8928809 28.0454481,35 19.9914991,35 C11.9303416,35 5.32598276,28.881944 4.74124198,21.1214225 L4.74124198,21.1214225 Z M19.9914991,23.3333333 C19.2260008,23.3333333 18.5787348,23.829868 18.3661899,24.5124986 C18.7784717,24.6375321 19.3674547,24.7140452 19.9914991,24.7140452 C20.6155435,24.7140452 21.2045265,24.6375321 21.6168083,24.5124986 C21.4042634,23.829868 20.7569973,23.3333333 19.9914991,23.3333333 Z M14.8940494,18.3333333 C15.8324639,18.3333333 16.5931993,17.5871412 16.5931993,16.6666667 C16.5931993,15.7461921 15.8324639,15 14.8940494,15 C13.9556348,15 13.1948995,15.7461921 13.1948995,16.6666667 C13.1948995,17.5871412 13.9556348,18.3333333 14.8940494,18.3333333 Z M25.0889488,18.3333333 C26.0273634,18.3333333 26.7880987,17.5871412 26.7880987,16.6666667 C26.7880987,15.7461921 26.0273634,15 25.0889488,15 C24.1505342,15 23.3897989,15.7461921 23.3897989,16.6666667 C23.3897989,17.5871412 24.1505342,18.3333333 25.0889488,18.3333333 Z M32.7658984,20.8425618 C34.9361448,20.1451422 35.9752147,16.4137045 34.8286061,12.471653 C33.6874481,8.5483409 30.8805276,6.1001561 28.7457019,6.78619316 C28.2345353,6.95045911 28.4288084,10.3910266 29.5473615,14.2366231 C30.6551607,18.0452476 32.311448,20.9886018 32.7658984,20.8425618 Z M7.23410159,20.8425618 C7.68855204,20.9886018 9.34483929,18.0452476 10.4526385,14.2366231 C11.5711916,10.3910266 11.7654647,6.95045911 11.2542981,6.78619316 C9.1194724,6.1001561 6.3125519,8.5483409 5.17139394,12.471653 C4.02478534,16.4137045 5.06385518,20.1451422 7.23410159,20.8425618 Z M5.29658062,21.6561465 C5.69342107,22.0212591 6.14298001,22.3133503 6.64026733,22.5175888 C7.78870166,28.4125699 12.8943983,32.9298151 19.1419241,33.307715 L19.1419241,26.3416246 C17.7686724,26.2128089 16.5931993,25.7656007 16.5931993,25 C16.5931993,23.1590508 18.1146699,21.6666667 19.9914991,21.6666667 C21.8683283,21.6666667 23.3897989,23.1590508 23.3897989,25 C23.3897989,25.7656007 22.2143257,26.2128089 20.841074,26.3416246 L20.841074,33.307715 C27.1288846,32.9273784 32.2600932,28.3541424 33.3644522,22.4033833 C33.3413699,22.4112421 33.3181872,22.4189131 33.2949043,22.4263952 C31.5284759,22.9940459 29.8474089,20.4736563 28.483006,16.4986375 C28.4858233,16.5542988 28.4872486,16.6103195 28.4872486,16.6666667 C28.4872486,18.5076158 26.965778,20 25.0889488,20 C23.2121197,20 21.690649,18.5076158 21.690649,16.6666667 C21.690649,14.8257175 23.2121197,13.3333333 25.0889488,13.3333333 C26.3076021,13.3333333 27.3764328,13.9625374 27.9762086,14.9078162 C27.9551825,14.83684 27.9342499,14.7655274 27.9134118,14.6938857 C27.210675,12.2778699 26.7982639,10.1103021 26.7882841,8.45053447 C24.7888636,7.31600205 22.4674895,6.66666667 19.9914991,6.66666667 C17.5225457,6.66666667 15.2073309,7.31231635 13.2117694,8.4408729 C13.2033364,10.1018864 12.7906893,12.2731792 12.0865882,14.6938857 C12.0704841,14.7492519 12.0543235,14.8044216 12.038107,14.8593913 C12.6433244,13.9411095 13.6963267,13.3333333 14.8940494,13.3333333 C16.7708785,13.3333333 18.2923492,14.8257175 18.2923492,16.6666667 C18.2923492,18.5076158 16.7708785,20 14.8940494,20 C13.0172202,20 11.4957495,18.5076158 11.4957495,16.6666667 C11.4957495,16.6292679 11.4963775,16.5920131 11.4976235,16.5549117 C10.1366957,20.497416 8.4631739,22.9913625 6.70509568,22.4263952 C6.18449355,22.2590971 5.71395616,21.9972965 5.29658062,21.6561465 L5.29658062,21.6561465 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (DogBark);

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Download=function Download(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,36H9.13a4,4,0,0,1-4-4V10.26a4,4,0,0,1,4-4h5.74a.5.5,0,0,1,0,1H9.13a3,3,0,0,0-3,3V32a3,3,0,0,0,3,3H30.87a3,3,0,0,0,3-3V10.26a3,3,0,0,0-3-3H25.13a.5.5,0,0,1,0-1h5.74a4,4,0,0,1,4,4V32A4,4,0,0,1,30.87,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,20.09a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0V19.59A.5.5,0,0,1,20,20.09Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.2,12.82a.5.5,0,0,1,.69.15L20,19.43,24.11,13a.5.5,0,1,1,.84.54l-4.53,7.11a.5.5,0,0,1-.84,0L15,13.51a.5.5,0,0,1,.15-.69Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,36H9.13a4,4,0,0,1-4-4V10.26a4,4,0,0,1,4-4h5.74a.5.5,0,0,1,0,1H9.13a3,3,0,0,0-3,3V32a3,3,0,0,0,3,3H30.87a3,3,0,0,0,3-3V10.26a3,3,0,0,0-3-3H25.13a.5.5,0,0,1,0-1h5.74a4,4,0,0,1,4,4V32A4,4,0,0,1,30.87,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,20.09a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0V19.59A.5.5,0,0,1,20,20.09Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.2,12.82a.5.5,0,0,1,.69.15L20,19.43,24.11,13a.5.5,0,1,1,.84.54l-4.53,7.11a.5.5,0,0,1-.84,0L15,13.51a.5.5,0,0,1,.15-.69Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,36H9.13a4,4,0,0,1-4-4V10.26a4,4,0,0,1,4-4h5.74a.5.5,0,0,1,0,1H9.13a3,3,0,0,0-3,3V32a3,3,0,0,0,3,3H30.87a3,3,0,0,0,3-3V10.26a3,3,0,0,0-3-3H25.13a.5.5,0,0,1,0-1h5.74a4,4,0,0,1,4,4V32A4,4,0,0,1,30.87,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,20.09a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0V19.59A.5.5,0,0,1,20,20.09Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.2,12.82a.5.5,0,0,1,.69.15L20,19.43,24.11,13a.5.5,0,1,1,.84.54l-4.53,7.11a.5.5,0,0,1-.84,0L15,13.51a.5.5,0,0,1,.15-.69Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,36H9.13a4,4,0,0,1-4-4V10.26a4,4,0,0,1,4-4h5.74a.5.5,0,0,1,0,1H9.13a3,3,0,0,0-3,3V32a3,3,0,0,0,3,3H30.87a3,3,0,0,0,3-3V10.26a3,3,0,0,0-3-3H25.13a.5.5,0,0,1,0-1h5.74a4,4,0,0,1,4,4V32A4,4,0,0,1,30.87,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,20.09a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0V19.59A.5.5,0,0,1,20,20.09Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.2,12.82a.5.5,0,0,1,.69.15L20,19.43,24.11,13a.5.5,0,1,1,.84.54l-4.53,7.11a.5.5,0,0,1-.84,0L15,13.51a.5.5,0,0,1,.15-.69Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Download);

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Edit=function Edit(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M5.36,35.72A1.36,1.36,0,0,1,4.1,33.86l3.57-9a1.33,1.33,0,0,1,.3-.46L23.67,8.47l0,0,0,0L27.11,5a2.32,2.32,0,0,1,1.64-.7A2.37,2.37,0,0,1,30.41,5L35.3,9.73a2.34,2.34,0,0,1,0,3.31L16.19,32.55a1.36,1.36,0,0,1-.6.36L5.73,35.67A1.37,1.37,0,0,1,5.36,35.72Zm19-26.53L8.67,25.09a.35.35,0,0,0-.08.12L5,34.23a.36.36,0,0,0,.34.49l10-2.78a.36.36,0,0,0,.16-.09L34.62,12.34a1.34,1.34,0,0,0,0-1.89h0L29.71,5.66a1.37,1.37,0,0,0-1-.38,1.32,1.32,0,0,0-.92.4L24.41,9.14Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.81,32.73a.5.5,0,0,1-.35-.15L8,25.09a.5.5,0,0,1,.71-.71l7.49,7.49a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.16,15.73a.5.5,0,0,1-.35-.15L24.53,8.3a.5.5,0,0,1,.71-.71l7.28,7.28a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Edit);

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Efficiency=function Efficiency(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.2963116,29.3769562 C13.9122784,29.7182478 13.5198154,30.0563523 13.1189565,30.3906704 C10.5295111,32.5502792 7.73015527,34.42933 4.7253407,35.9463424 C4.47883258,36.0707947 4.1781098,35.9718488 4.05365757,35.7253407 C3.92920533,35.4788326 4.02815118,35.1781098 4.2746593,35.0536576 C7.20849549,33.5724793 9.94505499,31.7355801 12.478468,29.6227026 C12.8565384,29.3073903 13.2270097,28.988615 13.5898435,28.6669103 L13.4626783,28.4184104 L13.4215061,28.3269021 C11.3301809,22.9763253 11.5447606,17.9993423 14.0768396,13.9103376 C17.5727734,8.26358693 25.1917112,4.67053387 34.9314038,4.00234503 C35.5100658,3.96264609 36.0010073,4.4219818 35.9998456,5.00200278 C35.9769564,16.4307113 33.4305599,24.5402711 28.1633304,28.3292737 C26.0787096,29.8290687 23.6273642,30.5791564 20.8358519,30.5791564 C18.982114,30.5791564 16.9827562,30.2481802 14.8467831,29.5910996 L14.773508,29.5654041 L14.2963116,29.3769562 Z M15.1208797,28.6274317 L15.1408109,28.6353027 C17.1896152,29.265568 19.0905187,29.5791564 20.8358519,29.5791564 C23.4256848,29.5791564 25.6714298,28.8901725 27.579316,27.5175304 C32.7470579,23.8000946 34.9786616,15.5782761 34.9998476,5 C25.516418,5.65060799 18.2172421,9.12235094 14.9270828,14.4367277 C12.5756046,18.2340838 12.3663088,22.8802706 14.3528893,27.9628618 L14.3573822,27.9716417 C16.0505259,26.4048165 17.566204,24.7790072 18.9001377,23.1536389 C19.53276,22.3828028 20.0780445,21.6676664 20.5347139,21.0268166 C20.8070345,20.6446656 20.9882949,20.3738693 21.0772457,20.2330192 C21.2246951,19.9995384 21.5335001,19.9297962 21.7669808,20.0772457 C22.0004616,20.2246951 22.0702038,20.5335001 21.9227543,20.7669808 C21.8969635,20.8078197 21.8477947,20.8834833 21.7753897,20.9916537 C21.6561912,21.1697317 21.5140467,21.3756682 21.3490963,21.6071452 C20.8795698,22.2660376 20.3205516,22.9991856 19.6731415,23.7880402 C18.3333891,25.4204985 16.814909,27.05253 15.1208797,28.6274317 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Efficiency);

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Exclamation=function Exclamation(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'3',rx:'1.5',ry:'1.5',transform:'translate(40 54.75) rotate(-180)',width:'3',x:'18.5',y:'25.88'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,23.63a.5.5,0,0,1-.5-.5v-12a.5.5,0,0,1,1,0v12A.5.5,0,0,1,20,23.63Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Exclamation);

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var FrostProtection=function FrostProtection(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(G,gProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M20,36a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0v31A.5.5,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M20,10.61a.49.49,0,0,1-.22-.05L14.5,7.92A.5.5,0,0,1,14.95,7l5.28,2.64a.5.5,0,0,1-.22.95Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M20,10.61a.5.5,0,0,1-.22-.95L25.05,7a.5.5,0,0,1,.45.89l-5.28,2.64A.49.49,0,0,1,20,10.61Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M14.72,33a.5.5,0,0,1-.22-.95l5.28-2.64a.5.5,0,0,1,.45.89L14.95,33A.49.49,0,0,1,14.72,33Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M25.28,33a.49.49,0,0,1-.22-.05l-5.28-2.64a.5.5,0,0,1,.45-.89l5.28,2.64a.5.5,0,0,1-.22.95Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M7,28.94A.5.5,0,0,1,6.73,28l26-16.88a.5.5,0,1,1,.54.84l-26,16.88A.5.5,0,0,1,7,28.94Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M28.3,15.11a.5.5,0,0,1-.5-.44L27.14,8.8a.5.5,0,1,1,1-.11l.66,5.86a.5.5,0,0,1-.44.55Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M33.38,18.1a.5.5,0,0,1-.25-.07L28,15a.5.5,0,1,1,.51-.86l5.09,3a.5.5,0,0,1-.25.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M11.7,25.89a.5.5,0,0,1-.25-.07l-5.09-3A.5.5,0,1,1,6.87,22L12,25a.5.5,0,0,1-.25.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M12.36,31.75a.5.5,0,0,1-.5-.44l-.66-5.86a.5.5,0,1,1,1-.11l.66,5.86a.5.5,0,0,1-.44.55Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M33,28.94a.5.5,0,0,1-.27-.08L6.73,12a.5.5,0,1,1,.54-.84L33.27,28a.5.5,0,0,1-.27.92Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M6.62,18.1a.5.5,0,0,1-.25-.93l5.09-3A.5.5,0,1,1,12,15L6.87,18A.5.5,0,0,1,6.62,18.1Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M11.7,15.11h-.06a.5.5,0,0,1-.44-.55l.66-5.86a.5.5,0,1,1,1,.11l-.66,5.86A.5.5,0,0,1,11.7,15.11Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M27.64,31.75h-.06a.5.5,0,0,1-.44-.55l.66-5.86a.5.5,0,1,1,1,.11l-.66,5.86A.5.5,0,0,1,27.64,31.75Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M28.3,25.89A.5.5,0,0,1,28,25l5.09-3a.5.5,0,1,1,.51.86l-5.09,3A.5.5,0,0,1,28.3,25.89Z'}));};FrostProtection.propTypes={fill:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (FrostProtection);

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var GlassBreak=function GlassBreak(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.4050907,17.2189411 L26.0170196,7.29998779 L16.0991263,7.29998779 L12.449912,18.2488007 C12.2731622,18.7791068 12.5839202,19.2027318 13.1414302,19.2027318 L17.5868103,19.2027318 L14.3577392,32.1203966 C14.2257927,32.6482392 14.4112026,32.751339 14.7759115,32.3344843 L27.3402344,17.9737233 C27.7105892,17.5504154 27.5503936,17.2189411 26.9950379,17.2189411 L19.4050907,17.2189411 Z M21.2734971,16.2189411 L26.9950379,16.2189411 C28.4067819,16.2189411 29.0307884,17.5601393 28.092846,18.632188 L15.528523,32.992949 C14.4733343,34.199008 13.0008076,33.4251829 13.3875906,31.8778854 L16.3060671,20.2027318 L13.1414302,20.2027318 C11.902361,20.2027318 11.1083304,19.1113941 11.5012186,17.9326034 L15.3783427,6.29998779 L27.8854259,6.29998779 L21.2734971,16.2189411 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (GlassBreak);

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Graphs=function Graphs(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.23,34.59a3.32,3.32,0,0,1-3.32-3.32V8.73a3.32,3.32,0,0,1,6.64,0V31.27A3.32,3.32,0,0,1,24.23,34.59Zm0-28.18a2.32,2.32,0,0,0-2.32,2.32V31.27a2.32,2.32,0,0,0,4.64,0V8.73A2.32,2.32,0,0,0,24.23,6.41Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.32,34.59A3.32,3.32,0,0,1,4,31.27V15.77a3.32,3.32,0,1,1,6.64,0v15.5A3.32,3.32,0,0,1,7.32,34.59Zm0-21.14A2.32,2.32,0,0,0,5,15.77v15.5a2.32,2.32,0,0,0,4.64,0V15.77A2.32,2.32,0,0,0,7.32,13.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.77,34.59a3.32,3.32,0,0,1-3.32-3.32V22.11a3.32,3.32,0,0,1,6.64,0v9.16A3.32,3.32,0,0,1,15.77,34.59Zm0-14.79a2.32,2.32,0,0,0-2.32,2.32v9.16a2.32,2.32,0,0,0,4.64,0V22.11A2.32,2.32,0,0,0,15.77,19.8Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.68,34.59a3.32,3.32,0,0,1-3.32-3.32v-19a3.32,3.32,0,1,1,6.64,0v19A3.32,3.32,0,0,1,32.68,34.59Zm0-24.66a2.32,2.32,0,0,0-2.32,2.32v19a2.32,2.32,0,0,0,4.64,0v-19A2.32,2.32,0,0,0,32.68,9.93Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Graphs);

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var GroupControl=function GroupControl(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.814 32.257l.01-.008c.103-.08.17-.196.188-.318l.057-.462c.147-1.2.455-3.7 1.043-5.58.58-1.85 1.072-2.96 1.432-3.77.41-.927.616-1.393.616-2.15 0-.343-.05-.422-.05-.425-.073-.04-.445-.035-.743-.04h-11.84c-.898 0-.898.21-.898.5 0 .77.2 1.234.602 2.16.346.8.82 1.89 1.39 3.71.587 1.876.883 4.29 1.042 5.588l.06.47c.016.128.087.247.192.324h6.898zm-.183 1h-6.448v.456c0 .698.643 1.287 1.404 1.287h3.563c.802 0 1.48-.625 1.48-1.365v-.378zm3.744-15.56H20.358c-.33 0-1.104 0-1.452-.685-.625-1.234-.906-3.006-.906-4.215C18 7.947 22.202 4 27.366 4c8.698 0 9.34 7.68 9.364 8.05.126 1.623-.246 3.663-.903 4.96-.35.687-1.123.687-1.453.687zM27.366 5C22.753 5 19 8.498 19 12.797c0 1.29.328 2.837.798 3.763.033.066.108.137.56.137h14.016c.452 0 .527-.072.56-.14.575-1.13.91-2.995.8-4.432l-.002-.013C35.717 11.822 35.268 5 27.366 5zm1.783 31h-3.564c-1.304 0-2.404-1.047-2.404-2.287v-.77c-.243-.23-.406-.544-.45-.878l-.06-.48c-.145-1.176-.444-3.622-1.005-5.41-.555-1.77-1.016-2.835-1.352-3.61-.428-.988-.686-1.584-.686-2.56 0-1.5 1.427-1.5 1.896-1.5h11.84c.65.005 1.115 0 1.453.337.3.3.34.74.34 1.128 0 .97-.278 1.6-.7 2.554-.35.79-.83 1.87-1.392 3.666-.562 1.79-.862 4.23-1.006 5.402l-.06.472c-.038.295-.17.574-.37.796v.775c0 1.282-1.138 2.365-2.483 2.365zm3.215-23.833c-.276 0-.5-.224-.5-.5 0-1.346-1.214-2.524-2.953-2.866-.27-.052-.447-.315-.395-.586.053-.27.317-.448.588-.394 2.213.435 3.76 2.017 3.76 3.847 0 .276-.224.5-.5.5z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.256 13.9c-.04-.61-.277-1.525-.83-2.392-.882-1.39-2.33-2.208-4.61-2.208-3.01 0-5.44 2.28-5.44 5.048 0 .772.187 1.743.476 2.364.033.003.08.005.146.005h9.636c.067 0 .113-.002.147-.005.344-.73.547-1.897.476-2.81zM4.998 17.718c-.227 0-.76 0-.998-.47-.43-.85-.623-2.068-.623-2.9 0-3.334 2.89-6.047 6.44-6.047 5.98 0 6.42 5.28 6.437 5.534.087 1.116-.17 2.52-.62 3.41-.24.473-.773.473-1 .473H4.998zM12.052 27.375c.21-1.704.397-2.83.73-3.89.33-1.052.578-1.686.996-2.628.334-.752.397-.96.397-1.35 0-.12-.002-.13.058-.07.067.07.048.065-.26.063H5.8c-.16 0-.252.007-.328.03.025.405.082.597.414 1.363.402.927.642 1.548.966 2.58.135.43.255.923.362 1.47.15.764.24 1.396.367 2.425l.042.323.318.308v.957c0 .29.297.572.652.572h2.45c.383 0 .706-.308.706-.626v-.916l.257-.285c.004-.005.02-.113.047-.325zm-3.46 3.152c-.896 0-1.652-.72-1.652-1.572v-.53c-.168-.158-.28-.374-.31-.603l-.04-.33c-.1-.81-.306-2.49-.692-3.72-.382-1.216-.7-1.95-.93-2.482-.294-.68-.47-1.088-.47-1.76 0-1.03.98-1.03 1.303-1.03h8.14c.447.003.768 0 1 .23.208.208.235.51.235.777 0 .666-.192 1.1-.482 1.755-.24.543-.57 1.286-.957 2.52-.386 1.232-.592 2.91-.69 3.715l-.042.324c-.027.204-.118.396-.256.548v.533c0 .883-.78 1.627-1.706 1.627h-2.45z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.26 28.7h5.127v-1H7.26'}));};/* harmony default export */ __webpack_exports__["a"] = (GroupControl);

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HeatingPage=function HeatingPage(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,32.21a5.3,5.3,0,0,1-3.71-1.54,5.74,5.74,0,0,1-1.57-4.14A13.09,13.09,0,0,1,17,19.39a20.92,20.92,0,0,1,2.08-2.64,1.23,1.23,0,0,1,1.74,0,20.89,20.89,0,0,1,2.08,2.64,13.1,13.1,0,0,1,2.33,7.15,5.74,5.74,0,0,1-1.57,4.13A5.31,5.31,0,0,1,20,32.21Zm0-14.84a.19.19,0,0,0-.14.06,19.85,19.85,0,0,0-2,2.51,12.1,12.1,0,0,0-2.16,6.57A4.79,4.79,0,0,0,17,30a4.23,4.23,0,0,0,6,0,4.79,4.79,0,0,0,1.28-3.45,12.11,12.11,0,0,0-2.17-6.58,19.77,19.77,0,0,0-2-2.51A.18.18,0,0,0,20,17.37Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a10.14,10.14,0,0,1-7.18-3.06c-2-2-3-4.73-3-8.26-.13-5.79,2.46-11.14,4.65-14.61a42.88,42.88,0,0,1,4.19-5.45,1.94,1.94,0,0,1,2.78,0,42.74,42.74,0,0,1,4.18,5.45c2.19,3.47,4.78,8.82,4.65,14.61-.08,3.53-1.07,6.23-3,8.26A10.14,10.14,0,0,1,20,36ZM20,5a.87.87,0,0,0-.65.29,41.81,41.81,0,0,0-4.08,5.32c-2.11,3.35-4.61,8.5-4.49,14,.07,3.26,1,5.75,2.76,7.58a9,9,0,0,0,12.93,0c1.78-1.84,2.69-4.32,2.76-7.58.12-5.55-2.37-10.7-4.49-14.05a41.64,41.64,0,0,0-4.08-5.31A.87.87,0,0,0,20,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (HeatingPage);

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Help=function Help(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,29a9,9,0,1,1,9-9A9,9,0,0,1,20,29Zm0-17a8,8,0,1,0,8,8A8,8,0,0,0,20,12Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'7.06',transform:'translate(-12.46 28.15) rotate(-45)',width:'1',x:'27.25',y:'25.58'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'7.06',transform:'translate(-5.46 11.26) rotate(-45)',width:'1',x:'10.36',y:'8.69'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'7.02',transform:'translate(-11.08 28.74) rotate(-45)',width:'1',x:'28.65',y:'24.24'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'7.06',transform:'translate(-4.08 11.83) rotate(-45)',width:'1',x:'11.75',y:'7.31'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',transform:'translate(-0.11 24.18) rotate(-45)',width:'7.06',x:'25.61',y:'11.72'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',transform:'translate(-17.01 17.18) rotate(-45)',width:'7.02',x:'8.72',y:'28.63'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',transform:'translate(0.47 22.8) rotate(-45)',width:'7.06',x:'24.22',y:'10.34'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',transform:'translate(-16.44 15.8) rotate(-45)',width:'7.03',x:'7.34',y:'27.24'}));};/* harmony default export */ __webpack_exports__["a"] = (Help);

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HiveIcon=function HiveIcon(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,Object.assign({},gProps,{transform:'translate(4, 4)'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.923,27.853 C26.656,27.6 26.908,27.51 27.242,27.356 C27.698,27.152 28.049,26.834 28.049,26.264 C28.049,25.759 27.715,25.319 27.242,25.18 C26.819,25.058 26.306,25.238 25.923,25.343 L18.696,27.291 C16.921,27.771 15.055,27.763 13.287,27.291 L6.078,25.343 C5.694,25.238 5.181,25.058 4.758,25.18 C4.285,25.319 3.951,25.759 3.951,26.264 C3.951,26.834 4.301,27.152 4.758,27.356 C5.092,27.51 5.344,27.6 6.078,27.853 L12.929,30.24 C14.917,30.932 17.068,30.932 19.064,30.24 L25.923,27.853 Z M13.572,23.554 C15.169,23.946 16.815,23.946 18.42,23.554 L29.1,20.931 C29.777,20.768 30.045,20.711 30.42,20.589 C30.892,20.434 31.226,20.035 31.226,19.514 C31.226,19.008 30.892,18.569 30.42,18.43 C30.045,18.325 29.491,18.462 29.1,18.536 L17.548,20.597 C16.529,20.777 15.454,20.777 14.436,20.597 L2.901,18.536 C2.509,18.462 1.955,18.325 1.581,18.43 C1.108,18.569 0.774,19.008 0.774,19.514 C0.774,20.035 1.108,20.434 1.581,20.589 C1.955,20.711 2.224,20.768 2.901,20.931 L13.572,23.554 Z M19.666,0.207 C17.214,-0.069 14.77,-0.069 12.318,0.207 L8.66,0.623 C8.269,0.664 7.707,0.696 7.34,0.811 C6.965,0.933 6.534,1.283 6.534,1.886 C6.534,2.407 6.876,2.823 7.34,2.961 C7.715,3.067 8.269,3.059 8.66,3.059 L23.34,3.059 C23.732,3.059 24.285,3.067 24.66,2.961 C25.124,2.823 25.467,2.407 25.467,1.886 C25.467,1.283 25.034,0.933 24.66,0.811 C24.293,0.696 23.732,0.664 23.34,0.623 L19.666,0.207 Z M27.715,9.229 C28.114,9.205 28.66,9.181 29.034,9.075 C29.507,8.936 29.841,8.504 29.841,7.999 C29.841,7.494 29.507,7.062 29.034,6.924 C28.66,6.81 28.114,6.826 27.715,6.826 L4.285,6.826 C3.886,6.826 3.34,6.81 2.965,6.924 C2.493,7.062 2.159,7.494 2.159,7.999 C2.159,8.504 2.493,8.936 2.965,9.075 C3.34,9.181 3.886,9.205 4.285,9.229 L14.697,9.971 C15.552,10.028 16.44,10.028 17.287,9.971 L27.715,9.229 Z M29.874,14.886 C30.558,14.78 30.819,14.748 31.194,14.618 C31.666,14.455 32,14.072 32,13.542 C32,13.037 31.666,12.605 31.194,12.467 C30.819,12.353 30.273,12.442 29.874,12.483 L17.565,13.721 C16.529,13.827 15.454,13.827 14.42,13.721 L2.127,12.483 C1.727,12.442 1.173,12.353 0.807,12.467 C0.334,12.605 0,13.037 0,13.542 C0,14.072 0.334,14.455 0.807,14.618 C1.173,14.74 1.442,14.78 2.127,14.886 L13.89,16.776 C15.275,16.997 16.717,16.997 18.102,16.776 L29.874,14.886 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (HiveIcon);

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Holidays=function Holidays(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.56,36a2,2,0,0,1-1.67-.89l-3.2-4.79-4.79-3.2A2,2,0,0,1,4.59,24l1.3-1.29a2,2,0,0,1,1.91-.53l4,1,4.41-4.41L6.94,12.17a2,2,0,0,1-.25-3.06L7.92,7.88a2,2,0,0,1,2.19-.44l12.38,5.1L30,5a3.61,3.61,0,0,1,5,0,3.53,3.53,0,0,1,0,5l-7.51,7.51L32.56,29.9a2,2,0,0,1-.44,2.19l-1.23,1.23a2.07,2.07,0,0,1-3.06-.25l-6.63-9.29-4.41,4.41,1,4a2,2,0,0,1-.53,1.91L16,35.41A2,2,0,0,1,14.56,36ZM7.31,23.14a1,1,0,0,0-.71.3L5.3,24.73a1,1,0,0,0,.15,1.56l5,3.39,3.25,4.87a1,1,0,0,0,1.56.15l1.29-1.3a1,1,0,0,0,.27-1l-1.15-4.57,5.65-5.64,7.31,10.25a1,1,0,0,0,1.54.13l1.23-1.23a1,1,0,0,0,.22-1.1l-5.35-13,8-8a2.53,2.53,0,0,0,0-3.57,2.59,2.59,0,0,0-3.57,0l-8,8-13-5.35a1,1,0,0,0-1.1.22L7.39,9.82a1,1,0,0,0,.13,1.54l10.24,7.31-5.64,5.65L7.55,23.17A1,1,0,0,0,7.31,23.14Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Holidays);

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Home=function Home(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(G,gProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M32,36H25.19a2.36,2.36,0,0,1-2.25-2.46V27.29a.84.84,0,0,0-.75-.9H17.81a.83.83,0,0,0-.75.9v6.26A2.36,2.36,0,0,1,14.81,36H8a2.39,2.39,0,0,1-2.25-2.46v-15a.5.5,0,0,1,.5-.5h0a.5.5,0,0,1,.5.5v15A1.4,1.4,0,0,0,8,35h6.82a1.37,1.37,0,0,0,1.25-1.46V27.29a1.83,1.83,0,0,1,1.75-1.9h4.38a1.83,1.83,0,0,1,1.75,1.9v6.26A1.37,1.37,0,0,0,25.19,35H32a1.37,1.37,0,0,0,1.25-1.46V18.61a.5.5,0,0,1,1,0V33.54A2.36,2.36,0,0,1,32,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M35.5,20.7a.5.5,0,0,1-.36-.15l-15-15.47A.22.22,0,0,0,20,5c-.13,0-.2,0-.26.06L4.86,20.38a.5.5,0,1,1-.72-.7L19,4.38A1.18,1.18,0,0,1,20,4a1.13,1.13,0,0,1,.91.39l15,15.46a.5.5,0,0,1-.36.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HotWater=function HotWater(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.38,16.21a3.14,3.14,0,1,1,3.14-3.14A3.14,3.14,0,0,1,15.38,16.21Zm0-5.28a2.14,2.14,0,1,0,2.14,2.14A2.14,2.14,0,0,0,15.38,10.94Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.23,16.21a3.14,3.14,0,1,1,3.14-3.14A3.14,3.14,0,0,1,29.23,16.21Zm0-5.28a2.14,2.14,0,1,0,2.14,2.14A2.14,2.14,0,0,0,29.23,10.94Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.45,13.4h-1a2.14,2.14,0,1,0-4.28,0h-1a3.14,3.14,0,1,1,6.28,0Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'1',width:'8.57',x:'18.02',y:'12.57'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'3.96',width:'1',x:'21.81',y:'13.07'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.31,30.06a6.79,6.79,0,0,1-6.22-4.12H9.29v3.79H4v-5c0-2.43,2.38-4.13,5.78-4.13h6.31a6.76,6.76,0,0,1,12.44,0H36v5.29H28.53A6.79,6.79,0,0,1,22.31,30.06Zm-14-5.12h8.49l.12.33a5.76,5.76,0,0,0,10.82,0l.12-.33H35V21.65H27.84l-.12-.33a5.76,5.76,0,0,0-10.82,0l-.12.33h-7C7,21.65,5,22.94,5,24.78v4H8.29Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.39,21.94a.5.5,0,0,1-.48-.35,2.88,2.88,0,0,0-2.6-2,.5.5,0,0,1-.47-.52.48.48,0,0,1,.53-.47,3.89,3.89,0,0,1,3.5,2.73.5.5,0,0,1-.33.63Z'}));};/* harmony default export */ __webpack_exports__["a"] = (HotWater);

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var IncorrectSound=function IncorrectSound(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M6.4,10.4019786 C6.4,9.95905807 6.75509186,9.6 7.2,9.6 C7.6418278,9.6 8,9.96460876 8,10.4019786 L8,18.3980214 C8,18.8409419 7.64490814,19.2 7.2,19.2 C6.7581722,19.2 6.4,18.8353912 6.4,18.3980214 L6.4,10.4019786 Z M3.2,13.5976241 C3.2,13.1571085 3.55509186,12.8 4,12.8 C4.4418278,12.8 4.8,13.162429 4.8,13.5976241 L4.8,18.4023759 C4.8,18.8428915 4.44490814,19.2 4,19.2 C3.5581722,19.2 3.2,18.837571 3.2,18.4023759 L3.2,13.5976241 Z M12.8,19.9926224 C12.8,19.5548691 13.1550919,19.2 13.6,19.2 C14.0418278,19.2 14.4,19.5607801 14.4,19.9926224 L14.4,23.2073776 C14.4,23.6451309 14.0449081,24 13.6,24 C13.1581722,24 12.8,23.6392199 12.8,23.2073776 L12.8,19.9926224 Z M16,18.4074951 C16,17.9615279 16.3550919,17.6 16.8,17.6 C17.2418278,17.6 17.6,17.9670807 17.6,18.4074951 L17.6,19.9925049 C17.6,20.4384721 17.2449081,20.8 16.8,20.8 C16.3581722,20.8 16,20.4329193 16,19.9925049 L16,18.4074951 Z M9.6,23.1976241 C9.6,22.7571085 9.95509186,22.4 10.4,22.4 C10.8418278,22.4 11.2,22.762429 11.2,23.1976241 L11.2,28.0023759 C11.2,28.4428915 10.8449081,28.8 10.4,28.8 C9.9581722,28.8 9.6,28.437571 9.6,28.0023759 L9.6,23.1976241 Z M22.4,15.1947181 C22.4,14.7558074 22.7550919,14.4 23.2,14.4 C23.6418278,14.4 24,14.755957 24,15.1947181 L24,28.0052819 C24,28.4441926 23.6449081,28.8 23.2,28.8 C22.7581722,28.8 22.4,28.444043 22.4,28.0052819 L22.4,15.1947181 Z M19.2,16.7963181 C19.2,16.3565237 19.5550919,16 20,16 C20.4418278,16 20.8,16.3645315 20.8,16.7963181 L20.8,23.2036819 C20.8,23.6434763 20.4449081,24 20,24 C19.5581722,24 19.2,23.6354685 19.2,23.2036819 L19.2,16.7963181 Z M25.6,13.6019786 C25.6,13.1590581 25.9550919,12.8 26.4,12.8 C26.8418278,12.8 27.2,13.1646088 27.2,13.6019786 L27.2,21.5980214 C27.2,22.0409419 26.8449081,22.4 26.4,22.4 C25.9581722,22.4 25.6,22.0353912 25.6,21.5980214 L25.6,13.6019786 Z M28.8,13.5976241 C28.8,13.1571085 29.1550919,12.8 29.6,12.8 C30.0418278,12.8 30.4,13.162429 30.4,13.5976241 L30.4,18.4023759 C30.4,18.8428915 30.0449081,19.2 29.6,19.2 C29.1581722,19.2 28.8,18.837571 28.8,18.4023759 L28.8,13.5976241 Z M12.8,8.79631805 C12.8,8.35652374 13.1550919,8 13.6,8 C14.0418278,8 14.4,8.36453152 14.4,8.79631805 L14.4,15.2036819 C14.4,15.6434763 14.0449081,16 13.6,16 C13.1581722,16 12.8,15.6354685 12.8,15.2036819 L12.8,8.79631805 Z M16,12.0074951 C16,11.5615279 16.3550919,11.2 16.8,11.2 C17.2418278,11.2 17.6,11.5670807 17.6,12.0074951 L17.6,13.5925049 C17.6,14.0384721 17.2449081,14.4 16.8,14.4 C16.3581722,14.4 16,14.0329193 16,13.5925049 L16,12.0074951 Z M9.6,3.99471815 C9.6,3.55580743 9.95509186,3.2 10.4,3.2 C10.8418278,3.2 11.2,3.55595703 11.2,3.99471815 L11.2,16.8052819 C11.2,17.2441926 10.8449081,17.6 10.4,17.6 C9.9581722,17.6 9.6,17.244043 9.6,16.8052819 L9.6,3.99471815 Z M22.4,3.99762411 C22.4,3.55710848 22.7550919,3.2 23.2,3.2 C23.6418278,3.2 24,3.56242905 24,3.99762411 L24,8.80237589 C24,9.24289152 23.6449081,9.6 23.2,9.6 C22.7581722,9.6 22.4,9.23757095 22.4,8.80237589 L22.4,3.99762411 Z M19.2,8.79262238 C19.2,8.35486913 19.5550919,8 20,8 C20.4418278,8 20.8,8.36078014 20.8,8.79262238 L20.8,12.0073776 C20.8,12.4451309 20.4449081,12.8 20,12.8 C19.5581722,12.8 19.2,12.4392199 19.2,12.0073776 L19.2,8.79262238 Z M2.79025709,24.6983548 C2.40456639,24.9138878 1.91717825,24.7759478 1.70164521,24.3902571 C1.48611218,24.0045664 1.62405222,23.5171783 2.00974291,23.3016452 L29.2097429,8.10164521 C29.5954336,7.88611218 30.0828217,8.02405222 30.2983548,8.40974291 C30.5138878,8.79543361 30.3759478,9.28282175 29.9902571,9.49835479 L2.79025709,24.6983548 Z',transform:'translate(4 4)'}));};/* harmony default export */ __webpack_exports__["a"] = (IncorrectSound);

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Info=function Info(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'3',rx:'1.5',ry:'1.5',width:'3',x:'18.5',y:'11.13'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,29.38a.5.5,0,0,1-.5-.5v-12a.5.5,0,0,1,1,0v12A.5.5,0,0,1,20,29.38Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Info);

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var InstallDevice=function InstallDevice(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,22a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,1,0v17A.5.5,0,0,1,20,22Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.2,14.73a.5.5,0,0,1,.69.15L20,21.33l4.11-6.45a.5.5,0,1,1,.84.54l-4.53,7.11a.5.5,0,0,1-.84,0L15,15.42a.5.5,0,0,1,.15-.69Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M34.17,36H5.83a.5.5,0,0,1,0-1H34.17a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.64,35.81a.5.5,0,0,1-.48-.37,9.5,9.5,0,0,0-18.32,0,.5.5,0,0,1-1-.27,10.5,10.5,0,0,1,20.24,0,.5.5,0,0,1-.35.62Z'}));};/* harmony default export */ __webpack_exports__["a"] = (InstallDevice);

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Link=function Link(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.7,26.6H6.48A2.48,2.48,0,0,1,4,24.12V15.88A2.48,2.48,0,0,1,6.48,13.4H16.7a2.48,2.48,0,0,1,2.48,2.48v8.25A2.48,2.48,0,0,1,16.7,26.6ZM6.48,14.4A1.48,1.48,0,0,0,5,15.88v8.25A1.48,1.48,0,0,0,6.48,25.6H16.7a1.48,1.48,0,0,0,1.48-1.48V15.88A1.48,1.48,0,0,0,16.7,14.4Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.52,26.6H23.3a2.48,2.48,0,0,1-2.48-2.48V15.88A2.48,2.48,0,0,1,23.3,13.4H33.52A2.48,2.48,0,0,1,36,15.88v8.25A2.48,2.48,0,0,1,33.52,26.6ZM23.3,14.4a1.48,1.48,0,0,0-1.48,1.48v8.25A1.48,1.48,0,0,0,23.3,25.6H33.52A1.48,1.48,0,0,0,35,24.12V15.88a1.48,1.48,0,0,0-1.48-1.48Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.76,20.5H13.24a.5.5,0,1,1,0-1H26.76a.5.5,0,1,1,0,1Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LinkBroken=function LinkBroken(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.87,26.79a2,2,0,0,1-1.79-1.14l-2.9-6.21a2,2,0,0,1,1-2.62l7.69-3.59a2,2,0,0,1,2.62,1l2.9,6.21a2,2,0,0,1-1,2.62L9.7,26.6A2,2,0,0,1,8.87,26.79ZM13.66,14a1,1,0,0,0-.41.09L5.56,17.73A1,1,0,0,0,5.09,19L8,25.23a1,1,0,0,0,1.29.47L17,22.11a1,1,0,0,0,.47-1.29l-2.9-6.21a1,1,0,0,0-.88-.56Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.15,19.07a.5.5,0,0,1-.21-1l3.55-1.65a.5.5,0,1,1,.42.91L14.36,19A.5.5,0,0,1,14.15,19.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.13,26.79a2,2,0,0,1-.83-.18L22.61,23a2,2,0,0,1-1-2.62l2.9-6.21a2,2,0,0,1,2.62-1l7.69,3.59a2,2,0,0,1,1,2.62l-2.9,6.21A2,2,0,0,1,31.13,26.79ZM26.34,14a1,1,0,0,0-.88.56l-2.9,6.21A1,1,0,0,0,23,22.11l7.69,3.59A1,1,0,0,0,32,25.23L34.91,19a1,1,0,0,0-.47-1.29l-7.69-3.59A1,1,0,0,0,26.34,14Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.85,19.07a.5.5,0,0,1-.21,0l-3.55-1.65a.5.5,0,1,1,.42-.91l3.55,1.65a.5.5,0,0,1-.21,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.54,21.39h-.06a.5.5,0,0,1-.43-.56L20,13.51a.5.5,0,1,1,1,.12L20,21A.5.5,0,0,1,19.54,21.39Z'}));};/* harmony default export */ __webpack_exports__["a"] = (LinkBroken);

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ListDeviceMenu=function ListDeviceMenu(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7,7.7a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35,11.15H13.84a.5.5,0,0,1,0-1H35a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7,26.4a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35,29.85H13.84a.5.5,0,0,1,0-1H35a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7,17a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35,20.5H13.84a.5.5,0,1,1,0-1H35a.5.5,0,0,1,0,1Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ListDeviceMenu);

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LockClosed=function LockClosed(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,Object.assign({},gProps,{transform:'translate(6, 0)'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M4,16 L4,10.0295557 C4,4.49038506 8.43864822,0 14,0 C19.5228475,0 24,4.49868441 24,10.0295557 L24,16 L27.0034652,16 C27.5538362,16 28,16.4474692 28,17.0006946 L28,38.9993054 C28,39.5519738 27.5601869,40 27.0034652,40 L0.996534824,40 C0.446163838,40 0,39.5525308 0,38.9993054 L0,17.0006946 C0,16.4480262 0.439813137,16 0.996534824,16 L4,16 Z M8,10.0295557 L8,15.9919434 L20,15.9919434 L20,10.0295557 C20,6.70180893 17.3076918,4 14,4 C10.6661284,4 8,6.68113924 8,10.0295557 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (LockClosed);

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Logout=function Logout(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.74,34.87H8a4,4,0,0,1-4-4V9.13a4,4,0,0,1,4-4H29.74a4,4,0,0,1,4,4v5.74a.5.5,0,0,1-1,0V9.13a3,3,0,0,0-3-3H8a3,3,0,0,0-3,3V30.87a3,3,0,0,0,3,3H29.74a3,3,0,0,0,3-3V25.13a.5.5,0,0,1,1,0v5.74A4,4,0,0,1,29.74,34.87Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,20.5H20.41a.5.5,0,0,1,0-1H35.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.18,15.2a.5.5,0,0,1-.15.69L20.57,20,27,24.11a.5.5,0,1,1-.54.84l-7.11-4.53a.5.5,0,0,1,0-.84L26.49,15a.5.5,0,0,1,.69.15Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Logout);

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ManageDevice=function ManageDevice(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.83,32a.5.5,0,0,1-.43-.25,6.06,6.06,0,0,1,8.26-8.28.5.5,0,0,1-.5.87,5.05,5.05,0,0,0-6.9,6.91.5.5,0,0,1-.43.75Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.32,32h-3.1a1.88,1.88,0,0,1-1.88-1.66l0-.18a14.42,14.42,0,0,1,0-2.88l0-.18a1.88,1.88,0,0,1,1.88-1.66H23a10.66,10.66,0,0,1,.52-1.25l-1.93-1.93a1.88,1.88,0,0,1-.14-2.52l.49.2-.39-.31a13.7,13.7,0,0,1,2-2l.11-.09a1.94,1.94,0,0,1,2.53.14l1.93,1.93A10.61,10.61,0,0,1,29.36,19V16.31A1.88,1.88,0,0,1,31,14.43l.16,0a14.1,14.1,0,0,1,2.9,0l.13,0a1.89,1.89,0,0,1,1.71,1.88v3.1a.5.5,0,1,1-1,0v-3.1a.89.89,0,0,0-.77-.88l-.19,0a13.42,13.42,0,0,0-2.66,0h-.11a.9.9,0,0,0-.83.89v3.47l-.36.11a9.66,9.66,0,0,0-1.76.73l-.33.18-2.45-2.45a.91.91,0,0,0-1.19-.07l-.12.1a12.72,12.72,0,0,0-1.89,1.89l-.1.12a.9.9,0,0,0,.07,1.19L24.7,24l-.17.33a9.52,9.52,0,0,0-.73,1.76l-.11.36H20.22a.89.89,0,0,0-.89.77l-.52.12.5.05a13.48,13.48,0,0,0,0,2.67l-.48.23.5-.05a.89.89,0,0,0,.89.77h3.1a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7,7.5a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,11H14a.5.5,0,0,1,0-1H35.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7,26.5a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17,30H14a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7,17a3,3,0,1,0,3,3,3,3,0,0,0-3-3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19,20.5H14a.5.5,0,0,1,0-1h5a.5.5,0,0,1,0,1Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ManageDevice);

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Menu=function Menu(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.37,17.09A5.09,5.09,0,1,1,17.46,12,5.1,5.1,0,0,1,12.37,17.09Zm0-9.18A4.09,4.09,0,1,0,16.46,12,4.1,4.1,0,0,0,12.37,7.9Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.24,32.1a.5.5,0,0,1-.5-.5V23.73A4.75,4.75,0,0,0,15,19H9.75A4.75,4.75,0,0,0,5,23.73V31.6a.5.5,0,1,1-1,0V23.73A5.75,5.75,0,0,1,9.75,18H15a5.75,5.75,0,0,1,5.75,5.75V31.6A.5.5,0,0,1,20.24,32.1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,10.75h-14a.5.5,0,0,1,0-1h14a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,20.25h-11a.5.5,0,0,1,0-1h11a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,29.75h-8a.5.5,0,0,1,0-1h8a.5.5,0,0,1,0,1Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var MicrophoneOff=function MicrophoneOff(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.54,26.91A7.46,7.46,0,0,1,16,25.36a.5.5,0,1,1,.61-.79,6.47,6.47,0,0,0,4,1.34,6.55,6.55,0,0,0,6.54-6.54V12.42a.5.5,0,1,1,1,0v6.95A7.55,7.55,0,0,1,20.54,26.91ZM14,22.49a.5.5,0,0,1-.46-.31A7.49,7.49,0,0,1,13,19.37V11.54A7.54,7.54,0,0,1,27,7.62a.5.5,0,1,1-.85.52A6.54,6.54,0,0,0,14,11.54v7.82a6.5,6.5,0,0,0,.47,2.44.5.5,0,0,1-.46.69Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.54,29.63A11.82,11.82,0,0,1,13.74,28a.5.5,0,1,1,.56-.83,11,11,0,0,0,6.24,1.5c6.41,0,9.14-2.61,9.14-8.72a.5.5,0,0,1,1,0C30.69,24.08,29.63,29.63,20.54,29.63ZM11.7,25.16a.5.5,0,0,1-.46-.3,12.59,12.59,0,0,1-.84-4.95.5.5,0,0,1,1,0,11.64,11.64,0,0,0,.76,4.55.5.5,0,0,1-.26.66A.49.49,0,0,1,11.7,25.16Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.78,36H13.31a.5.5,0,0,1,0-1H27.78a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.54,36a.5.5,0,0,1-.5-.5V29.13a.5.5,0,0,1,1,0v6.33A.5.5,0,0,1,20.54,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M9.35,30.58A.5.5,0,0,1,9,29.75L30.69,5.42a.5.5,0,0,1,.75.67L9.73,30.42A.5.5,0,0,1,9.35,30.58Z'}));};/* harmony default export */ __webpack_exports__["a"] = (MicrophoneOff);

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var MicrophoneOn=function MicrophoneOn(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,26.91a7.55,7.55,0,0,1-7.54-7.54V11.54a7.54,7.54,0,1,1,15.08,0v7.82A7.55,7.55,0,0,1,20,26.91ZM20,5a6.55,6.55,0,0,0-6.54,6.54v7.82a6.54,6.54,0,1,0,13.08,0V11.54A6.55,6.55,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,29.63c-9.09,0-10.14-5.55-10.14-9.72a.5.5,0,1,1,1,0c0,6.11,2.73,8.72,9.14,8.72s9.14-2.61,9.14-8.72a.5.5,0,0,1,1,0C30.14,24.08,29.09,29.63,20,29.63Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.23,36H12.77a.5.5,0,1,1,0-1H27.23a.5.5,0,1,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.5-.5V29.13a.5.5,0,0,1,1,0v6.33A.5.5,0,0,1,20,36Z'}));};/* harmony default export */ __webpack_exports__["a"] = (MicrophoneOn);

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Mimic=function Mimic(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14,11a9,9,0,1,1-9,9,9,9,0,0,1,9-9m0-1A10,10,0,1,0,24,20,10,10,0,0,0,14,10Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.93,11.3l-.5.87a9.24,9.24,0,0,1,2.49,2.08l.77-.64A10.06,10.06,0,0,0,30.93,11.3Zm4.44,5.21-.94.35A8.88,8.88,0,0,1,35,20v.06h1V20A9.86,9.86,0,0,0,35.37,16.51ZM30.5,27.79a9,9,0,0,1-3.06,1.1l.16,1A9.55,9.55,0,0,0,31,28.65ZM16.65,16.46A9.73,9.73,0,0,0,16,20h1a8.74,8.74,0,0,1,.59-3.16Zm4.43-5.16a9.91,9.91,0,0,0-2.75,2.28l.78.65a8.63,8.63,0,0,1,2.47-2.06ZM17.5,22.94l-1,.33h0a10.11,10.11,0,0,0,1.76,3.12l.77-.65A8.83,8.83,0,0,1,17.5,22.94Zm3.87,4.77-.51.87a9.84,9.84,0,0,0,3.38,1.26l.16-1A8.9,8.9,0,0,1,21.37,27.71ZM34.47,23a8.8,8.8,0,0,1-1.64,2.81l.76.65a9.77,9.77,0,0,0,1.82-3.12ZM26,10a10.55,10.55,0,0,0-1.79.16l.18,1a9.33,9.33,0,0,1,3.22,0l.18-1A10.55,10.55,0,0,0,26,10Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Mimic);

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Minus=function Minus(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.32,21H9.68a1,1,0,1,1,0-2H30.32a1,1,0,1,1,0,2Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Minus);

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var MonitorSense=function MonitorSense(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.1,33.84a.49.49,0,0,1-.25-.07,16,16,0,1,1,16.31,0,.5.5,0,1,1-.51-.86,15,15,0,1,0-15.29,0,.5.5,0,0,1-.26.93Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.51,29.55a.5.5,0,0,1-.22-.95,9.61,9.61,0,1,0-8.58,0,.5.5,0,1,1-.45.89,10.61,10.61,0,1,1,9.47,0A.49.49,0,0,1,24.51,29.55Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,25.22A5.22,5.22,0,1,1,25.22,20,5.22,5.22,0,0,1,20,25.22Zm0-9.44A4.22,4.22,0,1,0,24.22,20,4.22,4.22,0,0,0,20,15.78Z'}));};/* harmony default export */ __webpack_exports__["a"] = (MonitorSense);

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var MonitoringOff=function MonitoringOff(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.29,20.82C33.29,28.93,20,35.5,20,35.5S6.71,28.93,6.71,20.82V6.12A1.61,1.61,0,0,1,8.32,4.5H31.68a1.63,1.63,0,0,1,1.61,1.62Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.22-.05c-.55-.27-13.56-6.81-13.56-15.13V6.12A2.12,2.12,0,0,1,8.32,4H31.68a2.12,2.12,0,0,1,2.11,2.12V20.82c0,8.33-13,14.86-13.56,15.13A.5.5,0,0,1,20,36ZM8.32,5A1.12,1.12,0,0,0,7.21,6.12V20.82C7.21,28,18.28,34,20,34.94c1.72-.9,12.79-7,12.79-14.12V6.12A1.13,1.13,0,0,0,31.68,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.07,18H12.93a.5.5,0,0,1,0-1H27.07a.5.5,0,0,1,0,1Z',fill:'#fff'}));};/* harmony default export */ __webpack_exports__["a"] = (MonitoringOff);

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var MonitoringOn=function MonitoringOn(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.29,20.82C33.29,28.93,20,35.5,20,35.5S6.71,28.93,6.71,20.82V6.12A1.61,1.61,0,0,1,8.32,4.5H31.68a1.63,1.63,0,0,1,1.61,1.62Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.22-.05c-.55-.27-13.56-6.81-13.56-15.13V6.12A2.12,2.12,0,0,1,8.32,4H31.68a2.12,2.12,0,0,1,2.11,2.12V20.82c0,8.33-13,14.86-13.56,15.13A.5.5,0,0,1,20,36ZM8.32,5A1.12,1.12,0,0,0,7.21,6.12V20.82C7.21,28,18.28,34,20,34.94c1.72-.9,12.79-7,12.79-14.12V6.12A1.13,1.13,0,0,0,31.68,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M18.5,21.41a.5.5,0,0,1-.35-.85L25,13.74a.5.5,0,0,1,.71.71l-6.82,6.82A.5.5,0,0,1,18.5,21.41Z',fill:'#fff'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M18.5,21.41a.5.5,0,0,1-.35-.15l-3.81-3.81a.5.5,0,0,1,.71-.71l3.81,3.81a.5.5,0,0,1-.35.85Z',fill:'#fff'}));};/* harmony default export */ __webpack_exports__["a"] = (MonitoringOn);

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Moods=function Moods(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.62,26.14l-.14,0a.5.5,0,0,1-.34-.62,8.5,8.5,0,1,0-16.28,0,.5.5,0,0,1-1,.29,9.5,9.5,0,1,1,18.2,0A.5.5,0,0,1,28.62,26.14Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.89,27l-.14,0a42.31,42.31,0,0,0-23.49-.09.5.5,0,1,1-.28-1A43.31,43.31,0,0,1,32,26a.5.5,0,0,1-.14,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.54,29.22a.5.5,0,0,1-.1-1c1.18-.24,2.37-.43,3.55-.57a.5.5,0,0,1,.12,1c-1.15.13-2.32.32-3.47.55Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.46,29.22h-.1a42.54,42.54,0,0,0-11.69-.71.5.5,0,1,1-.08-1,43.35,43.35,0,0,1,12,.72.5.5,0,0,1-.1,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.94,31.7h-.06l-1.31-.13a.5.5,0,0,1,.09-1l1.33.13a.5.5,0,0,1-.06,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.06,31.68a.5.5,0,0,1-.05-1,54,54,0,0,1,8.45-.26.5.5,0,0,1,.48.52.49.49,0,0,1-.52.48,53.91,53.91,0,0,0-8.3.26Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,12.58a.5.5,0,0,1-.5-.5V6.17a.5.5,0,0,1,1,0v5.91A.5.5,0,0,1,20,12.58Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.73,15a.5.5,0,0,1-.35-.15L8.6,11.1a.5.5,0,0,1,.71-.71l3.77,3.77a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.54,20.88H8.48l-4-.5A.5.5,0,0,1,4,19.82a.49.49,0,0,1,.56-.44l4,.5a.5.5,0,0,1-.06,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.27,15a.5.5,0,0,1-.35-.85l3.77-3.77a.5.5,0,0,1,.71.71l-3.77,3.77A.5.5,0,0,1,27.27,15Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.46,20.88a.5.5,0,0,1-.06-1l4-.5a.49.49,0,0,1,.56.44.5.5,0,0,1-.44.56l-4,.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23,34.33H20.75a.5.5,0,0,1,0-1H23a.5.5,0,1,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M18.1,34.33H17a.5.5,0,1,1,0-1H18.1a.5.5,0,1,1,0,1Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Moods);

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var More=function More(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,4a3.56,3.56,0,1,0,3.56,3.56A3.56,3.56,0,0,0,20,4Zm0,12.44A3.56,3.56,0,1,0,23.56,20,3.56,3.56,0,0,0,20,16.44Zm0,12.44a3.56,3.56,0,1,0,3.56,3.56A3.56,3.56,0,0,0,20,28.89Z'}));};/* harmony default export */ __webpack_exports__["a"] = (More);

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var MoreVertical=function MoreVertical(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.44,23.56A3.56,3.56,0,1,0,28.89,20,3.56,3.56,0,0,0,32.44,23.56ZM20,23.56A3.56,3.56,0,1,0,16.44,20,3.56,3.56,0,0,0,20,23.56Zm-12.44,0A3.56,3.56,0,1,0,4,20,3.56,3.56,0,0,0,7.56,23.56Z'}));};/* harmony default export */ __webpack_exports__["a"] = (MoreVertical);

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var MultiProfile=function MultiProfile(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.8,17a6.51,6.51,0,1,1,6.51-6.51A6.51,6.51,0,0,1,14.8,17Zm0-12a5.51,5.51,0,1,0,5.51,5.51A5.51,5.51,0,0,0,14.8,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.09,36a.5.5,0,0,1-.5-.5V25.2a6.37,6.37,0,0,0-6.36-6.37H11.37A6.37,6.37,0,0,0,5,25.2V35.5a.5.5,0,0,1-1,0V25.2a7.37,7.37,0,0,1,7.37-7.37h6.87a7.37,7.37,0,0,1,7.36,7.37V35.5A.5.5,0,0,1,25.09,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28,15.17a4.85,4.85,0,1,1,4.85-4.85A4.86,4.86,0,0,1,28,15.17Zm0-8.71a3.85,3.85,0,1,0,3.85,3.85A3.86,3.86,0,0,0,28,6.46Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,29.86a.5.5,0,0,1-.5-.5V21.9a4.48,4.48,0,0,0-4.48-4.48h-5a4.44,4.44,0,0,0-2.59.83.5.5,0,0,1-.58-.81,5.44,5.44,0,0,1,3.17-1h5A5.48,5.48,0,0,1,36,21.9v7.46A.5.5,0,0,1,35.5,29.86Z'}));};/* harmony default export */ __webpack_exports__["a"] = (MultiProfile);

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Notifications=function Notifications(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a5.16,5.16,0,0,1-5.15-5.15.5.5,0,0,1,1,0,4.15,4.15,0,1,0,8.3,0,.5.5,0,0,1,1,0A5.16,5.16,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.63,29.8H8.38a2.82,2.82,0,1,1,0-5.65,1.74,1.74,0,0,0,1.73-1.82V16.9a9.81,9.81,0,0,1,6.3-9.11V7.6a3.6,3.6,0,0,1,7.2,0v.19a9.81,9.81,0,0,1,6.3,9.11v5.43a1.74,1.74,0,0,0,1.73,1.82,2.82,2.82,0,1,1,0,5.65ZM20,5a2.6,2.6,0,0,0-2.6,2.6v.9l-.34.12a8.81,8.81,0,0,0-6,8.29v5.43a2.75,2.75,0,0,1-2.73,2.82,1.82,1.82,0,1,0,0,3.65H31.63a1.82,1.82,0,1,0,0-3.65,2.75,2.75,0,0,1-2.73-2.82V16.9a8.81,8.81,0,0,0-6-8.29L22.6,8.5V7.6A2.6,2.6,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.3,17.67a.5.5,0,0,1-.5-.5,6.48,6.48,0,0,1,6.48-6.47.5.5,0,0,1,0,1,5.48,5.48,0,0,0-5.48,5.47A.5.5,0,0,1,14.3,17.67Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Notifications);

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var NotificationsOff=function NotificationsOff(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a5.16,5.16,0,0,1-5.15-5.15.5.5,0,1,1,1,0,4.15,4.15,0,0,0,8.3,0,.5.5,0,0,1,1,0A5.16,5.16,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.6,29.8H14.67a.5.5,0,1,1,0-1H31.6a1.82,1.82,0,0,0,0-3.65,2.75,2.75,0,0,1-2.73-2.82V16.9A8.55,8.55,0,0,0,28.65,15a.5.5,0,0,1,1-.23,9.55,9.55,0,0,1,.25,2.17v5.43a1.74,1.74,0,0,0,1.73,1.82,2.82,2.82,0,0,1,0,5.65Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M9.67,29.8H8.35a2.82,2.82,0,1,1,0-5.65,1.74,1.74,0,0,0,1.73-1.82V16.9a9.81,9.81,0,0,1,6.3-9.11V7.6a3.6,3.6,0,1,1,7.2,0v.19a10.06,10.06,0,0,1,4.37,3.34.5.5,0,1,1-.8.6,9,9,0,0,0-4.23-3.11l-.34-.12V7.6a2.6,2.6,0,1,0-5.2,0v.9L17,8.61a8.81,8.81,0,0,0-6,8.29v5.43a2.75,2.75,0,0,1-2.73,2.82,1.82,1.82,0,1,0,0,3.65H9.67a.5.5,0,1,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.27,17.67a.5.5,0,0,1-.5-.5,6.48,6.48,0,0,1,6.48-6.47.5.5,0,0,1,0,1,5.48,5.48,0,0,0-5.48,5.47A.5.5,0,0,1,14.27,17.67Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M6,36a.5.5,0,0,1-.35-.85l27.5-27.5a.5.5,0,0,1,.71.71L6.33,35.85A.5.5,0,0,1,6,36Z'}));};/* harmony default export */ __webpack_exports__["a"] = (NotificationsOff);

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Overflow=function Overflow(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.33,11.86A2.33,2.33,0,1,0,20,14.19,2.33,2.33,0,0,0,22.33,11.86Zm0,8.14A2.33,2.33,0,1,0,20,22.33,2.33,2.33,0,0,0,22.33,20Zm0,8.14A2.33,2.33,0,1,0,20,30.46,2.33,2.33,0,0,0,22.33,28.14Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Overflow);

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Pause=function Pause(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'31',rx:'3.88',ry:'3.88',width:'11.63',x:'23.88',y:'4.5'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.63,36H27.75a4.38,4.38,0,0,1-4.37-4.37V8.38A4.38,4.38,0,0,1,27.75,4h3.88A4.38,4.38,0,0,1,36,8.38V31.63A4.38,4.38,0,0,1,31.63,36ZM27.75,5a3.38,3.38,0,0,0-3.37,3.38V31.63A3.38,3.38,0,0,0,27.75,35h3.88A3.38,3.38,0,0,0,35,31.63V8.38A3.38,3.38,0,0,0,31.63,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'31',rx:'3.88',ry:'3.88',width:'11.63',x:'4.5',y:'4.5'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.25,36H8.38A4.38,4.38,0,0,1,4,31.63V8.38A4.38,4.38,0,0,1,8.38,4h3.88a4.38,4.38,0,0,1,4.38,4.38V31.63A4.38,4.38,0,0,1,12.25,36ZM8.38,5A3.38,3.38,0,0,0,5,8.38V31.63A3.38,3.38,0,0,0,8.38,35h3.88a3.38,3.38,0,0,0,3.38-3.37V8.38A3.38,3.38,0,0,0,12.25,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Pause);

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PauseSimple=function PauseSimple(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.63,36H27.75a4.38,4.38,0,0,1-4.37-4.37V8.38A4.38,4.38,0,0,1,27.75,4h3.88A4.38,4.38,0,0,1,36,8.38V31.63A4.38,4.38,0,0,1,31.63,36ZM27.75,5a3.38,3.38,0,0,0-3.37,3.38V31.63A3.38,3.38,0,0,0,27.75,35h3.88A3.38,3.38,0,0,0,35,31.63V8.38A3.38,3.38,0,0,0,31.63,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.25,36H8.38A4.38,4.38,0,0,1,4,31.63V8.38A4.38,4.38,0,0,1,8.38,4h3.88a4.38,4.38,0,0,1,4.38,4.38V31.63A4.38,4.38,0,0,1,12.25,36ZM8.38,5A3.38,3.38,0,0,0,5,8.38V31.63A3.38,3.38,0,0,0,8.38,35h3.88a3.38,3.38,0,0,0,3.38-3.37V8.38A3.38,3.38,0,0,0,12.25,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (PauseSimple);

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Play=function Play(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M6.37,33.7V6.29C6.37,4.58,8,4,9.65,4.93L33,18.64a1.72,1.72,0,0,1,0,2.72L9.65,35.06C8,36,6.37,35.41,6.37,33.7Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.09,36a2.34,2.34,0,0,1-1.21-.31,2.19,2.19,0,0,1-1-2V6.29a2.2,2.2,0,0,1,1-2,3.06,3.06,0,0,1,3,.19L33.22,18.21A2.14,2.14,0,0,1,34.13,20a2.05,2.05,0,0,1-.9,1.74L9.91,35.49A3.88,3.88,0,0,1,8.09,36Zm0-31a1.35,1.35,0,0,0-.69.17,1.25,1.25,0,0,0-.53,1.13V33.7a1.24,1.24,0,0,0,.52,1.12,2.14,2.14,0,0,0,2-.2L32.71,20.92a1.06,1.06,0,0,0,.42-.9,1.14,1.14,0,0,0-.44-1L9.4,5.36A2.78,2.78,0,0,0,8.1,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Play);

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var PlaySimple=function PlaySimple(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.09,36a2.34,2.34,0,0,1-1.21-.31,2.19,2.19,0,0,1-1-2V6.29a2.2,2.2,0,0,1,1-2,3.06,3.06,0,0,1,3,.19L33.22,18.21A2.14,2.14,0,0,1,34.13,20a2.05,2.05,0,0,1-.9,1.74L9.91,35.49A3.88,3.88,0,0,1,8.09,36Zm0-31a1.35,1.35,0,0,0-.69.17,1.25,1.25,0,0,0-.53,1.13V33.7a1.24,1.24,0,0,0,.52,1.12,2.14,2.14,0,0,0,2-.2L32.71,20.92a1.06,1.06,0,0,0,.42-.9,1.14,1.14,0,0,0-.44-1L9.4,5.36A2.78,2.78,0,0,0,8.1,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (PlaySimple);

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Plus=function Plus(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,31.32a1,1,0,0,1-1-1V9.68a1,1,0,0,1,2,0V30.32A1,1,0,0,1,20,31.32Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.32,21H9.68a1,1,0,1,1,0-2H30.32a1,1,0,1,1,0,2Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Plus);

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Question=function Question(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M18.34,24.46a.78.78,0,0,1-.78-.76l0-1.28a4.13,4.13,0,0,1,2.7-4,3.64,3.64,0,0,0,2.38-3.53,2.62,2.62,0,0,0-2.77-2.39,2.77,2.77,0,0,0-1.81.86,2.33,2.33,0,0,0-.64,1.78.77.77,0,0,1-.72.83.76.76,0,0,1-.83-.72,3.87,3.87,0,0,1,1.05-3A4.28,4.28,0,0,1,19.72,11a4.17,4.17,0,0,1,4.43,3.82,5.15,5.15,0,0,1-3.37,5.09,2.56,2.56,0,0,0-1.7,2.46l0,1.32a.78.78,0,0,1-.76.79Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'3.1',rx:'1.55',ry:'1.55',transform:'translate(-1.99 1.46) rotate(-4.26)',width:'3.1',x:'17.13',y:'25.94'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Question);

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Reassurance=function Reassurance(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,35 C28.2842712,35 35,28.2842712 35,20 C35,11.7157288 28.2842712,5 20,5 C11.7157288,5 5,11.7157288 5,20 C5,28.2842712 11.7157288,35 20,35 Z M20,36 C11.163444,36 4,28.836556 4,20 C4,11.163444 11.163444,4 20,4 C28.836556,4 36,11.163444 36,20 C36,28.836556 28.836556,36 20,36 Z M26.7687817,24.0736789 C26.6748026,24.1312688 26.4914206,24.2362482 26.2319158,24.3728199 C25.795992,24.6022371 25.3101095,24.8319957 24.7877901,25.046353 C23.3535134,25.6349732 21.9265087,25.995148 20.6120753,26.0168125 C20.5556603,26.017602 20.5556603,26.017602 20.4993161,26.0178227 C19.1305854,26.0140259 17.6775959,25.6543789 16.2192711,25.0553269 C15.7023479,24.8429847 15.2220648,24.6153947 14.7916204,24.3881562 C14.5354436,24.2529165 14.354632,24.1489966 14.262146,24.092053 C14.0270002,23.9472738 13.71901,24.0205304 13.5742307,24.2556762 C13.4294515,24.4908221 13.5027081,24.7988123 13.737854,24.9435915 C13.8483898,25.0116484 14.0481857,25.1264793 14.3247663,25.2724906 C14.7822507,25.5140039 15.2911743,25.7551656 15.8392995,25.980325 C17.4072506,26.6244095 18.9796132,27.013604 20.4655509,27.0177962 C20.5646486,27.0175711 20.5646486,27.0175711 20.6285551,27.0166767 C22.0855318,26.9926627 23.6274735,26.603478 25.1674563,25.9714766 C25.7206863,25.7444337 26.234931,25.5012635 26.6976362,25.2577519 C26.9773088,25.1105663 27.1794543,24.9948455 27.2912769,24.9263211 C27.5267276,24.782038 27.6006335,24.474203 27.4563504,24.2387524 C27.3120673,24.0033017 27.0042323,23.9293958 26.7687817,24.0736789 Z M13.4160251,17.296382 C13.5192984,17.1414722 13.7286531,16.8901405 14.0213912,16.6389952 C14.484912,16.2413323 14.9868017,16.0066642 15.5062861,16.0001326 C16.0250684,15.9936098 16.527574,16.2281244 16.9924318,16.6355383 C17.2785288,16.8862814 17.4832569,17.1374288 17.5842016,17.2921907 C17.735063,17.5234815 18.0448586,17.5886824 18.2761495,17.437821 C18.5074403,17.2869596 18.5726412,16.977164 18.4217798,16.7458732 C18.2750242,16.520877 18.0154007,16.2023875 17.6515439,15.8834937 C17.0171697,15.327511 16.2942815,14.9901459 15.4937139,15.0002116 C14.707823,15.0100928 13.9967098,15.3425873 13.3702606,15.8800295 C12.9990196,16.1985239 12.7338748,16.5168319 12.5839749,16.7416818 C12.4307986,16.9714462 12.4928856,17.2818809 12.7226499,17.4350571 C12.9524142,17.5882333 13.2628489,17.5261464 13.4160251,17.296382 Z M23.4160251,17.296382 C23.5192984,17.1414722 23.7286531,16.8901405 24.0213912,16.6389952 C24.484912,16.2413323 24.9868017,16.0066642 25.5062861,16.0001326 C26.0250684,15.9936098 26.527574,16.2281244 26.9924318,16.6355383 C27.2785288,16.8862814 27.4832569,17.1374288 27.5842016,17.2921907 C27.735063,17.5234815 28.0448586,17.5886824 28.2761495,17.437821 C28.5074403,17.2869596 28.5726412,16.977164 28.4217798,16.7458732 C28.2750242,16.520877 28.0154007,16.2023875 27.6515439,15.8834937 C27.0171697,15.327511 26.2942815,14.9901459 25.4937139,15.0002116 C24.707823,15.0100928 23.9967098,15.3425873 23.3702606,15.8800295 C22.9990196,16.1985239 22.7338748,16.5168319 22.5839749,16.7416818 C22.4307986,16.9714462 22.4928856,17.2818809 22.7226499,17.4350571 C22.9524142,17.5882333 23.2628489,17.5261464 23.4160251,17.296382 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Reassurance);

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Recipes=function Recipes(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.85,36H12.14a2.18,2.18,0,0,1-1.82-1,2.36,2.36,0,0,1-.26-2.2l1.2-3.1C7.69,27.5,4.72,25.19,4,20.21a2.26,2.26,0,0,1,.51-1.83,2.21,2.21,0,0,1,1.7-.75H33.76a2.21,2.21,0,0,1,1.7.74A2.27,2.27,0,0,1,36,20.21c-.68,5-3.66,7.28-7.24,9.49l1.2,3.06A2.4,2.4,0,0,1,29.66,35,2.17,2.17,0,0,1,27.85,36ZM6.24,18.64a1.23,1.23,0,0,0-.95.4,1.28,1.28,0,0,0-.28,1c.66,4.7,3.62,6.85,7.12,9a.5.5,0,0,1,.21.61L11,33.17a1.37,1.37,0,0,0,.16,1.28,1.2,1.2,0,0,0,1,.56H27.85a1.19,1.19,0,0,0,1-.56A1.43,1.43,0,0,0,29,33.13l-1.35-3.46a.5.5,0,0,1,.21-.61c3.65-2.22,6.49-4.29,7.13-9a1.28,1.28,0,0,0-.28-1,1.23,1.23,0,0,0-.95-.4Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.47,16.5H20.25a.5.5,0,0,1-.43-.75l5.83-10.2A3.09,3.09,0,0,1,28.33,4a3.09,3.09,0,0,1,3,3.93h0l-2.34,8.2A.5.5,0,0,1,28.47,16.5Zm-7.35-1h7l2.24-7.84a2.09,2.09,0,0,0-2-2.66,2.09,2.09,0,0,0-1.81,1.05Zm9.7-7.7h0Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.83,28A14.3,14.3,0,0,1,9.29,22.11a.5.5,0,0,1,.81-.59A13.3,13.3,0,0,0,20.83,27a.5.5,0,0,1,0,1Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Recipes);

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ResetReload=function ResetReload(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A13.75,13.75,0,0,1,9.58,13.28a.5.5,0,1,1,.76.65A12.75,12.75,0,1,0,20,9.5H16.61a.5.5,0,0,1,0-1H20A13.75,13.75,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.38,13.8a.5.5,0,0,0-.15-.69L16.78,9l6.45-4.11A.5.5,0,1,0,22.69,4L15.58,8.58a.5.5,0,0,0,0,.84L22.69,14a.5.5,0,0,0,.69-.15Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ResetReload);

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Schedule=function Schedule(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,Circle=_ref$svgComponents.Circle,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.06,36.39H7.94A4,4,0,0,1,4,32.45V11.78A4,4,0,0,1,7.94,7.83H32.06A4,4,0,0,1,36,11.78V32.45A4,4,0,0,1,32.06,36.39ZM7.94,8.83A3,3,0,0,0,5,11.78V32.45a3,3,0,0,0,2.94,2.94H32.06A3,3,0,0,0,35,32.45V11.78a3,3,0,0,0-2.94-2.94Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,19.83H4.5a.5.5,0,0,1,0-1h31a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.26,14.61a.5.5,0,0,1-.5-.5V5.67a.5.5,0,0,1,1,0v8.44A.5.5,0,0,1,12.26,14.61Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.75,14.61a.5.5,0,0,1-.5-.5V5.67a.5.5,0,0,1,1,0v8.44A.5.5,0,0,1,27.75,14.61Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'12.26',cy:'14.47',r:'2.5'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Circle,{cx:'27.75',cy:'14.47',r:'2.5'}));};/* harmony default export */ __webpack_exports__["a"] = (Schedule);

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Search=function Search(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7,36a2.85,2.85,0,0,1-2-.91c-1.4-1.4-1.18-3.24.62-5l8.79-8.79a.5.5,0,0,1,.71,0L18.74,25a.5.5,0,0,1,0,.71L9.95,34.47a5,5,0,0,1-2.42,1.47A2.82,2.82,0,0,1,7,36Zm7.72-13.68L6.24,30.76c-1.41,1.41-1.61,2.62-.62,3.62A1.78,1.78,0,0,0,7.33,35a4.08,4.08,0,0,0,1.91-1.2l8.44-8.44Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.19,25.62A10.81,10.81,0,1,1,36,14.81,10.82,10.82,0,0,1,25.19,25.62ZM25.19,5A9.81,9.81,0,1,0,35,14.81,9.82,9.82,0,0,0,25.19,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.59,10.49a.5.5,0,0,1-.37-.83,6.79,6.79,0,0,1,10.14,0,.5.5,0,0,1-.75.67,5.78,5.78,0,0,0-8.64,0A.5.5,0,0,1,20.59,10.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.53,24a.5.5,0,0,1-.35-.85l1.37-1.37a.5.5,0,0,1,.71.71l-1.37,1.37A.5.5,0,0,1,16.53,24Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Search);

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Settings=function Settings(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(G,gProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M20,26.7A6.7,6.7,0,1,1,26.7,20,6.71,6.71,0,0,1,20,26.7Zm0-12.4A5.7,5.7,0,1,0,25.7,20,5.71,5.71,0,0,0,20,14.3Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M20,36a15.05,15.05,0,0,1-1.6-.08h-.16a2.05,2.05,0,0,1-1.84-2v-3.1a11.71,11.71,0,0,1-1.47-.61l-2.18,2.18a2.1,2.1,0,0,1-2.74.15l.18-.5-.31.39a15.14,15.14,0,0,1-2.27-2.27l.28-.45L7.51,30a2,2,0,0,1,.15-2.74l2.18-2.18a11.71,11.71,0,0,1-.61-1.47H6.14a2,2,0,0,1-2-1.8l0-.2a16,16,0,0,1,0-3.21l0-.2a2,2,0,0,1,2-1.79H9.23a11.71,11.71,0,0,1,.61-1.47L7.66,12.75A2,2,0,0,1,7.51,10l.5.18-.39-.31A15.14,15.14,0,0,1,9.88,7.61l.45.28L10,7.51a2.1,2.1,0,0,1,2.74.15l2.18,2.18a11.71,11.71,0,0,1,1.47-.61V6.14a2,2,0,0,1,1.8-2l.2,0a15.84,15.84,0,0,1,3.21,0l.2,0a2,2,0,0,1,1.79,2V9.23a11.71,11.71,0,0,1,1.47.61l2.18-2.18A2.1,2.1,0,0,1,30,7.53l1.2,1a1.82,1.82,0,0,1,.28.28l1,1.19a2.06,2.06,0,0,1-.13,2.76l-2.18,2.18a11.71,11.71,0,0,1,.61,1.47h3.1a2,2,0,0,1,2,1.83l0,.17a16,16,0,0,1,0,3.2v.16a2.05,2.05,0,0,1-2,1.84h-3.1a11.71,11.71,0,0,1-.61,1.47l2.18,2.18A2.06,2.06,0,0,1,32.47,30l-1,1.2a1.82,1.82,0,0,1-.28.28l-1.19,1a2.1,2.1,0,0,1-2.76-.13l-2.18-2.18a11.71,11.71,0,0,1-1.47.61v3.1a2,2,0,0,1-1.83,2l-.17,0A15.11,15.11,0,0,1,20,36Zm-5.25-7.07.33.18a10.66,10.66,0,0,0,2,.81l.36.11v3.84a1.05,1.05,0,0,0,.94,1h.16a14.81,14.81,0,0,0,3,0l.17,0a1,1,0,0,0,.93-1V30l.36-.11a10.66,10.66,0,0,0,2-.81l.33-.18,2.7,2.7a1.07,1.07,0,0,0,1.41.07l1.2-1a.84.84,0,0,0,.14-.14l1-1.21A1.05,1.05,0,0,0,31.64,28l-2.7-2.7.18-.33a10.66,10.66,0,0,0,.81-2L30,22.6h3.84a1.05,1.05,0,0,0,1-.94V21.5a15,15,0,0,0,0-3l0-.17a1,1,0,0,0-1-.93H30L29.92,17a10.66,10.66,0,0,0-.81-2l-.18-.33,2.7-2.7a1.05,1.05,0,0,0,.07-1.41l-1-1.2a.84.84,0,0,0-.14-.14l-1.21-1A1.07,1.07,0,0,0,28,8.36l-2.7,2.7-.33-.18a10.66,10.66,0,0,0-2-.81L22.6,10V6.14a1.05,1.05,0,0,0-.91-1l-.2,0a14.94,14.94,0,0,0-3,0l-.19,0a1.05,1.05,0,0,0-.91,1V10l-.36.11a10.66,10.66,0,0,0-2,.81l-.33.18L12,8.36a1.08,1.08,0,0,0-1.4-.08l-.13.11a14.15,14.15,0,0,0-2.12,2.12l-.11.13A1.06,1.06,0,0,0,8.36,12l2.7,2.7-.18.33a10.66,10.66,0,0,0-.81,2L10,17.4H6.14a1.05,1.05,0,0,0-1,.91l0,.2a15,15,0,0,0,0,3l0,.19a1.05,1.05,0,0,0,1,.91H10l.11.36a10.66,10.66,0,0,0,.81,2l.18.33L8.36,28a1.06,1.06,0,0,0-.08,1.4l.11.13a14.15,14.15,0,0,0,2.12,2.12l.13.11a1.08,1.08,0,0,0,1.4-.08Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Settings);

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Shop=function Shop(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(G,gProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M32,36H8a.5.5,0,0,1-.49-.4L4,17.6A.5.5,0,0,1,4.5,17h31a.5.5,0,0,1,.49.6l-3.5,18A.5.5,0,0,1,32,36ZM8.41,35H31.59l3.31-17H5.11Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M25,17.5H24v-7c0-3-1.79-5.5-4-5.5s-4,2.47-4,5.5v7H15v-7C15,6.92,17.24,4,20,4s5,2.92,5,6.5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Shop);

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Signal1Bars=function Signal1Bars(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.23,29.66a3.32,3.32,0,0,1-3.32-3.32V17.89a3.32,3.32,0,0,1,6.64,0v8.45A3.32,3.32,0,0,1,24.23,29.66Zm0-14.09a2.32,2.32,0,0,0-2.32,2.32v8.45a2.32,2.32,0,1,0,4.64,0V17.89A2.32,2.32,0,0,0,24.23,15.57Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.77,29.66a3.32,3.32,0,0,1-3.32-3.32V22.11a3.32,3.32,0,0,1,6.64,0v4.23A3.32,3.32,0,0,1,15.77,29.66Zm0-9.86a2.32,2.32,0,0,0-2.32,2.32v4.23a2.32,2.32,0,1,0,4.64,0V22.11A2.32,2.32,0,0,0,15.77,19.8Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.32,23.52a2.82,2.82,0,1,0,2.82,2.82,2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.32,29.66a3.32,3.32,0,1,1,3.32-3.32A3.32,3.32,0,0,1,7.32,29.66Zm0-5.64a2.32,2.32,0,1,0,2.32,2.32A2.32,2.32,0,0,0,7.32,24Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.68,29.66a3.32,3.32,0,0,1-3.32-3.32V13.66a3.32,3.32,0,1,1,6.64,0V26.34A3.32,3.32,0,0,1,32.68,29.66Zm0-18.32a2.32,2.32,0,0,0-2.32,2.32V26.34a2.32,2.32,0,1,0,4.64,0V13.66A2.32,2.32,0,0,0,32.68,11.34Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Signal1Bars);

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Signal2Bars=function Signal2Bars(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.23,29.66a3.32,3.32,0,0,1-3.32-3.32V17.89a3.32,3.32,0,0,1,6.64,0v8.45A3.32,3.32,0,0,1,24.23,29.66Zm0-14.09a2.32,2.32,0,0,0-2.32,2.32v8.45a2.32,2.32,0,1,0,4.64,0V17.89A2.32,2.32,0,0,0,24.23,15.57Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.77,19.3A2.82,2.82,0,0,0,13,22.11v4.23a2.82,2.82,0,1,0,5.64,0V22.11a2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.77,29.66a3.32,3.32,0,0,1-3.32-3.32V22.11a3.32,3.32,0,0,1,6.64,0v4.23A3.32,3.32,0,0,1,15.77,29.66Zm0-9.86a2.32,2.32,0,0,0-2.32,2.32v4.23a2.32,2.32,0,1,0,4.64,0V22.11A2.32,2.32,0,0,0,15.77,19.8Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.32,23.52a2.82,2.82,0,1,0,2.82,2.82,2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.32,29.66a3.32,3.32,0,1,1,3.32-3.32A3.32,3.32,0,0,1,7.32,29.66Zm0-5.64a2.32,2.32,0,1,0,2.32,2.32A2.32,2.32,0,0,0,7.32,24Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.68,29.66a3.32,3.32,0,0,1-3.32-3.32V13.66a3.32,3.32,0,1,1,6.64,0V26.34A3.32,3.32,0,0,1,32.68,29.66Zm0-18.32a2.32,2.32,0,0,0-2.32,2.32V26.34a2.32,2.32,0,1,0,4.64,0V13.66A2.32,2.32,0,0,0,32.68,11.34Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Signal2Bars);

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Signal3Bars=function Signal3Bars(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.23,15.07a2.82,2.82,0,0,0-2.82,2.82v8.45a2.82,2.82,0,0,0,5.64,0V17.89a2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.23,29.66a3.32,3.32,0,0,1-3.32-3.32V17.89a3.32,3.32,0,0,1,6.64,0v8.45A3.32,3.32,0,0,1,24.23,29.66Zm0-14.09a2.32,2.32,0,0,0-2.32,2.32v8.45a2.32,2.32,0,1,0,4.64,0V17.89A2.32,2.32,0,0,0,24.23,15.57Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.77,19.3A2.82,2.82,0,0,0,13,22.11v4.23a2.82,2.82,0,1,0,5.64,0V22.11a2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.77,29.66a3.32,3.32,0,0,1-3.32-3.32V22.11a3.32,3.32,0,0,1,6.64,0v4.23A3.32,3.32,0,0,1,15.77,29.66Zm0-9.86a2.32,2.32,0,0,0-2.32,2.32v4.23a2.32,2.32,0,1,0,4.64,0V22.11A2.32,2.32,0,0,0,15.77,19.8Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.32,23.52a2.82,2.82,0,1,0,2.82,2.82,2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.32,29.66a3.32,3.32,0,1,1,3.32-3.32A3.32,3.32,0,0,1,7.32,29.66Zm0-5.64a2.32,2.32,0,1,0,2.32,2.32A2.32,2.32,0,0,0,7.32,24Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.68,29.66a3.32,3.32,0,0,1-3.32-3.32V13.66a3.32,3.32,0,1,1,6.64,0V26.34A3.32,3.32,0,0,1,32.68,29.66Zm0-18.32a2.32,2.32,0,0,0-2.32,2.32V26.34a2.32,2.32,0,1,0,4.64,0V13.66A2.32,2.32,0,0,0,32.68,11.34Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Signal3Bars);

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Signal4Bars=function Signal4Bars(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.23,15.07a2.82,2.82,0,0,0-2.82,2.82v8.45a2.82,2.82,0,1,0,5.64,0V17.89a2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.23,29.66a3.32,3.32,0,0,1-3.32-3.32V17.89a3.32,3.32,0,0,1,6.64,0v8.45A3.32,3.32,0,0,1,24.23,29.66Zm0-14.09a2.32,2.32,0,0,0-2.32,2.32v8.45a2.32,2.32,0,1,0,4.64,0V17.89A2.32,2.32,0,0,0,24.23,15.57Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.77,19.3A2.82,2.82,0,0,0,13,22.11v4.23a2.82,2.82,0,1,0,5.64,0V22.11a2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.77,29.66a3.32,3.32,0,0,1-3.32-3.32V22.11a3.32,3.32,0,0,1,6.64,0v4.23A3.32,3.32,0,0,1,15.77,29.66Zm0-9.86a2.32,2.32,0,0,0-2.32,2.32v4.23a2.32,2.32,0,1,0,4.64,0V22.11A2.32,2.32,0,0,0,15.77,19.8Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.32,23.52a2.82,2.82,0,1,0,2.82,2.82,2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M7.32,29.66a3.32,3.32,0,1,1,3.32-3.32A3.32,3.32,0,0,1,7.32,29.66Zm0-5.64a2.32,2.32,0,1,0,2.32,2.32A2.32,2.32,0,0,0,7.32,24Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.68,10.84a2.82,2.82,0,0,0-2.82,2.82V26.34a2.82,2.82,0,1,0,5.64,0V13.66a2.82,2.82,0,0,0-2.82-2.82Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.68,29.66a3.32,3.32,0,0,1-3.32-3.32V13.66a3.32,3.32,0,1,1,6.64,0V26.34A3.32,3.32,0,0,1,32.68,29.66Zm0-18.32a2.32,2.32,0,0,0-2.32,2.32V26.34a2.32,2.32,0,1,0,4.64,0V13.66A2.32,2.32,0,0,0,32.68,11.34Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Signal4Bars);

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SmokeCo=function SmokeCo(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.286181,7.21042908 C22.6846299,7.00801688 23.1860885,7.14093573 23.4062201,7.50731166 C23.6263517,7.87368758 23.481797,8.33478146 23.0833481,8.53719366 C22.9270706,8.6165827 22.6358265,8.78129338 22.2552382,9.02573137 C21.6154821,9.4366234 20.9752069,9.91662105 20.3799762,10.4587511 C18.7189871,11.971563 17.7393414,13.6529961 17.7393414,15.452717 C17.7393414,17.1719766 18.3434204,18.181022 19.9906002,19.8050797 C20.0309581,19.8448711 20.3444832,20.1526531 20.4365795,20.2438174 C22.0255954,21.8167541 22.6847646,22.8877415 22.6847646,24.5474037 C22.6847646,26.4140117 21.6829385,28.3331459 20.0314369,30.2313518 C19.4675182,30.8795096 18.8651189,31.4795782 18.2623845,32.0184008 C17.8986696,32.3435487 17.6127036,32.5783231 17.442768,32.708537 C17.0930632,32.9764999 16.5733283,32.9330545 16.2819076,32.611499 C15.990487,32.2899436 16.0377356,31.8120445 16.3874404,31.5440817 C16.5265937,31.4374548 16.7815334,31.2281526 17.1132686,30.9315934 C17.6696178,30.4342375 18.226302,29.8797072 18.7441947,29.2844508 C20.1835825,27.6300447 21.0362902,25.996567 21.0362902,24.5474037 C21.0362902,23.3673686 20.5594602,22.5926373 19.2287891,21.2754313 C19.139514,21.1870596 18.8275558,20.8808157 18.7850314,20.8388883 C16.8799295,18.960529 16.090867,17.6424898 16.090867,15.452717 C16.090867,13.1855115 17.2748439,11.1533708 19.2198926,9.38184036 C19.886775,8.77445063 20.598764,8.24069096 21.3112721,7.78307305 C21.7420422,7.50640508 22.0818548,7.31422691 22.286181,7.21042908 Z M32.1770274,8.7262102 C32.5754763,8.523798 33.0769348,8.65671686 33.2970664,9.02309278 C33.5171981,9.3894687 33.3726433,9.85056258 32.9741944,10.0529748 C32.8179169,10.1323638 32.5266728,10.2970745 32.1460845,10.5415125 C31.5063284,10.9524045 30.8660532,11.4324022 30.2708225,11.9745322 C28.6098335,13.4873441 27.6301877,15.1687772 27.6301877,16.9684981 C27.6301877,18.6877577 28.2342668,19.6968031 29.8814465,21.3208608 C29.9218045,21.3606522 30.2353296,21.6684342 30.3274259,21.7595986 C31.9164418,23.3325352 32.5756109,24.4035227 32.5756109,26.0631848 C32.5756109,27.9297928 31.5737849,29.848927 29.9222832,31.7471329 C29.3583646,32.3952907 28.7559652,32.9953593 28.1532308,33.5341819 C27.7895159,33.8593298 27.5035499,34.0941042 27.3336143,34.2243181 C26.9839095,34.492281 26.4641746,34.4488356 26.172754,34.1272801 C25.8813333,33.8057247 25.9285819,33.3278257 26.2782867,33.0598628 C26.4174401,32.9532359 26.6723798,32.7439337 27.004115,32.4473746 C27.5604641,31.9500186 28.1171483,31.3954883 28.635041,30.800232 C30.0744288,29.1458258 30.9271365,27.5123481 30.9271365,26.0631848 C30.9271365,24.8831497 30.4503065,24.1084184 29.1196355,22.7912124 C29.0303604,22.7028407 28.7184021,22.3965968 28.6758777,22.3546694 C26.7707758,20.4763101 25.9817133,19.1582709 25.9817133,16.9684981 C25.9817133,14.7012926 27.1656902,12.6691519 29.1107389,10.8976215 C29.7776214,10.2902317 30.4896104,9.75647209 31.2021184,9.29885417 C31.6328886,9.0221862 31.9727011,8.83000803 32.1770274,8.7262102 Z M12.3953347,5.69464796 C12.7937836,5.49223576 13.2952422,5.62515461 13.5153738,5.99153053 C13.7355054,6.35790646 13.5909507,6.81900033 13.1925018,7.02141254 C13.0362242,7.10080158 12.7449802,7.26551226 12.3643919,7.50995025 C11.7246357,7.92084228 11.0843606,8.40083993 10.4891298,8.94297001 C8.8281408,10.4557819 7.84849506,12.137215 7.84849506,13.9369359 C7.84849506,15.6561955 8.45257409,16.6652409 10.0997539,18.2892986 C10.1401118,18.32909 10.4536369,18.6368719 10.5457332,18.7280363 C12.1347491,20.300973 12.7939182,21.3719604 12.7939182,23.0316226 C12.7939182,24.8982305 11.7920922,26.8173648 10.1405906,28.7155707 C9.5766719,29.3637285 8.97427254,29.9637971 8.37153817,30.5026197 C8.00782323,30.8277676 7.72185726,31.0625419 7.55192166,31.1927558 C7.20221686,31.4607187 6.68248198,31.4172734 6.39106131,31.0957179 C6.09964064,30.7741625 6.14688927,30.2962634 6.49659407,30.0283005 C6.63574742,29.9216737 6.8906871,29.7123715 7.22242229,29.4158123 C7.77877147,28.9184564 8.33545567,28.3639261 8.85334833,27.7686697 C10.2927362,26.1142636 11.1454438,24.4807858 11.1454438,23.0316226 C11.1454438,21.8515874 10.6686138,21.0768562 9.33794279,19.7596502 C9.24866771,19.6712785 8.93670942,19.3650346 8.89418504,19.3231071 C6.98908316,17.4447479 6.20002067,16.1267087 6.20002067,13.9369359 C6.20002067,11.6697304 7.38399756,9.6375897 9.32904624,7.86605924 C9.99592871,7.25866951 10.7079177,6.72490984 11.4204257,6.26729193 C11.8511959,5.99062396 12.1910084,5.79844579 12.3953347,5.69464796 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SmokeCo);

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SmokeCo2=function SmokeCo2(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.09,22.3c0-2.82,1.35-4.17,3.72-4.17a3.3,3.3,0,0,1,2.86,1.28.68.68,0,0,1,.13.39.64.64,0,0,1-.64.63.66.66,0,0,1-.49-.24,2.28,2.28,0,0,0-1.87-.83c-1.58,0-2.29,1-2.29,2.93s.71,2.92,2.29,2.92a2.32,2.32,0,0,0,1.92-.78.71.71,0,0,1,.51-.26.64.64,0,0,1,.64.64.58.58,0,0,1-.12.36,3.71,3.71,0,0,1-3,1.28C13.44,26.46,12.09,25.21,12.09,22.3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,22.3c0-2.82,1.37-4.17,3.77-4.17s3.77,1.35,3.77,4.17-1.37,4.16-3.77,4.16S20,25.08,20,22.3Zm1.43,0c0,2,.77,2.92,2.34,2.92s2.34-1,2.34-2.92-.77-2.93-2.34-2.93S21.42,20.33,21.42,22.3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.49,30.8h-19A6.34,6.34,0,0,1,4,24.5a6.18,6.18,0,0,1,3.83-5.72A8.63,8.63,0,0,1,7.65,17a8.17,8.17,0,0,1,8-8.33,7.85,7.85,0,0,1,6.89,4.16A6.31,6.31,0,0,1,25,12.36a6.7,6.7,0,0,1,6.58,6.2,6.48,6.48,0,0,1,2.8,1.87h0A6,6,0,0,1,36,24.5,6.34,6.34,0,0,1,29.49,30.8ZM15.62,9.71a7.16,7.16,0,0,0-7,7.33A7.65,7.65,0,0,0,8.89,19L9,19.4l-.42.16A5.25,5.25,0,0,0,5,24.5a5.35,5.35,0,0,0,5.51,5.3h19A5.35,5.35,0,0,0,35,24.5a5,5,0,0,0-1.37-3.42h0A5.48,5.48,0,0,0,31,19.42l-.35-.1,0-.36A5.72,5.72,0,0,0,25,13.36a5.33,5.33,0,0,0-2.48.61l-.46.24-.22-.47A6.89,6.89,0,0,0,15.62,9.71Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SmokeCo2);

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SoundCam=function SoundCam(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M4.5,25.75a.5.5,0,0,1-.5-.5v-10a.5.5,0,0,1,1,0v10A.5.5,0,0,1,4.5,25.75Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.93,28.5a.5.5,0,0,1-.5-.5V12.5a.5.5,0,0,1,1,0V28A.5.5,0,0,1,8.93,28.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13.36,33.25a.5.5,0,0,1-.5-.5V8.25a.5.5,0,0,1,1,0v24.5A.5.5,0,0,1,13.36,33.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.79,29.88a.5.5,0,0,1-.5-.5V11.63a.5.5,0,0,1,1,0V29.38A.5.5,0,0,1,17.79,29.88Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.21,28.13a.5.5,0,0,1-.5-.5V13.38a.5.5,0,0,1,1,0V27.63A.5.5,0,0,1,22.21,28.13Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.64,33.38a.5.5,0,0,1-.5-.5V8.13a.5.5,0,1,1,1,0V32.88A.5.5,0,0,1,26.64,33.38Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.07,26a.5.5,0,0,1-.5-.5v-10a.5.5,0,1,1,1,0v10A.5.5,0,0,1,31.07,26Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,28.63a.5.5,0,0,1-.5-.5V13.38a.5.5,0,0,1,1,0V28.13A.5.5,0,0,1,35.5,28.63Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SoundCam);

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SoundOff=function SoundOff(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.07,25a1,1,0,0,1-.71-1.71l6.86-6.86a1,1,0,0,1,1.41,1.41l-6.86,6.86A1,1,0,0,1,28.07,25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M34.93,25a1,1,0,0,1-.71-.29L27.36,17.8a1,1,0,0,1,1.41-1.41l6.86,6.86A1,1,0,0,1,34.93,25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21.63,34a3.18,3.18,0,0,1-1.8-.54l-7.89-4.6H7.19A3.23,3.23,0,0,1,4,25.69V15.3a3.23,3.23,0,0,1,3.19-3.19h4.76l7.78-4.47a3.25,3.25,0,0,1,3.34-.32h0a3.16,3.16,0,0,1,1.74,2.84V30.83a3.29,3.29,0,0,1-1.58,2.75l-.1.06A3.35,3.35,0,0,1,21.63,34Zm1-1.24.35.38-.26-.43a2.27,2.27,0,0,0,1.1-1.9V10.16a2.16,2.16,0,0,0-1.19-1.95,2.22,2.22,0,0,0-2.34.25l-8.07,4.65h-5A2.22,2.22,0,0,0,5,15.3V25.69a2.22,2.22,0,0,0,2.19,2.19h5l8.14,4.75a2.23,2.23,0,0,0,1.27.39A2.27,2.27,0,0,0,22.63,32.78Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SoundOff);

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SoundOn=function SoundOn(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21.58,33.72a3.22,3.22,0,0,1-1.82-.55l-8-4.67H6.92a3.27,3.27,0,0,1-3.23-3.23V14.72a3.27,3.27,0,0,1,3.23-3.23h4.83l7.9-4.54A3.3,3.3,0,0,1,23,6.62h0A3.2,3.2,0,0,1,24.82,9.5v21a3.33,3.33,0,0,1-1.6,2.79l-.09.05A3.39,3.39,0,0,1,21.58,33.72Zm1-1.25.35.38-.26-.43a2.31,2.31,0,0,0,1.12-1.93V9.5a2.2,2.2,0,0,0-1.21-2,2.26,2.26,0,0,0-2.38.26L12,12.49H6.92a2.26,2.26,0,0,0-2.23,2.23V25.27A2.26,2.26,0,0,0,6.92,27.5H12l8.27,4.83a2.26,2.26,0,0,0,2.31.15Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SoundOn);

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Stop=function Stop(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'31',rx:'3.88',ry:'3.88',width:'31',x:'4.5',y:'4.5'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.63,36H8.38A4.38,4.38,0,0,1,4,31.63V8.38A4.38,4.38,0,0,1,8.38,4H31.63A4.38,4.38,0,0,1,36,8.38V31.63A4.38,4.38,0,0,1,31.63,36ZM8.38,5A3.38,3.38,0,0,0,5,8.38V31.63A3.38,3.38,0,0,0,8.38,35H31.63A3.38,3.38,0,0,0,35,31.63V8.38A3.38,3.38,0,0,0,31.63,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Stop);

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var StopSimple=function StopSimple(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.63,36H8.38A4.38,4.38,0,0,1,4,31.63V8.38A4.38,4.38,0,0,1,8.38,4H31.63A4.38,4.38,0,0,1,36,8.38V31.63A4.38,4.38,0,0,1,31.63,36ZM8.38,5A3.38,3.38,0,0,0,5,8.38V31.63A3.38,3.38,0,0,0,8.38,35H31.63A3.38,3.38,0,0,0,35,31.63V8.38A3.38,3.38,0,0,0,31.63,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (StopSimple);

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var TickOne=function TickOne(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.17,26.33a1,1,0,0,1-.71-.29l-5-5a1,1,0,0,1,1.41-1.41l4.29,4.29L27.12,14a1,1,0,0,1,1.41,1.41L17.88,26A1,1,0,0,1,17.17,26.33Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}));};/* harmony default export */ __webpack_exports__["a"] = (TickOne);

/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var TickSimple=function TickSimple(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.4,27.78a1,1,0,0,1-.71-.29L9.33,21.13a1,1,0,0,1,1.41-1.41l5.65,5.65L29.25,12.51a1,1,0,0,1,1.41,1.41L17.11,27.49A1,1,0,0,1,16.4,27.78Z'}));};/* harmony default export */ __webpack_exports__["a"] = (TickSimple);

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Tone=function Tone(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path,Rect=_ref$svgComponents.Rect;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36A16,16,0,1,1,36,20,16,16,0,0,1,20,36ZM20,5A15,15,0,1,0,35,20,15,15,0,0,0,20,5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rect,{height:'31',width:'1',x:'19.46',y:'4.5'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M4.64,19.2a.5.5,0,0,1-.35-.85L18.45,4.19a.5.5,0,0,1,.71.71L5,19.06A.5.5,0,0,1,4.64,19.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M5.08,24a.5.5,0,0,1-.35-.85L19.61,8.3a.5.5,0,0,1,.71.71L5.43,23.89A.5.5,0,0,1,5.08,24Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M6.41,28a.5.5,0,0,1-.35-.85L19.61,13.56a.5.5,0,1,1,.71.71L6.77,27.82A.5.5,0,0,1,6.41,28Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8.67,31a.5.5,0,0,1-.35-.85L19.61,18.83a.5.5,0,0,1,.71.71L9,30.83A.5.5,0,0,1,8.67,31Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.62,33.3a.5.5,0,0,1-.35-.85l8.34-8.34a.5.5,0,0,1,.71.71L12,33.15A.5.5,0,0,1,11.62,33.3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15,35.18a.5.5,0,0,1-.35-.85l5-5a.5.5,0,0,1,.71.71l-5,5A.5.5,0,0,1,15,35.18Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Tone);

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Trash=function Trash(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.83,7.58C23.6,6.11,22,5,20,5s-3.6,1.11-3.83,2.58l-1-.15C15.49,5.47,17.56,4,20,4s4.51,1.47,4.82,3.42Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.88,36H12.12a3.71,3.71,0,0,1-4-3.65V10.6H7.74c-.85,0-1.38-.71-1.38-1.85,0-.7.55-1.75,1.38-1.75H32.26c.83,0,1.38,1.05,1.38,1.75,0,1.13-.54,1.85-1.38,1.85h-.38V32.35A3.71,3.71,0,0,1,27.88,36ZM7.74,8a1,1,0,0,0-.38.75c0,.26,0,.85.38.85H9.12V32.35a2.72,2.72,0,0,0,3,2.65H27.88a2.72,2.72,0,0,0,3-2.65V9.6h1.38c.37,0,.38-.77.38-.85A1,1,0,0,0,32.25,8Zm0,0Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.5,32a.5.5,0,0,1-.5-.5v-19a.5.5,0,0,1,1,0v19A.5.5,0,0,1,25.5,32Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,32a.5.5,0,0,1-.5-.5v-19a.5.5,0,0,1,1,0v19A.5.5,0,0,1,20,32Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.5,32a.5.5,0,0,1-.5-.5v-19a.5.5,0,0,1,1,0v19A.5.5,0,0,1,14.5,32Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Trash);

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var UserProfile=function UserProfile(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,17.08a6.51,6.51,0,1,1,6.51-6.51A6.51,6.51,0,0,1,20,17.08Zm0-12a5.51,5.51,0,1,0,5.51,5.51A5.51,5.51,0,0,0,20,5.06Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.3,36.06a.5.5,0,0,1-.5-.5V25.27a6.37,6.37,0,0,0-6.36-6.37H16.57a6.37,6.37,0,0,0-6.36,6.37v10.3a.5.5,0,0,1-1,0V25.27a7.37,7.37,0,0,1,7.36-7.37h6.87a7.37,7.37,0,0,1,7.36,7.37v10.3A.5.5,0,0,1,30.3,36.06Z'}));};/* harmony default export */ __webpack_exports__["a"] = (UserProfile);

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var WelcomeHome=function WelcomeHome(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13,8.18472743 L13,31.8152726 C13,31.9084243 13.0981593,32 13.2617111,32 L15.7382889,32 C15.90219,32 16,31.907617 16,31.8152726 L16,8.18472743 C16,8.09157569 15.9018407,8 15.7382889,8 L13.2617111,8 C13.09781,8 13,8.09238303 13,8.18472743 Z M16,7.02504014 L16,4.99278641 C16,4.44448561 16.4321357,4.10803392 16.9634835,4.24087086 L27.0300251,6.75750627 C27.5657274,6.89143186 28,7.45127869 28,8.00329963 L28,31.9967004 C28,32.5508075 27.5729136,33.1067716 27.0382745,33.2404314 L16.9617255,35.7595686 C16.4305792,35.8923552 16,35.5476379 16,35.0072136 L16,32.9750924 C15.9157935,32.9914186 15.8282815,33 15.7382889,33 L13.2617111,33 C12.5648873,33 12,32.4806401 12,31.8152726 L12,8.18472743 C12,7.53042054 12.5541915,7 13.2617111,7 L15.7382889,7 C15.828022,7 15.9155672,7.00861247 16,7.02504014 Z M17,34.7192236 L26.7957388,32.2702889 C26.8817203,32.2487935 27,32.0955205 27,31.9967004 L27,8.00329963 C27,7.90863885 26.8765618,7.74991686 26.7874895,7.72764877 L17,5.28077641 L17,34.7192236 Z M19.5,23 C18.6715729,23 18,22.3284271 18,21.5 C18,20.6715729 18.6715729,20 19.5,20 C20.3284271,20 21,20.6715729 21,21.5 C21,22.3284271 20.3284271,23 19.5,23 Z'}));};/* harmony default export */ __webpack_exports__["a"] = (WelcomeHome);

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Wifi=function Wifi(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,32.29a2.15,2.15,0,1,1,2.15-2.15A2.15,2.15,0,0,1,20,32.29ZM20,29a1.15,1.15,0,1,0,1.15,1.15A1.15,1.15,0,0,0,20,29Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8,18.66a.5.5,0,0,1-.35-.85,17.48,17.48,0,0,1,24.73-.08.5.5,0,0,1-.71.71,16.48,16.48,0,0,0-23.31.07A.5.5,0,0,1,8,18.66Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M4.5,15.17a.5.5,0,0,1-.35-.85,22.42,22.42,0,0,1,31.71-.08.5.5,0,1,1-.71.71A21.42,21.42,0,0,0,4.85,15,.5.5,0,0,1,4.5,15.17Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.75,22.43a.5.5,0,0,1-.36-.85,12.16,12.16,0,0,1,17.2-.08.5.5,0,1,1-.7.71,11.16,11.16,0,0,0-15.79.07A.5.5,0,0,1,11.75,22.43Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.47,26.14a.5.5,0,0,1-.36-.85,6.9,6.9,0,0,1,9.77-.08.5.5,0,0,1-.7.71,5.9,5.9,0,0,0-8.35.07A.5.5,0,0,1,15.47,26.14Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Wifi);

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Wifi0Bars=function Wifi0Bars(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.5232,27.2418667 C19.1952,27.2418667 18.9272,27.5098667 18.9272,27.8378667 C18.9272,28.1678667 19.1952,28.4358667 19.5232,28.4358667 C19.8532,28.4358667 20.1212,28.1678667 20.1212,27.8378667 C20.1212,27.5098667 19.8532,27.2418667 19.5232,27.2418667 Z M19.5232,30.4358667 C18.0912,30.4358667 16.9272,29.2718667 16.9272,27.8378667 C16.9272,26.4078667 18.0912,25.2418667 19.5232,25.2418667 C20.9552,25.2418667 22.1212,26.4078667 22.1212,27.8378667 C22.1212,29.2718667 20.9552,30.4358667 19.5232,30.4358667 Z M7.9372,17.2526667 C7.6812,17.2526667 7.4272,17.1566667 7.2312,16.9606667 C6.8392,16.5726667 6.8392,15.9386667 7.2292,15.5466667 C10.5272,12.2286667 14.9192,10.4006667 19.5972,10.4006667 C24.2332,10.4006667 28.5972,12.2026667 31.8892,15.4706667 C32.2792,15.8606667 32.2812,16.4946667 31.8932,16.8846667 C31.5032,17.2766667 30.8712,17.2806667 30.4792,16.8886667 C27.5652,13.9946667 23.7012,12.4006667 19.5972,12.4006667 C15.4572,12.4006667 11.5672,14.0186667 8.6452,16.9586667 C8.4512,17.1546667 8.1952,17.2526667 7.9372,17.2526667 Z M11.5778,20.8932667 C11.3238,20.8932667 11.0678,20.7972667 10.8738,20.6032667 C10.4818,20.2152667 10.4778,19.5812667 10.8678,19.1892667 C13.1958,16.8432667 16.2938,15.5492667 19.5978,15.5492667 C22.8578,15.5492667 25.9298,16.8132667 28.2458,19.1112667 C28.6378,19.4992667 28.6418,20.1332667 28.2538,20.5252667 C27.8678,20.9172667 27.2298,20.9212667 26.8398,20.5312667 C24.8978,18.6072667 22.3258,17.5492667 19.5978,17.5492667 C16.8318,17.5492667 14.2358,18.6312667 12.2878,20.5972667 C12.0918,20.7952667 11.8358,20.8932667 11.5778,20.8932667 Z M15.1754,24.4908667 C14.9214,24.4908667 14.6694,24.3948667 14.4734,24.2028667 C14.0794,23.8168667 14.0754,23.1828667 14.4634,22.7888667 C17.1594,20.0428667 21.8974,20.0028667 24.6454,22.7048667 C25.0414,23.0908667 25.0454,23.7248667 24.6574,24.1188667 C24.2714,24.5148667 23.6374,24.5168667 23.2434,24.1308667 C21.2594,22.1808667 17.8374,22.2108667 15.8874,24.1928667 C15.6934,24.3908667 15.4334,24.4908667 15.1754,24.4908667 Z',fill:'#ADB6BC'}));};/* harmony default export */ __webpack_exports__["a"] = (Wifi0Bars);

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Wifi1Bars=function Wifi1Bars(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.5232,27.2418667 C19.1952,27.2418667 18.9272,27.5098667 18.9272,27.8378667 C18.9272,28.1678667 19.1952,28.4358667 19.5232,28.4358667 C19.8532,28.4358667 20.1212,28.1678667 20.1212,27.8378667 C20.1212,27.5098667 19.8532,27.2418667 19.5232,27.2418667 Z M19.5232,30.4358667 C18.0912,30.4358667 16.9272,29.2718667 16.9272,27.8378667 C16.9272,26.4078667 18.0912,25.2418667 19.5232,25.2418667 C20.9552,25.2418667 22.1212,26.4078667 22.1212,27.8378667 C22.1212,29.2718667 20.9552,30.4358667 19.5232,30.4358667 Z M15.1754,24.4908667 C14.9214,24.4908667 14.6694,24.3948667 14.4734,24.2028667 C14.0794,23.8168667 14.0754,23.1828667 14.4634,22.7888667 C17.1594,20.0428667 21.8974,20.0028667 24.6454,22.7048667 C25.0414,23.0908667 25.0454,23.7248667 24.6574,24.1188667 C24.2714,24.5148667 23.6374,24.5168667 23.2434,24.1308667 C21.2594,22.1808667 17.8374,22.2108667 15.8874,24.1928667 C15.6934,24.3908667 15.4334,24.4908667 15.1754,24.4908667 Z',id:'wifi_01@1x-a'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,{fill:'none',fillRule:'evenodd'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,{fill:'#ADB6BC',transform:'translate(6.667 10)'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M4.91113333,10.8932667 C4.65713333,10.8932667 4.40113333,10.7972667 4.20713333,10.6032667 C3.81513333,10.2152667 3.81113333,9.58126667 4.20113333,9.18926667 C6.52913333,6.84326667 9.62713333,5.54926667 12.9311333,5.54926667 C16.1911333,5.54926667 19.2631333,6.81326667 21.5791333,9.11126667 C21.9711333,9.49926667 21.9751333,10.1332667 21.5871333,10.5252667 C21.2011333,10.9172667 20.5631333,10.9212667 20.1731333,10.5312667 C18.2311333,8.60726667 15.6591333,7.54926667 12.9311333,7.54926667 C10.1651333,7.54926667 7.56913333,8.63126667 5.62113333,10.5972667 C5.42513333,10.7952667 5.16913333,10.8932667 4.91113333,10.8932667'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M1.27053333,7.25266667 C1.01453333,7.25266667 0.760533333,7.15666667 0.564533333,6.96066667 C0.172533333,6.57266667 0.172533333,5.93866667 0.562533333,5.54666667 C3.86053333,2.22866667 8.25253333,0.400666667 12.9305333,0.400666667 C17.5665333,0.400666667 21.9305333,2.20266667 25.2225333,5.47066667 C25.6125333,5.86066667 25.6145333,6.49466667 25.2265333,6.88466667 C24.8365333,7.27666667 24.2045333,7.28066667 23.8125333,6.88866667 C20.8985333,3.99466667 17.0345333,2.40066667 12.9305333,2.40066667 C8.79053333,2.40066667 4.90053333,4.01866667 1.97853333,6.95866667 C1.78453333,7.15466667 1.52853333,7.25266667 1.27053333,7.25266667'}))));};/* harmony default export */ __webpack_exports__["a"] = (Wifi1Bars);

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Wifi2Bars=function Wifi2Bars(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.5232,27.2418667 C19.1952,27.2418667 18.9272,27.5098667 18.9272,27.8378667 C18.9272,28.1678667 19.1952,28.4358667 19.5232,28.4358667 C19.8532,28.4358667 20.1212,28.1678667 20.1212,27.8378667 C20.1212,27.5098667 19.8532,27.2418667 19.5232,27.2418667 Z M19.5232,30.4358667 C18.0912,30.4358667 16.9272,29.2718667 16.9272,27.8378667 C16.9272,26.4078667 18.0912,25.2418667 19.5232,25.2418667 C20.9552,25.2418667 22.1212,26.4078667 22.1212,27.8378667 C22.1212,29.2718667 20.9552,30.4358667 19.5232,30.4358667 Z M11.5778,20.8932667 C11.3238,20.8932667 11.0678,20.7972667 10.8738,20.6032667 C10.4818,20.2152667 10.4778,19.5812667 10.8678,19.1892667 C13.1958,16.8432667 16.2938,15.5492667 19.5978,15.5492667 C22.8578,15.5492667 25.9298,16.8132667 28.2458,19.1112667 C28.6378,19.4992667 28.6418,20.1332667 28.2538,20.5252667 C27.8678,20.9172667 27.2298,20.9212667 26.8398,20.5312667 C24.8978,18.6072667 22.3258,17.5492667 19.5978,17.5492667 C16.8318,17.5492667 14.2358,18.6312667 12.2878,20.5972667 C12.0918,20.7952667 11.8358,20.8932667 11.5778,20.8932667 Z M15.1754,24.4908667 C14.9214,24.4908667 14.6694,24.3948667 14.4734,24.2028667 C14.0794,23.8168667 14.0754,23.1828667 14.4634,22.7888667 C17.1594,20.0428667 21.8974,20.0028667 24.6454,22.7048667 C25.0414,23.0908667 25.0454,23.7248667 24.6574,24.1188667 C24.2714,24.5148667 23.6374,24.5168667 23.2434,24.1308667 C21.2594,22.1808667 17.8374,22.2108667 15.8874,24.1928667 C15.6934,24.3908667 15.4334,24.4908667 15.1754,24.4908667 Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M1.27053333,7.25266667 C1.01453333,7.25266667 0.760533333,7.15666667 0.564533333,6.96066667 C0.172533333,6.57266667 0.172533333,5.93866667 0.562533333,5.54666667 C3.86053333,2.22866667 8.25253333,0.400666667 12.9305333,0.400666667 C17.5665333,0.400666667 21.9305333,2.20266667 25.2225333,5.47066667 C25.6125333,5.86066667 25.6145333,6.49466667 25.2265333,6.88466667 C24.8365333,7.27666667 24.2045333,7.28066667 23.8125333,6.88866667 C20.8985333,3.99466667 17.0345333,2.40066667 12.9305333,2.40066667 C8.79053333,2.40066667 4.90053333,4.01866667 1.97853333,6.95866667 C1.78453333,7.15466667 1.52853333,7.25266667 1.27053333,7.25266667',fill:'#ADB6BC',transform:'translate(6.667 10)'}));};/* harmony default export */ __webpack_exports__["a"] = (Wifi2Bars);

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Wifi3Bars=function Wifi3Bars(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.5232,27.2418667 C19.1952,27.2418667 18.9272,27.5098667 18.9272,27.8378667 C18.9272,28.1678667 19.1952,28.4358667 19.5232,28.4358667 C19.8532,28.4358667 20.1212,28.1678667 20.1212,27.8378667 C20.1212,27.5098667 19.8532,27.2418667 19.5232,27.2418667 Z M19.5232,30.4358667 C18.0912,30.4358667 16.9272,29.2718667 16.9272,27.8378667 C16.9272,26.4078667 18.0912,25.2418667 19.5232,25.2418667 C20.9552,25.2418667 22.1212,26.4078667 22.1212,27.8378667 C22.1212,29.2718667 20.9552,30.4358667 19.5232,30.4358667 Z M7.9372,17.2526667 C7.6812,17.2526667 7.4272,17.1566667 7.2312,16.9606667 C6.8392,16.5726667 6.8392,15.9386667 7.2292,15.5466667 C10.5272,12.2286667 14.9192,10.4006667 19.5972,10.4006667 C24.2332,10.4006667 28.5972,12.2026667 31.8892,15.4706667 C32.2792,15.8606667 32.2812,16.4946667 31.8932,16.8846667 C31.5032,17.2766667 30.8712,17.2806667 30.4792,16.8886667 C27.5652,13.9946667 23.7012,12.4006667 19.5972,12.4006667 C15.4572,12.4006667 11.5672,14.0186667 8.6452,16.9586667 C8.4512,17.1546667 8.1952,17.2526667 7.9372,17.2526667 Z M11.5778,20.8932667 C11.3238,20.8932667 11.0678,20.7972667 10.8738,20.6032667 C10.4818,20.2152667 10.4778,19.5812667 10.8678,19.1892667 C13.1958,16.8432667 16.2938,15.5492667 19.5978,15.5492667 C22.8578,15.5492667 25.9298,16.8132667 28.2458,19.1112667 C28.6378,19.4992667 28.6418,20.1332667 28.2538,20.5252667 C27.8678,20.9172667 27.2298,20.9212667 26.8398,20.5312667 C24.8978,18.6072667 22.3258,17.5492667 19.5978,17.5492667 C16.8318,17.5492667 14.2358,18.6312667 12.2878,20.5972667 C12.0918,20.7952667 11.8358,20.8932667 11.5778,20.8932667 Z M15.1754,24.4908667 C14.9214,24.4908667 14.6694,24.3948667 14.4734,24.2028667 C14.0794,23.8168667 14.0754,23.1828667 14.4634,22.7888667 C17.1594,20.0428667 21.8974,20.0028667 24.6454,22.7048667 C25.0414,23.0908667 25.0454,23.7248667 24.6574,24.1188667 C24.2714,24.5148667 23.6374,24.5168667 23.2434,24.1308667 C21.2594,22.1808667 17.8374,22.2108667 15.8874,24.1928667 C15.6934,24.3908667 15.4334,24.4908667 15.1754,24.4908667 Z',id:'wifi_03@1x-a'}));};/* harmony default export */ __webpack_exports__["a"] = (Wifi3Bars);

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var WifiOff=function WifiOff(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,32.29a2.15,2.15,0,1,1,2.15-2.15A2.15,2.15,0,0,1,20,32.29ZM20,29a1.15,1.15,0,1,0,1.15,1.15A1.15,1.15,0,0,0,20,29Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M4.5,15.2a.5.5,0,0,1-.35-.85,22.31,22.31,0,0,1,7.68-5.05.5.5,0,0,1,.37.93,21.32,21.32,0,0,0-7.34,4.83A.5.5,0,0,1,4.5,15.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,15.13a.5.5,0,0,1-.35-.15A21.45,21.45,0,0,0,14,9.6a.5.5,0,0,1-.28-1,22.46,22.46,0,0,1,22.11,5.63.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M8,18.69a.5.5,0,0,1-.35-.85,17.47,17.47,0,0,1,8.17-4.65.5.5,0,0,1,.24,1,16.46,16.46,0,0,0-7.7,4.38A.5.5,0,0,1,8,18.69Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32,18.62a.5.5,0,0,1-.35-.15A16.38,16.38,0,0,0,20,13.68a16.7,16.7,0,0,0-1.93.11.5.5,0,1,1-.12-1,17.71,17.71,0,0,1,2-.12,17.37,17.37,0,0,1,12.32,5.08.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.75,22.45a.5.5,0,0,1-.36-.85A12.16,12.16,0,0,1,20.8,18a.5.5,0,1,1-.06,1L20,19a11.09,11.09,0,0,0-7.93,3.31A.5.5,0,0,1,11.75,22.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M28.25,22.38a.5.5,0,0,1-.35-.15,11.24,11.24,0,0,0-4.06-2.57.5.5,0,1,1,.34-.94,12.24,12.24,0,0,1,4.43,2.8.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.47,26.17a.5.5,0,0,1-.36-.85,6.9,6.9,0,0,1,9.77-.08.5.5,0,0,1-.7.71,5.9,5.9,0,0,0-8.35.07A.5.5,0,0,1,15.47,26.17Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M32.33,30.58a.5.5,0,0,1-.35-.15L8,6.44a.5.5,0,0,1,.71-.71l24,24a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (WifiOff);

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__black_low_cloud__ = __webpack_require__(1724);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__black_low_cloud__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clear_sky__ = __webpack_require__(1725);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__clear_sky__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloudy_with_heavy_rain__ = __webpack_require__(1726);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__cloudy_with_heavy_rain__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloudy_with_heavy_rain_night__ = __webpack_require__(1727);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__cloudy_with_heavy_rain_night__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloudy_with_heavy_snow__ = __webpack_require__(1728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__cloudy_with_heavy_snow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cloudy_with_light_rain__ = __webpack_require__(1729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__cloudy_with_light_rain__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cloudy_with_light_rain_night__ = __webpack_require__(1730);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__cloudy_with_light_rain_night__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cloudy_with_sleet__ = __webpack_require__(1731);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__cloudy_with_sleet__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fog_mist__ = __webpack_require__(1732);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__fog_mist__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__heavy_rain_showers__ = __webpack_require__(1733);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__heavy_rain_showers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__heavy_snow_showers__ = __webpack_require__(1734);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__heavy_snow_showers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__heavy_snow_showers_night__ = __webpack_require__(1735);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__heavy_snow_showers_night__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__light_rain_showers__ = __webpack_require__(1736);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__light_rain_showers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__light_snow__ = __webpack_require__(1737);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__light_snow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__light_snow_night__ = __webpack_require__(1738);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__light_snow_night__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__light_snow_showers__ = __webpack_require__(1739);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__light_snow_showers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__sleet_showers__ = __webpack_require__(1740);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__sleet_showers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sleet_showers_night__ = __webpack_require__(1741);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__sleet_showers_night__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sunny__ = __webpack_require__(1742);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__sunny__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__sunny_intervals__ = __webpack_require__(1743);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__sunny_intervals__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__sunset_sunrise__ = __webpack_require__(1744);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_20__sunset_sunrise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__thunder_showers__ = __webpack_require__(1745);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_21__thunder_showers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__thunder_showers_night__ = __webpack_require__(1746);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_22__thunder_showers_night__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__thunderstorms__ = __webpack_require__(1747);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_23__thunderstorms__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__white_cloud__ = __webpack_require__(1748);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_24__white_cloud__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__white_cloud_night__ = __webpack_require__(1749);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_25__white_cloud_night__["a"]; });


/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var BlackLowCloud=function BlackLowCloud(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.46,23.34a6.73,6.73,0,0,1-6.73,6.73H15a8.41,8.41,0,1,1,7.6-12,6.72,6.72,0,0,1,10.9,5.27Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.57H15a8.91,8.91,0,1,1,7.78-13.25,7.23,7.23,0,1,1,4,13.25ZM15,13.75a7.91,7.91,0,0,0,0,15.82H26.73a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57A7.94,7.94,0,0,0,15,13.75Z'}));};/* harmony default export */ __webpack_exports__["a"] = (BlackLowCloud);

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ClearSky=function ClearSky(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.5,13A7.6,7.6,0,1,1,13,23.5,8.68,8.68,0,0,0,23.5,13'}));};/* harmony default export */ __webpack_exports__["a"] = (ClearSky);

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CloudyWithHeavyRain=function CloudyWithHeavyRain(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H23.64v-1h3.09a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1l-.22,1a8.91,8.91,0,1,1,9.72-13,7.23,7.23,0,1,1,4,13.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l4.36-7.4a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.06,33.45a.5.5,0,0,1-.43-.75L26,25.3a.5.5,0,1,1,.86.51l-4.36,7.4A.5.5,0,0,1,22.06,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.32,36a.5.5,0,0,1-.43-.75l7.36-12.49a.5.5,0,0,1,.86.51L15.75,35.75A.5.5,0,0,1,15.32,36Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CloudyWithHeavyRain);

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CloudyWithHeavyRainNight=function CloudyWithHeavyRainNight(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H23.64v-1h3.09a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1l-.22,1a8.91,8.91,0,1,1,9.72-13,7.23,7.23,0,1,1,4,13.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l4.36-7.4a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.06,33.45a.5.5,0,0,1-.43-.75L26,25.3a.5.5,0,1,1,.86.51l-4.36,7.4A.5.5,0,0,1,22.06,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.32,36a.5.5,0,0,1-.43-.75l7.36-12.49a.5.5,0,0,1,.86.51L15.75,35.75A.5.5,0,0,1,15.32,36Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CloudyWithHeavyRainNight);

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CloudyWithHeavySnow=function CloudyWithHeavySnow(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.2,30.85a.5.5,0,0,1,0-1,6.23,6.23,0,1,0-4.3-11.09l-.49.39-.27-.57a7.91,7.91,0,1,0-8.73,11.13.5.5,0,0,1,.39.59.51.51,0,0,1-.59.39,8.91,8.91,0,1,1,9.56-13.07,7.23,7.23,0,1,1,4.5,13.23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.5-.5V25.24a.5.5,0,0,1,1,0V35.49A.5.5,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.38,34.49a.5.5,0,0,1-.35-.85l7.25-7.25a.5.5,0,0,1,.71.71l-7.25,7.25A.5.5,0,0,1,16.38,34.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.13,30.87H15.2a.5.5,0,1,1,0-1h9.94a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.63,34.49a.5.5,0,0,1-.35-.15L16,27.1a.5.5,0,0,1,.71-.71L24,33.64a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.92,24.47a.5.5,0,0,1-.5-.5V18.16a.5.5,0,0,1,1,0V24A.5.5,0,0,1,16.92,24.47Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.87,23.62a.5.5,0,0,1-.35-.85l4.11-4.11a.5.5,0,1,1,.71.71l-4.11,4.11A.5.5,0,0,1,14.87,23.62Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.83,21.56H14.19a.5.5,0,1,1,0-1h5.63a.5.5,0,1,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19,23.62a.5.5,0,0,1-.35-.15l-4.11-4.11a.5.5,0,0,1,.71-.71l4.11,4.11a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CloudyWithHeavySnow);

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CloudyWithLightRain=function CloudyWithLightRain(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H23.64v-1h3.09a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1l-.22,1a8.91,8.91,0,1,1,9.72-13,7.23,7.23,0,1,1,4,13.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.06,33.45a.5.5,0,0,1-.43-.75l2.68-4.55a.5.5,0,0,1,.86.51l-2.68,4.55A.5.5,0,0,1,22.06,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.61,27.42a.5.5,0,0,1-.43-.75L26,25.3a.5.5,0,1,1,.86.51L26,27.18A.5.5,0,0,1,25.61,27.42Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l2.68-4.55a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.13,27.42a.5.5,0,0,1-.43-.75l.81-1.37a.5.5,0,0,1,.86.51l-.81,1.37A.5.5,0,0,1,15.13,27.42Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.32,36a.5.5,0,0,1-.43-.75L16.22,33a.5.5,0,0,1,.86.51l-1.33,2.26A.5.5,0,0,1,15.32,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.46,32.37a.5.5,0,0,1-.43-.75l5.23-8.87a.5.5,0,0,1,.86.51l-5.23,8.87A.5.5,0,0,1,17.46,32.37Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CloudyWithLightRain);

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CloudyWithLightRainNight=function CloudyWithLightRainNight(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H23.64v-1h3.09a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1l-.22,1a8.91,8.91,0,1,1,9.72-13,7.23,7.23,0,1,1,4,13.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.06,33.45a.5.5,0,0,1-.43-.75l2.68-4.55a.5.5,0,0,1,.86.51l-2.68,4.55A.5.5,0,0,1,22.06,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.61,27.42a.5.5,0,0,1-.43-.75L26,25.3a.5.5,0,1,1,.86.51L26,27.18A.5.5,0,0,1,25.61,27.42Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l2.68-4.55a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.13,27.42a.5.5,0,0,1-.43-.75l.81-1.37a.5.5,0,0,1,.86.51l-.81,1.37A.5.5,0,0,1,15.13,27.42Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.32,36a.5.5,0,0,1-.43-.75L16.22,33a.5.5,0,1,1,.86.51l-1.33,2.26A.5.5,0,0,1,15.32,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.46,32.37a.5.5,0,0,1-.43-.75l5.23-8.87a.5.5,0,0,1,.86.51l-5.23,8.87A.5.5,0,0,1,17.46,32.37Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CloudyWithLightRainNight);

/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CloudyWithSleet=function CloudyWithSleet(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13.12,30.67H13a8.91,8.91,0,1,1,9.72-13A7.23,7.23,0,0,1,33,27.19a.5.5,0,0,1-.87-.49,6.23,6.23,0,0,0-9.29-7.94l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1.5.5,0,0,1-.11,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l2.68-4.55a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.13,27.42a.5.5,0,0,1-.43-.75l.81-1.37a.5.5,0,0,1,.86.51l-.81,1.37A.5.5,0,0,1,15.13,27.42Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.32,36a.5.5,0,0,1-.43-.75L16.22,33a.5.5,0,0,1,.86.51l-1.33,2.26A.5.5,0,0,1,15.32,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.46,32.37a.5.5,0,0,1-.43-.75l5.23-8.87a.5.5,0,0,1,.86.51l-5.23,8.87A.5.5,0,0,1,17.46,32.37Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.82,36a.5.5,0,0,1-.5-.5V25.24a.5.5,0,0,1,1,0V35.49A.5.5,0,0,1,26.82,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.2,34.49a.5.5,0,0,1-.35-.85l7.25-7.25a.5.5,0,1,1,.71.71l-7.25,7.25A.5.5,0,0,1,23.2,34.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.95,30.87H22a.5.5,0,1,1,0-1h9.94a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.45,34.49a.5.5,0,0,1-.35-.15L22.84,27.1a.5.5,0,0,1,.71-.71l7.25,7.25a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (CloudyWithSleet);

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var FogMist=function FogMist(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87a.5.5,0,1,1,0-1,6.23,6.23,0,1,0-6.11-7.41.5.5,0,0,1-1-.19,7.23,7.23,0,1,1,7.1,8.59Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,28.87a.5.5,0,1,1,0-1,4.23,4.23,0,1,0-4.07-5.37.5.5,0,1,1-1-.27,5.23,5.23,0,1,1,5,6.63Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,26.87a.5.5,0,1,1,0-1,2.23,2.23,0,1,0-2-3.27.5.5,0,1,1-.88-.47,3.23,3.23,0,1,1,2.85,4.73Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,24.87a.5.5,0,1,1,0-1,.23.23,0,0,0,.22-.23c0-.25-.45-.25-.45,0a.5.5,0,0,1-1,0,1.22,1.22,0,1,1,1.22,1.23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.19,30.87H12.09a.5.5,0,0,1,0-1H27.19a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.88,28.87H9.52a.5.5,0,0,1,0-1H26.88a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27,26.87H7.8a.5.5,0,0,1,0-1H27a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.88,24.87H6.9a.5.5,0,0,1,0-1h20a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.13,22.87H6.56a.5.5,0,0,1,0-1H20.13a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.86,20.87H6.7a.5.5,0,0,1,0-1H20.86a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.57,18.87H7.36a.5.5,0,0,1,0-1H22.57a.5.5,0,1,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M21.23,16.87H8.68a.5.5,0,0,1,0-1H21.23a.5.5,0,1,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M18.57,14.87H11.35a.5.5,0,0,1,0-1h7.22a.5.5,0,0,1,0,1Z'}));};/* harmony default export */ __webpack_exports__["a"] = (FogMist);

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HeavyRainShowers=function HeavyRainShowers(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.51,7.5A.5.5,0,0,1,23,7V4.5a.5.5,0,0,1,1,0V7A.5.5,0,0,1,23.51,7.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,16.65H33a.5.5,0,0,1,0-1h2.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.06,10.2a.5.5,0,0,1-.35-.15L14.94,8.28a.5.5,0,0,1,.71-.71l1.77,1.77a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30,10.2a.5.5,0,0,1-.35-.85l1.77-1.77a.5.5,0,1,1,.71.71l-1.77,1.77A.5.5,0,0,1,30,10.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H23.64v-1h3.09a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1l-.22,1a8.91,8.91,0,1,1,9.72-13,7.23,7.23,0,1,1,4,13.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l4.36-7.4a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.06,33.45a.5.5,0,0,1-.43-.75L26,25.3a.5.5,0,1,1,.86.51l-4.36,7.4A.5.5,0,0,1,22.06,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.32,36a.5.5,0,0,1-.43-.75l7.36-12.49a.5.5,0,0,1,.86.51L15.75,35.75A.5.5,0,0,1,15.32,36Z'}));};/* harmony default export */ __webpack_exports__["a"] = (HeavyRainShowers);

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HeavySnowShowers=function HeavySnowShowers(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.51,7.5A.5.5,0,0,1,23,7V4.5a.5.5,0,0,1,1,0V7A.5.5,0,0,1,23.51,7.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,16.65H33a.5.5,0,0,1,0-1h2.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.06,10.2a.5.5,0,0,1-.35-.15L14.94,8.28a.5.5,0,0,1,.71-.71l1.77,1.77a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30,10.2a.5.5,0,0,1-.35-.85l1.77-1.77a.5.5,0,1,1,.71.71l-1.77,1.77A.5.5,0,0,1,30,10.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.2,30.85a.5.5,0,0,1,0-1,6.23,6.23,0,1,0-4.3-11.09l-.49.39-.27-.57a7.91,7.91,0,1,0-8.73,11.13.5.5,0,0,1-.2,1,8.91,8.91,0,1,1,9.56-13.07,7.23,7.23,0,1,1,4.5,13.23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.5-.5V25.24a.5.5,0,0,1,1,0V35.49A.5.5,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.38,34.49a.5.5,0,0,1-.35-.85l7.25-7.25a.5.5,0,0,1,.71.71l-7.25,7.25A.5.5,0,0,1,16.38,34.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.13,30.87H15.2a.5.5,0,0,1,0-1h9.94a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.63,34.49a.5.5,0,0,1-.35-.15L16,27.1a.5.5,0,0,1,.71-.71L24,33.64a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.92,24.47a.5.5,0,0,1-.5-.5V18.16a.5.5,0,0,1,1,0V24A.5.5,0,0,1,16.92,24.47Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.87,23.62a.5.5,0,0,1-.35-.85l4.11-4.11a.5.5,0,0,1,.71.71l-4.11,4.11A.5.5,0,0,1,14.87,23.62Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.83,21.56H14.19a.5.5,0,1,1,0-1h5.63a.5.5,0,1,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19,23.62a.5.5,0,0,1-.35-.15l-4.11-4.11a.5.5,0,0,1,.71-.71l4.11,4.11a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (HeavySnowShowers);

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HeavySnowShowersNight=function HeavySnowShowersNight(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.2,30.85a.5.5,0,0,1,0-1,6.23,6.23,0,1,0-4.3-11.09l-.49.39-.27-.57a7.91,7.91,0,1,0-8.73,11.13.5.5,0,0,1-.2,1,8.91,8.91,0,1,1,9.56-13.07,7.23,7.23,0,1,1,4.5,13.23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.5-.5V25.24a.5.5,0,0,1,1,0V35.49A.5.5,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.38,34.49a.5.5,0,0,1-.35-.85l7.25-7.25a.5.5,0,0,1,.71.71l-7.25,7.25A.5.5,0,0,1,16.38,34.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.13,30.87H15.2a.5.5,0,0,1,0-1h9.94a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.63,34.49a.5.5,0,0,1-.35-.15L16,27.1a.5.5,0,0,1,.71-.71L24,33.64a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.92,24.47a.5.5,0,0,1-.5-.5V18.16a.5.5,0,0,1,1,0V24A.5.5,0,0,1,16.92,24.47Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M14.87,23.62a.5.5,0,0,1-.35-.85l4.11-4.11a.5.5,0,0,1,.71.71l-4.11,4.11A.5.5,0,0,1,14.87,23.62Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19.83,21.56H14.19a.5.5,0,1,1,0-1h5.63a.5.5,0,1,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M19,23.62a.5.5,0,0,1-.35-.15l-4.11-4.11a.5.5,0,0,1,.71-.71l4.11,4.11a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (HeavySnowShowersNight);

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LightRainShowers=function LightRainShowers(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.6,32.24h0a.86.86,0,0,0,.75-.43h0A.87.87,0,0,0,23,30.62h0a.87.87,0,0,0-1.19.31h0a.87.87,0,0,0,.32,1.19A.88.88,0,0,0,22.6,32.24Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M24.34,29.23h0a.86.86,0,0,0,.75-.43h0a.86.86,0,0,0-.31-1.18h0a.87.87,0,0,0-1.19.31h0a.87.87,0,0,0,.76,1.3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.08,26.22h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.87.87,0,0,0-1.19.32h0a.86.86,0,0,0,.32,1.18A.8.8,0,0,0,26.08,26.22Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.22,36h0a.89.89,0,0,0,.76-.43h0a.88.88,0,0,0-.32-1.19h0a.87.87,0,0,0-1.19.32h0a.87.87,0,0,0,.32,1.18A.88.88,0,0,0,15.22,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17,33h0a.88.88,0,0,0,.76-.43h0a.87.87,0,0,0-.32-1.18h0a.87.87,0,0,0-1.19.31h0A.87.87,0,0,0,17,33Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M18.7,30h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.88.88,0,0,0-1.19.32h0a.86.86,0,0,0,.32,1.18A.89.89,0,0,0,18.7,30Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20.43,27h0a.85.85,0,0,0,.75-.43h0a.86.86,0,0,0-.31-1.18h0a.87.87,0,0,0-1.19.31h0a.87.87,0,0,0,.76,1.3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.17,24h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.88.88,0,0,0-1.19.32h0a.87.87,0,0,0,.76,1.3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.19,32.24h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.87.87,0,0,0-1.19.32h0a.87.87,0,0,0,.32,1.18A.88.88,0,0,0,12.19,32.24Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13.92,29.23h0a.86.86,0,0,0,.75-.43h0a.86.86,0,0,0-.31-1.18h0a.87.87,0,0,0-1.19.31h0a.87.87,0,0,0,.76,1.3Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.66,26.22h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.88.88,0,0,0-1.19.32h0a.86.86,0,0,0,.32,1.18A.89.89,0,0,0,15.66,26.22Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.51,7.5A.5.5,0,0,1,23,7V4.5a.5.5,0,0,1,1,0V7A.5.5,0,0,1,23.51,7.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,16.65H33a.5.5,0,0,1,0-1h2.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.06,10.2a.5.5,0,0,1-.35-.15L14.94,8.28a.5.5,0,0,1,.71-.71l1.77,1.77a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30,10.2a.5.5,0,0,1-.35-.85l1.77-1.77a.5.5,0,1,1,.71.71l-1.77,1.77A.5.5,0,0,1,30,10.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87h-.85a.5.5,0,0,1,0-1h.85a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-11.85,9.74.5.5,0,1,1-.59.8A8.91,8.91,0,1,1,22.73,17.62a7.23,7.23,0,1,1,4,13.25Z'}));};/* harmony default export */ __webpack_exports__["a"] = (LightRainShowers);

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LightSnow=function LightSnow(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.2,30.85a.5.5,0,0,1,0-1,6.23,6.23,0,1,0-4.3-11.09l-.49.39-.27-.57a7.91,7.91,0,1,0-8.73,11.13.5.5,0,0,1,.39.59.51.51,0,0,1-.59.39,8.91,8.91,0,1,1,9.56-13.07,7.23,7.23,0,1,1,4.5,13.23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.5-.5V25.24a.5.5,0,0,1,1,0V35.49A.5.5,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.38,34.49a.5.5,0,0,1-.35-.85l7.25-7.25a.5.5,0,0,1,.71.71l-7.25,7.25A.5.5,0,0,1,16.38,34.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.13,30.87H15.2a.5.5,0,1,1,0-1h9.94a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.63,34.49a.5.5,0,0,1-.35-.15L16,27.1a.5.5,0,0,1,.71-.71L24,33.64a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (LightSnow);

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LightSnowNight=function LightSnowNight(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.2,30.85a.5.5,0,0,1,0-1,6.23,6.23,0,1,0-4.3-11.09l-.49.39-.27-.57a7.91,7.91,0,1,0-8.73,11.13.5.5,0,0,1-.2,1,8.91,8.91,0,1,1,9.56-13.07,7.23,7.23,0,1,1,4.5,13.23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.5-.5V25.24a.5.5,0,0,1,1,0V35.49A.5.5,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.38,34.49a.5.5,0,0,1-.35-.85l7.25-7.25a.5.5,0,0,1,.71.71l-7.25,7.25A.5.5,0,0,1,16.38,34.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.13,30.87H15.2a.5.5,0,0,1,0-1h9.94a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.63,34.49a.5.5,0,0,1-.35-.15L16,27.1a.5.5,0,0,1,.71-.71L24,33.64a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (LightSnowNight);

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var LightSnowShowers=function LightSnowShowers(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.51,7.5A.5.5,0,0,1,23,7V4.5a.5.5,0,0,1,1,0V7A.5.5,0,0,1,23.51,7.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,16.65H33a.5.5,0,0,1,0-1h2.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.06,10.2a.5.5,0,0,1-.35-.15L14.94,8.28a.5.5,0,0,1,.71-.71l1.77,1.77a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30,10.2a.5.5,0,0,1-.35-.85l1.77-1.77a.5.5,0,1,1,.71.71l-1.77,1.77A.5.5,0,0,1,30,10.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.2,30.85a.5.5,0,0,1,0-1,6.23,6.23,0,1,0-4.3-11.09l-.49.39-.27-.57a7.91,7.91,0,1,0-8.73,11.13.5.5,0,0,1-.2,1,8.91,8.91,0,1,1,9.56-13.07,7.23,7.23,0,1,1,4.5,13.23Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,36a.5.5,0,0,1-.5-.5V25.24a.5.5,0,0,1,1,0V35.49A.5.5,0,0,1,20,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M16.38,34.49a.5.5,0,0,1-.35-.85l7.25-7.25a.5.5,0,0,1,.71.71l-7.25,7.25A.5.5,0,0,1,16.38,34.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M25.13,30.87H15.2a.5.5,0,0,1,0-1h9.94a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.63,34.49a.5.5,0,0,1-.35-.15L16,27.1a.5.5,0,0,1,.71-.71L24,33.64a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (LightSnowShowers);

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SleetShowers=function SleetShowers(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.51,7.5A.5.5,0,0,1,23,7V4.5a.5.5,0,0,1,1,0V7A.5.5,0,0,1,23.51,7.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,16.65H33a.5.5,0,0,1,0-1h2.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.06,10.2a.5.5,0,0,1-.35-.15L14.94,8.28a.5.5,0,0,1,.71-.71l1.77,1.77a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30,10.2a.5.5,0,0,1-.35-.85l1.77-1.77a.5.5,0,1,1,.71.71l-1.77,1.77A.5.5,0,0,1,30,10.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13.12,30.67H13a8.91,8.91,0,1,1,9.72-13A7.23,7.23,0,0,1,33,27.19a.5.5,0,0,1-.87-.49,6.23,6.23,0,0,0-9.29-7.95l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1.5.5,0,0,1-.11,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l2.68-4.55a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.13,27.42a.5.5,0,0,1-.43-.75l.81-1.37a.5.5,0,0,1,.86.51l-.81,1.37A.5.5,0,0,1,15.13,27.42Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.32,36a.5.5,0,0,1-.43-.75L16.22,33a.5.5,0,1,1,.86.51l-1.33,2.26A.5.5,0,0,1,15.32,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.46,32.37a.5.5,0,0,1-.43-.75l5.23-8.87a.5.5,0,0,1,.86.51l-5.23,8.87A.5.5,0,0,1,17.46,32.37Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.82,36a.5.5,0,0,1-.5-.5V25.24a.5.5,0,0,1,1,0V35.49A.5.5,0,0,1,26.82,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.2,34.49a.5.5,0,0,1-.35-.85l7.25-7.25a.5.5,0,0,1,.71.71l-7.25,7.25A.5.5,0,0,1,23.2,34.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.95,30.87H22a.5.5,0,0,1,0-1h9.94a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.45,34.49a.5.5,0,0,1-.35-.15L22.84,27.1a.5.5,0,0,1,.71-.71l7.25,7.25a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SleetShowers);

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SleetShowersNight=function SleetShowersNight(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13.12,30.67H13a8.91,8.91,0,1,1,9.72-13A7.23,7.23,0,0,1,33,27.19a.5.5,0,0,1-.87-.49,6.23,6.23,0,0,0-9.29-7.95l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1.5.5,0,0,1-.11,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l2.68-4.55a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.13,27.42a.5.5,0,0,1-.43-.75l.81-1.37a.5.5,0,0,1,.86.51l-.81,1.37A.5.5,0,0,1,15.13,27.42Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M15.32,36a.5.5,0,0,1-.43-.75L16.22,33a.5.5,0,1,1,.86.51l-1.33,2.26A.5.5,0,0,1,15.32,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.46,32.37a.5.5,0,0,1-.43-.75l5.23-8.87a.5.5,0,0,1,.86.51l-5.23,8.87A.5.5,0,0,1,17.46,32.37Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.82,36a.5.5,0,0,1-.5-.5V25.24a.5.5,0,0,1,1,0V35.49A.5.5,0,0,1,26.82,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.2,34.49a.5.5,0,0,1-.35-.85l7.25-7.25a.5.5,0,0,1,.71.71l-7.25,7.25A.5.5,0,0,1,23.2,34.49Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M31.95,30.87H22a.5.5,0,0,1,0-1h9.94a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.45,34.49a.5.5,0,0,1-.35-.15L22.84,27.1a.5.5,0,0,1,.71-.71l7.25,7.25a.5.5,0,0,1-.35.85Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SleetShowersNight);

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Sunny=function Sunny(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,27.5A7.5,7.5,0,1,1,27.5,20,7.51,7.51,0,0,1,20,27.5Zm0-14A6.5,6.5,0,1,0,26.5,20,6.51,6.51,0,0,0,20,13.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M9,20.5H6.5a.5.5,0,0,1,0-1H9a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.5,20.5H31a.5.5,0,0,1,0-1H33.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M29.55,30a.5.5,0,0,1-.35-.15l-1.8-1.8a.5.5,0,0,1,.71-.71l1.8,1.8a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.25,12.75a.5.5,0,0,1-.35-.15l-1.8-1.8a.5.5,0,0,1,.71-.71l1.8,1.8a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,9.54a.5.5,0,0,1-.5-.5V6.5a.5.5,0,0,1,1,0V9A.5.5,0,0,1,20,9.54Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,34a.5.5,0,0,1-.5-.5V31a.5.5,0,0,1,1,0V33.5A.5.5,0,0,1,20,34Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M10.45,30a.5.5,0,0,1-.35-.85l1.8-1.8a.5.5,0,0,1,.71.71l-1.8,1.8A.5.5,0,0,1,10.45,30Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.75,12.75a.5.5,0,0,1-.35-.85l1.8-1.8a.5.5,0,0,1,.71.71l-1.8,1.8A.5.5,0,0,1,27.75,12.75Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Sunny);

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SunnyIntervals=function SunnyIntervals(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H15a8.91,8.91,0,1,1,7.78-13.25,7.23,7.23,0,1,1,4,13.25ZM15,14a7.91,7.91,0,1,0,0,15.82H26.73a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57A7.94,7.94,0,0,0,15,14Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.55,6.55,0,0,0,0-.74,6.45,6.45,0,0,0-12.12-3.05l-.88-.47a7.45,7.45,0,0,1,14,4.38Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.51,7.5A.5.5,0,0,1,23,7V4.5a.5.5,0,1,1,1,0V7A.5.5,0,0,1,23.51,7.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,16.65H33a.5.5,0,0,1,0-1h2.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.06,10.2a.5.5,0,0,1-.35-.15L14.94,8.28a.5.5,0,0,1,.71-.71l1.77,1.77a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30,10.2a.5.5,0,0,1-.35-.85l1.77-1.77a.5.5,0,1,1,.71.71l-1.77,1.77A.5.5,0,0,1,30,10.2Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SunnyIntervals);

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SunsetSunrise=function SunsetSunrise(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M13,20.5a.5.5,0,0,1-.5-.5A7.51,7.51,0,0,1,20,12.5a.5.5,0,0,1,0,1A6.51,6.51,0,0,0,13.5,20,.5.5,0,0,1,13,20.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27,20.5a.5.5,0,0,1-.5-.5A6.51,6.51,0,0,0,20,13.5a.5.5,0,0,1,0-1A7.51,7.51,0,0,1,27.5,20,.5.5,0,0,1,27,20.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M9,20.5H6.5a.5.5,0,0,1,0-1H9a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M33.5,20.5H31a.5.5,0,0,1,0-1H33.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M12.25,12.75a.5.5,0,0,1-.35-.15l-1.8-1.8a.5.5,0,0,1,.71-.71l1.8,1.8a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M20,9.54a.5.5,0,0,1-.5-.5V6.5a.5.5,0,0,1,1,0V9A.5.5,0,0,1,20,9.54Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M27.75,12.75a.5.5,0,0,1-.35-.85l1.8-1.8a.5.5,0,0,1,.71.71l-1.8,1.8A.5.5,0,0,1,27.75,12.75Z'}));};/* harmony default export */ __webpack_exports__["a"] = (SunsetSunrise);

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ThunderShowers=function ThunderShowers(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H23.64v-1h3.09a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1l-.22,1a8.91,8.91,0,1,1,9.72-13,7.23,7.23,0,1,1,4,13.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l4.36-7.4a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.06,33.45a.5.5,0,0,1-.43-.75L26,25.3a.5.5,0,1,1,.86.51l-4.36,7.4A.5.5,0,0,1,22.06,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.27,36a.5.5,0,0,1-.43-.75l2.57-4.36H16.78a.5.5,0,0,1-.43-.75l2.79-4.81a.5.5,0,0,1,.87.5l-2.35,4.06h2.64a.5.5,0,0,1,.43.75l-3,5.12A.5.5,0,0,1,17.27,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M23.51,7.5A.5.5,0,0,1,23,7V4.5a.5.5,0,0,1,1,0V7A.5.5,0,0,1,23.51,7.5Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M35.5,16.65H33a.5.5,0,0,1,0-1h2.5a.5.5,0,0,1,0,1Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.06,10.2a.5.5,0,0,1-.35-.15L14.94,8.28a.5.5,0,0,1,.71-.71l1.77,1.77a.5.5,0,0,1-.35.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30,10.2a.5.5,0,0,1-.35-.85l1.77-1.77a.5.5,0,1,1,.71.71l-1.77,1.77A.5.5,0,0,1,30,10.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ThunderShowers);

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ThunderShowersNight=function ThunderShowersNight(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H23.64v-1h3.09a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1l-.22,1a8.91,8.91,0,1,1,9.72-13,7.23,7.23,0,1,1,4,13.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l4.36-7.4a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.06,33.45a.5.5,0,0,1-.43-.75L26,25.3a.5.5,0,1,1,.86.51l-4.36,7.4A.5.5,0,0,1,22.06,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.27,36a.5.5,0,0,1-.43-.75l2.57-4.36H16.78a.5.5,0,0,1-.43-.75l2.79-4.81a.5.5,0,0,1,.87.5l-2.35,4.06h2.64a.5.5,0,0,1,.43.75l-3,5.12A.5.5,0,0,1,17.27,36Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z'}));};/* harmony default export */ __webpack_exports__["a"] = (ThunderShowersNight);

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var Thunderstorms=function Thunderstorms(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H23.64v-1h3.09a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-8.87,11.1l-.22,1a8.91,8.91,0,1,1,9.72-13,7.23,7.23,0,1,1,4,13.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M11.58,33.45a.5.5,0,0,1-.43-.75l4.36-7.4a.5.5,0,0,1,.86.51L12,33.21A.5.5,0,0,1,11.58,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M22.06,33.45a.5.5,0,0,1-.43-.75L26,25.3a.5.5,0,1,1,.86.51l-4.36,7.4A.5.5,0,0,1,22.06,33.45Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M17.27,36a.5.5,0,0,1-.43-.75l2.57-4.36H16.78a.5.5,0,0,1-.43-.75l2.79-4.81a.5.5,0,1,1,.87.5l-2.35,4.06h2.64a.5.5,0,0,1,.43.75l-3,5.12A.5.5,0,0,1,17.27,36Z'}));};/* harmony default export */ __webpack_exports__["a"] = (Thunderstorms);

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var WhiteCloud=function WhiteCloud(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(G,gProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Path,{d:'M26.73,30.87H15a8.91,8.91,0,1,1,7.78-13.25,7.23,7.23,0,1,1,4,13.25ZM15,14a7.91,7.91,0,1,0,0,15.82H26.73a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57A7.94,7.94,0,0,0,15,14Z'}));};/* harmony default export */ __webpack_exports__["a"] = (WhiteCloud);

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var WhiteCloudNight=function WhiteCloudNight(_ref){var fill=_ref.fill,_ref$svgComponents=_ref.svgComponents,G=_ref$svgComponents.G,Path=_ref$svgComponents.Path;var gProps=fill?{fill:fill}:{};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](G,gProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H15a8.91,8.91,0,1,1,7.78-13.25,7.23,7.23,0,1,1,4,13.25ZM15,14a7.91,7.91,0,1,0,0,15.82H26.73a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57A7.94,7.94,0,0,0,15,14Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M26.73,30.87H15a8.91,8.91,0,1,1,7.78-13.25,7.23,7.23,0,1,1,4,13.25ZM15,14a7.91,7.91,0,1,0,0,15.82H26.73a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57A7.94,7.94,0,0,0,15,14Z'}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{d:'M30.87,18l-1-.12a6.55,6.55,0,0,0,0-.74,6.45,6.45,0,0,0-12.12-3.05l-.88-.47a7.45,7.45,0,0,1,14,4.38Z'}));};/* harmony default export */ __webpack_exports__["a"] = (WhiteCloudNight);

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export requestAlertSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(423);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(requestAlertSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchRequestAlert);function requestAlertSaga(_ref){var _ref$payload=_ref.payload,id=_ref$payload.id,isPersistent=_ref$payload.isPersistent,expiryMs=_ref$payload.expiryMs;var expiryTimeConfig,expiryTime,alert;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function requestAlertSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!isPersistent){_context.next=2;break;}return _context.abrupt('return');case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5__config_selectors__["a" /* getConfig */],'alerts:expiry');case 4:expiryTimeConfig=_context.sent;expiryTime=expiryMs||expiryTimeConfig;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],expiryTime);case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_4__selectors__["a" /* getAlertById */],id);case 10:alert=_context.sent;if(!alert){_context.next=14;break;}_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* dismissAlert */])(id));case 14:case'end':return _context.stop();}}},_marked,this);}function watchRequestAlert(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchRequestAlert$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_7__constants__["c" /* REQUEST_ALERT */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_saga__["a" /* default */])(requestAlertSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchRequestAlert]);

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export attemptLogIn */
/* unused harmony export setupCookies */
/* unused harmony export setupHub */
/* unused harmony export setupMoment */
/* unused harmony export setupUserActions */
/* unused harmony export setupUserHomes */
/* unused harmony export setupUserDevices */
/* unused harmony export setupEntitlements */
/* unused harmony export setupAppSettings */
/* unused harmony export setupDashboardConfiguration */
/* unused harmony export confirmLoginCompleteSaga */
/* unused harmony export getWeatherSaga */
/* unused harmony export logOut */
/* unused harmony export hideModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_get__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dashboard_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_app_settings__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__drivers_cookie__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hub_actions__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_settings_selectors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_settings_actions__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__entitlements_actions__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__holiday_mode_sagas__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__weather_actions__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__gtm__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_browser__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__config_constants__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__app_settings_constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__cookies_actions__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__intl__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__actions_actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__homes_actions__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__devices_actions__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__products_actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__constants_app_settings__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__products_utils__ = __webpack_require__(258);
// @noflow
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attemptLogIn),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchAttemptLogIn),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupCookies),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupHub),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupMoment),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupUserActions),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupUserHomes),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupUserDevices),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupEntitlements),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupAppSettings),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupDashboardConfiguration),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(confirmLoginCompleteSaga),_marked13=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getWeatherSaga),_marked14=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setUpApp),_marked15=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchLogIn),_marked16=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(logOut),_marked17=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchLogOut),_marked18=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupGTM),_marked19=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupHiveOffers),_marked20=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setupGtmTag),_marked21=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGtmConfig),_marked22=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(hideModal),_marked23=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchHideModal);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var errorCodeMap=function errorCodeMap(code){var _ref;return _ref={},_defineProperty(_ref,true,__WEBPACK_IMPORTED_MODULE_30__intl__["a" /* default */].loginUnexpectedError),_defineProperty(_ref,code===__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* application */].loginStatuses.ACCOUNT_LOCKED,__WEBPACK_IMPORTED_MODULE_30__intl__["a" /* default */].loginAccountLocked),_defineProperty(_ref,code===__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* application */].loginStatuses.NOT_AUTHORIZED,__WEBPACK_IMPORTED_MODULE_30__intl__["a" /* default */].loginNotAuthorized),_ref;};var isHiveLinkPrimary=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(function(t){return t==='assistedLivingHomes';},__WEBPACK_IMPORTED_MODULE_3_lodash_fp_get___default()('type'),__WEBPACK_IMPORTED_MODULE_1_lodash_fp_find___default()(function(h){return h.primary;}),__WEBPACK_IMPORTED_MODULE_3_lodash_fp_get___default()('homes'));function attemptLogIn(_ref2){var _ref2$payload=_ref2.payload,username=_ref2$payload.username,password=_ref2$payload.password,_ref2$payload$prevent=_ref2$payload.preventHiveLinkLogin,preventHiveLinkLogin=_ref2$payload$prevent===undefined?true:_ref2$payload$prevent,nextPathname=_ref2$payload.nextPathname;var _ref3,_ref4,responseJson,error,deviceGroupsEnabled,alert;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attemptLogIn$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_23__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__api__["c" /* auth */].login),username,password,true);case 2:_ref3=_context.sent;_ref4=_slicedToArray(_ref3,2);responseJson=_ref4[0];error=_ref4[1];if(!(!error&&preventHiveLinkLogin&&responseJson.homes&&isHiveLinkPrimary(responseJson.homes))){_context.next=12;break;}_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* logInComplete */])(new Error('Login Failed')));case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_30__intl__["a" /* default */].hiveLinkUnsupported,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* alerts */].types.ERROR,true));case 11:return _context.abrupt('return',_context.sent);case 12:if(error){_context.next=19;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_18__config_selectors__["a" /* getConfig */],'features:deviceGroups');case 15:deviceGroupsEnabled=_context.sent;_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* logIn */])(Object.assign({},responseJson,{deviceGroupsEnabled:deviceGroupsEnabled,nextPathname:nextPathname,manualLogin:true})));case 18:return _context.abrupt('return',_context.sent);case 19:_context.next=21;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* logInComplete */])(new Error('Login Failed')));case 21:alert=void 0;if(!(Object(__WEBPACK_IMPORTED_MODULE_26__utils_browser__["a" /* isMicrosoftEdge */])()&&error instanceof DOMException)){_context.next=26;break;}// M$ Edge Don't handle a 401 response on a CORS resource
// the same way as other browsers - so this detects
// a weird response and treats it like a login failure
alert=__WEBPACK_IMPORTED_MODULE_30__intl__["a" /* default */].loginNotAuthorized;_context.next=31;break;case 26:if(!(error.code!==401)){_context.next=30;break;}_context.next=29;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_30__intl__["a" /* default */].loginUnexpectedError,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* alerts */].types.ERROR,true));case 29:return _context.abrupt('return',_context.sent);case 30:alert=errorCodeMap(error.status)[true];case 31:_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__alerts_actions__["c" /* requestAlert */])(alert,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* alerts */].types.ERROR));case 33:case'end':return _context.stop();}}},_marked,this);}function watchAttemptLogIn(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchAttemptLogIn$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* attemptLogIn */],Object(__WEBPACK_IMPORTED_MODULE_24__handle_saga__["a" /* default */])(attemptLogIn));case 2:case'end':return _context2.stop();}}},_marked2,this);}function setupCookies(_ref5){var _ref5$payload=_ref5.payload,token=_ref5$payload.token,platform=_ref5$payload.platform,nextPathname=_ref5$payload.nextPathname;var countryCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupCookies$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__user_selectors__["h" /* getUserCountry */]);case 2:countryCode=_context3.sent;_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_13__drivers_cookie__["a" /* default */].set,'user-region',countryCode);case 5:_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_13__drivers_cookie__["a" /* default */].set,'token',token);case 7:if(!platform){_context3.next=12;break;}_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_13__drivers_cookie__["a" /* default */].set,'endpoint',platform.endpoint);case 10:_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_13__drivers_cookie__["a" /* default */].set,'honeycomb',platform.honeycomb);case 12:case'end':return _context3.stop();}}},_marked3,this);}function setupHub(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupHub$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__hub_actions__["a" /* dateTimeInterval */])(__WEBPACK_IMPORTED_MODULE_31_moment_timezone___default()().valueOf()));case 2:case'end':return _context4.stop();}}},_marked4,this);}function setupMoment(_ref6){var payload=_ref6.payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupMoment$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_31_moment_timezone___default.a.locale,payload.user.locale);case 2:case'end':return _context5.stop();}}},_marked5,this);}function setupUserActions(_ref7){var actions=_ref7.payload.actions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupUserActions$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!(actions&&actions.length)){_context6.next=5;break;}_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_33__actions_actions__["m" /* receiveActions */])(actions));case 3:_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_33__actions_actions__["j" /* getTemplates */])());case 5:case'end':return _context6.stop();}}},_marked6,this);}function setupUserHomes(_ref8){var homes=_ref8.payload.homes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupUserHomes$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(!homes){_context7.next=3;break;}_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_34__homes_actions__["b" /* receiveHomes */])(homes));case 3:case'end':return _context7.stop();}}},_marked7,this);}function setupUserDevices(_ref9){var _ref9$payload=_ref9.payload,devices=_ref9$payload.devices,products=_ref9$payload.products,deviceGroupsEnabled=_ref9$payload.deviceGroupsEnabled;var hubSupportsGroups,filteredProducts;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupUserDevices$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:if(!devices.length){_context8.next=3;break;}_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_35__devices_actions__["d" /* receiveDevices */])(devices));case 3:if(!products.length){_context8.next=10;break;}_context8.next=6;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_21__devices_selectors__["G" /* getHubHasCapability */],__WEBPACK_IMPORTED_MODULE_15__constants_devices__["capabilities"].PRODUCT_GROUP);case 6:hubSupportsGroups=_context8.sent;filteredProducts=deviceGroupsEnabled&&hubSupportsGroups?products:Object(__WEBPACK_IMPORTED_MODULE_38__products_utils__["a" /* filterOutDeviceGroups */])(products);_context8.next=10;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_36__products_actions__["e" /* receiveProducts */])({products:filteredProducts,loadedAt:new Date()}));case 10:case'end':return _context8.stop();}}},_marked8,this);}function setupEntitlements(_ref10){var payload=_ref10.payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupEntitlements$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__entitlements_actions__["a" /* getEntitlements */])({userid:payload.user.id}));case 2:case'end':return _context9.stop();}}},_marked9,this);}function setupAppSettings(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupAppSettings$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_17__app_settings_actions__["a" /* getAppSettings */])());case 2:case'end':return _context10.stop();}}},_marked10,this);}function setupDashboardConfiguration(_ref11){var _ref11$payload=_ref11.payload,actions=_ref11$payload.actions,products=_ref11$payload.products;var isDashboardCustomisationDataOn;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupDashboardConfiguration$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_18__config_selectors__["a" /* getConfig */],'features:dashboardCustomisationData');case 2:isDashboardCustomisationDataOn=_context11.sent;if(!isDashboardCustomisationDataOn){_context11.next=8;break;}_context11.next=6;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__dashboard_actions__["l" /* getDashboardCustomisation */])());case 6:_context11.next=10;break;case 8:_context11.next=10;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__dashboard_actions__["m" /* receiveDashboardCustomisation */])({customisation:{pages:[]},products:products,actions:actions}));case 10:case'end':return _context11.stop();}}},_marked11,this);}function confirmLoginCompleteSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function confirmLoginCompleteSaga$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["i" /* logInComplete */])());case 2:case'end':return _context12.stop();}}},_marked12,this);}function getWeatherSaga(){var postcode,countryCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getWeatherSaga$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__user_selectors__["d" /* getPostcode */]);case 2:postcode=_context13.sent;_context13.next=5;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__user_selectors__["h" /* getUserCountry */]);case 5:countryCode=_context13.sent;if(!(postcode&&countryCode)){_context13.next=9;break;}_context13.next=9;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__weather_actions__["a" /* getWeather */])({postcode:postcode,countryCode:countryCode}));case 9:case'end':return _context13.stop();}}},_marked13,this);}function setUpApp(action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setUpApp$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_29__cookies_actions__["c" /* loadCookies */])());case 2:_context14.next=4;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["a" /* all */])([setupCookies(action),setupUserDevices(action),setupUserActions(action),setupUserHomes(action),setupAppSettings(),setupEntitlements(action),setupHub(),setupMoment(action),getWeatherSaga()]);case 4:return _context14.delegateYield(setupDashboardConfiguration(action),'t0',5);case 5:return _context14.delegateYield(confirmLoginCompleteSaga(action),'t1',6);case 6:return _context14.delegateYield(Object(__WEBPACK_IMPORTED_MODULE_20__holiday_mode_sagas__["b" /* getHolidayModeDataSaga */])(),'t2',7);case 7:case'end':return _context14.stop();}}},_marked14,this);}function watchLogIn(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchLogIn$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4__actions__["h" /* logIn */],Object(__WEBPACK_IMPORTED_MODULE_24__handle_saga__["a" /* default */])(setUpApp));case 2:case'end':return _context15.stop();}}},_marked15,this);}function logOut(){var hub;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function logOut$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__alerts_actions__["b" /* dismissAllAlerts */])());case 2:_context16.next=4;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_21__devices_selectors__["F" /* getHub */]);case 4:hub=_context16.sent;if(!(hub&&hub.state.discovery)){_context16.next=8;break;}_context16.next=8;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_23__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__api__["g" /* nodes */].patchNode),{discovery:false},__WEBPACK_IMPORTED_MODULE_15__constants_devices__["deviceTypes"].HUB,hub.id);case 8:_context16.next=10;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_13__drivers_cookie__["a" /* default */].remove,'token');case 10:_context16.next=12;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_13__drivers_cookie__["a" /* default */].remove,'endpoint');case 12:_context16.next=14;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_13__drivers_cookie__["a" /* default */].remove,'honeycomb');case 14:case'end':return _context16.stop();}}},_marked16,this);}function watchLogOut(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchLogOut$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__actions__["k" /* logOut */],Object(__WEBPACK_IMPORTED_MODULE_24__handle_saga__["a" /* default */])(logOut));case 2:case'end':return _context17.stop();}}},_marked17,this);}function setupGTM(){var gtmContainerId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupGTM$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_18__config_selectors__["a" /* getConfig */],'gtmContainerId');case 2:gtmContainerId=_context18.sent;if(!gtmContainerId){_context18.next=6;break;}_context18.next=6;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_25__gtm__["a" /* injectGTMLoader */],gtmContainerId);case 6:case'end':return _context18.stop();}}},_marked18,this);}function setupHiveOffers(){var showShopMenu,countryCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupHiveOffers$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_18__config_selectors__["a" /* getConfig */],'features:shopMenuLink');case 2:showShopMenu=_context19.sent;_context19.next=5;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__user_selectors__["h" /* getUserCountry */]);case 5:countryCode=_context19.sent;if(!showShopMenu){_context19.next=14;break;}case 7:if(global.hivehome_gtm_offers){_context19.next=12;break;}_context19.next=10;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8_redux_saga__["b" /* delay */],1000);case 10:_context19.next=7;break;case 12:_context19.next=14;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["l" /* receiveGTMOffers */])(global.hivehome_gtm_offers[countryCode]));case 14:case'end':return _context19.stop();}}},_marked19,this);}function setupGtmTag(tag){var countryCode,gtmTag,dissmissedModal,fnMap,fn;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setupGtmTag$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:if(global[tag]){_context20.next=5;break;}_context20.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8_redux_saga__["b" /* delay */],1000);case 3:_context20.next=0;break;case 5:_context20.next=7;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__user_selectors__["h" /* getUserCountry */]);case 7:countryCode=_context20.sent;gtmTag=global[tag][countryCode];_context20.next=11;return gtmTag&&Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_16__app_settings_selectors__["a" /* getAppSetting */],Object(__WEBPACK_IMPORTED_MODULE_12__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_37__constants_app_settings__["h" /* MODAL_DISMISSED */],gtmTag.id));case 11:dissmissedModal=_context20.sent;if(!(dissmissedModal||!Object(__WEBPACK_IMPORTED_MODULE_25__gtm__["b" /* isGTMActive */])(Object(__WEBPACK_IMPORTED_MODULE_32_immutable__["fromJS"])(gtmTag)))){_context20.next=14;break;}return _context20.abrupt('return');case 14:fnMap={hivehomeWelcomeMessage:__WEBPACK_IMPORTED_MODULE_4__actions__["p" /* showWelcomeMessage */]};fn=fnMap[tag];if(!fn){_context20.next=19;break;}_context20.next=19;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(fn(gtmTag));case 19:case'end':return _context20.stop();}}},_marked20,this);}function watchGtmConfig(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGtmConfig$(_context21){while(1){switch(_context21.prev=_context21.next){case 0:if(false){_context21.next=3;break;}_context21.next=3;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_27__config_constants__["e" /* LOAD_COUNTRY_CONFIG */],Object(__WEBPACK_IMPORTED_MODULE_24__handle_saga__["a" /* default */])(setupGTM)),Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_27__config_constants__["e" /* LOAD_COUNTRY_CONFIG */],Object(__WEBPACK_IMPORTED_MODULE_24__handle_saga__["a" /* default */])(setupHiveOffers)),Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_28__app_settings_constants__["e" /* RECEIVE_APP_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_24__handle_saga__["a" /* default */])(function(){return setupGtmTag('hivehomeWelcomeMessage');}))]);case 3:case'end':return _context21.stop();}}},_marked21,this);}function hideModal(_ref12){var id=_ref12.payload.id;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function hideModal$(_context22){while(1){switch(_context22.prev=_context22.next){case 0:_context22.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_17__app_settings_actions__["c" /* setAppSettings */])(_defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_12__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_37__constants_app_settings__["h" /* MODAL_DISMISSED */],id),true)));case 2:case'end':return _context22.stop();}}},_marked22,this);}function watchHideModal(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchHideModal$(_context23){while(1){switch(_context23.prev=_context23.next){case 0:_context23.next=2;return Object(__WEBPACK_IMPORTED_MODULE_7_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__actions__["g" /* hideWelcomeMessage */],Object(__WEBPACK_IMPORTED_MODULE_24__handle_saga__["a" /* default */])(hideModal));case 2:case'end':return _context23.stop();}}},_marked23,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchAttemptLogIn,watchLogIn,watchLogOut,watchGtmConfig,watchHideModal]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getHolidayMode;
/* harmony export (immutable) */ __webpack_exports__["c"] = setHolidayMode;
/* harmony export (immutable) */ __webpack_exports__["a"] = disableHolidayMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
var endpoint='holiday-mode';function getHolidayMode(){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])(endpoint);}function setHolidayMode(start,end,temperature){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])(endpoint,{start:start,end:end,temperature:temperature});}function disableHolidayMode(){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["a" /* httpDelete */])(endpoint);}

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = isMicrosoftEdge;
function isMicrosoftEdge(){var ua=global.navigator&&global.navigator.userAgent||'';var edge=ua.indexOf('Edge/');if(edge>0){return parseInt(ua.substring(edge+5,ua.indexOf('.',edge)),10);}return false;}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({loginAccountLocked:{id:'application.account-locked',defaultMessage:'Sorry, one too many login attempts have locked your account. Click on the <a href="/forgotten-password">forgotten password</a> link to unlock it and reset your password.',linkHref:'/forgotten-password',linkText:'Reset your password?'},loginNotAuthorized:{id:'application.not-authorized',defaultMessage:'Sorry, we can\'t find these login details. Please check and try again. <a href="https://www.hivehome.com/cant-find-details">Need help?</a>',linkHref:'https://www.hivehome.com/cant-find-details',linkText:'Need help?'},loginUnexpectedError:{id:'application.login-unexpected-error',defaultMessage:'There was an unexpected error logging into your account.'},hiveLinkUnsupported:{id:'application.login-hive-link-unsupported-error',defaultMessage:'Hive Link will be coming to the web soon...'}}));

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setAppSettingsSaga */
/* unused harmony export getAppSettingsSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(51);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setAppSettingsSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSetAppSettings),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAppSettingsSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetAppSettings);function setAppSettingsSaga(_ref){var settings=_ref.payload;var userId,currentSettings,outSettings;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setAppSettingsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_4__user_selectors__["i" /* getUserId */]);case 2:userId=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_3__selectors__["b" /* getAppSettings */]);case 5:currentSettings=_context.sent;outSettings=Object.assign({},currentSettings.toJS(),settings);_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api__["m" /* user */].setAttribute),userId,__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* APP_SETTINGS_ATTRIBUTE */],outSettings);case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* receiveAppSettings */])(outSettings));case 11:case'end':return _context.stop();}}},_marked,this);}function watchSetAppSettings(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSetAppSettings$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* SET_APP_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_saga__["a" /* default */])(setAppSettingsSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function getAppSettingsSaga(){var userId,_ref2,_ref3,response,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAppSettingsSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_4__user_selectors__["i" /* getUserId */]);case 2:userId=_context3.sent;_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api__["m" /* user */].getAttribute),userId,__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* APP_SETTINGS_ATTRIBUTE */]);case 5:_ref2=_context3.sent;_ref3=_slicedToArray(_ref2,2);response=_ref3[0];error=_ref3[1];_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* receiveAppSettings */])(error||response));case 11:case'end':return _context3.stop();}}},_marked3,this);}function watchGetAppSettings(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetAppSettings$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* GET_APP_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_saga__["a" /* default */])(getAppSettingsSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchSetAppSettings,watchGetAppSettings]);

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getHomesSaga */
/* unused harmony export renameHomeSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__intl__ = __webpack_require__(1757);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getHomesSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(renameHomeSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetHomes),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchRenameHome);function getHomesSaga(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getHomesSaga$(_context){while(1){switch(_context.prev=_context.next){case 0://API call here. Mocked for now
response={user:'3d2e1f61-e385-41a4-a069-863ecaaa4411',homes:[{id:'4948205f-01f4-4d06-a4bd-219ea8bdc5ca',name:'Andrew Home',address:null,location:{country:'GB',timeZone:'Europe/London',latitude:553780480,longitude:-34359728},primary:true,users:[],owner:true}],entitlements:{hiveLive:false,propertyEntitlements:1,userEntitlements:1}};_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* receiveHomes */])(response.homes));case 3:case'end':return _context.stop();}}},_marked,this);}function renameHomeSaga(_ref){var _ref$payload=_ref.payload,name=_ref$payload.name,homeId=_ref$payload.homeId,userId=_ref$payload.userId;var _ref2,_ref3,home,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function renameHomeSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__api__["f" /* homes */].renameHome),name,homeId,userId);case 2:_ref2=_context2.sent;_ref3=_slicedToArray(_ref2,2);home=_ref3[0];error=_ref3[1];if(!error){_context2.next=12;break;}_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["c" /* renameHome */])(error));case 9:_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_8__intl__["a" /* default */].nameChangeError,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* alerts */].types.ERROR));case 11:return _context2.abrupt('return');case 12:_context2.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* renamedHome */])(home));case 14:case'end':return _context2.stop();}}},_marked2,this);}function watchGetHomes(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetHomes$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* getHomes */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_saga__["a" /* default */])(getHomesSaga));case 2:case'end':return _context3.stop();}}},_marked3,this);}function watchRenameHome(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchRenameHome$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_7__actions__["c" /* renameHome */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_saga__["a" /* default */])(renameHomeSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetHomes,watchRenameHome]);

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({nameChangeError:{id:'device.name-change-error',defaultMessage:'Home name could not be changed'}}));

/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export acquireDevicesSaga */
/* unused harmony export shouldSetDiscoveryMode */
/* unused harmony export findHub */
/* unused harmony export watchLoadInstallDevices */
/* unused harmony export finishInstallDevicesSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_sortBy__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_uniqBy__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_compose__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_routes__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dashboard_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__constants__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__install_upgrade_thermostat_hive2_selectors__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__install_upgrade_thermostat_slt3_slt3b_selectors__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__products_actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__intl__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__navigate__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__products_constants__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__devices_actions__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__alerts_actions__ = __webpack_require__(30);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(handleError),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(acquireDevicesSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(shouldSetDiscoveryMode),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(findHub),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(finishInstallDevicesSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchFinishInstallDevices);var putRequestAlert=__WEBPACK_IMPORTED_MODULE_5_lodash_fp_compose___default()(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */],__WEBPACK_IMPORTED_MODULE_30__alerts_actions__["c" /* requestAlert */]);function handleError(error,attemptsBeforeTroubleshooting,attemptsBeforeWarning){var errors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleError$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* acquireDevices */])(new Error(error)));case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__selectors__["a" /* errorsSelector */]);case 4:errors=_context.sent;if(!(errors>=attemptsBeforeTroubleshooting)){_context.next=9;break;}throw error;case 9:if(!(errors>=attemptsBeforeWarning)){_context.next=12;break;}_context.next=12;return putRequestAlert(__WEBPACK_IMPORTED_MODULE_25__intl__["a" /* default */].warning,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.WARNING);case 12:case'end':return _context.stop();}}},_marked,this);}function acquireDevicesSaga(){var setDiscoveryMode,hub,attemptsBeforeWarning,attemptsBeforeTroubleshooting,hive2UpgradeRouteState,slt3Slt3bUpgradeRouteState,pollExpiry,pollInterval,startAcquireDevicesAction,startTime,finishTime,timedOut,nextInterval,pollIntervalAsSeconds,now,timeRemaining,patchNodeError,_ref,_ref2,_ref3,_ref4,devices,devicesError,_ref5,_ref6,error,acquiredDevices;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function acquireDevicesSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(shouldSetDiscoveryMode);case 2:setDiscoveryMode=_context2.sent;hub=void 0;_context2.prev=4;_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(findHub);case 7:hub=_context2.sent;_context2.next=17;break;case 10:_context2.prev=10;_context2.t0=_context2['catch'](4);_context2.next=14;return putRequestAlert(__WEBPACK_IMPORTED_MODULE_25__intl__["a" /* default */].startHubDiscoveryFail,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.ERROR);case 14:_context2.next=16;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_27__navigate__["b" /* navigate */])('/install'));case 16:return _context2.abrupt('return',_context2.sent);case 17:_context2.next=19;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_17__config_selectors__["a" /* getConfig */],'acquireDevices:attemptsBeforeWarning');case 19:attemptsBeforeWarning=_context2.sent;_context2.next=22;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_17__config_selectors__["a" /* getConfig */],'acquireDevices:attemptsBeforeTroubleshooting');case 22:attemptsBeforeTroubleshooting=_context2.sent;_context2.next=25;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_18__install_upgrade_thermostat_hive2_selectors__["b" /* getHive2UpgradeRouteState */]);case 25:hive2UpgradeRouteState=_context2.sent;_context2.next=28;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_19__install_upgrade_thermostat_slt3_slt3b_selectors__["c" /* upgradeRouteState */]);case 28:slt3Slt3bUpgradeRouteState=_context2.sent;if(!(hive2UpgradeRouteState||slt3Slt3bUpgradeRouteState)){_context2.next=35;break;}_context2.next=32;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_17__config_selectors__["a" /* getConfig */],'upgradeThermostat:pollExpiry');case 32:_context2.t1=_context2.sent;_context2.next=38;break;case 35:_context2.next=37;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_17__config_selectors__["a" /* getConfig */],'acquireDevices:pollExpiry');case 37:_context2.t1=_context2.sent;case 38:pollExpiry=_context2.t1;_context2.next=41;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_17__config_selectors__["a" /* getConfig */],'acquireDevices:pollInterval');case 41:pollInterval=_context2.sent;startAcquireDevicesAction=Object(__WEBPACK_IMPORTED_MODULE_7__actions__["f" /* startAcquireDevices */])();_context2.next=45;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(startAcquireDevicesAction);case 45:// If the user doesn't want to put the hub into discovery mode then
// we can look for all devices so that we get something back at least.
startTime=setDiscoveryMode?__WEBPACK_IMPORTED_MODULE_26_moment_timezone___default()(startAcquireDevicesAction.payload):__WEBPACK_IMPORTED_MODULE_26_moment_timezone___default()(0);finishTime=__WEBPACK_IMPORTED_MODULE_26_moment_timezone___default()(startAcquireDevicesAction.payload).add(pollExpiry,'ms');timedOut=false;nextInterval=pollInterval;pollIntervalAsSeconds=pollInterval/1000;_context2.prev=50;case 51:now=__WEBPACK_IMPORTED_MODULE_26_moment_timezone___default()();if(!now.isSameOrAfter(finishTime)){_context2.next=55;break;}timedOut=true;return _context2.abrupt('break',80);case 55:timeRemaining=finishTime.diff(now,'seconds');if(timeRemaining<pollIntervalAsSeconds){nextInterval=timeRemaining*1000;}patchNodeError=void 0;if(!setDiscoveryMode){_context2.next=66;break;}_context2.next=61;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_22__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__api__["g" /* nodes */].patchNode),{discovery:true},__WEBPACK_IMPORTED_MODULE_16__constants_devices__["deviceTypes"].HUB,hub.id);case 61:_ref=_context2.sent;_ref2=_slicedToArray(_ref,2);patchNodeError=_ref2[1];if(!patchNodeError){_context2.next=66;break;}return _context2.delegateYield(handleError(patchNodeError,attemptsBeforeTroubleshooting,attemptsBeforeWarning),'t2',66);case 66:if(patchNodeError){_context2.next=77;break;}_context2.next=69;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_22__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__api__["e" /* devices */].getDevices),startTime.toDate());case 69:_ref3=_context2.sent;_ref4=_slicedToArray(_ref3,2);devices=_ref4[0];devicesError=_ref4[1];if(!devicesError){_context2.next=75;break;}return _context2.delegateYield(handleError(devicesError,attemptsBeforeTroubleshooting,attemptsBeforeWarning),'t3',75);case 75:_context2.next=77;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* acquireDevices */])(devices));case 77:_context2.next=79;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_11_redux_saga__["b" /* delay */],nextInterval);case 79:if(_context2.sent){_context2.next=51;break;}case 80:_context2.next=91;break;case 82:_context2.prev=82;_context2.t4=_context2['catch'](50);if(!hive2UpgradeRouteState){_context2.next=89;break;}_context2.next=87;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_27__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_6__constants_routes__["installDevicesTroubleshootingClean"]+'/hive2'));case 87:_context2.next=91;break;case 89:_context2.next=91;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_27__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_6__constants_routes__["installDevicesTroubleshootingClean"]));case 91:_context2.prev=91;if(!setDiscoveryMode){_context2.next=101;break;}_context2.next=95;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_22__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__api__["g" /* nodes */].patchNode),{discovery:false},__WEBPACK_IMPORTED_MODULE_16__constants_devices__["deviceTypes"].HUB,hub.id);case 95:_ref5=_context2.sent;_ref6=_slicedToArray(_ref5,2);error=_ref6[1];if(!error){_context2.next=101;break;}_context2.next=101;return putRequestAlert(__WEBPACK_IMPORTED_MODULE_25__intl__["a" /* default */].endHubDiscoveryFail,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.WARNING);case 101:if(!timedOut){_context2.next=113;break;}_context2.next=104;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__selectors__["b" /* getAcquiredDevices */]);case 104:acquiredDevices=_context2.sent;if(!hive2UpgradeRouteState){_context2.next=110;break;}_context2.next=108;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_27__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_6__constants_routes__["installDevicesTroubleshootingClean"]+'/hive2'));case 108:_context2.next=113;break;case 110:if(acquiredDevices.length){_context2.next=113;break;}_context2.next=113;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_27__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_6__constants_routes__["installDevicesTroubleshootingClean"]));case 113:_context2.next=115;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["g" /* stopAcquireDevices */])());case 115:return _context2.finish(91);case 116:case'end':return _context2.stop();}}},_marked2,this,[[4,10],[50,82,91,116]]);}function shouldSetDiscoveryMode(){var confirmHubDiscovery;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function shouldSetDiscoveryMode$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_17__config_selectors__["a" /* getConfig */],'confirmHubDiscovery');case 2:confirmHubDiscovery=_context3.sent;if(!confirmHubDiscovery){_context3.next=9;break;}_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(global.confirm,'Are you sure you want to set the hub into discovery mode?');case 6:_context3.t0=_context3.sent;_context3.next=10;break;case 9:_context3.t0=true;case 10:return _context3.abrupt('return',_context3.t0);case 11:case'end':return _context3.stop();}}},_marked3,this);}function findHub(){var hub,_ref7,_ref8,devices,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function findHub$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__devices_selectors__["F" /* getHub */]);case 2:hub=_context4.sent;if(!hub){_context4.next=7;break;}_context4.next=6;return hub;case 6:return _context4.abrupt('return',_context4.sent);case 7:_context4.next=9;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_22__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__api__["e" /* devices */].getDevices));case 9:_ref7=_context4.sent;_ref8=_slicedToArray(_ref7,2);devices=_ref8[0];error=_ref8[1];if(!error){_context4.next=15;break;}throw error;case 15:if(!devices.length){_context4.next=19;break;}_context4.next=18;return __WEBPACK_IMPORTED_MODULE_4_lodash_fp_find___default()(function(d){return d.type===__WEBPACK_IMPORTED_MODULE_16__constants_devices__["deviceTypes"].HUB;},devices);case 18:return _context4.abrupt('return',_context4.sent);case 19:case'end':return _context4.stop();}}},_marked4,this);}var watchLoadInstallDevices=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var acquireDevicesTask,action,hub,shouldPatch;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_15__constants__["e" /* LOAD_INSTALL_DEVICES */]);case 2:if(!_context5.sent){_context5.next=20;break;}_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["d" /* fork */])(acquireDevicesSaga);case 5:acquireDevicesTask=_context5.sent;_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["h" /* take */])([__WEBPACK_IMPORTED_MODULE_15__constants__["c" /* FINISHED_INSTALL_DEVICES */],__WEBPACK_IMPORTED_MODULE_15__constants__["h" /* STOP_ACQUIRE_DEVICES */],__WEBPACK_IMPORTED_MODULE_15__constants__["i" /* UNLOAD_INSTALL_DEVICES */],__WEBPACK_IMPORTED_MODULE_24__application_actions__["k" /* logOut */].toString()]);case 8:action=_context5.sent;_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["c" /* cancel */])(acquireDevicesTask);case 11:_context5.next=13;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(findHub);case 13:hub=_context5.sent;shouldPatch=action.type!==__WEBPACK_IMPORTED_MODULE_24__application_actions__["k" /* logOut */].toString();if(!(hub&&shouldPatch)){_context5.next=18;break;}_context5.next=18;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_22__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__api__["g" /* nodes */].patchNode),{discovery:false},__WEBPACK_IMPORTED_MODULE_16__constants_devices__["deviceTypes"].HUB,hub.id);case 18:_context5.next=0;break;case 20:case'end':return _context5.stop();}}},_callee,this);});function finishInstallDevicesSaga(_ref9){var devicesWithNames=_ref9.payload;var responses,err,oldDevices,newDevices,allNewDevices,allDevices,products,newProducts,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,p,newBulbItems,deviceGroupsEnabled,hubSupportsGroups,redirectConditionMap,redirectCondition,placementAdvice;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function finishInstallDevicesSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["a" /* all */])(devicesWithNames.map(function(_ref10){var device=_ref10.device,newName=_ref10.newName;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_22__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__api__["g" /* nodes */].patchNode),{name:newName},device.type,device.id);}));case 2:responses=_context6.sent;err=__WEBPACK_IMPORTED_MODULE_4_lodash_fp_find___default()(function(_ref11){var _ref12=_slicedToArray(_ref11,2),error=_ref12[1];return error;},responses);if(!err){_context6.next=12;break;}_context6.next=7;return putRequestAlert(__WEBPACK_IMPORTED_MODULE_8__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.ERROR);case 7:_context6.next=9;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* finishedInstallDevices */])(err));case 9:_context6.next=11;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_27__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_6__constants_routes__["dashboard"]));case 11:return _context6.abrupt('return');case 12:_context6.next=14;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__devices_selectors__["n" /* getDeviceItems */]);case 14:oldDevices=_context6.sent;_context6.next=17;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__selectors__["b" /* getAcquiredDevices */]);case 17:newDevices=_context6.sent;allNewDevices=newDevices.map(function(newDevice){var _devicesWithNames$fil=devicesWithNames.filter(function(_ref13){var id=_ref13.device.id;return id===newDevice.id;}),_devicesWithNames$fil2=_slicedToArray(_devicesWithNames$fil,1),renamedDevice=_devicesWithNames$fil2[0];if(renamedDevice&&(renamedDevice.newName||'').trim()){var _renamedDevice$device=renamedDevice.device,state=_renamedDevice$device.state,renamedRest=_objectWithoutProperties(_renamedDevice$device,['state']),newName=renamedDevice.newName;return Object.assign({},renamedRest,{state:Object.assign({},state,{name:newName})});}return newDevice;});allDevices=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_sortBy___default()(function(a){return a.sortOrder;}),__WEBPACK_IMPORTED_MODULE_3_lodash_fp_uniqBy___default()(function(d){return d.id;}))([].concat(_toConsumableArray(oldDevices),_toConsumableArray(allNewDevices)));_context6.next=22;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* finishedInstallDevices */])());case 22:_context6.next=24;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_29__devices_actions__["d" /* receiveDevices */])(allDevices));case 24:_context6.next=26;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_21__products_actions__["a" /* getProducts */])());case 26:_context6.next=28;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_28__products_constants__["f" /* RECEIVE_PRODUCTS */]);case 28:_context6.next=30;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_20__products_selectors__["z" /* getProductItems */]);case 30:products=_context6.sent;newProducts=products.filter(function(p){return newDevices.some(function(d){return[p.get('id'),p.get('parent')].includes(d.id);});});_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context6.prev=35;_iterator=newProducts[Symbol.iterator]();case 37:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context6.next=44;break;}p=_step.value;_context6.next=41;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__dashboard_actions__["g" /* dashboardAddProduct */])(p.get('id')));case 41:_iteratorNormalCompletion=true;_context6.next=37;break;case 44:_context6.next=50;break;case 46:_context6.prev=46;_context6.t0=_context6['catch'](35);_didIteratorError=true;_iteratorError=_context6.t0;case 50:_context6.prev=50;_context6.prev=51;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 53:_context6.prev=53;if(!_didIteratorError){_context6.next=56;break;}throw _iteratorError;case 56:return _context6.finish(53);case 57:return _context6.finish(50);case 58:_context6.next=60;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__dashboard_actions__["o" /* saveDashboardEdit */])());case 60:newBulbItems=newDevices.filter(function(d){return __WEBPACK_IMPORTED_MODULE_16__constants_devices__["bulbTypes"].includes(d.type);});_context6.next=63;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_17__config_selectors__["a" /* getConfig */],'features:deviceGroups');case 63:deviceGroupsEnabled=_context6.sent;_context6.next=66;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__devices_selectors__["G" /* getHubHasCapability */],__WEBPACK_IMPORTED_MODULE_16__constants_devices__["capabilities"].PRODUCT_GROUP);case 66:hubSupportsGroups=_context6.sent;redirectConditionMap=new Map([[true,null],[hubSupportsGroups&&deviceGroupsEnabled&&newBulbItems.length>1,{action:__WEBPACK_IMPORTED_MODULE_10__dashboard_actions__["n" /* redirectToPostinstallGroups */]}]]);redirectCondition=redirectConditionMap.get(true);if(!redirectCondition){_context6.next=72;break;}_context6.next=72;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(redirectCondition.action(true));case 72:_context6.next=74;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__selectors__["d" /* getPlacementAdvice */]);case 74:placementAdvice=_context6.sent;if(!(placementAdvice===__WEBPACK_IMPORTED_MODULE_15__constants__["f" /* PLACEMENT_ADVICE_TYPES */].NOT_SHOWN)){_context6.next=80;break;}_context6.next=78;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_27__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_6__constants_routes__["dashboard"]));case 78:_context6.next=82;break;case 80:_context6.next=82;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_27__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_6__constants_routes__["installDevicePlacement"]));case 82:case'end':return _context6.stop();}}},_marked5,this,[[35,46,50,58],[51,,53,57]]);}function watchFinishInstallDevices(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchFinishInstallDevices$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_9_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_15__constants__["d" /* FINISH_INSTALL_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_23__handle_saga__["a" /* default */])(finishInstallDevicesSaga));case 2:case'end':return _context7.stop();}}},_marked6,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchLoadInstallDevices,watchFinishInstallDevices]);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('sortBy', __webpack_require__(1760));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(231),
    baseOrderBy = __webpack_require__(1761),
    baseRest = __webpack_require__(183),
    isIterateeCall = __webpack_require__(163);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82),
    baseIteratee = __webpack_require__(55),
    baseMap = __webpack_require__(665),
    baseSortBy = __webpack_require__(1762),
    baseUnary = __webpack_require__(228),
    compareMultiple = __webpack_require__(1763),
    identity = __webpack_require__(150);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1762 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1764);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(187);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('uniqBy', __webpack_require__(1766));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(55),
    baseUniq = __webpack_require__(442);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({endHubDiscoveryFail:{id:'install-devices.alerts.end-hub-discovery-fail',description:'Hub is a product',defaultMessage:"There was a problem turning off your Hub's discovery mode"},startHubDiscoveryFail:{id:'install-devices.alerts.start-hub-discovery-fail',defaultMessage:"There was a problem starting your Hub's discovery mode"},warning:{id:'install-devices.alerts.warning',defaultMessage:"We're having trouble getting your new devices but we'll keep trying"}}));

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_honeycomb__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(424);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getData),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetData);function getData(_ref){var mediaId=_ref.payload.mediaId;var _ref2,_ref3,_ref3$0$media,media,error,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getData$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api_honeycomb__["c" /* getSenseMedia */]),mediaId);case 2:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);_ref3$0$media=_ref3[0].media;media=_ref3$0$media===undefined?[]:_ref3$0$media;error=_ref3[1];if(!(!media.length||error)){_context.next=11;break;}_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 10:return _context.abrupt('return',_context.sent);case 11:data=media[0].downloadUrl||'';if(data){_context.next=16;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 15:return _context.abrupt('return',_context.sent);case 16:_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* audioDataReceived */]({data:data}));case 18:case'end':return _context.stop();}}},_marked,this);}function watchGetData(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetData$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_8__constants__["c" /* GET_AUDIO_DATA */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_saga__["a" /* default */])(getData));case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetData]);

/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changePasswordSaga */
/* unused harmony export sendPasswordResetEmailSaga */
/* unused harmony export passwordResetRequestSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_compose__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__intl__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_errors__ = __webpack_require__(263);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(changePasswordSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(sendPasswordResetEmailSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(passwordResetRequestSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangePasswordSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSendPasswordResetEmailSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchPasswordResetRequest);function changePasswordSaga(_ref){var payload=_ref.payload;var putAction,_ref2,_ref3,err;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function changePasswordSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:putAction=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_compose___default()(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */],__WEBPACK_IMPORTED_MODULE_6__actions__["g" /* resetPassword */]);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_8__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__api__["d" /* changePassword */]),payload.newPassword,payload.existingPassword,payload.userId);case 3:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);err=_ref3[1];if(!err){_context.next=13;break;}if(!__WEBPACK_IMPORTED_MODULE_10__intl__["a" /* default */][err.status]){_context.next=10;break;}_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_10__intl__["a" /* default */][err.status],__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* alerts */].types.ERROR));case 10:_context.next=12;return putAction(err);case 12:return _context.abrupt('return',_context.sent);case 13:_context.next=15;return putAction(true);case 15:case'end':return _context.stop();}}},_marked,this);}function sendPasswordResetEmailSaga(_ref4){var payload=_ref4.payload;var _ref5,_ref6,json,err;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function sendPasswordResetEmailSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_8__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__api__["i" /* passwordResetEmail */]),payload);case 2:_ref5=_context2.sent;_ref6=_slicedToArray(_ref5,2);json=_ref6[0];err=_ref6[1];_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["e" /* passwordEmailRequestSent */])(err||json));case 8:case'end':return _context2.stop();}}},_marked2,this);}function passwordResetRequestSaga(_ref7){var _ref7$payload=_ref7.payload,password=_ref7$payload.password,token=_ref7$payload.token,email=_ref7$payload.email;var _ref8,_ref9,json,error,errorMsg;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function passwordResetRequestSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_8__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__api__["k" /* resetPassword */]),password,token,email);case 2:_ref8=_context3.sent;_ref9=_slicedToArray(_ref8,2);json=_ref9[0];error=_ref9[1];if(!error){_context3.next=10;break;}errorMsg=__WEBPACK_IMPORTED_MODULE_12__constants_errors__["b" /* resetPassword */][error.status]||__WEBPACK_IMPORTED_MODULE_12__constants_errors__["b" /* resetPassword */].DEFAULT_ERROR_MSG;_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__alerts_actions__["c" /* requestAlert */])(errorMsg,__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* alerts */].types.ERROR));case 10:_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["g" /* resetPassword */])(error||json));case 12:case'end':return _context3.stop();}}},_marked3,this);}function watchChangePasswordSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangePasswordSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__constants__["g" /* RESETTING_PASSWORD */],Object(__WEBPACK_IMPORTED_MODULE_9__handle_saga__["a" /* default */])(changePasswordSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}function watchSendPasswordResetEmailSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSendPasswordResetEmailSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST */],Object(__WEBPACK_IMPORTED_MODULE_9__handle_saga__["a" /* default */])(sendPasswordResetEmailSaga));case 2:case'end':return _context5.stop();}}},_marked5,this);}function watchPasswordResetRequest(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchPasswordResetRequest$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__constants__["f" /* PASSWORD_RESET_REQUEST */],Object(__WEBPACK_IMPORTED_MODULE_9__handle_saga__["a" /* default */])(passwordResetRequestSaga));case 2:case'end':return _context6.stop();}}},_marked6,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchChangePasswordSaga,watchSendPasswordResetEmailSaga,watchPasswordResetRequest]);

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* eslint-disable max-len *//* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({INVALID_OLD_PASSWORD:{id:'authentication.invalid-old-password',defaultMessage:'Oops! That does not look like your old password, please try again.'},INVALID_NEW_PASSWORD:{id:'authentication.invalid-new-password',defaultMessage:'Oops! Your password must be 8 characters or more with at least one number.'}}));

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changeBulbBrightnessSaga */
/* unused harmony export changeBulbStatusSaga */
/* unused harmony export getPatch */
/* unused harmony export changeBulbColourSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_products_products_api__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_bulbs__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors__ = __webpack_require__(520);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(changeBulbBrightnessSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeBulbBrightnessSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(changeBulbStatusSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeBulbStatusSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getPatch),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(changeBulbColourSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeBulbColorSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(talkToLightSaga),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchTalkToLightSaga);function changeBulbBrightnessSaga(_ref){var payload=_ref.payload;var productId,brightness,isOn,props,productType,colourMode,_ref2,_ref3,hue,saturation,patch,fullPatch,_ref4,_ref5,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function changeBulbBrightnessSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:productId=payload.productId,brightness=payload.brightness,isOn=payload.isOn;props={id:productId};_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__selectors__["L" /* getTypeForProduct */],props);case 4:productType=_context.sent;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["f" /* getColorModeForBulb */],props);case 7:colourMode=_context.sent;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["g" /* getHSVForBulb */],props);case 10:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);hue=_ref3[0];saturation=_ref3[1];patch=colourMode===__WEBPACK_IMPORTED_MODULE_8__constants_devices__["bulbModes"].colour?{hue:hue,saturation:saturation,value:brightness}:{brightness:brightness};fullPatch=isOn?patch:Object.assign({},patch,{status:'ON'});_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__api_products_products_api__["patchProduct"]),fullPatch,productType,productId);case 18:_ref4=_context.sent;_ref5=_slicedToArray(_ref4,2);error=_ref5[1];if(!error){_context.next=26;break;}_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* CHANGE_BRIGHTNESS */]));case 24:_context.next=26;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* alerts */].types.ERROR));case 26:_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["a" /* bulbSaved */])(payload));case 28:case'end':return _context.stop();}}},_marked,this);}function watchChangeBulbBrightnessSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeBulbBrightnessSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])([__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* CHANGE_BRIGHTNESS */]],changeBulbBrightnessSaga);case 2:case'end':return _context2.stop();}}},_marked2,this);}function changeBulbStatusSaga(_ref6){var productId=_ref6.payload.productId;var props,nextValue,productType,_ref7,_ref8,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function changeBulbStatusSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:props={id:productId};_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__selectors__["y" /* getProductItemById */],props);case 3:_context3.t0=['state','status'];nextValue=_context3.sent.getIn(_context3.t0);_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__selectors__["L" /* getTypeForProduct */],props);case 7:productType=_context3.sent;_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__api_products_products_api__["patchProduct"]),{status:nextValue},productType,productId);case 10:_ref7=_context3.sent;_ref8=_slicedToArray(_ref7,2);error=_ref8[1];if(!error){_context3.next=18;break;}_context3.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_13__constants__["g" /* TOGGLE_LIGHTBULB */]));case 16:_context3.next=18;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* alerts */].types.ERROR));case 18:_context3.next=20;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["f" /* toggleDone */])(error||{productId:productId}));case 20:case'end':return _context3.stop();}}},_marked3,this);}function watchChangeBulbStatusSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeBulbStatusSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_13__constants__["g" /* TOGGLE_LIGHTBULB */],changeBulbStatusSaga);case 2:case'end':return _context4.stop();}}},_marked4,this);}var maxSaturationHoneycombWillAccept=99;var minSaturation=0;var max=function max(maxValue){return function(value){return Math.max(value,maxValue);};};var min=function min(minValue){return function(value){return Math.min(value,minValue);};};var normaliseSaturation=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default()(max(minSaturation),min(maxSaturationHoneycombWillAccept));function getPatch(props,productType,mode,isCustomRange){var _ref9,_ref10,hue,saturation,value,colourTemperature,canChangeToWhite,colourMode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getPatch$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["g" /* getHSVForBulb */],props);case 2:_ref9=_context5.sent;_ref10=_slicedToArray(_ref9,3);hue=_ref10[0];saturation=_ref10[1];value=_ref10[2];_context5.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["l" /* getTemperatureForBulb */],props);case 9:colourTemperature=_context5.sent;_context5.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["e" /* getCanChangeToWhite */],props);case 12:canChangeToWhite=_context5.sent;colourMode=mode||(isCustomRange?__WEBPACK_IMPORTED_MODULE_8__constants_devices__["bulbModes"].white:__WEBPACK_IMPORTED_MODULE_8__constants_devices__["bulbModes"].colour);if(!isCustomRange){_context5.next=16;break;}return _context5.abrupt('return',{colourTemperature:colourTemperature});case 16:if(!(mode===__WEBPACK_IMPORTED_MODULE_8__constants_devices__["bulbModes"].white&&!canChangeToWhite)){_context5.next=18;break;}return _context5.abrupt('return',{colourMode:colourMode,colourTemperature:colourTemperature});case 18:return _context5.abrupt('return',{colourMode:colourMode,hue:hue,saturation:normaliseSaturation(saturation),value:value});case 19:case'end':return _context5.stop();}}},_marked5,this);}function changeBulbColourSaga(_ref11){var _ref11$payload=_ref11.payload,productId=_ref11$payload.productId,isCustomRange=_ref11$payload.isCustomRange,mode=_ref11$payload.mode,pickerType=_ref11$payload.pickerType;var props,productType,patch,_ref12,_ref13,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function changeBulbColourSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:props={id:productId};_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__selectors__["L" /* getTypeForProduct */],props);case 3:productType=_context6.sent;_context6.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(getPatch,props,productType,mode,isCustomRange);case 6:patch=_context6.sent;_context6.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__api_products_products_api__["patchProduct"]),patch,productType,productId);case 9:_ref12=_context6.sent;_ref13=_slicedToArray(_ref12,2);error=_ref13[1];if(!error){_context6.next=17;break;}_context6.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_13__constants__["d" /* COLOR_CHANGED */]));case 15:_context6.next=17;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* alerts */].types.ERROR));case 17:if(!pickerType){_context6.next=20;break;}_context6.next=20;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__ui_bulbs__["a" /* changePicker */])({pickerType:pickerType,productId:productId}));case 20:_context6.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__actions__["a" /* bulbSaved */])(error||{productId:productId}));case 22:case'end':return _context6.stop();}}},_marked6,this);}function watchChangeBulbColorSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeBulbColorSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["i" /* takeEvery */])([__WEBPACK_IMPORTED_MODULE_13__constants__["d" /* COLOR_CHANGED */],__WEBPACK_IMPORTED_MODULE_13__constants__["c" /* CHANGE_COLOR_MODE */]],changeBulbColourSaga);case 2:case'end':return _context7.stop();}}},_marked7,this);}function talkToLightSaga(_ref14){var payload=_ref14.payload;var id,type,patch,productType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function talkToLightSaga$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:id=payload.id,type=payload.type,patch=payload.patch;_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__selectors__["L" /* getTypeForProduct */],payload);case 3:productType=_context8.sent;_context8.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__api_products_products_api__["patchProduct"]),patch,type||productType,id);case 6:case'end':return _context8.stop();}}},_marked8,this);}function watchTalkToLightSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchTalkToLightSaga$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_13__constants__["e" /* TALK_TO_LIGHT */],talkToLightSaga);case 2:case'end':return _context9.stop();}}},_marked9,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchTalkToLightSaga,watchChangeBulbBrightnessSaga,watchChangeBulbStatusSaga,watchChangeBulbColorSaga]);

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createCurriedAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_curryN__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_curryN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_curryN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
// @noflow
var createCurriedAction=function createCurriedAction(type,payloadCreator){return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_curryN___default()(payloadCreator.length,Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(type,payloadCreator));};

/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export updateCameraSettingsSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(1774);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateCameraSettingsSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchUpdateCameraSettings);function updateCameraSettingsSaga(_ref){var _ref$payload=_ref.payload,cameraId=_ref$payload.cameraId,data=_ref$payload.data;var _ref2,_ref3,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateCameraSettingsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_3__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api__["g" /* nodes */].patchNode),data,'hivecamera',cameraId);case 2:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);error=_ref3[1];if(!error){_context.next=8;break;}_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* cameraSettingsUpdated */])(error));case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* cameraSettingsUpdated */])({data:data,cameraId:cameraId}));case 10:case'end':return _context.stop();}}},_marked,this);}function watchUpdateCameraSettings(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchUpdateCameraSettings$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* UPDATE_CAMERA_SETTINGS */],Object(__WEBPACK_IMPORTED_MODULE_4__handle_saga__["a" /* default */])(updateCameraSettingsSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchUpdateCameraSettings]);

/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export updateCameraSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cameraSettingsUpdated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(430);
var updateCameraSettings=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* UPDATE_CAMERA_SETTINGS */]);var cameraSettingsUpdated=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* CAMERA_SETTINGS_UPDATED */]);

/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadCountryConfigSaga */
/* unused harmony export loadCountry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__toResult__ = __webpack_require__(452);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadCountryConfigSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeUserSaga);function loadCountryConfigSaga(_ref){var user=_ref.payload.user;var i,_ref2,_ref3,countryConfig,err;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadCountryConfigSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* attemptLoadCountryConfig */])());case 2:i=0;case 3:if(!(i<__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ATTEMPTS_BEFORE_FAIL */])){_context.next=19;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_7__toResult__["a" /* default */])(loadCountry),user.countryCode);case 6:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);countryConfig=_ref3[0];err=_ref3[1];if(err){_context.next=14;break;}_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_1__actions__["b" /* loadCountryConfig */])(countryConfig.default));case 13:return _context.abrupt('return',_context.sent);case 14:_context.next=16;return i<__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ATTEMPTS_BEFORE_FAIL */]-1?Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_redux_saga__["b" /* delay */],2000):Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_1__actions__["b" /* loadCountryConfig */])(err));case 16:i++;_context.next=3;break;case 19:case'end':return _context.stop();}}},_marked,this);}function watchChangeUserSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeUserSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_6__application_actions__["h" /* logIn */],Object(__WEBPACK_IMPORTED_MODULE_5__handle_saga__["a" /* default */])(loadCountryConfigSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function loadCountry(country){return __webpack_require__(1777)("./"+country.toLowerCase());}/* harmony default export */ __webpack_exports__["a"] = ([watchChangeUserSaga]);

/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changeEnv */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attemptLoadCountryConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadCountryConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var changeEnv=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_ENV */]);var attemptLoadCountryConfig=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ATTEMPT_LOAD_COUNTRY_CONFIG */]);var loadCountryConfig=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* LOAD_COUNTRY_CONFIG */]);

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ca": [
		985,
		128
	],
	"./ca.js": [
		985,
		128
	],
	"./fr": [
		986,
		1
	],
	"./fr.js": [
		986,
		1
	],
	"./gb": [
		987,
		127
	],
	"./gb.js": [
		987,
		127
	],
	"./ie": [
		988,
		126
	],
	"./ie.js": [
		988,
		126
	],
	"./it": [
		989,
		0
	],
	"./it.js": [
		989,
		0
	],
	"./us": [
		990,
		125
	],
	"./us.js": [
		990,
		125
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1777;
module.exports = webpackAsyncContext;

/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_assisted_living__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__application_selectors__ = __webpack_require__(176);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attemptValidateTokenSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attemptAcceptInviteSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchAttemptValidateToken),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchAttemptAcceptInviteSaga);var DEAFULT_HOME_NAME='Home';// Maybe put this in config at some point
function attemptValidateTokenSaga(_ref){var token=_ref.payload.token;var homeServiceUrl,homeServiceApiKey,authToken,_ref2,_ref3,response,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attemptValidateTokenSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__config_selectors__["a" /* getConfig */],'homes:homeServiceUrl');case 2:homeServiceUrl=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__config_selectors__["a" /* getConfig */],'homes:homeServiceApiKey');case 5:homeServiceApiKey=_context.sent;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_7__application_selectors__["p" /* getToken */]);case 8:authToken=_context.sent;_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_3__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api_assisted_living__["b" /* validateToken */],true,false),token,homeServiceUrl,homeServiceApiKey,authToken);case 11:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);response=_ref3[0];error=_ref3[1];if(!(error||!response.valid)){_context.next=19;break;}_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* validateToken */])(new Error('Not Valid')));case 18:return _context.abrupt('return',_context.sent);case 19:_context.next=21;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* validateToken */])());case 21:case'end':return _context.stop();}}},_marked,this);}function attemptAcceptInviteSaga(_ref4){var _ref4$payload=_ref4.payload,token=_ref4$payload.token,_ref4$payload$homeNam=_ref4$payload.homeName,homeName=_ref4$payload$homeNam===undefined?DEAFULT_HOME_NAME:_ref4$payload$homeNam;var userId,homeServiceUrl,homeServiceApiKey,authToken,_ref5,_ref6,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attemptAcceptInviteSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5__user_selectors__["i" /* getUserId */]);case 2:userId=_context2.sent;_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__config_selectors__["a" /* getConfig */],'homes:homeServiceUrl');case 5:homeServiceUrl=_context2.sent;_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__config_selectors__["a" /* getConfig */],'homes:homeServiceApiKey');case 8:homeServiceApiKey=_context2.sent;_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_7__application_selectors__["p" /* getToken */]);case 11:authToken=_context2.sent;_context2.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_3__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api_assisted_living__["a" /* acceptInvite */],true,false),token,homeName,userId,homeServiceUrl,homeServiceApiKey,authToken);case 14:_ref5=_context2.sent;_ref6=_slicedToArray(_ref5,2);error=_ref6[1];_context2.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(error?Object(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* acceptInvite */])(error):Object(__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* acceptInvite */])());case 19:return _context2.abrupt('return',_context2.sent);case 20:case'end':return _context2.stop();}}},_marked2,this);}function watchAttemptValidateToken(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchAttemptValidateToken$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__actions__["c" /* attemptValidateToken */],attemptValidateTokenSaga);case 2:case'end':return _context3.stop();}}},_marked3,this);}function watchAttemptAcceptInviteSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchAttemptAcceptInviteSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* attemptAcceptInvite */],attemptAcceptInviteSaga);case 2:case'end':return _context4.stop();}}},_marked4,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchAttemptValidateToken,watchAttemptAcceptInviteSaga]);

/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acceptInvite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validateToken; });
var setupHeaders=function setupHeaders(token,apiKey){return Object.assign({'Content-Type':'application/json','x-api-key':apiKey},token?{Authorization:'Bearer '+token}:{});};var acceptInvite=function acceptInvite(token,homeName,userId,homeServiceUrl,apiKey,authToken){var endpoint=homeServiceUrl+'home/owner/'+userId+'/invitation/accept';var headers=setupHeaders(authToken,apiKey);return fetch(endpoint,{headers:headers,method:'POST',body:JSON.stringify({token:token,homeName:homeName})});};var validateToken=function validateToken(token,homeServiceUrl,apiKey,authToken){var endpoint=homeServiceUrl+'home/invitation/'+token;var headers=setupHeaders(authToken,apiKey);return fetch(endpoint,{headers:headers});};

/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getContactSensorEvents */
/* unused harmony export watchChangeSelectedDay */
/* unused harmony export loadPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hub_constants__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_sensor_events__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__intl__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__navigate__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__alerts_actions__ = __webpack_require__(30);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getContactSensorEvents),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeSelectedDay),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadPage),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadContactSensorPageSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchLoadContactSensorPageSaga);function getContactSensorEvents(_ref){var _ref$payload=_ref.payload,id=_ref$payload.id,day=_ref$payload.day;var timezone,startOfDay,from,to,_ref2,_ref3,response,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getContactSensorEvents$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__hub_selectors__["k" /* getTimezone */]);case 2:timezone=_context.sent;startOfDay=__WEBPACK_IMPORTED_MODULE_15_moment_timezone___default.a.tz(day,timezone).startOf('day');from=startOfDay.valueOf();to=__WEBPACK_IMPORTED_MODULE_15_moment_timezone___default.a.tz(day,timezone).endOf('day').valueOf();_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_12__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__api_sensor_events__["a" /* getEvents */]),__WEBPACK_IMPORTED_MODULE_8__constants_devices__["deviceTypes"].CONTACT_SENSOR,id,from,to);case 8:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);response=_ref3[0];error=_ref3[1];if(!error){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_17__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_14__intl__["a" /* default */].getEventsError,__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* alerts */].types.ERROR));case 15:_context.next=19;break;case 17:_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* receiveEvents */])(startOfDay.format('YYYY-MM-DD'),response,id));case 19:case'end':return _context.stop();}}},_marked,this);}function watchChangeSelectedDay(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeSelectedDay$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CHANGE_SELECTED_DAY */],Object(__WEBPACK_IMPORTED_MODULE_13__handle_saga__["a" /* default */])(getContactSensorEvents));case 2:case'end':return _context2.stop();}}},_marked2,this);}function loadPage(_ref4){var _ref4$payload=_ref4.payload,id=_ref4$payload.id,now=_ref4$payload.now,timezone=_ref4$payload.timezone;var startOfDay,_ref5,receiveEvents;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadPage$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:startOfDay=__WEBPACK_IMPORTED_MODULE_15_moment_timezone___default.a.tz(now,timezone).startOf('day');_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* changeSelectedDay */])({id:id,day:startOfDay.format('YYYY-MM-DD')}));case 3:_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* race */])({receiveEvents:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* RECEIVE_EVENTS */]),unloadPage:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* UNLOAD_PAGE */])});case 5:_ref5=_context3.sent;receiveEvents=_ref5.receiveEvents;if(!receiveEvents){_context3.next=14;break;}if(!receiveEvents.error){_context3.next=12;break;}_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_7__constants__["f" /* routes */].devices));case 11:return _context3.abrupt('return');case 12:_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* pageReady */])({id:id}));case 14:case'end':return _context3.stop();}}},_marked3,this);}function loadContactSensorPageSaga(_ref6){var id=_ref6.payload.id;var selectedDay,timezone,selectedDate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadContactSensorPageSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(false){_context4.next=18;break;}_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__selectors__["f" /* getSelectedDay */],{id:id});case 3:selectedDay=_context4.sent;_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__hub_selectors__["k" /* getTimezone */]);case 6:timezone=_context4.sent;if(selectedDay){_context4.next=11;break;}_context4.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__hub_selectors__["b" /* getCurrentTime */]);case 10:selectedDay=_context4.sent;case 11:selectedDate=__WEBPACK_IMPORTED_MODULE_15_moment_timezone___default.a.tz(selectedDay,timezone);_context4.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(loadPage,{payload:{id:id,now:selectedDate.format(),timezone:selectedDate.tz()}});case 14:_context4.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_redux_saga__["b" /* delay */],__WEBPACK_IMPORTED_MODULE_9__hub_constants__["c" /* GET_PRODUCTS_INTERVAL */]);case 16:_context4.next=0;break;case 18:case'end':return _context4.stop();}}},_marked4,this);}function watchLoadContactSensorPageSaga(){var action,deamon;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchLoadContactSensorPageSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(false){_context5.next=13;break;}_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* LOAD_PAGE */]);case 3:action=_context5.sent;_context5.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* fork */])(loadContactSensorPageSaga,action);case 6:deamon=_context5.sent;_context5.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* UNLOAD_PAGE */]);case 9:_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* cancel */])(deamon);case 11:_context5.next=0;break;case 13:case'end':return _context5.stop();}}},_marked5,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchChangeSelectedDay,watchLoadContactSensorPageSaga]);

/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({getEventsError:{id:'contact-sensor.getting-events-error',defaultMessage:"There was an error retrieving your device's events"}}));

/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__drivers_cookie__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__toResult__ = __webpack_require__(452);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadCookies),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchLoadCookies),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setCookie),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSetCookie);function loadCookies(){var _ref,_ref2,cookies,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadCookies$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_7__toResult__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__drivers_cookie__["a" /* default */].load));case 2:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);cookies=_ref2[0];error=_ref2[1];_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["b" /* cookiesLoaded */])(error||cookies));case 8:case'end':return _context.stop();}}},_marked,this);}function watchLoadCookies(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchLoadCookies$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* LOAD_COOKIES */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_saga__["a" /* default */])(loadCookies));case 2:case'end':return _context2.stop();}}},_marked2,this);}function setCookie(_ref3){var _ref3$payload=_ref3.payload,key=_ref3$payload.key,value=_ref3$payload.value;var userId,userKey,_ref4,_ref5,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setCookie$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5__user_selectors__["i" /* getUserId */]);case 2:userId=_context3.sent;userKey=userId+'-'+key;_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4__drivers_cookie__["a" /* default */].set,userKey,value);case 6:_ref4=_context3.sent;_ref5=_slicedToArray(_ref4,2);error=_ref5[1];_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* cookieSet */])(error||{key:userKey,value:value}));case 11:case'end':return _context3.stop();}}},_marked3,this);}function watchSetCookie(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSetCookie$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SET_COOKIE */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_saga__["a" /* default */])(setCookie));case 2:case'end':return _context4.stop();}}},_marked4,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchLoadCookies,watchSetCookie]);

/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDashboardCustomisation;
/* harmony export (immutable) */ __webpack_exports__["b"] = saveDashboardCustomisation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
function getDashboardCustomisation(userid){var getDashboardCustomisationURL=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'/web/user/'+userid+'/attributes/dashboard-config'});return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])(getDashboardCustomisationURL);}function saveDashboardCustomisation(userid,lastUpdated,pages){var getDashboardCustomisationURL=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'/web/user/'+userid+'/attributes/dashboard-config'});var body={lastUpdated:lastUpdated,pages:pages};return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])(getDashboardCustomisationURL,body);}

/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customisationErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
var customisationErrors=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({fetchError:{id:'dashboard.errors.fetch',defaultMessage:'Oops - We couldn\u2019t load your custom dashboard at this time.'}});

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export requestDevicesSaga */
/* unused harmony export renameDevice */
/* unused harmony export renameDeviceSaga */
/* unused harmony export renameHubDevicesSaga */
/* unused harmony export renameZoneSaga */
/* unused harmony export removeDevice */
/* unused harmony export removeDeviceSaga */
/* unused harmony export removeZoneSaga */
/* unused harmony export receiveDevicesSaga */
/* unused harmony export restartHubSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_routes__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dashboard_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__products_actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__intl__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__navigate__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__api_products_products_api__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__products_constants__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__settings_modal_actions__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_immutable__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__dashboard_selectors__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__install_nano1_upgrade_actions__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__install_nano1_upgrade_constants__ = __webpack_require__(218);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(renameDevice),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(renameDeviceSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchRenameDeviceSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(renameHubDevicesSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchRenameHubDeviceaSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(renameZoneSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchRenameZoneSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeDevice),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeDeviceSaga),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchRemoveDeviceSaga),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeZoneSaga),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchRemoveZoneSaga),_marked13=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(receiveDevicesSaga),_marked14=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchReceiveDevicesSaga),_marked15=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(restartHubSaga),_marked16=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchRestartHubSaga);//////// Format Functions
var formatDevices=function formatDevices(devices){return Array.isArray(devices)?devices.map(addSignalToHub):devices;};function addSignalToHub(device){return device.type===__WEBPACK_IMPORTED_MODULE_11__constants_devices__["deviceTypes"].HUB?addSignalToProp(device.props.online,device):device;}function addSignalToProp(isOnline,device){device.props.signal=isOnline?100:0;return device;}// Sagas
var requestDevicesSaga=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var putReceiveDevices,shouldFetchDevices,_ref,_ref2,devices,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:putReceiveDevices=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */],__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* receiveDevices */],formatDevices);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__selectors__["X" /* getShouldRequestDevices */]);case 3:shouldFetchDevices=_context.sent;if(shouldFetchDevices){_context.next=6;break;}return _context.abrupt('return');case 6:_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5__actions__["o" /* requestDevices */]());case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_16__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__api__["e" /* devices */].getDevices));case 10:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);devices=_ref2[0];error=_ref2[1];_context.next=16;return putReceiveDevices(error?error:devices);case 16:if(!error){_context.next=19;break;}_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_18__intl__["a" /* default */].error,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.ERROR));case 19:case'end':return _context.stop();}}},_callee,this);});var watchRequestDevices=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["i" /* takeEvery */])([__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* LOAD_INSTALL_OPTIONS */],__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* LOAD_MANAGE_DEVICES */],__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* LOAD_DEVICES */]],Object(__WEBPACK_IMPORTED_MODULE_17__handle_saga__["a" /* default */])(requestDevicesSaga));case 2:case'end':return _context2.stop();}}},_callee2,this);});function renameDevice(_ref3,action,productAction,zoneId){var _ref3$payload=_ref3.payload,name=_ref3$payload.name,productType=_ref3$payload.productType,productId=_ref3$payload.productId;var _ref4,_ref5,res,error,disallowRedirect;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function renameDevice$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_16__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_20__api_products_products_api__["patchProduct"]),{name:name},productType,productId);case 2:_ref4=_context3.sent;_ref5=_slicedToArray(_ref4,2);res=_ref5[0];error=_ref5[1];if(!error){_context3.next=12;break;}_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(action(error));case 9:_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_18__intl__["a" /* default */].nameChangeError,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.ERROR));case 11:return _context3.abrupt('return');case 12:_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_25__state_config_selectors__["a" /* getConfig */],'features:manageDevicesModal');case 14:disallowRedirect=_context3.sent;_context3.next=17;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(action({productId:productId,name:name}));case 17:_context3.next=19;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(productAction({productId:productId,name:name,zoneId:zoneId}));case 19:if(false){_context3.next=22;break;}_context3.next=22;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_23__settings_modal_actions__["d" /* closeSettingsModal */])({modal:__WEBPACK_IMPORTED_MODULE_23__settings_modal_actions__["c" /* SECONDARY */]}));case 22:if(!(!disallowRedirect&&res)){_context3.next=25;break;}_context3.next=25;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__navigate__["b" /* navigate */])('/devices#'+productId));case 25:if(res){_context3.next=28;break;}_context3.next=28;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_18__intl__["a" /* default */].nameChangeError,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.ERROR));case 28:case'end':return _context3.stop();}}},_marked,this);}function renameDeviceSaga(payload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function renameDeviceSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:return _context4.delegateYield(renameDevice(payload,__WEBPACK_IMPORTED_MODULE_5__actions__["m" /* renamedDevice */],__WEBPACK_IMPORTED_MODULE_14__products_actions__["h" /* renameProduct */]),'t0',1);case 1:case'end':return _context4.stop();}}},_marked2,this);}function watchRenameDeviceSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchRenameDeviceSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["l" /* RENAME_DEVICE */],Object(__WEBPACK_IMPORTED_MODULE_17__handle_saga__["a" /* default */])(renameDeviceSaga));case 2:case'end':return _context5.stop();}}},_marked3,this);}function renameHubDevicesSaga(_ref6){var devicesWithNames=_ref6.payload;var placementAdviceNeeded,responses,hasErrors,currentDevices,currentDevicesWithNewNames,_currentDevices,_ref13,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function renameHubDevicesSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:placementAdviceNeeded=false;if(!devicesWithNames.length){_context6.next=22;break;}_context6.next=4;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["a" /* all */])(devicesWithNames.map(function(_ref7){var device=_ref7.device,newName=_ref7.newName;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_16__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__api__["g" /* nodes */].patchNode),{name:newName},device.type,device.id);}));case 4:responses=_context6.sent;hasErrors=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_some___default()(function(_ref8){var _ref9=_slicedToArray(_ref8,2),error=_ref9[1];return error;},responses);if(!hasErrors){_context6.next=13;break;}_context6.next=9;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_8__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.ERROR));case 9:_context6.next=11;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_7__constants_routes__["install"]));case 11:_context6.next=20;break;case 13:_context6.next=15;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__selectors__["n" /* getDeviceItems */]);case 15:currentDevices=_context6.sent;currentDevicesWithNewNames=currentDevices.map(function(device){var id=device.id;var renamed=devicesWithNames.filter(function(_ref10){var renamedId=_ref10.device.id;return renamedId===id;});if(renamed.length){var _renamed$map=renamed.map(function(d){var _d$device=d.device,state=_d$device.state,renamedRest=_objectWithoutProperties(_d$device,['state']),newName=d.newName;return Object.assign({},renamedRest,{state:Object.assign({},state,{name:newName})});}),_renamed$map2=_slicedToArray(_renamed$map,1),renamedDevice=_renamed$map2[0];return renamedDevice;}return device;});placementAdviceNeeded=currentDevicesWithNewNames.some(function(_ref11){var type=_ref11.type;return type===__WEBPACK_IMPORTED_MODULE_11__constants_devices__["deviceTypes"].SIGNAL_BOOSTER;});_context6.next=20;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5__actions__["d" /* receiveDevices */](currentDevicesWithNewNames));case 20:_context6.next=26;break;case 22:_context6.next=24;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__selectors__["n" /* getDeviceItems */]);case 24:_currentDevices=_context6.sent;placementAdviceNeeded=_currentDevices.some(function(_ref12){var type=_ref12.type;return type===__WEBPACK_IMPORTED_MODULE_11__constants_devices__["deviceTypes"].SIGNAL_BOOSTER;});case 26:_context6.next=28;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__products_actions__["a" /* getProducts */])());case 28:_context6.next=30;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__dashboard_actions__["l" /* getDashboardCustomisation */])());case 30:_context6.next=32;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_21__products_constants__["f" /* RECEIVE_PRODUCTS */]);case 32:_ref13=_context6.sent;error=_ref13.error;if(!error){_context6.next=36;break;}return _context6.abrupt('return');case 36:if(!placementAdviceNeeded){_context6.next=41;break;}_context6.next=39;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_7__constants_routes__["installDevicePlacement"]));case 39:_context6.next=43;break;case 41:_context6.next=43;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_7__constants_routes__["dashboard"]));case 43:case'end':return _context6.stop();}}},_marked4,this);}function watchRenameHubDeviceaSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchRenameHubDeviceaSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["m" /* RENAME_HUB_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_17__handle_saga__["a" /* default */])(renameHubDevicesSaga));case 2:case'end':return _context7.stop();}}},_marked5,this);}function renameZoneSaga(payload){var zoneId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function renameZoneSaga$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__selectors__["D" /* getDeviceZoneId */],{id:payload.payload.productId});case 2:zoneId=_context8.sent;return _context8.delegateYield(renameDevice(payload,__WEBPACK_IMPORTED_MODULE_5__actions__["n" /* renamedZone */],__WEBPACK_IMPORTED_MODULE_14__products_actions__["i" /* renameProductZone */],zoneId),'t0',4);case 4:case'end':return _context8.stop();}}},_marked6,this);}function watchRenameZoneSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchRenameZoneSaga$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["n" /* RENAME_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_17__handle_saga__["a" /* default */])(renameZoneSaga));case 2:case'end':return _context9.stop();}}},_marked7,this);}function removeDevice(_ref14,deleteApi,action,productAction){var _ref14$payload=_ref14.payload,id=_ref14$payload.id,_ref14$payload$allowR=_ref14$payload.allowRedirect,allowRedirect=_ref14$payload$allowR===undefined?true:_ref14$payload$allowR;var _ref15,_ref16,error,device,isGroup,availableDashboardProducts,includedProducts,addProduct,addAllDevicesToDashboard;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeDevice$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_16__handle_api__["a" /* default */])(deleteApi),id);case 2:_ref15=_context10.sent;_ref16=_slicedToArray(_ref15,2);error=_ref16[1];_context10.next=7;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_15__products_selectors__["y" /* getProductItemById */],{id:id});case 7:device=_context10.sent;isGroup=device&&device.get('isGroup');if(!error){_context10.next=15;break;}_context10.next=12;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__alerts_actions__["c" /* requestAlert */])(isGroup?__WEBPACK_IMPORTED_MODULE_18__intl__["a" /* default */].groupRemoveError:__WEBPACK_IMPORTED_MODULE_18__intl__["a" /* default */].deviceRemoveError,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.ERROR));case 12:_context10.next=14;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* removeDeviceError */]());case 14:return _context10.abrupt('return');case 15:if(!isGroup){_context10.next=26;break;}_context10.next=18;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_26__dashboard_selectors__["a" /* getAvailableProductsForCustomisation */]);case 18:availableDashboardProducts=_context10.sent;// Get the list of products that are included on the group and are not already on the dashboard
includedProducts=device.getIn(['props','consumers']).toSet().intersect(availableDashboardProducts);addProduct=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */],__WEBPACK_IMPORTED_MODULE_12__dashboard_actions__["g" /* dashboardAddProduct */]);addAllDevicesToDashboard=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["a" /* all */],__WEBPACK_IMPORTED_MODULE_24__utils_immutable__["i" /* toJS */],Object(__WEBPACK_IMPORTED_MODULE_24__utils_immutable__["f" /* map */])(addProduct));_context10.next=24;return addAllDevicesToDashboard(includedProducts);case 24:_context10.next=26;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__dashboard_actions__["o" /* saveDashboardEdit */])());case 26:_context10.next=28;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_23__settings_modal_actions__["d" /* closeSettingsModal */])({modal:__WEBPACK_IMPORTED_MODULE_23__settings_modal_actions__["b" /* PRIMARY */]}));case 28:if(!allowRedirect){_context10.next=31;break;}_context10.next=31;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_7__constants_routes__["devices"]));case 31:_context10.next=33;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__alerts_actions__["c" /* requestAlert */])(isGroup?__WEBPACK_IMPORTED_MODULE_18__intl__["a" /* default */].groupRemoved:__WEBPACK_IMPORTED_MODULE_18__intl__["a" /* default */].deviceRemoved,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.SUCCESS));case 33:_context10.next=35;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(action({id:id}));case 35:_context10.next=37;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(productAction({id:id,zoneId:id}));case 37:_context10.next=39;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__dashboard_actions__["o" /* saveDashboardEdit */])());case 39:_context10.next=41;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__products_actions__["a" /* getProducts */])());case 41:case'end':return _context10.stop();}}},_marked8,this);}function removeDeviceSaga(payload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeDeviceSaga$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:return _context11.delegateYield(removeDevice(payload,__WEBPACK_IMPORTED_MODULE_9__api__["e" /* devices */].deleteDevice,__WEBPACK_IMPORTED_MODULE_5__actions__["h" /* removedDevice */],__WEBPACK_IMPORTED_MODULE_14__products_actions__["f" /* removeProduct */]),'t0',1);case 1:case'end':return _context11.stop();}}},_marked9,this);}function watchRemoveDeviceSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchRemoveDeviceSaga$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["g" /* REMOVE_DEVICE */],Object(__WEBPACK_IMPORTED_MODULE_17__handle_saga__["a" /* default */])(removeDeviceSaga));case 2:case'end':return _context12.stop();}}},_marked10,this);}function removeZoneSaga(payload){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeZoneSaga$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:return _context13.delegateYield(removeDevice(payload,__WEBPACK_IMPORTED_MODULE_9__api__["e" /* devices */].deleteZone,__WEBPACK_IMPORTED_MODULE_5__actions__["i" /* removedZone */],__WEBPACK_IMPORTED_MODULE_14__products_actions__["g" /* removeProductZone */]),'t0',1);case 1:case'end':return _context13.stop();}}},_marked11,this);}function watchRemoveZoneSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchRemoveZoneSaga$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["i" /* REMOVE_ZONE */],Object(__WEBPACK_IMPORTED_MODULE_17__handle_saga__["a" /* default */])(removeZoneSaga));case 2:case'end':return _context14.stop();}}},_marked12,this);}function receiveDevicesSaga(_ref17){var payload=_ref17.payload;var hub,isOnline,isMigrating,hasHublessDevice;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function receiveDevicesSaga$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:hub=__WEBPACK_IMPORTED_MODULE_4_lodash_fp_find___default()(function(x){return x.type===__WEBPACK_IMPORTED_MODULE_11__constants_devices__["deviceTypes"].HUB;},payload);if(hub){_context15.next=3;break;}return _context15.abrupt('return');case 3:isOnline=hub.props.online;isMigrating=[__WEBPACK_IMPORTED_MODULE_11__constants_devices__["hubOperationModes"].FAILURE,__WEBPACK_IMPORTED_MODULE_11__constants_devices__["hubOperationModes"].MIGRATING].includes(hub.props.operation);if(isOnline){_context15.next=15;break;}_context15.next=8;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_18__intl__["a" /* default */].hubOfflineError,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.ERROR,true));case 8:hasHublessDevice=payload.filter(function(d){return __WEBPACK_IMPORTED_MODULE_11__constants_devices__["hublessDeviceTypes"].includes(d.type);});if(!(hasHublessDevice.length>0)){_context15.next=11;break;}return _context15.abrupt('return');case 11:_context15.next=13;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_7__constants_routes__["devices"]));case 13:_context15.next=20;break;case 15:if(!isMigrating){_context15.next=20;break;}_context15.next=18;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_19__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_7__constants_routes__["upgradeNano1Hub"]));case 18:_context15.next=20;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_27__install_nano1_upgrade_actions__["c" /* progressInstallStage */])(__WEBPACK_IMPORTED_MODULE_28__install_nano1_upgrade_constants__["s" /* STAGE_STATUS */]));case 20:case'end':return _context15.stop();}}},_marked13,this);}function watchReceiveDevicesSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchReceiveDevicesSaga$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* RECEIVE_DEVICES */],Object(__WEBPACK_IMPORTED_MODULE_17__handle_saga__["a" /* default */])(receiveDevicesSaga));case 2:case'end':return _context16.stop();}}},_marked14,this);}function restartHubSaga(_ref18){var id=_ref18.payload.id;var _ref19,_ref20,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function restartHubSaga$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_16__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__api__["j" /* products */].restartHub),id);case 2:_ref19=_context17.sent;_ref20=_slicedToArray(_ref19,2);error=_ref20[1];if(!error){_context17.next=8;break;}_context17.next=8;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_18__intl__["a" /* default */].error,__WEBPACK_IMPORTED_MODULE_8__constants__["a" /* alerts */].types.ERROR));case 8:_context17.next=10;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5__actions__["q" /* restartedHub */](error||''));case 10:case'end':return _context17.stop();}}},_marked15,this);}function watchRestartHubSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchRestartHubSaga$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return Object(__WEBPACK_IMPORTED_MODULE_10_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["q" /* RESTART_HUB */],Object(__WEBPACK_IMPORTED_MODULE_17__handle_saga__["a" /* default */])(restartHubSaga));case 2:case'end':return _context18.stop();}}},_marked16,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchReceiveDevicesSaga,watchRemoveDeviceSaga,watchRemoveZoneSaga,watchRenameDeviceSaga,watchRenameHubDeviceaSaga,watchRenameZoneSaga,watchRequestDevices,watchRestartHubSaga]);

/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getEntitlements */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(51);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getEntitlements),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetEntitlements);function getEntitlements(_ref){var userid=_ref.payload.userid;var _ref2,_ref3,_ref3$,response,error,is404;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getEntitlements$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_4__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__api__["m" /* user */].getAttribute),userid,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* ENTITELEMENTS_ATTRIBUTE */]);case 2:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);_ref3$=_ref3[0];response=_ref3$===undefined?{}:_ref3$;error=_ref3[1];is404=error&&error.status===404;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["b" /* receiveEntitlements */])(error?is404?response:error:response));case 10:case'end':return _context.stop();}}},_marked,this);}function watchGetEntitlements(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetEntitlements$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* GET_ENTITLEMENTS */],Object(__WEBPACK_IMPORTED_MODULE_5__handle_saga__["a" /* default */])(getEntitlements));case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetEntitlements]);

/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_immutable__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_product_groups__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_errors__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashboard_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__honeycomb_actions__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__products_sagas__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dashboard_sagas__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__selectors__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dashboard_selectors__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__intl__ = __webpack_require__(1790);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saveGroupSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saveNewGroupCompleteSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSaveGroupSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSaveNewGroupCompleteSaga);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function saveGroupSaga(_ref){var _ref$payload=_ref.payload,id=_ref$payload.id,name=_ref$payload.name,availableItems=_ref$payload.availableItems,assignedToGroupItems=_ref$payload.assignedToGroupItems;var _ref2,_ref3,res,error,poll,consumers,groupConsumers,availableDashboardProducts,deselectedProducts,deselectedSize,addProduct,addAllDevicesToDashboard;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveGroupSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["d" /* saveGroupPending */])());case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__api_product_groups__["a" /* save */]),Object(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* forBeekeeper */])({id:id,name:name,items:[].concat(_toConsumableArray(availableItems),_toConsumableArray(assignedToGroupItems))}));case 4:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);res=_ref3[0];error=_ref3[1];if(!(error&&error.status===409)){_context.next=13;break;}_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_20__intl__["a" /* customisationErrors */].conflictStatusError,__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* alerts */].types.ERROR));case 11:_context.next=17;break;case 13:if(!error){_context.next=17;break;}_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_6__constants_errors__["a" /* generalErrorMessages */].tryAgain,__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* alerts */].types.ERROR));case 16:return _context.abrupt('return');case 17:poll=res.poll,consumers=res.consumers;_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_18__selectors__["b" /* getGroupConsumers */],{id:id});case 20:groupConsumers=_context.sent;_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_19__dashboard_selectors__["a" /* getAvailableProductsForCustomisation */]);case 23:availableDashboardProducts=_context.sent;// Get the list of products that have been deselected from the group and are not already on the dashboard
deselectedProducts=groupConsumers.map(function(groupConsumers){return groupConsumers.toSet().subtract(consumers).intersect(availableDashboardProducts);});deselectedSize=deselectedProducts.map(function(x){return x.size;}).getOrElse(0);if(!(deselectedSize>0)){_context.next=33;break;}addProduct=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */],__WEBPACK_IMPORTED_MODULE_8__dashboard_actions__["g" /* dashboardAddProduct */]);addAllDevicesToDashboard=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["a" /* all */],__WEBPACK_IMPORTED_MODULE_4__utils_immutable__["i" /* toJS */],Object(__WEBPACK_IMPORTED_MODULE_4__utils_immutable__["f" /* map */])(addProduct));_context.next=31;return addAllDevicesToDashboard(deselectedProducts.getOrElse(null));case 31:_context.next=33;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__dashboard_actions__["o" /* saveDashboardEdit */])());case 33:if(!poll){_context.next=38;break;}_context.next=36;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__honeycomb_actions__["a" /* pollNodeExists */])({id:poll,nextAction:Object(__WEBPACK_IMPORTED_MODULE_15__actions__["a" /* makeSaveNewGroupComplete */])({name:name,consumers:consumers}),errorAction:function errorAction(){return Object(__WEBPACK_IMPORTED_MODULE_9__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_6__constants_errors__["a" /* generalErrorMessages */].tryAgain,__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* alerts */].types.ERROR);}}));case 36:_context.next=40;break;case 38:_context.next=40;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_15__actions__["c" /* saveGroupComplete */])({name:name,consumers:consumers,nodeId:id})),Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__dashboard_actions__["i" /* dashboardRemoveProducts */])({ids:consumers})),Object(__WEBPACK_IMPORTED_MODULE_13__dashboard_sagas__["b" /* isDashboardCustomised */])()&&Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__dashboard_actions__["o" /* saveDashboardEdit */])())]);case 40:case'end':return _context.stop();}}},_marked,this);}function saveNewGroupCompleteSaga(_ref4){var _ref4$payload=_ref4.payload,id=_ref4$payload.id,name=_ref4$payload.name,consumers=_ref4$payload.consumers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveNewGroupCompleteSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_12__products_sagas__["b" /* getProductsSaga */])();case 2:_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__dashboard_actions__["g" /* dashboardAddProduct */])(id));case 4:_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__dashboard_actions__["i" /* dashboardRemoveProducts */])({ids:consumers}));case 6:_context2.t0=Object(__WEBPACK_IMPORTED_MODULE_13__dashboard_sagas__["b" /* isDashboardCustomised */])();if(!_context2.t0){_context2.next=11;break;}_context2.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__dashboard_actions__["o" /* saveDashboardEdit */])());case 10:_context2.t0=_context2.sent;case 11:_context2.next=13;return _context2.t0;case 13:case'end':return _context2.stop();}}},_marked2,this);}function watchSaveGroupSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSaveGroupSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_16__constants__["a" /* SAVE_GROUP */],Object(__WEBPACK_IMPORTED_MODULE_14__handle_saga__["a" /* default */])(saveGroupSaga));case 2:case'end':return _context3.stop();}}},_marked3,this);}function watchSaveNewGroupCompleteSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSaveNewGroupCompleteSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_16__constants__["d" /* SAVE_NEW_GROUP_COMPLETE */],Object(__WEBPACK_IMPORTED_MODULE_14__handle_saga__["a" /* default */])(saveNewGroupCompleteSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchSaveGroupSaga,watchSaveNewGroupCompleteSaga]);

/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = save;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
// @noflow
function save(data){if(data.id){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["d" /* httpPut */])('/product-groups/'+data.id,data);}return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('/product-groups',data);}

/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return forBeekeeper; });
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// @noflow
var forBeekeeper=function forBeekeeper(_ref){var id=_ref.id,name=_ref.name,items=_ref.items;var consumers=items.reduce(function(p,_ref2){var itemId=_ref2.id,include=_ref2.include;return include?[].concat(_toConsumableArray(p),[itemId]):p;},[]);return{id:id,name:name,consumers:consumers};};

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customisationErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
var customisationErrors=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({conflictStatusError:{id:'groups.errors.conflict-status-error',defaultMessage:'We were unable to save the changes to this group because one light can only be in one group at a time. Please try again.'}});

/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setBoostModeSaga */
/* unused harmony export stopBoostModeSaga */
/* unused harmony export changeHotWaterStatusSaga */
/* unused harmony export hotWaterStatusSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_app_settings__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_app_settings__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__thermostat_actions__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__intl__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_products_products_api__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_settings_actions__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions__ = __webpack_require__(69);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setBoostModeSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSetBoostModeSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(stopBoostModeSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchStopBoostModeSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(changeHotWaterStatusSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeHotWaterStatusSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(hotWaterStatusSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchHotWaterStatusSaga);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function setBoostModeSaga(_ref){var _ref$payload=_ref.payload,productId=_ref$payload.productId,duration=_ref$payload.duration,target=_ref$payload.target,controlMode=_ref$payload.controlMode;var props,productType,patch,_ref2,_ref3,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setBoostModeSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:props={id:productId};_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__selectors__["L" /* getTypeForProduct */],props);case 3:productType=_context.sent;patch=_defineProperty({mode:__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* devices */].deviceModes.BOOST,boost:duration},controlMode||'target',target);if(target){patch.target=target;}_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__api_products_products_api__["patchProduct"]),patch,productType,productId);case 8:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);error=_ref3[1];if(!error){_context.next=19;break;}_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SET_BOOST_HEATING_HOTWATER */]));case 14:_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 16:_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__thermostat_actions__["d" /* changedProductState */])({productId:productId}));case 18:return _context.abrupt('return');case 19:if(!target){_context.next=22;break;}_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_15__app_settings_actions__["c" /* setAppSettings */])(_defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_8__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_4__constants_app_settings__["b" /* BOOST_TARGET */],controlMode,productId),target)));case 22:if(!duration){_context.next=25;break;}_context.next=25;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_15__app_settings_actions__["c" /* setAppSettings */])(_defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_8__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_4__constants_app_settings__["a" /* BOOST_DURATION */],controlMode,productId),duration)));case 25:_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__thermostat_actions__["d" /* changedProductState */])({productId:productId}));case 27:case'end':return _context.stop();}}},_marked,this);}function watchSetBoostModeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSetBoostModeSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["j" /* takeLatest */])([__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* SET_BOOST_HEATING_HOTWATER */]],Object(__WEBPACK_IMPORTED_MODULE_11__handle_saga__["a" /* default */])(setBoostModeSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function stopBoostModeSaga(_ref4){var productId=_ref4.payload.productId;var props,productType,patch,_ref5,_ref6,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function stopBoostModeSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:props={id:productId};_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__selectors__["L" /* getTypeForProduct */],props);case 3:productType=_context3.sent;_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__selectors__["u" /* getPreviousConfigForProduct */],props);case 6:patch=_context3.sent;_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__api_products_products_api__["patchProduct"]),patch,productType,productId);case 9:_ref5=_context3.sent;_ref6=_slicedToArray(_ref5,2);error=_ref6[1];if(!error){_context3.next=20;break;}_context3.next=15;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* STOP_BOOST_HEATING_HOTWATER */]));case 15:_context3.next=17;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 17:_context3.next=19;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__thermostat_actions__["d" /* changedProductState */])({productId:productId}));case 19:return _context3.abrupt('return');case 20:_context3.next=22;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__thermostat_actions__["d" /* changedProductState */])({productId:productId}));case 22:case'end':return _context3.stop();}}},_marked3,this);}function watchStopBoostModeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchStopBoostModeSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["j" /* takeLatest */])([__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* STOP_BOOST_HEATING_HOTWATER */]],Object(__WEBPACK_IMPORTED_MODULE_11__handle_saga__["a" /* default */])(stopBoostModeSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}function changeHotWaterStatusSaga(_ref7){var payload=_ref7.payload;var productId,props,nextValue,productType,_ref8,_ref9,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function changeHotWaterStatusSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:productId=payload.productId;props={id:productId};_context5.next=4;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__selectors__["K" /* getStatusForProduct */],props);case 4:nextValue=_context5.sent;_context5.next=7;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__selectors__["L" /* getTypeForProduct */],props);case 7:productType=_context5.sent;_context5.next=10;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__api_products_products_api__["patchProduct"]),{status:nextValue},productType,productId);case 10:_ref8=_context5.sent;_ref9=_slicedToArray(_ref8,2);error=_ref9[1];if(!error){_context5.next=18;break;}_context5.next=16;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* TOGGLE_HOT_WATER */]));case 16:_context5.next=18;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 18:_context5.next=20;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["h" /* toggleHotWaterDone */])({productId:productId}));case 20:case'end':return _context5.stop();}}},_marked5,this);}function watchChangeHotWaterStatusSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeHotWaterStatusSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* TOGGLE_HOT_WATER */],changeHotWaterStatusSaga);case 2:case'end':return _context6.stop();}}},_marked6,this);}function hotWaterStatusSaga(_ref10){var _ref10$payload=_ref10.payload,nextStartTime=_ref10$payload.nextStartTime,nextEndTime=_ref10$payload.nextEndTime,nextStatus=_ref10$payload.nextStatus,productId=_ref10$payload.productId;var props,productType,_ref11,_ref12,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function hotWaterStatusSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:props={id:productId};_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__selectors__["L" /* getTypeForProduct */],props);case 3:productType=_context7.sent;_context7.next=6;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["d" /* setHotWaterStatusUpdateProduct */])({nextStatus:nextStatus,productId:productId}));case 6:_context7.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__api_products_products_api__["patchProduct"]),{status:nextStatus},productType,productId);case 8:_ref11=_context7.sent;_ref12=_slicedToArray(_ref11,2);error=_ref12[1];if(!error){_context7.next=17;break;}_context7.next=14;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SET_HOT_WATER_STATUS */]));case 14:_context7.next=16;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 16:return _context7.abrupt('return');case 17:_context7.next=19;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_12__intl__["a" /* default */].setHotWaterStatusSuccess,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.INFO,true,{intlValues:{nextStartTime:nextStartTime}}));case 19:_context7.next=21;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["c" /* setHotWaterStatusSuccessful */])({productId:productId}));case 21:case'end':return _context7.stop();}}},_marked7,this);}function watchHotWaterStatusSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchHotWaterStatusSaga$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["j" /* takeLatest */])([__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SET_HOT_WATER_STATUS */]],Object(__WEBPACK_IMPORTED_MODULE_11__handle_saga__["a" /* default */])(hotWaterStatusSaga));case 2:case'end':return _context8.stop();}}},_marked8,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchSetBoostModeSaga,watchStopBoostModeSaga,watchChangeHotWaterStatusSaga,watchHotWaterStatusSaga]);

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({setHotWaterStatusSuccess:{id:'heating-hotwater.status-set-success',defaultMessage:'You have advanced a time slot in your schedule. Next time slot at {nextStartTime}'}}));

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export heatingTargetSaga */
/* unused harmony export heatingHistorySaga */
/* unused harmony export changeReadyByStatusSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_app_settings__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_app_settings__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_history_history_api__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_periods__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_products_products_api__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_settings_actions__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(69);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(heatingTargetSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchHeatingTargetSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(heatingHistorySaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchHeatingHistorySaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(historyPeriodChangeSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchHistoryPeriodSelection),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(changeReadyByStatusSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchReadyByStatusSaga);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function heatingTargetSaga(_ref){var _ref$payload=_ref.payload,productId=_ref$payload.productId,target=_ref$payload.target;var props,productType,mode,patch,_ref2,_ref3,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function heatingTargetSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:props={id:productId};_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__selectors__["L" /* getTypeForProduct */],props);case 3:productType=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__selectors__["q" /* getModeForProduct */],props);case 6:mode=_context.sent;patch={target:target};if(!(mode===__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* devices */].deviceModes.OFF)){_context.next=12;break;}patch.mode=__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* devices */].deviceModes.MANUAL;_context.next=20;break;case 12:if(!(mode===__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* devices */].deviceModes.MANUAL)){_context.next=17;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_17__app_settings_actions__["c" /* setAppSettings */])(_defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_9__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_3__constants_app_settings__["f" /* MANUAL_TARGET_SETTING */],productId),target)));case 15:_context.next=20;break;case 17:if(!(mode===__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* devices */].deviceModes.BOOST)){_context.next=20;break;}_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_17__app_settings_actions__["c" /* setAppSettings */])(_defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_9__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_3__constants_app_settings__["b" /* BOOST_TARGET */],productId),target)));case 20:_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["f" /* setHeatingTargetUpdateProduct */])({productId:productId,target:target}));case 22:_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_13__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_15__api_products_products_api__["patchProduct"]),patch,productType,productId);case 24:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);error=_ref3[1];if(!error){_context.next=33;break;}_context.next=30;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_5__constants__["g" /* SET_TARGET_TEMPERATURE_UPDATE_PRODUCT */]));case 30:_context.next=32;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* alerts */].types.ERROR));case 32:return _context.abrupt('return');case 33:_context.next=35;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["e" /* setHeatingTargetSuccess */])({productId:productId}));case 35:case'end':return _context.stop();}}},_marked,this);}function watchHeatingTargetSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchHeatingTargetSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])([__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* SET_TARGET_TEMPERATURE */]],Object(__WEBPACK_IMPORTED_MODULE_14__handle_saga__["a" /* default */])(heatingTargetSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function heatingHistorySaga(_ref4){var _ref4$payload=_ref4.payload,productId=_ref4$payload.productId,period=_ref4$payload.period,start=_ref4$payload.start,end=_ref4$payload.end;var _ref5,_ref6,result,error,data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function heatingHistorySaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_13__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__api_history_history_api__["a" /* getHeatingHistory */]),productId,start,end,period.timeUnit,period.rate);case 2:_ref5=_context3.sent;_ref6=_slicedToArray(_ref5,2);result=_ref6[0];error=_ref6[1];if(!error){_context3.next=14;break;}if(!(error.code===404)){_context3.next=11;break;}_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["b" /* getTemperatureHistorySuccess */])({data:[],productId:productId,period:period,missingData:true}));case 10:return _context3.abrupt('return');case 11:_context3.next=13;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* alerts */].types.ERROR));case 13:return _context3.abrupt('return',_context3.sent);case 14:data=result.data;_context3.next=17;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["b" /* getTemperatureHistorySuccess */])({data:data,productId:productId,period:period,missingData:false}));case 17:case'end':return _context3.stop();}}},_marked3,this);}function watchHeatingHistorySaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchHeatingHistorySaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])([__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* GET_TEMPERATURE_HISTORY */]],Object(__WEBPACK_IMPORTED_MODULE_14__handle_saga__["a" /* default */])(heatingHistorySaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}function historyPeriodChangeSaga(_ref7){var _ref7$payload=_ref7.payload,productId=_ref7$payload.productId,period=_ref7$payload.period;var currentHubTime,range;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function historyPeriodChangeSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__hub_selectors__["c" /* getCurrentTimeWithTimezone */]);case 2:currentHubTime=_context5.sent;range=Object(__WEBPACK_IMPORTED_MODULE_12__utils_periods__["c" /* getStartEndTimeFromPeriod */])(period,currentHubTime);_context5.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* getTemperatureHistory */])(Object.assign({productId:productId,period:period},range)));case 6:case'end':return _context5.stop();}}},_marked5,this);}function watchHistoryPeriodSelection(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchHistoryPeriodSelection$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])([__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* SELECT_PERIOD */]],Object(__WEBPACK_IMPORTED_MODULE_14__handle_saga__["a" /* default */])(historyPeriodChangeSaga));case 2:case'end':return _context6.stop();}}},_marked6,this);}function changeReadyByStatusSaga(_ref8){var productId=_ref8.payload.productId;var props,nextValue,productType,_ref9,_ref10,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function changeReadyByStatusSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:props={id:productId};_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_7__selectors__["b" /* getIsReadyByEnabled */],props);case 3:nextValue=_context7.sent;_context7.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__selectors__["L" /* getTypeForProduct */],props);case 6:productType=_context7.sent;_context7.next=9;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_13__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_15__api_products_products_api__["patchProduct"]),{optimumStart:nextValue},productType,productId);case 9:_ref9=_context7.sent;_ref10=_slicedToArray(_ref9,2);error=_ref10[1];if(!error){_context7.next=17;break;}_context7.next=15;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_18__actions__["j" /* undoProductChange */])(__WEBPACK_IMPORTED_MODULE_5__constants__["h" /* TOGGLE_READY_BY */]));case 15:_context7.next=17;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* alerts */].types.ERROR));case 17:case'end':return _context7.stop();}}},_marked7,this);}function watchReadyByStatusSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchReadyByStatusSaga$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__constants__["h" /* TOGGLE_READY_BY */],changeReadyByStatusSaga);case 2:case'end':return _context8.stop();}}},_marked8,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchReadyByStatusSaga,watchHeatingTargetSaga,watchHeatingHistorySaga,watchHistoryPeriodSelection]);

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({durationMiliseconds:{defaultMessage:'less than a second',id:'sensor-logs.duration-miliseconds'},durationMinutes:{defaultMessage:'{minutes}m {seconds}s',id:'sensor-logs.duration-minutes'},durationHours:{defaultMessage:'more than {hours, plural,\n    \t\t\tone {an hour}\n    \t\t\tother {# hours}\n    \t\t}',id:'sensor-logs.duration-hours'}}));

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_nodes_nodes_api__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__handle_saga__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(poll),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(pollNodeExists),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchPollNodeExists);function poll(id){var _ref,_ref2,res,_res$nodes,nodes,_nodes,node;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function poll$(_context){while(1){switch(_context.prev=_context.next){case 0:if(false){_context.next=16;break;}_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_6__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__api_nodes_nodes_api__["getNodeCreationStatus"]),id);case 3:_ref=_context.sent;_ref2=_slicedToArray(_ref,1);res=_ref2[0];_res$nodes=res.nodes,nodes=_res$nodes===undefined?[]:_res$nodes;_nodes=_slicedToArray(nodes,1),node=_nodes[0];if(!(node&&node.id)){_context.next=10;break;}return _context.abrupt('return',node.id);case 10:if(!(node&&node.creationRequest&&node.creationRequest.status===__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* CREATION_FAILED */])){_context.next=12;break;}throw new Error('Creation of node '+id+' failed');case 12:_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_redux_saga__["b" /* delay */],1000);case 14:_context.next=0;break;case 16:case'end':return _context.stop();}}},_marked,this);}function pollNodeExists(_ref3){var _ref3$payload=_ref3.payload,id=_ref3$payload.id,nextAction=_ref3$payload.nextAction;var _ref4,nodeId,action;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function pollNodeExists$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* race */])({nodeId:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(poll,id),timeout:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_redux_saga__["b" /* delay */],__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* MAX_POLL_TIMEOUT */])});case 3:_ref4=_context2.sent;nodeId=_ref4.nodeId;if(!nodeId){_context2.next=10;break;}action=typeof nextAction==='function'?nextAction({nodeId:nodeId}):nextAction;_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(action);case 9:return _context2.abrupt('return',_context2.sent);case 10:if(!(typeof nextAction==='function')){_context2.next=14;break;}_context2.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(nextAction(new Error('Node creation timed out')));case 13:return _context2.abrupt('return',_context2.sent);case 14:_context2.next=21;break;case 16:_context2.prev=16;_context2.t0=_context2['catch'](0);if(!(typeof nextAction==='function')){_context2.next=21;break;}_context2.next=21;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(nextAction(_context2.t0));case 21:case'end':return _context2.stop();}}},_marked2,this,[[0,16]]);}function watchPollNodeExists(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchPollNodeExists$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* POLL_NODE_EXISTS */],Object(__WEBPACK_IMPORTED_MODULE_7__handle_saga__["a" /* default */])(pollNodeExists));case 2:case'end':return _context3.stop();}}},_marked3,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchPollNodeExists]);

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkServiceOutageStatusSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__products_thermostat_constants__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__products_actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__recipes_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__weather_actions__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__service_outage_constants__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__service_outage_actions__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__devices_actions__ = __webpack_require__(102);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(delayAction),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getWeatherPoll),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(weatherDaemonSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(currentDateDaemonSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getProductsAndRecipesPoll),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(refreshWorker),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(refreshLoginProductsDaemonSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(refreshProductsDaemonSaga),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchStartApiPoll),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(checkServiceOutageStatusSaga),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchCheckServiceOutageStatusSaga);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function delayAction(interval,fn){for(var _len=arguments.length,params=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){params[_key-2]=arguments[_key];}return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function delayAction$(_context){while(1){switch(_context.prev=_context.next){case 0:if(false){_context.next=7;break;}_context.next=3;return fn.apply(undefined,_toConsumableArray(params.map(function(p){return p();})));case 3:_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["b" /* delay */],interval);case 5:_context.next=0;break;case 7:case'end':return _context.stop();}}},_marked,this);}function getWeatherPoll(){var postcode,countryCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getWeatherPoll$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(false){_context2.next=13;break;}_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__user_selectors__["d" /* getPostcode */]);case 3:postcode=_context2.sent;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__user_selectors__["h" /* getUserCountry */]);case 6:countryCode=_context2.sent;_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__weather_actions__["a" /* getWeather */])({postcode:postcode,countryCode:countryCode}));case 9:_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["b" /* delay */],__WEBPACK_IMPORTED_MODULE_16__constants__["d" /* INTERVAL */]);case 11:_context2.next=0;break;case 13:case'end':return _context2.stop();}}},_marked2,this);}function weatherDaemonSaga(){var _ref,error,pollToUpdate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function weatherDaemonSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(false){_context3.next=15;break;}_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_15__application_actions__["i" /* logInComplete */]);case 3:_ref=_context3.sent;error=_ref.error;if(error){_context3.next=13;break;}_context3.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["d" /* fork */])(getWeatherPoll);case 8:pollToUpdate=_context3.sent;_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_15__application_actions__["k" /* logOut */]);case 11:_context3.next=13;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["c" /* cancel */])(pollToUpdate);case 13:_context3.next=0;break;case 15:case'end':return _context3.stop();}}},_marked3,this);}function currentDateDaemonSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function currentDateDaemonSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:return _context4.delegateYield(delayAction(__WEBPACK_IMPORTED_MODULE_16__constants__["d" /* INTERVAL */],__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */],__WEBPACK_IMPORTED_MODULE_14__actions__["a" /* dateTimeInterval */]),function(){return __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default()().valueOf();}),'t0',1);case 1:case'end':return _context4.stop();}}},_marked4,this);}function getProductsAndRecipesPoll(){var newActionsOn,hubActions2Capable,actions2Capable,_ref2,stopPoll;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getProductsAndRecipesPoll$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__config_selectors__["a" /* getConfig */],'features:newActions');case 2:newActionsOn=_context5.sent;_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_12__selectors__["a" /* canUseActions2 */]);case 5:hubActions2Capable=_context5.sent;actions2Capable=newActionsOn&&hubActions2Capable;case 7:if(false){_context5.next=27;break;}_context5.next=10;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["f" /* race */])({timeout:Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["b" /* delay */],__WEBPACK_IMPORTED_MODULE_16__constants__["c" /* GET_PRODUCTS_INTERVAL */]),stopPoll:Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_16__constants__["g" /* POLL_API_STOP */])});case 10:_ref2=_context5.sent;stopPoll=_ref2.stopPoll;if(!stopPoll){_context5.next=14;break;}return _context5.abrupt('return');case 14:_context5.next=16;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_24__devices_actions__["a" /* loadDevices */])());case 16:if(!actions2Capable){_context5.next=21;break;}_context5.next=19;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions_actions__["i" /* getActions */])());case 19:_context5.next=23;break;case 21:_context5.next=23;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__recipes_actions__["h" /* getRecipes */])());case 23:_context5.next=25;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__products_actions__["a" /* getProducts */])());case 25:_context5.next=7;break;case 27:case'end':return _context5.stop();}}},_marked5,this);}function refreshWorker(){var pollToUpdate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function refreshWorker$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["d" /* fork */])(getProductsAndRecipesPoll);case 2:pollToUpdate=_context6.sent;case 3:_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__products_thermostat_constants__["b" /* CHANGED_PRODUCT_STATE */]);case 5:if(!_context6.sent){_context6.next=13;break;}_context6.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["c" /* cancel */])(pollToUpdate);case 8:_context6.next=10;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["d" /* fork */])(getProductsAndRecipesPoll);case 10:pollToUpdate=_context6.sent;_context6.next=3;break;case 13:case'end':return _context6.stop();}}},_marked6,this);}function refreshLoginProductsDaemonSaga(){var _ref3,_error,worker;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function refreshLoginProductsDaemonSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(false){_context7.next=15;break;}_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_15__application_actions__["i" /* logInComplete */]);case 3:_ref3=_context7.sent;_error=_ref3.error;if(_error){_context7.next=13;break;}_context7.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["d" /* fork */])(refreshWorker);case 8:worker=_context7.sent;_context7.next=11;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_15__application_actions__["k" /* logOut */]);case 11:_context7.next=13;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["c" /* cancel */])(worker);case 13:_context7.next=0;break;case 15:case'end':return _context7.stop();}}},_marked7,this);}function refreshProductsDaemonSaga(){var worker;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function refreshProductsDaemonSaga$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:if(false){_context8.next=10;break;}_context8.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["d" /* fork */])(refreshWorker);case 3:worker=_context8.sent;_context8.next=6;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_15__application_actions__["k" /* logOut */]);case 6:_context8.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["c" /* cancel */])(worker);case 8:_context8.next=0;break;case 10:case'end':return _context8.stop();}}},_marked8,this);}function watchStartApiPoll(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchStartApiPoll$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_16__constants__["f" /* POLL_API_START */],refreshProductsDaemonSaga);case 2:case'end':return _context9.stop();}}},_marked9,this);}function checkServiceOutageStatusSaga(_ref4){var _ref4$payload=_ref4.payload,serviceUrlBase=_ref4$payload.serviceUrlBase,userLocale=_ref4$payload.userLocale;var result,_result,serviceOutage,_error2;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function checkServiceOutageStatusSaga$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:if(false){_context10.next=16;break;}_context10.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_19__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_18__api__["l" /* serviceOutage */].getServiceOutage),serviceUrlBase,userLocale);case 3:result=_context10.sent;if(result){_context10.next=6;break;}return _context10.abrupt('break',16);case 6:_result=_slicedToArray(result,2),serviceOutage=_result[0],_error2=_result[1];_context10.next=9;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_22__service_outage_actions__["c" /* receiveServiceOutage */])(_error2||serviceOutage));case 9:if(!_error2){_context10.next=12;break;}_context10.next=12;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_20__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_23__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_23__constants__["a" /* alerts */].types.ERROR));case 12:_context10.next=14;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["b" /* delay */],1200000);case 14:_context10.next=0;break;case 16:case'end':return _context10.stop();}}},_marked10,this);}function watchCheckServiceOutageStatusSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchCheckServiceOutageStatusSaga$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_21__service_outage_constants__["a" /* CHECK_SERVICE_OUTAGE_STATUS */],Object(__WEBPACK_IMPORTED_MODULE_17__handle_saga__["a" /* default */])(checkServiceOutageStatusSaga));case 2:case'end':return _context11.stop();}}},_marked11,this);}/* harmony default export */ __webpack_exports__["a"] = ([currentDateDaemonSaga,refreshLoginProductsDaemonSaga,weatherDaemonSaga,watchStartApiPoll,watchCheckServiceOutageStatusSaga]);

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadSelectedDayEvents */
/* unused harmony export watchLeakSensorLoadSelectedDayEvents */
/* unused harmony export leakSensorRefreshPage */
/* unused harmony export loadLeakSensorPageSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_sensor_events__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hub_constants__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__motion_sensor_intl__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(1798);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadSelectedDayEvents),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchLeakSensorLoadSelectedDayEvents),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(leakSensorRefreshPage),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadLeakSensorPageSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchLoadLeakSensorPageSaga);function loadSelectedDayEvents(_ref){var _ref$payload=_ref.payload,id=_ref$payload.id,day=_ref$payload.day;var timezone,startOfSelectedDay,from,to,_ref2,_ref3,response,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadSelectedDayEvents$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_9__hub_selectors__["k" /* getTimezone */]);case 2:timezone=_context.sent;startOfSelectedDay=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(day,timezone).startOf('day');from=startOfSelectedDay.valueOf();to=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(day,timezone).endOf('day').valueOf();_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_6__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__api_sensor_events__["a" /* getEvents */]),__WEBPACK_IMPORTED_MODULE_7__constants_devices__["deviceTypes"].LEAK_SENSOR,id,from,to);case 8:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);response=_ref3[0];error=_ref3[1];if(!error){_context.next=15;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_11__motion_sensor_intl__["a" /* default */].getEventsError,__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* alerts */].types.ERROR));case 15:_context.next=17;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["c" /* leakSensorReceiveEvents */])(startOfSelectedDay.format('YYYY-MM-DD'),error||response,id));case 17:case'end':return _context.stop();}}},_marked,this);}function watchLeakSensorLoadSelectedDayEvents(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchLeakSensorLoadSelectedDayEvents$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_13__constants__["b" /* LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS */],loadSelectedDayEvents);case 2:case'end':return _context2.stop();}}},_marked2,this);}function leakSensorRefreshPage(_ref4){var _ref4$payload=_ref4.payload,id=_ref4$payload.id,day=_ref4$payload.day;var _ref5,receiveEvents;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function leakSensorRefreshPage$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["a" /* leakSensorLoadSelectedDayEvents */])({id:id,day:day}));case 2:_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* race */])({receiveEvents:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_13__constants__["d" /* LEAK_SENSOR_RECEIVE_EVENTS */]),unloadPage:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_13__constants__["f" /* LEAK_SENSOR_UNLOAD_PAGE */])});case 4:_ref5=_context3.sent;receiveEvents=_ref5.receiveEvents;if(!receiveEvents){_context3.next=11;break;}if(!receiveEvents.error){_context3.next=9;break;}return _context3.abrupt('return');case 9:_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__actions__["b" /* leakSensorPageReady */])({id:id}));case 11:case'end':return _context3.stop();}}},_marked3,this);}function loadLeakSensorPageSaga(_ref6){var id=_ref6.payload.id;var currentTime,timezone,today;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadLeakSensorPageSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_9__hub_selectors__["b" /* getCurrentTime */]);case 2:currentTime=_context4.sent;_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_9__hub_selectors__["k" /* getTimezone */]);case 5:timezone=_context4.sent;today=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz(currentTime,timezone).startOf('day').format('YYYY-MM-DD');_context4.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(leakSensorRefreshPage,{payload:{id:id,day:today}});case 9:_context4.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_redux_saga__["b" /* delay */],__WEBPACK_IMPORTED_MODULE_8__hub_constants__["c" /* GET_PRODUCTS_INTERVAL */]);case 11:if(_context4.sent){_context4.next=0;break;}case 12:case'end':return _context4.stop();}}},_marked4,this);}function watchLoadLeakSensorPageSaga(){var action,deamon;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchLoadLeakSensorPageSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(false){_context5.next=13;break;}_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_13__constants__["a" /* LEAK_SENSOR_LOAD_PAGE */]);case 3:action=_context5.sent;_context5.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* fork */])(loadLeakSensorPageSaga,action);case 6:deamon=_context5.sent;_context5.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_13__constants__["f" /* LEAK_SENSOR_UNLOAD_PAGE */]);case 9:_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* cancel */])(deamon);case 11:_context5.next=0;break;case 13:case'end':return _context5.stop();}}},_marked5,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchLoadLeakSensorPageSaga,watchLeakSensorLoadSelectedDayEvents]);

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export leakSensorLoadPage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return leakSensorLoadSelectedDayEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return leakSensorPageReady; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return leakSensorReceiveEvents; });
/* unused harmony export leakSensorSetCurrentDay */
/* unused harmony export leakSensorUnloadPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(438);
var leakSensorLoadPage=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* LEAK_SENSOR_LOAD_PAGE */]);var leakSensorLoadSelectedDayEvents=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* LEAK_SENSOR_LOAD_SELECTED_DAY_EVENTS */]);var leakSensorPageReady=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* LEAK_SENSOR_PAGE_READY */]);var leakSensorReceiveEvents=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* LEAK_SENSOR_RECEIVE_EVENTS */],function(day,data,id){return{day:day,data:data,id:id};});var leakSensorSetCurrentDay=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* LEAK_SENSOR_SET_CURRENT_DAY */]);var leakSensorUnloadPage=Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_1__constants__["f" /* LEAK_SENSOR_UNLOAD_PAGE */]);

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMotionSensorEvents */
/* unused harmony export watchChangeMotionSensorSelectedDay */
/* unused harmony export loadMotionSensorPage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__hub_constants__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_sensor_events__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__intl__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__navigate__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__alerts_actions__ = __webpack_require__(30);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getMotionSensorEvents),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeMotionSensorSelectedDay),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadMotionSensorPage),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadMotionSensorPageSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchLoadMotionSensorPageSaga);function getMotionSensorEvents(_ref){var _ref$payload=_ref.payload,id=_ref$payload.id,day=_ref$payload.day;var timezone,startOfDay,from,to,_ref2,_ref3,response,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getMotionSensorEvents$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__hub_selectors__["k" /* getTimezone */]);case 2:timezone=_context.sent;startOfDay=__WEBPACK_IMPORTED_MODULE_14_moment_timezone___default.a.tz(day,timezone).startOf('day');from=startOfDay.valueOf();to=__WEBPACK_IMPORTED_MODULE_14_moment_timezone___default.a.tz(day,timezone).endOf('day').valueOf();_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_12__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__api_sensor_events__["a" /* getEvents */]),__WEBPACK_IMPORTED_MODULE_8__constants_devices__["deviceTypes"].MOTION_SENSOR,id,from,to);case 8:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);response=_ref3[0];error=_ref3[1];if(!error){_context.next=15;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_13__intl__["a" /* default */].getEventsError,__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* alerts */].types.ERROR));case 15:_context.next=17;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* receiveMotionSensorEvents */])(startOfDay.format('YYYY-MM-DD'),error||response,id));case 17:case'end':return _context.stop();}}},_marked,this);}function watchChangeMotionSensorSelectedDay(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeMotionSensorSelectedDay$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CHANGE_MOTION_SENSOR_SELECTED_DAY */],getMotionSensorEvents);case 2:case'end':return _context2.stop();}}},_marked2,this);}function loadMotionSensorPage(_ref4){var _ref4$payload=_ref4.payload,id=_ref4$payload.id,now=_ref4$payload.now,timezone=_ref4$payload.timezone;var startOfDay,_ref5,receiveMotionSensorEvents;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadMotionSensorPage$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:startOfDay=__WEBPACK_IMPORTED_MODULE_14_moment_timezone___default.a.tz(now,timezone).startOf('day');_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["b" /* changeMotionSensorSelectedDay */])({id:id,day:startOfDay.format('YYYY-MM-DD')}));case 3:_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* race */])({receiveMotionSensorEvents:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* RECEIVE_MOTION_SENSOR_EVENTS */]),unloadMotionSensorPage:Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* UNLOAD_MOTION_SENSOR_PAGE */])});case 5:_ref5=_context3.sent;receiveMotionSensorEvents=_ref5.receiveMotionSensorEvents;if(!receiveMotionSensorEvents){_context3.next=14;break;}if(!receiveMotionSensorEvents.error){_context3.next=12;break;}_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_15__navigate__["b" /* navigate */])(__WEBPACK_IMPORTED_MODULE_7__constants__["f" /* routes */].devices));case 11:return _context3.abrupt('return');case 12:_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["e" /* motionSensorPageReady */])({id:id}));case 14:case'end':return _context3.stop();}}},_marked3,this);}function loadMotionSensorPageSaga(_ref6){var id=_ref6.payload.id;var selectedDay,timezone,selectedDate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadMotionSensorPageSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(false){_context4.next=18;break;}_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__selectors__["g" /* getSelectedDay */],{id:id});case 3:selectedDay=_context4.sent;_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__hub_selectors__["k" /* getTimezone */]);case 6:timezone=_context4.sent;if(selectedDay){_context4.next=11;break;}_context4.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__hub_selectors__["b" /* getCurrentTime */]);case 10:selectedDay=_context4.sent;case 11:selectedDate=__WEBPACK_IMPORTED_MODULE_14_moment_timezone___default.a.tz(selectedDay,timezone);_context4.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(loadMotionSensorPage,{payload:{id:id,now:selectedDate.format(),timezone:selectedDate.tz()}});case 14:_context4.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_redux_saga__["b" /* delay */],__WEBPACK_IMPORTED_MODULE_9__hub_constants__["c" /* GET_PRODUCTS_INTERVAL */]);case 16:_context4.next=0;break;case 18:case'end':return _context4.stop();}}},_marked4,this);}function watchLoadMotionSensorPageSaga(){var action,deamon;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchLoadMotionSensorPageSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(false){_context5.next=13;break;}_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* LOAD_MOTION_SENSOR_PAGE */]);case 3:action=_context5.sent;_context5.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* fork */])(loadMotionSensorPageSaga,action);case 6:deamon=_context5.sent;_context5.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* UNLOAD_MOTION_SENSOR_PAGE */]);case 9:_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* cancel */])(deamon);case 11:_context5.next=0;break;case 13:case'end':return _context5.stop();}}},_marked5,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchChangeMotionSensorSelectedDay,watchLoadMotionSensorPageSaga]);

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MigrationError */
/* unused harmony export startMigrationSaga */
/* unused harmony export getMigrationStatusSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__drivers_cookie__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_migrations__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__intl__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__hub_actions__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__handle_saga__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(startMigrationSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchStartMigration),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getMigrationStatusSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetMigrationStatus),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(routeMigrationStatus),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(pollMigrationStatus),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchPollMigrationStatus);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MigrationError=function(_Error){_inherits(MigrationError,_Error);function MigrationError(status,code){_classCallCheck(this,MigrationError);var _this=_possibleConstructorReturn(this,(MigrationError.__proto__||Object.getPrototypeOf(MigrationError)).call(this));_this.status=200;_this.code='';_this.status=status;_this.code=code;return _this;}return MigrationError;}(Error);function startMigrationSaga(_ref){var hubCode=_ref.payload.code;var endpoint,token,hub,_ref2,_ref3,response,error,_response$migrations,migration,statusCode,_error$status,_error$status2,_error$status2$,errorCode;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function startMigrationSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__drivers_cookie__["a" /* default */].get,'honeycomb');case 2:endpoint=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__drivers_cookie__["a" /* default */].get,'token');case 5:token=_context.sent;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__devices_selectors__["F" /* getHub */]);case 8:hub=_context.sent;_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_13__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__api_migrations__["b" /* startMigration */]),endpoint,token,hub.id,hubCode);case 11:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);response=_ref3[0];error=_ref3[1];if(error){_context.next=24;break;}_response$migrations=_slicedToArray(response.migrations,1),migration=_response$migrations[0];_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__hub_actions__["c" /* pollApiStop */])());case 19:_context.next=21;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* startMigrationResponse */])({status:migration}));case 21:_context.next=23;return routeMigrationStatus(migration);case 23:return _context.abrupt('return');case 24:statusCode=error.code,_error$status=error.status;_error$status=_error$status===undefined?[]:_error$status;_error$status2=_slicedToArray(_error$status,1),_error$status2$=_error$status2[0];_error$status2$=_error$status2$===undefined?{}:_error$status2$;errorCode=_error$status2$.code;_context.next=31;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["f" /* startMigrationResponse */])(new MigrationError(statusCode,errorCode)));case 31:if(!(statusCode===404||errorCode===__WEBPACK_IMPORTED_MODULE_6__constants__["b" /* DESTINATION_NOT_FOUND */])){_context.next=36;break;}_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_8__intl__["a" /* default */].hubNotFound,__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* alerts */].types.ERROR));case 34:_context.next=43;break;case 36:if(![__WEBPACK_IMPORTED_MODULE_6__constants__["i" /* SOURCE_HUB_OFFLINE */],__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* DESTINATION_HUB_OFFLINE */]].includes(errorCode)){_context.next=41;break;}_context.next=39;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_8__intl__["a" /* default */].hubOffline,__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* alerts */].types.ERROR));case 39:_context.next=43;break;case 41:_context.next=43;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* progressInstallStage */])(__WEBPACK_IMPORTED_MODULE_6__constants__["m" /* STAGE_ERROR */]));case 43:case'end':return _context.stop();}}},_marked,this);}function watchStartMigration(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchStartMigration$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["u" /* START_MIGRATION_REQUEST */],Object(__WEBPACK_IMPORTED_MODULE_14__handle_saga__["a" /* default */])(startMigrationSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function getMigrationStatusSaga(){var endpoint,token,_ref4,_ref5,response,error,_response$migrations2,_response$migrations3,_response$migrations4,migration;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getMigrationStatusSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__hub_actions__["c" /* pollApiStop */])());case 2:_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__drivers_cookie__["a" /* default */].get,'honeycomb');case 4:endpoint=_context3.sent;_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2__drivers_cookie__["a" /* default */].get,'token');case 7:token=_context3.sent;_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_13__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__api_migrations__["a" /* getMigrations */]),endpoint,token);case 10:_ref4=_context3.sent;_ref5=_slicedToArray(_ref4,2);response=_ref5[0];error=_ref5[1];if(!error){_context3.next=18;break;}_context3.next=17;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_9__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* alerts */].types.ERROR));case 17:return _context3.abrupt('return',_context3.sent);case 18:_response$migrations2=response.migrations;_response$migrations2=_response$migrations2===undefined?[]:_response$migrations2;_response$migrations3=_slicedToArray(_response$migrations2,1),_response$migrations4=_response$migrations3[0],migration=_response$migrations4===undefined?{}:_response$migrations4;if(!(migration.status===__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* FAILED */])){_context3.next=26;break;}_context3.next=24;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["b" /* migrationStatusResponse */])(new MigrationError(200,migration.failureReason)));case 24:_context3.next=28;break;case 26:_context3.next=28;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["b" /* migrationStatusResponse */])({status:migration}));case 28:_context3.next=30;return routeMigrationStatus(migration,false);case 30:case'end':return _context3.stop();}}},_marked3,this);}function watchGetMigrationStatus(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetMigrationStatus$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_6__constants__["f" /* MIGRATION_STATUS_REQUEST */],Object(__WEBPACK_IMPORTED_MODULE_14__handle_saga__["a" /* default */])(getMigrationStatusSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}function routeMigrationStatus(_ref6){var status=_ref6.status;var loadStatusPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function routeMigrationStatus$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!(status===__WEBPACK_IMPORTED_MODULE_6__constants__["d" /* FINISHED */])){_context5.next=9;break;}_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* stopMigrationPoll */])());case 3:_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__hub_actions__["b" /* pollApiStart */])());case 5:_context5.next=7;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* progressInstallStage */])(__WEBPACK_IMPORTED_MODULE_6__constants__["l" /* STAGE_COMPLETE */]));case 7:_context5.next=21;break;case 9:if(!(status===__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* FAILED */])){_context5.next=18;break;}_context5.next=12;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["g" /* stopMigrationPoll */])());case 12:_context5.next=14;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__hub_actions__["b" /* pollApiStart */])());case 14:_context5.next=16;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* progressInstallStage */])(__WEBPACK_IMPORTED_MODULE_6__constants__["m" /* STAGE_ERROR */]));case 16:_context5.next=21;break;case 18:if(!loadStatusPage){_context5.next=21;break;}_context5.next=21;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["c" /* progressInstallStage */])(__WEBPACK_IMPORTED_MODULE_6__constants__["s" /* STAGE_STATUS */]));case 21:case'end':return _context5.stop();}}},_marked5,this);}function pollMigrationStatus(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function pollMigrationStatus$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(false){_context6.next=7;break;}_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* migrationStatusRequest */])());case 3:_context6.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_7_redux_saga__["b" /* delay */],__WEBPACK_IMPORTED_MODULE_6__constants__["e" /* MIGRATION_POLL_INTERVAL */]);case 5:_context6.next=0;break;case 7:case'end':return _context6.stop();}}},_marked6,this);}function watchPollMigrationStatus(){var deamon;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchPollMigrationStatus$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(false){_context7.next=12;break;}_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_6__constants__["t" /* START_MIGRATION_POLL */]);case 3:_context7.next=5;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["d" /* fork */])(pollMigrationStatus);case 5:deamon=_context7.sent;_context7.next=8;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_6__constants__["w" /* STOP_MIGRATION_POLL */]);case 8:_context7.next=10;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["c" /* cancel */])(deamon);case 10:_context7.next=0;break;case 12:case'end':return _context7.stop();}}},_marked7,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchStartMigration,watchGetMigrationStatus,watchPollMigrationStatus]);

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMigrations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return startMigration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__honeycomb__ = __webpack_require__(457);
var getMigrations=function getMigrations(endpoint,token){return fetch(endpoint+'/omnia/migrations',{method:'GET',headers:Object(__WEBPACK_IMPORTED_MODULE_0__honeycomb__["d" /* setupHeaders */])(token)});};var startMigration=function startMigration(endpoint,token,source,destination){return fetch(endpoint+'/omnia/migrations',{method:'POST',headers:Object(__WEBPACK_IMPORTED_MODULE_0__honeycomb__["d" /* setupHeaders */])(token),body:JSON.stringify({migrations:[{source:source,destination:destination}]})});};

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({hubNotFound:{id:'install-nano1-upgrade.alerts.not-found',description:'Hub search failure',defaultMessage:'Sorry, we cannot find your Hub - check its ID number and internet connection.'},hubOffline:{id:'install-nano1-upgrade.alerts.offline',description:'If source or destination hub are offline',defaultMessage:'Please confirm both hubs are connected with power and broadband, then try again'}}));

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadNotificationsSaga */
/* unused harmony export saveNotificationsSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_temperature__ = __webpack_require__(272);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadNotificationsSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetNotificationsSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saveNotificationsSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSaveNotificationsSaga);var putAlert=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */],__WEBPACK_IMPORTED_MODULE_13__alerts_actions__["c" /* requestAlert */]);function loadNotificationsSaga(){var _ref,_ref2,notifications,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadNotificationsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api__["h" /* notifications */].get));case 2:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);notifications=_ref2[0];error=_ref2[1];_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["c" /* receivedNotifications */])(error||notifications));case 8:case'end':return _context.stop();}}},_marked,this);}function watchGetNotificationsSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetNotificationsSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* LOAD_NOTIFICATIONS */],Object(__WEBPACK_IMPORTED_MODULE_12__handle_saga__["a" /* default */])(loadNotificationsSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function saveNotificationsSaga(_ref3){var payload=_ref3.payload;var id,hotEnabled,hotTemperature,coldEnabled,coldTemperature,warningsEnabled,UNEXPECTED_ERROR,ERROR,userId,unit,tempConvert,userAlerts,_ref4,_ref5,result,notificationsSaveError,_ref6,_ref7,setAlertsError,successPayload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveNotificationsSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:id=payload.id,hotEnabled=payload.hotEnabled,hotTemperature=payload.hotTemperature,coldEnabled=payload.coldEnabled,coldTemperature=payload.coldTemperature,warningsEnabled=payload.warningsEnabled;UNEXPECTED_ERROR=__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR;ERROR=__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* alerts */].types.ERROR;_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__user_selectors__["i" /* getUserId */]);case 5:userId=_context3.sent;_context3.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__config_selectors__["a" /* getConfig */],'temperatureUnit');case 8:unit=_context3.sent;tempConvert=unit==='F'?__WEBPACK_IMPORTED_MODULE_14__utils_temperature__["a" /* toCelsius */]:__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default.a;_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__user_selectors__["a" /* getAlerts */]);case 12:userAlerts=_context3.sent;_context3.next=15;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api__["h" /* notifications */].save),id,coldEnabled,tempConvert(coldTemperature),hotEnabled,tempConvert(hotTemperature));case 15:_ref4=_context3.sent;_ref5=_slicedToArray(_ref4,2);result=_ref5[0];notificationsSaveError=_ref5[1];_context3.next=21;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api__["m" /* user */].setAlerts),userId,userAlerts.set('warningsEmail',warningsEnabled).toJS());case 21:_ref6=_context3.sent;_ref7=_slicedToArray(_ref6,2);setAlertsError=_ref7[1];if(!(notificationsSaveError||setAlertsError)){_context3.next=29;break;}_context3.next=27;return putAlert(UNEXPECTED_ERROR,ERROR);case 27:_context3.next=29;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["e" /* saveNotificationsError */])());case 29:successPayload=Object.assign({},result,{id:id});_context3.next=32;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["f" /* savedNotifications */])(notificationsSaveError||setAlertsError||successPayload));case 32:case'end':return _context3.stop();}}},_marked3,this);}function watchSaveNotificationsSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSaveNotificationsSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_7__constants__["e" /* SAVE_NOTIFICATIONS */],Object(__WEBPACK_IMPORTED_MODULE_12__handle_saga__["a" /* default */])(saveNotificationsSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetNotificationsSaga,watchSaveNotificationsSaga]);

/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPowerConsumptionConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(992);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getPowerConsumptionConfig),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetPowerConsumptionConfig);function getPowerConsumptionConfig(){var _ref,_ref2,response,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getPowerConsumptionConfig$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_5__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__api__["b" /* app */].getAppConfig),__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* PLATFORM */],__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* CONFIG */]);case 2:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);response=_ref2[0];error=_ref2[1];_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["c" /* receivePowerConsumption */])(error||response));case 8:case'end':return _context.stop();}}},_marked,this);}function watchGetPowerConsumptionConfig(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetPowerConsumptionConfig$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* GET_POWER_CONSUMPTION */],Object(__WEBPACK_IMPORTED_MODULE_6__handle_saga__["a" /* default */])(getPowerConsumptionConfig));case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetPowerConsumptionConfig]);

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRecipesSaga */
/* unused harmony export createRecipeSaga */
/* unused harmony export deleteRecipeSaga */
/* unused harmony export updateRecipeSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ui_schedule_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_schedule__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__entitlements_selectors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__alerts_actions__ = __webpack_require__(30);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getRecipesSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetRecipesSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createRecipeSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchCreateRecipeSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteRecipeSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchDeleteRecipeSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateRecipeSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchUpdateRecipeSaga);/*******************
 *   GET RECIPES   *
 *******************/function getRecipesSaga(){var _ref,_ref2,recipes,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getRecipesSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api__["c" /* getRecipes */]));case 2:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);recipes=_ref2[0];error=_ref2[1];_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["k" /* receiveRecipes */])(error||recipes));case 8:if(!error){_context.next=11;break;}_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 11:case'end':return _context.stop();}}},_marked,this);}function watchGetRecipesSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetRecipesSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_4__constants__["h" /* GET_RECIPES */],Object(__WEBPACK_IMPORTED_MODULE_12__handle_saga__["a" /* default */])(getRecipesSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}/*********************
 *   CREATE RECIPE   *
 *********************/function createRecipeSaga(_ref3){var newRecipe=_ref3.payload.newRecipe;var defaultSchedule,recipe,_ref4,_ref5,result,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createRecipeSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_9__config_selectors__["a" /* getConfig */],'recipes:defaultSchedule');case 2:defaultSchedule=_context3.sent;recipe=Object.assign({},newRecipe.get('data').toJS(),{enabled:true,schedule:defaultSchedule.toJS(),scheduled:false});_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* createRecipe */]),recipe);case 6:_ref4=_context3.sent;_ref5=_slicedToArray(_ref4,2);result=_ref5[0];error=_ref5[1];_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["r" /* updateData */])(error||result));case 12:if(!error){_context3.next=15;break;}_context3.next=15;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 15:case'end':return _context3.stop();}}},_marked3,this);}function watchCreateRecipeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchCreateRecipeSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ATTEMPT_CREATE_RECIPE */],Object(__WEBPACK_IMPORTED_MODULE_12__handle_saga__["a" /* default */])(createRecipeSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}/*********************
 *   DELETE RECIPE   *
 *********************/function deleteRecipeSaga(_ref6){var recipeId=_ref6.payload;var _ref7,_ref8,result,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteRecipeSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* deleteRecipe */]),recipeId);case 2:_ref7=_context5.sent;_ref8=_slicedToArray(_ref7,2);result=_ref8[0];error=_ref8[1];_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["r" /* updateData */])(error||result));case 8:if(!error){_context5.next=11;break;}_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 11:case'end':return _context5.stop();}}},_marked5,this);}function watchDeleteRecipeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchDeleteRecipeSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* ATTEMPT_DELETE_RECIPE */],Object(__WEBPACK_IMPORTED_MODULE_12__handle_saga__["a" /* default */])(deleteRecipeSaga));case 2:case'end':return _context6.stop();}}},_marked6,this);}/*********************
 *   UPDATE RECIPE   *
 *********************/function updateRecipeSaga(_ref9){var recipe=_ref9.payload;var componentId,schedule,hasSMSEntitlement,_ref10,_ref11,result,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateRecipeSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:// before to update we first need to get the schedule from the component in case the user updated it
componentId=Object(__WEBPACK_IMPORTED_MODULE_8__utils_schedule__["c" /* createComponentId */])('recipe',recipe.getIn(['data','id']));_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__ui_schedule_selectors__["j" /* getScheduleData */],{componentId:componentId});case 3:schedule=_context7.sent;recipe=recipe.setIn(['data','schedule'],schedule);// if notification recipe, check sms entitlement
if(!recipe.get('isNotification',false)){_context7.next=10;break;}_context7.next=8;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__entitlements_selectors__["d" /* hasSMS */]);case 8:hasSMSEntitlement=_context7.sent;if(!hasSMSEntitlement&&recipe.getIn(['data','action','value','sms'],false)){// if sms is true but not entitlement then put ovewrite it as false
recipe=recipe.setIn(['data','action','value','sms'],false);}case 10:_context7.next=12;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api__["d" /* updateRecipe */]),recipe.get('data').toJS());case 12:_ref10=_context7.sent;_ref11=_slicedToArray(_ref10,2);result=_ref11[0];error=_ref11[1];_context7.next=18;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["s" /* updateRecipe */])(error||result));case 18:if(!error){_context7.next=25;break;}_context7.next=21;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 21:_context7.next=23;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__actions__["d" /* cancelAction */])(recipe.getIn(['data','id'])));case 23:_context7.next=27;break;case 25:_context7.next=27;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__ui_schedule_actions__["f" /* completeSaveSchedule */])({componentId:componentId}));case 27:case'end':return _context7.stop();}}},_marked7,this);}function watchUpdateRecipeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchUpdateRecipeSaga$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* ATTEMPT_UPDATE_RECIPE */],Object(__WEBPACK_IMPORTED_MODULE_12__handle_saga__["a" /* default */])(updateRecipeSaga));case 2:case'end':return _context8.stop();}}},_marked8,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchCreateRecipeSaga,watchDeleteRecipeSaga,watchGetRecipesSaga,watchUpdateRecipeSaga]);

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getRecipes;
/* harmony export (immutable) */ __webpack_exports__["a"] = createRecipe;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteRecipe;
/* harmony export (immutable) */ __webpack_exports__["d"] = updateRecipe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_helpers_helpers_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
function getRecipes(){var getRecipesURL=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'/recipes'});return Object(__WEBPACK_IMPORTED_MODULE_0__api_helpers_helpers_api__["b" /* httpGet */])(getRecipesURL);}function createRecipe(newRecipe){var createRecipeURL=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'/recipes'});return Object(__WEBPACK_IMPORTED_MODULE_0__api_helpers_helpers_api__["c" /* httpPost */])(createRecipeURL,newRecipe);}function deleteRecipe(recipeId){var deleteRecipeURL=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'/recipes/'+recipeId});return Object(__WEBPACK_IMPORTED_MODULE_0__api_helpers_helpers_api__["a" /* httpDelete */])(deleteRecipeURL);}function updateRecipe(recipe){var updateRecipeURL=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'/recipes/'+recipe.id});return Object(__WEBPACK_IMPORTED_MODULE_0__api_helpers_helpers_api__["d" /* httpPut */])(updateRecipeURL,recipe);}

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('slice', __webpack_require__(1808));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(240),
    isIterateeCall = __webpack_require__(163),
    toInteger = __webpack_require__(107);

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('reverse', __webpack_require__(1810));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 1810 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeReverse = arrayProto.reverse;

/**
 * Reverses `array` so that the first element becomes the last, the second
 * element becomes the second to last, and so on.
 *
 * **Note:** This method mutates `array` and is based on
 * [`Array#reverse`](https://mdn.io/Array/reverse).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = [1, 2, 3];
 *
 * _.reverse(array);
 * // => [3, 2, 1]
 *
 * console.log(array);
 * // => [3, 2, 1]
 */
function reverse(array) {
  return array == null ? array : nativeReverse.call(array);
}

module.exports = reverse;


/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(230),
    baseFlatten = __webpack_require__(231),
    copyArray = __webpack_require__(186),
    isArray = __webpack_require__(32);

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

module.exports = concat;


/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export attemptSaveScheduleSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__products_actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_products_products_api__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__alerts_actions__ = __webpack_require__(30);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attemptSaveScheduleSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchAttemptSaveScheduleSaga);/*********************
 *   SAVE SCHEDULE   *
 *********************/function attemptSaveScheduleSaga(_ref){var componentId=_ref.payload.componentId;var schedule,productId,productType,_ref2,_ref3,error,productMode,currentEvent;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attemptSaveScheduleSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5__selectors__["a" /* getCleanSchedule */],{componentId:componentId});case 2:schedule=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5__selectors__["d" /* getDataId */],{componentId:componentId});case 5:productId=_context.sent;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__products_selectors__["L" /* getTypeForProduct */],{id:productId});case 8:productType=_context.sent;_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_9__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_12__api_products_products_api__["patchProduct"]),{schedule:schedule},productType,productId);case 11:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);error=_ref3[1];if(!error){_context.next=20;break;}_context.next=17;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* alerts */].types.ERROR));case 17:_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["d" /* cancelSaveSchedule */])(componentId));case 19:return _context.abrupt('return');case 20:_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["f" /* completeSaveSchedule */])({componentId:componentId}));case 22:_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_6__products_selectors__["q" /* getModeForProduct */],{id:productId});case 24:productMode=_context.sent;if(!(productMode!==__WEBPACK_IMPORTED_MODULE_8__constants_devices__["deviceModes"].SCHEDULE)){_context.next=27;break;}return _context.abrupt('return');case 27:_context.next=29;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5__selectors__["c" /* getCurrentScheduleEvent */],{componentId:componentId,saved:true});case 29:currentEvent=_context.sent;_context.next=32;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_11__products_actions__["c" /* modifyProductState */])({productId:productId,productStateChanges:currentEvent.get('value').toJS()}));case 32:case'end':return _context.stop();}}},_marked,this);}function watchAttemptSaveScheduleSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchAttemptSaveScheduleSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_7__constants__["c" /* ATTEMPT_SAVE_SCHEDULE */],Object(__WEBPACK_IMPORTED_MODULE_10__handle_saga__["a" /* default */])(attemptSaveScheduleSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}/*************************//* harmony default export */ __webpack_exports__["a"] = ([watchAttemptSaveScheduleSaga]);

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setDefaultMutingSaga */
/* unused harmony export getHubOfflineNotificationsStatusSaga */
/* unused harmony export setHubOfflineNotificationsStatusSaga */
/* unused harmony export toggleMonitoringAllSaga */
/* unused harmony export toggleMonitoringSensorSaga */
/* unused harmony export watchEventPollingDaemonSaga */
/* unused harmony export getSenseEventLogs */
/* unused harmony export flagSenseMediaSaga */
/* unused harmony export watchChangeFlagSenseMediaSaga */
/* unused harmony export deleteSenseEventSaga */
/* unused harmony export watchDeleteSenseEventSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_honeycomb__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_products_sense__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_products_products_api__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_sensor_events__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__constants__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__intl__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__types__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__types__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setDefaultMutingSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSetDefaultMuting),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getHubOfflineNotificationsStatusSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetHubOfflineNotificationsStatusSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setHubOfflineNotificationsStatusSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSetHubOfflineNotificationsStatusSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(toggleMonitoringAllSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchToggleMonitoringAllSaga),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(toggleMonitoringSensorSaga),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchToggleMonitoringSensorSaga),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(eventPollingDaemonSaga),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchEventPollingDaemonSaga),_marked13=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getSenseEventLogs),_marked14=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(flagSenseMediaSaga),_marked15=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeFlagSenseMediaSaga),_marked16=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(deleteSenseEventSaga),_marked17=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchDeleteSenseEventSaga);function setDefaultMutingSaga(_ref){var productId=_ref.payload.productId;var productType,_ref2,_ref3,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setDefaultMutingSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["L" /* getTypeForProduct */],{id:productId});case 2:productType=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_15__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api_products_products_api__["patchProduct"]),__WEBPACK_IMPORTED_MODULE_18__constants__["r" /* defaultMuting */],productType,productId);case 5:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);error=_ref3[1];if(!error){_context.next=12;break;}_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* alerts */].types.ERROR));case 11:return _context.abrupt('return');case 12:_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["k" /* setDefaultMutingDone */]({defaultMuting:__WEBPACK_IMPORTED_MODULE_18__constants__["r" /* defaultMuting */],productId:productId}));case 14:case'end':return _context.stop();}}},_marked,this);}function watchSetDefaultMuting(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSetDefaultMuting$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_18__constants__["j" /* SET_DEFAULT_MUTING */],Object(__WEBPACK_IMPORTED_MODULE_16__handle_saga__["a" /* default */])(setDefaultMutingSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}function getHubOfflineNotificationsStatusSaga(_ref4){var hubId=_ref4.payload.hubId;var _ref5,_ref6,status,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getHubOfflineNotificationsStatusSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_15__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__api_products_sense__["a" /* getHubOfflineNotificationsStatus */]),hubId);case 2:_ref5=_context3.sent;_ref6=_slicedToArray(_ref5,2);status=_ref6[0];error=_ref6[1];if(!error){_context3.next=10;break;}_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* alerts */].types.ERROR));case 9:return _context3.abrupt('return');case 10:_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* receivedHubOfflineNotificationsStatus */](status));case 12:case'end':return _context3.stop();}}},_marked3,this);}function watchGetHubOfflineNotificationsStatusSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetHubOfflineNotificationsStatusSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_18__constants__["g" /* GET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS */],Object(__WEBPACK_IMPORTED_MODULE_16__handle_saga__["a" /* default */])(getHubOfflineNotificationsStatusSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}function setHubOfflineNotificationsStatusSaga(_ref7){var _ref7$payload=_ref7.payload,hubId=_ref7$payload.hubId,status=_ref7$payload.status;var _ref8,_ref9,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setHubOfflineNotificationsStatusSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_15__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__api_products_sense__["b" /* setHubOfflineNotificationsStatus */]),hubId,status);case 2:_ref8=_context5.sent;_ref9=_slicedToArray(_ref8,2);error=_ref9[1];if(!error){_context5.next=9;break;}_context5.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* alerts */].types.ERROR));case 8:return _context5.abrupt('return');case 9:_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["i" /* receivedHubOfflineNotificationsStatus */](status));case 11:case'end':return _context5.stop();}}},_marked5,this);}function watchSetHubOfflineNotificationsStatusSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSetHubOfflineNotificationsStatusSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_18__constants__["l" /* SET_SENSE_HUB_OFFLINE_NOTICATIONS_STATUS */],Object(__WEBPACK_IMPORTED_MODULE_16__handle_saga__["a" /* default */])(setHubOfflineNotificationsStatusSaga));case 2:case'end':return _context6.stop();}}},_marked6,this);}function toggleMonitoringAllSaga(_ref10){var _ref10$payload=_ref10.payload,isMonitoring=_ref10$payload.isMonitoring,productId=_ref10$payload.productId;var mute,productType,_ref11,_ref12,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function toggleMonitoringAllSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:// mute = (true) || (false) =  (inactive/notMonitoring) || (active/monitoring)
mute=isMonitoring;_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["L" /* getTypeForProduct */],{id:productId});case 3:productType=_context7.sent;_context7.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_15__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api_products_products_api__["patchProduct"]),{mute:mute},productType,productId);case 6:_ref11=_context7.sent;_ref12=_slicedToArray(_ref11,2);error=_ref12[1];if(!error){_context7.next=13;break;}_context7.next=12;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* alerts */].types.ERROR));case 12:return _context7.abrupt('return');case 13:_context7.next=15;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["o" /* toggleMonitoringAllDone */]({isMonitoring:isMonitoring,productId:productId}));case 15:case'end':return _context7.stop();}}},_marked7,this);}function watchToggleMonitoringAllSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchToggleMonitoringAllSaga$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_18__constants__["n" /* TOGGLE_MONITORING_ALL */],Object(__WEBPACK_IMPORTED_MODULE_16__handle_saga__["a" /* default */])(toggleMonitoringAllSaga));case 2:case'end':return _context8.stop();}}},_marked8,this);}function toggleMonitoringSensorSaga(_ref13){var _ref13$payload=_ref13.payload,isMonitoring=_ref13$payload.isMonitoring,productId=_ref13$payload.productId,sensorType=_ref13$payload.sensorType;var productType,_ref14,_ref15,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function toggleMonitoringSensorSaga$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_14__selectors__["L" /* getTypeForProduct */],{id:productId});case 2:productType=_context9.sent;_context9.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_15__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__api_products_products_api__["patchProduct"]),{sensors:_defineProperty({},sensorType,isMonitoring)},productType,productId);case 5:_ref14=_context9.sent;_ref15=_slicedToArray(_ref14,2);error=_ref15[1];if(!error){_context9.next=12;break;}_context9.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* alerts */].types.ERROR));case 11:return _context9.abrupt('return');case 12:_context9.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["q" /* toggleMonitoringSensorDone */]({productId:productId,sensorType:sensorType,isMonitoring:isMonitoring}));case 14:case'end':return _context9.stop();}}},_marked9,this);}function watchToggleMonitoringSensorSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchToggleMonitoringSensorSaga$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_18__constants__["p" /* TOGGLE_MONITORING_SENSOR */],Object(__WEBPACK_IMPORTED_MODULE_16__handle_saga__["a" /* default */])(toggleMonitoringSensorSaga));case 2:case'end':return _context10.stop();}}},_marked10,this);}function eventPollingDaemonSaga(action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function eventPollingDaemonSaga$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(getSenseEventLogs,action);case 2:_context11.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */],30000);case 4:_context11.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(eventPollingDaemonSaga,action);case 6:case'end':return _context11.stop();}}},_marked11,this);}function watchEventPollingDaemonSaga(){var daemon;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchEventPollingDaemonSaga$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:if(false){_context12.next=10;break;}_context12.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_18__constants__["a" /* CHANGE_SENSE_LOGS_SELECTED_DAY */],eventPollingDaemonSaga);case 3:daemon=_context12.sent;_context12.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_18__constants__["m" /* STOP_SENSE_DAY_EVENT_LOGS_POLLING */]);case 6:_context12.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* cancel */])(daemon);case 8:_context12.next=0;break;case 10:case'end':return _context12.stop();}}},_marked12,this);}function getSenseEventLogs(_ref16){var _ref16$payload=_ref16.payload,id=_ref16$payload.id,selectedDay=_ref16$payload.selectedDay;var timezone,startOfDay,from,to,_ref17,_ref18,response,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getSenseEventLogs$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_13__hub_selectors__["k" /* getTimezone */]);case 2:timezone=_context13.sent;startOfDay=__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(selectedDay,timezone).startOf('day');from=startOfDay.valueOf();to=__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default.a.tz(selectedDay,timezone).endOf('day').valueOf();_context13.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["g" /* getSenseDayEventLogs */](id,selectedDay));case 8:_context13.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_15__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__api_sensor_events__["a" /* getEvents */]),__WEBPACK_IMPORTED_MODULE_10__constants_devices__["deviceTypes"].SENSE,id,from,to);case 10:_ref17=_context13.sent;_ref18=_slicedToArray(_ref17,2);response=_ref18[0];error=_ref18[1];if(!error){_context13.next=20;break;}_context13.next=17;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_19__intl__["a" /* default */].getEventsError,__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* alerts */].types.ERROR));case 17:_context13.next=19;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* receiveSenseDayEventLogs */](error));case 19:return _context13.abrupt('return',_context13.sent);case 20:_context13.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["h" /* receiveSenseDayEventLogs */](id,startOfDay.format('YYYY-MM-DD'),Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(response)));case 22:case'end':return _context13.stop();}}},_marked13,this);}function flagSenseMediaSaga(_ref19){var _ref19$payload=_ref19.payload,id=_ref19$payload.id,mediaId=_ref19$payload.mediaId,flag=_ref19$payload.flag;var _ref20,_ref21,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function flagSenseMediaSaga$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_15__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__api_honeycomb__["b" /* flagSenseMedia */]),mediaId,flag);case 2:_ref20=_context14.sent;_ref21=_slicedToArray(_ref20,2);error=_ref21[1];if(!error){_context14.next=9;break;}_context14.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* alerts */].types.ERROR));case 8:return _context14.abrupt('return');case 9:_context14.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["e" /* flagSenseMediaComplete */](id,mediaId));case 11:case'end':return _context14.stop();}}},_marked14,this);}function watchChangeFlagSenseMediaSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeFlagSenseMediaSaga$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_18__constants__["d" /* FLAG_SENSE_MEDIA */],Object(__WEBPACK_IMPORTED_MODULE_16__handle_saga__["a" /* default */])(flagSenseMediaSaga));case 2:case'end':return _context15.stop();}}},_marked15,this);}function deleteSenseEventSaga(_ref22){var _ref22$payload=_ref22.payload,id=_ref22$payload.id,mediaId=_ref22$payload.mediaId;var _ref23,_ref24,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function deleteSenseEventSaga$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:_context16.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_15__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__api_honeycomb__["a" /* deleteSenseMedia */]),mediaId);case 2:_ref23=_context16.sent;_ref24=_slicedToArray(_ref23,2);error=_ref24[1];if(!error){_context16.next=9;break;}_context16.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_11__constants__["a" /* alerts */].types.ERROR));case 8:return _context16.abrupt('return');case 9:_context16.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_17__actions__["c" /* deleteSenseEventComplete */](id,mediaId));case 11:case'end':return _context16.stop();}}},_marked16,this);}function watchDeleteSenseEventSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchDeleteSenseEventSaga$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_18__constants__["b" /* DELETE_SENSE_EVENT */],Object(__WEBPACK_IMPORTED_MODULE_16__handle_saga__["a" /* default */])(deleteSenseEventSaga));case 2:case'end':return _context17.stop();}}},_marked17,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchChangeFlagSenseMediaSaga,watchDeleteSenseEventSaga,watchEventPollingDaemonSaga,watchSetDefaultMuting,watchGetHubOfflineNotificationsStatusSaga,watchSetHubOfflineNotificationsStatusSaga,watchToggleMonitoringAllSaga,watchToggleMonitoringSensorSaga]);

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHubOfflineNotificationsStatus;
/* harmony export (immutable) */ __webpack_exports__["b"] = setHubOfflineNotificationsStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
function getHubOfflineNotificationsStatus(id){var httpUrl=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'sense/'+id+'/hub-offline-notifications'});return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["b" /* httpGet */])(httpUrl);}function setHubOfflineNotificationsStatus(id,status){var httpUrl=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({pathname:'sense/'+id+'/hub-offline-notifications'});return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])(httpUrl,status);}

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({getEventsError:{id:'sense.getting-events-error',defaultMessage:"There was an error retrieving your device's events"}}));

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getContactsSaga */
/* unused harmony export saveContactsSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_text_control_text_control_api__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selectors__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__intl__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__alerts_actions__ = __webpack_require__(30);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getContactsSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetContactsSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saveContactsSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSaveContactsSaga);function getContactsSaga(){var _ref,_ref2,contacts,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getContactsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__api_text_control_text_control_api__["c" /* getTextControlContactsApi */]));case 2:_ref=_context.sent;_ref2=_slicedToArray(_ref,2);contacts=_ref2[0];error=_ref2[1];if(!error){_context.next=9;break;}_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* alerts */].types.ERROR));case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["b" /* receivedContacts */])(error||contacts));case 11:case'end':return _context.stop();}}},_marked,this);}function watchGetContactsSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetContactsSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* GET_CONTACTS */],Object(__WEBPACK_IMPORTED_MODULE_12__handle_saga__["a" /* default */])(getContactsSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}var makeContact=function makeContact(numberPrefix){return function(_ref3){var id=_ref3.id,name=_ref3.name,mobile=_ref3.mobile;return{id:id,name:name,mobile:numberPrefix&&mobile.startsWith(numberPrefix.get('local'))?mobile.replace(numberPrefix.get('local'),numberPrefix.get('international')):mobile};};};function saveContactsSaga(_ref4){var _ref4$payload=_ref4.payload,contacts=_ref4$payload.contacts,formId=_ref4$payload.formId;var currentContacts,nextIds,numberPrefix,deletedContactIds,apiContacts,newContacts,updatedContacts,addedContacts,addContactsError,deleteContactsError,_ref5,_ref6,_ref7,_ref8,_ref9,_ref10,updated,updateContactsError,exception,alert,errors,hasErrors;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveContactsSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_10__selectors__["e" /* getTextControlContacts */]);case 2:currentContacts=_context3.sent;nextIds=contacts.map(function(c){return c.id;}).filter(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default.a);_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_9__config_selectors__["a" /* getConfig */],'textControl:numberPrefix');case 6:numberPrefix=_context3.sent;deletedContactIds=currentContacts.toSeq().map(function(c){return c.get('id');}).filter(function(id){return!nextIds.includes(id);}).filter(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default.a).toJS();apiContacts=contacts.map(makeContact(numberPrefix));newContacts=apiContacts.filter(function(c){return!c.id&&c.name&&c.mobile;});updatedContacts=apiContacts.filter(function(c){return c.id&&c.name&&c.mobile;});addedContacts=void 0;addContactsError=void 0;deleteContactsError=void 0;if(!newContacts.length){_context3.next=21;break;}_context3.next=17;return __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["b" /* call */].apply(undefined,[Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__api_text_control_text_control_api__["a" /* addTextControlContactsApi */])].concat(_toConsumableArray(newContacts)));case 17:_ref5=_context3.sent;_ref6=_slicedToArray(_ref5,2);addedContacts=_ref6[0];addContactsError=_ref6[1];case 21:if(!deletedContactIds.length){_context3.next=27;break;}_context3.next=24;return __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["b" /* call */].apply(undefined,[Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__api_text_control_text_control_api__["b" /* deleteTextControlContactsApi */])].concat(_toConsumableArray(deletedContactIds)));case 24:_ref7=_context3.sent;_ref8=_slicedToArray(_ref7,2);deleteContactsError=_ref8[1];case 27:_context3.next=29;return __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["b" /* call */].apply(undefined,[Object(__WEBPACK_IMPORTED_MODULE_11__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__api_text_control_text_control_api__["d" /* updateTextControlContactsApi */])].concat(_toConsumableArray(updatedContacts)));case 29:_ref9=_context3.sent;_ref10=_slicedToArray(_ref9,2);updated=_ref10[0];updateContactsError=_ref10[1];exception=addContactsError||deleteContactsError||updateContactsError;if(!exception){_context3.next=40;break;}alert=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */],__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */]);_context3.next=38;return alert(__WEBPACK_IMPORTED_MODULE_13__intl__["a" /* default */].errorSavingContacts,__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* alerts */].types.ERROR);case 38:_context3.next=40;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["e" /* savedContacts */])(exception));case 40:errors=[].concat(_toConsumableArray(updated||[]),_toConsumableArray(addedContacts||[])).map(function(x){return x.error;}).filter(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_identity___default.a);hasErrors=!!errors.length;_context3.next=44;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["c" /* receivedServerErrors */])(hasErrors?errors:[]));case 44:_context3.next=46;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["e" /* savedContacts */])({updatedContacts:updatedContacts,addedContacts:addedContacts}));case 46:case'end':return _context3.stop();}}},_marked3,this);}function watchSaveContactsSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSaveContactsSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_7__constants__["f" /* SAVE_CONTACTS */],Object(__WEBPACK_IMPORTED_MODULE_12__handle_saga__["a" /* default */])(saveContactsSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetContactsSaga,watchSaveContactsSaga]);

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({savedContacts:{id:'text-control.saved-contacts',defaultMessage:'Text control successfully saved'},errorSavingContacts:{id:'text-control.saved-contacts-error',defaultMessage:'There was a problem saving your text control settings. Please try again.'}}));

/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export changeProductStateSaga */
/* unused harmony export setHumidifierTypeSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_app_settings__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_app_settings__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_products_products_api__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_settings_actions__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(69);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(cacheThermostatValue),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchCacheThermostatValue),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(changeProductStateSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchChangeProductStateSaga),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setHumidifierTypeSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSetHumidifierTypeSaga);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var putAppSettings=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */],__WEBPACK_IMPORTED_MODULE_16__app_settings_actions__["c" /* setAppSettings */]);function cacheThermostatValue(_ref){var payload=_ref.payload;var productId,controlMode,changeTypeKey,value;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function cacheThermostatValue$(_context){while(1){switch(_context.prev=_context.next){case 0:productId=payload.productId,controlMode=payload.controlMode,changeTypeKey=payload.changeTypeKey,value=payload.value;_context.next=3;return putAppSettings(_defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_8__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_4__constants_app_settings__["g" /* MANUAL_TARGET_VALUE */],productId,controlMode,changeTypeKey),value));case 3:case'end':return _context.stop();}}},_marked,this);}function watchCacheThermostatValue(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchCacheThermostatValue$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* CACHE_PRODUCT_TEMPERATURE */],cacheThermostatValue);case 2:case'end':return _context2.stop();}}},_marked2,this);}// eslint-disable-next-line no-unused-vars
function changeProductStateSaga(_ref2){var type=_ref2.type,payload=_ref2.payload;var productId,productType,patch,nextPatch,mode,controlMode,isTemperatureChange,changeTypeyKey,isChangingMode,_controlMode,_ref3,_ref4,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function changeProductStateSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:productId=payload.productId,productType=payload.productType,patch=_objectWithoutProperties(payload,['productId','productType']);nextPatch=patch;_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_11__selectors__["q" /* getModeForProduct */],{id:productId});case 4:mode=_context3.sent;_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_7__selectors__["p" /* getThermostatControlMode */],{id:productId});case 7:controlMode=_context3.sent;if(!(mode===__WEBPACK_IMPORTED_MODULE_10__constants_devices__["deviceModes"].MANUAL)){_context3.next=15;break;}isTemperatureChange=nextPatch.heat||nextPatch.cool;changeTypeyKey=nextPatch.heat?'heat':'cool';if(!isTemperatureChange){_context3.next=14;break;}_context3.next=14;return putAppSettings(_defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_8__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_4__constants_app_settings__["g" /* MANUAL_TARGET_VALUE */],productId,controlMode,changeTypeyKey),nextPatch.heat||nextPatch.cool));case 14:if(!isTemperatureChange&&patch.controlMode){nextPatch={controlMode:patch.controlMode};}case 15:if(mode===__WEBPACK_IMPORTED_MODULE_10__constants_devices__["deviceModes"].SCHEDULE){isChangingMode=patch.mode;if(isChangingMode){nextPatch={mode:patch.mode};}}if(!(mode===__WEBPACK_IMPORTED_MODULE_10__constants_devices__["deviceModes"].BOOST&&(nextPatch.heat||nextPatch.cool))){_context3.next=22;break;}_context3.next=19;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_7__selectors__["p" /* getThermostatControlMode */],{id:productId});case 19:_controlMode=_context3.sent;_context3.next=22;return putAppSettings(_defineProperty({},Object(__WEBPACK_IMPORTED_MODULE_8__utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_4__constants_app_settings__["b" /* BOOST_TARGET */],_controlMode,productId),nextPatch.heat||nextPatch.cool));case 22:_context3.next=24;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_12__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_14__api_products_products_api__["patchProduct"]),nextPatch,productType,productId);case 24:_ref3=_context3.sent;_ref4=_slicedToArray(_ref3,2);error=_ref4[1];if(!error){_context3.next=35;break;}_context3.next=30;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["d" /* changedProductState */])({productId:productId}));case 30:_context3.next=32;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["j" /* undoProductChange */])(type));case 32:_context3.next=34;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_15__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* alerts */].types.ERROR));case 34:return _context3.abrupt('return');case 35:_context3.next=37;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__actions__["d" /* changedProductState */])({productId:productId}));case 37:case'end':return _context3.stop();}}},_marked3,this);}function watchChangeProductStateSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchChangeProductStateSaga$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* CHANGE_PRODUCT_STATE */],Object(__WEBPACK_IMPORTED_MODULE_13__handle_saga__["a" /* default */])(changeProductStateSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}function setHumidifierTypeSaga(_ref5){var payload=_ref5.payload;var nastats;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setHumidifierTypeSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_7__selectors__["n" /* getOnlineNaThermostats */]);case 2:nastats=_context5.sent;_context5.next=5;return nastats.map(function(p){return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_12__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_14__api_products_products_api__["patchProduct"]),{humidifierType:payload},'nathermostat',p.get('id'));}).toJS();case 5:case'end':return _context5.stop();}}},_marked5,this);}function watchSetHumidifierTypeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSetHumidifierTypeSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5__constants__["e" /* SET_HUMIDIFIER_TYPE */],Object(__WEBPACK_IMPORTED_MODULE_13__handle_saga__["a" /* default */])(setHumidifierTypeSaga));case 2:case'end':return _context6.stop();}}},_marked6,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchCacheThermostatValue,watchChangeProductStateSaga,watchSetHumidifierTypeSaga]);

/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadLocaleTranslationsMemo */
/* unused harmony export loadLocaleTranslations */
/* unused harmony export loadTranslationsSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_memoize__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__handle_saga__ = __webpack_require__(19);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(loadTranslationsSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchAppLoadedSaga);var loadLocaleTranslationsMemo=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_memoize___default()(loadLocaleTranslations);function loadLocaleTranslations(locale){var lang=locale.toLowerCase().replace(/^(\w*)-.*/i,'$1');return Promise.all([__webpack_require__(1821)("./"+locale.toLowerCase()),__webpack_require__(1822)("./"+lang)]);}function loadTranslationsSaga(_ref){var locale=_ref.payload.locale;var loadTranslationsEffect,i,_ref2,_ref3,translations,languagePack;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function loadTranslationsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(!locale||locale.toLowerCase()===__WEBPACK_IMPORTED_MODULE_5__constants__["b" /* DEFAULT_LOCALE */].toLowerCase())){_context.next=4;break;}_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* loadTranslations */])());case 3:return _context.abrupt('return',_context.sent);case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* attemptLoadTranslations */])());case 6:loadTranslationsEffect=void 0;i=0;case 8:if(!(i<__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NUMBER_OF_ATTEMPTS */])){_context.next=33;break;}_context.prev=9;_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(loadLocaleTranslationsMemo,locale);case 12:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);translations=_ref3[0];languagePack=_ref3[1];_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_7_react_intl__["e" /* addLocaleData */],languagePack);case 18:loadTranslationsEffect=Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* loadTranslations */])(translations));return _context.abrupt('break',33);case 22:_context.prev=22;_context.t0=_context['catch'](9);if(!(i<__WEBPACK_IMPORTED_MODULE_5__constants__["d" /* NUMBER_OF_ATTEMPTS */]-1)){_context.next=29;break;}_context.next=27;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_redux_saga__["b" /* delay */],2000);case 27:_context.next=30;break;case 29:loadTranslationsEffect=Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["b" /* loadTranslations */])(_context.t0));case 30:i++;_context.next=8;break;case 33:_context.next=35;return loadTranslationsEffect;case 35:case'end':return _context.stop();}}},_marked,this,[[9,22]]);}function watchAppLoadedSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchAppLoadedSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_8__application_actions__["b" /* appLoaded */],Object(__WEBPACK_IMPORTED_MODULE_9__handle_saga__["a" /* default */])(loadTranslationsSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchAppLoadedSaga]);

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attemptLoadTranslations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadTranslations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_actions__ = __webpack_require__(5);
var attemptLoadTranslations=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ATTEMPT_LOAD_TRANSLATIONS */]);var loadTranslations=Object(__WEBPACK_IMPORTED_MODULE_1_redux_actions__["a" /* createAction */])(__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* LOAD_TRANSLATIONS */]);

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./README.md": [
		2582,
		203
	],
	"./base": [
		995,
		9
	],
	"./base.json": [
		995,
		9
	],
	"./en-ca": [
		996,
		8
	],
	"./en-ca.json": [
		996,
		8
	],
	"./en-ie": [
		997,
		7
	],
	"./en-ie.json": [
		997,
		7
	],
	"./en-us": [
		998,
		6
	],
	"./en-us.json": [
		998,
		6
	],
	"./es-us": [
		999,
		5
	],
	"./es-us.json": [
		999,
		5
	],
	"./fr-ca": [
		1000,
		4
	],
	"./fr-ca.json": [
		1000,
		4
	],
	"./fr-fr": [
		1001,
		3
	],
	"./fr-fr.json": [
		1001,
		3
	],
	"./it-it": [
		1002,
		2
	],
	"./it-it.json": [
		1002,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1821;
module.exports = webpackAsyncContext;

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en": [
		614
	],
	"./es": [
		2583,
		202
	],
	"./fr": [
		2584,
		201
	],
	"./it": [
		2585,
		200
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1822;
module.exports = webpackAsyncContext;

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timestampNow */
/* unused harmony export isUserStillActiveSaga */
/* unused harmony export setPinSaga */
/* unused harmony export toggleAnalyticsSharingAllowedSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__intl__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__alerts_actions__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api__ = __webpack_require__(51);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(isUserStillActiveSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(userStillActiveDaemonSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setPinSaga),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSetPin),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(toggleAnalyticsSharingAllowedSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchToggleAnalyticsSharingAllowed);var timestampNow=function timestampNow(){return __WEBPACK_IMPORTED_MODULE_13_moment_timezone___default()().valueOf();};function isUserStillActiveSaga(){var inactiveTimeout,lastActivity,currentTime,millisecondsSinceLastActive;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function isUserStillActiveSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_9__config_selectors__["a" /* getConfig */],'user:inactiveTimeout');case 2:inactiveTimeout=_context.sent;case 3:if(false){_context.next=19;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_redux_saga__["b" /* delay */],inactiveTimeout/4);case 6:_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5__selectors__["c" /* getLastActivity */]);case 8:lastActivity=_context.sent;_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(timestampNow);case 11:currentTime=_context.sent;millisecondsSinceLastActive=currentTime-lastActivity;if(!(millisecondsSinceLastActive>=inactiveTimeout)){_context.next=17;break;}_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6__application_actions__["k" /* logOut */])());case 16:return _context.abrupt('return',_context.sent);case 17:_context.next=3;break;case 19:case'end':return _context.stop();}}},_marked,this);}function userStillActiveDaemonSaga(){var daemon;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function userStillActiveDaemonSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_6__application_actions__["i" /* logInComplete */]);case 2:_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["d" /* fork */])(isUserStillActiveSaga);case 4:daemon=_context2.sent;_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_6__application_actions__["k" /* logOut */]);case 7:_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["c" /* cancel */])(daemon);case 9:case'end':return _context2.stop();}}},_marked2,this);}function setPinSaga(_ref){var _ref$payload=_ref.payload,confirm=_ref$payload.confirm,pin=_ref$payload.pin;var userId,_ref2,_ref3,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setPinSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(pin!==confirm)){_context3.next=6;break;}_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* settingPin */])(new Error('Pins not matching')));case 3:_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_12__intl__["a" /* default */].notMatching,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* alerts */].types.ERROR));case 5:return _context3.abrupt('return',_context3.sent);case 6:_context3.next=8;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* settingPin */])());case 8:_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5__selectors__["i" /* getUserId */]);case 10:userId=_context3.sent;_context3.next=13;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_15__api__["m" /* user */].setPin),userId,pin);case 13:_ref2=_context3.sent;_ref3=_slicedToArray(_ref2,2);error=_ref3[1];if(!error){_context3.next=20;break;}_context3.next=19;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["e" /* settingPin */])(error));case 19:return _context3.abrupt('return',_context3.sent);case 20:_context3.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["b" /* pinSet */])());case 22:case'end':return _context3.stop();}}},_marked3,this);}function watchSetPin(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSetPin$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_8__constants__["e" /* SET_PIN */],Object(__WEBPACK_IMPORTED_MODULE_11__handle_saga__["a" /* default */])(setPinSaga));case 2:case'end':return _context4.stop();}}},_marked4,this);}function toggleAnalyticsSharingAllowedSaga(_ref4){var allowAnalyticsSharing=_ref4.payload.allowAnalyticsSharing;var userId,_ref5,_ref6,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function toggleAnalyticsSharingAllowedSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_5__selectors__["i" /* getUserId */]);case 2:userId=_context5.sent;_context5.next=5;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_10__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_15__api__["m" /* user */].setAllowAnalyticsSharing),userId,allowAnalyticsSharing);case 5:_ref5=_context5.sent;_ref6=_slicedToArray(_ref5,2);error=_ref6[1];if(!error){_context5.next=12;break;}_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__alerts_actions__["c" /* requestAlert */])(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* feedback */].generic.UNEXPECTED_ERROR,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* alerts */].types.ERROR));case 11:return _context5.abrupt('return',_context5.sent);case 12:_context5.next=14;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* analyticsSharingToggled */])());case 14:case'end':return _context5.stop();}}},_marked5,this);}function watchToggleAnalyticsSharingAllowed(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchToggleAnalyticsSharingAllowed$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_8__constants__["f" /* TOGGLE_ANALYTICS_SHARING_ALLOWED */],Object(__WEBPACK_IMPORTED_MODULE_11__handle_saga__["a" /* default */])(toggleAnalyticsSharingAllowedSaga));case 2:case'end':return _context6.stop();}}},_marked6,this);}/* harmony default export */ __webpack_exports__["a"] = ([userStillActiveDaemonSaga,watchSetPin,watchToggleAnalyticsSharingAllowed]);

/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({notMatching:{id:'user.pins.not-matching',defaultMessage:"Oops! Your new PIN codes don't match. Check they are correct and try again."},pinChanged:{id:'user.pin-changed',defaultMessage:'Your PIN was successfully changed'}}));

/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getWeatherSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_weather__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(455);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getWeatherSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchGetWeatherSaga);function getWeatherSaga(_ref){var _ref$payload=_ref.payload,postcode=_ref$payload.postcode,countryCode=_ref$payload.countryCode;var overrideCode,_ref2,_ref3,weather,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getWeatherSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(!postcode||!countryCode)){_context.next=2;break;}return _context.abrupt('return');case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_4__config_selectors__["a" /* getConfig */],'weather:countryCode');case 4:overrideCode=_context.sent;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_6__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__api_weather__["a" /* getWeather */]),postcode,overrideCode||countryCode);case 7:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);weather=_ref3[0];error=_ref3[1];_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8__actions__["b" /* receivedWeather */])(error||weather));case 13:case'end':return _context.stop();}}},_marked,this);}function watchGetWeatherSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchGetWeatherSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* GET_WEATHER */],Object(__WEBPACK_IMPORTED_MODULE_7__handle_saga__["a" /* default */])(getWeatherSaga));case 2:case'end':return _context2.stop();}}},_marked2,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchGetWeatherSaga]);

/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWeather;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_config__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_url__);
function getWeather(postcode,country){var endpoint=Object(__WEBPACK_IMPORTED_MODULE_0__state_config__["b" /* getFromConfig */])('weatherApi');var _url$parse=__WEBPACK_IMPORTED_MODULE_1_url___default.a.parse(endpoint),host=_url$parse.host,port=_url$parse.port,protocol=_url$parse.protocol,pathname=_url$parse.pathname;var apiUrl=__WEBPACK_IMPORTED_MODULE_1_url___default.a.format({host:host,protocol:protocol,port:port,query:{postcode:postcode,country:country},pathname:pathname});return fetch(apiUrl);}

/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pollBridgeStatusSaga */
/* unused harmony export addChildrenToDashboardSaga */
/* unused harmony export createBridgeSD */
/* unused harmony export searchForBridgeAgain */
/* unused harmony export searchForBridgeSaga */
/* unused harmony export pairWithBridgeSaga */
/* unused harmony export bridgeNodeCreatedSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_install_hue_bridge__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_devices_devices_api__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_saga__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_routes__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__handle_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__handle_saga__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__honeycomb_actions__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__navigate__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_routes__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dashboard_actions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__products_actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__devices_actions__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__products_constants__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__devices_constants__ = __webpack_require__(167);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(pollBridgeStatusSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addChildrenToDashboardSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createBridgeSD),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(searchForBridgeAgain),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(searchForBridgeSaga),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(pairWithBridgeSaga),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(bridgeNodeCreatedSaga),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchHueBridgeNodeCreated),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchSearchForBridge),_marked10=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchPairWithBridge),_marked11=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchPollBridgeStatus),_marked12=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(watchAddChildrenToDashboard);function pollBridgeStatusSaga(_ref){var _ref$payload=_ref.payload,bridgeId=_ref$payload.bridgeId,currentStatus=_ref$payload.currentStatus;var _ref2,_ref3,response,error,status,id;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function pollBridgeStatusSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!bridgeId){_context.next=20;break;}_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_7__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__api_devices_devices_api__["getDevice"]),bridgeId);case 3:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,2);response=_ref3[0];error=_ref3[1];if(error){console.error('This is where error handling will be - part of another story');console.error(error);}status=response.props.status,id=response.id;if(!(status!==currentStatus)){_context.next=12;break;}_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["c" /* bridgeStatusUpdated */])(response));case 12:if(!(status===__WEBPACK_IMPORTED_MODULE_12__constants__["h" /* hueBridgeStatuses */].AUTHENTICATED)){_context.next=15;break;}_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* addChildrenToDashboard */])(id));case 15:if(!__WEBPACK_IMPORTED_MODULE_12__constants__["i" /* transientStatuses */].includes(status)){_context.next=20;break;}_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_redux_saga__["b" /* delay */],2000);case 18:_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["e" /* pollBridgeStatus */])(bridgeId,status));case 20:case'end':return _context.stop();}}},_marked,this);}function addChildrenToDashboardSaga(_ref4){var parent=_ref4.payload.parent;var hueDevices,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,device;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addChildrenToDashboardSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_15__products_actions__["a" /* getProducts */])());case 2:_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_16__devices_actions__["a" /* loadDevices */])());case 4:_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_18__products_constants__["f" /* RECEIVE_PRODUCTS */]),Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_19__devices_constants__["d" /* RECEIVE_DEVICES */])]);case 6:_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["g" /* select */])(__WEBPACK_IMPORTED_MODULE_17__devices_selectors__["E" /* getDevicesByParentId */],{parent:parent});case 8:hueDevices=_context2.sent;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=12;_iterator=hueDevices[Symbol.iterator]();case 14:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context2.next=21;break;}device=_step.value;_context2.next=18;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__dashboard_actions__["g" /* dashboardAddProduct */])(device.id));case 18:_iteratorNormalCompletion=true;_context2.next=14;break;case 21:_context2.next=27;break;case 23:_context2.prev=23;_context2.t0=_context2['catch'](12);_didIteratorError=true;_iteratorError=_context2.t0;case 27:_context2.prev=27;_context2.prev=28;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 30:_context2.prev=30;if(!_didIteratorError){_context2.next=33;break;}throw _iteratorError;case 33:return _context2.finish(30);case 34:return _context2.finish(27);case 35:_context2.next=37;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_14__dashboard_actions__["o" /* saveDashboardEdit */])());case 37:case'end':return _context2.stop();}}},_marked2,this,[[12,23,27,35],[28,,30,34]]);}function createBridgeSD(){var _ref5,_ref6,_ref6$,poll,id,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createBridgeSD$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_7__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api_install_hue_bridge__["a" /* createLinkToBridge */]));case 2:_ref5=_context3.sent;_ref6=_slicedToArray(_ref5,2);_ref6$=_ref6[0];poll=_ref6$.poll;id=_ref6$.id;error=_ref6[1];if(error){console.error('This is where error handling will be - part of another story');console.error(error);}if(!id){_context3.next=14;break;}_context3.next=12;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["b" /* bridgeNodeCreated */])({nodeId:id}));case 12:_context3.next=16;break;case 14:_context3.next=16;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_9__honeycomb_actions__["a" /* pollNodeExists */])({id:poll,nextAction:__WEBPACK_IMPORTED_MODULE_13__actions__["b" /* bridgeNodeCreated */]}));case 16:case'end':return _context3.stop();}}},_marked3,this);}function searchForBridgeAgain(bridgeId){var _ref7,_ref8,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function searchForBridgeAgain$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_7__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api_install_hue_bridge__["c" /* searchForBridgeAgain */]),bridgeId);case 2:_ref7=_context4.sent;_ref8=_slicedToArray(_ref7,2);error=_ref8[1];if(error){console.error('This is where error handling will be - part of another story');console.error(error);}_context4.next=8;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["e" /* pollBridgeStatus */])(bridgeId,__WEBPACK_IMPORTED_MODULE_12__constants__["h" /* hueBridgeStatuses */].SEARCHING));case 8:case'end':return _context4.stop();}}},_marked4,this);}function searchForBridgeSaga(_ref9){var bridgeId=_ref9.payload.bridgeId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function searchForBridgeSaga$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(bridgeId){_context5.next=5;break;}_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(createBridgeSD);case 3:_context5.next=7;break;case 5:_context5.next=7;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(searchForBridgeAgain,bridgeId);case 7:case'end':return _context5.stop();}}},_marked5,this);}function pairWithBridgeSaga(_ref10){var _ref10$payload=_ref10.payload,bridgeId=_ref10$payload.bridgeId,currentStatus=_ref10$payload.currentStatus;var _ref11,_ref12,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function pairWithBridgeSaga$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["b" /* call */])(Object(__WEBPACK_IMPORTED_MODULE_7__handle_api__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__api_install_hue_bridge__["b" /* pairWithBridge */]),bridgeId);case 2:_ref11=_context6.sent;_ref12=_slicedToArray(_ref11,2);error=_ref12[1];if(error){console.error('This is where error handling will be - part of another story');console.error(error);}_context6.next=8;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_13__actions__["e" /* pollBridgeStatus */])(bridgeId,currentStatus));case 8:case'end':return _context6.stop();}}},_marked6,this);}function bridgeNodeCreatedSaga(_ref13){var _ref13$payload=_ref13.payload;_ref13$payload=_ref13$payload===undefined?{}:_ref13$payload;var nodeId=_ref13$payload.nodeId,error=_ref13.error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function bridgeNodeCreatedSaga$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:if(error){_context7.next=3;break;}_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_10__navigate__["b" /* navigate */])(Object(__WEBPACK_IMPORTED_MODULE_11__utils_routes__["a" /* formatPattern */])(__WEBPACK_IMPORTED_MODULE_6__constants_routes__["installPhilipsHue"],{id:nodeId})));case 3:case'end':return _context7.stop();}}},_marked7,this);}function watchHueBridgeNodeCreated(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchHueBridgeNodeCreated$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_12__constants__["c" /* BRIDGE_NODE_CREATED */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_saga__["a" /* default */])(bridgeNodeCreatedSaga));case 2:case'end':return _context8.stop();}}},_marked8,this);}function watchSearchForBridge(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchSearchForBridge$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_12__constants__["g" /* SEARCH_FOR_BRIDGE */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_saga__["a" /* default */])(searchForBridgeSaga));case 2:case'end':return _context9.stop();}}},_marked9,this);}function watchPairWithBridge(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchPairWithBridge$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_12__constants__["e" /* PAIR_WITH_BRIDGE */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_saga__["a" /* default */])(pairWithBridgeSaga));case 2:case'end':return _context10.stop();}}},_marked10,this);}function watchPollBridgeStatus(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchPollBridgeStatus$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_12__constants__["f" /* POLL_HUE_BRIDGE_STATUS */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_saga__["a" /* default */])(pollBridgeStatusSaga));case 2:case'end':return _context11.stop();}}},_marked11,this);}function watchAddChildrenToDashboard(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function watchAddChildrenToDashboard$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_12__constants__["a" /* ADD_CHILDREN_TO_DASHBOARD */],Object(__WEBPACK_IMPORTED_MODULE_8__handle_saga__["a" /* default */])(addChildrenToDashboardSaga));case 2:case'end':return _context12.stop();}}},_marked12,this);}/* harmony default export */ __webpack_exports__["a"] = ([watchSearchForBridge,watchHueBridgeNodeCreated,watchPollBridgeStatus,watchPairWithBridge,watchAddChildrenToDashboard]);

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLinkToBridge;
/* harmony export (immutable) */ __webpack_exports__["b"] = pairWithBridge;
/* harmony export (immutable) */ __webpack_exports__["c"] = searchForBridgeAgain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__ = __webpack_require__(38);
function createLinkToBridge(){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('philips-hue/create');}function pairWithBridge(id){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('philips-hue/pair/'+id);}function searchForBridgeAgain(id){return Object(__WEBPACK_IMPORTED_MODULE_0__helpers_helpers_api__["c" /* httpPost */])('philips-hue/search/'+id);}

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
// @noflow
/* harmony default export */ __webpack_exports__["a"] = (function(){return function(next){return function(action){return next(Object.assign({},action,{meta:Object.assign({},action.meta,{activityStamp:__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().valueOf()})}));};};});

/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_trackers__ = __webpack_require__(1832);
/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__application_trackers__["a" /* default */]]);

/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(40);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (_defineProperty({},__WEBPACK_IMPORTED_MODULE_0__actions__["h" /* logIn */].toString(),[{condition:function condition(_ref){var manualLogin=_ref.manualLogin;return!!manualLogin;},event:function event(){return'Event 1';},values:function values(payload){return{eVar1:payload.user.username};}}]));

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1834),
    baseFlatten = __webpack_require__(231),
    baseRest = __webpack_require__(183),
    isArrayLikeObject = __webpack_require__(307);

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

module.exports = difference;


/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(290),
    arrayIncludes = __webpack_require__(279),
    arrayIncludesWith = __webpack_require__(443),
    arrayMap = __webpack_require__(82),
    baseUnary = __webpack_require__(228),
    cacheHas = __webpack_require__(291);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(231),
    baseRest = __webpack_require__(183),
    baseUniq = __webpack_require__(442),
    isArrayLikeObject = __webpack_require__(307);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = persistState;

var _mapValues = __webpack_require__(1837);

var _mapValues2 = _interopRequireDefault(_mapValues);

var _identity = __webpack_require__(150);

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function persistState(sessionId) {
  var deserializeState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
  var deserializeAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity2.default;

  if (!sessionId) {
    return function (next) {
      return function () {
        return next.apply(undefined, arguments);
      };
    };
  }

  function deserialize(state) {
    return _extends({}, state, {
      actionsById: (0, _mapValues2.default)(state.actionsById, function (liftedAction) {
        return _extends({}, liftedAction, {
          action: deserializeAction(liftedAction.action)
        });
      }),
      committedState: deserializeState(state.committedState),
      computedStates: state.computedStates.map(function (computedState) {
        return _extends({}, computedState, {
          state: deserializeState(computedState.state)
        });
      })
    });
  }

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var key = 'redux-dev-session-' + sessionId;

      var finalInitialState = void 0;
      try {
        var json = localStorage.getItem(key);
        if (json) {
          finalInitialState = deserialize(JSON.parse(json)) || initialState;
          next(reducer, initialState);
        }
      } catch (e) {
        console.warn('Could not read debug session from localStorage:', e);
        try {
          localStorage.removeItem(key);
        } finally {
          finalInitialState = undefined;
        }
      }

      var store = next(reducer, finalInitialState, enhancer);

      return _extends({}, store, {
        dispatch: function dispatch(action) {
          store.dispatch(action);

          try {
            localStorage.setItem(key, JSON.stringify(store.getState()));
          } catch (e) {
            console.warn('Could not write debug session to localStorage:', e);
          }

          return action;
        }
      });
    };
  };
}

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(224),
    baseForOwn = __webpack_require__(620),
    baseIteratee = __webpack_require__(55);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createDevTools;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(8);

var _reduxDevtoolsInstrument = __webpack_require__(714);

var _reduxDevtoolsInstrument2 = _interopRequireDefault(_reduxDevtoolsInstrument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createDevTools(children) {
  var _class, _temp;

  var monitorElement = _react.Children.only(children);
  var monitorProps = monitorElement.props;
  var Monitor = monitorElement.type;
  var ConnectedMonitor = (0, _reactRedux.connect)(function (state) {
    return state;
  })(Monitor);

  return _temp = _class = function (_Component) {
    _inherits(DevTools, _Component);

    function DevTools(props, context) {
      _classCallCheck(this, DevTools);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      if (!props.store && !context.store) {
        console.error('Redux DevTools could not render. You must pass the Redux store ' + 'to <DevTools> either as a "store" prop or by wrapping it in a ' + '<Provider store={store}>.');
        return _possibleConstructorReturn(_this);
      }

      if (context.store) {
        _this.liftedStore = context.store.liftedStore;
      } else {
        _this.liftedStore = props.store.liftedStore;
      }

      if (!_this.liftedStore) {
        console.error('Redux DevTools could not render. Did you forget to include ' + 'DevTools.instrument() in your store enhancer chain before ' + 'using createStore()?');
      }
      return _this;
    }

    DevTools.prototype.render = function render() {
      if (!this.liftedStore) {
        return null;
      }

      return _react2.default.createElement(ConnectedMonitor, _extends({}, monitorProps, {
        store: this.liftedStore }));
    };

    return DevTools;
  }(_react.Component), _class.contextTypes = {
    store: _propTypes2.default.object
  }, _class.propTypes = {
    store: _propTypes2.default.object
  }, _class.instrument = function (options) {
    return (0, _reduxDevtoolsInstrument2.default)(function (state, action) {
      return Monitor.update(monitorProps, state, action);
    }, options);
  }, _temp;
}

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _DockMonitor = __webpack_require__(1840);

var _DockMonitor2 = _interopRequireDefault(_DockMonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DockMonitor2.default;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDock = __webpack_require__(1841);

var _reactDock2 = _interopRequireDefault(_reactDock);

var _constants = __webpack_require__(716);

var _actions = __webpack_require__(717);

var _reducers = __webpack_require__(1845);

var _reducers2 = _interopRequireDefault(_reducers);

var _parseKey = __webpack_require__(1846);

var _parseKey2 = _interopRequireDefault(_parseKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DockMonitor = function (_Component) {
  _inherits(DockMonitor, _Component);

  function DockMonitor(props) {
    _classCallCheck(this, DockMonitor);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleSizeChange = _this.handleSizeChange.bind(_this);

    var childrenCount = _react.Children.count(props.children);
    if (childrenCount === 0) {
      console.error('<DockMonitor> requires at least one monitor inside. ' + 'Why don’t you try <LogMonitor>? You can get it at ' + 'https://github.com/gaearon/redux-devtools-log-monitor.');
    } else if (childrenCount > 1 && !props.changeMonitorKey) {
      console.error('You specified multiple monitors inside <DockMonitor> ' + 'but did not provide `changeMonitorKey` prop to change them. ' + 'Try specifying <DockMonitor changeMonitorKey="ctrl-m" /> ' + 'and then press Ctrl-M.');
    }
    return _this;
  }

  DockMonitor.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  };

  DockMonitor.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  };

  DockMonitor.prototype.matchesKey = function matchesKey(key, event) {
    if (!key) {
      return false;
    }

    var charCode = event.keyCode || event.which;
    var char = String.fromCharCode(charCode);
    return key.name.toUpperCase() === char.toUpperCase() && key.alt === event.altKey && key.ctrl === event.ctrlKey && key.meta === event.metaKey && key.shift === event.shiftKey;
  };

  DockMonitor.prototype.handleKeyDown = function handleKeyDown(e) {
    // Ignore regular keys when focused on a field
    // and no modifiers are active.
    if (!e.ctrlKey && !e.metaKey && !e.altKey && (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable)) {
      return;
    }

    var visibilityKey = (0, _parseKey2.default)(this.props.toggleVisibilityKey);
    var positionKey = (0, _parseKey2.default)(this.props.changePositionKey);

    var monitorKey = void 0;
    if (this.props.changeMonitorKey) {
      monitorKey = (0, _parseKey2.default)(this.props.changeMonitorKey);
    }

    if (this.matchesKey(visibilityKey, e)) {
      e.preventDefault();
      this.props.dispatch((0, _actions.toggleVisibility)());
    } else if (this.matchesKey(positionKey, e)) {
      e.preventDefault();
      this.props.dispatch((0, _actions.changePosition)());
    } else if (this.matchesKey(monitorKey, e)) {
      e.preventDefault();
      this.props.dispatch((0, _actions.changeMonitor)());
    }
  };

  DockMonitor.prototype.handleSizeChange = function handleSizeChange(requestedSize) {
    this.props.dispatch((0, _actions.changeSize)(requestedSize));
  };

  DockMonitor.prototype.renderChild = function renderChild(child, index, otherProps) {
    var monitorState = this.props.monitorState;
    var childMonitorIndex = monitorState.childMonitorIndex,
        childMonitorStates = monitorState.childMonitorStates;


    if (index !== childMonitorIndex) {
      return null;
    }

    return (0, _react.cloneElement)(child, _extends({
      monitorState: childMonitorStates[index]
    }, otherProps));
  };

  DockMonitor.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        monitorState = _props.monitorState,
        children = _props.children,
        fluid = _props.fluid,
        rest = _objectWithoutProperties(_props, ['monitorState', 'children', 'fluid']);

    var position = monitorState.position,
        isVisible = monitorState.isVisible,
        size = monitorState.size;


    return _react2.default.createElement(
      _reactDock2.default,
      { position: position,
        isVisible: isVisible,
        size: size,
        fluid: fluid,
        onSizeChange: this.handleSizeChange,
        dimMode: 'none' },
      _react.Children.map(children, function (child, index) {
        return _this2.renderChild(child, index, rest);
      })
    );
  };

  return DockMonitor;
}(_react.Component);

DockMonitor.update = _reducers2.default;
DockMonitor.propTypes = {
  defaultPosition: _propTypes2.default.oneOf(_constants.POSITIONS),
  defaultIsVisible: _propTypes2.default.bool.isRequired,
  defaultSize: _propTypes2.default.number.isRequired,
  toggleVisibilityKey: _propTypes2.default.string.isRequired,
  changePositionKey: _propTypes2.default.string.isRequired,
  changeMonitorKey: _propTypes2.default.string,
  fluid: _propTypes2.default.bool,

  dispatch: _propTypes2.default.func,
  monitorState: _propTypes2.default.shape({
    position: _propTypes2.default.oneOf(_constants.POSITIONS).isRequired,
    size: _propTypes2.default.number.isRequired,
    isVisible: _propTypes2.default.bool.isRequired,
    childMonitorState: _propTypes2.default.any
  })
};
DockMonitor.defaultProps = {
  defaultIsVisible: true,
  defaultPosition: 'right',
  defaultSize: 0.3,
  fluid: true
};
exports.default = DockMonitor;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dock = __webpack_require__(1842);

var _Dock2 = _interopRequireDefault(_Dock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dock2.default;

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(1843);

var _lodash2 = _interopRequireDefault(_lodash);

var _autoprefix = __webpack_require__(1844);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function autoprefixes(styles) {
  return Object.keys(styles).reduce(function (obj, key) {
    return obj[key] = (0, _autoprefix2.default)(styles[key]), obj;
  }, {});
}

var styles = autoprefixes({
  wrapper: {
    position: 'fixed',
    width: 0,
    height: 0,
    top: 0,
    left: 0
  },

  dim: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 0,
    background: 'rgba(0, 0, 0, 0.2)',
    opacity: 1
  },

  dimAppear: {
    opacity: 0
  },

  dimTransparent: {
    pointerEvents: 'none'
  },

  dimHidden: {
    opacity: 0
  },

  dock: {
    position: 'fixed',
    zIndex: 1,
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
    background: 'white',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
  },

  dockHidden: {
    opacity: 0
  },

  dockResizing: {
    transition: 'none'
  },

  dockContent: {
    width: '100%',
    height: '100%',
    overflow: 'auto'
  },

  resizer: {
    position: 'absolute',
    zIndex: 2,
    opacity: 0
  }
});

function getTransitions(duration) {
  return ['left', 'top', 'width', 'height'].map(function (p) {
    return p + ' ' + duration / 1000 + 's ease-out';
  });
}

function getDockStyles(_ref, _ref2) {
  var fluid = _ref.fluid;
  var dockStyle = _ref.dockStyle;
  var dockHiddenStyle = _ref.dockHiddenStyle;
  var duration = _ref.duration;
  var position = _ref.position;
  var isVisible = _ref.isVisible;
  var size = _ref2.size;
  var isResizing = _ref2.isResizing;
  var fullWidth = _ref2.fullWidth;
  var fullHeight = _ref2.fullHeight;

  var posStyle = void 0;
  var absSize = fluid ? size * 100 + '%' : size + 'px';

  function getRestSize(fullSize) {
    return fluid ? 100 - size * 100 + '%' : fullSize - size + 'px';
  }

  switch (position) {
    case 'left':
      posStyle = {
        width: absSize,
        left: isVisible ? 0 : '-' + absSize
      };
      break;
    case 'right':
      posStyle = {
        left: isVisible ? getRestSize(fullWidth) : fullWidth,
        width: absSize
      };
      break;
    case 'top':
      posStyle = {
        top: isVisible ? 0 : '-' + absSize,
        height: absSize
      };
      break;
    case 'bottom':
      posStyle = {
        top: isVisible ? getRestSize(fullHeight) : fullHeight,
        height: absSize
      };
      break;
  }

  var transitions = getTransitions(duration);

  return [styles.dock, (0, _autoprefix2.default)({
    transition: [].concat(_toConsumableArray(transitions), [!isVisible && 'opacity 0.01s linear ' + duration / 1000 + 's']).filter(function (t) {
      return t;
    }).join(',')
  }), dockStyle, (0, _autoprefix2.default)(posStyle), isResizing && styles.dockResizing, !isVisible && styles.dockHidden, !isVisible && dockHiddenStyle];
}

function getDimStyles(_ref3, _ref4) {
  var dimMode = _ref3.dimMode;
  var dimStyle = _ref3.dimStyle;
  var duration = _ref3.duration;
  var isVisible = _ref3.isVisible;
  var isTransitionStarted = _ref4.isTransitionStarted;

  return [styles.dim, (0, _autoprefix2.default)({
    transition: 'opacity ' + duration / 1000 + 's ease-out'
  }), dimStyle, dimMode === 'transparent' && styles.dimTransparent, !isVisible && styles.dimHidden, isTransitionStarted && isVisible && styles.dimAppear, isTransitionStarted && !isVisible && styles.dimDisappear];
}

function getResizerStyles(position) {
  var resizerStyle = void 0;
  var size = 10;

  switch (position) {
    case 'left':
      resizerStyle = {
        right: -size / 2,
        width: size,
        top: 0,
        height: '100%',
        cursor: 'col-resize'
      };
      break;
    case 'right':
      resizerStyle = {
        left: -size / 2,
        width: size,
        top: 0,
        height: '100%',
        cursor: 'col-resize'
      };
      break;
    case 'top':
      resizerStyle = {
        bottom: -size / 2,
        height: size,
        left: 0,
        width: '100%',
        cursor: 'row-resize'
      };
      break;
    case 'bottom':
      resizerStyle = {
        top: -size / 2,
        height: size,
        left: 0,
        width: '100%',
        cursor: 'row-resize'
      };
      break;
  }

  return [styles.resizer, (0, _autoprefix2.default)(resizerStyle)];
}

function getFullSize(position, fullWidth, fullHeight) {
  return position === 'left' || position === 'right' ? fullWidth : fullHeight;
}

var Dock = (_temp = _class = function (_Component) {
  _inherits(Dock, _Component);

  function Dock(props) {
    _classCallCheck(this, Dock);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dock).call(this, props));

    _this.transitionEnd = function () {
      _this.setState({ isTransitionStarted: false });
    };

    _this.hideDim = function () {
      if (!_this.props.isVisible) {
        _this.setState({ isDimHidden: true });
      }
    };

    _this.handleDimClick = function () {
      if (_this.props.dimMode === 'opaque') {
        _this.props.onVisibleChange && _this.props.onVisibleChange(false);
      }
    };

    _this.handleResize = function () {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(_this.updateWindowSize.bind(_this, true));
      } else {
        _this.updateWindowSize(true);
      }
    };

    _this.updateWindowSize = function (windowResize) {
      var sizeState = {
        fullWidth: window.innerWidth,
        fullHeight: window.innerHeight
      };

      if (windowResize) {
        _this.setState(_extends({}, sizeState, {
          isResizing: true,
          isWindowResizing: windowResize
        }));

        _this.debouncedUpdateWindowSizeEnd();
      } else {
        _this.setState(sizeState);
      }
    };

    _this.updateWindowSizeEnd = function () {
      _this.setState({
        isResizing: false,
        isWindowResizing: false
      });
    };

    _this.debouncedUpdateWindowSizeEnd = (0, _lodash2.default)(_this.updateWindowSizeEnd, 30);

    _this.handleWrapperLeave = function () {
      _this.setState({ isResizing: false });
    };

    _this.handleMouseDown = function () {
      _this.setState({ isResizing: true });
    };

    _this.handleMouseUp = function () {
      _this.setState({ isResizing: false });
    };

    _this.handleMouseMove = function (e) {
      if (!_this.state.isResizing || _this.state.isWindowResizing) return;
      e.preventDefault();

      var _this$props = _this.props;
      var position = _this$props.position;
      var fluid = _this$props.fluid;
      var _this$state = _this.state;
      var fullWidth = _this$state.fullWidth;
      var fullHeight = _this$state.fullHeight;
      var isControlled = _this$state.isControlled;
      var x = e.clientX;
      var y = e.clientY;

      var size = void 0;

      switch (position) {
        case 'left':
          size = fluid ? x / fullWidth : x;
          break;
        case 'right':
          size = fluid ? (fullWidth - x) / fullWidth : fullWidth - x;
          break;
        case 'top':
          size = fluid ? y / fullHeight : y;
          break;
        case 'bottom':
          size = fluid ? (fullHeight - y) / fullHeight : fullHeight - y;
          break;
      }

      _this.props.onSizeChange && _this.props.onSizeChange(size);

      if (!isControlled) {
        _this.setState({ size: size });
      }
    };

    _this.state = {
      isControlled: typeof props.size !== 'undefined',
      size: props.size || props.defaultSize,
      isDimHidden: !props.isVisible,
      fullWidth: typeof window !== 'undefined' && window.innerWidth,
      fullHeight: typeof window !== 'undefined' && window.innerHeight,
      isTransitionStarted: false,
      isWindowResizing: false
    };
    return _this;
  }

  _createClass(Dock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('mouseup', this.handleMouseUp);
      window.addEventListener('mousemove', this.handleMouseMove);
      window.addEventListener('resize', this.handleResize);

      if (!window.fullWidth) {
        this.updateWindowSize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('mouseup', this.handleMouseUp);
      window.removeEventListener('mousemove', this.handleMouseMove);
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isControlled = typeof nextProps.size !== 'undefined';

      this.setState({ isControlled: isControlled });

      if (isControlled && this.props.size !== nextProps.size) {
        this.setState({ size: nextProps.size });
      } else if (this.props.fluid !== nextProps.fluid) {
        this.updateSize(nextProps);
      }

      if (this.props.isVisible !== nextProps.isVisible) {
        this.setState({
          isTransitionStarted: true
        });
      }
    }
  }, {
    key: 'updateSize',
    value: function updateSize(props) {
      var _state = this.state;
      var fullWidth = _state.fullWidth;
      var fullHeight = _state.fullHeight;


      this.setState({
        size: props.fluid ? this.state.size / getFullSize(props.position, fullWidth, fullHeight) : getFullSize(props.position, fullWidth, fullHeight) * this.state.size
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (this.props.isVisible !== prevProps.isVisible) {
        if (!this.props.isVisible) {
          window.setTimeout(function () {
            return _this2.hideDim();
          }, this.props.duration);
        } else {
          this.setState({ isDimHidden: false });
        }

        window.setTimeout(function () {
          return _this2.setState({ isTransitionStarted: false });
        }, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var zIndex = _props.zIndex;
      var dimMode = _props.dimMode;
      var position = _props.position;
      var isVisible = _props.isVisible;
      var _state2 = this.state;
      var isResizing = _state2.isResizing;
      var size = _state2.size;
      var isDimHidden = _state2.isDimHidden;


      var dimStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDimStyles(this.props, this.state))));
      var dockStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDockStyles(this.props, this.state))));
      var resizerStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getResizerStyles(position))));

      return _react2.default.createElement(
        'div',
        { style: Object.assign({}, styles.wrapper, { zIndex: zIndex }) },
        dimMode !== 'none' && !isDimHidden && _react2.default.createElement('div', { style: dimStyles, onClick: this.handleDimClick }),
        _react2.default.createElement(
          'div',
          { style: dockStyles },
          _react2.default.createElement('div', { style: resizerStyles,
            onMouseDown: this.handleMouseDown }),
          _react2.default.createElement(
            'div',
            { style: styles.dockContent },
            typeof children === 'function' ? children({
              position: position,
              isResizing: isResizing,
              size: size,
              isVisible: isVisible
            }) : children
          )
        )
      );
    }
  }]);

  return Dock;
}(_react.Component), _class.propTypes = {
  position: _propTypes2.default.oneOf(['left', 'right', 'top', 'bottom']),
  zIndex: _propTypes2.default.number,
  fluid: _propTypes2.default.bool,
  size: _propTypes2.default.number,
  defaultSize: _propTypes2.default.number,
  dimMode: _propTypes2.default.oneOf(['none', 'transparent', 'opaque']),
  isVisible: _propTypes2.default.bool,
  onVisibleChange: _propTypes2.default.func,
  onSizeChange: _propTypes2.default.func,
  dimStyle: _propTypes2.default.object,
  dockStyle: _propTypes2.default.object,
  duration: _propTypes2.default.number
}, _class.defaultProps = {
  position: 'left',
  zIndex: 99999999,
  fluid: true,
  defaultSize: 0.3,
  dimMode: 'opaque',
  duration: 200
}, _temp);
exports.default = Dock;

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(715);

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeNow = getNative(Date, 'now');

/**
 * Gets the number of milliseconds that have elapsed since the Unix epoch
 * (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @category Date
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => logs the number of milliseconds it took for the deferred function to be invoked
 */
var now = nativeNow || function() {
  return new Date().getTime();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed invocations. Provide an options object to indicate that `func`
 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
 * Subsequent calls to the debounced function return the result of the last
 * `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
 * on the trailing edge of the timeout only if the the debounced function is
 * invoked more than once during the `wait` timeout.
 *
 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.leading=false] Specify invoking on the leading
 *  edge of the timeout.
 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
 *  delayed before it is invoked.
 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
 *  edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // avoid costly calculations while the window size is in flux
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // ensure `batchLog` is invoked once after 1 second of debounced calls
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', _.debounce(batchLog, 250, {
 *   'maxWait': 1000
 * }));
 *
 * // cancel a debounced call
 * var todoChanges = _.debounce(batchLog, 1000);
 * Object.observe(models.todo, todoChanges);
 *
 * Object.observe(models, function(changes) {
 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
 *     todoChanges.cancel();
 *   }
 * }, ['delete']);
 *
 * // ...at some point `models.todo` is changed
 * models.todo.completed = true;
 *
 * // ...before 1 second has passed `models.todo` is deleted
 * // which cancels the debounced `todoChanges` call
 * delete models.todo;
 */
function debounce(func, wait, options) {
  var args,
      maxTimeoutId,
      result,
      stamp,
      thisArg,
      timeoutId,
      trailingCall,
      lastCalled = 0,
      maxWait = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = wait < 0 ? 0 : (+wait || 0);
  if (options === true) {
    var leading = true;
    trailing = false;
  } else if (isObject(options)) {
    leading = !!options.leading;
    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (maxTimeoutId) {
      clearTimeout(maxTimeoutId);
    }
    lastCalled = 0;
    maxTimeoutId = timeoutId = trailingCall = undefined;
  }

  function complete(isCalled, id) {
    if (id) {
      clearTimeout(id);
    }
    maxTimeoutId = timeoutId = trailingCall = undefined;
    if (isCalled) {
      lastCalled = now();
      result = func.apply(thisArg, args);
      if (!timeoutId && !maxTimeoutId) {
        args = thisArg = undefined;
      }
    }
  }

  function delayed() {
    var remaining = wait - (now() - stamp);
    if (remaining <= 0 || remaining > wait) {
      complete(trailingCall, maxTimeoutId);
    } else {
      timeoutId = setTimeout(delayed, remaining);
    }
  }

  function maxDelayed() {
    complete(trailing, timeoutId);
  }

  function debounced() {
    args = arguments;
    stamp = now();
    thisArg = this;
    trailingCall = trailing && (timeoutId || !leading);

    if (maxWait === false) {
      var leadingCall = leading && !timeoutId;
    } else {
      if (!maxTimeoutId && !leading) {
        lastCalled = stamp;
      }
      var remaining = maxWait - (stamp - lastCalled),
          isCalled = remaining <= 0 || remaining > maxWait;

      if (isCalled) {
        if (maxTimeoutId) {
          maxTimeoutId = clearTimeout(maxTimeoutId);
        }
        lastCalled = stamp;
        result = func.apply(thisArg, args);
      }
      else if (!maxTimeoutId) {
        maxTimeoutId = setTimeout(maxDelayed, remaining);
      }
    }
    if (isCalled && timeoutId) {
      timeoutId = clearTimeout(timeoutId);
    }
    else if (!timeoutId && wait !== maxWait) {
      timeoutId = setTimeout(delayed, wait);
    }
    if (leadingCall) {
      isCalled = true;
      result = func.apply(thisArg, args);
    }
    if (isCalled && !timeoutId && !maxTimeoutId) {
      args = thisArg = undefined;
    }
    return result;
  }
  debounced.cancel = cancel;
  return debounced;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = debounce;


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = autoprefix;
// Same as https://github.com/SimenB/react-vendor-prefixes/blob/master/src/index.js,
// but dumber

var vendorSpecificProperties = ['animation', 'animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction', 'appearance', 'backfaceVisibility', 'backgroundClip', 'borderImage', 'borderImageSlice', 'boxSizing', 'boxShadow', 'contentColumns', 'transform', 'transformOrigin', 'transformStyle', 'transition', 'transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction', 'perspective', 'perspectiveOrigin', 'userSelect'];

var prefixes = ['Moz', 'Webkit', 'ms', 'O'];

function prefixProp(key, value) {
  return prefixes.reduce(function (obj, pre) {
    return obj[pre + key[0].toUpperCase() + key.substr(1)] = value, obj;
  }, {});
}

function autoprefix(style) {
  return Object.keys(style).reduce(function (obj, key) {
    return vendorSpecificProperties.indexOf(key) !== -1 ? _extends({}, obj, prefixProp(key, style[key])) : obj;
  }, style);
}

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = reducer;

var _actions = __webpack_require__(717);

var _constants = __webpack_require__(716);

var _react = __webpack_require__(0);

function position(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultPosition;
  var action = arguments[2];

  return action.type === _actions.CHANGE_POSITION ? _constants.POSITIONS[(_constants.POSITIONS.indexOf(state) + 1) % _constants.POSITIONS.length] : state;
}

function size(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultSize;
  var action = arguments[2];

  return action.type === _actions.CHANGE_SIZE ? action.size : state;
}

function isVisible(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultIsVisible;
  var action = arguments[2];

  return action.type === _actions.TOGGLE_VISIBILITY ? !state : state;
}

function childMonitorStates(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var action = arguments[2];

  return _react.Children.map(props.children, function (child, index) {
    return child.type.update(child.props, state[index], action);
  });
}

function childMonitorIndex(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var action = arguments[2];

  switch (action.type) {
    case _actions.CHANGE_MONITOR:
      return (state + 1) % _react.Children.count(props.children);
    default:
      return state;
  }
}

function reducer(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var action = arguments[2];

  if (!state.childMonitorStates) {
    _react.Children.forEach(props.children, function (child, index) {
      if (typeof child.type.update !== 'function') {
        console.error('Child of <DockMonitor> with the index ' + index + ' ' + ('(' + (child.type.displayName || child.type.name || child.type) + ') ') + 'does not appear to be a valid Redux DevTools monitor.');
      }
    });
  }

  return {
    position: position(props, state.position, action),
    isVisible: isVisible(props, state.isVisible, action),
    size: size(props, state.size, action),
    childMonitorIndex: childMonitorIndex(props, state.childMonitorIndex, action),
    childMonitorStates: childMonitorStates(props, state.childMonitorStates, action)
  };
}

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keycodes = __webpack_require__(1847);

function assertKeyString(s) {
  if (!/^(ctrl-|shift-|alt-|meta-){0,4}\w+$/.test(s))
    throw new Error('The string to parse needs to be of the format "c", "ctrl-c", "shift-ctrl-c".');
}

module.exports = function parse(s) {
  var keyString = s.trim().toLowerCase();

  assertKeyString(keyString);

  var key = {
      name     :  undefined
    , ctrl     :  false
    , meta     :  false
    , shift    :  false
    , alt      :  false
    , sequence :  undefined
  }
  , parts = keyString.split('-')
  , c;

  key.name = parts.pop();
  while((c = parts.pop())) key[c] = true;
  key.sequence = key.ctrl 
    ? keycodes.ctrl[key.name] || key.name
    : keycodes.nomod[key.name] || key.name;

  // uppercase sequence for single chars when shift was pressed
  if (key.shift && key.sequence && key.sequence.length === 1)
    key.sequence = key.sequence.toUpperCase();

  return key;
};


/***/ }),
/* 1847 */
/***/ (function(module, exports) {

// Most of these are according to this table: http://www.ssicom.org/js/x171166.htm
// However where nodejs readline diverges, they are adjusted to conform to it
module.exports = {
  nomod: {
      escape: '\u001b'
    , space: ' ' // actually '\u0020'
    }
  , ctrl: {
        ' ': '\u0000'
      , 'a': '\u0001'
      , 'b': '\u0002'
      , 'c': '\u0003'
      , 'd': '\u0004'
      , 'e': '\u0005'
      , 'f': '\u0006'
      , 'g': '\u0007'
      , 'h': '\u0008'
      , 'i': '\u0009'
      , 'j': '\u000a'
      , 'k': '\u000b'
      , 'm': '\u000c'
      , 'n': '\u000d'
      , 'l': '\u000e'
      , 'o': '\u000f'
      , 'p': '\u0010'
      , 'q': '\u0011'
      , 'r': '\u0012'
      , 's': '\u0013'
      , 't': '\u0014'
      , 'u': '\u0015'
      , 'v': '\u0016'
      , 'w': '\u0017'
      , 'x': '\u0018'
      , 'y': '\u0019'
      , 'z': '\u001a'
      , '[': '\u001b'
      , '\\':'\u001c'
      , ']': '\u001d'
      , '^': '\u001e'
      , '_': '\u001f'

      , 'space': '\u0000'
    }
};


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _LogMonitor = __webpack_require__(1849);

var _LogMonitor2 = _interopRequireDefault(_LogMonitor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LogMonitor2.default;

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _function = __webpack_require__(242);

var _function2 = _interopRequireDefault(_function);

var _reduxDevtoolsThemes = __webpack_require__(1851);

var themes = _interopRequireWildcard(_reduxDevtoolsThemes);

var _reduxDevtools = __webpack_require__(458);

var _actions = __webpack_require__(719);

var _reducers = __webpack_require__(1890);

var _reducers2 = _interopRequireDefault(_reducers);

var _LogMonitorButtonBar = __webpack_require__(1891);

var _LogMonitorButtonBar2 = _interopRequireDefault(_LogMonitorButtonBar);

var _LogMonitorEntryList = __webpack_require__(1894);

var _LogMonitorEntryList2 = _interopRequireDefault(_LogMonitorEntryList);

var _lodash = __webpack_require__(1964);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var toggleAction = _reduxDevtools.ActionCreators.toggleAction;
var setActionsActive = _reduxDevtools.ActionCreators.setActionsActive;


var styles = {
  container: {
    fontFamily: 'monaco, Consolas, Lucida Console, monospace',
    position: 'relative',
    overflowY: 'hidden',
    width: '100%',
    height: '100%',
    minWidth: 300,
    direction: 'ltr'
  },
  elements: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    overflowX: 'hidden',
    overflowY: 'auto'
  }
};

var LogMonitor = function (_Component) {
  _inherits(LogMonitor, _Component);

  function LogMonitor(props) {
    _classCallCheck(this, LogMonitor);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.shouldComponentUpdate = _function2.default;
    _this.updateScrollTop = (0, _lodash2.default)(function () {
      var node = _this.node;
      _this.props.dispatch((0, _actions.updateScrollTop)(node ? node.scrollTop : 0));
    }, 500);

    _this.handleToggleAction = _this.handleToggleAction.bind(_this);
    _this.handleToggleConsecutiveAction = _this.handleToggleConsecutiveAction.bind(_this);
    _this.getRef = _this.getRef.bind(_this);
    return _this;
  }

  LogMonitor.prototype.scroll = function scroll() {
    var node = this.node;
    if (!node) {
      return;
    }
    if (this.scrollDown) {
      var offsetHeight = node.offsetHeight;
      var scrollHeight = node.scrollHeight;

      node.scrollTop = scrollHeight - offsetHeight;
      this.scrollDown = false;
    }
  };

  LogMonitor.prototype.componentDidMount = function componentDidMount() {
    var node = this.node;
    if (!node || !this.props.monitorState) {
      return;
    }

    if (this.props.preserveScrollTop) {
      node.scrollTop = this.props.monitorState.initialScrollTop;
      node.addEventListener('scroll', this.updateScrollTop);
    } else {
      this.scrollDown = true;
      this.scroll();
    }
  };

  LogMonitor.prototype.componentWillUnmount = function componentWillUnmount() {
    var node = this.node;
    if (node && this.props.preserveScrollTop) {
      node.removeEventListener('scroll', this.updateScrollTop);
    }
  };

  LogMonitor.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var node = this.node;
    if (!node) {
      this.scrollDown = true;
    } else if (this.props.stagedActionIds.length < nextProps.stagedActionIds.length) {
      var scrollTop = node.scrollTop;
      var offsetHeight = node.offsetHeight;
      var scrollHeight = node.scrollHeight;


      this.scrollDown = Math.abs(scrollHeight - (scrollTop + offsetHeight)) < 20;
    } else {
      this.scrollDown = false;
    }
  };

  LogMonitor.prototype.componentDidUpdate = function componentDidUpdate() {
    this.scroll();
  };

  LogMonitor.prototype.handleToggleAction = function handleToggleAction(id) {
    this.props.dispatch(toggleAction(id));
  };

  LogMonitor.prototype.handleToggleConsecutiveAction = function handleToggleConsecutiveAction(id) {
    var _props = this.props;
    var monitorState = _props.monitorState;
    var actionsById = _props.actionsById;
    var consecutiveToggleStartId = monitorState.consecutiveToggleStartId;

    if (consecutiveToggleStartId && actionsById[consecutiveToggleStartId]) {
      var skippedActionIds = this.props.skippedActionIds;

      var start = Math.min(consecutiveToggleStartId, id);
      var end = Math.max(consecutiveToggleStartId, id);
      var active = skippedActionIds.indexOf(consecutiveToggleStartId) > -1;
      this.props.dispatch(setActionsActive(start, end + 1, active));
      this.props.dispatch((0, _actions.startConsecutiveToggle)(null));
    } else if (id > 0) {
      this.props.dispatch((0, _actions.startConsecutiveToggle)(id));
    }
  };

  LogMonitor.prototype.getTheme = function getTheme() {
    var theme = this.props.theme;

    if (typeof theme !== 'string') {
      return theme;
    }

    if (typeof themes[theme] !== 'undefined') {
      return themes[theme];
    }

    console.warn('DevTools theme ' + theme + ' not found, defaulting to nicinabox');
    return themes.nicinabox;
  };

  LogMonitor.prototype.getRef = function getRef(node) {
    this.node = node;
  };

  LogMonitor.prototype.render = function render() {
    var theme = this.getTheme();
    var consecutiveToggleStartId = this.props.monitorState.consecutiveToggleStartId;
    var _props2 = this.props;
    var dispatch = _props2.dispatch;
    var actionsById = _props2.actionsById;
    var skippedActionIds = _props2.skippedActionIds;
    var stagedActionIds = _props2.stagedActionIds;
    var computedStates = _props2.computedStates;
    var currentStateIndex = _props2.currentStateIndex;
    var select = _props2.select;
    var expandActionRoot = _props2.expandActionRoot;
    var expandStateRoot = _props2.expandStateRoot;
    var markStateDiff = _props2.markStateDiff;


    var entryListProps = {
      theme: theme,
      actionsById: actionsById,
      skippedActionIds: skippedActionIds,
      stagedActionIds: stagedActionIds,
      computedStates: computedStates,
      currentStateIndex: currentStateIndex,
      consecutiveToggleStartId: consecutiveToggleStartId,
      select: select,
      expandActionRoot: expandActionRoot,
      expandStateRoot: expandStateRoot,
      markStateDiff: markStateDiff,
      onActionClick: this.handleToggleAction,
      onActionShiftClick: this.handleToggleConsecutiveAction
    };

    return _react2.default.createElement(
      'div',
      { style: _extends({}, styles.container, { backgroundColor: theme.base00 }) },
      !this.props.hideMainButtons && _react2.default.createElement(_LogMonitorButtonBar2.default, {
        theme: theme,
        dispatch: dispatch,
        hasStates: computedStates.length > 1,
        hasSkippedActions: skippedActionIds.length > 0
      }),
      _react2.default.createElement(
        'div',
        {
          style: this.props.hideMainButtons ? styles.elements : _extends({}, styles.elements, { top: 30 }),
          ref: this.getRef
        },
        _react2.default.createElement(_LogMonitorEntryList2.default, entryListProps)
      )
    );
  };

  return LogMonitor;
}(_react.Component);

LogMonitor.update = _reducers2.default;
LogMonitor.propTypes = {
  dispatch: _propTypes2.default.func,
  computedStates: _propTypes2.default.array,
  actionsById: _propTypes2.default.object,
  stagedActionIds: _propTypes2.default.array,
  skippedActionIds: _propTypes2.default.array,
  monitorState: _propTypes2.default.shape({
    initialScrollTop: _propTypes2.default.number,
    consecutiveToggleStartId: _propTypes2.default.number
  }),

  preserveScrollTop: _propTypes2.default.bool,
  select: _propTypes2.default.func,
  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  expandActionRoot: _propTypes2.default.bool,
  expandStateRoot: _propTypes2.default.bool,
  markStateDiff: _propTypes2.default.bool,
  hideMainButtons: _propTypes2.default.bool
};
LogMonitor.defaultProps = {
  select: function select(state) {
    return state;
  },
  theme: 'nicinabox',
  preserveScrollTop: true,
  expandActionRoot: true,
  expandStateRoot: true,
  markStateDiff: false
};
exports.default = LogMonitor;

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = shallowEqual;

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

var _base16 = __webpack_require__(718);

_defaults(exports, _interopExportWildcard(_base16, _defaults));

var _nicinabox = __webpack_require__(1889);

exports.nicinabox = _interopRequire(_nicinabox);

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'threezerotwofour',
  author: 'jan t. sott (http://github.com/idleberg)',
  base00: '#090300',
  base01: '#3a3432',
  base02: '#4a4543',
  base03: '#5c5855',
  base04: '#807d7c',
  base05: '#a5a2a2',
  base06: '#d6d5d4',
  base07: '#f7f7f7',
  base08: '#db2d20',
  base09: '#e8bbd0',
  base0A: '#fded02',
  base0B: '#01a252',
  base0C: '#b5e4f4',
  base0D: '#01a0e4',
  base0E: '#a16a94',
  base0F: '#cdab53'
};
module.exports = exports['default'];

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'apathy',
  author: 'jannik siebert (https://github.com/janniks)',
  base00: '#031A16',
  base01: '#0B342D',
  base02: '#184E45',
  base03: '#2B685E',
  base04: '#5F9C92',
  base05: '#81B5AC',
  base06: '#A7CEC8',
  base07: '#D2E7E4',
  base08: '#3E9688',
  base09: '#3E7996',
  base0A: '#3E4C96',
  base0B: '#883E96',
  base0C: '#963E4C',
  base0D: '#96883E',
  base0E: '#4C963E',
  base0F: '#3E965B'
};
module.exports = exports['default'];

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'ashes',
  author: 'jannik siebert (https://github.com/janniks)',
  base00: '#1C2023',
  base01: '#393F45',
  base02: '#565E65',
  base03: '#747C84',
  base04: '#ADB3BA',
  base05: '#C7CCD1',
  base06: '#DFE2E5',
  base07: '#F3F4F5',
  base08: '#C7AE95',
  base09: '#C7C795',
  base0A: '#AEC795',
  base0B: '#95C7AE',
  base0C: '#95AEC7',
  base0D: '#AE95C7',
  base0E: '#C795AE',
  base0F: '#C79595'
};
module.exports = exports['default'];

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier dune',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)',
  base00: '#20201d',
  base01: '#292824',
  base02: '#6e6b5e',
  base03: '#7d7a68',
  base04: '#999580',
  base05: '#a6a28c',
  base06: '#e8e4cf',
  base07: '#fefbec',
  base08: '#d73737',
  base09: '#b65611',
  base0A: '#cfb017',
  base0B: '#60ac39',
  base0C: '#1fad83',
  base0D: '#6684e1',
  base0E: '#b854d4',
  base0F: '#d43552'
};
module.exports = exports['default'];

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier forest',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)',
  base00: '#1b1918',
  base01: '#2c2421',
  base02: '#68615e',
  base03: '#766e6b',
  base04: '#9c9491',
  base05: '#a8a19f',
  base06: '#e6e2e0',
  base07: '#f1efee',
  base08: '#f22c40',
  base09: '#df5320',
  base0A: '#d5911a',
  base0B: '#5ab738',
  base0C: '#00ad9c',
  base0D: '#407ee7',
  base0E: '#6666ea',
  base0F: '#c33ff3'
};
module.exports = exports['default'];

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier heath',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)',
  base00: '#1b181b',
  base01: '#292329',
  base02: '#695d69',
  base03: '#776977',
  base04: '#9e8f9e',
  base05: '#ab9bab',
  base06: '#d8cad8',
  base07: '#f7f3f7',
  base08: '#ca402b',
  base09: '#a65926',
  base0A: '#bb8a35',
  base0B: '#379a37',
  base0C: '#159393',
  base0D: '#516aec',
  base0E: '#7b59c0',
  base0F: '#cc33cc'
};
module.exports = exports['default'];

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier lakeside',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)',
  base00: '#161b1d',
  base01: '#1f292e',
  base02: '#516d7b',
  base03: '#5a7b8c',
  base04: '#7195a8',
  base05: '#7ea2b4',
  base06: '#c1e4f6',
  base07: '#ebf8ff',
  base08: '#d22d72',
  base09: '#935c25',
  base0A: '#8a8a0f',
  base0B: '#568c3b',
  base0C: '#2d8f6f',
  base0D: '#257fad',
  base0E: '#5d5db1',
  base0F: '#b72dd2'
};
module.exports = exports['default'];

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'atelier seaside',
  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)',
  base00: '#131513',
  base01: '#242924',
  base02: '#5e6e5e',
  base03: '#687d68',
  base04: '#809980',
  base05: '#8ca68c',
  base06: '#cfe8cf',
  base07: '#f0fff0',
  base08: '#e6193c',
  base09: '#87711d',
  base0A: '#c3c322',
  base0B: '#29a329',
  base0C: '#1999b3',
  base0D: '#3d62f5',
  base0E: '#ad2bee',
  base0F: '#e619c3'
};
module.exports = exports['default'];

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'bespin',
  author: 'jan t. sott',
  base00: '#28211c',
  base01: '#36312e',
  base02: '#5e5d5c',
  base03: '#666666',
  base04: '#797977',
  base05: '#8a8986',
  base06: '#9d9b97',
  base07: '#baae9e',
  base08: '#cf6a4c',
  base09: '#cf7d34',
  base0A: '#f9ee98',
  base0B: '#54be0d',
  base0C: '#afc4db',
  base0D: '#5ea6ea',
  base0E: '#9b859d',
  base0F: '#937121'
};
module.exports = exports['default'];

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'brewer',
  author: 'timothée poisot (http://github.com/tpoisot)',
  base00: '#0c0d0e',
  base01: '#2e2f30',
  base02: '#515253',
  base03: '#737475',
  base04: '#959697',
  base05: '#b7b8b9',
  base06: '#dadbdc',
  base07: '#fcfdfe',
  base08: '#e31a1c',
  base09: '#e6550d',
  base0A: '#dca060',
  base0B: '#31a354',
  base0C: '#80b1d3',
  base0D: '#3182bd',
  base0E: '#756bb1',
  base0F: '#b15928'
};
module.exports = exports['default'];

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'bright',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#000000',
  base01: '#303030',
  base02: '#505050',
  base03: '#b0b0b0',
  base04: '#d0d0d0',
  base05: '#e0e0e0',
  base06: '#f5f5f5',
  base07: '#ffffff',
  base08: '#fb0120',
  base09: '#fc6d24',
  base0A: '#fda331',
  base0B: '#a1c659',
  base0C: '#76c7b7',
  base0D: '#6fb3d2',
  base0E: '#d381c3',
  base0F: '#be643c'
};
module.exports = exports['default'];

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'chalk',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#151515',
  base01: '#202020',
  base02: '#303030',
  base03: '#505050',
  base04: '#b0b0b0',
  base05: '#d0d0d0',
  base06: '#e0e0e0',
  base07: '#f5f5f5',
  base08: '#fb9fb1',
  base09: '#eda987',
  base0A: '#ddb26f',
  base0B: '#acc267',
  base0C: '#12cfc0',
  base0D: '#6fc2ef',
  base0E: '#e1a3ee',
  base0F: '#deaf8f'
};
module.exports = exports['default'];

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'codeschool',
  author: 'brettof86',
  base00: '#232c31',
  base01: '#1c3657',
  base02: '#2a343a',
  base03: '#3f4944',
  base04: '#84898c',
  base05: '#9ea7a6',
  base06: '#a7cfa3',
  base07: '#b5d8f6',
  base08: '#2a5491',
  base09: '#43820d',
  base0A: '#a03b1e',
  base0B: '#237986',
  base0C: '#b02f30',
  base0D: '#484d79',
  base0E: '#c59820',
  base0F: '#c98344'
};
module.exports = exports['default'];

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'colors',
  author: 'mrmrs (http://clrs.cc)',
  base00: '#111111',
  base01: '#333333',
  base02: '#555555',
  base03: '#777777',
  base04: '#999999',
  base05: '#bbbbbb',
  base06: '#dddddd',
  base07: '#ffffff',
  base08: '#ff4136',
  base09: '#ff851b',
  base0A: '#ffdc00',
  base0B: '#2ecc40',
  base0C: '#7fdbff',
  base0D: '#0074d9',
  base0E: '#b10dc9',
  base0F: '#85144b'
};
module.exports = exports['default'];

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'default',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#181818',
  base01: '#282828',
  base02: '#383838',
  base03: '#585858',
  base04: '#b8b8b8',
  base05: '#d8d8d8',
  base06: '#e8e8e8',
  base07: '#f8f8f8',
  base08: '#ab4642',
  base09: '#dc9656',
  base0A: '#f7ca88',
  base0B: '#a1b56c',
  base0C: '#86c1b9',
  base0D: '#7cafc2',
  base0E: '#ba8baf',
  base0F: '#a16946'
};
module.exports = exports['default'];

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'eighties',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#2d2d2d',
  base01: '#393939',
  base02: '#515151',
  base03: '#747369',
  base04: '#a09f93',
  base05: '#d3d0c8',
  base06: '#e8e6df',
  base07: '#f2f0ec',
  base08: '#f2777a',
  base09: '#f99157',
  base0A: '#ffcc66',
  base0B: '#99cc99',
  base0C: '#66cccc',
  base0D: '#6699cc',
  base0E: '#cc99cc',
  base0F: '#d27b53'
};
module.exports = exports['default'];

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'embers',
  author: 'jannik siebert (https://github.com/janniks)',
  base00: '#16130F',
  base01: '#2C2620',
  base02: '#433B32',
  base03: '#5A5047',
  base04: '#8A8075',
  base05: '#A39A90',
  base06: '#BEB6AE',
  base07: '#DBD6D1',
  base08: '#826D57',
  base09: '#828257',
  base0A: '#6D8257',
  base0B: '#57826D',
  base0C: '#576D82',
  base0D: '#6D5782',
  base0E: '#82576D',
  base0F: '#825757'
};
module.exports = exports['default'];

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'flat',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#2C3E50',
  base01: '#34495E',
  base02: '#7F8C8D',
  base03: '#95A5A6',
  base04: '#BDC3C7',
  base05: '#e0e0e0',
  base06: '#f5f5f5',
  base07: '#ECF0F1',
  base08: '#E74C3C',
  base09: '#E67E22',
  base0A: '#F1C40F',
  base0B: '#2ECC71',
  base0C: '#1ABC9C',
  base0D: '#3498DB',
  base0E: '#9B59B6',
  base0F: '#be643c'
};
module.exports = exports['default'];

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'google',
  author: 'seth wright (http://sethawright.com)',
  base00: '#1d1f21',
  base01: '#282a2e',
  base02: '#373b41',
  base03: '#969896',
  base04: '#b4b7b4',
  base05: '#c5c8c6',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#CC342B',
  base09: '#F96A38',
  base0A: '#FBA922',
  base0B: '#198844',
  base0C: '#3971ED',
  base0D: '#3971ED',
  base0E: '#A36AC7',
  base0F: '#3971ED'
};
module.exports = exports['default'];

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'grayscale',
  author: 'alexandre gavioli (https://github.com/alexx2/)',
  base00: '#101010',
  base01: '#252525',
  base02: '#464646',
  base03: '#525252',
  base04: '#ababab',
  base05: '#b9b9b9',
  base06: '#e3e3e3',
  base07: '#f7f7f7',
  base08: '#7c7c7c',
  base09: '#999999',
  base0A: '#a0a0a0',
  base0B: '#8e8e8e',
  base0C: '#868686',
  base0D: '#686868',
  base0E: '#747474',
  base0F: '#5e5e5e'
};
module.exports = exports['default'];

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'green screen',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#001100',
  base01: '#003300',
  base02: '#005500',
  base03: '#007700',
  base04: '#009900',
  base05: '#00bb00',
  base06: '#00dd00',
  base07: '#00ff00',
  base08: '#007700',
  base09: '#009900',
  base0A: '#007700',
  base0B: '#00bb00',
  base0C: '#005500',
  base0D: '#009900',
  base0E: '#00bb00',
  base0F: '#005500'
};
module.exports = exports['default'];

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'harmonic16',
  author: 'jannik siebert (https://github.com/janniks)',
  base00: '#0b1c2c',
  base01: '#223b54',
  base02: '#405c79',
  base03: '#627e99',
  base04: '#aabcce',
  base05: '#cbd6e2',
  base06: '#e5ebf1',
  base07: '#f7f9fb',
  base08: '#bf8b56',
  base09: '#bfbf56',
  base0A: '#8bbf56',
  base0B: '#56bf8b',
  base0C: '#568bbf',
  base0D: '#8b56bf',
  base0E: '#bf568b',
  base0F: '#bf5656'
};
module.exports = exports['default'];

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'hopscotch',
  author: 'jan t. sott',
  base00: '#322931',
  base01: '#433b42',
  base02: '#5c545b',
  base03: '#797379',
  base04: '#989498',
  base05: '#b9b5b8',
  base06: '#d5d3d5',
  base07: '#ffffff',
  base08: '#dd464c',
  base09: '#fd8b19',
  base0A: '#fdcc59',
  base0B: '#8fc13e',
  base0C: '#149b93',
  base0D: '#1290bf',
  base0E: '#c85e7c',
  base0F: '#b33508'
};
module.exports = exports['default'];

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'isotope',
  author: 'jan t. sott',
  base00: '#000000',
  base01: '#404040',
  base02: '#606060',
  base03: '#808080',
  base04: '#c0c0c0',
  base05: '#d0d0d0',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#ff0000',
  base09: '#ff9900',
  base0A: '#ff0099',
  base0B: '#33ff00',
  base0C: '#00ffff',
  base0D: '#0066ff',
  base0E: '#cc00ff',
  base0F: '#3300ff'
};
module.exports = exports['default'];

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'marrakesh',
  author: 'alexandre gavioli (http://github.com/alexx2/)',
  base00: '#201602',
  base01: '#302e00',
  base02: '#5f5b17',
  base03: '#6c6823',
  base04: '#86813b',
  base05: '#948e48',
  base06: '#ccc37a',
  base07: '#faf0a5',
  base08: '#c35359',
  base09: '#b36144',
  base0A: '#a88339',
  base0B: '#18974e',
  base0C: '#75a738',
  base0D: '#477ca1',
  base0E: '#8868b3',
  base0F: '#b3588e'
};
module.exports = exports['default'];

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'mocha',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#3B3228',
  base01: '#534636',
  base02: '#645240',
  base03: '#7e705a',
  base04: '#b8afad',
  base05: '#d0c8c6',
  base06: '#e9e1dd',
  base07: '#f5eeeb',
  base08: '#cb6077',
  base09: '#d28b71',
  base0A: '#f4bc87',
  base0B: '#beb55b',
  base0C: '#7bbda4',
  base0D: '#8ab3b5',
  base0E: '#a89bb9',
  base0F: '#bb9584'
};
module.exports = exports['default'];

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633'
};
module.exports = exports['default'];

/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'ocean',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#2b303b',
  base01: '#343d46',
  base02: '#4f5b66',
  base03: '#65737e',
  base04: '#a7adba',
  base05: '#c0c5ce',
  base06: '#dfe1e8',
  base07: '#eff1f5',
  base08: '#bf616a',
  base09: '#d08770',
  base0A: '#ebcb8b',
  base0B: '#a3be8c',
  base0C: '#96b5b4',
  base0D: '#8fa1b3',
  base0E: '#b48ead',
  base0F: '#ab7967'
};
module.exports = exports['default'];

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'paraiso',
  author: 'jan t. sott',
  base00: '#2f1e2e',
  base01: '#41323f',
  base02: '#4f424c',
  base03: '#776e71',
  base04: '#8d8687',
  base05: '#a39e9b',
  base06: '#b9b6b0',
  base07: '#e7e9db',
  base08: '#ef6155',
  base09: '#f99b15',
  base0A: '#fec418',
  base0B: '#48b685',
  base0C: '#5bc4bf',
  base0D: '#06b6ef',
  base0E: '#815ba4',
  base0F: '#e96ba8'
};
module.exports = exports['default'];

/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'pop',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#000000',
  base01: '#202020',
  base02: '#303030',
  base03: '#505050',
  base04: '#b0b0b0',
  base05: '#d0d0d0',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#eb008a',
  base09: '#f29333',
  base0A: '#f8ca12',
  base0B: '#37b349',
  base0C: '#00aabb',
  base0D: '#0e5a94',
  base0E: '#b31e8d',
  base0F: '#7a2d00'
};
module.exports = exports['default'];

/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'railscasts',
  author: 'ryan bates (http://railscasts.com)',
  base00: '#2b2b2b',
  base01: '#272935',
  base02: '#3a4055',
  base03: '#5a647e',
  base04: '#d4cfc9',
  base05: '#e6e1dc',
  base06: '#f4f1ed',
  base07: '#f9f7f3',
  base08: '#da4939',
  base09: '#cc7833',
  base0A: '#ffc66d',
  base0B: '#a5c261',
  base0C: '#519f50',
  base0D: '#6d9cbe',
  base0E: '#b6b3eb',
  base0F: '#bc9458'
};
module.exports = exports['default'];

/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'shapeshifter',
  author: 'tyler benziger (http://tybenz.com)',
  base00: '#000000',
  base01: '#040404',
  base02: '#102015',
  base03: '#343434',
  base04: '#555555',
  base05: '#ababab',
  base06: '#e0e0e0',
  base07: '#f9f9f9',
  base08: '#e92f2f',
  base09: '#e09448',
  base0A: '#dddd13',
  base0B: '#0ed839',
  base0C: '#23edda',
  base0D: '#3b48e3',
  base0E: '#f996e2',
  base0F: '#69542d'
};
module.exports = exports['default'];

/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'solarized',
  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
  base00: '#002b36',
  base01: '#073642',
  base02: '#586e75',
  base03: '#657b83',
  base04: '#839496',
  base05: '#93a1a1',
  base06: '#eee8d5',
  base07: '#fdf6e3',
  base08: '#dc322f',
  base09: '#cb4b16',
  base0A: '#b58900',
  base0B: '#859900',
  base0C: '#2aa198',
  base0D: '#268bd2',
  base0E: '#6c71c4',
  base0F: '#d33682'
};
module.exports = exports['default'];

/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'summerfruit',
  author: 'christopher corley (http://cscorley.github.io/)',
  base00: '#151515',
  base01: '#202020',
  base02: '#303030',
  base03: '#505050',
  base04: '#B0B0B0',
  base05: '#D0D0D0',
  base06: '#E0E0E0',
  base07: '#FFFFFF',
  base08: '#FF0086',
  base09: '#FD8900',
  base0A: '#ABA800',
  base0B: '#00C918',
  base0C: '#1faaaa',
  base0D: '#3777E6',
  base0E: '#AD00A1',
  base0F: '#cc6633'
};
module.exports = exports['default'];

/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'tomorrow',
  author: 'chris kempson (http://chriskempson.com)',
  base00: '#1d1f21',
  base01: '#282a2e',
  base02: '#373b41',
  base03: '#969896',
  base04: '#b4b7b4',
  base05: '#c5c8c6',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#cc6666',
  base09: '#de935f',
  base0A: '#f0c674',
  base0B: '#b5bd68',
  base0C: '#8abeb7',
  base0D: '#81a2be',
  base0E: '#b294bb',
  base0F: '#a3685a'
};
module.exports = exports['default'];

/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'london tube',
  author: 'jan t. sott',
  base00: '#231f20',
  base01: '#1c3f95',
  base02: '#5a5758',
  base03: '#737171',
  base04: '#959ca1',
  base05: '#d9d8d8',
  base06: '#e7e7e8',
  base07: '#ffffff',
  base08: '#ee2e24',
  base09: '#f386a1',
  base0A: '#ffd204',
  base0B: '#00853e',
  base0C: '#85cebc',
  base0D: '#009ddc',
  base0E: '#98005d',
  base0F: '#b06110'
};
module.exports = exports['default'];

/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'twilight',
  author: 'david hart (http://hart-dev.com)',
  base00: '#1e1e1e',
  base01: '#323537',
  base02: '#464b50',
  base03: '#5f5a60',
  base04: '#838184',
  base05: '#a7a7a7',
  base06: '#c3c3c3',
  base07: '#ffffff',
  base08: '#cf6a4c',
  base09: '#cda869',
  base0A: '#f9ee98',
  base0B: '#8f9d6a',
  base0C: '#afc4db',
  base0D: '#7587a6',
  base0E: '#9b859d',
  base0F: '#9b703f'
};
module.exports = exports['default'];

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'nicinabox',
  author: 'nicinabox (http://github.com/nicinabox)',
  base00: '#2A2F3A',
  base01: '#3C444F',
  base02: '#4F5A65',
  base03: '#BEBEBE',
  base04: '#b0b0b0', // based on ocean theme
  base05: '#d0d0d0', // based on ocean theme
  base06: '#FFFFFF',
  base07: '#f5f5f5', // based on ocean theme
  base08: '#fb9fb1', // based on ocean theme
  base09: '#FC6D24',
  base0A: '#ddb26f', // based on ocean theme
  base0B: '#A1C659',
  base0C: '#12cfc0', // based on ocean theme
  base0D: '#6FB3D2',
  base0E: '#D381C3',
  base0F: '#deaf8f' // based on ocean theme
};
module.exports = exports['default'];

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = reducer;

var _actions = __webpack_require__(719);

function initialScrollTop(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var action = arguments[2];

  if (!props.preserveScrollTop) {
    return 0;
  }

  return action.type === _actions.UPDATE_SCROLL_TOP ? action.scrollTop : state;
}

function startConsecutiveToggle(props, state, action) {
  return action.type === _actions.START_CONSECUTIVE_TOGGLE ? action.id : state;
}

function reducer(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var action = arguments[2];

  return {
    initialScrollTop: initialScrollTop(props, state.initialScrollTop, action),
    consecutiveToggleStartId: startConsecutiveToggle(props, state.consecutiveToggleStartId, action)
  };
}

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _function = __webpack_require__(242);

var _function2 = _interopRequireDefault(_function);

var _reduxDevtools = __webpack_require__(458);

var _LogMonitorButton = __webpack_require__(1892);

var _LogMonitorButton2 = _interopRequireDefault(_LogMonitorButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var reset = _reduxDevtools.ActionCreators.reset;
var rollback = _reduxDevtools.ActionCreators.rollback;
var commit = _reduxDevtools.ActionCreators.commit;
var sweep = _reduxDevtools.ActionCreators.sweep;


var style = {
  textAlign: 'center',
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  borderColor: 'transparent',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'row'
};

var LogMonitorButtonBar = function (_Component) {
  _inherits(LogMonitorButtonBar, _Component);

  function LogMonitorButtonBar(props) {
    _classCallCheck(this, LogMonitorButtonBar);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.shouldComponentUpdate = _function2.default;

    _this.handleReset = _this.handleReset.bind(_this);
    _this.handleRollback = _this.handleRollback.bind(_this);
    _this.handleSweep = _this.handleSweep.bind(_this);
    _this.handleCommit = _this.handleCommit.bind(_this);
    return _this;
  }

  LogMonitorButtonBar.prototype.handleRollback = function handleRollback() {
    this.props.dispatch(rollback());
  };

  LogMonitorButtonBar.prototype.handleSweep = function handleSweep() {
    this.props.dispatch(sweep());
  };

  LogMonitorButtonBar.prototype.handleCommit = function handleCommit() {
    this.props.dispatch(commit());
  };

  LogMonitorButtonBar.prototype.handleReset = function handleReset() {
    this.props.dispatch(reset());
  };

  LogMonitorButtonBar.prototype.render = function render() {
    var _props = this.props;
    var theme = _props.theme;
    var hasStates = _props.hasStates;
    var hasSkippedActions = _props.hasSkippedActions;

    return _react2.default.createElement(
      'div',
      { style: _extends({}, style, { borderColor: theme.base02 }) },
      _react2.default.createElement(
        _LogMonitorButton2.default,
        {
          theme: theme,
          onClick: this.handleReset,
          enabled: true },
        'Reset'
      ),
      _react2.default.createElement(
        _LogMonitorButton2.default,
        {
          theme: theme,
          onClick: this.handleRollback,
          enabled: hasStates },
        'Revert'
      ),
      _react2.default.createElement(
        _LogMonitorButton2.default,
        {
          theme: theme,
          onClick: this.handleSweep,
          enabled: hasSkippedActions },
        'Sweep'
      ),
      _react2.default.createElement(
        _LogMonitorButton2.default,
        {
          theme: theme,
          onClick: this.handleCommit,
          enabled: hasStates },
        'Commit'
      )
    );
  };

  return LogMonitorButtonBar;
}(_react.Component);

LogMonitorButtonBar.propTypes = {
  dispatch: _propTypes2.default.func,
  theme: _propTypes2.default.object
};
exports.default = LogMonitorButtonBar;

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _brighten = __webpack_require__(1893);

var _brighten2 = _interopRequireDefault(_brighten);

var _function = __webpack_require__(242);

var _function2 = _interopRequireDefault(_function);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  base: {
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: 3,
    padding: 4,
    marginLeft: 3,
    marginRight: 3,
    marginTop: 5,
    marginBottom: 5,
    flexGrow: 1,
    display: 'inline-block',
    fontSize: '0.8em',
    color: 'white',
    textDecoration: 'none'
  }
};

var LogMonitorButton = function (_React$Component) {
  _inherits(LogMonitorButton, _React$Component);

  function LogMonitorButton(props) {
    _classCallCheck(this, LogMonitorButton);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.shouldComponentUpdate = _function2.default;


    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
    _this.onClick = _this.onClick.bind(_this);

    _this.state = {
      hovered: false,
      active: false
    };
    return _this;
  }

  LogMonitorButton.prototype.handleMouseEnter = function handleMouseEnter() {
    this.setState({ hovered: true });
  };

  LogMonitorButton.prototype.handleMouseLeave = function handleMouseLeave() {
    this.setState({ hovered: false });
  };

  LogMonitorButton.prototype.handleMouseDown = function handleMouseDown() {
    this.setState({ active: true });
  };

  LogMonitorButton.prototype.handleMouseUp = function handleMouseUp() {
    this.setState({ active: false });
  };

  LogMonitorButton.prototype.onClick = function onClick() {
    if (!this.props.enabled) {
      return;
    }
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  LogMonitorButton.prototype.render = function render() {
    var style = _extends({}, styles.base, {
      backgroundColor: this.props.theme.base02
    });
    if (this.props.enabled && this.state.hovered) {
      style = _extends({}, style, {
        backgroundColor: (0, _brighten2.default)(this.props.theme.base02, 0.2)
      });
    }
    if (!this.props.enabled) {
      style = _extends({}, style, {
        opacity: 0.2,
        cursor: 'text',
        backgroundColor: 'transparent'
      });
    }
    return _react2.default.createElement(
      'a',
      { onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onClick: this.onClick,
        style: style },
      this.props.children
    );
  };

  return LogMonitorButton;
}(_react2.default.Component);

exports.default = LogMonitorButton;

/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (hexColor, lightness) {
  var hex = String(hexColor).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex.replace(/(.)/g, '$1$1');
  }
  var lum = lightness || 0;

  var rgb = '#';
  var c = void 0;
  for (var i = 0; i < 3; ++i) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }
  return rgb;
};

/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LogMonitorEntry = __webpack_require__(1895);

var _LogMonitorEntry2 = _interopRequireDefault(_LogMonitorEntry);

var _function = __webpack_require__(242);

var _function2 = _interopRequireDefault(_function);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogMonitorEntryList = function (_Component) {
  _inherits(LogMonitorEntryList, _Component);

  function LogMonitorEntryList() {
    var _temp, _this, _ret;

    _classCallCheck(this, LogMonitorEntryList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LogMonitorEntryList.prototype.render = function render() {
    var elements = [];
    var _props = this.props;
    var theme = _props.theme;
    var actionsById = _props.actionsById;
    var computedStates = _props.computedStates;
    var currentStateIndex = _props.currentStateIndex;
    var consecutiveToggleStartId = _props.consecutiveToggleStartId;
    var select = _props.select;
    var skippedActionIds = _props.skippedActionIds;
    var stagedActionIds = _props.stagedActionIds;
    var expandActionRoot = _props.expandActionRoot;
    var expandStateRoot = _props.expandStateRoot;
    var markStateDiff = _props.markStateDiff;
    var onActionClick = _props.onActionClick;
    var onActionShiftClick = _props.onActionShiftClick;


    for (var i = 0; i < stagedActionIds.length; i++) {
      var actionId = stagedActionIds[i];
      var action = actionsById[actionId].action;
      var _computedStates$i = computedStates[i];
      var state = _computedStates$i.state;
      var error = _computedStates$i.error;

      var previousState = void 0;
      if (i > 0) {
        previousState = computedStates[i - 1].state;
      }
      elements.push(_react2.default.createElement(_LogMonitorEntry2.default, { key: actionId,
        theme: theme,
        select: select,
        action: action,
        actionId: actionId,
        state: state,
        previousState: previousState,
        collapsed: skippedActionIds.indexOf(actionId) > -1,
        inFuture: i > currentStateIndex,
        selected: consecutiveToggleStartId === i,
        error: error,
        expandActionRoot: expandActionRoot,
        expandStateRoot: expandStateRoot,
        markStateDiff: markStateDiff,
        onActionClick: onActionClick,
        onActionShiftClick: onActionShiftClick }));
    }

    return _react2.default.createElement(
      'div',
      null,
      elements
    );
  };

  return LogMonitorEntryList;
}(_react.Component);

LogMonitorEntryList.propTypes = {
  actionsById: _propTypes2.default.object,
  computedStates: _propTypes2.default.array,
  stagedActionIds: _propTypes2.default.array,
  skippedActionIds: _propTypes2.default.array,
  currentStateIndex: _propTypes2.default.number,
  consecutiveToggleStartId: _propTypes2.default.number,

  select: _propTypes2.default.func.isRequired,
  onActionClick: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  expandActionRoot: _propTypes2.default.bool,
  expandStateRoot: _propTypes2.default.bool
};
exports.default = LogMonitorEntryList;

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJsonTree = __webpack_require__(720);

var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);

var _LogMonitorEntryAction = __webpack_require__(1963);

var _LogMonitorEntryAction2 = _interopRequireDefault(_LogMonitorEntryAction);

var _function = __webpack_require__(242);

var _function2 = _interopRequireDefault(_function);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  entry: {
    display: 'block',
    WebkitUserSelect: 'none'
  },

  root: {
    marginLeft: 0
  }
};

var getDeepItem = function getDeepItem(data, path) {
  return path.reduce(function (obj, key) {
    return obj && obj[key];
  }, data);
};
var dataIsEqual = function dataIsEqual(data, previousData, keyPath) {
  var path = [].concat(keyPath).reverse().slice(1);

  return getDeepItem(data, path) === getDeepItem(previousData, path);
};

var LogMonitorEntry = function (_Component) {
  _inherits(LogMonitorEntry, _Component);

  function LogMonitorEntry(props) {
    _classCallCheck(this, LogMonitorEntry);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.shouldComponentUpdate = _function2.default;

    _this.handleActionClick = _this.handleActionClick.bind(_this);
    _this.shouldExpandNode = _this.shouldExpandNode.bind(_this);
    return _this;
  }

  LogMonitorEntry.prototype.printState = function printState(state, error) {
    var _this2 = this;

    var errorText = error;
    if (!errorText) {
      try {
        var _ret = function () {
          var data = _this2.props.select(state);
          var theme = void 0;

          if (_this2.props.markStateDiff) {
            (function () {
              var previousData = typeof _this2.props.previousState !== 'undefined' ? _this2.props.select(_this2.props.previousState) : undefined;
              var getValueStyle = function getValueStyle(_ref, nodeType, keyPath) {
                var style = _ref.style;
                return {
                  style: _extends({}, style, {
                    backgroundColor: dataIsEqual(data, previousData, keyPath) ? 'transparent' : _this2.props.theme.base01
                  })
                };
              };
              var getNestedNodeStyle = function getNestedNodeStyle(_ref2, keyPath) {
                var style = _ref2.style;
                return {
                  style: _extends({}, style, keyPath.length > 1 ? {} : styles.root)
                };
              };
              theme = {
                extend: _this2.props.theme,
                tree: styles.tree,
                value: getValueStyle,
                nestedNode: getNestedNodeStyle
              };
            })();
          } else {
            theme = _this2.props.theme;
          }

          return {
            v: _react2.default.createElement(_reactJsonTree2.default, {
              theme: theme,
              data: data,
              invertTheme: false,
              keyPath: ['state'],
              shouldExpandNode: _this2.shouldExpandNode })
          };
        }();

        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
      } catch (err) {
        errorText = 'Error selecting state.';
      }
    }

    return _react2.default.createElement(
      'div',
      { style: {
          color: this.props.theme.base08,
          paddingTop: 20,
          paddingLeft: 30,
          paddingRight: 30,
          paddingBottom: 35
        } },
      errorText
    );
  };

  LogMonitorEntry.prototype.handleActionClick = function handleActionClick(e) {
    var _props = this.props;
    var actionId = _props.actionId;
    var onActionClick = _props.onActionClick;
    var onActionShiftClick = _props.onActionShiftClick;

    if (actionId > 0) {
      if (e.shiftKey) {
        onActionShiftClick(actionId);
      } else {
        onActionClick(actionId);
      }
    }
  };

  LogMonitorEntry.prototype.shouldExpandNode = function shouldExpandNode(keyName, data, level) {
    return this.props.expandStateRoot && level === 0;
  };

  LogMonitorEntry.prototype.render = function render() {
    var _props2 = this.props;
    var actionId = _props2.actionId;
    var error = _props2.error;
    var action = _props2.action;
    var state = _props2.state;
    var collapsed = _props2.collapsed;
    var selected = _props2.selected;
    var inFuture = _props2.inFuture;

    var styleEntry = {
      opacity: collapsed ? 0.5 : 1,
      cursor: actionId > 0 ? 'pointer' : 'default'
    };

    return _react2.default.createElement(
      'div',
      { style: {
          opacity: selected ? 0.4 : inFuture ? 0.6 : 1, // eslint-disable-line no-nested-ternary
          textDecoration: collapsed ? 'line-through' : 'none',
          color: this.props.theme.base06
        } },
      _react2.default.createElement(_LogMonitorEntryAction2.default, {
        theme: this.props.theme,
        collapsed: collapsed,
        action: action,
        expandActionRoot: this.props.expandActionRoot,
        onClick: this.handleActionClick,
        style: _extends({}, styles.entry, styleEntry) }),
      !collapsed && _react2.default.createElement(
        'div',
        { style: { paddingLeft: 16 } },
        this.printState(state, error)
      )
    );
  };

  return LogMonitorEntry;
}(_react.Component);

LogMonitorEntry.propTypes = {
  state: _propTypes2.default.object.isRequired,
  action: _propTypes2.default.object.isRequired,
  actionId: _propTypes2.default.number.isRequired,
  select: _propTypes2.default.func.isRequired,
  inFuture: _propTypes2.default.bool,
  error: _propTypes2.default.string,
  onActionClick: _propTypes2.default.func.isRequired,
  onActionShiftClick: _propTypes2.default.func.isRequired,
  collapsed: _propTypes2.default.bool,
  selected: _propTypes2.default.bool,
  expandActionRoot: _propTypes2.default.bool,
  expandStateRoot: _propTypes2.default.bool
};
exports.default = LogMonitorEntry;

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(462);
__webpack_require__(474);
module.exports = __webpack_require__(475).f('iterator');

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(463)
  , defined   = __webpack_require__(464);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 1898 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(467)
  , descriptor     = __webpack_require__(320)
  , setToStringTag = __webpack_require__(472)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(203)(IteratorPrototype, __webpack_require__(114)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(204)
  , anObject = __webpack_require__(205)
  , getKeys  = __webpack_require__(209);

module.exports = __webpack_require__(207) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(172)
  , toLength  = __webpack_require__(1902)
  , toIndex   = __webpack_require__(1903);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(463)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(463)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(140).document && document.documentElement;

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(171)
  , toObject    = __webpack_require__(473)
  , IE_PROTO    = __webpack_require__(469)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1907)
  , step             = __webpack_require__(1908)
  , Iterators        = __webpack_require__(244)
  , toIObject        = __webpack_require__(172);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(722)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 1908 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1910), __esModule: true };

/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1911);
__webpack_require__(1916);
__webpack_require__(1917);
__webpack_require__(1918);
module.exports = __webpack_require__(66).Symbol;

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(140)
  , has            = __webpack_require__(171)
  , DESCRIPTORS    = __webpack_require__(207)
  , $export        = __webpack_require__(170)
  , redefine       = __webpack_require__(726)
  , META           = __webpack_require__(1912).KEY
  , $fails         = __webpack_require__(208)
  , shared         = __webpack_require__(470)
  , setToStringTag = __webpack_require__(472)
  , uid            = __webpack_require__(321)
  , wks            = __webpack_require__(114)
  , wksExt         = __webpack_require__(475)
  , wksDefine      = __webpack_require__(476)
  , keyOf          = __webpack_require__(1913)
  , enumKeys       = __webpack_require__(1914)
  , isArray        = __webpack_require__(1915)
  , anObject       = __webpack_require__(205)
  , toIObject      = __webpack_require__(172)
  , toPrimitive    = __webpack_require__(466)
  , createDesc     = __webpack_require__(320)
  , _create        = __webpack_require__(467)
  , gOPNExt        = __webpack_require__(729)
  , $GOPD          = __webpack_require__(731)
  , $DP            = __webpack_require__(204)
  , $keys          = __webpack_require__(209)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(730).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(322).f  = $propertyIsEnumerable;
  __webpack_require__(477).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(465)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(203)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(321)('meta')
  , isObject = __webpack_require__(206)
  , has      = __webpack_require__(171)
  , setDesc  = __webpack_require__(204).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(208)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(209)
  , toIObject = __webpack_require__(172);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(209)
  , gOPS    = __webpack_require__(477)
  , pIE     = __webpack_require__(322);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(468);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 1916 */
/***/ (function(module, exports) {



/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(476)('asyncIterator');

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(476)('observable');

/***/ }),
/* 1919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1920), __esModule: true };

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1921);
module.exports = __webpack_require__(66).Object.setPrototypeOf;

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(170);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(1922).set});

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(206)
  , anObject = __webpack_require__(205);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(723)(Function.call, __webpack_require__(731).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1924), __esModule: true };

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1925);
var $Object = __webpack_require__(66).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(170)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(467)});

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1927), __esModule: true };

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1928);
module.exports = __webpack_require__(66).Object.assign;

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(170);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(1929)});

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(209)
  , gOPS     = __webpack_require__(477)
  , pIE      = __webpack_require__(322)
  , toObject = __webpack_require__(473)
  , IObject  = __webpack_require__(728)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(208)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1931);
module.exports = __webpack_require__(66).Object.keys;

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(473)
  , $keys    = __webpack_require__(209);

__webpack_require__(732)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(721);

var _iterator2 = _interopRequireDefault(_iterator);

exports['default'] = objType;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function objType(obj) {
  var type = Object.prototype.toString.call(obj).slice(8, -1);
  if (type === 'Object' && typeof obj[_iterator2['default']] === 'function') {
    return 'Iterable';
  }

  return type;
}

/***/ }),
/* 1933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(243);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getOwnPropertyNames = __webpack_require__(734);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONNestedNode = __webpack_require__(479);

var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Returns the "n Items" string for this node,
// generating and caching it if it hasn't been created yet.
function createItemString(data) {
  var len = (0, _getOwnPropertyNames2['default'])(data).length;
  return len + ' ' + (len !== 1 ? 'keys' : 'key');
}

// Configures <JSONNestedNode> to render an Object
var JSONObjectNode = function JSONObjectNode(_ref) {
  var data = _ref.data,
      props = (0, _objectWithoutProperties3['default'])(_ref, ['data']);
  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
    data: data,
    nodeType: 'Object',
    nodeTypeIndicator: props.nodeType === 'Error' ? 'Error()' : '{}',
    createItemString: createItemString,
    expandable: (0, _getOwnPropertyNames2['default'])(data).length > 0
  }));
};

JSONObjectNode.propTypes = {
  data: _propTypes2['default'].object,
  nodeType: _propTypes2['default'].string
};

exports['default'] = JSONObjectNode;

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1935);
var $Object = __webpack_require__(66).Object;
module.exports = function getOwnPropertyNames(it){
  return $Object.getOwnPropertyNames(it);
};

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(732)('getOwnPropertyNames', function(){
  return __webpack_require__(729).f;
});

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getIterator2 = __webpack_require__(480);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getOwnPropertyNames = __webpack_require__(734);

var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);

var _keys = __webpack_require__(323);

var _keys2 = _interopRequireDefault(_keys);

exports['default'] = getCollectionEntries;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getLength(type, collection) {
  if (type === 'Object') {
    return (0, _keys2['default'])(collection).length;
  } else if (type === 'Array') {
    return collection.length;
  }

  return Infinity;
}

function isIterableMap(collection) {
  return typeof collection.set === 'function';
}

function getEntries(type, collection, sortObjectKeys) {
  var from = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var to = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Infinity;

  var res = void 0;

  if (type === 'Object') {
    var keys = (0, _getOwnPropertyNames2['default'])(collection);

    if (typeof sortObjectKeys !== 'undefined') {
      keys.sort(sortObjectKeys);
    }

    keys = keys.slice(from, to + 1);

    res = {
      entries: keys.map(function (key) {
        return { key: key, value: collection[key] };
      })
    };
  } else if (type === 'Array') {
    res = {
      entries: collection.slice(from, to + 1).map(function (val, idx) {
        return { key: idx + from, value: val };
      })
    };
  } else {
    var idx = 0;
    var entries = [];
    var done = true;

    var isMap = isIterableMap(collection);

    for (var _iterator = collection, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3['default'])(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var item = _ref;

      if (idx > to) {
        done = false;
        break;
      }
      if (from <= idx) {
        if (isMap && Array.isArray(item)) {
          if (typeof item[0] === 'string' || typeof item[0] === 'number') {
            entries.push({ key: item[0], value: item[1] });
          } else {
            entries.push({
              key: '[entry ' + idx + ']',
              value: {
                '[key]': item[0],
                '[value]': item[1]
              }
            });
          }
        } else {
          entries.push({ key: idx, value: item });
        }
      }
      idx++;
    }

    res = {
      hasMore: !done,
      entries: entries
    };
  }

  return res;
}

function getRanges(from, to, limit) {
  var ranges = [];
  while (to - from > limit * limit) {
    limit = limit * limit;
  }
  for (var i = from; i <= to; i += limit) {
    ranges.push({ from: i, to: Math.min(to, i + limit - 1) });
  }

  return ranges;
}

function getCollectionEntries(type, collection, sortObjectKeys, limit) {
  var from = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var to = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Infinity;

  var getEntriesBound = getEntries.bind(null, type, collection, sortObjectKeys);

  if (!limit) {
    return getEntriesBound().entries;
  }

  var isSubset = to < Infinity;
  var length = Math.min(to - from, getLength(type, collection));

  if (type !== 'Iterable') {
    if (length <= limit || limit < 7) {
      return getEntriesBound(from, to).entries;
    }
  } else {
    if (length <= limit && !isSubset) {
      return getEntriesBound(from, to).entries;
    }
  }

  var limitedEntries = void 0;
  if (type === 'Iterable') {
    var _getEntriesBound = getEntriesBound(from, from + limit - 1),
        hasMore = _getEntriesBound.hasMore,
        entries = _getEntriesBound.entries;

    limitedEntries = hasMore ? [].concat(entries, getRanges(from + limit, from + 2 * limit - 1, limit)) : entries;
  } else {
    limitedEntries = isSubset ? getRanges(from, to, limit) : [].concat(getEntriesBound(0, limit - 5).entries, getRanges(limit - 4, length - 5, limit), getEntriesBound(length - 4, length - 1).entries);
  }

  return limitedEntries;
}

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(474);
__webpack_require__(462);
module.exports = __webpack_require__(1938);

/***/ }),
/* 1938 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(205)
  , get      = __webpack_require__(1939);
module.exports = __webpack_require__(66).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(736)
  , ITERATOR  = __webpack_require__(114)('iterator')
  , Iterators = __webpack_require__(244);
module.exports = __webpack_require__(66).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(459);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(460);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(478);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONArrow = __webpack_require__(735);

var _JSONArrow2 = _interopRequireDefault(_JSONArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ItemRange = function (_React$Component) {
  (0, _inherits3['default'])(ItemRange, _React$Component);

  function ItemRange(props) {
    (0, _classCallCheck3['default'])(this, ItemRange);

    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));

    _this.state = { expanded: false };

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  ItemRange.prototype.render = function render() {
    var _props = this.props,
        styling = _props.styling,
        from = _props.from,
        to = _props.to,
        renderChildNodes = _props.renderChildNodes,
        nodeType = _props.nodeType;


    return this.state.expanded ? _react2['default'].createElement(
      'div',
      styling('itemRange', this.state.expanded),
      renderChildNodes(this.props, from, to)
    ) : _react2['default'].createElement(
      'div',
      (0, _extends3['default'])({}, styling('itemRange', this.state.expanded), {
        onClick: this.handleClick
      }),
      _react2['default'].createElement(_JSONArrow2['default'], {
        nodeType: nodeType,
        styling: styling,
        expanded: false,
        onClick: this.handleClick,
        arrowStyle: 'double'
      }),
      from + ' ... ' + to
    );
  };

  ItemRange.prototype.handleClick = function handleClick() {
    this.setState({ expanded: !this.state.expanded });
  };

  return ItemRange;
}(_react2['default'].Component);

ItemRange.propTypes = {
  styling: _propTypes2['default'].func.isRequired,
  from: _propTypes2['default'].number.isRequired,
  to: _propTypes2['default'].number.isRequired,
  renderChildNodes: _propTypes2['default'].func.isRequired,
  nodeType: _propTypes2['default'].string.isRequired
};
exports['default'] = ItemRange;

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(243);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _JSONNestedNode = __webpack_require__(479);

var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Returns the "n Items" string for this node,
// generating and caching it if it hasn't been created yet.
function createItemString(data) {
  return data.length + ' ' + (data.length !== 1 ? 'items' : 'item');
}

// Configures <JSONNestedNode> to render an Array
var JSONArrayNode = function JSONArrayNode(_ref) {
  var data = _ref.data,
      props = (0, _objectWithoutProperties3['default'])(_ref, ['data']);
  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
    data: data,
    nodeType: 'Array',
    nodeTypeIndicator: '[]',
    createItemString: createItemString,
    expandable: data.length > 0
  }));
};

JSONArrayNode.propTypes = {
  data: _propTypes2['default'].array
};

exports['default'] = JSONArrayNode;

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(243);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getIterator2 = __webpack_require__(480);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _isSafeInteger = __webpack_require__(1943);

var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);

exports['default'] = JSONIterableNode;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _JSONNestedNode = __webpack_require__(479);

var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Returns the "n Items" string for this node,
// generating and caching it if it hasn't been created yet.
function createItemString(data, limit) {
  var count = 0;
  var hasMore = false;
  if ((0, _isSafeInteger2['default'])(data.size)) {
    count = data.size;
  } else {
    // eslint-disable-next-line no-unused-vars
    for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3['default'])(_iterator);;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var entry = _ref;

      if (limit && count + 1 > limit) {
        hasMore = true;
        break;
      }
      count += 1;
    }
  }
  return '' + (hasMore ? '>' : '') + count + ' ' + (count !== 1 ? 'entries' : 'entry');
}

// Configures <JSONNestedNode> to render an iterable
function JSONIterableNode(_ref2) {
  var props = (0, _objectWithoutProperties3['default'])(_ref2, []);

  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
    nodeType: 'Iterable',
    nodeTypeIndicator: '()',
    createItemString: createItemString
  }));
}

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1944), __esModule: true };

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1945);
module.exports = __webpack_require__(66).Number.isSafeInteger;

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export   = __webpack_require__(170)
  , isInteger = __webpack_require__(1946)
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(206)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Renders simple values (eg. strings, numbers, booleans, etc)
 */

var JSONValueNode = function JSONValueNode(_ref) {
  var nodeType = _ref.nodeType,
      styling = _ref.styling,
      labelRenderer = _ref.labelRenderer,
      keyPath = _ref.keyPath,
      valueRenderer = _ref.valueRenderer,
      value = _ref.value,
      valueGetter = _ref.valueGetter;
  return _react2['default'].createElement(
    'li',
    styling('value', nodeType, keyPath),
    _react2['default'].createElement(
      'label',
      styling(['label', 'valueLabel'], nodeType, keyPath),
      labelRenderer(keyPath, nodeType, false, false)
    ),
    _react2['default'].createElement(
      'span',
      styling('valueText', nodeType, keyPath),
      valueRenderer.apply(undefined, [valueGetter(value), value].concat(keyPath))
    )
  );
};

JSONValueNode.propTypes = {
  nodeType: _propTypes2['default'].string.isRequired,
  styling: _propTypes2['default'].func.isRequired,
  labelRenderer: _propTypes2['default'].func.isRequired,
  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
  valueRenderer: _propTypes2['default'].func.isRequired,
  value: _propTypes2['default'].any,
  valueGetter: _propTypes2['default'].func
};

JSONValueNode.defaultProps = {
  valueGetter: function valueGetter(value) {
    return value;
  }
};

exports['default'] = JSONValueNode;

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(97);

var _extends3 = _interopRequireDefault(_extends2);

var _reactBase16Styling = __webpack_require__(737);

var _solarized = __webpack_require__(1962);

var _solarized2 = _interopRequireDefault(_solarized);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var colorMap = function colorMap(theme) {
  return {
    BACKGROUND_COLOR: theme.base00,
    TEXT_COLOR: theme.base07,
    STRING_COLOR: theme.base0B,
    DATE_COLOR: theme.base0B,
    NUMBER_COLOR: theme.base09,
    BOOLEAN_COLOR: theme.base09,
    NULL_COLOR: theme.base08,
    UNDEFINED_COLOR: theme.base08,
    FUNCTION_COLOR: theme.base08,
    SYMBOL_COLOR: theme.base08,
    LABEL_COLOR: theme.base0D,
    ARROW_COLOR: theme.base0D,
    ITEM_STRING_COLOR: theme.base0B,
    ITEM_STRING_EXPANDED_COLOR: theme.base03
  };
};

var valueColorMap = function valueColorMap(colors) {
  return {
    String: colors.STRING_COLOR,
    Date: colors.DATE_COLOR,
    Number: colors.NUMBER_COLOR,
    Boolean: colors.BOOLEAN_COLOR,
    Null: colors.NULL_COLOR,
    Undefined: colors.UNDEFINED_COLOR,
    Function: colors.FUNCTION_COLOR,
    Symbol: colors.SYMBOL_COLOR
  };
};

var getDefaultThemeStyling = function getDefaultThemeStyling(theme) {
  var colors = colorMap(theme);

  return {
    tree: {
      border: 0,
      padding: 0,
      marginTop: '0.5em',
      marginBottom: '0.5em',
      marginLeft: '0.125em',
      marginRight: 0,
      listStyle: 'none',
      MozUserSelect: 'none',
      WebkitUserSelect: 'none',
      backgroundColor: colors.BACKGROUND_COLOR
    },

    value: function value(_ref, nodeType, keyPath) {
      var style = _ref.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          paddingTop: '0.25em',
          paddingRight: 0,
          marginLeft: '0.875em',
          WebkitUserSelect: 'text',
          MozUserSelect: 'text',
          wordWrap: 'break-word',
          paddingLeft: keyPath.length > 1 ? '2.125em' : '1.25em',
          textIndent: '-0.5em',
          wordBreak: 'break-all'
        })
      };
    },

    label: {
      display: 'inline-block',
      color: colors.LABEL_COLOR
    },

    valueLabel: {
      margin: '0 0.5em 0 0'
    },

    valueText: function valueText(_ref2, nodeType) {
      var style = _ref2.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          color: valueColorMap(colors)[nodeType]
        })
      };
    },

    itemRange: function itemRange(styling, expanded) {
      return {
        style: {
          paddingTop: expanded ? 0 : '0.25em',
          cursor: 'pointer',
          color: colors.LABEL_COLOR
        }
      };
    },

    arrow: function arrow(_ref3, nodeType, expanded) {
      var style = _ref3.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          marginLeft: 0,
          transition: '150ms',
          WebkitTransition: '150ms',
          MozTransition: '150ms',
          WebkitTransform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
          MozTransform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
          transform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
          transformOrigin: '45% 50%',
          WebkitTransformOrigin: '45% 50%',
          MozTransformOrigin: '45% 50%',
          position: 'relative',
          lineHeight: '1.1em',
          fontSize: '0.75em'
        })
      };
    },

    arrowContainer: function arrowContainer(_ref4, arrowStyle) {
      var style = _ref4.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          display: 'inline-block',
          paddingRight: '0.5em',
          paddingLeft: arrowStyle === 'double' ? '1em' : 0,
          cursor: 'pointer'
        })
      };
    },

    arrowSign: {
      color: colors.ARROW_COLOR
    },

    arrowSignInner: {
      position: 'absolute',
      top: 0,
      left: '-0.4em'
    },

    nestedNode: function nestedNode(_ref5, keyPath, nodeType, expanded, expandable) {
      var style = _ref5.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          position: 'relative',
          paddingTop: '0.25em',
          marginLeft: keyPath.length > 1 ? '0.875em' : 0,
          paddingLeft: !expandable ? '1.125em' : 0
        })
      };
    },

    rootNode: {
      padding: 0,
      margin: 0
    },

    nestedNodeLabel: function nestedNodeLabel(_ref6, keyPath, nodeType, expanded, expandable) {
      var style = _ref6.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          margin: 0,
          padding: 0,
          WebkitUserSelect: expandable ? 'inherit' : 'text',
          MozUserSelect: expandable ? 'inherit' : 'text',
          cursor: expandable ? 'pointer' : 'default'
        })
      };
    },

    nestedNodeItemString: function nestedNodeItemString(_ref7, keyPath, nodeType, expanded) {
      var style = _ref7.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          paddingLeft: '0.5em',
          cursor: 'default',
          color: expanded ? colors.ITEM_STRING_EXPANDED_COLOR : colors.ITEM_STRING_COLOR
        })
      };
    },

    nestedNodeItemType: {
      marginLeft: '0.3em',
      marginRight: '0.3em'
    },

    nestedNodeChildren: function nestedNodeChildren(_ref8, nodeType, expanded) {
      var style = _ref8.style;
      return {
        style: (0, _extends3['default'])({}, style, {
          padding: 0,
          margin: 0,
          listStyle: 'none',
          display: expanded ? 'block' : 'none'
        })
      };
    },

    rootNodeChildren: {
      padding: 0,
      margin: 0,
      listStyle: 'none'
    }
  };
};

exports['default'] = (0, _reactBase16Styling.createStyling)(getDefaultThemeStyling, {
  defaultBase16: _solarized2['default']
});

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1950);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(480);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1951), __esModule: true };

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(474);
__webpack_require__(462);
module.exports = __webpack_require__(1952);

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(736)
  , ITERATOR  = __webpack_require__(114)('iterator')
  , Iterators = __webpack_require__(244);
module.exports = __webpack_require__(66).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var BIND_FLAG = 1,
    BIND_KEY_FLAG = 2,
    CURRY_BOUND_FLAG = 4,
    CURRY_FLAG = 8,
    CURRY_RIGHT_FLAG = 16,
    PARTIAL_FLAG = 32,
    PARTIAL_RIGHT_FLAG = 64,
    ARY_FLAG = 128,
    REARG_FLAG = 256,
    FLIP_FLAG = 512;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', ARY_FLAG],
  ['bind', BIND_FLAG],
  ['bindKey', BIND_KEY_FLAG],
  ['curry', CURRY_FLAG],
  ['curryRight', CURRY_RIGHT_FLAG],
  ['flip', FLIP_FLAG],
  ['partial', PARTIAL_FLAG],
  ['partialRight', PARTIAL_RIGHT_FLAG],
  ['rearg', REARG_FLAG]
];

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      result++;
    }
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var objectCreate = Object.create;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/* Used to set `toString` methods. */
var defineProperty = (function() {
  var func = getNative(Object, 'defineProperty'),
      name = getNative.name;

  return (name && name.length > 2) ? func : undefined;
}());

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & ARY_FLAG,
      isBind = bitmask & BIND_FLAG,
      isBindKey = bitmask & BIND_KEY_FLAG,
      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
      isFlip = bitmask & FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

  if (!(bitmask & CURRY_BOUND_FLAG)) {
    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
  }

  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *  The bitmask may be composed of the following flags:
 *     1 - `_.bind`
 *     2 - `_.bindKey`
 *     4 - `_.curry` or `_.curryRight` of a bound function
 *     8 - `_.curry`
 *    16 - `_.curryRight`
 *    32 - `_.partial`
 *    64 - `_.partialRight`
 *   128 - `_.rearg`
 *   256 - `_.ary`
 *   512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] == null
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  return setWrapToString(result, func, bitmask);
}

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length,
      lastIndex = length - 1;

  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
  var source = (reference + '');
  return defineProperty(wrapper, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
  });
};

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

var clamp = __webpack_require__(481);

function componentToHex(c) {
  var value = Math.round(clamp(c, 0, 255));
  var hex   = value.toString(16);

  return hex.length == 1 ? "0" + hex : hex;
}

function rgb2hex(rgb) {
  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
}

module.exports = rgb2hex;

/***/ }),
/* 1955 */
/***/ (function(module, exports, __webpack_require__) {

var hsl = __webpack_require__(1956);
var hex = __webpack_require__(1957);
var rgb = __webpack_require__(1958);
var hsl2rgb = __webpack_require__(1959);

function hsl2rgbParse(color) {
  var h = hsl(color);
  var r = hsl2rgb(h);

  // handle alpha since hsl2rgb doesn't know (or care!) about it
  if(h.length === 4) {
    r.push(h[3]);
  }

  return r;
}

var space2parser = {
  "#" : hex,
  "hsl" : hsl2rgbParse,
  "rgb" : rgb
};

function parse(color) {
  for(var scheme in space2parser) {
    if(color.indexOf(scheme) === 0) {
      return space2parser[scheme](color);
    }
  }
}

parse.rgb = rgb;
parse.hsl = hsl;
parse.hex = hex;

module.exports = parse;

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

var extractComponents = __webpack_require__(738);
var clamp = __webpack_require__(481);

function parseHslComponent(component, i) {
  component = parseFloat(component);

  switch(i) {
    case 0:
      return clamp(component, 0, 360);
    case 1:
    case 2:
      return clamp(component, 0, 100);
    case 3:
      return clamp(component, 0, 1);
  }
}

function hsl(color) {
  return extractComponents(color).map(parseHslComponent);
}

module.exports = hsl;

/***/ }),
/* 1957 */
/***/ (function(module, exports) {

function hex(hex) {
  if (hex.length === 4) {
    hex = '#' + hex.charAt(1) + hex.charAt(1) +
      hex.charAt(2) + hex.charAt(2) + 
      hex.charAt(3) + hex.charAt(3);
  }
  return [
    parseInt(hex.substring(1,3), 16),
    parseInt(hex.substring(3,5), 16),
    parseInt(hex.substring(5,7), 16)
  ];
}

module.exports = hex;

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

var extractComponents = __webpack_require__(738);
var clamp = __webpack_require__(481);

function parseRgbComponent(component, i) {
  if (i < 3) {
    if (component.indexOf('%') != -1) {
      return Math.round(255 * clamp(parseInt(component, 10), 0, 100)/100);
    } else {
      return clamp(parseInt(component, 10), 0, 255);
    }
  } else {
    return clamp(parseFloat(component), 0, 1);
  } 
}

function rgb(color) {
  return extractComponents(color).map(parseRgbComponent);
}

module.exports = rgb;

/***/ }),
/* 1959 */
/***/ (function(module, exports) {

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

module.exports = hsl2rgb;

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return baseRest(function(funcs) {
    funcs = baseFlatten(funcs, 1);

    var length = funcs.length,
        index = length;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      if (typeof funcs[index] != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
    }
    return function() {
      var index = 0,
          result = length ? funcs[index].apply(this, arguments) : arguments[0];

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yuv2rgb = yuv2rgb;
exports.rgb2yuv = rgb2yuv;
function yuv2rgb(yuv) {
  var y = yuv[0],
      u = yuv[1],
      v = yuv[2],
      r,
      g,
      b;

  r = y * 1 + u * 0 + v * 1.13983;
  g = y * 1 + u * -0.39465 + v * -0.58060;
  b = y * 1 + u * 2.02311 + v * 0;

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function rgb2yuv(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  var y = r * 0.299 + g * 0.587 + b * 0.114;
  var u = r * -0.14713 + g * -0.28886 + b * 0.436;
  var v = r * 0.615 + g * -0.51499 + b * -0.10001;

  return [y, u, v];
};

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  scheme: 'solarized',
  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
  base00: '#002b36',
  base01: '#073642',
  base02: '#586e75',
  base03: '#657b83',
  base04: '#839496',
  base05: '#93a1a1',
  base06: '#eee8d5',
  base07: '#fdf6e3',
  base08: '#dc322f',
  base09: '#cb4b16',
  base0A: '#b58900',
  base0B: '#859900',
  base0C: '#2aa198',
  base0D: '#268bd2',
  base0E: '#6c71c4',
  base0F: '#d33682'
};

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactJsonTree = __webpack_require__(720);

var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  actionBar: {
    paddingTop: 8,
    paddingBottom: 7,
    paddingLeft: 16
  },
  payload: {
    margin: 0,
    paddingLeft: 16,
    overflow: 'auto'
  }
};

var LogMonitorAction = function (_Component) {
  _inherits(LogMonitorAction, _Component);

  function LogMonitorAction(props) {
    _classCallCheck(this, LogMonitorAction);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.shouldExpandNode = _this.shouldExpandNode.bind(_this);
    return _this;
  }

  LogMonitorAction.prototype.renderPayload = function renderPayload(payload) {
    return _react2.default.createElement(
      'div',
      { style: _extends({}, styles.payload, {
          backgroundColor: this.props.theme.base00
        }) },
      Object.keys(payload).length > 0 ? _react2.default.createElement(_reactJsonTree2.default, { theme: this.props.theme,
        invertTheme: false,
        keyPath: ['action'],
        data: payload,
        shouldExpandNode: this.shouldExpandNode }) : ''
    );
  };

  LogMonitorAction.prototype.shouldExpandNode = function shouldExpandNode(keyName, data, level) {
    return this.props.expandActionRoot && level === 0;
  };

  LogMonitorAction.prototype.render = function render() {
    var _props$action = this.props.action;
    var type = _props$action.type;

    var payload = _objectWithoutProperties(_props$action, ['type']);

    return _react2.default.createElement(
      'div',
      { style: _extends({
          backgroundColor: this.props.theme.base02,
          color: this.props.theme.base06
        }, this.props.style) },
      _react2.default.createElement(
        'div',
        { style: styles.actionBar,
          onClick: this.props.onClick },
        type !== null && type.toString()
      ),
      !this.props.collapsed ? this.renderPayload(payload) : ''
    );
  };

  return LogMonitorAction;
}(_react.Component);

exports.default = LogMonitorAction;

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(0),m=__webpack_require__(1967),A=__webpack_require__(77),C=__webpack_require__(100),ea=__webpack_require__(1968),fa=__webpack_require__(1969),ha=__webpack_require__(1970),ja=__webpack_require__(269);
function D(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}ba?void 0:D("227");
function ka(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ka.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return ma.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function ma(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var na=null,oa={};
function pa(){if(na)for(var a in oa){var b=oa[a],c=na.indexOf(a);-1<c?void 0:D("96",a);if(!qa[c]){b.extractEvents?void 0:D("97",a);qa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;ra.hasOwnProperty(g)?D("99",g):void 0;ra[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&sa(k[e],h,g);e=!0}else f.registrationName?(sa(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function sa(a,b,c){ta[a]?D("100",a):void 0;ta[a]=b;ua[a]=b.eventTypes[c].dependencies}var qa=[],ra={},ta={},ua={};function va(a){na?D("101"):void 0;na=Array.prototype.slice.call(a);pa()}function wa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?D("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}
var xa=Object.freeze({plugins:qa,eventNameDispatchConfigs:ra,registrationNameModules:ta,registrationNameDependencies:ua,possibleRegistrationNames:null,injectEventPluginOrder:va,injectEventPluginsByName:wa}),Ca=null,Da=null,Ea=null;function Fa(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ea(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ga(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ha(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ia=null;
function Ja(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Fa(a,b,c[e],d[e]);else c&&Fa(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ka(a){return Ja(a,!0)}function La(a){return Ja(a,!1)}var Ma={injectEventPluginOrder:va,injectEventPluginsByName:wa};
function Na(a,b){var c=a.stateNode;if(!c)return null;var d=Ca(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Oa(a,b){null!==a&&(Ia=Ga(Ia,a));a=Ia;Ia=null;a&&(b?Ha(a,Ka):Ha(a,La),Ia?D("95"):void 0,E.rethrowCaughtError())}function Pa(a,b,c,d){for(var e=null,f=0;f<qa.length;f++){var h=qa[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ga(e,h))}Oa(e,!1)}var Qa=Object.freeze({injection:Ma,getListener:Na,runEventsInBatch:Oa,runExtractedEventsInBatch:Pa}),Ra=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Ra,Sa="__reactEventHandlers$"+Ra;
function Ta(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Ua(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Va(a){return a[Sa]||null}var ab=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ta,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Ua,getFiberCurrentPropsFromNode:Va,updateFiberProps:function(a,b){a[Sa]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function bb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function cb(a,b,c){if(b=Na(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ga(c._dispatchListeners,b),c._dispatchInstances=Ga(c._dispatchInstances,a)}function db(a){a&&a.dispatchConfig.phasedRegistrationNames&&bb(a._targetInst,cb,a)}
function eb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;bb(b,cb,a)}}function fb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Na(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ga(c._dispatchListeners,b),c._dispatchInstances=Ga(c._dispatchInstances,a))}function gb(a){a&&a.dispatchConfig.registrationName&&fb(a._targetInst,null,a)}function hb(a){Ha(a,db)}
function ib(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)fb(e[d],"bubbled",a);for(a=c.length;0<a--;)fb(c[a],"captured",b)}
var jb=Object.freeze({accumulateTwoPhaseDispatches:hb,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ha(a,eb)},accumulateEnterLeaveDispatches:ib,accumulateDirectDispatches:function(a){Ha(a,gb)}}),kb=null;function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var M={_root:null,_startText:null,_fallbackText:null};
function mb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function nb(){return"value"in M._root?M._root.value:M._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});N.Interface=pb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(N);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=N.extend({data:null}),ub=N.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Eb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Kb=!1;
function Lb(a,b){switch(a){case "topKeyUp":return-1!==vb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Mb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Nb=!1;function Ob(a,b){switch(a){case "topCompositionEnd":return Mb(b);case "topKeyPress":if(32!==b.which)return null;Kb=!0;return Ab;case "topTextInput":return a=b.data,a===Ab&&Kb?null:a;default:return null}}
function Pb(a,b){if(Nb)return"topCompositionEnd"===a||!wb&&Lb(a,b)?(a=mb(),M._root=null,M._startText=null,M._fallbackText=null,Nb=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return zb?null:b.data;default:return null}}
var Qb={eventTypes:Eb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "topCompositionStart":e=Eb.compositionStart;break b;case "topCompositionEnd":e=Eb.compositionEnd;break b;case "topCompositionUpdate":e=Eb.compositionUpdate;break b}e=void 0}else Nb?Lb(a,c)&&(e=Eb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Eb.compositionStart);e?(zb&&(Nb||e!==Eb.compositionStart?e===Eb.compositionEnd&&Nb&&(f=mb()):(M._root=d,M._startText=nb(),Nb=!0)),e=tb.getPooled(e,
b,c,d),f?e.data=f:(f=Mb(c),null!==f&&(e.data=f)),hb(e),f=e):f=null;(a=yb?Ob(a,c):Pb(a,c))?(b=ub.getPooled(Eb.beforeInput,b,c,d),b.data=a,hb(b)):b=null;return null===f?b:null===b?f:[f,b]}},Rb=null,Sb=null,Tb=null;function Ub(a){if(a=Da(a)){Rb&&"function"===typeof Rb.restoreControlledState?void 0:D("194");var b=Ca(a.stateNode);Rb.restoreControlledState(a.stateNode,a.type,b)}}var Vb={injectFiberControlledHostComponent:function(a){Rb=a}};function Wb(a){Sb?Tb?Tb.push(a):Tb=[a]:Sb=a}
function Xb(){return null!==Sb||null!==Tb}function Yb(){if(Sb){var a=Sb,b=Tb;Tb=Sb=null;Ub(a);if(b)for(a=0;a<b.length;a++)Ub(b[a])}}var Zb=Object.freeze({injection:Vb,enqueueStateRestore:Wb,needsStateRestore:Xb,restoreStateIfNeeded:Yb});function $b(a,b){return a(b)}function ac(a,b,c){return a(b,c)}function bc(){}var cc=!1;function dc(a,b){if(cc)return a(b);cc=!0;try{return $b(a,b)}finally{cc=!1,Xb()&&(bc(),Yb())}}
var ec={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function fc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!ec[a.type]:"textarea"===b?!0:!1}function gc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function hc(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ic(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function jc(a){var b=ic(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function kc(a){a._valueTracker||(a._valueTracker=jc(a))}function lc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ic(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var mc=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],nc=O?Symbol["for"]("react.element"):60103,oc=O?Symbol["for"]("react.call"):60104,pc=O?Symbol["for"]("react.return"):60105,qc=O?Symbol["for"]("react.portal"):60106,rc=O?Symbol["for"]("react.fragment"):60107,sc=O?Symbol["for"]("react.strict_mode"):60108,tc=O?Symbol["for"]("react.provider"):60109,uc=O?Symbol["for"]("react.context"):60110,vc=O?Symbol["for"]("react.async_mode"):60111,
wc=O?Symbol["for"]("react.forward_ref"):60112,xc="function"===typeof Symbol&&Symbol.iterator;function yc(a){if(null===a||"undefined"===typeof a)return null;a=xc&&a[xc]||a["@@iterator"];return"function"===typeof a?a:null}function zc(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case rc:return"ReactFragment";case qc:return"ReactPortal";case oc:return"ReactCall";case pc:return"ReactReturn"}return null}
function Ac(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=zc(a);var f=null;c&&(f=zc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Bc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Cc={},Dc={};function Ec(a){if(Dc.hasOwnProperty(a))return!0;if(Cc.hasOwnProperty(a))return!1;if(Bc.test(a))return Dc[a]=!0;Cc[a]=!0;return!1}
function Fc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Gc(a,b,c,d){if(null===b||"undefined"===typeof b||Fc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Hc=/[\-\:]([a-z])/g;function Sc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Hc,
Sc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Hc,Sc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Hc,Sc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Tc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Gc(b,c,e,d)&&(c=null),d||null===e?Ec(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Uc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Vc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Wc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Xc(a,b){b=b.checked;null!=b&&Tc(a,"checked",b,!1)}
function Yc(a,b){Xc(a,b);var c=Wc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Zc(a,b.type,Wc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function $c(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Wc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var ad={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function bd(a,b,c){a=N.getPooled(ad.change,a,b,c);a.type="change";Wb(c);hb(a);return a}var cd=null,dd=null;function ed(a){Oa(a,!1)}
function fd(a){var b=Ua(a);if(lc(b))return a}function gd(a,b){if("topChange"===a)return b}var hd=!1;m.canUseDOM&&(hd=hc("input")&&(!document.documentMode||9<document.documentMode));function id(){cd&&(cd.detachEvent("onpropertychange",jd),dd=cd=null)}function jd(a){"value"===a.propertyName&&fd(dd)&&(a=bd(dd,a,gc(a)),dc(ed,a))}function kd(a,b,c){"topFocus"===a?(id(),cd=b,dd=c,cd.attachEvent("onpropertychange",jd)):"topBlur"===a&&id()}
function ld(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return fd(dd)}function md(a,b){if("topClick"===a)return fd(b)}function nd(a,b){if("topInput"===a||"topChange"===a)return fd(b)}
var od={eventTypes:ad,_isInputEventSupported:hd,extractEvents:function(a,b,c,d){var e=b?Ua(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=gd:fc(e)?hd?f=nd:(f=ld,h=kd):(g=e.nodeName,!g||"input"!==g.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(f=md));if(f&&(f=f(a,b)))return bd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&Zc(e,"number",e.value)}},pd=N.extend({view:null,
detail:null}),qd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function rd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=qd[a])?!!b[a]:!1}function sd(){return rd}
var td=pd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:sd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),ud={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},vd={eventTypes:ud,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ta(b):null):a=null;if(a===b)return null;var f=null==a?e:Ua(a);e=null==b?e:Ua(b);var h=td.getPooled(ud.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=td.getPooled(ud.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;ib(h,c,a,b);return[h,c]}};function wd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function xd(a){return(a=a._reactInternalFiber)?2===wd(a):!1}function yd(a){2!==wd(a)?D("188"):void 0}
function zd(a){var b=a.alternate;if(!b)return b=wd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return yd(e),a;if(h===d)return yd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Ad(a){a=zd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Bd(a){a=zd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Cd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Dd=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Ed=pd.extend({relatedTarget:null});
function Fd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Gd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Hd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Id=pd.extend({key:function(a){if(a.key){var b=Gd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Fd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Hd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:sd,charCode:function(a){return"keypress"===
a.type?Fd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Fd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Jd=td.extend({dataTransfer:null}),Kd=pd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:sd}),Ld=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Md=td.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Nd={},Od={};function Pd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Nd[a]=b;Od[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Pd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Pd(a,!1)});
var Qd={eventTypes:Nd,isInteractiveTopLevelEventType:function(a){a=Od[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Od[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Fd(c))return null;case "topKeyDown":case "topKeyUp":a=Id;break;case "topBlur":case "topFocus":a=Ed;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
td;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Jd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Kd;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Cd;break;case "topTransitionEnd":a=Ld;break;case "topScroll":a=pd;break;case "topWheel":a=Md;break;case "topCopy":case "topCut":case "topPaste":a=Dd;break;default:a=
N}b=a.getPooled(e,b,c,d);hb(b);return b}},Rd=Qd.isInteractiveTopLevelEventType,Sd=[];function Td(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ta(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Pa(a.topLevelType,b,a.nativeEvent,gc(a.nativeEvent))}var Ud=!0;function Vd(a){Ud=!!a}
function W(a,b,c){if(!c)return null;a=(Rd(a)?Wd:Xd).bind(null,a);c.addEventListener(b,a,!1)}function Yd(a,b,c){if(!c)return null;a=(Rd(a)?Wd:Xd).bind(null,a);c.addEventListener(b,a,!0)}function Wd(a,b){ac(Xd,a,b)}
function Xd(a,b){if(Ud){var c=gc(b);c=Ta(c);null!==c&&"number"===typeof c.tag&&2!==wd(c)&&(c=null);if(Sd.length){var d=Sd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{dc(Td,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Sd.length&&Sd.push(a)}}}
var Zd=Object.freeze({get _enabled(){return Ud},setEnabled:Vd,isEnabled:function(){return Ud},trapBubbledEvent:W,trapCapturedEvent:Yd,dispatchEvent:Xd});function $d(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var ae={animationend:$d("Animation","AnimationEnd"),animationiteration:$d("Animation","AnimationIteration"),animationstart:$d("Animation","AnimationStart"),transitionend:$d("Transition","TransitionEnd")},be={},ce={};m.canUseDOM&&(ce=document.createElement("div").style,"AnimationEvent"in window||(delete ae.animationend.animation,delete ae.animationiteration.animation,delete ae.animationstart.animation),"TransitionEvent"in window||delete ae.transitionend.transition);
function de(a){if(be[a])return be[a];if(!ae[a])return a;var b=ae[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in ce)return be[a]=b[c];return a}
var ee={topAnimationEnd:de("animationend"),topAnimationIteration:de("animationiteration"),topAnimationStart:de("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:de("transitionend"),topWheel:"wheel"},fe={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},ge={},he=0,ie="_reactListenersID"+(""+Math.random()).slice(2);function je(a){Object.prototype.hasOwnProperty.call(a,ie)||(a[ie]=he++,ge[a[ie]]={});return ge[a[ie]]}function ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function le(a,b){var c=ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ke(c)}}function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var ne=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,oe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},pe=null,qe=null,re=null,se=!1;
function ue(a,b){if(se||null==pe||pe!==ea())return null;var c=pe;"selectionStart"in c&&me(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return re&&fa(re,c)?null:(re=c,a=N.getPooled(oe.select,qe,a,b),a.type="select",a.target=pe,hb(a),a)}
var we={eventTypes:oe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=je(e);f=ua.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ua(b):window;switch(a){case "topFocus":if(fc(e)||"true"===e.contentEditable)pe=e,qe=b,re=null;break;case "topBlur":re=qe=pe=null;break;case "topMouseDown":se=!0;break;case "topContextMenu":case "topMouseUp":return se=!1,ue(c,d);case "topSelectionChange":if(ne)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Ma.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ca=ab.getFiberCurrentPropsFromNode;Da=ab.getInstanceFromNode;Ea=ab.getNodeFromInstance;Ma.injectEventPluginsByName({SimpleEventPlugin:Qd,EnterLeaveEventPlugin:vd,ChangeEventPlugin:od,SelectEventPlugin:we,BeforeInputEventPlugin:Qb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ye(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function ze(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case rc:return Ae(a.children,b,c,e);case vc:f=11;b|=3;break;case sc:f=11;b|=2;break;case oc:f=7;break;case pc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case tc:f=13;break;case uc:f=12;break;case wc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Ae(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Be(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function Ce(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var De=null,Ee=null;
function Fe(a){return function(b){try{return a(b)}catch(c){}}}function Ge(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);De=Fe(function(a){return b.onCommitFiberRoot(c,a)});Ee=Fe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function He(a){"function"===typeof De&&De(a)}function Ie(a){"function"===typeof Ee&&Ee(a)}new Set;
function Je(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Ke(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Le=void 0,Me=void 0;
function Ne(a){Le=Me=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Je(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Je(null))):a=null;Le=c;Me=a!==c?a:null}function Oe(a,b){Ne(a);a=Le;var c=Me;null===c?Ke(a,b):null===a.last||null===c.last?(Ke(a,b),Ke(c,b)):(Ke(a,b),c.last=b)}function Pe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Qe(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Pe(g,d,a,e),h=!0;else if(v=Pe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Re(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Se(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!fa(b,c)||!fa(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,y=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:xd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Oe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Oe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Oe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=y(a),f=e?l(a,d):ja;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ja;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Qe(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,y=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||y!==q)&&g(a,n,r,q);y=a.memoizedState;b=null!==a.updateQueue?Qe(null,a,a.updateQueue,n,r,b):y;var t=void 0;h!==r&&(t=k(a,n,r,b));null!==t&&void 0!==t&&(b=null===b||void 0===b?t:A({},b,t));if(!(h!==r||y!==b||
B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,y,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),
d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,t=p(b);t=l(b,t);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||(h!==r||q!==t)&&g(b,x,r,t);q=b.memoizedState;c=null!==b.updateQueue?
Qe(a,b,b.updateQueue,x,r,c):q;var u=void 0;h!==r&&(u=k(b,x,r,c));null!==u&&void 0!==u&&(c=null===c||void 0===c?u:A({},c,u));if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),!1;(u=f(b,h,r,q,c,t))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==
typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,t),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,t)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||
(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=t;return u}}}var Te=Array.isArray;
function Ue(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ja?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function Ve(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function We(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ye(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Be(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ue(a,b,c),d["return"]=a,d;d=ze(c,a.mode,d);d.ref=Ue(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Ae(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Be(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case nc:return c=ze(b,a.mode,c),c.ref=Ue(a,null,b),c["return"]=a,c;case qc:return b=Ce(b,a.mode,c),b["return"]=a,b}if(Te(b)||yc(b))return b=Ae(b,
a.mode,c,null),b["return"]=a,b;Ve(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case nc:return c.key===e?c.type===rc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case qc:return c.key===e?v(a,b,c,d):null}if(Te(c)||yc(c))return null!==e?null:l(a,b,c,d,null);Ve(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case nc:return a=a.get(null===d.key?c:d.key)||null,d.type===rc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case qc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Te(d)||yc(d))return a=a.get(c)||null,l(b,a,d,e,null);Ve(b,d)}return null}function r(e,g,l,h){for(var r=null,k=null,q=g,t=g=0,u=null;null!==q&&t<l.length;t++){q.index>t?(u=q,q=null):u=q.sibling;var n=y(e,q,l[t],h);if(null===n){null===q&&(q=u);break}a&&q&&null===
n.alternate&&b(e,q);g=f(n,g,t);null===k?r=n:k.sibling=n;k=n;q=u}if(t===l.length)return c(e,q),r;if(null===q){for(;t<l.length;t++)if(q=p(e,l[t],h))g=f(q,g,t),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);t<l.length;t++)if(u=B(q,e,t,l[t],h)){if(a&&null!==u.alternate)q["delete"](null===u.key?t:u.key);g=f(u,g,t);null===k?r=u:k.sibling=u;k=u}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,g,l,h){var r=yc(l);"function"!==typeof r?D("150"):void 0;l=r.call(l);null==l?D("151"):void 0;for(var k=
r=null,q=g,t=g=0,u=null,n=l.next();null!==q&&!n.done;t++,n=l.next()){q.index>t?(u=q,q=null):u=q.sibling;var H=y(e,q,n.value,h);if(null===H){q||(q=u);break}a&&q&&null===H.alternate&&b(e,q);g=f(H,g,t);null===k?r=H:k.sibling=H;k=H;q=u}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;t++,n=l.next())n=p(e,n.value,h),null!==n&&(g=f(n,g,t),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;t++,n=l.next())if(n=B(q,e,t,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?t:n.key);
g=f(n,g,t);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,g){"object"===typeof f&&null!==f&&f.type===rc&&null===f.key&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case nc:a:{var k=f.key;for(l=d;null!==l;){if(l.key===k)if(10===l.tag?f.type===rc:l.type===f.type){c(a,l.sibling);d=e(l,f.type===rc?f.props.children:f.props,g);d.ref=Ue(a,l,f);d["return"]=a;a=d;break a}else{c(a,l);break}else b(a,l);l=l.sibling}f.type===
rc?(d=Ae(f.props.children,a.mode,g,f.key),d["return"]=a,a=d):(g=ze(f,a.mode,g),g.ref=Ue(a,d,f),g["return"]=a,a=g)}return h(a);case qc:a:{for(l=f.key;null!==d;){if(d.key===l)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ce(f,a.mode,g);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,g)):(c(a,d),d=Be(f,a.mode,g)),d["return"]=a,a=d,h(a);if(Te(f))return r(a,d,f,g);if(yc(f))return Q(a,d,f,g);l&&Ve(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:g=a.type,D("152",g.displayName||g.name||"Component")}return c(a,d)}}var Xe=We(!0),Ye=We(!1);
function Ze(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ye(b,null,c,d):Xe(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&z(b,!1),r(a,b);c=b.stateNode;mc.current=b;var g=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,g,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&z(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?u(a,b.pendingContext,b.pendingContext!==b.context):b.context&&u(a,b.context,!1);Y(a,b.containerInfo)}function y(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type.context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var t=f.value;if(t===l&&(0!==t||1/t===1/l)||t!==t&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(t,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else y(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ye(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ye(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,t=c.pushContextProvider,u=c.pushTopLevelContextObject,z=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Bb=e.tryToClaimNextHydratableInstance;
a=Se(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Cb=a.mountClassInstance,Mc=a.resumeMountClassInstance,Db=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:t(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=t(b),Jc(b,d),Cb(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=t(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Cb(b,c),d=!0):d=Mc(b,c):d=Db(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Qe(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ye(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Bb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Bb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ye(b,b.stateNode,d,c):Xe(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Xe(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:d=b.type;f=b.pendingProps;var u=b.memoizedProps;e=d._currentValue;h=d._changedBits;if(q()||0!==h||u!==f){b.memoizedProps=
f;u=f.unstable_observedBits;if(void 0===u||null===u)u=1073741823;b.stateNode=u;0!==(h&u)&&y(b,d,h,c);c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b);return a;default:D("156")}}}}
function $e(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,y=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,t=void 0,u=void 0;a.mutation?(q=function(){},t=function(a,b,c){(b.updateQueue=
c)&&f(b)},u=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=y();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,z=r();H=l(H,e,p,d,c,z);t(a,b,H,e,p,d,c,z);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(z=b.child;null!==z;){if(5===z.tag||6===z.tag)k(p,z.stateNode);else if(4!==z.tag&&null!==z.child){z.child["return"]=z;z=z.child;continue}if(z===b)break;
for(;null===z.sibling;){if(null===z["return"]||z["return"]===b)break a;z=z["return"]}z.sibling["return"]=z["return"];z=z.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)u(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=y();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Xe(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function af(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Ac(b)};do{switch(a.tag){case 3:Ne(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Ne(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function bf(a,b){var c=b.source;null===b.stack&&Ac(c);null!==c&&zc(c);b=b.value;null!==a&&2===a.tag&&zc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function cf(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(u){b(a,u)}else c.current=null}function h(a){"function"===typeof Ie&&Ie(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(u){b(a,u)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var y=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Re(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Re(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&y(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var g=d.value,h=d.stack;bf(a,d);b.componentDidCatch(g,{componentStack:null!==h?h:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],bf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var df={};
function ef(a,b){function c(a){a===df?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(df),k=a(df),v=a(df);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);b=e(b);f(k,a,a);f(g,b,a)},pushHostContext:function(a){var b=c(v.current),
e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function ff(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,y=null,B=!1;return{enterHydrationState:function(a){y=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){y=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=y;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,y)}p=a;y=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=y;c;)b(a,c),c=g(c);d(a);y=p?g(a.stateNode):null;return!0}}}
function gf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",zc(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ja),k=e(!1),v=ja;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ja;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ja;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
wd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function hf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type.context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type.context;a._currentValue=c;a._changedBits=b}}}
function jf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function kf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Xa=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Bb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));mc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Xa||null===I)b(),Xa=a,Z=c,I=ye(Xa.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Ac(a)};Oe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Ya?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Ya?1:Z:a.mode&1?za?10*(((l()+50)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Ya&&Xa===d||B(d,c);Fb>wg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ve=Ic()-Pc;return xg=(ve/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function y(a){if(0!==Gb){if(a>Gb)return;yg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():y(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){Za=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==Za&&(Gb=0,Qc=-1);0!==P&&y(P);Za=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(vg){Ba||(Ba=!0,Jb=vg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Ya=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();mc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Cb(w.alternate,w),w=w.nextEffect}catch($a){h=!0,k=$a}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Db(w);w.effectTag&=-3;break;case 6:Db(w);w.effectTag&=-3;te(w.alternate,w);break;case 4:te(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch($a){h=!0,k=$a}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch($a){p=!0,n=$a}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Ya=!1;"function"===typeof He&&He(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===Za||Za.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var t=jf(),u=ef(a,t),z=gf(t);t=hf(t);var H=ff(a),
Wa=Ze(a,u,z,t,H,v,k).beginWork,Bb=$e(a,u,z,t,H).completeWork;u=af(u,z,t,v,c);var Jc=u.throwException,Kc=u.unwindWork,Lc=u.unwindInterruptedWork;u=cf(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Cb=u.commitBeforeMutationLifeCycles,Mc=u.commitResetTextContent,Db=u.commitPlacement,gg=u.commitDeletion,te=u.commitWork,hg=u.commitLifeCycles,ig=u.commitErrorLogging,jg=u.commitAttachRef,kg=u.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,yg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),xg=2,ve=Pc,Rc=0,ia=0,ca=!1,I=null,Xa=null,Z=0,w=null,Ya=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,Za=null,J=!1,Hb=!1,za=!1,Aa=null,wg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:z}}
function lf(a){function b(a,b,c,d,e,f){d=b.current;if(c){c=c._reactInternalFiber;var g=k(c);c=v(c)?l(c,g):g}else c=ja;null===b.context?b.context=c:b.pendingContext=c;b=f;Oe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});h(d,e);return e}function c(a){a=Ad(a);return null===a?null:a.stateNode}var d=a.getPublicInstance;a=kf(a);var e=a.recalculateCurrentTime,f=a.computeExpirationForFiber,h=a.scheduleWork,g=a.legacyContext,
k=g.findCurrentUnmaskedContext,v=g.isContextProvider,l=g.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,d,g){var h=c.current,k=e();h=f(h);return b(a,c,d,k,h,g)},updateContainerAtExpirationTime:function(a,
c,d,f,g){var h=e();return b(a,c,d,h,f,g)},flushRoot:a.flushRoot,requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return d(a.child.stateNode);
default:return a.child.stateNode}},findHostInstance:c,findHostInstanceWithNoPortals:function(a){a=Bd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return Ge(A({},a,{findHostInstanceByFiber:function(a){return c(a)},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;
function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:qc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};var sf=void 0,tf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf=void 0;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==
wf&&wf<=a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},tf=function(a){clearTimeout(a)};function Ef(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Ff(a,b){a=A({children:void 0},b);if(b=Ef(b.children))a.children=b;return a}
function Gf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Hf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function If(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Kf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Lf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Mf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Of(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pf=void 0,Qf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mf.svg||"innerHTML"in a)a.innerHTML=b;else{Pf=Pf||document.createElement("div");Pf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Pf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Sf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Tf=["Webkit","ms","Moz","O"];Object.keys(Sf).forEach(function(a){Tf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Sf[b]=Sf[a]})});
function Uf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Sf.hasOwnProperty(e)&&Sf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Vf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Wf(a,b,c){b&&(Vf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Xf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Yf=Mf.html,Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=je(a);b=ua[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Yd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Yd("topFocus","focus",a),Yd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(hc("cancel",!0)&&Yd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(hc("close",!0)&&Yd("topClose","close",a),c.topClose=!0):ee.hasOwnProperty(e)&&W(e,ee[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Yf&&(d=Nf(a));d===Yf?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Xf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in fe)fe.hasOwnProperty(f)&&W(f,fe[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Vc(a,c);f=Uc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Ff(a,c);break;case "select":Hf(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Jf(a,c);f=If(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Wf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Uf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Qf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Rf(a,k):"number"===typeof k&&
Rf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ta.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Tc(a,g,k,e))}switch(b){case "input":kc(a);$c(a,c);break;case "textarea":kc(a);Lf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Gf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Gf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Uc(a,c);d=Uc(a,d);f=[];break;case "option":c=Ff(a,c);d=Ff(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=If(a,c);d=If(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Wf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ta.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ta.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Xc(a,e);Xf(c,d);d=Xf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Uf(a,g,Zf):"dangerouslySetInnerHTML"===h?Qf(a,g):"children"===h?Rf(a,g):Tc(a,h,g,d)}switch(c){case "input":Yc(a,e);break;case "textarea":Kf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Gf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Gf(a,!!e.multiple,e.defaultValue,!0):Gf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in fe)fe.hasOwnProperty(f)&&W(f,fe[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Vc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":Hf(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Jf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Wf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ta.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":kc(a);$c(a,c);break;case "textarea":kc(a);Lf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function mg(a,b){return a.nodeValue!==b}
var ng=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:mg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Va(d);e?void 0:D("90");lc(d);Yc(d,e)}}}break;case "textarea":Kf(a,c);break;case "select":b=c.value,null!=b&&Gf(a,!!c.multiple,b,!1)}}});Vb.injectFiberControlledHostComponent(ng);var og=null,pg=null;
function qg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}qg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new rg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
qg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
qg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};qg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function rg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}rg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function sg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}sg.prototype.render=function(a,b){var c=this._internalRoot,d=new rg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
sg.prototype.unmount=function(a){var b=this._internalRoot,c=new rg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};sg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new rg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
sg.prototype.createBatch=function(){var a=new qg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function tg(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function ug(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Of(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Of(a,b)}return a},getChildHostContext:function(a,b){return Of(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){og=Ud;var a=ea();if(me(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var y;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(y=l.firstChild))break;p=l;l=y}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(y=l.nextSibling))break;l=p;p=l.parentNode}l=y}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;pg={focusedElem:a,selectionRange:b};Vd(!1)},resetAfterCommit:function(){var a=pg,b=ea(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ha(document.documentElement,c)){if(me(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[lb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=le(c,a);var f=le(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}pg=null;Vd(og);og=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Sa]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return ug(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:rf,mutation:{commitMount:function(a,b,c){ug(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Sa]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Rf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Sa]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return mg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf}),Cg=X;$b=Cg.batchedUpdates;ac=Cg.interactiveUpdates;bc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new sg(a,!1,b)}
function Eg(a,b,c,d,e){tg(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;tg(b)?void 0:D("200");return pf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return X.findHostInstance(b);"function"===typeof a.render?D("188"):D("213",Object.keys(a))},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){tg(a)?void 0:
D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Qa,EventPluginRegistry:xa,EventPropagators:jb,ReactControlledComponent:Zb,ReactDOMComponentTree:ab,
ReactDOMEventListener:Zd},unstable_createRoot:function(a,b){return new sg(a,!0,null!=b&&!0===b.hydrate)}};X.injectIntoDevTools({findFiberByHostInstance:Ta,bundleType:0,version:"16.3.0",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(1971);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(1972);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// @noflow
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
window.console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
window.console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){window.console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Root;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lifecycle_component__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lifecycle_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_lifecycle_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__drivers_cookie__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_cookie_policy__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_error_boundary__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_state_translations_selectors__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_state_application_selectors__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_global__ = __webpack_require__(2544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_themes_main__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__routes__ = __webpack_require__(2553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_raven_user_setup__ = __webpack_require__(2561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_universal_analytics__ = __webpack_require__(819);
var mapStateToProps=function mapStateToProps(state){var locale=Object(__WEBPACK_IMPORTED_MODULE_7__core_state_application_selectors__["q" /* getUserLocale */])(state);var translations=Object(__WEBPACK_IMPORTED_MODULE_6__core_state_translations_selectors__["a" /* getTranslations */])(state);return{locale:locale,defaultLocale:locale,key:locale,messages:translations&&translations.toJS()};};var mapDistpatchToProps={appLoaded:__WEBPACK_IMPORTED_MODULE_1__core_state_application_actions__["b" /* appLoaded */]};function mergeProps(stateProps,dispatchProps,ownProps){var appLoaded=dispatchProps.appLoaded;var locale=stateProps.locale;return Object.assign({},ownProps,stateProps,dispatchProps,{componentWillMount:function componentWillMount(){return appLoaded({locale:locale});}});}var ConnectedIntlProvider=Object(__WEBPACK_IMPORTED_MODULE_2_react_lifecycle_component__["connectWithLifecycle"])(mapStateToProps,mapDistpatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_10_react_intl__["d" /* IntlProvider */]);function devToolsComponentWhenDevMode(isDev){if(isDev){return __webpack_require__(2562).default;}return null;}function Root(_ref){var children=_ref.children,store=_ref.store;var DevTools=void 0;var isDev="production"==='development';var HiveDevTools=devToolsComponentWhenDevMode(isDev);var allowDevTools=Object({"NODE_ENV":"production","PUBLIC_URL":"","PLATFORM":"web"}).REACT_APP_DEVTOOLS;if(allowDevTools){DevTools=__webpack_require__(713).default;var immutable=__webpack_require__(6);var installDevTools=__webpack_require__(2564);installDevTools(immutable);}var cookieAccepted=__WEBPACK_IMPORTED_MODULE_3__drivers_cookie__["a" /* default */].get('cookie-accepted');return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_redux__["Provider"],{store:store},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ConnectedIntlProvider,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__components_raven_user_setup__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15_styled_components__["a" /* ThemeProvider */],{theme:__WEBPACK_IMPORTED_MODULE_9__core_themes_main__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__components_error_boundary__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__components_universal_analytics__["a" /* UAUserSetup */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_global__["a" /* default */],null,!cookieAccepted&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_widgets_cookie_policy__["a" /* default */],null),children||__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__routes__["a" /* default */],null),isDev&&HiveDevTools&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HiveDevTools,null),allowDevTools&&DevTools?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DevTools,null):false))))))));}Root.propTypes={store:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired};

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _redux = __webpack_require__(222);

var _reactRedux = __webpack_require__(8);

var _applyLifecycle = __webpack_require__(740);

var _applyLifecycle2 = _interopRequireDefault(_applyLifecycle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (mapStateToProps, mapDispatchToProps, mergeProps) {
	return function (component) {
		var connected = (0, _redux.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, mergeProps), _applyLifecycle2.default);
		return connected(component);
	};
};

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_cookie_banner__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_cookie_banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_cookie_banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(2044);
var CookiePolicyAlert=function CookiePolicyAlert(_ref){var isLoading=_ref.isLoading,formatMessage=_ref.intl.formatMessage;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* CookieContainer */],null,!isLoading&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_cookie_banner___default.a,{buttonMessage:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',{'data-qa':'cookie-policy-close'},formatMessage(__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].cookiePolicyConfirm)),cookie:'cookie-accepted','data-qa':'cookie-policy',dismissOnScroll:false,link:{msg:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* InfoIcon */],null),url:formatMessage(__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].cookiePolicyURL),target:'_blank'},message:formatMessage(__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].cookiePolicyMessage),onAccept:function onAccept(){},styles:{banner:{backgroundColor:'#E5F5F7',boxShadow:'1px 0px 5px #3D8081',height:'100%',padding:'1rem',overflow:'auto'},message:{color:'#3E4F56',fontSize:'1rem',lineHeight:'1rem',display:'inline-block',float:'left',textAlign:'left'},link:{color:'#3D8081',fontSize:'1rem',marginLeft:'0'},button:{position:'relative',right:'0',top:'0',display:'inline-block',background:'transparent',color:'#3D8081',fontSize:'1rem',opacity:'1',height:'1rem',lineHeight:'1rem',marginTop:'0',float:'right'}}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["g" /* injectIntl */])(CookiePolicyAlert));

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InfoIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    z-index: 999999;\n'],['\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    z-index: 999999;\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: 0.75em;\n    margin-left: 0.25em;\n    position: relative;\n    top: 0.1em;\n    width: 0.75em;\n\n    & g {\n        fill: ',';\n    }\n'],['\n    height: 0.75em;\n    margin-left: 0.25em;\n    position: relative;\n    top: 0.1em;\n    width: 0.75em;\n\n    & g {\n        fill: ',';\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CookieContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject);var InfoIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */]).attrs({type:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_general_svg__["a" /* default */].INFO})(_templateObject2,function(props){return props.theme.primaryFontColor;});

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(1979);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 1980 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 169 /* <at>i */
	var CHARSET = 163 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(++length)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										caret++
										code = first
									}
									case COLON:
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							code = body.charCodeAt(caret)

							switch (code) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first + second) {
								case NULL: {
									break
								}
								case IMPORT:
								case CHARSET: {
									flat += chars + body.charAt(caret)
									break
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON)
										break

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust: t, e, x
			case 1015: {
				// text-size-adjust, -
				return out.charCodeAt(9) === DASH ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				return out.charCodeAt(8) === DASH ? webkit + out + out : out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// width: min-content / width: max-content
			case 953: {
				if ((index = out.indexOf('-content', 9)) > 0) {
					// width: min-content / width: max-content
					if (out.charCodeAt(index - 3) === 109 && out.charCodeAt(index - 4) !== 45) {
						cache = out.substring(index - 3)
						return 'width:' + webkit + cache + 'width:' + moz + cache + 'width:' + cache
					}
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	var i = 0

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}

		switch (out) {
			case void 0:
			case false:
			case true:
			case null:
			case content: {
				break
			}
			default: {
				return out
			}
		}
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				switch (plugin.constructor) {
					case Array: {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
						break
					}
					case Function: {
						plugins[plugged++] = plugin
						break
					}
					case Boolean: {
						unkwn = !!plugin|0
					}
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, at, depth) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (at === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (at) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + delimiter
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1983)();
}


/***/ }),
/* 1983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(100);
var invariant = __webpack_require__(86);
var ReactPropTypesSecret = __webpack_require__(1984);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['fill: ',';'],['fill: ',';']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IconStyle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].g(_templateObject,function(p){return p.color||p.theme.fontColor;});

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1987);

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _CookieBannerJs = __webpack_require__(1988);

var _CookieBannerJs2 = _interopRequireDefault(_CookieBannerJs);

exports['default'] = _CookieBannerJs2['default'];

var _browserCookieLite = __webpack_require__(761);

exports.cookie = _browserCookieLite.cookie;

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(47);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodashOmit = __webpack_require__(1989);

var _lodashOmit2 = _interopRequireDefault(_lodashOmit);

var _tcombReact = __webpack_require__(2001);

var _browserCookieLite = __webpack_require__(761);

var _styleUtils = __webpack_require__(2043);

var _styleUtils2 = _interopRequireDefault(_styleUtils);

_tcombReact.t['interface'].strict = true;

var Props = {
  children: _tcombReact.t.maybe(_tcombReact.t.union([_tcombReact.t.ReactChildren, _tcombReact.t.Function])),
  message: _tcombReact.t.maybe(_tcombReact.t.String),
  onAccept: _tcombReact.t.maybe(_tcombReact.t.Function),
  link: _tcombReact.t.maybe(_tcombReact.t['interface']({
    msg: _tcombReact.t.maybe(_tcombReact.t.String),
    url: _tcombReact.t.String,
    target: _tcombReact.t.maybe(_tcombReact.t.enums.of(['_blank', '_self', '_parent', '_top', 'framename']))
  })),
  buttonMessage: _tcombReact.t.maybe(_tcombReact.t.String),
  cookie: _tcombReact.t.maybe(_tcombReact.t.String),
  cookieExpiration: _tcombReact.t.maybe(_tcombReact.t.union([_tcombReact.t.Integer, _tcombReact.t['interface']({
    years: _tcombReact.t.maybe(_tcombReact.t.Number),
    days: _tcombReact.t.maybe(_tcombReact.t.Number),
    hours: _tcombReact.t.maybe(_tcombReact.t.Number)
  })])),
  dismissOnScroll: _tcombReact.t.maybe(_tcombReact.t.Boolean),
  dismissOnScrollThreshold: _tcombReact.t.maybe(_tcombReact.t.Number),
  closeIcon: _tcombReact.t.maybe(_tcombReact.t.String),
  disableStyle: _tcombReact.t.maybe(_tcombReact.t.Boolean),
  styles: _tcombReact.t.maybe(_tcombReact.t.Object),
  className: _tcombReact.t.maybe(_tcombReact.t.String)
};

/** React Cookie banner dismissable with just a scroll!
 * @param children - custom component rendered if user has not accepted cookies
 * @param message - message written inside default cookie banner
 * @param onAccept - called when user accepts cookies
 * @param link - object with infos used to render a link to your cookie-policy page
 * @param buttonMessage - message written inside the button of the default cookie banner
 * @param cookie - cookie-key used to save user's decision about you cookie-policy
 * @param cookieExpiration - used to set the cookie expiration
 * @param dismissOnScroll - whether the cookie banner should be dismissed on scroll or not
 * @param dismissOnScrollThreshold -
 *   amount of pixel the user need to scroll to dismiss the cookie banner
 * @param closeIcon - className passed to close-icon
 * @param disableStyle - pass `true` if you want to disable default style
 * @param styles - object with custom styles used to overwrite default ones
 */

var CookieBanner = (function (_React$Component) {
  _inherits(CookieBanner, _React$Component);

  function CookieBanner() {
    var _this = this;

    _classCallCheck(this, _CookieBanner);

    _React$Component.apply(this, arguments);

    this.state = { listeningScroll: false };

    this.addOnScrollListener = function (props) {
      var _props = props || _this.props;
      if (!_this.state.listeningScroll && !_this.hasAcceptedCookies() && _props.dismissOnScroll) {
        if (window.attachEvent) {
          //Internet Explorer
          window.attachEvent('onscroll', _this.onScroll);
        } else if (window.addEventListener) {
          window.addEventListener('scroll', _this.onScroll, false);
        }
        _this.setState({ listeningScroll: true });
      }
    };

    this.removeOnScrollListener = function () {
      if (_this.state.listeningScroll) {
        if (window.detachEvent) {
          //Internet Explorer
          window.detachEvent('onscroll', _this.onScroll);
        } else if (window.removeEventListener) {
          window.removeEventListener('scroll', _this.onScroll, false);
        }
        _this.setState({ listeningScroll: false });
      }
    };

    this.onScroll = function () {
      // tacit agreement buahaha! (evil laugh)
      if (window.pageYOffset > _this.props.dismissOnScrollThreshold) {
        _this.onAccept();
      }
    };

    this.getSecondsSinceExpiration = function (cookieExpiration) {
      if (_tcombReact.t.Integer.is(cookieExpiration)) {
        return cookieExpiration;
      }

      var SECONDS_IN_YEAR = 31536000;
      var SECONDS_IN_DAY = 86400;
      var SECONDS_IN_HOUR = 3600;

      var _cookieExpiration = _extends({
        years: 0, days: 0, hours: 0
      }, cookieExpiration);

      var years = _cookieExpiration.years;
      var days = _cookieExpiration.days;
      var hours = _cookieExpiration.hours;

      return years * SECONDS_IN_YEAR + days * SECONDS_IN_DAY + hours * SECONDS_IN_HOUR;
    };

    this.onAccept = function () {
      var _props2 = _this.props;
      var cookie = _props2.cookie;
      var cookieExpiration = _props2.cookieExpiration;
      var onAccept = _props2.onAccept;

      _browserCookieLite.cookie(cookie, true, _this.getSecondsSinceExpiration(cookieExpiration));
      onAccept({ cookie: cookie });

      if (_this.state.listeningScroll) {
        _this.removeOnScrollListener();
      } else {
        _this.forceUpdate();
      }
    };

    this.getStyle = function (style) {
      var _props3 = _this.props;
      var disableStyle = _props3.disableStyle;
      var styles = _props3.styles;

      if (!disableStyle) {
        // apply custom styles if available
        return _extends({}, _styleUtils2['default'].getStyle(style), styles[style]);
      }
    };

    this.getCloseButton = function () {
      var _props4 = _this.props;
      var closeIcon = _props4.closeIcon;
      var buttonMessage = _props4.buttonMessage;

      if (closeIcon) {
        return _react2['default'].createElement('i', { className: closeIcon, onClick: _this.onAccept, style: _this.getStyle('icon') });
      }
      return _react2['default'].createElement(
        'div',
        { className: 'button-close', onClick: _this.onAccept, style: _this.getStyle('button') },
        buttonMessage
      );
    };

    this.getLink = function () {
      var link = _this.props.link;

      if (link) {
        return _react2['default'].createElement(
          'a',
          {
            href: link.url,
            target: link.target,
            className: 'cookie-link',
            style: _this.getStyle('link')
          },
          link.msg || 'Learn more'
        );
      }
    };

    this.getBanner = function () {
      var _props5 = _this.props;
      var children = _props5.children;
      var className = _props5.className;
      var message = _props5.message;

      if (children) {
        if (_tcombReact.t.Function.is(children)) {
          return children(_this.onAccept);
        }
        return children;
      }

      var props = _lodashOmit2['default'](_this.props, Object.keys(Props));
      var computedClassName = _classnames2['default']('react-cookie-banner', className);
      return _react2['default'].createElement(
        'div',
        _extends({}, props, { className: computedClassName, style: _this.getStyle('banner') }),
        _react2['default'].createElement(
          'span',
          { className: 'cookie-message', style: _this.getStyle('message') },
          message,
          _this.getLink()
        ),
        _this.getCloseButton()
      );
    };

    this.hasAcceptedCookies = function () {
      return typeof window !== 'undefined' && _browserCookieLite.cookie(_this.props.cookie);
    };
  }

  CookieBanner.prototype.componentDidMount = function componentDidMount() {
    this.addOnScrollListener();
  };

  CookieBanner.prototype.render = function render() {
    return this.hasAcceptedCookies() ? null : this.getBanner();
  };

  CookieBanner.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.dismissOnScroll) {
      this.addOnScrollListener(nextProps);
    } else {
      this.removeOnScrollListener();
    }
  };

  CookieBanner.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeOnScrollListener();
  };

  _createClass(CookieBanner, null, [{
    key: 'defaultProps',
    value: {
      onAccept: function onAccept() {},
      dismissOnScroll: true,
      cookie: 'accepts-cookies',
      cookieExpiration: { years: 1 },
      buttonMessage: 'Got it',
      dismissOnScrollThreshold: 0,
      styles: {}
    },
    enumerable: true
  }]);

  var _CookieBanner = CookieBanner;
  CookieBanner = _tcombReact.props(Props, { strict: false })(CookieBanner) || CookieBanner;
  return CookieBanner;
})(_react2['default'].Component);

exports['default'] = CookieBanner;
module.exports = exports['default'];

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayMap = __webpack_require__(1990),
    baseDifference = __webpack_require__(1991),
    baseFlatten = __webpack_require__(1995),
    bindCallback = __webpack_require__(1996),
    pickByArray = __webpack_require__(1997),
    pickByCallback = __webpack_require__(1998),
    keysIn = __webpack_require__(744),
    restParam = __webpack_require__(2000);

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable properties of `object` that are not omitted.
 * Property names may be specified as individual arguments or as arrays of
 * property names. If `predicate` is provided it is invoked for each property
 * of `object` omitting the properties `predicate` returns truthy for. The
 * predicate is bound to `thisArg` and invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {Function|...(string|string[])} [predicate] The function invoked per
 *  iteration or property names to omit, specified as individual property
 *  names or arrays of property names.
 * @param {*} [thisArg] The `this` binding of `predicate`.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'user': 'fred', 'age': 40 };
 *
 * _.omit(object, 'age');
 * // => { 'user': 'fred' }
 *
 * _.omit(object, _.isNumber);
 * // => { 'user': 'fred' }
 */
var omit = restParam(function(object, props) {
  if (object == null) {
    return {};
  }
  if (typeof props[0] != 'function') {
    var props = arrayMap(baseFlatten(props), String);
    return pickByArray(object, baseDifference(keysIn(object), props));
  }
  var predicate = bindCallback(props[0], props[1], 3);
  return pickByCallback(object, function(value, key, object) {
    return !predicate(value, key, object);
  });
});

module.exports = omit;


/***/ }),
/* 1990 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `_.map` for arrays without support for callback
 * shorthands or `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseIndexOf = __webpack_require__(1992),
    cacheIndexOf = __webpack_require__(1993),
    createCache = __webpack_require__(1994);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.difference` which accepts a single array
 * of values to exclude.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values) {
  var length = array ? array.length : 0,
      result = [];

  if (!length) {
    return result;
  }
  var index = -1,
      indexOf = baseIndexOf,
      isCommon = true,
      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
      valuesLength = values.length;

  if (cache) {
    indexOf = cacheIndexOf;
    isCommon = false;
    values = cache;
  }
  outer:
  while (++index < length) {
    var value = array[index];

    if (isCommon && value === value) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === value) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (indexOf(values, value, 0) < 0) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 1992 */
/***/ (function(module, exports) {

/**
 * lodash 3.1.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `_.indexOf` without support for binary searches.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return indexOfNaN(array, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * Gets the index at which the first occurrence of `NaN` is found in `array`.
 * If `fromRight` is provided elements of `array` are iterated from right to left.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
 */
function indexOfNaN(array, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 0 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    var other = array[index];
    if (other !== other) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOf;


/***/ }),
/* 1993 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is in `cache` mimicking the return signature of
 * `_.indexOf` by returning `0` if the value is found, else `-1`.
 *
 * @private
 * @param {Object} cache The cache to search.
 * @param {*} value The value to search for.
 * @returns {number} Returns `0` if `value` is found, else `-1`.
 */
function cacheIndexOf(cache, value) {
  var data = cache.data,
      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

  return result ? 0 : -1;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = cacheIndexOf;


/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(715);

/** Native method references. */
var Set = getNative(global, 'Set');

/* Native method references for those with the same name as other `lodash` methods. */
var nativeCreate = getNative(Object, 'create');

/**
 *
 * Creates a cache object to store unique values.
 *
 * @private
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var length = values ? values.length : 0;

  this.data = { 'hash': nativeCreate(null), 'set': new Set };
  while (length--) {
    this.push(values[length]);
  }
}

/**
 * Adds `value` to the cache.
 *
 * @private
 * @name push
 * @memberOf SetCache
 * @param {*} value The value to cache.
 */
function cachePush(value) {
  var data = this.data;
  if (typeof value == 'string' || isObject(value)) {
    data.set.add(value);
  } else {
    data.hash[value] = true;
  }
}

/**
 * Creates a `Set` cache object to optimize linear searches of large arrays.
 *
 * @private
 * @param {Array} [values] The values to cache.
 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
 */
function createCache(values) {
  return (nativeCreate && Set) ? new SetCache(values) : null;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

// Add functions to the `Set` cache.
SetCache.prototype.push = cachePush;

module.exports = createCache;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArguments = __webpack_require__(742),
    isArray = __webpack_require__(743);

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `_.flatten` with added support for restricting
 * flattening and specifying the start index.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {boolean} [isDeep] Specify a deep flatten.
 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, isDeep, isStrict, result) {
  result || (result = []);

  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index];
    if (isObjectLike(value) && isArrayLike(value) &&
        (isStrict || isArray(value) || isArguments(value))) {
      if (isDeep) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, isDeep, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value));
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = baseFlatten;


/***/ }),
/* 1996 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function bindCallback(func, thisArg, argCount) {
  if (typeof func != 'function') {
    return identity;
  }
  if (thisArg === undefined) {
    return func;
  }
  switch (argCount) {
    case 1: return function(value) {
      return func.call(thisArg, value);
    };
    case 3: return function(value, index, collection) {
      return func.call(thisArg, value, index, collection);
    };
    case 4: return function(accumulator, value, index, collection) {
      return func.call(thisArg, accumulator, value, index, collection);
    };
    case 5: return function(value, other, key, object, source) {
      return func.call(thisArg, value, other, key, object, source);
    };
  }
  return function() {
    return func.apply(thisArg, arguments);
  };
}

/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = bindCallback;


/***/ }),
/* 1997 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * A specialized version of `_.pick` which picks `object` properties specified
 * by `props`.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property names to pick.
 * @returns {Object} Returns the new object.
 */
function pickByArray(object, props) {
  object = toObject(object);

  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index];
    if (key in object) {
      result[key] = object[key];
    }
  }
  return result;
}

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = pickByArray;


/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFor = __webpack_require__(1999),
    keysIn = __webpack_require__(744);

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor(object, iteratee, keysIn);
}

/**
 * A specialized version of `_.pick` that picks `object` properties `predicate`
 * returns truthy for.
 *
 * @private
 * @param {Object} object The source object.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Object} Returns the new object.
 */
function pickByCallback(object, predicate) {
  var result = {};
  baseForIn(object, function(value, key, object) {
    if (predicate(value, key, object)) {
      result[key] = value;
    }
  });
  return result;
}

module.exports = pickByCallback;


/***/ }),
/* 1999 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * Creates a base function for methods like `_.forIn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = baseFor;


/***/ }),
/* 2000 */
/***/ (function(module, exports) {

/**
 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Native method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */
function restParam(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        rest = Array(length);

    while (++index < length) {
      rest[index] = args[start + index];
    }
    switch (start) {
      case 0: return func.call(this, rest);
      case 1: return func.call(this, args[0], rest);
      case 2: return func.call(this, args[0], args[1], rest);
    }
    var otherArgs = Array(start + 1);
    index = -1;
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = rest;
    return func.apply(this, otherArgs);
  };
}

module.exports = restParam;


/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(2002);
var t = __webpack_require__(2019);

function getMessage(errors, what, displayName, type) {
  return [
    'Invalid ' + what + ' supplied to ' + displayName + ', should be a ' + t.getTypeName(type) + '.\n',
    'Detected errors (' + errors.length + '):\n'
  ].concat(errors.map(function (e, i) {
    return ' ' + (i + 1) + '. ' + e.message;
  })).join('\n') + '\n\n';
}

//
// main function
//

function getPropTypes(type, options) {

  // getPropTypes can also accept a dictionary prop -> type
  if (t.Object.is(type)) {
    type = t.struct(type);
  }

  var isSubtype = ( type.meta.kind === 'subtype' );

  // here type should be a struct or a subtype of a struct
  if (false) {
    t.assert(
      t.isType(type),
      '[tcomb-react] Invalid argument type supplied to propTypes()'
    );
  }

  var propTypes = {};
  var innerType = isSubtype ? type.meta.type : type;

  if (innerType.meta.kind === 'struct' || innerType.meta.kind === 'interface') {
    var props = innerType.meta.props;

    Object.keys(props).forEach(function (k) {

      var propType = props[k];
      var checkPropType;

      if (false) {

        // React custom prop validators
        // see http://facebook.github.io/react/docs/reusable-components.html
        checkPropType = function (values, prop, displayName) {

          var value = values[prop];
          var validationResult = t.validate(value, propType);

          if (!validationResult.isValid()) {

            var message = getMessage(validationResult.errors, 'prop ' + t.stringify(prop), displayName, propType);

            // add a readable entry in the call stack
            // when "Pause on exceptions" and "Pause on Caught Exceptions"
            // are enabled in Chrome DevTools
            checkPropType.displayName = message;

            t.fail(message);
          }
        };
      } else {
        checkPropType = function () {};
      }

      // attach the original tcomb definition, so other components can read it
      // via `propTypes.whatever.tcomb`
      checkPropType.tcomb = propType;

      propTypes[k] = checkPropType;
    });

    if (false) {
      options = options || {};
      // allows to opt-out additional props check
      if (options.strict !== false) {
        propTypes.__strict__ = function (values, prop, displayName) {
          var extra = [];
          for (var k in values) {
            // __strict__ and __subtype__ keys are excluded in order to support the React context feature
            if (k !== '__strict__' && k !== '__subtype__' && values.hasOwnProperty(k) && !props.hasOwnProperty(k)) {
              extra.push(k);
            }
          }
          if (extra.length > 0) {
            t.fail('Invalid additional prop(s):\n\n' + t.stringify(extra) + '\n\nsupplied to ' + displayName + '.');
          }
        };
      }
    }

  }
  else {
    if (false) {
      propTypes.__generictype__ = function (values, prop, displayName) {
        var validationResult = t.validate(values, innerType);
        if (!validationResult.isValid()) {
          t.fail(getMessage(validationResult.errors, 'props', displayName, innerType));
        }
      };
    }
  }

  if (isSubtype) {
    if (false) {
      propTypes.__subtype__ = function (values, prop, displayName) {
        if (!type.meta.predicate(values)) {
          t.fail('Invalid props:\n\n' + t.stringify(values) + '\n\nsupplied to ' + displayName + ', should be a ' + t.getTypeName(type) + ' subtype.');
        }
      };
    } else {
      propTypes.__subtype__ = function () {};
    }

    // attach the original predicate, so other components can read it
    // via `propTypes.__subtype__.predicate`
    propTypes.__subtype__.predicate = type.meta.predicate;
  }

  return propTypes;
}

//
// ES7 decorator
//

function es7PropsDecorator(type, options) {
  return function (Component) {
    Component.propTypes = getPropTypes(type, options);
  };
}

//
// Built-in types
//

var ReactElement = t.irreducible('ReactElement', React.isValidElement);
var ReactNode = t.irreducible('ReactNode', function (x) {
  return t.Str.is(x) || t.Num.is(x) || ReactElement.is(x) || t.list(ReactNode).is(x);
});
var ReactChild = t.irreducible('ReactChild', function(x) {
  return ReactNode.is(x) || t.Bool.is(x) || t.Nil.is(x);
});
var ReactChildren = t.irreducible('ReactChildren', function(x) {
  return ReactChild.is(x) || t.list(ReactChildren).is(x);
});

t.ReactElement = ReactElement; // deprecated
t.ReactNode = ReactNode; // deprecated
t.ReactChild = ReactChild; // deprecated
t.ReactChildren = ReactChildren; // deprecated

module.exports = {
  t: t, // deprecated
  propTypes: getPropTypes,
  props: es7PropsDecorator,
  ReactElement: ReactElement,
  ReactNode: ReactNode,
  ReactChild: ReactChild,
  ReactChildren: ReactChildren,
  ReactElementT: ReactElement,
  ReactNodeT: ReactNode,
  ReactChildT: ReactChild,
  ReactChildrenT: ReactChildren
};


/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(2003);


/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(77);

var ReactBaseClasses = __webpack_require__(745);
var ReactChildren = __webpack_require__(2005);
var ReactDOMFactories = __webpack_require__(2010);
var ReactElement = __webpack_require__(210);
var ReactPropTypes = __webpack_require__(2011);
var ReactVersion = __webpack_require__(2015);

var createReactClass = __webpack_require__(2016);
var onlyChild = __webpack_require__(2018);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(2006);
var ReactElement = __webpack_require__(210);

var emptyFunction = __webpack_require__(100);
var traverseAllChildren = __webpack_require__(2007);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(324);

var invariant = __webpack_require__(86);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(324);

var ReactCurrentOwner = __webpack_require__(748);
var REACT_ELEMENT_TYPE = __webpack_require__(749);

var getIteratorFn = __webpack_require__(2008);
var invariant = __webpack_require__(86);
var KeyEscapeUtils = __webpack_require__(2009);
var warning = __webpack_require__(325);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 2008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(210);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(210),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(2012);

module.exports = factory(isValidElement);

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(2013);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(100);
var invariant = __webpack_require__(86);
var warning = __webpack_require__(325);

var ReactPropTypesSecret = __webpack_require__(613);
var checkPropTypes = __webpack_require__(2014);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(745),
    Component = _require.Component;

var _require2 = __webpack_require__(210),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(746);
var factory = __webpack_require__(2017);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(77);

var emptyObject = __webpack_require__(269);
var _invariant = __webpack_require__(86);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 2018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(324);

var ReactElement = __webpack_require__(210);

var invariant = __webpack_require__(86);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var t = __webpack_require__(2020);
var stringify = t.stringify;

var noobj = {};

var ValidationError = t.struct({
  message: t.Any,
  actual: t.Any,
  expected: t.Any,
  path: t.list(t.union([t.String, t.Number]))
}, 'ValidationError');

function getDefaultValidationErrorMessage(actual, expected, path) {
  var expectedName = t.getTypeName(expected);
  var to = path.length ? '/' + path.join('/') + ': ' + expectedName : expectedName;
  return 'Invalid value ' + stringify(actual) + ' supplied to ' + to;
}

function getValidationErrorMessage(actual, expected, path, context) {
  if (t.Function.is(expected.getValidationErrorMessage)) {
    return expected.getValidationErrorMessage(actual, path, context);
  }
  else {
    return getDefaultValidationErrorMessage(actual, expected, path);
  }
}

ValidationError.of = function (actual, expected, path, context) {
  return new ValidationError({
    message: getValidationErrorMessage(actual, expected, path, context),
    actual: actual,
    expected: expected,
    path: path
  });
};

var ValidationResult = t.struct({
  errors: t.list(ValidationError),
  value: t.Any
}, 'ValidationResult');

ValidationResult.prototype.isValid = function () {
  return !(this.errors.length);
};

ValidationResult.prototype.firstError = function () {
  return this.isValid() ? null : this.errors[0];
};

ValidationResult.prototype.toString = function () {
  if (this.isValid()) {
    return '[ValidationResult, true, ' + stringify(this.value) + ']';
  }
  else {
    return '[ValidationResult, false, (' + this.errors.map(function (err) {
      return stringify(err.message);
    }).join(', ') + ')]';
  }
};

function validate(x, type, options) {
  options = options || {};
  var path = t.Array.is(options) ? options : options.path || [];
  return new ValidationResult(recurse(x, type, path, options));
}

function recurse(x, type, path, options) {
  if (t.isType(type)) {
    return validators[type.meta.kind](x, type, path, options);
  }
  else {
    return validators.es6classes(x, type, path, options);
  }
}

var validators = validate.validators = {};

validators.es6classes = function validateES6Classes(x, type, path, options) {
  return {
    value: x,
    errors: x instanceof type ? [] : [ValidationError.of(x, type, path, options.context)]
  };
};

// irreducibles and enums
validators.irreducible =
validators.enums = function validateIrreducible(x, type, path, options) {
  return {
    value: x,
    errors: type.is(x) ? [] : [ValidationError.of(x, type, path, options.context)]
  };
};

validators.list = function validateList(x, type, path, options) {

  // x should be an array
  if (!t.Array.is(x)) {
    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
  }

  var ret = {value: [], errors: []};
  // every item should be of type `type.meta.type`
  for (var i = 0, len = x.length; i < len; i++ ) {
    var item = recurse(x[i], type.meta.type, path.concat(i), options);
    ret.value[i] = item.value;
    ret.errors = ret.errors.concat(item.errors);
  }
  return ret;
};

validators.subtype = function validateSubtype(x, type, path, options) {

  // x should be a valid inner type
  var ret = recurse(x, type.meta.type, path, options);
  if (ret.errors.length) {
    return ret;
  }

  // x should satisfy the predicate
  if (!type.meta.predicate(ret.value)) {
    ret.errors = [ValidationError.of(x, type, path, options.context)];
  }

  return ret;

};

validators.maybe = function validateMaybe(x, type, path, options) {
  return t.Nil.is(x) ?
    {value: x, errors: []} :
    recurse(x, type.meta.type, path, options);
};

validators.struct = function validateStruct(x, type, path, options) {

  // x should be an object
  if (!t.Object.is(x)) {
    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
  }

  // [optimization]
  if (type.is(x)) {
    return {value: x, errors: []};
  }

  var ret = {value: {}, errors: []};
  var props = type.meta.props;
  var defaultProps = type.meta.defaultProps || noobj;
  // every item should be of type `props[name]`
  for (var name in props) {
    if (props.hasOwnProperty(name)) {
      var actual = x[name];
      // apply defaults
      if (actual === undefined) {
        actual = defaultProps[name];
      }
      var prop = recurse(actual, props[name], path.concat(name), options);
      ret.value[name] = prop.value;
      ret.errors = ret.errors.concat(prop.errors);
    }
  }
  var strict = options.hasOwnProperty('strict') ? options.strict : type.meta.strict;
  if (strict) {
    for (var field in x) {
      if (x.hasOwnProperty(field) && !props.hasOwnProperty(field)) {
        ret.errors.push(ValidationError.of(x[field], t.Nil, path.concat(field), options.context));
      }
    }
  }
  if (!ret.errors.length) {
    ret.value = new type(ret.value);
  }
  return ret;
};

validators.tuple = function validateTuple(x, type, path, options) {

  var types = type.meta.types;
  var len = types.length;

  // x should be an array of at most `len` items
  if (!t.Array.is(x) || x.length > len) {
    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
  }

  var ret = {value: [], errors: []};
  // every item should be of type `types[i]`
  for (var i = 0; i < len; i++) {
    var item = recurse(x[i], types[i], path.concat(i), options);
    ret.value[i] = item.value;
    ret.errors = ret.errors.concat(item.errors);
  }
  return ret;
};

validators.dict = function validateDict(x, type, path, options) {

  // x should be an object
  if (!t.Object.is(x)) {
    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
  }

  var ret = {value: {}, errors: []};
  // every key should be of type `domain`
  // every value should be of type `codomain`
  for (var k in x) {
    if (x.hasOwnProperty(k)) {
      var subpath = path.concat(k);
      var key = recurse(k, type.meta.domain, subpath, options);
      var item = recurse(x[k], type.meta.codomain, subpath, options);
      ret.value[k] = item.value;
      ret.errors = ret.errors.concat(key.errors, item.errors);
    }
  }
  return ret;
};

validators.union = function validateUnion(x, type, path, options) {
  var ctor = type.dispatch(x);
  return t.Function.is(ctor) ?
    recurse(x, ctor, path.concat(type.meta.types.indexOf(ctor)), options) :
    {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
};

validators.intersection = function validateIntersection(x, type, path, options) {

  var types = type.meta.types;
  var len = types.length;

  var ret = {value: x, errors: []};
  var nrOfStructs = 0;
  // x should be of type `types[i]` for all i
  for (var i = 0; i < len; i++) {
    if (types[i].meta.kind === 'struct') {
      nrOfStructs++;
    }
    var item = recurse(x, types[i], path, options);
    ret.errors = ret.errors.concat(item.errors);
  }
  if (nrOfStructs > 1) {
    ret.errors.push(ValidationError.of(x, type, path, options.context));
  }
  return ret;
};

validators['interface'] = function validateInterface(x, type, path, options) { // eslint-disable-line dot-notation

  // x should be an object
  if (!t.Object.is(x)) {
    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
  }

  var ret = {value: {}, errors: []};
  var props = type.meta.props;
  // every item should be of type `props[name]`
  for (var name in props) {
    var prop = recurse(x[name], props[name], path.concat(name), options);
    ret.value[name] = prop.value;
    ret.errors = ret.errors.concat(prop.errors);
  }
  var strict = options.hasOwnProperty('strict') ? options.strict : type.meta.strict;
  if (strict) {
    for (var field in x) {
      if (!props.hasOwnProperty(field) && !t.Nil.is(x[field])) {
        ret.errors.push(ValidationError.of(x[field], t.Nil, path.concat(field), options.context));
      }
    }
  }
  return ret;
};

t.mixin(t, {
  ValidationError: ValidationError,
  ValidationResult: ValidationResult,
  validate: validate
});

module.exports = t;


/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

/*! @preserve
 *
 * tcomb.js - Type checking and DDD for JavaScript
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014-2016 Giulio Canti
 *
 */

// core
var t = __webpack_require__(36);

// types
t.Any = __webpack_require__(482);
t.Array = __webpack_require__(2022);
t.Boolean = __webpack_require__(751);
t.Date = __webpack_require__(2023);
t.Error = __webpack_require__(2024);
t.Function = __webpack_require__(328);
t.Nil = __webpack_require__(752);
t.Number = __webpack_require__(753);
t.Integer = __webpack_require__(2025);
t.IntegerT = t.Integer;
t.Object = __webpack_require__(2026);
t.RegExp = __webpack_require__(2027);
t.String = __webpack_require__(484);
t.Type = __webpack_require__(2028);
t.TypeT = t.Type;

// short alias are deprecated
t.Arr = t.Array;
t.Bool = t.Boolean;
t.Dat = t.Date;
t.Err = t.Error;
t.Func = t.Function;
t.Num = t.Number;
t.Obj = t.Object;
t.Re = t.RegExp;
t.Str = t.String;

// combinators
t.dict = __webpack_require__(485);
t.declare = __webpack_require__(2029);
t.enums = __webpack_require__(2030);
t.irreducible = __webpack_require__(67);
t.list = __webpack_require__(756);
t.maybe = __webpack_require__(2031);
t.refinement = __webpack_require__(483);
t.struct = __webpack_require__(2033);
t.tuple = __webpack_require__(759);
t.union = __webpack_require__(2037);
t.func = __webpack_require__(2038);
t.intersection = __webpack_require__(2039);
t.subtype = t.refinement;
t.inter = __webpack_require__(2040); // IE8 alias
t['interface'] = t.inter;

// functions
t.assert = t;
t.update = __webpack_require__(2041);
t.mixin = __webpack_require__(486);
t.isType = __webpack_require__(59);
t.is = __webpack_require__(119);
t.getTypeName = __webpack_require__(53);
t.match = __webpack_require__(2042);

module.exports = t;


/***/ }),
/* 2021 */
/***/ (function(module, exports) {

module.exports = function fail(message) {
  throw new TypeError('[tcomb] ' + message);
};

/***/ }),
/* 2022 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);
var isArray = __webpack_require__(116);

module.exports = irreducible('Array', isArray);


/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);

module.exports = irreducible('Date', function (x) { return x instanceof Date; });


/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);

module.exports = irreducible('Error', function (x) { return x instanceof Error; });


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

var refinement = __webpack_require__(483);
var Number = __webpack_require__(753);

module.exports = refinement(Number, function (x) { return x % 1 === 0; }, 'Integer');


/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);
var isObject = __webpack_require__(115);

module.exports = irreducible('Object', isObject);


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);

module.exports = irreducible('RegExp', function (x) { return x instanceof RegExp; });


/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

var irreducible = __webpack_require__(67);
var isType = __webpack_require__(59);

module.exports = irreducible('Type', isType);

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var isType = __webpack_require__(59);
var isNil = __webpack_require__(98);
var mixin = __webpack_require__(486);
var getTypeName = __webpack_require__(53);
var isUnion = __webpack_require__(755);

// All the .declare-d types should be clearly different from each other thus they should have
// different names when a name was not explicitly provided.
var nextDeclareUniqueId = 1;

module.exports = function declare(name) {
  if (false) {
    assert(isTypeName(name), function () { return 'Invalid argument name ' + name + ' supplied to declare([name]) (expected a string)'; });
  }

  var type;

  function Declare(value, path) {
    if (false) {
      assert(!isNil(type), function () { return 'Type declared but not defined, don\'t forget to call .define on every declared type'; });
      if (isUnion(type)) {
        assert(type.dispatch === Declare.dispatch, function () { return 'Please define the custom ' + name + '.dispatch function before calling ' + name + '.define()'; });
      }
    }
    return type(value, path);
  }

  Declare.define = function (spec) {
    if (false) {
      assert(isType(spec), function () { return 'Invalid argument type ' + assert.stringify(spec) +  ' supplied to define(type) (expected a type)'; });
      assert(isNil(type), function () { return 'Declare.define(type) can only be invoked once'; });
      assert(isNil(spec.meta.name) && Object.keys(spec.prototype).length === 0, function () { return 'Invalid argument type ' + assert.stringify(spec) + ' supplied to define(type) (expected a fresh, unnamed type)'; });
    }

    if (isUnion(spec) && Declare.hasOwnProperty('dispatch')) {
      spec.dispatch = Declare.dispatch;
    }
    type = spec;
    mixin(Declare, type, true); // true because it overwrites Declare.displayName
    if (name) {
      type.displayName = Declare.displayName = name;
      Declare.meta.name = name;
    }
    Declare.meta.identity = type.meta.identity;
    Declare.prototype = type.prototype;
    return Declare;
  };

  Declare.displayName = name || ( getTypeName(Declare) + "$" + nextDeclareUniqueId++ );
  // in general I can't say if this type will be an identity, for safety setting to false
  Declare.meta = { identity: false };
  Declare.prototype = null;
  return Declare;
};


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var forbidNewOperator = __webpack_require__(246);
var isString = __webpack_require__(326);
var isObject = __webpack_require__(115);

function getDefaultName(map) {
  return Object.keys(map).map(function (k) { return assert.stringify(k); }).join(' | ');
}

function enums(map, name) {

  if (false) {
    assert(isObject(map), function () { return 'Invalid argument map ' + assert.stringify(map) + ' supplied to enums(map, [name]) combinator (expected a dictionary of String -> String | Number)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to enums(map, [name]) combinator (expected a string)'; });
  }

  var displayName = name || getDefaultName(map);

  function Enums(value, path) {

    if (false) {
      forbidNewOperator(this, Enums);
      path = path || [displayName];
      assert(Enums.is(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected one of ' + assert.stringify(Object.keys(map)) + ')'; });
    }

    return value;
  }

  Enums.meta = {
    kind: 'enums',
    map: map,
    name: name,
    identity: true
  };

  Enums.displayName = displayName;

  Enums.is = function (x) {
    return map.hasOwnProperty(x);
  };

  return Enums;
}

enums.of = function (keys, name) {
  keys = isString(keys) ? keys.split(' ') : keys;
  var value = {};
  keys.forEach(function (k) {
    value[k] = k;
  });
  return enums(value, name);
};

enums.getDefaultName = getDefaultName;
module.exports = enums;



/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var isFunction = __webpack_require__(58);
var isMaybe = __webpack_require__(2032);
var isIdentity = __webpack_require__(117);
var Any = __webpack_require__(482);
var create = __webpack_require__(118);
var Nil = __webpack_require__(752);
var forbidNewOperator = __webpack_require__(246);
var is = __webpack_require__(119);
var getTypeName = __webpack_require__(53);

function getDefaultName(type) {
  return '?' + getTypeName(type);
}

function maybe(type, name) {

  if (isMaybe(type) || type === Any || type === Nil) { // makes the combinator idempotent and handle Any, Nil
    return type;
  }

  if (false) {
    assert(isFunction(type), function () { return 'Invalid argument type ' + assert.stringify(type) + ' supplied to maybe(type, [name]) combinator (expected a type)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to maybe(type, [name]) combinator (expected a string)'; });
  }

  var displayName = name || getDefaultName(type);
  var identity = isIdentity(type);

  function Maybe(value, path) {
    if (false) {
      if (identity) {
        forbidNewOperator(this, Maybe);
      }
    }
    return Nil.is(value) ? value : create(type, value, path);
  }

  Maybe.meta = {
    kind: 'maybe',
    type: type,
    name: name,
    identity: identity
  };

  Maybe.displayName = displayName;

  Maybe.is = function (x) {
    return Nil.is(x) || is(x, type);
  };

  return Maybe;
}

maybe.getDefaultName = getDefaultName;
module.exports = maybe;


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

var isType = __webpack_require__(59);

module.exports = function isMaybe(x) {
  return isType(x) && ( x.meta.kind === 'maybe' );
};

/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var String = __webpack_require__(484);
var Function = __webpack_require__(328);
var isBoolean = __webpack_require__(327);
var isObject = __webpack_require__(115);
var isNil = __webpack_require__(98);
var create = __webpack_require__(118);
var getTypeName = __webpack_require__(53);
var dict = __webpack_require__(485);
var getDefaultInterfaceName = __webpack_require__(757);
var extend = __webpack_require__(758);

function getDefaultName(props) {
  return 'Struct' + getDefaultInterfaceName(props);
}

function extendStruct(mixins, name) {
  return extend(struct, mixins, name);
}

function getOptions(options) {
  if (!isObject(options)) {
    options = isNil(options) ? {} : { name: options };
  }
  if (!options.hasOwnProperty('strict')) {
    options.strict = struct.strict;
  }
  if (!options.hasOwnProperty('defaultProps')) {
    options.defaultProps = {};
  }
  return options;
}

function struct(props, options) {

  options = getOptions(options);
  var name = options.name;
  var strict = options.strict;
  var defaultProps = options.defaultProps;

  if (false) {
    assert(dict(String, Function).is(props), function () { return 'Invalid argument props ' + assert.stringify(props) + ' supplied to struct(props, [options]) combinator (expected a dictionary String -> Type)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to struct(props, [options]) combinator (expected a string)'; });
    assert(isBoolean(strict), function () { return 'Invalid argument strict ' + assert.stringify(strict) + ' supplied to struct(props, [options]) combinator (expected a boolean)'; });
    assert(isObject(defaultProps), function () { return 'Invalid argument defaultProps ' + assert.stringify(defaultProps) + ' supplied to struct(props, [options]) combinator (expected an object)'; });
  }

  var displayName = name || getDefaultName(props);

  function Struct(value, path) {

    if (Struct.is(value)) { // implements idempotency
      return value;
    }

    if (false) {
      path = path || [displayName];
      assert(isObject(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an object)'; });
      // strictness
      if (strict) {
        for (k in value) {
          if (value.hasOwnProperty(k)) {
            assert(props.hasOwnProperty(k), function () { return 'Invalid additional prop "' + k + '" supplied to ' + path.join('/'); });
          }
        }
      }
    }

    if (!(this instanceof Struct)) { // `new` is optional
      return new Struct(value, path);
    }

    for (var k in props) {
      if (props.hasOwnProperty(k)) {
        var expected = props[k];
        var actual = value[k];
        // apply defaults
        if (actual === undefined) {
          actual = defaultProps[k];
        }
        this[k] = create(expected, actual, (  false ? path.concat(k + ': ' + getTypeName(expected)) : null ));
      }
    }

    if (false) {
      Object.freeze(this);
    }

  }

  Struct.meta = {
    kind: 'struct',
    props: props,
    name: name,
    identity: false,
    strict: strict,
    defaultProps: defaultProps
  };

  Struct.displayName = displayName;

  Struct.is = function (x) {
    return x instanceof Struct;
  };

  Struct.update = function (instance, patch) {
    return new Struct(assert.update(instance, patch));
  };

  Struct.extend = function (xs, name) {
    return extendStruct([Struct].concat(xs), name);
  };

  return Struct;
}

struct.strict = false;
struct.getOptions = getOptions;
struct.getDefaultName = getDefaultName;
struct.extend = extendStruct;
module.exports = struct;


/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

var isType = __webpack_require__(59);

module.exports = function isStruct(x) {
  return isType(x) && ( x.meta.kind === 'struct' );
};

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

var isType = __webpack_require__(59);

module.exports = function isInterface(x) {
  return isType(x) && ( x.meta.kind === 'interface' );
};

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

var isType = __webpack_require__(59);

function isRefinement(type) {
  return isType(type) && type.meta.kind === 'subtype';
}

function getPredicates(type) {
  return isRefinement(type) ?
    [type.meta.predicate].concat(getPredicates(type.meta.type)) :
    [];
}

function getUnrefinedType(type) {
  return isRefinement(type) ?
    getUnrefinedType(type.meta.type) :
    type;
}

function decompose(type) {
  return {
    predicates: getPredicates(type),
    unrefinedType: getUnrefinedType(type)
  };
}

module.exports = decompose;

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var isFunction = __webpack_require__(58);
var getTypeName = __webpack_require__(53);
var isIdentity = __webpack_require__(117);
var isArray = __webpack_require__(116);
var create = __webpack_require__(118);
var is = __webpack_require__(119);
var forbidNewOperator = __webpack_require__(246);
var isUnion = __webpack_require__(755);
var isNil = __webpack_require__(98);

function getDefaultName(types) {
  return types.map(getTypeName).join(' | ');
}

function union(types, name) {

  if (false) {
    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + assert.stringify(types) + ' supplied to union(types, [name]) combinator (expected an array of at least 2 types)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to union(types, [name]) combinator (expected a string)'; });
  }

  var displayName = name || getDefaultName(types);
  var identity = types.every(isIdentity);

  function Union(value, path) {

    if (true) {
      if (identity) {
        return value;
      }
    }

    var type = Union.dispatch(value);
    if (!type && Union.is(value)) {
      return value;
    }

    if (false) {
      if (identity) {
        forbidNewOperator(this, Union);
      }
      path = path || [displayName];
      assert(isFunction(type), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (no constructor returned by dispatch)'; });
      path[path.length - 1] += '(' + getTypeName(type) + ')';
    }

    return create(type, value, path);
  }

  Union.meta = {
    kind: 'union',
    types: types,
    name: name,
    identity: identity
  };

  Union.displayName = displayName;

  Union.is = function (x) {
    return types.some(function (type) {
      return is(x, type);
    });
  };

  Union.dispatch = function (x) { // default dispatch implementation
    for (var i = 0, len = types.length; i < len; i++ ) {
      var type = types[i];
      if (isUnion(type)) { // handle union of unions
        var t = type.dispatch(x);
        if (!isNil(t)) {
          return t;
        }
      }
      else if (is(x, type)) {
        return type;
      }
    }
  };

  Union.update = function (instance, patch) {
    return Union(assert.update(instance, patch));
  };

  return Union;
}

union.getDefaultName = getDefaultName;
module.exports = union;



/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var FunctionType = __webpack_require__(328);
var isArray = __webpack_require__(116);
var list = __webpack_require__(756);
var isObject = __webpack_require__(115);
var create = __webpack_require__(118);
var isNil = __webpack_require__(98);
var isBoolean = __webpack_require__(327);
var tuple = __webpack_require__(759);
var getFunctionName = __webpack_require__(245);
var getTypeName = __webpack_require__(53);
var isType = __webpack_require__(59);

function getDefaultName(domain, codomain) {
  return '(' + domain.map(getTypeName).join(', ') + ') => ' + getTypeName(codomain);
}

function isInstrumented(f) {
  return FunctionType.is(f) && isObject(f.instrumentation);
}

function getOptionalArgumentsIndex(types) {
  var end = types.length;
  var areAllMaybes = false;
  for (var i = end - 1; i >= 0; i--) {
    var type = types[i];
    if (!isType(type) || type.meta.kind !== 'maybe') {
      return (i + 1);
    } else {
      areAllMaybes = true;
    }
  }
  return areAllMaybes ? 0 : end;
}

function func(domain, codomain, name) {

  domain = isArray(domain) ? domain : [domain]; // handle handy syntax for unary functions

  if (false) {
    assert(list(FunctionType).is(domain), function () { return 'Invalid argument domain ' + assert.stringify(domain) + ' supplied to func(domain, codomain, [name]) combinator (expected an array of types)'; });
    assert(FunctionType.is(codomain), function () { return 'Invalid argument codomain ' + assert.stringify(codomain) + ' supplied to func(domain, codomain, [name]) combinator (expected a type)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to func(domain, codomain, [name]) combinator (expected a string)'; });
  }

  var displayName = name || getDefaultName(domain, codomain);
  var domainLength = domain.length;
  var optionalArgumentsIndex = getOptionalArgumentsIndex(domain);

  function FuncType(value, path) {

    if (!isInstrumented(value)) { // automatically instrument the function
      return FuncType.of(value);
    }

    if (false) {
      path = path || [displayName];
      assert(FuncType.is(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
    }

    return value;
  }

  FuncType.meta = {
    kind: 'func',
    domain: domain,
    codomain: codomain,
    name: name,
    identity: true
  };

  FuncType.displayName = displayName;

  FuncType.is = function (x) {
    return isInstrumented(x) &&
      x.instrumentation.domain.length === domainLength &&
      x.instrumentation.domain.every(function (type, i) {
        return type === domain[i];
      }) &&
      x.instrumentation.codomain === codomain;
  };

  FuncType.of = function (f, curried) {

    if (false) {
      assert(FunctionType.is(f), function () { return 'Invalid argument f supplied to func.of ' + displayName + ' (expected a function)'; });
      assert(isNil(curried) || isBoolean(curried), function () { return 'Invalid argument curried ' + assert.stringify(curried) + ' supplied to func.of ' + displayName + ' (expected a boolean)'; });
    }

    if (FuncType.is(f)) { // makes FuncType.of idempotent
      return f;
    }

    function fn() {
      var args = Array.prototype.slice.call(arguments);
      var argsLength = args.length;

      if (false) {
        // type-check arguments
        var tupleLength = curried ? argsLength : Math.max(argsLength, optionalArgumentsIndex);
        tuple(domain.slice(0, tupleLength), 'arguments of function ' + displayName)(args);
      }

      if (curried && argsLength < domainLength) {
        if (false) {
          assert(argsLength > 0, 'Invalid arguments.length = 0 for curried function ' + displayName);
        }
        var g = Function.prototype.bind.apply(f, [this].concat(args));
        var newDomain = func(domain.slice(argsLength), codomain);
        return newDomain.of(g, true);
      }
      else {
        return create(codomain, f.apply(this, args));
      }
    }

    fn.instrumentation = {
      domain: domain,
      codomain: codomain,
      f: f
    };

    fn.displayName = getFunctionName(f);

    return fn;

  };

  return FuncType;

}

func.getDefaultName = getDefaultName;
func.getOptionalArgumentsIndex = getOptionalArgumentsIndex;
module.exports = func;


/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var isFunction = __webpack_require__(58);
var isArray = __webpack_require__(116);
var forbidNewOperator = __webpack_require__(117);
var is = __webpack_require__(119);
var getTypeName = __webpack_require__(53);
var isIdentity = __webpack_require__(117);

function getDefaultName(types) {
  return types.map(getTypeName).join(' & ');
}

function intersection(types, name) {

  if (false) {
    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + assert.stringify(types) + ' supplied to intersection(types, [name]) combinator (expected an array of at least 2 types)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to intersection(types, [name]) combinator (expected a string)'; });
  }

  var displayName = name || getDefaultName(types);
  var identity = types.every(isIdentity);

  function Intersection(value, path) {

    if (false) {
      if (identity) {
        forbidNewOperator(this, Intersection);
      }
      path = path || [displayName];
      assert(Intersection.is(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
    }

    return value;
  }

  Intersection.meta = {
    kind: 'intersection',
    types: types,
    name: name,
    identity: identity
  };

  Intersection.displayName = displayName;

  Intersection.is = function (x) {
    return types.every(function (type) {
      return is(x, type);
    });
  };

  Intersection.update = function (instance, patch) {
    return Intersection(assert.update(instance, patch));
  };

  return Intersection;
}

intersection.getDefaultName = getDefaultName;
module.exports = intersection;



/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isTypeName = __webpack_require__(76);
var String = __webpack_require__(484);
var Function = __webpack_require__(328);
var isBoolean = __webpack_require__(327);
var isObject = __webpack_require__(115);
var isNil = __webpack_require__(98);
var create = __webpack_require__(118);
var getTypeName = __webpack_require__(53);
var dict = __webpack_require__(485);
var getDefaultInterfaceName = __webpack_require__(757);
var isIdentity = __webpack_require__(117);
var is = __webpack_require__(119);
var extend = __webpack_require__(758);
var assign = __webpack_require__(760);

function extendInterface(mixins, name) {
  return extend(inter, mixins, name);
}

function getOptions(options) {
  if (!isObject(options)) {
    options = isNil(options) ? {} : { name: options };
  }
  if (!options.hasOwnProperty('strict')) {
    options.strict = inter.strict;
  }
  return options;
}

function inter(props, options) {

  options = getOptions(options);
  var name = options.name;
  var strict = options.strict;

  if (false) {
    assert(dict(String, Function).is(props), function () { return 'Invalid argument props ' + assert.stringify(props) + ' supplied to interface(props, [options]) combinator (expected a dictionary String -> Type)'; });
    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to interface(props, [options]) combinator (expected a string)'; });
    assert(isBoolean(strict), function () { return 'Invalid argument strict ' + assert.stringify(strict) + ' supplied to struct(props, [options]) combinator (expected a boolean)'; });
  }

  var displayName = name || getDefaultInterfaceName(props);
  var identity = Object.keys(props).map(function (prop) { return props[prop]; }).every(isIdentity);

  function Interface(value, path) {

    if (true) {
      if (identity) {
        return value; // just trust the input if elements must not be hydrated
      }
    }

    if (false) {
      path = path || [displayName];
      assert(!isNil(value), function () { return 'Invalid value ' + value + ' supplied to ' + path.join('/'); });
      // strictness
      if (strict) {
        for (var k in value) {
          assert(props.hasOwnProperty(k), function () { return 'Invalid additional prop "' + k + '" supplied to ' + path.join('/'); });
        }
      }
    }

    var idempotent = true;
    var ret = identity ? {} : assign({}, value);
    for (var prop in props) {
      var expected = props[prop];
      var actual = value[prop];
      var instance = create(expected, actual, (  false ? path.concat(prop + ': ' + getTypeName(expected)) : null ));
      idempotent = idempotent && ( actual === instance );
      ret[prop] = instance;
    }

    if (idempotent) { // implements idempotency
      ret = value;
    }

    if (false) {
      Object.freeze(ret);
    }

    return ret;

  }

  Interface.meta = {
    kind: 'interface',
    props: props,
    name: name,
    identity: identity,
    strict: strict
  };

  Interface.displayName = displayName;

  Interface.is = function (x) {
    if (isNil(x)) {
      return false;
    }
    if (strict) {
      for (var k in x) {
        if (!props.hasOwnProperty(k)) {
          return false;
        }
      }
    }
    for (var prop in props) {
      if (!is(x[prop], props[prop])) {
        return false;
      }
    }
    return true;
  };

  Interface.update = function (instance, patch) {
    return Interface(assert.update(instance, patch));
  };

  Interface.extend = function (xs, name) {
    return extendInterface([Interface].concat(xs), name);
  };

  return Interface;
}

inter.strict = false;
inter.getOptions = getOptions;
inter.getDefaultName = getDefaultInterfaceName;
inter.extend = extendInterface;
module.exports = inter;


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isObject = __webpack_require__(115);
var isFunction = __webpack_require__(58);
var isArray = __webpack_require__(116);
var isNumber = __webpack_require__(754);
var assign = __webpack_require__(760);

function getShallowCopy(x) {
  if (isObject(x)) {
    if (x instanceof Date || x instanceof RegExp) {
      return x;
    }
    return assign({}, x);
  }
  if (isArray(x)) {
    return x.concat();
  }
  return x;
}

function isCommand(k) {
  return update.commands.hasOwnProperty(k);
}

function getCommand(k) {
  return update.commands[k];
}

function update(instance, patch) {

  if (false) {
    assert(isObject(patch), function () { return 'Invalid argument patch ' + assert.stringify(patch) + ' supplied to function update(instance, patch): expected an object containing commands'; });
  }

  var value = instance;
  var isChanged = false;
  var newValue;
  for (var k in patch) {
    if (patch.hasOwnProperty(k)) {
      if (isCommand(k)) {
        newValue = getCommand(k)(patch[k], value);
        if (newValue !== instance) {
          isChanged = true;
          value = newValue;
        } else {
          value = instance;
        }
      }
      else {
        if (value === instance) {
          value = getShallowCopy(instance);
        }
        newValue = update(value[k], patch[k]);
        isChanged = isChanged || ( newValue !== value[k] );
        value[k] = newValue;
      }
    }
  }
  return isChanged ? value : instance;
}

// built-in commands

function $apply(f, value) {
  if (false) {
    assert(isFunction(f), 'Invalid argument f supplied to immutability helper { $apply: f } (expected a function)');
  }
  return f(value);
}

function $push(elements, arr) {
  if (false) {
    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper { $push: elements } (expected an array)');
    assert(isArray(arr), 'Invalid value supplied to immutability helper $push (expected an array)');
  }
  if (elements.length > 0) {
    return arr.concat(elements);
  }
  return arr;
}

function $remove(keys, obj) {
  if (false) {
    assert(isArray(keys), 'Invalid argument keys supplied to immutability helper { $remove: keys } (expected an array)');
    assert(isObject(obj), 'Invalid value supplied to immutability helper $remove (expected an object)');
  }
  if (keys.length > 0) {
    obj = getShallowCopy(obj);
    for (var i = 0, len = keys.length; i < len; i++ ) {
      delete obj[keys[i]];
    }
  }
  return obj;
}

function $set(value) {
  return value;
}

function $splice(splices, arr) {
  if (false) {
    assert(isArray(splices) && splices.every(isArray), 'Invalid argument splices supplied to immutability helper { $splice: splices } (expected an array of arrays)');
    assert(isArray(arr), 'Invalid value supplied to immutability helper $splice (expected an array)');
  }
  if (splices.length > 0) {
    arr = getShallowCopy(arr);
    return splices.reduce(function (acc, splice) {
      acc.splice.apply(acc, splice);
      return acc;
    }, arr);
  }
  return arr;
}

function $swap(config, arr) {
  if (false) {
    assert(isObject(config), 'Invalid argument config supplied to immutability helper { $swap: config } (expected an object)');
    assert(isNumber(config.from), 'Invalid argument config.from supplied to immutability helper { $swap: config } (expected a number)');
    assert(isNumber(config.to), 'Invalid argument config.to supplied to immutability helper { $swap: config } (expected a number)');
    assert(isArray(arr), 'Invalid value supplied to immutability helper $swap (expected an array)');
  }
  if (config.from !== config.to) {
    arr = getShallowCopy(arr);
    var element = arr[config.to];
    arr[config.to] = arr[config.from];
    arr[config.from] = element;
  }
  return arr;
}

function $unshift(elements, arr) {
  if (false) {
    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper {$unshift: elements} (expected an array)');
    assert(isArray(arr), 'Invalid value supplied to immutability helper $unshift (expected an array)');
  }
  if (elements.length > 0) {
    return elements.concat(arr);
  }
  return arr;
}

function $merge(whatToMerge, value) {
  var isChanged = false;
  var result = getShallowCopy(value);
  for (var k in whatToMerge) {
    if (whatToMerge.hasOwnProperty(k)) {
      result[k] = whatToMerge[k];
      isChanged = isChanged || ( result[k] !== value[k] );
    }
  }
  return isChanged ? result : value;
}

update.commands = {
  $apply: $apply,
  $push: $push,
  $remove: $remove,
  $set: $set,
  $splice: $splice,
  $swap: $swap,
  $unshift: $unshift,
  $merge: $merge
};

module.exports = update;


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(36);
var isFunction = __webpack_require__(58);
var isType = __webpack_require__(59);
var Any = __webpack_require__(482);

module.exports = function match(x) {
  var type, guard, f, count;
  for (var i = 1, len = arguments.length; i < len; ) {
    type = arguments[i];
    guard = arguments[i + 1];
    f = arguments[i + 2];

    if (isFunction(f) && !isType(f)) {
      i = i + 3;
    }
    else {
      f = guard;
      guard = Any.is;
      i = i + 2;
    }

    if (false) {
      count = (count || 0) + 1;
      assert(isType(type), function () { return 'Invalid type in clause #' + count; });
      assert(isFunction(guard), function () { return 'Invalid guard in clause #' + count; });
      assert(isFunction(f), function () { return 'Invalid block in clause #' + count; });
    }

    if (type.is(x) && guard(x)) {
      return f(x);
    }
  }
  assert.fail('Match error');
};


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var styles = {
  icon: {
    position: 'absolute',
    fontSize: '1em',
    top: '50%',
    marginTop: '-0.5em',
    right: '1em',
    color: 'white',
    cursor: 'pointer'
  },

  link: {
    color: '#F0F0F0',
    textDecoration: 'underline',
    marginLeft: '10px'
  },

  button: {
    position: 'absolute',
    top: '50%',
    right: '35px',
    height: '24px',
    lineHeight: '24px',
    marginTop: '-12px',
    paddingLeft: '8px',
    paddingRight: '8px',
    opacity: '0.5',
    backgroundColor: 'white',
    borderRadius: '3px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#242424',
    cursor: 'pointer'
  },

  message: {
    lineHeight: '45px',
    fontWeight: 500,
    color: '#F0F0F0'
  },

  banner: {
    position: 'relative',
    textAlign: 'center',
    backgroundColor: '#484848',
    width: '100%',
    height: '45px',
    zIndex: '10000'
  }
};

var getStyle = function getStyle(style) {
  return styles[style];
};

exports['default'] = { getStyle: getStyle };
module.exports = exports['default'];

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({cookiePolicyMessage:{id:'cookie-policy.message',defaultMessage:'By continuing to use this site you agree to our cookie policy'},cookiePolicyLink:{id:'cookie-policy.link',defaultMessage:'(see the cookie policy here).'},cookiePolicyURL:{id:'cookie-policy.url',defaultMessage:'https://www.hivehome.com/cookies'},cookiePolicyConfirm:{id:'cookie-policy.confirm',defaultMessage:"Don't show this message again"}}));

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ErrorBoundary=function(_React$Component){_inherits(ErrorBoundary,_React$Component);function ErrorBoundary(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ErrorBoundary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ErrorBoundary.__proto__||Object.getPrototypeOf(ErrorBoundary)).call.apply(_ref,[this].concat(args))),_this),_this.state={hasError:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ErrorBoundary,[{key:'componentDidCatch',value:function componentDidCatch(error){this.setState({hasError:true});__WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureException(error);}},{key:'render',value:function render(){var hasError=this.state.hasError;var _props=this.props,children=_props.children,_props$errorComponent=_props.errorComponent,errorComponent=_props$errorComponent===undefined?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__error__["a" /* default */],null):_props$errorComponent;return hasError?errorComponent:children;}}]);return ErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_hive_logo_logo_svg__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_hive_logo_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_hive_logo_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(2543);
var refresh=function refresh(){return global.location=global.location;};/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* LogoContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img',{alt:'Hive Logo',src:__WEBPACK_IMPORTED_MODULE_3__assets_hive_logo_logo_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].message)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].buttonLabel)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Button */],{onClick:refresh},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].buttonText)));});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LogoContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 100%;\n'],['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    height: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['margin-top: 1em;'],['margin-top: 1em;']),_templateObject3=_taggedTemplateLiteral(['margin-bottom: 1em;'],['margin-bottom: 1em;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject);var Button=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0__widgets__["l" /* Button */])(_templateObject2);var LogoContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3);

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accordion_component_css__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__accordion_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__accordion_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
// @noflow
var CONTENT_PREFIX='accordion-content';var propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,contentId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,header:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,isExpanded:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,onToggle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func};var Accordion=function Accordion(_ref){var children=_ref.children,className=_ref.className,_ref$contentId=_ref.contentId,contentId=_ref$contentId===undefined?CONTENT_PREFIX+'-'+Math.random().toString(16):_ref$contentId,header=_ref.header,isExpanded=_ref.isExpanded,onToggle=_ref.onToggle;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('accordion',className)},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('button',{'aria-controls':contentId,'aria-expanded':isExpanded,className:'accordion__header',onClick:onToggle,type:'button'},header),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{'aria-hidden':!isExpanded,className:'accordion__content',id:contentId},children));};Accordion.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Copyright (c) 2015 Twitter, Inc. and other contributors

Component to add Velocity animations to one or more children. Wraps a single child without adding
additional DOM nodes.

The API attempts to be as declarative as possible. A single animation property declares what
animation the child should have. If that property changes, this component applies the new animation
to the child on the next tick.

By default, the animation is not run when the component is mounted. Instead, Velocity's "finish"
command is used to jump to the animation's end state. For a component that animates out of and
back in to a default state, this allows the parent to specify the "animate into" animation as
the default, and therefore not have to distinguish between the initial state and the state to
return to after animating away.

Properties:
 animation: Either an animation key or hash defining the animation. See Velocity's documentation
   for what this can be. (It is passed to Velocity exactly.)
 runOnMount: If true, runs the animation even when the component is first mounted.
 targetQuerySelector: By default, this component's single child is animated. If targetQuerySelector
   is provided, it is used to select descendants to apply the animation to. Use with caution, only
   when you're confident that React's reconciliation will preserve these nodes during animation.
   Also note querySelectorAll's silly behavior w.r.t. pruning results when being called on a node.
   A special value of "children" will use the direct children of the node, since there isn't a
   great way to specify that to querySelectorAll.
 interruptBehavior: Sets how the previous animation should behave when the "animation" prop is
   changed before it’s done. Default is "stop", which halts the animation where it is. "finish"
   will jump the animation to its completed appearance. "queue" will run the new animation after
   the previous one has finished.

Unrecognized properties are passed as options to Velocity (e.g. "duration", "delay", "loop").

Methods:
 runAnimation: Triggers the animation immediately. Useful for when you want an animation that
   corresponds to an event but not a particular model state change (e.g. a "bump" when a click
   occurs).
*/

var _ = {
  forEach: __webpack_require__(487),
  isEqual: __webpack_require__(768),
  keys: __webpack_require__(173),
  omit: __webpack_require__(769)
};

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(130);
var PropTypes = __webpack_require__(4);
var Velocity = __webpack_require__(492);

var VelocityComponent = function (_React$Component) {
  _inherits(VelocityComponent, _React$Component);

  function VelocityComponent(props) {
    _classCallCheck(this, VelocityComponent);

    var _this = _possibleConstructorReturn(this, (VelocityComponent.__proto__ || Object.getPrototypeOf(VelocityComponent)).call(this, props));

    _this._animationTimeout = null;

    // This public method is kept as self-bound to maintain compatibility with the React.createClass
    // version of the component.
    _this.runAnimation = _this.runAnimation.bind(_this);
    return _this;
  }

  _createClass(VelocityComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.runAnimation();

      // Jump to the end so that the component has the visual appearance of the animation having
      // been run to completion.
      if (this.props.runOnMount !== true) {
        this._finishAnimation();
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps, newState) {
      if (!_.isEqual(newProps.animation, this.props.animation)) {
        if (newProps.interruptBehavior === 'stop') {
          this._stopAnimation();
        } else if (newProps.interruptBehavior === 'finish') {
          this._finishAnimation();
        }

        this._scheduleAnimation();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._stopAnimation();
      this._clearVelocityCache(this._getDOMTarget());

      if (this._animationTimeout) {
        clearTimeout(this._animationTimeout);
      }
    }

    // It's ok to call this externally! By default the animation will be queued up. Pass stop: true in
    // to stop the current animation before running. Pass finish: true to finish the current animation
    // before running.

  }, {
    key: 'runAnimation',
    value: function runAnimation(config) {
      config = config || {};

      this._animationTimeout = null;

      if (this.props.animation == null) {
        return;
      }

      if (config.stop) {
        Velocity(this._getDOMTarget(), 'stop', true);
      } else if (config.finish) {
        Velocity(this._getDOMTarget(), 'finishAll', true);
      }

      // Delegate all props except for the ones that we have specified as our own via propTypes.
      var opts = _.omit(this.props, _.keys(VelocityComponent.propTypes));
      Velocity(this._getDOMTarget(), this.props.animation, opts);
    }

    // We trigger animations on a new tick because of a Velocity bug where adding a
    // multi-step animation from within a complete callback causes the first 2 animations to run
    // simultaneously.

  }, {
    key: '_scheduleAnimation',
    value: function _scheduleAnimation() {
      if (this._animationTimeout) {
        return;
      }

      this._animationTimeout = setTimeout(this.runAnimation, 0);
    }

    // Returns one or more DOM nodes to apply the animation to. This is checked every time we start
    // or stop an animation, which means that if an animation is proceeding but the element is removed
    // from the page, it will run its course rather than ever being stopped. (We go this route
    // because of difficulty in tracking what animations are currently being animated, due to both
    // chained animations and the need to be able to "stop" an animation before it begins.)

  }, {
    key: '_getDOMTarget',
    value: function _getDOMTarget() {
      var node = ReactDOM.findDOMNode(this);

      if (this.props.targetQuerySelector === 'children') {
        return node.children;
      } else if (this.props.targetQuerySelector != null) {
        return node.querySelectorAll(this.props.targetQuerySelector);
      } else {
        return node;
      }
    }
  }, {
    key: '_finishAnimation',
    value: function _finishAnimation() {
      Velocity(this._getDOMTarget(), 'finishAll', true);
    }
  }, {
    key: '_stopAnimation',
    value: function _stopAnimation() {
      Velocity(this._getDOMTarget(), 'stop', true);
    }

    // Velocity keeps extensive caches for all animated elements to minimize layout thrashing.
    // This can cause a serious memory leak, keeping references to unmounted elements as well
    // completion handlers and associated react objects. This crudely clears these references.

  }, {
    key: '_clearVelocityCache',
    value: function _clearVelocityCache(target) {
      if (target.length) {
        _.forEach(target, this._clearVelocityCache);
      } else {
        Velocity.Utilities.removeData(target, ['velocity', 'fxqueue']);
      }
    }

    // This component does not include any DOM footprint of its own, so instead we return our
    // child out of render(). (Render must only return a single element, which restricts us to
    // one child. If you want to animate multiple children, provide your own wrapper element and
    // use the "targetQuerySelector" prop to target its children.)

  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return VelocityComponent;
}(React.Component);

VelocityComponent.propTypes = {
  animation: PropTypes.any,
  children: PropTypes.element.isRequired,
  runOnMount: PropTypes.bool,
  targetQuerySelector: PropTypes.string,
  interruptBehavior: PropTypes.string
};

VelocityComponent.defaultProps = {
  animation: null,
  runOnMount: false,
  targetQuerySelector: null,
  interruptBehavior: 'stop'
};

module.exports = VelocityComponent;

/***/ }),
/* 2051 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(764),
    keys = __webpack_require__(173);

/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(120);

/**
 * Creates a base function for `_.forIn` or `_.forInRight`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var iterable = toObject(object),
        props = keysFunc(object),
        length = props.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      var key = props[index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(2055),
    isObjectLike = __webpack_require__(211);

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike(value) && reIsHostCtor.test(value);
}

module.exports = isNative;


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 which returns 'object' for typed array constructors.
  return isObject(value) && objToString.call(value) == funcTag;
}

module.exports = isFunction;


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

var isArguments = __webpack_require__(488),
    isArray = __webpack_require__(121),
    isIndex = __webpack_require__(489),
    isLength = __webpack_require__(212),
    keysIn = __webpack_require__(490);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function shimKeys(object) {
  var props = keysIn(object),
      propsLength = props.length,
      length = propsLength && object.length;

  var allowIndexes = !!length && isLength(length) &&
    (isArray(object) || isArguments(object));

  var index = -1,
      result = [];

  while (++index < propsLength) {
    var key = props[index];
    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = shimKeys;


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

var getLength = __webpack_require__(765),
    isLength = __webpack_require__(212),
    toObject = __webpack_require__(120);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    var length = collection ? getLength(collection) : 0;
    if (!isLength(length)) {
      return eachFunc(collection, iteratee);
    }
    var index = fromRight ? length : -1,
        iterable = toObject(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

var bindCallback = __webpack_require__(248),
    isArray = __webpack_require__(121);

/**
 * Creates a function for `_.forEach` or `_.forEachRight`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over an array.
 * @param {Function} eachFunc The function to iterate over a collection.
 * @returns {Function} Returns the new each function.
 */
function createForEach(arrayFunc, eachFunc) {
  return function(collection, iteratee, thisArg) {
    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
      ? arrayFunc(collection, iteratee)
      : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
  };
}

module.exports = createForEach;


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

var equalArrays = __webpack_require__(2060),
    equalByTag = __webpack_require__(2062),
    equalObjects = __webpack_require__(2063),
    isArray = __webpack_require__(121),
    isTypedArray = __webpack_require__(2064);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = objToString.call(object);
    if (objTag == argsTag) {
      objTag = objectTag;
    } else if (objTag != objectTag) {
      objIsArr = isTypedArray(object);
    }
  }
  if (!othIsArr) {
    othTag = objToString.call(other);
    if (othTag == argsTag) {
      othTag = objectTag;
    } else if (othTag != objectTag) {
      othIsArr = isTypedArray(other);
    }
  }
  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && !(objIsArr || objIsObj)) {
    return equalByTag(object, other, objTag);
  }
  if (!isLoose) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
    }
  }
  if (!isSameTag) {
    return false;
  }
  // Assume cyclic values are equal.
  // For more information on detecting circular references see https://es5.github.io/#JO.
  stackA || (stackA = []);
  stackB || (stackB = []);

  var length = stackA.length;
  while (length--) {
    if (stackA[length] == object) {
      return stackB[length] == other;
    }
  }
  // Add `object` and `other` to the stack of traversed objects.
  stackA.push(object);
  stackB.push(other);

  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

  stackA.pop();
  stackB.pop();

  return result;
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(2061);

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing arrays.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var index = -1,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
    return false;
  }
  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index],
        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

    if (result !== undefined) {
      if (result) {
        continue;
      }
      return false;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (isLoose) {
      if (!arraySome(other, function(othValue) {
            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
          })) {
        return false;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
      return false;
    }
  }
  return true;
}

module.exports = equalArrays;


/***/ }),
/* 2061 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 2062 */
/***/ (function(module, exports) {

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    stringTag = '[object String]';

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag) {
  switch (tag) {
    case boolTag:
    case dateTag:
      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
      return +object == +other;

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case numberTag:
      // Treat `NaN` vs. `NaN` as equal.
      return (object != +object)
        ? other != +other
        : object == +other;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings primitives and string
      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
      return object == (other + '');
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

var keys = __webpack_require__(173);

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparing values.
 * @param {boolean} [isLoose] Specify performing partial comparisons.
 * @param {Array} [stackA] Tracks traversed `value` objects.
 * @param {Array} [stackB] Tracks traversed `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
  var objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isLoose) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  var skipCtor = isLoose;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key],
        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

    // Recursively compare objects (susceptible to call stack limits).
    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
      return false;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (!skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      return false;
    }
  }
  return true;
}

module.exports = equalObjects;


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

var isLength = __webpack_require__(212),
    isObjectLike = __webpack_require__(211);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dateTag] = typedArrayTags[errorTag] =
typedArrayTags[funcTag] = typedArrayTags[mapTag] =
typedArrayTags[numberTag] = typedArrayTags[objectTag] =
typedArrayTags[regexpTag] = typedArrayTags[setTag] =
typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/** Used for native method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto.toString;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
function isTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
}

module.exports = isTypedArray;


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(2066),
    cacheIndexOf = __webpack_require__(2068),
    createCache = __webpack_require__(2069);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.difference` which accepts a single array
 * of values to exclude.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values) {
  var length = array ? array.length : 0,
      result = [];

  if (!length) {
    return result;
  }
  var index = -1,
      indexOf = baseIndexOf,
      isCommon = true,
      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
      valuesLength = values.length;

  if (cache) {
    indexOf = cacheIndexOf;
    isCommon = false;
    values = cache;
  }
  outer:
  while (++index < length) {
    var value = array[index];

    if (isCommon && value === value) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === value) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (indexOf(values, value, 0) < 0) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

var indexOfNaN = __webpack_require__(2067);

/**
 * The base implementation of `_.indexOf` without support for binary searches.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return indexOfNaN(array, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = baseIndexOf;


/***/ }),
/* 2067 */
/***/ (function(module, exports) {

/**
 * Gets the index at which the first occurrence of `NaN` is found in `array`.
 *
 * @private
 * @param {Array} array The array to search.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
 */
function indexOfNaN(array, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 0 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    var other = array[index];
    if (other !== other) {
      return index;
    }
  }
  return -1;
}

module.exports = indexOfNaN;


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);

/**
 * Checks if `value` is in `cache` mimicking the return signature of
 * `_.indexOf` by returning `0` if the value is found, else `-1`.
 *
 * @private
 * @param {Object} cache The cache to search.
 * @param {*} value The value to search for.
 * @returns {number} Returns `0` if `value` is found, else `-1`.
 */
function cacheIndexOf(cache, value) {
  var data = cache.data,
      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

  return result ? 0 : -1;
}

module.exports = cacheIndexOf;


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(2070),
    getNative = __webpack_require__(329);

/** Native method references. */
var Set = getNative(global, 'Set');

/* Native method references for those with the same name as other `lodash` methods. */
var nativeCreate = getNative(Object, 'create');

/**
 * Creates a `Set` cache object to optimize linear searches of large arrays.
 *
 * @private
 * @param {Array} [values] The values to cache.
 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
 */
function createCache(values) {
  return (nativeCreate && Set) ? new SetCache(values) : null;
}

module.exports = createCache;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(2071),
    getNative = __webpack_require__(329);

/** Native method references. */
var Set = getNative(global, 'Set');

/* Native method references for those with the same name as other `lodash` methods. */
var nativeCreate = getNative(Object, 'create');

/**
 *
 * Creates a cache object to store unique values.
 *
 * @private
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var length = values ? values.length : 0;

  this.data = { 'hash': nativeCreate(null), 'set': new Set };
  while (length--) {
    this.push(values[length]);
  }
}

// Add functions to the `Set` cache.
SetCache.prototype.push = cachePush;

module.exports = SetCache;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(99);

/**
 * Adds `value` to the cache.
 *
 * @private
 * @name push
 * @memberOf SetCache
 * @param {*} value The value to cache.
 */
function cachePush(value) {
  var data = this.data;
  if (typeof value == 'string' || isObject(value)) {
    data.set.add(value);
  } else {
    data.hash[value] = true;
  }
}

module.exports = cachePush;


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(2073),
    isArguments = __webpack_require__(488),
    isArray = __webpack_require__(121),
    isArrayLike = __webpack_require__(247),
    isObjectLike = __webpack_require__(211);

/**
 * The base implementation of `_.flatten` with added support for restricting
 * flattening and specifying the start index.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {boolean} [isDeep] Specify a deep flatten.
 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, isDeep, isStrict, result) {
  result || (result = []);

  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index];
    if (isObjectLike(value) && isArrayLike(value) &&
        (isStrict || isArray(value) || isArguments(value))) {
      if (isDeep) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, isDeep, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 2073 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

var toObject = __webpack_require__(120);

/**
 * A specialized version of `_.pick` which picks `object` properties specified
 * by `props`.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property names to pick.
 * @returns {Object} Returns the new object.
 */
function pickByArray(object, props) {
  object = toObject(object);

  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index];
    if (key in object) {
      result[key] = object[key];
    }
  }
  return result;
}

module.exports = pickByArray;


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

var baseForIn = __webpack_require__(2076);

/**
 * A specialized version of `_.pick` which picks `object` properties `predicate`
 * returns truthy for.
 *
 * @private
 * @param {Object} object The source object.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Object} Returns the new object.
 */
function pickByCallback(object, predicate) {
  var result = {};
  baseForIn(object, function(value, key, object) {
    if (predicate(value, key, object)) {
      result[key] = value;
    }
  });
  return result;
}

module.exports = pickByCallback;


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(764),
    keysIn = __webpack_require__(490);

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor(object, iteratee, keysIn);
}

module.exports = baseForIn;


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Copyright (c) 2015 Twitter, Inc. and other contributors

Component to add Velocity animations around React transitions. Delegates to the React TransitionGroup
addon.

Properties
  enter: Animation to run on a child component being added
  leave: Animation to run on a child component leaving
  runOnMount: if true, runs the "enter" animation on the elements that exist as children when this
    component is mounted.
  enterHideStyle/enterShowStyle: see below.

Any additional properties (e.g. "className", "component") will be passed to the internal
TransitionGroup.

"enter" and "leave" should either be a string naming an animation, or a hash with an
"animation" key that can either be a string itself, or a hash of style attributes to animate (this
value is passed to Velocity its the first arg).

If "enter" or "leave" is a hash, it can additionally have a "style" value that is applied the tick
before the Velocity animation starts. Use this for non-animating properties (like "position") that
are prerequisites for correct animation. The style value is applied using Velocity's JS -> CSS
routines, which may differ from React's.

Any hash entries beyond "animation" and "style" are passed in an options hash to Velocity. Use this
for options like "stagger", "reverse", &tc.

By default, this component will immediately hide all entering children with display: 'none', and
unhide them one tick later with display: ''. This is done so that we can coalesce multiple enters
into a single animation, and we want to avoid any popping of elements in while they're collected. If
you prefer a different way of hiding these elements so that e.g. geometry can be immediately
calculated, use the enterHideStyle and enterShowStyle props to provide alternate style hashes for
hiding and revealing entering elements.

Statics
  disabledForTest: Set this to true globally to turn off all custom animation logic. Instead, this
    component will behave like a vanilla TransitionGroup.

Inspired by https://gist.github.com/tkafka/0d94c6ec94297bb67091
*/

var _ = {
  each: __webpack_require__(2078),
  extend: __webpack_require__(2079),
  forEach: __webpack_require__(487),
  isEqual: __webpack_require__(768),
  keys: __webpack_require__(173),
  omit: __webpack_require__(769),
  pluck: __webpack_require__(2086)
};
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(130);
var PropTypes = __webpack_require__(4);
var TransitionGroup = __webpack_require__(2099);
var Velocity = __webpack_require__(492);

// Shim requestAnimationFrame for browsers that don't support it, in particular IE 9.
var shimRequestAnimationFrame = typeof window !== 'undefined' && (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
  window.setTimeout(callback, 0);
});

// Fix 'Invalid calling object' error in IE
shimRequestAnimationFrame = typeof window !== 'undefined' && shimRequestAnimationFrame.bind(window);

var shimCancelAnimationFrame = typeof window !== 'undefined' && (window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || function (timeout) {
  window.clearTimeout(timeout);
});

shimCancelAnimationFrame = typeof window !== 'undefined' && shimCancelAnimationFrame.bind(window);

// Internal wrapper for the transitioned elements. Delegates all child lifecycle events to the
// parent VelocityTransitionGroup so that it can co-ordinate animating all of the elements at once.

var VelocityTransitionGroupChild = function (_React$Component) {
  _inherits(VelocityTransitionGroupChild, _React$Component);

  function VelocityTransitionGroupChild() {
    _classCallCheck(this, VelocityTransitionGroupChild);

    return _possibleConstructorReturn(this, (VelocityTransitionGroupChild.__proto__ || Object.getPrototypeOf(VelocityTransitionGroupChild)).apply(this, arguments));
  }

  _createClass(VelocityTransitionGroupChild, [{
    key: 'componentWillAppear',
    value: function componentWillAppear(doneFn) {
      this.props.willAppearFunc(ReactDOM.findDOMNode(this), doneFn);
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(doneFn) {
      this.props.willEnterFunc(ReactDOM.findDOMNode(this), doneFn);
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(doneFn) {
      this.props.willLeaveFunc(ReactDOM.findDOMNode(this), doneFn);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Clear references from velocity cache.
      Velocity.Utilities.removeData(ReactDOM.findDOMNode(this), ['velocity', 'fxqueue']);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.Children.only(this.props.children);
    }
  }]);

  return VelocityTransitionGroupChild;
}(React.Component);

VelocityTransitionGroupChild.propTypes = {
  children: PropTypes.element.isRequired,
  willAppearFunc: PropTypes.func.isRequired,
  willEnterFunc: PropTypes.func.isRequired,
  willLeaveFunc: PropTypes.func.isRequired
};

var VelocityTransitionGroup = function (_React$Component2) {
  _inherits(VelocityTransitionGroup, _React$Component2);

  function VelocityTransitionGroup(props) {
    _classCallCheck(this, VelocityTransitionGroup);

    var _this2 = _possibleConstructorReturn(this, (VelocityTransitionGroup.__proto__ || Object.getPrototypeOf(VelocityTransitionGroup)).call(this, props));

    _this2._scheduledAnimationFrame = null;
    _this2._scheduledAnimationRunFrames = [];
    _this2._entering = [];
    _this2._leaving = [];

    _this2._timers = [];
    _this2._unmounted = false;

    _this2.childWillAppear = _this2.childWillAppear.bind(_this2);
    _this2.childWillEnter = _this2.childWillEnter.bind(_this2);
    _this2.childWillLeave = _this2.childWillLeave.bind(_this2);

    _this2._runAnimations = _this2._runAnimations.bind(_this2);
    _this2._wrapChild = _this2._wrapChild.bind(_this2);
    return _this2;
  }

  _createClass(VelocityTransitionGroup, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._scheduledAnimationFrame) {
        shimCancelAnimationFrame(this._scheduledAnimationFrame);
      }

      _.forEach(this._timers, function (timer) {
        clearTimeout(timer);
      });

      _.forEach(this._scheduledAnimationRunFrames, function (frame) {
        shimCancelAnimationFrame(frame);
      });

      // We don't cancel all the in-process animations, so we use this to know if the component
      // is gone when an animation is over.
      this._unmounted = true;
    }
  }, {
    key: 'render',
    value: function render() {
      // Pass any props that are not our own on into the TransitionGroup delegate.
      var transitionGroupProps = _.omit(this.props, _.keys(VelocityTransitionGroup.propTypes));

      // Without our custom childFactory, we just get a default TransitionGroup that doesn't do
      // anything special at all.
      if (!this.constructor.disabledForTest && !Velocity.velocityReactServerShim) {
        transitionGroupProps.childFactory = this._wrapChild;
      }

      return React.createElement(TransitionGroup, transitionGroupProps, this.props.children);
    }
  }, {
    key: 'childWillAppear',
    value: function childWillAppear(node, doneFn) {
      var _this3 = this;

      if (this.props.runOnMount) {
        this.childWillEnter(node, doneFn);
      } else {
        this._finishAnimation(node, this.props.enter);

        // Important to tick over so that any callbacks due to finishing the animation complete first.
        //
        // Using setTimeout so that doneFn gets called even when the tab is hidden.
        var t = setTimeout(function () {
          var idx = _this3._timers.indexOf(t);
          if (idx >= 0) {
            _this3._timers.splice(idx, 1);
          }

          doneFn();
        }, 0);
        this._timers.push(t);
      }
    }
  }, {
    key: 'childWillEnter',
    value: function childWillEnter(node, doneFn) {
      if (this._shortCircuitAnimation(this.props.enter, doneFn)) return;

      // By finishing a "leave" on the element, we put it in the right state to be animated in. Useful
      // if "leave" includes a rotation or something that we'd like to have as our starting point, for
      // symmetry.
      // We use overrideOpts to prevent any "begin" or "complete" callback from triggering in this case, since
      // it doesn't make a ton of sense.
      this._finishAnimation(node, this.props.leave, { begin: undefined, complete: undefined });

      // We're not going to start the animation for a tick, so set the node's display to none (or any
      // custom "hide" style provided) so that it doesn't flash in.
      _.forEach(this.props.enterHideStyle, function (val, key) {
        Velocity.CSS.setPropertyValue(node, key, val);
      });

      this._entering.push({
        node: node,
        doneFn: doneFn
      });

      this._schedule();
    }
  }, {
    key: 'childWillLeave',
    value: function childWillLeave(node, doneFn) {
      if (this._shortCircuitAnimation(this.props.leave, doneFn)) return;

      this._leaving.push({
        node: node,
        doneFn: doneFn
      });

      this._schedule();
    }
  }, {
    key: '_shortCircuitAnimation',


    // document.hidden check is there because animation completion callbacks won't fire (due to
    // chaining off of rAF), which would prevent entering / leaving DOM nodes from being cleaned up
    // while the tab is hidden.
    //
    // Returns true if this did short circuit, false if lifecycle methods should continue with
    // their animations.
    value: function _shortCircuitAnimation(animationProp, doneFn) {
      if (document.hidden || this._parseAnimationProp(animationProp).animation == null) {
        doneFn();

        return true;
      } else {
        return false;
      }
    }
  }, {
    key: '_schedule',
    value: function _schedule() {
      if (this._scheduledAnimationFrame) {
        return;
      }

      // Need rAF to make sure we're in the same event queue as Velocity from here out. Important
      // for avoiding getting wrong interleaving with Velocity callbacks.
      this._scheduledAnimationFrame = shimRequestAnimationFrame(this._runAnimations);
    }

    // arrow function because this is used as an rAF callback

  }, {
    key: '_runAnimations',
    value: function _runAnimations() {
      this._scheduledAnimationFrame = null;

      this._runAnimation(true, this._entering, this.props.enter);
      this._runAnimation(false, this._leaving, this.props.leave);

      this._entering = [];
      this._leaving = [];
    }

    // Used to parse out the 'enter' and 'leave' properties. Handles cases where they are omitted
    // as well as when they are just strings and not hashes of animation and options.

  }, {
    key: '_parseAnimationProp',
    value: function _parseAnimationProp(animationProp) {
      var animation, opts, style;

      if (typeof animationProp === 'string') {
        animation = animationProp;
        style = null;
        opts = {};
      } else {
        animation = animationProp != null ? animationProp.animation : null;
        style = animationProp != null ? animationProp.style : null;
        opts = _.omit(animationProp, 'animation', 'style');
      }

      return {
        animation: animation,
        style: style,
        opts: opts
      };
    }
  }, {
    key: '_runAnimation',
    value: function _runAnimation(entering, queue, animationProp) {
      var _this4 = this;

      if (queue.length === 0) {
        return;
      }

      var nodes = _.pluck(queue, 'node');
      var doneFns = _.pluck(queue, 'doneFn');

      var parsedAnimation = this._parseAnimationProp(animationProp);
      var animation = parsedAnimation.animation;
      var style = parsedAnimation.style;
      var opts = parsedAnimation.opts;

      // Clearing display reverses the behavior from childWillAppear where all elements are added with
      // display: none to prevent them from flashing in before the animation starts. We don't do this
      // for the fade/slide animations or any animation that ends in "In," since Velocity will handle
      // it for us.
      //
      // If a custom "enterShowStyle" prop is passed, (i.e. not one that just reverses display: none)
      // we always run it, regardless of the animation, since it's probably doing something around
      // opacity or positioning that Velocity will not necessarily reset.
      if (entering) {
        if (!_.isEqual(this.props.enterShowStyle, { display: '' }) || !(/^(fade|slide)/.test(animation) || /In$/.test(animation))) {
          style = _.extend({}, this.props.enterShowStyle, style);
        }
      }

      // Because Safari can synchronously repaint when CSS "display" is reset, we set styles for all
      // browsers before the rAF tick below that starts the animation. This way you know in all
      // cases that you need to support your static styles being visible on the element before
      // the animation begins.
      if (style != null) {
        _.each(style, function (value, key) {
          Velocity.hook(nodes, key, value);
        });
      }

      var doneFn = function doneFn() {
        // calling doneFns after the parent has unmounted leads to errors
        if (_this4._unmounted) {
          return;
        }

        doneFns.map(function (doneFn) {
          doneFn();
        });
      };

      // For nodes that are entering, we tell the TransitionGroup that we're done with them
      // immediately. That way, they can be removed later before their entering animations complete.
      // If we're leaving, we stop current animations (which may be partially-completed enter
      // animations) so that we can then animate out. Velocity typically makes these transitions
      // very smooth, correctly animating from whatever state the element is currently in.
      if (entering) {
        doneFn();
        doneFn = null;
      } else {
        Velocity(nodes, 'stop');
      }

      var combinedCompleteFn;
      if (doneFn && opts.complete) {
        var optsCompleteFn = opts.complete;
        combinedCompleteFn = function combinedCompleteFn() {
          doneFn();
          // preserve this / args from Velocity so the complete function has context for what completed
          optsCompleteFn.apply(this, arguments);
        };
      } else {
        // One or the other or neither.
        combinedCompleteFn = doneFn || opts.complete;
      }

      // Bit of a hack. Without this rAF, sometimes an enter animation doesn't start running, or is
      // stopped before getting anywhere. This should get us on the other side of both completeFn and
      // any _finishAnimation that's happening.
      var t = shimRequestAnimationFrame(function () {
        var idx = _this4._scheduledAnimationRunFrames.indexOf(t);
        if (idx >= 0) {
          _this4._scheduledAnimationRunFrames.splice(idx, 1);
        }

        Velocity(nodes, animation, _.extend({}, opts, {
          complete: combinedCompleteFn
        }));
      });

      this._scheduledAnimationRunFrames.push(t);
    }
  }, {
    key: '_finishAnimation',
    value: function _finishAnimation(node, animationProp, overrideOpts) {
      var parsedAnimation = this._parseAnimationProp(animationProp);
      var animation = parsedAnimation.animation;
      var style = parsedAnimation.style;
      var opts = _.extend({}, parsedAnimation.opts, overrideOpts);

      if (style != null) {
        _.each(style, function (value, key) {
          Velocity.hook(node, key, value);
        });
      }

      if (animation != null) {
        // Opts are relevant even though we're immediately finishing, since things like "display"
        // can affect the animation outcome.

        Velocity(node, animation, opts);
        Velocity(node, 'finishAll', true);
      }
    }
  }, {
    key: '_wrapChild',
    value: function _wrapChild(child) {
      return React.createElement(VelocityTransitionGroupChild, {
        willAppearFunc: this.childWillAppear,
        willEnterFunc: this.childWillEnter,
        willLeaveFunc: this.childWillLeave
      }, child);
    }
  }]);

  return VelocityTransitionGroup;
}(React.Component);

VelocityTransitionGroup.disabledForTest = false; // global, mutable, for disabling animations during test

VelocityTransitionGroup.propTypes = {
  runOnMount: PropTypes.bool,
  enter: PropTypes.any,
  leave: PropTypes.any,
  children: PropTypes.any,
  enterHideStyle: PropTypes.object,
  enterShowStyle: PropTypes.object
};

VelocityTransitionGroup.defaultProps = {
  runOnMount: false,
  enter: null,
  leave: null,
  enterHideStyle: {
    display: 'none'
  },
  enterShowStyle: {
    display: ''
  }
};

module.exports = VelocityTransitionGroup;

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(487);


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2080);


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

var assignWith = __webpack_require__(2081),
    baseAssign = __webpack_require__(2082),
    createAssigner = __webpack_require__(2084);

/**
 * Assigns own enumerable properties of source object(s) to the destination
 * object. Subsequent sources overwrite property assignments of previous sources.
 * If `customizer` is provided it's invoked to produce the assigned values.
 * The `customizer` is bound to `thisArg` and invoked with five arguments:
 * (objectValue, sourceValue, key, object, source).
 *
 * **Note:** This method mutates `object` and is based on
 * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
 *
 * @static
 * @memberOf _
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
 * // => { 'user': 'fred', 'age': 40 }
 *
 * // using a customizer callback
 * var defaults = _.partialRight(_.assign, function(value, other) {
 *   return _.isUndefined(value) ? other : value;
 * });
 *
 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
 * // => { 'user': 'barney', 'age': 36 }
 */
var assign = createAssigner(function(object, source, customizer) {
  return customizer
    ? assignWith(object, source, customizer)
    : baseAssign(object, source);
});

module.exports = assign;


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

var keys = __webpack_require__(173);

/**
 * A specialized version of `_.assign` for customizing assigned values without
 * support for argument juggling, multiple sources, and `this` binding `customizer`
 * functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 */
function assignWith(object, source, customizer) {
  var index = -1,
      props = keys(source),
      length = props.length;

  while (++index < length) {
    var key = props[index],
        value = object[key],
        result = customizer(value, source[key], key, object, source);

    if ((result === result ? (result !== value) : (value === value)) ||
        (value === undefined && !(key in object))) {
      object[key] = result;
    }
  }
  return object;
}

module.exports = assignWith;


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

var baseCopy = __webpack_require__(2083),
    keys = __webpack_require__(173);

/**
 * The base implementation of `_.assign` without support for argument juggling,
 * multiple sources, and `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return source == null
    ? object
    : baseCopy(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 2083 */
/***/ (function(module, exports) {

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */
function baseCopy(source, props, object) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    object[key] = source[key];
  }
  return object;
}

module.exports = baseCopy;


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

var bindCallback = __webpack_require__(248),
    isIterateeCall = __webpack_require__(2085),
    restParam = __webpack_require__(771);

/**
 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return restParam(function(object, sources) {
    var index = -1,
        length = object == null ? 0 : sources.length,
        customizer = length > 2 ? sources[length - 2] : undefined,
        guard = length > 2 ? sources[2] : undefined,
        thisArg = length > 1 ? sources[length - 1] : undefined;

    if (typeof customizer == 'function') {
      customizer = bindCallback(customizer, thisArg, 5);
      length -= 2;
    } else {
      customizer = typeof thisArg == 'function' ? thisArg : undefined;
      length -= (customizer ? 1 : 0);
    }
    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(247),
    isIndex = __webpack_require__(489),
    isObject = __webpack_require__(99);

/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
      ? (isArrayLike(object) && isIndex(index, object.length))
      : (type == 'string' && index in object)) {
    var other = object[index];
    return value === value ? (value === other) : (other !== other);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

var map = __webpack_require__(2087),
    property = __webpack_require__(776);

/**
 * Gets the property value of `path` from all elements in `collection`.
 *
 * @static
 * @memberOf _
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Array|string} path The path of the property to pluck.
 * @returns {Array} Returns the property values.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 }
 * ];
 *
 * _.pluck(users, 'user');
 * // => ['barney', 'fred']
 *
 * var userIndex = _.indexBy(users, 'user');
 * _.pluck(userIndex, 'age');
 * // => [36, 40] (iteration order is not guaranteed)
 */
function pluck(collection, path) {
  return map(collection, property(path));
}

module.exports = pluck;


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(770),
    baseCallback = __webpack_require__(2088),
    baseMap = __webpack_require__(2098),
    isArray = __webpack_require__(121);

/**
 * Creates an array of values by running each element in `collection` through
 * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
 * arguments: (value, index|key, collection).
 *
 * If a property name is provided for `iteratee` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `iteratee` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
 * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
 * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
 * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
 * `sum`, `uniq`, and `words`
 *
 * @static
 * @memberOf _
 * @alias collect
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function timesThree(n) {
 *   return n * 3;
 * }
 *
 * _.map([1, 2], timesThree);
 * // => [3, 6]
 *
 * _.map({ 'a': 1, 'b': 2 }, timesThree);
 * // => [3, 6] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // using the `_.property` callback shorthand
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee, thisArg) {
  var func = isArray(collection) ? arrayMap : baseMap;
  iteratee = baseCallback(iteratee, thisArg, 3);
  return func(collection, iteratee);
}

module.exports = map;


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(2089),
    baseMatchesProperty = __webpack_require__(2093),
    bindCallback = __webpack_require__(248),
    identity = __webpack_require__(767),
    property = __webpack_require__(776);

/**
 * The base implementation of `_.callback` which supports specifying the
 * number of arguments to provide to `func`.
 *
 * @private
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */
function baseCallback(func, thisArg, argCount) {
  var type = typeof func;
  if (type == 'function') {
    return thisArg === undefined
      ? func
      : bindCallback(func, thisArg, argCount);
  }
  if (func == null) {
    return identity;
  }
  if (type == 'object') {
    return baseMatches(func);
  }
  return thisArg === undefined
    ? property(func)
    : baseMatchesProperty(func, thisArg);
}

module.exports = baseCallback;


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2090),
    getMatchData = __webpack_require__(2091),
    toObject = __webpack_require__(120);

/**
 * The base implementation of `_.matches` which does not clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    var key = matchData[0][0],
        value = matchData[0][1];

    return function(object) {
      if (object == null) {
        return false;
      }
      return object[key] === value && (value !== undefined || (key in toObject(object)));
    };
  }
  return function(object) {
    return baseIsMatch(object, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(491),
    toObject = __webpack_require__(120);

/**
 * The base implementation of `_.isMatch` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Array} matchData The propery names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparing objects.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = toObject(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(772),
    pairs = __webpack_require__(2092);

/**
 * Gets the propery names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = pairs(object),
      length = result.length;

  while (length--) {
    result[length][2] = isStrictComparable(result[length][1]);
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

var keys = __webpack_require__(173),
    toObject = __webpack_require__(120);

/**
 * Creates a two dimensional array of the key-value pairs for `object`,
 * e.g. `[[key1, value1], [key2, value2]]`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the new array of key-value pairs.
 * @example
 *
 * _.pairs({ 'barney': 36, 'fred': 40 });
 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
 */
function pairs(object) {
  object = toObject(object);

  var index = -1,
      props = keys(object),
      length = props.length,
      result = Array(length);

  while (++index < length) {
    var key = props[index];
    result[index] = [key, object[key]];
  }
  return result;
}

module.exports = pairs;


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(773),
    baseIsEqual = __webpack_require__(491),
    baseSlice = __webpack_require__(2094),
    isArray = __webpack_require__(121),
    isKey = __webpack_require__(774),
    isStrictComparable = __webpack_require__(772),
    last = __webpack_require__(2095),
    toObject = __webpack_require__(120),
    toPath = __webpack_require__(775);

/**
 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to compare.
 * @returns {Function} Returns the new function.
 */
function baseMatchesProperty(path, srcValue) {
  var isArr = isArray(path),
      isCommon = isKey(path) && isStrictComparable(srcValue),
      pathKey = (path + '');

  path = toPath(path);
  return function(object) {
    if (object == null) {
      return false;
    }
    var key = pathKey;
    object = toObject(object);
    if ((isArr || !isCommon) && !(key in object)) {
      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
      if (object == null) {
        return false;
      }
      key = last(path);
      object = toObject(object);
    }
    return object[key] === srcValue
      ? (srcValue !== undefined || (key in object))
      : baseIsEqual(srcValue, object[key], undefined, true);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 2094 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  start = start == null ? 0 : (+start || 0);
  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = (end === undefined || end > length) ? length : (+end || 0);
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 2095 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 2096 */
/***/ (function(module, exports) {

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  return value == null ? '' : (value + '');
}

module.exports = baseToString;


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(773),
    toPath = __webpack_require__(775);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new function.
 */
function basePropertyDeep(path) {
  var pathKey = (path + '');
  path = toPath(path);
  return function(object) {
    return baseGet(object, path, pathKey);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(763),
    isArrayLike = __webpack_require__(247);

/**
 * The base implementation of `_.map` without support for callback shorthands
 * and `this` binding.
 *
 * @private
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(2100);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(141);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(2101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2100 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Copyright (c) 2015 Twitter, Inc. and other contributors

var _ = {
  isObject: __webpack_require__(99)
};
var Velocity = __webpack_require__(492);

var effectCounter = 0;

// Takes a Velocity "UI pack effect" definition and registers it with a unique key, returning that
// key (to later pass as a value for the "animation" property). Takes an optional suffix, which can
// be "In" or "Out" to modify UI Pack's behavior.
//
// Unlike what you get from passing a style hash to VelocityComponent's "animation" property,
// Velocity "UI pack effects" can have chained animation calls and specify a "defaultDuration", and
// also can take advantage of "stagger" and "reverse" options on the VelocityComponent.
//
// You will need to manually register the UI Pack with the global Velocity in your application with:
//
//   require('velocity');
//   require('velocity-animate/velocity.ui');
//
// See: http://julian.com/research/velocity/#uiPack
//
// Typical usage:
//
// var Animations = {
//   down: VelocityHelpers.registerEffect({
//     defaultDuration: 1100,
//     calls: [
//       [{
//         transformOriginX: [ '50%', '50%' ],
//         transformOriginY: [ 0, 0 ],
//         rotateX: [0, 'spring'],
//       }, 1, {
//         delay: 100,
//         easing: 'ease-in',
//       }]
//     ],
//   }),
//
//   up: VelocityHelpers.registerEffect({
//     defaultDuration: 200,
//     calls: [
//       [{
//         transformOriginX: [ '50%', '50%' ],
//         transformOriginY: [ 0, 0 ],
//         rotateX: 160,
//       }]
//     ],
//   }),
// };
// ...
// <VelocityComponent animation={this.state.isUp ? Animations.up : Animations.down}>
//   ...
// <Velocity>
function registerEffect(suffix, animation) {
  if (_.isObject(suffix)) {
    animation = suffix;
    suffix = '';
  }

  var key = 'VelocityHelper.animation.' + effectCounter++ + suffix;

  // No-op on the server for now.
  if (Velocity.velocityReactServerShim) {
    return key;
  }

  if (Velocity.RegisterEffect === undefined) {
    throw "Velocity.RegisterEffect not found. You need to require 'velocity-animate/velocity.ui' at a top level for UI Pack.";
  }

  Velocity.RegisterEffect(key, animation);
  return key;
}

module.exports = {
  registerEffect: registerEffect
};

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_component__ = __webpack_require__(2104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__checkbox_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule__ = __webpack_require__(2106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__schedule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__select_component__ = __webpack_require__(2109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__select_component__["a"]; });


/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2105);
var ActionCheckbox=function ActionCheckbox(_ref){var currentValue=_ref.currentValue,handleChange=_ref.handleChange,label=_ref.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Base */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* ToggleContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["_14" /* ToggleButton */],{isOn:currentValue,onChange:function onChange(){return handleChange(!currentValue);}})));};/* harmony default export */ __webpack_exports__["a"] = (ActionCheckbox);

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ToggleContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    width: 100%;\n'],['\n    display: flex;\n    width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['flex: 1 0 auto;'],['flex: 1 0 auto;']),_templateObject3=_taggedTemplateLiteral(['\n    flex: 0 0 2em;\n    font-size: 0.7em;\n'],['\n    flex: 0 0 2em;\n    font-size: 0.7em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Base=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var Label=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);var ToggleContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3);

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_schedule__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_ui_schedule_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__(2107);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var mapStateToProps=function mapStateToProps(state,_ref){var actionId=_ref.actionId;// $FlowFixMe, can't understand why the complaining, I guess because schedule section is not properly typed so one for later
var schedule=Object(__WEBPACK_IMPORTED_MODULE_3__core_state_ui_schedule_selectors__["j" /* getScheduleData */])(state,{componentId:Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_schedule__["c" /* createComponentId */])('action',actionId)});var defaultSchedule=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'actions:defaultSchedule');return{defaultSchedule:defaultSchedule,schedule:schedule,scheduleComponentId:__WEBPACK_IMPORTED_MODULE_1__core_utils_schedule__["a" /* actionFormComponentId */]};};var mapDispatchToProps={setupActionFormSchedule:__WEBPACK_IMPORTED_MODULE_4__core_state_ui_schedule_actions__["o" /* setupActionFormSchedule */]};var mergeProps=function mergeProps(_ref2,dispatchProps,ownProps){var defaultSchedule=_ref2.defaultSchedule,schedule=_ref2.schedule,restStateProps=_objectWithoutProperties(_ref2,['defaultSchedule','schedule']);var setupActionFormSchedule=dispatchProps.setupActionFormSchedule;return Object.assign({},ownProps,restStateProps,{setNewSchedule:function setNewSchedule(){return setupActionFormSchedule({defaultSchedule:defaultSchedule,schedule:schedule});}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));

/***/ }),
/* 2107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2108);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActionSchedule=function(_Component){_inherits(ActionSchedule,_Component);function ActionSchedule(){_classCallCheck(this,ActionSchedule);return _possibleConstructorReturn(this,(ActionSchedule.__proto__||Object.getPrototypeOf(ActionSchedule)).apply(this,arguments));}_createClass(ActionSchedule,[{key:'componentWillMount',value:function componentWillMount(){var setNewSchedule=this.props.setNewSchedule;setNewSchedule();}},{key:'render',value:function render(){var scheduleComponentId=this.props.scheduleComponentId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Base */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["_0" /* Schedule */],{componentId:scheduleComponentId}));}}]);return ActionSchedule;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ActionSchedule);

/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 0;\n    width: 100%;\n'],['\n    position: absolute;\n    top: 0;\n    width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Base=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2110);
var Select=function Select(_ref){var currentValue=_ref.currentValue,handleChange=_ref.handleChange,label=_ref.label,options=_ref.options;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* Base */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],label),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* DropdownContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["t" /* Dropdown */],{currentValue:currentValue!==undefined?options.findIndex(function(o){return o.value===currentValue;}):0,handleChange:function(_handleChange){function handleChange(_x){return _handleChange.apply(this,arguments);}handleChange.toString=function(){return _handleChange.toString();};return handleChange;}(function(index){return handleChange(options[index].value);}),options:options.map(function(o){return o.label;})})));};/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 2110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DropdownContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['width: 100%;'],['width: 100%;']),_templateObject2=_taggedTemplateLiteral(['\n    color: ',';\n    font-size: 0.8em;\n'],['\n    color: ',';\n    font-size: 0.8em;\n']),_templateObject3=_taggedTemplateLiteral(['font-size: 0.8em;'],['font-size: 0.8em;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Base=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var Label=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(p){return p.theme.secondaryBase;});var DropdownContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3);

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({defaultChooseLabel:{id:'actions.defaultChooseLabel',defaultMessage:'Choose...'},removeFromAction:{id:'actions.removeFromAction',defaultMessage:'Remove from action'}}));

/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Main; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AttributeIconContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AttributeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MoreIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TickIcon; });
/* unused harmony export Done */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TextSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Detail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DetailItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RemoveAttribute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_velocity_react__);
var _templateObject=_taggedTemplateLiteral(['\n    border: solid 1px ',';\n    border-radius: ','em;\n    display: flex;\n    flex-direction: column;\n    height: ','em;\n    margin-bottom: 1em;\n    max-width: 30em;\n    overflow: hidden;\n    position: relative;\n    transition: height 0.3s ',';\n'],['\n    border: solid 1px ',';\n    border-radius: ','em;\n    display: flex;\n    flex-direction: column;\n    height: ','em;\n    margin-bottom: 1em;\n    max-width: 30em;\n    overflow: hidden;\n    position: relative;\n    transition: height 0.3s ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    border-bottom: solid 1px ',';\n    cursor: ',';\n    display: flex;\n    height: ','em;\n    padding: 0 ','em;\n    position: absolute;\n    width: 100%;\n'],['\n    align-items: center;\n    border-bottom: solid 1px ',';\n    cursor: ',';\n    display: flex;\n    height: ','em;\n    padding: 0 ','em;\n    position: absolute;\n    width: 100%;\n']),_templateObject3=_taggedTemplateLiteral(['flex: 0 0 3em;'],['flex: 0 0 3em;']),_templateObject4=_taggedTemplateLiteral(['\n    height: 2.2em;\n    width: 2.2em;\n\n    & > g {\n        fill: ',';\n    }\n'],['\n    height: 2.2em;\n    width: 2.2em;\n\n    & > g {\n        fill: ',';\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 0 0 3em;\n    height: 3em;\n    justify-content: flex-end;\n    overflow: hidden;\n    position: relative;\n    will-change: transform, opacity;\n'],['\n    align-items: center;\n    display: flex;\n    flex: 0 0 3em;\n    height: 3em;\n    justify-content: flex-end;\n    overflow: hidden;\n    position: relative;\n    will-change: transform, opacity;\n']),_templateObject6=_taggedTemplateLiteral(['\n    height: 3em;\n    position: absolute;\n    right: 0;\n    width: 2.2em;\n\n    & > g {\n        fill: ',';\n    }\n'],['\n    height: 3em;\n    position: absolute;\n    right: 0;\n    width: 2.2em;\n\n    & > g {\n        fill: ',';\n    }\n']),_templateObject7=_taggedTemplateLiteral(['\n    color: ',';\n    cursor: pointer;\n    line-height: 3em;\n    position: absolute;\n    right: 0;\n'],['\n    color: ',';\n    cursor: pointer;\n    line-height: 3em;\n    position: absolute;\n    right: 0;\n']),_templateObject8=_taggedTemplateLiteral(['flex: 1 0 auto;'],['flex: 1 0 auto;']),_templateObject9=_taggedTemplateLiteral(['font-size: 1.2em;'],['font-size: 1.2em;']),_templateObject10=_taggedTemplateLiteral(['color: ',';'],['color: ',';']),_templateObject11=_taggedTemplateLiteral(['\n    position: absolute;\n    top: ','em;\n    width: 100%;\n'],['\n    position: absolute;\n    top: ','em;\n    width: 100%;\n']),_templateObject12=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    height: ','em;\n    padding: 0 ','em;\n    width: 100%;\n'],['\n    align-items: center;\n    display: flex;\n    height: ','em;\n    padding: 0 ','em;\n    width: 100%;\n']),_templateObject13=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    border-top: solid 1px ',';\n    color: ',';\n    cursor: pointer;\n    display: flex;\n    height: ','em;\n    justify-content: center;\n    width: 100%;\n'],['\n    align-items: center;\n    background-color: ',';\n    border-top: solid 1px ',';\n    color: ',';\n    cursor: pointer;\n    display: flex;\n    height: ','em;\n    justify-content: center;\n    width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var minifiedHeight=4;var detailItemHeight=4.5;var scheduleHeight=38;var heightRemove=2.2;var borderRadius=1;var easeOutQuint='cubic-bezier(0.23, 1, 0.32, 1)';var Main=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(p){return p.theme.secondaryMedium;},borderRadius,function(p){return p.isDetailVisible?minifiedHeight+(p.isSchedule?scheduleHeight:p.detailsLength*detailItemHeight)+(p.removable?heightRemove:borderRadius):minifiedHeight;},easeOutQuint);var Header=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(p){return p.theme.secondaryLight;},function(p){return p.clickable?'pointer':'inherit';},minifiedHeight,borderRadius);var AttributeIconContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3);var AttributeIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject4,function(p){return p.quickAction?p.theme.black:p.theme.mainBrandColor;});var ActionContainer=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_velocity_react__["VelocityTransitionGroup"]).attrs({component:'div'})(_templateObject5);var MoreIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject6,function(p){return p.theme.secondaryHeavy;});var TickIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject6,function(p){return p.theme.mainBrandColor;});var Done=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject7,function(p){return p.theme.mainBrandColor;});var TextSection=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject8);var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject9);var Description=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject10,function(p){return p.theme.secondaryBase;});var Detail=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject11,minifiedHeight);var DetailItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject12,function(p){return p.isSchedule?scheduleHeight:detailItemHeight;},borderRadius);var RemoveAttribute=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject13,function(p){return p.theme.secondaryLight;},function(p){return p.theme.secondaryMedium;},function(p){return p.theme.mainBrandColor;},heightRemove);

/***/ }),
/* 2113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_actions_actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_actions_selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component__ = __webpack_require__(2114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(348);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var FILTER='filter';var ACTION_ID='actionId';function getQueryStringValue(props,key){var search=props.location.search;var queryString=new URLSearchParams(search);var filterValue=queryString.get(key);return filterValue;}var mapStateToProps=function mapStateToProps(state,ownProps){var tagDeviceType=ownProps.tagDeviceType;var queryStringFilter=getQueryStringValue(ownProps,FILTER);var currentQueryStringTab=getQueryStringValue(ownProps,__WEBPACK_IMPORTED_MODULE_6__constants__["c" /* TAB_KEY */]);var actionId=getQueryStringValue(ownProps,ACTION_ID);var actionIdExists=!!Object(__WEBPACK_IMPORTED_MODULE_3__core_state_actions_selectors__["c" /* getAction */])(state,{actionId:actionId});var savingState=Object(__WEBPACK_IMPORTED_MODULE_3__core_state_actions_selectors__["a" /* currentSavingState */])(state);return{currentQueryStringTab:currentQueryStringTab,formAction:actionIdExists&&Object(__WEBPACK_IMPORTED_MODULE_3__core_state_actions_selectors__["k" /* initialiseFormFromAction */])(state,{actionId:actionId}),savingState:savingState,tagDeviceType:tagDeviceType||queryStringFilter};};var mapDispatchToProps={getActions:__WEBPACK_IMPORTED_MODULE_2__core_state_actions_actions__["i" /* getActions */],getTemplates:__WEBPACK_IMPORTED_MODULE_2__core_state_actions_actions__["j" /* getTemplates */],loadForm:__WEBPACK_IMPORTED_MODULE_2__core_state_actions_actions__["k" /* loadForm */]};var mergeProps=function mergeProps(_ref,dispatchProps,ownProps){var schedule=_ref.schedule,restStateProps=_objectWithoutProperties(_ref,['schedule']);var formAction=restStateProps.formAction;var loadForm=dispatchProps.loadForm,restDispatchProps=_objectWithoutProperties(dispatchProps,['loadForm']);return Object.assign({},restStateProps,restDispatchProps,ownProps,{loadActionIdForm:formAction?function(){return loadForm(formAction);}:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default.a});};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_4__component__["a" /* default */])));

/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_isEqual__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__querystring_tab_manager__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tabs_content__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__discover_actions__ = __webpack_require__(2145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__my_actions__ = __webpack_require__(2154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__action_canvas__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__intl__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_router_dom__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__core_constants_routes__ = __webpack_require__(124);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ActionEntry=function(_Component){_inherits(ActionEntry,_Component);function ActionEntry(props){_classCallCheck(this,ActionEntry);var _this=_possibleConstructorReturn(this,(ActionEntry.__proto__||Object.getPrototypeOf(ActionEntry)).call(this,props));_this.state={currentFilter:{name:__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* filtersType */].SHOW_ALL},redirectToDashboard:false,redirectToMyActions:false,removeAction:null,selectedTemplate:undefined};_this.changeFilter=function(newFilter){if(!__WEBPACK_IMPORTED_MODULE_1_lodash_fp_isEqual___default()(_this.state.currentFilter,newFilter)){_this.setState({currentFilter:newFilter});}_this.selectTemplate();};_this.selectTemplate=function(template){return _this.setState({selectedTemplate:template});};_this.showConfirmModal=function(actionId,name){var deprecated=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return _this.setState({removeAction:{id:actionId,name:name,deprecated:deprecated}});};_this.hideConfirmModal=function(){return _this.setState({removeAction:null});};var tagDeviceType=props.tagDeviceType;if(tagDeviceType){_this.state=Object.assign({},_this.state,{currentFilter:{name:__WEBPACK_IMPORTED_MODULE_9__constants__["a" /* filtersType */].BY_DEVICE,selectedItem:tagDeviceType}});}return _this;}_createClass(ActionEntry,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,getActions=_props.getActions,getTemplates=_props.getTemplates,loadActionIdForm=_props.loadActionIdForm;getActions();getTemplates();loadActionIdForm();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.savingState==='saving'&&nextProps.savingState==='done'){if(this.props.tagDeviceType==='quick-action'){this.setState({redirectToDashboard:true,selectedTemplate:undefined});return;}if(this.props.currentQueryStringTab===__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* TAB_DISCOVER */]){this.setState({redirectToMyActions:true,selectedTemplate:undefined});return;}}if(this.props.savingState==='done'&&nextProps.currentQueryStringTab===__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* TAB_DISCOVER */]){this.setState({redirectToMyActions:false});}}},{key:'render',value:function render(){var _props2=this.props,productId=_props2.productId,showFilter=_props2.showFilter;var _state=this.state,currentFilter=_state.currentFilter,redirectToDashboard=_state.redirectToDashboard,redirectToMyActions=_state.redirectToMyActions,removeAction=_state.removeAction,selectedTemplate=_state.selectedTemplate;return[__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__querystring_tab_manager__["a" /* default */],{key:'actions-tabs',tabGroup:__WEBPACK_IMPORTED_MODULE_7__constants__["c" /* TAB_KEY */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["_5" /* Tabs */],{maxWidth:true},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["_5" /* Tabs */].Item,{icon:__WEBPACK_IMPORTED_MODULE_6__core_constants_icons_general_svg__["a" /* default */].ACTIONS,name:__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* TAB_ACTIONS */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__intl__["a" /* default */].myActions)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["_5" /* Tabs */].Item,{icon:__WEBPACK_IMPORTED_MODULE_6__core_constants_icons_general_svg__["a" /* default */].DISCOVER,name:__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* TAB_DISCOVER */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_13__intl__["a" /* default */].discoverActions)))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["_3" /* StandardLayout */],{key:'actions-constant'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__tabs_content__["a" /* default */],{tabGroup:__WEBPACK_IMPORTED_MODULE_7__constants__["c" /* TAB_KEY */]},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__tabs_content__["a" /* default */].Screen,{component:__WEBPACK_IMPORTED_MODULE_11__my_actions__["a" /* default */],name:__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* TAB_ACTIONS */],productId:productId,removeAction:this.showConfirmModal}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__tabs_content__["a" /* default */].Screen,{changeFilter:this.changeFilter,component:__WEBPACK_IMPORTED_MODULE_10__discover_actions__["a" /* default */],currentFilter:currentFilter,name:__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* TAB_DISCOVER */],selectedTemplate:selectedTemplate,selectTemplate:this.selectTemplate,showFilter:showFilter}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__action_canvas__["a" /* default */],{key:'action-canvas',parentRemoveActionState:removeAction,parentResetActionState:this.hideConfirmModal}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{key:'redirect'},redirectToDashboard&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["c" /* Redirect */],{to:__WEBPACK_IMPORTED_MODULE_15__core_constants_routes__["dashboard"]}),redirectToMyActions&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_router_dom__["c" /* Redirect */],{to:{search:'?'+__WEBPACK_IMPORTED_MODULE_7__constants__["c" /* TAB_KEY */]+'='+__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* TAB_ACTIONS */]}}))];}}]);return ActionEntry;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ActionEntry);

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__ = __webpack_require__(2118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(100);
var invariant = __webpack_require__(86);
var ReactPropTypesSecret = __webpack_require__(2117);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(141);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(493);

var _PathUtils = __webpack_require__(250);

var _createTransitionManager = __webpack_require__(494);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(777);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsolute = function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
};

// About 1.5x faster than the two-arg version of Array#splice()
var spliceOne = function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }list.pop();
};

// This implementation is based heavily on node's url.parse
var resolvePathname = function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
};

module.exports = resolvePathname;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var valueEqual = function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
    return valueEqual(item, b[index]);
  });

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
};

exports.default = valueEqual;

/***/ }),
/* 2121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__ = __webpack_require__(2124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Router__ = __webpack_require__(495);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(100);
var invariant = __webpack_require__(86);
var ReactPropTypesSecret = __webpack_require__(2123);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(141);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(250);

var _LocationUtils = __webpack_require__(493);

var _createTransitionManager = __webpack_require__(494);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 2125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 2126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for updating the location programatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(2128)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 2128 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 2129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(495);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 2130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(496);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 2131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(778);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 2132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__ = __webpack_require__(2133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(44);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(141);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(493);

var _PathUtils = __webpack_require__(250);

var _createTransitionManager = __webpack_require__(494);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(777);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 2134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* unused harmony reexport default */


/***/ }),
/* 2135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(779);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [activeClassName, className].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

NavLink.defaultProps = {
  activeClassName: 'active'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 2136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* unused harmony reexport default */


/***/ }),
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"]; });


/***/ }),
/* 2138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"]; });


/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* unused harmony reexport default */


/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* unused harmony reexport default */


/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Switch"]; });


/***/ }),
/* 2142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* unused harmony reexport default */


/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(44);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"]; });


/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TabContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return List; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Item; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TabIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    background-color: transparent;\n    outline: none;\n    width: 100%;\n    -webkit-tap-highlight-color: transparent;\n'],['\n    background-color: transparent;\n    outline: none;\n    width: 100%;\n    -webkit-tap-highlight-color: transparent;\n']),_templateObject2=_taggedTemplateLiteral(['\n    border-bottom: solid ',' ',';\n    margin: 1em 0;\n    transition: border-color 0.1s ease-out;\n\n    ',':focus & {\n        border-bottom-color: ',';\n    }\n'],['\n    border-bottom: solid ',' ',';\n    margin: 1em 0;\n    transition: border-color 0.1s ease-out;\n\n    ',':focus & {\n        border-bottom-color: ',';\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    display: flex;\n    margin: 0 auto;\n    padding: 0 1em;\n    position: relative;\n    max-width: ',';\n'],['\n    display: flex;\n    margin: 0 auto;\n    padding: 0 1em;\n    position: relative;\n    max-width: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    background-color: ',';\n    border: solid ',' ',';\n    border-bottom-color: ',';\n    border-radius: 1em 1em 0 0;\n    cursor: ',';\n    display: flex;\n    flex: 0 1 10em;\n    height: 3em;\n    justify-content: center;\n    margin: 0 0.3em;\n    position: relative;\n    top: ',';\n    transition: background-color 0.1s ease-out, border-color 0.1s ease-out;\n\n    &:hover {\n        background-color: ',';\n    }\n    ',':focus & {\n        border-color: ',';\n        border-bottom-color: ',';\n    }\n\n    a,\n    div {\n        display: flex;\n        flex-direction: column;\n        text-align: center;\n        align-items: center;\n        justify-content: center;\n        color: ',';\n        text-decoration: none;\n    }\n\n    a {\n        width: 100%;\n        height: 100%;\n    }\n'],['\n    background-color: ',';\n    border: solid ',' ',';\n    border-bottom-color: ',';\n    border-radius: 1em 1em 0 0;\n    cursor: ',';\n    display: flex;\n    flex: 0 1 10em;\n    height: 3em;\n    justify-content: center;\n    margin: 0 0.3em;\n    position: relative;\n    top: ',';\n    transition: background-color 0.1s ease-out, border-color 0.1s ease-out;\n\n    &:hover {\n        background-color: ',';\n    }\n    ',':focus & {\n        border-color: ',';\n        border-bottom-color: ',';\n    }\n\n    a,\n    div {\n        display: flex;\n        flex-direction: column;\n        text-align: center;\n        align-items: center;\n        justify-content: center;\n        color: ',';\n        text-decoration: none;\n    }\n\n    a {\n        width: 100%;\n        height: 100%;\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    height: 1.3em;\n    margin-bottom: 0.1em;\n    transition: fill 0.1s ease-out;\n    width: 1.3em;\n\n    & > g {\n        fill: ',';\n    }\n'],['\n    height: 1.3em;\n    margin-bottom: 0.1em;\n    transition: fill 0.1s ease-out;\n    width: 1.3em;\n\n    & > g {\n        fill: ',';\n    }\n']),_templateObject6=_taggedTemplateLiteral(['\n    font-size: 0.9em;\n    user-select: none;\n'],['\n    font-size: 0.9em;\n    user-select: none;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var STROKE='1px';var Base=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var TabContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,STROKE,function(p){return p.theme.secondaryMedium;},Base,function(p){return p.theme.secondaryHeavy;});var List=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ul(_templateObject3,function(p){return p.maxWidth?p.theme.layoutMaxWidth:'100%';});var Item=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].li(_templateObject4,function(p){return p.theme.white;},STROKE,function(p){return p.theme.secondaryMedium;},function(p){return p.selected?p.theme.white:p.theme.secondaryMedium;},function(p){return p.selected?'inherit':'pointer';},STROKE,function(p){return p.selected?p.theme.white:p.theme.lightGrey;},Base,function(p){return p.theme.secondaryHeavy;},function(p){return p.selected?p.theme.white:p.theme.secondaryHeavy;},function(p){return p.selected?'inherit':p.theme.heavyGrey;});var TabIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject5,function(p){return p.selected?p.theme.mainBrandColor:p.theme.fontColor;});var Label=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject6);

/***/ }),
/* 2145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_intersection__ = __webpack_require__(2146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_intersection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_actions_selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_state_devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__(2150);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var tagsToCheck=function tagsToCheck(currentFilter,region,productTypesUserOwns){var filterByDevices=Object(__WEBPACK_IMPORTED_MODULE_3__core_constants_actions__["e" /* getFilterDevicesList */])(region,productTypesUserOwns);var findSelectedItem=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_find___default()(function(c){return!!currentFilter.selectedItem&&c.id===currentFilter.selectedItem;});var map={BUILD_YOUR_OWN:function BUILD_YOUR_OWN(){return['canvas'];},BY_CATEGORY:function BY_CATEGORY(){var category=findSelectedItem(__WEBPACK_IMPORTED_MODULE_3__core_constants_actions__["c" /* categories */]);return category&&category.tagsAssociated;},BY_DEVICE:function BY_DEVICE(){var filterByDevice=findSelectedItem(filterByDevices);return filterByDevice&&filterByDevice.tagsAssociated;},SHOW_ALL:function SHOW_ALL(){},WELCOME_HOME:function WELCOME_HOME(){return['WelcomeHomeUK','WelcomeHomeUS'];}};return map[currentFilter.name]();};var mapStateToProps=function mapStateToProps(state,_ref){var currentFilter=_ref.currentFilter;var region=Object(__WEBPACK_IMPORTED_MODULE_8__core_state_config_selectors__["d" /* getIconLocaleSuffix */])(state);var list=Object(__WEBPACK_IMPORTED_MODULE_5__core_state_actions_selectors__["i" /* getNormalisedTemplates */])(state);var productTypesUserOwns=Object(__WEBPACK_IMPORTED_MODULE_6__core_state_products_selectors__["B" /* getProductTypesUserOwns */])(state);var tags=tagsToCheck(currentFilter,region,productTypesUserOwns);var hasSLT1=Object(__WEBPACK_IMPORTED_MODULE_7__core_state_devices_selectors__["_2" /* hasSLT1Thermostat */])(state);var templates=list.reduce(function(acc,template){if(tags&&__WEBPACK_IMPORTED_MODULE_1_lodash_fp_intersection___default()(template.tags,tags).length===0||hasSLT1&&template.incompatible.includes(__WEBPACK_IMPORTED_MODULE_4__core_constants_devices__["deviceModels"].SLT1)){return acc;}var groupIcons=['when','while','then'].reduce(function(groups,group){return Object.assign({},groups,_defineProperty({},group,template[group].reduce(function(acc,templateEvent){var definition=Object.assign({required:templateEvent.required},Object(__WEBPACK_IMPORTED_MODULE_3__core_constants_actions__["d" /* getAttributeDefinition */])(templateEvent.type,region));return definition?[].concat(_toConsumableArray(acc),[definition]):acc;},[])));},{});return[].concat(_toConsumableArray(acc),[Object.assign({description:template.description,id:template.id,name:template.name,incompatible:template.incompatible},groupIcons)]);},[]);return{productTypesUserOwns:productTypesUserOwns,region:region,templates:templates};};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* default */]));

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('intersection', __webpack_require__(2147));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82),
    baseIntersection = __webpack_require__(2148),
    baseRest = __webpack_require__(183),
    castArrayLikeObject = __webpack_require__(2149);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(290),
    arrayIncludes = __webpack_require__(279),
    arrayIncludesWith = __webpack_require__(443),
    arrayMap = __webpack_require__(82),
    baseUnary = __webpack_require__(228),
    cacheHas = __webpack_require__(291);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(307);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 2150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filter_title__ = __webpack_require__(2152);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var changeFilter=_ref.changeFilter,currentFilter=_ref.currentFilter,productTypesUserOwns=_ref.productTypesUserOwns,_ref$showFilter=_ref.showFilter,showFilter=_ref$showFilter===undefined?true:_ref$showFilter,region=_ref.region,templates=_ref.templates,selectedTemplate=_ref.selectedTemplate,selectTemplate=_ref.selectTemplate;var AnchorOrDiv=showFilter?'a':'div';return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* DiscoveryActions */],null,showFilter&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* FirstColumn */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["b" /* ActionFilter */],{changeFilter:changeFilter,currentFilter:currentFilter,productTypesUserOwns:productTypesUserOwns,region:region})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* SecondColumn */],{showFilter:showFilter},selectedTemplate?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["e" /* ActionTemplateDescription */],{close:function close(){return selectTemplate();},template:selectedTemplate}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* FilterStatus */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__filter_title__["a" /* default */],{currentFilter:currentFilter,productTypesUserOwns:productTypesUserOwns,region:region})),templates.map(function(template){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AnchorOrDiv,{href:'#main',key:template.id,onClick:function onClick(){return selectTemplate(template);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["d" /* ActionTemplate */],template));}))));});

/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiscoveryActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FirstColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SecondColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FilterStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_style__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    margin-top: 1em;\n\n    ',';\n'],['\n    display: flex;\n    flex-direction: column;\n    margin-top: 1em;\n\n    ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n\t\tflex-direction: row;\n\t'],['\n\t\tflex-direction: row;\n\t']),_templateObject3=_taggedTemplateLiteral(['\n    border-bottom: solid 1px ',';\n    display: flex;\n    flex: 0 0 35%;\n    justify-content: center;\n    margin-bottom: 1em;\n    padding-bottom: 1em;\n\n    ',';\n'],['\n    border-bottom: solid 1px ',';\n    display: flex;\n    flex: 0 0 35%;\n    justify-content: center;\n    margin-bottom: 1em;\n    padding-bottom: 1em;\n\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['border-bottom: none'],['border-bottom: none']),_templateObject5=_taggedTemplateLiteral(['\n    flex: 1 0 65%;\n    margin-left: 0;\n\n    ',';\n'],['\n    flex: 1 0 65%;\n    margin-left: 0;\n\n    ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n        ','\n\t'],['\n        ','\n\t']),_templateObject7=_taggedTemplateLiteral(['\n                border-left: solid 1px ',';\n                margin-left: 1em;\n                padding-left: 1em;\n            '],['\n                border-left: solid 1px ',';\n                margin-left: 1em;\n                padding-left: 1em;\n            ']),_templateObject8=_taggedTemplateLiteral(['\n    align-items: flex-start;\n    display: flex;\n    height: 2em;\n    justify-content: center;\n'],['\n    align-items: flex-start;\n    display: flex;\n    height: 2em;\n    justify-content: center;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DiscoveryActions=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].desktop(_templateObject2));var FirstColumn=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(p){return p.theme.secondaryMedium;},__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].desktop(_templateObject4));var SecondColumn=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].desktop(_templateObject6,function(p){return p.showFilter&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject7,function(p){return p.theme.secondaryMedium;});}));var FilterStatus=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject8);

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_find__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_actions_intl__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_actions__ = __webpack_require__(75);
var BUILD_YOUR_OWN='BUILD_YOUR_OWN';var BY_DEVICE='BY_DEVICE';var SHOW_ALL='SHOW_ALL';var WELCOME_HOME='WELCOME_HOME';var FilterTitle=function FilterTitle(_ref){var currentFilter=_ref.currentFilter,productTypesUserOwns=_ref.productTypesUserOwns,region=_ref.region;if(currentFilter.name===SHOW_ALL){return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].titleChooseAction);}if(currentFilter.name===BUILD_YOUR_OWN){return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].buildYourOwnActions);}if(currentFilter.name!==WELCOME_HOME){var filterItems=currentFilter.name===BY_DEVICE?Object(__WEBPACK_IMPORTED_MODULE_6__core_constants_actions__["e" /* getFilterDevicesList */])(region,productTypesUserOwns):__WEBPACK_IMPORTED_MODULE_6__core_constants_actions__["c" /* categories */];var findFilterItem=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_find___default()(function(x){return x.id===currentFilter.selectedItem;});var filteredItem=findFilterItem(filterItems);var filterItemId=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default()(['id'],filteredItem);var edgeCaseItems=new Map([[filterItemId==='motion-sensor',__WEBPACK_IMPORTED_MODULE_4__core_constants_actions_intl__["a" /* default */].motionAttribute],[filterItemId==='contact-sensor',__WEBPACK_IMPORTED_MODULE_4__core_constants_actions_intl__["a" /* default */].winDoorAttribute]]).get(true);var filterItemMessage=edgeCaseItems||__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default()(['text'],filteredItem);return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],filterItemMessage,function(filterName){return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].titleSpecificTemplates,{values:{selected:filterName}}));});}};/* harmony default export */ __webpack_exports__["a"] = (FilterTitle);

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({titleChooseAction:{id:'discover-actions.title-choose-action',defaultMessage:'Showing all action templates'},titleSpecificTemplates:{id:'discover-actions.title-specific-templates',defaultMessage:'Showing {selected} templates'},buildYourOwnActions:{id:'discover-actions.build-your-own-actions',defaultMessage:'Build your own actions'},all:{id:'discover-actions-title.all',defaultMessage:'all'}}));

/***/ }),
/* 2154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_actions_selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2155);
var mapStateToProps=function mapStateToProps(state,_ref){var productId=_ref.productId;var list=productId?Object(__WEBPACK_IMPORTED_MODULE_1__core_state_actions_selectors__["g" /* getActionsListOfProductId */])(state,{id:productId}):Object(__WEBPACK_IMPORTED_MODULE_1__core_state_actions_selectors__["j" /* getOrderedActionsList */])(state);var isLoading=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_actions_selectors__["h" /* getIsLoadingActionsList */])(state);return{actions:list,isLoading:isLoading};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action__ = __webpack_require__(2156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(2160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__discover_splash__ = __webpack_require__(2161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__indicators_loading__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(348);
var MyActions=function MyActions(_ref){var actions=_ref.actions,isLoading=_ref.isLoading,productId=_ref.productId,removeAction=_ref.removeAction;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__indicators_loading__["a" /* default */],{isLoading:isLoading},actions.length===0&&!productId?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__discover_splash__["a" /* default */],null):[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* CreateAction */],{key:'create-action',to:{search:'?'+__WEBPACK_IMPORTED_MODULE_9__constants__["c" /* TAB_KEY */]+'='+__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* TAB_DISCOVER */]}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["d" /* PlusContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__core_icons_svg_icons__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].PLUS})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].createAction)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["b" /* NumberActions */],{key:'number-actions'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].numberAction,{values:{amount:actions.length}})),' ',__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__styles__["c" /* NumberText */],null,actions.length)),actions.map(function(action){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__action__["a" /* default */],{action:action,key:action.id,removeAction:function(_removeAction){function removeAction(){return _removeAction.apply(this,arguments);}removeAction.toString=function(){return _removeAction.toString();};return removeAction;}(function(){var deprecated=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return removeAction(action.id,action.name,deprecated);})});})]));};/* harmony default export */ __webpack_exports__["a"] = (MyActions);

/***/ }),
/* 2156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_actions_actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_actions_selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__(2157);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapStateToProps=function mapStateToProps(state,_ref){var action=_ref.action;var actionsBeingDeleted=Object(__WEBPACK_IMPORTED_MODULE_5__core_state_actions_selectors__["e" /* getActionsBeingDeleted */])(state);var region=Object(__WEBPACK_IMPORTED_MODULE_4__core_state_config_selectors__["d" /* getIconLocaleSuffix */])(state);var actionId=action.id;var formAction=Object(__WEBPACK_IMPORTED_MODULE_5__core_state_actions_selectors__["k" /* initialiseFormFromAction */])(state,{actionId:actionId});if(!formAction){return{formAction:formAction};}var attributes=['when','while','then'].reduce(function(acc,group){return Object.assign({},acc,_defineProperty({},group,formAction[group].reduce(function(groupAttributes,event){var attr=Object(__WEBPACK_IMPORTED_MODULE_2__core_constants_actions__["d" /* getAttributeDefinition */])(event.type,region);return attr.type?[].concat(_toConsumableArray(groupAttributes),[Object.assign({},attr,{type:event.type})]):groupAttributes;},[])));},{});var thenTypes=attributes.then.reduce(function(acc,_ref2){var type=_ref2.type;return type&&acc.includes(type)?acc:[].concat(_toConsumableArray(acc),[type]);},[]);return{actionBeingDeleted:actionsBeingDeleted.includes(actionId),formAction:formAction,icons:Object.assign({when:attributes.when.length?attributes.when[0].icon:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__["a" /* default */].QUESTION},attributes.while.length?{while:attributes.while[0].icon}:{},attributes.then.length?{then:{type:thenTypes.length>1?__WEBPACK_IMPORTED_MODULE_2__core_constants_actions__["b" /* actionTypes */].MIXED:attributes.then[0].icon,count:attributes.then.length}}:{})};};var mapDispatchToProps={loadForm:__WEBPACK_IMPORTED_MODULE_3__core_state_actions_actions__["k" /* loadForm */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var formAction=stateProps.formAction,restStateProps=_objectWithoutProperties(stateProps,['formAction']);var loadForm=dispatchProps.loadForm;var removeAction=ownProps.removeAction;return Object.assign({},restStateProps,ownProps,{chooseAction:function chooseAction(){return formAction&&formAction.template.id===__WEBPACK_IMPORTED_MODULE_2__core_constants_actions__["a" /* DEFAULT_TEMPLATE */]?removeAction(true):loadForm(formAction);}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_summary_component__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(2159);
// $FlowFixMe
var ActionComponent=function ActionComponent(_ref){var action=_ref.action,actionBeingDeleted=_ref.actionBeingDeleted,chooseAction=_ref.chooseAction,icons=_ref.icons,removeAction=_ref.removeAction;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* ActionContainer */],{active:!actionBeingDeleted,onClick:!actionBeingDeleted?chooseAction:null},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* ActionIcons */],null,icons&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icons_summary_component__["a" /* default */],{_while:icons.while,disabled:!action.enabled,then:icons.then,when:icons.when})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["e" /* RemoveActionContainer */],{onClick:actionBeingDeleted?null:function(e){e.stopPropagation();removeAction();}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* RemoveActionButton */],{type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].TRASH})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* Name */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',null,action.name)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["f" /* Status */],{enabled:action.enabled},action.enabled?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].enabledAction):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].disabledAction)));};/* harmony default export */ __webpack_exports__["a"] = (ActionComponent);

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Main; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NumberContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Number; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n    margin-right: ','em;\n    position: relative;\n    width: ','em;\n'],['\n    display: flex;\n    justify-content: space-between;\n    margin-right: ','em;\n    position: relative;\n    width: ','em;\n']),_templateObject2=_taggedTemplateLiteral(['\n    border-top-color: ',';\n    left: ','em;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    width: calc(100% - ','em);\n'],['\n    border-top-color: ',';\n    left: ','em;\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    width: calc(100% - ','em);\n']),_templateObject3=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    border: ',' 1px ',';\n    border-radius: 100%;\n    display: flex;\n    height: ','em;\n    justify-content: center;\n    position: relative;\n    width: ','em;\n\n    & > svg > g {\n        fill: ',';\n    }\n'],['\n    align-items: center;\n    background-color: ',';\n    border: ',' 1px ',';\n    border-radius: 100%;\n    display: flex;\n    height: ','em;\n    justify-content: center;\n    position: relative;\n    width: ','em;\n\n    & > svg > g {\n        fill: ',';\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    height: ','em;\n    position: relative;\n    width: ','em;\n'],['\n    height: ','em;\n    position: relative;\n    width: ','em;\n']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    display: flex;\n    height: 1em;\n    justify-content: center;\n    left: calc(','em - 2px);\n    position: absolute;\n    width: ','em;\n'],['\n    align-items: center;\n    background-color: ',';\n    display: flex;\n    height: 1em;\n    justify-content: center;\n    left: calc(','em - 2px);\n    position: absolute;\n    width: ','em;\n']),_templateObject6=_taggedTemplateLiteral(['font-size: 0.625em;'],['font-size: 0.625em;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var size=3;var Main=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,size/2,function(p){return size*(p.number+(p.number-1)/3);});var Line=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].hr(_templateObject2,function(p){return p.disabled?p.theme.secondaryMedium:p.theme.mainBrandColor;},size/2,size);var IconContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(p){return p.theme.white;},function(p){return p.disabled?'dashed':'solid';},function(p){return p.theme.secondaryMedium;},size,size,function(p){return p.disabled?p.theme.secondaryHeavy:'inherit';});var Icon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject4,size*0.7,size*0.7);var NumberContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,function(p){return p.theme.white;},size*5/6,size/3);var Number=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject6);

/***/ }),
/* 2159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RemoveActionContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RemoveActionButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Status; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    border: ',' 1px ',';\n    border-radius: ','em;\n    cursor: ',';\n    display: flex;\n    flex-wrap: wrap;\n    height: ','em;\n    margin-top: ','em;\n    padding: ','em 0 0 0;\n    transition: 0.3s;\n\n    &:hover {\n        box-shadow: 0 0 0.5em 0 ',';\n    }\n\n    ',';\n'],['\n    border: ',' 1px ',';\n    border-radius: ','em;\n    cursor: ',';\n    display: flex;\n    flex-wrap: wrap;\n    height: ','em;\n    margin-top: ','em;\n    padding: ','em 0 0 0;\n    transition: 0.3s;\n\n    &:hover {\n        box-shadow: 0 0 0.5em 0 ',';\n    }\n\n    ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n\t\tflex-wrap: nowrap;\n        height: ','em;\n        padding: ','em 0;\n\t'],['\n\t\tflex-wrap: nowrap;\n        height: ','em;\n        padding: ','em 0;\n\t']),_templateObject3=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 1 0 12em;\n    height: ','em;\n    order: 1;\n    padding-left: ','em;\n\n    ',';\n'],['\n    align-items: center;\n    display: flex;\n    flex: 1 0 12em;\n    height: ','em;\n    order: 1;\n    padding-left: ','em;\n\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n\t\tflex: 0 0 14em;\n\t'],['\n\t\tflex: 0 0 14em;\n\t']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 0 0 4em;\n    height: ','em;\n    justify-content: flex-end;\n    order: 2;\n    padding: 0 ','em;\n\n    ',';\n'],['\n    align-items: center;\n    display: flex;\n    flex: 0 0 4em;\n    height: ','em;\n    justify-content: flex-end;\n    order: 2;\n    padding: 0 ','em;\n\n    ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n\t\torder: 4;\n\t'],['\n\t\torder: 4;\n\t']),_templateObject7=_taggedTemplateLiteral(['\n    height: 1.5em;\n    margin: 0;\n    width: 2em;\n'],['\n    height: 1.5em;\n    margin: 0;\n    width: 2em;\n']),_templateObject8=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 1 1 100%;\n    height: ','em;\n    order: 3;\n    overflow: hidden;\n    padding: 0 ','em;\n\n    & > span {\n        font-size: 1.2em;\n    }\n\n    ',';\n'],['\n    align-items: center;\n    display: flex;\n    flex: 1 1 100%;\n    height: ','em;\n    order: 3;\n    overflow: hidden;\n    padding: 0 ','em;\n\n    & > span {\n        font-size: 1.2em;\n    }\n\n    ',';\n']),_templateObject9=_taggedTemplateLiteral(['\n        flex: 1 1 auto;\n        height: ','em;\n\t\torder: 2;\n\t'],['\n        flex: 1 1 auto;\n        height: ','em;\n\t\torder: 2;\n\t']),_templateObject10=_taggedTemplateLiteral(['\n    display: none;\n\n    ',';\n'],['\n    display: none;\n\n    ',';\n']),_templateObject11=_taggedTemplateLiteral(['\n        align-items: center;\n        color: ',';\n        display: flex;\n        flex: 0 0 6em;\n        padding: 0 ','em;\n        order: 3;\n    '],['\n        align-items: center;\n        color: ',';\n        display: flex;\n        flex: 0 0 6em;\n        padding: 0 ','em;\n        order: 3;\n    ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var height=4;var heightText=3;var padding=1;var ActionContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(p){return p.active?'solid':'dashed';},function(p){return p.theme.secondaryMedium;},padding,function(p){return p.active?'pointer':'inherit';},height+heightText+padding,padding,padding,function(p){return p.theme.secondaryMedium;},__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject2,height+2*padding,padding));var ActionIcons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,height,padding,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject4));var RemoveActionContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,height,padding,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject6));var RemoveActionButton=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */])(_templateObject7);var Name=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject8,heightText,padding,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject9,height));var Status=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject11,function(p){return p.enabled?p.theme.mainBrandColor:'inherit';},padding));

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PlusContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NumberActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NumberText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(87);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    border: dashed 1px ',';\n    border-radius: 0.5em;\n    cursor: pointer;\n    display: flex;\n    height: 2.4em;\n    justify-content: center;\n    padding: 0.2em;\n'],['\n    align-items: center;\n    border: dashed 1px ',';\n    border-radius: 0.5em;\n    cursor: pointer;\n    display: flex;\n    height: 2.4em;\n    justify-content: center;\n    padding: 0.2em;\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: 1.8em;\n    width: 3em;\n\n    & > svg > g {\n        fill: ',';\n    }\n'],['\n    height: 1.8em;\n    width: 3em;\n\n    & > svg > g {\n        fill: ',';\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    border-radius: 0.5em;\n    display: flex;\n    height: 1.8em;\n    justify-content: center;\n    margin: 1em 0;\n'],['\n    align-items: center;\n    background-color: ',';\n    border-radius: 0.5em;\n    display: flex;\n    height: 1.8em;\n    justify-content: center;\n    margin: 1em 0;\n']),_templateObject4=_taggedTemplateLiteral(['margin-left: 0.5em;'],['margin-left: 0.5em;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CreateAction=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */])(_templateObject,function(p){return p.theme.secondaryMedium;});var PlusContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(p){return p.theme.mainBrandColor;});var NumberActions=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(p){return p.theme.secondaryLight;});var NumberText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject4);

/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layouts_standard_layouts_standard_component__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(2163);
var DiscoverSplash=function DiscoverSplash(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__layouts_standard_layouts_standard_component__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* IconContainer */],{isModal:false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* ActionIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].body,function(msg){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* TextBody */],null,msg);}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].description,function(msg){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* SecondaryTextBody */],null,msg);})));};/* harmony default export */ __webpack_exports__["a"] = (DiscoverSplash);

/***/ }),
/* 2162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandardLayoutContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    margin: 0 auto;\n    max-width: ',';\n    overflow: hidden;\n    padding: 0 1.5rem 1.5rem 1.5rem;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n'],['\n    margin: 0 auto;\n    max-width: ',';\n    overflow: hidden;\n    padding: 0 1.5rem 1.5rem 1.5rem;\n    width: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StandardLayoutContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(p){return p.theme.layoutMaxWidth;});

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({body:{id:'hive.actions.my-actions.discover-action.body',// prettier-ignore
defaultMessage:'You haven\'t set up any actions\nyet. But there\'s no time like the\npresent.'},description:{id:'hive.actions.my-actions.discover-action.description',// prettier-ignore
defaultMessage:'Tap Discover to explore all sorts of\nwonderful ways you can make your home\nwork better for you.'}}));

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingIndicatorContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoadingIndicatorContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    padding: 1rem;\n    text-align: center;\n    height: 100%;\n'],['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    padding: 1rem;\n    text-align: center;\n    height: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n    flex: 1;\n    max-width: 10rem;\n'],['\n    flex: 1;\n    max-width: 10rem;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LoadingIndicatorContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var LoadingIndicatorContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);

/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LogoContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_splashscreen_animation_png__ = __webpack_require__(2166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_splashscreen_animation_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_splashscreen_animation_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_style__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(['\n\t0% { background-position: 0 0%; }\n\t8% { background-position: 0 12.5%% }\n\t12% { background-position: 0 25%; }\n\t16% { background-position: 0 37.5%; }\n\t20% { background-position: 0 50%; }\n\t24% { background-position: 0 62.5%; }\n\t28% { background-position: 0 75%; }\n\t32% { background-position: 0 87.5%; }\n\t36% { background-position: 0 100%; }\n\t40% { background-position: 0 0%; }\n\t100% { background-position: 0 0%; }\n'],['\n\t0% { background-position: 0 0%; }\n\t8% { background-position: 0 12.5%% }\n\t12% { background-position: 0 25%; }\n\t16% { background-position: 0 37.5%; }\n\t20% { background-position: 0 50%; }\n\t24% { background-position: 0 62.5%; }\n\t28% { background-position: 0 75%; }\n\t32% { background-position: 0 87.5%; }\n\t36% { background-position: 0 100%; }\n\t40% { background-position: 0 0%; }\n\t100% { background-position: 0 0%; }\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n'],['\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n    animation: ',' 2.5s infinite step-end;\n    background: url(',') no-repeat;\n    background-size: 100%;\n    width: 10rem;\n    height: 10rem;\n    ',';\n'],['\n    animation: ',' 2.5s infinite step-end;\n    background: url(',') no-repeat;\n    background-size: 100%;\n    width: 10rem;\n    height: 10rem;\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n\t\twidth: 12rem;\n\t\theight: 12rem;\n\t'],['\n\t\twidth: 12rem;\n\t\theight: 12rem;\n\t']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var imageChange=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject);var AnimationContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);var LogoContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,imageChange,__WEBPACK_IMPORTED_MODULE_1__assets_images_splashscreen_animation_png___default.a,__WEBPACK_IMPORTED_MODULE_2__core_utils_style__["b" /* media */].tablet(_templateObject4));

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/splashscreen-animation.627d4514bd5598bd5497ff102fab23fff8fb7110032c47106547e9a93bcc03ab.png";

/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_detail__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__intl__ = __webpack_require__(784);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    height: 3em;\n\n    & > span {\n        color: ',';\n        font-size: 1.2em;\n    }\n'],['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    height: 3em;\n\n    & > span {\n        color: ',';\n        font-size: 1.2em;\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    min-height: 3em;\n\n    & > span {\n        font-size: 1.1em;\n    }\n'],['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    min-height: 3em;\n\n    & > span {\n        font-size: 1.1em;\n    }\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ConfirmTitle=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject,function(p){return p.theme.mainBrandColor;});var ConfirmText=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2);// if there is an event notification check at least one the settings (push, email or text) is true
var checkIfValidNotification=function checkIfValidNotification(form){var notificationEvent=form.then.find(function(event){return event.type==='notification';});return!notificationEvent?true:Object.keys(notificationEvent.settings||{}).some(function(key){return notificationEvent.settings&&notificationEvent.settings[key];});};var ActionCanvas=function(_React$Component){_inherits(ActionCanvas,_React$Component);function ActionCanvas(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ActionCanvas);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ActionCanvas.__proto__||Object.getPrototypeOf(ActionCanvas)).call.apply(_ref,[this].concat(args))),_this),_this.state={actionNameEdited:null,removeAction:null},_this.editActionName=function(name){return _this.setState({actionNameEdited:name});},_this.hideSideModal=function(){_this.setState({actionNameEdited:null});_this.props.cancelForm();},_this.removeAction=function(){var _this$props=_this.props,attemptRemoveAction=_this$props.attemptRemoveAction,parentResetActionState=_this$props.parentResetActionState;var removeAction=_this.state.removeAction;removeAction&&attemptRemoveAction(removeAction.id);_this.setState({removeAction:null});parentResetActionState&&parentResetActionState();},_this.showConfirmModal=function(actionId,name){var deprecated=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return _this.setState({removeAction:{id:actionId,name:name,deprecated:deprecated}});},_this.hideConfirmModal=function(){_this.setState({removeAction:null});_this.props.parentResetActionState&&_this.props.parentResetActionState();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ActionCanvas,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){if(this.state.actionNameEdited&&!nextProps.extendedForm){this.setState({actionNameEdited:null});}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.parentRemoveActionState){this.setState({removeAction:nextProps.parentRemoveActionState});}}},{key:'render',value:function render(){var _props=this.props,extendedForm=_props.extendedForm,saveAction=_props.saveAction,savingState=_props.savingState;var _state=this.state,actionNameEdited=_state.actionNameEdited,removeAction=_state.removeAction;var savableForm=savingState!=='saving'&&actionNameEdited!==''&&extendedForm?extendedForm.then.length>0&&checkIfValidNotification(extendedForm):false;return[__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4____["_2" /* SideModal */],{asyncButton:{disabled:!savableForm,error:savingState==='failed',onClick:function onClick(){return saveAction(actionNameEdited);},saving:savingState==='saving'},isOpen:!!extendedForm,key:'actions-side-modal',onRequestClose:this.hideSideModal,title:__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].sideModalTitle},extendedForm&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__action_detail__["a" /* default */],{actionNameEdited:actionNameEdited,editActionName:this.editActionName,extendedForm:extendedForm,showConfirmModal:this.showConfirmModal})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4____["J" /* Modal */],{isOpen:!!removeAction,key:'confirm-modal',onRequestClose:this.hideConfirmModal,onSave:this.removeAction,saveText:__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].removeActionButton},removeAction&&[__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ConfirmTitle,{key:'title'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],removeAction.deprecated?__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].notFullySupportedTitle:__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].confirmRemoveAction)),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ConfirmText,{key:'content'},removeAction.deprecated?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].notFullySupportedContent):removeAction.name)])];}}]);return ActionCanvas;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ActionCanvas);

/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_state_actions_selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_state_actions_actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component__ = __webpack_require__(2169);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var mapStateToProps=function mapStateToProps(state,_ref){var extendedForm=_ref.extendedForm;var region=Object(__WEBPACK_IMPORTED_MODULE_4__core_state_config_selectors__["d" /* getIconLocaleSuffix */])(state);var isNano1=Object(__WEBPACK_IMPORTED_MODULE_5__core_state_devices_selectors__["N" /* getIsHubNano1 */])(state);var checkExtraAttributeAvailibility=function checkExtraAttributeAvailibility(group,type,definition){var existingEventsUsingThisType=extendedForm[group].filter(function(event){return event.type===type;}).length;if(!definition.devices){return existingEventsUsingThisType===0;}// $FlowFixMe
var devices=Object(__WEBPACK_IMPORTED_MODULE_6__core_state_actions_selectors__["o" /* listDevicesForActionAttribute */])(state,{types:definition.devices});return devices.length>existingEventsUsingThisType;};var allowedTypes=['while','then'].reduce(function(acc,group){return Object.assign({},acc,_defineProperty({},group,Object(__WEBPACK_IMPORTED_MODULE_6__core_state_actions_selectors__["b" /* eventsByGroup */])(state,{group:group,templateId:extendedForm.template.id}).map(function(event){var definition=Object(__WEBPACK_IMPORTED_MODULE_3__core_constants_actions__["d" /* getAttributeDefinition */])(event.type,region);return{available:checkExtraAttributeAvailibility(group,event.type,definition),event:event,icon:definition.icon,label:definition.text};})));},{});var prepareActionEvent=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_curry___default()(function(state,props){return Object(__WEBPACK_IMPORTED_MODULE_6__core_state_actions_selectors__["p" /* newActionEvent */])(state,props);});return{allowedTypes:Object.assign({},allowedTypes),// I know it's weird, but go ask flow
extendedForm:extendedForm,isNano1:isNano1,prepareActionEvent:prepareActionEvent(state)};};var mapDispatchToProps={addActionAttribute:__WEBPACK_IMPORTED_MODULE_7__core_state_actions_actions__["a" /* addActionAttribute */],removeActionAttribute:__WEBPACK_IMPORTED_MODULE_7__core_state_actions_actions__["o" /* removeActionAttribute */],setActionAttribute:__WEBPACK_IMPORTED_MODULE_7__core_state_actions_actions__["s" /* setActionAttribute */],setActionForm:__WEBPACK_IMPORTED_MODULE_7__core_state_actions_actions__["t" /* setActionForm */]};var mergeProps=function mergeProps(_ref2,dispatchProps,_ref3){var form=_ref3.form,restOwnProps=_objectWithoutProperties(_ref3,['form']);var prepareActionEvent=_ref2.prepareActionEvent,restStateProps=_objectWithoutProperties(_ref2,['prepareActionEvent']);var addActionAttribute=dispatchProps.addActionAttribute,removeActionAttribute=dispatchProps.removeActionAttribute,setActionAttribute=dispatchProps.setActionAttribute,_setActionForm=dispatchProps.setActionForm;return Object.assign({},restOwnProps,restStateProps,{addActionAttribute:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default()(addActionAttribute,prepareActionEvent),removeActionAttribute:removeActionAttribute,setActionAttribute:setActionAttribute,setActionForm:function setActionForm(propertyName,newValue){return _setActionForm({propertyName:propertyName,newValue:newValue});}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_8__component__["a" /* default */]));

/***/ }),
/* 2169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_attribute__ = __webpack_require__(2170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons_summary_component__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__add_event_component__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__intl__ = __webpack_require__(2173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(2174);
var MAX_NAME_LENGTH=128;var MAX_NAME_LENGTH_QUICK_ACTON=40;var QUICK_ACTION='quick-action';var getIcon=function getIcon(key,obj){return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default()(null,[key,'0','definition','icon'],obj);};var ActionDetail=function ActionDetail(_ref){var actionNameEdited=_ref.actionNameEdited,addActionAttribute=_ref.addActionAttribute,allowedTypes=_ref.allowedTypes,editActionName=_ref.editActionName,extendedForm=_ref.extendedForm,isNano1=_ref.isNano1,removeActionAttribute=_ref.removeActionAttribute,region=_ref.region,_setActionAttribute=_ref.setActionAttribute,setActionForm=_ref.setActionForm,showConfirmModal=_ref.showConfirmModal;var whenLength=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default()(0,['when','length'],extendedForm);var whileLength=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default()(0,['while','length'],extendedForm);var thenLength=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default()(0,['then','length'],extendedForm);var isQuickAction=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default()('',['when','0','type'],extendedForm)===QUICK_ACTION;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* ActionContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icons_summary_component__["a" /* default */],Object.assign({},whileLength>0?{_while:getIcon('while',extendedForm)}:{},thenLength>0?{then:{type:getIcon('then',extendedForm)}}:{},{when:whenLength>0?getIcon('when',extendedForm):__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].QUESTION})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["e" /* Line */],null),actionNameEdited===null?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["g" /* Section */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,extendedForm.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["c" /* EditIconContainer */],{onClick:function onClick(){return editActionName(extendedForm.name);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__core_icons_svg_icons__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].EDIT}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__intl__["a" /* default */].nameYourAction,function(message){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["b" /* ActionNameInput */],{maxLength:isQuickAction?MAX_NAME_LENGTH_QUICK_ACTON:MAX_NAME_LENGTH,onChange:function onChange(e){return editActionName(e.currentTarget.value);},placeholder:message,type:'text',value:actionNameEdited});}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["e" /* Line */],null),!extendedForm.when.find(function(event){return event.type===__WEBPACK_IMPORTED_MODULE_3__core_constants_actions__["b" /* actionTypes */].QUICK_ACTION;})&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["g" /* Section */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__intl__["a" /* default */].enableAction)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["h" /* ToggleContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["_14" /* ToggleButton */],{isOn:extendedForm.enabled,onChange:function onChange(){return setActionForm('enabled',!extendedForm.enabled);}}))),['when','while','then'].map(function(group){return(group==='when'||allowedTypes[group].length>0)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:group},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["d" /* EventTitle */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__intl__["a" /* default */][group])),extendedForm[group].map(function(event,index){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__action_attribute__["a" /* default */],{actionId:extendedForm.id,event:event,formStatus:extendedForm.status,key:event.guid,removeActionAttribute:removeActionAttribute,setActionAttribute:function setActionAttribute(attributeProperty,newValue){return _setActionAttribute({attributeIndex:index,attributeProperty:attributeProperty,group:group,newValue:newValue});}});}),group!=='when'&&(group!=='while'||__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default()(0,[group,'length'],extendedForm)===0)&&(group!=='then'||!isNano1||__WEBPACK_IMPORTED_MODULE_0_lodash_fp_getOr___default()(0,[group,'length'],extendedForm)===0)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__add_event_component__["a" /* default */],{addActionAttribute:addActionAttribute,allowedTypes:allowedTypes[group]}));}),extendedForm.id&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["e" /* Line */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["g" /* Section */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__styles__["f" /* Remove */],{onClick:function onClick(){return extendedForm.id&&showConfirmModal(extendedForm.id,extendedForm.name);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_10__intl__["a" /* default */].removeAction)))));};/* harmony default export */ __webpack_exports__["a"] = (ActionDetail);

/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_entitlements_selectors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_products_bulbs_actions__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__(762);
var mapStateToProps=function mapStateToProps(state){var hasSMS=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_entitlements_selectors__["b" /* getHasEntitlement */])(state,'SMS');return{hasSMS:hasSMS,checkCapability:function checkCapability(props){return Object(__WEBPACK_IMPORTED_MODULE_2__core_state_devices_selectors__["_0" /* getWhetherDeviceHasCapability */])(state,props);}};};var mapDispatchToProps={showHiveLiveModal:__WEBPACK_IMPORTED_MODULE_3__core_state_application_actions__["m" /* showHiveLiveModal */],talkToLight:__WEBPACK_IMPORTED_MODULE_4__core_state_products_bulbs_actions__["e" /* talkToLight */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var checkCapability=stateProps.checkCapability;var talkToLight=dispatchProps.talkToLight;var _setActionAttribute=ownProps.setActionAttribute;return Object.assign({},stateProps,dispatchProps,ownProps,{setActionAttribute:function setActionAttribute(prop,newVal){if(prop==='id'&&newVal){var hasIdentifyDeviceCapabilitiy=checkCapability({id:newVal,capabilityName:__WEBPACK_IMPORTED_MODULE_5__core_constants_devices__["capabilities"].IDENTIFY_DEVICE});hasIdentifyDeviceCapabilitiy&&talkToLight({id:newVal,patch:{identifyMode:true}});}return _setActionAttribute(prop,newVal);}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(2172);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddEvent=function(_Component){_inherits(AddEvent,_Component);function AddEvent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddEvent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddEvent.__proto__||Object.getPrototypeOf(AddEvent)).call.apply(_ref,[this].concat(args))),_this),_this.state={isDetailVisible:false},_this.showDetailVisibility=function(){return _this.setState({isDetailVisible:true});},_this.hideDetailVisibility=function(){return _this.setState({isDetailVisible:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddEvent,[{key:'render',value:function render(){var _this2=this;var _props=this.props,addActionAttribute=_props.addActionAttribute,allowedTypes=_props.allowedTypes;var isDetailVisible=this.state.isDetailVisible;return allowedTypes.some(function(item){return item.available;})&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* AddEventContainer */],{isDetailVisible:isDetailVisible,numberElements:allowedTypes.length},isDetailVisible?[allowedTypes.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* AllowedTypeItem */],{disabled:!item.available,key:item.event.type,onClick:item.available?function(){_this2.hideDetailVisibility();addActionAttribute({event:item.event});}:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* AddEventIcon */],{disabled:!item.available},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__core_icons_svg_icons__["a" /* default */],{type:item.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],item.label));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* CancelAdding */],{key:'cancel',onClick:this.hideDetailVisibility},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].cancelAttribute))]:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styles__["e" /* ShowDetail */],{onClick:this.showDetailVisibility},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__core_icons_svg_icons__["a" /* default */],{type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].PLUS})));}}]);return AddEvent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AddEvent);

/***/ }),
/* 2172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddEventContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ShowDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AllowedTypeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AddEventIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CancelAdding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    border: ',';\n    border-radius: 1em;\n    display: flex;\n    flex-direction: column;\n    height: ','em;\n    justify-content: center;\n    overflow: hidden;\n    transition: all 0.3s ',';\n\n    & > svg > g {\n        fill: ',';\n    }\n'],['\n    align-items: center;\n    border: ',';\n    border-radius: 1em;\n    display: flex;\n    flex-direction: column;\n    height: ','em;\n    justify-content: center;\n    overflow: hidden;\n    transition: all 0.3s ',';\n\n    & > svg > g {\n        fill: ',';\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n    height: ','em;\n    justify-content: center;\n'],['\n    align-items: center;\n    cursor: pointer;\n    display: flex;\n    height: ','em;\n    justify-content: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n    align-items: center;\n    border-bottom: solid 1px ',';\n    cursor: ',';\n    display: flex;\n    height: ','em;\n    width: 100%;\n\n    & > span {\n        opacity: ',';\n        font-size: 1.2em;\n    }\n\n    &:hover {\n        background-color: ',';\n    }\n'],['\n    align-items: center;\n    border-bottom: solid 1px ',';\n    cursor: ',';\n    display: flex;\n    height: ','em;\n    width: 100%;\n\n    & > span {\n        opacity: ',';\n        font-size: 1.2em;\n    }\n\n    &:hover {\n        background-color: ',';\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: flex;\n    height: ','em;\n    justify-content: center;\n    opacity: ',';\n    padding: 0.4em;\n    width: 5em;\n'],['\n    display: flex;\n    height: ','em;\n    justify-content: center;\n    opacity: ',';\n    padding: 0.4em;\n    width: 5em;\n']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    color: ',';\n    cursor: pointer;\n    display: flex;\n    height: ','em;\n    justify-content: center;\n    width: 100%;\n'],['\n    align-items: center;\n    background-color: ',';\n    color: ',';\n    cursor: pointer;\n    display: flex;\n    height: ','em;\n    justify-content: center;\n    width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var heightItem=3;var heightAddAndCancel=2.2;var easeOutQuint='cubic-bezier(0.23, 1, 0.32, 1)';var AddEventContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(p){return p.isDetailVisible?'solid 1px '+p.theme.secondaryMedium:'dashed 2px '+p.theme.secondaryMedium;},function(p){return p.isDetailVisible?p.numberElements*heightItem+heightAddAndCancel:heightAddAndCancel;},easeOutQuint,function(p){return p.theme.mainBrandColor;});var ShowDetail=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,heightAddAndCancel);var AllowedTypeItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(p){return p.theme.secondaryMedium;},function(p){return p.disabled?'inherit':'pointer';},heightItem,function(p){return p.disabled?0.5:1;},function(p){return p.disabled?'inherit':p.theme.secondaryLight;});var AddEventIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,heightItem,function(p){return p.disabled?0.3:1;});var CancelAdding=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,function(p){return p.theme.secondaryLight;},function(p){return p.theme.mainBrandColor;},heightAddAndCancel);

/***/ }),
/* 2173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({// Templates list
enableAction:{id:'actions.enable-action',defaultMessage:'Enable this action'},nameYourAction:{id:'actions.nameYourAction',defaultMessage:'Name your action'},when:{id:'actions.when',defaultMessage:'WHEN'},while:{id:'actions.while',defaultMessage:'WHILE'},then:{id:'actions.then',defaultMessage:'THEN'},removeAction:{id:'actions.remove-action',defaultMessage:'Remove action'}}));

/***/ }),
/* 2174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Section; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EditIconContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionNameInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ToggleContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EventTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Remove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['padding: 2em;'],['padding: 2em;']),_templateObject2=_taggedTemplateLiteral(['\n    border: none;\n    border-bottom: solid 1px ',';\n    margin: 0.7em 0;\n'],['\n    border: none;\n    border-bottom: solid 1px ',';\n    margin: 0.7em 0;\n']),_templateObject3=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    height: 2.3em;\n\n    & > *:first-child {\n        flex: 1 0 auto;\n    }\n'],['\n    align-items: center;\n    display: flex;\n    height: 2.3em;\n\n    & > *:first-child {\n        flex: 1 0 auto;\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    cursor: pointer;\n    flex: 0 0 2.5em;\n    padding: 0.6em;\n'],['\n    cursor: pointer;\n    flex: 0 0 2.5em;\n    padding: 0.6em;\n']),_templateObject5=_taggedTemplateLiteral(['\n    background-color: ',';\n    border: solid 1px ',';\n    border-radius: 1em;\n    height: 3em;\n    padding-left: 1em;\n    width: 100%;\n'],['\n    background-color: ',';\n    border: solid 1px ',';\n    border-radius: 1em;\n    height: 3em;\n    padding-left: 1em;\n    width: 100%;\n']),_templateObject6=_taggedTemplateLiteral(['\n    flex: 0 0 2.5em;\n    padding: 0.6em;\n\n    & > * {\n        font-size: 0.7em;\n    }\n'],['\n    flex: 0 0 2.5em;\n    padding: 0.6em;\n\n    & > * {\n        font-size: 0.7em;\n    }\n']),_templateObject7=_taggedTemplateLiteral(['margin: 1.5em 0 0.2em;'],['margin: 1.5em 0 0.2em;']),_templateObject8=_taggedTemplateLiteral(['\n    align-items: center;\n    cursor: pointer;\n    color: ',';\n    display: flex;\n    height: 2em;\n    justify-content: center;\n    transition: all 0.2s;\n\n    &:hover {\n        text-decoration: underline;\n    }\n'],['\n    align-items: center;\n    cursor: pointer;\n    color: ',';\n    display: flex;\n    height: 2em;\n    justify-content: center;\n    transition: all 0.2s;\n\n    &:hover {\n        text-decoration: underline;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ActionContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var Line=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].hr(_templateObject2,function(p){return p.theme.secondaryLight;});var Section=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3);var EditIconContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4);var ActionNameInput=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].input(_templateObject5,function(p){return p.theme.secondaryLight;},function(p){return p.theme.mediumGrey;});var ToggleContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject6);var EventTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject7);var Remove=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject8,function(p){return p.theme.mainBrandColor;});

/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_actions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_list_component__ = __webpack_require__(2179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(2181);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var changeFilter=_ref.changeFilter,currentFilter=_ref.currentFilter,productTypesUserOwns=_ref.productTypesUserOwns,region=_ref.region;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* Heading */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].browseByCategory)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons_list_component__["a" /* default */],{changeFilter:function(_changeFilter){function changeFilter(_x){return _changeFilter.apply(this,arguments);}changeFilter.toString=function(){return _changeFilter.toString();};return changeFilter;}(function(selectedItem){return changeFilter({name:__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* filtersType */].BY_CATEGORY,selectedItem:selectedItem});}),list:__WEBPACK_IMPORTED_MODULE_1__core_constants_actions__["c" /* categories */],selectedItem:currentFilter.name===__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* filtersType */].BY_CATEGORY?currentFilter.selectedItem:undefined}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* Line */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* Heading */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].browseByDevice)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__icons_list_component__["a" /* default */],{changeFilter:function(_changeFilter2){function changeFilter(_x2){return _changeFilter2.apply(this,arguments);}changeFilter.toString=function(){return _changeFilter2.toString();};return changeFilter;}(function(selectedItem){return changeFilter({name:__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* filtersType */].BY_DEVICE,selectedItem:selectedItem});}),list:Object(__WEBPACK_IMPORTED_MODULE_1__core_constants_actions__["e" /* getFilterDevicesList */])(region,productTypesUserOwns),selectedItem:currentFilter.name===__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* filtersType */].BY_DEVICE?currentFilter.selectedItem:undefined}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* Button */],{onClick:function onClick(){return changeFilter({name:__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* filtersType */].SHOW_ALL});},selected:currentFilter.name===__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* filtersType */].SHOW_ALL},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].browseAllActions)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* Button */],{onClick:function onClick(){return changeFilter({name:__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* filtersType */].BUILD_YOUR_OWN});},selected:currentFilter.name===__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* filtersType */].BUILD_YOUR_OWN},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].buildYourOwn)));});

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl__ = __webpack_require__(2178);
var FilterHeader=function FilterHeader(){return[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({key:'title'},__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].title),function(m){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Heading */],null,m);}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({key:'body'},__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].body),function(m){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('p',null,m);})];};/* harmony default export */ __webpack_exports__["a"] = (FilterHeader);

/***/ }),
/* 2177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Heading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    border-bottom: 1px solid ',';\n    padding-bottom: 0.5em;\n'],['\n    border-bottom: 1px solid ',';\n    padding-bottom: 0.5em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Heading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].h2(_templateObject,function(props){return props.theme.mediumGrey;});

/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({title:{id:'actions.filter.title',defaultMessage:'Discover Hive Actions'},body:{id:'actions.filter.body',defaultMessage:'Get your lights, plugs and sensors working together to make your home work better for you.'}}));

/***/ }),
/* 2179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2180);
var Icon=function Icon(_ref){var definition=_ref.definition,onClick=_ref.onClick,selected=_ref.selected;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* IconCell */],{canBeUsed:definition.canBeUsed||definition.isUniversal,onClick:onClick,selected:selected},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* IconContainer */],{selected:selected},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* DiscoverIcon */],{type:definition.icon})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* IconText */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],definition.text)));};/* harmony default export */ __webpack_exports__["a"] = (function(_ref2){var changeFilter=_ref2.changeFilter,list=_ref2.list,selectedItem=_ref2.selectedItem;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Container */],null,list.map(function(item,index){return!item.hidden&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{definition:item,key:'icon-'+index,onClick:function onClick(){return changeFilter(item.id);},selected:selectedItem===item.id});}));});

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* unused harmony export mapDefinitionToBorderColor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IconText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DiscoverIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    flex-wrap: wrap;\n'],['\n    display: flex;\n    flex-wrap: wrap;\n']),_templateObject2=_taggedTemplateLiteral(['\n    background-color: ',';\n    border: solid 1px ',';\n    border-radius: 1em;\n    cursor: pointer;\n    display: flex;\n    flex: 0 0 5.5em;\n    flex-direction: column;\n    height: 5.5em;\n    margin: 0 0.5em 0.5em 0;\n    transition: 0.3s;\n\n    &:hover {\n        box-shadow: 0 0 0.5em 0 ',';\n    }\n'],['\n    background-color: ',';\n    border: solid 1px ',';\n    border-radius: 1em;\n    cursor: pointer;\n    display: flex;\n    flex: 0 0 5.5em;\n    flex-direction: column;\n    height: 5.5em;\n    margin: 0 0.5em 0.5em 0;\n    transition: 0.3s;\n\n    &:hover {\n        box-shadow: 0 0 0.5em 0 ',';\n    }\n']),_templateObject3=_taggedTemplateLiteral(['fill: ',';'],['fill: ',';']),_templateObject4=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 0 0 70%;\n    justify-content: center;\n    padding: 15% 0 5%;\n\n    & > svg > g {\n        ',';\n    }\n'],['\n    align-items: center;\n    display: flex;\n    flex: 0 0 70%;\n    justify-content: center;\n    padding: 15% 0 5%;\n\n    & > svg > g {\n        ',';\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: flex-start;\n    display: flex;\n    flex: 0 0 30%;\n    font-size: 0.8em;\n    justify-content: center;\n'],['\n    align-items: flex-start;\n    display: flex;\n    flex: 0 0 30%;\n    font-size: 0.8em;\n    justify-content: center;\n']),_templateObject6=_taggedTemplateLiteral(['height: 3em;'],['height: 3em;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var mapDefinitionToBorderColor=function mapDefinitionToBorderColor(_ref){var selected=_ref.selected,canBeUsed=_ref.canBeUsed,theme=_ref.theme;var borderColorMap=new Map([[true,'transparent'],[!canBeUsed,theme.secondaryLight],[selected,theme.mediumGrey]]);return borderColorMap.get(true);};var IconCell=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(p){return p.canBeUsed?p.theme.secondaryLight:p.theme.white;},mapDefinitionToBorderColor,function(p){return p.theme.secondaryMedium;});var IconColor=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject3,function(p){return p.theme.mainBrandColor;});var IconContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(p){return p.selected?IconColor:null;});var IconText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5);var DiscoverIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject6);

/***/ }),
/* 2181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['max-width: 25em;'],['max-width: 25em;']),_templateObject2=_taggedTemplateLiteral(['\n    color: ',';\n    margin: 1em 0;\n'],['\n    color: ',';\n    margin: 1em 0;\n']),_templateObject3=_taggedTemplateLiteral(['\n    border: none;\n    border-top: solid 1px ',';\n'],['\n    border: none;\n    border-top: solid 1px ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    background-color: ',';\n    border: solid 1px transparent;\n    border-color: ',';\n    border-radius: 1em;\n    color: ',';\n    cursor: pointer;\n    font-size: 1.2em;\n    height: 3em;\n    justify-content: center;\n    margin-top: 0.5em;\n    transition: 0.3s;\n\n    &:hover {\n        background-color: ',';\n        box-shadow: ',';\n    }\n'],['\n    align-items: center;\n    display: flex;\n    background-color: ',';\n    border: solid 1px transparent;\n    border-color: ',';\n    border-radius: 1em;\n    color: ',';\n    cursor: pointer;\n    font-size: 1.2em;\n    height: 3em;\n    justify-content: center;\n    margin-top: 0.5em;\n    transition: 0.3s;\n\n    &:hover {\n        background-color: ',';\n        box-shadow: ',';\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var Heading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(p){return p.theme.secondaryHeavy;});var Line=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].hr(_templateObject3,function(p){return p.theme.secondaryLight;});var Button=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(p){return p.selected?p.theme.secondaryLight:'transparent';},function(p){return p.selected?p.theme.mediumGrey:'transparent';},function(p){return p.selected?p.theme.mainBrandColor:'inherit';},function(p){return p.theme.secondaryLight;},function(p){return p.selected?'none':'0 0 0.5em 0 '+p.theme.secondaryMedium;});

/***/ }),
/* 2182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_actions_selectors__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_entitlements_selectors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_state_actions_actions__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component__ = __webpack_require__(2183);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var checkIfMissingDevice=function checkIfMissingDevice(state,attribute){if(attribute.required&&attribute.devices){// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_2__core_state_actions_selectors__["o" /* listDevicesForActionAttribute */])(state,{types:attribute.devices||[]}).length>0?false:true;}return false;};var checkHiveLive=function checkHiveLive(state,attribute){return attribute.entitlements?attribute.entitlements.some(function(entl){return Object(__WEBPACK_IMPORTED_MODULE_3__core_state_entitlements_selectors__["b" /* getHasEntitlement */])(state,entl);})?'requiredAndHave':'requiredButDontHave':'notRequired';};var mapStateToProps=function mapStateToProps(state,_ref){var template=_ref.template;var isNano1=Object(__WEBPACK_IMPORTED_MODULE_5__core_state_devices_selectors__["N" /* getIsHubNano1 */])(state);var _map=[template.when,template.while,template.then].map(function(arr){return arr.map(function(templateEvent){return{definition:templateEvent,hiveLive:checkHiveLive(state,templateEvent),missingDevice:checkIfMissingDevice(state,templateEvent)};});}),_map2=_slicedToArray(_map,3),when=_map2[0],_while=_map2[1],then=_map2[2];var whenEventWithMissingDevice=when.find(function(templateEvent){return templateEvent.missingDevice;});var hiveActionsUrl=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_config_selectors__["a" /* getConfig */])(state,'help:hiveActions');var findOutMoreUrl=whenEventWithMissingDevice?Object(__WEBPACK_IMPORTED_MODULE_1__core_state_config_selectors__["a" /* getConfig */])(state,'actions:requiredDeviceUrl:'+whenEventWithMissingDevice.definition.type):hiveActionsUrl;return{_while:_while,description:template.description,findOutMoreUrl:findOutMoreUrl,hasHub:Object(__WEBPACK_IMPORTED_MODULE_4__core_state_hub_selectors__["d" /* getHasHub */])(state),hiveActionsUrl:hiveActionsUrl,isNano1Incompatible:isNano1&&template.incompatible.includes('NANO1'),name:template.name,state:state,templateId:template.id,templateAvailable:!whenEventWithMissingDevice,then:then,when:when};};var mapDispatchToProps={loadForm:__WEBPACK_IMPORTED_MODULE_6__core_state_actions_actions__["k" /* loadForm */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var state=stateProps.state,templateId=stateProps.templateId,restStateProps=_objectWithoutProperties(stateProps,['state','templateId']);var loadForm=dispatchProps.loadForm;return Object.assign({},restStateProps,ownProps,{chooseTemplate:function chooseTemplate(){return loadForm(Object(__WEBPACK_IMPORTED_MODULE_2__core_state_actions_selectors__["l" /* initialiseFormFromTemplate */])(state,{templateId:templateId}));}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_7__component__["a" /* default */]));

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__description_item_component__ = __webpack_require__(2185);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TemplateDescription=function(_React$Component){_inherits(TemplateDescription,_React$Component);function TemplateDescription(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TemplateDescription);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TemplateDescription.__proto__||Object.getPrototypeOf(TemplateDescription)).call.apply(_ref,[this].concat(args))),_this),_this.state={showNano1Modal:false,showHubRequiredModal:false},_this.chooseTemplate=function(){var _this$props=_this.props,chooseTemplate=_this$props.chooseTemplate,isNano1Incompatible=_this$props.isNano1Incompatible;isNano1Incompatible?_this.setState({showNano1Modal:true}):chooseTemplate();},_this.hideModal=function(){return _this.setState({showNano1Modal:false});},_this.showHubRequiredModal=function(){return _this.setState({showHubRequiredModal:true});},_this.hideHubRequiredModal=function(){return _this.setState({showHubRequiredModal:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TemplateDescription,[{key:'render',value:function render(){var _props=this.props,_while=_props._while,close=_props.close,description=_props.description,findOutMoreUrl=_props.findOutMoreUrl,hasHub=_props.hasHub,hiveActionsUrl=_props.hiveActionsUrl,name=_props.name,templateAvailable=_props.templateAvailable,then=_props.then,when=_props.when;var _state=this.state,showNano1Modal=_state.showNano1Modal,showHubRequiredModal=_state.showHubRequiredModal;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["n" /* UpperContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* CloseButtonContainer */],{onClick:close},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* CloseButton */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].CLOSE})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["m" /* Title */],null,name),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* ButtonContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* MobileLine */],null),templateAvailable?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["l" /* Button */],{onClick:hasHub?this.chooseTemplate:this.showHubRequiredModal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].continue)):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["x" /* HrefButton */],{alternate:true,href:findOutMoreUrl,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].findOutMore)))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["k" /* NonMobileLine */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* LowerContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Description */],null,description),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* DevicesColumn */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["l" /* ThisActionUses */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].thisActionUses)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* ListContainer */],null,when.map(function(templateEvent,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__description_item_component__["a" /* default */],{definition:templateEvent.definition,hiveLive:templateEvent.hiveLive,isRequired:true,key:'when-'+index,missingDevice:templateEvent.missingDevice});}),[].concat(_toConsumableArray(_while),_toConsumableArray(then)).map(function(templateEvent,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__description_item_component__["a" /* default */],{definition:templateEvent.definition,hiveLive:templateEvent.hiveLive,key:'while-then-'+index,missingDevice:templateEvent.missingDevice});})))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["J" /* Modal */],{closeText:__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].done,isOpen:showNano1Modal,key:'confirm-modal',onRequestClose:this.hideModal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["j" /* ModalTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].upgradeHubTitle)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["i" /* ModalContent */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].upgradeHubContent))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["J" /* Modal */],{isOpen:showHubRequiredModal,key:'hub-required-modal',linkUrl:hiveActionsUrl,onRequestClose:this.hideHubRequiredModal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["j" /* ModalTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].hubRequiredTitle)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["i" /* ModalContent */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].hubRequiredDescription))));}}]);return TemplateDescription;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TemplateDescription);

/***/ }),
/* 2184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UpperContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CloseButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CloseButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MobileLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NonMobileLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LowerContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DevicesColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ThisActionUses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ListContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ModalTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ModalContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n\n    ',';\n'],['\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n\n    ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n        flex-direction: row;\n    '],['\n        flex-direction: row;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n    cursor: pointer;\n    display: flex;\n    flex: 0 0 3em;\n    justify-content: center;\n'],['\n    cursor: pointer;\n    display: flex;\n    flex: 0 0 3em;\n    justify-content: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n    height: 2em;\n    width: 2em;\n'],['\n    height: 2em;\n    width: 2em;\n']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    font-size: 1.2em;\n    height: 4em;\n    justify-content: center;\n\n    ',';\n'],['\n    align-items: center;\n    display: flex;\n    font-size: 1.2em;\n    height: 4em;\n    justify-content: center;\n\n    ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n        flex: 1 0 10em;\n        justify-content:flex-start;\n        padding-left: 1em;\n    '],['\n        flex: 1 0 10em;\n        justify-content:flex-start;\n        padding-left: 1em;\n    ']),_templateObject7=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    position: relative;\n    width: 100%;\n\n    & > a {\n        white-space: nowrap;\n    }\n\n    ',';\n'],['\n    display: flex;\n    justify-content: center;\n    position: relative;\n    width: 100%;\n\n    & > a {\n        white-space: nowrap;\n    }\n\n    ',';\n']),_templateObject8=_taggedTemplateLiteral(['\n        flex: 0 0 5em;\n        justify-content:flex-end;\n    '],['\n        flex: 0 0 5em;\n        justify-content:flex-end;\n    ']),_templateObject9=_taggedTemplateLiteral(['\n    border-top-color: ',';\n    margin: 0;\n'],['\n    border-top-color: ',';\n    margin: 0;\n']),_templateObject10=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 50%;\n    width: 120%;\n\n    ',';\n'],['\n    position: absolute;\n    top: 50%;\n    width: 120%;\n\n    ',';\n']),_templateObject11=_taggedTemplateLiteral(['\n        display: none;\n    '],['\n        display: none;\n    ']),_templateObject12=_taggedTemplateLiteral(['\n    display: none;\n\n    ',';\n'],['\n    display: none;\n\n    ',';\n']),_templateObject13=_taggedTemplateLiteral(['\n        display: inherit;\n    '],['\n        display: inherit;\n    ']),_templateObject14=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    padding-top: 2em;\n\n    ',';\n'],['\n    display: flex;\n    flex-direction: column;\n    padding-top: 2em;\n\n    ',';\n']),_templateObject15=_taggedTemplateLiteral(['\n    line-height: 1.5em;\n    padding: 0 0 2em;\n\n    ',';\n'],['\n    line-height: 1.5em;\n    padding: 0 0 2em;\n\n    ',';\n']),_templateObject16=_taggedTemplateLiteral(['\n        flex: 2 0 10em;\n        padding-right: 4em;\n    '],['\n        flex: 2 0 10em;\n        padding-right: 4em;\n    ']),_templateObject17=_taggedTemplateLiteral(['\n    ',';\n'],['\n    ',';\n']),_templateObject18=_taggedTemplateLiteral(['\n        flex: 1 0 10em;\n    '],['\n        flex: 1 0 10em;\n    ']),_templateObject19=_taggedTemplateLiteral(['\n    font-size: 0.9em;\n    margin-bottom: 1em;\n'],['\n    font-size: 0.9em;\n    margin-bottom: 1em;\n']),_templateObject20=_taggedTemplateLiteral(['margin: 0;'],['margin: 0;']),_templateObject21=_taggedTemplateLiteral(['\n    color: ',';\n    height: 3em;\n\n    & > span {\n        font-size: 1.2em;\n    }\n'],['\n    color: ',';\n    height: 3em;\n\n    & > span {\n        font-size: 1.2em;\n    }\n']),_templateObject22=_taggedTemplateLiteral(['\n    padding: 0.5em 0 1em;\n\n    & > span {\n        font-size: 1.1em;\n    }\n'],['\n    padding: 0.5em 0 1em;\n\n    & > span {\n        font-size: 1.1em;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var UpperContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject2));var CloseButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3);var CloseButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */])(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject6));var ButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject8));var Line=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].hr(_templateObject9,function(p){return p.theme.secondaryMedium;});var MobileLine=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(Line)(_templateObject10,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject11));var NonMobileLine=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(Line)(_templateObject12,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject13));var LowerContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject14,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject2));var Description=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject15,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject16));var DevicesColumn=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject17,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject18));var ThisActionUses=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject19);var ListContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].ul(_templateObject20);var ModalTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject21,function(p){return p.theme.mainBrandColor;});var ModalContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject22);

/***/ }),
/* 2185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2186);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var definition=_ref.definition,hiveLive=_ref.hiveLive,isRequired=_ref.isRequired,missingDevice=_ref.missingDevice;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* ItemIcon */],{type:definition.icon}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* ItemTexts */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],definition.text),missingDevice&&isRequired&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* ItemRequired */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].deviceRequired)),!missingDevice&&hiveLive!=='notRequired'&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* ItemRequired */],{noError:hiveLive==='requiredAndHave'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].hiveLiveRequired))),(missingDevice||hiveLive==='requiredButDontHave')&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* ItemExclamation */],{type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].EXCLAMATION}));});

/***/ }),
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ItemIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ItemTexts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ItemRequired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ItemExclamation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    height: 3em;\n'],['\n    align-items: center;\n    display: flex;\n    height: 3em;\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: 2.6em;\n    margin-right: 1em;\n    flex: 0 0 2.6em;\n'],['\n    height: 2.6em;\n    margin-right: 1em;\n    flex: 0 0 2.6em;\n']),_templateObject3=_taggedTemplateLiteral(['flex: 1 0 5em;'],['flex: 1 0 5em;']),_templateObject4=_taggedTemplateLiteral(['\n    color: ',';\n    font-size: 0.8em;\n    padding-top: 0.1em;\n'],['\n    color: ',';\n    font-size: 0.8em;\n    padding-top: 0.1em;\n']),_templateObject5=_taggedTemplateLiteral(['\n    height: 2.6em;\n    margin-left: 1em;\n    flex: 0 0 1.8em;\n\n    & > g {\n        fill: ',';\n    }\n'],['\n    height: 2.6em;\n    margin-left: 1em;\n    flex: 0 0 1.8em;\n\n    & > g {\n        fill: ',';\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ListItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].li(_templateObject);var ItemIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject2);var ItemTexts=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3);var ItemRequired=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(p){return p.noError?'inherit':p.theme.error;});var ItemExclamation=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject5,function(p){return p.theme.error;});

/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(251);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* AttributeIcons */],null,props.when.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* AttributeIconContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* AttributeIcon */],{type:props.when[0].icon})),props.while.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* AttributeIconContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* AttributeIcon */],{type:props.while[0].icon})),props.then.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* AttributeIconContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* AttributeIcon */],{type:props.then.length>1?__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].MORE_VERTICAL:props.then[0].icon}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["g" /* Description */],null,props.name),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* Control */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* ControlText */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].setUpNow)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* MoreIcon */],{type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].MORE})));});

/***/ }),
/* 2188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AttributeIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AttributeIconContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttributeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Control; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ControlText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MoreIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    border: 1px solid ',';\n    border-radius: 1em;\n    cursor: pointer;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-bottom: 1em;\n    padding: 0;\n    transition: 0.3s;\n\n    &:hover {\n        box-shadow: 0 0 0.5em 0 ',';\n    }\n\n    ',';\n'],['\n    align-items: center;\n    border: 1px solid ',';\n    border-radius: 1em;\n    cursor: pointer;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-bottom: 1em;\n    padding: 0;\n    transition: 0.3s;\n\n    &:hover {\n        box-shadow: 0 0 0.5em 0 ',';\n    }\n\n    ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n\t\tflex-wrap: nowrap;\n        padding: ','em;\n\t'],['\n\t\tflex-wrap: nowrap;\n        padding: ','em;\n\t']),_templateObject3=_taggedTemplateLiteral(['\n    display: flex;\n    flex: 1 0 60%;\n    margin-right: ','em;\n    max-width: ','em;\n    order: 1;\n\n    ',';\n'],['\n    display: flex;\n    flex: 1 0 60%;\n    margin-right: ','em;\n    max-width: ','em;\n    order: 1;\n\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n\t\tflex-basis: 0 0 auto;\n\t'],['\n\t\tflex-basis: 0 0 auto;\n\t']),_templateObject5=_taggedTemplateLiteral(['\n    background-color: ',';\n    border-radius: 100%;\n    height: ','em;\n    margin: ','em;\n    position: relative;\n    width: ','em;\n\n    ',';\n'],['\n    background-color: ',';\n    border-radius: 100%;\n    height: ','em;\n    margin: ','em;\n    position: relative;\n    width: ','em;\n\n    ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n        margin: ','em;\n    '],['\n        margin: ','em;\n    ']),_templateObject7=_taggedTemplateLiteral(['padding: ','em;'],['padding: ','em;']),_templateObject8=_taggedTemplateLiteral(['\n    flex: 1 1 auto;\n    margin: ','em;\n    margin-top: ','em;\n    order: 3;\n\n    ',';\n'],['\n    flex: 1 1 auto;\n    margin: ','em;\n    margin-top: ','em;\n    order: 3;\n\n    ',';\n']),_templateObject9=_taggedTemplateLiteral(['\n        margin: 0 ','em;\n\t\torder: 2;\n\t'],['\n        margin: 0 ','em;\n\t\torder: 2;\n\t']),_templateObject10=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 1 0 30%;\n    justify-content: flex-end;\n    order: 2;\n\n    ',';\n'],['\n    align-items: center;\n    display: flex;\n    flex: 1 0 30%;\n    justify-content: flex-end;\n    order: 2;\n\n    ',';\n']),_templateObject11=_taggedTemplateLiteral(['\n        flex: 0 0 ','em;\n\t\torder: 3;\n\t'],['\n        flex: 0 0 ','em;\n\t\torder: 3;\n\t']),_templateObject12=_taggedTemplateLiteral(['font-size: 0.9em;'],['font-size: 0.9em;']),_templateObject13=_taggedTemplateLiteral(['\n    height: ','em;\n    margin: 0;\n    width: ','em;\n\n    & > g {\n        fill: ',';\n    }\n\n    ',';\n'],['\n    height: ','em;\n    margin: 0;\n    width: ','em;\n\n    & > g {\n        fill: ',';\n    }\n\n    ',';\n']),_templateObject14=_taggedTemplateLiteral(['\n        margin: ','em;\n\t'],['\n        margin: ','em;\n\t']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var size=3;var margin=0.5;var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,function(p){return p.theme.secondaryMedium;},function(p){return p.theme.secondaryMedium;},__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject2,margin));var AttributeIcons=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3,margin,3*(size+2*margin),__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject4));var AttributeIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5,function(p){return p.theme.secondaryLight;},size,margin*0.7,size,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject6,margin));var AttributeIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */])(_templateObject7,size*0.1);var Description=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject8,1.7*margin,0.5*margin,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject9,margin));var Control=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject11,3*size));var ControlText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject12);var MoreIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */])(_templateObject13,size*0.7,size*0.7,function(p){return p.theme.secondaryHeavy;},__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject14,margin));

/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Alert;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__ = __webpack_require__(20);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Alert(_ref){var children=_ref.children,id=_ref.id,_ref$dismissable=_ref.dismissable,dismissable=_ref$dismissable===undefined?false:_ref$dismissable,onDismiss=_ref.onDismiss,type=_ref.type,props=_objectWithoutProperties(_ref,['children','id','dismissable','onDismiss','type']);var isError=type===__WEBPACK_IMPORTED_MODULE_2__core_constants__["a" /* alerts */].types.ERROR;var isSuccess=type===__WEBPACK_IMPORTED_MODULE_2__core_constants__["a" /* alerts */].types.SUCCESS;var isWarning=type===__WEBPACK_IMPORTED_MODULE_2__core_constants__["a" /* alerts */].types.WARNING;var iconTypeMap=new Map([[true,__WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__["a" /* default */].INFO],[isError,__WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__["a" /* default */].EXCLAMATION],[isSuccess,__WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__["a" /* default */].TICK_ONE]]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* AlertContainer */],Object.assign({},props,{error:isError,success:isSuccess,warning:isWarning}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* IconContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* AlertIcon */],{type:iconTypeMap.get(true)})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* Message */],null,children),dismissable&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Close */],{onClick:function onClick(){return onDismiss&&typeof id==='number'&&onDismiss(id);},type:'button'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* IconContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* AlertIcon */],{type:__WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__["a" /* default */].CLOSE}))));}

/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlertContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Message; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Close; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AlertIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(70);
var _templateObject=_taggedTemplateLiteral(['\n    background-color: ',';\n    color: ',';\n    display: flex;\n    min-height: 3rem;\n    border-radius: 2px;\n\n    & a {\n        color: ',';\n        text-decoration: underline;\n    }\n'],['\n    background-color: ',';\n    color: ',';\n    display: flex;\n    min-height: 3rem;\n    border-radius: 2px;\n\n    & a {\n        color: ',';\n        text-decoration: underline;\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 0 0 3rem;\n    justify-content: center;\n'],['\n    align-items: center;\n    display: flex;\n    flex: 0 0 3rem;\n    justify-content: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 1 1 auto;\n    padding-left: 1rem;\n'],['\n    align-items: center;\n    display: flex;\n    flex: 1 1 auto;\n    padding-left: 1rem;\n']),_templateObject4=_taggedTemplateLiteral(['\n    align-items: center;\n    background: transparent;\n    border: none;\n    color: ',';\n    cursor: pointer;\n    display: flex;\n    flex: 0 0 3rem;\n    justify-content: center;\n    padding: 0;\n\n    &:hover,\n    &:focus {\n        background: ',';\n    }\n\n    &:active {\n        background: ',';\n    }\n'],['\n    align-items: center;\n    background: transparent;\n    border: none;\n    color: ',';\n    cursor: pointer;\n    display: flex;\n    flex: 0 0 3rem;\n    justify-content: center;\n    padding: 0;\n\n    &:hover,\n    &:focus {\n        background: ',';\n    }\n\n    &:active {\n        background: ',';\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    height: ',';\n    width: ',';\n\n    & g {\n        fill: ',';\n    }\n'],['\n    height: ',';\n    width: ',';\n\n    & g {\n        fill: ',';\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AlertContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(_ref){var error=_ref.error,success=_ref.success,theme=_ref.theme,warning=_ref.warning;var colorMap=new Map([[true,theme.infoColor],[error,theme.error],[success,theme.successColor],[warning,theme.warningColor]]);return colorMap.get(true);},function(_ref2){var theme=_ref2.theme;return theme.white;},function(props){return props.theme.white;});var IconContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);var Message=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3);var Close=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].button(_templateObject4,function(props){return props.theme.white;},function(props){return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["f" /* transparentize */])(0.5,props.theme.white);},function(props){return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["f" /* transparentize */])(0.7,props.theme.white);});var iconSize='1.333333rem';var AlertIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject5,iconSize,iconSize,function(props){return props.theme.white;});

/***/ }),
/* 2191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_products_heating_hotwater_actions__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_app_settings__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_app_settings__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_state_app_settings_selectors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_state_products_thermostat_selectors__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__(2192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment_timezone__);
// @noflow
var mapStateToProps=function mapStateToProps(state,_ref){var id=_ref.id;var getProductItemById=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_products_selectors__["P" /* makeGetProductItemById */])();var controlMode=Object(__WEBPACK_IMPORTED_MODULE_8__core_state_products_thermostat_selectors__["p" /* getThermostatControlMode */])(state,{id:id});var cookieDuration=Object(__WEBPACK_IMPORTED_MODULE_6__core_state_app_settings_selectors__["a" /* getAppSetting */])(state,Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_app_settings__["a" /* buildKey */])(__WEBPACK_IMPORTED_MODULE_3__core_constants_app_settings__["a" /* BOOST_DURATION */],controlMode,id));var defaultDuration=Object(__WEBPACK_IMPORTED_MODULE_7__core_state_config_selectors__["a" /* getConfig */])(state,'products:hotwater:defaultBoostDuration');var selectedTime=parseInt(cookieDuration||defaultDuration,10);var product=getProductItemById(state,{id:id});var loadedAt=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_products_selectors__["F" /* getProductsLoadedAt */])(state);var remaining=product.getIn(['state','boost']);var elapsed=__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()().diff(loadedAt,'minutes');var duration=Math.max(0,remaining-elapsed);if(!duration){Object(__WEBPACK_IMPORTED_MODULE_2__core_state_products_heating_hotwater_actions__["f" /* timeoutBoostHeatingHotwater */])({productId:id});}return{selectedTime:selectedTime,duration:duration,showDropDown:false,controlMode:controlMode.toLowerCase()};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var id=_ref2.id;return{setBoost:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default()(dispatch,function(duration,controlMode){return Object(__WEBPACK_IMPORTED_MODULE_2__core_state_products_heating_hotwater_actions__["a" /* setBoostHeatingHotwater */])({productId:id,duration:duration,controlMode:controlMode,loadedAt:new Date()});})};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* default */]));

/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_decorators_interval_update__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_boost_intl__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_utils_numbers__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__spinner_spinner_component__ = __webpack_require__(252);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Boost=function(_React$Component){_inherits(Boost,_React$Component);function Boost(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Boost);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Boost.__proto__||Object.getPrototypeOf(Boost)).call.apply(_ref,[this].concat(args))),_this),_this.state={boostCaptions:[],boostOptions:[],showDropDown:false},_this.toggleDropdown=function(){return _this.setState({showDropDown:!_this.state.showDropDown});},_this.setBoostFromIndex=function(index){var _this$props=_this.props,controlMode=_this$props.controlMode,setBoost=_this$props.setBoost;var boostOptions=_this.state.boostOptions;var value=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default()([index,'value'],boostOptions);setBoost(value,controlMode);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Boost,[{key:'componentWillMount',value:function componentWillMount(){var intl=this.props.intl;var boostOptions=[{value:30,caption:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_boost_intl__["a" /* default */].thirtyMinutes)},{value:60,caption:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_boost_intl__["a" /* default */].oneHour)},{value:120,caption:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_boost_intl__["a" /* default */].twoHours)},{value:180,caption:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_boost_intl__["a" /* default */].threeHours)},{value:240,caption:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_boost_intl__["a" /* default */].fourHours)},{value:300,caption:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_boost_intl__["a" /* default */].fiveHours)},{value:360,caption:intl.formatMessage(__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_boost_intl__["a" /* default */].sixHours)}];var boostCaptions=boostOptions.map(function(opt){return opt.caption;});this.setState({boostCaptions:boostCaptions,boostOptions:boostOptions});}},{key:'render',value:function render(){var _props=this.props,selectedTime=_props.selectedTime,duration=_props.duration;var _state=this.state,boostCaptions=_state.boostCaptions,boostOptions=_state.boostOptions,showDropDown=_state.showDropDown;var currentIndex=boostOptions.findIndex(function(opt){return opt.value===selectedTime;});var hours=Math.floor(duration/60);var minutes=duration%60;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* BoostContainer */],{'data-qa':'boost-base'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* BoostHeader */],{'data-qa':'boost-timer-current',onClick:this.toggleDropdown},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* BoostTimer */],{'data-qa':'boost-timer'},Object(__WEBPACK_IMPORTED_MODULE_7__core_utils_numbers__["a" /* padNumber */])(Math.max(hours,0)),':',Object(__WEBPACK_IMPORTED_MODULE_7__core_utils_numbers__["a" /* padNumber */])(Math.max(minutes,0))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* DropdownIcon */],{'data-qa':'boost-timer-toggle',type:showDropDown?__WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__["a" /* default */].ARROW_UP:__WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general_svg__["a" /* default */].ARROW_DOWN})),showDropDown&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__spinner_spinner_component__["a" /* default */],{bgColor:{r:255,g:255,b:255},color:{r:47,g:68,b:78},currentIndex:currentIndex,'data-qa':'boost-timer-spinner',font:'Bariol, Arial, sans-serif',handleChangeIndex:this.setBoostFromIndex,rangeValues:boostCaptions,style:{width:'100%',height:'4rem',fontSize:'2rem',marginBottom:'1rem',outline:'none'}}));}}]);return Boost;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__core_decorators_interval_update__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["g" /* injectIntl */])(Boost),1000));

/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoostContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BoostHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BoostTimer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DropdownIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['transition: height 0.5s linear;'],['transition: height 0.5s linear;']),_templateObject2=_taggedTemplateLiteral(['\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    height: 2rem;\n    margin-top: 3rem;\n'],['\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    height: 2rem;\n    margin-top: 3rem;\n']),_templateObject3=_taggedTemplateLiteral(['\n    width: 15%;\n    float: left;\n    text-align: right;\n    margin: 0;\n'],['\n    width: 15%;\n    float: left;\n    text-align: right;\n    margin: 0;\n']),_templateObject4=_taggedTemplateLiteral(['\n    cursor: pointer;\n    height: ',';\n    margin-left: 0.2em;\n    position: relative;\n    top: 0.2em;\n    width: ',';\n'],['\n    cursor: pointer;\n    height: ',';\n    margin-left: 0.2em;\n    position: relative;\n    top: 0.2em;\n    width: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BoostContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject);var BoostHeader=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2);var BoostTimer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h3(_templateObject3);var iconSize='1em';var DropdownIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0__core_icons_svg_icons__["a" /* default */])(_templateObject4,iconSize,iconSize);

/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({autoTitle:{id:'hotwater.boost.auto-title',defaultMessage:'Boost'},heatTitle:{id:'hotwater.boost.heat-title',defaultMessage:'Boost'},coolTitle:{id:'hotwater.boost.cool-title',defaultMessage:'Boost'},thirtyMinutes:{id:'hotwater.boost.thirty-minutes',defaultMessage:'30 minutes'},oneHour:{id:'hotwater.boost.one-hour',defaultMessage:'01 hour'},twoHours:{id:'hotwater.boost.two-hours',defaultMessage:'02 hours'},threeHours:{id:'hotwater.boost.three-hours',defaultMessage:'03 hours'},fourHours:{id:'hotwater.boost.four-hours',defaultMessage:'04 hours'},fiveHours:{id:'hotwater.boost.five-hours',defaultMessage:'05 hours'},sixHours:{id:'hotwater.boost.six-hours',defaultMessage:'06 hours'}}));

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(52);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Hamster.js v1.1.2
 * (c) 2013 Monospaced http://monospaced.com
 * License: MIT
 */

(function(window, document){
'use strict';

/**
 * Hamster
 * use this to create instances
 * @returns {Hamster.Instance}
 * @constructor
 */
var Hamster = function(element) {
  return new Hamster.Instance(element);
};

// default event name
Hamster.SUPPORT = 'wheel';

// default DOM methods
Hamster.ADD_EVENT = 'addEventListener';
Hamster.REMOVE_EVENT = 'removeEventListener';
Hamster.PREFIX = '';

// until browser inconsistencies have been fixed...
Hamster.READY = false;

Hamster.Instance = function(element){
  if (!Hamster.READY) {
    // fix browser inconsistencies
    Hamster.normalise.browser();

    // Hamster is ready...!
    Hamster.READY = true;
  }

  this.element = element;

  // store attached event handlers
  this.handlers = [];

  // return instance
  return this;
};

/**
 * create new hamster instance
 * all methods should return the instance itself, so it is chainable.
 * @param   {HTMLElement}       element
 * @returns {Hamster.Instance}
 * @constructor
 */
Hamster.Instance.prototype = {
  /**
   * bind events to the instance
   * @param   {Function}    handler
   * @param   {Boolean}     useCapture
   * @returns {Hamster.Instance}
   */
  wheel: function onEvent(handler, useCapture){
    Hamster.event.add(this, Hamster.SUPPORT, handler, useCapture);

    // handle MozMousePixelScroll in older Firefox
    if (Hamster.SUPPORT === 'DOMMouseScroll') {
      Hamster.event.add(this, 'MozMousePixelScroll', handler, useCapture);
    }

    return this;
  },

  /**
   * unbind events to the instance
   * @param   {Function}    handler
   * @param   {Boolean}     useCapture
   * @returns {Hamster.Instance}
   */
  unwheel: function offEvent(handler, useCapture){
    // if no handler argument,
    // unbind the last bound handler (if exists)
    if (handler === undefined && (handler = this.handlers.slice(-1)[0])) {
      handler = handler.original;
    }

    Hamster.event.remove(this, Hamster.SUPPORT, handler, useCapture);

    // handle MozMousePixelScroll in older Firefox
    if (Hamster.SUPPORT === 'DOMMouseScroll') {
      Hamster.event.remove(this, 'MozMousePixelScroll', handler, useCapture);
    }

    return this;
  }
};

Hamster.event = {
  /**
   * cross-browser 'addWheelListener'
   * @param   {Instance}    hamster
   * @param   {String}      eventName
   * @param   {Function}    handler
   * @param   {Boolean}     useCapture
   */
  add: function add(hamster, eventName, handler, useCapture){
    // store the original handler
    var originalHandler = handler;

    // redefine the handler
    handler = function(originalEvent){

      if (!originalEvent) {
        originalEvent = window.event;
      }

      // create a normalised event object,
      // and normalise "deltas" of the mouse wheel
      var event = Hamster.normalise.event(originalEvent),
          delta = Hamster.normalise.delta(originalEvent);

      // fire the original handler with normalised arguments
      return originalHandler(event, delta[0], delta[1], delta[2]);

    };

    // cross-browser addEventListener
    hamster.element[Hamster.ADD_EVENT](Hamster.PREFIX + eventName, handler, useCapture || false);

    // store original and normalised handlers on the instance
    hamster.handlers.push({
      original: originalHandler,
      normalised: handler
    });
  },

  /**
   * removeWheelListener
   * @param   {Instance}    hamster
   * @param   {String}      eventName
   * @param   {Function}    handler
   * @param   {Boolean}     useCapture
   */
  remove: function remove(hamster, eventName, handler, useCapture){
    // find the normalised handler on the instance
    var originalHandler = handler,
        lookup = {},
        handlers;
    for (var i = 0, len = hamster.handlers.length; i < len; ++i) {
      lookup[hamster.handlers[i].original] = hamster.handlers[i];
    }
    handlers = lookup[originalHandler];
    handler = handlers.normalised;

    // cross-browser removeEventListener
    hamster.element[Hamster.REMOVE_EVENT](Hamster.PREFIX + eventName, handler, useCapture || false);

    // remove original and normalised handlers from the instance
    for (var h in hamster.handlers) {
      if (hamster.handlers[h] == handlers) {
        hamster.handlers.splice(h, 1);
        break;
      }
    }
  }
};

/**
 * these hold the lowest deltas,
 * used to normalise the delta values
 * @type {Number}
 */
var lowestDelta,
    lowestDeltaXY;

Hamster.normalise = {
  /**
   * fix browser inconsistencies
   */
  browser: function normaliseBrowser(){
    // detect deprecated wheel events
    if (!('onwheel' in document || document.documentMode >= 9)) {
      Hamster.SUPPORT = document.onmousewheel !== undefined ?
                        'mousewheel' : // webkit and IE < 9 support at least "mousewheel"
                        'DOMMouseScroll'; // assume remaining browsers are older Firefox
    }

    // detect deprecated event model
    if (!window.addEventListener) {
      // assume IE < 9
      Hamster.ADD_EVENT = 'attachEvent';
      Hamster.REMOVE_EVENT = 'detachEvent';
      Hamster.PREFIX = 'on';
    }

  },

  /**
   * create a normalised event object
   * @param   {Function}    originalEvent
   * @returns {Object}      event
   */
   event: function normaliseEvent(originalEvent){
    var event = {
          // keep a reference to the original event object
          originalEvent: originalEvent,
          target: originalEvent.target || originalEvent.srcElement,
          type: 'wheel',
          deltaMode: originalEvent.type === 'MozMousePixelScroll' ? 0 : 1,
          deltaX: 0,
          delatZ: 0,
          preventDefault: function(){
            if (originalEvent.preventDefault) {
              originalEvent.preventDefault();
            } else {
              originalEvent.returnValue = false;
            }
          },
          stopPropagation: function(){
            if (originalEvent.stopPropagation) {
              originalEvent.stopPropagation();
            } else {
              originalEvent.cancelBubble = false;
            }
          }
        };

    // calculate deltaY (and deltaX) according to the event

    // 'mousewheel'
    if (originalEvent.wheelDelta) {
      event.deltaY = - 1/40 * originalEvent.wheelDelta;
    }
    // webkit
    if (originalEvent.wheelDeltaX) {
      event.deltaX = - 1/40 * originalEvent.wheelDeltaX;
    }

    // 'DomMouseScroll'
    if (originalEvent.detail) {
      event.deltaY = originalEvent.detail;
    }

    return event;
  },

  /**
   * normalise 'deltas' of the mouse wheel
   * @param   {Function}    originalEvent
   * @returns {Array}       deltas
   */
  delta: function normaliseDelta(originalEvent){
    var delta = 0,
      deltaX = 0,
      deltaY = 0,
      absDelta = 0,
      absDeltaXY = 0,
      fn;

    // normalise deltas according to the event

    // 'wheel' event
    if (originalEvent.deltaY) {
      deltaY = originalEvent.deltaY * -1;
      delta  = deltaY;
    }
    if (originalEvent.deltaX) {
      deltaX = originalEvent.deltaX;
      delta  = deltaX * -1;
    }

    // 'mousewheel' event
    if (originalEvent.wheelDelta) {
      delta = originalEvent.wheelDelta;
    }
    // webkit
    if (originalEvent.wheelDeltaY) {
      deltaY = originalEvent.wheelDeltaY;
    }
    if (originalEvent.wheelDeltaX) {
      deltaX = originalEvent.wheelDeltaX * -1;
    }

    // 'DomMouseScroll' event
    if (originalEvent.detail) {
      delta = originalEvent.detail * -1;
    }

    // Don't return NaN
    if (delta === 0) {
      return [0, 0, 0];
    }

    // look for lowest delta to normalize the delta values
    absDelta = Math.abs(delta);
    if (!lowestDelta || absDelta < lowestDelta) {
      lowestDelta = absDelta;
    }
    absDeltaXY = Math.max(Math.abs(deltaY), Math.abs(deltaX));
    if (!lowestDeltaXY || absDeltaXY < lowestDeltaXY) {
      lowestDeltaXY = absDeltaXY;
    }

    // convert deltas to whole numbers
    fn = delta > 0 ? 'floor' : 'ceil';
    delta  = Math[fn](delta / lowestDelta);
    deltaX = Math[fn](deltaX / lowestDeltaXY);
    deltaY = Math[fn](deltaY / lowestDeltaXY);

    return [delta, deltaX, deltaY];
  }
};

if (typeof window.define === 'function' && window.define.amd) {
  // AMD
  window.define('hamster', [], function(){
    return Hamster;
  });
} else if (true) {
  // CommonJS
  module.exports = Hamster;
} else {
  // Browser global
  window.Hamster = Hamster;
}

})(window, window.document);


/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fonts_bariol_regular_ttf__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fonts_bariol_regular_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_fonts_bariol_regular_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_custom_prop_types__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_themes_main__ = __webpack_require__(78);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var FONT_DEF='Arial, sans-serif';var FONT_SIZE_COEF=0.35;var USABLE_HEIGHT_COEF=0.65;/*** Helper functions ***/var _getYPosAccordingToRatio=function _getYPosAccordingToRatio(height,ratio){return height/2*(1+Math.sin(ratio*Math.PI)*USABLE_HEIGHT_COEF);};var _getFactorAccordingToRatio=function _getFactorAccordingToRatio(ratio){return(Math.cos(ratio*Math.PI)+1)/2;};var _getColor=function _getColor(color){return'rgb('+color.r+', '+color.g+', '+color.b+')';};var _getColorWithOpacity=function _getColorWithOpacity(color,opacity){return'rgba('+color.r+', '+color.g+', '+color.b+', '+opacity+')';};var _getStyleAccordingToRangeColor=function _getStyleAccordingToRangeColor(displayFloatIndex,rangeColors){// when a float index is between 2 colors it will generated a colour which is propotional to the index value
// e.g. displayFloatIndex = 1.25 will have 75% from rangeColours[1] and 25% from rangeColours[2]
var colorOffset=displayFloatIndex%1;var colorIndex=Math.max(Math.floor(displayFloatIndex),0);var thisColor=rangeColors[colorIndex];var nextColor=rangeColors[colorIndex+1];if(!nextColor){nextColor=thisColor;}var calculateColor={r:Math.round(thisColor.r+(nextColor.r-thisColor.r)*colorOffset),g:Math.round(thisColor.g+(nextColor.g-thisColor.g)*colorOffset),b:Math.round(thisColor.b+(nextColor.b-thisColor.b)*colorOffset)};return _getColor(calculateColor);};var _normalizeValue=function _normalizeValue(value){return(typeof value==='undefined'?'undefined':_typeof(value))==='object'?value:[{text:value,coef:1}];};var _calculateTextWidth=function _calculateTextWidth(ctx,font,fontSize,v){ctx.font=fontSize*v.coef+'px '+(v.font||font||FONT_DEF);return ctx.measureText(v.text).width;};var _displayValue=function _displayValue(ctx,font,fontSize,value,xPosition,y){ctx.font=fontSize*value.coef+'px '+(value.font||font||FONT_DEF);ctx.fillText(value.text,xPosition,y+fontSize/3);};/*** Component ***/var SpinnerValue=function(_React$Component){_inherits(SpinnerValue,_React$Component);function SpinnerValue(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SpinnerValue);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SpinnerValue.__proto__||Object.getPrototypeOf(SpinnerValue)).call.apply(_ref,[this].concat(args))),_this),_this.state={fontLoaded:false},_this.displayValue=function(ratio,value){var _this$props=_this.props,color=_this$props.color,ctx=_this$props.ctx,font=_this$props.font,height=_this$props.height,width=_this$props.width;var y=_getYPosAccordingToRatio(height,ratio);var factor=_getFactorAccordingToRatio(ratio);var fontSize=factor*height*FONT_SIZE_COEF;var normalizedValue=_normalizeValue(value);var widths=normalizedValue.map(function(value){return _calculateTextWidth(ctx,font,fontSize,value);});var fullTextWidth=widths.reduce(function(a,b){return a+b;});ctx.fillStyle=_getColorWithOpacity(color,factor);var xPosition=(width-fullTextWidth)/2;normalizedValue.forEach(function(v,i){_displayValue(ctx,font,fontSize,v,xPosition,y);xPosition+=widths[i];});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SpinnerValue,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _props$loadFont,loadFont,myFont;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props$loadFont=this.props.loadFont,loadFont=_props$loadFont===undefined?true:_props$loadFont;this._mounted=true;if(!(loadFont&&window.FontFace)){_context.next=8;break;}myFont=new FontFace('Bariol','url('+__WEBPACK_IMPORTED_MODULE_1__assets_fonts_bariol_regular_ttf___default.a+')');_context.next=6;return myFont.load();case 6:if(this._mounted){_context.next=8;break;}return _context.abrupt('return');case 8:this.setState({fontLoaded:true});case 9:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){this._mounted=false;}},{key:'componentDidUpdate',value:function componentDidUpdate(){var _this2=this;var _props=this.props,bgColor=_props.bgColor,ctx=_props.ctx,height=_props.height,displayFloatIndex=_props.displayFloatIndex,isLoop=_props.isLoop,rangeColors=_props.rangeColors,rangeValues=_props.rangeValues,visibilityCoef=_props.visibilityCoef,width=_props.width,disabled=_props.disabled;var fontLoaded=this.state.fontLoaded;// don't do anything until the ctx is loaded
if(!ctx||!fontLoaded){return null;}ctx.fillStyle=disabled?__WEBPACK_IMPORTED_MODULE_5__core_themes_main__["a" /* default */].mediumGrey:rangeColors?_getStyleAccordingToRangeColor(displayFloatIndex,rangeColors):_getColor(bgColor);ctx.fillRect(0,0,width,height);var rangeToFilter=isLoop?[].concat(_toConsumableArray(rangeValues),_toConsumableArray(rangeValues),_toConsumableArray(rangeValues)):rangeValues;var valuesToShow=rangeToFilter.map(function(value,index){return{value:value,index:isLoop?index-rangeValues.length:index};}).filter(function(o){return Math.abs(displayFloatIndex-o.index)<visibilityCoef;});valuesToShow.forEach(function(o){_this2.displayValue((o.index-displayFloatIndex)/visibilityCoef,o.value);});}},{key:'render',value:function render(){return null;}}]);return SpinnerValue;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);SpinnerValue.propTypes={bgColor:__WEBPACK_IMPORTED_MODULE_2__core_utils_custom_prop_types__["a" /* colorProptype */],color:__WEBPACK_IMPORTED_MODULE_2__core_utils_custom_prop_types__["a" /* colorProptype */],ctx:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,displayFloatIndex:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,font:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,height:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,isLoop:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,rangeColors:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,rangeValues:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,visibilityCoef:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,width:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number};SpinnerValue.defaultProps={bgColor:{r:180,g:180,b:180},color:{r:255,g:255,b:255},isLoop:false,rangeValues:[],visibilityCoef:1.8};/* harmony default export */ __webpack_exports__["a"] = (SpinnerValue);

/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//Brand Colours
var black='rgb(0, 0, 0)';//#000000
var brandActive='rgb(255, 122, 0)';//#FF7A00
var brandBlock='rgb(41, 66, 76)';//#29424C
var grey='rgb(47, 68, 78)';//#2F444E
var paleGrey='rgb(251, 251, 251)';//#FBFBFB
var secondaryBase='rgb(104, 129, 137)';//#688189
var secondaryHeavy='rgb(165, 171, 175)';//#A5ABAF
var secondaryLight='rgb(247, 248, 249)';//#F7F8F9
var secondaryMedium='rgb(209, 212, 211)';//#D1D4D3
var white='rgb(255, 255, 255)';//#FFFFFF
var coolBlue='rgb(0, 165, 165)';//#00A5A5
var coldBlue='rgb(69, 180, 255)';//#45B4FF
var fontColor=brandBlock;var footerLinkColor='rgb(122, 129, 134)';//#7A8186
var greyBlue='rgb(42, 66, 75)';//#2A424B
var turqoise='rgb(61, 232, 170)';//#3DE8AA
var linkColor='rgb(37, 122, 124)';//#257A7C
var secondaryLinkColor='rgb(37, 122, 124)';//#257A7C
var vermillion='rgb(231, 45, 65)';//#E72D41
var primaryBtnColor=brandActive;var primaryBtnColorBusy='rgb(255, 155, 64)';//#FF9B40
var primaryBtnColorDisabled='rgb(251, 226, 205)';//#FBE2CD
var primaryBtnColorHover='rgb(255, 109, 0)';//#FF6D00
var primaryBtnColorError='rgb(227, 77, 51)';//#E34D33
var productBorderColor='rgb(241, 241, 241)';// #f1f1f1
var frenchGrey='rgb(200, 199, 204)';//#C8C7CC
var iron='rgb(204, 210, 214)';//#CCD2D6
var pickledBluewood='rgb(51, 73, 91)';//#33495B
var shuttleGrey='rgb(92, 109, 124)';//#5C6D7C
var productStateBorderOn='1px solid '+secondaryMedium;// alert bar colours
var infoColor='rgb(61, 97, 232)';//#3d61e8
var successColor='rgb(162, 198, 23)';//#A2C617
var warningColor='rgb(72, 171, 159)';//#48AB9F
/* harmony default export */ __webpack_exports__["a"] = ({//primary colours
mainBrandColor:brandActive,secondaryColor:brandBlock,white:white,black:black,secondaryHeavy:secondaryHeavy,secondaryMedium:secondaryMedium,secondaryLight:secondaryLight,dashboardOfflineColor:secondaryBase,footerColor:brandBlock,footerBackground:brandBlock,footerLink:footerLinkColor,primaryFontColor:grey,linkColor:linkColor,cooling:coolBlue,coldTempBlue:coldBlue,turqoise:turqoise,heating:brandActive,productBorderColor:productBorderColor,frenchGrey:frenchGrey,iron:iron,pickledBluewood:pickledBluewood,shuttleGrey:shuttleGrey,secondaryLinkColor:secondaryLinkColor,fontColor:fontColor,error:vermillion,infoColor:infoColor,successColor:successColor,warningColor:warningColor,// greys
grey:grey,secondaryBase:secondaryBase,heavyGrey:secondaryHeavy,mediumGrey:secondaryMedium,lightGrey:secondaryLight,paleGrey:paleGrey,offlineGrey:secondaryMedium,fadedGrey:secondaryLight,blueyGrey:greyBlue,// borders
flipperBorder:productStateBorderOn,// not sure this variable should be there
// button colours
primaryBtnColors:{default:primaryBtnColor,busy:primaryBtnColorBusy,disabled:primaryBtnColorDisabled,hover:primaryBtnColorHover,error:primaryBtnColorError},// measurments
headerHeightRem:4,headerHeightDesktopRem:6,infoBarHeight:'3em',menuSubItemsContainer:'1px',mobileMenuWidth:'16rem',// layout
viewportMinWidth:'22.85714em'/* 320px width of an iPhone 4/5 *//*calc(320px / var(--mobile-font-size));*/,layoutMaxWidth:'60rem',// font sizes
mobileFontSize:'14px',tabletFontSize:'16px',desktopFontSize:'18px'});

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BoostRings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
// @noflow
function BoostRings(_ref){var mode=_ref.mode;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* BoostRingsContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* BoostRingsInner */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* BoostRingsInnerInner */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* BoostRingsList */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["e" /* BoostRingsRing1 */],{mode:mode}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["f" /* BoostRingsRing2 */],{mode:mode}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["g" /* BoostRingsRing3 */],{mode:mode}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["h" /* BoostRingsRing4 */],{mode:mode})))));}BoostRings.propTypes={mode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};

/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoostRingsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BoostRingsInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BoostRingsInnerInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BoostRingsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BoostRingsRing1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BoostRingsRing2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BoostRingsRing3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BoostRingsRing4; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_animations__ = __webpack_require__(273);
var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    user-select: none;\n'],['\n    position: relative;\n    user-select: none;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n'],['\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    text-align: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n    position: relative;\n    display: inline-block;\n    line-height: 0;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n'],['\n    position: relative;\n    display: inline-block;\n    line-height: 0;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n']),_templateObject4=_taggedTemplateLiteral(['\n    margin: 0;\n    padding: 0 0 100%;\n    width: 100%;\n'],['\n    margin: 0;\n    padding: 0 0 100%;\n    width: 100%;\n']),_templateObject5=_taggedTemplateLiteral(['\n    position: absolute;\n    display: block;\n    width: 120%;\n    height: 120%;\n    top: -10%;\n    left: -10%;\n    border: 1px solid;\n    border-color: ',';\n    background-color: transparent;\n    border-radius: 50%;\n    opacity: 0;\n    box-sizing: content-box;\n    animation: 4s ',' infinite linear;\n'],['\n    position: absolute;\n    display: block;\n    width: 120%;\n    height: 120%;\n    top: -10%;\n    left: -10%;\n    border: 1px solid;\n    border-color: ',';\n    background-color: transparent;\n    border-radius: 50%;\n    opacity: 0;\n    box-sizing: content-box;\n    animation: 4s ',' infinite linear;\n']),_templateObject6=_taggedTemplateLiteral(['animation-delay: 0;'],['animation-delay: 0;']),_templateObject7=_taggedTemplateLiteral(['animation-delay: 1s;'],['animation-delay: 1s;']),_templateObject8=_taggedTemplateLiteral(['animation-delay: 2s;'],['animation-delay: 2s;']),_templateObject9=_taggedTemplateLiteral(['animation-delay: 3s;'],['animation-delay: 3s;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BoostRingsContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var BoostRingsInner=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);var BoostRingsInnerInner=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3);var BoostRingsList=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4);var BoostRingsRing=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,function(props){return props.mode==='cool'?props.theme.coldTempBlue:props.theme.mainBrandColor;},__WEBPACK_IMPORTED_MODULE_1__core_constants_animations__["c" /* expandFadeOut */]);var BoostRingsRing1=BoostRingsRing.extend(_templateObject6);var BoostRingsRing2=BoostRingsRing.extend(_templateObject7);var BoostRingsRing3=BoostRingsRing.extend(_templateObject8);var BoostRingsRing4=BoostRingsRing.extend(_templateObject9);

/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bounce; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_animations__ = __webpack_require__(273);
var _templateObject=_taggedTemplateLiteral(['\n    animation: ',';\n    height: ',';\n    padding-bottom: ',';\n    pointer-events: ',';\n    transition: all 0.3 ease-in;\n    user-select: none;\n    width: 100%;\n    border-radius: 100%;\n'],['\n    animation: ',';\n    height: ',';\n    padding-bottom: ',';\n    pointer-events: ',';\n    transition: all 0.3 ease-in;\n    user-select: none;\n    width: 100%;\n    border-radius: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Bounce=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){var animationMap=new Map([[true,'none'],[props.bounce,__WEBPACK_IMPORTED_MODULE_1__core_constants_animations__["a" /* bounceEffect */]+' 1s ease-in-out infinite'],[props.finishBounce,__WEBPACK_IMPORTED_MODULE_1__core_constants_animations__["e" /* finishBounceEffect */]+' 1s ease-in-out']]);return animationMap.get(true);},function(p){return p.usePadding?'0':'100%';},function(p){return p.usePadding?'100%':'0';},function(p){return p.bounce?'none':'inherit';});

/***/ }),
/* 2202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_component_css__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__calendar_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_velocity_animate_velocity_ui__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_velocity_animate_velocity_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_velocity_animate_velocity_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_velocity_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__month_calendar_month_component__ = __webpack_require__(2204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var SlideRight={// Register these with UI Pack so that we can use stagger later.
In:__WEBPACK_IMPORTED_MODULE_3_velocity_react__["velocityHelpers"].registerEffect({calls:[[{translateX:['0%','120%']},1,{easing:'ease-out'}]]}),Out:__WEBPACK_IMPORTED_MODULE_3_velocity_react__["velocityHelpers"].registerEffect({calls:[[{translateX:['-120%','0%']},1,{easing:'ease-out'}]]})};var SlideLeft={// Register these with UI Pack so that we can use stagger later.
In:__WEBPACK_IMPORTED_MODULE_3_velocity_react__["velocityHelpers"].registerEffect({calls:[[{translateX:['0%','-120%']},1,{easing:'ease-out'}]]}),Out:__WEBPACK_IMPORTED_MODULE_3_velocity_react__["velocityHelpers"].registerEffect({calls:[[{translateX:['120%','0%']},1,{easing:'ease-out'}]]})};var Calendar=function(_Component){_inherits(Calendar,_Component);function Calendar(props,context){_classCallCheck(this,Calendar);var _this=_possibleConstructorReturn(this,(Calendar.__proto__||Object.getPrototypeOf(Calendar)).call(this,props,context));_initialiseProps.call(_this);var startDate=_this.props.startDate;var dateToRender=startDate||new Date();_this.state={dateToRender:dateToRender,items:['month-'+dateToRender.getMonth()],slideDirection:'none'};return _this;}_createClass(Calendar,[{key:'handleMonthSelected',value:function handleMonthSelected(d){var slideDirection=this.getSlideDirection(this.state.dateToRender.getMonth(),d.getMonth());this.setState({dateToRender:d,items:['month-'+d.getMonth()],slideDirection:slideDirection});}},{key:'getSlideDirection',value:function getSlideDirection(current,next){var slideDirection='none';if(next===11&&current===0){slideDirection='left';}else if(next===0&&current===11){slideDirection='right';}else if(next<current){slideDirection='left';}else if(next>current){slideDirection='right';}return slideDirection;}},{key:'render',value:function render(){var _props=this.props,startDate=_props.startDate,endDate=_props.endDate,displaySingleActive=_props.displaySingleActive,handleDateSelected=_props.handleDateSelected;var _state=this.state,dateToRender=_state.dateToRender,slideDirection=_state.slideDirection;var monthId=parseInt(dateToRender.getMonth(),10);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'calendar'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'calendar__month-blocker-left'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'calendar__month-blocker-right'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'calendar__left-click','data-qa':'calendar-left',onClick:this.showPrevious},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'general-icon__left'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'calendar__right-click','data-qa':'calendar-right',onClick:this.showNext},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'general-icon__right'})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_velocity_react__["VelocityTransitionGroup"],{className:'calendar__container',component:'div',enter:{animation:(slideDirection==='left'?SlideLeft:SlideRight).In,duration:500},leave:{animation:(slideDirection==='left'?SlideLeft:SlideRight).Out,duration:500}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__month_calendar_month_component__["a" /* default */],{className:'calendar__month',dateToRender:dateToRender,displaySingleActive:displaySingleActive,endDate:endDate,fixedMonth:monthId,handleDateSelected:handleDateSelected,key:'month-'+monthId,startDate:startDate})));}}]);return Calendar;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);Calendar.propTypes={displaySingleActive:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,endDate:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(Date),handleDateSelected:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,startDate:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.instanceOf(Date)};var _initialiseProps=function _initialiseProps(){var _this2=this;this.showPrevious=function(){var dateToRender=_this2.state.dateToRender;_this2.handleMonthSelected(__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(dateToRender).subtract(1,'month').toDate());};this.showNext=function(){var dateToRender=_this2.state.dateToRender;_this2.handleMonthSelected(__WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()(dateToRender).add(1,'month').toDate());};};/* harmony default export */ __webpack_exports__["a"] = (Calendar);

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_month_component_css__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_month_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__calendar_month_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__days_calendar_days_component__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_instadate__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_instadate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_instadate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var CalendarMonth=function(_React$Component){_inherits(CalendarMonth,_React$Component);function CalendarMonth(){_classCallCheck(this,CalendarMonth);return _possibleConstructorReturn(this,(CalendarMonth.__proto__||Object.getPrototypeOf(CalendarMonth)).apply(this,arguments));}_createClass(CalendarMonth,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var nextDate=nextProps.dateToRender;var _props=this.props,currentDate=_props.dateToRender,fixedMonth=_props.fixedMonth;//// fixedMonth is used to force the calendar days component to not re-render a new month
if(fixedMonth!==undefined){if(fixedMonth===nextDate.getMonth()&&Object(__WEBPACK_IMPORTED_MODULE_4_instadate__["isSameMonth"])(nextDate,currentDate)){return true;}return false;}return true;}},{key:'render',value:function render(){var _props2=this.props,dateToRender=_props2.dateToRender,startDate=_props2.startDate,endDate=_props2.endDate,handleDateSelected=_props2.handleDateSelected,className=_props2.className,displaySingleActive=_props2.displaySingleActive;return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('calendar-month',className)},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('h3',{className:'calendar-month__month'},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('span',{'data-qa':'calendar-month'},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedDate */],{month:'short',value:dateToRender})),'\xA0',__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('span',{className:'calendar-month__year','data-qa':'calendar-year'},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["a" /* FormattedDate */],{value:dateToRender,year:'numeric'}))),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__days_calendar_days_component__["a" /* default */],{dateToRender:dateToRender,displaySingleActive:displaySingleActive,endDate:endDate,handleDateSelected:handleDateSelected,startDate:startDate}));}}]);return CalendarMonth;}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);CalendarMonth.propTypes={className:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,dateToRender:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,displaySingleActive:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,endDate:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(Date),fixedMonth:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,handleDateSelected:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,startDate:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.instanceOf(Date)};/* harmony default export */ __webpack_exports__["a"] = (CalendarMonth);

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CalendarDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_days_component_css__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__calendar_days_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__calendar_days_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_instadate__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_instadate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_instadate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var CalendarDays=function(_React$Component){_inherits(CalendarDays,_React$Component);function CalendarDays(){_classCallCheck(this,CalendarDays);return _possibleConstructorReturn(this,(CalendarDays.__proto__||Object.getPrototypeOf(CalendarDays)).apply(this,arguments));}_createClass(CalendarDays,[{key:'getHeader',value:function getHeader(){var start=new Date(0);var headings=[];for(var dayOfWeek=1;dayOfWeek<8;dayOfWeek++){var date=new Date(0);date.setDate(start.getDate()+dayOfWeek-start.getDay());headings.push(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('li',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__heading-day'),key:'day-heading-'+dayOfWeek},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedDate */],{value:date,weekday:'narrow'})));}return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('ul',{className:'calendar-days__header'},headings);}},{key:'getBody',value:function getBody(){var dateToRender=this.props.dateToRender;var lastDayOfMonth=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["lastDateInMonth"])(dateToRender);var daysInMonth=lastDayOfMonth.getDate();var firstWeekDay=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["firstDateInMonth"])(dateToRender).getDay();var days=[];if(firstWeekDay!==1){if(firstWeekDay===0){firstWeekDay=7;}var prevMonth=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["addDays"])(Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["firstDateInMonth"])(dateToRender),-1);var prevMonthLastDate=prevMonth.getDate();var prevMonthLastDay=prevMonth.getDay()===0?7:prevMonth.getDay();var prevMonthLastMonday=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["addDays"])(Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["firstDateInMonth"])(dateToRender),-prevMonthLastDay);for(var i=prevMonthLastMonday.getDate();i<prevMonthLastDate+1;i++){var d=new Date(prevMonth);d.setDate(i);days.push(this.getDay(d));}}var firstDayOfMonth=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["firstDateInMonth"])(dateToRender);for(var _i=0;_i<daysInMonth;_i++){var _d=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["addDays"])(firstDayOfMonth,_i);days.push(this.getDay(_d));}var nextMonth=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["addMonths"])(dateToRender,1);var firstDayNextMonth=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["firstDateInMonth"])(nextMonth);var nextMonthFirstWeekday=firstDayNextMonth.getDay();if(nextMonthFirstWeekday!==1){if(nextMonthFirstWeekday===0){nextMonthFirstWeekday=7;}var index=0;for(var _i2=nextMonthFirstWeekday;_i2<8;_i2++){var _d2=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["addDays"])(firstDayNextMonth,index);days.push(this.getDay(_d2));index++;}}return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('ul',{className:'calendar-days__body'},days);}},{key:'getDay',value:function getDay(d){var displaySingleActive=this.props.displaySingleActive;if(displaySingleActive===null||displaySingleActive===undefined||displaySingleActive===false){return this.getDayRangeActive(d);}else{return this.getDaySingleActive(d);}}},{key:'getDaySingleActive',value:function getDaySingleActive(d){var _props=this.props,dateToRender=_props.dateToRender,formatDate=_props.intl.formatDate,startDate=_props.startDate;var dString=formatDate(d,{day:'2-digit'});var isNotThisMonth=!Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["isSameMonth"])(d,dateToRender);var isSameAsStart=startDate&&Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["isSameDay"])(d,startDate);return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('li',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__day',{'calendar-days__day--active':isSameAsStart},{'calendar-days__day-content__greyed':isNotThisMonth}),key:'calendar-day-'+formatDate(d,{day:'2-digit',month:'2-digit',year:'numeric'}),onClick:this.props.handleDateSelected.bind(this,d)},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{'aria-label':'calendar-day-'+formatDate(d,{day:'2-digit',month:'2-digit',year:'numeric'}),className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__day-content')},dString),isSameAsStart&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__day-content-active')},dString));}},{key:'getDayRangeActive',value:function getDayRangeActive(d){var _props2=this.props,dateToRender=_props2.dateToRender,endDate=_props2.endDate,formatDate=_props2.intl.formatDate,startDate=_props2.startDate;var end=endDate?endDate.getDate():null;var dString=formatDate(d,{day:'2-digit'});var isNotThisMonth=!Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["isSameMonth"])(d,dateToRender);var isSameAsStart=startDate&&Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["isSameDay"])(d,startDate);var isSameAsEnd=endDate&&Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["isSameDay"])(d,endDate);var isAfterStart=startDate&&Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["isDayAfter"])(d,startDate);var isBeforeEnd=endDate&&Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["isDayBefore"])(d,endDate);var currentDate=new Date();var isBeforeCurrentDate=Object(__WEBPACK_IMPORTED_MODULE_1_instadate__["isDayBefore"])(d,currentDate);return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('li',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__day',{'calendar-days__day--start':isSameAsStart||isSameAsEnd},{'calendar-days__day-content__greyed':isNotThisMonth},{'calendar-days__day-content__previous':isBeforeCurrentDate}),'data-qa':isSameAsStart?'calendar-day-start':isSameAsEnd?'calendar-day-end':'calendar-day',key:'calendar-day-'+formatDate(d,{day:'2-digit',month:'2-digit',year:'numeric'}),onClick:this.props.handleDateSelected.bind(this,d)},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{'aria-label':'day-'+formatDate(d,{day:'2-digit'}),className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__day-content',{'calendar-days__day-content-tween':isAfterStart&&isBeforeEnd})},dString),isSameAsStart&&end&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__day-content-pre')}),isSameAsStart&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__day-content-start')},dString),isSameAsEnd&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__day-content-post')}),isSameAsEnd&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()('calendar-days__day-content-end')},dString));}},{key:'getFullComponent',value:function getFullComponent(){return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:'calendar-days'},this.getHeader(),this.getBody());}},{key:'render',value:function render(){return this.getFullComponent();}}]);return CalendarDays;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);CalendarDays.propTypes={dateToRender:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,displaySingleActive:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,endDate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Date),handleDateSelected:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["h" /* intlShape */],startDate:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(Date)};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["g" /* injectIntl */])(CalendarDays));

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order of result values is determined by the
 * order they occur in the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
    : [];
});

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = difference;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (val) {
	return val < 0 ? Math.ceil(val) : Math.floor(val);
};


/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_moment_proptypes__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_moment_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_moment_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
// @noflow
var DaySelectorItem=function DaySelectorItem(_ref){var selected=_ref.selected,day=_ref.day,onSelect=_ref.onSelect;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('a',{onClick:onSelect},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* DaySelectorItemWeekDay */],null,day.format('dd')),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DaySelectorItemDayNumber */],{'data-qa':selected?'day-selector-day-selected':'day-selector-day',selected:selected},day.format('DD')));};DaySelectorItem.propTypes={day:__WEBPACK_IMPORTED_MODULE_1_react_moment_proptypes__["momentObj"].isRequired,onSelect:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,selected:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};/* harmony default export */ __webpack_exports__["a"] = (DaySelectorItem);

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

var moment = __webpack_require__(335);

function isValidMoment(testMoment) {
  if (typeof testMoment.isValid === 'function') {
    // moment 1.7.0+
    return testMoment.isValid();
  }

  return ! isNaN(testMoment);
}

module.exports = {
  isValidMoment : isValidMoment,
}


/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Checkbox;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_component_css__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__checkbox_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__checkbox_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral([''],['']);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// @noflow
var StyledInput=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].input(_templateObject);Checkbox.propTypes={className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};function Checkbox(_ref){var className=_ref.className,props=_objectWithoutProperties(_ref,['className']);return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](StyledInput,Object.assign({},props,{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('checkbox','general-icon__tick',className),type:'checkbox'}));}

/***/ }),
/* 2213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(531);
var PopupItem=function PopupItem(_ref){var index=_ref.index,caption=_ref.caption,icon=_ref.icon,action=_ref.action,selected=_ref.selected;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Item */],{key:index,onClick:action},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* ItemIcon */],{type:icon}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* ItemCaption */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* ItemCaptionContent */],{selected:selected},caption)));};/* harmony default export */ __webpack_exports__["a"] = (PopupItem);

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var DelayCSS=function(_Component){_inherits(DelayCSS,_Component);function DelayCSS(props){_classCallCheck(this,DelayCSS);var _this=_possibleConstructorReturn(this,(DelayCSS.__proto__||Object.getPrototypeOf(DelayCSS)).call(this,props));_this.state={isWaitOver:false};setTimeout(function(){_this.setState({isWaitOver:true});},props.durationMs);return _this;}_createClass(DelayCSS,[{key:'render',value:function render(){var _props=this.props,className=_props.children.props.className,cssClassesToAdd=_props.cssClassesToAdd;var isWaitOver=this.state.isWaitOver;return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(this.props.children,isWaitOver?{className:(className||'')+' '+cssClassesToAdd}:{});}}]);return DelayCSS;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);DelayCSS.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,cssClassesToAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,durationMs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};DelayCSS.defaultProps={durationMs:0};/* unused harmony default export */ var _unused_webpack_default_export = (DelayCSS);

/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_revalidate__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_revalidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_revalidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_devices_actions__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_redux_form__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var validate=Object(__WEBPACK_IMPORTED_MODULE_0_revalidate__["combineValidators"])({name:Object(__WEBPACK_IMPORTED_MODULE_0_revalidate__["composeValidators"])(Object(__WEBPACK_IMPORTED_MODULE_0_revalidate__["isRequired"])({message:'required'}),Object(__WEBPACK_IMPORTED_MODULE_0_revalidate__["hasLengthBetween"])(1,20)({message:'passwordLength'}),Object(__WEBPACK_IMPORTED_MODULE_0_revalidate__["matchesPattern"])(/^[A-Za-z0-9/\s]+$/)({message:'invalidCharacters'}))()});var reduxFormProps={form:'rename-device',fields:['name'],validate:validate};var mapStateToProps=function mapStateToProps(state,_ref){var deviceId=_ref.deviceId;var props={id:deviceId};var hasHub=Object(__WEBPACK_IMPORTED_MODULE_4__core_state_hub_selectors__["d" /* getHasHub */])(state);var device=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["g" /* getDeviceById */])(state,props);var deviceName=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["s" /* getDeviceName */])(state,props).getOrElse('');var type=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["C" /* getDeviceType */])(state,props);var ipAddress=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["m" /* getDeviceIPAddress */])(state,props);var isHubSense=hasHub&&Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["O" /* getIsHubSense */])(state);var macAddress=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["p" /* getDeviceMacAddress */])(state,props);var hasErrored=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["k" /* getDeviceErrorStatus */])(state,props);var saving=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["y" /* getDeviceSavingStatus */])(state,props);var connection=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["j" /* getDeviceConnectionType */])(state,props);var version=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["l" /* getDeviceFirmwareVersion */])(state,props);var power=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["u" /* getDevicePowerSource */])(state,props);var lastSeen=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["o" /* getDeviceLastSeen */])(state,props);var serialNumber=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["z" /* getDeviceSerialNumber */])(state,props);var isRestarting=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["x" /* getDeviceRestartingStatus */])(state,props);var hasRestartingError=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["w" /* getDeviceRestartingErrorStatus */])(state,props);var zoneId=device&&device.props&&device.props.zone;var tuiId=device&&device.props&&device.props.tui;var connectedDevices=device&&device.state&&device.state.connectedDevices;var isHub=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["M" /* getIsHub */])(state,props);var isHueBridge=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_devices_selectors__["P" /* getIsHueBridge */])(state,props);var hideRemoveDevice=(Object(__WEBPACK_IMPORTED_MODULE_3__core_state_config_selectors__["a" /* getConfig */])(state,'cannotRemoveDevice')||[]).includes(type);return{connectedDevices:connectedDevices,connection:connection,device:device,deviceName:deviceName,hasErrored:hasErrored,id:deviceId,initialValues:{name:deviceName},ipAddress:ipAddress,isHub:isHub,isHubSense:isHubSense,isHueBridge:isHueBridge,isRestarting:isRestarting,hasRestartingError:hasRestartingError,lastSeen:__WEBPACK_IMPORTED_MODULE_6_moment_timezone___default.a.duration(lastSeen,'seconds'),macAddress:macAddress,power:power,saving:saving,serialNumber:serialNumber,showRemoveDevice:!hideRemoveDevice,tuiId:tuiId,type:type,version:version,zoneId:zoneId};};var mapDispatchToProps={renameDevice:__WEBPACK_IMPORTED_MODULE_2__core_state_devices_actions__["j" /* renameDevice */],renameZone:__WEBPACK_IMPORTED_MODULE_2__core_state_devices_actions__["l" /* renameZone */],restartHub:__WEBPACK_IMPORTED_MODULE_2__core_state_devices_actions__["p" /* restartHub */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var id=stateProps.id,zoneProducts=stateProps.zoneProducts,stateRest=_objectWithoutProperties(stateProps,['id','zoneProducts']);var _restartHub=dispatchProps.restartHub,dispatchRest=_objectWithoutProperties(dispatchProps,['restartHub']);return Object.assign({},stateRest,{id:id},dispatchRest,{restartHub:function restartHub(){return _restartHub({id:id});}},ownProps);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_redux_form__["reduxForm"])(reduxFormProps,mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var sym = typeof Symbol === 'function' ? Symbol : function (id) {
  return '@@revalidate/' + id;
};

exports.default = sym;

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = composeValidators;

var _omit = __webpack_require__(2219);

var _omit2 = _interopRequireDefault(_omit);

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _createValidatorWithMultipleErrors = __webpack_require__(2223);

var _createValidatorWithMultipleErrors2 = _interopRequireDefault(_createValidatorWithMultipleErrors);

var _createValidatorWithSingleError = __webpack_require__(2224);

var _createValidatorWithSingleError2 = _interopRequireDefault(_createValidatorWithSingleError);

var _markAsValueValidator = __webpack_require__(787);

var _markAsValueValidator2 = _interopRequireDefault(_markAsValueValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function composeValidators() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return function configurableValidators(sharedConfig) {
    var config = void 0;

    if (typeof sharedConfig === 'string') {
      config = { field: sharedConfig };
    } else {
      config = (0, _objectAssign2.default)({}, sharedConfig);
    }

    if (config.multiple === true) {
      return (0, _markAsValueValidator2.default)((0, _createValidatorWithMultipleErrors2.default)(validators.slice(0), (0, _omit2.default)(config, 'multiple')));
    }

    return (0, _markAsValueValidator2.default)((0, _createValidatorWithSingleError2.default)(validators.slice(0), config));
  };
}

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82),
    baseClone = __webpack_require__(372),
    baseUnset = __webpack_require__(2220),
    castPath = __webpack_require__(189),
    copyObject = __webpack_require__(152),
    customOmitClone = __webpack_require__(2222),
    flatRest = __webpack_require__(294),
    getAllKeysIn = __webpack_require__(378);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(189),
    last = __webpack_require__(693),
    parent = __webpack_require__(2221),
    toKey = __webpack_require__(153);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(293),
    baseSlice = __webpack_require__(240);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(308);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createValidatorWithMultipleErrors;

var _isValueValidator = __webpack_require__(789);

var _isValueValidator2 = _interopRequireDefault(_isValueValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildErrorsArray(validators, validate) {
  return validators.reduce(function (errors, validator) {
    var errorMessage = validate(validator);

    if (errorMessage) {
      errors.push(errorMessage);
    }

    return errors;
  }, []);
}

function buildErrorsObject(validators, validate) {
  return Object.keys(validators).reduce(function (errors, key) {
    var validator = validators[key];
    var errorMessage = validate(validator);

    if (errorMessage) {
      errors[key] = errorMessage;
    }

    return errors;
  }, {});
}

function createValidatorWithMultipleErrors(validators, sharedConfig) {
  var buildErrors = void 0;
  var finalValidators = void 0;

  if (typeof validators[0] === 'object') {
    buildErrors = buildErrorsObject;
    finalValidators = validators[0];
  } else {
    buildErrors = buildErrorsArray;
    finalValidators = validators;
  }

  return function composedValidator(value, allValues) {
    return buildErrors(finalValidators, function (validator) {
      if ((0, _isValueValidator2.default)(validator)) {
        return validator(value, allValues);
      }

      return validator(sharedConfig, value, allValues);
    });
  };
}

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createValidatorWithSingleError;

var _isValueValidator = __webpack_require__(789);

var _isValueValidator2 = _interopRequireDefault(_isValueValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createValidatorWithSingleError(validators, sharedConfig) {
  return function composedValidator(value, allValues) {
    for (var i = 0, l = validators.length; i < l; i++) {
      var validator = validators[i];
      var errorMessage = void 0;

      if ((0, _isValueValidator2.default)(validator)) {
        errorMessage = validator(value, allValues);
      } else {
        errorMessage = validator(sharedConfig, value, allValues);
      }

      if (errorMessage) {
        return errorMessage;
      }
    }
  };
}

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = combineValidators;

var _internalCombineValidators = __webpack_require__(790);

var _internalCombineValidators2 = _interopRequireDefault(_internalCombineValidators);

var _ensureNestedValidators = __webpack_require__(2227);

var _ensureNestedValidators2 = _interopRequireDefault(_ensureNestedValidators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function combineValidators(validators) {
  var finalValidators = (0, _ensureNestedValidators2.default)(validators);
  return (0, _internalCombineValidators2.default)(finalValidators, true);
}

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = parseFieldName;
function parseFieldName(fieldName) {
  var isArray = fieldName.indexOf('[]') > -1;
  var baseName = isArray ? fieldName.replace('[]', '') : fieldName;

  return {
    isArray: isArray,
    baseName: baseName,
    fullName: fieldName
  };
}

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ensureNestedValidators;

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _fillObjectFromPath = __webpack_require__(2228);

var _fillObjectFromPath2 = _interopRequireDefault(_fillObjectFromPath);

var _internalCombineNestedValidators = __webpack_require__(2229);

var _internalCombineNestedValidators2 = _interopRequireDefault(_internalCombineNestedValidators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ensureNestedValidators(validators) {
  var baseShape = Object.keys(validators).reduce(function (root, path) {
    return (0, _objectAssign2.default)({}, root, (0, _fillObjectFromPath2.default)(root, path.split('.'), validators[path]));
  }, {});

  return (0, _internalCombineNestedValidators2.default)(baseShape);
}

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = fillObjectFromPath;

var _objectAssign = __webpack_require__(77);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fillObjectFromPath(object, path, finalValue) {
  var _assign;

  if (path.length <= 0) {
    return finalValue;
  }

  var head = path[0];
  var tail = path.slice(1);


  return (0, _objectAssign2.default)({}, object, (_assign = {}, _assign[head] = fillObjectFromPath(object[head] || {}, tail, finalValue), _assign));
}

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = internalCombineNestedValidators;

var _internalCombineValidators = __webpack_require__(790);

var _internalCombineValidators2 = _interopRequireDefault(_internalCombineValidators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function internalCombineNestedValidators(baseShape) {
  return Object.keys(baseShape).reduce(function (memo, key) {
    if (typeof baseShape[key] === 'object') {
      memo[key] = (0, _internalCombineValidators2.default)(internalCombineNestedValidators(baseShape[key]));
    } else {
      memo[key] = baseShape[key];
    }

    return memo;
  }, {});
}

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasLengthBetween;

var _createValidator = __webpack_require__(122);

var _createValidator2 = _interopRequireDefault(_createValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasLengthBetween(min, max) {
  return (0, _createValidator2.default)(function (message) {
    return function (value) {
      if (value && (value.length < min || value.length > max)) {
        return message;
      }
    };
  }, function (field) {
    return field + ' must be between ' + min + ' and ' + max + ' characters long';
  });
}

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasLengthGreaterThan;

var _createValidator = __webpack_require__(122);

var _createValidator2 = _interopRequireDefault(_createValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasLengthGreaterThan(min) {
  return (0, _createValidator2.default)(function (message) {
    return function (value) {
      if (value && value.length <= min) {
        return message;
      }
    };
  }, function (field) {
    return field + ' must be longer than ' + min + ' characters';
  });
}

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasLengthLessThan;

var _createValidator = __webpack_require__(122);

var _createValidator2 = _interopRequireDefault(_createValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasLengthLessThan(max) {
  return (0, _createValidator2.default)(function (message) {
    return function (value) {
      if (value && value.length >= max) {
        return message;
      }
    };
  }, function (field) {
    return field + ' cannot be longer than ' + max + ' characters';
  });
}

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _internalMatchesPattern = __webpack_require__(330);

var _internalMatchesPattern2 = _interopRequireDefault(_internalMatchesPattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _internalMatchesPattern2.default)(/^[A-Za-z]+$/, function (field) {
  return field + ' must be alphabetic';
});

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _internalMatchesPattern = __webpack_require__(330);

var _internalMatchesPattern2 = _interopRequireDefault(_internalMatchesPattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _internalMatchesPattern2.default)(/^[0-9A-Za-z]+$/, function (field) {
  return field + ' must be alphanumeric';
});

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _internalMatchesPattern = __webpack_require__(330);

var _internalMatchesPattern2 = _interopRequireDefault(_internalMatchesPattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _internalMatchesPattern2.default)(/^\d+$/, function (field) {
  return field + ' must be numeric';
});

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOneOf;

var _findIndex = __webpack_require__(429);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _createValidator = __webpack_require__(122);

var _createValidator2 = _interopRequireDefault(_createValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultComparer = function (value, optionValue) {
  return value === optionValue;
};

function isOneOf(values) {
  var comparer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultComparer;

  var valuesClone = values.slice(0);

  return (0, _createValidator2.default)(function (message) {
    return function (value) {
      if (value === undefined) {
        return;
      }

      var valueIndex = (0, _findIndex2.default)(valuesClone, function (optionValue) {
        return comparer(value, optionValue);
      });

      if (valueIndex === -1) {
        return message;
      }
    };
  }, function (field) {
    return field + ' must be one of ' + JSON.stringify(valuesClone);
  });
}

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createValidator = __webpack_require__(122);

var _createValidator2 = _interopRequireDefault(_createValidator);

var _valueMissing = __webpack_require__(791);

var _valueMissing2 = _interopRequireDefault(_valueMissing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createValidator2.default)(function (message) {
  return function (value) {
    if ((0, _valueMissing2.default)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + ' is required';
});

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = matchesField;

var _get = __webpack_require__(292);

var _get2 = _interopRequireDefault(_get);

var _createValidator = __webpack_require__(122);

var _createValidator2 = _interopRequireDefault(_createValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matchesField(otherField, otherFieldLabel) {
  return (0, _createValidator2.default)(function (message) {
    return function (value, allValues) {
      var otherValue = (0, _get2.default)(allValues, otherField);

      if (!allValues || value !== otherValue) {
        return message;
      }
    };
  }, function (field) {
    return field + ' must match ' + otherFieldLabel;
  });
}

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isRequiredIf;

var _invariant = __webpack_require__(57);

var _invariant2 = _interopRequireDefault(_invariant);

var _createValidator = __webpack_require__(122);

var _createValidator2 = _interopRequireDefault(_createValidator);

var _valueMissing = __webpack_require__(791);

var _valueMissing2 = _interopRequireDefault(_valueMissing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isRequiredIf(condition) {
  (0, _invariant2.default)(typeof condition === 'function', 'Please provide a condition function to determine if a field should be required');

  return (0, _createValidator2.default)(function (message) {
    return function (value, allValues) {
      if (condition(allValues) && (0, _valueMissing2.default)(value)) {
        return message;
      }
    };
  }, function (field) {
    return field + ' is required';
  });
}

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = matchesPattern;

var _internalMatchesPattern = __webpack_require__(330);

var _internalMatchesPattern2 = _interopRequireDefault(_internalMatchesPattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matchesPattern(regex) {
  return (0, _internalMatchesPattern2.default)(regex, function (field) {
    return field + ' must match pattern ' + regex;
  });
}

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buttons_async__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__panel_list_default__ = __webpack_require__(2246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__panel_list_hub__ = __webpack_require__(2247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__panel_list_hue_bridge__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__buttons_button_styles__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__unsaved_changes_modal__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__remove_device__ = __webpack_require__(795);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoPanel=function(_Component){_inherits(InfoPanel,_Component);function InfoPanel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoPanel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoPanel.__proto__||Object.getPrototypeOf(InfoPanel)).call.apply(_ref,[this].concat(args))),_this),_this.state={showRemoveModal:false},_this.handleRestartHub=function(e){e.preventDefault();_this.props.restartHub();},_this.renameDevice=function(name){var deviceInfo={name:name,productType:_this.props.type,productId:_this.props.id};_this.isZone()?_this.props.renameZone(deviceInfo):_this.props.renameDevice(deviceInfo);},_this.isZone=function(){return _this.props.id===_this.props.zoneId&&typeof _this.props.tuiId!=='undefined'||typeof _this.props.zoneId!=='undefined'&&_this.props.id!==_this.props.zoneId;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoPanel,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){return!!nextProps.device;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,connectedDevices=_props.connectedDevices,device=_props.device,name=_props.fields.name,hasErrored=_props.hasErrored,hasRestartingError=_props.hasRestartingError,id=_props.id,isHub=_props.isHub,isHubSense=_props.isHubSense,isHueBridge=_props.isHueBridge,isRestarting=_props.isRestarting,pristine=_props.pristine,saving=_props.saving,serialNumber=_props.serialNumber,showRemoveDevice=_props.showRemoveDevice;var isZone=this.isZone();var headingIntl=isZone?__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].zoneNickname:__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].nickname;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{className:'edit-device',onSubmit:function onSubmit(e){e.preventDefault();!name.invalid&&_this2.renameDevice(name.value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__unsaved_changes_modal__["a" /* default */],{showModal:!pristine&&!name.invalid}),isHueBridge&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__panel_list_hue_bridge__["a" /* default */],{connectedDevices:connectedDevices,device:device.props,serialNumber:serialNumber}),isHub&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__panel_list_hub__["a" /* default */],Object.assign({},this.props,{headingIntl:headingIntl})),!isHueBridge&&!isHub&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__panel_list_default__["a" /* default */],Object.assign({},this.props,{headingIntl:headingIntl})),!isHueBridge&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__buttons_button_styles__["a" /* RHSButtonContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__buttons_async__["a" /* default */],{disabled:name.initialValue===name.value||!name.value,error:hasErrored,saving:saving,type:'submit'})),showRemoveDevice&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__remove_device__["a" /* default */],{deviceId:id}),isHubSense&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__buttons_button_styles__["a" /* RHSButtonContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__buttons_async__["a" /* default */],{disabled:isRestarting,error:hasRestartingError,messages:{save:__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].restartHub,saving:__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].restarting},onClick:this.handleRestartHub,saving:isRestarting})));}}]);return InfoPanel;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (InfoPanel);

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContentContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SaveTextWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SaveText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_constants_components_widgets_buttons_async__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    background-color: ',';\n    border: ',';\n    border-radius: 1.5em;\n    color: ',';\n    cursor: ',';\n    font-size: 1em;\n    height: 2.65em;\n    outline: none;\n    width: 8em;\n\n    ',';\n\n    &:focus {\n        box-shadow: 0 0 10px 0 rgba(255, 122, 0, 0.5);\n    }\n'],['\n    background-color: ',';\n    border: ',';\n    border-radius: 1.5em;\n    color: ',';\n    cursor: ',';\n    font-size: 1em;\n    height: 2.65em;\n    outline: none;\n    width: 8em;\n\n    ',';\n\n    &:focus {\n        box-shadow: 0 0 10px 0 rgba(255, 122, 0, 0.5);\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n'],['\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n']),_templateObject3=_taggedTemplateLiteral(['\n    position: relative;\n    flex-grow: 2;\n    height: 1em;\n'],['\n    position: relative;\n    flex-grow: 2;\n    height: 1em;\n']),_templateObject4=_taggedTemplateLiteral(['\n    text-align: center;\n    display: block;\n    position: absolute;\n    width: 100%;\n    transition: opacity 0.5s ease-in-out;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    opacity: ',';\n'],['\n    text-align: center;\n    display: block;\n    position: absolute;\n    width: 100%;\n    transition: opacity 0.5s ease-in-out;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    opacity: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AsyncBtn=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].button(_templateObject,function(_ref){var primaryBtnColors=_ref.theme.primaryBtnColors,saveState=_ref.saveState,disabled=_ref.disabled;return disabled&&saveState===__WEBPACK_IMPORTED_MODULE_0__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT?primaryBtnColors.disabled:primaryBtnColors[Object(__WEBPACK_IMPORTED_MODULE_0__core_constants_components_widgets_buttons_async__["a" /* getBgColorKey */])(saveState)];},function(_ref2){var primaryBtnColors=_ref2.theme.primaryBtnColors,disabled=_ref2.disabled;return disabled?'1px solid '+primaryBtnColors.disabled:'1px solid '+primaryBtnColors.default;},function(_ref3){var theme=_ref3.theme;return theme.white;},function(_ref4){var disabled=_ref4.disabled,saveState=_ref4.saveState;return!disabled&&saveState===__WEBPACK_IMPORTED_MODULE_0__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT?'pointer':'default';},function(_ref5){var disabled=_ref5.disabled,saveState=_ref5.saveState,primaryBtnColors=_ref5.theme.primaryBtnColors;if(!disabled&&saveState===__WEBPACK_IMPORTED_MODULE_0__core_constants_components_widgets_buttons_async__["b" /* saveStates */].DEFAULT){return'\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground-color: '+primaryBtnColors.hover+';\n\t\t\t\t\ttransition: background-color 0.5s ease-in-out;\n\t\t\t\t}\n\t\t\t';}else{return'';}});var ContentContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2);var SaveTextWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3);var SaveText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4,function(_ref6){var saveState=_ref6.saveState,thisState=_ref6.thisState;return saveState===thisState?1:0;});

/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2244);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var saveState=_ref.saveState;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["i" /* SpinnerComponent */],{saveState:saveState},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["j" /* SpinnerContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["l" /* SpinnerPartsContainer */],{saveState:saveState},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* Spinner */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["k" /* SpinnerIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* Filler */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* FillerIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Mask */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* MaskHiddenChild */],null,'.')),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* OverlayIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["m" /* Tick */],{saveState:saveState}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Cross */],{saveState:saveState}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* SolidCircle */],{saveState:saveState})));});

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SpinnerComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SpinnerContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SpinnerPartsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Spinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SpinnerIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Filler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FillerIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Mask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MaskHiddenChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OverlayIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Tick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cross; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SolidCircle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_constants_animations__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    background-color: ',';\n    height: ',';\n    overflow: hidden;\n    width: ',';\n\n    ',';\n'],['\n    background-color: ',';\n    height: ',';\n    overflow: hidden;\n    width: ',';\n\n    ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    background-color: inherit;\n    height: 100%;\n    position: relative;\n    width: 100%;\n'],['\n    background-color: inherit;\n    height: 100%;\n    position: relative;\n    width: 100%;\n']),_templateObject3=_taggedTemplateLiteral(['\n    background-color: inherit;\n    position: relative;\n    height: 100%;\n    width: 100%;\n    ',';\n'],['\n    background-color: inherit;\n    position: relative;\n    height: 100%;\n    width: 100%;\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    background-color: inherit;\n    height: 100%;\n    overflow: hidden;\n    position: absolute;\n    width: 50%;\n'],['\n    background-color: inherit;\n    height: 100%;\n    overflow: hidden;\n    position: absolute;\n    width: 50%;\n']),_templateObject5=_taggedTemplateLiteral(['\n    background-color: inherit;\n    animation: ',' ',' linear infinite;\n    transform-origin: 100% 50%;\n'],['\n    background-color: inherit;\n    animation: ',' ',' linear infinite;\n    transform-origin: 100% 50%;\n']),_templateObject6=_taggedTemplateLiteral(['\n    height: 100%;\n    width: 100%;\n\n    & g {\n        fill: ',';\n    }\n'],['\n    height: 100%;\n    width: 100%;\n\n    & g {\n        fill: ',';\n    }\n']),_templateObject7=_taggedTemplateLiteral(['\n    height: 200%;\n    transform: translateY(-25%);\n    width: 200%;\n'],['\n    height: 200%;\n    transform: translateY(-25%);\n    width: 200%;\n']),_templateObject8=_taggedTemplateLiteral(['\n    animation: ',' ',' linear infinite reverse;\n    background-color: inherit;\n    left: 50%;\n'],['\n    animation: ',' ',' linear infinite reverse;\n    background-color: inherit;\n    left: 50%;\n']),_templateObject9=_taggedTemplateLiteral(['transform: translate(-50%, -25%);'],['transform: translate(-50%, -25%);']),_templateObject10=_taggedTemplateLiteral(['\n    animation: ',' ',' linear infinite;\n    background-color: inherit;\n    height: 100%;\n    opacity: 1;\n    overflow: hidden;\n    position: absolute;\n    width: 50%;\n'],['\n    animation: ',' ',' linear infinite;\n    background-color: inherit;\n    height: 100%;\n    opacity: 1;\n    overflow: hidden;\n    position: absolute;\n    width: 50%;\n']),_templateObject11=_taggedTemplateLiteral(['transform: translateX(-100%);'],['transform: translateX(-100%);']),_templateObject12=_taggedTemplateLiteral(['\n    left: 0;\n    opacity: 0.5;\n    position: absolute;\n    transform: translate3d(0, 0, 0);\n'],['\n    left: 0;\n    opacity: 0.5;\n    position: absolute;\n    transform: translate3d(0, 0, 0);\n']),_templateObject13=_taggedTemplateLiteral(['\n    left: 0;\n    position: absolute;\n    visibility: hidden;\n\n    ',';\n'],['\n    left: 0;\n    position: absolute;\n    visibility: hidden;\n\n    ',';\n']),_templateObject14=_taggedTemplateLiteral(['\n    left: 0;\n    opacity: ',';\n    position: absolute;\n    transition: opacity 0.25s ',';\n'],['\n    left: 0;\n    opacity: ',';\n    position: absolute;\n    transition: opacity 0.25s ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var spinnerComponentSize='2em';var spinnerDuration='3s';var SpinnerComponent=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject,function(_ref){var primaryBtnColors=_ref.theme.primaryBtnColors,saveState=_ref.saveState;return primaryBtnColors[Object(__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["a" /* getBgColorKey */])(saveState)];},spinnerComponentSize,spinnerComponentSize,function(_ref2){var saveState=_ref2.saveState;var transitionStates=[__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVED_END,__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR_END];var displaySavingStates=[__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVING,__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVED,__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR];var opacity=displaySavingStates.includes(saveState)?1:0;var width=displaySavingStates.includes(saveState)?spinnerComponentSize:0;var transition=transitionStates.includes(saveState)?'opacity 0s ease-in-out, width 0.25s ease-in-out 0.25s, margin 0.25s ease-in-out 0.25s':'opacity 0s ease-in-out 0.8s, width 0.3s ease-in-out 0.5s, margin 0.3s ease-in-out 0.5s';var margin=displaySavingStates.includes(saveState)?'0.25em 0 0 0.5em':'0.25em 0 0';return'\n            margin: '+margin+';\n\t\t\topacity: '+opacity+';\n\t\t\ttransition: '+transition+';\n            width: '+width+';\n\t\t';});var SpinnerContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2);var SpinnerPartsContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject3,function(_ref3){var saveState=_ref3.saveState;var hideStates=[__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVED,__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR];return'display: '+(hideStates.includes(saveState)?'none':'block');});var SpinnerBase=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4);var Spinner=SpinnerBase.extend(_templateObject5,__WEBPACK_IMPORTED_MODULE_0__core_constants_animations__["g" /* rotate360 */],spinnerDuration);var BaseSVGIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__core_icons_svg_icons__["a" /* default */]).attrs({type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].CIRCLE_OUTLINE})(_templateObject6,function(props){return props.theme.white;});var SpinnerIcon=BaseSVGIcon.extend(_templateObject7);var Filler=SpinnerBase.extend(_templateObject8,__WEBPACK_IMPORTED_MODULE_0__core_constants_animations__["k" /* vanish */],spinnerDuration);var FillerIcon=SpinnerIcon.extend(_templateObject9);var Mask=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject10,__WEBPACK_IMPORTED_MODULE_0__core_constants_animations__["k" /* vanish */],spinnerDuration);var MaskHiddenChild=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject11);var OverlayIcon=BaseSVGIcon.extend(_templateObject12);var Tick=BaseSVGIcon.extend.attrs({type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].TICK_ONE})(_templateObject13,function(_ref4){var saveState=_ref4.saveState;if(saveState===__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVED){return'\n                animation: '+__WEBPACK_IMPORTED_MODULE_0__core_constants_animations__["d" /* expandIn */]+' 0.5s '+__WEBPACK_IMPORTED_MODULE_0__core_constants_animations__["b" /* easing */].bounce+' 1;\n                visibility: visible;\n            ';}});var Cross=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(BaseSVGIcon).attrs({type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].CLOSE})(_templateObject13,function(_ref5){var saveState=_ref5.saveState;if(saveState===__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR){return'\n                animation: '+__WEBPACK_IMPORTED_MODULE_0__core_constants_animations__["d" /* expandIn */]+' 0.5s '+__WEBPACK_IMPORTED_MODULE_0__core_constants_animations__["b" /* easing */].bounce+' 1;\n                visibility: visible;\n            ';}});var SolidCircle=BaseSVGIcon.extend.attrs({type:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general_svg__["a" /* default */].CIRCLE_OUTLINE})(_templateObject14,function(_ref6){var saveState=_ref6.saveState;return saveState===__WEBPACK_IMPORTED_MODULE_1__core_constants_components_widgets_buttons_async__["b" /* saveStates */].SAVE_ERROR?1:0;},__WEBPACK_IMPORTED_MODULE_0__core_constants_animations__["b" /* easing */].bounce);

/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
var messages=Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({save:{id:'buttons.async.save',defaultMessage:'Save'},saving:{id:'buttons.async.saving',defaultMessage:'Saving...'},saved:{id:'buttons.async.saved',defaultMessage:'Saved!'},error:{id:'buttons.async.error',defaultMessage:'Error'}});/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__edit_device_name__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var DefaultInfoPanelList=function DefaultInfoPanelList(props){return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* DeviceInfoPanelList */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__edit_device_name__["a" /* default */],props));};/* harmony default export */ __webpack_exports__["a"] = (DefaultInfoPanelList);

/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__edit_device_name__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__timespan__ = __webpack_require__(349);
var HubInfoPanelList=function HubInfoPanelList(_ref){var ipAddress=_ref.ipAddress,macAddress=_ref.macAddress,version=_ref.version,lastSeen=_ref.lastSeen,power=_ref.power,connection=_ref.connection,deviceName=_ref.deviceName,fields=_ref.fields,headingIntl=_ref.headingIntl;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* DeviceInfoPanelList */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__edit_device_name__["a" /* default */],{deviceName:deviceName,fields:fields,headingIntl:headingIntl}),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].powerSource),':'),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */][power]))),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].internetConnection),':'),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */][connection]))),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].ipAddress),':'),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,ipAddress)),macAddress&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].macAddress),':'),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,macAddress)),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].firmwareVersion),':'),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,version)),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].hubUptime),':'),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__timespan__["a" /* default */],{value:lastSeen}))));};/* harmony default export */ __webpack_exports__["a"] = (HubInfoPanelList);

/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({timespan:{id:'timespan',defaultMessage:'\n      {years, plural,\n\t\t\t\t=0 {}\n\t\t\t\tone {# year}\n\t\t\t\tother {# years}\n\t\t\t}\n      {months, plural,\n\t\t\t\t=0 {}\n\t\t\t\tone {# month}\n\t\t\t\tother {# months}\n\t\t\t}\n\t\t\t{days, plural,\n\t\t\t\t=0 {}\n\t\t\t\tone {# day}\n\t\t\t\tother {# days}\n\t\t\t}\n\t\t\t{hours, plural,\n\t\t\t\t=0 {}\n\t\t\t\tone {# hour}\n\t\t\t\tother {# hours}\n\t\t\t}\n\t\t\t{minutes, plural,\n\t\t\t\t=0 {}\n\t\t\t\tone {# minute}\n\t\t\t\tother {# minutes}\n\t\t\t}\n\t\t\t{seconds, plural,\n\t\t\t\t=0 {}\n\t\t\t\tone {# second}\n\t\t\t\tother {# seconds}\n\t\t\t}'}}));

/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
var HueBridgeInfoPanel=function HueBridgeInfoPanel(_ref){var _ref$device=_ref.device,version=_ref$device.version,ipAddress=_ref$device.ipAddress,serialNumber=_ref.serialNumber,connectedDevices=_ref.connectedDevices;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* DeviceInfoPanelList */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2__intl__["a" /* default */].manufacturer),':'),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2__intl__["a" /* default */].philips))),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2__intl__["a" /* default */].ipAddress),':'),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,ipAddress)),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2__intl__["a" /* default */].serialNumber),':'),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,serialNumber)),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* DeviceInfoPanelListItem */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* DeviceInfoPanelHeading */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2__intl__["a" /* default */].connectedDevices),':'),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* DeviceInfoPanelValue */],null,connectedDevices+' ',__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_2__intl__["a" /* default */].connectedDevices,{value:{connectedDevices:connectedDevices}})))));};/* harmony default export */ __webpack_exports__["a"] = (HueBridgeInfoPanel);

/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({title:{id:'unsaved-messages-modal.title',defaultMessage:'Unsaved Changes'},description:{id:'unsaved-messages-modal.description',defaultMessage:'You have unsaved changes, are you sure you want to leave?'},cancel:{id:'unsaved-messages-modal.cancel',defaultMessage:'Cancel'},continue:{id:'unsaved-messages-modal.continue',defaultMessage:'Continue'}}));

/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Buttons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ModalButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ModalHrefButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ModalLinkButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return overlayStyle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buttons__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
var _templateObject=_taggedTemplateLiteral(['\n\tfrom { transform: translate3d(-50%, 100%, 0); }\n\tto { transform: translate3d(-50%, 7vh, 0); }\n'],['\n\tfrom { transform: translate3d(-50%, 100%, 0); }\n\tto { transform: translate3d(-50%, 7vh, 0); }\n']),_templateObject2=_taggedTemplateLiteral(['\n\tfrom { transform: translate3d(-50%, 100%, 0); }\n\tto { transform: translate3d(-50%, 0, 0); }\n'],['\n\tfrom { transform: translate3d(-50%, 100%, 0); }\n\tto { transform: translate3d(-50%, 0, 0); }\n']),_templateObject3=_taggedTemplateLiteral(['\n    animation: ',' 0.3s ease-out forwards;\n    background-color: ',';\n    border-radius: ','px;\n    box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 13px 19px 2px rgba(0, 0, 0, 0.14),\n        0 5px 24px 4px rgba(0, 0, 0, 0.12);\n    height: ',';\n    left: 50%;\n    max-width: 100vw;\n    min-width: 20rem;\n    outline: none;\n    overflow: hidden;\n    position: absolute;\n    width: ',';\n\n    ',';\n'],['\n    animation: ',' 0.3s ease-out forwards;\n    background-color: ',';\n    border-radius: ','px;\n    box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 13px 19px 2px rgba(0, 0, 0, 0.14),\n        0 5px 24px 4px rgba(0, 0, 0, 0.12);\n    height: ',';\n    left: 50%;\n    max-width: 100vw;\n    min-width: 20rem;\n    outline: none;\n    overflow: hidden;\n    position: absolute;\n    width: ',';\n\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n\t\tanimation-name: ',';\n\t\theight: ',';\n\t\tmax-height: ',';\n\t\tmax-width: 60rem;\n\t'],['\n\t\tanimation-name: ',';\n\t\theight: ',';\n\t\tmax-height: ',';\n\t\tmax-width: 60rem;\n\t']),_templateObject5=_taggedTemplateLiteral(['\n    height: ',';\n    overflow-y: auto;\n    padding: ',';\n\n    ',';\n'],['\n    height: ',';\n    overflow-y: auto;\n    padding: ',';\n\n    ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n\t\t\theight: inherit;\n\t\t\tmax-height: ',';\n\t\t'],['\n\t\t\theight: inherit;\n\t\t\tmax-height: ',';\n\t\t']),_templateObject7=_taggedTemplateLiteral(['\n    align-items: center;\n    bottom: 0;\n    box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.2);\n    display: flex;\n    height: ','em;\n    justify-content: space-around;\n    padding: 1em;\n'],['\n    align-items: center;\n    bottom: 0;\n    box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.2);\n    display: flex;\n    height: ','em;\n    justify-content: space-around;\n    padding: 1em;\n']),_templateObject8=_taggedTemplateLiteral(['\n    \tmargin: 0 1em;\n    \tpadding: 0.75rem 3rem;\n    '],['\n    \tmargin: 0 1em;\n    \tpadding: 0.75rem 3rem;\n    ']),_templateObject9=_taggedTemplateLiteral(['',';'],['',';']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var buttonContainerHeight=5;var deskstopMaxHeight='86vh';var reveal=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject);var revealFullScreen=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject2);var StyledModal=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a)(_templateObject3,function(p){return p.isBig?revealFullScreen:reveal;},function(p){return p.theme.white;},function(p){return p.isBig?0:3;},function(p){return p.isBig?'100%':'inherit';},function(p){return p.isBig?'100vw':'inherit';},__WEBPACK_IMPORTED_MODULE_2__core_utils_style__["b" /* media */].large(_templateObject4,reveal,function(p){return p.isBig?deskstopMaxHeight:'inherit';},deskstopMaxHeight));var getHeight=function getHeight(p,isDesktop){var nonUsableHeight=p.hasButtons?buttonContainerHeight:0;return'calc('+(isDesktop?deskstopMaxHeight:'100%')+' - '+nonUsableHeight+'em)';};var Content=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,function(p){return p.isBig?getHeight(p,false):'inherit';},function(p){return p.noPadding?0:'1em';},__WEBPACK_IMPORTED_MODULE_2__core_utils_style__["b" /* media */].large(_templateObject6,function(p){return getHeight(p,true);}));var Buttons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject7,buttonContainerHeight);var modalButtonStyles='\n    margin: 0 0.5em;\n    padding: 0.75rem 2rem;\n    flex-shrink: 0;\n    '+__WEBPACK_IMPORTED_MODULE_2__core_utils_style__["b" /* media */].tablet(_templateObject8)+';\n';var ModalButton=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__buttons__["b" /* Button */])(_templateObject9,modalButtonStyles);var ModalHrefButton=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__buttons__["c" /* HrefButton */])(_templateObject9,modalButtonStyles);var ModalLinkButton=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__buttons__["d" /* LinkButton */])(_templateObject9,modalButtonStyles);// Unfortunately we cannot use styled component for the overlay
// as react-modal only accepts inline styling
var overlayStyle={backgroundColor:'rgba(0, 0, 0, 0.5)',bottom:0,left:0,position:'fixed',right:0,top:0,transition:'background-color 0.3s',zIndex:999// 1 less than the alerts
};

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HrefButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buttons_link_component_css__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buttons_link_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__buttons_link_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
HrefButton.propTypes={alternate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,href:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,target:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};function HrefButton(_ref){var alternate=_ref.alternate,children=_ref.children,className=_ref.className,href=_ref.href,target=_ref.target,props=_objectWithoutProperties(_ref,['alternate','children','className','href','target']);var linkClasses=_defineProperty({'link-button':true,'link-button--alternate':alternate},className,className!=null);return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('a',Object.assign({className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(linkClasses),href:href,target:target},props),children);}

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LinkButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buttons_link_component_css__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buttons_link_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__buttons_link_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
LinkButton.propTypes={alternate:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node.isRequired,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,to:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired};/**
 * Represents a wrapper around a `Link` component from `react-router` so that
 * they are styled like buttons.
 *
 * alternate: whether or not to show a different style
 * className: any extra classes to append
 */function LinkButton(_ref){var alternate=_ref.alternate,children=_ref.children,className=_ref.className,props=_objectWithoutProperties(_ref,['alternate','children','className']);var linkClasses=_defineProperty({'link-button':true,'link-button--alternate':alternate},className,className!=null);return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],Object.assign({},props,{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()(linkClasses)}),children);}

/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2255);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var TextButton=function TextButton(_ref){var children=_ref.children,className=_ref.className,props=_objectWithoutProperties(_ref,['children','className']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* StyledButton */],Object.assign({},props,{className:className}),children);};/* harmony default export */ __webpack_exports__["a"] = (TextButton);

/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished__ = __webpack_require__(70);
var _templateObject=_taggedTemplateLiteral(['\n    background-color: transparent;\n    border: none;\n    color: ',';\n    cursor: pointer;\n    font-size: 1rem;\n    outline: none;\n    padding: 0;\n    transition: color 0.3s;\n\n    &:focus,\n    &:hover {\n        color: ',';\n    }\n\n    &:active {\n        color: ',';\n    }\n\n    &:disabled {\n        color: ',';\n        cursor: auto;\n    }\n'],['\n    background-color: transparent;\n    border: none;\n    color: ',';\n    cursor: pointer;\n    font-size: 1rem;\n    outline: none;\n    padding: 0;\n    transition: color 0.3s;\n\n    &:focus,\n    &:hover {\n        color: ',';\n    }\n\n    &:active {\n        color: ',';\n    }\n\n    &:disabled {\n        color: ',';\n        cursor: auto;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledButton=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].button(_templateObject,function(_ref){var alternative=_ref.alternative,theme=_ref.theme;return alternative?theme.primaryFontColor:theme.mainBrandColor;},function(_ref2){var alternative=_ref2.alternative,theme=_ref2.theme;return alternative?Object(__WEBPACK_IMPORTED_MODULE_1_polished__["c" /* lighten */])(0.1,theme.primaryFontColor):Object(__WEBPACK_IMPORTED_MODULE_1_polished__["c" /* lighten */])(0.1,theme.mainBrandColor);},function(_ref3){var alternative=_ref3.alternative,theme=_ref3.theme;return alternative?Object(__WEBPACK_IMPORTED_MODULE_1_polished__["a" /* darken */])(0.1,theme.primaryFontColor):Object(__WEBPACK_IMPORTED_MODULE_1_polished__["a" /* darken */])(0.1,theme.mainBrandColor);},function(props){return props.theme.mediumGrey;});

/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Switch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polished__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 1px;\n    position: absolute;\n    visibility: hidden;\n    width: 1px;\n'],['\n    height: 1px;\n    position: absolute;\n    visibility: hidden;\n    width: 1px;\n']),_templateObject2=_taggedTemplateLiteral(['\n    cursor: pointer;\n    display: block;\n    background-color: ',';\n    border-radius: ',';\n    box-shadow: ',';\n    height: ',';\n    position: relative;\n    transition: all 0.2s ease 0.1s;\n    width: calc(',' + ',');\n    &:after {\n        content: \'\';\n        cursor: pointer;\n        display: block;\n        background-color: ',';\n        border-radius: ',';\n        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);\n        height: ',';\n        margin-left: calc(',' / 2);\n        position: relative;\n        top: calc(',' / 2);\n        transform: ',';\n        transition: transform 0.2s ease;\n        width: ',';\n    }\n'],['\n    cursor: pointer;\n    display: block;\n    background-color: ',';\n    border-radius: ',';\n    box-shadow: ',';\n    height: ',';\n    position: relative;\n    transition: all 0.2s ease 0.1s;\n    width: calc(',' + ',');\n    &:after {\n        content: \'\';\n        cursor: pointer;\n        display: block;\n        background-color: ',';\n        border-radius: ',';\n        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);\n        height: ',';\n        margin-left: calc(',' / 2);\n        position: relative;\n        top: calc(',' / 2);\n        transform: ',';\n        transition: transform 0.2s ease;\n        width: ',';\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var buttonHeight='2.5em';var circleMargin='0.25em';var circleSize=function circleSize(){var height=arguments.length>0&&arguments[0]!==undefined?arguments[0]:buttonHeight;var margin=arguments.length>1&&arguments[1]!==undefined?arguments[1]:circleMargin;return'calc('+height+' - '+margin+')';};var widthOffset='1.5em';var Checkbox=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].input(_templateObject);var Switch=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject2,function(props){return props.theme.offlineGrey;},buttonHeight,function(_ref){var isOn=_ref.isOn,theme=_ref.theme;return isOn?'inset 0 0 0 2em '+theme.mainBrandColor:'inset 0 0 0 0 '+Object(__WEBPACK_IMPORTED_MODULE_0_polished__["e" /* rgba */])(theme.mainBrandColor,0.75);},buttonHeight,buttonHeight,widthOffset,function(props){return props.theme.white;},circleSize(),circleSize(),circleMargin,circleMargin,function(props){return props.isOn?'translateX('+widthOffset+')':'none';},circleSize());

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(130);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(2258);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(799);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(801);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = 'ReactModalPortal';
var bodyOpenClassName = exports.bodyOpenClassName = 'ReactModal__Body--open';

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement('div');
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      var isOpen = newProps.isOpen;
      // Stop unnecessary renders if modal is remaining closed

      if (!this.props.isOpen && !isOpen) return;

      var currentParent = getParentElement(this.props.parentSelector);
      var newParent = getParentElement(newProps.parentSelector);

      if (newParent !== currentParent) {
        currentParent.removeChild(this.node);
        newParent.appendChild(this.node);
      }

      !isReact16 && this.renderPortal(newProps);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      if (newProps.portalClassName !== this.props.portalClassName) {
        this.node.className = newProps.portalClassName;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement('div');
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({ ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: 'setAppElement',
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfter: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnOverlayClick: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position: 'absolute',
    top: '40px',
    left: '40px',
    right: '40px',
    bottom: '40px',
    border: '1px solid #ccc',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '20px'
  }
};
exports.default = Modal;

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _focusManager = __webpack_require__(2259);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(2260);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(799);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _refCount = __webpack_require__(800);

var refCount = _interopRequireWildcard(_refCount);

var _bodyClassList = __webpack_require__(2261);

var bodyClassList = _interopRequireWildcard(_bodyClassList);

var _safeHTMLElement = __webpack_require__(801);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: 'ReactModal__Overlay',
  content: 'ReactModal__Content'
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setFocusAfterRender = function (focus) {
      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
    };

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
    };

    _this.setContentRef = function (content) {
      _this.content = content;
    };

    _this.afterClose = function () {
      focusManager.returnFocus();
      focusManager.teardownScopedFocus();
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        focusManager.setupScopedFocus(_this.node);
        focusManager.markForFocusLater();
        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      _this.beforeClose();
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }
      if (event.keyCode === ESC_KEY) {
        event.preventDefault();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
    };

    _this.handleOverlayOnMouseUp = function () {
      if (_this.moveFromContentToOverlay === null) {
        _this.shouldClose = false;
      }
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function () {
      _this.moveFromContentToOverlay = false;
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
      _this.moveFromContentToOverlay = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === 'undefined' ? 'undefined' : _typeof(additional)) === 'object' ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + '--after-open',
        beforeClose: CLASS_NAMES[which] + '--before-close'
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + ' ' + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + ' ' + classNames.beforeClose;
      }
      return typeof additional === 'string' && additional ? className + ' ' + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc['aria-' + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Focus needs to be set when mounting and already open
      if (this.props.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (false) {
        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + 'This may cause unexpected behavior when multiple modals are open.');
        }
      }
      // Focus only needs to be set once when the modal is being opened
      if (!this.props.isOpen && newProps.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      } else if (this.props.isOpen && !newProps.isOpen) {
        this.close();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.focusAfterRender) {
        this.focusContent();
        this.setFocusAfterRender(false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.beforeClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: 'beforeOpen',
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          bodyOpenClassName = _props.bodyOpenClassName;
      // Add body class

      bodyClassList.add(bodyOpenClassName);
      // Add aria-hidden to appElement
      if (ariaHideApp) {
        ariaAppHider.hide(appElement);
      }
    }
  }, {
    key: 'beforeClose',
    value: function beforeClose() {
      var _props2 = this.props,
          appElement = _props2.appElement,
          ariaHideApp = _props2.ariaHideApp,
          bodyOpenClassName = _props2.bodyOpenClassName;
      // Remove class if no more modals are open

      bodyClassList.remove(bodyOpenClassName);
      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && refCount.totalCount() < 1) {
        ariaAppHider.show(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          overlayClassName = _props3.overlayClassName,
          defaultStyles = _props3.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        'div',
        {
          ref: this.setOverlayRef,
          className: this.buildClassName('overlay', overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          onMouseUp: this.handleOverlayOnMouseUp },
        _react2.default.createElement(
          'div',
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName('content', className),
            tabIndex: '-1',
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            'aria-label': this.props.contentLabel
          }, this.ariaAttributes(this.props.aria || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  }
};
ModalPortal.propTypes = {
  isOpen: _propTypes.PropTypes.bool.isRequired,
  defaultStyles: _propTypes.PropTypes.shape({
    content: _propTypes.PropTypes.object,
    overlay: _propTypes.PropTypes.object
  }),
  style: _propTypes.PropTypes.shape({
    content: _propTypes.PropTypes.object,
    overlay: _propTypes.PropTypes.object
  }),
  className: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
  overlayClassName: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
  bodyOpenClassName: _propTypes.PropTypes.string,
  ariaHideApp: _propTypes.PropTypes.bool,
  appElement: _propTypes.PropTypes.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes.PropTypes.func,
  onRequestClose: _propTypes.PropTypes.func,
  closeTimeoutMS: _propTypes.PropTypes.number,
  shouldFocusAfterRender: _propTypes.PropTypes.bool,
  shouldCloseOnOverlayClick: _propTypes.PropTypes.bool,
  role: _propTypes.PropTypes.string,
  contentLabel: _propTypes.PropTypes.string,
  aria: _propTypes.PropTypes.object,
  children: _propTypes.PropTypes.node
};
exports.default = ModalPortal;
module.exports = exports['default'];

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(798);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    toFocus.focus();
    return;
  } catch (e) {
    console.warn(['You tried to return focus to', toFocus, 'but it is not in the DOM anymore'].join(" "));
  }
}
/* eslint-enable no-console */

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
}

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(798);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement ||
  // handle immediate shift+tab after opening with mouse
  node === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
}
module.exports = exports['default'];

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.remove = remove;

var _refCount = __webpack_require__(800);

var refCount = _interopRequireWildcard(_refCount);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function add(bodyClass) {
  // Increment class(es) on refCount tracker and add class(es) to body
  bodyClass.split(' ').map(refCount.add).forEach(function (className) {
    return document.body.classList.add(className);
  });
}

function remove(bodyClass) {
  var classListMap = refCount.get();
  // Decrement class(es) from the refCount tracker
  // and remove unused class(es) from body
  bodyClass.split(' ').map(refCount.remove).filter(function (className) {
    return classListMap[className] === 0;
  }).forEach(function (className) {
    return document.body.classList.remove(className);
  });
}

/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({cancel:{id:'modal.cancel',defaultMessage:'Cancel'},learnMore:{id:'modal.learn-more',defaultMessage:'Learn more'},save:{id:'modal.save',defaultMessage:'Save'}}));

/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RemoveButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buttons_button_styles__ = __webpack_require__(333);
var _templateObject=_taggedTemplateLiteral(['\n    ',';\n'],['\n    ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    margin: 0.75rem auto;\n    display: block;\n  '],['\n    margin: 0.75rem auto;\n    display: block;\n  ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var RemoveButton=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__buttons_button_styles__["b" /* StyledButton */])(_templateObject,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].mobile(_templateObject2));

/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domains_container__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(804);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(__WEBPACK_IMPORTED_MODULE_2____["c" /* mapStateToProps */],__WEBPACK_IMPORTED_MODULE_2____["b" /* mapDispatchToProps */],__WEBPACK_IMPORTED_MODULE_2____["d" /* mergeProps */])(__WEBPACK_IMPORTED_MODULE_1__domains_container__["a" /* default */]));

/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_groupBy__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_devices__ = __webpack_require__(12);
var modelTypeGroupMap=function modelTypeGroupMap(model){return new Map([[true,model],[__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["gu10DimmableModelTypes"].includes(model),__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["gu10DimmableModelTypes"][model]],[__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["gu10TuneableModelTypes"].includes(model),__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["gu10TuneableModelTypes"][model]],[__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["candlelightDimmableModelTypes"].includes(model),__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["candlelightDimmableModelTypes"][model]],[__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["candlelightTuneableModelTypes"].includes(model),__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["candlelightTuneableModelTypes"][model]]]).get(true);};var mapStateToProps=function mapStateToProps(state,_ref){var devices=_ref.devices;return{devices:Object.values(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_groupBy___default()(function(device){return device.type&&modelTypeGroupMap(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default()('model')(device.props));},devices)),localeSuffix:Object(__WEBPACK_IMPORTED_MODULE_4__core_state_config_selectors__["d" /* getIconLocaleSuffix */])(state),isNano1:Object(__WEBPACK_IMPORTED_MODULE_5__core_state_devices_selectors__["N" /* getIsHubNano1 */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_3__component__["a" /* default */]));

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(224),
    createAggregator = __webpack_require__(2267);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(2268),
    baseAggregator = __webpack_require__(2269),
    baseIteratee = __webpack_require__(55),
    isArray = __webpack_require__(32);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 2268 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(196);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_first__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__group__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__item__ = __webpack_require__(806);
// $FlowFixMe
var DeviceList=function DeviceList(_ref){var devices=_ref.devices,localeSuffix=_ref.localeSuffix,identifyDevice=_ref.identifyDevice,isNano1=_ref.isNano1;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('ul',null,devices.map(function(deviceList){return deviceList.length===1?deviceList.map(function(_ref2){var id=_ref2.id,field=_ref2.field,props=_ref2.props,type=_ref2.type;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('li',{key:id},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__item__["a" /* default */],{capabilities:props.capabilities,field:field,id:id,identifyDevice:identifyDevice,isNano1:isNano1,localeSuffix:localeSuffix,manufacturer:props&&props.manufacturer,model:props&&props.model,online:props&&props.online,type:type}));}):__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('li',{key:'device-group-'+__WEBPACK_IMPORTED_MODULE_1_lodash_fp_first___default()(deviceList).type},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__group__["a" /* default */],{devices:deviceList,identifyDevice:identifyDevice,isNano1:isNano1,localeSuffix:localeSuffix,model:__WEBPACK_IMPORTED_MODULE_1_lodash_fp_first___default()(deviceList).props&&__WEBPACK_IMPORTED_MODULE_1_lodash_fp_first___default()(deviceList).props.model,type:__WEBPACK_IMPORTED_MODULE_1_lodash_fp_first___default()(deviceList).type}));}));};/* harmony default export */ __webpack_exports__["a"] = (DeviceList);

/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_translations_devices__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_svg_icons__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__item_styles__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(2275);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeviceListGroup=function(_React$Component){_inherits(DeviceListGroup,_React$Component);function DeviceListGroup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeviceListGroup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeviceListGroup.__proto__||Object.getPrototypeOf(DeviceListGroup)).call.apply(_ref,[this].concat(args))),_this),_this.state={showGroupItems:false},_this.toggleShowGroupItems=function(){return _this.setState({showGroupItems:!_this.state.showGroupItems});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeviceListGroup,[{key:'render',value:function render(){var _props=this.props,devices=_props.devices,localeSuffix=_props.localeSuffix,model=_props.model,type=_props.type,manufacturer=_props.manufacturer,identifyDevice=_props.identifyDevice,isNano1=_props.isNano1;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["g" /* GroupWrapper */],{onClick:this.toggleShowGroupItems},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__item_styles__["a" /* DeviceIconWrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__item_styles__["g" /* StyledSVGIcon */],{type:Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_svg_icons__["a" /* deviceTypeToIcon */])({model:model,type:type,localeSuffix:localeSuffix})})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["h" /* ItemContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["f" /* GroupName */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3__core_translations_devices__["a" /* findDeviceTypeMessage */])(type,manufacturer,model),{values:{amount:2}}))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* GroupCount */],null,'x',devices.length),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* GroupExpand */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* FlipIcon */],{isExpanded:this.state.showGroupItems},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* DropDownIcon */],null))))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["e" /* GroupItemList */],{component:'ul',enter:{animation:{'max-height':'10rem',rotateX:0},duration:300},leave:{animation:{'max-height':0,rotateX:'90deg'},duration:300}},this.state.showGroupItems&&devices.map(function(_ref2){var id=_ref2.id,field=_ref2.field,props=_ref2.props;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('li',{key:type+'-group-'+id},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__item__["a" /* default */],{capabilities:props.capabilities,field:field,id:id,identifyDevice:identifyDevice,isNano1:isNano1,localeSuffix:localeSuffix,manufacturer:props&&props.manufacturer,model:props&&props.model,online:props&&props.online,type:type}));})));}}]);return DeviceListGroup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DeviceListGroup);

/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({name:{id:'device-list-item.name',defaultMessage:'Device name'}}));

/***/ }),
/* 2273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LabelField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InputField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InputValidation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    clear: both;\n    margin-bottom: 0.5rem;\n    position: relative;\n    width: 100%;\n'],['\n    clear: both;\n    margin-bottom: 0.5rem;\n    position: relative;\n    width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: ',';\n    clip: ',';\n'],['\n    position: ',';\n    clip: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n    border: none;\n    height: 3rem;\n    margin-bottom: 0.1rem;\n    padding: 0 1rem;\n    transition: border-bottom-color 0.3s;\n    border: 1px solid ',';\n    width: 100%;\n    border-radius: 2px;\n\n    &:focus {\n        border-color: ',';\n        outline: none;\n    }\n'],['\n    border: none;\n    height: 3rem;\n    margin-bottom: 0.1rem;\n    padding: 0 1rem;\n    transition: border-bottom-color 0.3s;\n    border: 1px solid ',';\n    width: 100%;\n    border-radius: 2px;\n\n    &:focus {\n        border-color: ',';\n        outline: none;\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    color: ',';\n    float: right;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    margin-top: 0.25rem;\n    opacity: ',';\n    text-align: right;\n    transition: opacity 0.3s;\n    width: 100%;\n    height: ',';\n'],['\n    color: ',';\n    float: right;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    margin-top: 0.25rem;\n    opacity: ',';\n    text-align: right;\n    transition: opacity 0.3s;\n    width: 100%;\n    height: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InputContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var LabelField=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].label(_templateObject2,function(props){return props.showLabel?'static':'absolute';},function(props){return props.showLabel?'inital':'rect(1px, 1px, 1px, 1px)';});var showError=function showError(props){return props.error&&props.touched||props.serverError&&!props.touched;};var InputField=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].input(_templateObject3,function(props){return showError(props)?props.theme.error:props.theme.mediumGrey;},function(_ref){var theme=_ref.theme;return theme.grey;});var InputValidation=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.error;},function(props){return showError(props)?'1':'0';},function(props){return showError(props)?'1.2rem':'0';});

/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var defaultCondition=function defaultCondition(){return false;};var ConditionalFeature=function ConditionalFeature(_ref){var children=_ref.children,_ref$condition=_ref.condition,condition=_ref$condition===undefined?defaultCondition:_ref$condition,isValidChildren=_ref.isValidChildren,featureFlags=_ref.featureFlags,entitlementFlags=_ref.entitlementFlags,rest=_objectWithoutProperties(_ref,['children','condition','isValidChildren','featureFlags','entitlementFlags']);var shouldRender=isValidChildren&&condition(featureFlags,entitlementFlags);return shouldRender?children(rest):null;};// the next property is used in the ProductPageLayout component
ConditionalFeature.areaName='ConditionalFeature';/* harmony default export */ __webpack_exports__["a"] = (ConditionalFeature);

/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GroupWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GroupName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GroupCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GroupExpand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FlipIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropDownIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GroupItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ItemContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_velocity_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__item_styles_js__ = __webpack_require__(500);
var _templateObject=_taggedTemplateLiteral(['cursor: pointer;'],['cursor: pointer;']),_templateObject2=_taggedTemplateLiteral(['\n    display: flex;\n    flex: 1 0 auto;\n    flex-direction: column;\n    font-weight: bold;\n'],['\n    display: flex;\n    flex: 1 0 auto;\n    flex-direction: column;\n    font-weight: bold;\n']),_templateObject3=_taggedTemplateLiteral(['\n    display: flex;\n    color: ',';\n    flex: 0 0 4rem;\n    justify-content: center;\n'],['\n    display: flex;\n    color: ',';\n    flex: 0 0 4rem;\n    justify-content: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: flex;\n    flex: 0 0 3rem;\n    justify-content: center;\n'],['\n    display: flex;\n    flex: 0 0 3rem;\n    justify-content: center;\n']),_templateObject5=_taggedTemplateLiteral(['\n    transform: rotateZ(',');\n\n    transition: all 0.3s ',';\n'],['\n    transform: rotateZ(',');\n\n    transition: all 0.3s ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n    height: 1em;\n    width: 1em;\n    & g {\n        fill: ',';\n    }\n'],['\n    height: 1em;\n    width: 1em;\n    & g {\n        fill: ',';\n    }\n']),_templateObject7=_taggedTemplateLiteral(['\n    font-size: 0.75em;\n    margin-left: 2rem;\n'],['\n    font-size: 0.75em;\n    margin-left: 2rem;\n']),_templateObject8=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: flex-start;\n    align-content: flex-start;\n    margin-left: 1rem;\n    width: 100%;\n'],['\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: flex-start;\n    align-content: flex-start;\n    margin-left: 1rem;\n    width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var EASING='cubic-bezier(0.215, 0.61, 0.355, 1)';var GroupWrapper=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__item_styles_js__["h" /* Wrapper */])(_templateObject);var GroupName=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2);var GroupCount=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.heavyGrey;});var GroupExpand=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4);var FlipIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5,function(p){return p.isExpanded?'180deg':0;},EASING);var DropDownIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */]).attrs({type:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_general_svg__["a" /* default */].ARROW_DOWN})(_templateObject6,function(props){return props.theme.heavyGrey;});var GroupItemList=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_velocity_react__["VelocityTransitionGroup"])(_templateObject7);var ItemContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject8);

/***/ }),
/* 2276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__numbered_list__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__remove_device__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_device_offline_intl__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_components_widgets_device_offline_redux__ = __webpack_require__(2280);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OfflineComponent=function(_Component){_inherits(OfflineComponent,_Component);function OfflineComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OfflineComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OfflineComponent.__proto__||Object.getPrototypeOf(OfflineComponent)).call.apply(_ref,[this].concat(args))),_this),_this.state={showExtendedSupport:false,refreshing:false},_this.refresh=function(){var refresh=_this.props.refresh;// Dispatch request all devices
refresh();_this.setState({refreshing:true});setTimeout(function(){_this.setState({refreshing:false,showExtendedSupport:true});},5000);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OfflineComponent,[{key:'render',value:function render(){var _props=this.props,deviceId=_props.deviceId,deviceInstructions=_props.deviceInstructions,hiveHomeLink=_props.hiveHomeLink,hiveHomeLinkText=_props.hiveHomeLinkText,isRemovable=_props.isRemovable,phoneNumber=_props.phoneNumber,placementGuideUrl=_props.placementGuideUrl,showPhoneNumber=_props.showPhoneNumber;var _state=this.state,refreshing=_state.refreshing,showExtendedSupport=_state.showExtendedSupport;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_device_offline_intl__["a" /* default */].subheading)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__numbered_list__["a" /* default */],null,deviceInstructions.map(function(msg){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_device_offline_intl__["a" /* default */][msg],{key:msg,values:{break:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),link:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* OfflinePageLink */],{href:placementGuideUrl,target:'_blank'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_device_offline_intl__["a" /* default */].hubGuideLinkText))}}));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_device_offline_intl__["a" /* default */].note)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,showPhoneNumber&&!showExtendedSupport&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["l" /* Button */],{disabled:refreshing,onClick:this.refresh},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_device_offline_intl__["a" /* default */].refresh)),isRemovable&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* RemoveDeviceOffset */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__remove_device__["a" /* default */],{deviceId:deviceId}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["_16" /* WaitingIndicator */],{show:refreshing}),showExtendedSupport&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_widgets_device_offline_intl__["a" /* default */].extendedSupport,{values:{hiveHomeLink:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* OfflinePageLink */],{href:hiveHomeLink,target:'_blank'},hiveHomeLinkText)}}))),phoneNumber&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* PhoneNumberStyles */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["O" /* PhoneNumber */],{phoneNumber:phoneNumber}))));}}]);return OfflineComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var Offline=function Offline(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__core_components_widgets_device_offline_redux__["a" /* default */],Object.assign({},props,{render:function render(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(OfflineComponent,props);}}));};/* harmony default export */ __webpack_exports__["a"] = (Offline);

/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return List; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Item; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    list-style: none;\n    padding: 0;\n    margin: 1.5em 0;\n    text-align: left;\n'],['\n    position: relative;\n    list-style: none;\n    padding: 0;\n    margin: 1.5em 0;\n    text-align: left;\n']),_templateObject2=_taggedTemplateLiteral(['\n    counter-increment: step-counter;\n    line-height: 2em;\n    margin: 0 0 1em 3em;\n    padding: 0;\n\n    &:before {\n        content: counter(step-counter);\n        position: absolute;\n        left: 0;\n        border: 1px solid ',';\n        width: 2em;\n        height: 2em;\n        border-radius: 2em;\n        text-align: center;\n        vertical-align: middle;\n    }\n'],['\n    counter-increment: step-counter;\n    line-height: 2em;\n    margin: 0 0 1em 3em;\n    padding: 0;\n\n    &:before {\n        content: counter(step-counter);\n        position: absolute;\n        left: 0;\n        border: 1px solid ',';\n        width: 2em;\n        height: 2em;\n        border-radius: 2em;\n        text-align: center;\n        vertical-align: middle;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var List=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ol(_templateObject);var Item=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].li(_templateObject2,function(_ref){var theme=_ref.theme;return theme.mediumGrey;});

/***/ }),
/* 2278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({subheading:{id:'manage-device.subheading',defaultMessage:'Please try the following steps in order'},step1:{id:'manage-device.step1',defaultMessage:"Unplug your hub's power supply and plug back in again"},step2:{id:'manage-device.step2',defaultMessage:'Check your device has power, is turned on or has batteries'},step3:{id:'manage-device.step3',defaultMessage:'When the hub lights stop flashing, tap refresh'},note:{id:'manage-device.note',defaultMessage:'Note: you will still be able to control any connected devices from the menu'},refresh:{id:'manage-device.refresh',defaultMessage:'Refresh'},extendedSupport:{id:'manage-device.extended-support',defaultMessage:'If the above steps have not helped please check {hiveHomeLink} for our support hours.'},checkPlug:{id:'manage-device.check-plug',defaultMessage:'Check the plug has power by confirming the wall socket is on, if not, turn it on, wait a couple of minutes and press refresh'},checkPower:{id:'manage-device.check-power',defaultMessage:'If you have other Hive devices, check they are all powered by turning them on at the light switch or wall socket, wait a couple of minutes and press refresh'},turnPlugOff:{id:'manage-device.turn-plug-off',defaultMessage:'Turn the affected plug off and back on again at the wall socket, wait a couple of minutes and press refresh'},checkPlacement:{id:'manage-device.check-placement',defaultMessage:'Check your Hive Hub is placed correctly by following the guide {link}'},turnOffOn:{id:'manage-device.turn-off-on',defaultMessage:'At your Hive Hub turn it off and back on again at the wall socket, wait 10 minutes and press refresh'},checkLight:{id:'manage-device.check-light',defaultMessage:'Check the affected light has power by confirming the light switch or wall socket is on, if not, turn it on, wait a couple of minutes and press refresh'},checkBridge:{id:'manage-device.check-bridge',defaultMessage:'Check that your Philips Hue bridge is powered and connected to your router'},contactPhilips:{id:'manage-device.contact-philips',defaultMessage:'In the Hue app if you’re unable to control your lights please contact Philips Hue for support.'},'remove-Philips':{id:'manage-device.remove-philips',defaultMessage:'Delete Philips Hue'},turnLightOffOn:{id:'manage-device.turn-light-off-on',defaultMessage:'Turn the affected light off and back on again at the light switch or wall socket, wait a couple of minutes and press refresh'},openSensorCase:{id:'manage-device.open-sensor-case',defaultMessage:'On the sensor press the side markings and pull open the case. Remove and then reinsert the battery, wait a couple of minutes and press refresh'},pressBackButton:{id:'manage-device.press-back-button',defaultMessage:'Press the back button on the thermostat to ensure the device has power, if not, replace the batteries and wait a couple of minutes then press refresh'},callUs:{id:'manage-device.call-us',defaultMessage:'If there is no light on the boiler module with the power switched on, you need to call us on the number below (click refresh). If you have a green light, please turn the mains power switch for the boiler off and back on, wait a couple of minutes and press refresh'},pressTabThermostat:{id:'manage-device.press-tab-thermostat',defaultMessage:'Press the tab at the bottom of the thermostat and lift off the wall. Remove and then reinsert a battery, wait a couple of minutes and press refresh'},checkHasLight:{id:'manage-device.check-has-light',defaultMessage:'Check your boiler module has a light, if not, ensure mains power switch for boiler is on.'},hubGuideLinkText:{id:'manage-device.hub-guide-link-text',defaultMessage:'here'},naStep1:{id:'manage-device.naStep1',defaultMessage:'Remove the thermostat faceplate from the wall'},naStep2:{id:'manage-device.naStep2',defaultMessage:'Check your wires are secure and in the correct terminals. {break} Tip: You can compare this to the photo you took when you installed your thermostat'},naStep3:{id:'manage-device.naStep3',defaultMessage:'Put the faceplate back on, confirm your wiring and tap refresh below'}}));

/***/ }),
/* 2279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OfflinePageLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PhoneNumberStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RemoveDeviceOffset; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['color: ',';'],['color: ',';']),_templateObject2=_taggedTemplateLiteral(['text-align: center;'],['text-align: center;']),_templateObject3=_taggedTemplateLiteral(['margin-left: 2rem;'],['margin-left: 2rem;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var OfflinePageLink=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].a(_templateObject,function(props){return props.theme.mainBrandColor;});var PhoneNumberStyles=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].p(_templateObject2);var RemoveDeviceOffset=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject3);

/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domains_container__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(2281);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(__WEBPACK_IMPORTED_MODULE_2____["b" /* mapStateToProps */],__WEBPACK_IMPORTED_MODULE_2____["a" /* mapDispatchToProps */])(__WEBPACK_IMPORTED_MODULE_1__domains_container__["a" /* default */]));

/***/ }),
/* 2281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapStateToProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapDispatchToProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__devices_offline_instructions__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_devices_actions__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_devices__ = __webpack_require__(12);
var mapStateToProps=function mapStateToProps(state,_ref){var type=_ref.type,deviceId=_ref.deviceId;var supportedTypes=Object(__WEBPACK_IMPORTED_MODULE_2__state_config_selectors__["a" /* getConfig */])(state,'help:showDeviceOfflineNumberFor');var phoneNumber=(!supportedTypes||supportedTypes.includes(type))&&Object(__WEBPACK_IMPORTED_MODULE_2__state_config_selectors__["a" /* getConfig */])(state,'help:deviceOfflineTelephoneNumber');var manufacturer=Object(__WEBPACK_IMPORTED_MODULE_4__state_devices_selectors__["q" /* getDeviceManufacturer */])(state,{id:deviceId})||'';var deviceInstructions=__WEBPACK_IMPORTED_MODULE_1__devices_offline_instructions__["a" /* default */][type+'-'+manufacturer]||__WEBPACK_IMPORTED_MODULE_1__devices_offline_instructions__["a" /* default */][type];var showPhoneNumber=Object(__WEBPACK_IMPORTED_MODULE_2__state_config_selectors__["c" /* getFeatureFlag */])(state,'showPhoneNumber');return{deviceId:deviceId,deviceInstructions:deviceInstructions,hiveHomeLink:Object(__WEBPACK_IMPORTED_MODULE_2__state_config_selectors__["a" /* getConfig */])(state,'help:mainLink'),hiveHomeLinkText:Object(__WEBPACK_IMPORTED_MODULE_2__state_config_selectors__["a" /* getConfig */])(state,'help:mainLinkText'),isRemovable:__WEBPACK_IMPORTED_MODULE_5__constants_devices__["removableDevicesByManufacturers"].includes(manufacturer),phoneNumber:phoneNumber,placementGuideUrl:Object(__WEBPACK_IMPORTED_MODULE_2__state_config_selectors__["a" /* getConfig */])(state,'help:hubPlacementGuide'),showPhoneNumber:showPhoneNumber};};var mapDispatchToProps={refresh:__WEBPACK_IMPORTED_MODULE_3__state_devices_actions__["c" /* loadManageDevices */]};

/***/ }),
/* 2282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_devices__ = __webpack_require__(12);
var _deviceTypes$ACTIVE_P;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var sensor=['checkPower','openSensorCase','checkPlacement','turnOffOn'];var heating=['pressBackButton','checkPower','pressTabThermostat','checkHasLight','callUs','checkPlacement','turnOffOn'];var nathermostat=['naStep1','naStep2','naStep3'];var plug=['checkPlug','checkPower','turnPlugOff','checkPlacement','turnOffOn'];var bulb=['checkLight','checkPower','turnLightOffOn','checkPlacement','turnOffOn'];var hueDevice=['checkLight','checkBridge','contactPhilips'];var hub=['step1','step2','step3'];/* harmony default export */ __webpack_exports__["a"] = (_deviceTypes$ACTIVE_P={},_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].ACTIVE_PLUG,plug),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].SIGNAL_BOOSTER,plug),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].SMART_PLUG,plug),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].BOILER_MODULE,heating),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].NA_THERMOSTAT,nathermostat),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,bulb),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].COLOR_LIGHT,bulb),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].TUNEABLE_LIGHT,bulb),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].WARM_WHITE_LIGHT,bulb),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT+'-'+__WEBPACK_IMPORTED_MODULE_0__constants_devices__["manufacturers"].PHILIPS,hueDevice),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].COLOR_LIGHT+'-'+__WEBPACK_IMPORTED_MODULE_0__constants_devices__["manufacturers"].PHILIPS,hueDevice),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].TUNEABLE_LIGHT+'-'+__WEBPACK_IMPORTED_MODULE_0__constants_devices__["manufacturers"].PHILIPS,hueDevice),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].WARM_WHITE_LIGHT+'-'+__WEBPACK_IMPORTED_MODULE_0__constants_devices__["manufacturers"].PHILIPS,hueDevice),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].CONTACT_SENSOR,sensor),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].MOTION_SENSOR,sensor),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].HIVE_BUTTON,sensor),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].HEATING,heating),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].HOT_WATER,heating),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].HUB,hub),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].THERMOSTAT_UI,heating),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].HUE_BRIDGE,hueDevice),_defineProperty(_deviceTypes$ACTIVE_P,__WEBPACK_IMPORTED_MODULE_0__constants_devices__["deviceTypes"].SENSE,hub),_deviceTypes$ACTIVE_P);

/***/ }),
/* 2283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    background-color: ',';\n    cursor: pointer;\n    font-size: 1.3em;\n    height: ',';\n    position: relative;\n'],['\n    background-color: ',';\n    cursor: pointer;\n    font-size: 1.3em;\n    height: ',';\n    position: relative;\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    display: flex;\n    height: calc(',' - 1px);\n    justify-content: center;\n    pointer-events: none;\n    position: absolute;\n    right: 0;\n    width: 3rem;\n'],['\n    align-items: center;\n    background-color: ',';\n    display: flex;\n    height: calc(',' - 1px);\n    justify-content: center;\n    pointer-events: none;\n    position: absolute;\n    right: 0;\n    width: 3rem;\n']),_templateObject3=_taggedTemplateLiteral(['\n    flex: 0 0 3em;\n    height: 1.1em;\n    width: 1.1em;\n\n    & > g {\n        fill: ',';\n    }\n'],['\n    flex: 0 0 3em;\n    height: 1.1em;\n    width: 1.1em;\n\n    & > g {\n        fill: ',';\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    appearance: none;\n    background-color: transparent;\n    border: none;\n    border-bottom: 1px solid ',';\n    border-radius: 0;\n    cursor: pointer;\n    height: ',';\n    overflow: hidden;\n    padding-left: 0.5em;\n    position: absolute;\n    top: 0;\n    transition: border 0.2s ease-in;\n    width: 100%;\n\n    &:-moz-focusring {\n        color: transparent;\n        text-shadow: 0 0 0 #000;\n    }\n\n    &:hover,\n    &:focus {\n        border-bottom-color: ',';\n        outline: none;\n    }\n\n    &:-ms-expand {\n        display: none;\n    }\n'],['\n    appearance: none;\n    background-color: transparent;\n    border: none;\n    border-bottom: 1px solid ',';\n    border-radius: 0;\n    cursor: pointer;\n    height: ',';\n    overflow: hidden;\n    padding-left: 0.5em;\n    position: absolute;\n    top: 0;\n    transition: border 0.2s ease-in;\n    width: 100%;\n\n    &:-moz-focusring {\n        color: transparent;\n        text-shadow: 0 0 0 #000;\n    }\n\n    &:hover,\n    &:focus {\n        border-bottom-color: ',';\n        outline: none;\n    }\n\n    &:-ms-expand {\n        display: none;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var height='2em';var Base=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(p){return p.color?p.color:p.theme.white;},height);var IconContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(p){return p.color?p.color:p.theme.white;},height);var Icon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject3,function(p){return p.theme.mainBrandColor;});var Select=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].select(_templateObject4,function(p){return p.theme.mediumGrey;},height,function(p){return p.theme.mainBrandColor;});

/***/ }),
/* 2284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({pleaseSelect:{id:'recipe-item.please-select',defaultMessage:'Please Select...'}}));

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(2286);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 2289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(2290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
// @noflow
var propTypes={hubDateTime:__WEBPACK_IMPORTED_MODULE_2_react_moment_proptypes__["momentObj"].isRequired};var HubClock=function HubClock(_ref){var hubDateTime=_ref.hubDateTime;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* HubClockContainer */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* HomeIcon */],{type:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__["a" /* default */].HOME}),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* HubClockLongTimeSpan */],null,hubDateTime.format('llll')),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* HubClockShortTimeSpan */],null,hubDateTime.format('LT')));};HubClock.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (HubClock);

/***/ }),
/* 2290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HubClockContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HomeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HubClockLongTimeSpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HubClockShortTimeSpan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    font-size: 1rem;\n    justify-content: flex-end;\n    padding: 0 1em;\n'],['\n    align-items: center;\n    display: flex;\n    font-size: 1rem;\n    justify-content: flex-end;\n    padding: 0 1em;\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: 1.3rem;\n    margin-bottom: 0.3rem;\n    margin-right: 0.4rem;\n    width: 1.3rem;\n'],['\n    height: 1.3rem;\n    margin-bottom: 0.3rem;\n    margin-right: 0.4rem;\n    width: 1.3rem;\n']),_templateObject3=_taggedTemplateLiteral(['\n    display: none;\n\n    ',';\n'],['\n    display: none;\n\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n\t\tdisplay: inherit;\n\t'],['\n\t\tdisplay: inherit;\n\t']),_templateObject5=_taggedTemplateLiteral(['\n    display: inherit;\n\n    ',';\n'],['\n    display: inherit;\n\n    ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n\t\tdisplay: none;\n\t'],['\n\t\tdisplay: none;\n\t']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var HubClockContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject);var HomeIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */])(_templateObject2);var HubClockLongTimeSpan=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject3,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject4));var HubClockShortTimeSpan=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject5,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject6));

/***/ }),
/* 2291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconMenuContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Item; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Icons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-around;\n    list-style-type: none;\n    padding: 0;\n    width: 100%;\n'],['\n    display: flex;\n    justify-content: space-around;\n    list-style-type: none;\n    padding: 0;\n    width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n    text-align: center;\n    line-height: 3em;\n    color: ',';\n    transition: color 0.4s ease-in-out;\n\n    &:hover {\n        cursor: pointer;\n        color: ',';\n    }\n'],['\n    text-align: center;\n    line-height: 3em;\n    color: ',';\n    transition: color 0.4s ease-in-out;\n\n    &:hover {\n        cursor: pointer;\n        color: ',';\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    height: ',';\n    position: relative;\n    top: calc(',' / 4);\n    width: ',';\n\n    & g {\n        fill: ',';\n        transition: fill 0.1s ease-in-out;\n    }\n\n    ',':hover & {\n        & g {\n            fill: ',';\n        }\n    }\n'],['\n    height: ',';\n    position: relative;\n    top: calc(',' / 4);\n    width: ',';\n\n    & g {\n        fill: ',';\n        transition: fill 0.1s ease-in-out;\n    }\n\n    ',':hover & {\n        & g {\n            fill: ',';\n        }\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: inline-block;\n    margin-right: 0.3em;\n'],['\n    display: inline-block;\n    margin-right: 0.3em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IconMenuContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ul(_templateObject);var Item=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].li(_templateObject2,function(p){return new Map([[true,p.theme.primaryFontColor],[p.disabled&&!p.isSelected,p.theme.mediumGrey],[p.isSelected,p.theme.mainBrandColor]]).get(true);},function(props){return!props.disabled&&props.theme.mainBrandColor;});var iconSizeNormal='1.5em';var Icon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject3,iconSizeNormal,iconSizeNormal,iconSizeNormal,function(p){return new Map([[true,p.theme.primaryFontColor],[p.disabled&&!p.isSelected,p.theme.mediumGrey],[p.isSelected,p.theme.mainBrandColor]]).get(true);},Item,function(props){return!props.disabled&&props.theme.mainBrandColor;});var Icons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4);

/***/ }),
/* 2292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledRouterLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledExternalLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    a {\n        color: ',';\n        text-decoration: none;\n    }\n'],['\n    a {\n        color: ',';\n        text-decoration: none;\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    color: ',';\n    text-decoration: none;\n'],['\n    color: ',';\n    text-decoration: none;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledRouterLink=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject,function(_ref){var theme=_ref.theme,alternate=_ref.alternate;return alternate?theme.secondaryLinkColor:theme.mainBrandColor;});var StyledExternalLink=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].a(_templateObject2,function(_ref2){var theme=_ref2.theme,alternate=_ref2.alternate;return alternate?theme.secondaryLinkColor:theme.mainBrandColor;});

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(249);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
  };

  return Link;
}(_react2.default.Component);

Link.propTypes = {
  onClick: _propTypes2.default.func,
  target: _propTypes2.default.string,
  replace: _propTypes2.default.bool,
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.shape({
      push: _propTypes2.default.func.isRequired,
      replace: _propTypes2.default.func.isRequired,
      createHref: _propTypes2.default.func.isRequired
    }).isRequired
  }).isRequired
};
exports.default = Link;

/***/ }),
/* 2294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_TransitionGroup__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_TransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_TransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routing_page_transition__ = __webpack_require__(2295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2297);
var LoadTransition=function LoadTransition(_ref){var transitionKey=_ref.transitionKey,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_transition_group_TransitionGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__routing_page_transition__["a" /* default */],{key:transitionKey},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* AnimatedContentContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* AnimatedContent */],null,children))));};/* harmony default export */ __webpack_exports__["a"] = (LoadTransition);

/***/ }),
/* 2295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2296);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children,inProp=_ref.in;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* StyledCSSTransition */],{classNames:'fade','in':inProp,timeout:{enter:__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* TRANSITION_ENTER_DURATION */],exit:__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* TRANSITION_EXIT_DURATION */]},unmountOnExit:true},children);});

/***/ }),
/* 2296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledCSSTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    width: 100%;\n\n    &.fade-enter {\n        left: 0;\n        opacity: 0;\n        top: 0;\n        transform: translateY(5em);\n        z-index: 100;\n    }\n    &.fade-enter.fade-enter-active {\n        opacity: 1;\n        transform: translateY(0);\n        transition: opacity ','ms ','ms ',',\n            transform ','ms ','ms ',';\n    }\n\n    &.fade-exit {\n        opacity: 1;\n        transform: scale(1);\n        z-index: 1;\n    }\n    &.fade-exit.fade-exit-active {\n        opacity: 0;\n        transform: scale(0.8);\n        transition: opacity ','ms ',',\n            transform ','ms ',';\n    }\n'],['\n    position: relative;\n    width: 100%;\n\n    &.fade-enter {\n        left: 0;\n        opacity: 0;\n        top: 0;\n        transform: translateY(5em);\n        z-index: 100;\n    }\n    &.fade-enter.fade-enter-active {\n        opacity: 1;\n        transform: translateY(0);\n        transition: opacity ','ms ','ms ',',\n            transform ','ms ','ms ',';\n    }\n\n    &.fade-exit {\n        opacity: 1;\n        transform: scale(1);\n        z-index: 1;\n    }\n    &.fade-exit.fade-exit-active {\n        opacity: 0;\n        transform: scale(0.8);\n        transition: opacity ','ms ',',\n            transform ','ms ',';\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var easeOutQuart='cubic-bezier(0.165, 0.84, 0.44, 1)';var StyledCSSTransition=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition___default.a)(_templateObject,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* TRANSITION_ENTER_DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* TRANSITION_ENTER_DELAY */],easeOutQuart,__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* TRANSITION_ENTER_DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* TRANSITION_ENTER_DELAY */],easeOutQuart,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* TRANSITION_EXIT_DURATION */],easeOutQuart,__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* TRANSITION_EXIT_DURATION */],easeOutQuart);

/***/ }),
/* 2297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnimatedContentContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimatedContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    flex-grow: 1;\n    width: 100%;\n'],['\n    display: flex;\n    flex-grow: 1;\n    width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['width: 100%;'],['width: 100%;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AnimatedContentContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var AnimatedContent=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);

/***/ }),
/* 2298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_dom_resize__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__logs__ = __webpack_require__(2301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_moment_proptypes__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_moment_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_moment_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__timeline__ = __webpack_require__(2315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__zoom__ = __webpack_require__(2325);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
// import PreventBackGesture from '../prevent-back-gesture';
var MAX_TICKS_MOBILE=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].MAX_TICKS_MOBILE,MAX_TICKS_TABLET=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].MAX_TICKS_TABLET,MAX_TICKS_DESKTOP=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].MAX_TICKS_DESKTOP,MAX_TICKS_LARGE=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].MAX_TICKS_LARGE,MAX_TICKS_XLARGE=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].MAX_TICKS_XLARGE,MIN_TICKS_ON_SCREEN=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].MIN_TICKS_ON_SCREEN,MERGE_THRESHOLD_HOUR=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].MERGE_THRESHOLD_HOUR,VIEW_MOBILE=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].VIEW_MOBILE,VIEW_TABLET=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].VIEW_TABLET,VIEW_DESKTOP=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].VIEW_DESKTOP,VIEW_LARGE=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].VIEW_LARGE,ZOOM_HOUR=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].ZOOM_HOUR,ZOOM_MINS=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].ZOOM_MINS;var getTicksToDisplay=function getTicksToDisplay(componentWidth){var _truthMap;var truthMap=(_truthMap={},_defineProperty(_truthMap,true,MIN_TICKS_ON_SCREEN),_defineProperty(_truthMap,componentWidth>VIEW_LARGE,MAX_TICKS_XLARGE),_defineProperty(_truthMap,componentWidth>VIEW_DESKTOP&&componentWidth<=VIEW_LARGE,MAX_TICKS_LARGE),_defineProperty(_truthMap,componentWidth>VIEW_TABLET&&componentWidth<=VIEW_DESKTOP,MAX_TICKS_DESKTOP),_defineProperty(_truthMap,componentWidth>VIEW_MOBILE&&componentWidth<=VIEW_TABLET,MAX_TICKS_TABLET),_defineProperty(_truthMap,componentWidth<=VIEW_MOBILE,MAX_TICKS_MOBILE),_truthMap);return truthMap[true];};var canIncrease=function canIncrease(zoomLevel){return zoomLevel!==ZOOM_MINS;};var canDecrease=function canDecrease(zoomLevel){return zoomLevel!==ZOOM_HOUR;};var LogsTimeline=function(_Component){_inherits(LogsTimeline,_Component);function LogsTimeline(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LogsTimeline);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LogsTimeline.__proto__||Object.getPrototypeOf(LogsTimeline)).call.apply(_ref,[this].concat(args))),_this),_this.increaseZoom=function(){var _this$props=_this.props,zoomLevel=_this$props.zoomLevel,updateZoomLevel=_this$props.updateZoomLevel;if(!canIncrease(zoomLevel)){return;}var nextZoomLevel=__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* increaseZoomMap */][zoomLevel];updateZoomLevel(nextZoomLevel);},_this.decreaseZoom=function(){var _this$props2=_this.props,zoomLevel=_this$props2.zoomLevel,updateZoomLevel=_this$props2.updateZoomLevel;if(!canDecrease(zoomLevel)){return;}var nextZoomLevel=__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* decreaseZoomMap */][zoomLevel];updateZoomLevel(nextZoomLevel);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LogsTimeline,[{key:'render',value:function render(){var _this2=this;var _props=this.props,formatMessage=_props.intl.formatMessage,now=_props.now,simpleMergedLabel=_props.simpleMergedLabel,sensorLogs=_props.sensorLogs,timelineEnd=_props.timelineEnd,timelineStart=_props.timelineStart,zoomLevel=_props.zoomLevel;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__dom_dom_resize__["a" /* default */],null,function(_ref2){var width=_ref2.width;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__zoom__["a" /* default */],{canDecrease:canDecrease(zoomLevel),canIncrease:canIncrease(zoomLevel),decreaseZoom:_this2.decreaseZoom,increaseZoom:_this2.increaseZoom,zoomLevel:zoomLevel}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'logs-timeline-container'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'logs-timeline-component'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__timeline__["a" /* default */],{minTicksDisplayed:getTicksToDisplay(width),now:now,timelineEnd:timelineEnd,timelineStart:timelineStart,zoomLevel:zoomLevel}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__logs__["a" /* default */],{formatMessage:formatMessage,mergeThreshold:__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* mergeThresholdMap */][zoomLevel]||MERGE_THRESHOLD_HOUR,minTicksDisplayed:getTicksToDisplay(width),sensorLogs:sensorLogs,simpleMergedLabel:simpleMergedLabel,timelineEnd:timelineEnd,timelineStart:timelineStart,zoomLevel:zoomLevel}))));});}}]);return LogsTimeline;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);LogsTimeline.propTypes={intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["h" /* intlShape */].isRequired,now:__WEBPACK_IMPORTED_MODULE_6_react_moment_proptypes__["momentObj"].isRequired,sensorLogs:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array.isRequired,simpleMergedLabel:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,timelineEnd:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,timelineStart:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,updateZoomLevel:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,zoomLevel:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number};LogsTimeline.defaultProps={zoomLevel:ZOOM_HOUR};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["g" /* injectIntl */])(LogsTimeline));

/***/ }),
/* 2299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 100%;\n    position: relative;\n    width: 100%;\n'],['\n    height: 100%;\n    position: relative;\n    width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getTimelineEndRounded */
/* unused harmony export getTickAmount */
/* unused harmony export getTickSpaceWidth */
/* unused harmony export getPositionOffset */
/* unused harmony export getWidthUnits */
/* unused harmony export getTotalWidth */
/* unused harmony export getDateFromStart */
/* unused harmony export getRightDistance */
/* unused harmony export getEventLogStyle */
/* unused harmony export formatZIndex */
/* unused harmony export mergeStylesWithZIndex */
/* unused harmony export getLogBGStyle */
/* unused harmony export getDurationMessage */
/* unused harmony export getMultipleEventsMessage */
/* unused harmony export formatLog */
/* unused harmony export mergeLog */
/* unused harmony export mergeOverlaps */
/* unused harmony export getLogsData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_toPairs__ = __webpack_require__(2302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_toPairs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_toPairs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_replace__ = __webpack_require__(2307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_map__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_last__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_fromPairs__ = __webpack_require__(2309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_fp_fromPairs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_fromPairs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_state_hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__info_intl_js__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component__ = __webpack_require__(2311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_instadate__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_instadate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_instadate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_constants_time_units__ = __webpack_require__(315);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// @noflow
var removePercent=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_replace___default()('%','');var wrapValuesWithPercent=__WEBPACK_IMPORTED_MODULE_5_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_fromPairs___default.a,__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default()(function(_ref){var _ref2=_slicedToArray(_ref,2),x=_ref2[0],y=_ref2[1];return[x,y+'%'];}),__WEBPACK_IMPORTED_MODULE_0_lodash_fp_toPairs___default.a);var unwrapPercentValues=__WEBPACK_IMPORTED_MODULE_5_lodash_fp_flowRight___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_fp_fromPairs___default.a,__WEBPACK_IMPORTED_MODULE_2_lodash_fp_map___default()(function(_ref3){var _ref4=_slicedToArray(_ref3,2),x=_ref4[0],y=_ref4[1];return[x,removePercent(y)];}),__WEBPACK_IMPORTED_MODULE_0_lodash_fp_toPairs___default.a);var fixPercentStringToDecimal=__WEBPACK_IMPORTED_MODULE_5_lodash_fp_flowRight___default()(Number,function(n){return n.toFixed(2);},Number,removePercent);/**
 * Returns UTC time of passed in UTC date plus one hour
 * @param  {int} utcDate [utc time of a given date]
 * @return {int} utcDate [utc time of date plus one hour with seconds and millisconds set at 0]
 */function getHourRoundedUTC(utcDate){var originalDate=new Date(utcDate);var roundedDate=Object(__WEBPACK_IMPORTED_MODULE_11_instadate__["addHours"])(originalDate,1);var timezoneOffsetMinutes=roundedDate.getTimezoneOffset();roundedDate.setMinutes(0,0,0);return Object(__WEBPACK_IMPORTED_MODULE_11_instadate__["utc"])(Object(__WEBPACK_IMPORTED_MODULE_11_instadate__["addMinutes"])(roundedDate,timezoneOffsetMinutes));}/**
 * Returns Milliseconds from end - start
 * @param  {int} start UTCDate in Milliseconds
 * @param  {int} end UTCDate in Milliseconds
 * @return {int} end - start
 */var getMSDuration=function getMSDuration(_ref5){var start=_ref5.start,end=_ref5.end;return start&&end?end-start:null;};var MILLISECONDS_IN_HOUR=3600000;var getTimelineEndRounded=function getTimelineEndRounded(timelineEnd){return getHourRoundedUTC(timelineEnd);};var getTickAmount=function getTickAmount(_ref6){var timelineEnd=_ref6.timelineEnd,timelineStart=_ref6.timelineStart,zoomLevel=_ref6.zoomLevel;return 1+(getTimelineEndRounded(timelineEnd)-timelineStart)/MILLISECONDS_IN_HOUR*zoomLevel;};var getTickSpaceWidth=function getTickSpaceWidth(minTicksDisplayed){return 100/minTicksDisplayed;};var getPositionOffset=__WEBPACK_IMPORTED_MODULE_5_lodash_fp_flowRight___default()(function(tickSpaceWidth){return tickSpaceWidth*0.5;},getTickSpaceWidth);var getMinTicksPositionOffset=function getMinTicksPositionOffset(_ref7){var minTicksDisplayed=_ref7.minTicksDisplayed,timelineEnd=_ref7.timelineEnd,timelineStart=_ref7.timelineStart,zoomLevel=_ref7.zoomLevel;var tickSpaceWidth=getTickSpaceWidth(minTicksDisplayed);var timelineEndRounded=__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default()(timelineEnd).add(1,'hour').startOf('hour').valueOf();var tickAmount=1+(timelineEndRounded-timelineStart)/MILLISECONDS_IN_HOUR*zoomLevel;return getPositionOffset(minTicksDisplayed)+Math.max(minTicksDisplayed-tickAmount,0)*tickSpaceWidth;};var getWidthUnits=__WEBPACK_IMPORTED_MODULE_5_lodash_fp_flowRight___default()(function(tickSpaceWidth){return tickSpaceWidth/MILLISECONDS_IN_HOUR;},getTickSpaceWidth);var getTotalWidth=function getTotalWidth(_ref8){var minTicksDisplayed=_ref8.minTicksDisplayed,timelineEnd=_ref8.timelineEnd,timelineStart=_ref8.timelineStart,zoomLevel=_ref8.zoomLevel;var tickAmount=getTickAmount({timelineEnd:timelineEnd,timelineStart:timelineStart,zoomLevel:zoomLevel});var tickSpaceWidth=getTickSpaceWidth(minTicksDisplayed);return tickAmount*tickSpaceWidth;};var getDateFromStart=function getDateFromStart(_ref9){var hubTimezone=_ref9.hubTimezone,start=_ref9.start;return start&&hubTimezone?__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.tz(start,hubTimezone):null;};var getRightDistance=function getRightDistance(_ref10){var positionOffset=_ref10.positionOffset,timeAsDuration=_ref10.timeAsDuration,widthUnits=_ref10.widthUnits,zoomLevel=_ref10.zoomLevel;return timeAsDuration*widthUnits*zoomLevel+positionOffset;};var getEventLogStyle=function getEventLogStyle(_ref11){var logTime=_ref11.logTime,minTicksDisplayed=_ref11.minTicksDisplayed,timelineEnd=_ref11.timelineEnd,timelineStart=_ref11.timelineStart,zoomLevel=_ref11.zoomLevel;var timeAsDuration=getMSDuration({start:logTime,end:getTimelineEndRounded(timelineEnd)});var positionOffset=getMinTicksPositionOffset({minTicksDisplayed:minTicksDisplayed,timelineEnd:timelineEnd,timelineStart:timelineStart,zoomLevel:zoomLevel});var widthUnits=getWidthUnits(minTicksDisplayed);var logRight=getRightDistance({positionOffset:positionOffset,timeAsDuration:timeAsDuration,widthUnits:widthUnits,zoomLevel:zoomLevel});return{right:logRight};};var formatZIndex=function formatZIndex(index){return{zIndex:index};};var mergeStylesWithZIndex=function mergeStylesWithZIndex(style,index){return Object.assign({},style,formatZIndex(index));};var getLogBGStyle=function getLogBGStyle(_ref12){var end=_ref12.end,endStyleValues=_ref12.endStyleValues,inMotion=_ref12.inMotion,minTicksDisplayed=_ref12.minTicksDisplayed,start=_ref12.start,startStyleValues=_ref12.startStyleValues,timelineEnd=_ref12.timelineEnd,zoomLevel=_ref12.zoomLevel;var widthUnits=getWidthUnits(minTicksDisplayed);var logStyleBGWidth=void 0;var logStyleBGRight=void 0;if(start&&end){logStyleBGRight=endStyleValues.right;logStyleBGWidth=startStyleValues.right-endStyleValues.right;}else if(start&&!end){// Current Event Log in motion
if(inMotion){var nowWidth=(timelineEnd-start)*widthUnits*zoomLevel;logStyleBGRight=startStyleValues.right-nowWidth;logStyleBGWidth=nowWidth;}else{logStyleBGRight=startStyleValues.right;logStyleBGWidth=0;}}else if(!start&&end){//Log from day before
logStyleBGRight=endStyleValues.right;logStyleBGWidth=getPositionOffset(minTicksDisplayed);}return wrapValuesWithPercent({right:logStyleBGRight,width:logStyleBGWidth});};var getDurationMessage=function getDurationMessage(formatMessage,duration){return duration?__WEBPACK_IMPORTED_MODULE_10_moment_timezone___default.a.duration(duration).humanize().toString().split(' ').reduce(function(msg,str){var id=__WEBPACK_IMPORTED_MODULE_12__core_constants_time_units__["d" /* messages */][str];var returnStr=id?formatMessage(__WEBPACK_IMPORTED_MODULE_12__core_constants_time_units__["d" /* messages */][str]):str;return[].concat(_toConsumableArray(msg),[returnStr]);},[]).join(' '):null;};var getMultipleEventsMessage=function getMultipleEventsMessage(formatMessage,eventCount){return eventCount+' '+formatMessage(__WEBPACK_IMPORTED_MODULE_8__info_intl_js__["a" /* default */].events);};var formatLog=function formatLog(_ref13){var formatMessage=_ref13.formatMessage,hubTimezone=_ref13.hubTimezone,minTicksDisplayed=_ref13.minTicksDisplayed,timelineEnd=_ref13.timelineEnd,timelineStart=_ref13.timelineStart,zoomLevel=_ref13.zoomLevel;return function(_ref14,index,_ref15){var end=_ref14.end,start=_ref14.start,inMotion=_ref14.inMotion,type=_ref14.type;var length=_ref15.length;var zIndex=length-index;var startStyleValues=getEventLogStyle({logTime:start,minTicksDisplayed:minTicksDisplayed,timelineEnd:timelineEnd,timelineStart:timelineStart,zoomLevel:zoomLevel});var endStyleValues=getEventLogStyle({logTime:end||timelineEnd,minTicksDisplayed:minTicksDisplayed,timelineEnd:timelineEnd,timelineStart:timelineStart,zoomLevel:zoomLevel});var logBGStyle=mergeStylesWithZIndex(getLogBGStyle({end:end,endStyleValues:endStyleValues,inMotion:inMotion,minTicksDisplayed:minTicksDisplayed,start:start,startStyleValues:startStyleValues,timelineEnd:timelineEnd,zoomLevel:zoomLevel}),zIndex);var startStyle=mergeStylesWithZIndex(wrapValuesWithPercent(startStyleValues),zIndex);var endStyle=mergeStylesWithZIndex(wrapValuesWithPercent(endStyleValues),zIndex);var infoStyle={right:endStyle.right,zIndex:zIndex};var durationMessage=getDurationMessage(formatMessage,getMSDuration({start:start,end:end}));var timeToDisplay=getDateFromStart({hubTimezone:hubTimezone,start:start});return{end:end,endStyle:endStyle,durationMessage:durationMessage,infoStyle:infoStyle,inMotion:inMotion,label:type,logBGStyle:logBGStyle,start:start,startStyle:startStyle,timeToDisplay:timeToDisplay};};};var mergeLog=function mergeLog(_ref16){var lastLog=_ref16.lastLog,currentLog=_ref16.currentLog,formatMessage=_ref16.formatMessage,minTicksDisplayed=_ref16.minTicksDisplayed,timelineEnd=_ref16.timelineEnd;var lastEnd=lastLog.end,lastEndStyle=lastLog.endStyle,mergeCount=lastLog.mergeCount,inMotion=lastLog.inMotion,label=lastLog.label;var start=currentLog.start,startStyle=currentLog.startStyle,infoStyle=currentLog.infoStyle,timeToDisplay=currentLog.timeToDisplay;var nextMergeCount=mergeCount+1||2;var durationMessage=getMultipleEventsMessage(formatMessage,nextMergeCount);var logBGStyle=mergeStylesWithZIndex(getLogBGStyle({end:lastEnd,endStyleValues:unwrapPercentValues(lastEndStyle),inMotion:inMotion,minTicksDisplayed:minTicksDisplayed,start:start,startStyleValues:unwrapPercentValues(startStyle),timelineEnd:timelineEnd}),startStyle.zIndex);return{end:lastEnd,endStyle:lastEndStyle,durationMessage:durationMessage,infoStyle:infoStyle,inMotion:inMotion,label:label,logBGStyle:logBGStyle,mergeCount:nextMergeCount,start:start,startStyle:startStyle,timeToDisplay:timeToDisplay};};var mergeOverlaps=function mergeOverlaps(_ref17){var formatMessage=_ref17.formatMessage,minTicksDisplayed=_ref17.minTicksDisplayed,timelineEnd=_ref17.timelineEnd,mergeThreshold=_ref17.mergeThreshold;return function(all,log,i){var mergedLog=log;if(i>0){var _last2=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_last___default()(all),lastStartStyle=_last2.startStyle,lastInMotion=_last2.inMotion;var endStyle=log.endStyle;if(lastInMotion){return[].concat(_toConsumableArray(all),[log]);}var lastStart=fixPercentStringToDecimal(lastStartStyle.right);var currentEnd=fixPercentStringToDecimal(endStyle.right);if(currentEnd-lastStart<mergeThreshold){mergedLog=mergeLog({currentLog:log,lastLog:__WEBPACK_IMPORTED_MODULE_3_lodash_fp_last___default()(all),formatMessage:formatMessage,minTicksDisplayed:minTicksDisplayed,timelineEnd:timelineEnd});//Remove the last log as it will be replaced with the new mergedLog
all.pop(i-1);}}return[].concat(_toConsumableArray(all),[mergedLog]);};};/**********************
 *****  Component *****
 **********************/var getLogsData=function getLogsData(_ref18){var formatMessage=_ref18.formatMessage,hubTimezone=_ref18.hubTimezone,mergeThreshold=_ref18.mergeThreshold,minTicksDisplayed=_ref18.minTicksDisplayed,sensorLogs=_ref18.sensorLogs,timelineEnd=_ref18.timelineEnd,timelineStart=_ref18.timelineStart,zoomLevel=_ref18.zoomLevel;var totalWidth=getTotalWidth({minTicksDisplayed:minTicksDisplayed,timelineEnd:timelineEnd,timelineStart:timelineStart,zoomLevel:zoomLevel});var timelineStyle={width:Math.max(totalWidth,100)+'%'};var logs=sensorLogs.map(formatLog({formatMessage:formatMessage,hubTimezone:hubTimezone,minTicksDisplayed:minTicksDisplayed,timelineEnd:timelineEnd,timelineStart:timelineStart,zoomLevel:zoomLevel}));var mergedLogs=logs.reduce(mergeOverlaps({formatMessage:formatMessage,mergeThreshold:mergeThreshold,minTicksDisplayed:minTicksDisplayed,timelineEnd:timelineEnd}),[]);return{logs:mergedLogs,timelineStyle:timelineStyle};};var mapStateToProps=function mapStateToProps(state,props){var hubTimezone=Object(__WEBPACK_IMPORTED_MODULE_7__core_state_hub_selectors__["k" /* getTimezone */])(state);var _getLogsData=getLogsData(Object.assign({},props,{hubTimezone:hubTimezone})),logs=_getLogsData.logs,timelineStyle=_getLogsData.timelineStyle;return{logs:logs,timelineStyle:timelineStyle};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_9__component__["a" /* default */]));

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('toPairs', __webpack_require__(2303), __webpack_require__(71));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__(2304),
    keys = __webpack_require__(108);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

var baseToPairs = __webpack_require__(2305),
    getTag = __webpack_require__(288),
    mapToArray = __webpack_require__(381),
    setToPairs = __webpack_require__(2306);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(82);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),
/* 2306 */
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('replace', __webpack_require__(2308));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(190);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('fromPairs', __webpack_require__(2310));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 2310 */
/***/ (function(module, exports) {

/**
 * The inverse of `_.toPairs`; this method returns an object composed
 * from key-value `pairs`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} pairs The key-value pairs.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.fromPairs([['a', 1], ['b', 2]]);
 * // => { 'a': 1, 'b': 2 }
 */
function fromPairs(pairs) {
  var index = -1,
      length = pairs == null ? 0 : pairs.length,
      result = {};

  while (++index < length) {
    var pair = pairs[index];
    result[pair[0]] = pair[1];
  }
  return result;
}

module.exports = fromPairs;


/***/ }),
/* 2311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info__ = __webpack_require__(2313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
// @noflow
var LogsPropTypes={logs:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({end:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,endStyle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({right:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired}),durationMessage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,infoStyle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({right:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,width:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string}),inMotion:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,label:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,logBGStyle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({right:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,width:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired}),mergeCount:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,start:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,startStyle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({right:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired}),timeToDisplay:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object})).isRequired,simpleMergedLabel:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,timelineStyle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired};var Logs=function Logs(_ref){var logs=_ref.logs,simpleMergedLabel=_ref.simpleMergedLabel,timelineStyle=_ref.timelineStyle;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:'logs-timeline-component__events'},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:'logs-timeline-component__events-timeline',style:timelineStyle}),logs.map(function(log,i){var end=log.end,endStyle=log.endStyle,durationMessage=log.durationMessage,infoStyle=log.infoStyle,inMotion=log.inMotion,label=log.label,logBGStyle=log.logBGStyle,mergeCount=log.mergeCount,start=log.start,startStyle=log.startStyle,timeToDisplay=log.timeToDisplay;var showMultipleEvents=mergeCount>0;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('logs-timeline-component__log',{'logs-timeline-component--in-motion':inMotion}),'data-qa':'logs-timeline-event',key:'log-'+i},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('logs-timeline-component__log-bg',{'logs-timeline-component__log-bg--round-start':start},{'logs-timeline-component__log-bg--multiple-events':showMultipleEvents}),style:logBGStyle}),start&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:'logs-timeline-component__log-start',style:startStyle}),(end||inMotion)&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:'logs-timeline-component__log-end',style:endStyle}),start&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__info__["a" /* default */],{durationMessage:durationMessage,inMotion:inMotion,label:label,showMultipleEvents:showMultipleEvents,simpleMergedLabel:simpleMergedLabel,style:infoStyle,timeToDisplay:timeToDisplay}));}));};Logs.propTypes=LogsPropTypes;/* harmony default export */ __webpack_exports__["a"] = (Logs);

/***/ }),
/* 2312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_moment_proptypes__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_moment_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_moment_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
// @noflow
var LogsInfoPropTypes={durationMessage:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,inMotion:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,label:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,showMultipleEvents:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,simpleMergedLabel:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,style:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({right:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,zIndex:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired}),timeToDisplay:__WEBPACK_IMPORTED_MODULE_4_react_moment_proptypes__["momentObj"]};var LogsInfo=function LogsInfo(_ref){var style=_ref.style,durationMessage=_ref.durationMessage,inMotion=_ref.inMotion,label=_ref.label,showMultipleEvents=_ref.showMultipleEvents,simpleMergedLabel=_ref.simpleMergedLabel,timeToDisplay=_ref.timeToDisplay;return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',{className:'logs-timeline-component__info',style:style},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',{className:'logs-timeline-component__info-wrapper'},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('logs-timeline-component__info-text',{'logs-timeline-component__info-text--in-motion':!durationMessage})},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',null,inMotion?__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].motionDetected):simpleMergedLabel&&showMultipleEvents?__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('span',null,durationMessage):__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */][label]),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('br',null),durationMessage&&!simpleMergedLabel&&__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('span',{className:'logs-timeline-component__info-duration'},'(',durationMessage,')')),timeToDisplay&&timeToDisplay.format('LT'))));};LogsInfo.propTypes=LogsInfoPropTypes;/* harmony default export */ __webpack_exports__["a"] = (LogsInfo);

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getWidthRightStyle */
/* unused harmony export getLabelWidth */
/* unused harmony export getLabelDate */
/* unused harmony export getDayLabelsData */
/* unused harmony export getNowTickStyle */
/* unused harmony export getTickMoment */
/* unused harmony export getTickData */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css__ = __webpack_require__(2316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__day_labels__ = __webpack_require__(2317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_moment_proptypes__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_moment_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_moment_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ticks__ = __webpack_require__(2319);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// @noflow
var MILLISECONDS_IN_DAY=86400000;var MILLISECONDS_IN_HOUR=3600000;var TICKS_PER_DAY=__WEBPACK_IMPORTED_MODULE_7__constants__["d" /* responsiveVars */].TICKS_PER_DAY;//###### Component Methods ########//
var getWidthRightStyle=function getWidthRightStyle(_ref){var width=_ref.width,right=_ref.right;return{width:width+'%',right:right+'%'};};var getLabelWidth=function getLabelWidth(_ref2){var index=_ref2.index,positionOffset=_ref2.positionOffset,tickSpaceWidth=_ref2.tickSpaceWidth,timelineEnd=_ref2.timelineEnd,timezone=_ref2.timezone,zoomLevel=_ref2.zoomLevel;var fullDaysWidth=TICKS_PER_DAY*tickSpaceWidth*zoomLevel;if(index!==0){return fullDaysWidth;}var iteratedDateMS=timelineEnd-MILLISECONDS_IN_DAY*index;var iteratedMoment=__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz(iteratedDateMS,timezone);var iteratedStartOfDay=iteratedMoment.startOf('day').valueOf();var timeoffset=iteratedDateMS-iteratedStartOfDay;var hoursOffset=Math.floor(timeoffset/MILLISECONDS_IN_HOUR)+1;return hoursOffset*tickSpaceWidth*zoomLevel+positionOffset;};var getLabelDate=function getLabelDate(_ref3){var index=_ref3.index,timelineEnd=_ref3.timelineEnd,timezone=_ref3.timezone;var iteratedDateMS=timelineEnd-MILLISECONDS_IN_DAY*index;var iteratedMoment=__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz(iteratedDateMS,timezone);var iteratedStartOfDay=iteratedMoment.startOf('day').valueOf();return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(iteratedStartOfDay).toDate();};var getDayLabelsData=function getDayLabelsData(_ref4){var minTicksDisplayed=_ref4.minTicksDisplayed,timelineEnd=_ref4.timelineEnd,timelineStart=_ref4.timelineStart,timezone=_ref4.timezone,zoomLevel=_ref4.zoomLevel;var tickSpaceWidth=100/minTicksDisplayed;var positionOffset=tickSpaceWidth*0.5;var daysAmount=Math.ceil((timelineEnd-timelineStart)/MILLISECONDS_IN_DAY);var iteratedRight=0;var dayLabels=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,daysAmount).reduce(function(all,item,i){var date=getLabelDate({index:i,timelineEnd:timelineEnd,timezone:timezone});var width=getLabelWidth({timezone:timezone,index:i,positionOffset:positionOffset,tickSpaceWidth:tickSpaceWidth,timelineEnd:timelineEnd,zoomLevel:zoomLevel});var dateStyle=getWidthRightStyle({width:width,right:iteratedRight});iteratedRight+=width;return[].concat(_toConsumableArray(all),[{date:date,style:dateStyle}]);},[]);return{dayLabels:dayLabels};};var getNowTickStyle=function getNowTickStyle(_ref5){var now=_ref5.now,positionOffset=_ref5.positionOffset,tickSpaceWidth=_ref5.tickSpaceWidth,timelineEndRounded=_ref5.timelineEndRounded,zoomLevel=_ref5.zoomLevel;var nowMS=timelineEndRounded-now.valueOf();var widthPerMS=tickSpaceWidth*zoomLevel/MILLISECONDS_IN_HOUR;var nowWidth=nowMS*widthPerMS;var nowRight=positionOffset+nowWidth;return{right:nowRight+'%'};};var getTickMoment=function getTickMoment(_ref6){var timezone=_ref6.timezone,timelineEndRounded=_ref6.timelineEndRounded,index=_ref6.index,zoomLevel=_ref6.zoomLevel;var timeMS=timelineEndRounded-MILLISECONDS_IN_HOUR*(index/zoomLevel);return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz(timeMS,timezone);};var getTickData=function getTickData(_ref7){var minTicksDisplayed=_ref7.minTicksDisplayed,now=_ref7.now,timelineEnd=_ref7.timelineEnd,timelineStart=_ref7.timelineStart,timezone=_ref7.timezone,zoomLevel=_ref7.zoomLevel;var timelineEndRounded=__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(timelineEnd).add(1,'hour').startOf('hour').valueOf();var tickAmount=1+(timelineEndRounded-timelineStart)/MILLISECONDS_IN_HOUR*zoomLevel;var tickSpaceWidth=100/minTicksDisplayed;var minTicksPositionOffset=Math.max(minTicksDisplayed-tickAmount,0)*tickSpaceWidth;var positionOffset=tickSpaceWidth*0.5+minTicksPositionOffset;var ticks=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,tickAmount).reduce(function(all,item,i){var tickMoment=getTickMoment({timezone:timezone,index:i,timelineEndRounded:timelineEndRounded,zoomLevel:zoomLevel});var tickPosition=i*tickSpaceWidth+positionOffset;var tickStyle={right:tickPosition+'%',width:(i===0?tickSpaceWidth:tickSpaceWidth*0.5)+'%'};return[].concat(_toConsumableArray(all),[{index:i,tickMoment:tickMoment,tickStyle:tickStyle,type:'tick'}]);},[]);if(now.isBetween(timelineStart,timelineEnd,null,'[]')){var nowTickStyle=getNowTickStyle({now:now,positionOffset:positionOffset,timelineEndRounded:timelineEndRounded,tickSpaceWidth:tickSpaceWidth,zoomLevel:zoomLevel});var nowTick={type:'now',style:nowTickStyle};return[nowTick].concat(_toConsumableArray(ticks));}return ticks;};//###### Component Render ########//
var timelinePropTypes={minTicksDisplayed:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,now:__WEBPACK_IMPORTED_MODULE_4_react_moment_proptypes__["momentObj"].isRequired,timelineEnd:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,timelineStart:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,zoomLevel:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired};var Timeline=function Timeline(_ref8){var minTicksDisplayed=_ref8.minTicksDisplayed,now=_ref8.now,timelineEnd=_ref8.timelineEnd,timelineStart=_ref8.timelineStart,zoomLevel=_ref8.zoomLevel;var timezone=now.tz();var dayLabelsData=getDayLabelsData({minTicksDisplayed:minTicksDisplayed,timelineEnd:timelineEnd,timelineStart:timelineStart,timezone:timezone,zoomLevel:zoomLevel});var tickData=getTickData({minTicksDisplayed:minTicksDisplayed,now:now,timelineEnd:timelineEnd,timelineStart:timelineStart,timezone:timezone,zoomLevel:zoomLevel});return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',{className:'logs-timeline-component__timeline'},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__day_labels__["a" /* default */],{dayLabels:dayLabelsData.dayLabels}),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ticks__["a" /* default */],{tickData:tickData}));};Timeline.propTypes=timelinePropTypes;/* harmony default export */ __webpack_exports__["a"] = (Timeline);

/***/ }),
/* 2316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
// @noflow
var DayLabelsPropTypes={dayLabels:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({date:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,style:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired})).isRequired};var DayLabels=function DayLabels(_ref){var dayLabels=_ref.dayLabels;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{className:'logs-timeline-component__day-labels'},dayLabels.map(function(label,i){return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{className:'logs-timeline-component__day-label',key:'day-'+i,style:label.style},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{className:'logs-timeline-component__day-label-date'},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedDate */],{day:'numeric',month:'short',value:label.date,weekday:'short',year:'numeric'})));}));};DayLabels.propTypes=DayLabelsPropTypes;/* harmony default export */ __webpack_exports__["a"] = (DayLabels);

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__now__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tick__ = __webpack_require__(2323);
// @noflow
var TimelineTicksPropTypes={tickData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired};var TimelineTicks=function TimelineTicks(_ref){var tickData=_ref.tickData;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{className:'logs-timeline-component__ticks'},tickData.map(function(tick){if(tick.type==='now'){return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__now__["a" /* default */],{key:'tick-now',style:tick.style});}else{return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__tick__["a" /* default */],Object.assign({key:'tick-'+tick.index},tick));}}));};TimelineTicks.propTypes=TimelineTicksPropTypes;/* harmony default export */ __webpack_exports__["a"] = (TimelineTicks);

/***/ }),
/* 2320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_time_units__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
// @noflow
var NowTickPropTypes={style:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({right:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired})};var NowTick=function NowTick(_ref){var style=_ref.style;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:'logs-timeline-component__now',style:style},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('span',{className:'logs-timeline-component__now-pipe'},'|'),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:'logs-timeline-component__now-label'},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2__core_constants_time_units__["d" /* messages */].now)));};NowTick.propTypes=NowTickPropTypes;/* harmony default export */ __webpack_exports__["a"] = (NowTick);

/***/ }),
/* 2322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_moment_proptypes__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_moment_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_moment_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
// @noflow
var TimelineTicksPropTypes={tickMoment:__WEBPACK_IMPORTED_MODULE_1_react_moment_proptypes__["momentObj"].isRequired,tickStyle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired};var TimelineTick=function TimelineTick(_ref){var tickMoment=_ref.tickMoment,tickStyle=_ref.tickStyle;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{className:'logs-timeline-component__tick',style:tickStyle},tickMoment.hours()===0&&__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('span',{className:'logs-timeline-component__tick-pipe'},'|'),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('span',{className:'logs-timeline-component__tick-time'},tickMoment.format('LT')),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('span',{className:'logs-timeline-component__tick-point'},'\u2022'));};TimelineTick.propTypes=TimelineTicksPropTypes;/* harmony default export */ __webpack_exports__["a"] = (TimelineTick);

/***/ }),
/* 2324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl_js__ = __webpack_require__(2327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
// @noflow
var propTypes={canDecrease:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,canIncrease:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,decreaseZoom:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,increaseZoom:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,zoomLevel:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired};var ZoomControls=function ZoomControls(_ref){var canIncrease=_ref.canIncrease,canDecrease=_ref.canDecrease,decreaseZoom=_ref.decreaseZoom,increaseZoom=_ref.increaseZoom,zoomLevel=_ref.zoomLevel;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:'zoom-controls'},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('span',null,'Zoom:'),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('button',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('zoom-controls__plus',{'zoom-controls__plus--disabled':!canIncrease}),'data-qa':'logs-timeline-zoom-plus',onClick:canIncrease&&increaseZoom},'+'),zoomLevel&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl_js__["a" /* default */][zoomLevel],function(message){return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('span',{className:'zoom-controls__interval'},message);}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('button',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('zoom-controls__minus',{'zoom-controls__minus--disabled':!canDecrease}),'data-qa':'logs-timeline-zoom-minus',onClick:canDecrease&&decreaseZoom},'-'));};ZoomControls.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ZoomControls);

/***/ }),
/* 2326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(503);
var _defineMessages;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ZOOM_HOUR=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].ZOOM_HOUR,ZOOM_30MINS=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].ZOOM_30MINS,ZOOM_15MINS=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].ZOOM_15MINS,ZOOM_10MINS=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].ZOOM_10MINS,ZOOM_5MINS=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].ZOOM_5MINS,ZOOM_2MINS=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].ZOOM_2MINS,ZOOM_MINS=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* responsiveVars */].ZOOM_MINS;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])((_defineMessages={},_defineProperty(_defineMessages,ZOOM_HOUR,{id:'zoom-component.hourly',defaultMessage:'Hourly'}),_defineProperty(_defineMessages,ZOOM_30MINS,{id:'zoom-component.30Mins',defaultMessage:'30 Mins'}),_defineProperty(_defineMessages,ZOOM_15MINS,{id:'zoom-component.15Mins',defaultMessage:'15 Mins'}),_defineProperty(_defineMessages,ZOOM_10MINS,{id:'zoom-component.10Mins',defaultMessage:'10 Mins'}),_defineProperty(_defineMessages,ZOOM_5MINS,{id:'zoom-component.5Mins',defaultMessage:'5 Mins'}),_defineProperty(_defineMessages,ZOOM_2MINS,{id:'zoom-component.2Mins',defaultMessage:'2 Mins'}),_defineProperty(_defineMessages,ZOOM_MINS,{id:'zoom-component.AMinute',defaultMessage:'A Minute'}),_defineMessages)));

/***/ }),
/* 2328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export shrinkExpandAgain */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ModeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ModeItemWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ModeItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ModeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActiveIndicatorWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveIndicator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DescriptionWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TransitionWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Description; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_animations__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group_CSSTransition__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n\t0% { transform: scale(1); }\n\t25% { transform: scale(0.84); }\n\t75% { transform: scale(0.84); }\n\t100% { transform: scale(1); }\n'],['\n\t0% { transform: scale(1); }\n\t25% { transform: scale(0.84); }\n\t75% { transform: scale(0.84); }\n\t100% { transform: scale(1); }\n']),_templateObject2=_taggedTemplateLiteral(['position: relative;'],['position: relative;']),_templateObject3=_taggedTemplateLiteral(['\n    align-items: center;\n    border: ',';\n    border-radius: 1.5em;\n    display: flex;\n    height: ',';\n    position: relative;\n'],['\n    align-items: center;\n    border: ',';\n    border-radius: 1.5em;\n    display: flex;\n    height: ',';\n    position: relative;\n']),_templateObject4=_taggedTemplateLiteral(['\n    align-items: center;\n    color: ',';\n    cursor: pointer;\n    display: flex;\n    font-size: 1.1em;\n    justify-content: center;\n    text-align: center;\n    width: ',';\n    & span {\n        font-size: ',';\n    }\n'],['\n    align-items: center;\n    color: ',';\n    cursor: pointer;\n    display: flex;\n    font-size: 1.1em;\n    justify-content: center;\n    text-align: center;\n    width: ',';\n    & span {\n        font-size: ',';\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    height: 1.25em;\n    margin-right: 0.25em;\n    width: 1.25em;\n    & g {\n        fill: ',';\n    }\n'],['\n    height: 1.25em;\n    margin-right: 0.25em;\n    width: 1.25em;\n    & g {\n        fill: ',';\n    }\n']),_templateObject6=_taggedTemplateLiteral(['\n    left: 0;\n    position: absolute;\n    top: 0;\n    transition: transform 0.2s linear 0.25s;\n    transform: ',';\n    width: ',';\n'],['\n    left: 0;\n    position: absolute;\n    top: 0;\n    transition: transform 0.2s linear 0.25s;\n    transform: ',';\n    width: ',';\n']),_templateObject7=_taggedTemplateLiteral(['\n    animation: ',';\n    border: ',';\n    border-radius: 1.5em;\n    height: ',';\n'],['\n    animation: ',';\n    border: ',';\n    border-radius: 1.5em;\n    height: ',';\n']),_templateObject8=_taggedTemplateLiteral(['\n    height: 3em;\n    overflow: hidden;\n    padding: 1em 0;\n    position: relative;\n    text-align: center;\n'],['\n    height: 3em;\n    overflow: hidden;\n    padding: 1em 0;\n    position: relative;\n    text-align: center;\n']),_templateObject9=_taggedTemplateLiteral(['\n    left: 0;\n    position: absolute;\n    top: 1em;\n    width: 100%;\n\n    &.','-enter {\n        animation: ',';\n    }\n\n    &.','-exit {\n        animation: ',';\n    }\n\n    &.','-enter {\n        animation: ',';\n    }\n\n    &.','-exit {\n        animation: ',';\n    }\n'],['\n    left: 0;\n    position: absolute;\n    top: 1em;\n    width: 100%;\n\n    &.','-enter {\n        animation: ',';\n    }\n\n    &.','-exit {\n        animation: ',';\n    }\n\n    &.','-enter {\n        animation: ',';\n    }\n\n    &.','-exit {\n        animation: ',';\n    }\n']),_templateObject10=_taggedTemplateLiteral(['color: ',';'],['color: ',';']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var generalIconSize='2.5em';var menuHeight='2.75em';var shrinkExpandAgain=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject);var animateShrink=__WEBPACK_IMPORTED_MODULE_2__core_constants_animations__["h" /* shrinkExpand */]+' 0.8s '+__WEBPACK_IMPORTED_MODULE_2__core_constants_animations__["b" /* easing */].bounce+' 1';var animateShrinkAgain=shrinkExpandAgain+' 0.8s '+__WEBPACK_IMPORTED_MODULE_2__core_constants_animations__["b" /* easing */].bounce+' 1';var animateSlideAndGrow=__WEBPACK_IMPORTED_MODULE_2__core_constants_animations__["i" /* slideDownAndGrow */]+' '+__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* ANIMATION_SLIDE_ENTER_DURATION */]+'ms '+__WEBPACK_IMPORTED_MODULE_2__core_constants_animations__["b" /* easing */].bounce+' 1';var animateSlideUp=__WEBPACK_IMPORTED_MODULE_2__core_constants_animations__["j" /* slideUp */]+' '+__WEBPACK_IMPORTED_MODULE_1__constants__["e" /* ANIMATION_SLIDE_EXIT_DURATION */]+'ms '+__WEBPACK_IMPORTED_MODULE_2__core_constants_animations__["b" /* easing */].bounce+' 1';var animateImplode=__WEBPACK_IMPORTED_MODULE_2__core_constants_animations__["f" /* implode */]+' '+__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* ANIMATION_IMPLODE_DURATION */]+'ms linear';var ModeSelector=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);var ModeItemWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return'1px solid '+theme.fadedGrey;},menuHeight);var ModeItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme,disabled=_ref2.disabled;return disabled?theme.mediumGrey:theme.primaryFontColor;},function(_ref3){var itemWidth=_ref3.itemWidth;return itemWidth+'%';},generalIconSize);var ModeIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__core_icons_svg_icons__["a" /* default */])(_templateObject5,function(props){return props.theme.primaryFontColor;});var ActiveIndicatorWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject6,function(_ref4){var itemCount=_ref4.itemCount,itemWidth=_ref4.itemWidth,selectedIndex=_ref4.selectedIndex;return'translateX('+itemWidth*itemCount*selectedIndex+'%)';},function(_ref5){var itemWidth=_ref5.itemWidth;return itemWidth+'%';});var ActiveIndicator=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject7,function(props){return props.activeAnimate?animateShrink:animateShrinkAgain;},function(_ref6){var theme=_ref6.theme,disabled=_ref6.disabled;return disabled?'none':'1px solid '+theme.mainBrandColor;},menuHeight);var DescriptionWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject8);var TransitionWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_transition_group_CSSTransition___default.a)(_templateObject9,__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ANIMATION_KEY_SLIDE */],animateSlideAndGrow,__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* ANIMATION_KEY_SLIDE */],animateSlideUp,__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ANIMATION_KEY_IMPLODE */],animateImplode,__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* ANIMATION_KEY_IMPLODE */],animateImplode);var Description=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject10,function(_ref7){var theme=_ref7.theme;return theme.offlineGrey;});

/***/ }),
/* 2329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({purpose:{defaultMessage:'Mode selector',id:'mode-selector-block.purpose'}}));

/***/ }),
/* 2330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl__ = __webpack_require__(2332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pagination__ = __webpack_require__(2333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group_TransitionGroup__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group_TransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_transition_group_TransitionGroup__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LEFT='left';var RIGHT='right';var ModeSelector=function(_React$Component){_inherits(ModeSelector,_React$Component);function ModeSelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModeSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModeSelector.__proto__||Object.getPrototypeOf(ModeSelector)).call.apply(_ref,[this].concat(args))),_this),_this.state={slideDirection:LEFT},_this.onClickNext=function(e){e.preventDefault();var nextIndex=_this.props.selectedIndex+1;var next=nextIndex<_this.props.modes.length?nextIndex:0;_this.updateState(LEFT,next);},_this.onClickPrevious=function(e){e.preventDefault();var previousIndex=_this.props.selectedIndex-1;var previous=previousIndex>=0?previousIndex:_this.props.modes.length-1;_this.updateState(RIGHT,previous);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModeSelector,[{key:'updateState',value:function updateState(slideDirection,selectedIndex){this.setState({slideDirection:slideDirection});this.props.onChange&&this.props.onChange(selectedIndex);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,modes=_props.modes,purpose=_props.purpose,selectedIndex=_props.selectedIndex;var slideDirection=this.state.slideDirection;var selectedMode=modes[selectedIndex];var hasDescription=!!selectedMode.description;var hasMultipleModes=modes.length>1;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["j" /* Wrapper */],{'aria-label':purpose,role:'region'},hasMultipleModes&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].previousMode,function(m){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* ArrowWrapper */],{'aria-label':m,onClick:_this2.onClickPrevious,type:'button'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* ArrowLeft */],null));}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Content */],{'aria-live':'polite'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_transition_group_TransitionGroup___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["i" /* StyledCSSTransition */],{classNames:'mode-selector-slide-'+slideDirection,key:selectedMode.name,timeout:{enter:450,exit:300}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* ItemWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["g" /* ModeName */],{hasDescription:hasDescription},selectedMode.name),hasDescription&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* Description */],null,selectedMode.description)))),hasMultipleModes&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["h" /* PaginationContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__pagination__["a" /* default */],{activePage:selectedIndex,pages:modes.length}))),hasMultipleModes&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].nextMode,function(m){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* ArrowWrapper */],{'aria-label':m,onClick:_this2.onClickNext,type:'button'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* ArrowRight */],null));}));}}]);return ModeSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ModeSelector.defaultProps={purpose:__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].purpose,selectedIndex:0};/* harmony default export */ __webpack_exports__["a"] = (ModeSelector);

/***/ }),
/* 2331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ArrowWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrowLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArrowRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ItemWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return StyledCSSTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ModeName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PaginationContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    border: 1px ',' solid;\n    border-radius: 32px;\n    display: flex;\n    height: 3.8em;\n'],['\n    border: 1px ',' solid;\n    border-radius: 32px;\n    display: flex;\n    height: 3.8em;\n']),_templateObject2=_taggedTemplateLiteral(['\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    outline: none;\n    padding: 0;\n    width: 3.8em;\n    z-index: 10;\n'],['\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    outline: none;\n    padding: 0;\n    width: 3.8em;\n    z-index: 10;\n']),_templateObject3=_taggedTemplateLiteral(['\n    height: 1.5em;\n    width: 1.5em;\n\n    & g {\n        fill: ',';\n    }\n'],['\n    height: 1.5em;\n    width: 1.5em;\n\n    & g {\n        fill: ',';\n    }\n']),_templateObject4=_taggedTemplateLiteral([''],['']),_templateObject5=_taggedTemplateLiteral(['\n    flex: 1;\n    position: relative;\n'],['\n    flex: 1;\n    position: relative;\n']),_templateObject6=_taggedTemplateLiteral(['padding-top: 0.5em;'],['padding-top: 0.5em;']),_templateObject7=_taggedTemplateLiteral(['\n    &.mode-selector-slide-left-enter,\n    &.mode-selector-slide-right-enter {\n        bottom: 0;\n        left: 0;\n        opacity: 0.01;\n        position: absolute;\n        right: 0;\n        top: 0;\n    }\n    &.mode-selector-slide-left-enter {\n        transform: translateX(20%);\n    }\n\n    &.mode-selector-slide-right-enter {\n        transform: translateX(-20%);\n    }\n\n    &.mode-selector-slide-left-enter.mode-selector-slide-left-enter-active,\n    &.mode-selector-slide-right-enter.mode-selector-slide-right-enter-active {\n        opacity: 1;\n        transform: translateX(0);\n        transition: opacity 300ms ease-in 150ms, transform 300ms ease-in 150ms;\n    }\n\n    &.mode-selector-slide-left-exit,\n    &.mode-selector-slide-right-exit {\n        bottom: 0;\n        left: 0;\n        opacity: 1;\n        position: absolute;\n        right: 0;\n        top: 0;\n        transform: translateX(0);\n    }\n\n    &.mode-selector-slide-left-exit.mode-selector-slide-left-exit-active,\n    &.mode-selector-slide-right-exit.mode-selector-slide-right-exit-active {\n        opacity: 0.01;\n        transition: opacity 300ms ease-in, transform 300ms ease-in;\n    }\n\n    &.mode-selector-slide-left-exit.mode-selector-slide-left-exit-active {\n        transform: translateX(-20%);\n    }\n\n    &.mode-selector-slide-right-exit.mode-selector-slide-right-exit-active {\n        transform: translateX(20%);\n    }\n'],['\n    &.mode-selector-slide-left-enter,\n    &.mode-selector-slide-right-enter {\n        bottom: 0;\n        left: 0;\n        opacity: 0.01;\n        position: absolute;\n        right: 0;\n        top: 0;\n    }\n    &.mode-selector-slide-left-enter {\n        transform: translateX(20%);\n    }\n\n    &.mode-selector-slide-right-enter {\n        transform: translateX(-20%);\n    }\n\n    &.mode-selector-slide-left-enter.mode-selector-slide-left-enter-active,\n    &.mode-selector-slide-right-enter.mode-selector-slide-right-enter-active {\n        opacity: 1;\n        transform: translateX(0);\n        transition: opacity 300ms ease-in 150ms, transform 300ms ease-in 150ms;\n    }\n\n    &.mode-selector-slide-left-exit,\n    &.mode-selector-slide-right-exit {\n        bottom: 0;\n        left: 0;\n        opacity: 1;\n        position: absolute;\n        right: 0;\n        top: 0;\n        transform: translateX(0);\n    }\n\n    &.mode-selector-slide-left-exit.mode-selector-slide-left-exit-active,\n    &.mode-selector-slide-right-exit.mode-selector-slide-right-exit-active {\n        opacity: 0.01;\n        transition: opacity 300ms ease-in, transform 300ms ease-in;\n    }\n\n    &.mode-selector-slide-left-exit.mode-selector-slide-left-exit-active {\n        transform: translateX(-20%);\n    }\n\n    &.mode-selector-slide-right-exit.mode-selector-slide-right-exit-active {\n        transform: translateX(20%);\n    }\n']),_templateObject8=_taggedTemplateLiteral(['\n    display: block;\n    font-size: ',';\n    overflow: hidden;\n    text-align: center;\n    text-overflow: ellipsis;\n    margin-top: ',';\n    white-space: nowrap;\n'],['\n    display: block;\n    font-size: ',';\n    overflow: hidden;\n    text-align: center;\n    text-overflow: ellipsis;\n    margin-top: ',';\n    white-space: nowrap;\n']),_templateObject9=_taggedTemplateLiteral(['\n    color: ',';\n    display: block;\n    font-size: 0.9em;\n    overflow: hidden;\n    text-align: center;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n'],['\n    color: ',';\n    display: block;\n    font-size: 0.9em;\n    overflow: hidden;\n    text-align: center;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n']),_templateObject10=_taggedTemplateLiteral(['\n    bottom: 0.2em;\n    left: 0;\n    position: absolute;\n    right: 0;\n'],['\n    bottom: 0.2em;\n    left: 0;\n    position: absolute;\n    right: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject,function(props){return props.theme.lightGrey;});var ArrowWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].button(_templateObject2);var ArrowLeft=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3__core_icons_svg_icons__["a" /* default */]).attrs({type:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__["a" /* default */].ARROW_LEFT})(_templateObject3,function(props){return props.theme.mainBrandColor;});var ArrowRight=ArrowLeft.extend.attrs({type:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__["a" /* default */].ARROW_RIGHT})(_templateObject4);var Content=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject5);var ItemWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject6);var StyledCSSTransition=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react_transition_group_CSSTransition___default.a)(_templateObject7);var ModeName=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].span(_templateObject8,function(props){return props.hasDescription?'1em':'1.2em';},function(props){return props.hasDescription?0:'0.65em';});var Description=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].span(_templateObject9,function(props){return props.theme.mediumGrey;});var PaginationContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject10);

/***/ }),
/* 2332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({nextMode:{id:'mode-selector.next-mode',defaultMessage:'Next mode'},previousMode:{id:'mode-selector.previous-mode',defaultMessage:'Previous mode'},purpose:{id:'mode-selector-slide.purpose',defaultMessage:'Mode Selector'}}));

/***/ }),
/* 2333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2334);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var activePage=_ref.activePage,pages=_ref.pages;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Pagination */],null,__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,pages).map(function(index){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Item */],{active:activePage===index,key:'item-'+index});}));});

/***/ }),
/* 2334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Pagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Item; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    margin: 0;\n    padding: 0;\n'],['\n    display: flex;\n    justify-content: center;\n    margin: 0;\n    padding: 0;\n']),_templateObject2=_taggedTemplateLiteral(['\n    background-color: ',';\n    border-radius: 8px;\n    height: 8px;\n    list-style: none;\n    margin: 0 2px;\n    width: 8px;\n'],['\n    background-color: ',';\n    border-radius: 8px;\n    height: 8px;\n    list-style: none;\n    margin: 0 2px;\n    width: 8px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Pagination=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ul(_templateObject);var Item=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].li(_templateObject2,function(_ref){var active=_ref.active,theme=_ref.theme;return active?theme.mediumGrey:theme.lightGrey;});

/***/ }),
/* 2335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_js__ = __webpack_require__(2336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
// @noflow
var propTypes={activeIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,handleClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string).isRequired,purpose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var ModeSelectorSwitch=function ModeSelectorSwitch(_ref){var activeIndex=_ref.activeIndex,handleClick=_ref.handleClick,items=_ref.items,purpose=_ref.purpose;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles_js__["c" /* Container */],null,items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles_js__["d" /* MenuItem */],{active:activeIndex===index,'aria-label':purpose,itemIsFirst:index===0,itemIsLast:index===items.length-1,itemsTotal:items.length,key:'mode-switcher-'+item+'-'+index,onClick:function onClick(){return handleClick(index);}},item);}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles_js__["b" /* ActiveBarContainer */],{itemsTotal:items.length,selectedIndex:activeIndex},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles_js__["a" /* ActiveBar */],null)));};ModeSelectorSwitch.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (ModeSelectorSwitch);

/***/ }),
/* 2336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MenuItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActiveBarContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    margin: 0 1em;\n    position: relative;\n'],['\n    margin: 0 1em;\n    position: relative;\n']),_templateObject2=_taggedTemplateLiteral(['\n    color: ',';\n    cursor: pointer;\n    display: inline-block;\n    font-size: 1em;\n    text-align: center;\n    text-transform: capitalize;\n    width: ',';\n    &:after {\n        content: \'\';\n        display: block;\n        height: 1.2em;\n        margin-left: ',';\n        width: ',';\n        border-bottom: ',';\n    }\n'],['\n    color: ',';\n    cursor: pointer;\n    display: inline-block;\n    font-size: 1em;\n    text-align: center;\n    text-transform: capitalize;\n    width: ',';\n    &:after {\n        content: \'\';\n        display: block;\n        height: 1.2em;\n        margin-left: ',';\n        width: ',';\n        border-bottom: ',';\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    position: absolute;\n    bottom: -0.1em;\n    left: 0;\n    transition: transform 0.5s ease;\n    transform: ',';\n    width: ',';\n'],['\n    position: absolute;\n    bottom: -0.1em;\n    left: 0;\n    transition: transform 0.5s ease;\n    transform: ',';\n    width: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    position: relative;\n    width: 3.75em;\n    height: 0.3125em;\n    background-color: ',';\n    border-radius: 0.3125em;\n    margin-left: calc(50% - 1.875em);\n\n    &::after {\n        content: \' \';\n        position: absolute;\n        bottom: 0.3125em;\n        left: 50%;\n        margin-left: -0.15625em;\n        border-left: 0.3125em solid transparent;\n        border-right: 0.3125em solid transparent;\n        border-bottom: 0.25em solid ',';\n    }\n'],['\n    position: relative;\n    width: 3.75em;\n    height: 0.3125em;\n    background-color: ',';\n    border-radius: 0.3125em;\n    margin-left: calc(50% - 1.875em);\n\n    &::after {\n        content: \' \';\n        position: absolute;\n        bottom: 0.3125em;\n        left: 50%;\n        margin-left: -0.15625em;\n        border-left: 0.3125em solid transparent;\n        border-right: 0.3125em solid transparent;\n        border-bottom: 0.25em solid ',';\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var MenuItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(props){return props.active?props.theme.mainBrandColor:props.theme.linkColor;},function(_ref){var itemsTotal=_ref.itemsTotal;return 100/itemsTotal+'%';},function(_ref2){var itemIsFirst=_ref2.itemIsFirst;return itemIsFirst?'50%':'0';},function(_ref3){var itemIsFirst=_ref3.itemIsFirst,itemIsLast=_ref3.itemIsLast;return itemIsFirst||itemIsLast?'50%':'100%';},function(_ref4){var theme=_ref4.theme;return'1px dotted '+theme.mediumGrey;});var ActiveBarContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(_ref5){var selectedIndex=_ref5.selectedIndex;return'translate3d('+selectedIndex+'00%, 0, 0)';},function(_ref6){var itemsTotal=_ref6.itemsTotal;return 100/itemsTotal+'%';});var ActiveBar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,function(_ref7){var theme=_ref7.theme;return theme.mainBrandColor;},function(_ref8){var theme=_ref8.theme;return theme.mainBrandColor;});

/***/ }),
/* 2337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_app_settings_actions__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_app_settings__ = __webpack_require__(88);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var mapStateToProps=function mapStateToProps(state){return{faqLink:Object(__WEBPACK_IMPORTED_MODULE_1__core_state_config_selectors__["a" /* getConfig */])(state,'help:faqLink')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{dismissPopup:function dismissPopup(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__core_state_app_settings_actions__["c" /* setAppSettings */])(_defineProperty({},__WEBPACK_IMPORTED_MODULE_4__core_constants_app_settings__["s" /* THANK_YOU_ACCEPTED */],true)));}};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 2338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl__ = __webpack_require__(2342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var propTypes={dismissPopup:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired};var NewWebsiteAlert=function NewWebsiteAlert(_ref){var dismissPopup=_ref.dismissPopup;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* MainWrapper */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* PopupWrapper */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ImageContainer */],null),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* TextContainer */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0____["N" /* PageTitle */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].title)),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* MessageContainer */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].hello)),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* MessageContainer */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].thankYouMessage)),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* MessageContainer */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].changeMessage)),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* MessageContainer */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].thanksAgain,{values:{break:__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('br',null)}}))),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0____["l" /* Button */],{onClick:dismissPopup,type:'submit'},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].ok)))));};//<b><FormattedMessage {...menuMessages.settings} /></b>
NewWebsiteAlert.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["g" /* injectIntl */])(NewWebsiteAlert));

/***/ }),
/* 2339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MainWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PopupWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MessageContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TextContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__welcome_png__ = __webpack_require__(2340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__welcome_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__welcome_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__welcome_mobile_png__ = __webpack_require__(2341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__welcome_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__welcome_mobile_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    width: 100vw;\n    height: 100vh;\n    position: absolute;\n    z-index: 1000;\n    background-color: rgba(35, 35, 35, 0.3);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n'],['\n    width: 100vw;\n    height: 100vh;\n    position: absolute;\n    z-index: 1000;\n    background-color: rgba(35, 35, 35, 0.3);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    width: 90%;\n    height: auto;\n    background: white;\n    border-radius: ',';\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50%, -50%, 0);\n\n    ',';\n'],['\n    position: absolute;\n    width: 90%;\n    height: auto;\n    background: white;\n    border-radius: ',';\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50%, -50%, 0);\n\n    ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n\t\twidth: 50%;\n\t'],['\n\t\twidth: 50%;\n\t']),_templateObject4=_taggedTemplateLiteral(['\n    background-image: url(',');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    width: 100%;\n    height: 200px;\n    border-top-right-radius: ',';\n    border-top-left-radius: ',';\n\n    ',';\n'],['\n    background-image: url(',');\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    width: 100%;\n    height: 200px;\n    border-top-right-radius: ',';\n    border-top-left-radius: ',';\n\n    ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n\t\tbackground-image: url(',');\n\t'],['\n\t\tbackground-image: url(',');\n\t']),_templateObject6=_taggedTemplateLiteral(['margin-bottom: 20px;'],['margin-bottom: 20px;']),_templateObject7=_taggedTemplateLiteral(['padding: 40px;'],['padding: 40px;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var borderRadius='10px';var MainWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject);var PopupWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject2,borderRadius,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].desktop(_templateObject3));var ImageContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_2__welcome_mobile_png___default.a,borderRadius,borderRadius,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject5,__WEBPACK_IMPORTED_MODULE_0__welcome_png___default.a));var MessageContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject6);var TextContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject7);

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/welcome.621d6b31632b717731982ee8c08dccf5feb3daf8a15db30f0458708747b94470.png";

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/welcome-mobile.22d2dc88585e1e45575c8c208e9f20ad6eb96957820e5ba670091e987cbb6488.png";

/***/ }),
/* 2342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({title:{id:'alert.title',defaultMessage:'Thank you'},hello:{id:'alert.hello',// eslint-disable-next-line max-len
defaultMessage:'Hello'},thankYouMessage:{id:'alert.thank-you-message',// eslint-disable-next-line max-len
defaultMessage:'We just wanted to say a big thank you to everyone who has sent us feedback over the past couple of weeks. Your feedback is really appreciated, and helps us keep the app reliable and easy to use as we add new and exciting smart features.'},changeMessage:{id:'alert.change-message',// eslint-disable-next-line max-len
defaultMessage:'We have taken your comments on board and will continue to improve the app further over the coming weeks.'},thanksAgain:{id:'alert.thanks-again',defaultMessage:'Thanks again, {break} The Hive Team'},ok:{id:'alert.ok',defaultMessage:'Ok'}}));

/***/ }),
/* 2343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2344);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function PhoneNumber(_ref){var phoneNumber=_ref.phoneNumber,props=_objectWithoutProperties(_ref,['phoneNumber']);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* HtmlLink */],Object.assign({},props,{href:'tel:'+phoneNumber}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* PhoneIcon */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* Text */],null,phoneNumber));}

/***/ }),
/* 2344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HtmlLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PhoneIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Text; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    color: ',';\n    display: flex;\n    margin: 1em;\n    text-decoration: none;\n'],['\n    align-items: center;\n    color: ',';\n    display: flex;\n    margin: 1em;\n    text-decoration: none;\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: 2.5em;\n    width: 2.5em;\n\n    & g {\n        fill: ',';\n    }\n'],['\n    height: 2.5em;\n    width: 2.5em;\n\n    & g {\n        fill: ',';\n    }\n']),_templateObject3=_taggedTemplateLiteral(['font-size: 1.6em;'],['font-size: 1.6em;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var HtmlLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].a(_templateObject,function(props){return props.theme.primaryFontColor;});var PhoneIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */]).attrs({type:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_general_svg__["a" /* default */].CALL})(_templateObject2,function(props){return props.theme.mainBrandColor;});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span(_templateObject3);

/***/ }),
/* 2345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pin_input_component_css__ = __webpack_require__(2346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pin_input_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pin_input_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_form_form_helpers__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_custom_prop_types__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
/* eslint-disable react/prefer-stateless-function */var backSpaceKey=8;var shiftKey=16;var tabKey=9;// This needs to be a class so that it has a backing instance and can have refs
// placed on it in `PinInputGroup`.
var PinInput=function(_Component){_inherits(PinInput,_Component);function PinInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PinInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PinInput.__proto__||Object.getPrototypeOf(PinInput)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnKeyUp=function(e){var _this$props=_this.props,onKeyUp=_this$props.onKeyUp,onPinDeleted=_this$props.onPinDeleted,onPinEntered=_this$props.onPinEntered,pinIndex=_this$props.pinIndex,value=_this$props.value;onKeyUp&&onKeyUp(e);var keyCode=e.keyCode;var shiftHeld=e.shiftKey;if(!value&&keyCode===backSpaceKey){onPinDeleted&&onPinDeleted(_this,pinIndex);return;}if(value&&value.length===1&&keyCode!==shiftKey&&keyCode!==tabKey&&!shiftHeld){onPinEntered&&onPinEntered(_this,pinIndex);}},_this.handleOnFocus=function(e){var _this$props2=_this.props,onPinFocused=_this$props2.onPinFocused,pinIndex=_this$props2.pinIndex,onFocus=_this$props2.onFocus;onPinFocused&&onPinFocused(pinIndex);onFocus&&onFocus(e);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PinInput,[{key:'render',value:function render(){var _props=this.props,className=_props.className,onPinDeleted=_props.onPinDeleted,onPinEntered=_props.onPinEntered,onPinFocused=_props.onPinFocused,pinIndex=_props.pinIndex,props=_objectWithoutProperties(_props,['className','onPinDeleted','onPinEntered','onPinFocused','pinIndex']);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_form_form_helpers__["a" /* getDOMOnlyProps */])(props),{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('pin-input',className),onFocus:this.handleOnFocus,onKeyUp:this.handleOnKeyUp}));}}]);return PinInput;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* eslint-enable react/prefer-stateless-function */PinInput.propTypes={'aria-label':__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,onFocus:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,onKeyUp:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,onPinDeleted:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,onPinEntered:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,onPinFocused:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,pinIndex:Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_custom_prop_types__["b" /* isDependentOn */])('onPinEntered',function(_,onPinEntered){return onPinEntered;},__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number),value:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PinInput);

/***/ }),
/* 2346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_takeRight__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_takeRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_takeRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_take__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_take___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_take__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_every__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pin_input_group_component_css__ = __webpack_require__(2351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pin_input_group_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pin_input_group_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var PinInputGroup=function(_Component){_inherits(PinInputGroup,_Component);function PinInputGroup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PinInputGroup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PinInputGroup.__proto__||Object.getPrototypeOf(PinInputGroup)).call.apply(_ref,[this].concat(args))),_this),_this.handleOnPinDeleted=function(pinInput,pinIndex){if(pinIndex-1>=0){Object(__WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"])(_this['pinInput'+(pinIndex-1)]).select();// eslint-disable-line react/no-find-dom-node
}},_this.handleOnPinEntered=function(pinInput,pinIndex){if(pinIndex+1<__WEBPACK_IMPORTED_MODULE_4_react__["Children"].count(_this.props.children)){Object(__WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"])(_this['pinInput'+(pinIndex+1)]).focus();// eslint-disable-line react/no-find-dom-node
}},_this.handleOnPinFocused=function(pinIndex){var node=Object(__WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"])(_this['pinInput'+pinIndex]);if(node){node.setSelectionRange(0,1);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PinInputGroup,[{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,_props$separatorChar=_props.separatorChar,separatorChar=_props$separatorChar===undefined?'-':_props$separatorChar,separatorAfterIndex=_props.separatorAfterIndex;// Clone the children so we can capture a `ref` to each one for calling
// `focus` on later. We can also add some props that a consumer shouldn't
// be concerned with related to selecting the next `PinInput`
var autoFocusedChildren=__WEBPACK_IMPORTED_MODULE_4_react__["Children"].map(children,function(child,i){return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child,{onPinEntered:_this2.handleOnPinEntered,onPinDeleted:_this2.handleOnPinDeleted,onPinFocused:_this2.handleOnPinFocused,pinIndex:i,ref:function ref(c){return _this2['pinInput'+i]=c;}});});var childrenBefore=autoFocusedChildren;var childrenAfter=void 0;var useSeparator=separatorAfterIndex!==undefined&&separatorAfterIndex>=0&&separatorAfterIndex<__WEBPACK_IMPORTED_MODULE_4_react__["Children"].count(autoFocusedChildren);if(useSeparator){childrenBefore=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_take___default()(separatorAfterIndex+1,autoFocusedChildren);childrenAfter=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_takeRight___default()(separatorAfterIndex+1,autoFocusedChildren);}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul',{className:'pin-input-group'},childrenBefore,useSeparator&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span',{className:'pin-input-group__separator'},separatorChar),childrenAfter);}}]);return PinInputGroup;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);PinInputGroup.propTypes={children:function children(props,propName,componentName){if(!__WEBPACK_IMPORTED_MODULE_2_lodash_fp_every___default()(function(x){return x.type===__WEBPACK_IMPORTED_MODULE_6____["P" /* PinInput */];},props[propName])){return new Error('Invalid prop \''+propName+'\' supplied to \''+componentName+'\'.\n\t\t\t\t\tChildren should be of elements of \'PinInput\'.');}},separatorAfterIndex:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,separatorChar:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PinInputGroup);

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(2349),
    baseEvery = __webpack_require__(2350),
    baseIteratee = __webpack_require__(55),
    isArray = __webpack_require__(32),
    isIterateeCall = __webpack_require__(163);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 2349 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(196);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 2351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
// Replacement for a `div` that needs to stop browser gestures like Chrome's
// "swipe to go back". It passes through all `props` and it's up to the consumer
// to make sure all of them are suitable for a `div`.
var PreventBackGesture=function(_Component){_inherits(PreventBackGesture,_Component);function PreventBackGesture(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PreventBackGesture);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PreventBackGesture.__proto__||Object.getPrototypeOf(PreventBackGesture)).call.apply(_ref,[this].concat(args))),_this),_this.handleWheel=function(e){if(_this.root.scrollLeft+e.deltaX<0){e.preventDefault();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PreventBackGesture,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},this.props,{onWheel:this.handleWheel,ref:function ref(c){return _this2.root=c;}}));}}]);return PreventBackGesture;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (PreventBackGesture);

/***/ }),
/* 2353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PrimaryBtn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__primary_btn_component_css__ = __webpack_require__(2354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__primary_btn_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__primary_btn_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
/*
	Primary Btn Component
	@param {string || component} [children='save'] - content to be displayed within the button.
	@param {string} [className] - space delimited css classes to be added for styling.
	@param {bool} [processing] - determines whether or not to show processing animation.
	@param {string} [processingPhrase] - text to be displayed when displaying processing animation.
 */PrimaryBtn.propTypes={children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,processing:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,processingPhrase:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};PrimaryBtn.defaultProps={children:'Save'};function PrimaryBtn(_ref){var children=_ref.children,className=_ref.className,processing=_ref.processing,processingPhrase=_ref.processingPhrase,props=_objectWithoutProperties(_ref,['children','className','processing','processingPhrase']);var buttonClasses=__WEBPACK_IMPORTED_MODULE_2_classnames___default()('primary-btn',{'primary-btn--processing':processing},className);return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["l" /* Button */],Object.assign({},props,{className:buttonClasses}),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('primary-btn__text-top',{'primary-btn__text-top--hide':processing})},children),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('span',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('primary-btn__text-bottom',{'primary-btn__text-bottom--hide':processing})},children),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('p',{className:__WEBPACK_IMPORTED_MODULE_2_classnames___default()('primary-btn__dots',{'primary-btn__dots--show':processing})},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('span',null,processingPhrase||children),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('span',{className:'primary-btn__dot-1'},' . '),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('span',{className:'primary-btn__dot-2'},'. '),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('span',{className:'primary-btn__dot-3'},'.')));}

/***/ }),
/* 2354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RangeSlider=function(_React$Component){_inherits(RangeSlider,_React$Component);function RangeSlider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RangeSlider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RangeSlider.__proto__||Object.getPrototypeOf(RangeSlider)).call.apply(_ref,[this].concat(args))),_this),_this.handleChange=function(event){var value=parseInt(event.currentTarget.value,10);var _this$props=_this.props,minSnapPoint=_this$props.minSnapPoint,_this$props$minSnapPo=_this$props.minSnapPointThreshold,minSnapPointThreshold=_this$props$minSnapPo===undefined?minSnapPoint:_this$props$minSnapPo,_this$props$minValue=_this$props.minValue,minValue=_this$props$minValue===undefined?0:_this$props$minValue,valueMap=_this$props.valueMap,_this$props$valuePost=_this$props.valuePostfix,valuePostfix=_this$props$valuePost===undefined?'':_this$props$valuePost;if(minSnapPoint&&value<minSnapPoint){value=value<minSnapPointThreshold?minValue:minSnapPoint;var nextDisplayValue=valueMap.get(value)||''+value+valuePostfix;_this.setState({value:value,displayValue:nextDisplayValue});_this.props.setValue(value);return;}_this.setState({value:value,displayValue:''+value+valuePostfix});_this.props.setValue(value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RangeSlider,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,_props$maxValue=_props.maxValue,maxValue=_props$maxValue===undefined?100:_props$maxValue,defaultValue=_props.defaultValue,_props$valuePostfix=_props.valuePostfix,valuePostfix=_props$valuePostfix===undefined?'':_props$valuePostfix;this.setState({value:defaultValue!==undefined?defaultValue:maxValue/2,displayValue:defaultValue<30?'OFF':''+defaultValue+valuePostfix});}},{key:'render',value:function render(){var _props2=this.props,_props2$minValue=_props2.minValue,minValue=_props2$minValue===undefined?0:_props2$minValue,_props2$maxValue=_props2.maxValue,maxValue=_props2$maxValue===undefined?100:_props2$maxValue,_props2$step=_props2.step,step=_props2$step===undefined?1:_props2$step,disabled=_props2.disabled;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* RangeSliderContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["f" /* SliderContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* Slider */],{'aria-label':'range slider',disabled:disabled,max:maxValue,min:minValue,onChange:this.handleChange,step:step,type:'range',value:this.state.value}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* SliderColorBar */],null),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["e" /* SliderColorBar */],{disabled:disabled,highlightProgress:true,style:{width:this.state.value+'%'}})),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["c" /* SetValueContainer */],{disabled:disabled},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* LabelText */],null,'set to'),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('div',null,this.state.displayValue)));}}]);return RangeSlider;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);RangeSlider.defaultState={valueMap:new Map()};/* harmony default export */ __webpack_exports__["a"] = (RangeSlider);

/***/ }),
/* 2356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SliderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Slider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SliderColorBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SetValueContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RangeSliderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabelText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    height: 30px;\n    width: 100%;\n'],['\n    position: relative;\n    height: 30px;\n    width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    appearance: none;\n    background: none;\n    vertical-align: center;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    z-index: 1;\n\n    &::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        border: none;\n        height: 30px;\n        width: 30px;\n        border-radius: 50%;\n        background: white;\n        box-shadow: ',';\n        position: relative;\n        z-index: 500;\n    }\n\n    &::-moz-range-thumb {\n        z-index: 500;\n        border: none;\n        box-shadow: ',';\n        background: white;\n    }\n\n    &::-ms-thumb {\n        border: none;\n        height: 16px;\n        width: 16px;\n        border-radius: 50%;\n        background: ',';\n    }\n\n    &::-moz-range-track {\n        background: none;\n    }\n\n    &:focus {\n        outline: none;\n    }\n'],['\n    position: absolute;\n    appearance: none;\n    background: none;\n    vertical-align: center;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    z-index: 1;\n\n    &::-webkit-slider-thumb {\n        -webkit-appearance: none;\n        border: none;\n        height: 30px;\n        width: 30px;\n        border-radius: 50%;\n        background: white;\n        box-shadow: ',';\n        position: relative;\n        z-index: 500;\n    }\n\n    &::-moz-range-thumb {\n        z-index: 500;\n        border: none;\n        box-shadow: ',';\n        background: white;\n    }\n\n    &::-ms-thumb {\n        border: none;\n        height: 16px;\n        width: 16px;\n        border-radius: 50%;\n        background: ',';\n    }\n\n    &::-moz-range-track {\n        background: none;\n    }\n\n    &:focus {\n        outline: none;\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    pointer-events: none;\n    position: absolute;\n    height: 3px;\n    top: calc(50% - 1.5px);\n    background-color: ',';\n    width: 100%;\n'],['\n    pointer-events: none;\n    position: absolute;\n    height: 3px;\n    top: calc(50% - 1.5px);\n    background-color: ',';\n    width: 100%;\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    color: ',';\n    text-align: center;\n    width: 10%;\n    margin-left: 15px;\n'],['\n    display: flex;\n    flex-direction: column;\n    color: ',';\n    text-align: center;\n    width: 10%;\n    margin-left: 15px;\n']),_templateObject5=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n'],['\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n']),_templateObject6=_taggedTemplateLiteral(['\n    white-space: nowrap;\n    font-size: 0.8em;\n'],['\n    white-space: nowrap;\n    font-size: 0.8em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SliderContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var Slider=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].input(_templateObject2,function(props){return'-2px 2px 2px '+props.theme.heavyGrey+',\n\t\t\t1px -1px 1px '+props.theme.lightGrey;},function(props){return'-2px 2px 2px '+props.theme.heavyGrey+',\n\t\t\t1px -1px 1px '+props.theme.lightGrey;},function(props){return props.theme.mainBrandColor;});var SliderColorBar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,function(props){if(props.disabled){return props.theme.lightGrey;}return props.highlightProgress?props.theme.mainBrandColor:props.theme.lightGrey;});var SetValueContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].p(_templateObject4,function(_ref){var disabled=_ref.disabled,theme=_ref.theme;return disabled?theme.mediumGrey:theme.mainBrandColor;});var RangeSliderContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5);var LabelText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject6);

/***/ }),
/* 2357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__recipe_item_style__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_constants_icons_general__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__style_variables__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__recipe_modal__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__recipe_item__ = __webpack_require__(2393);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();RecipesList.propTypes={canAddRecipe:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,cancelTemplate:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,consumerId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["h" /* intlShape */],isFirstLoadingDone:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,modalVisiblePage:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,producerId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,readyToSave:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,recipes:__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.map.isRequired,saveRecipe:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,showTemplateList:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired};function RecipesList(_ref){var canAddRecipe=_ref.canAddRecipe,cancelTemplate=_ref.cancelTemplate,consumerId=_ref.consumerId,formatMessage=_ref.intl.formatMessage,isFirstLoadingDone=_ref.isFirstLoadingDone,modalVisiblePage=_ref.modalVisiblePage,producerId=_ref.producerId,readyToSave=_ref.readyToSave,recipes=_ref.recipes,saveRecipe=_ref.saveRecipe,showTemplateList=_ref.showTemplateList;return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4____["G" /* LoadingIndicator */],{isLoading:isFirstLoadingDone},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* Margin */],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* RecipesListContainer */],null,recipes.entrySeq().map(function(_ref2){var _ref3=_slicedToArray(_ref2,2),key=_ref3[0],value=_ref3[1];return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* RecipeListItem */],{classNames:'animation',key:'recipe#'+key,timeout:__WEBPACK_IMPORTED_MODULE_10__style_variables__["i" /* recipeItemAnimationDuration */]},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__recipe_item_style__["m" /* RecipeItem */],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__recipe_item__["a" /* default */],{recipe:value})));}),canAddRecipe&&__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__recipe_item_style__["m" /* RecipeItem */],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__recipe_item_style__["b" /* Content */],{onClick:showTemplateList},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* AddRecipeButton */],null,__WEBPACK_IMPORTED_MODULE_9_react__["createElement"]('div',null,formatMessage(__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].addRecipe)),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* AddIcon */],{icon:__WEBPACK_IMPORTED_MODULE_7__core_constants_icons_general__["PLUS"]})))))),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__modal__["a" /* default */],{contentLabel:'Actions Modal',disableSaveButton:!readyToSave,isBig:true,isOpen:modalVisiblePage!==null,noPadding:true,onRequestClose:cancelTemplate,onSave:saveRecipe},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__recipe_modal__["a" /* default */],{consumerId:consumerId,producerId:producerId})));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["g" /* injectIntl */])(RecipesList));

/***/ }),
/* 2358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Margin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RecipesListContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RecipeListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AddRecipeButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_variables__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group_TransitionGroup__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group_TransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_transition_group_TransitionGroup__);
var _templateObject=_taggedTemplateLiteral(['\n    margin: auto;\n    max-width: 60em;\n    padding: 0 1em;\n'],['\n    margin: auto;\n    max-width: 60em;\n    padding: 0 1em;\n']),_templateObject2=_taggedTemplateLiteral(['\n    display: flex;\n    flex-wrap: wrap;\n    left: ','em;\n    position: relative;\n    width: calc(100% + ','em);\n\n    ',' ',';\n'],['\n    display: flex;\n    flex-wrap: wrap;\n    left: ','em;\n    position: relative;\n    width: calc(100% + ','em);\n\n    ',' ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n\t\tleft: ','em;\n\t\twidth: calc(100% + ','em);\n\t'],['\n\t\tleft: ','em;\n\t\twidth: calc(100% + ','em);\n\t']),_templateObject4=_taggedTemplateLiteral(['\n    &.animation-appear,\n    &.animation-enter,\n    &.animation-exit.animation-exit-active {\n        transform: rotate3d(1, 0, 0, 90deg);\n    }\n\n    &.animation-appear.animation-appear-active,\n    &.animation-enter.animation-enter-active,\n    &.animation-exit {\n        transform: rotate3d(1, 0, 0, 0);\n    }\n\n    &.animation-appear.animation-appear-active,\n    &.animation-enter.animation-enter-active,\n    &.animation-exit.animation-exit-active {\n        transition: transform ','ms ',';\n    }\n'],['\n    &.animation-appear,\n    &.animation-enter,\n    &.animation-exit.animation-exit-active {\n        transform: rotate3d(1, 0, 0, 90deg);\n    }\n\n    &.animation-appear.animation-appear-active,\n    &.animation-enter.animation-enter-active,\n    &.animation-exit {\n        transform: rotate3d(1, 0, 0, 0);\n    }\n\n    &.animation-appear.animation-appear-active,\n    &.animation-enter.animation-enter-active,\n    &.animation-exit.animation-exit-active {\n        transition: transform ','ms ',';\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: center;\n    border: dashed 1px ',';\n    border-radius: ','em;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    height: ','em;\n    justify-content: center;\n'],['\n    align-items: center;\n    border: dashed 1px ',';\n    border-radius: ','em;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    height: ','em;\n    justify-content: center;\n']),_templateObject6=_taggedTemplateLiteral(['font-size: 2em;'],['font-size: 2em;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var bezier='cubic-bezier(0.23, 1, 0.32, 1)';var Margin=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject);var RecipesListContainer=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_react_transition_group_TransitionGroup___default.a)(_templateObject2,-__WEBPACK_IMPORTED_MODULE_0__style_variables__["g" /* marginMobile */],2*__WEBPACK_IMPORTED_MODULE_0__style_variables__["g" /* marginMobile */],__WEBPACK_IMPORTED_MODULE_3__core_utils_style__["b" /* media */].tablet(_templateObject3,-__WEBPACK_IMPORTED_MODULE_0__style_variables__["h" /* marginTablet */],2*__WEBPACK_IMPORTED_MODULE_0__style_variables__["h" /* marginTablet */]),__WEBPACK_IMPORTED_MODULE_3__core_utils_style__["b" /* media */].desktop(_templateObject3,-__WEBPACK_IMPORTED_MODULE_0__style_variables__["f" /* marginDesktop */],2*__WEBPACK_IMPORTED_MODULE_0__style_variables__["f" /* marginDesktop */]));var RecipeListItem=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransition___default.a)(_templateObject4,__WEBPACK_IMPORTED_MODULE_0__style_variables__["i" /* recipeItemAnimationDuration */],bezier);var AddRecipeButton=__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */].div(_templateObject5,function(p){return p.theme.mainBrandColor;},__WEBPACK_IMPORTED_MODULE_0__style_variables__["a" /* borderRadius */],__WEBPACK_IMPORTED_MODULE_0__style_variables__["e" /* iconsContainerHeight */]+__WEBPACK_IMPORTED_MODULE_0__style_variables__["j" /* textContainerHeight */]+2*__WEBPACK_IMPORTED_MODULE_0__style_variables__["c" /* detailsPadding */]+__WEBPACK_IMPORTED_MODULE_0__style_variables__["b" /* controlPanelHeight */]);var AddIcon=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons__["a" /* default */])(_templateObject6);

/***/ }),
/* 2359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__device_icons_ttf__ = __webpack_require__(2360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__device_icons_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__device_icons_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__device_icons_woff__ = __webpack_require__(2361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__device_icons_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__device_icons_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__device_icons_woff2__ = __webpack_require__(2362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__device_icons_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__device_icons_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__general_icons_ttf__ = __webpack_require__(2363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__general_icons_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__general_icons_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__general_icons_woff__ = __webpack_require__(2364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__general_icons_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__general_icons_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__general_icons_woff2__ = __webpack_require__(2365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__general_icons_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__general_icons_woff2__);
var _templateObject=_taggedTemplateLiteral(['\n\t@font-face {\n\t\tfont-family: HiveDeviceIcons;\n\t\tfont-weight: normal;\n\t\tfont-style: normal;\n\t\tsrc: url("','") format("woff2"),\n\t\t\turl("','") format("woff"),\n\t\t\turl("','") format("truetype");\n\t}\n\n\t@font-face {\n\t\tfont-family: HiveGeneralIcons;\n\t\tfont-weight: normal;\n\t\tfont-style: normal;\n\t\tsrc: url("','") format("woff2"),\n\t\t\turl("','") format("woff"),\n\t\t\turl("','") format("truetype");\n\t}\n\n'],['\n\t@font-face {\n\t\tfont-family: HiveDeviceIcons;\n\t\tfont-weight: normal;\n\t\tfont-style: normal;\n\t\tsrc: url("','") format("woff2"),\n\t\t\turl("','") format("woff"),\n\t\t\turl("','") format("truetype");\n\t}\n\n\t@font-face {\n\t\tfont-family: HiveGeneralIcons;\n\t\tfont-weight: normal;\n\t\tfont-style: normal;\n\t\tsrc: url("','") format("woff2"),\n\t\t\turl("','") format("woff"),\n\t\t\turl("','") format("truetype");\n\t}\n\n']),_templateObject2=_taggedTemplateLiteral(['\n    display: inline-block;\n    vertical-align: middle;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n    font-family: ',';\n'],['\n    display: inline-block;\n    vertical-align: middle;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n    font-family: ',';\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// @noflow
// eslint-disable-next-line no-unused-expressions
Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* injectGlobal */])(_templateObject,__WEBPACK_IMPORTED_MODULE_3__device_icons_woff2___default.a,__WEBPACK_IMPORTED_MODULE_2__device_icons_woff___default.a,__WEBPACK_IMPORTED_MODULE_1__device_icons_ttf___default.a,__WEBPACK_IMPORTED_MODULE_6__general_icons_woff2___default.a,__WEBPACK_IMPORTED_MODULE_5__general_icons_woff___default.a,__WEBPACK_IMPORTED_MODULE_4__general_icons_ttf___default.a);var StyledIcon=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject2,function(p){var _truthMap;var truthMap=(_truthMap={},_defineProperty(_truthMap,true,'HiveGeneralIcons'),_defineProperty(_truthMap,p.set==='device','HiveDeviceIcons'),_truthMap);return truthMap[true];});

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/device-icons.cdeafc44f49d5da64206bcb6e3639e8a68c403eec0e841da895179cd95c86704.ttf";

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/device-icons.43b81f9f40b1536357704a125c871c6c11d10d073792ce3ae8124484402e556f.woff";

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/device-icons.f334e8d6ca158e18e1f47d5f3b636412393fb2c61107597f56b930720b688aea.woff2";

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/general-icons.3f758206f8b3b8dfdf41477204d6f58e69cd742aa40768a791bff2555b968f47.ttf";

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/general-icons.1c4d7d64aeef9e2e8fd32f6bc1fc9287a2fc120777eea558a107876494651af2.woff";

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/general-icons.03f55bed4c15aea3e2f748a8de86c0e18b1505301e4ac954d37942ecb67eb916.woff2";

/***/ }),
/* 2366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_icons_general__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
var propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};var DeviceIcon=function DeviceIcon(_ref){var active=_ref.active,className=_ref.className,icon=_ref.icon,model=_ref.model,type=_ref.type,props=_objectWithoutProperties(_ref,['active','className','icon','model','type']);return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0____["a" /* default */],Object.assign({className:className,icon:icon?icon:__WEBPACK_IMPORTED_MODULE_2__constants_icons_general__["QUESTION"]},props,{set:icon?'device':'general'}));};DeviceIcon.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (DeviceIcon);

/***/ }),
/* 2367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RecipeModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
// @noflow
RecipeModal.propTypes={consumerId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,currentPage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,currentRecipe:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,producerId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,templates:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.list.isRequired};function RecipeModal(_ref){var consumerId=_ref.consumerId,currentPage=_ref.currentPage,currentRecipe=_ref.currentRecipe,producerId=_ref.producerId,templates=_ref.templates;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Mask */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* MainContainer */],{currentPage:currentPage},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* PageContainer */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["j" /* TemplatesList */],{producerId:producerId,specificConsumerId:consumerId,templatesList:templates})),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* PageContainer */],null,currentRecipe&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["d" /* RecipeDetail */],{currentRecipe:currentRecipe,specificConsumerId:consumerId,specificProducerId:producerId})),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* PageContainer */],null,currentRecipe&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["e" /* RecipeSchedule */],null))));}

/***/ }),
/* 2368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Mask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MainContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PageContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 100%;\n    overflow: hidden;\n'],['\n    height: 100%;\n    overflow: hidden;\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: flex-start;\n    display: flex;\n    height: 100%;\n    transform: translate3d(','%, 0, 0);\n    transition: transform 0.3s ease-out;\n    width: ','%;\n'],['\n    align-items: flex-start;\n    display: flex;\n    height: 100%;\n    transform: translate3d(','%, 0, 0);\n    transition: transform 0.3s ease-out;\n    width: ','%;\n']),_templateObject3=_taggedTemplateLiteral(['\n    flex: 0 0 ','%;\n    height: 100%;\n    overflow: scroll;\n'],['\n    flex: 0 0 ','%;\n    height: 100%;\n    overflow: scroll;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Mask=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var pageNumbers=3;var MainContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2,function(p){return p.currentPage*-100/pageNumbers;},pageNumbers*100);var PageContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,100/pageNumbers);

/***/ }),
/* 2369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
// @noflow
var propTypes={action:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,currentIndex:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,deviceType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,handleSelection:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,isDeviceActiveState:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,list:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.list.isRequired};var DeviceSelector=function DeviceSelector(_ref){var action=_ref.action,currentIndex=_ref.currentIndex,deviceType=_ref.deviceType,handleSelection=_ref.handleSelection,isDeviceActiveState=_ref.isDeviceActiveState,list=_ref.list;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Container */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* IconWrapper */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* StyledDeviceIcon */],{active:isDeviceActiveState,type:deviceType})),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["f" /* Summary */],null,list.size===1&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* Device */],null,list.get(currentIndex)),list.size>1&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__dropdown__["a" /* default */],{currentValue:currentIndex,handleChange:handleSelection,options:list}),action&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* Action */],null,action)));};DeviceSelector.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (DeviceSelector);

/***/ }),
/* 2370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledDeviceIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Summary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_icons_device_icon__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_variables__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n    padding: 0.5em 1em;\n'],['\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n    padding: 0.5em 1em;\n']),_templateObject2=_taggedTemplateLiteral(['width: ','em;'],['width: ','em;']),_templateObject3=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    border-radius: 50%;\n    color: ',';\n    display: flex;\n    font-size: 2.5em;\n    height: ','em;\n    justify-content: center;\n    transition: background-color 0.3s ease-in;\n    width: ','em;\n'],['\n    align-items: center;\n    background-color: ',';\n    border-radius: 50%;\n    color: ',';\n    display: flex;\n    font-size: 2.5em;\n    height: ','em;\n    justify-content: center;\n    transition: background-color 0.3s ease-in;\n    width: ','em;\n']),_templateObject4=_taggedTemplateLiteral(['\n    display: flex;\n    flex: 1 0 auto;\n    flex-direction: column;\n    margin-left: 1em;\n'],['\n    display: flex;\n    flex: 1 0 auto;\n    flex-direction: column;\n    margin-left: 1em;\n']),_templateObject5=_taggedTemplateLiteral(['\n    font-size: 1.5em;\n    margin-left: 0.25em;\n'],['\n    font-size: 1.5em;\n    margin-left: 0.25em;\n']),_templateObject6=_taggedTemplateLiteral(['\n    margin: 0.1em 0 0 0.45em;\n    color: ',';\n'],['\n    margin: 0.1em 0 0 0.45em;\n    color: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject);var IconWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject2,2.5*__WEBPACK_IMPORTED_MODULE_1__style_variables__["d" /* iconContainerSize */]);var StyledDeviceIcon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0__core_icons_device_icon__["a" /* default */])(_templateObject3,function(p){return p.active?p.theme.mainBrandColor:p.theme.secondaryColor;},function(p){return p.theme.white;},__WEBPACK_IMPORTED_MODULE_1__style_variables__["d" /* iconContainerSize */],__WEBPACK_IMPORTED_MODULE_1__style_variables__["d" /* iconContainerSize */]);var Summary=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject4);var Device=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].span(_templateObject5);var Action=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].span(_templateObject6,function(p){return p.theme.mainBrandColor;});

/***/ }),
/* 2371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_icons__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_icons_general__ = __webpack_require__(148);
var _this=this;// @noflow
var FrequencySelector=function FrequencySelector(_ref){var _ref$handleChange=_ref.handleChange,handleChange=_ref$handleChange===undefined?function(){}:_ref$handleChange,isScheduled=_ref.isScheduled;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:'frequency-selector'},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('frequency-selector__always',{'frequency-selector__active':!isScheduled}),onClick:handleChange.bind(_this,false)},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].always)),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('frequency-selector__scheduled',{'frequency-selector__active':isScheduled}),onClick:handleChange.bind(_this,true)},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__core_icons__["a" /* default */],{className:'frequency-selector__scheduled-icon',icon:__WEBPACK_IMPORTED_MODULE_6__core_constants_icons_general__["SCHEDULE"]}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].scheduled)));};/* harmony default export */ __webpack_exports__["a"] = (FrequencySelector);

/***/ }),
/* 2372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropdown__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
// @noflow
// import { Dropdown } from '~/components/widgets';
var propTypes={className:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,currentIndex:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,description:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,handleSelection:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,list:__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.list.isRequired};var GenericSelector=function GenericSelector(_ref){var className=_ref.className,currentIndex=_ref.currentIndex,description=_ref.description,handleSelection=_ref.handleSelection,list=_ref.list;var color=className==='then-consumer__selector--pale-grey'?'rgb(251, 251, 251)':'rgb(241, 241, 241)';return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('generic-selector',className)},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:'generic-selector__description'},description),list.size===1&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('span',{className:'generic-selector__default-option'},list.get(currentIndex)),list.size>1&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',{className:'generic-selector__dropdown'},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__dropdown__["a" /* default */],{color:color,currentValue:currentIndex,handleChange:handleSelection,options:list})));};GenericSelector.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (GenericSelector);

/***/ }),
/* 2374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_recipes_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_recipes_selectors__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_recipes__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_constants_subscriptions__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_state_entitlements_selectors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component__ = __webpack_require__(2376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__core_state_application_actions__ = __webpack_require__(40);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();// @noflow
var mapStateToProps=function mapStateToProps(state){var getProducersList=Object(__WEBPACK_IMPORTED_MODULE_3__core_state_recipes_selectors__["i" /* makeGetProducersList */])();var getConsumersList=Object(__WEBPACK_IMPORTED_MODULE_3__core_state_recipes_selectors__["h" /* makeGetConsumersList */])();var getProductItemById=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_products_selectors__["P" /* makeGetProductItemById */])();var notificationsConfig=Object(__WEBPACK_IMPORTED_MODULE_9__core_state_config_selectors__["a" /* getConfig */])(state,'recipes:notifications');return function(state,_ref){var currentRecipe=_ref.currentRecipe,specificConsumerId=_ref.specificConsumerId,specificProducerId=_ref.specificProducerId;var templateName=currentRecipe.get('name');var status=currentRecipe.get('status');var producerIndex=void 0,producerName=void 0,producerTrigger=void 0,producerType=void 0,producers=void 0;var producerId=currentRecipe.getIn(['data','producer']);if([__WEBPACK_IMPORTED_MODULE_4__core_constants_recipes__["c" /* recipeStatus */].EDITING,__WEBPACK_IMPORTED_MODULE_4__core_constants_recipes__["c" /* recipeStatus */].UPDATING].includes(status)){var selectedProduct=getProductItemById(state,{id:producerId});producerName=selectedProduct.getIn(['state','name']);producerTrigger=currentRecipe.getIn(['data','trigger','eventName']);producerType=selectedProduct.get('type');producers=Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])([{id:producerId,name:Object(__WEBPACK_IMPORTED_MODULE_0__core_state_products_selectors__["r" /* getNameForProduct */])(state,{id:producerId})}]);producerIndex=0;}else{producerType=__WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__["e" /* templates */][templateName].producer.type;producers=getProducersList(state,{name:templateName});producerIndex=producers.indexOf(producers.find(function(p){return p.get('id')===producerId;}));}if(specificProducerId){// For recipes shown in a producer product page we only want to deal with this producer
producers=producers.filter(function(producer){return producer.get('id')===specificProducerId;});producerIndex=0;}var isNotification=currentRecipe.get('isNotification');var props={isActive:currentRecipe.get('isActive'),isNotification:isNotification,producerName:producerName,producerTrigger:producerTrigger,producerType:producerType,producers:producers,producerIndex:producerIndex,templateName:templateName};if(isNotification){props.notificationOptions=currentRecipe.getIn(['data','action','value']);// Remove the options that are not supported in the user country
notificationsConfig.entrySeq().forEach(function(_ref2){var _ref3=_slicedToArray(_ref2,2),key=_ref3[0],value=_ref3[1];if(!value){props.notificationOptions=props.notificationOptions.delete(key);}});// check that the user has the entitlement for sms
props.hasSMSEntitlement=Object(__WEBPACK_IMPORTED_MODULE_10__core_state_entitlements_selectors__["d" /* hasSMS */])(state);if(!props.hasSMSEntitlement&&props.notificationOptions.get(__WEBPACK_IMPORTED_MODULE_4__core_constants_recipes__["b" /* notificationTypes */].sms)){props.notificationOptions=props.notificationOptions.set(__WEBPACK_IMPORTED_MODULE_4__core_constants_recipes__["b" /* notificationTypes */].sms,false);}}else{var consumerDuration=void 0,consumerIndex=void 0,consumerName=void 0,consumerType=void 0,consumers=void 0;var consumerId=currentRecipe.getIn(['data','consumer']);if([__WEBPACK_IMPORTED_MODULE_4__core_constants_recipes__["c" /* recipeStatus */].EDITING,__WEBPACK_IMPORTED_MODULE_4__core_constants_recipes__["c" /* recipeStatus */].UPDATING].includes(status)){var selectedConsumer=getProductItemById(state,{id:consumerId});consumerDuration=currentRecipe.getIn(['data','action','duration']);consumerName=selectedConsumer.getIn(['state','name']);consumerType=selectedConsumer.get('type');consumers=Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])([{id:consumerId,name:consumerName}]);consumerIndex=0;}else{consumerType=__WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__["e" /* templates */][templateName].consumer.types[0];consumers=getConsumersList(state,{name:templateName});consumerIndex=consumers.indexOf(consumers.find(function(p){return p.get('id')===consumerId;}));if(specificConsumerId){// For recipes shown in a consumer product page we only want to deal with this consumer
consumers=consumers.filter(function(consumer){return consumer.get('id')===specificConsumerId;});consumerIndex=0;}}var consumerPropertiesList=Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])([]);if(consumerId!==-1){consumerPropertiesList=currentRecipe.get('consumerPropertiesList',Object(__WEBPACK_IMPORTED_MODULE_8_immutable__["fromJS"])([]));// if it is heating then check if device has the boost capability
if(consumerType===__WEBPACK_IMPORTED_MODULE_6__core_constants_devices__["deviceTypes"].HEATING&&!Object(__WEBPACK_IMPORTED_MODULE_0__core_state_products_selectors__["v" /* getProductCapabilities */])(state,{id:consumerId}).includes('BOOST')){// if not remove the boost option from the mode property
var modePropertyIndex=consumerPropertiesList.findIndex(function(p){return p.get('field')==='mode';});consumerPropertiesList=consumerPropertiesList.removeIn([modePropertyIndex,'optionsList',3]);}}props=Object.assign({},props,{consumerDuration:consumerDuration,consumerName:consumerName,consumerIndex:consumerIndex,consumerPropertiesList:consumerPropertiesList,consumerState:currentRecipe.getIn(['data','action','changes']),consumerType:consumerType,consumers:consumers,isConsumerActive:Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__["c" /* isConsumerActive */])(currentRecipe,consumerType)});}return props;};};var mapDispatchToProps={handleNotificationChange:__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_actions__["i" /* handleNotificationChange */],handlePropertyChange:__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_actions__["j" /* handlePropertyChange */],selectConsumer:__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_actions__["m" /* selectConsumer */],selectProducer:__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_actions__["n" /* selectProducer */],showHiveLiveModal:__WEBPACK_IMPORTED_MODULE_13__core_state_application_actions__["m" /* showHiveLiveModal */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var consumers=stateProps.consumers,consumerPropertiesList=stateProps.consumerPropertiesList,consumerType=stateProps.consumerType,hasSMSEntitlement=stateProps.hasSMSEntitlement,isNotification=stateProps.isNotification,producers=stateProps.producers;var _handleNotificationChange=dispatchProps.handleNotificationChange,handlePropertyChange=dispatchProps.handlePropertyChange,_selectConsumer=dispatchProps.selectConsumer,_selectProducer=dispatchProps.selectProducer,showHiveLiveModal=dispatchProps.showHiveLiveModal;var specificConsumerId=ownProps.specificConsumerId;return Object.assign({},stateProps,ownProps,{consumerPropertiesList:!isNotification&&consumerPropertiesList.map(function(o){return o.set('handler',function(index){return handlePropertyChange({index:index,property:o.get('type'),consumerType:consumerType});});}),consumersList:!isNotification&&consumers.map(function(p){return p.get('name');}),handleNotificationChange:function handleNotificationChange(notificationType){return notificationType===__WEBPACK_IMPORTED_MODULE_4__core_constants_recipes__["b" /* notificationTypes */].sms&&!hasSMSEntitlement?showHiveLiveModal({feature:__WEBPACK_IMPORTED_MODULE_7__core_constants_subscriptions__["a" /* features */].textNotifications}):_handleNotificationChange(notificationType);},producersList:producers.map(function(p){return p.get('name');}),selectConsumer:function selectConsumer(index){return!isNotification&&_selectConsumer(consumers.getIn([index,'id']));},selectProducer:function selectProducer(index){return _selectProducer({producerId:producers.getIn([index,'id']),specificConsumerId:specificConsumerId});}});};var ConnectedRecipeDetail=Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_12__component__["a" /* default */]);ConnectedRecipeDetail.propTypes={currentRecipe:__WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.object.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ConnectedRecipeDetail);

/***/ }),
/* 2376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__intl__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
// @noflow
RecipeDetail.propTypes={consumerDuration:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isNotification','templateName'],function(_,isNotification,templateName){return!isNotification&&!templateName;},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number),consumerIndex:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isNotification'],function(_,isNotification){return!isNotification;},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired),consumerName:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isNotification','templateName'],function(_,isNotification,templateName){return!isNotification&&!templateName;},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired),consumerPropertiesList:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isNotification'],function(_,isNotification){return!isNotification;},__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.list.isRequired),consumerState:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isNotification'],function(_,isNotification){return!isNotification;},__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.list.isRequired),consumerType:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isNotification'],function(_,isNotification){return!isNotification;},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired),consumersList:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isNotification'],function(_,isNotification){return!isNotification;},__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.list.isRequired),handleNotificationChange:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["h" /* intlShape */],isActive:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,isConsumerActive:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isNotification'],function(_,isNotification){return!isNotification;},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired),isNotification:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,notificationOptions:__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.map,producerIndex:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,producerName:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['templateName'],function(_,templateName){return!templateName;},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired),producerTrigger:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['templateName'],function(_,templateName){return!templateName;},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired),producerType:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,producersList:__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.list,requireHiveLiveModal:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,selectConsumer:Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isNotification'],function(_,isNotification){return!isNotification;},__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired),selectProducer:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,templateName:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string};function RecipeDetail(_ref){var consumerDuration=_ref.consumerDuration,consumerState=_ref.consumerState,consumerIndex=_ref.consumerIndex,consumerName=_ref.consumerName,consumerPropertiesList=_ref.consumerPropertiesList,consumerType=_ref.consumerType,consumersList=_ref.consumersList,handleNotificationChange=_ref.handleNotificationChange,formatMessage=_ref.intl.formatMessage,isActive=_ref.isActive,isConsumerActive=_ref.isConsumerActive,isNotification=_ref.isNotification,notificationOptions=_ref.notificationOptions,producerIndex=_ref.producerIndex,producerName=_ref.producerName,producerTrigger=_ref.producerTrigger,producerType=_ref.producerType,producersList=_ref.producersList,selectConsumer=_ref.selectConsumer,selectProducer=_ref.selectProducer,templateName=_ref.templateName;var title=void 0;if(templateName){title=__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* Title */],null,formatMessage(__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */][templateName]));}else{var whenText=Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* getWhenText */])(formatMessage,{name:producerName,trigger:producerTrigger,type:producerType});var thenText=isNotification?Object(__WEBPACK_IMPORTED_MODULE_2__common__["b" /* getThenNotificationText */])(formatMessage,notificationOptions):Object(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* getThenConsumerText */])(formatMessage,{duration:consumerDuration,name:consumerName,state:consumerState,type:consumerType});title=__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* Title */],null,whenText,', ',thenText);}return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Container */],null,title,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* CompContainer */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('h2',null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].when)),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3____["h" /* RecipeWhen */],{currentIndex:producerIndex,deviceType:producerType,handleSelection:selectProducer,isDeviceActiveState:isActive,list:producersList})),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* CompContainer */],{hide:producerIndex===-1},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('h2',null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].then)),isNotification?__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3____["g" /* RecipeThenNotify */],{changeHandlers:handleNotificationChange,options:notificationOptions}):__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3____["f" /* RecipeThenConsumer */],{deviceList:consumersList,deviceType:consumerType,handleDeviceSelection:selectConsumer,isDeviceActiveState:isConsumerActive,propertiesList:consumerPropertiesList,selectedDeviceIndex:consumerIndex})));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["g" /* injectIntl */])(RecipeDetail));

/***/ }),
/* 2377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Title; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    margin: 1em;\n\n    ',' ',';\n'],['\n    margin: 1em;\n\n    ',' ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n\t\tmargin: 1.5em;\n\t'],['\n\t\tmargin: 1.5em;\n\t']),_templateObject3=_taggedTemplateLiteral(['\n\t\tmargin: 2em;\n\t'],['\n\t\tmargin: 2em;\n\t']),_templateObject4=_taggedTemplateLiteral(['\n\tfont-size: 0.8em;\n\tmargin-bottom: 2em;\n\topacity: ','\n\n\ttransition: opacity 0.3s ease-out;\n'],['\n\tfont-size: 0.8em;\n\tmargin-bottom: 2em;\n\topacity: ','\n\n\ttransition: opacity 0.3s ease-out;\n']),_templateObject5=_taggedTemplateLiteral(['\n\tborder-bottom: solid 1px ','\n\tpadding-bottom: 0.3em;\n'],['\n\tborder-bottom: solid 1px ','\n\tpadding-bottom: 0.3em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject2),__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].desktop(_templateObject3));var CompContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4,function(p){return p.hide?0:1;});var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h2(_templateObject5,function(p){return p.theme.mediumGrey;});

/***/ }),
/* 2378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_schedule__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_recipes_selectors__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component__ = __webpack_require__(2379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_recipes_actions__ = __webpack_require__(169);
var mapStateToProps=function mapStateToProps(state){var currentRecipe=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_recipes_selectors__["a" /* getCurrentRecipe */])(state);var componentId=Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_schedule__["c" /* createComponentId */])('recipe',currentRecipe.getIn(['data','id']));return{isScheduled:currentRecipe.getIn(['data','scheduled'],false),scheduleComponentId:componentId};};var mapDispatchToProps={toggleScheduleState:__WEBPACK_IMPORTED_MODULE_4__core_state_recipes_actions__["q" /* toggleScheduleState */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__component__["a" /* default */]));

/***/ }),
/* 2379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = RecipeSchedule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(28);
// @noflow
RecipeSchedule.propTypes={isScheduled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired,scheduleComponentId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,toggleScheduleState:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired};function RecipeSchedule(_ref){var isScheduled=_ref.isScheduled,scheduleComponentId=_ref.scheduleComponentId,toggleScheduleState=_ref.toggleScheduleState;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Main */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* FrequencyContainer */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["b" /* FrequencySelector */],{handleChange:toggleScheduleState,isScheduled:isScheduled})),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* ScheduleContainer */],{show:isScheduled},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4____["_0" /* Schedule */],{componentId:scheduleComponentId})));}

/***/ }),
/* 2380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Main; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FrequencyContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ScheduleContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    margin: 1em;\n\n    ',';\n    ',';\n'],['\n    margin: 1em;\n\n    ',';\n    ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n        font-size: 14px;\n\t\tmargin: 1.5em;\n\t'],['\n        font-size: 14px;\n\t\tmargin: 1.5em;\n\t']),_templateObject3=_taggedTemplateLiteral(['\n\t\tmargin: 2em;\n\t'],['\n\t\tmargin: 2em;\n\t']),_templateObject4=_taggedTemplateLiteral(['\n    border: solid 1px ',';\n    border-radius: 0.5em;\n    overflow: hidden;\n    margin-bottom: 0.5em;\n'],['\n    border: solid 1px ',';\n    border-radius: 0.5em;\n    overflow: hidden;\n    margin-bottom: 0.5em;\n']),_templateObject5=_taggedTemplateLiteral(['\n    margin-bottom: 2em;\n    position: relative;\n    opacity: ',';\n    pointer-events: ',';\n\n    transition: opacity 0.3s ease-out;\n'],['\n    margin-bottom: 2em;\n    position: relative;\n    opacity: ',';\n    pointer-events: ',';\n\n    transition: opacity 0.3s ease-out;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Main=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject2),__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].desktop(_templateObject3));var FrequencyContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4,function(p){return p.theme.mainBrandColor;});var ScheduleContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5,function(p){return p.show?1:0.2;},function(p){return p.show?'inherit':'none';});

/***/ }),
/* 2381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var selectorBaseClassname='then-consumer__selector';var separatorBaseClassname='then-consumer__separator';var getModifierClasses=function getModifierClasses(index){var _truthMap;var truthMap=(_truthMap={},_defineProperty(_truthMap,true,{selectorModifier:selectorBaseClassname+'--pale-grey',separatorModifier:separatorBaseClassname+'--light-grey'}),_defineProperty(_truthMap,index%2===1,{selectorModifier:selectorBaseClassname+'--light-grey',separatorModifier:separatorBaseClassname+'--pale-grey'}),_defineProperty(_truthMap,index===0,{selectorModifier:selectorBaseClassname+'--pale-grey',separatorModifier:''}),_truthMap);return truthMap[true];};var propTypes={deviceList:__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.list.isRequired,deviceType:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,handleDeviceSelection:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["h" /* intlShape */],isDeviceActiveState:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,propertiesList:__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.contains({handler:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,label:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,optionsList:__WEBPACK_IMPORTED_MODULE_4_react_immutable_proptypes___default.a.list.isRequired,selectedIndex:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired})).isRequired,selectedDeviceIndex:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired};var RecipeThenConsumer=function RecipeThenConsumer(_ref){var propertiesList=_ref.propertiesList,deviceList=_ref.deviceList,deviceType=_ref.deviceType,handleDeviceSelection=_ref.handleDeviceSelection,formatMessage=_ref.intl.formatMessage,isDeviceActiveState=_ref.isDeviceActiveState,selectedDeviceIndex=_ref.selectedDeviceIndex;return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',{className:'then-consumer'},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["a" /* DeviceSelector */],{currentIndex:selectedDeviceIndex,deviceType:deviceType,handleSelection:handleDeviceSelection,isDeviceActiveState:isDeviceActiveState,list:deviceList}),propertiesList.map(function(d,index){var _getModifierClasses=getModifierClasses(index),separatorModifier=_getModifierClasses.separatorModifier,selectorModifier=_getModifierClasses.selectorModifier;return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',{key:'consumer-'+index},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_3_classnames___default()(separatorBaseClassname,separatorModifier)}),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["c" /* GenericSelector */],{className:selectorModifier,currentIndex:d.get('selectedIndex'),description:formatMessage(d.get('label').toJS()),handleSelection:d.get('handler'),list:d.get('optionsList').map(function(o){var label=o.get('label');return typeof label==='string'?label:formatMessage(o.get('label').toJS());})}));}));};RecipeThenConsumer.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["g" /* injectIntl */])(RecipeThenConsumer));

/***/ }),
/* 2382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_constants_icons_general__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8____ = __webpack_require__(28);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var propTypes={changeHandlers:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["h" /* intlShape */].isRequired,options:__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.map.isRequired};var RecipeThenNotify=function RecipeThenNotify(_ref){var changeHandlers=_ref.changeHandlers,formatMessage=_ref.intl.formatMessage,options=_ref.options;return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* Header */],null,__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* IconWrapper */],null,__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["h" /* StyledIcon */],{icon:__WEBPACK_IMPORTED_MODULE_5__core_constants_icons_general__["NOTIFICATIONS_ON"]})),__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["i" /* Summary */],null,__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* Device */],null,Object(__WEBPACK_IMPORTED_MODULE_2__common__["b" /* getThenNotificationText */])(formatMessage,options)))),__WEBPACK_IMPORTED_MODULE_7_react__["createElement"]('div',null,options.entrySeq().map(function(_ref2,i){var _ref3=_slicedToArray(_ref2,2),key=_ref3[0],value=_ref3[1];return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"]('div',{key:'option-'+key},__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["g" /* Seperator */],{index:i}),__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["f" /* Option */],{index:i},__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Description */],null,formatMessage(__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */][key])),__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["j" /* Toggle */],null,__WEBPACK_IMPORTED_MODULE_7_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8____["_14" /* ToggleButton */],{isOn:value,onChange:function onChange(){return changeHandlers(key);}}))));})));};RecipeThenNotify.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["g" /* injectIntl */])(RecipeThenNotify));

/***/ }),
/* 2384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return StyledIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Summary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Device; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Toggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Seperator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Option; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_icons__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_variables__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    border: 1px solid ',';\n    border-radius: 0.5em;\n    overflow: hidden;\n    position: relative;\n'],['\n    border: 1px solid ',';\n    border-radius: 0.5em;\n    overflow: hidden;\n    position: relative;\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n    padding: 0.5em 1em;\n'],['\n    align-items: center;\n    display: flex;\n    justify-content: flex-start;\n    padding: 0.5em 1em;\n']),_templateObject3=_taggedTemplateLiteral(['width: ','em;'],['width: ','em;']),_templateObject4=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    border-radius: 50%;\n    color: ',';\n    display: flex;\n    font-size: 2.5em;\n    height: ','em;\n    justify-content: center;\n    transition: background-color 0.3s ease-in;\n    width: ','em;\n'],['\n    align-items: center;\n    background-color: ',';\n    border-radius: 50%;\n    color: ',';\n    display: flex;\n    font-size: 2.5em;\n    height: ','em;\n    justify-content: center;\n    transition: background-color 0.3s ease-in;\n    width: ','em;\n']),_templateObject5=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    margin-left: 1em;\n    width: calc(80% - 1em);\n'],['\n    display: flex;\n    flex-direction: column;\n    margin-left: 1em;\n    width: calc(80% - 1em);\n']),_templateObject6=_taggedTemplateLiteral(['\n    font-size: 1.5em;\n    margin-left: 0.25em;\n'],['\n    font-size: 1.5em;\n    margin-left: 0.25em;\n']),_templateObject7=_taggedTemplateLiteral(['\n    color: ',';\n    font-size: 1.2em;\n'],['\n    color: ',';\n    font-size: 1.2em;\n']),_templateObject8=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-end;\n    width: calc(40% - 1em);\n'],['\n    display: flex;\n    justify-content: flex-end;\n    width: calc(40% - 1em);\n']),_templateObject9=_taggedTemplateLiteral(['\n    border-bottom: 1px solid ',';\n\n    &:before,\n    &:after {\n        content: \'\';\n        display: block;\n        width: 0;\n        height: 0;\n        left: calc(50% - ',');\n        border-left: ',' solid transparent;\n        border-right: ',' solid transparent;\n        border-top: ',' solid ',';\n        position: absolute;\n        z-index: 1;\n    }\n\n    &:after {\n        border-top: ',' solid\n            ',';\n        margin-top: -1px;\n    }\n'],['\n    border-bottom: 1px solid ',';\n\n    &:before,\n    &:after {\n        content: \'\';\n        display: block;\n        width: 0;\n        height: 0;\n        left: calc(50% - ',');\n        border-left: ',' solid transparent;\n        border-right: ',' solid transparent;\n        border-top: ',' solid ',';\n        position: absolute;\n        z-index: 1;\n    }\n\n    &:after {\n        border-top: ',' solid\n            ',';\n        margin-top: -1px;\n    }\n']),_templateObject10=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    display: flex;\n    justify-content: space-between;\n    padding: 1em;\n'],['\n    align-items: center;\n    background-color: ',';\n    display: flex;\n    justify-content: space-between;\n    padding: 1em;\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// @noflow
var triangleSize='12px';var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject,function(p){return p.theme.mediumGrey;});var Header=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject2);var IconWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject3,2.5*__WEBPACK_IMPORTED_MODULE_1__style_variables__["d" /* iconContainerSize */]);var StyledIcon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0__core_icons__["a" /* default */])(_templateObject4,function(p){return p.theme.mainBrandColor;},function(p){return p.theme.white;},__WEBPACK_IMPORTED_MODULE_1__style_variables__["d" /* iconContainerSize */],__WEBPACK_IMPORTED_MODULE_1__style_variables__["d" /* iconContainerSize */]);var Summary=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject5);var Device=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].span(_templateObject6);var Description=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject7,function(p){return p.theme.mainBrandColor;});var Toggle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject8);var Seperator=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject9,function(p){return p.theme.mediumGrey;},triangleSize,triangleSize,triangleSize,triangleSize,function(p){return p.theme.mediumGrey;},triangleSize,function(p){var _true;return(_true={},_defineProperty(_true,p.index%2===0,p.theme.lightGrey),_defineProperty(_true,p.index%2!==0,p.theme.paleGrey),_defineProperty(_true,p.index===0,p.theme.white),_true)[true];});var Option=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject10,function(p){return p.index%2===0?p.theme.paleGrey:p.theme.lightGrey;});

/***/ }),
/* 2385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
// @noflow
var propTypes={action:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,currentIndex:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,deviceType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,handleSelection:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,isDeviceActiveState:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,list:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.list.isRequired};var RecipeWhen=function RecipeWhen(_ref){var action=_ref.action,currentIndex=_ref.currentIndex,deviceType=_ref.deviceType,handleSelection=_ref.handleSelection,isDeviceActiveState=_ref.isDeviceActiveState,list=_ref.list;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',{className:'recipes-when'},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1____["a" /* DeviceSelector */],{action:action,currentIndex:currentIndex,deviceType:deviceType,handleSelection:handleSelection,isDeviceActiveState:isDeviceActiveState,list:list}));};RecipeWhen.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (RecipeWhen);

/***/ }),
/* 2386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_recipes_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2388);
var mapStateToProps=function mapStateToProps(state,_ref){var producerId=_ref.producerId,templatesList=_ref.templatesList;return{producerId:producerId,templatesList:templatesList};};var mapDispatchToProps={selectTemplate:__WEBPACK_IMPORTED_MODULE_1__core_state_recipes_actions__["o" /* selectTemplate */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var producerId=stateProps.producerId;var _selectTemplate=dispatchProps.selectTemplate;var specificConsumerId=ownProps.specificConsumerId;return Object.assign({},stateProps,dispatchProps,ownProps,{selectTemplate:function selectTemplate(templateName){return _selectTemplate({producerId:producerId,templateName:templateName,specificConsumerId:specificConsumerId});}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 2388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css__ = __webpack_require__(2389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(175);
// @noflow
var propTypes={selectTemplate:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,templatesList:__WEBPACK_IMPORTED_MODULE_1_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)};var TemplatesList=function TemplatesList(_ref){var _selectTemplate=_ref.selectTemplate,templatesList=_ref.templatesList;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{className:'templates-list'},templatesList.map(function(templateName,i){return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4____["i" /* Template */],{key:'template-'+i,name:templateName,selectTemplate:function selectTemplate(){return _selectTemplate(templateName);}});}));};TemplatesList.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (TemplatesList);

/***/ }),
/* 2389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(2391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__ = __webpack_require__(184);
var mapStateToProps=function mapStateToProps(state,_ref){var name=_ref.name,selectTemplate=_ref.selectTemplate;var template=__WEBPACK_IMPORTED_MODULE_2__core_utils_recipes__["e" /* templates */][name];return{active:template.producer.active,consumerType:template.isNotification?null:template.consumer.types[0],isNotification:template.isNotification===true,producerType:template.producer.type,selectTemplate:selectTemplate};};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */]));

/***/ }),
/* 2391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_components_conditional_feature__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
var BUTTON_TEMPLATE_REGEXP=/^hive-button/i;var propTypes={active:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,consumerType:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["h" /* intlShape */],isNotification:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,name:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,producerType:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,selectTemplate:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func};var Template=function Template(_ref){var active=_ref.active,consumerType=_ref.consumerType,formatMessage=_ref.intl.formatMessage,isNotification=_ref.isNotification,name=_ref.name,producerType=_ref.producerType,_ref$selectTemplate=_ref.selectTemplate,selectTemplate=_ref$selectTemplate===undefined?function(){}:_ref$selectTemplate;return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__core_components_conditional_feature__["a" /* default */],{condition:function condition(featureFlags){return!isHiveButton(name)||featureFlags.hiveButton;}},function(){return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* Main */],{onClick:selectTemplate},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Icons */],null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* StyledDeviceIcon */],{active:active,type:producerType}),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["f" /* StyledIcon */],{icon:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general__["RIGHT"]}),isNotification?__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["f" /* StyledIcon */],{icon:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general__["NOTIFICATIONS_ON"],set:'general'}):__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* StyledDeviceIcon */],{active:false,type:consumerType})),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* Description */],null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('p',null,formatMessage(__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */][name]))),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* NextStep */],null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["f" /* StyledIcon */],{icon:__WEBPACK_IMPORTED_MODULE_2__core_constants_icons_general__["RIGHT"]})));});};function isHiveButton(templateName){return BUTTON_TEMPLATE_REGEXP.test(templateName);}Template.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["g" /* injectIntl */])(Template));

/***/ }),
/* 2392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Main; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Icons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NextStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StyledDeviceIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StyledIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_device_icon__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_icons__ = __webpack_require__(147);
var _templateObject=_taggedTemplateLiteral(['\n    border-bottom: 1px solid ',';\n    cursor: pointer;\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    padding: ',';\n    position: relative;\n\n    &:first-of-type {\n        border-top: 1px solid ',';\n    }\n\n    &:hover {\n        background-color: ',';\n    }\n'],['\n    border-bottom: 1px solid ',';\n    cursor: pointer;\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    padding: ',';\n    position: relative;\n\n    &:first-of-type {\n        border-top: 1px solid ',';\n    }\n\n    &:hover {\n        background-color: ',';\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    width: auto;\n'],['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    width: auto;\n']),_templateObject3=_taggedTemplateLiteral(['\n    ',' margin-left: ',';\n    transition: all 0.2s ease-in-out;\n'],['\n    ',' margin-left: ',';\n    transition: all 0.2s ease-in-out;\n']),_templateObject4=_taggedTemplateLiteral(['\n    ',' flex-grow: 2;\n    justify-content: flex-start;\n    margin-left: calc(',' * 1.5);\n\n    p {\n        margin: 0;\n        padding: 0 calc(',' * 0.5);\n        text-align: left;\n    }\n'],['\n    ',' flex-grow: 2;\n    justify-content: flex-start;\n    margin-left: calc(',' * 1.5);\n\n    p {\n        margin: 0;\n        padding: 0 calc(',' * 0.5);\n        text-align: left;\n    }\n']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    width: ',';\n'],['\n    align-items: center;\n    display: flex;\n    width: ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n    font-size: ',';\n    color: ',';\n'],['\n    font-size: ',';\n    color: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var padding='0.7em';var nextStepWidth='2.5em';var iconSize='2.5em';var Main=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(p){return p.theme.offlineGrey;},padding,function(p){return p.theme.offlineGrey;},function(p){return Object(__WEBPACK_IMPORTED_MODULE_1_polished__["c" /* lighten */])(0.3,p.theme.offlineGrey);});var commonStyle=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject2);var Icons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,commonStyle,padding);var Description=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4,commonStyle,padding,padding);var NextStep=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,nextStepWidth);var StyledDeviceIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_device_icon__["a" /* default */])(_templateObject6,iconSize,function(p){return p.active?p.theme.mainBrandColor:p.theme.primaryFontColor;});var StyledIcon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3__core_icons__["a" /* default */])(_templateObject6,iconSize,function(p){return p.active?p.theme.mainBrandColor:p.theme.primaryFontColor;});

/***/ }),
/* 2393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_entitlements_selectors__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_recipes__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_constants_recipes__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__(2394);
var NOTIFICATION='NOTIFICATION';var mapStateToProps=function mapStateToProps(state,_ref){var recipe=_ref.recipe;var getProductItemById=Object(__WEBPACK_IMPORTED_MODULE_4__core_state_products_selectors__["P" /* makeGetProductItemById */])();var consumerProduct=getProductItemById(state,{id:recipe.getIn(['data','consumer'])});var producerProduct=getProductItemById(state,{id:recipe.getIn(['data','producer'])});var notificationOptions=void 0,consumer=void 0;if(recipe.getIn(['data','action','type'])===NOTIFICATION){notificationOptions=recipe.getIn(['data','action','value']);if(!Object(__WEBPACK_IMPORTED_MODULE_2__core_state_entitlements_selectors__["d" /* hasSMS */])(state)&&notificationOptions.get(__WEBPACK_IMPORTED_MODULE_5__core_constants_recipes__["b" /* notificationTypes */].sms)){notificationOptions=notificationOptions.set(__WEBPACK_IMPORTED_MODULE_5__core_constants_recipes__["b" /* notificationTypes */].sms,false);}}else if(consumerProduct){var type=consumerProduct.get('type');consumer={duration:recipe.getIn(['data','action','duration']),isActive:Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_recipes__["c" /* isConsumerActive */])(recipe,type),name:consumerProduct.getIn(['state','name']),state:recipe.getIn(['data','action','changes']),type:type};}var producer={name:producerProduct.getIn(['state','name']),trigger:recipe.getIn(['data','trigger','eventName']),type:producerProduct.get('type')};var isEnabled=recipe.getIn(['data','enabled']);var isScheduled=recipe.getIn(['data','scheduled']);var status=recipe.get('status');return{consumer:consumer,isEnabled:isEnabled,isScheduled:isScheduled,notificationOptions:notificationOptions,producer:producer,status:status};};var mapDispatchToProps={attemptDeleteRecipe:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["b" /* attemptDeleteRecipe */],attemptUpdateRecipe:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["c" /* attemptUpdateRecipe */],cancelAction:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["d" /* cancelAction */],editRecipe:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["f" /* editRecipe */],editSchedule:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["g" /* editSchedule */],requestConfirmDelete:__WEBPACK_IMPORTED_MODULE_0__core_state_recipes_actions__["l" /* requestConfirmDelete */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var attemptDeleteRecipe=dispatchProps.attemptDeleteRecipe,attemptUpdateRecipe=dispatchProps.attemptUpdateRecipe,_cancelAction=dispatchProps.cancelAction,_editRecipe=dispatchProps.editRecipe,editSchedule=dispatchProps.editSchedule,requestConfirmDelete=dispatchProps.requestConfirmDelete;var _stateProps$consumer=stateProps.consumer,consumer=_stateProps$consumer===undefined?{}:_stateProps$consumer,isEnabled=stateProps.isEnabled;var recipe=ownProps.recipe;return Object.assign({},stateProps,{cancelAction:function cancelAction(){return _cancelAction(recipe.getIn(['data','id']));},confirmDelete:function confirmDelete(){return attemptDeleteRecipe(recipe.getIn(['data','id']));},deleteRecipe:function deleteRecipe(){return requestConfirmDelete(recipe.getIn(['data','id']));},editRecipe:function editRecipe(){return _editRecipe({recipeData:recipe.get('data'),consumerType:consumer.type});},showSchedule:function showSchedule(){return editSchedule({recipeData:recipe.get('data'),consumerType:consumer.type});},toggleRecipeStatus:function toggleRecipeStatus(){return attemptUpdateRecipe(recipe.setIn(['data','enabled'],!isEnabled));}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),
/* 2394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__intl__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_constants_recipes__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__buttons_toggle__ = __webpack_require__(515);
RecipesItem.propTypes={cancelAction:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,confirmDelete:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,consumer:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({duration:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,name:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,state:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any.isRequired,type:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired}),deleteRecipe:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,editRecipe:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["h" /* intlShape */],isEnabled:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,isScheduled:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired,notificationOptions:__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.map,producer:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,trigger:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired}).isRequired,showSchedule:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,status:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,toggleRecipeStatus:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired};function RecipesItem(_ref){var cancelAction=_ref.cancelAction,confirmDelete=_ref.confirmDelete,consumer=_ref.consumer,deleteRecipe=_ref.deleteRecipe,editRecipe=_ref.editRecipe,formatMessage=_ref.intl.formatMessage,isEnabled=_ref.isEnabled,isScheduled=_ref.isScheduled,notificationOptions=_ref.notificationOptions,producer=_ref.producer,toggleRecipeStatus=_ref.toggleRecipeStatus,showSchedule=_ref.showSchedule,status=_ref.status;var whenText=Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* getWhenText */])(formatMessage,producer);var thenText=notificationOptions?Object(__WEBPACK_IMPORTED_MODULE_2__common__["b" /* getThenNotificationText */])(formatMessage,notificationOptions):Object(__WEBPACK_IMPORTED_MODULE_2__common__["a" /* getThenConsumerText */])(formatMessage,consumer);var UPDATING=__WEBPACK_IMPORTED_MODULE_9__core_constants_recipes__["c" /* recipeStatus */].UPDATING,CONFIRMING=__WEBPACK_IMPORTED_MODULE_9__core_constants_recipes__["c" /* recipeStatus */].CONFIRMING,DELETING=__WEBPACK_IMPORTED_MODULE_9__core_constants_recipes__["c" /* recipeStatus */].DELETING;return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["m" /* RecipeItem */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Content */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["g" /* IconsContainer */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["j" /* Producer */],{isEnabled:isEnabled},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["k" /* ProductDeviceIcon */],{active:true,type:producer.type})),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* Consumer */],{isEnabled:isEnabled},consumer?__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["k" /* ProductDeviceIcon */],{active:consumer.isActive,type:consumer.type}):__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["l" /* ProductIcon */],{icon:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general__["NOTIFICATIONS_ON"],set:'general'}))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["f" /* Details */],{isEnabled:isEnabled},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["n" /* Text */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div',null,whenText),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div',null,thenText)),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* ControlPanel */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* ControlPanelToggleButton */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__buttons_toggle__["a" /* default */],{isOn:isEnabled,onChange:toggleRecipeStatus})),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* ControlPanelIcon */],{icon:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general__["SCHEDULE"],isDisabled:!isScheduled,onClick:showSchedule}),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* ControlPanelIcon */],{icon:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general__["EDIT"],onClick:editRecipe}),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* ControlPanelIcon */],{icon:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general__["TRASH"],onClick:deleteRecipe}))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["h" /* Overlay */],{show:[UPDATING,CONFIRMING,DELETING].includes(status)},status===UPDATING&&__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["i" /* OverlayContent */],null,formatMessage(__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].updating)),[CONFIRMING,DELETING].includes(status)&&__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["i" /* OverlayContent */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('span',null,formatMessage(status===CONFIRMING?__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].confirmDeleting:__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].deleting)),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div',null,status===CONFIRMING&&__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4____["l" /* Button */],{alternate:true,onClick:cancelAction},formatMessage(__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].cancel)),status===CONFIRMING&&__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4____["l" /* Button */],{onClick:confirmDelete},formatMessage(__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].confirm)))))));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["g" /* injectIntl */])(RecipesItem));

/***/ }),
/* 2395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule_type__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_ui_schedule_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component__ = __webpack_require__(2450);
// @noflow
var mapStateToProps=function mapStateToProps(state,ownProps){var isScheduleLoaded=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["j" /* getScheduleData */])(state,ownProps)!=null;var isSavingSchedule=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["g" /* getIsSavingSchedule */])(state,ownProps);var scheduleType=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["n" /* getScheduleType */])(state,ownProps);var productId=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["d" /* getDataId */])(state,ownProps);var productProps=Object(__WEBPACK_IMPORTED_MODULE_3__core_state_products_selectors__["H" /* getPropsForProduct */])(state,{id:productId});return Object.assign({},ownProps,{isSavingSchedule:isSavingSchedule,productId:productId,isScheduleLoaded:isScheduleLoaded,productProps:productProps,scheduleType:scheduleType});};var mapDispatchToProps={resetSchedule:__WEBPACK_IMPORTED_MODULE_4__core_state_ui_schedule_actions__["l" /* resetSchedule */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var productProps=stateProps.productProps,scheduleType=stateProps.scheduleType;var resetSchedule=dispatchProps.resetSchedule;var componentId=ownProps.componentId;var reset=function reset(){var defaultSchedule=Object(__WEBPACK_IMPORTED_MODULE_2__schedule_type__["b" /* getDefaultSchedule */])({type:scheduleType,productProps:productProps});if(defaultSchedule){resetSchedule({componentId:componentId,defaultSchedule:defaultSchedule});}};return Object.assign({},ownProps,stateProps,{reset:reset});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_5__component__["a" /* default */]));

/***/ }),
/* 2396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateValue", function() { return updateValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intl__ = __webpack_require__(2397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_themes_main__ = __webpack_require__(78);
// @noflow
var getValueColor=function getValueColor(_ref){var value=_ref.value;return value.get('status')==='OFF'?__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].mediumGrey:__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].mainBrandColor;};var getValueLabel=function getValueLabel(_ref2){var formatMessage=_ref2.formatMessage,value=_ref2.value;return formatMessage(value.get('status')==='OFF'?__WEBPACK_IMPORTED_MODULE_0__intl__["a" /* default */].off:__WEBPACK_IMPORTED_MODULE_0__intl__["a" /* default */].on);};var updateValue=function updateValue(event){return event.getIn(['value','status'])==='OFF'?event.setIn(['value','status'],'ON'):event.setIn(['value','status'],'OFF');};var defaultEventValue={status:'OFF'};var getDefaultSchedule=function getDefaultSchedule(){return{monday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],tuesday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],wednesday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],thursday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],friday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],saturday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],sunday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}]};};

/***/ }),
/* 2397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({off:{id:'schedule.active-plug.off',defaultMessage:'Off',description:'Schedule active plug `Off` label, it has to be short so use abreaviations if too long'},on:{id:'schedule.active-plug.on',defaultMessage:'On',description:'Schedule active plug `On` label, it has to be short so use abreaviations if too long'}}));

/***/ }),
/* 2398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPicker", function() { return hasPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPicker", function() { return getPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bulbs_color_tuneable__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_colour__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__intl__ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style__ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_themes_main__ = __webpack_require__(78);
// @noflow
var maxSaturation=99;var getValueColor=function getValueColor(_ref){var value=_ref.value;var colourTemperature=value.get('colourTemperature');var isWhiteMode=value.get('colourMode',__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white)===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white;if(value.get('status')===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceModes"].OFF||isWhiteMode&&!colourTemperature){return __WEBPACK_IMPORTED_MODULE_9__core_themes_main__["a" /* default */].mediumGrey;}return isWhiteMode?// darken the colour to make it easier to read
Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* darken */])(0.2,Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_colour__["c" /* convertTemperatureToRGB */])(colourTemperature)):Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_colour__["i" /* hsvToRgbString */])({h:value.get('hue'),s:value.get('saturation'),v:100});};var getValueLabel=function getValueLabel(_ref2){var formatMessage=_ref2.formatMessage,value=_ref2.value;var isWhiteMode=value.get('colourMode',__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white)===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white;var brightness=value.get('brightness');if(value.get('status')===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceModes"].OFF||isWhiteMode&&!brightness){return formatMessage(__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].off);}return(isWhiteMode?brightness:value.get('value'))+'%';};var hasPicker=function hasPicker(){return true;};var getPicker=function getPicker(_ref3){var config=_ref3.config,value=_ref3.value,updateValue=_ref3.updateValue;var defaultBrightness=config.getIn(['products','colourtuneablelight','defaultBrightness']);var defaultTemperature=config.getIn(['products','colourtuneablelight','defaultTemperature']);var defaultHue=config.getIn(['products','colourtuneablelight','defaultHue']);var defaultSaturation=config.getIn(['products','colourtuneablelight','defaultSaturation']);var isOn=value.get('status')==='ON';var colourTemperature=value.get('colourTemperature')||defaultTemperature;var colourMode=value.get('colourMode',__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].colour);var isWhite=colourMode===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white;var brightness=value.get(isWhite?'brightness':'value',defaultBrightness);var hue=value.get('hue',defaultHue);var saturation=value.get('saturation')||defaultSaturation;var hsv={h:hue,s:value.get('saturation')||saturation,v:100};var _hsvToRgb=Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_colour__["h" /* hsvToRgb */])(hsv),red=_hsvToRgb.red,green=_hsvToRgb.green,blue=_hsvToRgb.blue;var rgb=[red,green,blue];var brightnessChanged=function brightnessChanged(newValue){return updateValue(value.set(isWhite?'brightness':'value',newValue));};var toggleLightbulb=function toggleLightbulb(){return isOn?updateValue(value.clear().set('status','OFF')):updateValue(Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])({status:'ON',value:brightness,hue:hue,saturation:saturation,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].colour}));};var changeMode=function changeMode(_ref4){var mode=_ref4.mode;return mode===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white?updateValue(Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])({status:'ON',brightness:brightness,colourTemperature:colourTemperature,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white})):updateValue(Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])({status:'ON',value:brightness,hue:hue,saturation:saturation,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].colour}));};var colourChanged=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default()(1000,function(_ref5){var hsv=_ref5.hsv,valueInRange=_ref5.valueInRange;return colourMode===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].colour?updateValue(value.withMutations(function(value){return value.set('hue',hsv.h).set('saturation',Math.min(hsv.s,maxSaturation));})):updateValue(value.set('colourTemperature',valueInRange));});return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__style__["a" /* PickerContainer */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__bulbs_color_tuneable__["a" /* default */],{bulbBrightness:brightness,bulbColorMode:colourMode,bulbType:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,changeColor:colourChanged,changeColorMode:changeMode,colourStartRadians:3.52,colourStopRadians:5.9,delayRendering:500,handleRadiusPercent:5,isCustomRange:isWhite,isOn:isOn,isSmall:true,isTuneable:true,pickerDepthPercent:5,rangeValue:colourTemperature,rgb:rgb,toggleLightbulb:toggleLightbulb,valueChanged:brightnessChanged}));};var defaultEventValue={status:'OFF'};var getDefaultSchedule=function getDefaultSchedule(){return{monday:[{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],tuesday:[{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],wednesday:[{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],thursday:[{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],friday:[{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],saturday:[{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],sunday:[{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:2700,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}]};};

/***/ }),
/* 2399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_inRange__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_inRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_inRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_equals__ = __webpack_require__(2402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_equals___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_equals__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bounce_effect__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__color_picker__ = __webpack_require__(2404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_constants_icons_devices_svg__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dom_dom_resize__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10____ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__core_i18n_components_widgets_flipper_intl__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_router_dom__ = __webpack_require__(87);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getIntlTemperatureKey=function getIntlTemperatureKey(temp){var tempMessageMap=new Map([[__WEBPACK_IMPORTED_MODULE_1_lodash_fp_inRange___default()(2700,3461,temp),'warmest'],[__WEBPACK_IMPORTED_MODULE_1_lodash_fp_inRange___default()(3461,4221,temp),'warm'],[__WEBPACK_IMPORTED_MODULE_1_lodash_fp_inRange___default()(4221,4981,temp),'mid'],[__WEBPACK_IMPORTED_MODULE_1_lodash_fp_inRange___default()(4981,5741,temp),'cool'],[__WEBPACK_IMPORTED_MODULE_1_lodash_fp_inRange___default()(5741,6536,temp),'coolest']]);return tempMessageMap.get(true)||'warmest';};var makeFlipperMessage=function makeFlipperMessage(message){return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* FlipperMessage */],null,message);};var RGBFlipper=function(_React$Component){_inherits(RGBFlipper,_React$Component);function RGBFlipper(props){_classCallCheck(this,RGBFlipper);var _this=_possibleConstructorReturn(this,(RGBFlipper.__proto__||Object.getPrototypeOf(RGBFlipper)).call(this,props));_this.state={};if(props.rgb){_this.state={rgb:props.rgb};}return _this;}_createClass(RGBFlipper,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!__WEBPACK_IMPORTED_MODULE_2_lodash_fp_equals___default()(nextProps.rgb,this.props.rgb)||nextProps.isOn!==this.props.isOn||nextProps.isCustomRange!==this.props.isCustomRange){this.setState({rgb:nextProps.rgb});}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,isOn=_props.isOn,isSaving=_props.isSaving,isToggling=_props.isToggling,toggleLightbulb=_props.toggleLightbulb,changeColor=_props.changeColor,bulbBrightness=_props.bulbBrightness,debug=_props.debug,delayRendering=_props.delayRendering,handleRadiusPercent=_props.handleRadiusPercent,image=_props.image,isCustomRange=_props.isCustomRange,logger=_props.logger,colourStartRadians=_props.colourStartRadians,colourStopRadians=_props.colourStopRadians,pickerDepthPercent=_props.pickerDepthPercent,rangeValue=_props.rangeValue,rgb=_props.rgb,minTemperature=_props.minTemperature,maxTemperature=_props.maxTemperature,productId=_props.productId,isSmall=_props.isSmall,isGroup=_props.isGroup;var temperatureIntlKey=getIntlTemperatureKey(rangeValue);return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* RgbFlipper */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__dom_dom_resize__["a" /* default */],null,function(_ref){var width=_ref.width;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["e" /* Picker */],{isOn:isOn},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__color_picker__["a" /* default */],{colourStartRadians:colourStartRadians,colourStopRadians:colourStopRadians,debug:debug,delayRendering:delayRendering,disabled:!isOn,handleRadiusPercent:handleRadiusPercent,image:image,isCustomRange:isCustomRange,logger:logger,maxTemperature:maxTemperature,minTemperature:minTemperature,onValue:function onValue(v){if(v.shouldUpdateServer){changeColor(v);}_this2.setState({rgb:v.rgb});},pickerDepthPercent:pickerDepthPercent,productId:productId,rangeValue:rangeValue,rgb:rgb,width:width}));}),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* FlipperContainer */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10____["a" /* default */],{childKey:isOn?'show':'hide'},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__bounce_effect__["a" /* default */],{isWaiting:isToggling||isSaving},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["i" /* default */],{isActive:isOn,isCustomRange:isCustomRange,isOn:isOn,isSmall:isSmall,isVariableColour:!isCustomRange,onClick:toggleLightbulb,rgb:this.state.rgb,style:{background:isOn&&!isCustomRange&&this.state.rgb?'rgb('+this.state.rgb.toString()+')':'#FFFFFF'},tabIndex:'0'},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* BrightnessFlipperIcon */],{isActive:isOn,isVariableColour:!isCustomRange,type:isGroup?__WEBPACK_IMPORTED_MODULE_8__core_constants_icons_devices_svg__["a" /* default */].LIGHT_DOUBLE:__WEBPACK_IMPORTED_MODULE_8__core_constants_icons_devices_svg__["a" /* default */].LIGHT}),isOn?__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_12__core_i18n_components_widgets_flipper_intl__["a" /* default */].on,{values:{brightness:bulbBrightness&&bulbBrightness.toFixed()}}),makeFlipperMessage):__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__core_i18n_components_widgets_flipper_intl__["a" /* default */].off,makeFlipperMessage),isOn&&isCustomRange&&__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_12__core_i18n_components_widgets_flipper_intl__["a" /* default */][temperatureIntlKey],makeFlipperMessage)))))));}}]);return RGBFlipper;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_router_dom__["f" /* withRouter */])(RGBFlipper));

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

var baseInRange = __webpack_require__(2401),
    toFinite = __webpack_require__(369),
    toNumber = __webpack_require__(268);

/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = toFinite(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = toFinite(end);
  }
  number = toNumber(number);
  return baseInRange(number, start, end);
}

module.exports = inRange;


/***/ }),
/* 2401 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin(start, end) && number < nativeMax(start, end);
}

module.exports = baseInRange;


/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(200);


/***/ }),
/* 2403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RgbFlipper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlipperContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 100%;\n    position: relative;\n    width: 100%;\n'],['\n    height: 100%;\n    position: relative;\n    width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 15.5%;\n    left: 15.5%;\n    z-index: 2;\n    width: 69%;\n    height: 69%;\n    border-radius: 50%;\n'],['\n    position: absolute;\n    top: 15.5%;\n    left: 15.5%;\n    z-index: 2;\n    width: 69%;\n    height: 69%;\n    border-radius: 50%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var RgbFlipper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var FlipperContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);

/***/ }),
/* 2404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(2405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__ = __webpack_require__(14);
var mapStateToProps=function mapStateToProps(state,ownProps){return Object.assign({},ownProps,{maxTemperature:ownProps.maxTemperature||Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'products:bulbs:maxTemperature'),minTemperature:ownProps.minTemperature||Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'products:bulbs:minTemperature')});};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]));

/***/ }),
/* 2405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_isEqual__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_last__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_math_trig__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__canvas_helpers__ = __webpack_require__(2406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_utils_colour__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_disabled_picker_png__ = __webpack_require__(2409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_images_disabled_picker_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_images_disabled_picker_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__find_closest_match__ = __webpack_require__(2410);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DebugPanel=void 0;if(false){DebugPanel=require('./debug').default;}var valueInRange=function valueInRange(oldMin,oldMax,newMin,newMax,value){var oldRange=oldMax-oldMin;var newRange=newMax-newMin;return(value-oldMin)*newRange/oldRange+newMin;};var handleStyles={fillStyle:'white'};var ColorPicker=function(_React$Component){_inherits(ColorPicker,_React$Component);function ColorPicker(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ColorPicker);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ColorPicker.__proto__||Object.getPrototypeOf(ColorPicker)).call.apply(_ref,[this].concat(args))),_this),_this.state={closest:{distance:Infinity},containerRect:undefined,context:undefined,inUse:false,image:new Image(),imageLoadTimeoutId:null,items:null,offsetX:undefined,offsetY:undefined},_this.imageLoadHandler=function(img,rgb,rangeValue,isCustomRange,disabled){var _this2=_this,canvas=_this2.canvas,container=_this2.container;if(!container||!canvas){return;}var canvasComputedStyles=window.getComputedStyle(container,null);var width=parseFloat(canvasComputedStyles.width);var height=parseFloat(canvasComputedStyles.height);canvas.width=width;canvas.height=height;_this.canvas=canvas;_this.setState({context:canvas.getContext('2d'),containerRect:container.getBoundingClientRect(),image:img});if(disabled){_this.draw(Math.PI/2);}else{_this.draw(Math.PI);if(isCustomRange){_this.positionHandleToRangeValue(rangeValue);}else{_this.positionHandleToRGB(rgb);}}},_this.positionHandleToRangeValue=function(value){var _this$props=_this.props,maxTemperature=_this$props.maxTemperature,minTemperature=_this$props.minTemperature,colourStartRadians=_this$props.colourStartRadians,colourStopRadians=_this$props.colourStopRadians;var currentColourTemperature=value||minTemperature;var circle=Math.PI*2;var offset=circle-colourStopRadians;var radians=valueInRange(minTemperature,maxTemperature,0,colourStartRadians+offset,currentColourTemperature)-offset;var result=_this.draw(radians);if(!result||!result.rad||!result.rgb){return;}_this.save(result.rad,result.rgb,value,false);},_this.positionHandleToRGB=function(targetColor){if(!_this.container||!_this.canvas){return;}var _targetColor=_slicedToArray(targetColor,3),r=_targetColor[0],g=_targetColor[1],b=_targetColor[2];var _this3=_this,canvas=_this3.canvas,container=_this3.container,props=_this3.props,save=_this3.save,draw=_this3.draw,state=_this3.state;if(isNaN(r+g+b)){var result=draw(Math.PI/2);result&&result.rgb&&save(Math.PI/2,result.rgb);return;}var handleRadiusPercent=props.handleRadiusPercent,pickerDepthPercent=props.pickerDepthPercent;var canvasComputedStyles=window.getComputedStyle(canvas,null);var canvasWidth=parseFloat(canvasComputedStyles.width);var canvasHeight=parseFloat(canvasComputedStyles.height);var containerRect=window.getComputedStyle(container,null);var containerWidth=parseFloat(containerRect.width);var _findClosestMatch=Object(__WEBPACK_IMPORTED_MODULE_8__find_closest_match__["a" /* default */])(targetColor,state.context||canvas.getContext('2d'),canvasWidth,canvasHeight,containerWidth,handleRadiusPercent,pickerDepthPercent),rad=_findClosestMatch.rad,rgb=_findClosestMatch.rgb;if(rad){var _result=_this.draw(rad);_result&&_result.rad&&_this.save(_result.rad,rgb,null,false);}},_this.yieldValue=function(rgb,rad,rangeValue,shouldUpdateServer){var _this$props2=_this.props,onValue=_this$props2.onValue,productId=_this$props2.productId,isCustomRange=_this$props2.isCustomRange;var hsv=Object(__WEBPACK_IMPORTED_MODULE_6__core_utils_colour__["j" /* rgbToHsv */])(rgb);return onValue({shouldUpdateServer:shouldUpdateServer,rgb:rgb,rad:rad,hsv:hsv,valueInRange:rangeValue,productId:productId,isCustomRange:isCustomRange});},_this.drawHandle=function(context,rgb,x,y,radius){var currentColourCSS=Object(__WEBPACK_IMPORTED_MODULE_6__core_utils_colour__["k" /* rgbToRgbString */])(rgb);var handleParts=[Object.assign({},handleStyles,{strokeStyle:'white',x:x,y:y,radius:radius,shadowColor:currentColourCSS,shadowBlur:10,shadowOffsetX:0,shadowOffsetY:0}),{x:x,y:y,radius:radius-1,fillStyle:currentColourCSS}];handleParts.forEach(function(opts){return Object(__WEBPACK_IMPORTED_MODULE_5__canvas_helpers__["a" /* drawCircle */])(context,opts);});},_this.allSearchPoints=[],_this.draw=function(radians){var _this$props3=_this.props,debug=_this$props3.debug,logger=_this$props3.logger,colourStartRadians=_this$props3.colourStartRadians,colourStopRadians=_this$props3.colourStopRadians,handleRadiusPercent=_this$props3.handleRadiusPercent,pickerDepthPercent=_this$props3.pickerDepthPercent,minTemperature=_this$props3.minTemperature,maxTemperature=_this$props3.maxTemperature;debug&&logger&&logger('radians',radians);var canvas=_this.canvas;var _this$state=_this.state,image=_this$state.image,items=_this$state.items,context=_this$state.context;if(!context){return;}var canvasComputedStyles=window.getComputedStyle(canvas,null);var width=parseFloat(canvasComputedStyles.width);var height=parseFloat(canvasComputedStyles.height);var containerRect=window.getComputedStyle(_this.container,null);var containerWidth=parseFloat(containerRect.width);var handleRadius=containerWidth/100*handleRadiusPercent;var pickerDepth=containerWidth/100*pickerDepthPercent;var vectorLength=width/2-handleRadius-pickerDepth/2;var _coordsFromRadians=Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_math_trig__["a" /* coordsFromRadians */])(radians,vectorLength,width,height),x=_coordsFromRadians.x,y=_coordsFromRadians.y;context.clearRect(0,0,width,height);context.drawImage(image,handleRadius,handleRadius,width-handleRadius*2,width-handleRadius*2);var circle=Math.PI*2;var offset=circle-colourStopRadians;var newRadians=radians+offset;if(newRadians>circle){newRadians=newRadians-circle;}var valueInAssignedRange=Math.round(valueInRange(0,colourStartRadians+offset,minTemperature,maxTemperature,newRadians));if(debug){_this.allSearchPoints.push([x,y]);_this.allSearchPoints.forEach(function(_ref2){var _ref3=_slicedToArray(_ref2,2),x=_ref3[0],y=_ref3[1];context.beginPath();context.arc(x,y,1,0,2*Math.PI);context.stroke();});}var rgb=context.getImageData(x,y,1,1).data.slice(0,3);var isInvalidArea=radians>colourStartRadians&&radians<colourStopRadians;var nextValue=isInvalidArea?Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lodash_fp_last___default()(items)):{rgb:rgb,rad:radians,valueInAssignedRange:valueInAssignedRange};var _coordsFromRadians2=Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_math_trig__["a" /* coordsFromRadians */])(nextValue.rad,vectorLength,width,height),nextX=_coordsFromRadians2.x,nextY=_coordsFromRadians2.y;_this.drawHandle(context,nextValue.rgb,nextX,nextY,handleRadius);debug&&Object(__WEBPACK_IMPORTED_MODULE_5__canvas_helpers__["b" /* drawLine */])(context,{x:width/2,y:height/2},{x:x,y:y});var newItem={rgb:nextValue.rgb,rad:nextValue.rad,valueInAssignedRange:valueInAssignedRange};if(_this.state.items){_this.setState({items:[].concat(_toConsumableArray(_this.state.items.slice(0,5)),[newItem])});}else{_this.setState({items:[newItem]});}return nextValue;},_this.save=function(rad,rgb,valueInAssignedRange){var shouldUpdateServer=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;_this.yieldValue(rgb,rad,valueInAssignedRange,shouldUpdateServer);var _rgbToHsv=Object(__WEBPACK_IMPORTED_MODULE_6__core_utils_colour__["j" /* rgbToHsv */])(rgb),h=_rgbToHsv.h,s=_rgbToHsv.s,v=_rgbToHsv.v;var newItem={rgb:rgb,rad:rad,valueInAssignedRange:valueInAssignedRange,hsv:'hsv('+h+', '+s+', '+v+')'};if(_this.state.items){_this.setState({items:[].concat(_toConsumableArray(_this.state.items.slice(0,5)),[newItem])});}else{_this.setState({items:[newItem]});}},_this.touch=function(e){e.preventDefault();_this.clicked(e);},_this.clicked=function(e){var _this$props4=_this.props,disabled=_this$props4.disabled,debug=_this$props4.debug,logger=_this$props4.logger;if(disabled){return;}var offsetX=e.nativeEvent.offsetX&&e.nativeEvent.offsetX;var offsetY=e.nativeEvent.offsetY&&e.nativeEvent.offsetY;var which=e.nativeEvent.which&&e.nativeEvent.which;var buttons=e.nativeEvent.buttons&&e.nativeEvent.buttons;if(e.type==='mousemove'&&(which!==1||buttons!==1)){return;}_this.setState({inUse:true});var canvasComputedStyles=window.getComputedStyle(_this.canvas,null);var width=parseFloat(canvasComputedStyles.width);var height=parseFloat(canvasComputedStyles.height);if(_this.container&&(e.type==='touchmove'||e.type==='touchstart')&&e.targetTouches){var _containerRect=_this.container.getBoundingClientRect();var lastTouch=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_last___default()(e.targetTouches);offsetX=lastTouch.clientX-_containerRect.left;offsetY=lastTouch.clientY-_containerRect.top;}_this.setState({offsetX:offsetX,offsetY:offsetY});var radians=Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_math_trig__["b" /* radFromCoords */])(offsetX,offsetY,width,height);var result=_this.draw(radians);result&&result.rad&&result.rgb&&result.valueInAssignedRange&&_this.save(result.rad,result.rgb,result.valueInAssignedRange);debug&&logger&&result&&result.rgb&&logger('%c imgData: '+Object(__WEBPACK_IMPORTED_MODULE_6__core_utils_colour__["k" /* rgbToRgbString */])(result.rgb),'color: '+Object(__WEBPACK_IMPORTED_MODULE_6__core_utils_colour__["k" /* rgbToRgbString */])(result.rgb));},_this.keyDown=function(e){var _this$props5=_this.props,debug=_this$props5.debug,logger=_this$props5.logger,disabled=_this$props5.disabled;if(disabled){return;}var items=_this.state.items;var fullCircle=Math.PI*2;var keyMap={'39':-0.1,'37':0.1};var lastData=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_last___default()(items);// $FlowFixMe
var increment=e.nativeEvent.keyCode&&keyMap[e.nativeEvent.keyCode];if(!increment){return;}var radians=lastData.rad+increment;radians=radians<0?fullCircle-Math.abs(radians):radians;radians=radians+increment>fullCircle?0:radians;var result=_this.draw(radians);if(!result){return;}_this.save(result.rad,result.rgb);if(debug&&logger&&result&&result.rgb){logger('%c imgData: '+result.rgb.toString(),'color: '+result.rgb.toString());}},_this.mouseUpHandler=function(){_this.setState({inUse:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ColorPicker,[{key:'componentDidMount',value:function componentDidMount(){var _this4=this;var _props=this.props,image=_props.image,rgb=_props.rgb,minTemperature=_props.minTemperature,_props$rangeValue=_props.rangeValue,rangeValue=_props$rangeValue===undefined?minTemperature:_props$rangeValue,isCustomRange=_props.isCustomRange,disabled=_props.disabled,_props$delayRendering=_props.delayRendering,delayRendering=_props$delayRendering===undefined?0:_props$delayRendering;var img=new Image();img.src=disabled?__WEBPACK_IMPORTED_MODULE_7__assets_images_disabled_picker_png___default.a:image;img.onload=function(){var loadHandler=function loadHandler(){return _this4.imageLoadHandler(img,rgb,rangeValue,isCustomRange,disabled);};var timeoutId=setTimeout(loadHandler,delayRendering);_this4.setState({imageLoadTimeoutId:timeoutId});};}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref4){var _this5=this;var newImage=_ref4.image,rgb=_ref4.rgb,minTemperature=_ref4.minTemperature,rangeValue=_ref4.rangeValue,isCustomRange=_ref4.isCustomRange,disabled=_ref4.disabled,width=_ref4.width;if(!this.state.context){return;}var nextRangeValue=rangeValue||minTemperature;var _props2=this.props,prevImage=_props2.image,prevDisabled=_props2.disabled,prevIsCustomRange=_props2.isCustomRange,previousWidth=_props2.width,prevRgb=_props2.rgb;newImage=disabled?__WEBPACK_IMPORTED_MODULE_7__assets_images_disabled_picker_png___default.a:newImage;var propsChanged=width!==previousWidth||isCustomRange!==prevIsCustomRange||newImage!==prevImage||disabled!==prevDisabled||!__WEBPACK_IMPORTED_MODULE_0_lodash_fp_isEqual___default()(rgb,prevRgb);if(propsChanged){var _imageLoadTimeoutId=this.state.imageLoadTimeoutId;if(_imageLoadTimeoutId){clearTimeout(_imageLoadTimeoutId);}var img=new Image();img.src=newImage;img.onload=function(){var timeoutId=_this5.imageLoadHandler(img,rgb,nextRangeValue,isCustomRange,disabled);_this5.setState({imageLoadTimeoutId:timeoutId});};}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var imageLoadTimeoutId=this.state.imageLoadTimeoutId;if(!imageLoadTimeoutId)return;clearTimeout(imageLoadTimeoutId);}},{key:'render',value:function render(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{ref:function ref(c){return _this6.container=c;},style:{width:'100%',height:'100%',position:'relative'}},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('canvas',{onMouseDown:this.clicked,onMouseMove:this.clicked,onMouseUp:this.mouseUpHandler,onTouchEnd:this.mouseUpHandler,onTouchMove:this.touch,onTouchStart:this.touch,ref:function ref(c){return _this6.canvas=c;},style:{zIndex:this.state.inUse?10:1,outline:'none',position:'relative',WebkitTapHighlightColor:'transparent'},tabIndex:'0'}),this.props.debug&&DebugPanel&&__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](DebugPanel,{state:this.state}));}}]);return ColorPicker;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ColorPicker);

/***/ }),
/* 2406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = drawLine;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return drawCircle; });
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
function drawLine(context,from,to){var lineWidth=arguments.length>3&&arguments[3]!==undefined?arguments[3]:1;var strokeStyle=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'#000000';context.beginPath();context.lineWidth=lineWidth;context.strokeStyle=strokeStyle;context.moveTo(from.x,from.y);context.lineTo(to.x,to.y);context.stroke();context.closePath();return context;}var drawCircle=function drawCircle(context,properties){var x=properties.x,y=properties.y,radius=properties.radius,rest=_objectWithoutProperties(properties,['x','y','radius']);context.beginPath();context.arc(x,y,radius,0,Math.PI*2);for(var prop in rest){if({}.hasOwnProperty.call(rest,prop)){context[prop]=rest[prop];}}context.fill();context.stroke();context.closePath();for(var _prop in rest){if({}.hasOwnProperty.call(rest,_prop)){context[_prop]=null;}}return context;};

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('spread', __webpack_require__(2408));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(278),
    arrayPush = __webpack_require__(230),
    baseRest = __webpack_require__(183),
    castSlice = __webpack_require__(691),
    toInteger = __webpack_require__(107);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that invokes `func` with the `this` binding of the
 * create function and an array of arguments much like
 * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
 *
 * **Note:** This method is based on the
 * [spread operator](https://mdn.io/spread_operator).
 *
 * @static
 * @memberOf _
 * @since 3.2.0
 * @category Function
 * @param {Function} func The function to spread arguments over.
 * @param {number} [start=0] The start position of the spread.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.spread(function(who, what) {
 *   return who + ' says ' + what;
 * });
 *
 * say(['fred', 'hello']);
 * // => 'fred says hello'
 *
 * var numbers = Promise.all([
 *   Promise.resolve(40),
 *   Promise.resolve(36)
 * ]);
 *
 * numbers.then(_.spread(function(x, y) {
 *   return x + y;
 * }));
 * // => a Promise of 76
 */
function spread(func, start) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  start = start == null ? 0 : nativeMax(toInteger(start), 0);
  return baseRest(function(args) {
    var array = args[start],
        otherArgs = castSlice(args, 0, start);

    if (array) {
      arrayPush(otherArgs, array);
    }
    return apply(func, this, otherArgs);
  });
}

module.exports = spread;


/***/ }),
/* 2409 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_isEqual__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_from_rad__ = __webpack_require__(2411);
function rgb2Lab(rgb){var r=rgb[0]/255,g=rgb[1]/255,b=rgb[2]/255,x=void 0,y=void 0,z=void 0;r=r>0.04045?Math.pow((r+0.055)/1.055,2.4):r/12.92;g=g>0.04045?Math.pow((g+0.055)/1.055,2.4):g/12.92;b=b>0.04045?Math.pow((b+0.055)/1.055,2.4):b/12.92;x=(r*0.4124+g*0.3576+b*0.1805)/0.95047;y=(r*0.2126+g*0.7152+b*0.0722)/1.0;z=(r*0.0193+g*0.1192+b*0.9505)/1.08883;x=x>0.008856?Math.pow(x,1/3):7.787*x+16/116;y=y>0.008856?Math.pow(y,1/3):7.787*y+16/116;z=z>0.008856?Math.pow(z,1/3):7.787*z+16/116;return{L:116*y-16,A:500*(x-y),B:200*(y-z)};}var square=function square(base){return Math.pow(base,2);};function deltaE76(x,y){return Math.sqrt(square(y.L-x.L)+square(y.A-x.A)+square(y.B-x.B));}var calculateDistance=function calculateDistance(rgb1,rgb2){return deltaE76(rgb2Lab(rgb1),rgb2Lab(rgb2));};var circle=Math.PI*2;var increment=0.01;var _findClosestMatch=function _findClosestMatch(targetColor,context,canvasWidth,canvasHeight,containerWidth,handleRadiusPercent,pickerDepthPercent){var rad=arguments.length>7&&arguments[7]!==undefined?arguments[7]:0;var closestMatch=arguments.length>8&&arguments[8]!==undefined?arguments[8]:{distance:Infinity};if(rad>=circle){return closestMatch;}var rgb=Object(__WEBPACK_IMPORTED_MODULE_1__color_from_rad__["a" /* default */])(rad,context,canvasWidth,canvasHeight,containerWidth,handleRadiusPercent,pickerDepthPercent);if(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_isEqual___default()(rgb,targetColor)){return{distance:0,rad:rad,rgb:rgb};}var distance=calculateDistance(targetColor.slice(0,3),rgb.slice(0,3));return _findClosestMatch(targetColor,context,canvasWidth,canvasHeight,containerWidth,handleRadiusPercent,pickerDepthPercent,rad+increment,distance<closestMatch.distance?{distance:distance,rad:rad,rgb:rgb}:closestMatch);};// This function finds radians of the closest matching colour on the color-picker
var findClosestMatch=_findClosestMatch;/* harmony default export */ __webpack_exports__["a"] = (findClosestMatch);

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_math_trig__ = __webpack_require__(813);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/* harmony default export */ __webpack_exports__["a"] = (function(radians,context,canvasWidth,canvasHeight,containerWidth,handleRadiusPercent,pickerDepthPercent){var handleRadius=containerWidth/100*handleRadiusPercent;var pickerDepth=containerWidth/100*pickerDepthPercent;var vectorLength=canvasWidth/2-handleRadius-pickerDepth/2;var _coordsFromRadians=Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_math_trig__["a" /* coordsFromRadians */])(radians,vectorLength,canvasWidth,canvasHeight),x=_coordsFromRadians.x,y=_coordsFromRadians.y;var _context$getImageData=_slicedToArray(context.getImageData(x,y,2,2).data,3),r=_context$getImageData[0],g=_context$getImageData[1],b=_context$getImageData[2];return Uint8ClampedArray.from([r,g,b]);});

/***/ }),
/* 2412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bounce_effect__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hit_circle__ = __webpack_require__(2413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_constants_icons_devices_svg__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_i18n_components_widgets_flipper_intl__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_velocity_react__);
// $FlowFixMe
var BrightnessFlipper=function BrightnessFlipper(_ref){var isGroup=_ref.isGroup,items=_ref.items,value=_ref.value,valueChanged=_ref.valueChanged,isOn=_ref.isOn,isSaving=_ref.isSaving,isToggling=_ref.isToggling,toggleLightbulb=_ref.toggleLightbulb,rgb=_ref.rgb,isVariableColour=_ref.isVariableColour,isSmall=_ref.isSmall;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* BrightnessFlipperWrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_velocity_react__["VelocityComponent"],{animation:{zIndex:2},delay:400,runOnMount:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('svg',{version:'1.1',xmlns:'http://www.w3.org/2000/svg'},items.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__hit_circle__["a" /* default */],{delay:i*30+300,disabled:!isOn||isToggling,isVariableColour:isVariableColour,items:items,key:item.get('value'),onClick:function onClick(){return valueChanged(item.get('value'));},purpose:item.get('value'),rgb:rgb,rScale:item.get('rScale'),selectedValue:value,value:item.get('value'),xFactor:item.get('xFactor'),yFactor:item.get('yFactor')});}))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* BrightnessFlipperContent */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6____["a" /* default */],{childKey:isOn?'show':'hide'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__bounce_effect__["a" /* default */],{isWaiting:isToggling||isSaving},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["i" /* default */],{isActive:isOn,isSmall:isSmall,isVariableColour:isVariableColour,onClick:toggleLightbulb,rgb:rgb,style:{background:rgb&&isVariableColour&&isOn?'rgb('+rgb.toString()+')':'#FFFFFF'}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* BrightnessFlipperIcon */],{isActive:isOn,isVariableColour:isVariableColour,type:isGroup?__WEBPACK_IMPORTED_MODULE_5__core_constants_icons_devices_svg__["a" /* default */].LIGHT_DOUBLE:__WEBPACK_IMPORTED_MODULE_5__core_constants_icons_devices_svg__["a" /* default */].LIGHT}),isOn?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_intl__["c" /* FormattedMessage */],Object.assign({},__WEBPACK_IMPORTED_MODULE_8__core_i18n_components_widgets_flipper_intl__["a" /* default */].on,{values:{brightness:value}}),function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* FlipperMessage */],null,message);}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_8__core_i18n_components_widgets_flipper_intl__["a" /* default */].off,function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* FlipperMessage */],null,message);})))))));};/* harmony default export */ __webpack_exports__["a"] = (BrightnessFlipper);

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_ceil__ = __webpack_require__(2414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_ceil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_ceil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_velocity_react__);
var _templateObject=_taggedTemplateLiteral(['\n    fill: ',';\n'],['\n    fill: ',';\n']),_templateObject2=_taggedTemplateLiteral(['pointer-events: fill;'],['pointer-events: fill;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Circle=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].circle(_templateObject,function(props){return props.isActive?props.isVariableColour?'rgb('+props.rgb.toString()+')':props.theme.mainBrandColor:props.theme.offlineGrey;});var HitCircle=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].circle(_templateObject2);var startAnimationRadiusCirclePosition=30;var bigRadiusCirclePosition=43;var offsetX=50;var offsetY=50;var maxCircleRadius=4;var minCircleRadius=1;var CircleWithHitArea=function CircleWithHitArea(_ref){var items=_ref.items,delay=_ref.delay,onClick=_ref.onClick,rScale=_ref.rScale,selectedValue=_ref.selectedValue,value=_ref.value,xFactor=_ref.xFactor,yFactor=_ref.yFactor,disabled=_ref.disabled,rgb=_ref.rgb,isVariableColour=_ref.isVariableColour,purpose=_ref.purpose;var initialCx=xFactor*startAnimationRadiusCirclePosition+offsetX+'%';var initialCy=yFactor*startAnimationRadiusCirclePosition+offsetY+'%';var finalCx=xFactor*bigRadiusCirclePosition+offsetX+'%';var finalCy=yFactor*bigRadiusCirclePosition+offsetY+'%';var r=minCircleRadius+(maxCircleRadius-minCircleRadius)*rScale+'%';// $FlowFixMe
var minDotValue=items.first().get('value');var dotValue=selectedValue&&selectedValue<8?minDotValue:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_ceil___default()(selectedValue,-1);return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('g',{'aria-label':purpose},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_velocity_react__["VelocityComponent"],{animation:{opacity:1,cx:finalCx,cy:finalCy},delay:delay,duration:400,easing:'ease-in-out',runOnMount:true},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Circle,{cx:initialCx,cy:initialCy,isActive:!disabled&&value<=dotValue,isVariableColour:isVariableColour,r:r,rgb:rgb})),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](HitCircle,{cx:finalCx,cy:finalCy,fillOpacity:'0',onClick:onClick,r:maxCircleRadius+'%'}));};/* harmony default export */ __webpack_exports__["a"] = (CircleWithHitArea);

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(10),
    func = convert('ceil', __webpack_require__(2415));

func.placeholder = __webpack_require__(9);
module.exports = func;


/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__(2416);

/**
 * Computes `number` rounded up to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round up.
 * @param {number} [precision=0] The precision to round up to.
 * @returns {number} Returns the rounded up number.
 * @example
 *
 * _.ceil(4.006);
 * // => 5
 *
 * _.ceil(6.004, 2);
 * // => 6.01
 *
 * _.ceil(6040, -2);
 * // => 6100
 */
var ceil = createRound('ceil');

module.exports = ceil;


/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(107),
    toNumber = __webpack_require__(268),
    toString = __webpack_require__(190);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interlace_items__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(149);
var DimmerMenu=function DimmerMenu(_ref){var onClick=_ref.onClick,temperaturePickerActive=_ref.temperaturePickerActive,isOn=_ref.isOn,isSmall=_ref.isSmall,_ref$additionalItems=_ref.additionalItems,additionalItems=_ref$additionalItems===undefined?[]:_ref$additionalItems;var switchMessage=temperaturePickerActive?__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__["a" /* default */].pickerTuneable:__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__["a" /* default */].pickerColor;var defaultItems=[__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["d" /* MenuItem */],{enabled:isOn,key:'previous-picker',onClick:isOn&&onClick},temperaturePickerActive?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["c" /* MenuIcon */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].CIRCLE_OUTLINE}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["c" /* MenuIcon */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].COLOR_PICKER}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],switchMessage,function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* StyledSpan */],null,message);}))];return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* Menu */],{isSmall:isSmall},Object(__WEBPACK_IMPORTED_MODULE_5__interlace_items__["a" /* default */])(defaultItems,additionalItems));};/* harmony default export */ __webpack_exports__["a"] = (DimmerMenu);

/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interlace_items__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(149);
var PickerMenu=function PickerMenu(_ref){var _ref$additionalItems=_ref.additionalItems,additionalItems=_ref$additionalItems===undefined?[]:_ref$additionalItems,isOn=_ref.isOn,isSmall=_ref.isSmall,isTuneable=_ref.isTuneable,canChangeToWhite=_ref.canChangeToWhite,switchPicker=_ref.switchPicker,temperaturePickerActive=_ref.temperaturePickerActive,toggleDimmer=_ref.toggleDimmer,toggleWhite=_ref.toggleWhite;var switchMessage=temperaturePickerActive?__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__["a" /* default */].pickerColor:__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__["a" /* default */].pickerTuneable;var colorPickerItems=isTuneable?[__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["d" /* MenuItem */],{enabled:isOn,key:'color-picker',onClick:isOn&&switchPicker},temperaturePickerActive?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["c" /* MenuIcon */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].COLOR_PICKER}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["c" /* MenuIcon */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].CIRCLE_OUTLINE}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],switchMessage,function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* StyledSpan */],null,message);}))]:[];var whiteItems=canChangeToWhite?[__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["d" /* MenuItem */],{enabled:isOn,key:'white',onClick:isOn&&toggleWhite},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["c" /* MenuIcon */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].TONE}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__["a" /* default */].pickerWhite,function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* StyledSpan */],null,message);}))]:[];var defaultItems=colorPickerItems.concat(whiteItems).concat(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["d" /* MenuItem */],{enabled:isOn,key:'dimmer',onClick:isOn&&toggleDimmer},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["c" /* MenuIcon */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].DIMMER}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__["a" /* default */].pickerDimmer,function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* StyledSpan */],null,message);})));return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* Menu */],{isSmall:isSmall},Object(__WEBPACK_IMPORTED_MODULE_5__interlace_items__["a" /* default */])(defaultItems,additionalItems));};/* harmony default export */ __webpack_exports__["a"] = (PickerMenu);

/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({off:{id:'schedule.color-tuneable-light.off',defaultMessage:'Off',description:'Schedule Color Tuneable Light `Off` label, it has to be short so use abreaviations if too long'}}));

/***/ }),
/* 2420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 80%;\n    margin: 0 10%;\n    width: 80%;\n'],['\n    height: 80%;\n    margin: 0 10%;\n    width: 80%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PickerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPicker", function() { return hasPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPicker", function() { return getPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bulbs_color_tuneable__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(2422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(2423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_themes_main__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_utils_colour__ = __webpack_require__(90);
// @noflow
var maxSaturation=99;var offWhiteRGB='#fff6b9';var getValueColor=function getValueColor(_ref){var config=_ref.config,value=_ref.value;var offWhiteHue=config.getIn(['products','bulbs','offWhiteHue']);var offWhiteSaturation=config.getIn(['products','bulbs','offWhiteSaturation']);if(value.get('status')==='OFF'){return __WEBPACK_IMPORTED_MODULE_7__core_themes_main__["a" /* default */].mediumGrey;}var h=value.get('hue');var s=value.get('saturation');if(value.get('brightness')||h===offWhiteHue&&s===offWhiteSaturation){return offWhiteRGB;}return Object(__WEBPACK_IMPORTED_MODULE_8__core_utils_colour__["i" /* hsvToRgbString */])({h:h,s:s,v:100});};var getValueLabel=function getValueLabel(_ref2){var formatMessage=_ref2.formatMessage,value=_ref2.value;if(value.get('status')==='OFF'){return formatMessage(__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].off);}return(value.get('brightness')||value.get('value'))+'%';};var hasPicker=function hasPicker(){return true;};var getPicker=function getPicker(_ref3){var config=_ref3.config,value=_ref3.value,updateValue=_ref3.updateValue;var defaultBrightness=config.getIn(['products','colourtuneablelight','defaultBrightness']);var defaultHue=config.getIn(['products','colourtuneablelight','defaultHue']);var defaultSaturation=config.getIn(['products','colourtuneablelight','defaultSaturation']);var defaultsForBulbs=config.getIn(['products','bulbs']);var isOn=value.get('status')==='ON';var colourMode=value.get('colourMode',__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].colour);var isWhite=colourMode===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white;var brightness=value.get(isWhite?'brightness':'value',defaultBrightness);var hue=value.get('hue',defaultHue);var saturation=value.get('saturation',defaultSaturation);var hsv={h:hue,s:value.get('saturation',saturation),v:100};var _hsvToRgb=Object(__WEBPACK_IMPORTED_MODULE_8__core_utils_colour__["h" /* hsvToRgb */])(hsv),red=_hsvToRgb.red,green=_hsvToRgb.green,blue=_hsvToRgb.blue;var rgb=[red,green,blue];var brightnessChanged=function brightnessChanged(newValue){return updateValue(value.set(isWhite?'brightness':'value',newValue));};var toggleLightbulb=function toggleLightbulb(){return isOn?updateValue(value.clear().set('status','OFF')):updateValue(Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])({status:'ON',value:brightness,hue:hue,saturation:saturation,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].colour}));};var changeMode=function changeMode(_ref4){var mode=_ref4.mode;return mode===__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white?updateValue(Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])({status:'ON',brightness:brightness,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white})):updateValue(Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])({status:'ON',value:brightness,hue:hue,saturation:saturation,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].colour}));};var colourChanged=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default()(1000,function(_ref5){var hsv=_ref5.hsv,valueInRange=_ref5.valueInRange;return updateValue(value.withMutations(function(value){return value.set('hue',hsv.h).set('saturation',Math.min(hsv.s,maxSaturation));}));});return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__style__["a" /* PickerContainer */],null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__bulbs_color_tuneable__["a" /* default */],{bulbBrightness:brightness,bulbColorMode:colourMode,bulbType:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,canChangeToWhite:true,changeColor:colourChanged,changeColorMode:changeMode,defaultsForBulbs:defaultsForBulbs,delayRendering:500,handleRadiusPercent:5,isOn:isOn,isSmall:true,isTuneable:false,maxRad:3.9,pickerDepthPercent:5,rgb:rgb,toggleLightbulb:toggleLightbulb,valueChanged:brightnessChanged}));};var defaultEventValue={status:'OFF'};var getDefaultSchedule=function getDefaultSchedule(){return{monday:[{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],tuesday:[{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],wednesday:[{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],thursday:[{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],friday:[{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],saturday:[{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}],sunday:[{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourMode:__WEBPACK_IMPORTED_MODULE_1__core_constants_devices__["bulbModes"].white},start:960},{value:{status:'OFF'},start:1290}]};};

/***/ }),
/* 2422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({off:{id:'schedule.color-light.off',defaultMessage:'Off',description:'Schedule Color Light `Off` label, it has to be short so use abreaviations if too long'}}));

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 80%;\n    margin: 0 10%;\n    width: 80%;\n'],['\n    height: 80%;\n    margin: 0 10%;\n    width: 80%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PickerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPicker", function() { return hasPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPicker", function() { return getPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_colour__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(28);
// @noflow
var getValueColor=function getValueColor(_ref){var value=_ref.value;return Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_colour__["d" /* getColour */])(value.get('target',5));};var getValueLabel=function getValueLabel(_ref2){var value=_ref2.value,productState=_ref2.productState;var temp=value.get('target',5);var frostProtection=productState.get('frostProtection',7);return frostProtection&&temp===frostProtection?__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* Frost */],{dy:'10'},'N'):__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3____["_6" /* Temperature */],{element:'tspan',value:temp});};var hasPicker=function hasPicker(){return true;};var getPicker=function getPicker(_ref3){var config=_ref3.config,productState=_ref3.productState,value=_ref3.value,updateValue=_ref3.updateValue;var temp=value.get('target',5);var frostValue=productState.get('frostProtection',7);return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* PickerContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3____["_8" /* TemperatureSpinnerFull */],{currentTemp:temp,frostProtectionValue:frostValue,handleChangeTemp:function handleChangeTemp(newTarget){return updateValue(value.set('target',newTarget));},interval:0.5,maxTemp:config.getIn(['products','heating','maxTemp'],32),minTemp:config.getIn(['products','heating','minTemp'],5)}));};var defaultEventValue={target:16};var getDefaultSchedule=function getDefaultSchedule(_ref4){var productProps=_ref4.productProps;if(productProps.get('maxEvents')===4){return{monday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:20},start:990},{value:{target:7},start:1320}],tuesday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:20},start:990},{value:{target:7},start:1320}],wednesday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:20},start:990},{value:{target:7},start:1320}],thursday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:20},start:990},{value:{target:7},start:1320}],friday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:20},start:990},{value:{target:7},start:1320}],saturday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:20},start:990},{value:{target:7},start:1320}],sunday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:20},start:990},{value:{target:7},start:1320}]};}else{return{monday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:7},start:720},{value:{target:7},start:840},{value:{target:20},start:990},{value:{target:7},start:1320}],tuesday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:7},start:720},{value:{target:7},start:840},{value:{target:20},start:990},{value:{target:7},start:1320}],wednesday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:7},start:720},{value:{target:7},start:840},{value:{target:20},start:990},{value:{target:7},start:1320}],thursday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:7},start:720},{value:{target:7},start:840},{value:{target:20},start:990},{value:{target:7},start:1320}],friday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:7},start:720},{value:{target:7},start:840},{value:{target:20},start:990},{value:{target:7},start:1320}],saturday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:7},start:720},{value:{target:7},start:840},{value:{target:20},start:990},{value:{target:7},start:1320}],sunday:[{value:{target:20},start:390},{value:{target:7},start:510},{value:{target:7},start:720},{value:{target:7},start:840},{value:{target:20},start:990},{value:{target:7},start:1320}]};}};

/***/ }),
/* 2425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Frost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PickerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    font-family: HiveGeneralIcons;\n    font-size: 2em;\n'],['\n    font-family: HiveGeneralIcons;\n    font-size: 2em;\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: 80%;\n    margin: 10%;\n    width: 80%;\n'],['\n    height: 80%;\n    margin: 10%;\n    width: 80%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Frost=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].tspan(_templateObject);var PickerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);

/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateValue", function() { return updateValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intl__ = __webpack_require__(2427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_themes_main__ = __webpack_require__(78);
// @noflow
var getValueColor=function getValueColor(_ref){var value=_ref.value;return value.get('status')==='OFF'?__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].mediumGrey:__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].mainBrandColor;};var getValueLabel=function getValueLabel(_ref2){var formatMessage=_ref2.formatMessage,value=_ref2.value;return formatMessage(value.get('status')==='OFF'?__WEBPACK_IMPORTED_MODULE_0__intl__["a" /* default */].off:__WEBPACK_IMPORTED_MODULE_0__intl__["a" /* default */].on);};var updateValue=function updateValue(event){return event.getIn(['value','status'])==='OFF'?event.setIn(['value','status'],'ON'):event.setIn(['value','status'],'OFF');};var defaultEventValue={status:'OFF'};var getDefaultSchedule=function getDefaultSchedule(){return{monday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'OFF'},start:720},{value:{status:'OFF'},start:840},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],tuesday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'OFF'},start:720},{value:{status:'OFF'},start:840},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],wednesday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'OFF'},start:720},{value:{status:'OFF'},start:840},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],thursday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'OFF'},start:720},{value:{status:'OFF'},start:840},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],friday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'OFF'},start:720},{value:{status:'OFF'},start:840},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],saturday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'OFF'},start:720},{value:{status:'OFF'},start:840},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}],sunday:[{value:{status:'ON'},start:390},{value:{status:'OFF'},start:510},{value:{status:'OFF'},start:720},{value:{status:'OFF'},start:840},{value:{status:'ON'},start:960},{value:{status:'OFF'},start:1290}]};};

/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({off:{id:'schedule.hotwater.off',defaultMessage:'Off',description:'Schedule hot water `Off` label, it has to be short so use abreaviations if too long'},on:{id:'schedule.hotwater.on',defaultMessage:'On',description:'Schedule hot water `On` label, it has to be short so use abreaviations if too long'}}));

/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPicker", function() { return hasPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPicker", function() { return getPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__temperature_spinner_dual_color_range__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__temperature__ = __webpack_require__(255);
// @noflow
var getValueColor=function getValueColor(_ref){var value=_ref.value;return value.get('cool')>26?'rgb(66, 168, 118)':'rgb(69, 180, 255)';};var getValueLabel=function getValueLabel(_ref2){var value=_ref2.value;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__temperature__["a" /* default */],{element:'tspan',value:value.get('cool')});};var hasPicker=function hasPicker(){return true;};var getPicker=function getPicker(_ref3){var config=_ref3.config,productProps=_ref3.productProps,value=_ref3.value,updateValue=_ref3.updateValue;var minCool=productProps.get('minCool')||config.getIn(['products','cooling','minTemp']);var maxCool=productProps.get('maxCool')||config.getIn(['products','cooling','maxTemp']);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* PickerContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__temperature_spinner_dual_color_range__["a" /* default */],{controlMode:'COOL',currentTemp:value.get('cool'),handleChangeTemp:function handleChangeTemp(newCoolValue){return updateValue(value.set('cool',newCoolValue));},maxCool:maxCool,minCool:minCool}));};var defaultEventValue={cool:25.5};var defaultDaySchedule=[{value:{cool:25.5},start:360},{value:{cool:29.5},start:480},{value:{cool:29.5},start:720},{value:{cool:29.5},start:840},{value:{cool:25.5},start:1080},{value:{cool:28},start:1320}];var getDefaultSchedule=function getDefaultSchedule(){return{monday:defaultDaySchedule,tuesday:defaultDaySchedule,wednesday:defaultDaySchedule,thursday:defaultDaySchedule,friday:defaultDaySchedule,saturday:defaultDaySchedule,sunday:defaultDaySchedule};};

/***/ }),
/* 2429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 80%;\n    margin: 10%;\n    width: 80%;\n\n    & > div > div {\n        transform: scale(1.5) translate(0, 25%);\n    }\n'],['\n    height: 80%;\n    margin: 10%;\n    width: 80%;\n\n    & > div > div {\n        transform: scale(1.5) translate(0, 25%);\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PickerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_FONT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defineRangeValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defineRangeColours; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getIndexFromTemp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTempFromIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_last__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last__);
// @noflow
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DEFAULT_FONT='Bariol, Arial, sans-serif';var getColour=function getColour(_ref){var aboveColor=_ref.aboveColor,belowColor=_ref.belowColor,midTemp=_ref.midTemp;return function(temperature){return temperature<=midTemp?belowColor:aboveColor;};};var formatTemperatureToObj=function formatTemperatureToObj(temperature,frostProtectionValue){return temperature.toString().split('.').reduce(function(agg,val){if(frostProtectionValue&&parseInt(val,10)===frostProtectionValue){return[{text:''+val,coef:1},{text:'N',coef:0.7,font:'HiveGeneralIcons'}];}else if(agg.length){var prev=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default()(agg);return[{text:prev.text.slice(0,-1),coef:prev.coef},{text:'.'+val+'\xB0',coef:0.5}];}else{return[{text:val+'\xB0',coef:1}];}},[]);};var defineRangeAndFormat=function defineRangeAndFormat(_ref2){var interval=_ref2.interval,maxTemp=_ref2.maxTemp,minTemp=_ref2.minTemp,formatFn=_ref2.formatFn,_ref2$frostProtection=_ref2.frostProtectionValue,frostProtectionValue=_ref2$frostProtection===undefined?null:_ref2$frostProtection;var total=(maxTemp-minTemp)/interval+1;return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,total).reduce(function(agg,_,index){var temperature=maxTemp-index*interval;var value=formatFn(temperature,frostProtectionValue);return[].concat(_toConsumableArray(agg),[value]);},[]);};var defineRangeValues=function defineRangeValues(_ref3){var interval=_ref3.interval,frostProtectionValue=_ref3.frostProtectionValue,maxTemp=_ref3.maxTemp,minTemp=_ref3.minTemp;return defineRangeAndFormat({interval:interval,maxTemp:maxTemp,minTemp:minTemp,formatFn:formatTemperatureToObj,frostProtectionValue:frostProtectionValue});};var defineRangeColours=function defineRangeColours(_ref4){var aboveColor=_ref4.aboveColor,belowColor=_ref4.belowColor,interval=_ref4.interval,maxTemp=_ref4.maxTemp,midTemp=_ref4.midTemp,minTemp=_ref4.minTemp;return defineRangeAndFormat({interval:interval,maxTemp:maxTemp,minTemp:minTemp,formatFn:getColour({aboveColor:aboveColor,belowColor:belowColor,midTemp:midTemp})});};var getIndexFromTemp=function getIndexFromTemp(_ref5){var interval=_ref5.interval,maxTemp=_ref5.maxTemp,minTemp=_ref5.minTemp,temp=_ref5.temp;var currentValue=temp?Math.max(Math.min(temp,maxTemp),minTemp):minTemp;return Math.round((maxTemp-currentValue)/interval);};var getTempFromIndex=function getTempFromIndex(_ref6){var maxTemp=_ref6.maxTemp,interval=_ref6.interval,index=_ref6.index;return maxTemp-index*interval;};

/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SpinnerContainerContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_style__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: ',';\n'],['\n    display: flex;\n    flex-direction: ',';\n']),_templateObject2=_taggedTemplateLiteral(['width: 100%;'],['width: 100%;']),_templateObject3=_taggedTemplateLiteral(['\n    display: block;\n    position: relative;\n    width: 65%;\n    margin: 0 auto;\n\n    ',' &:focus {\n        outline: none;\n    }\n'],['\n    display: block;\n    position: relative;\n    width: 65%;\n    margin: 0 auto;\n\n    ',' &:focus {\n        outline: none;\n    }\n']),_templateObject4=_taggedTemplateLiteral(['\n      width: 50%;\n      '],['\n      width: 50%;\n      ']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(props){return props.menuAbove?'column':'row';});var SpinnerContainerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);var SpinnerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,__WEBPACK_IMPORTED_MODULE_1__core_utils_style__["b" /* media */].tablet(_templateObject4));

/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cooling__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__heating__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var DualTemperatureSpinner=function(_React$Component){_inherits(DualTemperatureSpinner,_React$Component);function DualTemperatureSpinner(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DualTemperatureSpinner);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DualTemperatureSpinner.__proto__||Object.getPrototypeOf(DualTemperatureSpinner)).call.apply(_ref,[this].concat(args))),_this),_this.state={coolHovered:false,heatHovered:false},_this.handleCoolHovered=function(state){_this.setState({coolHovered:state});},_this.handleHeatHovered=function(state){_this.setState({heatHovered:state});},_this.coolHoverOver=function(){return _this.handleCoolHovered(true);},_this.coolHoverOut=function(){return _this.handleCoolHovered(false);},_this.coolTouched=function(){_this.handleCoolHovered(true);_this.handleHeatHovered(false);},_this.heatHoverOver=function(){return _this.handleHeatHovered(true);},_this.heatHoverOut=function(){return _this.handleHeatHovered(false);},_this.heatTouched=function(){_this.handleHeatHovered(true);_this.handleCoolHovered(false);},_this.resetState=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default()(1000,function(){_this.handleCoolHovered(false);_this.handleHeatHovered(false);}),_this.handleCoolingChange=function(temp){var _this$props=_this.props,heatTemperature=_this$props.heatTemperature,handleChangeTemp=_this$props.handleChangeTemp,mode=_this$props.mode,minDifference=_this$props.comfortZone;var _mode=_slicedToArray(mode,2),heat=_mode[0],cool=_mode[1];handleChangeTemp(temp,cool);if(heatTemperature>temp-minDifference){handleChangeTemp(temp-minDifference,heat);}},_this.handleHeatingChange=function(temp){var _this$props2=_this.props,coolTemperature=_this$props2.coolTemperature,handleChangeTemp=_this$props2.handleChangeTemp,mode=_this$props2.mode,minDifference=_this$props2.comfortZone;var _mode2=_slicedToArray(mode,2),heat=_mode2[0],cool=_mode2[1];handleChangeTemp(temp,heat);if(coolTemperature<temp+minDifference){handleChangeTemp(temp+minDifference,cool);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DualTemperatureSpinner,[{key:'render',value:function render(){var _props=this.props,coolTemperature=_props.coolTemperature,heatTemperature=_props.heatTemperature,mode=_props.mode,minCool=_props.minCool,maxCool=_props.maxCool,minHeat=_props.minHeat,maxHeat=_props.maxHeat,isUpdating=_props.isUpdating,disabled=_props.disabled;var _mode3=_slicedToArray(mode,2),heat=_mode3[0],cool=_mode3[1];var _state=this.state,coolHovered=_state.coolHovered,heatHovered=_state.heatHovered;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* SpinnerWrapperTop */],{heatHovered:heatHovered,isUpdating:isUpdating,mouseOver:coolHovered,onBlur:this.coolHoverOut,onFocus:this.coolHoverOver,onMouseOut:this.coolHoverOut,onMouseOver:this.coolHoverOver,onTouchEnd:this.resetState,onTouchStart:this.coolTouched},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__cooling__["a" /* default */],{currentTemp:coolTemperature,disabled:disabled,handleChangeTemp:this.handleCoolingChange,isSingleBGColorOnly:true,isUpdating:isUpdating,maxCool:maxCool,minCool:minCool,mode:cool})),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* SpinnerWrapperBottom */],{coolHovered:coolHovered,isUpdating:isUpdating,mouseOver:heatHovered,offsetTop:true,onBlur:this.heatHoverOut,onFocus:this.heatHoverOver,onMouseOut:this.heatHoverOut,onMouseOver:this.heatHoverOver,onTouchEnd:this.resetState,onTouchStart:this.heatTouched},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__heating__["a" /* default */],{currentTemp:heatTemperature,disabled:disabled,handleChangeTemp:this.handleHeatingChange,isDualSpinner:true,isSingleBGColorOnly:true,isUpdating:isUpdating,maxHeat:maxHeat,minHeat:minHeat,mode:heat})));}}]);return DualTemperatureSpinner;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);DualTemperatureSpinner.propTypes={comfortZone:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,coolTemperature:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,handleChangeTemp:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,heatTemperature:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,isUpdating:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,mode:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string).isRequired};/* harmony default export */ __webpack_exports__["a"] = (DualTemperatureSpinner);

/***/ }),
/* 2433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SpinnerWrapperTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerWrapperBottom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    position: relative;\n    transition: transform 0.3s ease-in;\n'],['\n    position: relative;\n    transition: transform 0.3s ease-in;\n']),_templateObject2=_taggedTemplateLiteral(['\n    transform: ',';\n'],['\n    transform: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SpinnerWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var small='scale(0.8)';var medium='scale(0.92)';var SpinnerWrapperTop=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(SpinnerWrapper)(_templateObject2,function(_ref){var mouseOver=_ref.mouseOver,heatHovered=_ref.heatHovered,isUpdating=_ref.isUpdating;return isUpdating?''+medium:mouseOver?'scale(1)':heatHovered?''+small:''+medium;});var SpinnerWrapperBottom=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(SpinnerWrapper)(_templateObject2,function(_ref2){var mouseOver=_ref2.mouseOver,coolHovered=_ref2.coolHovered,isUpdating=_ref2.isUpdating;return isUpdating?''+medium:mouseOver?'scale(1)':coolHovered?''+small:''+medium;});

/***/ }),
/* 2434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_temperature__ = __webpack_require__(272);
var CELSIUS='C';var FARENHEIT='F';var removeDecimalZeroes=function removeDecimalZeroes(num){return num%1===0?Math.floor(num):num;};function Temperature(_ref){var value=_ref.value,unit=_ref.unit,hideSymbol=_ref.hideSymbol,showUnit=_ref.showUnit,_ref$element=_ref.element,element=_ref$element===undefined?'span':_ref$element,_ref$decimalPlaces=_ref.decimalPlaces,decimalPlaces=_ref$decimalPlaces===undefined?1:_ref$decimalPlaces,intl=_ref.intl;var transformTemperatureForDisplay=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default()(intl.formatNumber,removeDecimalZeroes,Number,function(num){return num.toFixed(decimalPlaces);});var displayValue='';if(!isNaN(parseInt(value,10))){var temp=unit===CELSIUS?value:Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_temperature__["b" /* toFarenheit */])(value);displayValue=transformTemperatureForDisplay(temp);}// $FlowFixMe
return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(element,null,[displayValue,!hideSymbol&&'°',showUnit&&unit]);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["g" /* injectIntl */])(Temperature));

/***/ }),
/* 2435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDualColors", function() { return getDualColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPicker", function() { return hasPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPicker", function() { return getPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(2436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__temperature_spinner_dual_color_range__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__temperature__ = __webpack_require__(255);
// @noflow
var getDualColors=function getDualColors(){return{bottomColor:'rgb(231, 97, 54)',topColor:'rgb(69, 180, 255)'};};var getValueLabel=function getValueLabel(_ref){var value=_ref.value;return{bottomValue:__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__temperature__["a" /* default */],{element:'tspan',value:value.get('heat')}),topValue:__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__temperature__["a" /* default */],{element:'tspan',value:value.get('cool')})};};var hasPicker=function hasPicker(){return true;};var updateDebounceValue=500;var getPicker=function getPicker(_ref2){var config=_ref2.config,value=_ref2.value,updateValue=_ref2.updateValue,productState=_ref2.productState,productProps=_ref2.productProps;var localValue=value;var updateValueDebounced=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default()(updateDebounceValue,updateValue);var updateLocalValue=function updateLocalValue(newValue,attribute){if(localValue.get(attribute)!==newValue){localValue=localValue.set(attribute,newValue);}updateValueDebounced(localValue);};var minCool=productProps.get('minCool')||config.getIn(['products','cooling','minTemp']);var maxCool=productProps.get('maxCool')||config.getIn(['products','cooling','maxTemp']);var minHeat=productProps.get('minHeat')||config.getIn(['products','heating','minTemp']);var maxHeat=productProps.get('maxHeat')||config.getIn(['products','heating','maxTemp']);return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["a" /* PickerContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__temperature_spinner_dual_color_range__["a" /* default */],{comfortZone:productState.get('comfortZone'),controlMode:'AUTO',coolTemperature:value.get('cool'),handleChangeTemp:updateLocalValue,heatTemperature:value.get('heat'),maxCool:maxCool,maxHeat:maxHeat,minCool:minCool,minHeat:minHeat}));};var defaultEventValue={cool:25.5,heat:21};var defaultDaySchedule=[{value:{cool:25.5,heat:21},start:360},{value:{cool:29.5,heat:16.5},start:480},{value:{cool:29.5,heat:16.5},start:720},{value:{cool:29.5,heat:16.5},start:840},{value:{cool:25.5,heat:21},start:1080},{value:{cool:28,heat:16.5},start:1320}];var getDefaultSchedule=function getDefaultSchedule(){return{monday:defaultDaySchedule,tuesday:defaultDaySchedule,wednesday:defaultDaySchedule,thursday:defaultDaySchedule,friday:defaultDaySchedule,saturday:defaultDaySchedule,sunday:defaultDaySchedule};};

/***/ }),
/* 2436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerContainer; });
/* unused harmony export HeatLabel */
/* unused harmony export CoolLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__temperature__ = __webpack_require__(255);
var _templateObject=_taggedTemplateLiteral(['\n    height: 100%;\n    width: 100%;\n'],['\n    height: 100%;\n    width: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['fill: rgb(231, 97, 54);'],['fill: rgb(231, 97, 54);']),_templateObject3=_taggedTemplateLiteral(['fill: rgb(69, 180, 271);'],['fill: rgb(69, 180, 271);']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PickerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var HeatLabel=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__temperature__["a" /* default */])(_templateObject2);var CoolLabel=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__temperature__["a" /* default */])(_templateObject3);

/***/ }),
/* 2437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPicker", function() { return hasPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPicker", function() { return getPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__temperature_spinner_dual_color_range__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__temperature__ = __webpack_require__(255);
// @noflow
var getValueColor=function getValueColor(_ref){var value=_ref.value;return value.get('heat')>20.6?'rgb(231, 97, 54)':'rgb(246, 199, 42)';};var getValueLabel=function getValueLabel(_ref2){var value=_ref2.value;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__temperature__["a" /* default */],{element:'tspan',value:value.get('heat')});};var hasPicker=function hasPicker(){return true;};var getPicker=function getPicker(_ref3){var config=_ref3.config,productProps=_ref3.productProps,value=_ref3.value,updateValue=_ref3.updateValue;var minHeat=productProps.get('minHeat')||config.getIn(['products','heating','minTemp']);var maxHeat=productProps.get('maxHeat')||config.getIn(['products','heating','maxTemp']);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* PickerContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__temperature_spinner_dual_color_range__["a" /* default */],{controlMode:'HEAT',currentTemp:value.get('heat'),handleChangeTemp:function handleChangeTemp(newHeatValue){return updateValue(value.set('heat',newHeatValue));},maxHeat:maxHeat,minHeat:minHeat}));};var defaultEventValue={heat:21};var defaultDaySchedule=[{value:{heat:21},start:360},{value:{heat:16.5},start:480},{value:{heat:16.5},start:720},{value:{heat:16.5},start:840},{value:{heat:21},start:1080},{value:{heat:16.5},start:1320}];var getDefaultSchedule=function getDefaultSchedule(){return{monday:defaultDaySchedule,tuesday:defaultDaySchedule,wednesday:defaultDaySchedule,thursday:defaultDaySchedule,friday:defaultDaySchedule,saturday:defaultDaySchedule,sunday:defaultDaySchedule};};

/***/ }),
/* 2438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 80%;\n    margin: 10%;\n    width: 80%;\n\n    & > div > div {\n        transform: scale(1.5) translate(0, 25%);\n    }\n'],['\n    height: 80%;\n    margin: 10%;\n    width: 80%;\n\n    & > div > div {\n        transform: scale(1.5) translate(0, 25%);\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PickerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateValue", function() { return updateValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasSaveButton", function() { return hasSaveButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intl__ = __webpack_require__(2440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_themes_main__ = __webpack_require__(78);
// @noflow
var getValueColor=function getValueColor(_ref){var value=_ref.value;return value.get('state')==='DISARM'?__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].mediumGrey:__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].mainBrandColor;};var getValueLabel=function getValueLabel(_ref2){var formatMessage=_ref2.formatMessage,value=_ref2.value;return formatMessage(value.get('state')==='DISARM'?__WEBPACK_IMPORTED_MODULE_0__intl__["a" /* default */].off:__WEBPACK_IMPORTED_MODULE_0__intl__["a" /* default */].on);};var updateValue=function updateValue(event){return event.getIn(['value','state'])==='DISARM'?event.setIn(['value','state'],'ARM'):event.setIn(['value','state'],'DISARM');};var hasSaveButton=function hasSaveButton(){return false;};var defaultEventValue={state:'ARM'};var getDefaultSchedule=function getDefaultSchedule(){return{monday:[{value:{state:'ARM'},start:390},{value:{state:'ARM'},start:510},{value:{state:'ARM'},start:960},{value:{state:'ARM'},start:1290}],tuesday:[{value:{state:'ARM'},start:390},{value:{state:'ARM'},start:510},{value:{state:'ARM'},start:960},{value:{state:'ARM'},start:1290}],wednesday:[{value:{state:'ARM'},start:390},{value:{state:'ARM'},start:510},{value:{state:'ARM'},start:960},{value:{state:'ARM'},start:1290}],thursday:[{value:{state:'ARM'},start:390},{value:{state:'ARM'},start:510},{value:{state:'ARM'},start:960},{value:{state:'ARM'},start:1290}],friday:[{value:{state:'ARM'},start:390},{value:{state:'ARM'},start:510},{value:{state:'ARM'},start:960},{value:{state:'ARM'},start:1290}],saturday:[{value:{state:'ARM'},start:390},{value:{state:'ARM'},start:510},{value:{state:'ARM'},start:960},{value:{state:'ARM'},start:1290}],sunday:[{value:{state:'ARM'},start:390},{value:{state:'ARM'},start:510},{value:{state:'ARM'},start:960},{value:{state:'ARM'},start:1290}]};};

/***/ }),
/* 2440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({off:{id:'schedule.recipes.off',defaultMessage:'Off',description:'Schedule recipes `Off` label, it has to be short so use abreaviations if too long'},on:{id:'schedule.recipes.on',defaultMessage:'On',description:'Schedule recipes `On` label, it has to be short so use abreaviations if too long'}}));

/***/ }),
/* 2441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPicker", function() { return hasPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPicker", function() { return getPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_colour__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__intl__ = __webpack_require__(2442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style__ = __webpack_require__(2443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_themes_main__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bulbs_tuneablelight__ = __webpack_require__(1014);
// @noflow
var getValueColor=function getValueColor(_ref){var config=_ref.config,value=_ref.value;var colourTemperature=value.get('colourTemperature')?Object(__WEBPACK_IMPORTED_MODULE_1_polished__["a" /* darken */])(0.2,Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_colour__["c" /* convertTemperatureToRGB */])(value.get('colourTemperature'))):Object(__WEBPACK_IMPORTED_MODULE_1_polished__["a" /* darken */])(0.2,Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_colour__["c" /* convertTemperatureToRGB */])(config.getIn(['products','tuneablelight','defaultTemperature'])));return value.get('status')==='OFF'?__WEBPACK_IMPORTED_MODULE_7__core_themes_main__["a" /* default */].mediumGrey:colourTemperature;};var getValueLabel=function getValueLabel(_ref2){var formatMessage=_ref2.formatMessage,value=_ref2.value;return value.get('status')==='OFF'?formatMessage(__WEBPACK_IMPORTED_MODULE_4__intl__["a" /* default */].off):value.get('brightness')+'%';};var hasPicker=function hasPicker(){return true;};var getPicker=function getPicker(_ref3){var config=_ref3.config,value=_ref3.value,updateValue=_ref3.updateValue;var defaultBrightness=config.getIn(['products','tuneablelight','defaultBrightness']);var defaultTemperature=config.getIn(['products','tuneablelight','defaultTemperature']);var isOn=value.get('status')==='ON';var colourTemperature=value.get('colourTemperature',defaultTemperature);var brightness=value.get('brightness',defaultBrightness);var brightnessChanged=function brightnessChanged(newValue){return updateValue(value.set('brightness',newValue));};var toggleLightbulb=function toggleLightbulb(){isOn?updateValue(value.clear().set('status','OFF')):updateValue(value.withMutations(function(value){return value.set('status','ON').set('brightness',defaultBrightness).set('colourTemperature',defaultTemperature);}));};var temperatureChanged=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_debounce___default()(1000,function(_ref4){var valueInRange=_ref4.valueInRange;return updateValue(value.set('colourTemperature',valueInRange));});return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__style__["a" /* PickerContainer */],null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__bulbs_tuneablelight__["a" /* default */],{bulbBrightness:brightness,bulbType:__WEBPACK_IMPORTED_MODULE_3__core_constants_devices__["deviceTypes"].COLOR_TUNEABLE_LIGHT,changeColor:temperatureChanged,colourStartRadians:3.52,colourStopRadians:5.9,delayRendering:500,handleRadiusPercent:5,isCustomRange:true,isOn:isOn,isSmall:true,pickerDepthPercent:5,rangeValue:colourTemperature,rgb:[],toggleLightbulb:toggleLightbulb,valueChanged:brightnessChanged}));};var defaultEventValue={status:'OFF'};var getDefaultSchedule=function getDefaultSchedule(){return{monday:[{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:960},{value:{status:'OFF'},start:1290}],tuesday:[{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:960},{value:{status:'OFF'},start:1290}],wednesday:[{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:960},{value:{status:'OFF'},start:1290}],thursday:[{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:960},{value:{status:'OFF'},start:1290}],friday:[{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:960},{value:{status:'OFF'},start:1290}],saturday:[{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:960},{value:{status:'OFF'},start:1290}],sunday:[{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100,colourTemperature:4617.5},start:960},{value:{status:'OFF'},start:1290}]};};

/***/ }),
/* 2442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({off:{id:'schedule.tuneable-light.off',defaultMessage:'Off',description:'Schedule Tuneable Light `Off` label, it has to be short so use abreaviations if too long'}}));

/***/ }),
/* 2443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 80%;\n    margin: 0 10%;\n    width: 80%;\n'],['\n    height: 80%;\n    margin: 0 10%;\n    width: 80%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PickerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interlace_items__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(149);
var DimmerMenu=function DimmerMenu(_ref){var onClick=_ref.onClick,isOn=_ref.isOn,_ref$additionalItems=_ref.additionalItems,additionalItems=_ref$additionalItems===undefined?[]:_ref$additionalItems;var defaultItems=[__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["d" /* MenuItem */],{enabled:isOn,key:'tuneable-picker',onClick:isOn&&onClick},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["c" /* MenuIcon */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].CIRCLE_OUTLINE}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__["a" /* default */].pickerTuneable,function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* StyledSpan */],null,message);}))];return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* Menu */],null,Object(__WEBPACK_IMPORTED_MODULE_5__interlace_items__["a" /* default */])(defaultItems,additionalItems));};/* harmony default export */ __webpack_exports__["a"] = (DimmerMenu);

/***/ }),
/* 2445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__interlace_items__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(149);
var PickerMenu=function PickerMenu(_ref){var toggleDimmer=_ref.toggleDimmer,isOn=_ref.isOn,_ref$additionalItems=_ref.additionalItems,additionalItems=_ref$additionalItems===undefined?[]:_ref$additionalItems;var defaultItems=[__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["d" /* MenuItem */],{enabled:isOn,key:'pickerDimmer',onClick:isOn&&toggleDimmer},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["c" /* MenuIcon */],{type:__WEBPACK_IMPORTED_MODULE_4__core_constants_icons_general_svg__["a" /* default */].DIMMER}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__core_i18n_components_bulbs_intl__["a" /* default */].pickerDimmer,function(message){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* StyledSpan */],null,message);}))];return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* Menu */],null,Object(__WEBPACK_IMPORTED_MODULE_5__interlace_items__["a" /* default */])(defaultItems,additionalItems));};/* harmony default export */ __webpack_exports__["a"] = (PickerMenu);

/***/ }),
/* 2446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueColor", function() { return getValueColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueLabel", function() { return getValueLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPicker", function() { return hasPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPicker", function() { return getPicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEventValue", function() { return defaultEventValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultSchedule", function() { return getDefaultSchedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__intl__ = __webpack_require__(2447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(2448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_themes_main__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bulbs_warm_white__ = __webpack_require__(1015);
// @noflow
var getValueColor=function getValueColor(_ref){var value=_ref.value;return value.get('status')==='OFF'?__WEBPACK_IMPORTED_MODULE_3__core_themes_main__["a" /* default */].mediumGrey:__WEBPACK_IMPORTED_MODULE_3__core_themes_main__["a" /* default */].mainBrandColor;};var getValueLabel=function getValueLabel(_ref2){var formatMessage=_ref2.formatMessage,value=_ref2.value;return value.get('status')==='OFF'?formatMessage(__WEBPACK_IMPORTED_MODULE_0__intl__["a" /* default */].off):value.get('brightness')+'%';};var hasPicker=function hasPicker(){return true;};var getPicker=function getPicker(_ref3){var config=_ref3.config,value=_ref3.value,updateValue=_ref3.updateValue;var isOn=value.get('status')==='ON';var toggleLightbulb=function toggleLightbulb(){isOn?updateValue(value.clear().set('status','OFF')):updateValue(value.withMutations(function(value){return value.set('status','ON').set('brightness',config.getIn(['products','warmwhitelight','defaultBrightness']));}));};var valueChanged=function valueChanged(newValue){return updateValue(value.set('brightness',newValue));};return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["a" /* PickerContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__bulbs_warm_white__["a" /* default */],{bulbBrightness:value.get('brightness')||config.getIn(['products','warmwhitelight','defaultBrightness']),isOn:isOn,isSmall:true,toggleLightbulb:toggleLightbulb,valueChanged:valueChanged}));};var defaultEventValue={status:'OFF'};var getDefaultSchedule=function getDefaultSchedule(){return{monday:[{value:{status:'ON',brightness:100},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100},start:960},{value:{status:'OFF'},start:1290}],tuesday:[{value:{status:'ON',brightness:100},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100},start:960},{value:{status:'OFF'},start:1290}],wednesday:[{value:{status:'ON',brightness:100},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100},start:960},{value:{status:'OFF'},start:1290}],thursday:[{value:{status:'ON',brightness:100},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100},start:960},{value:{status:'OFF'},start:1290}],friday:[{value:{status:'ON',brightness:100},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100},start:960},{value:{status:'OFF'},start:1290}],saturday:[{value:{status:'ON',brightness:100},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100},start:960},{value:{status:'OFF'},start:1290}],sunday:[{value:{status:'ON',brightness:100},start:390},{value:{status:'OFF'},start:510},{value:{status:'ON',brightness:100},start:960},{value:{status:'OFF'},start:1290}]};};

/***/ }),
/* 2447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({off:{id:'schedule.warm-white-light.off',defaultMessage:'Off',description:'Schedule Warm White Light `Off` label, it has to be short so use abreaviations if too long'}}));

/***/ }),
/* 2448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    height: 90%;\n    margin: 5%;\n    width: 90%;\n'],['\n    height: 90%;\n    margin: 5%;\n    width: 90%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PickerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interlace_items__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(123);
var DimmerMenu=function DimmerMenu(_ref){var _ref$additionalItems=_ref.additionalItems,additionalItems=_ref$additionalItems===undefined?[]:_ref$additionalItems;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__menu__["a" /* Menu */],null,Object(__WEBPACK_IMPORTED_MODULE_1__interlace_items__["a" /* default */])([],additionalItems));};/* harmony default export */ __webpack_exports__["a"] = (DimmerMenu);

/***/ }),
/* 2450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Schedule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style__ = __webpack_require__(2451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_domains_schedule_intl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messages_bar__ = __webpack_require__(2452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__picker_container__ = __webpack_require__(2455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_container__ = __webpack_require__(2458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tooltip__ = __webpack_require__(2489);
// @noflow
Schedule.propTypes={componentId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,isSavingSchedule:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isScheduleLoaded:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,reset:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};function Schedule(_ref){var componentId=_ref.componentId,isSavingSchedule=_ref.isSavingSchedule,isScheduleLoaded=_ref.isScheduleLoaded,reset=_ref.reset,style=_ref.style;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3____["G" /* LoadingIndicator */],{isLoading:!isScheduleLoaded},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__style__["a" /* Base */],{'data-qa':'schedule-base',style:style},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__messages_bar__["a" /* default */],{componentId:componentId}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__style__["e" /* Resize */],null,function(_ref2){var height=_ref2.height,width=_ref2.width;return height>0&&width>0?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__style__["b" /* Container */],{role:'presentation'},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__svg_container__["a" /* default */],{componentId:componentId,height:height,width:width}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__tooltip__["a" /* default */],{componentId:componentId,height:height,width:width}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__picker_container__["a" /* default */],{componentId:componentId,height:height,width:width})):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',null);}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__style__["d" /* ResetSchedule */],{'data-qa':'schedule-reset',onClick:reset},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__core_domains_schedule_intl__["a" /* default */].resetSchedule)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__style__["c" /* Overlay */],{show:isSavingSchedule},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__core_domains_schedule_intl__["a" /* default */].savingSchedule))));}

/***/ }),
/* 2451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Base; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Resize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ResetSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Overlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polished__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_dom_resize__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(49);
var _templateObject=_taggedTemplateLiteral(['\n    height: ','em;\n    min-height: ','em;\n    min-width: 22.8571428em; /* which for a font size of 14px is 320px (the width of iPhone 4 screen) */\n    position: relative;\n    user-select: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n'],['\n    height: ','em;\n    min-height: ','em;\n    min-width: 22.8571428em; /* which for a font size of 14px is 320px (the width of iPhone 4 screen) */\n    position: relative;\n    user-select: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n']),_templateObject2=_taggedTemplateLiteral(['\n    height: ','em;\n    width: 100%;\n'],['\n    height: ','em;\n    width: 100%;\n']),_templateObject3=_taggedTemplateLiteral(['\n    max-width: 100%;\n    position: relative;\n'],['\n    max-width: 100%;\n    position: relative;\n']),_templateObject4=_taggedTemplateLiteral(['\n    cursor: pointer;\n    float: right;\n    height: ','em;\n    font-size: 1rem;\n    line-height: ','em;\n    padding: 0 2.2em;\n    text-decoration: underline;\n'],['\n    cursor: pointer;\n    float: right;\n    height: ','em;\n    font-size: 1rem;\n    line-height: ','em;\n    padding: 0 2.2em;\n    text-decoration: underline;\n']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    color: ',';\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    opacity: ',';\n    position: absolute;\n    top: 0;\n    transition: ',';\n    pointer-events: ',';\n    width: 100%;\n'],['\n    align-items: center;\n    background-color: ',';\n    color: ',';\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    opacity: ',';\n    position: absolute;\n    top: 0;\n    transition: ',';\n    pointer-events: ',';\n    width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var svgComponentHeight=32;var resetScheduleHeight=3;var Base=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject,svgComponentHeight+resetScheduleHeight,svgComponentHeight+resetScheduleHeight);var Resize=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__dom_dom_resize__["a" /* default */])(_templateObject2,svgComponentHeight);var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject3);var ResetSchedule=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject4,resetScheduleHeight,resetScheduleHeight);var Overlay=__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div(_templateObject5,function(p){return Object(__WEBPACK_IMPORTED_MODULE_0_polished__["f" /* transparentize */])(0.5,p.theme.secondaryColor);},function(p){return p.theme.white;},function(p){return p.show?1:0;},__WEBPACK_IMPORTED_MODULE_3__constants__["i" /* TRANSITION_DEF */],function(p){return p.show?'auto':'none';});

/***/ }),
/* 2452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component__ = __webpack_require__(2453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_constants_schedule__ = __webpack_require__(80);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var mapStateToProps=function mapStateToProps(state,_ref){var _true$isAddMode$isCop;var componentId=_ref.componentId;var scheduleMode=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["m" /* getScheduleMode */])(state,{componentId:componentId});var isAddMode=scheduleMode===__WEBPACK_IMPORTED_MODULE_5__core_constants_schedule__["b" /* scheduleModesEnum */].ADD_EVENT;var isCopyMode=scheduleMode===__WEBPACK_IMPORTED_MODULE_5__core_constants_schedule__["b" /* scheduleModesEnum */].COPY_DAY;var isDeleteMode=scheduleMode===__WEBPACK_IMPORTED_MODULE_5__core_constants_schedule__["b" /* scheduleModesEnum */].DELETE_EVENT;var selectedDay=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["o" /* getSelectedDay */])(state,{componentId:componentId});var isADaySelected=selectedDay!==null;var numEventsInSelectedDay=isADaySelected?Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["e" /* getDayScheduleEvents */])(state,{componentId:componentId,dayIndex:selectedDay}).size-1:null;var productId=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["d" /* getDataId */])(state,{componentId:componentId});var maxEvents=(Object(__WEBPACK_IMPORTED_MODULE_3__core_state_products_selectors__["H" /* getPropsForProduct */])(state,{id:productId})||Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({})).get('maxEvents',6);var isMaxEventsReached=numEventsInSelectedDay>=maxEvents;var isADaySelectedToBeCopyFrom=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["b" /* getCopyDay */])(state,{componentId:componentId})!==null;var isMinEventsReached=numEventsInSelectedDay<=1;var messageId=(_true$isAddMode$isCop={},_defineProperty(_true$isAddMode$isCop,true,null),_defineProperty(_true$isAddMode$isCop,isAddMode,'addEvent'),_defineProperty(_true$isAddMode$isCop,isAddMode&&isADaySelected,'addEventSelectedDay'),_defineProperty(_true$isAddMode$isCop,isAddMode&&isADaySelected&&isMaxEventsReached,'addEventMaxEvents'),_defineProperty(_true$isAddMode$isCop,isCopyMode,'copyDayEventsCopyFrom'),_defineProperty(_true$isAddMode$isCop,isCopyMode&&isADaySelectedToBeCopyFrom,'copyDayEventsCopyTo'),_defineProperty(_true$isAddMode$isCop,isDeleteMode,'deleteEvent'),_defineProperty(_true$isAddMode$isCop,isDeleteMode&&isADaySelected,'deleteEventSelectedDay'),_defineProperty(_true$isAddMode$isCop,isDeleteMode&&isADaySelected&&isMinEventsReached,'deleteEventMinEvents'),_true$isAddMode$isCop)[true];return{messageId:messageId};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4__component__["a" /* default */]));

/***/ }),
/* 2453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_domains_schedule_intl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
MessagesBar.propTypes={intl:__WEBPACK_IMPORTED_MODULE_0_react_intl__["h" /* intlShape */],messageId:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string};function MessagesBar(_ref){var formatMessage=_ref.intl.formatMessage,messageId=_ref.messageId;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Container */],null,messageId?formatMessage(__WEBPACK_IMPORTED_MODULE_2__core_domains_schedule_intl__["a" /* default */][messageId]):'');}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["g" /* injectIntl */])(MessagesBar));

/***/ }),
/* 2454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    min-height: 3em;\n    padding: 0 1em;\n'],['\n    align-items: center;\n    display: flex;\n    justify-content: center;\n    min-height: 3em;\n    padding: 0 1em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_devices_selectors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__schedule_type__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component__ = __webpack_require__(2456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_state_ui_schedule_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_state_groups_selectors__ = __webpack_require__(340);
// @noflow
var mapStateToProps=function mapStateToProps(state,_ref){var componentId=_ref.componentId;var config=Object(__WEBPACK_IMPORTED_MODULE_4__core_state_config_selectors__["a" /* getConfig */])(state);var productId=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["d" /* getDataId */])(state,{componentId:componentId});var isHueDevice=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_devices_selectors__["R" /* getIsHueDevice */])(state,{id:productId});var isGroup=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_products_selectors__["m" /* getIsGroupForProduct */])(state,{id:productId});var groupHasHueDevices=Object(__WEBPACK_IMPORTED_MODULE_8__core_state_groups_selectors__["c" /* getGroupHasHueDevices */])(state,{id:productId});var productProps=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_products_selectors__["H" /* getPropsForProduct */])(state,{id:productId});var productState=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_products_selectors__["J" /* getStateForProduct */])(state,{id:productId});var scheduleType=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["n" /* getScheduleType */])(state,{componentId:componentId});var selectedEvent=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["p" /* getSelectedEvent */])(state,{componentId:componentId});var showingPopup=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["q" /* isShowingPopup */])(state,{componentId:componentId});return{config:config,isHueDevice:isHueDevice,isGroup:isGroup,groupHasHueDevices:groupHasHueDevices,productProps:productProps,productState:productState,scheduleType:scheduleType,selectedEvent:selectedEvent,showingPopup:showingPopup};};var mapDispatchToProps={updateEventValue:__WEBPACK_IMPORTED_MODULE_7__core_state_ui_schedule_actions__["t" /* updateEventValue */]};var definePicker=function definePicker(_ref2,dispatchProps,ownProps){var config=_ref2.config,scheduleType=_ref2.scheduleType,selectedEvent=_ref2.selectedEvent,showingPopup=_ref2.showingPopup,productProps=_ref2.productProps,productState=_ref2.productState;if(!showingPopup||!dispatchProps||!ownProps){return;}return Object(__WEBPACK_IMPORTED_MODULE_5__schedule_type__["d" /* getPicker */])({config:config,productProps:productProps,productState:productState,type:scheduleType,updateValue:function updateValue(newValue){return dispatchProps.updateEventValue({componentId:ownProps.componentId,updatedEvent:selectedEvent.set('type',scheduleType).set('value',newValue)});},value:selectedEvent.get('value')});};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var showingPopup=stateProps.showingPopup,isHueDevice=stateProps.isHueDevice,isGroup=stateProps.isGroup,groupHasHueDevices=stateProps.groupHasHueDevices;var isGroupAndHasHueDevices=isGroup&&groupHasHueDevices;return Object.assign({},ownProps,{isHueDevice:isHueDevice,isGroupAndHasHueDevices:isGroupAndHasHueDevices,picker:definePicker(stateProps,dispatchProps,ownProps),showingPopup:showingPopup});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_6__component__["a" /* default */]));

/***/ }),
/* 2456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PickerContainer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__style__ = __webpack_require__(2457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_domains_schedule_intl__ = __webpack_require__(215);
function PickerContainer(_ref){var height=_ref.height,picker=_ref.picker,showingPopup=_ref.showingPopup,width=_ref.width,isHueDevice=_ref.isHueDevice,isGroupAndHasHueDevices=_ref.isGroupAndHasHueDevices;var popupSize=Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* getPopupSize */])(height)*0.9;var popupButtonHeight=Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* getPopupButtonHeight */])(height)+(isHueDevice||isGroupAndHasHueDevices?50:0);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__style__["d" /* TransitionGroup */],{component:'div',enter:{animation:{opacity:1},duration:300},leave:{animation:{opacity:0},duration:300},style:{transform:'translate3d('+width/2+'px, '+height/2.25+'px, 0)'},transform:'translate('+width/2+' '+height/2+')'},showingPopup&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__style__["c" /* Position */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__style__["a" /* Container */],{size:popupSize,style:{transform:'translate3d('+-popupSize/2+'px, '+-(popupSize+popupButtonHeight)/2+'px, 0)'},transform:'translate('+-popupSize/2+' '+-(popupSize+popupButtonHeight)/2+')'},(isHueDevice||isGroupAndHasHueDevices)&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_4__core_domains_schedule_intl__["a" /* default */].hueWarningMessage,function(message){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__style__["b" /* HueWarningMessage */],null,message);}),picker)));}

/***/ }),
/* 2457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TransitionGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HueWarningMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_velocity_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(49);
var _templateObject=_taggedTemplateLiteral(['to { opacity: 1; }'],['to { opacity: 1; }']),_templateObject2=_taggedTemplateLiteral(['\n    left: 0;\n    position: absolute;\n    top: 0;\n'],['\n    left: 0;\n    position: absolute;\n    top: 0;\n']),_templateObject3=_taggedTemplateLiteral(['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    height: ','px;\n    left: 0;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    width: ','px;\n'],['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    height: ','px;\n    left: 0;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    width: ','px;\n']),_templateObject4=_taggedTemplateLiteral(['\n    line-height: 1.5em;\n    text-align: center;\n'],['\n    line-height: 1.5em;\n    text-align: center;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var revealOpacity=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject);var TransitionGroup=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_velocity_react__["VelocityTransitionGroup"])(_templateObject2);var Position=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject3,revealOpacity,__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* EASING */],__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* DURATION */],function(p){return p.size;},function(p){return p.size;});var HueWarningMessage=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject4);

/***/ }),
/* 2458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_ui_schedule_actions__ = __webpack_require__(81);
// @noflow
var mapStateToProps=function mapStateToProps(state,ownProps){var componentId=ownProps.componentId;var showingPopup=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["q" /* isShowingPopup */])(state,{componentId:componentId});var selectedDay=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["o" /* getSelectedDay */])(state,ownProps);var selectedEvent=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["p" /* getSelectedEvent */])(state,ownProps);var numEventsInSelectedDay=selectedDay!==null?Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["e" /* getDayScheduleEvents */])(state,{componentId:componentId,dayIndex:selectedDay}).size:null;return Object.assign({},ownProps,{numEventsInSelectedDay:numEventsInSelectedDay,selectedDay:selectedDay,selectedEvent:selectedEvent,showingPopup:showingPopup});};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref){var componentId=_ref.componentId;return{updateEventStart:function updateEventStart(dayIndex,eventIndex,newStartTime){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__core_state_ui_schedule_actions__["s" /* updateEventStart */])({componentId:componentId,dayIndex:dayIndex,eventIndex:eventIndex,newStartTime:newStartTime}));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 2459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_panel__ = __webpack_require__(2460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_utils_custom_prop_types__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__popup__ = __webpack_require__(2467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__slider__ = __webpack_require__(2470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__definitions__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__time_axis__ = __webpack_require__(2475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_velocity_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__week__ = __webpack_require__(2478);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n    flex: ',';\n    max-width: 100%;\n'],['\n    flex: ',';\n    max-width: 100%;\n']);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// @noflow
var MINUTES_IN_DAY=1440;var MINIMUM_EVENT_DURATION=15;var Container=__WEBPACK_IMPORTED_MODULE_8_styled_components__["c" /* default */].svg(_templateObject,function(p){return'1 0 '+p.theme.viewportMinWidth;});var SVGContainer=function(_Component){_inherits(SVGContainer,_Component);function SVGContainer(props){_classCallCheck(this,SVGContainer);var _this=_possibleConstructorReturn(this,(SVGContainer.__proto__||Object.getPrototypeOf(SVGContainer)).call(this,props));_this.onStart=function(xPos){var selectedEvent=_this.props.selectedEvent;var startTime=selectedEvent.get('start');_this.setState({initialStartTime:startTime,isDragging:true,startXPos:xPos,temporaryStartTime:startTime});};_this.onMove=function(xPos){var _this$props=_this.props,height=_this$props.height,numEventsInSelectedDay=_this$props.numEventsInSelectedDay,selectedEvent=_this$props.selectedEvent,width=_this$props.width;var _this$state=_this.state,isDragging=_this$state.isDragging,initialStartTime=_this$state.initialStartTime,startXPos=_this$state.startXPos;var timeAxisHeight=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* getTimeAxisHeight */])(height);if(isDragging){var newStart=initialStartTime+Math.floor((xPos-startXPos)*MINUTES_IN_DAY/(width-2*timeAxisHeight));newStart=Math.round(newStart/MINIMUM_EVENT_DURATION)*MINIMUM_EVENT_DURATION;// check that the start time is valid (leaving space to the other events)
var eventIndex=selectedEvent.get('eventIndex');newStart=Math.max(eventIndex*MINIMUM_EVENT_DURATION,newStart);newStart=Math.min(MINUTES_IN_DAY-(numEventsInSelectedDay-eventIndex-1)*MINIMUM_EVENT_DURATION,newStart);_this.setState({temporaryStartTime:newStart});}};_this.onEnd=function(){var _this$props2=_this.props,selectedEvent=_this$props2.selectedEvent,updateEventStart=_this$props2.updateEventStart;var temporaryStartTime=_this.state.temporaryStartTime;if(temporaryStartTime!==null){updateEventStart(selectedEvent.get('dayIndex'),selectedEvent.get('eventIndex'),temporaryStartTime);}_this.setState({isDragging:false,temporaryStartTime:null});};_this.state={isDragging:false,temporaryStartTime:null};return _this;}_createClass(SVGContainer,[{key:'render',value:function render(){var _props=this.props,componentId=_props.componentId,height=_props.height,selectedDay=_props.selectedDay,selectedEvent=_props.selectedEvent,showingPopup=_props.showingPopup,width=_props.width;var _state=this.state,isDragging=_state.isDragging,temporaryStartTime=_state.temporaryStartTime;// define the heigh of every section
var controlPanelHeight=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* getControlPanelHeight */])(height);var timeAxisHeight=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* getTimeAxisHeight */])(height);var weekHeight=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* getWeekHeight */])(height);var isSliderShown=!!selectedEvent&&selectedEvent.get('dayIndex')===selectedDay;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,{'data-qa':'schedule-svg',height:height,width:width},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__definitions__["a" /* default */],{componentId:componentId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__control_panel__["a" /* default */],{componentId:componentId,height:controlPanelHeight,sideMarginWidth:timeAxisHeight,width:width}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__time_axis__["a" /* default */],{height:timeAxisHeight,isSliderShown:isSliderShown,top:controlPanelHeight,width:width}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__week__["a" /* default */],{componentId:componentId,height:weekHeight,isDragging:isDragging,sideMarginWidth:timeAxisHeight,temporaryStartTime:temporaryStartTime,top:controlPanelHeight+timeAxisHeight,width:width}),isSliderShown&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__slider__["a" /* default */],{componentId:componentId,height:height,isDragging:isDragging,key:'slider-for-event-'+selectedEvent.get('dayIndex')+'-'+selectedEvent.get('eventIndex'),onEnd:this.onEnd,onMove:this.onMove,onStart:this.onStart,temporaryStartTime:temporaryStartTime,top:controlPanelHeight+timeAxisHeight,width:width-2*timeAxisHeight}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_velocity_react__["VelocityTransitionGroup"],{component:'g',enter:{animation:{opacity:1},duration:300},leave:{animation:{opacity:0},duration:300}},showingPopup&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__popup__["a" /* default */],{componentId:componentId,height:height,width:width})));}}]);return SVGContainer;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);SVGContainer.propTypes={componentId:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,dragging:__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.map,height:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired,numEventsInSelectedDay:Object(__WEBPACK_IMPORTED_MODULE_4__core_utils_custom_prop_types__["b" /* isDependentOn */])(['selectedDay'],function(_,selectedDay){return selectedDay!==null;},__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired),selectedDay:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,selectedEvent:__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.contains({dayIndex:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired,eventIndex:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired,start:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired}),showingPopup:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired,updateEventStart:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,width:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (SVGContainer);

/***/ }),
/* 2460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component__ = __webpack_require__(2461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schedule_type__ = __webpack_require__(214);
// @noflow
var mapStateToProps=function mapStateToProps(state,_ref){var componentId=_ref.componentId;var scheduleMode=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["m" /* getScheduleMode */])(state,{componentId:componentId});var areChangesMade=!!Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["l" /* getScheduleFromComponent */])(state,{componentId:componentId});var scheduleType=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["n" /* getScheduleType */])(state,{componentId:componentId});var showSaveButton=Object(__WEBPACK_IMPORTED_MODULE_4__schedule_type__["h" /* hasSaveButton */])({type:scheduleType});return{areChangesMade:areChangesMade,scheduleMode:scheduleMode,showSaveButton:showSaveButton};};var mapDispatchToProps={attemptSaveSchedule:__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__["c" /* attemptSaveSchedule */],changeMode:__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__["e" /* changeMode */],undoAll:__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__["q" /* undoAll */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var _attemptSaveSchedule=dispatchProps.attemptSaveSchedule,_changeMode=dispatchProps.changeMode,_undoAll=dispatchProps.undoAll;var componentId=ownProps.componentId;return Object.assign({},stateProps,ownProps,{attemptSaveSchedule:function attemptSaveSchedule(){return _attemptSaveSchedule({componentId:componentId});},changeMode:function changeMode(scheduleMode){return _changeMode({componentId:componentId,scheduleMode:scheduleMode});},undoAll:function undoAll(){return _undoAll({componentId:componentId});}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_3__component__["a" /* default */]));

/***/ }),
/* 2461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(2462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_component__ = __webpack_require__(2463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icon_component__ = __webpack_require__(2465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_domains_schedule_intl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_constants_schedule__ = __webpack_require__(80);
ControlPanel.propTypes={areChangesMade:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,attemptSaveSchedule:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,changeMode:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,height:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,intl:__WEBPACK_IMPORTED_MODULE_0_react_intl__["h" /* intlShape */],scheduleMode:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,showSaveButton:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,sideMarginWidth:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,undoAll:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,width:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired};function ControlPanel(_ref){var areChangesMade=_ref.areChangesMade,attemptSaveSchedule=_ref.attemptSaveSchedule,_changeMode=_ref.changeMode,height=_ref.height,formatMessage=_ref.intl.formatMessage,scheduleMode=_ref.scheduleMode,_ref$showSaveButton=_ref.showSaveButton,showSaveButton=_ref$showSaveButton===undefined?true:_ref$showSaveButton,sideMarginWidth=_ref.sideMarginWidth,undoAll=_ref.undoAll,width=_ref.width;var size=Math.floor(height*0.8);var buttonWidth=sideMarginWidth*2;var relativeIconRightStart=width-sideMarginWidth-buttonWidth*(showSaveButton?2.2:1.2);return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["a" /* Background */],{height:height,width:width}),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icon_component__["a" /* default */],{changeMode:function changeMode(){return _changeMode(__WEBPACK_IMPORTED_MODULE_7__core_constants_schedule__["b" /* scheduleModesEnum */].ADD_EVENT);},isSelected:scheduleMode===__WEBPACK_IMPORTED_MODULE_7__core_constants_schedule__["b" /* scheduleModesEnum */].ADD_EVENT,size:size,type:'PLUS',xPos:relativeIconRightStart-size*3.6,yPos:height/2}),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icon_component__["a" /* default */],{changeMode:function changeMode(){return _changeMode(__WEBPACK_IMPORTED_MODULE_7__core_constants_schedule__["b" /* scheduleModesEnum */].COPY_DAY);},isSelected:scheduleMode===__WEBPACK_IMPORTED_MODULE_7__core_constants_schedule__["b" /* scheduleModesEnum */].COPY_DAY,size:size,type:'COPY',xPos:relativeIconRightStart-size*2.3,yPos:height/2}),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__icon_component__["a" /* default */],{changeMode:function changeMode(){return _changeMode(__WEBPACK_IMPORTED_MODULE_7__core_constants_schedule__["b" /* scheduleModesEnum */].DELETE_EVENT);},isSelected:scheduleMode===__WEBPACK_IMPORTED_MODULE_7__core_constants_schedule__["b" /* scheduleModesEnum */].DELETE_EVENT,size:size,type:'MINUS',xPos:relativeIconRightStart-size,yPos:height/2}),showSaveButton&&__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_component__["a" /* default */],{'data-qa':'schedule-save',height:size,isDisable:!areChangesMade,onClick:attemptSaveSchedule,text:formatMessage(__WEBPACK_IMPORTED_MODULE_4__core_domains_schedule_intl__["a" /* default */].save),width:buttonWidth,xPos:width-sideMarginWidth-buttonWidth*0.5,yPos:height/2}),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__button_component__["a" /* default */],{'data-qa':'schedule-undo-all',height:size,isDisable:!areChangesMade,onClick:undoAll,text:formatMessage(__WEBPACK_IMPORTED_MODULE_4__core_domains_schedule_intl__["a" /* default */].undoAll),width:buttonWidth,xPos:width-sideMarginWidth-buttonWidth*(showSaveButton?1.7:0.5),yPos:height/2}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["g" /* injectIntl */])(ControlPanel));

/***/ }),
/* 2462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Background; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['fill: ',';'],['fill: ',';']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Background=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].rect(_templateObject,function(p){return p.theme.white;});

/***/ }),
/* 2463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
Button.propTypes={height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,isDisable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,xPos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,yPos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};function Button(_ref){var height=_ref.height,isDisable=_ref.isDisable,_onClick=_ref.onClick,text=_ref.text,width=_ref.width,xPos=_ref.xPos,yPos=_ref.yPos,props=_objectWithoutProperties(_ref,['height','isDisable','onClick','text','width','xPos','yPos']);return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Container */],{'data-qa':props['data-qa'],isDisable:isDisable,onClick:function onClick(){return isDisable?null:_onClick();},style:{transform:'translate3d('+xPos+'px, '+yPos+'px, 0)'},transform:'translate('+xPos+' '+yPos+')'},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* Border */],{height:height,isDisable:isDisable,rx:height/2,ry:height/2,width:width,x:-width/2,y:-height/2}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* Label */],{dy:'5',isDisable:isDisable},text));}

/***/ }),
/* 2464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Border; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(49);
var _templateObject=_taggedTemplateLiteral(['\n    cursor: ',';\n\n    &:hover > rect {\n        fill: ',';\n    }\n    &:hover > text {\n        fill: ',';\n    }\n'],['\n    cursor: ',';\n\n    &:hover > rect {\n        fill: ',';\n    }\n    &:hover > text {\n        fill: ',';\n    }\n']),_templateObject2=_taggedTemplateLiteral(['\n    fill: ',';\n    opacity: ',';\n    stroke: ',';\n    stroke-width: 1;\n    transition: ',';\n'],['\n    fill: ',';\n    opacity: ',';\n    stroke: ',';\n    stroke-width: 1;\n    transition: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n    fill: ',';\n    opacity: ',';\n    text-anchor: middle;\n    transition: ',';\n'],['\n    fill: ',';\n    opacity: ',';\n    text-anchor: middle;\n    transition: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].g(_templateObject,function(p){return p.isDisable?'default':'pointer';},function(p){return p.isDisable?p.theme.white:p.theme.mainBrandColor;},function(p){return p.isDisable?p.theme.mediumGrey:p.theme.white;});var Border=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].rect(_templateObject2,function(p){return p.theme.white;},function(p){return p.isDisable?0.5:1;},function(p){return p.isDisable?p.theme.mediumGrey:p.theme.mainBrandColor;},__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* TRANSITION_DEF */]);var Label=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].text(_templateObject3,function(p){return p.isDisable?p.theme.mediumGrey:p.theme.mainBrandColor;},function(p){return p.isDisable?0.5:1;},__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* TRANSITION_DEF */]);

/***/ }),
/* 2465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Icon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var getIcon=function getIcon(iconType,size,isSelected){var _true$true;return(_true$true={},_defineProperty(_true$true,true,null),_defineProperty(_true$true,iconType==='COPY',__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* IconGroup */],{isSelected:isSelected},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* Line */],{d:'M'+-size/4+' '+-size*3/8+' h '+size*5/8+' v '+size*7/8+' h '+-size*5/8+' Z'}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* Line */],{d:'M'+-size*3/8+' '+size*3/8+' v '+-size*7/8+' h '+size*5/8}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* DashLine */],{d:'M'+size/4+' '+-size*3/8+' v '+size*6/8+' h '+-size*4/8}))),_defineProperty(_true$true,iconType==='MINUS',__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* IconGroup */],{isSelected:isSelected},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* Line */],{d:'M'+-size/2+' 0 h '+size}))),_defineProperty(_true$true,iconType==='PLUS',__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* IconGroup */],{isSelected:isSelected},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* Line */],{d:'M'+-size*0.5+' 0 h '+size}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* Line */],{d:'M0 '+-size*0.5+' v '+size}))),_true$true)[true];};Icon.propTypes={changeMode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,xPos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,yPos:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};function Icon(_ref){var changeMode=_ref.changeMode,isSelected=_ref.isSelected,size=_ref.size,type=_ref.type,xPos=_ref.xPos,yPos=_ref.yPos;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('g',{transform:'translate('+xPos+' '+yPos+')'},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* Background */],{height:size,isSelected:isSelected,rx:size*0.5,ry:size*0.5,width:size,x:-size*0.5,y:-size*0.5}),getIcon(type,size,isSelected),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* ClickableArea */],{'data-qa':('schedule-'+type).toLowerCase(),height:size,onClick:changeMode,width:size,x:-size*0.5,y:-size*0.5}));}

/***/ }),
/* 2466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DashLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClickableArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(49);
var _templateObject=_taggedTemplateLiteral(['\n    fill: ',';\n    stroke: ',';\n    transition: ',';\n'],['\n    fill: ',';\n    stroke: ',';\n    transition: ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    transform: scale3d(0.6, 0.6, 1);\n\n    & > path {\n        stroke: ',';\n    }\n'],['\n    transform: scale3d(0.6, 0.6, 1);\n\n    & > path {\n        stroke: ',';\n    }\n']),_templateObject3=_taggedTemplateLiteral(['\n    fill: transparent;\n    stroke-width: 1;\n    transition: ',';\n'],['\n    fill: transparent;\n    stroke-width: 1;\n    transition: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    fill: transparent;\n    stroke-dasharray: 1, 2;\n    stroke-width: 1;\n    transition: ',';\n'],['\n    fill: transparent;\n    stroke-dasharray: 1, 2;\n    stroke-width: 1;\n    transition: ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n    cursor: pointer;\n    fill: transparent;\n'],['\n    cursor: pointer;\n    fill: transparent;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Background=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].rect(_templateObject,function(p){return p.isSelected?p.theme.mainBrandColor:p.theme.white;},function(p){return p.theme.mainBrandColor;},__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* TRANSITION_DEF */]);var IconGroup=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].g(_templateObject2,function(p){return p.isSelected?p.theme.white:p.theme.mainBrandColor;});// as I.E. does not support transform css attributes on SVG element we need to add them as properties
IconGroup.defaultProps={transform:'scale(0.6, 0.6)'};var Line=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].path(_templateObject3,__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* TRANSITION_DEF */]);var DashLine=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].path(_templateObject4,__WEBPACK_IMPORTED_MODULE_1__constants__["i" /* TRANSITION_DEF */]);var ClickableArea=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].rect(_templateObject5);

/***/ }),
/* 2467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_ui_schedule_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component__ = __webpack_require__(2468);
// @noflow
var MINUTES_IN_DAY=1440;var mapStateToProps=function mapStateToProps(state,_ref){var componentId=_ref.componentId;var selectedDay=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["o" /* getSelectedDay */])(state,{componentId:componentId});var selectedEvent=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["p" /* getSelectedEvent */])(state,{componentId:componentId});var dayEvents=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["e" /* getDayScheduleEvents */])(state,{componentId:componentId,dayIndex:selectedDay});if(!selectedDay||!selectedEvent||!dayEvents){return;}var isPreviousDayEvent=selectedEvent.get('dayIndex')!==selectedDay;var nextEvent=dayEvents.get(isPreviousDayEvent?1:selectedEvent.get('eventIndex')+2);var numEventsInSelectedDay=dayEvents.size;var selectedEventDuration=(nextEvent?nextEvent.get('start'):MINUTES_IN_DAY)-(isPreviousDayEvent?0:selectedEvent.get('start'));return{isPreviousDayEvent:isPreviousDayEvent,numEventsInSelectedDay:numEventsInSelectedDay,selectedDay:selectedDay,selectedEvent:selectedEvent,selectedEventDuration:selectedEventDuration};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var componentId=_ref2.componentId;return{hidePopup:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default()(dispatch,function(){return Object(__WEBPACK_IMPORTED_MODULE_3__core_state_ui_schedule_actions__["j" /* hidePopup */])({componentId:componentId});})};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__component__["a" /* default */]));

/***/ }),
/* 2468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Popup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
// @noflow
Popup.propTypes={height:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,hidePopup:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,isPreviousDayEvent:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool.isRequired,numEventsInSelectedDay:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,selectedDay:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,selectedEvent:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.contains({eventIndex:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,start:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired}).isRequired,selectedEventDuration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,width:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired};function Popup(_ref){var height=_ref.height,hidePopup=_ref.hidePopup,isPreviousDayEvent=_ref.isPreviousDayEvent,numEventsInSelectedDay=_ref.numEventsInSelectedDay,selectedDay=_ref.selectedDay,selectedEvent=_ref.selectedEvent,selectedEventDuration=_ref.selectedEventDuration,width=_ref.width;var popupWidth=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* getPopupSize */])(height);var buttonHeight=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* getPopupButtonHeight */])(height);var pathPoint=buttonHeight*0.12;var popupHeight=popupWidth+buttonHeight;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* Overlay */],{height:height,onClick:hidePopup,width:width}),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('g',{transform:'translate('+width/2+' '+height/2+')'},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["f" /* ScaleGroup */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* PopupContainer */],{r:popupHeight/2,x:-popupWidth/2,y:-popupHeight/2}),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('g',{onClick:hidePopup,style:{transform:'translate3d(0, '+popupWidth/2.5+'px, 0)'},transform:'translate(0 '+popupWidth/2.5+')'},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* CloseButton */],{'data-qa':'popup-close',r:buttonHeight*0.3}),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('g',{transform:'translate('+-pathPoint*0.5+' 0)'},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* CrossPath */],{d:'M '+-pathPoint+' 0 l '+pathPoint+' '+pathPoint}),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* CrossPath */],{d:'M 0 '+pathPoint+' l '+2*pathPoint+' '+2*-pathPoint})),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* ClickableArea */],{r:buttonHeight*0.5})))));}

/***/ }),
/* 2469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ScaleGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PopupContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CloseButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CrossPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickableArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['to { transform: scale3d(1, 1, 1); }'],['to { transform: scale3d(1, 1, 1); }']),_templateObject2=_taggedTemplateLiteral(['\n    fill: ',';\n    opacity: 0.9;\n'],['\n    fill: ',';\n    opacity: 0.9;\n']),_templateObject3=_taggedTemplateLiteral(['\n    animation: ',' ',' ',' forwards;\n    transform: scale3d(0, 0, 1);\n'],['\n    animation: ',' ',' ',' forwards;\n    transform: scale3d(0, 0, 1);\n']),_templateObject4=_taggedTemplateLiteral(['\n    fill: transparent;\n    transition: ',';\n'],['\n    fill: transparent;\n    transition: ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n    fill: ',';\n    stroke: ',';\n    stroke-width: 2px;\n    transition: ',';\n'],['\n    fill: ',';\n    stroke: ',';\n    stroke-width: 2px;\n    transition: ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n    stroke: ',';\n    stroke-width: 2px;\n'],['\n    stroke: ',';\n    stroke-width: 2px;\n']),_templateObject7=_taggedTemplateLiteral(['\n    cursor: pointer;\n    opacity: 0;\n'],['\n    cursor: pointer;\n    opacity: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var revealScaling=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].rect(_templateObject2,function(p){return p.theme.white;});var ScaleGroup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject3,revealScaling,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EASING */]);var PopupContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].circle(_templateObject4,__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */]);var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].circle(_templateObject5,function(p){return p.theme.white;},function(p){return p.theme.heavyGrey;},__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */]);var CrossPath=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].path(_templateObject6,function(p){return p.theme.heavyGrey;});var ClickableArea=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].circle(_templateObject7);

/***/ }),
/* 2470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2471);
var mapStateToProps=function mapStateToProps(state,ownProps){var componentId=ownProps.componentId;var selectedDay=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["o" /* getSelectedDay */])(state,{componentId:componentId});var selectedEvent=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["p" /* getSelectedEvent */])(state,{componentId:componentId});var numEventsInSelectedDay=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["e" /* getDayScheduleEvents */])(state,{componentId:componentId,dayIndex:selectedDay// $FlowFixMe
}).size;return Object.assign({},ownProps,{numEventsInSelectedDay:numEventsInSelectedDay,selectedDay:selectedDay,selectedEvent:selectedEvent});};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 2471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Slider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(2472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(49);
// @noflow
var MINUTES_IN_DAY=1440;Slider.propTypes={height:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,isDragging:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,numEventsInSelectedDay:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,onEnd:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onMove:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,onStart:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,selectedDay:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,selectedEvent:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.contains({eventIndex:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,start:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired}).isRequired,temporaryStartTime:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,top:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,width:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired};function Slider(_ref){var height=_ref.height,isDragging=_ref.isDragging,numEventsInSelectedDay=_ref.numEventsInSelectedDay,onEnd=_ref.onEnd,onMove=_ref.onMove,onStart=_ref.onStart,selectedDay=_ref.selectedDay,selectedEvent=_ref.selectedEvent,temporaryStartTime=_ref.temporaryStartTime,top=_ref.top,width=_ref.width;var sliderHeight=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* getTimeAxisHeight */])(height);var halfSliderHeight=sliderHeight/2;var start=temporaryStartTime||selectedEvent.get('start');var xPos=sliderHeight+Math.round(start*width/MINUTES_IN_DAY);var _getSelectedDayHeight=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["d" /* getSelectedDayHeight */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["f" /* getWeekHeight */])(height),numEventsInSelectedDay),otherDayHeight=_getSelectedDayHeight.otherDayHeight,selectedDayHeight=_getSelectedDayHeight.selectedDayHeight;var yPos=Math.round(otherDayHeight*selectedDay+(selectedEvent.get('eventIndex')+1.5)*selectedDayHeight/numEventsInSelectedDay);var deltaYTimeLabel=-yPos-halfSliderHeight;var showSliderAbove=top+yPos+__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* SLIDER_Y */]+halfSliderHeight>height;var arrowLength=sliderHeight/6;var leftArrowPath='\n\t\tM '+-sliderHeight/5+' '+-arrowLength+'\n\t\tl '+-arrowLength+' '+arrowLength+'\n\t\tl '+arrowLength+' '+arrowLength+'\n\t';var rightArrowPath='\n\t\tM '+sliderHeight/5+' '+-arrowLength+'\n\t\tl '+arrowLength+' '+arrowLength+'\n\t\tl '+-arrowLength+' '+arrowLength+'\n\t';var joinPath='M '+-sliderHeight/3+' 0 h '+2*sliderHeight/3;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('g',{style:{transform:'translate3d('+xPos+'px, '+(top+yPos)+'px, 0)'},transform:'translate('+xPos+' '+(top+yPos)+')'},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["i" /* UpperLine */],{d:'M0 0 v '+deltaYTimeLabel}),!showSliderAbove&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["a" /* LowerLine */],{d:'M0 0 v '+__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* SLIDER_Y */]}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["f" /* StartDot */],{r:'4'}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('g',{'data-qa':'schedule-slider',style:{transform:'translate3d(0, '+__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* SLIDER_Y */]*(showSliderAbove?-1:1)+'px, 0)'},transform:'translate(0 '+__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* SLIDER_Y */]*(showSliderAbove?-1:1)+')'},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["c" /* ScaleGroup */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["e" /* SliderElement */],{height:sliderHeight,rx:halfSliderHeight,ry:halfSliderHeight,width:sliderHeight*2,x:-sliderHeight,y:-halfSliderHeight}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["b" /* Path */],{d:leftArrowPath}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["b" /* Path */],{d:rightArrowPath}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["b" /* Path */],{d:joinPath}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["d" /* SliderClickArea */],{height:sliderHeight,isDragging:isDragging,onMouseDown:function onMouseDown(e){return onStart(e.clientX);},onMouseLeave:onEnd,onMouseMove:function onMouseMove(e){return onMove(e.clientX);},onMouseUp:onEnd,onTouchEnd:onEnd,onTouchMove:function onTouchMove(e){return onMove(e.targetTouches[0].clientX);},onTouchStart:function onTouchStart(e){return onStart(e.targetTouches[0].clientX);},width:sliderHeight*2,x:-sliderHeight,y:-halfSliderHeight}))),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('g',{'data-qa':'schedule-time-displayed',style:{transform:'translate3d(0, '+deltaYTimeLabel+'px, 0)'},transform:'translate(0 '+deltaYTimeLabel+')'},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["c" /* ScaleGroup */],null,__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["g" /* TimeContainer */],{height:sliderHeight,rx:halfSliderHeight,ry:halfSliderHeight,width:sliderHeight*2,x:-sliderHeight,y:-halfSliderHeight}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["h" /* TimeLabel */],{dy:'6'},__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.utc(0).minutes(start).format('LT')))));}

/***/ }),
/* 2472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UpperLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LowerLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StartDot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ScaleGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SliderElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Path; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SliderClickArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TimeContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TimeLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['to { transform: scale3d(1, 1, 1); }'],['to { transform: scale3d(1, 1, 1); }']),_templateObject2=_taggedTemplateLiteral(['to { opacity: 1; }'],['to { opacity: 1; }']),_templateObject3=_taggedTemplateLiteral(['\n    animation: ',' ',' ',' forwards;\n    opacity: 0.5;\n    stroke: ',';\n    stroke-dasharray: 5 2;\n    stroke-width: 2;\n    transform: scale3d(1, 0, 1);\n'],['\n    animation: ',' ',' ',' forwards;\n    opacity: 0.5;\n    stroke: ',';\n    stroke-dasharray: 5 2;\n    stroke-width: 2;\n    transform: scale3d(1, 0, 1);\n']),_templateObject4=_taggedTemplateLiteral(['transform-origin: 0 100%;'],['transform-origin: 0 100%;']),_templateObject5=_taggedTemplateLiteral(['transform-origin: 0 0;'],['transform-origin: 0 0;']),_templateObject6=_taggedTemplateLiteral(['\n    animation: ',' ',' ',' forwards;\n    fill: ',';\n    opacity: 0;\n'],['\n    animation: ',' ',' ',' forwards;\n    fill: ',';\n    opacity: 0;\n']),_templateObject7=_taggedTemplateLiteral(['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    transform: scale3d(0, 0, 1);\n'],['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    transform: scale3d(0, 0, 1);\n']),_templateObject8=_taggedTemplateLiteral(['\n    fill: ',';\n    height: ','px;\n    width: ','px;\n'],['\n    fill: ',';\n    height: ','px;\n    width: ','px;\n']),_templateObject9=_taggedTemplateLiteral(['\n    fill: transparent;\n    stroke: ',';\n    stroke-width: 2px;\n'],['\n    fill: transparent;\n    stroke: ',';\n    stroke-width: 2px;\n']),_templateObject10=_taggedTemplateLiteral(['\n    cursor: ew-resize;\n    fill: transparent;\n    height: ','px;\n    transform: ',';\n    width: ','px;\n'],['\n    cursor: ew-resize;\n    fill: transparent;\n    height: ','px;\n    transform: ',';\n    width: ','px;\n']),_templateObject11=_taggedTemplateLiteral(['\n    fill: ',';\n    stroke: ',';\n    strokewidth: 1;\n'],['\n    fill: ',';\n    stroke: ',';\n    strokewidth: 1;\n']),_templateObject12=_taggedTemplateLiteral(['\n    font-size: 1.1em;\n    text-anchor: middle;\n'],['\n    font-size: 1.1em;\n    text-anchor: middle;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var revealScaling=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var revealOpacity=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject2);var Line=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].path(_templateObject3,revealScaling,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EASING */],function(p){return p.theme.heavyGrey;});var UpperLine=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(Line)(_templateObject4);var LowerLine=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(Line)(_templateObject5);var StartDot=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].circle(_templateObject6,revealOpacity,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EASING */],function(p){return p.theme.heavyGrey;});var ScaleGroup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject7,revealScaling,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EASING */],__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */]);var SliderElement=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].rect(_templateObject8,function(p){return p.theme.footerColor;},function(p){return p.height;},function(p){return p.width;});var Path=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].path(_templateObject9,function(p){return p.theme.white;});var SliderClickArea=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].rect(_templateObject10,function(p){return p.height;},function(p){return p.isDragging?'scale3d(4, 4, 1)':'scale3d(1, 1, 1)';},function(p){return p.width;});var TimeContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].rect(_templateObject11,function(p){return p.theme.white;},function(p){return p.theme.footerColor;});var TimeLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].text(_templateObject12);

/***/ }),
/* 2473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedule_type__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component__ = __webpack_require__(2474);
var mapStateToProps=function mapStateToProps(state,_ref){var componentId=_ref.componentId;var scheduleType=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_ui_schedule_selectors__["n" /* getScheduleType */])(state,{componentId:componentId});var dualColors=Object(__WEBPACK_IMPORTED_MODULE_1__schedule_type__["c" /* getDualColors */])({type:scheduleType});return Object.assign({},dualColors);};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_3__component__["a" /* default */]));

/***/ }),
/* 2474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SVGDefinitions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
// @noflow
SVGDefinitions.propTypes={bottomColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,topColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};function SVGDefinitions(_ref){var bottomColor=_ref.bottomColor,topColor=_ref.topColor;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('defs',null,bottomColor&&topColor&&__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('linearGradient',{id:__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* dualColorGradiant */],x1:'0%',x2:'0%',y1:'0%',y2:'100%'},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('stop',{offset:'0%',stopColor:topColor}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('stop',{offset:'48%',stopColor:topColor}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('stop',{offset:'52%',stopColor:bottomColor}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('stop',{offset:'100%',stopColor:bottomColor})));}

/***/ }),
/* 2475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_hub_selectors__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2476);
var mapStateToProps=function mapStateToProps(state,ownProps){var hubDate=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_hub_selectors__["e" /* getHubDate */])(state);return{currentTime:hubDate.hours()*60+hubDate.minutes()};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 2476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var _getLabelFormat=function _getLabelFormat(value){return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.utc(0).hours(value).format('LT').replace(':00','').replace(' ','').toLowerCase();};var TimeAxis=function(_Component){_inherits(TimeAxis,_Component);function TimeAxis(){_classCallCheck(this,TimeAxis);return _possibleConstructorReturn(this,(TimeAxis.__proto__||Object.getPrototypeOf(TimeAxis)).apply(this,arguments));}_createClass(TimeAxis,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var _props=this.props,currentTime=_props.currentTime,height=_props.height,isSliderShown=_props.isSliderShown,top=_props.top,width=_props.width;return height!==nextProps.height||isSliderShown!==nextProps.isSliderShown||top!==nextProps.top||width!==nextProps.width||currentTime!==nextProps.currentTime;}},{key:'render',value:function render(){var _true$true;var _props2=this.props,currentTime=_props2.currentTime,height=_props2.height,isSliderShown=_props2.isSliderShown,top=_props2.top,width=_props2.width;var axisWidth=width-2*__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* SIDE_MARGIN_WIDTH */];var y=top+height/2;// define the frequency of the labels depending of the width od the schedule
var step=(_true$true={},_defineProperty(_true$true,true,6),_defineProperty(_true$true,width>2*__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* MIN_WIDTH */],4),_defineProperty(_true$true,width>3*__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* MIN_WIDTH */],3),_defineProperty(_true$true,width>4*__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* MIN_WIDTH */],2),_defineProperty(_true$true,width>6*__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* MIN_WIDTH */],1),_true$true)[true];var labels=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_rangeStep___default()(step,0,25).map(function(hour,i){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__style__["e" /* Label */],{dy:'4',key:'axis-label-'+hour,x:__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* SIDE_MARGIN_WIDTH */]+hour*axisWidth/24,y:y},_getLabelFormat(hour));});var currentTimeX=__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* SIDE_MARGIN_WIDTH */]+currentTime*axisWidth/1440;var currentTimeSize=height*3/4;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__style__["a" /* Container */],{fade:isSliderShown},labels,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__style__["c" /* CurrentTimeContainer */],{style:{transform:'translate3d('+currentTimeX+'px, '+y+'px, 0)'},transform:'translate('+currentTimeX+' '+y+')'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__style__["b" /* CurrentTimeBorder */],{height:currentTimeSize,rx:currentTimeSize/2,ry:currentTimeSize/2,width:currentTimeSize*2,x:-currentTimeSize,y:-currentTimeSize/2}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__style__["d" /* CurrentTimeLabel */],{dy:'4'},__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.utc(0).minutes(currentTime).format('LT').replace(' ','').toLowerCase())));}}]);return TimeAxis;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);TimeAxis.propTypes={currentTime:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,height:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,isSliderShown:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,top:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,width:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (TimeAxis);

/***/ }),
/* 2477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CurrentTimeBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CurrentTimeContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CurrentTimeLabel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    opacity: ',';\n    transition: ',';\n'],['\n    opacity: ',';\n    transition: ',';\n']),_templateObject2=_taggedTemplateLiteral(['text-anchor: middle;'],['text-anchor: middle;']),_templateObject3=_taggedTemplateLiteral(['\n    fill: ',';\n    stroke: ',';\n    stroke-width: 2;\n    height: ','px;\n    width: ','px;\n'],['\n    fill: ',';\n    stroke: ',';\n    stroke-width: 2;\n    height: ','px;\n    width: ','px;\n']),_templateObject4=_taggedTemplateLiteral(['transition: ',';'],['transition: ',';']),_templateObject5=_taggedTemplateLiteral(['\n    font-size: 0.8em;\n    text-anchor: middle;\n'],['\n    font-size: 0.8em;\n    text-anchor: middle;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject,function(p){return p.fade?__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* OPACITY_LEVEL */]:1;},__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */]);var Label=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].text(_templateObject2);var CurrentTimeBorder=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].rect(_templateObject3,function(p){return p.theme.white;},function(p){return p.theme.mediumGrey;},function(p){return p.height;},function(p){return p.width;});var CurrentTimeContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject4,__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */]);var CurrentTimeLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].text(_templateObject5);

/***/ }),
/* 2478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2479);
var mapStateToProps=function mapStateToProps(state,ownProps){var componentId=ownProps.componentId;var selectedDay=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["o" /* getSelectedDay */])(state,{componentId:componentId});var numEventsInSelectedDay=selectedDay!==null?Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["e" /* getDayScheduleEvents */])(state,{componentId:componentId,dayIndex:selectedDay// $FlowFixMe
}).size:null;return Object.assign({},ownProps,{numEventsInSelectedDay:numEventsInSelectedDay,selectedDay:selectedDay});};// $FlowFixMe
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 2479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Week;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__day__ = __webpack_require__(2480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_utils_custom_prop_types__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
// @noflow
var DAYS_IN_WEEK=7;Week.propTypes={componentId:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,height:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,isDragging:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,numEventsInSelectedDay:Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_custom_prop_types__["b" /* isDependentOn */])(['selectedDay'],function(_,selectedDay){return selectedDay!==null;},__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired),selectedDay:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,sideMarginWidth:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,temporaryStartTime:Object(__WEBPACK_IMPORTED_MODULE_3__core_utils_custom_prop_types__["b" /* isDependentOn */])(['isDragging'],function(_,isDragging){return isDragging;},__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired),top:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,width:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired};function Week(_ref){var componentId=_ref.componentId,height=_ref.height,isDragging=_ref.isDragging,numEventsInSelectedDay=_ref.numEventsInSelectedDay,selectedDay=_ref.selectedDay,sideMarginWidth=_ref.sideMarginWidth,temporaryStartTime=_ref.temporaryStartTime,top=_ref.top,width=_ref.width;// if no day is selected the height will be equally spread into the 7 days of the week
var dayHeight=Math.floor(height/DAYS_IN_WEEK);var selectedDayH=void 0;if(selectedDay!==null){var _getSelectedDayHeight=Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getSelectedDayHeight */])(height,numEventsInSelectedDay),otherDayHeight=_getSelectedDayHeight.otherDayHeight,selectedDayHeight=_getSelectedDayHeight.selectedDayHeight;dayHeight=otherDayHeight;selectedDayH=selectedDayHeight;}var days=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,7).map(function(i){var h=selectedDay===i?selectedDayH:dayHeight;var t=dayHeight*i;if(selectedDay!==null&&i>selectedDay){t+=selectedDayH-dayHeight;}return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__day__["a" /* default */],{componentId:componentId,dayIndex:i,height:h,isDayDragging:selectedDay===i?isDragging:false,key:'day-'+i,sideMarginWidth:sideMarginWidth,temporaryStartTime:selectedDay===i?temporaryStartTime:null,top:top+t,width:width});});return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]('g',null,days);}

/***/ }),
/* 2480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component__ = __webpack_require__(2481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_schedule__ = __webpack_require__(80);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var mapStateToProps=function mapStateToProps(state,ownProps){var isDayDragging=ownProps.isDayDragging,temporaryStartTime=ownProps.temporaryStartTime;var selectedDay=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["o" /* getSelectedDay */])(state,ownProps);var selectedEvent=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["p" /* getSelectedEvent */])(state,ownProps);var events=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["e" /* getDayScheduleEvents */])(state,ownProps);var scheduleMode=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["m" /* getScheduleMode */])(state,ownProps);var copyDay=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["b" /* getCopyDay */])(state,ownProps);var currentEvent=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["c" /* getCurrentScheduleEvent */])(state,ownProps);var productId=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["d" /* getDataId */])(state,ownProps);var maxEvents=(Object(__WEBPACK_IMPORTED_MODULE_5__core_state_products_selectors__["H" /* getPropsForProduct */])(state,{id:productId})||Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({})).get('maxEvents',6);if(isDayDragging){var updatingEventIndex=selectedEvent.get('eventIndex')+1;events=events.map(function(event,i){var _true;if(i===0){return event;}var timeStart=(_true={},_defineProperty(_true,i===updatingEventIndex,temporaryStartTime),_defineProperty(_true,i<updatingEventIndex,Math.min(event.get('start'),temporaryStartTime-(updatingEventIndex-i)*15)),_defineProperty(_true,i>updatingEventIndex,Math.max(event.get('start'),temporaryStartTime+(i-updatingEventIndex)*15)),_true)[true];return event.set('start',timeStart);});}return Object.assign({},ownProps,{copyDay:copyDay,currentEvent:currentEvent,events:events,maxEvents:maxEvents,scheduleMode:scheduleMode,selectedDay:selectedDay});};var mapDispatchToProps={copyDayEvents:__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__["g" /* copyDayEvents */],selectDay:__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__["m" /* selectDay */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var componentId=ownProps.componentId,dayIndex=ownProps.dayIndex;var copyDayEvents=dispatchProps.copyDayEvents,_selectDay=dispatchProps.selectDay;var scheduleMode=stateProps.scheduleMode;return Object.assign({},stateProps,ownProps,{selectDay:function selectDay(){if(scheduleMode===__WEBPACK_IMPORTED_MODULE_6__core_constants_schedule__["b" /* scheduleModesEnum */].COPY_DAY){copyDayEvents({componentId:componentId,dayIndex:dayIndex});}else{_selectDay({componentId:componentId,dayIndex:dayIndex});}}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_3__component__["a" /* default */]));

/***/ }),
/* 2481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__add_event_button__ = __webpack_require__(2483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__event__ = __webpack_require__(2486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_domains_schedule_intl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_constants_schedule__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_velocity_react__);
var MINUTES_IN_DAY=1440;Day.propTypes={componentId:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,copyDay:__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.map,currentEvent:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object.isRequired,dayIndex:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,events:__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.list.isRequired,height:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,intl:__WEBPACK_IMPORTED_MODULE_1_react_intl__["h" /* intlShape */],isDayDragging:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool.isRequired,maxEvents:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,scheduleMode:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string.isRequired,selectDay:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,selectedDay:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,sideMarginWidth:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,top:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired,width:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number.isRequired};function Day(_ref){var componentId=_ref.componentId,copyDay=_ref.copyDay,currentEvent=_ref.currentEvent,dayIndex=_ref.dayIndex,events=_ref.events,height=_ref.height,formatMessage=_ref.intl.formatMessage,isDayDragging=_ref.isDayDragging,maxEvents=_ref.maxEvents,scheduleMode=_ref.scheduleMode,selectDay=_ref.selectDay,selectedDay=_ref.selectedDay,sideMarginWidth=_ref.sideMarginWidth,top=_ref.top,width=_ref.width;var isCopyMode=scheduleMode===__WEBPACK_IMPORTED_MODULE_10__core_constants_schedule__["b" /* scheduleModesEnum */].COPY_DAY;var isAddMode=scheduleMode===__WEBPACK_IMPORTED_MODULE_10__core_constants_schedule__["b" /* scheduleModesEnum */].ADD_EVENT;var isDeletedMode=scheduleMode===__WEBPACK_IMPORTED_MODULE_10__core_constants_schedule__["b" /* scheduleModesEnum */].DELETE_EVENT;var isSelectedDay=selectedDay===dayIndex;var usableWidth=width-(isCopyMode?2.7:2)*sideMarginWidth;var getXPos=function getXPos(start){return(isCopyMode?1.7:1)*sideMarginWidth+start*usableWidth/MINUTES_IN_DAY;};var eventHeight=isSelectedDay?height/events.size:height;var addEventButtons=[];var eventsList=events.map(function(event,i){var start=i===0?0:event.get('start');var end=events.getIn([i+1,'start'],MINUTES_IN_DAY);var xPos=getXPos(start);var eventWidth=getXPos(end)-xPos;var yPos=top+(isSelectedDay?eventHeight*i:0);var isCurrentEvent=currentEvent.get('dayIndex')===event.get('dayIndex')&&currentEvent.get('eventIndex')===event.get('eventIndex');var isLastEvent=i===events.size-1;if(isAddMode&&isSelectedDay&&events.size<=maxEvents&&!isLastEvent&&end-start>15){addEventButtons.push(__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__add_event_button__["a" /* default */],{componentId:componentId,event:event,eventHeight:eventHeight,key:'add-event-'+event.get('guid'),left:xPos+eventWidth,maxEvents:maxEvents,scheduleMode:scheduleMode,top:yPos+eventHeight}));}return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__event__["a" /* default */],{canBeDeleted:isSelectedDay&&isDeletedMode&&i!==0&&events.size>2,componentId:componentId,containerWidth:width,event:event,height:eventHeight,isCurrentEvent:isCurrentEvent,isDayDragging:isDayDragging,isDayShrunk:selectedDay!==null&&!isSelectedDay,isFirstEvent:i===0,isLastEvent:isLastEvent,isSelectedDay:isSelectedDay,key:'event-'+event.get('guid'),left:xPos,sideMarginWidth:sideMarginWidth,top:yPos,width:eventWidth});});var isSelectedToBeCopied=!!(copyDay&&copyDay.get('dayToCopy')===dayIndex);var isCopiedTo=!!(copyDay&&copyDay.get('copyToList').includes(dayIndex));var crossSize=12;var closeTextWidth=60;var closeButtonWidth=closeTextWidth+3*crossSize;var closeButtonHeight=25;var closeButtonLeft=width-(sideMarginWidth+closeButtonWidth)-1;return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* Container */],{'data-qa':'schedule-weekday-'+dayIndex,isCopyMode:isCopyMode,onClick:selectDay},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* ClickableArea */],{height:height,width:width,x:0,y:top}),isSelectedDay&&__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* CloseGroup */],{'data-qa':'schedule-close-day',style:{transform:'translate3d('+closeButtonLeft+'px, '+(top+10)+'px, 0)'},transform:'translate('+closeButtonLeft+' '+(top+10)+')'},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* CloseBorder */],{height:closeButtonHeight,rx:closeButtonHeight/2,ry:closeButtonHeight/2,width:closeButtonWidth}),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["m" /* TextContainer */],{isHidden:!isSelectedDay},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["h" /* CrossPath */],{d:'M '+crossSize+' '+closeButtonHeight*0.7+' l '+crossSize+' '+-crossSize}),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["h" /* CrossPath */],{d:'M '+2*crossSize+' '+closeButtonHeight*0.7+' l '+-crossSize+' '+-crossSize}),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* CloseText */],{style:{transform:'translate3d('+3*crossSize+'px, '+closeButtonHeight*0.7+'px, 0)'},transform:'translate('+3*crossSize+' '+closeButtonHeight*0.7+')'},formatMessage(__WEBPACK_IMPORTED_MODULE_6__core_domains_schedule_intl__["a" /* default */].close)))),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["j" /* EventsContainer */],{blur:isCopyMode&&copyDay&&copyDay.get('dayToCopy')!==dayIndex&&!copyDay.get('copyToList').includes(dayIndex)},eventsList),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["l" /* Mask */],{height:height,style:{transform:'translate3d(0, '+top+'px, 0)'},transform:'translate(0 '+top+')',width:(isCopyMode?1.7:1)*sideMarginWidth}),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["l" /* Mask */],{height:height,style:{transform:'translate3d('+(width-sideMarginWidth)+'px, '+top+'px, 0)'},transform:'translate('+(width-sideMarginWidth)+' '+top+')',width:sideMarginWidth}),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["m" /* TextContainer */],{style:{transform:'translate3d('+sideMarginWidth/2+'px, '+(top+height/2)+'px, 0)'},transform:'translate('+sideMarginWidth/2+' '+(top+height/2)+')'},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["i" /* DayLabel */],{blurLabel:selectedDay!==null&&!isSelectedDay,dy:'4'},__WEBPACK_IMPORTED_MODULE_7_moment_timezone___default.a.weekdays((dayIndex+1)%7)[0].toUpperCase())),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_velocity_react__["VelocityTransitionGroup"],{component:'g',enter:{animation:{opacity:1},duration:200,easing:__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* EASING */]}},isAddMode&&addEventButtons),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["g" /* CopyButtonContainer */],{style:{transform:'translate3d('+sideMarginWidth*1.2+'px, '+(top+height/2)+'px, 0)\n\t\t\t\t\t\tscale('+(isCopyMode?1:0)+')',transitionDelay:isCopyMode?0.2+dayIndex*0.02+'s':'0s'},transform:'translate('+sideMarginWidth*1.2+' '+(top+height/2)+') scale('+(isCopyMode?1:0)+')'},__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["f" /* CopyButton */],{isCopiedTo:isCopiedTo,isSelectedToBeCopied:isSelectedToBeCopied,r:'10'}),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["k" /* Line */],{isCopiedTo:isCopiedTo,x1:'-1',x2:'-5',y1:'3',y2:'-1'}),__WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["k" /* Line */],{isCopiedTo:isCopiedTo,x1:'-1',x2:'6',y1:'3',y2:'-4'})));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["g" /* injectIntl */])(Day));

/***/ }),
/* 2482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickableArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EventsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Mask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TextContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DayLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CopyButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CopyButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CloseGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CloseBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CloseText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CrossPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['to { opacity: 1; }'],['to { opacity: 1; }']),_templateObject2=_taggedTemplateLiteral(['cursor: ',';'],['cursor: ',';']),_templateObject3=_taggedTemplateLiteral(['fill: transparent;'],['fill: transparent;']),_templateObject4=_taggedTemplateLiteral(['\n    opacity: ',';\n    transition: ',';\n'],['\n    opacity: ',';\n    transition: ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n    fill: white;\n    transition: ',';\n'],['\n    fill: white;\n    transition: ',';\n']),_templateObject6=_taggedTemplateLiteral(['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    cursor: pointer;\n    opacity: 0;\n    transition: ',';\n'],['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    cursor: pointer;\n    opacity: 0;\n    transition: ',';\n']),_templateObject7=_taggedTemplateLiteral(['\n    opacity: ',';\n    text-anchor: middle;\n'],['\n    opacity: ',';\n    text-anchor: middle;\n']),_templateObject8=_taggedTemplateLiteral(['transition: ',';'],['transition: ',';']),_templateObject9=_taggedTemplateLiteral(['\n\tfill: ','\n\tstroke: ','\n'],['\n\tfill: ','\n\tstroke: ','\n']),_templateObject10=_taggedTemplateLiteral(['\n    stroke: ',';\n    stroke-width: 2;\n'],['\n    stroke: ',';\n    stroke-width: 2;\n']),_templateObject11=_taggedTemplateLiteral(['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    cursor: pointer;\n    opacity: 0;\n'],['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    cursor: pointer;\n    opacity: 0;\n']),_templateObject12=_taggedTemplateLiteral(['\n    fill: ',';\n    stroke: ',';\n    stroke-width: 1;\n'],['\n    fill: ',';\n    stroke: ',';\n    stroke-width: 1;\n']),_templateObject13=_taggedTemplateLiteral(['fill: ',';'],['fill: ',';']),_templateObject14=_taggedTemplateLiteral(['\n    stroke: ',';\n    stroke-width: 2px;\n'],['\n    stroke: ',';\n    stroke-width: 2px;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var revealOpacity=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject2,function(p){return p.isCopyMode?'pointer':'inherit';});var ClickableArea=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].rect(_templateObject3);var EventsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject4,function(p){return p.blur?0.3:1;},__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */]);var Mask=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].rect(_templateObject5,__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */]);var TextContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject6,revealOpacity,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EASING */],__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */]);var DayLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].text(_templateObject7,function(p){return p.blurLabel?__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* OPACITY_LEVEL */]:1;});var CopyButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject8,__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */]);var CopyButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].circle(_templateObject9,function(p){return p.isSelectedToBeCopied?p.theme.mainBrandColor:p.theme.white;},function(p){return p.isCopiedTo?p.theme.white:p.theme.mainBrandColor;});var Line=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].line(_templateObject10,function(p){return p.isCopiedTo?p.theme.mainBrandColor:p.theme.white;});var CloseGroup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject11,revealOpacity,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EASING */],__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */]);var CloseBorder=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].rect(_templateObject12,function(p){return p.theme.white;},function(p){return p.theme.footerColor;});var CloseText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].text(_templateObject13,function(p){return p.theme.mainBrandColor;});var CrossPath=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].path(_templateObject14,function(p){return p.theme.heavyGrey;});

/***/ }),
/* 2483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__component__ = __webpack_require__(2484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__schedule_type__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_ui_schedule_selectors__ = __webpack_require__(42);
// @noflow
var mergeStateToProps=function mergeStateToProps(state,_ref){var componentId=_ref.componentId;var scheduleType=Object(__WEBPACK_IMPORTED_MODULE_5__core_state_ui_schedule_selectors__["n" /* getScheduleType */])(state,{componentId:componentId});var defaultEventValue=Object(__WEBPACK_IMPORTED_MODULE_4__schedule_type__["a" /* getDefaultEventValue */])({type:scheduleType});return{defaultEventValue:defaultEventValue};};var mapDispatchToProps=function mapDispatchToProps(dispatch,_ref2){var componentId=_ref2.componentId,event=_ref2.event,maxEvents=_ref2.maxEvents;var dispatchAddEvent=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_flowRight___default()(dispatch,__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_actions__["a" /* addEvent */]);return{addEvent:function addEvent(e,defaultEventValue){e.stopPropagation();dispatchAddEvent({componentId:componentId,defaultEventValue:defaultEventValue,eventToSplit:event,maxEvents:maxEvents});}};};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var defaultEventValue=stateProps.defaultEventValue;var _addEvent=dispatchProps.addEvent;return Object.assign({},stateProps,dispatchProps,ownProps,{addEvent:function addEvent(e){return _addEvent(e,defaultEventValue);}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mergeStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_2__component__["a" /* default */]));

/***/ }),
/* 2484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AddEventButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
// @noflow
AddEventButton.propTypes={addEvent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,eventHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,left:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,top:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};function AddEventButton(_ref){var addEvent=_ref.addEvent,eventHeight=_ref.eventHeight,left=_ref.left,top=_ref.top;var r=eventHeight*0.35;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* Opacity */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* Container */],{onClick:addEvent,style:{transform:'translate3d('+left+'px, '+top+'px, 0)'},transform:'translate('+left+' '+top+')'},__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* ClickableArea */],{height:eventHeight,width:eventHeight,x:-eventHeight/2,y:-eventHeight/2}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* Background */],{r:r}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* Line */],{d:'M'+-r*0.5+' 0 h '+r}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* Line */],{d:'M0 '+-r*0.5+' v '+r})));}

/***/ }),
/* 2485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Opacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClickableArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Background; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Line; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polished__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['opacity: 0;'],['opacity: 0;']),_templateObject2=_taggedTemplateLiteral(['cursor: pointer;'],['cursor: pointer;']),_templateObject3=_taggedTemplateLiteral(['fill: transparent;'],['fill: transparent;']),_templateObject4=_taggedTemplateLiteral(['\n    fill: ',';\n    stroke: ',';\n    stroke-dasharray: 3, 3;\n    stroke-width: 2;\n'],['\n    fill: ',';\n    stroke: ',';\n    stroke-dasharray: 3, 3;\n    stroke-width: 2;\n']),_templateObject5=_taggedTemplateLiteral(['\n    fill: transparent;\n    stroke: ',';\n    stroke-width: 2;\n'],['\n    fill: transparent;\n    stroke: ',';\n    stroke-width: 2;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Opacity=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].g(_templateObject2);var ClickableArea=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].rect(_templateObject3);var Background=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].circle(_templateObject4,function(p){return Object(__WEBPACK_IMPORTED_MODULE_0_polished__["f" /* transparentize */])(0.2,p.theme.lightGrey);},function(p){return p.theme.heavyGrey;});var Line=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].path(_templateObject5,function(p){return p.theme.heavyGrey;});

/***/ }),
/* 2486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schedule_type__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component__ = __webpack_require__(2487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_app_settings_selectors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_state_products_selectors__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_constants_app_settings__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_constants_schedule__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__core_state_app_settings_actions__ = __webpack_require__(126);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var mapStateToProps=function mapStateToProps(state,ownProps){var config=Object(__WEBPACK_IMPORTED_MODULE_6__core_state_config_selectors__["a" /* getConfig */])(state);var event=ownProps.event;var selectedEvent=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["p" /* getSelectedEvent */])(state,ownProps);var isSelected=!!selectedEvent&&event.get('dayIndex')===selectedEvent.get('dayIndex')&&event.get('eventIndex')===selectedEvent.get('eventIndex');var scheduleType=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["n" /* getScheduleType */])(state,ownProps);var scheduleMode=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["m" /* getScheduleMode */])(state,ownProps);var slotType=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["f" /* getEventTypeFromEvent */])(state,Object.assign({},ownProps,{event:event}));var eventColor=Object(__WEBPACK_IMPORTED_MODULE_2__schedule_type__["e" /* getValueColor */])({config:config,type:scheduleType,slotType:slotType,value:event.get('value')});var productId=Object(__WEBPACK_IMPORTED_MODULE_1__core_state_ui_schedule_selectors__["d" /* getDataId */])(state,ownProps);var productState=Object(__WEBPACK_IMPORTED_MODULE_7__core_state_products_selectors__["J" /* getStateForProduct */])(state,{id:productId});var getLabel=function getLabel(formatMessage){return Object(__WEBPACK_IMPORTED_MODULE_2__schedule_type__["f" /* getValueLabel */])({config:config,productState:productState,formatMessage:formatMessage,type:scheduleType,slotType:slotType,value:event.get('value')});};var dualColors=Object(__WEBPACK_IMPORTED_MODULE_2__schedule_type__["c" /* getDualColors */])({type:scheduleType});var scheduleStopTooltip=Object(__WEBPACK_IMPORTED_MODULE_5__core_state_app_settings_selectors__["a" /* getAppSetting */])(state,__WEBPACK_IMPORTED_MODULE_8__core_constants_app_settings__["l" /* SCHEDULE_STOP_TOOLTIP */]);return{dualColors:dualColors,eventColor:eventColor,getLabel:getLabel,isSelected:isSelected,scheduleMode:scheduleMode,scheduleStopTooltip:scheduleStopTooltip,scheduleType:scheduleType,selectedEvent:selectedEvent};};var mapDispatchToProps={deleteEvent:__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__["h" /* deleteEvent */],selectEvent:__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__["n" /* selectEvent */],setAppSettings:__WEBPACK_IMPORTED_MODULE_10__core_state_app_settings_actions__["c" /* setAppSettings */],showPopup:__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__["p" /* showPopup */],updateEventValue:__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_actions__["t" /* updateEventValue */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var isSelected=stateProps.isSelected,scheduleMode=stateProps.scheduleMode,scheduleStopTooltip=stateProps.scheduleStopTooltip,scheduleType=stateProps.scheduleType;var deleteEvent=dispatchProps.deleteEvent,_selectEvent=dispatchProps.selectEvent,setAppSettings=dispatchProps.setAppSettings,showPopup=dispatchProps.showPopup,updateEventValue=dispatchProps.updateEventValue;var canBeDeleted=ownProps.canBeDeleted,componentId=ownProps.componentId,event=ownProps.event,isSelectedDay=ownProps.isSelectedDay;return Object.assign({},stateProps,dispatchProps,ownProps,{selectEvent:function selectEvent(e){if(isSelectedDay){e.stopPropagation();if(isSelected){if(!scheduleStopTooltip){setAppSettings(_defineProperty({},__WEBPACK_IMPORTED_MODULE_8__core_constants_app_settings__["l" /* SCHEDULE_STOP_TOOLTIP */],true));}if(Object(__WEBPACK_IMPORTED_MODULE_2__schedule_type__["g" /* hasPicker */])({type:scheduleType})){showPopup({componentId:componentId});}else{var updatedEvent=Object(__WEBPACK_IMPORTED_MODULE_2__schedule_type__["i" /* updateValue */])(scheduleType,event);updateEventValue({componentId:componentId,updatedEvent:updatedEvent});}}else if(scheduleMode===__WEBPACK_IMPORTED_MODULE_9__core_constants_schedule__["b" /* scheduleModesEnum */].DEFAULT){_selectEvent(ownProps);}else if(scheduleMode===__WEBPACK_IMPORTED_MODULE_9__core_constants_schedule__["b" /* scheduleModesEnum */].DELETE_EVENT){canBeDeleted&&deleteEvent({componentId:componentId,eventToDelete:event});}}else if(scheduleMode===__WEBPACK_IMPORTED_MODULE_9__core_constants_schedule__["b" /* scheduleModesEnum */].DEFAULT){_selectEvent(ownProps);}}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_4__component__["a" /* default */]));

/***/ }),
/* 2487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_constants_schedule__ = __webpack_require__(80);
// @noflow
var ADDED_CLICKABLE_WIDTH=50;// needed when the event is tiny and so hard to select the event
var MIN_TEXT_WIDTH=40;// the number of pixels needed to display the value
Event.propTypes={canBeDeleted:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,containerWidth:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,dualColors:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,event:__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.contains({value:__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.map.isRequired}).isRequired,eventColor:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,getLabel:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,height:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["h" /* intlShape */],isCurrentEvent:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,isDayDragging:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,isDayShrunk:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,isFirstEvent:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,isLastEvent:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,isSelected:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,isSelectedDay:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool.isRequired,left:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,scheduleMode:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,scheduleType:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,selectEvent:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired,sideMarginWidth:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,top:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired,width:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number.isRequired};function Event(_ref){var canBeDeleted=_ref.canBeDeleted,containerWidth=_ref.containerWidth,dualColors=_ref.dualColors,event=_ref.event,eventColor=_ref.eventColor,getLabel=_ref.getLabel,height=_ref.height,formatMessage=_ref.intl.formatMessage,isCurrentEvent=_ref.isCurrentEvent,isDayDragging=_ref.isDayDragging,isDayShrunk=_ref.isDayShrunk,isFirstEvent=_ref.isFirstEvent,isLastEvent=_ref.isLastEvent,isSelected=_ref.isSelected,isSelectedDay=_ref.isSelectedDay,left=_ref.left,scheduleMode=_ref.scheduleMode,scheduleType=_ref.scheduleType,selectEvent=_ref.selectEvent,sideMarginWidth=_ref.sideMarginWidth,top=_ref.top,width=_ref.width;var eventWidth=Math.max(width-2*__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* EVENT_SIDE_MARGIN */],0);var heightMargin=Math.floor(height*__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* EVENT_HEIGHT_MARGIN_RATIO */]);var eventHeight=height-2*heightMargin;var radius=Math.min(Math.floor(eventHeight/2),Math.floor(eventWidth/(isFirstEvent||isLastEvent?1:2)));if(radius===1){// it seems for really small events the radius of 1 make the event to not be rendered
radius=0;}var x=__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* EVENT_SIDE_MARGIN */]-(isFirstEvent?radius:0);var displayWidth=eventWidth+(isFirstEvent?radius:0)+(isLastEvent?radius:0);var isTinyEvent=displayWidth===0&&!isFirstEvent;var isLabelOnTheLeft=containerWidth-sideMarginWidth-(left+width)<MIN_TEXT_WIDTH;var textXPos=width>=MIN_TEXT_WIDTH?width/2:isLabelOnTheLeft?-5:width+5;var eventLabel=getLabel(formatMessage);var TextComponent=function TextComponent(props){return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["d" /* Label */],Object.assign({dy:'5',hide:isDayShrunk||width<MIN_TEXT_WIDTH&&!isSelectedDay,isCurrentEvent:isCurrentEvent,isDualColors:!!dualColors,isSelected:isSelected,textPosition:width>=MIN_TEXT_WIDTH?'middle':isLabelOnTheLeft?'end':'start',valueColor:eventColor},props));};var addedClickableWidth=isSelectedDay?ADDED_CLICKABLE_WIDTH:0;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Group */],{'data-qa':'schedule-event',isDayDragging:isDayDragging,style:{transform:'translate3d('+left+'px, '+top+'px, 0)'},transform:'translate('+left+' '+top+')'},__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["e" /* OuterElement */],{blurEvent:isDayShrunk,canBeDeleted:canBeDeleted,dash:canBeDeleted,height:eventHeight,isCurrentEvent:isCurrentEvent,isDayDragging:isDayDragging,isDualColors:!!dualColors,isSelected:isSelected,isSelectedDay:isSelectedDay,isTinyEvent:isTinyEvent,rx:radius,ry:radius,style:{transform:'translate3d('+x+'px, '+heightMargin+'px, 0)'},transform:'translate('+x+' '+heightMargin+')',valueColor:eventColor,width:isTinyEvent?1:displayWidth}),isCurrentEvent&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* InnerElement */],{blurEvent:isDayShrunk,height:Math.max(eventHeight-8,0),isDayDragging:isDayDragging,isDualColors:!!dualColors,isSelected:isSelected,isSelectedDay:isSelectedDay,rx:Math.max(radius-4,0),ry:Math.max(radius-4,0),style:{transform:'translate3d('+(x+4)+'px, '+(heightMargin+4)+'px, 0)'},transform:'translate('+(x+4)+' '+(heightMargin+4)+')',valueColor:eventColor,width:Math.max(displayWidth-8,0)}),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Group */],{isDayDragging:isDayDragging,style:{transform:'translate3d('+textXPos+'px, '+height/2+'px, 0)'},transform:'translate('+textXPos+' '+height/2+')'},eventLabel.topValue&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](TextComponent,{dy:5-eventHeight*0.23,valueColor:dualColors?dualColors.topColor:eventColor},eventLabel.topValue),eventLabel.bottomValue&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](TextComponent,{dy:5+eventHeight*0.23,valueColor:dualColors?dualColors.bottomColor:eventColor},eventLabel.bottomValue),!eventLabel.topValue&&!eventLabel.bottomValue&&__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](TextComponent,{dy:'5'},eventLabel)),__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* ClickableArea */],{height:height,isClickable:scheduleMode===__WEBPACK_IMPORTED_MODULE_6__core_constants_schedule__["b" /* scheduleModesEnum */].DEFAULT||scheduleMode===__WEBPACK_IMPORTED_MODULE_6__core_constants_schedule__["b" /* scheduleModesEnum */].DELETE_EVENT&&canBeDeleted,onClick:selectEvent,style:{transform:'translate3d(-'+addedClickableWidth/2+'px, 0, 0)'},transform:'translate(-'+addedClickableWidth/2+' 0)',width:width+addedClickableWidth}));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["g" /* injectIntl */])(Event));

/***/ }),
/* 2488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Group; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OuterElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InnerElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClickableArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_colour__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['transition: ',';'],['transition: ',';']),_templateObject2=_taggedTemplateLiteral(['\n    opacity: ',';\n'],['\n    opacity: ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n    fill: ',';\n\n    stroke: ',';\n    stroke-dasharray: ',';\n    stroke-width: ',';\n    transition: ',';\n'],['\n    fill: ',';\n\n    stroke: ',';\n    stroke-dasharray: ',';\n    stroke-width: ',';\n    transition: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    fill: ',';\n    stroke: 0;\n    transition: ',';\n'],['\n    fill: ',';\n    stroke: 0;\n    transition: ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n    cursor: ',';\n    fill: transparent;\n'],['\n    cursor: ',';\n    fill: transparent;\n']),_templateObject6=_taggedTemplateLiteral(['\n    fill: ',';\n    font-size: ',';\n    font-weight: ',';\n    opacity: ',';\n    text-anchor: ',';\n    transition: ',';\n'],['\n    fill: ',';\n    font-size: ',';\n    font-weight: ',';\n    opacity: ',';\n    text-anchor: ',';\n    transition: ',';\n']);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// @noflow
var Group=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].g(_templateObject,function(p){return p.isDayDragging?'none':__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */];});var opacityRect=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].rect(_templateObject2,function(p){var _true$p$blurEvent$p$i;return(_true$p$blurEvent$p$i={},_defineProperty(_true$p$blurEvent$p$i,true,0.5),_defineProperty(_true$p$blurEvent$p$i,!p.isSelectedDay,1),_defineProperty(_true$p$blurEvent$p$i,p.blurEvent,__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* OPACITY_LEVEL */]),_defineProperty(_true$p$blurEvent$p$i,p.isSelected,1),_true$p$blurEvent$p$i)[true];});var OuterElement=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(opacityRect)(_templateObject3,function(p){var _true$p$canBeDeleted$;return(_true$p$canBeDeleted$={},_defineProperty(_true$p$canBeDeleted$,true,p.valueColor),_defineProperty(_true$p$canBeDeleted$,p.canBeDeleted,Object(__WEBPACK_IMPORTED_MODULE_1_polished__["f" /* transparentize */])(0.25,p.valueColor)),_defineProperty(_true$p$canBeDeleted$,p.isDualColors,'url(#'+__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* dualColorGradiant */]+')'),_defineProperty(_true$p$canBeDeleted$,p.isCurrentEvent,p.theme.white),_true$p$canBeDeleted$)[true];},function(p){return p.isDualColors?'url(#'+__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* dualColorGradiant */]+')':p.valueColor;},function(p){return p.dash?'15 5':'inherit';},function(p){return p.isTinyEvent?1:2;},function(p){return p.isDayDragging?'none':__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */];});var InnerElement=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(opacityRect)(_templateObject4,function(p){return p.isDualColors?'url(#'+__WEBPACK_IMPORTED_MODULE_0__constants__["j" /* dualColorGradiant */]+')':p.valueColor;},function(p){return p.isDayDragging?'none':__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */];});var ClickableArea=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].rect(_templateObject5,function(p){return p.isClickable?'pointer':'inherit';});var Label=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].text(_templateObject6,function(p){if(p.textPosition!=='middle'){return p.valueColor;}// get the contrast ratio between the event colour and the white font
var contrastRatio=Object(__WEBPACK_IMPORTED_MODULE_2__core_utils_colour__["a" /* contrastRatioFromColours */])(p.valueColor,p.theme.white);// if the ratio is too low (which means both color are very close) use the main font colour
return contrastRatio<2?p.theme.fontColor:p.theme.white;},function(p){return p.isCurrentEvent&&!p.isDualColors?'1.05em':'0.9em';},function(p){return p.isSelected?'bold':'inherit';},function(p){return p.hide?0:1;},function(p){return p.textPosition;},function(p){return p.isDayDragging?'none':__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* TRANSITION_DEF */];});

/***/ }),
/* 2489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_app_settings_selectors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_app_settings__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component__ = __webpack_require__(2490);
var mapStateToProps=function mapStateToProps(state,ownProps){var componentId=ownProps.componentId;var scheduleStopTooltip=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_app_settings_selectors__["a" /* getAppSetting */])(state,__WEBPACK_IMPORTED_MODULE_3__core_constants_app_settings__["l" /* SCHEDULE_STOP_TOOLTIP */]);var selectedEvent=scheduleStopTooltip?null:Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["p" /* getSelectedEvent */])(state,{componentId:componentId});if(scheduleStopTooltip||!selectedEvent||selectedEvent&&selectedEvent.size===0){return Object.assign({},ownProps,{showToolTip:false});}var selectedDay=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["o" /* getSelectedDay */])(state,{componentId:componentId});var dayEvents=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_ui_schedule_selectors__["e" /* getDayScheduleEvents */])(state,{componentId:componentId,dayIndex:selectedDay});var numEventsInSelectedDay=dayEvents.size;var nextEventIndex=selectedEvent&&selectedEvent.get('dayIndex')===selectedDay?selectedEvent.get('eventIndex')+2:1;var nextEventStart=dayEvents&&dayEvents.getIn([nextEventIndex,'start'],1440);return Object.assign({},ownProps,{nextEventStart:nextEventStart,numEventsInSelectedDay:numEventsInSelectedDay,selectedDay:selectedDay,selectedEvent:selectedEvent,showToolTip:true});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_4__component__["a" /* default */]));

/***/ }),
/* 2490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(2491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_domains_schedule_intl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
var MINUTES_IN_DAY=1440;Event.propTypes={height:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,intl:__WEBPACK_IMPORTED_MODULE_2_react_intl__["h" /* intlShape */],nextEventStart:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,numEventsInSelectedDay:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,selectedDay:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,selectedEvent:__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.contains({eventIndex:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired,start:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired}),showToolTip:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,width:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number.isRequired};function Event(_ref){var height=_ref.height,formatMessage=_ref.intl.formatMessage,nextEventStart=_ref.nextEventStart,numEventsInSelectedDay=_ref.numEventsInSelectedDay,selectedDay=_ref.selectedDay,selectedEvent=_ref.selectedEvent,showToolTip=_ref.showToolTip,width=_ref.width;if(!showToolTip){return null;}var controlPanelHeight=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* getControlPanelHeight */])(height);var timeAxisHeight=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["e" /* getTimeAxisHeight */])(height);var eventIndex=selectedEvent.get('dayIndex')===selectedDay?selectedEvent.get('eventIndex'):-1;var eventMiddle=((eventIndex>-1?selectedEvent.get('start',0):0)+nextEventStart)/2;var xPos=timeAxisHeight+Math.round(eventMiddle*(width-2*timeAxisHeight)/MINUTES_IN_DAY);var _getSelectedDayHeight=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getSelectedDayHeight */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* getWeekHeight */])(height),numEventsInSelectedDay),otherDayHeight=_getSelectedDayHeight.otherDayHeight,selectedDayHeight=_getSelectedDayHeight.selectedDayHeight;var yPos=controlPanelHeight+timeAxisHeight+Math.round(otherDayHeight*selectedDay+(eventIndex+1.1)*selectedDayHeight/numEventsInSelectedDay);var arrowSize=15;var textContainerWidth=controlPanelHeight*5;var textContainerLeftPercent=-50;if(xPos-textContainerWidth/2<0){textContainerLeftPercent=-xPos*100/textContainerWidth;}if(xPos+textContainerWidth/2>width){textContainerLeftPercent=-100+(width-xPos)*100/textContainerWidth;}return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["b" /* Container */],{style:{transform:'translate3d('+xPos+'px, '+yPos+'px, 0)'}},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["a" /* Arrow */],{arrowSize:arrowSize}),__WEBPACK_IMPORTED_MODULE_6_react__["createElement"]('div',{style:{transform:'translateY('+-arrowSize+'px)'}},__WEBPACK_IMPORTED_MODULE_6_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__style__["c" /* TextContainer */],{leftTranslation:textContainerLeftPercent,style:{width:textContainerWidth}},formatMessage(__WEBPACK_IMPORTED_MODULE_4__core_domains_schedule_intl__["a" /* default */].tooltipMessage))));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_intl__["g" /* injectIntl */])(Event));

/***/ }),
/* 2491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Arrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TextContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['to { opacity: 1; }'],['to { opacity: 1; }']),_templateObject2=_taggedTemplateLiteral(['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n'],['\n    animation: ',' ',' ',' forwards;\n    animation-delay: ',';\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n']),_templateObject3=_taggedTemplateLiteral(['\n\tborder: solid ','px ',';\n\tborder-bottom-width: 0;\n\tborder-left-color: transparent;\n\tborder-right-color: transparent\n\tposition: absolute;\n\ttransform: translate3d(-','px, -','px, 0);\n\twidth: 0;\n'],['\n\tborder: solid ','px ',';\n\tborder-bottom-width: 0;\n\tborder-left-color: transparent;\n\tborder-right-color: transparent\n\tposition: absolute;\n\ttransform: translate3d(-','px, -','px, 0);\n\twidth: 0;\n']),_templateObject4=_taggedTemplateLiteral(['\n    background-color: ',';\n    border-radius: 2em;\n    color: ',';\n    padding: 0.3em 0.5em;\n    text-align: center;\n    transform: translate3d(','%, -95%, 0);\n'],['\n    background-color: ',';\n    border-radius: 2em;\n    color: ',';\n    padding: 0.3em 0.5em;\n    text-align: center;\n    transform: translate3d(','%, -95%, 0);\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var revealOpacity=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2,revealOpacity,__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */],__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* EASING */],__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DURATION */]);var Arrow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3,function(p){return p.arrowSize;},function(p){return p.theme.mainBrandColor;},function(p){return p.arrowSize;},function(p){return p.arrowSize;});var TextContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4,function(p){return p.theme.mainBrandColor;},function(p){return p.theme.white;},function(p){return p.leftTranslation;});

/***/ }),
/* 2492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2493);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var SequenceCarousel=function SequenceCarousel(_ref){var cancel=_ref.cancel,index=_ref.index,next=_ref.next,onCancel=_ref.onCancel,onNext=_ref.onNext,sequence=_ref.sequence;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* SequenceContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["h" /* SequenceList */],null,[].concat(_toConsumableArray(Array(sequence))).map(function(x,i){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* SequenceItem */],{className:i===index&&'active',key:i},i+1===index?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* PaginationDotActive */],null):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* PaginationDot */],null));})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* ButtonContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* CancelButton */],{alternate:true,onClick:onCancel,type:'button'},cancel),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* NextButton */],{onClick:onNext,type:'button'},next)));};/* harmony default export */ __webpack_exports__["a"] = (SequenceCarousel);

/***/ }),
/* 2493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SequenceContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SequenceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SequenceItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PaginationDot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PaginationDotActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CancelButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NextButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buttons__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['width: 100%;'],['width: 100%;']),_templateObject2=_taggedTemplateLiteral(['\n    overflow: hidden;\n    list-style: none;\n    margin: 0 auto;\n    height: 2em;\n    width: 100%;\n    text-align: center;\n'],['\n    overflow: hidden;\n    list-style: none;\n    margin: 0 auto;\n    height: 2em;\n    width: 100%;\n    text-align: center;\n']),_templateObject3=_taggedTemplateLiteral(['display: inline-block;'],['display: inline-block;']),_templateObject4=_taggedTemplateLiteral(['\n    height: 1em;\n    width: 1em;\n    & g {\n        fill: ',';\n    }\n'],['\n    height: 1em;\n    width: 1em;\n    & g {\n        fill: ',';\n    }\n']),_templateObject5=_taggedTemplateLiteral([''],['']),_templateObject6=_taggedTemplateLiteral(['\n    width: 100%;\n    margin: 0.5em 0;\n'],['\n    width: 100%;\n    margin: 0.5em 0;\n']),_templateObject7=_taggedTemplateLiteral(['\n    width: 9em;\n    margin: 0 0.5em;\n'],['\n    width: 9em;\n    margin: 0 0.5em;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SequenceContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject);var SequenceList=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].ul(_templateObject2);var SequenceItem=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].li(_templateObject3);var PaginationDot=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_icons_svg_icons__["a" /* default */]).attrs({type:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__["a" /* default */].CIRCLE_OUTLINE})(_templateObject4,function(props){return props.theme.primaryFontColor;});var PaginationDotActive=PaginationDot.extend.attrs({type:__WEBPACK_IMPORTED_MODULE_1__core_constants_icons_general_svg__["a" /* default */].CIRCLE_FILLED})(_templateObject5);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject6);var CancelButton=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0__buttons__["b" /* Button */])(_templateObject7);var NextButton=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0__buttons__["b" /* Button */])(_templateObject7);

/***/ }),
/* 2494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Main; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TitleContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ButtonsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Buttons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ModalButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return overlayStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return overlayStyleHidding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArrowContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Arrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buttons__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_icons_svg_icons__ = __webpack_require__(24);
var _templateObject=_taggedTemplateLiteral(['\n\tfrom { transform: translate3d(100vw, 0, 0); }\n\tto { transform: translate3d(0, 0, 0); }\n'],['\n\tfrom { transform: translate3d(100vw, 0, 0); }\n\tto { transform: translate3d(0, 0, 0); }\n']),_templateObject2=_taggedTemplateLiteral(['\n\tfrom { transform: translate3d(0, 0, 0); }\n    to { transform: translate3d(100vw, 0, 0); }\n'],['\n\tfrom { transform: translate3d(0, 0, 0); }\n    to { transform: translate3d(100vw, 0, 0); }\n']),_templateObject3=_taggedTemplateLiteral(['\n    animation: ',' ',' ',' both;\n    background-color: ',';\n    box-shadow: 0 0 0.5em 0 rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    outline: none;\n    position: fixed;\n    width: 100vw;\n    will-change: transform;\n\n    ',';\n'],['\n    animation: ',' ',' ',' both;\n    background-color: ',';\n    box-shadow: 0 0 0.5em 0 rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    outline: none;\n    position: fixed;\n    width: 100vw;\n    will-change: transform;\n\n    ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n        right: 0;\n        width: ','em;\n    '],['\n        right: 0;\n        width: ','em;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n    align-items: center;\n    background-color: ',';\n    display: flex;\n    flex: 0 0 ','em;\n    padding-left: 2em;\n'],['\n    align-items: center;\n    background-color: ',';\n    display: flex;\n    flex: 0 0 ','em;\n    padding-left: 2em;\n']),_templateObject6=_taggedTemplateLiteral(['\n    font-size: 1.5em;\n    width: ',';\n    display: ',';\n    align-items: ',';\n    justify-content: ',';\n'],['\n    font-size: 1.5em;\n    width: ',';\n    display: ',';\n    align-items: ',';\n    justify-content: ',';\n']),_templateObject7=_taggedTemplateLiteral(['\n    flex: 0 0 ',';\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n'],['\n    flex: 0 0 ',';\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n']),_templateObject8=_taggedTemplateLiteral(['\n    background-color: ',';\n    box-shadow: 0 0 0.5em 0 rgba(0, 0, 0, 0.4);\n    flex: 0 0 ','em;\n'],['\n    background-color: ',';\n    box-shadow: 0 0 0.5em 0 rgba(0, 0, 0, 0.4);\n    flex: 0 0 ','em;\n']),_templateObject9=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    height: ','em;\n    justify-content: space-around;\n    padding: 0 8%;\n\n    & > button {\n        padding: 0.6em 2.5em;\n    }\n\n    ',';\n'],['\n    align-items: center;\n    display: flex;\n    height: ','em;\n    justify-content: space-around;\n    padding: 0 8%;\n\n    & > button {\n        padding: 0.6em 2.5em;\n    }\n\n    ',';\n']),_templateObject10=_taggedTemplateLiteral(['\n\t\tmax-width: ','em;\n\t'],['\n\t\tmax-width: ','em;\n\t']),_templateObject11=_taggedTemplateLiteral(['height: 2.6em;'],['height: 2.6em;']),_templateObject12=_taggedTemplateLiteral(['\n    display: inline-block;\n    text-align: center;\n'],['\n    display: inline-block;\n    text-align: center;\n']),_templateObject13=_taggedTemplateLiteral(['\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n'],['\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n']),_templateObject14=_taggedTemplateLiteral(['\n    width: 1.5em;\n    height: 1.5em;\n    margin: 0em;\n    z-index: 200;\n'],['\n    width: 1.5em;\n    height: 1.5em;\n    margin: 0em;\n    z-index: 200;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var maxWidth=28;var titleHeight=4.5;var buttonContainerHeight=4.75;var iconSize=1.5;var contentPadding=2;var reveal=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject);var hide=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject2);var easeOutQuint='cubic-bezier(0.23, 1, 0.32, 1)';var Main=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_modal___default.a)(_templateObject3,function(p){return p.hiding?hide:reveal;},function(p){return p.hiding?'0.7s':'0.3s';},easeOutQuint,function(p){return p.theme.white;},__WEBPACK_IMPORTED_MODULE_2__core_utils_style__["b" /* media */].tablet(_templateObject4,maxWidth));var TitleContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject5,function(p){return p.theme.secondaryLight;},titleHeight);var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject6,function(p){return p.navigationIcon?'calc(100% - '+(iconSize+contentPadding)+'em)':'100%';},function(p){return p.navigationIcon?'flex':'inherit';},function(p){return p.navigationIcon?'center':'inherit';},function(p){return p.navigationIcon?'center':'inherit';});var Content=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject7,function(p){return p.showButtons?'calc(100% - '+(titleHeight+buttonContainerHeight)+'em)':'100%';});var ButtonsContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject8,function(p){return p.theme.white;},buttonContainerHeight);var Buttons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject9,buttonContainerHeight,__WEBPACK_IMPORTED_MODULE_2__core_utils_style__["b" /* media */].tablet(_templateObject10,maxWidth));var ModalButton=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__buttons__["b" /* Button */])(_templateObject11);// Unfortunately we cannot use styled component for the overlay
// as react-modal only accepts inline styling
var overlayStyle={backgroundColor:'rgba(0, 0, 0, 0.4)',bottom:0,left:0,position:'fixed',right:0,top:0,transition:'background-color 0.3s',zIndex:999// 1 less than the alerts
};var overlayStyleHidding=Object.assign({},overlayStyle,{backgroundColor:'rgba(0, 0, 0, 0)'});var StatusSVG=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_4__core_icons_svg_icons__["a" /* default */])(_templateObject12);var ArrowContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject13);var Arrow=StatusSVG.extend(_templateObject14);

/***/ }),
/* 2495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({cancel:{id:'sideModal.cancel',defaultMessage:'Cancel'},save:{id:'sideModal.save',defaultMessage:'Save'}}));

/***/ }),
/* 2496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sticky_component_css__ = __webpack_require__(2497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sticky_component_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sticky_component_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stickyfill__ = __webpack_require__(2498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stickyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stickyfill__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var stickyfill=null;// keep only one instance of stickyfill
var Sticky=function(_React$Component){_inherits(Sticky,_React$Component);function Sticky(){_classCallCheck(this,Sticky);return _possibleConstructorReturn(this,(Sticky.__proto__||Object.getPrototypeOf(Sticky)).apply(this,arguments));}_createClass(Sticky,[{key:'componentDidMount',value:function componentDidMount(){if(stickyfill===null){stickyfill=__WEBPACK_IMPORTED_MODULE_4_stickyfill___default()();}stickyfill.add(this.c);}},{key:'componentDidUpdate',value:function componentDidUpdate(){stickyfill&&stickyfill.rebuild();}},{key:'componentWillUnmount',value:function componentWillUnmount(){stickyfill.remove(this.c);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,className=_props.className,top=_props.top;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()('sticky',className),ref:function ref(c){return _this2.c=c;},style:{top:top}},children);}}]);return Sticky;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);Sticky.propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,top:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string};Sticky.defaultProps={className:'',top:'0rem'};/* harmony default export */ __webpack_exports__["a"] = (Sticky);

/***/ }),
/* 2497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2498 */
/***/ (function(module, exports) {

/*!
 * Stickyfill -- `position: sticky` polyfill
 * v. 1.1.1 | https://github.com/wilddeer/stickyfill
 * Copyright Oleg Korsunsky | http://wd.dizaina.net/
 *
 * MIT License
 */

module.exports = (function(doc, win) {
    if (!doc) {
        doc = document;
    }

    if (!win) {
        win = window;
    }
    
    var watchArray = [],
        scroll,
        initialized = false,
        html = doc.documentElement,
        noop = function() {},
        checkTimer,

        //visibility API strings
        hiddenPropertyName = 'hidden',
        visibilityChangeEventName = 'visibilitychange';

    //fallback to prefixed names in old webkit browsers
    if (doc.webkitHidden !== undefined) {
        hiddenPropertyName = 'webkitHidden';
        visibilityChangeEventName = 'webkitvisibilitychange';
    }

    //test getComputedStyle
    if (!win.getComputedStyle) {
        seppuku();
    }

    //test for native support
    var prefixes = ['', '-webkit-', '-moz-', '-ms-'],
        block = document.createElement('div');

    for (var i = prefixes.length - 1; i >= 0; i--) {
        try {
            block.style.position = prefixes[i] + 'sticky';
        }
        catch(e) {}
        if (block.style.position != '') {
            seppuku();
        }
    }

    updateScrollPos();

    //commit seppuku!
    function seppuku() {
        init = add = rebuild = pause = stop = kill = noop;
    }

    function mergeObjects(targetObj, sourceObject) {
        for (key in sourceObject) {
            if (sourceObject.hasOwnProperty(key)) {
                targetObj[key] = sourceObject[key];
            }
        }
    }

    function parseNumeric(val) {
        return parseFloat(val) || 0;
    }

    function updateScrollPos() {
        scroll = {
            top: win.pageYOffset,
            left: win.pageXOffset
        };
    }

    function onScroll() {
        if (win.pageXOffset != scroll.left) {
            updateScrollPos();
            rebuild();
            return;
        }
        
        if (win.pageYOffset != scroll.top) {
            updateScrollPos();
            recalcAllPos();
        }
    }

    //fixes flickering
    function onWheel(event) {
        setTimeout(function() {
            if (win.pageYOffset != scroll.top) {
                scroll.top = win.pageYOffset;
                recalcAllPos();
            }
        }, 0);
    }

    function recalcAllPos() {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            recalcElementPos(watchArray[i]);
        }
    }

    function recalcElementPos(el) {
        if (!el.inited) return;

        var currentMode = (scroll.top <= el.limit.start? 0: scroll.top >= el.limit.end? 2: 1);

        if (el.mode != currentMode) {
            switchElementMode(el, currentMode);
        }
    }

    //checks whether stickies start or stop positions have changed
    function fastCheck() {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            if (!watchArray[i].inited) continue;

            var deltaTop = Math.abs(getDocOffsetTop(watchArray[i].clone) - watchArray[i].docOffsetTop),
                deltaHeight = Math.abs(watchArray[i].parent.node.offsetHeight - watchArray[i].parent.height);

            if (deltaTop >= 2 || deltaHeight >= 2) return false;
        }
        return true;
    }

    function initElement(el) {
        if (isNaN(parseFloat(el.computed.top)) || el.isCell) return;

        el.inited = true;

        if (!el.clone) clone(el);
        if (el.parent.computed.position != 'absolute' &&
            el.parent.computed.position != 'relative') el.parent.node.style.position = 'relative';

        recalcElementPos(el);

        el.parent.height = el.parent.node.offsetHeight;
        el.docOffsetTop = getDocOffsetTop(el.clone);
    }

    function deinitElement(el) {
        var deinitParent = true;

        el.clone && killClone(el);
        mergeObjects(el.node.style, el.css);

        //check whether element's parent is used by other stickies
        for (var i = watchArray.length - 1; i >= 0; i--) {
            if (watchArray[i].node !== el.node && watchArray[i].parent.node === el.parent.node) {
                deinitParent = false;
                break;
            }
        };

        if (deinitParent) el.parent.node.style.position = el.parent.css.position;
        el.mode = -1;
    }

    function initAll() {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            initElement(watchArray[i]);
        }
    }

    function deinitAll() {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            deinitElement(watchArray[i]);
        }
    }

    function switchElementMode(el, mode) {
        var nodeStyle = el.node.style;

        switch (mode) {
            case 0:
                nodeStyle.position = 'absolute';
                nodeStyle.left = el.offset.left + 'px';
                nodeStyle.right = el.offset.right + 'px';
                nodeStyle.top = el.offset.top + 'px';
                nodeStyle.bottom = 'auto';
                nodeStyle.width = 'auto';
                nodeStyle.marginLeft = 0;
                nodeStyle.marginRight = 0;
                nodeStyle.marginTop = 0;
                break;

            case 1:
                nodeStyle.position = 'fixed';
                nodeStyle.left = el.box.left + 'px';
                nodeStyle.right = el.box.right + 'px';
                nodeStyle.top = el.css.top;
                nodeStyle.bottom = 'auto';
                nodeStyle.width = 'auto';
                nodeStyle.marginLeft = 0;
                nodeStyle.marginRight = 0;
                nodeStyle.marginTop = 0;
                break;

            case 2:
                nodeStyle.position = 'absolute';
                nodeStyle.left = el.offset.left + 'px';
                nodeStyle.right = el.offset.right + 'px';
                nodeStyle.top = 'auto';
                nodeStyle.bottom = 0;
                nodeStyle.width = 'auto';
                nodeStyle.marginLeft = 0;
                nodeStyle.marginRight = 0;
                break;
        }

        el.mode = mode;
    }

    function clone(el) {
        el.clone = document.createElement('div');

        var refElement = el.node.nextSibling || el.node,
            cloneStyle = el.clone.style;

        cloneStyle.height = el.height + 'px';
        cloneStyle.width = el.width + 'px';
        cloneStyle.marginTop = el.computed.marginTop;
        cloneStyle.marginBottom = el.computed.marginBottom;
        cloneStyle.marginLeft = el.computed.marginLeft;
        cloneStyle.marginRight = el.computed.marginRight;
        cloneStyle.padding = cloneStyle.border = cloneStyle.borderSpacing = 0;
        cloneStyle.fontSize = '1em';
        cloneStyle.position = 'static';
        cloneStyle.cssFloat = el.computed.cssFloat;

        el.node.parentNode.insertBefore(el.clone, refElement);
    }

    function killClone(el) {
        el.clone.parentNode.removeChild(el.clone);
        el.clone = undefined;
    }

    function getElementParams(node) {
        var computedStyle = getComputedStyle(node),
            parentNode = node.parentNode,
            parentComputedStyle = getComputedStyle(parentNode),
            cachedPosition = node.style.position;

        node.style.position = 'relative';

        var computed = {
                top: computedStyle.top,
                marginTop: computedStyle.marginTop,
                marginBottom: computedStyle.marginBottom,
                marginLeft: computedStyle.marginLeft,
                marginRight: computedStyle.marginRight,
                cssFloat: computedStyle.cssFloat
            },
            numeric = {
                top: parseNumeric(computedStyle.top),
                marginBottom: parseNumeric(computedStyle.marginBottom),
                paddingLeft: parseNumeric(computedStyle.paddingLeft),
                paddingRight: parseNumeric(computedStyle.paddingRight),
                borderLeftWidth: parseNumeric(computedStyle.borderLeftWidth),
                borderRightWidth: parseNumeric(computedStyle.borderRightWidth)
            };

        node.style.position = cachedPosition;

        var css = {
                position: node.style.position,
                top: node.style.top,
                bottom: node.style.bottom,
                left: node.style.left,
                right: node.style.right,
                width: node.style.width,
                marginTop: node.style.marginTop,
                marginLeft: node.style.marginLeft,
                marginRight: node.style.marginRight
            },
            nodeOffset = getElementOffset(node),
            parentOffset = getElementOffset(parentNode),
            
            parent = {
                node: parentNode,
                css: {
                    position: parentNode.style.position
                },
                computed: {
                    position: parentComputedStyle.position
                },
                numeric: {
                    borderLeftWidth: parseNumeric(parentComputedStyle.borderLeftWidth),
                    borderRightWidth: parseNumeric(parentComputedStyle.borderRightWidth),
                    borderTopWidth: parseNumeric(parentComputedStyle.borderTopWidth),
                    borderBottomWidth: parseNumeric(parentComputedStyle.borderBottomWidth)
                }
            },

            el = {
                node: node,
                box: {
                    left: nodeOffset.win.left,
                    right: html.clientWidth - nodeOffset.win.right
                },
                offset: {
                    top: nodeOffset.win.top - parentOffset.win.top - parent.numeric.borderTopWidth,
                    left: nodeOffset.win.left - parentOffset.win.left - parent.numeric.borderLeftWidth,
                    right: -nodeOffset.win.right + parentOffset.win.right - parent.numeric.borderRightWidth
                },
                css: css,
                isCell: computedStyle.display == 'table-cell',
                computed: computed,
                numeric: numeric,
                width: nodeOffset.win.right - nodeOffset.win.left,
                height: nodeOffset.win.bottom - nodeOffset.win.top,
                mode: -1,
                inited: false,
                parent: parent,
                limit: {
                    start: nodeOffset.doc.top - numeric.top,
                    end: parentOffset.doc.top + parentNode.offsetHeight - parent.numeric.borderBottomWidth -
                        node.offsetHeight - numeric.top - numeric.marginBottom
                }
            };

        return el;
    }

    function getDocOffsetTop(node) {
        var docOffsetTop = 0;

        while (node) {
            docOffsetTop += node.offsetTop;
            node = node.offsetParent;
        }

        return docOffsetTop;
    }

    function getElementOffset(node) {
        var box = node.getBoundingClientRect();

            return {
                doc: {
                    top: box.top + win.pageYOffset,
                    left: box.left + win.pageXOffset
                },
                win: box
            };
    }

    function startFastCheckTimer() {
        checkTimer = setInterval(function() {
            !fastCheck() && rebuild();
        }, 500);
    }

    function stopFastCheckTimer() {
        clearInterval(checkTimer);
    }

    function handlePageVisibilityChange() {
        if (!initialized) return;

        if (document[hiddenPropertyName]) {
            stopFastCheckTimer();
        }
        else {
            startFastCheckTimer();
        }
    }

    function init() {
        if (initialized) return;

        updateScrollPos();
        initAll();

        win.addEventListener('scroll', onScroll);
        win.addEventListener('wheel', onWheel);

        //watch for width changes
        win.addEventListener('resize', rebuild);
        win.addEventListener('orientationchange', rebuild);

        //watch for page visibility
        doc.addEventListener(visibilityChangeEventName, handlePageVisibilityChange);

        startFastCheckTimer();

        initialized = true;
    }

    function rebuild() {
        if (!initialized) return;

        deinitAll();
        
        for (var i = watchArray.length - 1; i >= 0; i--) {
            watchArray[i] = getElementParams(watchArray[i].node);
        }
        
        initAll();
    }

    function pause() {
        win.removeEventListener('scroll', onScroll);
        win.removeEventListener('wheel', onWheel);
        win.removeEventListener('resize', rebuild);
        win.removeEventListener('orientationchange', rebuild);
        doc.removeEventListener(visibilityChangeEventName, handlePageVisibilityChange);

        stopFastCheckTimer();

        initialized = false;
    }

    function stop() {
        pause();
        deinitAll(); 
    }

    function kill() {
        stop();

        //empty the array without loosing the references,
        //the most performant method according to http://jsperf.com/empty-javascript-array
        while (watchArray.length) {
            watchArray.pop();
        }
    }

    function add(node) {
        //check if Stickyfill is already applied to the node
        for (var i = watchArray.length - 1; i >= 0; i--) {
            if (watchArray[i].node === node) return;
        };

        var el = getElementParams(node);

        watchArray.push(el);

        if (!initialized) {
            init();
        }
        else {
            initElement(el);
        }
    }

    function remove(node) {
        for (var i = watchArray.length - 1; i >= 0; i--) {
            if (watchArray[i].node === node) {
                deinitElement(watchArray[i]);
                watchArray.splice(i, 1);
            }
        };
    }

    //expose Stickyfill
    return {
        stickies: watchArray,
        add: add,
        remove: remove,
        init: init,
        rebuild: rebuild,
        pause: pause,
        stop: stop,
        kill: kill
    };
})

/***/ }),
/* 2499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_last__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_first__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_findIndex__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_constants_periods__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bar_graph_constants__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bar_graph__ = __webpack_require__(2500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__core_utils_colour__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__intl__ = __webpack_require__(2512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment_timezone__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var YDOMAIN=__WEBPACK_IMPORTED_MODULE_7__bar_graph_constants__["a" /* barColourModes */].YDOMAIN;/************************
 *   Helper functions   *
 ************************/var _injectXLabels=function _injectXLabels(graphData,resolution,timezone){return graphData.map(function(entry){var _labelMap;var entryDate=__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(entry.date).tz(timezone);var labelMap=(_labelMap={},_defineProperty(_labelMap,__WEBPACK_IMPORTED_MODULE_4__core_constants_periods__["TODAY"].resolution,entryDate.format('HH:mm')),_defineProperty(_labelMap,__WEBPACK_IMPORTED_MODULE_4__core_constants_periods__["THIS_WEEK"].resolution,entryDate.format('ddd MMM DD')),_defineProperty(_labelMap,__WEBPACK_IMPORTED_MODULE_4__core_constants_periods__["THIS_MONTH"].resolution,entryDate.format('MMM DD')),_defineProperty(_labelMap,__WEBPACK_IMPORTED_MODULE_4__core_constants_periods__["THIS_YEAR"].resolution,entryDate.format('MMM')),_labelMap);return Object.assign({},entry,{labelX:labelMap[resolution]});});};var minDayLength=47;var minWeekLength=7;var minYearLength=12;var getMinMonthLength=function getMinMonthLength(d){return __WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(d).endOf('month').date();};var incrementValuesMap=[[30,'m'],[30,'m'],[1,'d'],[1,'d'],[1,'d'],[1,'d'],[1,'M']];var getMappedPeriodItem=function getMappedPeriodItem(PERIOD,propertyMap){var index=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_findIndex___default()(function(x){return __WEBPACK_IMPORTED_MODULE_4__core_constants_periods__[x].constant===PERIOD;},Object.keys(__WEBPACK_IMPORTED_MODULE_4__core_constants_periods__));return index>-1?propertyMap[index]:__WEBPACK_IMPORTED_MODULE_2_lodash_fp_first___default()(propertyMap);};var _padHistoryData=function _padHistoryData(history,period){if(history.length===0){return history;}var firstItemDate=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_first___default()(history).date;var lastItemDate=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default()(history).date;var PERIOD=period.constant;var minLengthMap=[minDayLength,minDayLength,minWeekLength,minWeekLength,getMinMonthLength(lastItemDate),getMinMonthLength(lastItemDate),minYearLength];var firstPeriodValuesMap=[__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).hour(),__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).hour(),(__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).weekday()+1)%7,(__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).weekday()+1)%7,__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).date()-1,__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).date()-1,__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).month()];var startOfPeriodValuesMap=[__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).startOf('day'),__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).startOf('day'),__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).startOf('week').subtract(1,'day'),__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).startOf('week').subtract(1,'day'),__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).startOf('month'),__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).startOf('month'),__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(firstItemDate).startOf('year')];var minLength=getMappedPeriodItem(PERIOD,minLengthMap);var incrementValues=getMappedPeriodItem(PERIOD,incrementValuesMap);var firstPeriodValue=getMappedPeriodItem(PERIOD,firstPeriodValuesMap);var startOfPeriodValue=getMappedPeriodItem(PERIOD,startOfPeriodValuesMap);var defaultValue=0;var granularity='minutes';if(Array.isArray(incrementValues)){granularity=incrementValues[1]==='d'?'days':incrementValues[1]==='M'?'months':'minutes';}var finalHistoryData=history;if(typeof firstPeriodValue==='number'&&firstPeriodValue!==0){var iterations=PERIOD===__WEBPACK_IMPORTED_MODULE_4__core_constants_periods__["TODAY"].constant||PERIOD===__WEBPACK_IMPORTED_MODULE_4__core_constants_periods__["YESTERDAY"].constant?firstPeriodValue*2:firstPeriodValue;finalHistoryData=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,iterations).reduce(function(all,item,index){var _moment;if(index===0){return[{date:startOfPeriodValue.valueOf(),value:defaultValue}];}return[].concat(_toConsumableArray(all),[{date:(_moment=__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default()(all).date)).add.apply(_moment,_toConsumableArray(incrementValues)).valueOf(),value:defaultValue}]);},[])),_toConsumableArray(history));}if(typeof minLength==='number'&&finalHistoryData.length<minLength){var fillDateGaps=finalHistoryData.reduce(function(all,item,index){if(index===0){return[item];}var lastDate=__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default()(all).date);var currentDate=__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(item.date);var diff=currentDate.diff(lastDate,granularity);var timeStep=__WEBPACK_IMPORTED_MODULE_2_lodash_fp_first___default()(incrementValues);var diffTotal=diff/timeStep;if(diff>timeStep){var fillerItems=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,diffTotal-1).reduce(function(agg,item,index){var _moment2;if(index===0){return[{date:lastDate.add.apply(lastDate,_toConsumableArray(incrementValues)).valueOf(),value:defaultValue}];}return[].concat(_toConsumableArray(agg),[{date:(_moment2=__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default()(agg).date)).add.apply(_moment2,_toConsumableArray(incrementValues)).valueOf(),value:defaultValue}]);},[]);return[].concat(_toConsumableArray(all),_toConsumableArray(fillerItems),[item]);}return[].concat(_toConsumableArray(all),[item]);},[]);var missingEntries=minLength-fillDateGaps.length;return __WEBPACK_IMPORTED_MODULE_0_lodash_fp_range___default()(0,missingEntries).reduce(function(all){var _moment3;return[].concat(_toConsumableArray(all),[{date:(_moment3=__WEBPACK_IMPORTED_MODULE_11_moment_timezone___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_last___default()(all).date)).add.apply(_moment3,_toConsumableArray(incrementValues)).valueOf(),value:defaultValue}]);},fillDateGaps);}return finalHistoryData;};var _mapGraphData=function _mapGraphData(graphData,selectedPeriod,timezone){if(graphData.length){var history=_padHistoryData(graphData,selectedPeriod);return _injectXLabels(history,selectedPeriod.resolution,timezone);}return graphData;};/*****************
 *   Component   *
 *****************/var TemperatureGraphComponent=function TemperatureGraphComponent(_ref){var _ref$animDuration=_ref.animDuration,animDuration=_ref$animDuration===undefined?500:_ref$animDuration,graphData=_ref.graphData,_ref$graphStyles=_ref.graphStyles,graphStyles=_ref$graphStyles===undefined?{axisColour:'rgb(47, 68, 78)',barColours:Object(__WEBPACK_IMPORTED_MODULE_9__core_utils_colour__["f" /* getRangeColourStrings */])(32,0).reverse(),barColourMode:YDOMAIN,fontColour:'rgb(47, 68, 78)',fontFamily:'Bariol, Arial',fontSize:'1em'}:_ref$graphStyles,timezone=_ref.timezone,formatMessage=_ref.intl.formatMessage,noData=_ref.noData,period=_ref.period,_ref$xDomain=_ref.xDomain,xDomain=_ref$xDomain===undefined?'date':_ref$xDomain,_ref$yDomain=_ref.yDomain,yDomain=_ref$yDomain===undefined?'value':_ref$yDomain;return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__bar_graph__["a" /* default */],{animDuration:animDuration,graphData:_mapGraphData(graphData,period,timezone),graphStyles:graphStyles,noData:noData,noDataMessage:formatMessage(__WEBPACK_IMPORTED_MODULE_10__intl__["a" /* default */].noDataMessage),xDomain:xDomain,yDomain:yDomain});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["g" /* injectIntl */])(TemperatureGraphComponent));

/***/ }),
/* 2500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(2501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graph_tool_tip__ = __webpack_require__(2502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_dom_resize__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__graph__ = __webpack_require__(2503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__indicators_loading__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__intl__ = __webpack_require__(2511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants__ = __webpack_require__(217);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var BAR_AMOUNT_LIMIT=__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* responsiveVars */].BAR_AMOUNT_LIMIT,GRAPH_WIDTH_MEDIUM=__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* responsiveVars */].GRAPH_WIDTH_MEDIUM,GRAPH_HEIGHT_COEF_MEDIUM=__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* responsiveVars */].GRAPH_HEIGHT_COEF_MEDIUM,GRAPH_HEIGHT_COEF_SMALL=__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* responsiveVars */].GRAPH_HEIGHT_COEF_SMALL,GRAPH_MAX_HEIGHT_COEF=__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* responsiveVars */].GRAPH_MAX_HEIGHT_COEF,GUTTER_SPACING_L=__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* responsiveVars */].GUTTER_SPACING_L,GUTTER_SPACING_S=__WEBPACK_IMPORTED_MODULE_9__constants__["b" /* responsiveVars */].GUTTER_SPACING_S;var maxHeight=window.innerHeight-GRAPH_MAX_HEIGHT_COEF;var getCompHeight=function getCompHeight(compWidth){var compHeight=compWidth<GRAPH_WIDTH_MEDIUM?compWidth*GRAPH_HEIGHT_COEF_SMALL:compWidth*GRAPH_HEIGHT_COEF_MEDIUM;return Math.min(compHeight,maxHeight);};var getGutterSize=function getGutterSize(dataLength){return dataLength<BAR_AMOUNT_LIMIT?GUTTER_SPACING_L:GUTTER_SPACING_S;};var BarGraph=function(_React$Component){_inherits(BarGraph,_React$Component);function BarGraph(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BarGraph);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BarGraph.__proto__||Object.getPrototypeOf(BarGraph)).call.apply(_ref,[this].concat(args))),_this),_this.state={toolTipData:{backgroundColour:__WEBPACK_IMPORTED_MODULE_1__graph_tool_tip__["b" /* initialValues */].backgroundColour,x:__WEBPACK_IMPORTED_MODULE_1__graph_tool_tip__["b" /* initialValues */].x,xLabel:__WEBPACK_IMPORTED_MODULE_1__graph_tool_tip__["b" /* initialValues */].xLabel,y:__WEBPACK_IMPORTED_MODULE_1__graph_tool_tip__["b" /* initialValues */].y,yLabel:__WEBPACK_IMPORTED_MODULE_1__graph_tool_tip__["b" /* initialValues */].yLabel}},_this.handleSelectedBarValue=function(barData){_this.setState({toolTipData:Object.assign({},barData,{yLabel:barData.yLabel+'\xB0'})});},_this.handleResetBarValue=function(){return _this.setState({toolTipData:Object.assign({},__WEBPACK_IMPORTED_MODULE_1__graph_tool_tip__["b" /* initialValues */])});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BarGraph,[{key:'render',value:function render(){var _this2=this;var _props=this.props,animDuration=_props.animDuration,graphData=_props.graphData,graphStyles=_props.graphStyles,_props$gutter=_props.gutter,gutter=_props$gutter===undefined?getGutterSize(graphData.length):_props$gutter,noData=_props.noData,noDataMessage=_props.noDataMessage,_props$margin=_props.margin,margin=_props$margin===undefined?{top:20,left:30,bottom:50,right:30}:_props$margin,xDomain=_props.xDomain,yDomain=_props.yDomain,_props$yTicksInterval=_props.yTicksInterval,yTicksInterval=_props$yTicksInterval===undefined?5:_props$yTicksInterval;var toolTipData=this.state.toolTipData;return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__dom_dom_resize__["a" /* default */],null,function(_ref2){var width=_ref2.width;var compHeight=getCompHeight(width);return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* LoadingContainer */],{noData:noData},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__indicators_loading__["a" /* default */],{isLoading:!graphData.length})),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* NoDataContainer */],{height:compHeight-margin.bottom,noData:noData},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["e" /* NoDataMsgContainer */],{containerHeight:compHeight-margin.bottom},!noDataMessage&&__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_6__intl__["a" /* default */].noDataMessage),noDataMessage&&__WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('span',null,noDataMessage))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* GraphContainer */],{beInvisible:!graphData.length,height:compHeight},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__graph_tool_tip__["a" /* default */],toolTipData),graphData.length&&compHeight>0&&__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__graph__["a" /* default */],{animDuration:animDuration,compHeight:compHeight,compWidth:width,graphData:graphData,graphStyles:graphStyles,gutter:gutter,margin:margin,resetSelectedBarValue:_this2.handleResetBarValue,setSelectedBarValue:_this2.handleSelectedBarValue,xDomain:xDomain,yDomain:yDomain,yTicksInterval:yTicksInterval})));});}}]);return BarGraph;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);BarGraph.propTypes={animDuration:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,graphData:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array.isRequired,graphStyles:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({axisColour:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,barColours:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired).isRequired,barColourMode:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,fontColour:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,fontFamily:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,fontSize:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired}),gutter:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,margin:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({top:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,left:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,bottom:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,right:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number}),noData:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,noDataMessage:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,xDomain:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,yDomain:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,yTicksInterval:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (BarGraph);

/***/ }),
/* 2501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LoadingContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GraphContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NoDataContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NoDataMsgContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polished__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['position: relative;'],['position: relative;']),_templateObject2=_taggedTemplateLiteral(['\n    display: ',';\n    position: absolute;\n    width: 100%;\n'],['\n    display: ',';\n    position: absolute;\n    width: 100%;\n']),_templateObject3=_taggedTemplateLiteral(['\n    display: block;\n    height: ',';\n    position: relative;\n    visibility: ',';\n'],['\n    display: block;\n    height: ',';\n    position: relative;\n    visibility: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    background: ',';\n    height: ',';\n    opacity: ',';\n    position: absolute;\n    transition: opacity 0.5s ease-out;\n    width: 100%;\n'],['\n    background: ',';\n    height: ',';\n    opacity: ',';\n    position: absolute;\n    transition: opacity 0.5s ease-out;\n    width: 100%;\n']),_templateObject5=_taggedTemplateLiteral(['\n    border: ',';\n    border-radius: 3px;\n    margin-left: 10%;\n    padding: 10px 0;\n    text-align: center;\n    transform: ',';\n    width: 80%;\n'],['\n    border: ',';\n    border-radius: 3px;\n    margin-left: 10%;\n    padding: 10px 0;\n    text-align: center;\n    transform: ',';\n    width: 80%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject);var LoadingContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject2,function(_ref){var noData=_ref.noData;return noData?'none':'block';});var GraphContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject3,function(_ref2){var height=_ref2.height;return height+'px';},function(_ref3){var beInvisible=_ref3.beInvisible;return beInvisible?'hidden':'visible';});var NoDataContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4,function(_ref4){var theme=_ref4.theme;return theme.lightGrey;},function(_ref5){var height=_ref5.height;return height+'px';},function(_ref6){var noData=_ref6.noData;return noData?1:0;});var NoDataMsgContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject5,function(_ref7){var theme=_ref7.theme;return'3px solid '+Object(__WEBPACK_IMPORTED_MODULE_0_polished__["f" /* transparentize */])(0.5,theme.error);},function(_ref8){var containerHeight=_ref8.containerHeight;return'translateY('+(containerHeight/2-20)+'px)';});

/***/ }),
/* 2502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_colour__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(217);
var _templateObject=_taggedTemplateLiteral(['\n\t0% { opacity: 0; }\n\t100% { opacity: 1; }\n'],['\n\t0% { opacity: 0; }\n\t100% { opacity: 1; }\n']),_templateObject2=_taggedTemplateLiteral(['\n    animation: ',';\n    height: ',';\n    position: absolute;\n    transition: transform 0.3s ease;\n    transform: ',';\n    width: ',';\n'],['\n    animation: ',';\n    height: ',';\n    position: absolute;\n    transition: transform 0.3s ease;\n    transform: ',';\n    width: ',';\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// @noflow
var fadeIn=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject);var SVGElem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].svg(_templateObject2,function(){return fadeIn+' 0.25s linear';},function(_ref){var height=_ref.height;return height+'px';},function(_ref2){var x=_ref2.x,y=_ref2.y;return'translate3d('+x+'px, '+y+'px, 0)';},function(_ref3){var width=_ref3.width;return width+'px';});var MIDDLE=__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* textAnchor */].MIDDLE;var defaultTextStyles={fontFamily:'Bariol, Arial',fontSize:'1em',fill:'#FFFFFF'};var circleRadius=50;var triangleHeight=10;var triangleHeightHalf=triangleHeight/2;var initialValues={backgroundColour:Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_colour__["d" /* getColour */])(32),x:-(circleRadius*2),xLabel:'',y:-(circleRadius*2),yLabel:''};var _getPolyPoints=function _getPolyPoints(){var x1=circleRadius-triangleHeightHalf;var y1=circleRadius*2-1;var x2=x1+triangleHeight;var y2=y1+triangleHeight;var x3=x1+triangleHeightHalf;return[x1,y1,x2,y1,x3,y2,x1,y1].join(',');};var propTypes={backgroundColour:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,textStyleX:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({fontFamily:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,fontSize:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,fill:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}),textStyleY:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({fontFamily:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,fontSize:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,fill:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}),x:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,xLabel:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),y:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,yLabel:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string])};var GraphToolTip=function GraphToolTip(_ref4){var _ref4$backgroundColou=_ref4.backgroundColour,backgroundColour=_ref4$backgroundColou===undefined?initialValues.backgroundColour:_ref4$backgroundColou,_ref4$textStyleX=_ref4.textStyleX,textStyleX=_ref4$textStyleX===undefined?defaultTextStyles:_ref4$textStyleX,_ref4$textStyleY=_ref4.textStyleY,textStyleY=_ref4$textStyleY===undefined?Object.assign({},defaultTextStyles,{fontSize:'1.6em'}):_ref4$textStyleY,_ref4$x=_ref4.x,x=_ref4$x===undefined?initialValues.x:_ref4$x,_ref4$xLabel=_ref4.xLabel,xLabel=_ref4$xLabel===undefined?initialValues.xLabel:_ref4$xLabel,_ref4$y=_ref4.y,y=_ref4$y===undefined?initialValues.y:_ref4$y,_ref4$yLabel=_ref4.yLabel,yLabel=_ref4$yLabel===undefined?initialValues.yLabel:_ref4$yLabel;var textStyleXCombined=Object.assign({},textStyleX,{textAnchor:MIDDLE});var textStyleYCombined=Object.assign({},textStyleY,{textAnchor:MIDDLE});var shapeStyle={fill:backgroundColour};var svgX=x-circleRadius;var svgY=y-circleRadius*2-triangleHeight;var polyPoints=_getPolyPoints();var yTextY=circleRadius+4;var xTextY=circleRadius+25;var shouldRender=x!==initialValues.x&&y!==initialValues.y;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('div',null,shouldRender&&__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](SVGElem,{height:circleRadius*2+triangleHeight,name:'GraphToolTip',width:circleRadius*2,x:svgX,y:svgY},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('polygon',{points:polyPoints,style:shapeStyle}),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('circle',{cx:circleRadius,cy:circleRadius,r:circleRadius,style:shapeStyle}),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('text',{style:textStyleYCombined,x:circleRadius,y:yTextY},yLabel),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('text',{style:textStyleXCombined,x:circleRadius,y:xTextY},xLabel)));};GraphToolTip.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (GraphToolTip);

/***/ }),
/* 2503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_last__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axis__ = __webpack_require__(2504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bars__ = __webpack_require__(2509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// @noflow
/************************
 *   Helper functions   *
 ************************/var _injectBarHeights=function _injectBarHeights(barChartData,offsetHeight,yDomain,yMaxValue){var yIncr=yMaxValue?offsetHeight/yMaxValue:0;return barChartData.map(function(obj){return Object.assign({},obj,{height:Math.floor(yIncr*obj[yDomain])});});};var _injectBarWidths=function _injectBarWidths(barChartData,barWidth){return barChartData.map(function(obj){return Object.assign({},obj,{width:barWidth});});};var _injectBarX=function _injectBarX(barChartData,gutter,marginLeft){return barChartData.map(function(obj,i){return Object.assign({},obj,{x:marginLeft+obj.width*i+gutter*i});});};var _injectBarY=function _injectBarY(barChartData,offsetHeight,marginTop){return barChartData.map(function(obj){return Object.assign({},obj,{y:Math.floor(offsetHeight-obj.height+marginTop)});});};var _getBarChartData=function _getBarChartData(_ref){var compHeight=_ref.compHeight,compWidth=_ref.compWidth,graphData=_ref.graphData,gutter=_ref.gutter,margin=_ref.margin,yDomain=_ref.yDomain,yTicksInterval=_ref.yTicksInterval;var offsetHeight=compHeight-margin.top-margin.bottom;var offsetWidth=compWidth-margin.left-margin.right;var yHighestValue=Math.max.apply(Math,_toConsumableArray(graphData.map(function(obj){return obj[yDomain];})));var yTicksRemainder=yHighestValue%yTicksInterval;var yMaxValue=yTicksRemainder>0?yHighestValue-yTicksRemainder+yTicksInterval:yHighestValue;var barWidth=offsetWidth/graphData.length-gutter;var barChartData=graphData.map(function(obj){return Object.assign({},obj);});barChartData=_injectBarHeights(barChartData,offsetHeight,yDomain,yMaxValue);barChartData=_injectBarWidths(barChartData,barWidth);barChartData=_injectBarX(barChartData,gutter,margin.left);barChartData=_injectBarY(barChartData,offsetHeight,margin.top);return barChartData;};/*****************
 *   Component   *
 *****************/var Graph=function(_React$Component){_inherits(Graph,_React$Component);function Graph(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Graph);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Graph.__proto__||Object.getPrototypeOf(Graph)).call.apply(_ref2,[this].concat(args))),_this),_this.renderGraph=function(){var _this$props=_this.props,animDuration=_this$props.animDuration,compHeight=_this$props.compHeight,compWidth=_this$props.compWidth,graphStyles=_this$props.graphStyles,gutter=_this$props.gutter,margin=_this$props.margin,resetSelectedBarValue=_this$props.resetSelectedBarValue,setSelectedBarValue=_this$props.setSelectedBarValue,xDomain=_this$props.xDomain,yDomain=_this$props.yDomain,yTicksInterval=_this$props.yTicksInterval;var barChartData=_getBarChartData(_this.props);var axisColour=graphStyles.axisColour,barColours=graphStyles.barColours,barColourMode=graphStyles.barColourMode,fontColour=graphStyles.fontColour,fontFamily=graphStyles.fontFamily,fontSize=graphStyles.fontSize;var axisStyles={axisColour:axisColour,fontColour:fontColour,fontFamily:fontFamily,fontSize:fontSize};return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__bars__["a" /* default */],{animDuration:animDuration,barChartData:barChartData,barColourMode:barColourMode,barColours:barColours,compHeight:compHeight,compWidth:compWidth,gutter:gutter,handleMouseOut:resetSelectedBarValue,handleMouseOver:setSelectedBarValue,marginBottom:margin.bottom,xDomain:xDomain,yDomain:yDomain}),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__axis__["a" /* default */],{axisStyles:axisStyles,barChartData:barChartData,compHeight:compHeight,compWidth:compWidth,margin:margin,xDomain:xDomain,yDomain:yDomain,yTicksInterval:yTicksInterval}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Graph,[{key:'shouldComponentUpdate',// shouldComponentUpdate doesn't do a deep comparison of the graphData for us, so we have to do a manual check
value:function shouldComponentUpdate(nextProps){var _props=this.props,graphData=_props.graphData,xDomain=_props.xDomain,compWidth=_props.compWidth;var nextGraphData=nextProps.graphData,nextCompWidth=nextProps.compWidth;if(nextCompWidth!==compWidth){return true;}if(nextGraphData.length>0&&graphData[0]&&graphData[0][xDomain]){var currentDataFirstDate=graphData[0][xDomain];var currentDataLastDate=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_last___default()(graphData)[xDomain];var nextDataFirstData=nextGraphData[0][xDomain];var nextDataLastDate=__WEBPACK_IMPORTED_MODULE_0_lodash_fp_last___default()(nextGraphData)[xDomain];return currentDataFirstDate!==nextDataFirstData&&currentDataLastDate!==nextDataLastDate||graphData.length!==nextGraphData.length;}return true;}},{key:'render',value:function render(){var _props2=this.props,compHeight=_props2.compHeight,compWidth=_props2.compWidth;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('svg',{height:compHeight,name:'Graph',width:compWidth},this.renderGraph());}}]);return Graph;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);Graph.propTypes={animDuration:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,compHeight:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,compWidth:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,graphData:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,graphStyles:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({axisColour:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,barColours:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array.isRequired,barColourMode:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,fontColour:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,fontFamily:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,fontSize:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired}),gutter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,margin:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({top:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,left:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,bottom:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,right:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired}),resetSelectedBarValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,setSelectedBarValue:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,xDomain:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,yDomain:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,yTicksInterval:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Graph);

/***/ }),
/* 2504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Axis;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axisX__ = __webpack_require__(2505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axisY__ = __webpack_require__(2507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
// @noflow
function Axis(_ref){var barChartData=_ref.barChartData,compHeight=_ref.compHeight,compWidth=_ref.compWidth,axisStyles=_ref.axisStyles,margin=_ref.margin,xDomain=_ref.xDomain,yDomain=_ref.yDomain,yTicksInterval=_ref.yTicksInterval;return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('svg',{name:'Axis'},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__axisX__["a" /* default */],{axisStyles:axisStyles,barChartData:barChartData,compHeight:compHeight,compWidth:compWidth,margin:margin,xDomain:xDomain}),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__axisY__["a" /* default */],{axisStyles:axisStyles,barChartData:barChartData,compHeight:compHeight,margin:margin,yDomain:yDomain,yTicksInterval:yTicksInterval}));}Axis.propTypes={axisStyles:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({axisColour:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,fontColour:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,fontFamily:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,fontSize:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired}),barChartData:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({labelX:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),width:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,x:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired})).isRequired,compHeight:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,compWidth:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,margin:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({top:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,left:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,bottom:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,right:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired}),xDomain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,yDomain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,yTicksInterval:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired};

/***/ }),
/* 2505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AxisX;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__xTicks__ = __webpack_require__(2506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
// @noflow
function AxisX(_ref){var barChartData=_ref.barChartData,compHeight=_ref.compHeight,compWidth=_ref.compWidth,axisStyles=_ref.axisStyles,margin=_ref.margin,xDomain=_ref.xDomain;var lineStyle={stroke:axisStyles.axisColour};var y=compHeight-margin.bottom;var x2=compWidth-margin.right;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('line',{name:'xAxis',style:lineStyle,x1:margin.left,x2:x2,y1:y,y2:y}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__xTicks__["a" /* default */],{axisStyles:axisStyles,barChartData:barChartData,compHeight:compHeight,compWidth:compWidth,margin:margin,xDomain:xDomain}));}AxisX.propTypes={axisStyles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({axisColour:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,fontFamily:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,fontColour:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,fontSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),barChartData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({labelX:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,x:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired})).isRequired,compHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,compWidth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({top:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,left:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,bottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,right:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}),xDomain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};

/***/ }),
/* 2506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AxisXTicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(217);
// @noflow
var START=__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* textAnchor */].START;var X_TICK_HEIGHT=10;var X_LABEL_Y_OFFSET=20;var textMergeMargin=5;var getSVGTextLength=function getSVGTextLength(_ref){var label=_ref.label,style=_ref.style;if(label&&document&&document.createElementNS){var text=document.createElementNS('SVG','text');var textNode=document.createTextNode(label);text.appendChild(textNode);text.setAttribute('style',style);document.body.appendChild(text);var textWidth=text.getBoundingClientRect().width;document.body.removeChild(text);return textWidth;}return 0;};function AxisXTicks(_ref2){var barChartData=_ref2.barChartData,compHeight=_ref2.compHeight,compWidth=_ref2.compWidth,axisStyles=_ref2.axisStyles,margin=_ref2.margin,xDomain=_ref2.xDomain;var axisColour=axisStyles.axisColour,fontColour=axisStyles.fontColour,fontFamily=axisStyles.fontFamily,fontSize=axisStyles.fontSize;var lineStyle={stroke:axisColour};var textStyle={fontFamily:fontFamily,fontSize:fontSize,stroke:fontColour,textAnchor:START};var y1=compHeight-margin.bottom;var y2=y1+X_TICK_HEIGHT;var y2Halved=y1+X_TICK_HEIGHT/2;var labelY=y2+X_LABEL_Y_OFFSET;var ticks=[];var dataLength=barChartData.length;if(dataLength){var textWidth=getSVGTextLength({label:barChartData[0].labelX,style:textStyle})+textMergeMargin;var lastLabelXPos=0;barChartData.forEach(function(data,i){var x=data.x;var labelX=data.labelX||data[xDomain];var showLabel=x>lastLabelXPos;lastLabelXPos=showLabel?x+textWidth:lastLabelXPos;ticks.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('g',{key:'xTick-'+labelX+'-'+i,name:'xTick'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('line',{style:lineStyle,x1:x,x2:x,y1:y1,y2:showLabel?y2:y2Halved}),showLabel&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('text',{style:textStyle,x:x,y:labelY},labelX)));});/// Adding a last tick at the end
var lastTickX=compWidth-margin.right;ticks.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('g',{key:'xTick-last',name:'xTick'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('line',{style:lineStyle,x1:lastTickX,x2:lastTickX,y1:y1,y2:y2})));}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('g',{name:'xTicks'},ticks);}AxisXTicks.propTypes={axisStyles:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({axisColour:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,fontColour:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,fontFamily:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,fontSize:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired}),barChartData:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({labelX:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]),width:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,x:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired})).isRequired,compHeight:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,compWidth:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,margin:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({top:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,left:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,bottom:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,right:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired}),xDomain:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired};

/***/ }),
/* 2507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AxisY;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__yTicks__ = __webpack_require__(2508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
// @noflow
function AxisY(_ref){var barChartData=_ref.barChartData,compHeight=_ref.compHeight,axisStyles=_ref.axisStyles,margin=_ref.margin,yDomain=_ref.yDomain,yTicksInterval=_ref.yTicksInterval;var lineStyle={stroke:axisStyles.axisColour};var y2=compHeight-margin.bottom;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('line',{name:'yAxis',style:lineStyle,x1:margin.left,x2:margin.left,y1:margin.top,y2:y2}),__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__yTicks__["a" /* default */],{axisStyles:axisStyles,barChartData:barChartData,compHeight:compHeight,margin:margin,yDomain:yDomain,yTicksInterval:yTicksInterval}));}AxisY.propTypes={axisStyles:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({axisColour:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,fontColour:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,fontFamily:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,fontSize:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}),barChartData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({labelX:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,x:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired})).isRequired,compHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,margin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({top:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,left:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,bottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,right:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired}),yDomain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,yTicksInterval:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};

/***/ }),
/* 2508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AxisYTicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(217);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// @noflow
var END=__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* textAnchor */].END;var Y_LABEL_X_OFFSET=10;function AxisYTicks(_ref){var barChartData=_ref.barChartData,compHeight=_ref.compHeight,axisStyles=_ref.axisStyles,margin=_ref.margin,yDomain=_ref.yDomain,yTicksInterval=_ref.yTicksInterval;var axisColour=axisStyles.axisColour,fontColour=axisStyles.fontColour,fontFamily=axisStyles.fontFamily,fontSize=axisStyles.fontSize;var lineStyle={stroke:axisColour};var textStyle={fontFamily:fontFamily,fontSize:fontSize,stroke:fontColour,textAnchor:END};var offsetHeight=compHeight-margin.bottom-margin.top;var yHighestValue=Math.max.apply(Math,_toConsumableArray(barChartData.map(function(obj){return obj[yDomain];})));var yRemainder=yHighestValue%yTicksInterval;var maxY=yRemainder>0?yHighestValue-yRemainder+yTicksInterval:yHighestValue;var yIncr=offsetHeight/maxY;var tickAmount=maxY/yTicksInterval;var ticks=[];var x1=margin.left-Y_LABEL_X_OFFSET;for(var i=0;i<tickAmount+1;i++){var y=margin.top+yIncr*(i*yTicksInterval);var textValue=maxY-i*yTicksInterval;ticks.push(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('g',{key:'yTick-'+textValue,name:'yTick'},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('line',{style:lineStyle,x1:x1,x2:margin.left,y1:y,y2:y}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('text',{style:textStyle,x:x1,y:y},textValue)));}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('g',{name:'yTicks'},ticks);}AxisYTicks.propTypes={axisStyles:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({axisColour:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,fontColour:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,fontFamily:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,fontSize:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired}),barChartData:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({labelX:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]),width:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,x:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired})).isRequired,compHeight:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,margin:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({top:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,left:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,bottom:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,right:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired}),yDomain:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,yTicksInterval:__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired};

/***/ }),
/* 2509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bar__ = __webpack_require__(2510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
// @noflow
var propTypes={animDuration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,barChartData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({labelX:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),width:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,x:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired})).isRequired,barColourMode:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,barColours:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,compHeight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,compWidth:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,gutter:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,handleMouseOut:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,handleMouseOver:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,marginBottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,xDomain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,yDomain:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};var Bars=function Bars(_ref){var animDuration=_ref.animDuration,barChartData=_ref.barChartData,barColours=_ref.barColours,barColourMode=_ref.barColourMode,compWidth=_ref.compWidth,compHeight=_ref.compHeight,gutter=_ref.gutter,handleMouseOver=_ref.handleMouseOver,handleMouseOut=_ref.handleMouseOut,marginBottom=_ref.marginBottom,xDomain=_ref.xDomain,yDomain=_ref.yDomain;var barChartLength=barChartData.length;var actualBarChartLength=barChartData.reduce(function(total,item){return item[yDomain]!==0?total+=1:total;},0);var bars=barChartLength?barChartData.map(function(data,i){var yStart=compHeight-marginBottom;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__bar__["a" /* default */],{actualBarChartLength:actualBarChartLength,animDuration:animDuration,barChartLength:barChartLength,barColourMode:barColourMode,barColours:barColours,compWidth:compWidth,data:data,gutter:gutter,handleMouseOut:handleMouseOut,handleMouseOver:handleMouseOver,index:i,key:'bar-'+data.labelX+'-'+data[yDomain],xDomain:xDomain,yDomain:yDomain,yStart:yStart});}):[__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('rect',{height:'0',key:'bar-0',width:'0',x:'0',y:'0'})];return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('svg',{name:'BarGraphBars'},bars);};Bars.propTypes=propTypes;/* harmony default export */ __webpack_exports__["a"] = (Bars);

/***/ }),
/* 2510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_utils_colour__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_react__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_velocity_react__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// @noflow
var YDOMAIN=__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* barColourModes */].YDOMAIN,XINDEX=__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* barColourModes */].XINDEX,SINGLE=__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* barColourModes */].SINGLE;var BAR_RADIUS_MEDIUM=__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* responsiveVars */].BAR_RADIUS_MEDIUM,BAR_RADIUS_SMALL=__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* responsiveVars */].BAR_RADIUS_SMALL,BAR_AMOUNT_LIMIT=__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* responsiveVars */].BAR_AMOUNT_LIMIT;/************************
 *   Helper functions   *
 ************************/var _getHexColour=function _getHexColour(colour){return colour.includes('#')?colour:Object(__WEBPACK_IMPORTED_MODULE_1__core_utils_colour__["b" /* convertRGBToHex */])(colour);};var _getBarColour=function _getBarColour(_ref){var _colourMap;var barColours=_ref.barColours,barColourMode=_ref.barColourMode,index=_ref.index,yValue=_ref.yValue;var colourMap=(_colourMap={},_defineProperty(_colourMap,YDOMAIN,barColours[parseInt(yValue,10)]),_defineProperty(_colourMap,XINDEX,barColours[index]),_defineProperty(_colourMap,SINGLE,barColours[0]),_colourMap);return _getHexColour(colourMap[barColourMode]||colourMap[SINGLE]);};/*****************
 *   Component   *
 *****************/var BarComponentPropTypes={actualBarChartLength:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,animDuration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,barChartLength:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,barColourMode:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,barColours:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,compWidth:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,data:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({height:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,labelX:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),width:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,x:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,y:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired}).isRequired,gutter:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,handleMouseOut:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,handleMouseOver:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,index:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,xDomain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,yDomain:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,yStart:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired};var BarComponent=function BarComponent(_ref2){var actualBarChartLength=_ref2.actualBarChartLength,animDuration=_ref2.animDuration,barChartLength=_ref2.barChartLength,compWidth=_ref2.compWidth,data=_ref2.data,barColours=_ref2.barColours,barColourMode=_ref2.barColourMode,gutter=_ref2.gutter,handleMouseOver=_ref2.handleMouseOver,handleMouseOut=_ref2.handleMouseOut,index=_ref2.index,xDomain=_ref2.xDomain,yDomain=_ref2.yDomain,yStart=_ref2.yStart;var height=data.height,labelX=data.labelX,width=data.width,x=data.x,y=data.y;var barRadius=barChartLength>BAR_AMOUNT_LIMIT?BAR_RADIUS_SMALL:BAR_RADIUS_MEDIUM;var barColour=_getBarColour({barColours:barColours,barColourMode:barColourMode,index:index,yValue:data[yDomain]});var delayTotal=animDuration*0.5;var delayUnit=delayTotal/actualBarChartLength;var duration=animDuration-delayTotal;var delay=index*delayUnit;var heightStart=0;var startColour=_getHexColour(barColours[0]);var hiddenX=x;var hiddenWidth=width+gutter;var mouseOver=function mouseOver(){return handleMouseOver({backgroundColour:barColour,x:x+width/2,xLabel:labelX||data[xDomain],y:y,yLabel:data[yDomain]});};return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('g',null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_velocity_react__["VelocityComponent"],{animation:{height:[height,heightStart],y:[y,yStart],fill:[barColour,startColour]},delay:delay,duration:duration,easing:'ease-in-out',runOnMount:true},__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('rect',{rx:barRadius,ry:barRadius,width:width,x:x})),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]('rect',{fill:'transparent',height:height,onClick:mouseOver,onMouseEnter:mouseOver,onMouseLeave:handleMouseOut,width:hiddenWidth,x:hiddenX,y:y}));};BarComponent.propTypes=BarComponentPropTypes;/* harmony default export */ __webpack_exports__["a"] = (BarComponent);

/***/ }),
/* 2511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({noDataMessage:{id:'bar-graph.no-data-message',defaultMessage:'The data is empty or not valid.'}}));

/***/ }),
/* 2512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({noDataMessage:{id:'temperature-graph.no-data-message',defaultMessage:'No temperature history is available for this period.'}}));

/***/ }),
/* 2513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_colour__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__spinner_spinner_component__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(2514);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var DEFAULT_FONT='Bariol, Arial, sans-serif';/************************
 *   Helper functions   *
 ************************/var _defineRangeValues=function _defineRangeValues(maxTemp,minTemp,interval,frostProtection,intl){var rangeValues=[];for(var i=maxTemp;i>=minTemp;i-=interval){if(i===frostProtection){rangeValues.push([{text:''+intl.formatNumber(i),coef:1},{text:'N',coef:0.7,font:'HiveGeneralIcons'}]);}else{rangeValues.push([{text:intl.formatNumber(i)+'\xB0',coef:1}]);}}return rangeValues;};var _getCurrentIndex=function _getCurrentIndex(maxTemp,minTemp,interval,currentValue){var temp=currentValue?Math.max(Math.min(currentValue,maxTemp),minTemp):minTemp;return Math.round((maxTemp-temp)/interval);};var _getTemperature=function _getTemperature(maxTemp,interval,index){return maxTemp-index*interval;};/*****************
 *   Component   *
 *****************/var TemperatureSpinner=function(_React$Component){_inherits(TemperatureSpinner,_React$Component);function TemperatureSpinner(props){_classCallCheck(this,TemperatureSpinner);var _this=_possibleConstructorReturn(this,(TemperatureSpinner.__proto__||Object.getPrototypeOf(TemperatureSpinner)).call(this,props));_initialiseProps.call(_this);var currentTemp=props.currentTemp,interval=props.interval,maxTemp=props.maxTemp,minTemp=props.minTemp,frostProtectionValue=props.frostProtectionValue,intl=props.intl;var rangeValues=_defineRangeValues(maxTemp,minTemp,interval,frostProtectionValue,intl);var rangeColors=Object(__WEBPACK_IMPORTED_MODULE_0__core_utils_colour__["g" /* getRangeColours */])(maxTemp,minTemp,interval);var currentIndex=_getCurrentIndex(maxTemp,minTemp,interval,currentTemp);_this.state={currentIndex:currentIndex,rangeColors:rangeColors,rangeValues:rangeValues};return _this;}_createClass(TemperatureSpinner,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){var currentTemp=nextProps.currentTemp,interval=nextProps.interval,maxTemp=nextProps.maxTemp,minTemp=nextProps.minTemp;if(currentTemp!==this.props.currentTemp){var currentIndex=_getCurrentIndex(maxTemp,minTemp,interval,currentTemp);this.setState({currentIndex:currentIndex});}}},{key:'render',value:function render(){var _state=this.state,currentIndex=_state.currentIndex,rangeColors=_state.rangeColors,rangeValues=_state.rangeValues;return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* SpinnerContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__spinner_spinner_component__["a" /* default */],{currentIndex:currentIndex,font:DEFAULT_FONT,handleChangeIndex:this.handleChangeIndex,rangeColors:rangeColors,rangeValues:rangeValues,style:{borderRadius:'100%',height:'100%',position:'absolute',width:'100%'}}));}}]);return TemperatureSpinner;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);TemperatureSpinner.propTypes={currentTemp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,frostProtectionValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,handleChangeTemp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,interval:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,intl:__WEBPACK_IMPORTED_MODULE_3_react_intl__["h" /* intlShape */],maxTemp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,minTemp:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};TemperatureSpinner.defaultProps={interval:1};var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleChangeIndex=function(newIndex){var _props=_this2.props,handleChangeTemp=_props.handleChangeTemp,interval=_props.interval,maxTemp=_props.maxTemp;var newTemperature=_getTemperature(maxTemp,interval,newIndex);handleChangeTemp(newTemperature);_this2.setState({currentIndex:newIndex});};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_intl__["g" /* injectIntl */])(TemperatureSpinner));

/***/ }),
/* 2514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpinnerContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    display: block;\n    padding-bottom: 100%;\n    position: relative;\n    width: 100%;\n'],['\n    display: block;\n    padding-bottom: 100%;\n    position: relative;\n    width: 100%;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SpinnerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__spinner_spinner_component__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__time_units_js__ = __webpack_require__(2517);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*eslint react/no-did-mount-set-state:0*/var DEFAULT_FONT='Bariol, Arial, sans-serif';/************************
 *   Helper functions   *
 ************************/var getAmPmRange=function getAmPmRange(){var hours=[];['am','pm'].forEach(function(period){['12','1','2','3','4','5','6','7','8','9','10','11'].forEach(function(hour){hours.push([{text:hour,coef:1},{text:period,coef:0.3}]);});});return hours;};var getHourAndMinuteIndexes=function getHourAndMinuteIndexes(time){var _time$split=time.split(':'),_time$split2=_slicedToArray(_time$split,2),hours=_time$split2[0],minutes=_time$split2[1];return[parseInt(hours,10),parseInt(minutes,10)];};var getFormattedHours=function getFormattedHours(hours,minutes){return('0'+hours).substr(-2)+':'+('0'+minutes).substr(-2);};/*****************
 *   Component   *
 *****************/var TimeSpinnerComponent=function(_React$Component){_inherits(TimeSpinnerComponent,_React$Component);function TimeSpinnerComponent(props){_classCallCheck(this,TimeSpinnerComponent);var _this=_possibleConstructorReturn(this,(TimeSpinnerComponent.__proto__||Object.getPrototypeOf(TimeSpinnerComponent)).call(this,props));_initialiseProps.call(_this);var _getHourAndMinuteInde=getHourAndMinuteIndexes(props.timeToDisplay),_getHourAndMinuteInde2=_slicedToArray(_getHourAndMinuteInde,2),indexHour=_getHourAndMinuteInde2[0],indexMinute=_getHourAndMinuteInde2[1];_this.state={indexHour:indexHour,indexMinute:indexMinute};return _this;}_createClass(TimeSpinnerComponent,[{key:'componentWillUpdate',value:function componentWillUpdate(nextProps){var timeToDisplay=nextProps.timeToDisplay;if(timeToDisplay!==this.props.timeToDisplay){var _getHourAndMinuteInde3=getHourAndMinuteIndexes(timeToDisplay),_getHourAndMinuteInde4=_slicedToArray(_getHourAndMinuteInde3,2),_indexHour=_getHourAndMinuteInde4[0],_indexMinute=_getHourAndMinuteInde4[1];this.setState({indexHour:_indexHour,indexMinute:_indexMinute});}}},{key:'render',value:function render(){var _props=this.props,bgColor=_props.bgColor,color=_props.color,isAmPmDisplayFormat=_props.isAmPmDisplayFormat,isScheduleFormat=_props.isScheduleFormat,props=_objectWithoutProperties(_props,['bgColor','color','isAmPmDisplayFormat','isScheduleFormat']);var _state=this.state,indexHour=_state.indexHour,indexMinute=_state.indexMinute;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* SpinnerContainer */],{'data-qa':props['data-qa']},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__spinner_spinner_component__["a" /* default */],{bgColor:bgColor,color:color,currentIndex:indexHour,font:DEFAULT_FONT,handleChangeIndex:this.handleChangeHourIndex,isLoop:true,rangeValues:isAmPmDisplayFormat?getAmPmRange():__WEBPACK_IMPORTED_MODULE_4__time_units_js__["a" /* HOURS_RANGE */],style:{width:'100%',height:'100%'}})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* PickerColonContainer */],null,':'),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__spinner_spinner_component__["a" /* default */],{bgColor:bgColor,color:color,currentIndex:indexMinute,font:DEFAULT_FONT,handleChangeIndex:this.handleChangeMinuteIndex,isLoop:true,rangeValues:isScheduleFormat?__WEBPACK_IMPORTED_MODULE_4__time_units_js__["c" /* SCHEDULE_RANGE */]:__WEBPACK_IMPORTED_MODULE_4__time_units_js__["b" /* MINUTES_RANGE */],style:{width:'100%',height:'100%'}})));}}]);return TimeSpinnerComponent;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);TimeSpinnerComponent.defaultProps={bgColor:{r:255,g:255,b:255},color:{r:47,g:68,b:78},handleChangeTime:function handleChangeTime(){return undefined;},isAmPmDisplayFormat:false,isScheduleFormat:false,timeToDisplay:'00:00'};var _initialiseProps=function _initialiseProps(){var _this2=this;this.handleChangeHourIndex=function(newIndexHour){var handleChangeTime=_this2.props.handleChangeTime;var indexMinute=_this2.state.indexMinute;_this2.setState({indexMinute:indexMinute,indexHour:newIndexHour});handleChangeTime(getFormattedHours(newIndexHour,indexMinute));};this.handleChangeMinuteIndex=function(newIndexMinute){var handleChangeTime=_this2.props.handleChangeTime;var indexHour=_this2.state.indexHour;_this2.setState({indexMinute:newIndexMinute,indexHour:indexHour});handleChangeTime(getFormattedHours(indexHour,newIndexMinute));};};/* harmony default export */ __webpack_exports__["a"] = (TimeSpinnerComponent);

/***/ }),
/* 2516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SpinnerContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PickerColonContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    justify-content: center;\n    display: flex;\n    width: 100%;\n    height: 100%;\n'],['\n    justify-content: center;\n    display: flex;\n    width: 100%;\n    height: 100%;\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    flex: 1 0 0rem;\n    font-weight: bold;\n    justify-content: center;\n'],['\n    align-items: center;\n    display: flex;\n    flex: 1 0 0rem;\n    font-weight: bold;\n    justify-content: center;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SpinnerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);var PickerColonContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject2);

/***/ }),
/* 2517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HOURS_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MINUTES_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCHEDULE_RANGE; });
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var succ=function succ(n){return n+1;};var add15=function add15(n){return n+15;};var padLeft=function padLeft(value,padder,padLength){return Array(padLength).fill(padder).concat(value).join('');};var stringify=function stringify(n){return n.toString().length===1?padLeft(n,'0',1):n.toString();};var sequence=function sequence(start,end,nextFn){return start>=end?[stringify(end)]:[stringify(start)].concat(_toConsumableArray(sequence(nextFn(start),end,nextFn)));};var HOURS_RANGE=sequence(0,23,succ);var MINUTES_RANGE=sequence(0,59,succ);var SCHEDULE_RANGE=sequence(0,45,add15);

/***/ }),
/* 2518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__page_title_index__ = __webpack_require__(2519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__page_title_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__h2__ = __webpack_require__(844);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__h2__["a"]; });


/***/ }),
/* 2519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PageTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(2520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
PageTitle.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};function PageTitle(_ref){var children=_ref.children,className=_ref.className,props=_objectWithoutProperties(_ref,['children','className']);return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* HeadingStyles */],{'data-qa':props['data-qa']},children);}

/***/ }),
/* 2520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeadingStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    font-size: 2rem;\n    font-weight: 500;\n    line-height: 2rem;\n    margin-top: 0;\n'],['\n    font-size: 2rem;\n    font-weight: 500;\n    line-height: 2rem;\n    margin-top: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var HeadingStyles=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].h1(_templateObject);

/***/ }),
/* 2521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loading__ = __webpack_require__(355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__loading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login__ = __webpack_require__(2522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__login__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__waiting__ = __webpack_require__(783);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__waiting__["a"]; });


/***/ }),
/* 2522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_application_selectors__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_translations_selectors__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component__ = __webpack_require__(2523);
var mapStateToProps=function mapStateToProps(state){return{isLoading:Object(__WEBPACK_IMPORTED_MODULE_3__core_state_translations_selectors__["b" /* getTranslationsLoading */])(state),isLoggedIn:Object(__WEBPACK_IMPORTED_MODULE_0__core_state_application_selectors__["j" /* getLoginComplete */])(state),showLoginAnimation:Object(__WEBPACK_IMPORTED_MODULE_0__core_state_application_selectors__["n" /* getShowLoginAnimation */])(state)};};var mapDispatchToProps={startLoginAnimation:__WEBPACK_IMPORTED_MODULE_1__core_state_application_actions__["q" /* startLoginAnimation */],stopLoginAnimation:__WEBPACK_IMPORTED_MODULE_1__core_state_application_actions__["r" /* stopLoginAnimation */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_4__component__["a" /* default */]));

/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ANIMATION_DURATION=1440;var LoginIndicator=function(_React$Component){_inherits(LoginIndicator,_React$Component);function LoginIndicator(){_classCallCheck(this,LoginIndicator);return _possibleConstructorReturn(this,(LoginIndicator.__proto__||Object.getPrototypeOf(LoginIndicator)).apply(this,arguments));}_createClass(LoginIndicator,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,isLoggedIn=_props.isLoggedIn,startLoginAnimation=_props.startLoginAnimation,stopLoginAnimation=_props.stopLoginAnimation;if(isLoggedIn){startLoginAnimation();setTimeout(function(){stopLoginAnimation();},ANIMATION_DURATION);}}},{key:'render',value:function render(){var _props2=this.props,isLoading=_props2.isLoading,showLoginAnimation=_props2.showLoginAnimation,children=_props2.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2____["G" /* LoadingIndicator */],{isLoading:isLoading||showLoginAnimation},children));}}]);return LoginIndicator;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoginIndicator);

/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['height: 100vh;'],['height: 100vh;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject);

/***/ }),
/* 2525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_groupBy__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_compose__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
// @noflow
var groupChildren=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_compose___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_groupBy___default()(function(x){return x.type.areaName;}),__WEBPACK_IMPORTED_MODULE_4_react__["Children"].toArray);var ProductPageLayout=function ProductPageLayout(_ref){var children=_ref.children;var childrenByArea=groupChildren(children);return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* FirstRow */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["c" /* ProductState */],{rightLine:!!childrenByArea['ScheduleArea']},childrenByArea['DeviceStateArea']),childrenByArea['ScheduleArea']&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["e" /* ScheduleLayout */],null,childrenByArea['ScheduleArea'])),childrenByArea['GraphArea']&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* GraphLayout */],null,childrenByArea['GraphArea']),childrenByArea['RecipesArea']&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* RecipesAreaContainer */],null,childrenByArea['RecipesArea'])),childrenByArea['ConditionalFeature']&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* RecipesAreaContainer */],null,childrenByArea['ConditionalFeature'])),childrenByArea['HistoryArea']&&__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',null,childrenByArea['HistoryArea']));};ProductPageLayout.propTypes={children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any};/* harmony default export */ __webpack_exports__["a"] = (ProductPageLayout);

/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FirstRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ProductState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ScheduleLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GraphLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RecipesAreaContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_utils_style__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    clear: both;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    margin: 0 calc(',' / 2) calc(',' / 2);\n\n    ',';\n\n    ',';\n\n    ',';\n'],['\n    clear: both;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    margin: 0 calc(',' / 2) calc(',' / 2);\n\n    ',';\n\n    ',';\n\n    ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n\t\tmargin: 0 calc(',' / 2) calc(',' / 2);\n\t'],['\n\t\tmargin: 0 calc(',' / 2) calc(',' / 2);\n\t']),_templateObject3=_taggedTemplateLiteral(['\n        align-items: stretch;\n        flex-direction: row;\n\t\tmargin: 0 calc(',' / 2) calc(',' / 2);\n\t'],['\n        align-items: stretch;\n        flex-direction: row;\n\t\tmargin: 0 calc(',' / 2) calc(',' / 2);\n\t']),_templateObject4=_taggedTemplateLiteral(['\n    border-right: none;\n    max-width: 30rem;\n    min-width: ',';\n    padding: 0 1em;\n    width: 100%;\n\n    ',' ',';\n'],['\n    border-right: none;\n    max-width: 30rem;\n    min-width: ',';\n    padding: 0 1em;\n    width: 100%;\n\n    ',' ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n\t\tpadding-right: 0.5rem;\n\t'],['\n\t\tpadding-right: 0.5rem;\n\t']),_templateObject6=_taggedTemplateLiteral(['\n        border-right: ',';\n        flex: 1 0 ',';\n\t\tpadding-right: 1rem;\n\t'],['\n        border-right: ',';\n        flex: 1 0 ',';\n\t\tpadding-right: 1rem;\n\t']),_templateObject7=_taggedTemplateLiteral(['\n    padding: 0;\n    width: 100%;\n\n    ',' ',';\n'],['\n    padding: 0;\n    width: 100%;\n\n    ',' ',';\n']),_templateObject8=_taggedTemplateLiteral(['\n\t\tpadding-left: 0.5rem;\n\t'],['\n\t\tpadding-left: 0.5rem;\n\t']),_templateObject9=_taggedTemplateLiteral(['\n        flex: 4 0 ',';\n\t\tmax-width: 70rem;\n\t\tpadding-left: 1rem;\n\t'],['\n        flex: 4 0 ',';\n\t\tmax-width: 70rem;\n\t\tpadding-left: 1rem;\n\t']),_templateObject10=_taggedTemplateLiteral(['\n    min-width: ',';\n    padding: ',' 0;\n\n    ',' ',' ',';\n'],['\n    min-width: ',';\n    padding: ',' 0;\n\n    ',' ',' ',';\n']),_templateObject11=_taggedTemplateLiteral(['\n\t\tpadding: ',' 0;\n\t'],['\n\t\tpadding: ',' 0;\n\t']),_templateObject12=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    min-width: ',';\n\n    & > * {\n        width: 100%;\n    }\n'],['\n    display: flex;\n    justify-content: center;\n    min-width: ',';\n\n    & > * {\n        width: 100%;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var mobileMargin='1rem';var tabletMargin='1.5rem';var desktopMargin='2rem';var xlargeMargin='3rem';var sideMargin='1rem';var FirstRow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject,mobileMargin,mobileMargin,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject2,tabletMargin,tabletMargin),__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].desktop(_templateObject3,desktopMargin,desktopMargin),__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].xlarge(_templateObject2,xlargeMargin,xlargeMargin));var ProductState=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject4,function(p){return p.theme.viewportMinWidth;},__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject5),__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].desktop(_templateObject6,function(p){return p.rightLine?'1px solid '+p.theme.productBorderColor:'none';},function(p){return p.theme.viewportMinWidth;}));var ScheduleLayout=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject7,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject8),__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].desktop(_templateObject9,function(p){return p.theme.viewportMinWidth;}));var GraphLayout=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject10,function(_ref){var theme=_ref.theme;return theme.viewportMinWidth;},mobileMargin,__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].tablet(_templateObject11,tabletMargin),__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].desktop(_templateObject11,desktopMargin),__WEBPACK_IMPORTED_MODULE_0__core_utils_style__["b" /* media */].xlarge(_templateObject11,xlargeMargin));var RecipesAreaContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject12,function(_ref2){var theme=_ref2.theme;return'calc('+theme.viewportMinWidth+' - 2 * '+sideMargin+')';});

/***/ }),
/* 2527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Timer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_decorators_interval_update__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timer_intl__ = __webpack_require__(2528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(2529);
/**
 * Represents a timer that displays a countdown.
 */var Timer=function Timer(_ref){var minutes=_ref.minutes,_ref$now=_ref.now,now=_ref$now===undefined?new Date():_ref$now,seconds=_ref.seconds,_ref$startFrom=_ref.startFrom,startFrom=_ref$startFrom===undefined?now:_ref$startFrom;var duration=differenceBetweenTimes(now,startFrom,minutes,seconds);return __WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* Container */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* TimerBox */],null,duration),__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* RemainingBox */],null,__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_2__timer_intl__["a" /* default */].remaining)));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__core_decorators_interval_update__["a" /* default */])(Timer,1000));/**
 * Returns the difference between two times in custom format
 */var differenceBetweenTimes=function differenceBetweenTimes(start,end){var minutesLimit=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var secondsLimit=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var format=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'mm:ss';var startTime=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(start);var endTime=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(end).add(minutesLimit,'minutes').add(secondsLimit,'seconds');var duration=__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.duration(endTime.diff(startTime));return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.utc(duration.asMilliseconds()).format(format);};

/***/ }),
/* 2528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({remaining:{id:'timer.remaining',defaultMessage:'remaining'}}));

/***/ }),
/* 2529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TimerBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RemainingBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    background-color: ',';\n    border-radius: 0.4rem;\n    padding: 0.5rem;\n    text-align: center;\n'],['\n    background-color: ',';\n    border-radius: 0.4rem;\n    padding: 0.5rem;\n    text-align: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n    display: block;\n    font-size: 1.5rem;\n    margin-bottom: -0.25rem;\n'],['\n    display: block;\n    font-size: 1.5rem;\n    margin-bottom: -0.25rem;\n']),_templateObject3=_taggedTemplateLiteral(['\n    display: inline-block;\n    font-size: 0.8rem;\n'],['\n    display: inline-block;\n    font-size: 0.8rem;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div(_templateObject,function(p){return p.theme.productBorderColor;});var TimerBox=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject2);var RemainingBox=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span(_templateObject3);

/***/ }),
/* 2530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_every__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_fp_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_fp_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_curry__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_fp_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_fp_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_utils_immutable__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icons__ = __webpack_require__(2532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// @noflow
var replaceNullWithDefault=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_curry___default()(function(def,value){return value||def;});var replace=__WEBPACK_IMPORTED_MODULE_3_lodash_fp_curry___default()(function(regEx,replacement,string){return string.replace(regEx,replacement);});var getWeatherIcon=__WEBPACK_IMPORTED_MODULE_1_lodash_fp_flowRight___default()(function(value){return __WEBPACK_IMPORTED_MODULE_7__icons__["a" /* default */][value];},replace(/^(day|night)_/,''),replaceNullWithDefault('sunny'),Object(__WEBPACK_IMPORTED_MODULE_5__core_utils_immutable__["c" /* get */])('icon'));var MaybeRender=function MaybeRender(_ref){var children=_ref.children,conditions=_objectWithoutProperties(_ref,['children']);return __WEBPACK_IMPORTED_MODULE_2_lodash_fp_every___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a,conditions)?children:null;};/* harmony default export */ __webpack_exports__["a"] = (function(_ref2){var hubDateTime=_ref2.hubDateTime,weather=_ref2.weather;var temperature=weather.getIn(['temperature','value']);var iconName=getWeatherIcon(weather);return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* InfoBar */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](MaybeRender,{hubDateTime:hubDateTime},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* Item */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6____["y" /* HubClock */],{hubDateTime:hubDateTime}))),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](MaybeRender,{iconName:iconName,temp:temperature!==undefined},__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* Item */],null,__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* Icon */],{type:iconName}),__WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* Temp */],{value:temperature}))));});

/***/ }),
/* 2531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InfoBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Item; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Temp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(28);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    height: ',';\n    margin-bottom: 0;\n    margin-top: 0;\n    /* we also define the max-height to be sure it does not use more space than allowed*/\n    max-height: ',';\n    overflow: hidden;\n    padding-right: 1em;\n    justify-content: flex-end;\n    align-items: center;\n'],['\n    display: flex;\n    height: ',';\n    margin-bottom: 0;\n    margin-top: 0;\n    /* we also define the max-height to be sure it does not use more space than allowed*/\n    max-height: ',';\n    overflow: hidden;\n    padding-right: 1em;\n    justify-content: flex-end;\n    align-items: center;\n']),_templateObject2=_taggedTemplateLiteral(['\n    align-items: center;\n    display: flex;\n    height: ',';\n    justify-content: center;\n'],['\n    align-items: center;\n    display: flex;\n    height: ',';\n    justify-content: center;\n']),_templateObject3=_taggedTemplateLiteral(['\n    height: 2em;\n    margin-bottom: 0.3em;\n    margin-right: 5px;\n    width: 2em;\n'],['\n    height: 2em;\n    margin-bottom: 0.3em;\n    margin-right: 5px;\n    width: 2em;\n']),_templateObject4=_taggedTemplateLiteral(['line-height: ',';'],['line-height: ',';']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InfoBar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ul(_templateObject,function(props){return props.theme.infoBarHeight;},function(props){return props.theme.infoBarHeight;});var Item=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].li(_templateObject2,function(props){return props.theme.infoBarHeight;});var Icon=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1__core_icons_svg_icons__["a" /* default */])(_templateObject3);var Temp=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2____["_6" /* Temperature */])(_templateObject4,function(props){return props.theme.infoBarHeight;});

/***/ }),
/* 2532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__ = __webpack_require__(353);
/* eslint-disable camelcase *//* harmony default export */ __webpack_exports__["a"] = ({cloudy:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].WHITE_CLOUD,white_cloud:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].WHITE_CLOUD,sunny_intervals:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].SUNNY_INTERVALS,cloudy_with_light_rain:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_LIGHT_RAIN,cloudy_with_heavy_rain:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_HEAVY_RAIN,heavy_rain_showers:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].HEAVY_RAIN_SHOWERS,light_rain_showers:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].LIGHT_RAIN_SHOWERS,cloudy_with_light_snow:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].LIGHT_SNOW,light_snow:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].LIGHT_SNOW,light_snow_showers:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].LIGHT_SNOW_SHOWERS,cloudy_with_heavy_snow:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_HEAVY_SNOW,heavy_snow_showers:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].HEAVY_SNOW_SHOWERS,thunderstorms:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].THUNDERSTORMS,thundery_showers:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].THUNDER_SHOWERS,cloudy_with_sleet:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].CLOUDY_WITH_SLEET,sleet_showers:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].SLEET_SHOWERS,sunny:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].SUNNY,clear_sky:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].SUNNY,black_low_cloud:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].BLACK_LOW_CLOUD,fog:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].FOG_MIST,mist:__WEBPACK_IMPORTED_MODULE_0__core_constants_icons_weather_svg__["a" /* default */].FOG_MIST});/* eslint-enable camelcase */

/***/ }),
/* 2533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_products_thermostat_selectors__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component__ = __webpack_require__(2534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lifecycle_component__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_lifecycle_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_lifecycle_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_devices__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_application_actions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_state_products_thermostat_actions__ = __webpack_require__(354);
// This will be replaced by BK at some point
// but for now we've agreed to do it in-app.
function setAllStatsToExistingHumidifyType(){var nextProps=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(this.props.isMissingAHumidifierType&&this.props.knownHumidityType&&this.props.knownHumidityType!==nextProps.knownHumidityType){this.props.setAs(this.props.knownHumidityType);}}var mapStateToProps=function mapStateToProps(state){var knownHumidityType=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_products_thermostat_selectors__["m" /* getKnownHumidifierType */])(state);var isMissingAHumidifierType=Object(__WEBPACK_IMPORTED_MODULE_0__core_state_products_thermostat_selectors__["k" /* getIsAnyMissingHumidifierType */])(state);return{knownHumidityType:knownHumidityType,isMissingAHumidifierType:isMissingAHumidifierType,isOpen:isMissingAHumidifierType&&!knownHumidityType,setAllStatsToExistingHumidifyType:setAllStatsToExistingHumidifyType,componentWillReceiveProps:setAllStatsToExistingHumidifyType};};var mapDispatchToProps={setAs:__WEBPACK_IMPORTED_MODULE_5__core_state_products_thermostat_actions__["e" /* setHumidifierType */],setAsHumidifier:function setAsHumidifier(){return Object(__WEBPACK_IMPORTED_MODULE_5__core_state_products_thermostat_actions__["e" /* setHumidifierType */])(__WEBPACK_IMPORTED_MODULE_3__core_constants_devices__["deviceHumidityModes"].HUMIDIFIER);},setAsDeHumidifier:function setAsDeHumidifier(){return Object(__WEBPACK_IMPORTED_MODULE_5__core_state_products_thermostat_actions__["e" /* setHumidifierType */])(__WEBPACK_IMPORTED_MODULE_3__core_constants_devices__["deviceHumidityModes"].DEHUMIDIFIER);},hideHumidityControl:__WEBPACK_IMPORTED_MODULE_4__core_state_application_actions__["e" /* hideHumidityControl */]};var mergeProps=function mergeProps(stateProps,dispatchProps,ownProps){var isOpen=stateProps.isOpen,setAllStatsToExistingHumidifyType=stateProps.setAllStatsToExistingHumidifyType;var hideHumidityControl=dispatchProps.hideHumidityControl;return Object.assign({},ownProps,stateProps,dispatchProps,{componentDidMount:function componentDidMount(nextProps){setAllStatsToExistingHumidifyType.call(this,nextProps);if(!isOpen){hideHumidityControl();}}});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_lifecycle_component__["connectWithLifecycle"])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_1__component__["a" /* default */]));

/***/ }),
/* 2534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style__ = __webpack_require__(2535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intl__ = __webpack_require__(2536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
// @noflow
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var isOpen=_ref.isOpen,setAsHumidifier=_ref.setAsHumidifier,setAsDeHumidifier=_ref.setAsDeHumidifier;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0____["J" /* Modal */],{contentLabel:'Humidity control modal',isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('h2',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].popupTitle)),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('p',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].popupQuestion)),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__style__["a" /* Buttons */],null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('li',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0____["l" /* Button */],{onClick:setAsHumidifier},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].humidifier))),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('li',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0____["l" /* Button */],{onClick:setAsDeHumidifier},__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_3__intl__["a" /* default */].dehumidifier)))));});

/***/ }),
/* 2535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Buttons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n\n    li:last-child {\n        margin-left: 1em;\n    }\n'],['\n    display: flex;\n\n    li:last-child {\n        margin-left: 1em;\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Buttons=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ul(_templateObject);

/***/ }),
/* 2536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({popupTitle:{id:'humidity-popup.title',defaultMessage:'Humidity Controller'},popupQuestion:{id:'humidity-popup.question',defaultMessage:'What have you connected to the Acc terminal?'},humidifier:{id:'humidity-popup.humidifier',defaultMessage:'Humidifier'},dehumidifier:{id:'humidity-popup.dehumidifier',defaultMessage:'Dehumidifier'}}));

/***/ }),
/* 2537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var errors=_ref.errors,messages=_ref.messages;var keys=Object.keys(errors);if(!keys.length){return null;}var displayMessages=keys.map(function(key){var message=messages[key];return message&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* Error */],{key:key},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_intl__["c" /* FormattedMessage */],message));}).filter(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_identity___default.a);if(!displayMessages.length){return null;}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* Errors */],null,displayMessages);});

/***/ }),
/* 2538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Errors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Error; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['color: ',';'],['color: ',';']),_templateObject2=_taggedTemplateLiteral(['margin-bottom: 1em;'],['margin-bottom: 1em;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Errors=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].ul(_templateObject,function(props){return props.theme.error;});var Error=__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].li(_templateObject2);

/***/ }),
/* 2539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(2540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_products_actions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_devices_actions__ = __webpack_require__(102);
// @noflow
var mapStateToProps=function mapStateToProps(state){var phoneNumber=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_config_selectors__["a" /* getConfig */])(state,'help:deviceOfflineTelephoneNumber');return{phoneNumber:phoneNumber};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{refresh:function refresh(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__core_state_devices_actions__["a" /* loadDevices */])());dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__core_state_products_actions__["a" /* getProducts */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]));

/***/ }),
/* 2540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(2541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__intl__ = __webpack_require__(2542);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var WiringError=function(_Component){_inherits(WiringError,_Component);function WiringError(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WiringError);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WiringError.__proto__||Object.getPrototypeOf(WiringError)).call.apply(_ref,[this].concat(args))),_this),_this.refresh=function(){var refresh=_this.props.refresh;refresh();_this.setState({refreshing:true});setTimeout(function(){_this.setState({refreshing:false,showExtendedSupport:true});},5000);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WiringError,[{key:'componentWillMount',value:function componentWillMount(){this.setState({refreshing:false,showExtendedSupport:false});}},{key:'render',value:function render(){var _state=this.state,showExtendedSupport=_state.showExtendedSupport,refreshing=_state.refreshing;var phoneNumber=this.props.phoneNumber;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["_3" /* StandardLayout */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* HeaderContainer */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__styles__["c" /* WarningIcon */],{icon:__WEBPACK_IMPORTED_MODULE_3__core_constants_icons_general__["EXCLAMATION"]}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* WiringTitle */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].title))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* Subheading */],null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].subheading)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].step1)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].step2)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].step3)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].step4)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].step5)),!showExtendedSupport&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["R" /* PrimaryBtn */],{disabled:refreshing,onClick:this.refresh},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].refresh)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["_16" /* WaitingIndicator */],{show:refreshing}),showExtendedSupport&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["c" /* FormattedMessage */],__WEBPACK_IMPORTED_MODULE_5__intl__["a" /* default */].extendedSupport)),phoneNumber&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'phone_number'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["O" /* PhoneNumber */],{phoneNumber:phoneNumber}))));}}]);return WiringError;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WiringError);

/***/ }),
/* 2541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Subheading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WarningIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return WiringTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_icons__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(['display: flex;'],['display: flex;']),_templateObject2=_taggedTemplateLiteral(['font-weight: bold;'],['font-weight: bold;']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 2.5rem;\n    color: ',';\n'],['\n    font-size: 2.5rem;\n    color: ',';\n']),_templateObject4=_taggedTemplateLiteral(['\n    font-size: 2rem;\n    font-weight: normal;\n    margin: 0;\n'],['\n    font-size: 2rem;\n    font-weight: normal;\n    margin: 0;\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var HeaderContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div(_templateObject);var Subheading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].p(_templateObject2);var WarningIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_0__core_icons__["a" /* default */])(_templateObject3,function(props){return props.theme.error;});var WiringTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h1(_templateObject4);

/***/ }),
/* 2542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({title:{id:'wiring-error.title',defaultMessage:'Wiring error!'},subheading:{id:'wiring-error.subheading',defaultMessage:'Please try the following steps in order.'},refresh:{id:'wiring-error.refesh',defaultMessage:'Refresh'},step1:{id:'wiring-error.step1',defaultMessage:'1. Go to your thermostat'},step2:{id:'wiring-error.step2',defaultMessage:'2. Take the thermostat body off the wall'},step3:{id:'wiring-error.step3',defaultMessage:'3. Check the wires are in the correct terminals'},step4:{id:'wiring-error.step4',defaultMessage:'4. Replace the thermostat body'},step5:{id:'wiring-error.step5',defaultMessage:'5. Press check on the thermostat (if the wires are correct) and tap refresh'},extendedSupport:{id:'wiring-error.extended-support',defaultMessage:'If the above steps have not helped please check hivehome.com for our support hours.'}}));

/***/ }),
/* 2543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({message:{id:'error-boundary.message',defaultMessage:'An error has occurred and the Hive team has been notified.'},buttonLabel:{id:'error-bounary.button-label',defaultMessage:'Please press Refresh to reload the app.'},buttonText:{id:'error-boundary.button-text',defaultMessage:'Refresh'}}));

/***/ }),
/* 2544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fonts_bariol_bold_ttf__ = __webpack_require__(2545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fonts_bariol_bold_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_fonts_bariol_bold_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fonts_bariol_bold_woff__ = __webpack_require__(2546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fonts_bariol_bold_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_fonts_bariol_bold_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fonts_bariol_medium_ttf__ = __webpack_require__(2547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fonts_bariol_medium_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_fonts_bariol_medium_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_fonts_bariol_medium_woff__ = __webpack_require__(2548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_fonts_bariol_medium_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_fonts_bariol_medium_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_fonts_bariol_regular_ttf__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_fonts_bariol_regular_ttf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_fonts_bariol_regular_ttf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_fonts_bariol_regular_woff__ = __webpack_require__(2549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_fonts_bariol_regular_woff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_fonts_bariol_regular_woff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reset_css__ = __webpack_require__(2550);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n\t\t\t@font-face {\n\t\t\t\tfont-family: Bariol;\n\t\t\t\tsrc: url(',') format("woff"), url(',') format("truetype");\n\t\t\t}\n\n\t\t\t@font-face {\n\t\t\t\tfont-family: Bariol;\n\t\t\t\tfont-weight: 500;\n                src: url(',') format("woff"), url(',') format("truetype");\n\t\t\t}\n\n\t\t\t@font-face {\n\t\t\t\tfont-family: Bariol;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tsrc: url(',') format("woff"), url(',') format("truetype");\n\t\t\t}\n\n\t\t\t:root {\n\t\t\t\tfont-family: Bariol, Arial;\n\t\t\t}\n\t\t'],['\n\t\t\t@font-face {\n\t\t\t\tfont-family: Bariol;\n\t\t\t\tsrc: url(',') format("woff"), url(',') format("truetype");\n\t\t\t}\n\n\t\t\t@font-face {\n\t\t\t\tfont-family: Bariol;\n\t\t\t\tfont-weight: 500;\n                src: url(',') format("woff"), url(',') format("truetype");\n\t\t\t}\n\n\t\t\t@font-face {\n\t\t\t\tfont-family: Bariol;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tsrc: url(',') format("woff"), url(',') format("truetype");\n\t\t\t}\n\n\t\t\t:root {\n\t\t\t\tfont-family: Bariol, Arial;\n\t\t\t}\n\t\t']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// @noflow
var _class=function(_Component){_inherits(_class,_Component);function _class(){_classCallCheck(this,_class);return _possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).apply(this,arguments));}_createClass(_class,[{key:'componentWillMount',value:function componentWillMount(){Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["d" /* injectGlobal */])(_templateObject,__WEBPACK_IMPORTED_MODULE_6__assets_fonts_bariol_regular_woff___default.a,__WEBPACK_IMPORTED_MODULE_5__assets_fonts_bariol_regular_ttf___default.a,__WEBPACK_IMPORTED_MODULE_4__assets_fonts_bariol_medium_woff___default.a,__WEBPACK_IMPORTED_MODULE_3__assets_fonts_bariol_medium_ttf___default.a,__WEBPACK_IMPORTED_MODULE_2__assets_fonts_bariol_bold_woff___default.a,__WEBPACK_IMPORTED_MODULE_1__assets_fonts_bariol_bold_ttf___default.a);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__reset_css__["a" /* default */],null,this.props.children);}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bariol_bold.ff6d057ec95b6df4703a4dc4bb401b119124c019d05f372f4f60eda0c80c276c.ttf";

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bariol_bold.278934679a31a018a2b7294b41d14f6a5f2209ea731c2046b98117b6249799ee.woff";

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bariol_medium.a950708e1e5e935edf97f88caf51c0e20034879730b6f37cd9e50f6b0825df99.ttf";

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bariol_medium.560a5861a64f769c63e99eb743bdcc4bfbecf8d58a6fcc27cf9336c03913b03a.woff";

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bariol_regular.b4346fed77712978e621deabf119c73541b5b0ccd7fdf57750da8e6de04be185.woff";

/***/ }),
/* 2550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_css__ = __webpack_require__(2551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__normalize__ = __webpack_require__(2552);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['',''],['','']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResetCSS=function(_React$Component){_inherits(ResetCSS,_React$Component);function ResetCSS(){_classCallCheck(this,ResetCSS);return _possibleConstructorReturn(this,(ResetCSS.__proto__||Object.getPrototypeOf(ResetCSS)).apply(this,arguments));}_createClass(ResetCSS,[{key:'componentWillMount',value:function componentWillMount(){Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* injectGlobal */])(_templateObject,__WEBPACK_IMPORTED_MODULE_3__normalize__["a" /* default */]);Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* injectGlobal */])(_templateObject,__WEBPACK_IMPORTED_MODULE_2__base_css__["a" /* default */]);}},{key:'render',value:function render(){return this.props.children;}}]);return ResetCSS;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ResetCSS);

/***/ }),
/* 2551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_themes_main__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_utils_style__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(['\n    /*\nUse \'border-box\' properly:\nhttps://css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice/\n*/\n    html {\n        box-sizing: border-box;\n        color: ',';\n        font-size: ',';\n    }\n\n    body {\n        background-color: ',';\n    }\n\n    body,\n    html {\n        height: 100%;\n        overflow-x: hidden;\n        position: relative;\n    }\n\n    #app {\n        height: 100%;\n        overflow-x: hidden;\n        overflow-y: scroll;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    *,\n    *:before,\n    *:after {\n        box-sizing: inherit;\n    }\n\n    a {\n        color: ',';\n        text-decoration: none;\n    }\n\n    ul {\n        list-style: none;\n        padding: 0;\n    }\n\n    /* This css is to counter the normalize css that sets the font-family of these elements to sas-serif */\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n        font-family: inherit;\n    }\n\n    ',' ',';\n'],['\n    /*\nUse \'border-box\' properly:\nhttps://css-tricks.com/inheriting-box-sizing-probably-slightly-better-best-practice/\n*/\n    html {\n        box-sizing: border-box;\n        color: ',';\n        font-size: ',';\n    }\n\n    body {\n        background-color: ',';\n    }\n\n    body,\n    html {\n        height: 100%;\n        overflow-x: hidden;\n        position: relative;\n    }\n\n    #app {\n        height: 100%;\n        overflow-x: hidden;\n        overflow-y: scroll;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    *,\n    *:before,\n    *:after {\n        box-sizing: inherit;\n    }\n\n    a {\n        color: ',';\n        text-decoration: none;\n    }\n\n    ul {\n        list-style: none;\n        padding: 0;\n    }\n\n    /* This css is to counter the normalize css that sets the font-family of these elements to sas-serif */\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n        font-family: inherit;\n    }\n\n    ',' ',';\n']),_templateObject2=_taggedTemplateLiteral(['\n    html {\n        font-size: ',';\n    }\n'],['\n    html {\n        font-size: ',';\n    }\n']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var baseCSS=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(_templateObject,__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].primaryFontColor,__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].mobileFontSize,__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].white,__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].primaryFontColor,__WEBPACK_IMPORTED_MODULE_2__core_utils_style__["b" /* media */].tablet(_templateObject2,__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].tabletFontSize),__WEBPACK_IMPORTED_MODULE_2__core_utils_style__["b" /* media */].desktop(_templateObject2,__WEBPACK_IMPORTED_MODULE_1__core_themes_main__["a" /* default */].desktopFontSize));/* harmony default export */ __webpack_exports__["a"] = (baseCSS);

/***/ }),
/* 2552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeCSS="/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -ms-text-size-adjust: 100%; /* 2 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\n\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on 'h1' elements within 'section' and\n * 'article' contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\n\nfigcaption,\nfigure,\nmain { /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct margin in IE 8.\n */\n\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd 'em' font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\n\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of 'bolder' by the next rule in Safari 6.\n */\n\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd 'em' font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\n\ndfn {\n  font-style: italic;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\n\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent 'sub' and 'sup' elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\naudio,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\n\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native 'audio' and 'video'\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\nhtml [type=\"button\"], /* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from 'fieldset' elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    'fieldset' elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to 'inherit' in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\n\ndetails, /* 1 */\nmenu {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Scripting\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\n\ncanvas {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in IE.\n */\n\ntemplate {\n  display: none;\n}\n\n/* Hidden\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10-.\n */\n\n[hidden] {\n  display: none;\n}\n";/* harmony default export */ __webpack_exports__["a"] = (normalizeCSS);

/***/ }),
/* 2553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Routes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async_route__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_application_selectors__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_translations_selectors__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_universal_analytics__ = __webpack_require__(819);
// @noflow
/*
    isLoadingTranslations is a HACK!
    When isLoadingTranslations changes, we know that we're replacing the translations used in react-intl.
    react-intl attaches translations to the React context and because react-redux connect uses
    shouldComponentUpdate, components making use of translations aren't automatically re-rendered.
    The problem is that context is broken in React. isLoadingTranslations gives react-redux a reason to re-render
    and in turn, the new context is picked up and used.
*/var mapStateToProps=function mapStateToProps(state){return{isLoggedIn:Object(__WEBPACK_IMPORTED_MODULE_2__core_state_application_selectors__["f" /* getIsLoggedIn */])(state),isLoggingOut:Object(__WEBPACK_IMPORTED_MODULE_2__core_state_application_selectors__["h" /* getIsLoggingOut */])(state),isLoadingTranslations:Object(__WEBPACK_IMPORTED_MODULE_3__core_state_translations_selectors__["b" /* getTranslationsLoading */])(state)};};var Routes=function Routes(_ref){var isLoggedIn=_ref.isLoggedIn,isLoggingOut=_ref.isLoggingOut;return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"]('div',null,__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__async_route__["a" /* default */],{entry:'post-auth',isLoggedIn:isLoggedIn,sLoggingOut:isLoggingOut}),__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0__async_route__["a" /* default */],{entry:'pre-auth',isLoggedIn:isLoggedIn,isLoggingOut:isLoggingOut}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router__["withRouter"])(Object(__WEBPACK_IMPORTED_MODULE_6__components_universal_analytics__["b" /* withTracker */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps)(Routes))));

/***/ }),
/* 2554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loader=function(_Component){_inherits(Loader,_Component);function Loader(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Loader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Loader.__proto__||Object.getPrototypeOf(Loader)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.loadComponent=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(props){var load,component;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:load=props.load;_context.prev=1;_context.next=4;return load();case 4:component=_context.sent;_this.setState({component:component});_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);console.error(_context.t0);case 11:case'end':return _context.stop();}}},_callee,_this2,[[1,8]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Loader,[{key:'componentDidMount',value:function componentDidMount(){this.loadComponent(this.props);}},{key:'render',value:function render(){var _props=this.props,load=_props.load,props=_objectWithoutProperties(_props,['load']);// eslint-disable-line no-unused-vars
var Child=this.state.component;return Child?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Child,props):null;}}]);return Loader;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 2555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadBundle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_state_store__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_state_sagas_registration__ = __webpack_require__(700);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var seenNamedSagas=Object.assign({},__WEBPACK_IMPORTED_MODULE_1__core_state_sagas_registration__["b" /* synchronousSagas */]);function setupBundle(bundle,store){if(bundle.getReducers){var newReducers=bundle.getReducers();Object(__WEBPACK_IMPORTED_MODULE_0__core_state_store__["b" /* injectAsyncReducers */])(store,newReducers);}if(bundle.getTrackers){var newTrackers=bundle.getTrackers();Object(__WEBPACK_IMPORTED_MODULE_0__core_state_store__["d" /* injectAsyncTrackers */])(newTrackers);}if(bundle.getSagas){var newSagas=bundle.getSagas();var isSagasArray=Array.isArray(newSagas);if(!isSagasArray){newSagas=Object.keys(newSagas).reduce(function(agg,key){if(seenNamedSagas[key]){return agg;}seenNamedSagas[key]=true;return[].concat(_toConsumableArray(agg),_toConsumableArray(newSagas[key]));},[]);}Object(__WEBPACK_IMPORTED_MODULE_0__core_state_store__["c" /* injectAsyncSagas */])(newSagas);}}function loadBundle(bundle,store){return __webpack_require__(2556)("./"+bundle+'/entry').then(function(loadedBundle){setupBundle(loadedBundle,store);return loadedBundle.default;});}

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./change-password/entry": [
		2586,
		171
	],
	"./change-pin/entry": [
		2587,
		162
	],
	"./connected-care-invite/entry": [
		2588,
		129
	],
	"./dashboard/entry": [
		2589,
		133
	],
	"./dev/entry": [
		2590,
		134
	],
	"./forgotten-password/entry": [
		2591,
		179
	],
	"./holiday-mode/entry": [
		2592,
		138
	],
	"./home/entry": [
		2593,
		190
	],
	"./install-device-placement/entry": [
		2595,
		192
	],
	"./install-devices-found/entry": [
		2597,
		154
	],
	"./install-devices-instructions/entry": [
		2598,
		170
	],
	"./install-devices-troubleshooting/entry": [
		2599,
		194
	],
	"./install-devices/entry": [
		2596,
		165
	],
	"./install-hive2-discovery/entry": [
		2601,
		143
	],
	"./install-hive2-insert-batteries/entry": [
		2602,
		189
	],
	"./install-hive2-remove-batteries/entry": [
		2603,
		188
	],
	"./install-hive2-wrong-product/entry": [
		2604,
		195
	],
	"./install-hive2/entry": [
		2600,
		164
	],
	"./install-hub/entry": [
		2605,
		146
	],
	"./install-hue-bridge/entry": [
		2606,
		150
	],
	"./install-me/entry": [
		2607,
		130
	],
	"./install-nano1-upgrade/bad-hub-placement/entry": [
		2570,
		174
	],
	"./install-nano1-upgrade/claim-hub/entry": [
		2571,
		168
	],
	"./install-nano1-upgrade/complete/entry": [
		2572,
		167
	],
	"./install-nano1-upgrade/entry": [
		2608,
		135
	],
	"./install-nano1-upgrade/error/entry": [
		2577,
		169
	],
	"./install-nano1-upgrade/good-hub-placement/entry": [
		2576,
		173
	],
	"./install-nano1-upgrade/instructions/entry": [
		2574,
		176
	],
	"./install-nano1-upgrade/slt1-error/entry": [
		2578,
		172
	],
	"./install-nano1-upgrade/spare-ethernet/entry": [
		2575,
		181
	],
	"./install-nano1-upgrade/start/entry": [
		2573,
		157
	],
	"./install-nano1-upgrade/status/entry": [
		2579,
		166
	],
	"./install-slt3-slt3b-upgrade/components/acquire-stat/entry": [
		2609,
		186
	],
	"./install-slt3-slt3b-upgrade/components/instructions/entry": [
		2610,
		161
	],
	"./install-slt3-slt3b-upgrade/entry": [
		2611,
		139
	],
	"./install-zone-firmware-update/entry": [
		2612,
		198
	],
	"./install-zone-wrong-product/entry": [
		2613,
		197
	],
	"./install-zones-discovery/entry": [
		2615,
		158
	],
	"./install-zones/entry": [
		2614,
		163
	],
	"./install/entry": [
		2594,
		156
	],
	"./login/entry": [
		2616,
		180
	],
	"./manage-device/entry": [
		2617,
		160
	],
	"./manage-devices/entry": [
		2618,
		144
	],
	"./mimic-mode/entry": [
		2619,
		152
	],
	"./my-account/entry": [
		2620,
		147
	],
	"./notifications/entry": [
		2621,
		153
	],
	"./post-auth/entry": [
		2622,
		132
	],
	"./postinstall-groups/entry": [
		2623,
		191
	],
	"./pre-auth-account/entry": [
		2625,
		131
	],
	"./pre-auth/entry": [
		2624,
		196
	],
	"./product/entry": [
		2626,
		182
	],
	"./products-active-plugs/entry": [
		2627,
		145
	],
	"./products-bulbs/entry": [
		2628,
		140
	],
	"./products-camera/entry": [
		2629,
		175
	],
	"./products-contact-sensor/entry": [
		2630,
		148
	],
	"./products-heating/entry": [
		2631,
		137
	],
	"./products-hivebutton/entry": [
		2632,
		151
	],
	"./products-hot-water/entry": [
		2633,
		142
	],
	"./products-leak-sensor/entry": [
		2634,
		177
	],
	"./products-motion-sensor/entry": [
		2635,
		149
	],
	"./products-sense/entry": [
		2636,
		136
	],
	"./products-thermostat/entry": [
		2637,
		141
	],
	"./ready-by-find-out-more/entry": [
		2638,
		193
	],
	"./ready-by-set-up/entry": [
		2639,
		185
	],
	"./recipes/entry": [
		2640,
		155
	],
	"./reset-password-biq/entry": [
		2642,
		184
	],
	"./reset-password-cognito/entry": [
		2643,
		183
	],
	"./reset-password/entry": [
		2641,
		187
	],
	"./text-control/entry": [
		2644,
		159
	],
	"./wrong-product/entry": [
		2645,
		178
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2556;
module.exports = webpackAsyncContext;

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(2558),
    flatRest = __webpack_require__(294);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(581),
    hasIn = __webpack_require__(578);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 2559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connectedUAUserSetup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ga__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_state_user_selectors__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Component to set user-id on login
// totally just copied from raven-user-setup
var UAUserSetup=function(_React$Component){_inherits(UAUserSetup,_React$Component);function UAUserSetup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UAUserSetup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UAUserSetup.__proto__||Object.getPrototypeOf(UAUserSetup)).call.apply(_ref,[this].concat(args))),_this),_this.componentWillReceiveProps=_this.setupUser,_this.setupUser=function(props){return __WEBPACK_IMPORTED_MODULE_2_react_ga__["a" /* default */].set({userId:__WEBPACK_IMPORTED_MODULE_0_lodash_fp_get___default()(['id'],props)});},_this.render=function(){return _this.props.children;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UAUserSetup,[{key:'componentDidMount',value:function componentDidMount(){this.setupUser(this.props);}}]);return UAUserSetup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{id:Object(__WEBPACK_IMPORTED_MODULE_4__core_state_user_selectors__["i" /* getUserId */])(state)};};var connectedUAUserSetup=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps,null,null,{pure:false})(UAUserSetup);

/***/ }),
/* 2560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTracker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_ga__ = __webpack_require__(411);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// HOC that should live somewhere under ReactRouter
// Provides page tracking only
// Requires that ReactGA.initialize has been alreay called otherwise
// nothing will get sent/tracked.
function withTracker(WrappedComponent){var trackPage=function trackPage(page){__WEBPACK_IMPORTED_MODULE_1_react_ga__["a" /* default */].pageview(page);};return function(_React$Component){_inherits(_class,_React$Component);function _class(){_classCallCheck(this,_class);return _possibleConstructorReturn(this,(_class.__proto__||Object.getPrototypeOf(_class)).apply(this,arguments));}_createClass(_class,[{key:'componentDidMount',value:function componentDidMount(){var page=this.props.location.pathname;trackPage(page);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var currentPage=this.props.location.pathname;var nextPage=nextProps.location.pathname;if(currentPage!==nextPage){__WEBPACK_IMPORTED_MODULE_1_react_ga__["a" /* default */].pageview(nextPage);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent,this.props);}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);}

/***/ }),
/* 2561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_user_selectors__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RavenUserSetup=function(_React$Component){_inherits(RavenUserSetup,_React$Component);function RavenUserSetup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RavenUserSetup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RavenUserSetup.__proto__||Object.getPrototypeOf(RavenUserSetup)).call.apply(_ref,[this].concat(args))),_this),_this.componentWillReceiveProps=_this.setupUser,_this.setupUser=function(props){return __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.setUserContext(__WEBPACK_IMPORTED_MODULE_0_lodash_fp_pick___default()(['id'],props));},_this.render=function(){return _this.props.children;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RavenUserSetup,[{key:'componentDidMount',value:function componentDidMount(){this.setupUser(this.props);}}]);return RavenUserSetup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{id:Object(__WEBPACK_IMPORTED_MODULE_3__core_state_user_selectors__["i" /* getUserId */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps,null,null,{pure:false})(RavenUserSetup));

/***/ }),
/* 2562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__component__ = __webpack_require__(2563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_state_app_settings_selectors__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_state_app_settings_actions__ = __webpack_require__(126);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function mapStateToProps(state){var settings=Object(__WEBPACK_IMPORTED_MODULE_2__core_state_app_settings_selectors__["b" /* getAppSettings */])(state).filter(function(value){return typeof value==='boolean';}).toArray();return{settings:settings};}function mapDispatchToProps(dispatch){return{changeSetting:function changeSetting(key,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__core_state_app_settings_actions__["c" /* setAppSettings */])(_defineProperty({},key,value)));}};}/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_0__component__["a" /* default */]));

/***/ }),
/* 2563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widgets__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n    position: absolute;\n    top: 1em;\n    right: 1em;\n    width: 30%;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    border-radius: 5px;\n    box-shadow: 0px 0px 25px -5px rgba(0, 0, 0, 0.75);\n    background: rgb(255, 255, 255);\n    z-index: 1000;\n    padding: 1em 0 0 1em;\n'],['\n    position: absolute;\n    top: 1em;\n    right: 1em;\n    width: 30%;\n    border: 1px solid rgba(0, 0, 0, 0.25);\n    border-radius: 5px;\n    box-shadow: 0px 0px 25px -5px rgba(0, 0, 0, 0.75);\n    background: rgb(255, 255, 255);\n    z-index: 1000;\n    padding: 1em 0 0 1em;\n']),_templateObject2=_taggedTemplateLiteral(['max-height: 100%;'],['max-height: 100%;']),_templateObject3=_taggedTemplateLiteral(['\n    display: grid;\n    grid-template-columns: 70% 10%;\n    margin-bottom: 1em;\n    align-items: center;\n'],['\n    display: grid;\n    grid-template-columns: 70% 10%;\n    margin-bottom: 1em;\n    align-items: center;\n']),_templateObject4=_taggedTemplateLiteral(['font-size: 1.3em;'],['font-size: 1.3em;']),_templateObject5=_taggedTemplateLiteral(['display: block;'],['display: block;']);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tools=function(_React$Component){_inherits(Tools,_React$Component);function Tools(props){_classCallCheck(this,Tools);var _this=_possibleConstructorReturn(this,(Tools.__proto__||Object.getPrototypeOf(Tools)).call(this,props));_this.el=document.createElement('div');document.querySelector('body').appendChild(_this.el);return _this;}_createClass(Tools,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children,this.el);}}]);return Tools;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Settings=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div(_templateObject);var List=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].ul(_templateObject2);var ListItem=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].li(_templateObject3);var Heading=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].h1(_templateObject4);var ToggleContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].span(_templateObject5);var letterAKeyCode=65;var _class=function(_React$Component2){_inherits(_class,_React$Component2);function _class(){var _ref;var _temp,_this2,_ret;_classCallCheck(this,_class);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref=_class.__proto__||Object.getPrototypeOf(_class)).call.apply(_ref,[this].concat(args))),_this2),_this2.state={displaySettings:false},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(_class,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;document.querySelector('body').addEventListener('keydown',function(_ref2){var ctrlKey=_ref2.ctrlKey,keyCode=_ref2.keyCode;if(ctrlKey&&keyCode===letterAKeyCode){_this3.setState(function(state){return{displaySettings:!state.displaySettings};});}});}},{key:'render',value:function render(){var _props=this.props,settings=_props.settings,changeSetting=_props.changeSetting;var displaySettings=this.state.displaySettings;return displaySettings?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tools,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Settings,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,'App settings'),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](List,null,settings.map(function(_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],value=_ref4[1];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ListItem,{key:key},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span',null,key),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ToggleContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__widgets__["_14" /* ToggleButton */],{isOn:value,onChange:function onChange(){return changeSetting(key,!value);}})));})))):null;}}]);return _class;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["immutableDevTools"] = factory();
	else
		root["immutableDevTools"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createFormatters2 = __webpack_require__(1);

	var _createFormatters3 = _interopRequireDefault(_createFormatters2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Check for globally defined Immutable and add an install method to it.
	if (typeof Immutable !== "undefined") {
	  Immutable.installDevTools = install.bind(null, Immutable);
	}

	// I imagine most people are using Immutable as a CommonJS module though...

	var installed = false;
	function install(Immutable) {
	  if (typeof window === "undefined") {
	    throw new Error("Can only install immutable-devtools in a browser environment.");
	  }

	  // Don't install more than once.
	  if (installed === true) {
	    return;
	  }

	  window.devtoolsFormatters = window.devtoolsFormatters || [];

	  var _createFormatters = (0, _createFormatters3.default)(Immutable);

	  var RecordFormatter = _createFormatters.RecordFormatter;
	  var OrderedMapFormatter = _createFormatters.OrderedMapFormatter;
	  var OrderedSetFormatter = _createFormatters.OrderedSetFormatter;
	  var ListFormatter = _createFormatters.ListFormatter;
	  var MapFormatter = _createFormatters.MapFormatter;
	  var SetFormatter = _createFormatters.SetFormatter;
	  var StackFormatter = _createFormatters.StackFormatter;

	  window.devtoolsFormatters.push(RecordFormatter, OrderedMapFormatter, OrderedSetFormatter, ListFormatter, MapFormatter, SetFormatter, StackFormatter);

	  installed = true;
	}

	module.exports = install;
	exports.default = install;

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createFormatter;

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	var listStyle = { style: 'list-style-type: none; padding: 0; margin: 0 0 0 12px; font-style: normal' };
	var immutableNameStyle = { style: 'color: rgb(232,98,0)' };
	var keyStyle = { style: 'color: #881391' };
	var defaultValueKeyStyle = { style: 'color: #777' };
	var alteredValueKeyStyle = { style: 'color: #881391; font-weight: bolder' };
	var inlineValuesStyle = { style: 'color: #777; font-style: italic' };
	var nullStyle = { style: 'color: #777' };

	function createFormatter(Immutable) {

	  var reference = function reference(object, config) {
	    if (typeof object === 'undefined') return ['span', nullStyle, 'undefined'];else if (object === 'null') return ['span', nullStyle, 'null'];

	    return ['object', { object: object, config: config }];
	  };

	  var renderIterableHeader = function renderIterableHeader(iterable) {
	    var name = arguments.length <= 1 || arguments[1] === undefined ? 'Iterable' : arguments[1];
	    return ['span', ['span', immutableNameStyle, name], ['span', '[' + iterable.size + ']']];
	  };

	  var hasBody = function hasBody(collection, config) {
	    return collection.size > 0 && !(config && config.noPreview);
	  };

	  var renderIterableBody = function renderIterableBody(collection, mapper) {
	    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

	    if (options.sorted) {
	      collection = collection.sortBy(function (value, key) {
	        return key;
	      });
	    }
	    var children = collection.map(mapper).toList().toJS();
	    return ['ol', listStyle].concat(_toConsumableArray(children));
	  };

	  var RecordFormatter = {
	    header: function header(record, config) {
	      if (!(record instanceof Immutable.Record)) return null;

	      var defaults = record.clear();
	      var changed = !Immutable.is(defaults, record);

	      if (config && config.noPreview) return ['span', changed ? immutableNameStyle : nullStyle, record._name || record.constructor.name || 'Record'];

	      var inlinePreview = undefined;
	      if (!changed) {
	        inlinePreview = ['span', inlineValuesStyle, '{}'];
	      } else {
	        var preview = record.keySeq().reduce(function (preview, key) {
	          if (Immutable.is(defaults.get(key), record.get(key))) return preview;
	          if (preview.length) preview.push(', ');

	          preview.push(['span', {}, ['span', keyStyle, key + ': '], reference(record.get(key), { noPreview: true })]);
	          return preview;
	        }, []);
	        inlinePreview = ['span', inlineValuesStyle, '{'].concat(_toConsumableArray(preview), ['}']);
	      }
	      return ['span', {}, ['span', immutableNameStyle, record._name || record.constructor.name || 'Record'], ' ', inlinePreview];
	    },

	    hasBody: hasBody,
	    body: function body(record) {
	      var defaults = record.clear();
	      var children = record.keySeq().map(function (key) {
	        var style = Immutable.is(defaults.get(key), record.get(key)) ? defaultValueKeyStyle : alteredValueKeyStyle;
	        return ['li', {}, ['span', style, key + ': '], reference(record.get(key))];
	      }).toJS();
	      return ['ol', listStyle].concat(_toConsumableArray(children));
	    }
	  };

	  var ListFormatter = {
	    header: function header(o) {
	      if (!Immutable.List.isList(o)) return null;
	      return renderIterableHeader(o, 'List');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value, key) {
	        return ['li', ['span', keyStyle, key + ': '], reference(value)];
	      });
	    }
	  };

	  var StackFormatter = {
	    header: function header(o) {
	      if (!Immutable.Stack.isStack(o)) return null;
	      return renderIterableHeader(o, 'Stack');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value, key) {
	        return ['li', ['span', keyStyle, key + ': '], reference(value)];
	      });
	    }
	  };

	  var MapFormatter = {
	    header: function header(o) {
	      if (!Immutable.Map.isMap(o)) return null;
	      return renderIterableHeader(o, 'Map');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value, key) {
	        return ['li', {}, '{', reference(key), ' => ', reference(value), '}'];
	      }, { sorted: true });
	    }
	  };

	  var OrderedMapFormatter = {
	    header: function header(o) {
	      if (!Immutable.OrderedMap.isOrderedMap(o)) return null;
	      return renderIterableHeader(o, 'OrderedMap');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value, key) {
	        return ['li', {}, '{', reference(key), ' => ', reference(value), '}'];
	      });
	    }
	  };

	  var SetFormatter = {
	    header: function header(o) {
	      if (!Immutable.Set.isSet(o)) return null;
	      return renderIterableHeader(o, 'Set');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value) {
	        return ['li', reference(value)];
	      }, { sorted: true });
	    }
	  };

	  var OrderedSetFormatter = {
	    header: function header(o) {
	      if (!Immutable.OrderedSet.isOrderedSet(o)) return null;
	      return renderIterableHeader(o, 'OrderedSet');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value) {
	        return ['li', reference(value)];
	      });
	    }
	  };

	  return {
	    RecordFormatter: RecordFormatter,
	    OrderedMapFormatter: OrderedMapFormatter,
	    OrderedSetFormatter: OrderedSetFormatter,
	    ListFormatter: ListFormatter,
	    MapFormatter: MapFormatter,
	    SetFormatter: SetFormatter,
	    StackFormatter: StackFormatter
	  };
	}

/***/ }
/******/ ])
});
;

/***/ }),
/* 2565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drivers_cookie__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ua_parser_js__ = __webpack_require__(2566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ua_parser_js__);
var minimumVersions={safari:9,'mobile-safari-mobile':9,chrome:44,'chrome-mobile':44,ie:11,'ie-mobile':11,firefox:45};function getVersion(){var uaInfo=new __WEBPACK_IMPORTED_MODULE_1_ua_parser_js___default.a().getResult();var browserType=uaInfo.browser.name.toLowerCase().replace(' ','-');if(uaInfo.device&&uaInfo.device.type){browserType+='-'+uaInfo.device.type.toLowerCase();}return{type:browserType,version:parseFloat(uaInfo.browser.version)};}window.browserDetect=function browserDetect(cookieKey,redirectTo){var skipBrowserWarning=__WEBPACK_IMPORTED_MODULE_0__drivers_cookie__["a" /* default */].get(cookieKey);if(!skipBrowserWarning){var browserVersion=getVersion();if(minimumVersions[browserVersion.type]&&browserVersion.version&&browserVersion.version<minimumVersions[browserVersion.type]){document.location=redirectTo;}}};

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * UAParser.js v0.7.12
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.12',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function () {

            var result, i = 0, j, k, p, q, matches, match, args = arguments;

            // loop through all regexes maps
            while (i < args.length && !matches) {

                var regex = args[i],       // even sequence (0,2,4,..)
                    props = args[i + 1];   // odd sequence (1,3,5,..)

                // construct object barebones
                if (typeof result === UNDEF_TYPE) {
                    result = {};
                    for (p in props) {
                        if (props.hasOwnProperty(p)){
                            q = props[p];
                            if (typeof q === OBJ_TYPE) {
                                result[q[0]] = undefined;
                            } else {
                                result[q] = undefined;
                            }
                        }
                    }
                }

                // try matching uastring with regexes
                j = k = 0;
                while (j < regex.length && !matches) {
                    matches = regex[j++].exec(this.getUA());
                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        result[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        result[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        result[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                result[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            return result;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
            ], [NAME, VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /android.+samsungbrowser\/([\w\.]+)/i,
            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i,
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            /(qqbrowser)[\/\s]?([\w\.]+)/i
                                                                                // QQBrowser
            ], [NAME, VERSION], [

            /(uc\s?browser)[\/\s]?([\w\.]+)/i,
            /ucweb.+(ucbrowser)[\/\s]?([\w\.]+)/i,
            /juc.+(ucweb)[\/\s]?([\w\.]+)/i
                                                                                // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS
            ], [VERSION, [NAME, 'Facebook']], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Huawei/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /(?:sony)?(?:(?:(?:c|d)\d{4})|(?:so[-l].+))\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Phone'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w+)*/i,                                                    // ZTE
            /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
                                                                                // Alcatel/GeeksPhone/Huawei/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /(nexus\s6p)/i                                                      // Huawei Nexus 6P
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w+)*/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w+)*/i                                                       // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]+)*/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w+)*/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i    // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i                                         // OnePlus
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /\s(tablet)[;\/]/i,                                                 // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL]

            /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(R1001)/i                                                          // Oppo R1001
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
            /(X9006)/i                                                          // Oppo Find 7a
            ], [[MODEL, 'Find 7a'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
            /(R2001)/i                                                          // Oppo YOYO R2001
            ], [[MODEL, 'Yoyo R2001'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
            /(R815)/i                                                           // Oppo Clover R815
            ], [[MODEL, 'Clover R815'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [
             /(U707)/i                                                          // Oppo Find Way S
            ], [[MODEL, 'Find Way S'], [VENDOR, 'Oppo'], [TYPE, MOBILE]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
            /(gnu)\s?([\w\.]+)*/i                                               // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                  // Haiku
            ], [NAME, VERSION],[

            /(ip[honead]+)(?:.*os\s([\w]+)*\slike\smac|;\sopera)/i              // iOS
            ], [[NAME, 'iOS'], [VERSION, /_/g, '.']], [

            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
            /(unix)\s?([\w\.]+)*/i                                              // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////


    var UAParser = function (uastring, extensions) {

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var browser = mapper.rgx.apply(this, rgxmap.browser);
            browser.major = util.major(browser.version);
            return browser;
        };
        this.getCPU = function () {
            return mapper.rgx.apply(this, rgxmap.cpu);
        };
        this.getDevice = function () {
            return mapper.rgx.apply(this, rgxmap.device);
        };
        this.getEngine = function () {
            return mapper.rgx.apply(this, rgxmap.engine);
        };
        this.getOS = function () {
            return mapper.rgx.apply(this, rgxmap.os);
        };
        this.getResult = function() {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };


    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(2567)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window.jQuery || window.Zepto;
    if (typeof $ !== UNDEF_TYPE) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 2567 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 2568 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(1337);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.c9599c94cead801030f5d00495cf3c30db2767b2ece991cf7ad925a42985746a.js